(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3fc5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3fc5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bIbwS", function(module, exports) {
!/**
 * Highcharts JS v12.4.0 (2025-09-04)
 * @module highcharts/highcharts
 *
 * (c) 2009-2025 Highsoft AS
 *
 * License: www.highcharts.com/license
 */ function(t, e) {
    t._Highcharts = e(), module.exports = t._Highcharts;
}("undefined" == typeof window ? module.exports : window, ()=>(()=>{
        "use strict";
        let t, e;
        var i, s, o, r, a, n, h, l, d, c, p, g, u, f, m, x, y, b, v = {};
        v.d = (t, e)=>{
            for(var i in e)v.o(e, i) && !v.o(t, i) && Object.defineProperty(t, i, {
                enumerable: !0,
                get: e[i]
            });
        }, v.o = (t, e)=>Object.prototype.hasOwnProperty.call(t, e);
        var k = {};
        v.d(k, {
            default: ()=>lI
        }), function(t) {
            t.SVG_NS = "http://www.w3.org/2000/svg", t.product = "Highcharts", t.version = "12.4.0", t.win = "undefined" != typeof window ? window : {}, t.doc = t.win.document, t.svg = !!t.doc?.createElementNS?.(t.SVG_NS, "svg")?.createSVGRect, t.pageLang = t.doc?.documentElement?.closest("[lang]")?.lang, t.userAgent = t.win.navigator?.userAgent || "", t.isChrome = t.win.chrome, t.isFirefox = -1 !== t.userAgent.indexOf("Firefox"), t.isMS = /(edge|msie|trident)/i.test(t.userAgent) && !t.win.opera, t.isSafari = !t.isChrome && -1 !== t.userAgent.indexOf("Safari"), t.isTouchDevice = /(Mobile|Android|Windows Phone)/.test(t.userAgent), t.isWebKit = -1 !== t.userAgent.indexOf("AppleWebKit"), t.deg2rad = 2 * Math.PI / 360, t.marginNames = [
                "plotTop",
                "marginRight",
                "marginBottom",
                "plotLeft"
            ], t.noop = function() {}, t.supportsPassiveEvents = function() {
                let e = !1;
                if (!t.isMS) {
                    let i = Object.defineProperty({}, "passive", {
                        get: function() {
                            e = !0;
                        }
                    });
                    t.win.addEventListener && t.win.removeEventListener && (t.win.addEventListener("testPassive", t.noop, i), t.win.removeEventListener("testPassive", t.noop, i));
                }
                return e;
            }(), t.charts = [], t.composed = [], t.dateFormats = {}, t.seriesTypes = {}, t.symbolSizes = {}, t.chartCount = 0;
        }(i || (i = {}));
        let w = i, { charts: M, doc: S, win: T } = w;
        function C(t, e, i, s) {
            let o = e ? "Highcharts error" : "Highcharts warning";
            32 === t && (t = `${o}: Deprecated member`);
            let r = D(t), a = r ? `${o} #${t}: www.highcharts.com/errors/${t}/` : t.toString();
            if (void 0 !== s) {
                let t = "";
                r && (a += "?"), j(s, function(e, i) {
                    t += `
 - ${i}: ${e}`, r && (a += encodeURI(i) + "=" + encodeURI(e));
                }), a += t;
            }
            U(w, "displayError", {
                chart: i,
                code: t,
                message: a,
                params: s
            }, function() {
                if (e) throw Error(a);
                T.console && -1 === C.messages.indexOf(a) && console.warn(a);
            }), C.messages.push(a);
        }
        function A(t, e) {
            return parseInt(t, e || 10);
        }
        function P(t) {
            return "string" == typeof t;
        }
        function L(t) {
            let e = Object.prototype.toString.call(t);
            return "[object Array]" === e || "[object Array Iterator]" === e;
        }
        function O(t, e) {
            return !!t && "object" == typeof t && (!e || !L(t));
        }
        function E(t) {
            return O(t) && "number" == typeof t.nodeType;
        }
        function I(t) {
            let e = t?.constructor;
            return !!(O(t, !0) && !E(t) && e?.name && "Object" !== e.name);
        }
        function D(t) {
            return "number" == typeof t && !isNaN(t) && t < 1 / 0 && t > -1 / 0;
        }
        function B(t) {
            return null != t;
        }
        function N(t, e, i) {
            let s, o = P(e) && !B(i), r = (e, i)=>{
                B(e) ? t.setAttribute(i, e) : o ? (s = t.getAttribute(i)) || "class" !== i || (s = t.getAttribute(i + "Name")) : t.removeAttribute(i);
            };
            return P(e) ? r(i, e) : j(e, r), s;
        }
        function z(t) {
            return L(t) ? t : [
                t
            ];
        }
        function R(t, e) {
            let i;
            for(i in t || (t = {}), e)t[i] = e[i];
            return t;
        }
        function W() {
            let t = arguments, e = t.length;
            for(let i = 0; i < e; i++){
                let e = t[i];
                if (null != e) return e;
            }
        }
        function H(t, e) {
            R(t.style, e);
        }
        function X(t) {
            return Math.pow(10, Math.floor(Math.log(t) / Math.LN10));
        }
        function F(t, e) {
            return t > 1e14 ? t : parseFloat(t.toPrecision(e || 14));
        }
        (C || (C = {})).messages = [], Math.easeInOutSine = function(t) {
            return -0.5 * (Math.cos(Math.PI * t) - 1);
        };
        let G = Array.prototype.find ? function(t, e) {
            return t.find(e);
        } : function(t, e) {
            let i, s = t.length;
            for(i = 0; i < s; i++)if (e(t[i], i)) return t[i];
        };
        function j(t, e, i) {
            for(let s in t)Object.hasOwnProperty.call(t, s) && e.call(i || t[s], t[s], s, t);
        }
        function Y(t, e, i) {
            function s(e, i) {
                let s = t.removeEventListener;
                s && s.call(t, e, i, !1);
            }
            function o(i) {
                let o, r;
                t.nodeName && (e ? (o = {})[e] = !0 : o = i, j(o, function(t, e) {
                    if (i[e]) for(r = i[e].length; r--;)s(e, i[e][r].fn);
                }));
            }
            let r = "function" == typeof t && t.prototype || t;
            if (Object.hasOwnProperty.call(r, "hcEvents")) {
                let t = r.hcEvents;
                if (e) {
                    let r = t[e] || [];
                    i ? (t[e] = r.filter(function(t) {
                        return i !== t.fn;
                    }), s(e, i)) : (o(t), t[e] = []);
                } else o(t), delete r.hcEvents;
            }
        }
        function U(t, e, i, s) {
            if (i = i || {}, S?.createEvent && (t.dispatchEvent || t.fireEvent && t !== w)) {
                let s = S.createEvent("Events");
                s.initEvent(e, !0, !0), i = R(s, i), t.dispatchEvent ? t.dispatchEvent(i) : t.fireEvent(e, i);
            } else if (t.hcEvents) {
                i.target || R(i, {
                    preventDefault: function() {
                        i.defaultPrevented = !0;
                    },
                    target: t,
                    type: e
                });
                let s = [], o = t, r = !1;
                for(; o.hcEvents;)Object.hasOwnProperty.call(o, "hcEvents") && o.hcEvents[e] && (s.length && (r = !0), s.unshift.apply(s, o.hcEvents[e])), o = Object.getPrototypeOf(o);
                r && s.sort((t, e)=>t.order - e.order), s.forEach((e)=>{
                    !1 === e.fn.call(t, i) && i.preventDefault();
                });
            }
            s && !i.defaultPrevented && s.call(t, i);
        }
        let $ = function() {
            let e = Math.random().toString(36).substring(2, 9) + "-", i = 0;
            return function() {
                return "highcharts-" + (t ? "" : e) + i++;
            };
        }();
        T.jQuery && (T.jQuery.fn.highcharts = function() {
            let t = [].slice.call(arguments);
            if (this[0]) return t[0] ? (new w[P(t[0]) ? t.shift() : "Chart"](this[0], t[0], t[1]), this) : M[N(this[0], "data-highcharts-chart")];
        });
        let V = {
            addEvent: function(t, e, i, s = {}) {
                let o = "function" == typeof t && t.prototype || t;
                Object.hasOwnProperty.call(o, "hcEvents") || (o.hcEvents = {});
                let r = o.hcEvents;
                w.Point && t instanceof w.Point && t.series && t.series.chart && (t.series.chart.runTrackerClick = !0);
                let a = t.addEventListener;
                a && a.call(t, e, i, !!w.supportsPassiveEvents && {
                    passive: void 0 === s.passive ? -1 !== e.indexOf("touch") : s.passive,
                    capture: !1
                }), r[e] || (r[e] = []);
                let n = {
                    fn: i,
                    order: "number" == typeof s.order ? s.order : 1 / 0
                };
                return r[e].push(n), r[e].sort((t, e)=>t.order - e.order), function() {
                    Y(t, e, i);
                };
            },
            arrayMax: function(t) {
                let e = t.length, i = t[0];
                for(; e--;)t[e] > i && (i = t[e]);
                return i;
            },
            arrayMin: function(t) {
                let e = t.length, i = t[0];
                for(; e--;)t[e] < i && (i = t[e]);
                return i;
            },
            attr: N,
            clamp: function(t, e, i) {
                return t > e ? t < i ? t : i : e;
            },
            clearTimeout: function(t) {
                B(t) && clearTimeout(t);
            },
            correctFloat: F,
            createElement: function(t, e, i, s, o) {
                let r = S.createElement(t);
                return e && R(r, e), o && H(r, {
                    padding: "0",
                    border: "none",
                    margin: "0"
                }), i && H(r, i), s && s.appendChild(r), r;
            },
            crisp: function(t, e = 0, i) {
                let s = e % 2 / 2, o = i ? -1 : 1;
                return (Math.round(t * o - s) + s) * o;
            },
            css: H,
            defined: B,
            destroyObjectProperties: function(t, e, i) {
                j(t, function(s, o) {
                    s !== e && s?.destroy && s.destroy(), (s?.destroy || !i) && delete t[o];
                });
            },
            diffObjects: function(t, e, i, s) {
                let o = {};
                return !function t(e, o, r, a) {
                    let n = i ? o : e;
                    j(e, function(i, h) {
                        if (!a && s && s.indexOf(h) > -1 && o[h]) {
                            i = z(i), r[h] = [];
                            for(let e = 0; e < Math.max(i.length, o[h].length); e++)o[h][e] && (void 0 === i[e] ? r[h][e] = o[h][e] : (r[h][e] = {}, t(i[e], o[h][e], r[h][e], a + 1)));
                        } else O(i, !0) && !i.nodeType ? (r[h] = L(i) ? [] : {}, t(i, o[h] || {}, r[h], a + 1), 0 === Object.keys(r[h]).length && ("colorAxis" !== h || 0 !== a) && delete r[h]) : (e[h] !== o[h] || h in e && !(h in o)) && "__proto__" !== h && "constructor" !== h && (r[h] = n[h]);
                    });
                }(t, e, o, 0), o;
            },
            discardElement: function(t) {
                t?.parentElement?.removeChild(t);
            },
            erase: function(t, e) {
                let i = t.length;
                for(; i--;)if (t[i] === e) {
                    t.splice(i, 1);
                    break;
                }
            },
            error: C,
            extend: R,
            extendClass: function(t, e) {
                let i = function() {};
                return i.prototype = new t, R(i.prototype, e), i;
            },
            find: G,
            fireEvent: U,
            getAlignFactor: (t = "")=>({
                    center: .5,
                    right: 1,
                    middle: .5,
                    bottom: 1
                })[t] || 0,
            getClosestDistance: function(t, e) {
                let i, s, o, r, a = !e;
                return t.forEach((t)=>{
                    if (t.length > 1) for(r = s = t.length - 1; r > 0; r--)(o = t[r] - t[r - 1]) < 0 && !a ? (e?.(), e = void 0) : o && (void 0 === i || o < i) && (i = o);
                }), i;
            },
            getMagnitude: X,
            getNestedProperty: function(t, e) {
                let i = t.split(".");
                for(; i.length && B(e);){
                    let t = i.shift();
                    if (void 0 === t || "__proto__" === t) return;
                    if ("this" === t) {
                        let t;
                        return O(e) && (t = e["@this"]), t ?? e;
                    }
                    let s = e[t.replace(/[\\'"]/g, "")];
                    if (!B(s) || "function" == typeof s || "number" == typeof s.nodeType || s === T) return;
                    e = s;
                }
                return e;
            },
            getStyle: function t(e, i, s) {
                let o;
                if ("width" === i) {
                    let i = Math.min(e.offsetWidth, e.scrollWidth), s = e.getBoundingClientRect?.().width;
                    return s < i && s >= i - 1 && (i = Math.floor(s)), Math.max(0, i - (t(e, "padding-left", !0) || 0) - (t(e, "padding-right", !0) || 0));
                }
                if ("height" === i) return Math.max(0, Math.min(e.offsetHeight, e.scrollHeight) - (t(e, "padding-top", !0) || 0) - (t(e, "padding-bottom", !0) || 0));
                let r = T.getComputedStyle(e, void 0);
                return r && (o = r.getPropertyValue(i), W(s, "opacity" !== i) && (o = A(o))), o;
            },
            insertItem: function(t, e) {
                let i, s = t.options.index, o = e.length;
                for(i = t.options.isInternal ? o : 0; i < o + 1; i++)if (!e[i] || D(s) && s < W(e[i].options.index, e[i]._i) || e[i].options.isInternal) {
                    e.splice(i, 0, t);
                    break;
                }
                return i;
            },
            isArray: L,
            isClass: I,
            isDOMElement: E,
            isFunction: function(t) {
                return "function" == typeof t;
            },
            isNumber: D,
            isObject: O,
            isString: P,
            merge: function(t, ...e) {
                let i, s = [
                    t,
                    ...e
                ], o = {}, r = function(t, e) {
                    return "object" != typeof t && (t = {}), j(e, function(i, s) {
                        "__proto__" !== s && "constructor" !== s && (!O(i, !0) || I(i) || E(i) ? t[s] = e[s] : t[s] = r(t[s] || {}, i));
                    }), t;
                };
                !0 === t && (o = s[1], s = Array.prototype.slice.call(s, 2));
                let a = s.length;
                for(i = 0; i < a; i++)o = r(o, s[i]);
                return o;
            },
            normalizeTickInterval: function(t, e, i, s, o) {
                let r, a = t;
                i = W(i, X(t));
                let n = t / i;
                for(!e && (e = o ? [
                    1,
                    1.2,
                    1.5,
                    2,
                    2.5,
                    3,
                    4,
                    5,
                    6,
                    8,
                    10
                ] : [
                    1,
                    2,
                    2.5,
                    5,
                    10
                ], !1 === s && (1 === i ? e = e.filter(function(t) {
                    return t % 1 == 0;
                }) : i <= .1 && (e = [
                    1 / i
                ]))), r = 0; r < e.length && (a = e[r], (!o || !(a * i >= t)) && (o || !(n <= (e[r] + (e[r + 1] || e[r])) / 2))); r++);
                return F(a * i, -Math.round(Math.log(.001) / Math.LN10));
            },
            objectEach: j,
            offset: function(t) {
                let e = S.documentElement, i = t.parentElement || t.parentNode ? t.getBoundingClientRect() : {
                    top: 0,
                    left: 0,
                    width: 0,
                    height: 0
                };
                return {
                    top: i.top + (T.pageYOffset || e.scrollTop) - (e.clientTop || 0),
                    left: i.left + (T.pageXOffset || e.scrollLeft) - (e.clientLeft || 0),
                    width: i.width,
                    height: i.height
                };
            },
            pad: function(t, e, i) {
                return Array((e || 2) + 1 - String(t).replace("-", "").length).join(i || "0") + t;
            },
            pick: W,
            pInt: A,
            pushUnique: function(t, e) {
                return 0 > t.indexOf(e) && !!t.push(e);
            },
            relativeLength: function(t, e, i) {
                return /%$/.test(t) ? e * parseFloat(t) / 100 + (i || 0) : parseFloat(t);
            },
            removeEvent: Y,
            replaceNested: function(t, ...e) {
                let i, s;
                do for (s of (i = t, e))t = t.replace(s[0], s[1]);
                while (t !== i);
                return t;
            },
            splat: z,
            stableSort: function(t, e) {
                let i, s, o = t.length;
                for(s = 0; s < o; s++)t[s].safeI = s;
                for(t.sort(function(t, s) {
                    return 0 === (i = e(t, s)) ? t.safeI - s.safeI : i;
                }), s = 0; s < o; s++)delete t[s].safeI;
            },
            syncTimeout: function(t, e, i) {
                return e > 0 ? setTimeout(t, e, i) : (t.call(0, i), -1);
            },
            timeUnits: {
                millisecond: 1,
                second: 1e3,
                minute: 6e4,
                hour: 36e5,
                day: 864e5,
                week: 6048e5,
                month: 24192e5,
                year: 314496e5
            },
            ucfirst: function(t) {
                return P(t) ? t.substring(0, 1).toUpperCase() + t.substring(1) : String(t);
            },
            uniqueKey: $,
            useSerialIds: function(e) {
                return t = W(e, t);
            },
            wrap: function(t, e, i) {
                let s = t[e];
                t[e] = function() {
                    let t = arguments, e = this;
                    return i.apply(this, [
                        function() {
                            return s.apply(e, arguments.length ? arguments : t);
                        }
                    ].concat([].slice.call(arguments)));
                };
            }
        }, { pageLang: Z, win: _ } = w, { defined: q, error: K, extend: J, isNumber: Q, isObject: tt, isString: te, merge: ti, objectEach: ts, pad: to, splat: tr, timeUnits: ta, ucfirst: tn } = V, th = w.isSafari && _.Intl && !_.Intl.DateTimeFormat.prototype.formatRange, tl = (t)=>void 0 === t.main, td = class {
            constructor(t, e){
                this.options = {
                    timezone: "UTC"
                }, this.variableTimezone = !1, this.Date = _.Date, this.update(t), this.lang = e;
            }
            update(t = {}) {
                this.dTLCache = {}, this.options = t = ti(!0, this.options, t);
                let { timezoneOffset: e, useUTC: i, locale: s } = t;
                this.Date = t.Date || _.Date || Date;
                let o = t.timezone;
                q(i) && (o = i ? "UTC" : void 0), e && e % 60 == 0 && (o = "Etc/GMT" + (e > 0 ? "+" : "") + e / 60), this.variableTimezone = "UTC" !== o && o?.indexOf("Etc/GMT") !== 0, this.timezone = o, this.lang && s && (this.lang.locale = s), [
                    "months",
                    "shortMonths",
                    "weekdays",
                    "shortWeekdays"
                ].forEach((t)=>{
                    let e = /months/i.test(t), i = /short/.test(t), s = {
                        timeZone: "UTC"
                    };
                    s[e ? "month" : "weekday"] = i ? "short" : "long", this[t] = (e ? [
                        0,
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11
                    ] : [
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9
                    ]).map((t)=>this.dateFormat(s, (e ? 31 : 1) * 24 * 36e5 * t));
                });
            }
            toParts(t) {
                let [e, i, s, o, r, a, n] = this.dateTimeFormat({
                    weekday: "narrow",
                    day: "numeric",
                    month: "numeric",
                    year: "numeric",
                    hour: "numeric",
                    minute: "numeric",
                    second: "numeric"
                }, t, "es").split(/(?:, | |\/|:)/g);
                return [
                    o,
                    s - 1,
                    i,
                    r,
                    a,
                    n,
                    Math.floor(Number(t) || 0) % 1e3,
                    "DLMXJVS".indexOf(e)
                ].map(Number);
            }
            dateTimeFormat(t, e, i = this.options.locale || Z) {
                let s = JSON.stringify(t) + i;
                te(t) && (t = this.str2dtf(t));
                let o = this.dTLCache[s];
                if (!o) {
                    t.timeZone ?? (t.timeZone = this.timezone);
                    try {
                        o = new Intl.DateTimeFormat(i, t);
                    } catch (e) {
                        /Invalid time zone/i.test(e.message) ? (K(34), t.timeZone = "UTC", o = new Intl.DateTimeFormat(i, t)) : K(e.message, !1);
                    }
                }
                return this.dTLCache[s] = o, o?.format(e) || "";
            }
            str2dtf(t, e = {}) {
                let i = {
                    L: {
                        fractionalSecondDigits: 3
                    },
                    S: {
                        second: "2-digit"
                    },
                    M: {
                        minute: "numeric"
                    },
                    H: {
                        hour: "2-digit"
                    },
                    k: {
                        hour: "numeric"
                    },
                    E: {
                        weekday: "narrow"
                    },
                    a: {
                        weekday: "short"
                    },
                    A: {
                        weekday: "long"
                    },
                    d: {
                        day: "2-digit"
                    },
                    e: {
                        day: "numeric"
                    },
                    b: {
                        month: "short"
                    },
                    B: {
                        month: "long"
                    },
                    m: {
                        month: "2-digit"
                    },
                    o: {
                        month: "numeric"
                    },
                    y: {
                        year: "2-digit"
                    },
                    Y: {
                        year: "numeric"
                    }
                };
                return Object.keys(i).forEach((s)=>{
                    -1 !== t.indexOf(s) && J(e, i[s]);
                }), e;
            }
            makeTime(t, e, i = 1, s = 0, o, r, a) {
                let n = this.Date.UTC(t, e, i, s, o || 0, r || 0, a || 0);
                if ("UTC" !== this.timezone) {
                    let t = this.getTimezoneOffset(n);
                    if (n += t, -1 !== [
                        2,
                        3,
                        8,
                        9,
                        10,
                        11
                    ].indexOf(e) && (s < 5 || s > 20)) {
                        let e = this.getTimezoneOffset(n);
                        t !== e ? n += e - t : t - 36e5 !== this.getTimezoneOffset(n - 36e5) || th || (n -= 36e5);
                    }
                }
                return n;
            }
            parse(t) {
                if (!te(t)) return t ?? void 0;
                let e = (t = t.replace(/\//g, "-").replace(/(GMT|UTC)/, "")).indexOf("Z") > -1 || /([+-][0-9]{2}):?[0-9]{2}$/.test(t), i = /^[0-9]{4}-[0-9]{2}(-[0-9]{2}|)$/.test(t);
                e || i || (t += "Z");
                let s = Date.parse(t);
                if (Q(s)) return s + (!e || i ? this.getTimezoneOffset(s) : 0);
            }
            getTimezoneOffset(t) {
                if ("UTC" !== this.timezone) {
                    let [e, i, s, o, r = 0] = this.dateTimeFormat({
                        timeZoneName: "shortOffset"
                    }, t, "en").split(/(GMT|:)/).map(Number), a = -(60 * (s + r / 60) * 6e4);
                    if (Q(a)) return a;
                }
                return 0;
            }
            dateFormat(t, e, i) {
                let s = this.lang;
                if (!q(e) || isNaN(e)) return s?.invalidDate || "";
                if (te(t = t ?? "%Y-%m-%d %H:%M:%S")) {
                    let i, o = /%\[([a-zA-Z]+)\]/g;
                    for(; i = o.exec(t);)t = t.replace(i[0], this.dateTimeFormat(i[1], e, s?.locale));
                }
                if (te(t) && -1 !== t.indexOf("%")) {
                    let i = this, [o, r, a, n, h, l, d, c] = this.toParts(e), p = s?.weekdays || this.weekdays, g = s?.shortWeekdays || this.shortWeekdays, u = s?.months || this.months, f = s?.shortMonths || this.shortMonths;
                    ts(J({
                        a: g ? g[c] : p[c].substr(0, 3),
                        A: p[c],
                        d: to(a),
                        e: to(a, 2, " "),
                        w: c,
                        v: s?.weekFrom ?? "",
                        b: f[r],
                        B: u[r],
                        m: to(r + 1),
                        o: r + 1,
                        y: o.toString().substr(2, 2),
                        Y: o,
                        H: to(n),
                        k: n,
                        I: to(n % 12 || 12),
                        l: n % 12 || 12,
                        M: to(h),
                        p: n < 12 ? "AM" : "PM",
                        P: n < 12 ? "am" : "pm",
                        S: to(l),
                        L: to(d, 3)
                    }, w.dateFormats), function(s, o) {
                        if (te(t)) for(; -1 !== t.indexOf("%" + o);)t = t.replace("%" + o, "function" == typeof s ? s.call(i, e) : s);
                    });
                } else if (tt(t)) {
                    let i = (this.getTimezoneOffset(e) || 0) / 36e5, s = this.timezone || "Etc/GMT" + (i >= 0 ? "+" : "") + i, { prefix: o = "", suffix: r = "" } = t;
                    t = o + this.dateTimeFormat(J({
                        timeZone: s
                    }, t), e) + r;
                }
                return i ? tn(t) : t;
            }
            resolveDTLFormat(t) {
                return tt(t, !0) ? tt(t, !0) && tl(t) ? {
                    main: t
                } : t : {
                    main: (t = tr(t))[0],
                    from: t[1],
                    to: t[2]
                };
            }
            getDateFormat(t, e, i, s) {
                let o = this.dateFormat("%m-%d %H:%M:%S.%L", e), r = "01-01 00:00:00.000", a = {
                    millisecond: 15,
                    second: 12,
                    minute: 9,
                    hour: 6,
                    day: 3
                }, n = "millisecond", h = n;
                for(n in ta){
                    if (t && t === ta.week && +this.dateFormat("%w", e) === i && o.substr(6) === r.substr(6)) {
                        n = "week";
                        break;
                    }
                    if (t && ta[n] > t) {
                        n = h;
                        break;
                    }
                    if (a[n] && o.substr(a[n]) !== r.substr(a[n])) break;
                    "week" !== n && (h = n);
                }
                return this.resolveDTLFormat(s[n]).main;
            }
        }, { defined: tc, extend: tp, timeUnits: tg } = V, tu = class extends td {
            getTimeTicks(t, e, i, s) {
                let o = this, r = [], a = {}, { count: n = 1, unitRange: h } = t, [l, d, c, p, g, u] = o.toParts(e), f = (e || 0) % 1e3, m;
                if (s ?? (s = 1), tc(e)) {
                    if (f = h >= tg.second ? 0 : n * Math.floor(f / n), h >= tg.second && (u = h >= tg.minute ? 0 : n * Math.floor(u / n)), h >= tg.minute && (g = h >= tg.hour ? 0 : n * Math.floor(g / n)), h >= tg.hour && (p = h >= tg.day ? 0 : n * Math.floor(p / n)), h >= tg.day && (c = h >= tg.month ? 1 : Math.max(1, n * Math.floor(c / n))), h >= tg.month && (d = h >= tg.year ? 0 : n * Math.floor(d / n)), h >= tg.year && (l -= l % n), h === tg.week) {
                        n && (e = o.makeTime(l, d, c, p, g, u, f));
                        let t = this.dateTimeFormat({
                            timeZone: this.timezone,
                            weekday: "narrow"
                        }, e, "es"), i = "DLMXJVS".indexOf(t);
                        c += -i + s + (i < s ? -7 : 0);
                    }
                    e = o.makeTime(l, d, c, p, g, u, f), o.variableTimezone && tc(i) && (m = i - e > 4 * tg.month || o.getTimezoneOffset(e) !== o.getTimezoneOffset(i));
                    let t = e, x = 1;
                    for(; t < i;)r.push(t), h === tg.year ? t = o.makeTime(l + x * n, 0) : h === tg.month ? t = o.makeTime(l, d + x * n) : m && (h === tg.day || h === tg.week) ? t = o.makeTime(l, d, c + x * n * (h === tg.day ? 1 : 7)) : m && h === tg.hour && n > 1 ? t = o.makeTime(l, d, c, p + x * n) : t += h * n, x++;
                    r.push(t), h <= tg.hour && r.length < 1e4 && r.forEach((t)=>{
                        t % 18e5 == 0 && "000000000" === o.dateFormat("%H%M%S%L", t) && (a[t] = "day");
                    });
                }
                return r.info = tp(t, {
                    higherRanks: a,
                    totalRange: h * n
                }), r;
            }
        }, { isTouchDevice: tf } = w, { fireEvent: tm, merge: tx } = V, ty = {
            colors: [
                "#2caffe",
                "#544fc5",
                "#00e272",
                "#fe6a35",
                "#6b8abc",
                "#d568fb",
                "#2ee0ca",
                "#fa4b42",
                "#feb56a",
                "#91e8e1"
            ],
            symbols: [
                "circle",
                "diamond",
                "square",
                "triangle",
                "triangle-down"
            ],
            lang: {
                weekFrom: "week from",
                chartTitle: "Chart title",
                locale: void 0,
                loading: "Loading...",
                months: void 0,
                seriesName: "Series {add index 1}",
                shortMonths: void 0,
                weekdays: void 0,
                numericSymbols: [
                    "k",
                    "M",
                    "G",
                    "T",
                    "P",
                    "E"
                ],
                pieSliceName: "Slice",
                resetZoom: "Reset zoom",
                yAxisTitle: "Values",
                resetZoomTitle: "Reset zoom level 1:1"
            },
            global: {
                buttonTheme: {
                    fill: "#f7f7f7",
                    padding: 8,
                    r: 2,
                    stroke: "#cccccc",
                    "stroke-width": 1,
                    style: {
                        color: "#333333",
                        cursor: "pointer",
                        fontSize: "0.8em",
                        fontWeight: "normal"
                    },
                    states: {
                        hover: {
                            fill: "#e6e6e6"
                        },
                        select: {
                            fill: "#e6e9ff",
                            style: {
                                color: "#000000",
                                fontWeight: "bold"
                            }
                        },
                        disabled: {
                            style: {
                                color: "#cccccc"
                            }
                        }
                    }
                }
            },
            time: {
                Date: void 0,
                timezone: "UTC",
                timezoneOffset: 0,
                useUTC: void 0
            },
            chart: {
                alignThresholds: !1,
                panning: {
                    enabled: !1,
                    type: "x"
                },
                styledMode: !1,
                borderRadius: 0,
                colorCount: 10,
                allowMutatingData: !0,
                ignoreHiddenSeries: !0,
                spacing: [
                    10,
                    10,
                    15,
                    10
                ],
                resetZoomButton: {
                    theme: {},
                    position: {}
                },
                reflow: !0,
                type: "line",
                zooming: {
                    singleTouch: !1,
                    resetButton: {
                        theme: {
                            zIndex: 6
                        },
                        position: {
                            align: "right",
                            x: -10,
                            y: 10
                        }
                    }
                },
                width: null,
                height: null,
                borderColor: "#334eff",
                backgroundColor: "#ffffff",
                plotBorderColor: "#cccccc"
            },
            title: {
                style: {
                    color: "#333333",
                    fontWeight: "bold"
                },
                text: "Chart title",
                margin: 15,
                minScale: .67
            },
            subtitle: {
                style: {
                    color: "#666666",
                    fontSize: "0.8em"
                },
                text: ""
            },
            caption: {
                margin: 15,
                style: {
                    color: "#666666",
                    fontSize: "0.8em"
                },
                text: "",
                align: "left",
                verticalAlign: "bottom"
            },
            plotOptions: {},
            legend: {
                enabled: !0,
                align: "center",
                alignColumns: !0,
                className: "highcharts-no-tooltip",
                events: {},
                layout: "horizontal",
                itemMarginBottom: 2,
                itemMarginTop: 2,
                labelFormatter: function() {
                    return this.name;
                },
                borderColor: "#999999",
                borderRadius: 0,
                navigation: {
                    style: {
                        fontSize: "0.8em"
                    },
                    activeColor: "#0022ff",
                    inactiveColor: "#cccccc"
                },
                itemStyle: {
                    color: "#333333",
                    cursor: "pointer",
                    fontSize: "0.8em",
                    textDecoration: "none",
                    textOverflow: "ellipsis"
                },
                itemHoverStyle: {
                    color: "#000000"
                },
                itemHiddenStyle: {
                    color: "#666666",
                    textDecoration: "line-through"
                },
                shadow: !1,
                itemCheckboxStyle: {
                    position: "absolute",
                    width: "13px",
                    height: "13px"
                },
                squareSymbol: !0,
                symbolPadding: 5,
                verticalAlign: "bottom",
                x: 0,
                y: 0,
                title: {
                    style: {
                        color: "#333333",
                        fontSize: "0.8em",
                        fontWeight: "bold"
                    }
                }
            },
            loading: {
                labelStyle: {
                    fontWeight: "bold",
                    position: "relative",
                    top: "45%"
                },
                style: {
                    position: "absolute",
                    backgroundColor: "#ffffff",
                    opacity: .5,
                    textAlign: "center"
                }
            },
            tooltip: {
                enabled: !0,
                animation: {
                    duration: 300,
                    easing: (t)=>Math.sqrt(1 - Math.pow(t - 1, 2))
                },
                borderRadius: 3,
                dateTimeLabelFormats: {
                    millisecond: "%[AebHMSL]",
                    second: "%[AebHMS]",
                    minute: "%[AebHM]",
                    hour: "%[AebHM]",
                    day: "%[AebY]",
                    week: "%v %[AebY]",
                    month: "%[BY]",
                    year: "%Y"
                },
                footerFormat: "",
                headerShape: "callout",
                hideDelay: 500,
                padding: 8,
                position: {
                    x: 0,
                    y: 3
                },
                shared: !1,
                snap: tf ? 25 : 10,
                headerFormat: '<span style="font-size: 0.8em">{ucfirst point.key}</span><br/>',
                pointFormat: '<span style="color:{point.color}">\u25CF</span> {series.name}: <b>{point.y}</b><br/>',
                backgroundColor: "#ffffff",
                borderWidth: void 0,
                stickOnContact: !1,
                style: {
                    color: "#333333",
                    cursor: "default",
                    fontSize: "0.8em"
                },
                useHTML: !1
            },
            credits: {
                enabled: !0,
                href: "https://www.highcharts.com?credits",
                position: {
                    align: "right",
                    x: -10,
                    verticalAlign: "bottom",
                    y: -5
                },
                style: {
                    cursor: "pointer",
                    color: "#999999",
                    fontSize: "0.6em"
                },
                text: "Highcharts.com"
            }
        }, tb = new tu(ty.time, ty.lang), tv = {
            defaultOptions: ty,
            defaultTime: tb,
            getOptions: function() {
                return ty;
            },
            setOptions: function(t) {
                return tm(w, "setOptions", {
                    options: t
                }), tx(!0, ty, t), t.time && tb.update(ty.time), t.lang && "locale" in t.lang && tb.update({
                    locale: t.lang.locale
                }), t.lang?.chartTitle && (ty.title = {
                    ...ty.title,
                    text: t.lang.chartTitle
                }), ty;
            }
        }, { win: tk } = w, { isNumber: tw, isString: tM, merge: tS, pInt: tT, defined: tC } = V, tA = (t, e, i)=>`color-mix(in srgb,${t},${e} ${100 * i}%)`, tP = (t)=>tM(t) && !!t && "none" !== t;
        class tL {
            static parse(t) {
                return t ? new tL(t) : tL.None;
            }
            constructor(t){
                let e, i, s, o;
                this.rgba = [
                    NaN,
                    NaN,
                    NaN,
                    NaN
                ], this.input = t;
                let r = w.Color;
                if (r && r !== tL) return new r(t);
                if ("object" == typeof t && void 0 !== t.stops) this.stops = t.stops.map((t)=>new tL(t[1]));
                else if ("string" == typeof t) for(this.input = t = tL.names[t.toLowerCase()] || t, s = tL.parsers.length; s-- && !i;)(e = (o = tL.parsers[s]).regex.exec(t)) && (i = o.parse(e));
                i && (this.rgba = i);
            }
            get(t) {
                let e = this.input, i = this.rgba;
                if (this.output) return this.output;
                if ("object" == typeof e && void 0 !== this.stops) {
                    let i = tS(e);
                    return i.stops = [].slice.call(i.stops), this.stops.forEach((e, s)=>{
                        i.stops[s] = [
                            i.stops[s][0],
                            e.get(t)
                        ];
                    }), i;
                }
                return i && tw(i[0]) ? "rgb" !== t && (t || 1 !== i[3]) ? "a" === t ? `${i[3]}` : "rgba(" + i.join(",") + ")" : "rgb(" + i[0] + "," + i[1] + "," + i[2] + ")" : e;
            }
            brighten(t) {
                let e = this.rgba;
                if (this.stops) this.stops.forEach(function(e) {
                    e.brighten(t);
                });
                else if (tw(t) && 0 !== t) {
                    if (tw(e[0])) for(let i = 0; i < 3; i++)e[i] += tT(255 * t), e[i] < 0 && (e[i] = 0), e[i] > 255 && (e[i] = 255);
                    else tL.useColorMix && tP(this.input) && (this.output = tA(this.input, t > 0 ? "white" : "black", Math.abs(t)));
                }
                return this;
            }
            setOpacity(t) {
                return this.rgba[3] = t, this;
            }
            tweenTo(t, e) {
                let i = this.rgba, s = t.rgba;
                if (!tw(i[0]) || !tw(s[0])) return tL.useColorMix && tP(this.input) && tP(t.input) && e < .99 ? tA(this.input, t.input, e) : t.input || "none";
                let o = 1 !== s[3] || 1 !== i[3], r = (t, s)=>t + (i[s] - t) * (1 - e), a = s.slice(0, 3).map(r).map(Math.round);
                return o && a.push(r(s[3], 3)), (o ? "rgba(" : "rgb(") + a.join(",") + ")";
            }
        }
        tL.names = {
            white: "#ffffff",
            black: "#000000"
        }, tL.parsers = [
            {
                regex: /rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d?(?:\.\d+)?)\s*\)/,
                parse: function(t) {
                    return [
                        tT(t[1]),
                        tT(t[2]),
                        tT(t[3]),
                        parseFloat(t[4], 10)
                    ];
                }
            },
            {
                regex: /rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)/,
                parse: function(t) {
                    return [
                        tT(t[1]),
                        tT(t[2]),
                        tT(t[3]),
                        1
                    ];
                }
            },
            {
                regex: /^#([a-f0-9])([a-f0-9])([a-f0-9])([a-f0-9])?$/i,
                parse: function(t) {
                    return [
                        tT(t[1] + t[1], 16),
                        tT(t[2] + t[2], 16),
                        tT(t[3] + t[3], 16),
                        tC(t[4]) ? tT(t[4] + t[4], 16) / 255 : 1
                    ];
                }
            },
            {
                regex: /^#([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})?$/i,
                parse: function(t) {
                    return [
                        tT(t[1], 16),
                        tT(t[2], 16),
                        tT(t[3], 16),
                        tC(t[4]) ? tT(t[4], 16) / 255 : 1
                    ];
                }
            }
        ], tL.useColorMix = tk.CSS?.supports("color", "color-mix(in srgb,red,blue 9%)"), tL.None = new tL("");
        let { parse: tO } = tL, { win: tE } = w, { isNumber: tI, objectEach: tD } = V;
        class tB {
            constructor(t, e, i){
                this.pos = NaN, this.options = e, this.elem = t, this.prop = i;
            }
            dSetter() {
                let t = this.paths, e = t?.[0], i = t?.[1], s = this.now || 0, o = [];
                if (1 !== s && e && i) {
                    if (e.length === i.length && s < 1) for(let t = 0; t < i.length; t++){
                        let r = e[t], a = i[t], n = [];
                        for(let t = 0; t < a.length; t++){
                            let e = r[t], i = a[t];
                            tI(e) && tI(i) && ("A" !== a[0] || 4 !== t && 5 !== t) ? n[t] = e + s * (i - e) : n[t] = i;
                        }
                        o.push(n);
                    }
                    else o = i;
                } else o = this.toD || [];
                this.elem.attr("d", o, void 0, !0);
            }
            update() {
                let t = this.elem, e = this.prop, i = this.now, s = this.options.step;
                this[e + "Setter"] ? this[e + "Setter"]() : t.attr ? t.element && t.attr(e, i, null, !0) : t.style[e] = i + this.unit, s && s.call(t, i, this);
            }
            run(t, e, i) {
                let s = this, o = s.options, r = function(t) {
                    return !r.stopped && s.step(t);
                }, a = tE.requestAnimationFrame || function(t) {
                    setTimeout(t, 13);
                }, n = function() {
                    for(let t = 0; t < tB.timers.length; t++)tB.timers[t]() || tB.timers.splice(t--, 1);
                    tB.timers.length && a(n);
                };
                t !== e || this.elem["forceAnimate:" + this.prop] ? (this.startTime = +new Date, this.start = t, this.end = e, this.unit = i, this.now = this.start, this.pos = 0, r.elem = this.elem, r.prop = this.prop, r() && 1 === tB.timers.push(r) && a(n)) : (delete o.curAnim[this.prop], o.complete && 0 === Object.keys(o.curAnim).length && o.complete.call(this.elem));
            }
            step(t) {
                let e, i, s = +new Date, o = this.options, r = this.elem, a = o.complete, n = o.duration, h = o.curAnim;
                return r.attr && !r.element ? e = !1 : t || s >= n + this.startTime ? (this.now = this.end, this.pos = 1, this.update(), h[this.prop] = !0, i = !0, tD(h, function(t) {
                    !0 !== t && (i = !1);
                }), i && a && a.call(r), e = !1) : (this.pos = o.easing((s - this.startTime) / n), this.now = this.start + (this.end - this.start) * this.pos, this.update(), e = !0), e;
            }
            initPath(t, e, i) {
                let s = t.startX, o = t.endX, r = i.slice(), a = t.isArea, n = a ? 2 : 1, h = e && i.length > e.length && i.hasStackedCliffs, l, d, c, p, g = e?.slice();
                if (!g || h) return [
                    r,
                    r
                ];
                function u(t, e) {
                    for(; t.length < d;){
                        let i = t[0], s = e[d - t.length];
                        if (s && "M" === i[0] && ("C" === s[0] ? t[0] = [
                            "C",
                            i[1],
                            i[2],
                            i[1],
                            i[2],
                            i[1],
                            i[2]
                        ] : t[0] = [
                            "L",
                            i[1],
                            i[2]
                        ]), t.unshift(i), a) {
                            let e = t.pop();
                            t.push(t[t.length - 1], e);
                        }
                    }
                }
                function f(t) {
                    for(; t.length < d;){
                        let e = t[Math.floor(t.length / n) - 1].slice();
                        if ("C" === e[0] && (e[1] = e[5], e[2] = e[6]), a) {
                            let i = t[Math.floor(t.length / n)].slice();
                            t.splice(t.length / 2, 0, e, i);
                        } else t.push(e);
                    }
                }
                if (s && o && o.length) {
                    for(c = 0; c < s.length; c++)if (s[c] === o[0]) {
                        l = c;
                        break;
                    } else if (s[0] === o[o.length - s.length + c]) {
                        l = c, p = !0;
                        break;
                    } else if (s[s.length - 1] === o[o.length - s.length + c]) {
                        l = s.length - c;
                        break;
                    }
                    void 0 === l && (g = []);
                }
                return g.length && tI(l) && (d = r.length + l * n, p ? (u(g, r), f(r)) : (u(r, g), f(g))), [
                    g,
                    r
                ];
            }
            fillSetter() {
                tB.prototype.strokeSetter.apply(this, arguments);
            }
            strokeSetter() {
                this.elem.attr(this.prop, tO(this.start).tweenTo(tO(this.end), this.pos), void 0, !0);
            }
        }
        tB.timers = [];
        let { defined: tN, getStyle: tz, isArray: tR, isNumber: tW, isObject: tH, merge: tX, objectEach: tF, pick: tG } = V;
        function tj(t) {
            return tH(t) ? tX({
                duration: 500,
                defer: 0
            }, t) : {
                duration: 500 * !!t,
                defer: 0
            };
        }
        function tY(t, e) {
            let i = tB.timers.length;
            for(; i--;)tB.timers[i].elem !== t || e && e !== tB.timers[i].prop || (tB.timers[i].stopped = !0);
        }
        let tU = {
            animate: function(t, e, i) {
                let s, o = "", r, a, n;
                tH(i) || (n = arguments, i = {
                    duration: n[2],
                    easing: n[3],
                    complete: n[4]
                }), tW(i.duration) || (i.duration = 400), i.easing = "function" == typeof i.easing ? i.easing : Math[i.easing] || Math.easeInOutSine, i.curAnim = tX(e), tF(e, function(n, h) {
                    tY(t, h), a = new tB(t, i, h), r = void 0, "d" === h && tR(e.d) ? (a.paths = a.initPath(t, t.pathArray, e.d), a.toD = e.d, s = 0, r = 1) : t.attr ? s = t.attr(h) : (s = parseFloat(tz(t, h)) || 0, "opacity" !== h && (o = "px")), r || (r = n), "string" == typeof r && r.match("px") && (r = r.replace(/px/g, "")), a.run(s, r, o);
                });
            },
            animObject: tj,
            getDeferredAnimation: function(t, e, i) {
                let s = tj(e), o = i ? [
                    i
                ] : t.series, r = 0, a = 0;
                return o.forEach((t)=>{
                    let i = tj(t.options.animation);
                    r = tH(e) && tN(e.defer) ? s.defer : Math.max(r, i.duration + i.defer), a = Math.min(s.duration, i.duration);
                }), t.renderer.forExport && (r = 0), {
                    defer: Math.max(0, r - a),
                    duration: Math.min(r, a)
                };
            },
            setAnimation: function(t, e) {
                e.renderer.globalAnimation = tG(t, e.options.chart.animation, !0);
            },
            stop: tY
        }, { SVG_NS: t$, win: tV } = w, { attr: tZ, createElement: t_, css: tq, error: tK, isFunction: tJ, isString: tQ, objectEach: t0, splat: t1 } = V, { trustedTypes: t2 } = tV, t3 = t2 && tJ(t2.createPolicy) && t2.createPolicy("highcharts", {
            createHTML: (t)=>t
        }), t5 = t3 ? t3.createHTML("") : "";
        class t6 {
            static filterUserAttributes(t) {
                return t0(t, (e, i)=>{
                    let s = !0;
                    -1 === t6.allowedAttributes.indexOf(i) && (s = !1), -1 !== [
                        "background",
                        "dynsrc",
                        "href",
                        "lowsrc",
                        "src"
                    ].indexOf(i) && (s = tQ(e) && t6.allowedReferences.some((t)=>0 === e.indexOf(t))), s || (tK(33, !1, void 0, {
                        "Invalid attribute in config": `${i}`
                    }), delete t[i]), tQ(e) && t[i] && (t[i] = e.replace(/</g, "&lt;"));
                }), t;
            }
            static parseStyle(t) {
                return t.split(";").reduce((t, e)=>{
                    let i = e.split(":").map((t)=>t.trim()), s = i.shift();
                    return s && i.length && (t[s.replace(/-([a-z])/g, (t)=>t[1].toUpperCase())] = i.join(":")), t;
                }, {});
            }
            static setElementHTML(t, e) {
                t.innerHTML = t6.emptyHTML, e && new t6(e).addToDOM(t);
            }
            constructor(t){
                this.nodes = "string" == typeof t ? this.parseMarkup(t) : t;
            }
            addToDOM(t) {
                return function t(e, i) {
                    let s;
                    return t1(e).forEach(function(e) {
                        let o, r = e.tagName, a = e.textContent ? w.doc.createTextNode(e.textContent) : void 0, n = t6.bypassHTMLFiltering;
                        if (r) {
                            if ("#text" === r) o = a;
                            else if (-1 !== t6.allowedTags.indexOf(r) || n) {
                                let s = "svg" === r ? t$ : i.namespaceURI || t$, h = w.doc.createElementNS(s, r), l = e.attributes || {};
                                t0(e, function(t, e) {
                                    "tagName" !== e && "attributes" !== e && "children" !== e && "style" !== e && "textContent" !== e && (l[e] = t);
                                }), tZ(h, n ? l : t6.filterUserAttributes(l)), e.style && tq(h, e.style), a && h.appendChild(a), t(e.children || [], h), o = h;
                            } else tK(33, !1, void 0, {
                                "Invalid tagName in config": r
                            });
                        }
                        o && i.appendChild(o), s = o;
                    }), s;
                }(this.nodes, t);
            }
            parseMarkup(t) {
                let e, i = [];
                t = t.trim().replace(/ style=(["'])/g, " data-style=$1");
                try {
                    e = new DOMParser().parseFromString(t3 ? t3.createHTML(t) : t, "text/html");
                } catch  {}
                if (!e) {
                    let i = t_("div");
                    i.innerHTML = t, e = {
                        body: i
                    };
                }
                let s = (t, e)=>{
                    let i = t.nodeName.toLowerCase(), o = {
                        tagName: i
                    };
                    "#text" === i && (o.textContent = t.textContent || "");
                    let r = t.attributes;
                    if (r) {
                        let t = {};
                        [].forEach.call(r, (e)=>{
                            "data-style" === e.name ? o.style = t6.parseStyle(e.value) : t[e.name] = e.value;
                        }), o.attributes = t;
                    }
                    if (t.childNodes.length) {
                        let e = [];
                        [].forEach.call(t.childNodes, (t)=>{
                            s(t, e);
                        }), e.length && (o.children = e);
                    }
                    e.push(o);
                };
                return [].forEach.call(e.body.childNodes, (t)=>s(t, i)), i;
            }
        }
        t6.allowedAttributes = [
            "alt",
            "aria-controls",
            "aria-describedby",
            "aria-expanded",
            "aria-haspopup",
            "aria-hidden",
            "aria-label",
            "aria-labelledby",
            "aria-live",
            "aria-pressed",
            "aria-readonly",
            "aria-roledescription",
            "aria-selected",
            "class",
            "clip-path",
            "color",
            "colspan",
            "cx",
            "cy",
            "d",
            "disabled",
            "dx",
            "dy",
            "fill",
            "filterUnits",
            "flood-color",
            "flood-opacity",
            "height",
            "href",
            "id",
            "in",
            "in2",
            "markerHeight",
            "markerWidth",
            "offset",
            "opacity",
            "operator",
            "orient",
            "padding",
            "paddingLeft",
            "paddingRight",
            "patternUnits",
            "r",
            "radius",
            "refX",
            "refY",
            "result",
            "role",
            "rowspan",
            "scope",
            "slope",
            "src",
            "startOffset",
            "stdDeviation",
            "stroke-linecap",
            "stroke-width",
            "stroke",
            "style",
            "summary",
            "tabindex",
            "tableValues",
            "target",
            "text-align",
            "text-anchor",
            "textAnchor",
            "textLength",
            "title",
            "type",
            "valign",
            "width",
            "x",
            "x1",
            "x2",
            "xlink:href",
            "y",
            "y1",
            "y2",
            "zIndex"
        ], t6.allowedReferences = [
            "https://",
            "http://",
            "mailto:",
            "/",
            "../",
            "./",
            "#"
        ], t6.allowedTags = [
            "#text",
            "a",
            "abbr",
            "b",
            "br",
            "button",
            "caption",
            "circle",
            "clipPath",
            "code",
            "dd",
            "defs",
            "div",
            "dl",
            "dt",
            "em",
            "feComponentTransfer",
            "feComposite",
            "feDropShadow",
            "feFlood",
            "feFuncA",
            "feFuncB",
            "feFuncG",
            "feFuncR",
            "feGaussianBlur",
            "feMerge",
            "feMergeNode",
            "feMorphology",
            "feOffset",
            "filter",
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "hr",
            "i",
            "img",
            "li",
            "linearGradient",
            "marker",
            "ol",
            "p",
            "path",
            "pattern",
            "pre",
            "rect",
            "small",
            "span",
            "stop",
            "strong",
            "style",
            "sub",
            "sup",
            "svg",
            "table",
            "tbody",
            "td",
            "text",
            "textPath",
            "th",
            "thead",
            "title",
            "tr",
            "tspan",
            "u",
            "ul"
        ], t6.emptyHTML = t5, t6.bypassHTMLFiltering = !1;
        let { defaultOptions: t9, defaultTime: t4 } = tv, { pageLang: t8 } = w, { extend: t7, getNestedProperty: et, isArray: ee, isNumber: ei, isObject: es, isString: eo, pick: er, ucfirst: ea } = V, en = {
            add: (t, e)=>t + e,
            divide: (t, e)=>0 !== e ? t / e : "",
            eq: (t, e)=>t == e,
            each: function(t) {
                let e = arguments[arguments.length - 1];
                return !!ee(t) && t.map((i, s)=>ed(e.body, t7(es(i) ? i : {
                        "@this": i
                    }, {
                        "@index": s,
                        "@first": 0 === s,
                        "@last": s === t.length - 1
                    }))).join("");
            },
            ge: (t, e)=>t >= e,
            gt: (t, e)=>t > e,
            if: (t)=>!!t,
            le: (t, e)=>t <= e,
            lt: (t, e)=>t < e,
            multiply: (t, e)=>t * e,
            ne: (t, e)=>t != e,
            subtract: (t, e)=>t - e,
            ucfirst: ea,
            unless: (t)=>!t
        }, eh = {}, el = (t)=>/^["'].+["']$/.test(t);
        function ed(t = "", e, i) {
            let s = /\{([a-zA-Z\u00C0-\u017F\d:\.,;\-\/<>\[\]%_@+"'’= #\(\)]+)\}/g, o = /\(([a-zA-Z\u00C0-\u017F\d:\.,;\-\/<>\[\]%_@+"'= ]+)\)/g, r = [], a = /f$/, n = /\.(\d)/, h = i?.options?.lang || t9.lang, l = i?.time || t4, d = i?.numberFormatter || ec.bind(i), c = (t = "")=>{
                let i;
                return "true" === t || "false" !== t && ((i = Number(t)).toString() === t ? i : el(t) ? t.slice(1, -1) : et(t, e));
            }, p, g, u = 0, f;
            for(; null !== (p = s.exec(t));){
                let i = p, s = o.exec(p[1]);
                s && (p = s, f = !0), g?.isBlock || (g = {
                    ctx: e,
                    expression: p[1],
                    find: p[0],
                    isBlock: "#" === p[1].charAt(0),
                    start: p.index,
                    startInner: p.index + p[0].length,
                    length: p[0].length
                });
                let a = (g.isBlock ? i : p)[1].split(" ")[0].replace("#", "");
                en[a] && (g.isBlock && a === g.fn && u++, g.fn || (g.fn = a));
                let n = "else" === p[1];
                if (g.isBlock && g.fn && (p[1] === `/${g.fn}` || n)) {
                    if (u) !n && u--;
                    else {
                        let e = g.startInner, i = t.substr(e, p.index - e);
                        void 0 === g.body ? (g.body = i, g.startInner = p.index + p[0].length) : g.elseBody = i, g.find += i + p[0], n || (r.push(g), g = void 0);
                    }
                } else g.isBlock || r.push(g);
                if (s && !g?.isBlock) break;
            }
            return r.forEach((s)=>{
                let r, p, { body: g, elseBody: u, expression: f, fn: m } = s;
                if (m) {
                    let t = [
                        s
                    ], o = [], a = f.length, n = 0, h;
                    for(p = 0; p <= a; p++){
                        let t = f.charAt(p);
                        h || '"' !== t && "'" !== t ? h === t && (h = "") : h = t, h || " " !== t && p !== a || (o.push(f.substr(n, p - n)), n = p + 1);
                    }
                    for(p = en[m].length; p--;)t.unshift(c(o[p + 1]));
                    r = en[m].apply(e, t), s.isBlock && "boolean" == typeof r && (r = ed(r ? g : u, e, i));
                } else {
                    let t = el(f) ? [
                        f
                    ] : f.split(":"), e = (r = c(t.shift() || "")) % 1 != 0;
                    if ("number" == typeof r && (t.length || e)) {
                        let i = t.join(":");
                        if (a.test(i) || e) {
                            let t = parseInt((i.match(n) || [
                                "",
                                "-1"
                            ])[1], 10);
                            null !== r && (r = d(r, t, h.decimalPoint, i.indexOf(",") > -1 ? h.thousandsSep : ""));
                        } else r = l.dateFormat(i, r);
                    }
                    o.lastIndex = 0, o.test(s.find) && eo(r) && (r = `"${r}"`);
                }
                t = t.replace(s.find, er(r, ""));
            }), f ? ed(t, e, i) : t;
        }
        function ec(t, e, i, s) {
            e *= 1;
            let o, r, [a, n] = (t = +t || 0).toString().split("e").map(Number), h = this?.options?.lang || t9.lang, l = (t.toString().split(".")[1] || "").split("e")[0].length, d = e, c = {};
            i ?? (i = h.decimalPoint), s ?? (s = h.thousandsSep), -1 === e ? e = Math.min(l, 20) : ei(e) ? e && n < 0 && ((r = e + n) >= 0 ? (a = +a.toExponential(r).split("e")[0], e = r) : (a = Math.floor(a), t = e < 20 ? +(a * Math.pow(10, n)).toFixed(e) : 0, n = 0)) : e = 2, n && (e ?? (e = 2), t = a), ei(e) && e >= 0 && (c.minimumFractionDigits = e, c.maximumFractionDigits = e), "" === s && (c.useGrouping = !1);
            let p = s || i, g = p ? "en" : this?.locale || h.locale || t8, u = JSON.stringify(c) + g;
            return o = (eh[u] ?? (eh[u] = new Intl.NumberFormat(g, c))).format(t), p && (o = o.replace(/([,\.])/g, "_$1").replace(/_\,/g, s ?? ",").replace("_.", i ?? ".")), (e || 0 != +o) && (!(n < 0) || d) || (o = "0"), n && 0 != +o && (o += "e" + (n < 0 ? "" : "+") + n), o;
        }
        let ep = {
            dateFormat: function(t, e, i) {
                return t4.dateFormat(t, e, i);
            },
            format: ed,
            helpers: en,
            numberFormat: ec
        };
        !function(t) {
            let e;
            t.rendererTypes = {}, t.getRendererType = function(i = e) {
                return t.rendererTypes[i] || t.rendererTypes[e];
            }, t.registerRendererType = function(i, s, o) {
                t.rendererTypes[i] = s, (!e || o) && (e = i, w.Renderer = s);
            };
        }(s || (s = {}));
        let eg = s, { clamp: eu, pick: ef, pushUnique: em, stableSort: ex } = V;
        (o || (o = {})).distribute = function t(e, i, s) {
            let o = e, r = o.reducedLen || i, a = (t, e)=>t.target - e.target, n = [], h = e.length, l = [], d = n.push, c, p, g, u = !0, f, m, x = 0, y;
            for(c = h; c--;)x += e[c].size;
            if (x > r) {
                for(ex(e, (t, e)=>(e.rank || 0) - (t.rank || 0)), g = (y = e[0].rank === e[e.length - 1].rank) ? h / 2 : -1, p = y ? g : h - 1; g && x > r;)f = e[c = Math.floor(p)], em(l, c) && (x -= f.size), p += g, y && p >= e.length && (g /= 2, p = g);
                l.sort((t, e)=>e - t).forEach((t)=>d.apply(n, e.splice(t, 1)));
            }
            for(ex(e, a), e = e.map((t)=>({
                    size: t.size,
                    targets: [
                        t.target
                    ],
                    align: ef(t.align, .5)
                })); u;){
                for(c = e.length; c--;)f = e[c], m = (Math.min.apply(0, f.targets) + Math.max.apply(0, f.targets)) / 2, f.pos = eu(m - f.size * f.align, 0, i - f.size);
                for(c = e.length, u = !1; c--;)c > 0 && e[c - 1].pos + e[c - 1].size > e[c].pos && (e[c - 1].size += e[c].size, e[c - 1].targets = e[c - 1].targets.concat(e[c].targets), e[c - 1].align = .5, e[c - 1].pos + e[c - 1].size > i && (e[c - 1].pos = i - e[c - 1].size), e.splice(c, 1), u = !0);
            }
            return d.apply(o, n), c = 0, e.some((e)=>{
                let r = 0;
                return (e.targets || []).some(()=>(o[c].pos = e.pos + r, void 0 !== s && Math.abs(o[c].pos - o[c].target) > s) ? (o.slice(0, c + 1).forEach((t)=>delete t.pos), o.reducedLen = (o.reducedLen || i) - .1 * i, o.reducedLen > .1 * i && t(o, i, s), !0) : (r += o[c].size, c++, !1));
            }), ex(o, a), o;
        };
        let ey = o, { animate: eb, animObject: ev, stop: ek } = tU, { deg2rad: ew, doc: eM, svg: eS, SVG_NS: eT, win: eC, isFirefox: eA } = w, { addEvent: eP, attr: eL, createElement: eO, crisp: eE, css: eI, defined: eD, erase: eB, extend: eN, fireEvent: ez, getAlignFactor: eR, isArray: eW, isFunction: eH, isNumber: eX, isObject: eF, isString: eG, merge: ej, objectEach: eY, pick: eU, pInt: e$, pushUnique: eV, replaceNested: eZ, syncTimeout: e_, uniqueKey: eq } = V;
        class eK {
            _defaultGetter(t) {
                let e = eU(this[t + "Value"], this[t], this.element ? this.element.getAttribute(t) : null, 0);
                return /^-?[\d\.]+$/.test(e) && (e = parseFloat(e)), e;
            }
            _defaultSetter(t, e, i) {
                i.setAttribute(e, t);
            }
            add(t) {
                let e, i = this.renderer, s = this.element;
                return t && (this.parentGroup = t), void 0 !== this.textStr && "text" === this.element.nodeName && i.buildText(this), this.added = !0, (!t || t.handleZ || this.zIndex) && (e = this.zIndexSetter()), e || (t ? t.element : i.box).appendChild(s), this.onAdd && this.onAdd(), this;
            }
            addClass(t, e) {
                let i = e ? "" : this.attr("class") || "";
                return (t = (t || "").split(/ /g).reduce(function(t, e) {
                    return -1 === i.indexOf(e) && t.push(e), t;
                }, i ? [
                    i
                ] : []).join(" ")) !== i && this.attr("class", t), this;
            }
            afterSetters() {
                this.doTransform && (this.updateTransform(), this.doTransform = !1);
            }
            align(t, e, i, s = !0) {
                let o = this.renderer, r = o.alignedObjects, a = !!t;
                t ? (this.alignOptions = t, this.alignByTranslate = e, this.alignTo = i) : (t = this.alignOptions || {}, e = this.alignByTranslate, i = this.alignTo);
                let n = !i || eG(i) ? i || "renderer" : void 0;
                n && (a && eV(r, this), i = void 0);
                let h = eU(i, o[n], o), l = (h.x || 0) + (t.x || 0) + ((h.width || 0) - (t.width || 0)) * eR(t.align), d = (h.y || 0) + (t.y || 0) + ((h.height || 0) - (t.height || 0)) * eR(t.verticalAlign), c = {
                    "text-align": t?.align
                };
                return c[e ? "translateX" : "x"] = Math.round(l), c[e ? "translateY" : "y"] = Math.round(d), s && (this[this.placed ? "animate" : "attr"](c), this.placed = !0), this.alignAttr = c, this;
            }
            alignSetter(t) {
                let e = {
                    left: "start",
                    center: "middle",
                    right: "end"
                };
                e[t] && (this.alignValue = t, this.element.setAttribute("text-anchor", e[t]));
            }
            animate(t, e, i) {
                let s = ev(eU(e, this.renderer.globalAnimation, !0)), o = s.defer;
                return eM.hidden && (s.duration = 0), 0 !== s.duration ? (i && (s.complete = i), e_(()=>{
                    this.element && eb(this, t, s);
                }, o)) : (this.attr(t, void 0, i || s.complete), eY(t, function(t, e) {
                    s.step && s.step.call(this, t, {
                        prop: e,
                        pos: 1,
                        elem: this
                    });
                }, this)), this;
            }
            applyTextOutline(t) {
                let e = this.element;
                -1 !== t.indexOf("contrast") && (t = t.replace(/contrast/g, this.renderer.getContrast(e.style.fill)));
                let i = t.indexOf(" "), s = t.substring(i + 1), o = t.substring(0, i);
                if (o && "none" !== o && w.svg) {
                    this.fakeTS = !0, o = o.replace(/(^[\d\.]+)(.*?)$/g, function(t, e, i) {
                        return 2 * Number(e) + i;
                    }), this.removeTextOutline();
                    let t = eM.createElementNS(eT, "tspan");
                    eL(t, {
                        class: "highcharts-text-outline",
                        fill: s,
                        stroke: s,
                        "stroke-width": o,
                        "stroke-linejoin": "round"
                    });
                    let i = e.querySelector("textPath") || e;
                    [].forEach.call(i.childNodes, (e)=>{
                        let i = e.cloneNode(!0);
                        i.removeAttribute && [
                            "fill",
                            "stroke",
                            "stroke-width",
                            "stroke"
                        ].forEach((t)=>i.removeAttribute(t)), t.appendChild(i);
                    });
                    let r = 0;
                    [].forEach.call(i.querySelectorAll("text tspan"), (t)=>{
                        r += Number(t.getAttribute("dy"));
                    });
                    let a = eM.createElementNS(eT, "tspan");
                    a.textContent = "\u200B", eL(a, {
                        x: Number(e.getAttribute("x")),
                        dy: -r
                    }), t.appendChild(a), i.insertBefore(t, i.firstChild);
                }
            }
            attr(t, e, i, s) {
                let { element: o } = this, r = eK.symbolCustomAttribs, a, n, h = this, l;
                return "string" == typeof t && void 0 !== e && (a = t, (t = {})[a] = e), "string" == typeof t ? h = (this[t + "Getter"] || this._defaultGetter).call(this, t, o) : (eY(t, function(e, i) {
                    l = !1, s || ek(this, i), this.symbolName && -1 !== r.indexOf(i) && (n || (this.symbolAttr(t), n = !0), l = !0), this.rotation && ("x" === i || "y" === i) && (this.doTransform = !0), l || (this[i + "Setter"] || this._defaultSetter).call(this, e, i, o);
                }, this), this.afterSetters()), i && i.call(this), h;
            }
            clip(t) {
                if (t && !t.clipPath) {
                    let e = eq() + "-", i = this.renderer.createElement("clipPath").attr({
                        id: e
                    }).add(this.renderer.defs);
                    eN(t, {
                        clipPath: i,
                        id: e,
                        count: 0
                    }), t.add(i);
                }
                return this.attr("clip-path", t ? `url(${this.renderer.url}#${t.id})` : "none");
            }
            crisp(t, e) {
                e = Math.round(e || t.strokeWidth || 0);
                let i = t.x || this.x || 0, s = t.y || this.y || 0, o = (t.width || this.width || 0) + i, r = (t.height || this.height || 0) + s, a = eE(i, e), n = eE(s, e);
                return eN(t, {
                    x: a,
                    y: n,
                    width: eE(o, e) - a,
                    height: eE(r, e) - n
                }), eD(t.strokeWidth) && (t.strokeWidth = e), t;
            }
            complexColor(t, e, i) {
                let s = this.renderer, o, r, a, n, h, l, d, c, p, g, u = [], f;
                ez(this.renderer, "complexColor", {
                    args: arguments
                }, function() {
                    if (t.radialGradient ? r = "radialGradient" : t.linearGradient && (r = "linearGradient"), r) {
                        if (a = t[r], h = s.gradients, l = t.stops, p = i.radialReference, eW(a) && (t[r] = a = {
                            x1: a[0],
                            y1: a[1],
                            x2: a[2],
                            y2: a[3],
                            gradientUnits: "userSpaceOnUse"
                        }), "radialGradient" === r && p && !eD(a.gradientUnits) && (n = a, a = ej(a, s.getRadialAttr(p, n), {
                            gradientUnits: "userSpaceOnUse"
                        })), eY(a, function(t, e) {
                            "id" !== e && u.push(e, t);
                        }), eY(l, function(t) {
                            u.push(t);
                        }), h[u = u.join(",")]) g = h[u].attr("id");
                        else {
                            a.id = g = eq();
                            let t = h[u] = s.createElement(r).attr(a).add(s.defs);
                            t.radAttr = n, t.stops = [], l.forEach(function(e) {
                                0 === e[1].indexOf("rgba") ? (d = (o = tL.parse(e[1])).get("rgb"), c = o.get("a")) : (d = e[1], c = 1);
                                let i = s.createElement("stop").attr({
                                    offset: e[0],
                                    "stop-color": d,
                                    "stop-opacity": c
                                }).add(t);
                                t.stops.push(i);
                            });
                        }
                        f = "url(" + s.url + "#" + g + ")", i.setAttribute(e, f), i.gradient = u, t.toString = function() {
                            return f;
                        };
                    }
                });
            }
            css(t) {
                let e = this.styles, i = {}, s = this.element, o, r = !e;
                if (e && eY(t, function(t, s) {
                    e && e[s] !== t && (i[s] = t, r = !0);
                }), r) {
                    e && (t = eN(e, i)), null === t.width || "auto" === t.width ? delete this.textWidth : "text" === s.nodeName.toLowerCase() && t.width && (o = this.textWidth = e$(t.width)), eN(this.styles, t), o && !eS && this.renderer.forExport && delete t.width;
                    let r = eA && t.fontSize || null;
                    r && (eX(r) || /^\d+$/.test(r)) && (t.fontSize += "px");
                    let a = ej(t);
                    s.namespaceURI === this.SVG_NS && ([
                        "textOutline",
                        "textOverflow",
                        "whiteSpace",
                        "width"
                    ].forEach((t)=>a && delete a[t]), a.color && (a.fill = a.color, delete a.color)), eI(s, a);
                }
                return this.added && ("text" === this.element.nodeName && this.renderer.buildText(this), t.textOutline && this.applyTextOutline(t.textOutline)), this;
            }
            dashstyleSetter(t) {
                let e, i = this["stroke-width"];
                if ("inherit" === i && (i = 1), t) {
                    let s = (t = t.toLowerCase()).replace("shortdashdotdot", "3,1,1,1,1,1,").replace("shortdashdot", "3,1,1,1").replace("shortdot", "1,1,").replace("shortdash", "3,1,").replace("longdash", "8,3,").replace(/dot/g, "1,3,").replace("dash", "4,3,").replace(/,$/, "").split(",");
                    for(e = s.length; e--;)s[e] = "" + e$(s[e]) * eU(i, NaN);
                    t = s.join(",").replace(/NaN/g, "none"), this.element.setAttribute("stroke-dasharray", t);
                }
            }
            destroy() {
                let t = this, e = t.element || {}, i = t.renderer, s = e.ownerSVGElement, o = "SPAN" === e.nodeName && t.parentGroup || void 0, r, a;
                if (e.onclick = e.onmouseout = e.onmouseover = e.onmousemove = e.point = null, ek(t), t.clipPath && s) {
                    let e = t.clipPath;
                    [].forEach.call(s.querySelectorAll("[clip-path],[CLIP-PATH]"), function(t) {
                        t.getAttribute("clip-path").indexOf(e.element.id) > -1 && t.removeAttribute("clip-path");
                    }), t.clipPath = e.destroy();
                }
                if (t.stops) {
                    for(a = 0; a < t.stops.length; a++)t.stops[a].destroy();
                    t.stops.length = 0, t.stops = void 0;
                }
                for(t.safeRemoveChild(e); o?.div && 0 === o.div.childNodes.length;)r = o.parentGroup, t.safeRemoveChild(o.div), delete o.div, o = r;
                t.alignOptions && eB(i.alignedObjects, t), eY(t, (e, i)=>{
                    (t[i]?.parentGroup === t || -1 !== [
                        "connector",
                        "foreignObject"
                    ].indexOf(i)) && t[i]?.destroy?.(), delete t[i];
                });
            }
            dSetter(t, e, i) {
                eW(t) && ("string" == typeof t[0] && (t = this.renderer.pathToSegments(t)), this.pathArray = t, t = t.reduce((t, e, i)=>e?.join ? (i ? t + " " : "") + e.join(" ") : (e || "").toString(), "")), /(NaN| {2}|^$)/.test(t) && (t = "M 0 0"), this[e] !== t && (i.setAttribute(e, t), this[e] = t);
            }
            fillSetter(t, e, i) {
                "string" == typeof t ? i.setAttribute(e, t) : t && this.complexColor(t, e, i);
            }
            hrefSetter(t, e, i) {
                i.setAttributeNS("http://www.w3.org/1999/xlink", e, t);
            }
            getBBox(t, e) {
                let i, s, o, r, { alignValue: a, element: n, renderer: h, styles: l, textStr: d } = this, { cache: c, cacheKeys: p } = h, g = n.namespaceURI === this.SVG_NS, u = eU(e, this.rotation, 0), f = h.styledMode ? n && eK.prototype.getStyle.call(n, "font-size") : l.fontSize;
                if (eD(d) && (-1 === (r = d.toString()).indexOf("<") && (r = r.replace(/\d/g, "0")), r += [
                    "",
                    h.rootFontSize,
                    f,
                    u,
                    this.textWidth,
                    a,
                    l.lineClamp,
                    l.textOverflow,
                    l.fontWeight
                ].join(",")), r && !t && (i = c[r]), !i || i.polygon) {
                    if (g || h.forExport) {
                        try {
                            o = this.fakeTS && function(t) {
                                let e = n.querySelector(".highcharts-text-outline");
                                e && eI(e, {
                                    display: t
                                });
                            }, eH(o) && o("none"), i = n.getBBox ? eN({}, n.getBBox()) : {
                                width: n.offsetWidth,
                                height: n.offsetHeight,
                                x: 0,
                                y: 0
                            }, eH(o) && o("");
                        } catch  {}
                        (!i || i.width < 0) && (i = {
                            x: 0,
                            y: 0,
                            width: 0,
                            height: 0
                        });
                    } else i = this.htmlGetBBox();
                    s = i.height, g && (i.height = s = ({
                        "11px,17": 14,
                        "13px,20": 16
                    })[`${f || ""},${Math.round(s)}`] || s), u && (i = this.getRotatedBox(i, u));
                    let t = {
                        bBox: i
                    };
                    ez(this, "afterGetBBox", t), i = t.bBox;
                }
                if (r && ("" === d || i.height > 0)) {
                    for(; p.length > 250;)delete c[p.shift()];
                    c[r] || p.push(r), c[r] = i;
                }
                return i;
            }
            getRotatedBox(t, e) {
                let { x: i, y: s, width: o, height: r } = t, { alignValue: a, translateY: n, rotationOriginX: h = 0, rotationOriginY: l = 0 } = this, d = eR(a), c = Number(this.element.getAttribute("y") || 0) - (n ? 0 : s), p = e * ew, g = (e - 90) * ew, u = Math.cos(p), f = Math.sin(p), m = o * u, x = o * f, y = Math.cos(g), b = Math.sin(g), [[v, k], [w, M]] = [
                    h,
                    l
                ].map((t)=>[
                        t - t * u,
                        t * f
                    ]), S = i + d * (o - m) + v + M + c * y, T = S + m, C = T - r * y, A = C - m, P = s + c - d * x - k + w + c * b, L = P + x, O = L - r * b, E = O - x, I = Math.min(S, T, C, A), D = Math.min(P, L, O, E), B = Math.max(S, T, C, A) - I, N = Math.max(P, L, O, E) - D;
                return {
                    x: I,
                    y: D,
                    width: B,
                    height: N,
                    polygon: [
                        [
                            S,
                            P
                        ],
                        [
                            T,
                            L
                        ],
                        [
                            C,
                            O
                        ],
                        [
                            A,
                            E
                        ]
                    ]
                };
            }
            getStyle(t) {
                return eC.getComputedStyle(this.element || this, "").getPropertyValue(t);
            }
            hasClass(t) {
                return -1 !== ("" + this.attr("class")).split(" ").indexOf(t);
            }
            hide() {
                return this.attr({
                    visibility: "hidden"
                });
            }
            htmlGetBBox() {
                return {
                    height: 0,
                    width: 0,
                    x: 0,
                    y: 0
                };
            }
            constructor(t, e){
                this.onEvents = {}, this.opacity = 1, this.SVG_NS = eT, this.element = "span" === e || "body" === e ? eO(e) : eM.createElementNS(this.SVG_NS, e), this.renderer = t, this.styles = {}, ez(this, "afterInit");
            }
            on(t, e) {
                let { onEvents: i } = this;
                return i[t] && i[t](), i[t] = eP(this.element, t, e), this;
            }
            opacitySetter(t, e, i) {
                let s = Number(Number(t).toFixed(3));
                this.opacity = s, i.setAttribute(e, s);
            }
            reAlign() {
                this.alignOptions?.width && "left" !== this.alignOptions.align && (this.alignOptions.width = this.getBBox().width, this.placed = !1, this.align());
            }
            removeClass(t) {
                return this.attr("class", ("" + this.attr("class")).replace(eG(t) ? RegExp(`(^| )${t}( |$)`) : t, " ").replace(/ +/g, " ").trim());
            }
            removeTextOutline() {
                let t = this.element.querySelector("tspan.highcharts-text-outline");
                t && this.safeRemoveChild(t);
            }
            safeRemoveChild(t) {
                let e = t.parentNode;
                e && e.removeChild(t);
            }
            setRadialReference(t) {
                let e = this.element.gradient && this.renderer.gradients[this.element.gradient] || void 0;
                return this.element.radialReference = t, e?.radAttr && e.animate(this.renderer.getRadialAttr(t, e.radAttr)), this;
            }
            shadow(t) {
                let { renderer: e } = this, i = ej(this.parentGroup?.rotation === 90 ? {
                    offsetX: -1,
                    offsetY: -1
                } : {}, eF(t) ? t : {}), s = e.shadowDefinition(i);
                return this.attr({
                    filter: t ? `url(${e.url}#${s})` : "none"
                });
            }
            show(t = !0) {
                return this.attr({
                    visibility: t ? "inherit" : "visible"
                });
            }
            "stroke-widthSetter"(t, e, i) {
                this[e] = t, i.setAttribute(e, t);
            }
            strokeWidth() {
                if (!this.renderer.styledMode) return this["stroke-width"] || 0;
                let t = this.getStyle("stroke-width"), e = 0, i;
                return /px$/.test(t) ? e = e$(t) : "" !== t && (eL(i = eM.createElementNS(eT, "rect"), {
                    width: t,
                    "stroke-width": 0
                }), this.element.parentNode.appendChild(i), e = i.getBBox().width, i.parentNode.removeChild(i)), e;
            }
            symbolAttr(t) {
                let e = this;
                eK.symbolCustomAttribs.forEach(function(i) {
                    e[i] = eU(t[i], e[i]);
                }), e.attr({
                    d: e.renderer.symbols[e.symbolName](e.x, e.y, e.width, e.height, e)
                });
            }
            textSetter(t) {
                t !== this.textStr && (delete this.textPxLength, this.textStr = t, this.added && this.renderer.buildText(this), this.reAlign());
            }
            titleSetter(t) {
                let e = this.element, i = e.getElementsByTagName("title")[0] || eM.createElementNS(this.SVG_NS, "title");
                e.insertBefore ? e.insertBefore(i, e.firstChild) : e.appendChild(i), i.textContent = eZ(eU(t, ""), [
                    /<[^>]*>/g,
                    ""
                ]).replace(/&lt;/g, "<").replace(/&gt;/g, ">");
            }
            toFront() {
                let t = this.element;
                return t.parentNode.appendChild(t), this;
            }
            translate(t, e) {
                return this.attr({
                    translateX: t,
                    translateY: e
                });
            }
            updateTransform(t = "transform") {
                let { element: e, foreignObject: i, matrix: s, padding: o, rotation: r = 0, rotationOriginX: a, rotationOriginY: n, scaleX: h, scaleY: l, text: d, translateX: c = 0, translateY: p = 0 } = this, g = [
                    "translate(" + c + "," + p + ")"
                ];
                eD(s) && g.push("matrix(" + s.join(",") + ")"), r && (g.push("rotate(" + r + " " + (a ?? e.getAttribute("x") ?? this.x ?? 0) + " " + (n ?? e.getAttribute("y") ?? this.y ?? 0) + ")"), d?.element.tagName !== "SPAN" || d?.foreignObject || d.attr({
                    rotation: r,
                    rotationOriginX: (a || 0) - o,
                    rotationOriginY: (n || 0) - o
                })), (eD(h) || eD(l)) && g.push("scale(" + eU(h, 1) + " " + eU(l, 1) + ")"), g.length && !(d || this).textPath && (i?.element || e).setAttribute(t, g.join(" "));
            }
            visibilitySetter(t, e, i) {
                "inherit" === t ? i.removeAttribute(e) : this[e] !== t && i.setAttribute(e, t), this[e] = t;
            }
            xGetter(t) {
                return "circle" === this.element.nodeName && ("x" === t ? t = "cx" : "y" === t && (t = "cy")), this._defaultGetter(t);
            }
            zIndexSetter(t, e) {
                let i = this.renderer, s = this.parentGroup, o = (s || i).element || i.box, r = this.element, a = o === i.box, n, h, l, d = !1, c, p = this.added, g;
                if (eD(t) ? (r.setAttribute("data-z-index", t), t *= 1, this[e] === t && (p = !1)) : eD(this[e]) && r.removeAttribute("data-z-index"), this[e] = t, p) {
                    for((t = this.zIndex) && s && (s.handleZ = !0), g = (n = o.childNodes).length - 1; g >= 0 && !d; g--)c = !eD(l = (h = n[g]).getAttribute("data-z-index")), h !== r && (t < 0 && c && !a && !g ? (o.insertBefore(r, n[g]), d = !0) : (e$(l) <= t || c && (!eD(t) || t >= 0)) && (o.insertBefore(r, n[g + 1]), d = !0));
                    d || (o.insertBefore(r, n[3 * !!a]), d = !0);
                }
                return d;
            }
        }
        eK.symbolCustomAttribs = [
            "anchorX",
            "anchorY",
            "clockwise",
            "end",
            "height",
            "innerR",
            "r",
            "start",
            "width",
            "x",
            "y"
        ], eK.prototype.strokeSetter = eK.prototype.fillSetter, eK.prototype.yGetter = eK.prototype.xGetter, eK.prototype.matrixSetter = eK.prototype.rotationOriginXSetter = eK.prototype.rotationOriginYSetter = eK.prototype.rotationSetter = eK.prototype.scaleXSetter = eK.prototype.scaleYSetter = eK.prototype.translateXSetter = eK.prototype.translateYSetter = eK.prototype.verticalAlignSetter = function(t, e) {
            this[e] = t, this.doTransform = !0;
        };
        let eJ = eK, { defined: eQ, extend: e0, getAlignFactor: e1, isNumber: e2, merge: e3, pick: e5, removeEvent: e6 } = V;
        class e9 extends eJ {
            constructor(t, e, i, s, o, r, a, n, h, l){
                let d;
                super(t, "g"), this.paddingLeftSetter = this.paddingSetter, this.paddingRightSetter = this.paddingSetter, this.doUpdate = !1, this.textStr = e, this.x = i, this.y = s, this.anchorX = r, this.anchorY = a, this.baseline = h, this.className = l, this.addClass("button" === l ? "highcharts-no-tooltip" : "highcharts-label"), l && this.addClass("highcharts-" + l), this.text = t.text(void 0, 0, 0, n).attr({
                    zIndex: 1
                }), "string" == typeof o && ((d = /^url\((.*?)\)$/.test(o)) || this.renderer.symbols[o]) && (this.symbolKey = o), this.bBox = e9.emptyBBox, this.padding = 3, this.baselineOffset = 0, this.needsBox = t.styledMode || d, this.deferredAttr = {}, this.alignFactor = 0;
            }
            alignSetter(t) {
                let e = e1(t);
                this.textAlign = t, e !== this.alignFactor && (this.alignFactor = e, this.bBox && e2(this.xSetting) && this.attr({
                    x: this.xSetting
                }));
            }
            anchorXSetter(t, e) {
                this.anchorX = t, this.boxAttr(e, Math.round(t) - this.getCrispAdjust() - this.xSetting);
            }
            anchorYSetter(t, e) {
                this.anchorY = t, this.boxAttr(e, t - this.ySetting);
            }
            boxAttr(t, e) {
                this.box ? this.box.attr(t, e) : this.deferredAttr[t] = e;
            }
            css(t) {
                if (t) {
                    let e = {};
                    t = e3(t), e9.textProps.forEach((i)=>{
                        void 0 !== t[i] && (e[i] = t[i], delete t[i]);
                    }), this.text.css(e), "fontSize" in e || "fontWeight" in e ? this.updateTextPadding() : ("width" in e || "textOverflow" in e) && this.updateBoxSize();
                }
                return eJ.prototype.css.call(this, t);
            }
            destroy() {
                e6(this.element, "mouseenter"), e6(this.element, "mouseleave"), this.text && this.text.destroy(), this.box && (this.box = this.box.destroy()), eJ.prototype.destroy.call(this);
            }
            fillSetter(t, e) {
                t && (this.needsBox = !0), this.fill = t, this.boxAttr(e, t);
            }
            getBBox(t, e) {
                this.textStr && 0 === this.bBox.width && 0 === this.bBox.height && this.updateBoxSize();
                let { padding: i, height: s = 0, translateX: o = 0, translateY: r = 0, width: a = 0 } = this, n = e5(this.paddingLeft, i), h = e ?? (this.rotation || 0), l = {
                    width: a,
                    height: s,
                    x: o + this.bBox.x - n,
                    y: r + this.bBox.y - i + this.baselineOffset
                };
                return h && (l = this.getRotatedBox(l, h)), l;
            }
            getCrispAdjust() {
                return (this.renderer.styledMode && this.box ? this.box.strokeWidth() : this["stroke-width"] ? parseInt(this["stroke-width"], 10) : 0) % 2 / 2;
            }
            heightSetter(t) {
                this.heightSetting = t, this.doUpdate = !0;
            }
            afterSetters() {
                super.afterSetters(), this.doUpdate && (this.updateBoxSize(), this.doUpdate = !1);
            }
            onAdd() {
                this.text.add(this), this.attr({
                    text: e5(this.textStr, ""),
                    x: this.x || 0,
                    y: this.y || 0
                }), this.box && eQ(this.anchorX) && this.attr({
                    anchorX: this.anchorX,
                    anchorY: this.anchorY
                });
            }
            paddingSetter(t, e) {
                e2(t) ? t !== this[e] && (this[e] = t, this.updateTextPadding()) : this[e] = void 0;
            }
            rSetter(t, e) {
                this.boxAttr(e, t);
            }
            strokeSetter(t, e) {
                this.stroke = t, this.boxAttr(e, t);
            }
            "stroke-widthSetter"(t, e) {
                t && (this.needsBox = !0), this["stroke-width"] = t, this.boxAttr(e, t);
            }
            "text-alignSetter"(t) {
                this.textAlign = this["text-align"] = t, this.updateTextPadding();
            }
            textSetter(t) {
                void 0 !== t && this.text.attr({
                    text: t
                }), this.updateTextPadding(), this.reAlign();
            }
            updateBoxSize() {
                let t, e = this.text, i = {}, s = this.padding, o = this.bBox = (!e2(this.widthSetting) || !e2(this.heightSetting) || this.textAlign) && eQ(e.textStr) ? e.getBBox(void 0, 0) : e9.emptyBBox;
                this.width = this.getPaddedWidth(), this.height = (this.heightSetting || o.height || 0) + 2 * s;
                let r = this.renderer.fontMetrics(e);
                if (this.baselineOffset = s + Math.min((this.text.firstLineMetrics || r).b, o.height || 1 / 0), this.heightSetting && (this.baselineOffset += (this.heightSetting - r.h) / 2), this.needsBox && !e.textPath) {
                    if (!this.box) {
                        let t = this.box = this.symbolKey ? this.renderer.symbol(this.symbolKey) : this.renderer.rect();
                        t.addClass(("button" === this.className ? "" : "highcharts-label-box") + (this.className ? " highcharts-" + this.className + "-box" : "")), t.add(this);
                    }
                    i.x = t = this.getCrispAdjust(), i.y = (this.baseline ? -this.baselineOffset : 0) + t, i.width = Math.round(this.width), i.height = Math.round(this.height), this.box.attr(e0(i, this.deferredAttr)), this.deferredAttr = {};
                }
            }
            updateTextPadding() {
                let t = this.text, e = t.styles.textAlign || this.textAlign;
                if (!t.textPath) {
                    this.updateBoxSize();
                    let i = this.baseline ? 0 : this.baselineOffset, s = (this.paddingLeft ?? this.padding) + e1(e) * (this.widthSetting ?? this.bBox.width);
                    (s !== t.x || i !== t.y) && (t.attr({
                        align: e,
                        x: s
                    }), void 0 !== i && t.attr("y", i)), t.x = s, t.y = i;
                }
            }
            widthSetter(t) {
                this.widthSetting = e2(t) ? t : void 0, this.doUpdate = !0;
            }
            getPaddedWidth() {
                let t = this.padding, e = e5(this.paddingLeft, t), i = e5(this.paddingRight, t);
                return (this.widthSetting || this.bBox.width || 0) + e + i;
            }
            xSetter(t) {
                this.x = t, this.alignFactor && (t -= this.alignFactor * this.getPaddedWidth(), this["forceAnimate:x"] = !0), this.anchorX && (this["forceAnimate:anchorX"] = !0), this.xSetting = Math.round(t), this.attr("translateX", this.xSetting);
            }
            ySetter(t) {
                this.anchorY && (this["forceAnimate:anchorY"] = !0), this.ySetting = this.y = Math.round(t), this.attr("translateY", this.ySetting);
            }
        }
        e9.emptyBBox = {
            width: 0,
            height: 0,
            x: 0,
            y: 0
        }, e9.textProps = [
            "color",
            "direction",
            "fontFamily",
            "fontSize",
            "fontStyle",
            "fontWeight",
            "lineClamp",
            "lineHeight",
            "textAlign",
            "textDecoration",
            "textOutline",
            "textOverflow",
            "whiteSpace",
            "width"
        ];
        let { defined: e4, isNumber: e8, pick: e7 } = V;
        function it(t, e, i, s, o) {
            let r = [];
            if (o) {
                let a = o.start || 0, n = o.end || 0, h = e7(o.r, i), l = e7(o.r, s || i), d = 2e-4 / (o.borderRadius ? 1 : Math.max(h, 1)), c = Math.abs(n - a - 2 * Math.PI) < d;
                c && (a = Math.PI / 2, n = 2.5 * Math.PI - d);
                let p = o.innerR, g = e7(o.open, c), u = Math.cos(a), f = Math.sin(a), m = Math.cos(n), x = Math.sin(n), y = e7(o.longArc, n - a - Math.PI < d ? 0 : 1), b = [
                    "A",
                    h,
                    l,
                    0,
                    y,
                    e7(o.clockwise, 1),
                    t + h * m,
                    e + l * x
                ];
                b.params = {
                    start: a,
                    end: n,
                    cx: t,
                    cy: e
                }, r.push([
                    "M",
                    t + h * u,
                    e + l * f
                ], b), e4(p) && ((b = [
                    "A",
                    p,
                    p,
                    0,
                    y,
                    e4(o.clockwise) ? 1 - o.clockwise : 0,
                    t + p * u,
                    e + p * f
                ]).params = {
                    start: n,
                    end: a,
                    cx: t,
                    cy: e
                }, r.push(g ? [
                    "M",
                    t + p * m,
                    e + p * x
                ] : [
                    "L",
                    t + p * m,
                    e + p * x
                ], b)), g || r.push([
                    "Z"
                ]);
            }
            return r;
        }
        function ie(t, e, i, s, o) {
            return o?.r ? ii(t, e, i, s, o) : [
                [
                    "M",
                    t,
                    e
                ],
                [
                    "L",
                    t + i,
                    e
                ],
                [
                    "L",
                    t + i,
                    e + s
                ],
                [
                    "L",
                    t,
                    e + s
                ],
                [
                    "Z"
                ]
            ];
        }
        function ii(t, e, i, s, o) {
            let r = o?.r || 0;
            return [
                [
                    "M",
                    t + r,
                    e
                ],
                [
                    "L",
                    t + i - r,
                    e
                ],
                [
                    "A",
                    r,
                    r,
                    0,
                    0,
                    1,
                    t + i,
                    e + r
                ],
                [
                    "L",
                    t + i,
                    e + s - r
                ],
                [
                    "A",
                    r,
                    r,
                    0,
                    0,
                    1,
                    t + i - r,
                    e + s
                ],
                [
                    "L",
                    t + r,
                    e + s
                ],
                [
                    "A",
                    r,
                    r,
                    0,
                    0,
                    1,
                    t,
                    e + s - r
                ],
                [
                    "L",
                    t,
                    e + r
                ],
                [
                    "A",
                    r,
                    r,
                    0,
                    0,
                    1,
                    t + r,
                    e
                ],
                [
                    "Z"
                ]
            ];
        }
        let is = {
            arc: it,
            callout: function(t, e, i, s, o) {
                let r = Math.min(o?.r || 0, i, s), a = r + 6, n = o?.anchorX, h = o?.anchorY || 0, l = ii(t, e, i, s, {
                    r: r
                });
                if (!e8(n) || n < i && n > 0 && h < s && h > 0) return l;
                if (t + n > i - a) {
                    if (h > e + a && h < e + s - a) l.splice(3, 1, [
                        "L",
                        t + i,
                        h - 6
                    ], [
                        "L",
                        t + i + 6,
                        h
                    ], [
                        "L",
                        t + i,
                        h + 6
                    ], [
                        "L",
                        t + i,
                        e + s - r
                    ]);
                    else if (n < i) {
                        let o = h < e + a, d = o ? e : e + s;
                        l.splice(o ? 2 : 5, 0, [
                            "L",
                            n,
                            h
                        ], [
                            "L",
                            t + i - r,
                            d
                        ]);
                    } else l.splice(3, 1, [
                        "L",
                        t + i,
                        s / 2
                    ], [
                        "L",
                        n,
                        h
                    ], [
                        "L",
                        t + i,
                        s / 2
                    ], [
                        "L",
                        t + i,
                        e + s - r
                    ]);
                } else if (t + n < a) {
                    if (h > e + a && h < e + s - a) l.splice(7, 1, [
                        "L",
                        t,
                        h + 6
                    ], [
                        "L",
                        t - 6,
                        h
                    ], [
                        "L",
                        t,
                        h - 6
                    ], [
                        "L",
                        t,
                        e + r
                    ]);
                    else if (n > 0) {
                        let i = h < e + a, o = i ? e : e + s;
                        l.splice(i ? 1 : 6, 0, [
                            "L",
                            n,
                            h
                        ], [
                            "L",
                            t + r,
                            o
                        ]);
                    } else l.splice(7, 1, [
                        "L",
                        t,
                        s / 2
                    ], [
                        "L",
                        n,
                        h
                    ], [
                        "L",
                        t,
                        s / 2
                    ], [
                        "L",
                        t,
                        e + r
                    ]);
                } else h > s && n < i - a ? l.splice(5, 1, [
                    "L",
                    n + 6,
                    e + s
                ], [
                    "L",
                    n,
                    e + s + 6
                ], [
                    "L",
                    n - 6,
                    e + s
                ], [
                    "L",
                    t + r,
                    e + s
                ]) : h < 0 && n > a && l.splice(1, 1, [
                    "L",
                    n - 6,
                    e
                ], [
                    "L",
                    n,
                    e - 6
                ], [
                    "L",
                    n + 6,
                    e
                ], [
                    "L",
                    i - r,
                    e
                ]);
                return l;
            },
            circle: function(t, e, i, s) {
                return it(t + i / 2, e + s / 2, i / 2, s / 2, {
                    start: .5 * Math.PI,
                    end: 2.5 * Math.PI,
                    open: !1
                });
            },
            diamond: function(t, e, i, s) {
                return [
                    [
                        "M",
                        t + i / 2,
                        e
                    ],
                    [
                        "L",
                        t + i,
                        e + s / 2
                    ],
                    [
                        "L",
                        t + i / 2,
                        e + s
                    ],
                    [
                        "L",
                        t,
                        e + s / 2
                    ],
                    [
                        "Z"
                    ]
                ];
            },
            rect: ie,
            roundedRect: ii,
            square: ie,
            triangle: function(t, e, i, s) {
                return [
                    [
                        "M",
                        t + i / 2,
                        e
                    ],
                    [
                        "L",
                        t + i,
                        e + s
                    ],
                    [
                        "L",
                        t,
                        e + s
                    ],
                    [
                        "Z"
                    ]
                ];
            },
            "triangle-down": function(t, e, i, s) {
                return [
                    [
                        "M",
                        t,
                        e
                    ],
                    [
                        "L",
                        t + i,
                        e
                    ],
                    [
                        "L",
                        t + i / 2,
                        e + s
                    ],
                    [
                        "Z"
                    ]
                ];
            }
        }, { doc: io, SVG_NS: ir, win: ia } = w, { attr: ih, extend: il, fireEvent: id, isString: ic, objectEach: ip, pick: ig } = V, iu = (t, e)=>t.substring(0, e) + "\u2026", im = class {
            constructor(t){
                let e = t.styles;
                this.renderer = t.renderer, this.svgElement = t, this.width = t.textWidth, this.textLineHeight = e?.lineHeight, this.textOutline = e?.textOutline, this.ellipsis = e?.textOverflow === "ellipsis", this.lineClamp = e?.lineClamp, this.noWrap = e?.whiteSpace === "nowrap";
            }
            buildSVG() {
                let t = this.svgElement, e = t.element, i = t.renderer, s = ig(t.textStr, "").toString(), o = -1 !== s.indexOf("<"), r = e.childNodes, a = !t.added && i.box, n = [
                    s,
                    this.ellipsis,
                    this.noWrap,
                    this.textLineHeight,
                    this.textOutline,
                    t.getStyle("font-size"),
                    t.styles.lineClamp,
                    this.width
                ].join(",");
                if (n !== t.textCache) {
                    t.textCache = n, delete t.actualWidth;
                    for(let t = r.length; t--;)e.removeChild(r[t]);
                    if (o || this.ellipsis || this.width || t.textPath || -1 !== s.indexOf(" ") && (!this.noWrap || /<br.*?>/g.test(s))) {
                        if ("" !== s) {
                            a && a.appendChild(e);
                            let i = new t6(s);
                            this.modifyTree(i.nodes), i.addToDOM(e), this.modifyDOM(), this.ellipsis && -1 !== (e.textContent || "").indexOf("\u2026") && t.attr("title", this.unescapeEntities(t.textStr || "", [
                                "&lt;",
                                "&gt;"
                            ])), a && a.removeChild(e);
                        }
                    } else e.appendChild(io.createTextNode(this.unescapeEntities(s)));
                    ic(this.textOutline) && t.applyTextOutline && t.applyTextOutline(this.textOutline);
                }
            }
            modifyDOM() {
                let t, e = this.svgElement, i = ih(e.element, "x");
                for(e.firstLineMetrics = void 0; t = e.element.firstChild;)if (/^[\s\u200B]*$/.test(t.textContent || " ")) e.element.removeChild(t);
                else break;
                [].forEach.call(e.element.querySelectorAll("tspan.highcharts-br"), (t, s)=>{
                    t.nextSibling && t.previousSibling && (0 === s && 1 === t.previousSibling.nodeType && (e.firstLineMetrics = e.renderer.fontMetrics(t.previousSibling)), ih(t, {
                        dy: this.getLineHeight(t.nextSibling),
                        x: i
                    }));
                });
                let s = this.width || 0;
                if (!s) return;
                let o = (t, o)=>{
                    let r = t.textContent || "", a = r.replace(/([^\^])-/g, "$1- ").split(" "), n = !this.noWrap && (a.length > 1 || e.element.childNodes.length > 1), h = this.getLineHeight(o), l = Math.max(0, s - .8 * h), d = 0, c = e.actualWidth;
                    if (n) {
                        let r = [], n = [];
                        for(; o.firstChild && o.firstChild !== t;)n.push(o.firstChild), o.removeChild(o.firstChild);
                        for(; a.length;)if (a.length && !this.noWrap && d > 0 && (r.push(t.textContent || ""), t.textContent = a.join(" ").replace(/- /g, "-")), this.truncate(t, void 0, a, 0 === d && c || 0, s, l, (t, e)=>a.slice(0, e).join(" ").replace(/- /g, "-")), c = e.actualWidth, d++, this.lineClamp && d >= this.lineClamp) {
                            a.length && (this.truncate(t, t.textContent || "", void 0, 0, s, l, iu), t.textContent = t.textContent?.replace("\u2026", "") + "\u2026");
                            break;
                        }
                        n.forEach((e)=>{
                            o.insertBefore(e, t);
                        }), r.forEach((e)=>{
                            o.insertBefore(io.createTextNode(e), t);
                            let s = io.createElementNS(ir, "tspan");
                            s.textContent = "\u200B", ih(s, {
                                dy: h,
                                x: i
                            }), o.insertBefore(s, t);
                        });
                    } else this.ellipsis && r && this.truncate(t, r, void 0, 0, s, l, iu);
                }, r = (t)=>{
                    [].slice.call(t.childNodes).forEach((i)=>{
                        i.nodeType === ia.Node.TEXT_NODE ? o(i, t) : (-1 !== i.className.baseVal.indexOf("highcharts-br") && (e.actualWidth = 0), r(i));
                    });
                };
                r(e.element);
            }
            getLineHeight(t) {
                let e = t.nodeType === ia.Node.TEXT_NODE ? t.parentElement : t;
                return this.textLineHeight ? parseInt(this.textLineHeight.toString(), 10) : this.renderer.fontMetrics(e || this.svgElement.element).h;
            }
            modifyTree(t) {
                let e = (i, s)=>{
                    let { attributes: o = {}, children: r, style: a = {}, tagName: n } = i, h = this.renderer.styledMode;
                    if ("b" === n || "strong" === n ? h ? o.class = "highcharts-strong" : a.fontWeight = "bold" : ("i" === n || "em" === n) && (h ? o.class = "highcharts-emphasized" : a.fontStyle = "italic"), a?.color && (a.fill = a.color), "br" === n) {
                        o.class = "highcharts-br", i.textContent = "\u200B";
                        let e = t[s + 1];
                        e?.textContent && (e.textContent = e.textContent.replace(/^ +/gm, ""));
                    } else "a" === n && r && r.some((t)=>"#text" === t.tagName) && (i.children = [
                        {
                            children: r,
                            tagName: "tspan"
                        }
                    ]);
                    "#text" !== n && "a" !== n && (i.tagName = "tspan"), il(i, {
                        attributes: o,
                        style: a
                    }), r && r.filter((t)=>"#text" !== t.tagName).forEach(e);
                };
                t.forEach(e), id(this.svgElement, "afterModifyTree", {
                    nodes: t
                });
            }
            truncate(t, e, i, s, o, r, a) {
                let n, h, l = this.svgElement, { rotation: d } = l, c = [], p = i && !s ? 1 : 0, g = (e || i || "").length, u = g;
                i || (o = r);
                let f = function(e, o) {
                    let r = o || e, a = t.parentNode;
                    if (a && void 0 === c[r] && a.getSubStringLength) try {
                        c[r] = s + a.getSubStringLength(0, i ? r + 1 : r);
                    } catch  {}
                    return c[r];
                };
                if (l.rotation = 0, s + (h = f(t.textContent.length)) > o) {
                    for(; p <= g;)u = Math.ceil((p + g) / 2), i && (n = a(i, u)), h = f(u, n && n.length - 1), p === g ? p = g + 1 : h > o ? g = u - 1 : p = u;
                    0 === g ? t.textContent = "" : e && g === e.length - 1 || (t.textContent = n || a(e || i, u)), this.ellipsis && h > o && this.truncate(t, t.textContent || "", void 0, 0, o, r, iu);
                }
                i && i.splice(0, u), l.actualWidth = h, l.rotation = d;
            }
            unescapeEntities(t, e) {
                return ip(this.renderer.escapes, function(i, s) {
                    e && -1 !== e.indexOf(i) || (t = t.toString().replace(RegExp(i, "g"), s));
                }), t;
            }
        }, { defaultOptions: ix } = tv, { charts: iy, deg2rad: ib, doc: iv, isFirefox: ik, isMS: iw, isWebKit: iM, noop: iS, SVG_NS: iT, symbolSizes: iC, win: iA } = w, { addEvent: iP, attr: iL, createElement: iO, crisp: iE, css: iI, defined: iD, destroyObjectProperties: iB, extend: iN, isArray: iz, isNumber: iR, isObject: iW, isString: iH, merge: iX, pick: iF, pInt: iG, replaceNested: ij, uniqueKey: iY } = V;
        class iU {
            constructor(t, e, i, s, o, r, a){
                let n, h;
                this.x = 0, this.y = 0;
                let l = this.createElement("svg").attr({
                    version: "1.1",
                    class: "highcharts-root"
                }), d = l.element;
                a || l.css(this.getStyle(s || {})), t.appendChild(d), iL(t, "dir", "ltr"), -1 === t.innerHTML.indexOf("xmlns") && iL(d, "xmlns", this.SVG_NS), this.box = d, this.boxWrapper = l, this.alignedObjects = [], this.url = this.getReferenceURL(), this.createElement("desc").add().element.appendChild(iv.createTextNode("Created with Highcharts 12.4.0")), this.defs = this.createElement("defs").add(), this.allowHTML = r, this.forExport = o, this.styledMode = a, this.gradients = {}, this.cache = {}, this.cacheKeys = [], this.imgCount = 0, this.rootFontSize = l.getStyle("font-size"), this.setSize(e, i, !1), ik && t.getBoundingClientRect && ((n = function() {
                    iI(t, {
                        left: 0,
                        top: 0
                    }), h = t.getBoundingClientRect(), iI(t, {
                        left: Math.ceil(h.left) - h.left + "px",
                        top: Math.ceil(h.top) - h.top + "px"
                    });
                })(), this.unSubPixelFix = iP(iA, "resize", n));
            }
            definition(t) {
                return new t6([
                    t
                ]).addToDOM(this.defs.element);
            }
            getReferenceURL() {
                if ((ik || iM) && iv.getElementsByTagName("base").length) {
                    if (!iD(e)) {
                        let t = iY(), i = new t6([
                            {
                                tagName: "svg",
                                attributes: {
                                    width: 8,
                                    height: 8
                                },
                                children: [
                                    {
                                        tagName: "defs",
                                        children: [
                                            {
                                                tagName: "clipPath",
                                                attributes: {
                                                    id: t
                                                },
                                                children: [
                                                    {
                                                        tagName: "rect",
                                                        attributes: {
                                                            width: 4,
                                                            height: 4
                                                        }
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        tagName: "rect",
                                        attributes: {
                                            id: "hitme",
                                            width: 8,
                                            height: 8,
                                            "clip-path": `url(#${t})`,
                                            fill: "rgba(0,0,0,0.001)"
                                        }
                                    }
                                ]
                            }
                        ]).addToDOM(iv.body);
                        iI(i, {
                            position: "fixed",
                            top: 0,
                            left: 0,
                            zIndex: 9e5
                        });
                        let s = iv.elementFromPoint(6, 6);
                        e = s?.id === "hitme", iv.body.removeChild(i);
                    }
                    if (e) return ij(iA.location.href.split("#")[0], [
                        /<[^>]*>/g,
                        ""
                    ], [
                        /([\('\)])/g,
                        "\\$1"
                    ], [
                        / /g,
                        "%20"
                    ]);
                }
                return "";
            }
            getStyle(t) {
                return this.style = iN({
                    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", sans-serif',
                    fontSize: "1rem"
                }, t), this.style;
            }
            setStyle(t) {
                this.boxWrapper.css(this.getStyle(t));
            }
            isHidden() {
                return !this.boxWrapper.getBBox().width;
            }
            destroy() {
                let t = this.defs;
                return this.box = null, this.boxWrapper = this.boxWrapper.destroy(), iB(this.gradients || {}), this.gradients = null, this.defs = t.destroy(), this.unSubPixelFix && this.unSubPixelFix(), this.alignedObjects = null, null;
            }
            createElement(t) {
                return new this.Element(this, t);
            }
            getRadialAttr(t, e) {
                return {
                    cx: t[0] - t[2] / 2 + (e.cx || 0) * t[2],
                    cy: t[1] - t[2] / 2 + (e.cy || 0) * t[2],
                    r: (e.r || 0) * t[2]
                };
            }
            shadowDefinition(t) {
                let e = [
                    `highcharts-drop-shadow-${this.chartIndex}`,
                    ...Object.keys(t).map((e)=>`${e}-${t[e]}`)
                ].join("-").toLowerCase().replace(/[^a-z\d\-]/g, ""), i = iX({
                    color: "#000000",
                    offsetX: 1,
                    offsetY: 1,
                    opacity: .15,
                    width: 5
                }, t);
                return this.defs.element.querySelector(`#${e}`) || this.definition({
                    tagName: "filter",
                    attributes: {
                        id: e,
                        filterUnits: i.filterUnits
                    },
                    children: this.getShadowFilterContent(i)
                }), e;
            }
            getShadowFilterContent(t) {
                return [
                    {
                        tagName: "feDropShadow",
                        attributes: {
                            dx: t.offsetX,
                            dy: t.offsetY,
                            "flood-color": t.color,
                            "flood-opacity": Math.min(5 * t.opacity, 1),
                            stdDeviation: t.width / 2
                        }
                    }
                ];
            }
            buildText(t) {
                new im(t).buildSVG();
            }
            getContrast(t) {
                if ("transparent" === t) return "#000000";
                let e = tL.parse(t).rgba, i = " clamp(0,calc(9e9*(0.5 - (0.2126*r + 0.7152*g + 0.0722*b))),1)";
                if (iR(e[0]) || !tL.useColorMix) {
                    let t = e.map((t)=>{
                        let e = t / 255;
                        return e <= .04 ? e / 12.92 : Math.pow((e + .055) / 1.055, 2.4);
                    }), i = .2126 * t[0] + .7152 * t[1] + .0722 * t[2];
                    return 1.05 / (i + .05) > (i + .05) / .05 ? "#FFFFFF" : "#000000";
                }
                return "color(from " + t + " srgb" + i + i + i + ")";
            }
            button(t, e, i, s, o = {}, r, a, n, h, l) {
                let d = this.label(t, e, i, h, void 0, void 0, l, void 0, "button"), c = this.styledMode, p = arguments, g = 0;
                o = iX(ix.global.buttonTheme, o), c && (delete o.fill, delete o.stroke, delete o["stroke-width"]);
                let u = o.states || {}, f = o.style || {};
                delete o.states, delete o.style;
                let m = [
                    t6.filterUserAttributes(o)
                ], x = [
                    f
                ];
                return c || [
                    "hover",
                    "select",
                    "disabled"
                ].forEach((t, e)=>{
                    m.push(iX(m[0], t6.filterUserAttributes(p[e + 5] || u[t] || {}))), x.push(m[e + 1].style), delete m[e + 1].style;
                }), iP(d.element, iw ? "mouseover" : "mouseenter", function() {
                    3 !== g && d.setState(1);
                }), iP(d.element, iw ? "mouseout" : "mouseleave", function() {
                    3 !== g && d.setState(g);
                }), d.setState = (t = 0)=>{
                    if (1 !== t && (d.state = g = t), d.removeClass(/highcharts-button-(normal|hover|pressed|disabled)/).addClass("highcharts-button-" + [
                        "normal",
                        "hover",
                        "pressed",
                        "disabled"
                    ][t]), !c) {
                        d.attr(m[t]);
                        let e = x[t];
                        iW(e) && d.css(e);
                    }
                }, d.attr(m[0]), !c && (d.css(iN({
                    cursor: "default"
                }, f)), l && d.text.css({
                    pointerEvents: "none"
                })), d.on("touchstart", (t)=>t.stopPropagation()).on("click", function(t) {
                    3 !== g && s?.call(d, t);
                });
            }
            crispLine(t, e) {
                let [i, s] = t;
                return iD(i[1]) && i[1] === s[1] && (i[1] = s[1] = iE(i[1], e)), iD(i[2]) && i[2] === s[2] && (i[2] = s[2] = iE(i[2], e)), t;
            }
            path(t) {
                let e = this.styledMode ? {} : {
                    fill: "none"
                };
                return iz(t) ? e.d = t : iW(t) && iN(e, t), this.createElement("path").attr(e);
            }
            circle(t, e, i) {
                let s = iW(t) ? t : void 0 === t ? {} : {
                    x: t,
                    y: e,
                    r: i
                }, o = this.createElement("circle");
                return o.xSetter = o.ySetter = function(t, e, i) {
                    i.setAttribute("c" + e, t);
                }, o.attr(s);
            }
            arc(t, e, i, s, o, r) {
                let a;
                iW(t) ? (e = (a = t).y, i = a.r, s = a.innerR, o = a.start, r = a.end, t = a.x) : a = {
                    innerR: s,
                    start: o,
                    end: r
                };
                let n = this.symbol("arc", t, e, i, i, a);
                return n.r = i, n;
            }
            rect(t, e, i, s, o, r) {
                let a = iW(t) ? t : void 0 === t ? {} : {
                    x: t,
                    y: e,
                    r: o,
                    width: Math.max(i || 0, 0),
                    height: Math.max(s || 0, 0)
                }, n = this.createElement("rect");
                return this.styledMode || (void 0 !== r && (a["stroke-width"] = r, iN(a, n.crisp(a))), a.fill = "none"), n.rSetter = function(t, e, i) {
                    n.r = t, iL(i, {
                        rx: t,
                        ry: t
                    });
                }, n.rGetter = function() {
                    return n.r || 0;
                }, n.attr(a);
            }
            roundedRect(t) {
                return this.symbol("roundedRect").attr(t);
            }
            setSize(t, e, i) {
                this.width = t, this.height = e, this.boxWrapper.animate({
                    width: t,
                    height: e
                }, {
                    step: function() {
                        this.attr({
                            viewBox: "0 0 " + this.attr("width") + " " + this.attr("height")
                        });
                    },
                    duration: iF(i, !0) ? void 0 : 0
                }), this.alignElements();
            }
            g(t) {
                let e = this.createElement("g");
                return t ? e.attr({
                    class: "highcharts-" + t
                }) : e;
            }
            image(t, e, i, s, o, r) {
                let a = {
                    preserveAspectRatio: "none"
                };
                iR(e) && (a.x = e), iR(i) && (a.y = i), iR(s) && (a.width = s), iR(o) && (a.height = o);
                let n = this.createElement("image").attr(a), h = function(e) {
                    n.attr({
                        href: t
                    }), r.call(n, e);
                };
                if (r) {
                    n.attr({
                        href: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                    });
                    let e = new iA.Image;
                    iP(e, "load", h), e.src = t, e.complete && h({});
                } else n.attr({
                    href: t
                });
                return n;
            }
            symbol(t, e, i, s, o, r) {
                let a, n, h, l, d = this, c = /^url\((.*?)\)$/, p = c.test(t), g = !p && (this.symbols[t] ? t : "circle"), u = g && this.symbols[g];
                if (u) "number" == typeof e && (n = u.call(this.symbols, e || 0, i || 0, s || 0, o || 0, r)), a = this.path(n), d.styledMode || a.attr("fill", "none"), iN(a, {
                    symbolName: g || void 0,
                    x: e,
                    y: i,
                    width: s,
                    height: o
                }), r && iN(a, r);
                else if (p) {
                    h = t.match(c)[1];
                    let s = a = this.image(h);
                    s.imgwidth = iF(r?.width, iC[h]?.width), s.imgheight = iF(r?.height, iC[h]?.height), l = (t)=>t.attr({
                            width: t.width,
                            height: t.height
                        }), [
                        "width",
                        "height"
                    ].forEach((t)=>{
                        s[`${t}Setter`] = function(t, e) {
                            this[e] = t;
                            let { alignByTranslate: i, element: s, width: o, height: a, imgwidth: n, imgheight: h } = this, l = "width" === e ? n : h, d = 1;
                            r && "within" === r.backgroundSize && o && a && n && h ? (d = Math.min(o / n, a / h), iL(s, {
                                width: Math.round(n * d),
                                height: Math.round(h * d)
                            })) : s && l && s.setAttribute(e, l), !i && n && h && this.translate(((o || 0) - n * d) / 2, ((a || 0) - h * d) / 2);
                        };
                    }), iD(e) && s.attr({
                        x: e,
                        y: i
                    }), s.isImg = !0, s.symbolUrl = t, iD(s.imgwidth) && iD(s.imgheight) ? l(s) : (s.attr({
                        width: 0,
                        height: 0
                    }), iO("img", {
                        onload: function() {
                            let t = iy[d.chartIndex];
                            0 === this.width && (iI(this, {
                                position: "absolute",
                                top: "-999em"
                            }), iv.body.appendChild(this)), iC[h] = {
                                width: this.width,
                                height: this.height
                            }, s.imgwidth = this.width, s.imgheight = this.height, s.element && l(s), this.parentNode && this.parentNode.removeChild(this), d.imgCount--, d.imgCount || !t || t.hasLoaded || t.onload();
                        },
                        src: h
                    }), this.imgCount++);
                }
                return a;
            }
            clipRect(t, e, i, s) {
                return this.rect(t, e, i, s, 0);
            }
            text(t, e, i, s) {
                let o = {};
                if (s && (this.allowHTML || !this.forExport)) return this.html(t, e, i);
                o.x = Math.round(e || 0), i && (o.y = Math.round(i)), iD(t) && (o.text = t);
                let r = this.createElement("text").attr(o);
                return s && (!this.forExport || this.allowHTML) || (r.xSetter = function(t, e, i) {
                    let s = i.getElementsByTagName("tspan"), o = i.getAttribute(e);
                    for(let i = 0, r; i < s.length; i++)(r = s[i]).getAttribute(e) === o && r.setAttribute(e, t);
                    i.setAttribute(e, t);
                }), r;
            }
            fontMetrics(t) {
                let e = iR(t) ? t : iG(eJ.prototype.getStyle.call(t, "font-size") || 0), i = e < 24 ? e + 3 : Math.round(1.2 * e), s = Math.round(.8 * i);
                return {
                    h: i,
                    b: s,
                    f: e
                };
            }
            rotCorr(t, e, i) {
                let s = t;
                return e && i && (s = Math.max(s * Math.cos(e * ib), 4)), {
                    x: -t / 3 * Math.sin(e * ib),
                    y: s
                };
            }
            pathToSegments(t) {
                let e = [], i = [], s = {
                    A: 8,
                    C: 7,
                    H: 2,
                    L: 3,
                    M: 3,
                    Q: 5,
                    S: 5,
                    T: 3,
                    V: 2
                };
                for(let o = 0; o < t.length; o++)iH(i[0]) && iR(t[o]) && i.length === s[i[0].toUpperCase()] && t.splice(o, 0, i[0].replace("M", "L").replace("m", "l")), "string" == typeof t[o] && (i.length && e.push(i.slice(0)), i.length = 0), i.push(t[o]);
                return e.push(i.slice(0)), e;
            }
            label(t, e, i, s, o, r, a, n, h) {
                return new e9(this, t, e, i, s, o, r, a, n, h);
            }
            alignElements() {
                this.alignedObjects.forEach((t)=>t.align());
            }
        }
        iN(iU.prototype, {
            Element: eJ,
            SVG_NS: iT,
            escapes: {
                "&": "&amp;",
                "<": "&lt;",
                ">": "&gt;",
                "'": "&#39;",
                '"': "&quot;"
            },
            symbols: is,
            draw: iS
        }), eg.registerRendererType("svg", iU, !0);
        let { composed: i$, isFirefox: iV } = w, { attr: iZ, css: i_, createElement: iq, defined: iK, extend: iJ, getAlignFactor: iQ, isNumber: i0, pInt: i1, pushUnique: i2 } = V;
        function i3(t, e, i) {
            let s = this.div?.style;
            eJ.prototype[`${e}Setter`].call(this, t, e, i), s && (i.style[e] = s[e] = t);
        }
        let i5 = (t, e)=>{
            if (!t.div) {
                let i = iZ(t.element, "class"), s = t.css, o = iq("div", i ? {
                    className: i
                } : void 0, {
                    position: "absolute",
                    left: `${t.translateX || 0}px`,
                    top: `${t.translateY || 0}px`,
                    ...t.styles,
                    display: t.display,
                    opacity: t.opacity,
                    visibility: t.visibility
                }, t.parentGroup?.div || e);
                t.classSetter = (t, e, i)=>{
                    i.setAttribute("class", t), o.className = t;
                }, t.translateXSetter = t.translateYSetter = (e, i)=>{
                    t[i] = e, o.style["translateX" === i ? "left" : "top"] = `${e}px`, t.doTransform = !0;
                }, t.scaleXSetter = t.scaleYSetter = (e, i)=>{
                    t[i] = e, t.doTransform = !0;
                }, t.opacitySetter = t.visibilitySetter = i3, t.css = (e)=>(s.call(t, e), e.cursor && (o.style.cursor = e.cursor), e.pointerEvents && (o.style.pointerEvents = e.pointerEvents), t), t.on = function() {
                    return eJ.prototype.on.apply({
                        element: o,
                        onEvents: t.onEvents
                    }, arguments), t;
                }, t.div = o;
            }
            return t.div;
        };
        class i6 extends eJ {
            static compose(t) {
                i2(i$, this.compose) && (t.prototype.html = function(t, e, i) {
                    return new i6(this, "span").attr({
                        text: t,
                        x: Math.round(e),
                        y: Math.round(i)
                    });
                });
            }
            constructor(t, e){
                super(t, e), i6.useForeignObject ? this.foreignObject = t.createElement("foreignObject").attr({
                    zIndex: 2
                }) : this.css({
                    position: "absolute",
                    ...t.styledMode ? {} : {
                        fontFamily: t.style.fontFamily,
                        fontSize: t.style.fontSize
                    }
                }), this.element.style.whiteSpace = "nowrap";
            }
            getSpanCorrection(t, e, i) {
                this.xCorr = -t * i, this.yCorr = -e;
            }
            css(t) {
                let e, { element: i } = this, s = "SPAN" === i.tagName && t && "width" in t, o = s && t.width;
                return s && (delete t.width, this.textWidth = i1(o) || void 0, e = !0), t?.textOverflow === "ellipsis" && (t.overflow = "hidden", t.whiteSpace = "nowrap"), t?.lineClamp && (t.display = "-webkit-box", t.WebkitLineClamp = t.lineClamp, t.WebkitBoxOrient = "vertical", t.overflow = "hidden"), i0(Number(t?.fontSize)) && (t.fontSize += "px"), iJ(this.styles, t), i_(i, t), e && this.updateTransform(), this;
            }
            htmlGetBBox() {
                let { element: t } = this;
                return {
                    x: t.offsetLeft,
                    y: t.offsetTop,
                    width: t.offsetWidth,
                    height: t.offsetHeight
                };
            }
            updateTransform() {
                if (!this.added) {
                    this.alignOnAdd = !0;
                    return;
                }
                let { element: t, foreignObject: e, oldTextWidth: i, renderer: s, rotation: o, rotationOriginX: r, rotationOriginY: a, scaleX: n, scaleY: h, styles: { display: l = "inline-block", whiteSpace: d }, textAlign: c = "left", textWidth: p, translateX: g = 0, translateY: u = 0, x: f = 0, y: m = 0 } = this;
                if (e || i_(t, {
                    marginLeft: `${g}px`,
                    marginTop: `${u}px`
                }), "SPAN" === t.tagName) {
                    let g, u = [
                        o,
                        c,
                        t.innerHTML,
                        p,
                        this.textAlign
                    ].join(","), x = -(this.parentGroup?.padding * 1) || 0;
                    if (p !== i) {
                        let e = this.textPxLength ? this.textPxLength : (i_(t, {
                            width: "",
                            whiteSpace: d || "nowrap"
                        }), t.offsetWidth), r = p || 0, a = !s.styledMode && "" === t.style.textOverflow && t.style.webkitLineClamp;
                        (r > i || e > r || a) && (/[\-\s\u00AD]/.test(t.textContent || t.innerText) || "ellipsis" === t.style.textOverflow) && (i_(t, {
                            width: (o || n || e > r || a) && i0(p) ? p + "px" : "auto",
                            display: l,
                            whiteSpace: d || "normal"
                        }), this.oldTextWidth = p);
                    }
                    e && (i_(t, {
                        display: "inline-block",
                        verticalAlign: "top"
                    }), e.attr({
                        width: s.width,
                        height: s.height
                    })), u !== this.cTT && (g = s.fontMetrics(t).b, iK(o) && !e && (o !== (this.oldRotation || 0) || c !== this.oldAlign) && i_(t, {
                        transform: `rotate(${o}deg)`,
                        transformOrigin: `${x}% ${x}px`
                    }), this.getSpanCorrection(!iK(o) && !this.textWidth && this.textPxLength || t.offsetWidth, g, iQ(c)));
                    let { xCorr: y = 0, yCorr: b = 0 } = this, v = {
                        left: `${f + y}px`,
                        top: `${m + b}px`,
                        textAlign: c,
                        transformOrigin: `${(r ?? f) - y - f - x}px ${(a ?? m) - b - m - x}px`
                    };
                    (n || h) && (v.transform = `scale(${n ?? 1},${h ?? 1})`), e ? (super.updateTransform(), i0(f) && i0(m) ? (e.attr({
                        x: f + y,
                        y: m + b,
                        width: t.offsetWidth + 3,
                        height: t.offsetHeight,
                        "transform-origin": t.getAttribute("transform-origin") || "0 0"
                    }), i_(t, {
                        display: l,
                        textAlign: c
                    })) : iV && e.attr({
                        width: 0,
                        height: 0
                    })) : i_(t, v), this.cTT = u, this.oldRotation = o, this.oldAlign = c;
                }
            }
            add(t) {
                let { foreignObject: e, renderer: i } = this, s = i.box.parentNode, o = [];
                if (e) e.add(t), super.add(i.createElement("body").attr({
                    xmlns: "http://www.w3.org/1999/xhtml"
                }).css({
                    background: "transparent",
                    margin: "0 3px 0 0"
                }).add(e));
                else {
                    let e;
                    if (this.parentGroup = t, t && !(e = t.div)) {
                        let i = t;
                        for(; i;)o.push(i), i = i.parentGroup;
                        for (let t of o.reverse())e = i5(t, s);
                    }
                    (e || s).appendChild(this.element);
                }
                return this.added = !0, this.alignOnAdd && this.updateTransform(), this;
            }
            textSetter(t) {
                t !== this.textStr && (delete this.bBox, delete this.oldTextWidth, t6.setElementHTML(this.element, t ?? ""), this.textStr = t, this.doTransform = !0);
            }
            alignSetter(t) {
                this.alignValue = this.textAlign = t, this.doTransform = !0;
            }
            xSetter(t, e) {
                this[e] = t, this.doTransform = !0;
            }
        }
        let i9 = i6.prototype;
        i9.visibilitySetter = i9.opacitySetter = i3, i9.ySetter = i9.rotationSetter = i9.rotationOriginXSetter = i9.rotationOriginYSetter = i9.xSetter, !function(t) {
            t.xAxis = {
                alignTicks: !0,
                allowDecimals: void 0,
                panningEnabled: !0,
                zIndex: 2,
                zoomEnabled: !0,
                dateTimeLabelFormats: {
                    millisecond: {
                        main: "%[HMSL]",
                        range: !1
                    },
                    second: {
                        main: "%[HMS]",
                        range: !1
                    },
                    minute: {
                        main: "%[HM]",
                        range: !1
                    },
                    hour: {
                        main: "%[HM]",
                        range: !1
                    },
                    day: {
                        main: "%[eb]"
                    },
                    week: {
                        main: "%[eb]"
                    },
                    month: {
                        main: "%[bY]"
                    },
                    year: {
                        main: "%Y"
                    }
                },
                endOnTick: !1,
                gridLineDashStyle: "Solid",
                gridZIndex: 1,
                labels: {
                    autoRotationLimit: 80,
                    distance: 15,
                    enabled: !0,
                    indentation: 10,
                    overflow: "justify",
                    reserveSpace: void 0,
                    rotation: void 0,
                    staggerLines: 0,
                    step: 0,
                    useHTML: !1,
                    zIndex: 7,
                    style: {
                        color: "#333333",
                        cursor: "default",
                        fontSize: "0.8em",
                        textOverflow: "ellipsis"
                    }
                },
                maxPadding: .01,
                minorGridLineDashStyle: "Solid",
                minorTickLength: 2,
                minorTickPosition: "outside",
                minorTicksPerMajor: 5,
                minPadding: .01,
                offset: void 0,
                reversed: void 0,
                reversedStacks: !1,
                showEmpty: !0,
                showFirstLabel: !0,
                showLastLabel: !0,
                startOfWeek: 1,
                startOnTick: !1,
                tickLength: 10,
                tickPixelInterval: 100,
                tickmarkPlacement: "between",
                tickPosition: "outside",
                title: {
                    align: "middle",
                    useHTML: !1,
                    x: 0,
                    y: 0,
                    style: {
                        color: "#666666",
                        fontSize: "0.8em"
                    }
                },
                visible: !0,
                minorGridLineColor: "#f2f2f2",
                minorGridLineWidth: 1,
                minorTickColor: "#999999",
                lineColor: "#333333",
                lineWidth: 1,
                gridLineColor: "#e6e6e6",
                gridLineWidth: void 0,
                tickColor: "#333333"
            }, t.yAxis = {
                reversedStacks: !0,
                endOnTick: !0,
                maxPadding: .05,
                minPadding: .05,
                tickPixelInterval: 72,
                showLastLabel: !0,
                labels: {
                    x: void 0
                },
                startOnTick: !0,
                title: {},
                stackLabels: {
                    animation: {},
                    allowOverlap: !1,
                    enabled: !1,
                    crop: !0,
                    overflow: "justify",
                    formatter: function() {
                        let { numberFormatter: t } = this.axis.chart;
                        return t(this.total || 0, -1);
                    },
                    style: {
                        color: "#000000",
                        fontSize: "0.7em",
                        fontWeight: "bold",
                        textOutline: "1px contrast"
                    }
                },
                gridLineWidth: 1,
                lineWidth: 0
            };
        }(r || (r = {}));
        let i4 = r, { addEvent: i8, isFunction: i7, objectEach: st, removeEvent: se } = V;
        (a || (a = {})).registerEventOptions = function(t, e) {
            t.eventOptions = t.eventOptions || {}, st(e.events, function(e, i) {
                t.eventOptions[i] !== e && (t.eventOptions[i] && (se(t, i, t.eventOptions[i]), delete t.eventOptions[i]), i7(e) && (t.eventOptions[i] = e, i8(t, i, e, {
                    order: 0
                })));
            });
        };
        let si = a, { deg2rad: ss } = w, { clamp: so, correctFloat: sr, defined: sa, destroyObjectProperties: sn, extend: sh, fireEvent: sl, getAlignFactor: sd, isNumber: sc, merge: sp, objectEach: sg, pick: su } = V, sf = class {
            constructor(t, e, i, s, o){
                this.isNew = !0, this.isNewLabel = !0, this.axis = t, this.pos = e, this.type = i || "", this.parameters = o || {}, this.tickmarkOffset = this.parameters.tickmarkOffset, this.options = this.parameters.options, sl(this, "init"), i || s || this.addLabel();
            }
            addLabel() {
                let t = this, e = t.axis, i = e.options, s = e.chart, o = e.categories, r = e.logarithmic, a = e.names, n = t.pos, h = su(t.options?.labels, i.labels), l = e.tickPositions, d = n === l[0], c = n === l[l.length - 1], p = (!h.step || 1 === h.step) && 1 === e.tickInterval, g = l.info, u = t.label, f, m, x, y = this.parameters.category || (o ? su(o[n], a[n], n) : n);
                r && sc(y) && (y = sr(r.lin2log(y))), e.dateTime && (g ? f = (m = s.time.resolveDTLFormat(i.dateTimeLabelFormats[!i.grid?.enabled && g.higherRanks[n] || g.unitName])).main : sc(y) && (f = e.dateTime.getXDateFormat(y, i.dateTimeLabelFormats || {}))), t.isFirst = d, t.isLast = c;
                let b = {
                    axis: e,
                    chart: s,
                    dateTimeLabelFormat: f,
                    isFirst: d,
                    isLast: c,
                    pos: n,
                    tick: t,
                    tickPositionInfo: g,
                    value: y
                };
                sl(this, "labelFormat", b);
                let v = (t)=>h.formatter ? h.formatter.call(t, t) : h.format ? (t.text = e.defaultLabelFormatter.call(t), ep.format(h.format, t, s)) : e.defaultLabelFormatter.call(t), k = v.call(b, b), w = m?.list;
                w ? t.shortenLabel = function() {
                    for(x = 0; x < w.length; x++)if (sh(b, {
                        dateTimeLabelFormat: w[x]
                    }), u.attr({
                        text: v.call(b, b)
                    }), u.getBBox().width < e.getSlotWidth(t) - 2 * (h.padding || 0)) return;
                    u.attr({
                        text: ""
                    });
                } : t.shortenLabel = void 0, p && e._addedPlotLB && t.moveLabel(k, h), sa(u) || t.movedLabel ? u && u.textStr !== k && !p && (!u.textWidth || h.style.width || u.styles.width || u.css({
                    width: null
                }), u.attr({
                    text: k
                }), u.textPxLength = u.getBBox().width) : (t.label = u = t.createLabel(k, h), t.rotation = 0);
            }
            createLabel(t, e, i) {
                let s = this.axis, { renderer: o, styledMode: r } = s.chart, a = e.style.whiteSpace, n = sa(t) && e.enabled ? o.text(t, i?.x, i?.y, e.useHTML).add(s.labelGroup) : void 0;
                return n && (r || n.css(sp(e.style)), n.textPxLength = n.getBBox().width, !r && a && n.css({
                    whiteSpace: a
                })), n;
            }
            destroy() {
                sn(this, this.axis);
            }
            getPosition(t, e, i, s) {
                let o = this.axis, r = o.chart, a = s && r.oldChartHeight || r.chartHeight, n = {
                    x: t ? sr(o.translate(e + i, void 0, void 0, s) + o.transB) : o.left + o.offset + (o.opposite ? (s && r.oldChartWidth || r.chartWidth) - o.right - o.left : 0),
                    y: t ? a - o.bottom + o.offset - (o.opposite ? o.height : 0) : sr(a - o.translate(e + i, void 0, void 0, s) - o.transB)
                };
                return n.y = so(n.y, -1000000000, 1e9), sl(this, "afterGetPosition", {
                    pos: n
                }), n;
            }
            getLabelPosition(t, e, i, s, o, r, a, n) {
                let h, l, d = this.axis, c = d.transA, p = d.isLinked && d.linkedParent ? d.linkedParent.reversed : d.reversed, g = d.staggerLines, u = d.tickRotCorr || {
                    x: 0,
                    y: 0
                }, f = s || d.reserveSpaceDefault ? 0 : -d.labelOffset * ("center" === d.labelAlign ? .5 : 1), m = o.distance, x = {};
                return h = 0 === d.side ? i.rotation ? -m : -i.getBBox().height : 2 === d.side ? u.y + m : Math.cos(i.rotation * ss) * (u.y - i.getBBox(!1, 0).height / 2), sa(o.y) && (h = 0 === d.side && d.horiz ? o.y + h : o.y), t = t + su(o.x, [
                    0,
                    1,
                    0,
                    -1
                ][d.side] * m) + f + u.x - (r && s ? r * c * (p ? -1 : 1) : 0), e = e + h - (r && !s ? r * c * (p ? 1 : -1) : 0), g && (l = a / (n || 1) % g, d.opposite && (l = g - l - 1), e += l * (d.labelOffset / g)), x.x = t, x.y = Math.round(e), sl(this, "afterGetLabelPosition", {
                    pos: x,
                    tickmarkOffset: r,
                    index: a
                }), x;
            }
            getLabelSize() {
                return this.label ? this.label.getBBox()[this.axis.horiz ? "height" : "width"] : 0;
            }
            getMarkPath(t, e, i, s, o = !1, r) {
                return r.crispLine([
                    [
                        "M",
                        t,
                        e
                    ],
                    [
                        "L",
                        t + (o ? 0 : -i),
                        e + (o ? i : 0)
                    ]
                ], s);
            }
            handleOverflow(t) {
                let e = this.axis, i = e.options.labels, s = t.x, o = e.chart.chartWidth, r = e.chart.spacing, a = su(e.labelLeft, Math.min(e.pos, r[3])), n = su(e.labelRight, Math.max(e.isRadial ? 0 : e.pos + e.len, o - r[1])), h = this.label, l = this.rotation, d = sd(e.labelAlign || h.attr("align")), c = h.getBBox().width, p = e.getSlotWidth(this), g = p, u = 1, f;
                l || "justify" !== i.overflow ? l < 0 && s - d * c < a ? f = Math.round(s / Math.cos(l * ss) - a) : l > 0 && s + d * c > n && (f = Math.round((o - s) / Math.cos(l * ss))) : (s - d * c < a ? g = t.x + g * (1 - d) - a : s + (1 - d) * c > n && (g = n - t.x + g * d, u = -1), (g = Math.min(p, g)) < p && "center" === e.labelAlign && (t.x += u * (p - g - d * (p - Math.min(c, g)))), (c > g || e.autoRotation && h?.styles?.width) && (f = g)), f && h && (this.shortenLabel ? this.shortenLabel() : h.css(sh({}, {
                    width: Math.floor(f) + "px",
                    lineClamp: +!e.isRadial
                })));
            }
            moveLabel(t, e) {
                let i = this, s = i.label, o = i.axis, r = !1, a;
                s && s.textStr === t ? (i.movedLabel = s, r = !0, delete i.label) : sg(o.ticks, function(e) {
                    r || e.isNew || e === i || !e.label || e.label.textStr !== t || (i.movedLabel = e.label, r = !0, e.labelPos = i.movedLabel.xy, delete e.label);
                }), !r && (i.labelPos || s) && (a = i.labelPos || s.xy, i.movedLabel = i.createLabel(t, e, a), i.movedLabel && i.movedLabel.attr({
                    opacity: 0
                }));
            }
            render(t, e, i) {
                let s = this.axis, o = s.horiz, r = this.pos, a = su(this.tickmarkOffset, s.tickmarkOffset), n = this.getPosition(o, r, a, e), h = n.x, l = n.y, d = s.pos, c = d + s.len, p = o ? h : l, g = su(i, this.label?.newOpacity, 1);
                !s.chart.polar && (sr(p) < d || p > c) && (i = 0), i ?? (i = 1), this.isActive = !0, this.renderGridLine(e, i), this.renderMark(n, i), this.renderLabel(n, e, g, t), this.isNew = !1, sl(this, "afterRender");
            }
            renderGridLine(t, e) {
                let i = this.axis, s = i.options, o = {}, r = this.pos, a = this.type, n = su(this.tickmarkOffset, i.tickmarkOffset), h = i.chart.renderer, l = this.gridLine, d, c = s.gridLineWidth, p = s.gridLineColor, g = s.gridLineDashStyle;
                "minor" === this.type && (c = s.minorGridLineWidth, p = s.minorGridLineColor, g = s.minorGridLineDashStyle), l || (i.chart.styledMode || (o.stroke = p, o["stroke-width"] = c || 0, o.dashstyle = g), a || (o.zIndex = 1), t && (e = 0), this.gridLine = l = h.path().attr(o).addClass("highcharts-" + (a ? a + "-" : "") + "grid-line").add(i.gridGroup)), l && (d = i.getPlotLinePath({
                    value: r + n,
                    lineWidth: l.strokeWidth(),
                    force: "pass",
                    old: t,
                    acrossPanes: !1
                })) && l[t || this.isNew ? "attr" : "animate"]({
                    d: d,
                    opacity: e
                });
            }
            renderMark(t, e) {
                let i = this.axis, s = i.options, o = i.chart.renderer, r = this.type, a = i.tickSize(r ? r + "Tick" : "tick"), n = t.x, h = t.y, l = su(s["minor" !== r ? "tickWidth" : "minorTickWidth"], !r && i.isXAxis ? 1 : 0), d = s["minor" !== r ? "tickColor" : "minorTickColor"], c = this.mark, p = !c;
                a && (i.opposite && (a[0] = -a[0]), !c && (this.mark = c = o.path().addClass("highcharts-" + (r ? r + "-" : "") + "tick").add(i.axisGroup), i.chart.styledMode || c.attr({
                    stroke: d,
                    "stroke-width": l
                })), c[p ? "attr" : "animate"]({
                    d: this.getMarkPath(n, h, a[0], c.strokeWidth(), i.horiz, o),
                    opacity: e
                }));
            }
            renderLabel(t, e, i, s) {
                let o = this.axis, r = o.horiz, a = o.options, n = this.label, h = a.labels, l = h.step, d = su(this.tickmarkOffset, o.tickmarkOffset), c = t.x, p = t.y, g = !0;
                n && sc(c) && (n.xy = t = this.getLabelPosition(c, p, n, r, h, d, s, l), (!this.isFirst || this.isLast || a.showFirstLabel) && (!this.isLast || this.isFirst || a.showLastLabel) ? !r || h.step || h.rotation || e || 0 === i || this.handleOverflow(t) : g = !1, l && s % l && (g = !1), g && sc(t.y) ? (t.opacity = i, n[this.isNewLabel ? "attr" : "animate"](t).show(!0), this.isNewLabel = !1) : (n.hide(), this.isNewLabel = !0));
            }
            replaceMovedLabel() {
                let t = this.label, e = this.axis;
                t && !this.isNew && (t.animate({
                    opacity: 0
                }, void 0, t.destroy), delete this.label), e.isDirty = !0, this.label = this.movedLabel, delete this.movedLabel;
            }
        }, { animObject: sm } = tU, { xAxis: sx, yAxis: sy } = i4, { defaultOptions: sb } = tv, { registerEventOptions: sv } = si, { deg2rad: sk } = w, { arrayMax: sw, arrayMin: sM, clamp: sS, correctFloat: sT, defined: sC, destroyObjectProperties: sA, erase: sP, error: sL, extend: sO, fireEvent: sE, getClosestDistance: sI, insertItem: sD, isArray: sB, isNumber: sN, isString: sz, merge: sR, normalizeTickInterval: sW, objectEach: sH, pick: sX, relativeLength: sF, removeEvent: sG, splat: sj, syncTimeout: sY } = V, sU = (t, e)=>sW(e, void 0, void 0, sX(t.options.allowDecimals, e < .5 || void 0 !== t.tickAmount), !!t.tickAmount);
        sO(sb, {
            xAxis: sx,
            yAxis: sR(sx, sy)
        });
        class s$ {
            constructor(t, e, i){
                this.init(t, e, i);
            }
            init(t, e, i = this.coll) {
                let s = "xAxis" === i, o = this.isZAxis || (t.inverted ? !s : s);
                this.chart = t, this.horiz = o, this.isXAxis = s, this.coll = i, sE(this, "init", {
                    userOptions: e
                }), this.opposite = sX(e.opposite, this.opposite), this.side = sX(e.side, this.side, o ? 2 * !this.opposite : this.opposite ? 1 : 3), this.setOptions(e);
                let r = this.options, a = r.labels;
                this.type ?? (this.type = r.type || "linear"), this.uniqueNames ?? (this.uniqueNames = r.uniqueNames ?? !0), sE(this, "afterSetType"), this.userOptions = e, this.minPixelPadding = 0, this.reversed = sX(r.reversed, this.reversed), this.visible = r.visible, this.zoomEnabled = r.zoomEnabled, this.hasNames = "category" === this.type || !0 === r.categories, this.categories = sB(r.categories) && r.categories || (this.hasNames ? [] : void 0), this.names || (this.names = [], this.names.keys = {}), this.plotLinesAndBandsGroups = {}, this.positiveValuesOnly = !!this.logarithmic, this.isLinked = sC(r.linkedTo), this.ticks = {}, this.labelEdge = [], this.minorTicks = {}, this.plotLinesAndBands = [], this.alternateBands = {}, this.len ?? (this.len = 0), this.minRange = this.userMinRange = r.minRange || r.maxZoom, this.range = r.range, this.offset = r.offset || 0, this.max = void 0, this.min = void 0;
                let n = sX(r.crosshair, sj(t.options.tooltip.crosshairs)[+!s]);
                this.crosshair = !0 === n ? {} : n, -1 === t.axes.indexOf(this) && (s ? t.axes.splice(t.xAxis.length, 0, this) : t.axes.push(this), sD(this, t[this.coll])), t.orderItems(this.coll), this.series = this.series || [], t.inverted && !this.isZAxis && s && !sC(this.reversed) && (this.reversed = !0), this.labelRotation = sN(a.rotation) ? a.rotation : void 0, sv(this, r), sE(this, "afterInit");
            }
            setOptions(t) {
                let e = this.horiz ? {
                    labels: {
                        autoRotation: [
                            -45
                        ],
                        padding: 3
                    },
                    margin: 15
                } : {
                    labels: {
                        padding: 1
                    },
                    title: {
                        rotation: 90 * this.side
                    }
                };
                this.options = sR(e, "yAxis" === this.coll ? {
                    title: {
                        text: this.chart.options.lang.yAxisTitle
                    }
                } : {}, sb[this.coll], t), sE(this, "afterSetOptions", {
                    userOptions: t
                });
            }
            defaultLabelFormatter() {
                let t = this.axis, { numberFormatter: e } = this.chart, i = sN(this.value) ? this.value : NaN, s = t.chart.time, o = t.categories, r = this.dateTimeLabelFormat, a = sb.lang, n = a.numericSymbols, h = a.numericSymbolMagnitude || 1e3, l = t.logarithmic ? Math.abs(i) : t.tickInterval, d = n?.length, c, p;
                if (o) p = `${this.value}`;
                else if (r) p = s.dateFormat(r, i, !0);
                else if (d && n && l >= 1e3) for(; d-- && void 0 === p;)l >= (c = Math.pow(h, d + 1)) && 10 * i % c == 0 && null !== n[d] && 0 !== i && (p = e(i / c, -1) + n[d]);
                return void 0 === p && (p = Math.abs(i) >= 1e4 ? e(i, -1) : e(i, -1, void 0, "")), p;
            }
            getSeriesExtremes() {
                let t, e = this;
                sE(this, "getSeriesExtremes", null, function() {
                    e.hasVisibleSeries = !1, e.dataMin = e.dataMax = e.threshold = void 0, e.softThreshold = !e.isXAxis, e.series.forEach((i)=>{
                        if (i.reserveSpace()) {
                            let s = i.options, o, r = s.threshold, a, n;
                            if (e.hasVisibleSeries = !0, e.positiveValuesOnly && 0 >= (r || 0) && (r = void 0), e.isXAxis) (o = i.getColumn("x")).length && (o = e.logarithmic ? o.filter((t)=>t > 0) : o, a = (t = i.getXExtremes(o)).min, n = t.max, sN(a) || a instanceof Date || (o = o.filter(sN), a = (t = i.getXExtremes(o)).min, n = t.max), o.length && (e.dataMin = Math.min(sX(e.dataMin, a), a), e.dataMax = Math.max(sX(e.dataMax, n), n)));
                            else {
                                let t = i.applyExtremes();
                                sN(t.dataMin) && (a = t.dataMin, e.dataMin = Math.min(sX(e.dataMin, a), a)), sN(t.dataMax) && (n = t.dataMax, e.dataMax = Math.max(sX(e.dataMax, n), n)), sC(r) && (e.threshold = r), (!s.softThreshold || e.positiveValuesOnly) && (e.softThreshold = !1);
                            }
                        }
                    });
                }), sE(this, "afterGetSeriesExtremes");
            }
            translate(t, e, i, s, o, r) {
                let a = this.linkedParent || this, n = s && a.old ? a.old.min : a.min;
                if (!sN(n)) return NaN;
                let h = a.minPixelPadding, l = (a.isOrdinal || a.brokenAxis?.hasBreaks || a.logarithmic && o) && !!a.lin2val, d = 1, c = 0, p = s && a.old ? a.old.transA : a.transA, g = 0;
                return p || (p = a.transA), i && (d *= -1, c = a.len), a.reversed && (d *= -1, c -= d * (a.sector || a.len)), e ? (g = (t = t * d + c - h) / p + n, l && (g = a.lin2val(g))) : (l && (t = a.val2lin(t)), g = d * (t - n) * p + c + d * h + (sN(r) ? p * r : 0), a.isRadial || (g = sT(g))), g;
            }
            toPixels(t, e) {
                return this.translate(this.chart?.time.parse(t) ?? NaN, !1, !this.horiz, void 0, !0) + (e ? 0 : this.pos);
            }
            toValue(t, e) {
                return this.translate(t - (e ? 0 : this.pos), !0, !this.horiz, void 0, !0);
            }
            getPlotLinePath(t) {
                let e = this, i = e.chart, s = e.left, o = e.top, r = t.old, a = t.value, n = t.lineWidth, h = r && i.oldChartHeight || i.chartHeight, l = r && i.oldChartWidth || i.chartWidth, d = e.transB, c = t.translatedValue, p = t.force, g, u, f, m, x;
                function y(t, e, i) {
                    return "pass" !== p && (t < e || t > i) && (p ? t = sS(t, e, i) : x = !0), t;
                }
                let b = {
                    value: a,
                    lineWidth: n,
                    old: r,
                    force: p,
                    acrossPanes: t.acrossPanes,
                    translatedValue: c
                };
                return sE(this, "getPlotLinePath", b, function(t) {
                    g = f = (c = sS(c = sX(c, e.translate(a, void 0, void 0, r)), -1000000000, 1e9)) + d, u = m = h - c - d, sN(c) ? e.horiz ? (u = o, m = h - e.bottom + (e.options.isInternal ? 0 : i.scrollablePixelsY || 0), g = f = y(g, s, s + e.width)) : (g = s, f = l - e.right + (i.scrollablePixelsX || 0), u = m = y(u, o, o + e.height)) : (x = !0, p = !1), t.path = x && !p ? void 0 : i.renderer.crispLine([
                        [
                            "M",
                            g,
                            u
                        ],
                        [
                            "L",
                            f,
                            m
                        ]
                    ], n || 1);
                }), b.path;
            }
            getLinearTickPositions(t, e, i) {
                let s, o, r, a = sT(Math.floor(e / t) * t), n = sT(Math.ceil(i / t) * t), h = [];
                if (sT(a + t) === a && (r = 20), this.single) return [
                    e
                ];
                for(s = a; s <= n && (h.push(s), (s = sT(s + t, r)) !== o);)o = s;
                return h;
            }
            getMinorTickInterval() {
                let { minorTicks: t, minorTickInterval: e } = this.options;
                return !0 === t ? sX(e, "auto") : !1 !== t ? e : void 0;
            }
            getMinorTickPositions() {
                let t = this.options, e = this.tickPositions, i = this.minorTickInterval, s = this.pointRangePadding || 0, o = (this.min || 0) - s, r = (this.max || 0) + s, a = this.brokenAxis?.hasBreaks ? this.brokenAxis.unitLength : r - o, n = [], h;
                if (a && a / i < this.len / 3) {
                    let s = this.logarithmic;
                    if (s) this.paddedTicks.forEach(function(t, e, o) {
                        e && n.push.apply(n, s.getLogTickPositions(i, o[e - 1], o[e], !0));
                    });
                    else if (this.dateTime && "auto" === this.getMinorTickInterval()) n = n.concat(this.getTimeTicks(this.dateTime.normalizeTimeTickInterval(i), o, r, t.startOfWeek));
                    else for(h = o + (e[0] - o) % i; h <= r && h !== n[0]; h += i)n.push(h);
                }
                return 0 !== n.length && this.trimTicks(n), n;
            }
            adjustForMinRange() {
                let t = this.options, e = this.logarithmic, i = this.chart.time, { max: s, min: o, minRange: r } = this, a, n, h, l;
                this.isXAxis && void 0 === r && !e && (r = sC(t.min) || sC(t.max) || sC(t.floor) || sC(t.ceiling) ? null : Math.min(5 * (sI(this.series.map((t)=>{
                    let e = t.getColumn("x");
                    return t.xIncrement ? e.slice(0, 2) : e;
                })) || 0), this.dataMax - this.dataMin)), sN(s) && sN(o) && sN(r) && s - o < r && (n = this.dataMax - this.dataMin >= r, a = (r - s + o) / 2, h = [
                    o - a,
                    i.parse(t.min) ?? o - a
                ], n && (h[2] = e ? e.log2lin(this.dataMin) : this.dataMin), l = [
                    (o = sw(h)) + r,
                    i.parse(t.max) ?? o + r
                ], n && (l[2] = e ? e.log2lin(this.dataMax) : this.dataMax), (s = sM(l)) - o < r && (h[0] = s - r, h[1] = i.parse(t.min) ?? s - r, o = sw(h))), this.minRange = r, this.min = o, this.max = s;
            }
            getClosest() {
                let t, e;
                if (this.categories) e = 1;
                else {
                    let i = [];
                    this.series.forEach(function(t) {
                        let s = t.closestPointRange, o = t.getColumn("x");
                        1 === o.length ? i.push(o[0]) : t.sorted && sC(s) && t.reserveSpace() && (e = sC(e) ? Math.min(e, s) : s);
                    }), i.length && (i.sort((t, e)=>t - e), t = sI([
                        i
                    ]));
                }
                return t && e ? Math.min(t, e) : t || e;
            }
            nameToX(t) {
                let e = sB(this.options.categories), i = e ? this.categories : this.names, s = t.options.x, o;
                return t.series.requireSorting = !1, sC(s) || (s = this.uniqueNames && i ? e ? i.indexOf(t.name) : sX(i.keys[t.name], -1) : t.series.autoIncrement()), -1 === s ? !e && i && (o = i.length) : sN(s) && (o = s), void 0 !== o ? (this.names[o] = t.name, this.names.keys[t.name] = o) : t.x && (o = t.x), o;
            }
            updateNames() {
                let t = this, e = this.names;
                e.length > 0 && (Object.keys(e.keys).forEach(function(t) {
                    delete e.keys[t];
                }), e.length = 0, this.minRange = this.userMinRange, (this.series || []).forEach((e)=>{
                    e.xIncrement = null, (!e.points || e.isDirtyData) && (t.max = Math.max(t.max || 0, e.dataTable.rowCount - 1), e.processData(), e.generatePoints());
                    let i = e.getColumn("x").slice();
                    e.data.forEach((e, s)=>{
                        let o = i[s];
                        e?.options && void 0 !== e.name && void 0 !== (o = t.nameToX(e)) && o !== e.x && (i[s] = e.x = o);
                    }), e.dataTable.setColumn("x", i);
                }));
            }
            setAxisTranslation() {
                let t = this, e = t.max - t.min, i = t.linkedParent, s = !!t.categories, o = t.isXAxis, r = t.axisPointRange || 0, a, n = 0, h = 0, l, d = t.transA;
                (o || s || r) && (a = t.getClosest(), i ? (n = i.minPointOffset, h = i.pointRangePadding) : t.series.forEach(function(e) {
                    let i = s ? 1 : o ? sX(e.options.pointRange, a, 0) : t.axisPointRange || 0, l = e.options.pointPlacement;
                    if (r = Math.max(r, i), !t.single || s) {
                        let t = e.is("xrange") ? !o : o;
                        n = Math.max(n, t && sz(l) ? 0 : i / 2), h = Math.max(h, t && "on" === l ? 0 : i);
                    }
                }), l = t.ordinal?.slope && a ? t.ordinal.slope / a : 1, t.minPointOffset = n *= l, t.pointRangePadding = h *= l, t.pointRange = Math.min(r, t.single && s ? 1 : e), o && (t.closestPointRange = a)), t.translationSlope = t.transA = d = t.staticScale || t.len / (e + h || 1), t.transB = t.horiz ? t.left : t.bottom, t.minPixelPadding = d * n, sE(this, "afterSetAxisTranslation");
            }
            minFromRange() {
                let { max: t, min: e } = this;
                return sN(t) && sN(e) && t - e || void 0;
            }
            setTickInterval(t) {
                let { categories: e, chart: i, dataMax: s, dataMin: o, dateTime: r, isXAxis: a, logarithmic: n, options: h, softThreshold: l } = this, d = i.time, c = sN(this.threshold) ? this.threshold : void 0, p = this.minRange || 0, { ceiling: g, floor: u, linkedTo: f, softMax: m, softMin: x } = h, y = sN(f) && i[this.coll]?.[f], b = h.tickPixelInterval, v = h.maxPadding, k = h.minPadding, w = 0, M, S = sN(h.tickInterval) && h.tickInterval >= 0 ? h.tickInterval : void 0, T, C, A, P;
                if (r || e || y || this.getTickAmount(), A = sX(this.userMin, d.parse(h.min)), P = sX(this.userMax, d.parse(h.max)), y ? (this.linkedParent = y, M = y.getExtremes(), this.min = sX(M.min, M.dataMin), this.max = sX(M.max, M.dataMax), this.type !== y.type && sL(11, !0, i)) : (l && sC(c) && sN(s) && sN(o) && (o >= c ? (T = c, k = 0) : s <= c && (C = c, v = 0)), this.min = sX(A, T, o), this.max = sX(P, C, s)), sN(this.max) && sN(this.min) && (n && (this.positiveValuesOnly && !t && 0 >= Math.min(this.min, sX(o, this.min)) && sL(10, !0, i), this.min = sT(n.log2lin(this.min), 16), this.max = sT(n.log2lin(this.max), 16)), this.range && sN(o) && (this.userMin = this.min = A = Math.max(o, this.minFromRange() || 0), this.userMax = P = this.max, this.range = void 0)), sE(this, "foundExtremes"), this.adjustForMinRange(), sN(this.min) && sN(this.max)) {
                    if (!sN(this.userMin) && sN(x) && x < this.min && (this.min = A = x), !sN(this.userMax) && sN(m) && m > this.max && (this.max = P = m), e || this.axisPointRange || this.stacking?.usePercentage || y || (w = this.max - this.min) && (!sC(A) && k && (this.min -= w * k), !sC(P) && v && (this.max += w * v)), !sN(this.userMin) && sN(u) && (this.min = Math.max(this.min, u)), !sN(this.userMax) && sN(g) && (this.max = Math.min(this.max, g)), l && sN(o) && sN(s)) {
                        let t = c || 0;
                        !sC(A) && this.min < t && o >= t ? this.min = h.minRange ? Math.min(t, this.max - p) : t : !sC(P) && this.max > t && s <= t && (this.max = h.minRange ? Math.max(t, this.min + p) : t);
                    }
                    !i.polar && this.min > this.max && (sC(h.min) ? this.max = this.min : sC(h.max) && (this.min = this.max)), w = this.max - this.min;
                }
                if (this.min !== this.max && sN(this.min) && sN(this.max) ? y && !S && b === y.options.tickPixelInterval ? this.tickInterval = S = y.tickInterval : this.tickInterval = sX(S, this.tickAmount ? w / Math.max(this.tickAmount - 1, 1) : void 0, e ? 1 : w * b / Math.max(this.len, b)) : this.tickInterval = 1, a && !t) {
                    let t = this.min !== this.old?.min || this.max !== this.old?.max;
                    this.series.forEach(function(e) {
                        e.forceCrop = e.forceCropping?.(), e.processData(t);
                    }), sE(this, "postProcessData", {
                        hasExtremesChanged: t
                    });
                }
                this.setAxisTranslation(), sE(this, "initialAxisTranslation"), this.pointRange && !S && (this.tickInterval = Math.max(this.pointRange, this.tickInterval));
                let L = sX(h.minTickInterval, r && !this.series.some((t)=>!t.sorted) ? this.closestPointRange : 0);
                !S && L && this.tickInterval < L && (this.tickInterval = L), r || n || S || (this.tickInterval = sU(this, this.tickInterval)), this.tickAmount || (this.tickInterval = this.unsquish()), this.setTickPositions();
            }
            setTickPositions() {
                let t = this.options, e = t.tickPositions, i = t.tickPositioner, s = this.getMinorTickInterval(), o = !this.isPanning, r = o && t.startOnTick, a = o && t.endOnTick, n = [], h;
                if (this.tickmarkOffset = this.categories && "between" === t.tickmarkPlacement && 1 === this.tickInterval ? .5 : 0, this.single = this.min === this.max && sC(this.min) && !this.tickAmount && (this.min % 1 == 0 || !1 !== t.allowDecimals), e) n = e.slice();
                else if (sN(this.min) && sN(this.max)) {
                    if (!this.ordinal?.positions && (this.max - this.min) / this.tickInterval > Math.max(2 * this.len, 200)) n = [
                        this.min,
                        this.max
                    ], sL(19, !1, this.chart);
                    else if (this.dateTime) n = this.getTimeTicks(this.dateTime.normalizeTimeTickInterval(this.tickInterval, t.units), this.min, this.max, t.startOfWeek, this.ordinal?.positions, this.closestPointRange, !0);
                    else if (this.logarithmic) n = this.logarithmic.getLogTickPositions(this.tickInterval, this.min, this.max);
                    else {
                        let t = this.tickInterval, e = t;
                        for(; e <= 2 * t;)if (n = this.getLinearTickPositions(this.tickInterval, this.min, this.max), this.tickAmount && n.length > this.tickAmount) this.tickInterval = sU(this, e *= 1.1);
                        else break;
                    }
                    n.length > this.len && (n = [
                        n[0],
                        n[n.length - 1]
                    ])[0] === n[1] && (n.length = 1), i && (this.tickPositions = n, (h = i.apply(this, [
                        this.min,
                        this.max
                    ])) && (n = h));
                }
                this.tickPositions = n, this.minorTickInterval = "auto" === s && this.tickInterval ? this.tickInterval / t.minorTicksPerMajor : s, this.paddedTicks = n.slice(0), this.trimTicks(n, r, a), !this.isLinked && sN(this.min) && sN(this.max) && (this.single && n.length < 2 && !this.categories && !this.series.some((t)=>t.is("heatmap") && "between" === t.options.pointPlacement) && (this.min -= .5, this.max += .5), e || h || this.adjustTickAmount()), sE(this, "afterSetTickPositions");
            }
            trimTicks(t, e, i) {
                let s = t[0], o = t[t.length - 1], r = !this.isOrdinal && this.minPointOffset || 0;
                if (sE(this, "trimTicks"), !this.isLinked || !this.grid) {
                    if (e && s !== -1 / 0) this.min = s;
                    else for(; this.min - r > t[0];)t.shift();
                    if (i) this.max = o;
                    else for(; this.max + r < t[t.length - 1];)t.pop();
                    0 === t.length && sC(s) && !this.options.tickPositions && t.push((o + s) / 2);
                }
            }
            alignToOthers() {
                let t, e = this, i = e.chart, s = [
                    this
                ], o = e.options, r = i.options.chart, a = "yAxis" === this.coll && r.alignThresholds, n = [];
                if (e.thresholdAlignment = void 0, (!1 !== r.alignTicks && o.alignTicks || a) && !1 !== o.startOnTick && !1 !== o.endOnTick && !e.logarithmic) {
                    let o = (t)=>{
                        let { horiz: e, options: i } = t;
                        return [
                            e ? i.left : i.top,
                            i.width,
                            i.height,
                            i.pane
                        ].join(",");
                    }, r = o(this);
                    i[this.coll].forEach(function(i) {
                        let { series: a } = i;
                        a.length && a.some((t)=>t.visible) && i !== e && o(i) === r && (t = !0, s.push(i));
                    });
                }
                if (t && a) {
                    s.forEach((t)=>{
                        let i = t.getThresholdAlignment(e);
                        sN(i) && n.push(i);
                    });
                    let t = n.length > 1 ? n.reduce((t, e)=>t += e, 0) / n.length : void 0;
                    s.forEach((e)=>{
                        e.thresholdAlignment = t;
                    });
                }
                return t;
            }
            getThresholdAlignment(t) {
                if ((!sN(this.dataMin) || this !== t && this.series.some((t)=>t.isDirty || t.isDirtyData)) && this.getSeriesExtremes(), sN(this.threshold)) {
                    let t = sS((this.threshold - (this.dataMin || 0)) / ((this.dataMax || 0) - (this.dataMin || 0)), 0, 1);
                    return this.options.reversed && (t = 1 - t), t;
                }
            }
            getTickAmount() {
                let t = this.options, e = t.tickPixelInterval, i = t.tickAmount;
                sC(t.tickInterval) || i || !(this.len < e) || this.isRadial || this.logarithmic || !t.startOnTick || !t.endOnTick || (i = 2), !i && this.alignToOthers() && (i = Math.ceil(this.len / e) + 1), i < 4 && (this.finalTickAmt = i, i = 5), this.tickAmount = i;
            }
            adjustTickAmount() {
                let t = this, { finalTickAmt: e, max: i, min: s, options: o, tickPositions: r, tickAmount: a, thresholdAlignment: n } = t, h = r?.length, l = sX(t.threshold, t.softThreshold ? 0 : null), d, c, p = t.tickInterval, g, u = ()=>r.push(sT(r[r.length - 1] + p)), f = ()=>r.unshift(sT(r[0] - p));
                if (sN(n) && (g = n < .5 ? Math.ceil(n * (a - 1)) : Math.floor(n * (a - 1)), o.reversed && (g = a - 1 - g)), t.hasData() && sN(s) && sN(i)) {
                    let n = ()=>{
                        t.transA *= (h - 1) / (a - 1), t.min = o.startOnTick ? r[0] : Math.min(s, r[0]), t.max = o.endOnTick ? r[r.length - 1] : Math.max(i, r[r.length - 1]);
                    };
                    if (sN(g) && sN(t.threshold)) {
                        for(; r[g] !== l || r.length !== a || r[0] > s || r[r.length - 1] < i;){
                            for(r.length = 0, r.push(t.threshold); r.length < a;)void 0 === r[g] || r[g] > t.threshold ? f() : u();
                            if (p > 8 * t.tickInterval) break;
                            p *= 2;
                        }
                        n();
                    } else if (h < a) {
                        for(; r.length < a;)r.length % 2 || s === l ? u() : f();
                        n();
                    }
                    if (sC(e)) {
                        for(c = d = r.length; c--;)(3 === e && c % 2 == 1 || e <= 2 && c > 0 && c < d - 1) && r.splice(c, 1);
                        t.finalTickAmt = void 0;
                    }
                }
            }
            setScale() {
                let { coll: t, stacking: e } = this, i = !1, s = !1;
                this.series.forEach((t)=>{
                    i = i || t.isDirtyData || t.isDirty, s = s || t.xAxis?.isDirty || !1;
                }), this.setAxisSize();
                let o = this.len !== this.old?.len;
                o || i || s || this.isLinked || this.forceRedraw || this.userMin !== this.old?.userMin || this.userMax !== this.old?.userMax || this.alignToOthers() ? (e && "yAxis" === t && e.buildStacks(), this.forceRedraw = !1, this.userMinRange || (this.minRange = void 0), this.getSeriesExtremes(), this.setTickInterval(), e && "xAxis" === t && e.buildStacks(), this.isDirty || (this.isDirty = o || this.min !== this.old?.min || this.max !== this.old?.max)) : e && e.cleanStacks(), i && delete this.allExtremes, sE(this, "afterSetScale");
            }
            setExtremes(t, e, i = !0, s, o) {
                let r = this.chart;
                this.series.forEach((t)=>{
                    delete t.kdTree;
                }), t = r.time.parse(t), e = r.time.parse(e), sE(this, "setExtremes", o = sO(o, {
                    min: t,
                    max: e
                }), (t)=>{
                    this.userMin = t.min, this.userMax = t.max, this.eventArgs = t, i && r.redraw(s);
                });
            }
            setAxisSize() {
                let t = this.chart, e = this.options, i = e.offsets || [
                    0,
                    0,
                    0,
                    0
                ], s = this.horiz, o = this.width = Math.round(sF(sX(e.width, t.plotWidth - i[3] + i[1]), t.plotWidth)), r = this.height = Math.round(sF(sX(e.height, t.plotHeight - i[0] + i[2]), t.plotHeight)), a = this.top = Math.round(sF(sX(e.top, t.plotTop + i[0]), t.plotHeight, t.plotTop)), n = this.left = Math.round(sF(sX(e.left, t.plotLeft + i[3]), t.plotWidth, t.plotLeft));
                this.bottom = t.chartHeight - r - a, this.right = t.chartWidth - o - n, this.len = Math.max(s ? o : r, 0), this.pos = s ? n : a;
            }
            getExtremes() {
                let t = this.logarithmic;
                return {
                    min: t ? sT(t.lin2log(this.min)) : this.min,
                    max: t ? sT(t.lin2log(this.max)) : this.max,
                    dataMin: this.dataMin,
                    dataMax: this.dataMax,
                    userMin: this.userMin,
                    userMax: this.userMax
                };
            }
            getThreshold(t) {
                let e = this.logarithmic, i = e ? e.lin2log(this.min) : this.min, s = e ? e.lin2log(this.max) : this.max;
                return null === t || t === -1 / 0 ? t = i : t === 1 / 0 ? t = s : i > t ? t = i : s < t && (t = s), this.translate(t, 0, 1, 0, 1);
            }
            autoLabelAlign(t) {
                let e = (sX(t, 0) - 90 * this.side + 720) % 360, i = {
                    align: "center"
                };
                return sE(this, "autoLabelAlign", i, function(t) {
                    e > 15 && e < 165 ? t.align = "right" : e > 195 && e < 345 && (t.align = "left");
                }), i.align;
            }
            tickSize(t) {
                let e = this.options, i = sX(e["tick" === t ? "tickWidth" : "minorTickWidth"], "tick" === t && this.isXAxis && !this.categories ? 1 : 0), s = e["tick" === t ? "tickLength" : "minorTickLength"], o;
                i && s && ("inside" === e[t + "Position"] && (s = -s), o = [
                    s,
                    i
                ]);
                let r = {
                    tickSize: o
                };
                return sE(this, "afterTickSize", r), r.tickSize;
            }
            labelMetrics() {
                let t = this.chart.renderer, e = this.ticks, i = e[Object.keys(e)[0]] || {};
                return this.chart.renderer.fontMetrics(i.label || i.movedLabel || t.box);
            }
            unsquish() {
                let t = this.options.labels, e = t.padding || 0, i = this.horiz, s = this.tickInterval, o = this.len / ((+!!this.categories + this.max - this.min) / s), r = t.rotation, a = sT(.8 * this.labelMetrics().h), n = Math.max(this.max - this.min, 0), h = function(t) {
                    let i = (t + 2 * e) / (o || 1);
                    return (i = i > 1 ? Math.ceil(i) : 1) * s > n && t !== 1 / 0 && o !== 1 / 0 && n && (i = Math.ceil(n / s)), sT(i * s);
                }, l = s, d, c = Number.MAX_VALUE, p;
                if (i) {
                    if (!t.staggerLines && (sN(r) ? p = [
                        r
                    ] : o < t.autoRotationLimit && (p = t.autoRotation)), p) {
                        let t, e;
                        for (let i of p)(i === r || i && i >= -90 && i <= 90) && (e = (t = h(Math.abs(a / Math.sin(sk * i)))) + Math.abs(i / 360)) < c && (c = e, d = i, l = t);
                    }
                } else l = h(.75 * a);
                return this.autoRotation = p, this.labelRotation = sX(d, sN(r) ? r : 0), t.step ? s : l;
            }
            getSlotWidth(t) {
                let e = this.chart, i = this.horiz, s = this.options.labels, o = Math.max(this.tickPositions.length - !this.categories, 1), r = e.margin[3];
                if (t && sN(t.slotWidth)) return t.slotWidth;
                if (i && s.step < 2 && !this.isRadial) return s.rotation ? 0 : (this.staggerLines || 1) * this.len / o;
                if (!i) {
                    let t = s.style.width;
                    if (void 0 !== t) return parseInt(String(t), 10);
                    if (!this.opposite && r) return r - e.spacing[3];
                }
                return .33 * e.chartWidth;
            }
            renderUnsquish() {
                let t = this.chart, e = t.renderer, i = this.tickPositions, s = this.ticks, o = this.options.labels, r = o.style, a = this.horiz, n = this.getSlotWidth(), h = Math.max(1, Math.round(n - (a ? 2 * (o.padding || 0) : o.distance || 0))), l = {}, d = this.labelMetrics(), c = r.lineClamp, p, g = c ?? (Math.floor(this.len / (i.length * d.h)) || 1), u = 0;
                sz(o.rotation) || (l.rotation = o.rotation || 0), i.forEach(function(t) {
                    let e = s[t];
                    e.movedLabel && e.replaceMovedLabel();
                    let i = e.label?.textPxLength || 0;
                    i > u && (u = i);
                }), this.maxLabelLength = u, this.autoRotation ? u > h && u > d.h ? l.rotation = this.labelRotation : this.labelRotation = 0 : n && (p = h), l.rotation && (p = u > .5 * t.chartHeight ? .33 * t.chartHeight : u, c || (g = 1)), this.labelAlign = o.align || this.autoLabelAlign(this.labelRotation), this.labelAlign && (l.align = this.labelAlign), i.forEach(function(t) {
                    let e = s[t], i = e?.label, o = r.width, a = {};
                    i && (i.attr(l), e.shortenLabel ? e.shortenLabel() : p && !o && "nowrap" !== r.whiteSpace && (p < (i.textPxLength || 0) || "SPAN" === i.element.tagName) ? i.css(sO(a, {
                        width: `${p}px`,
                        lineClamp: g
                    })) : !i.styles.width || a.width || o || i.css({
                        width: "auto"
                    }), e.rotation = l.rotation);
                }, this), this.tickRotCorr = e.rotCorr(d.b, this.labelRotation || 0, 0 !== this.side);
            }
            hasData() {
                return this.series.some(function(t) {
                    return t.hasData();
                }) || this.options.showEmpty && sC(this.min) && sC(this.max);
            }
            addTitle(t) {
                let e, i = this.chart.renderer, s = this.horiz, o = this.opposite, r = this.options.title, a = this.chart.styledMode;
                this.axisTitle || ((e = r.textAlign) || (e = (s ? {
                    low: "left",
                    middle: "center",
                    high: "right"
                } : {
                    low: o ? "right" : "left",
                    middle: "center",
                    high: o ? "left" : "right"
                })[r.align]), this.axisTitle = i.text(r.text || "", 0, 0, r.useHTML).attr({
                    zIndex: 7,
                    rotation: r.rotation || 0,
                    align: e
                }).addClass("highcharts-axis-title"), a || this.axisTitle.css(sR(r.style)), this.axisTitle.add(this.axisGroup), this.axisTitle.isNew = !0), a || r.style.width || this.isRadial || this.axisTitle.css({
                    width: this.len + "px"
                }), this.axisTitle[t ? "show" : "hide"](t);
            }
            generateTick(t) {
                let e = this.ticks;
                e[t] ? e[t].addLabel() : e[t] = new sf(this, t);
            }
            createGroups() {
                let { axisParent: t, chart: e, coll: i, options: s } = this, o = e.renderer, r = (e, r, a)=>o.g(e).attr({
                        zIndex: a
                    }).addClass(`highcharts-${i.toLowerCase()}${r} ` + (this.isRadial ? `highcharts-radial-axis${r} ` : "") + (s.className || "")).add(t);
                this.axisGroup || (this.gridGroup = r("grid", "-grid", s.gridZIndex), this.axisGroup = r("axis", "", s.zIndex), this.labelGroup = r("axis-labels", "-labels", s.labels.zIndex));
            }
            getOffset() {
                let t = this, { chart: e, horiz: i, options: s, side: o, ticks: r, tickPositions: a, coll: n } = t, h = e.inverted && !t.isZAxis ? [
                    1,
                    0,
                    3,
                    2
                ][o] : o, l = t.hasData(), d = s.title, c = s.labels, p = sN(s.crossing), g = e.axisOffset, u = e.clipOffset, f = [
                    -1,
                    1,
                    1,
                    -1
                ][o], m, x = 0, y, b = 0, v = 0, k, w;
                if (t.showAxis = m = l || s.showEmpty, t.staggerLines = t.horiz && c.staggerLines || void 0, t.createGroups(), l || t.isLinked ? (a.forEach(function(e) {
                    t.generateTick(e);
                }), t.renderUnsquish(), t.reserveSpaceDefault = 0 === o || 2 === o || ({
                    1: "left",
                    3: "right"
                })[o] === t.labelAlign, sX(c.reserveSpace, !p && null, "center" === t.labelAlign || null, t.reserveSpaceDefault) && a.forEach(function(t) {
                    v = Math.max(r[t].getLabelSize(), v);
                }), t.staggerLines && (v *= t.staggerLines), t.labelOffset = v * (t.opposite ? -1 : 1)) : sH(r, function(t, e) {
                    t.destroy(), delete r[e];
                }), d?.text && !1 !== d.enabled && (t.addTitle(m), m && !p && !1 !== d.reserveSpace && (t.titleOffset = x = t.axisTitle.getBBox()[i ? "height" : "width"], b = sC(y = d.offset) ? 0 : sX(d.margin, i ? 5 : 10))), t.renderLine(), t.offset = f * sX(s.offset, g[o] ? g[o] + (s.margin || 0) : 0), t.tickRotCorr = t.tickRotCorr || {
                    x: 0,
                    y: 0
                }, w = 0 === o ? -t.labelMetrics().h : 2 === o ? t.tickRotCorr.y : 0, k = Math.abs(v) + b, v && (k -= w, k += f * (i ? sX(c.y, t.tickRotCorr.y + f * c.distance) : sX(c.x, f * c.distance))), t.axisTitleMargin = sX(y, k), t.getMaxLabelDimensions && (t.maxLabelDimensions = t.getMaxLabelDimensions(r, a)), "colorAxis" !== n && u) {
                    let e = this.tickSize("tick");
                    g[o] = Math.max(g[o], (t.axisTitleMargin || 0) + x + f * t.offset, k, a?.length && e ? e[0] + f * t.offset : 0);
                    let i = !t.axisLine || s.offset ? 0 : t.axisLine.strokeWidth() / 2;
                    u[h] = Math.max(u[h], i);
                }
                sE(this, "afterGetOffset");
            }
            getLinePath(t) {
                let e = this.chart, i = this.opposite, s = this.offset, o = this.horiz, r = this.left + (i ? this.width : 0) + s, a = e.chartHeight - this.bottom - (i ? this.height : 0) + s;
                return i && (t *= -1), e.renderer.crispLine([
                    [
                        "M",
                        o ? this.left : r,
                        o ? a : this.top
                    ],
                    [
                        "L",
                        o ? e.chartWidth - this.right : r,
                        o ? a : e.chartHeight - this.bottom
                    ]
                ], t);
            }
            renderLine() {
                !this.axisLine && (this.axisLine = this.chart.renderer.path().addClass("highcharts-axis-line").add(this.axisGroup), this.chart.styledMode || this.axisLine.attr({
                    stroke: this.options.lineColor,
                    "stroke-width": this.options.lineWidth,
                    zIndex: 7
                }));
            }
            getTitlePosition(t) {
                let e = this.horiz, i = this.left, s = this.top, o = this.len, r = this.options.title, a = e ? i : s, n = this.opposite, h = this.offset, l = r.x, d = r.y, c = this.chart.renderer.fontMetrics(t), p = t ? Math.max(t.getBBox(!1, 0).height - c.h - 1, 0) : 0, g = {
                    low: a + (e ? 0 : o),
                    middle: a + o / 2,
                    high: a + (e ? o : 0)
                }[r.align], u = (e ? s + this.height : i) + (e ? 1 : -1) * (n ? -1 : 1) * (this.axisTitleMargin || 0) + [
                    -p,
                    p,
                    c.f,
                    -p
                ][this.side], f = {
                    x: e ? g + l : u + (n ? this.width : 0) + h + l,
                    y: e ? u + d - (n ? this.height : 0) + h : g + d
                };
                return sE(this, "afterGetTitlePosition", {
                    titlePosition: f
                }), f;
            }
            renderMinorTick(t, e) {
                let i = this.minorTicks;
                i[t] || (i[t] = new sf(this, t, "minor")), e && i[t].isNew && i[t].render(null, !0), i[t].render(null, !1, 1);
            }
            renderTick(t, e, i) {
                let s = this.isLinked, o = this.ticks;
                (!s || t >= this.min && t <= this.max || this.grid?.isColumn) && (o[t] || (o[t] = new sf(this, t)), i && o[t].isNew && o[t].render(e, !0, -1), o[t].render(e));
            }
            render() {
                let t, e, i = this, s = i.chart, o = i.logarithmic, r = s.renderer, a = i.options, n = i.isLinked, h = i.tickPositions, l = i.axisTitle, d = i.ticks, c = i.minorTicks, p = i.alternateBands, g = a.stackLabels, u = a.alternateGridColor, f = a.crossing, m = i.tickmarkOffset, x = i.axisLine, y = i.showAxis, b = sm(r.globalAnimation);
                if (i.labelEdge.length = 0, i.overlap = !1, [
                    d,
                    c,
                    p
                ].forEach(function(t) {
                    sH(t, function(t) {
                        t.isActive = !1;
                    });
                }), sN(f)) {
                    let t = this.isXAxis ? s.yAxis[0] : s.xAxis[0], e = [
                        1,
                        -1,
                        -1,
                        1
                    ][this.side];
                    if (t) {
                        let s = t.toPixels(f, !0);
                        i.horiz && (s = t.len - s), i.offset = e * s;
                    }
                }
                if (i.hasData() || n) {
                    let r = i.chart.hasRendered && i.old && sN(i.old.min);
                    i.minorTickInterval && !i.categories && i.getMinorTickPositions().forEach(function(t) {
                        i.renderMinorTick(t, r);
                    }), h.length && (h.forEach(function(t, e) {
                        i.renderTick(t, e, r);
                    }), m && (0 === i.min || i.single) && (d[-1] || (d[-1] = new sf(i, -1, null, !0)), d[-1].render(-1))), u && h.forEach(function(r, a) {
                        e = void 0 !== h[a + 1] ? h[a + 1] + m : i.max - m, a % 2 == 0 && r < i.max && e <= i.max + (s.polar ? -m : m) && (p[r] || (p[r] = new w.PlotLineOrBand(i, {})), t = r + m, p[r].options = {
                            from: o ? o.lin2log(t) : t,
                            to: o ? o.lin2log(e) : e,
                            color: u,
                            className: "highcharts-alternate-grid"
                        }, p[r].render(), p[r].isActive = !0);
                    }), i._addedPlotLB || (i._addedPlotLB = !0, (a.plotLines || []).concat(a.plotBands || []).forEach(function(t) {
                        i.addPlotBandOrLine(t);
                    }));
                }
                [
                    d,
                    c,
                    p
                ].forEach(function(t) {
                    let e = [], i = b.duration;
                    sH(t, function(t, i) {
                        t.isActive || (t.render(i, !1, 0), t.isActive = !1, e.push(i));
                    }), sY(function() {
                        let i = e.length;
                        for(; i--;)t[e[i]] && !t[e[i]].isActive && (t[e[i]].destroy(), delete t[e[i]]);
                    }, t !== p && s.hasRendered && i ? i : 0);
                }), x && (x[x.isPlaced ? "animate" : "attr"]({
                    d: this.getLinePath(x.strokeWidth())
                }), x.isPlaced = !0, x[y ? "show" : "hide"](y)), l && y && (l[l.isNew ? "attr" : "animate"](i.getTitlePosition(l)), l.isNew = !1), g?.enabled && i.stacking && i.stacking.renderStackTotals(), i.old = {
                    len: i.len,
                    max: i.max,
                    min: i.min,
                    transA: i.transA,
                    userMax: i.userMax,
                    userMin: i.userMin
                }, i.isDirty = !1, sE(this, "afterRender");
            }
            redraw() {
                this.visible && (this.render(), this.plotLinesAndBands.forEach(function(t) {
                    t.render();
                })), this.series.forEach(function(t) {
                    t.isDirty = !0;
                });
            }
            getKeepProps() {
                return this.keepProps || s$.keepProps;
            }
            destroy(t) {
                let e = this, i = e.plotLinesAndBands, s = this.eventOptions;
                if (sE(this, "destroy", {
                    keepEvents: t
                }), t || sG(e), [
                    e.ticks,
                    e.minorTicks,
                    e.alternateBands
                ].forEach(function(t) {
                    sA(t);
                }), i) {
                    let t = i.length;
                    for(; t--;)i[t].destroy();
                }
                for(let t in [
                    "axisLine",
                    "axisTitle",
                    "axisGroup",
                    "gridGroup",
                    "labelGroup",
                    "cross",
                    "scrollbar"
                ].forEach(function(t) {
                    e[t] && (e[t] = e[t].destroy());
                }), e.plotLinesAndBandsGroups)e.plotLinesAndBandsGroups[t] = e.plotLinesAndBandsGroups[t].destroy();
                sH(e, function(t, i) {
                    -1 === e.getKeepProps().indexOf(i) && delete e[i];
                }), this.eventOptions = s;
            }
            drawCrosshair(t, e) {
                let i = this.crosshair, s = i?.snap ?? !0, o = this.chart, r, a, n, h = this.cross, l;
                if (sE(this, "drawCrosshair", {
                    e: t,
                    point: e
                }), t || (t = this.cross?.e), i && !1 !== (sC(e) || !s)) {
                    if (s ? sC(e) && (a = sX("colorAxis" !== this.coll ? e.crosshairPos : null, this.isXAxis ? e.plotX : this.len - e.plotY)) : a = t && (this.horiz ? t.chartX - this.pos : this.len - t.chartY + this.pos), sC(a) && (l = {
                        value: e && (this.isXAxis ? e.x : sX(e.stackY, e.y)),
                        translatedValue: a
                    }, o.polar && sO(l, {
                        isCrosshair: !0,
                        chartX: t?.chartX,
                        chartY: t?.chartY,
                        point: e
                    }), r = this.getPlotLinePath(l) || null), !sC(r)) return void this.hideCrosshair();
                    n = this.categories && !this.isRadial, h || (this.cross = h = o.renderer.path().addClass("highcharts-crosshair highcharts-crosshair-" + (n ? "category " : "thin ") + (i.className || "")).attr({
                        zIndex: sX(i.zIndex, 2)
                    }).add(), !o.styledMode && (h.attr({
                        stroke: i.color || (n ? tL.parse("#ccd3ff").setOpacity(.25).get() : "#cccccc"),
                        "stroke-width": sX(i.width, 1)
                    }).css({
                        "pointer-events": "none"
                    }), i.dashStyle && h.attr({
                        dashstyle: i.dashStyle
                    }))), h.show().attr({
                        d: r
                    }), n && !i.width && h.attr({
                        "stroke-width": this.transA
                    }), this.cross.e = t;
                } else this.hideCrosshair();
                sE(this, "afterDrawCrosshair", {
                    e: t,
                    point: e
                });
            }
            hideCrosshair() {
                this.cross && this.cross.hide(), sE(this, "afterHideCrosshair");
            }
            update(t, e) {
                let i = this.chart;
                t = sR(this.userOptions, t), this.destroy(!0), this.init(i, t), i.isDirtyBox = !0, sX(e, !0) && i.redraw();
            }
            remove(t) {
                let e = this.chart, i = this.coll, s = this.series, o = s.length;
                for(; o--;)s[o] && s[o].remove(!1);
                sP(e.axes, this), sP(e[i] || [], this), e.orderItems(i), this.destroy(), e.isDirtyBox = !0, sX(t, !0) && e.redraw();
            }
            setTitle(t, e) {
                this.update({
                    title: t
                }, e);
            }
            setCategories(t, e) {
                this.update({
                    categories: t
                }, e);
            }
        }
        s$.keepProps = [
            "coll",
            "extKey",
            "hcEvents",
            "len",
            "names",
            "series",
            "userMax",
            "userMin"
        ];
        let { addEvent: sV, getMagnitude: sZ, normalizeTickInterval: s_, timeUnits: sq } = V;
        !function(t) {
            function e() {
                return this.chart.time.getTimeTicks.apply(this.chart.time, arguments);
            }
            function i() {
                if ("datetime" !== this.type) {
                    this.dateTime = void 0;
                    return;
                }
                this.dateTime || (this.dateTime = new s(this));
            }
            t.compose = function(t) {
                return t.keepProps.includes("dateTime") || (t.keepProps.push("dateTime"), t.prototype.getTimeTicks = e, sV(t, "afterSetType", i)), t;
            };
            class s {
                constructor(t){
                    this.axis = t;
                }
                normalizeTimeTickInterval(t, e) {
                    let i = e || [
                        [
                            "millisecond",
                            [
                                1,
                                2,
                                5,
                                10,
                                20,
                                25,
                                50,
                                100,
                                200,
                                500
                            ]
                        ],
                        [
                            "second",
                            [
                                1,
                                2,
                                5,
                                10,
                                15,
                                30
                            ]
                        ],
                        [
                            "minute",
                            [
                                1,
                                2,
                                5,
                                10,
                                15,
                                30
                            ]
                        ],
                        [
                            "hour",
                            [
                                1,
                                2,
                                3,
                                4,
                                6,
                                8,
                                12
                            ]
                        ],
                        [
                            "day",
                            [
                                1,
                                2
                            ]
                        ],
                        [
                            "week",
                            [
                                1,
                                2
                            ]
                        ],
                        [
                            "month",
                            [
                                1,
                                2,
                                3,
                                4,
                                6
                            ]
                        ],
                        [
                            "year",
                            null
                        ]
                    ], s = i[i.length - 1], o = sq[s[0]], r = s[1], a;
                    for(a = 0; a < i.length && (o = sq[(s = i[a])[0]], r = s[1], !i[a + 1] || !(t <= (o * r[r.length - 1] + sq[i[a + 1][0]]) / 2)); a++);
                    o === sq.year && t < 5 * o && (r = [
                        1,
                        2,
                        5
                    ]);
                    let n = s_(t / o, r, "year" === s[0] ? Math.max(sZ(t / o), 1) : 1);
                    return {
                        unitRange: o,
                        count: n,
                        unitName: s[0]
                    };
                }
                getXDateFormat(t, e) {
                    let { axis: i } = this, s = i.chart.time;
                    return i.closestPointRange ? s.getDateFormat(i.closestPointRange, t, i.options.startOfWeek, e) || s.resolveDTLFormat(e.year).main : s.resolveDTLFormat(e.day).main;
                }
            }
            t.Additions = s;
        }(n || (n = {}));
        let sK = n, { addEvent: sJ, normalizeTickInterval: sQ, pick: s0 } = V;
        !function(t) {
            function e() {
                "logarithmic" !== this.type ? this.logarithmic = void 0 : this.logarithmic ?? (this.logarithmic = new s(this));
            }
            function i() {
                let t = this.logarithmic;
                t && (this.lin2val = function(e) {
                    return t.lin2log(e);
                }, this.val2lin = function(e) {
                    return t.log2lin(e);
                });
            }
            t.compose = function(t) {
                return t.keepProps.includes("logarithmic") || (t.keepProps.push("logarithmic"), sJ(t, "afterSetType", e), sJ(t, "afterInit", i)), t;
            };
            class s {
                constructor(t){
                    this.axis = t;
                }
                getLogTickPositions(t, e, i, s) {
                    let o = this.axis, r = o.len, a = o.options, n = [];
                    if (s || (this.minorAutoInterval = void 0), t >= .5) t = Math.round(t), n = o.getLinearTickPositions(t, e, i);
                    else if (t >= .08) {
                        let o, r, a, h, l, d, c, p = Math.floor(e);
                        for(o = t > .3 ? [
                            1,
                            2,
                            4
                        ] : t > .15 ? [
                            1,
                            2,
                            4,
                            6,
                            8
                        ] : [
                            1,
                            2,
                            3,
                            4,
                            5,
                            6,
                            7,
                            8,
                            9
                        ], r = p; r < i + 1 && !c; r++)for(a = 0, h = o.length; a < h && !c; a++)(l = this.log2lin(this.lin2log(r) * o[a])) > e && (!s || d <= i) && void 0 !== d && n.push(d), d > i && (c = !0), d = l;
                    } else {
                        let h = this.lin2log(e), l = this.lin2log(i), d = s ? o.getMinorTickInterval() : a.tickInterval, c = a.tickPixelInterval / (s ? 5 : 1), p = s ? r / o.tickPositions.length : r;
                        t = sQ(t = s0("auto" === d ? null : d, this.minorAutoInterval, (l - h) * c / (p || 1))), n = o.getLinearTickPositions(t, h, l).map(this.log2lin), s || (this.minorAutoInterval = t / 5);
                    }
                    return s || (o.tickInterval = t), n;
                }
                lin2log(t) {
                    return Math.pow(10, t);
                }
                log2lin(t) {
                    return Math.log(t) / Math.LN10;
                }
            }
            t.Additions = s;
        }(h || (h = {}));
        let s1 = h, { erase: s2, extend: s3, isNumber: s5 } = V;
        !function(t) {
            let e;
            function i(t) {
                return this.addPlotBandOrLine(t, "plotBands");
            }
            function s(t, i) {
                let s = this.userOptions, o = new e(this, t);
                if (this.visible && (o = o.render()), o) {
                    if (this._addedPlotLB || (this._addedPlotLB = !0, (s.plotLines || []).concat(s.plotBands || []).forEach((t)=>{
                        this.addPlotBandOrLine(t);
                    })), i) {
                        let e = s[i] || [];
                        e.push(t), s[i] = e;
                    }
                    this.plotLinesAndBands.push(o);
                }
                return o;
            }
            function o(t) {
                return this.addPlotBandOrLine(t, "plotLines");
            }
            function r(t, e, i) {
                i = i || this.options;
                let s = this.getPlotLinePath({
                    value: e,
                    force: !0,
                    acrossPanes: i.acrossPanes
                }), o = [], r = this.horiz, a = !s5(this.min) || !s5(this.max) || t < this.min && e < this.min || t > this.max && e > this.max, n = this.getPlotLinePath({
                    value: t,
                    force: !0,
                    acrossPanes: i.acrossPanes
                }), h, l = 1, d;
                if (n && s) for(a && (d = n.toString() === s.toString(), l = 0), h = 0; h < n.length; h += 2){
                    let t = n[h], e = n[h + 1], i = s[h], a = s[h + 1];
                    ("M" === t[0] || "L" === t[0]) && ("M" === e[0] || "L" === e[0]) && ("M" === i[0] || "L" === i[0]) && ("M" === a[0] || "L" === a[0]) && (r && i[1] === t[1] ? (i[1] += l, a[1] += l) : r || i[2] !== t[2] || (i[2] += l, a[2] += l), o.push([
                        "M",
                        t[1],
                        t[2]
                    ], [
                        "L",
                        e[1],
                        e[2]
                    ], [
                        "L",
                        a[1],
                        a[2]
                    ], [
                        "L",
                        i[1],
                        i[2]
                    ], [
                        "Z"
                    ])), o.isFlat = d;
                }
                return o;
            }
            function a(t) {
                this.removePlotBandOrLine(t);
            }
            function n(t) {
                let e = this.plotLinesAndBands, i = this.options, s = this.userOptions;
                if (e) {
                    let o = e.length;
                    for(; o--;)e[o].id === t && e[o].destroy();
                    [
                        i.plotLines || [],
                        s.plotLines || [],
                        i.plotBands || [],
                        s.plotBands || []
                    ].forEach(function(e) {
                        for(o = e.length; o--;)e[o]?.id === t && s2(e, e[o]);
                    });
                }
            }
            function h(t) {
                this.removePlotBandOrLine(t);
            }
            t.compose = function(t, l) {
                let d = l.prototype;
                return d.addPlotBand || (e = t, s3(d, {
                    addPlotBand: i,
                    addPlotLine: o,
                    addPlotBandOrLine: s,
                    getPlotBandPath: r,
                    removePlotBand: a,
                    removePlotLine: h,
                    removePlotBandOrLine: n
                })), l;
            };
        }(l || (l = {}));
        let s6 = l, { addEvent: s9, arrayMax: s4, arrayMin: s8, defined: s7, destroyObjectProperties: ot, erase: oe, fireEvent: oi, merge: os, objectEach: oo, pick: or } = V;
        class oa {
            static compose(t, e) {
                return s9(t, "afterInit", function() {
                    this.labelCollectors.push(()=>{
                        let t = [];
                        for (let e of this.axes)for (let { label: i, options: s } of e.plotLinesAndBands)i && !s?.label?.allowOverlap && t.push(i);
                        return t;
                    });
                }), s6.compose(oa, e);
            }
            constructor(t, e){
                this.axis = t, this.options = e, this.id = e.id;
            }
            render() {
                oi(this, "render");
                let { axis: t, options: e } = this, { horiz: i, logarithmic: s } = t, { color: o, events: r, zIndex: a = 0 } = e, { renderer: n, time: h } = t.chart, l = {}, d = h.parse(e.to), c = h.parse(e.from), p = h.parse(e.value), g = e.borderWidth, u = e.label, { label: f, svgElem: m } = this, x = [], y, b = s7(c) && s7(d), v = s7(p), k = !m, w = {
                    class: "highcharts-plot-" + (b ? "band " : "line ") + (e.className || "")
                }, M = b ? "bands" : "lines";
                if (!t.chart.styledMode && (v ? (w.stroke = o || "#999999", w["stroke-width"] = or(e.width, 1), e.dashStyle && (w.dashstyle = e.dashStyle)) : b && (w.fill = o || "#e6e9ff", g && (w.stroke = e.borderColor, w["stroke-width"] = g))), l.zIndex = a, M += "-" + a, (y = t.plotLinesAndBandsGroups[M]) || (t.plotLinesAndBandsGroups[M] = y = n.g("plot-" + M).attr(l).add()), m || (this.svgElem = m = n.path().attr(w).add(y)), s7(p)) x = t.getPlotLinePath({
                    value: s?.log2lin(p) ?? p,
                    lineWidth: m.strokeWidth(),
                    acrossPanes: e.acrossPanes
                });
                else {
                    if (!(s7(c) && s7(d))) return;
                    x = t.getPlotBandPath(s?.log2lin(c) ?? c, s?.log2lin(d) ?? d, e);
                }
                return !this.eventsAdded && r && (oo(r, (t, e)=>{
                    m?.on(e, (t)=>{
                        r[e].apply(this, [
                            t
                        ]);
                    });
                }), this.eventsAdded = !0), (k || !m.d) && x?.length ? m.attr({
                    d: x
                }) : m && (x ? (m.show(), m.animate({
                    d: x
                })) : m.d && (m.hide(), f && (this.label = f = f.destroy()))), u && (s7(u.text) || s7(u.formatter)) && x?.length && t.width > 0 && t.height > 0 && !x.isFlat ? (u = os({
                    align: i && b ? "center" : void 0,
                    x: i ? !b && 4 : 10,
                    verticalAlign: !i && b ? "middle" : void 0,
                    y: i ? b ? 16 : 10 : b ? 6 : -4,
                    rotation: i && !b ? 90 : 0,
                    ...b ? {
                        inside: !0
                    } : {}
                }, u), this.renderLabel(u, x, b, a)) : f && f.hide(), this;
            }
            renderLabel(t, e, i, s) {
                let o = this.axis, r = o.chart.renderer, a = t.inside, n = this.label;
                n || (this.label = n = r.text(this.getLabelText(t), 0, 0, t.useHTML).attr({
                    align: t.textAlign || t.align,
                    rotation: t.rotation,
                    class: "highcharts-plot-" + (i ? "band" : "line") + "-label " + (t.className || ""),
                    zIndex: s
                }), o.chart.styledMode || n.css(os({
                    color: o.chart.options.title?.style?.color,
                    fontSize: "0.8em",
                    textOverflow: i && !a ? "" : "ellipsis"
                }, t.style)), n.add());
                let h = e.xBounds || [
                    e[0][1],
                    e[1][1],
                    i ? e[2][1] : e[0][1]
                ], l = e.yBounds || [
                    e[0][2],
                    e[1][2],
                    i ? e[2][2] : e[0][2]
                ], d = s8(h), c = s8(l), p = s4(h) - d;
                n.align(t, !1, {
                    x: d,
                    y: c,
                    width: p,
                    height: s4(l) - c
                }), n.alignAttr.y -= r.fontMetrics(n).b, (!n.alignValue || "left" === n.alignValue || s7(a)) && n.css({
                    width: (t.style?.width || (i && a ? p : 90 === n.rotation ? o.height - (n.alignAttr.y - o.top) : (t.clip ? o.width : o.chart.chartWidth) - (n.alignAttr.x - o.left))) + "px"
                }), n.show(!0);
            }
            getLabelText(t) {
                return s7(t.formatter) ? t.formatter.call(this) : t.text;
            }
            destroy() {
                oe(this.axis.plotLinesAndBands, this), delete this.axis, ot(this);
            }
        }
        let { animObject: on } = tU, { format: oh } = ep, { composed: ol, dateFormats: od, doc: oc, isSafari: op } = w, { distribute: og } = ey, { addEvent: ou, clamp: of, css: om, discardElement: ox, extend: oy, fireEvent: ob, getAlignFactor: ov, isArray: ok, isNumber: ow, isObject: oM, isString: oS, merge: oT, pick: oC, pushUnique: oA, splat: oP, syncTimeout: oL } = V;
        class oO {
            constructor(t, e, i){
                this.allowShared = !0, this.crosshairs = [], this.distance = 0, this.isHidden = !0, this.isSticky = !1, this.options = {}, this.outside = !1, this.chart = t, this.init(t, e), this.pointer = i;
            }
            bodyFormatter(t) {
                return t.map((t)=>{
                    let e = t.series.tooltipOptions, i = t.formatPrefix || "point";
                    return (e[i + "Formatter"] || t.tooltipFormatter).call(t, e[i + "Format"] || "");
                });
            }
            cleanSplit(t) {
                this.chart.series.forEach(function(e) {
                    let i = e?.tt;
                    i && (!i.isActive || t ? e.tt = i.destroy() : i.isActive = !1);
                });
            }
            defaultFormatter(t) {
                let e, i = this.points || oP(this);
                return (e = (e = [
                    t.headerFooterFormatter(i[0])
                ]).concat(t.bodyFormatter(i))).push(t.headerFooterFormatter(i[0], !0)), e;
            }
            destroy() {
                this.label && (this.label = this.label.destroy()), this.split && (this.cleanSplit(!0), this.tt && (this.tt = this.tt.destroy())), this.renderer && (this.renderer = this.renderer.destroy(), ox(this.container)), V.clearTimeout(this.hideTimer);
            }
            getAnchor(t, e) {
                let i, { chart: s, pointer: o } = this, r = s.inverted, a = s.plotTop, n = s.plotLeft;
                if (t = oP(t), t[0].series?.yAxis && !t[0].series.yAxis.options.reversedStacks && (t = t.slice().reverse()), this.followPointer && e) void 0 === e.chartX && (e = o.normalize(e)), i = [
                    e.chartX - n,
                    e.chartY - a
                ];
                else if (t[0].tooltipPos) i = t[0].tooltipPos;
                else {
                    let s = 0, o = 0;
                    t.forEach(function(t) {
                        let e = t.pos(!0);
                        e && (s += e[0], o += e[1]);
                    }), s /= t.length, o /= t.length, this.shared && t.length > 1 && e && (r ? s = e.chartX : o = e.chartY), i = [
                        s - n,
                        o - a
                    ];
                }
                let h = {
                    point: t[0],
                    ret: i
                };
                return ob(this, "getAnchor", h), h.ret.map(Math.round);
            }
            getClassName(t, e, i) {
                let s = this.options, o = t.series, r = o.options;
                return [
                    s.className,
                    "highcharts-label",
                    i && "highcharts-tooltip-header",
                    e ? "highcharts-tooltip-box" : "highcharts-tooltip",
                    !i && "highcharts-color-" + oC(t.colorIndex, o.colorIndex),
                    r?.className
                ].filter(oS).join(" ");
            }
            getLabel({ anchorX: t, anchorY: e } = {
                anchorX: 0,
                anchorY: 0
            }) {
                let i = this, s = this.chart.styledMode, o = this.options, r = this.split && this.allowShared, a = this.container, n = this.chart.renderer;
                if (this.label) {
                    let t = !this.label.hasClass("highcharts-label");
                    (!r && t || r && !t) && this.destroy();
                }
                if (!this.label) {
                    if (this.outside) {
                        let t = this.chart, e = t.options.chart.style, i = eg.getRendererType();
                        this.container = a = w.doc.createElement("div"), a.className = "highcharts-tooltip-container " + (t.renderTo.className.match(/(highcharts[a-zA-Z0-9-]+)\s?/gm) || ""), om(a, {
                            position: "absolute",
                            top: "1px",
                            pointerEvents: "none",
                            zIndex: Math.max(this.options.style.zIndex || 0, (e?.zIndex || 0) + 3)
                        }), this.renderer = n = new i(a, 0, 0, e, void 0, void 0, n.styledMode);
                    }
                    if (r ? this.label = n.g("tooltip") : (this.label = n.label("", t, e, o.shape || "callout", void 0, void 0, o.useHTML, void 0, "tooltip").attr({
                        padding: o.padding,
                        r: o.borderRadius
                    }), s || this.label.attr({
                        fill: o.backgroundColor,
                        "stroke-width": o.borderWidth || 0
                    }).css(o.style).css({
                        pointerEvents: o.style.pointerEvents || (this.shouldStickOnContact() ? "auto" : "none")
                    })), i.outside) {
                        let t = this.label;
                        [
                            t.xSetter,
                            t.ySetter
                        ].forEach((e, s)=>{
                            t[s ? "ySetter" : "xSetter"] = (o)=>{
                                e.call(t, i.distance), t[s ? "y" : "x"] = o, a && (a.style[s ? "top" : "left"] = `${o}px`);
                            };
                        });
                    }
                    this.label.attr({
                        zIndex: 8
                    }).shadow(o.shadow ?? !o.fixed).add();
                }
                return a && !a.parentElement && w.doc.body.appendChild(a), this.label;
            }
            getPlayingField() {
                let { body: t, documentElement: e } = oc, { chart: i, distance: s, outside: o } = this;
                return {
                    width: o ? Math.max(t.scrollWidth, e.scrollWidth, t.offsetWidth, e.offsetWidth, e.clientWidth) - 2 * s - 2 : i.chartWidth,
                    height: o ? Math.max(t.scrollHeight, e.scrollHeight, t.offsetHeight, e.offsetHeight, e.clientHeight) : i.chartHeight
                };
            }
            getPosition(t, e, i) {
                let { distance: s, chart: o, outside: r, pointer: a } = this, { inverted: n, plotLeft: h, plotTop: l, polar: d } = o, { plotX: c = 0, plotY: p = 0 } = i, g = {}, u = n && i.h || 0, { height: f, width: m } = this.getPlayingField(), x = a.getChartPosition(), y = (t)=>t * x.scaleX, b = (t)=>t * x.scaleY, v = (i)=>{
                    let a = "x" === i;
                    return [
                        i,
                        a ? m : f,
                        a ? t : e
                    ].concat(r ? [
                        a ? y(t) : b(e),
                        a ? x.left - s + y(c + h) : x.top - s + b(p + l),
                        0,
                        a ? m : f
                    ] : [
                        a ? t : e,
                        a ? c + h : p + l,
                        a ? h : l,
                        a ? h + o.plotWidth : l + o.plotHeight
                    ]);
                }, k = v("y"), w = v("x"), M, S = !!i.negative;
                !d && o.hoverSeries?.yAxis?.reversed && (S = !S);
                let T = !this.followPointer && oC(i.ttBelow, !d && !n === S), C = function(t, e, i, o, a, n, h) {
                    let l = r ? "y" === t ? b(s) : y(s) : s, d = (i - o) / 2, c = o < a - s, p = a + s + o < e, f = a - l - i + d, m = a + l - d;
                    if (T && p) g[t] = m;
                    else if (!T && c) g[t] = f;
                    else if (c) g[t] = Math.min(h - o, f - u < 0 ? f : f - u);
                    else {
                        if (!p) return g[t] = 0, !1;
                        g[t] = Math.max(n, m + u + i > e ? m : m + u);
                    }
                }, A = function(t, e, i, o, r) {
                    if (r < s || r > e - s) return !1;
                    r < i / 2 ? g[t] = 1 : r > e - o / 2 ? g[t] = e - o - 2 : g[t] = r - i / 2;
                }, P = function(t) {
                    [k, w] = [
                        w,
                        k
                    ], M = t;
                }, L = ()=>{
                    !1 !== C.apply(0, k) ? !1 !== A.apply(0, w) || M || (P(!0), L()) : M ? g.x = g.y = 0 : (P(!0), L());
                };
                return (n && !d || this.len > 1) && P(), L(), g;
            }
            getFixedPosition(t, e, i) {
                let s = i.series, { chart: o, options: r, split: a } = this, n = r.position, h = n.relativeTo, l = r.shared || s?.yAxis?.isRadial && ("pane" === h || !h) ? "plotBox" : h, d = "chart" === l ? o.renderer : o[l] || o.getClipBox(s, !0);
                return {
                    x: d.x + (d.width - t) * ov(n.align) + n.x,
                    y: d.y + (d.height - e) * ov(n.verticalAlign) + (!a && n.y || 0)
                };
            }
            hide(t) {
                let e = this;
                V.clearTimeout(this.hideTimer), t = oC(t, this.options.hideDelay), this.isHidden || (this.hideTimer = oL(function() {
                    let i = e.getLabel();
                    e.getLabel().animate({
                        opacity: 0
                    }, {
                        duration: t ? 150 : t,
                        complete: ()=>{
                            i.hide(), e.container && e.container.remove();
                        }
                    }), e.isHidden = !0;
                }, t));
            }
            init(t, e) {
                this.chart = t, this.options = e, this.crosshairs = [], this.isHidden = !0, this.split = e.split && !t.inverted && !t.polar, this.shared = e.shared || this.split, this.outside = oC(e.outside, !!(t.scrollablePixelsX || t.scrollablePixelsY));
            }
            shouldStickOnContact(t) {
                return !!(!this.followPointer && this.options.stickOnContact && (!t || this.pointer.inClass(t.target, "highcharts-tooltip")));
            }
            move(t, e, i, s) {
                let { followPointer: o, options: r } = this, a = on(!o && !this.isHidden && !r.fixed && r.animation), n = o || (this.len || 0) > 1, h = {
                    x: t,
                    y: e
                };
                n ? h.anchorX = h.anchorY = NaN : (h.anchorX = i, h.anchorY = s), a.step = ()=>this.drawTracker(), this.getLabel().animate(h, a);
            }
            refresh(t, e) {
                let { chart: i, options: s, pointer: o, shared: r } = this, a = oP(t), n = a[0], h = s.format, l = s.formatter || this.defaultFormatter, d = i.styledMode, c = this.allowShared;
                if (!s.enabled || !n.series) return;
                V.clearTimeout(this.hideTimer), this.allowShared = !(!ok(t) && t.series && t.series.noSharedTooltip), c = c && !this.allowShared, this.followPointer = !this.split && n.series.tooltipOptions.followPointer;
                let p = this.getAnchor(t, e), g = p[0], u = p[1];
                r && this.allowShared && (o.applyInactiveState(a), a.forEach((t)=>t.setState("hover")), n.points = a), this.len = a.length;
                let f = oS(h) ? oh(h, n, i) : l.call(n, this);
                n.points = void 0;
                let m = n.series;
                if (this.distance = oC(m.tooltipOptions.distance, 16), !1 === f) this.hide();
                else {
                    if (this.split && this.allowShared) this.renderSplit(f, a);
                    else {
                        let t = g, r = u;
                        if (e && o.isDirectTouch && (t = e.chartX - i.plotLeft, r = e.chartY - i.plotTop), !(i.polar || !1 === m.options.clip || a.some((e)=>o.isDirectTouch || e.series.shouldShowTooltip(t, r)))) return void this.hide();
                        {
                            let t = this.getLabel(c && this.tt || {});
                            (!s.style.width || d) && t.css({
                                width: (this.outside ? this.getPlayingField() : i.spacingBox).width + "px"
                            }), t.attr({
                                class: this.getClassName(n),
                                text: f && f.join ? f.join("") : f
                            }), this.outside && t.attr({
                                x: of(t.x || 0, 0, this.getPlayingField().width - (t.width || 0) - 1)
                            }), d || t.attr({
                                stroke: s.borderColor || n.color || m.color || "#666666"
                            }), this.updatePosition({
                                plotX: g,
                                plotY: u,
                                negative: n.negative,
                                ttBelow: n.ttBelow,
                                series: m,
                                h: p[2] || 0
                            });
                        }
                    }
                    this.isHidden && this.label && this.label.attr({
                        opacity: 1
                    }).show(), this.isHidden = !1;
                }
                ob(this, "refresh");
            }
            renderSplit(t, e) {
                let i = this, { chart: s, chart: { chartWidth: o, chartHeight: r, plotHeight: a, plotLeft: n, plotTop: h, scrollablePixelsY: l = 0, scrollablePixelsX: d, styledMode: c }, distance: p, options: g, options: { fixed: u, position: f, positioner: m }, pointer: x } = i, { scrollLeft: y = 0, scrollTop: b = 0 } = s.scrollablePlotArea?.scrollingContainer || {}, v = i.outside && "number" != typeof d ? oc.documentElement.getBoundingClientRect() : {
                    left: y,
                    right: y + o,
                    top: b,
                    bottom: b + r
                }, k = i.getLabel(), w = this.renderer || s.renderer, M = !!s.xAxis[0]?.opposite, { left: S, top: T } = x.getChartPosition(), C = m || u, A = h + b, P = 0, L = a - l, O = function(t, e, s, o = [
                    0,
                    0
                ], r = !0) {
                    let a, n;
                    if (s.isHeader) n = M ? 0 : L, a = of(o[0] - t / 2, v.left, v.right - t - (i.outside ? S : 0));
                    else if (u && s) {
                        let o = i.getFixedPosition(t, e, s);
                        a = o.x, n = o.y - A;
                    } else n = o[1] - A, a = of(a = r ? o[0] - t - p : o[0] + p, r ? a : v.left, v.right);
                    return {
                        x: a,
                        y: n
                    };
                };
                oS(t) && (t = [
                    !1,
                    t
                ]);
                let E = t.slice(0, e.length + 1).reduce(function(t, s, o) {
                    if (!1 !== s && "" !== s) {
                        let r = e[o - 1] || {
                            isHeader: !0,
                            plotX: e[0].plotX,
                            plotY: a,
                            series: {}
                        }, l = r.isHeader, d = l ? i : r.series, f = d.tt = function(t, e, s) {
                            let o = t, { isHeader: r, series: a } = e, n = a.tooltipOptions || g;
                            if (!o) {
                                let t = {
                                    padding: n.padding,
                                    r: n.borderRadius
                                };
                                c || (t.fill = n.backgroundColor, t["stroke-width"] = n.borderWidth ?? (u && !r ? 0 : 1)), o = w.label("", 0, 0, n[r ? "headerShape" : "shape"] || (u && !r ? "rect" : "callout"), void 0, void 0, n.useHTML).addClass(i.getClassName(e, !0, r)).attr(t).add(k);
                            }
                            return o.isActive = !0, o.attr({
                                text: s
                            }), c || o.css(n.style).attr({
                                stroke: n.borderColor || e.color || a.color || "#333333"
                            }), o;
                        }(d.tt, r, s.toString()), x = f.getBBox(), y = x.width + f.strokeWidth();
                        l && (P = x.height, L += P, M && (A -= P));
                        let { anchorX: b, anchorY: S } = function(t) {
                            let e, i, { isHeader: s, plotX: o = 0, plotY: r = 0, series: l } = t;
                            if (s) e = Math.max(n + o, n), i = h + a / 2;
                            else {
                                let { xAxis: t, yAxis: s } = l;
                                e = t.pos + of(o, -p, t.len + p), l.shouldShowTooltip(0, s.pos - h + r, {
                                    ignoreX: !0
                                }) && (i = s.pos + r);
                            }
                            return {
                                anchorX: e = of(e, v.left - p, v.right + p),
                                anchorY: i
                            };
                        }(r);
                        if ("number" == typeof S) {
                            let e = x.height + 1, s = (m || O).call(i, y, e, r, [
                                b,
                                S
                            ]);
                            t.push({
                                align: C ? 0 : void 0,
                                anchorX: b,
                                anchorY: S,
                                boxWidth: y,
                                point: r,
                                rank: oC(s.rank, +!!l),
                                size: e,
                                target: s.y,
                                tt: f,
                                x: s.x
                            });
                        } else f.isActive = !1;
                    }
                    return t;
                }, []);
                !C && E.some((t)=>{
                    let { outside: e } = i, s = (e ? S : 0) + t.anchorX;
                    return s < v.left && s + t.boxWidth < v.right || s < S - v.left + t.boxWidth && v.right - s > s;
                }) && (E = E.map((t)=>{
                    let { x: e, y: i } = O.call(this, t.boxWidth, t.size, t.point, [
                        t.anchorX,
                        t.anchorY
                    ], !1);
                    return oy(t, {
                        target: i,
                        x: e
                    });
                })), i.cleanSplit(), og(E, L);
                let I = {
                    left: S,
                    right: S
                };
                E.forEach(function(t) {
                    let { x: e, boxWidth: s, isHeader: o } = t;
                    !o && (i.outside && S + e < I.left && (I.left = S + e), !o && i.outside && I.left + s > I.right && (I.right = S + e));
                }), E.forEach(function(t) {
                    let { x: e, anchorX: s, anchorY: o, pos: r, point: { isHeader: a } } = t, n = {
                        visibility: void 0 === r ? "hidden" : "inherit",
                        x: e,
                        y: (r || 0) + A + (u && f.y || 0),
                        anchorX: s,
                        anchorY: o
                    };
                    if (i.outside && e < s) {
                        let t = S - I.left;
                        t > 0 && (a || (n.x = e + t, n.anchorX = s + t), a && (n.x = (I.right - I.left) / 2, n.anchorX = s + t));
                    }
                    t.tt.attr(n);
                });
                let { container: D, outside: B, renderer: N } = i;
                if (B && D && N) {
                    let { width: t, height: e, x: i, y: s } = k.getBBox();
                    N.setSize(t + i, e + s, !1), D.style.left = I.left + "px", D.style.top = T + "px";
                }
                op && k.attr({
                    opacity: 1 === k.opacity ? .999 : 1
                });
            }
            drawTracker() {
                if (!this.shouldStickOnContact()) {
                    this.tracker && (this.tracker = this.tracker.destroy());
                    return;
                }
                let t = this.chart, e = this.label, i = this.shared ? t.hoverPoints : t.hoverPoint;
                if (!e || !i) return;
                let s = {
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0
                }, o = this.getAnchor(i), r = e.getBBox();
                o[0] += t.plotLeft - (e.translateX || 0), o[1] += t.plotTop - (e.translateY || 0), s.x = Math.min(0, o[0]), s.y = Math.min(0, o[1]), s.width = o[0] < 0 ? Math.max(Math.abs(o[0]), r.width - o[0]) : Math.max(Math.abs(o[0]), r.width), s.height = o[1] < 0 ? Math.max(Math.abs(o[1]), r.height - Math.abs(o[1])) : Math.max(Math.abs(o[1]), r.height), this.tracker ? this.tracker.attr(s) : (this.tracker = e.renderer.rect(s).addClass("highcharts-tracker").add(e), t.styledMode || this.tracker.attr({
                    fill: "rgba(0,0,0,0)"
                }));
            }
            styledModeFormat(t) {
                return t.replace('style="font-size: 0.8em"', 'class="highcharts-header"').replace(/style="color:{(point|series)\.color}"/g, 'class="highcharts-color-{$1.colorIndex} {series.options.className} {point.options.className}"');
            }
            headerFooterFormatter(t, e) {
                let i = t.series, s = i.tooltipOptions, o = i.xAxis, r = o?.dateTime, a = {
                    isFooter: e,
                    point: t
                }, n = s.xDateFormat || "", h = s[e ? "footerFormat" : "headerFormat"];
                return ob(this, "headerFormatter", a, function(e) {
                    if (r && !n && ow(t.key) && (n = r.getXDateFormat(t.key, s.dateTimeLabelFormats)), r && n) {
                        if (oM(n)) {
                            let t = n;
                            od[0] = (e)=>i.chart.time.dateFormat(t, e), n = "%0";
                        }
                        (t.tooltipDateKeys || [
                            "key"
                        ]).forEach((t)=>{
                            h = h.replace(RegExp("point\\." + t + "([ \\)}])"), `(point.${t}:${n})$1`);
                        });
                    }
                    i.chart.styledMode && (h = this.styledModeFormat(h)), e.text = oh(h, t, this.chart);
                }), a.text || "";
            }
            update(t) {
                this.destroy(), this.init(this.chart, oT(!0, this.options, t));
            }
            updatePosition(t) {
                let { chart: e, container: i, distance: s, options: o, pointer: r, renderer: a } = this, { height: n = 0, width: h = 0 } = this.getLabel(), { fixed: l, positioner: d } = o, { left: c, top: p, scaleX: g, scaleY: u } = r.getChartPosition(), f = (d || l && this.getFixedPosition || this.getPosition).call(this, h, n, t), m = w.doc, x = (t.plotX || 0) + e.plotLeft, y = (t.plotY || 0) + e.plotTop, b;
                if (a && i) {
                    if (d || l) {
                        let { scrollLeft: t = 0, scrollTop: i = 0 } = e.scrollablePlotArea?.scrollingContainer || {};
                        f.x += t + c - s, f.y += i + p - s;
                    }
                    b = (o.borderWidth || 0) + 2 * s + 2, a.setSize(of(h + b, 0, m.documentElement.clientWidth) - 1, n + b, !1), (1 !== g || 1 !== u) && (om(i, {
                        transform: `scale(${g}, ${u})`
                    }), x *= g, y *= u), x += c - f.x, y += p - f.y;
                }
                this.move(Math.round(f.x), Math.round(f.y || 0), x, y);
            }
        }
        !function(t) {
            t.compose = function(e) {
                oA(ol, "Core.Tooltip") && ou(e, "afterInit", function() {
                    let e = this.chart;
                    e.options.tooltip && (e.tooltip = new t(e, e.options.tooltip, this));
                });
            };
        }(oO || (oO = {}));
        let oE = oO, { animObject: oI } = tU, { defaultOptions: oD } = tv, { format: oB } = ep, { addEvent: oN, crisp: oz, erase: oR, extend: oW, fireEvent: oH, getNestedProperty: oX, isArray: oF, isFunction: oG, isNumber: oj, isObject: oY, merge: oU, pick: o$, syncTimeout: oV, removeEvent: oZ, uniqueKey: o_ } = V;
        class oq {
            animateBeforeDestroy() {
                let t = this, e = {
                    x: t.startXPos,
                    opacity: 0
                }, i = t.getGraphicalProps();
                i.singular.forEach(function(i) {
                    t[i] = t[i].animate("dataLabel" === i ? {
                        x: t[i].startXPos,
                        y: t[i].startYPos,
                        opacity: 0
                    } : e);
                }), i.plural.forEach(function(e) {
                    t[e].forEach(function(e) {
                        e.element && e.animate(oW({
                            x: t.startXPos
                        }, e.startYPos ? {
                            x: e.startXPos,
                            y: e.startYPos
                        } : {}));
                    });
                });
            }
            applyOptions(t, e) {
                let i = this.series, s = i.options.pointValKey || i.pointValKey;
                return oW(this, t = oq.prototype.optionsToObject.call(this, t)), this.options = this.options ? oW(this.options, t) : t, t.group && delete this.group, t.dataLabels && delete this.dataLabels, s && (this.y = oq.prototype.getNestedProperty.call(this, s)), this.selected && (this.state = "select"), "name" in this && void 0 === e && i.xAxis && i.xAxis.hasNames && (this.x = i.xAxis.nameToX(this)), void 0 === this.x && i ? this.x = e ?? i.autoIncrement() : oj(t.x) && i.options.relativeXValue ? this.x = i.autoIncrement(t.x) : "string" == typeof this.x && (e ?? (e = i.chart.time.parse(this.x)), oj(e) && (this.x = e)), this.isNull = this.isValid && !this.isValid(), this.formatPrefix = this.isNull ? "null" : "point", this;
            }
            destroy() {
                if (!this.destroyed) {
                    let t = this, e = t.series, i = e.chart, s = e.options.dataSorting, o = i.hoverPoints, r = oI(t.series.chart.renderer.globalAnimation), a = ()=>{
                        for(let e in (t.graphic || t.graphics || t.dataLabel || t.dataLabels) && (oZ(t), t.destroyElements()), t)delete t[e];
                    };
                    t.legendItem && i.legend.destroyItem(t), o && (t.setState(), oR(o, t), o.length || (i.hoverPoints = null)), t === i.hoverPoint && t.onMouseOut(), s?.enabled ? (this.animateBeforeDestroy(), oV(a, r.duration)) : a(), i.pointCount--;
                }
                this.destroyed = !0;
            }
            destroyElements(t) {
                let e = this, i = e.getGraphicalProps(t);
                i.singular.forEach(function(t) {
                    e[t] = e[t].destroy();
                }), i.plural.forEach(function(t) {
                    e[t].forEach(function(t) {
                        t?.element && t.destroy();
                    }), delete e[t];
                });
            }
            firePointEvent(t, e, i) {
                let s = this, o = this.series.options;
                s.manageEvent(t), "click" === t && o.allowPointSelect && (i = function(t) {
                    !s.destroyed && s.select && s.select(null, t.ctrlKey || t.metaKey || t.shiftKey);
                }), oH(s, t, e, i);
            }
            getClassName() {
                return "highcharts-point" + (this.selected ? " highcharts-point-select" : "") + (this.negative ? " highcharts-negative" : "") + (this.isNull ? " highcharts-null-point" : "") + (void 0 !== this.colorIndex ? " highcharts-color-" + this.colorIndex : "") + (this.options.className ? " " + this.options.className : "") + (this.zone?.className ? " " + this.zone.className.replace("highcharts-negative", "") : "");
            }
            getGraphicalProps(t) {
                let e, i, s = this, o = [], r = {
                    singular: [],
                    plural: []
                };
                for((t = t || {
                    graphic: 1,
                    dataLabel: 1
                }).graphic && o.push("graphic", "connector"), t.dataLabel && o.push("dataLabel", "dataLabelPath", "dataLabelUpper"), i = o.length; i--;)s[e = o[i]] && r.singular.push(e);
                return [
                    "graphic",
                    "dataLabel"
                ].forEach(function(e) {
                    let i = e + "s";
                    t[e] && s[i] && r.plural.push(i);
                }), r;
            }
            getNestedProperty(t) {
                if (t) return 0 === t.indexOf("custom.") ? oX(t, this.options) : this[t];
            }
            getZone() {
                let t = this.series, e = t.zones, i = t.zoneAxis || "y", s, o = 0;
                for(s = e[0]; this[i] >= s.value;)s = e[++o];
                return this.nonZonedColor || (this.nonZonedColor = this.color), s?.color && !this.options.color ? this.color = s.color : this.color = this.nonZonedColor, s;
            }
            hasNewShapeType() {
                return (this.graphic && (this.graphic.symbolName || this.graphic.element.nodeName)) !== this.shapeType;
            }
            constructor(t, e, i){
                this.formatPrefix = "point", this.visible = !0, this.point = this, this.series = t, this.applyOptions(e, i), this.id ?? (this.id = o_()), this.resolveColor(), this.dataLabelOnNull ?? (this.dataLabelOnNull = t.options.nullInteraction), t.chart.pointCount++, oH(this, "afterInit");
            }
            isValid() {
                return (oj(this.x) || this.x instanceof Date) && oj(this.y);
            }
            optionsToObject(t) {
                let e = this.series, i = e.options.keys, s = i || e.pointArrayMap || [
                    "y"
                ], o = s.length, r = {}, a, n = 0, h = 0;
                if (oj(t) || null === t) r[s[0]] = t;
                else if (oF(t)) for(!i && t.length > o && ("string" == (a = typeof t[0]) ? e.xAxis?.dateTime ? r.x = e.chart.time.parse(t[0]) : r.name = t[0] : "number" === a && (r.x = t[0]), n++); h < o;)i && void 0 === t[n] || (s[h].indexOf(".") > 0 ? oq.prototype.setNestedProperty(r, t[n], s[h]) : r[s[h]] = t[n]), n++, h++;
                else "object" == typeof t && (r = t, t.dataLabels && (e.hasDataLabels = ()=>!0), t.marker && (e._hasPointMarkers = !0));
                return r;
            }
            pos(t, e = this.plotY) {
                if (!this.destroyed) {
                    let { plotX: i, series: s } = this, { chart: o, xAxis: r, yAxis: a } = s, n = 0, h = 0;
                    if (oj(i) && oj(e)) return t && (n = r ? r.pos : o.plotLeft, h = a ? a.pos : o.plotTop), o.inverted && r && a ? [
                        a.len - e + h,
                        r.len - i + n
                    ] : [
                        i + n,
                        e + h
                    ];
                }
            }
            resolveColor() {
                let t = this.series, e = t.chart.options.chart, i = t.chart.styledMode, s, o, r = e.colorCount, a;
                delete this.nonZonedColor, t.options.colorByPoint ? (i || (s = (o = t.options.colors || t.chart.options.colors)[t.colorCounter], r = o.length), a = t.colorCounter, t.colorCounter++, t.colorCounter === r && (t.colorCounter = 0)) : (i || (s = t.color), a = t.colorIndex), this.colorIndex = o$(this.options.colorIndex, a), this.color = o$(this.options.color, s);
            }
            setNestedProperty(t, e, i) {
                return i.split(".").reduce(function(t, i, s, o) {
                    let r = o.length - 1 === s;
                    return t[i] = r ? e : oY(t[i], !0) ? t[i] : {}, t[i];
                }, t), t;
            }
            shouldDraw() {
                return !this.isNull;
            }
            tooltipFormatter(t) {
                let { chart: e, pointArrayMap: i = [
                    "y"
                ], tooltipOptions: s } = this.series, { valueDecimals: o = "", valuePrefix: r = "", valueSuffix: a = "" } = s;
                return e.styledMode && (t = e.tooltip?.styledModeFormat(t) || t), i.forEach((e)=>{
                    e = "{point." + e, (r || a) && (t = t.replace(RegExp(e + "}", "g"), r + e + "}" + a)), t = t.replace(RegExp(e + "}", "g"), e + ":,." + o + "f}");
                }), oB(t, this, e);
            }
            update(t, e, i, s) {
                let o, r = this, a = r.series, n = r.graphic, h = a.chart, l = a.options;
                function d() {
                    r.applyOptions(t);
                    let s = n && r.hasMockGraphic, d = null === r.y ? !s : s;
                    n && d && (r.graphic = n.destroy(), delete r.hasMockGraphic), oY(t, !0) && (n?.element && t && t.marker && void 0 !== t.marker.symbol && (r.graphic = n.destroy()), t?.dataLabels && r.dataLabel && (r.dataLabel = r.dataLabel.destroy())), o = r.index;
                    let c = {};
                    for (let t of a.dataColumnKeys())c[t] = r[t];
                    a.dataTable.setRow(c, o), l.data[o] = oY(l.data[o], !0) || oY(t, !0) ? r.options : o$(t, l.data[o]), a.isDirty = a.isDirtyData = !0, !a.fixedBox && a.hasCartesianSeries && (h.isDirtyBox = !0), "point" === l.legendType && (h.isDirtyLegend = !0), e && h.redraw(i);
                }
                e = o$(e, !0), !1 === s ? d() : r.firePointEvent("update", {
                    options: t
                }, d);
            }
            remove(t, e) {
                this.series.removePoint(this.series.data.indexOf(this), t, e);
            }
            select(t, e) {
                let i = this, s = i.series, o = s.chart;
                t = o$(t, !i.selected), this.selectedStaging = t, i.firePointEvent(t ? "select" : "unselect", {
                    accumulate: e
                }, function() {
                    i.selected = i.options.selected = t, s.options.data[s.data.indexOf(i)] = i.options, i.setState(t && "select"), e || o.getSelectedPoints().forEach(function(t) {
                        let e = t.series;
                        t.selected && t !== i && (t.selected = t.options.selected = !1, e.options.data[e.data.indexOf(t)] = t.options, t.setState(o.hoverPoints && e.options.inactiveOtherPoints ? "inactive" : ""), t.firePointEvent("unselect"));
                    });
                }), delete this.selectedStaging;
            }
            onMouseOver(t) {
                let { inverted: e, pointer: i } = this.series.chart;
                i && (t = t ? i.normalize(t) : i.getChartCoordinatesFromPoint(this, e), i.runPointActions(t, this));
            }
            onMouseOut() {
                let t = this.series.chart;
                this.firePointEvent("mouseOut"), this.series.options.inactiveOtherPoints || (t.hoverPoints || []).forEach(function(t) {
                    t.setState();
                }), t.hoverPoints = t.hoverPoint = null;
            }
            manageEvent(t) {
                let e = oU(this.series.options.point, this.options), i = e.events?.[t];
                oG(i) && (!this.hcEvents?.[t] || this.hcEvents?.[t]?.map((t)=>t.fn).indexOf(i) === -1) ? (this.importedUserEvent?.(), this.importedUserEvent = oN(this, t, i), this.hcEvents && (this.hcEvents[t].userEvent = !0)) : this.importedUserEvent && !i && this.hcEvents?.[t] && this.hcEvents?.[t].userEvent && (oZ(this, t), delete this.hcEvents[t], Object.keys(this.hcEvents) || delete this.importedUserEvent);
            }
            setState(t, e) {
                let i = this.series, s = this.state, o = i.options.states[t || "normal"] || {}, r = oD.plotOptions[i.type].marker && i.options.marker, a = r && !1 === r.enabled, n = r?.states?.[t || "normal"] || {}, h = !1 === n.enabled, l = this.marker || {}, d = i.chart, c = r && i.markerAttribs, p = i.halo, g, u, f, m = i.stateMarkerGraphic, x;
                if ((t = t || "") === this.state && !e || this.selected && "select" !== t || !1 === o.enabled || t && (h || a && !1 === n.enabled) || t && l.states && l.states[t] && !1 === l.states[t].enabled) return;
                if (this.state = t, c && (g = i.markerAttribs(this, t)), this.graphic && !this.hasMockGraphic) {
                    if (s && this.graphic.removeClass("highcharts-point-" + s), t && this.graphic.addClass("highcharts-point-" + t), !d.styledMode) {
                        u = i.pointAttribs(this, t), f = o$(d.options.chart.animation, o.animation);
                        let e = u.opacity;
                        i.options.inactiveOtherPoints && oj(e) && (this.dataLabels || []).forEach(function(t) {
                            t && !t.hasClass("highcharts-data-label-hidden") && (t.animate({
                                opacity: e
                            }, f), t.connector && t.connector.animate({
                                opacity: e
                            }, f));
                        }), this.graphic.animate(u, f);
                    }
                    g && this.graphic.animate(g, o$(d.options.chart.animation, n.animation, r.animation)), m && m.hide();
                } else t && n && (x = l.symbol || i.symbol, m && m.currentSymbol !== x && (m = m.destroy()), g && (m ? m[e ? "animate" : "attr"]({
                    x: g.x,
                    y: g.y
                }) : x && (i.stateMarkerGraphic = m = d.renderer.symbol(x, g.x, g.y, g.width, g.height, oU(r, n)).add(i.markerGroup), m.currentSymbol = x)), !d.styledMode && m && "inactive" !== this.state && m.attr(i.pointAttribs(this, t))), m && (m[t && this.isInside ? "show" : "hide"](), m.element.point = this, m.addClass(this.getClassName(), !0));
                let y = o.halo, b = this.graphic || m, v = b?.visibility || "inherit";
                y?.size && b && "hidden" !== v && !this.isCluster ? (p || (i.halo = p = d.renderer.path().add(b.parentGroup)), p.show()[e ? "animate" : "attr"]({
                    d: this.haloPath(y.size)
                }), p.attr({
                    class: "highcharts-halo highcharts-color-" + o$(this.colorIndex, i.colorIndex) + (this.className ? " " + this.className : ""),
                    visibility: v,
                    zIndex: -1
                }), p.point = this, d.styledMode || p.attr(oW({
                    fill: this.color || i.color,
                    "fill-opacity": y.opacity
                }, t6.filterUserAttributes(y.attributes || {})))) : p?.point?.haloPath && !p.point.destroyed && p.animate({
                    d: p.point.haloPath(0)
                }, null, p.hide), oH(this, "afterSetState", {
                    state: t
                });
            }
            haloPath(t) {
                let e = this.pos();
                return e ? this.series.chart.renderer.symbols.circle(oz(e[0], 1) - t, e[1] - t, 2 * t, 2 * t) : [];
            }
        }
        let oK = oq, { parse: oJ } = tL, { charts: oQ, composed: o0, isTouchDevice: o1 } = w, { addEvent: o2, attr: o3, css: o5, extend: o6, find: o9, fireEvent: o4, isNumber: o8, isObject: o7, objectEach: rt, offset: re, pick: ri, pushUnique: rs, splat: ro } = V;
        class rr {
            applyInactiveState(t = []) {
                let e = [];
                for (let i of (t.forEach((t)=>{
                    let i = t.series;
                    e.push(i), i.linkedParent && e.push(i.linkedParent), i.linkedSeries && e.push.apply(e, i.linkedSeries), i.navigatorSeries && e.push(i.navigatorSeries), i.boosted && i.markerGroup && e.push.apply(e, this.chart.series.filter((t)=>t.markerGroup === i.markerGroup));
                }), this.chart.series)){
                    let t = i.options;
                    t.states?.inactive?.enabled !== !1 && (-1 === e.indexOf(i) ? i.setState("inactive", !0) : t.inactiveOtherPoints && i.setAllPointsToState("inactive"));
                }
            }
            destroy() {
                let t = this;
                this.eventsToUnbind.forEach((t)=>t()), this.eventsToUnbind = [], !w.chartCount && (rr.unbindDocumentMouseUp.forEach((t)=>t.unbind()), rr.unbindDocumentMouseUp.length = 0, rr.unbindDocumentTouchEnd && (rr.unbindDocumentTouchEnd = rr.unbindDocumentTouchEnd())), clearInterval(t.tooltipTimeout), rt(t, function(e, i) {
                    t[i] = void 0;
                });
            }
            getSelectionMarkerAttrs(t, e) {
                let i = {
                    args: {
                        chartX: t,
                        chartY: e
                    },
                    attrs: {},
                    shapeType: "rect"
                };
                return o4(this, "getSelectionMarkerAttrs", i, (i)=>{
                    let s, { chart: o, zoomHor: r, zoomVert: a } = this, { mouseDownX: n = 0, mouseDownY: h = 0 } = o, l = i.attrs;
                    l.x = o.plotLeft, l.y = o.plotTop, l.width = r ? 1 : o.plotWidth, l.height = a ? 1 : o.plotHeight, r && (l.width = Math.max(1, Math.abs(s = t - n)), l.x = (s > 0 ? 0 : s) + n), a && (l.height = Math.max(1, Math.abs(s = e - h)), l.y = (s > 0 ? 0 : s) + h);
                }), i;
            }
            drag(t) {
                let { chart: e } = this, { mouseDownX: i = 0, mouseDownY: s = 0 } = e, { panning: o, panKey: r, selectionMarkerFill: a } = e.options.chart, n = e.plotLeft, h = e.plotTop, l = e.plotWidth, d = e.plotHeight, c = o7(o) ? o.enabled : o, p = r && t[`${r}Key`], g = t.chartX, u = t.chartY, f, m = this.selectionMarker;
                if ((!m || !m.touch) && (g < n ? g = n : g > n + l && (g = n + l), u < h ? u = h : u > h + d && (u = h + d), this.hasDragged = Math.sqrt(Math.pow(i - g, 2) + Math.pow(s - u, 2)), this.hasDragged > 10)) {
                    f = e.isInsidePlot(i - n, s - h, {
                        visiblePlotOnly: !0
                    });
                    let { shapeType: r, attrs: l } = this.getSelectionMarkerAttrs(g, u);
                    this.hasZoom && f && !p && !m && (this.selectionMarker = m = e.renderer[r](), m.attr({
                        class: "highcharts-selection-marker",
                        zIndex: 7
                    }).add(), e.styledMode || m.attr({
                        fill: a || oJ("#334eff").setOpacity(.25).get()
                    })), m && m.attr(l), f && !m && c && e.pan(t, o);
                }
            }
            dragStart(t) {
                let e = this.chart;
                e.mouseIsDown = t.type, e.cancelClick = !1, e.mouseDownX = t.chartX, e.mouseDownY = t.chartY;
            }
            getSelectionBox(t) {
                let e = {
                    args: {
                        marker: t
                    },
                    result: t.getBBox()
                };
                return o4(this, "getSelectionBox", e), e.result;
            }
            drop(t) {
                let e, { chart: i, selectionMarker: s } = this;
                for (let t of i.axes)t.isPanning && (t.isPanning = !1, (t.options.startOnTick || t.options.endOnTick || t.series.some((t)=>t.boosted)) && (t.forceRedraw = !0, t.setExtremes(t.userMin, t.userMax, !1), e = !0));
                if (e && i.redraw(), s && t) {
                    if (this.hasDragged) {
                        let e = this.getSelectionBox(s);
                        i.transform({
                            axes: i.axes.filter((t)=>t.zoomEnabled && ("xAxis" === t.coll && this.zoomX || "yAxis" === t.coll && this.zoomY)),
                            selection: {
                                originalEvent: t,
                                xAxis: [],
                                yAxis: [],
                                ...e
                            },
                            from: e
                        });
                    }
                    o8(i.index) && (this.selectionMarker = s.destroy());
                }
                i && o8(i.index) && (o5(i.container, {
                    cursor: i._cursor
                }), i.cancelClick = this.hasDragged > 10, i.mouseIsDown = !1, this.hasDragged = 0, this.pinchDown = [], this.hasPinchMoved = !1);
            }
            findNearestKDPoint(t, e, i) {
                let s;
                return t.forEach(function(t) {
                    let o = !(t.noSharedTooltip && e) && 0 > t.options.findNearestPointBy.indexOf("y"), r = t.searchPoint(i, o);
                    o7(r, !0) && r.series && (!o7(s, !0) || function(t, i) {
                        let s, o = t.distX - i.distX, r = t.dist - i.dist, a = i.series.group?.zIndex - t.series.group?.zIndex;
                        return 0 !== o && e ? o : 0 !== r ? r : 0 !== a ? a : t.series.index > i.series.index ? -1 : 1;
                    }(s, r) > 0) && (s = r);
                }), s;
            }
            getChartCoordinatesFromPoint(t, e) {
                let { xAxis: i, yAxis: s } = t.series, o = t.shapeArgs;
                if (i && s) {
                    let r = t.clientX ?? t.plotX ?? 0, a = t.plotY || 0;
                    return t.isNode && o && o8(o.x) && o8(o.y) && (r = o.x, a = o.y), e ? {
                        chartX: s.len + s.pos - a,
                        chartY: i.len + i.pos - r
                    } : {
                        chartX: r + i.pos,
                        chartY: a + s.pos
                    };
                }
                if (o?.x && o.y) return {
                    chartX: o.x,
                    chartY: o.y
                };
            }
            getChartPosition() {
                if (this.chartPosition) return this.chartPosition;
                let { container: t } = this.chart, e = re(t);
                this.chartPosition = {
                    left: e.left,
                    top: e.top,
                    scaleX: 1,
                    scaleY: 1
                };
                let { offsetHeight: i, offsetWidth: s } = t;
                return s > 2 && i > 2 && (this.chartPosition.scaleX = e.width / s, this.chartPosition.scaleY = e.height / i), this.chartPosition;
            }
            getCoordinates(t) {
                let e = {
                    xAxis: [],
                    yAxis: []
                };
                for (let i of this.chart.axes)e[i.isXAxis ? "xAxis" : "yAxis"].push({
                    axis: i,
                    value: i.toValue(t[i.horiz ? "chartX" : "chartY"])
                });
                return e;
            }
            getHoverData(t, e, i, s, o, r) {
                let a = [], n = function(t) {
                    return t.visible && !(!o && t.directTouch) && ri(t.options.enableMouseTracking, !0);
                }, h = e, l, d = {
                    chartX: r ? r.chartX : void 0,
                    chartY: r ? r.chartY : void 0,
                    shared: o
                };
                o4(this, "beforeGetHoverData", d), l = h && !h.stickyTracking ? [
                    h
                ] : i.filter((t)=>t.stickyTracking && (d.filter || n)(t));
                let c = s && t || !r ? t : this.findNearestKDPoint(l, o, r);
                return h = c?.series, c && (o && !h.noSharedTooltip ? (l = i.filter(function(t) {
                    return d.filter ? d.filter(t) : n(t) && !t.noSharedTooltip;
                })).forEach(function(t) {
                    let e = t.options?.nullInteraction, i = o9(t.points, function(t) {
                        return t.x === c.x && (!t.isNull || !!e);
                    });
                    o7(i) && (t.boosted && t.boost && (i = t.boost.getPoint(i)), a.push(i));
                }) : a.push(c)), o4(this, "afterGetHoverData", d = {
                    hoverPoint: c
                }), {
                    hoverPoint: d.hoverPoint,
                    hoverSeries: h,
                    hoverPoints: a
                };
            }
            getPointFromEvent(t) {
                let e = t.target, i;
                for(; e && !i;)i = e.point, e = e.parentNode;
                return i;
            }
            onTrackerMouseOut(t) {
                let e = this.chart, i = t.relatedTarget, s = e.hoverSeries;
                this.isDirectTouch = !1, !s || !i || s.stickyTracking || this.inClass(i, "highcharts-tooltip") || this.inClass(i, "highcharts-series-" + s.index) && this.inClass(i, "highcharts-tracker") || s.onMouseOut();
            }
            inClass(t, e) {
                let i = t, s;
                for(; i;){
                    if (s = o3(i, "class")) {
                        if (-1 !== s.indexOf(e)) return !0;
                        if (-1 !== s.indexOf("highcharts-container")) return !1;
                    }
                    i = i.parentElement;
                }
            }
            constructor(t, e){
                this.hasDragged = 0, this.pointerCaptureEventsToUnbind = [], this.eventsToUnbind = [], this.options = e, this.chart = t, this.runChartClick = !!e.chart.events?.click, this.pinchDown = [], this.setDOMEvents(), o4(this, "afterInit");
            }
            normalize(t, e) {
                let i = t.touches, s = i ? i.length ? i.item(0) : ri(i.changedTouches, t.changedTouches)[0] : t;
                e || (e = this.getChartPosition());
                let o = s.pageX - e.left, r = s.pageY - e.top;
                return o6(t, {
                    chartX: Math.round(o /= e.scaleX),
                    chartY: Math.round(r /= e.scaleY)
                });
            }
            onContainerClick(t) {
                let e = this.chart, i = e.hoverPoint, s = this.normalize(t), o = e.plotLeft, r = e.plotTop;
                !e.cancelClick && (i && this.inClass(s.target, "highcharts-tracker") ? (o4(i.series, "click", o6(s, {
                    point: i
                })), e.hoverPoint && i.firePointEvent("click", s)) : (o6(s, this.getCoordinates(s)), e.isInsidePlot(s.chartX - o, s.chartY - r, {
                    visiblePlotOnly: !0
                }) && o4(e, "click", s)));
            }
            onContainerMouseDown(t) {
                let e = (1 & (t.buttons || t.button)) == 1;
                t = this.normalize(t), w.isFirefox && 0 !== t.button && this.onContainerMouseMove(t), (void 0 === t.button || e) && (this.zoomOption(t), e && t.preventDefault?.(), this.dragStart(t));
            }
            onContainerMouseLeave(t) {
                let { pointer: e } = oQ[ri(rr.hoverChartIndex, -1)] || {};
                t = this.normalize(t), this.onContainerMouseMove(t), e && !this.inClass(t.relatedTarget, "highcharts-tooltip") && (e.reset(), e.chartPosition = void 0);
            }
            onContainerMouseEnter() {
                delete this.chartPosition;
            }
            onContainerMouseMove(t) {
                let e = this.chart, i = e.tooltip, s = this.normalize(t);
                this.setHoverChartIndex(t), ("mousedown" === e.mouseIsDown || this.touchSelect(s)) && this.drag(s), !e.exporting?.openMenu && (this.inClass(s.target, "highcharts-tracker") || e.isInsidePlot(s.chartX - e.plotLeft, s.chartY - e.plotTop, {
                    visiblePlotOnly: !0
                })) && !i?.shouldStickOnContact(s) && (this.inClass(s.target, "highcharts-no-tooltip") ? this.reset(!1, 0) : this.runPointActions(s));
            }
            onDocumentTouchEnd(t) {
                this.onDocumentMouseUp(t);
            }
            onContainerTouchMove(t) {
                this.touchSelect(t) ? this.onContainerMouseMove(t) : this.touch(t);
            }
            onContainerTouchStart(t) {
                this.touchSelect(t) ? this.onContainerMouseDown(t) : (this.zoomOption(t), this.touch(t, !0));
            }
            onDocumentMouseMove(t) {
                let e = this.chart, i = e.tooltip, s = this.chartPosition, o = this.normalize(t, s);
                !s || e.isInsidePlot(o.chartX - e.plotLeft, o.chartY - e.plotTop, {
                    visiblePlotOnly: !0
                }) || i?.shouldStickOnContact(o) || o.target !== e.container.ownerDocument && this.inClass(o.target, "highcharts-tracker") || this.reset();
            }
            onDocumentMouseUp(t) {
                t?.touches && this.hasPinchMoved && t?.preventDefault?.(), oQ[ri(rr.hoverChartIndex, -1)]?.pointer?.drop(t);
            }
            pinch(t) {
                let e = this, { chart: i, hasZoom: s, lastTouches: o } = e, r = [].map.call(t.touches || [], (t)=>e.normalize(t)), a = r.length, n = 1 === a && (e.inClass(t.target, "highcharts-tracker") && i.runTrackerClick || e.runChartClick), h = i.tooltip, l = 1 === a && ri(h?.options.followTouchMove, !0);
                a > 1 ? e.initiated = !0 : l && (e.initiated = !1), s && e.initiated && !n && !1 !== t.cancelable && t.preventDefault(), "touchstart" === t.type ? (e.pinchDown = r, e.res = !0, i.mouseDownX = t.chartX) : l ? this.runPointActions(e.normalize(t)) : o && (o4(i, "touchpan", {
                    originalEvent: t,
                    touches: r
                }, ()=>{
                    let e = (t)=>{
                        let e = t[0], i = t[1] || e;
                        return {
                            x: e.chartX,
                            y: e.chartY,
                            width: i.chartX - e.chartX,
                            height: i.chartY - e.chartY
                        };
                    };
                    i.transform({
                        axes: i.axes.filter((t)=>t.zoomEnabled && (this.zoomHor && t.horiz || this.zoomVert && !t.horiz)),
                        to: e(r),
                        from: e(o),
                        trigger: t.type
                    });
                }), e.res && (e.res = !1, this.reset(!1, 0))), e.lastTouches = r;
            }
            reset(t, e) {
                let i = this.chart, s = i.hoverSeries, o = i.hoverPoint, r = i.hoverPoints, a = i.tooltip, n = a?.shared ? r : o;
                t && n && ro(n).forEach(function(e) {
                    e.series.isCartesian && void 0 === e.plotX && (t = !1);
                }), t ? a && n && ro(n).length && (a.refresh(n), a.shared && r ? r.forEach(function(t) {
                    t.setState(t.state, !0), t.series.isCartesian && (t.series.xAxis.crosshair && t.series.xAxis.drawCrosshair(null, t), t.series.yAxis.crosshair && t.series.yAxis.drawCrosshair(null, t));
                }) : o && (o.setState(o.state, !0), i.axes.forEach(function(t) {
                    t.crosshair && o.series[t.coll] === t && t.drawCrosshair(null, o);
                }))) : (o && o.onMouseOut(), r && r.forEach(function(t) {
                    t.setState();
                }), s && s.onMouseOut(), a && a.hide(e), this.unDocMouseMove && (this.unDocMouseMove = this.unDocMouseMove()), i.axes.forEach(function(t) {
                    t.hideCrosshair();
                }), i.hoverPoints = i.hoverPoint = void 0);
            }
            runPointActions(t, e, i) {
                let s = this.chart, o = s.series, r = s.tooltip?.options.enabled ? s.tooltip : void 0, a = !!r && r.shared, n = e || s.hoverPoint, h = n?.series || s.hoverSeries, l = (!t || "touchmove" !== t.type) && (!!e || h?.directTouch && this.isDirectTouch), d = this.getHoverData(n, h, o, l, a, t);
                n = d.hoverPoint, h = d.hoverSeries;
                let c = d.hoverPoints, p = h?.tooltipOptions.followPointer && !h.tooltipOptions.split, g = a && h && !h.noSharedTooltip;
                if (n && (i || n !== s.hoverPoint || r?.isHidden)) {
                    if ((s.hoverPoints || []).forEach(function(t) {
                        -1 === c.indexOf(t) && t.setState();
                    }), s.hoverSeries !== h && h.onMouseOver(), this.applyInactiveState(c), (c || []).forEach(function(t) {
                        t.setState("hover");
                    }), s.hoverPoint && s.hoverPoint.firePointEvent("mouseOut"), !n.series) return;
                    s.hoverPoints = c, s.hoverPoint = n, n.firePointEvent("mouseOver", void 0, ()=>{
                        r && n && r.refresh(g ? c : n, t);
                    });
                } else if (p && r && !r.isHidden) {
                    let e = r.getAnchor([
                        {}
                    ], t);
                    s.isInsidePlot(e[0], e[1], {
                        visiblePlotOnly: !0
                    }) && r.updatePosition({
                        plotX: e[0],
                        plotY: e[1]
                    });
                }
                this.unDocMouseMove || (this.unDocMouseMove = o2(s.container.ownerDocument, "mousemove", (t)=>oQ[rr.hoverChartIndex ?? -1]?.pointer?.onDocumentMouseMove(t)), this.eventsToUnbind.push(this.unDocMouseMove)), s.axes.forEach(function(e) {
                    let i, o = e.crosshair?.snap ?? !0;
                    o && ((i = s.hoverPoint) && i.series[e.coll] === e || (i = o9(c, (t)=>t.series?.[e.coll] === e))), i || !o ? e.drawCrosshair(t, i) : e.hideCrosshair();
                });
            }
            setDOMEvents() {
                let t = this.chart.container, e = t.ownerDocument;
                t.onmousedown = this.onContainerMouseDown.bind(this), t.onmousemove = this.onContainerMouseMove.bind(this), t.onclick = this.onContainerClick.bind(this), this.eventsToUnbind.push(o2(t, "mouseenter", this.onContainerMouseEnter.bind(this)), o2(t, "mouseleave", this.onContainerMouseLeave.bind(this))), rr.unbindDocumentMouseUp.some((t)=>t.doc === e) || rr.unbindDocumentMouseUp.push({
                    doc: e,
                    unbind: o2(e, "mouseup", this.onDocumentMouseUp.bind(this))
                });
                let i = this.chart.renderTo.parentElement;
                for(; i && "BODY" !== i.tagName;)this.eventsToUnbind.push(o2(i, "scroll", ()=>{
                    delete this.chartPosition;
                })), i = i.parentElement;
                this.eventsToUnbind.push(o2(t, "touchstart", this.onContainerTouchStart.bind(this), {
                    passive: !1
                }), o2(t, "touchmove", this.onContainerTouchMove.bind(this), {
                    passive: !1
                })), rr.unbindDocumentTouchEnd || (rr.unbindDocumentTouchEnd = o2(e, "touchend", this.onDocumentTouchEnd.bind(this), {
                    passive: !1
                })), this.setPointerCapture(), o2(this.chart, "redraw", this.setPointerCapture.bind(this));
            }
            setPointerCapture() {
                if (!o1) return;
                let t = this.pointerCaptureEventsToUnbind, e = this.chart, i = e.container, s = ri(e.options.tooltip?.followTouchMove, !0) && e.series.some((t)=>t.options.findNearestPointBy.indexOf("y") > -1);
                !this.hasPointerCapture && s ? (t.push(o2(i, "pointerdown", (t)=>{
                    t.target?.hasPointerCapture(t.pointerId) && t.target?.releasePointerCapture(t.pointerId);
                }), o2(i, "pointermove", (t)=>{
                    e.pointer?.getPointFromEvent(t)?.onMouseOver(t);
                })), e.styledMode || o5(i, {
                    "touch-action": "none"
                }), i.className += " highcharts-no-touch-action", this.hasPointerCapture = !0) : this.hasPointerCapture && !s && (t.forEach((t)=>t()), t.length = 0, e.styledMode || o5(i, {
                    "touch-action": ri(e.options.chart.style?.["touch-action"], "manipulation")
                }), i.className = i.className.replace(" highcharts-no-touch-action", ""), this.hasPointerCapture = !1);
            }
            setHoverChartIndex(t) {
                let e = this.chart, i = w.charts[ri(rr.hoverChartIndex, -1)];
                if (i && i !== e) {
                    let s = {
                        relatedTarget: e.container
                    };
                    t && !t?.relatedTarget && Object.assign({}, t, s), i.pointer?.onContainerMouseLeave(t || s);
                }
                i?.mouseIsDown || (rr.hoverChartIndex = e.index);
            }
            touch(t, e) {
                let i, { chart: s, pinchDown: o = [] } = this;
                this.setHoverChartIndex(), 1 === (t = this.normalize(t)).touches.length ? s.isInsidePlot(t.chartX - s.plotLeft, t.chartY - s.plotTop, {
                    visiblePlotOnly: !0
                }) && !s.exporting?.openMenu ? (e && this.runPointActions(t), "touchmove" === t.type && (this.hasPinchMoved = i = !!o[0] && Math.pow(o[0].chartX - t.chartX, 2) + Math.pow(o[0].chartY - t.chartY, 2) >= 16), ri(i, !0) && this.pinch(t)) : e && this.reset() : 2 === t.touches.length && this.pinch(t);
            }
            touchSelect(t) {
                return !!(this.chart.zooming.singleTouch && t.touches && 1 === t.touches.length);
            }
            zoomOption(t) {
                let e = this.chart, i = e.inverted, s = e.zooming.type || "", o, r;
                /touch/.test(t.type) && (s = ri(e.zooming.pinchType, s)), this.zoomX = o = /x/.test(s), this.zoomY = r = /y/.test(s), this.zoomHor = o && !i || r && i, this.zoomVert = r && !i || o && i, this.hasZoom = o || r;
            }
        }
        rr.unbindDocumentMouseUp = [], function(t) {
            t.compose = function(e) {
                rs(o0, "Core.Pointer") && o2(e, "beforeRender", function() {
                    this.pointer = new t(this, this.options);
                });
            };
        }(rr || (rr = {}));
        let ra = rr;
        !function(t) {
            t.setLength = function(t, e, i) {
                return Array.isArray(t) ? (t.length = e, t) : t[i ? "subarray" : "slice"](0, e);
            }, t.splice = function(t, e, i, s, o = []) {
                if (Array.isArray(t)) return Array.isArray(o) || (o = Array.from(o)), {
                    removed: t.splice(e, i, ...o),
                    array: t
                };
                let r = Object.getPrototypeOf(t).constructor, a = t[s ? "subarray" : "slice"](e, e + i), n = new r(t.length - i + o.length);
                return n.set(t.subarray(0, e), 0), n.set(o, e), n.set(t.subarray(e + i), e + o.length), {
                    removed: a,
                    array: n
                };
            };
        }(d || (d = {}));
        let { setLength: rn, splice: rh } = d, { fireEvent: rl, objectEach: rd, uniqueKey: rc } = V, rp = class {
            constructor(t = {}){
                this.autoId = !t.id, this.columns = {}, this.id = t.id || rc(), this.modified = this, this.rowCount = 0, this.versionTag = rc();
                let e = 0;
                rd(t.columns || {}, (t, i)=>{
                    this.columns[i] = t.slice(), e = Math.max(e, t.length);
                }), this.applyRowCount(e);
            }
            applyRowCount(t) {
                this.rowCount = t, rd(this.columns, (e, i)=>{
                    e.length !== t && (this.columns[i] = rn(e, t));
                });
            }
            deleteRows(t, e = 1) {
                if (e > 0 && t < this.rowCount) {
                    let i = 0;
                    rd(this.columns, (s, o)=>{
                        this.columns[o] = rh(s, t, e).array, i = s.length;
                    }), this.rowCount = i;
                }
                rl(this, "afterDeleteRows", {
                    rowIndex: t,
                    rowCount: e
                }), this.versionTag = rc();
            }
            getColumn(t, e) {
                return this.columns[t];
            }
            getColumns(t, e) {
                return (t || Object.keys(this.columns)).reduce((t, e)=>(t[e] = this.columns[e], t), {});
            }
            getRow(t, e) {
                return (e || Object.keys(this.columns)).map((e)=>this.columns[e]?.[t]);
            }
            setColumn(t, e = [], i = 0, s) {
                this.setColumns({
                    [t]: e
                }, i, s);
            }
            setColumns(t, e, i) {
                let s = this.rowCount;
                rd(t, (t, e)=>{
                    this.columns[e] = t.slice(), s = t.length;
                }), this.applyRowCount(s), i?.silent || (rl(this, "afterSetColumns"), this.versionTag = rc());
            }
            setRow(t, e = this.rowCount, i, s) {
                let { columns: o } = this, r = i ? this.rowCount + 1 : e + 1;
                rd(t, (t, a)=>{
                    let n = o[a] || s?.addColumns !== !1 && Array(r);
                    n && (i ? n = rh(n, e, 0, !0, [
                        t
                    ]).array : n[e] = t, o[a] = n);
                }), r > this.rowCount && this.applyRowCount(r), s?.silent || (rl(this, "afterSetRows"), this.versionTag = rc());
            }
        }, { extend: rg, merge: ru, pick: rf } = V;
        !function(t) {
            function e(t, e, i) {
                let s = this.legendItem = this.legendItem || {}, { chart: o, options: r } = this, { baseline: a = 0, symbolWidth: n, symbolHeight: h } = t, l = this.symbol || "circle", d = h / 2, c = o.renderer, p = s.group, g = a - Math.round((t.fontMetrics?.b || h) * (i ? .4 : .3)), u = {}, f, m = r.marker, x = 0;
                if (o.styledMode || (u["stroke-width"] = Math.min(r.lineWidth || 0, 24), r.dashStyle ? u.dashstyle = r.dashStyle : "square" !== r.linecap && (u["stroke-linecap"] = "round")), s.line = c.path().addClass("highcharts-graph").attr(u).add(p), i && (s.area = c.path().addClass("highcharts-area").add(p)), u["stroke-linecap"] && (x = Math.min(s.line.strokeWidth(), n) / 2), n) {
                    let t = [
                        [
                            "M",
                            x,
                            g
                        ],
                        [
                            "L",
                            n - x,
                            g
                        ]
                    ];
                    s.line.attr({
                        d: t
                    }), s.area?.attr({
                        d: [
                            ...t,
                            [
                                "L",
                                n - x,
                                a
                            ],
                            [
                                "L",
                                x,
                                a
                            ]
                        ]
                    });
                }
                if (m && !1 !== m.enabled && n) {
                    let t = Math.min(rf(m.radius, d), d);
                    0 === l.indexOf("url") && (m = ru(m, {
                        width: h,
                        height: h
                    }), t = 0), s.symbol = f = c.symbol(l, n / 2 - t, g - t, 2 * t, 2 * t, rg({
                        context: "legend"
                    }, m)).addClass("highcharts-point").add(p), f.isMarker = !0;
                }
            }
            t.areaMarker = function(t, i) {
                e.call(this, t, i, !0);
            }, t.lineMarker = e, t.rectangle = function(t, e) {
                let i = e.legendItem || {}, s = t.options, o = t.symbolHeight, r = s.squareSymbol, a = r ? o : t.symbolWidth;
                i.symbol = this.chart.renderer.rect(r ? (t.symbolWidth - o) / 2 : 0, t.baseline - o + 1, a, o, rf(t.options.symbolRadius, o / 2)).addClass("highcharts-point").attr({
                    zIndex: 3
                }).add(i.group);
            };
        }(c || (c = {}));
        let rm = c, { defaultOptions: rx } = tv, { extend: ry, extendClass: rb, merge: rv } = V;
        !function(t) {
            function e(e, i) {
                let s = rx.plotOptions || {}, o = i.defaultOptions, r = i.prototype;
                return r.type = e, r.pointClass || (r.pointClass = oK), !t.seriesTypes[e] && (o && (s[e] = o), t.seriesTypes[e] = i, !0);
            }
            t.seriesTypes = w.seriesTypes, t.registerSeriesType = e, t.seriesType = function(i, s, o, r, a) {
                let n = rx.plotOptions || {};
                if (s = s || "", n[i] = rv(n[s], o), delete t.seriesTypes[i], e(i, rb(t.seriesTypes[s] || r1, r)), t.seriesTypes[i].prototype.type = i, a) {
                    class e extends oK {
                    }
                    ry(e.prototype, a), t.seriesTypes[i].prototype.pointClass = e;
                }
                return t.seriesTypes[i];
            };
        }(p || (p = {}));
        let rk = p, { animObject: rw, setAnimation: rM } = tU, { defaultOptions: rS } = tv, { registerEventOptions: rT } = si, { svg: rC, win: rA } = w, { seriesTypes: rP } = rk, { format: rL } = ep, { arrayMax: rO, arrayMin: rE, clamp: rI, correctFloat: rD, crisp: rB, defined: rN, destroyObjectProperties: rz, diffObjects: rR, erase: rW, error: rH, extend: rX, find: rF, fireEvent: rG, getClosestDistance: rj, getNestedProperty: rY, insertItem: rU, isArray: r$, isNumber: rV, isString: rZ, merge: r_, objectEach: rq, pick: rK, removeEvent: rJ, syncTimeout: rQ } = V;
        class r0 {
            constructor(){
                this.zoneAxis = "y";
            }
            init(t, e) {
                let i;
                rG(this, "init", {
                    options: e
                }), this.dataTable ?? (this.dataTable = new rp);
                let s = t.series;
                this.eventsToUnbind = [], this.chart = t, this.options = this.setOptions(e);
                let o = this.options, r = !1 !== o.visible;
                this.linkedSeries = [], this.bindAxes(), rX(this, {
                    name: o.name,
                    state: "",
                    visible: r,
                    selected: !0 === o.selected
                }), rT(this, o);
                let a = o.events;
                (a?.click || o.point?.events?.click || o.allowPointSelect) && (t.runTrackerClick = !0), this.getColor(), this.getSymbol(), this.isCartesian && (t.hasCartesianSeries = !0), s.length && (i = s[s.length - 1]), this._i = rK(i?._i, -1) + 1, this.opacity = this.options.opacity, t.orderItems("series", rU(this, s)), o.dataSorting?.enabled ? this.setDataSortingOptions() : this.points || this.data || this.setData(o.data, !1), rG(this, "afterInit");
            }
            is(t) {
                return rP[t] && this instanceof rP[t];
            }
            bindAxes() {
                let t, e = this, i = e.options, s = e.chart;
                rG(this, "bindAxes", null, function() {
                    (e.axisTypes || []).forEach(function(o) {
                        (s[o] || []).forEach(function(s) {
                            t = s.options, (rK(i[o], 0) === s.index || void 0 !== i[o] && i[o] === t.id) && (rU(e, s.series), e[o] = s, s.isDirty = !0);
                        }), e[o] || e.optionalAxis === o || rH(18, !0, s);
                    });
                }), rG(this, "afterBindAxes");
            }
            hasData() {
                return this.visible && void 0 !== this.dataMax && void 0 !== this.dataMin || this.visible && this.dataTable.rowCount > 0;
            }
            hasMarkerChanged(t, e) {
                let i = t.marker, s = e.marker || {};
                return i && (s.enabled && !i.enabled || s.symbol !== i.symbol || s.height !== i.height || s.width !== i.width);
            }
            autoIncrement(t) {
                let e, i = this.options, { pointIntervalUnit: s, relativeXValue: o } = this.options, r = this.chart.time, a = this.xIncrement ?? r.parse(i.pointStart) ?? 0;
                if (this.pointInterval = e = rK(this.pointInterval, i.pointInterval, 1), o && rV(t) && (e *= t), s) {
                    let t = r.toParts(a);
                    "day" === s ? t[2] += e : "month" === s ? t[1] += e : "year" === s && (t[0] += e), e = r.makeTime.apply(r, t) - a;
                }
                return o && rV(t) ? a + e : (this.xIncrement = a + e, a);
            }
            setDataSortingOptions() {
                let t = this.options;
                rX(this, {
                    requireSorting: !1,
                    sorted: !1,
                    enabledDataSorting: !0,
                    allowDG: !1
                }), rN(t.pointRange) || (t.pointRange = 1);
            }
            setOptions(t) {
                let e, i = this.chart, s = i.options.plotOptions, o = i.userOptions || {}, r = r_(t), a = i.styledMode, n = {
                    plotOptions: s,
                    userOptions: r
                };
                rG(this, "setOptions", n);
                let h = n.plotOptions[this.type], l = o.plotOptions || {}, d = l.series || {}, c = rS.plotOptions[this.type] || {}, p = l[this.type] || {};
                h.dataLabels = this.mergeArrays(c.dataLabels, h.dataLabels), this.userOptions = n.userOptions;
                let g = r_(h, s.series, p, r);
                this.tooltipOptions = r_(rS.tooltip, rS.plotOptions.series?.tooltip, c?.tooltip, i.userOptions.tooltip, l.series?.tooltip, p.tooltip, r.tooltip), this.stickyTracking = rK(r.stickyTracking, p.stickyTracking, d.stickyTracking, !!this.tooltipOptions.shared && !this.noSharedTooltip || g.stickyTracking), null === h.marker && delete g.marker, this.zoneAxis = g.zoneAxis || "y";
                let u = this.zones = (g.zones || []).map((t)=>({
                        ...t
                    }));
                return (g.negativeColor || g.negativeFillColor) && !g.zones && (e = {
                    value: g[this.zoneAxis + "Threshold"] || g.threshold || 0,
                    className: "highcharts-negative"
                }, a || (e.color = g.negativeColor, e.fillColor = g.negativeFillColor), u.push(e)), u.length && rN(u[u.length - 1].value) && u.push(a ? {} : {
                    color: this.color,
                    fillColor: this.fillColor
                }), rG(this, "afterSetOptions", {
                    options: g
                }), g;
            }
            getName() {
                return this.options.name ?? rL(this.chart.options.lang.seriesName, this, this.chart);
            }
            getCyclic(t, e, i) {
                let s, o, r = this.chart, a = `${t}Index`, n = `${t}Counter`, h = i?.length || r.options.chart.colorCount;
                !e && (rN(o = rK("color" === t ? this.options.colorIndex : void 0, this[a])) ? s = o : (r.series.length || (r[n] = 0), s = r[n] % h, r[n] += 1), i && (e = i[s])), void 0 !== s && (this[a] = s), this[t] = e;
            }
            getColor() {
                this.chart.styledMode ? this.getCyclic("color") : this.options.colorByPoint ? this.color = "#cccccc" : this.getCyclic("color", this.options.color || rS.plotOptions[this.type].color, this.chart.options.colors);
            }
            getPointsCollection() {
                return (this.hasGroupedData ? this.points : this.data) || [];
            }
            getSymbol() {
                let t = this.options.marker;
                this.getCyclic("symbol", t.symbol, this.chart.options.symbols);
            }
            getColumn(t, e) {
                return (e ? this.dataTable.modified : this.dataTable).getColumn(t, !0) || [];
            }
            findPointIndex(t, e) {
                let i, s, o, { id: r, x: a } = t, n = this.points, h = this.options.dataSorting, l = this.cropStart || 0;
                if (r) {
                    let t = this.chart.get(r);
                    t instanceof oK && (i = t);
                } else if (this.linkedParent || this.enabledDataSorting || this.options.relativeXValue) {
                    let e = (e)=>!e.touched && e.index === t.index;
                    if (h?.matchByName ? e = (e)=>!e.touched && e.name === t.name : this.options.relativeXValue && (e = (e)=>!e.touched && e.options.x === t.x), !(i = rF(n, e))) return;
                }
                return i && void 0 !== (o = i?.index) && (s = !0), void 0 === o && rV(a) && (o = this.getColumn("x").indexOf(a, e)), -1 !== o && void 0 !== o && this.cropped && (o = o >= l ? o - l : o), !s && rV(o) && n[o]?.touched && (o = void 0), o;
            }
            updateData(t, e) {
                let { options: i, requireSorting: s } = this, o = i.dataSorting, r = this.points, a = [], n = t.length === r.length, h, l, d, c, p = !0;
                if (this.xIncrement = null, t.forEach((t, e)=>{
                    let l, d = rN(t) && this.pointClass.prototype.optionsToObject.call({
                        series: this
                    }, t) || {}, { id: p, x: g } = d;
                    p || rV(g) ? (-1 === (l = this.findPointIndex(d, c)) || void 0 === l ? a.push(t) : r[l] && t !== i.data?.[l] ? (r[l].update(t, !1, void 0, !1), r[l].touched = !0, s && (c = l + 1)) : r[l] && (r[l].touched = !0), (!n || e !== l || o?.enabled || this.hasDerivedData) && (h = !0)) : a.push(t);
                }, this), h) for(l = r.length; l--;)(d = r[l]) && !d.touched && d.remove?.(!1, e);
                else n && !o?.enabled ? (t.forEach((t, e)=>{
                    t === r[e].y || r[e].destroyed || r[e].update(t, !1, void 0, !1);
                }), a.length = 0) : p = !1;
                if (r.forEach((t)=>{
                    t && (t.touched = !1);
                }), !p) return !1;
                a.forEach((t)=>{
                    this.addPoint(t, !1, void 0, void 0, !1);
                }, this);
                let g = this.getColumn("x");
                return null === this.xIncrement && g.length && (this.xIncrement = rO(g), this.autoIncrement()), !0;
            }
            dataColumnKeys() {
                return [
                    "x",
                    ...this.pointArrayMap || [
                        "y"
                    ]
                ];
            }
            setData(t, e = !0, i, s) {
                let o = this.points, r = o?.length || 0, a = this.options, n = this.chart, h = a.dataSorting, l = this.xAxis, d = a.turboThreshold, c = this.dataTable, p = this.dataColumnKeys(), g = this.pointValKey || "y", u = (this.pointArrayMap || []).length, f = a.keys, m, x, y = 0, b = 1, v;
                n.options.chart.allowMutatingData || (a.data && delete this.options.data, this.userOptions.data && delete this.userOptions.data, v = r_(!0, t));
                let k = (t = v || t || []).length;
                if (h?.enabled && (t = this.sortData(t)), n.options.chart.allowMutatingData && !1 !== s && k && r && !this.cropped && !this.hasGroupedData && this.visible && !this.boosted && (x = this.updateData(t, i)), !x) {
                    this.xIncrement = null, this.colorCounter = 0;
                    let e = d && !a.relativeXValue && k > d;
                    if (e) {
                        let i = this.getFirstValidPoint(t), s = this.getFirstValidPoint(t, k - 1, -1), o = (t)=>!!(r$(t) && (f || rV(t[0])));
                        if (rV(i) && rV(s)) {
                            let e = [], i = [];
                            for (let s of t)e.push(this.autoIncrement()), i.push(s);
                            c.setColumns({
                                x: e,
                                [g]: i
                            });
                        } else if (o(i) && o(s)) {
                            if (u) {
                                let e = +(i.length === u), s = Array(p.length).fill(0).map(()=>[]);
                                for (let i of t){
                                    e && s[0].push(this.autoIncrement());
                                    for(let t = e; t <= u; t++)s[t]?.push(i[t - e]);
                                }
                                c.setColumns(p.reduce((t, e, i)=>(t[e] = s[i], t), {}));
                            } else {
                                f && (y = f.indexOf("x"), b = f.indexOf("y"), y = y >= 0 ? y : 0, b = b >= 0 ? b : 1), 1 === i.length && (b = 0);
                                let e = [], s = [];
                                if (y === b) for (let i of t)e.push(this.autoIncrement()), s.push(i[b]);
                                else for (let i of t)e.push(i[y]), s.push(i[b]);
                                c.setColumns({
                                    x: e,
                                    [g]: s
                                });
                            }
                        } else e = !1;
                    }
                    if (!e) {
                        let e = p.reduce((t, e)=>(t[e] = [], t), {});
                        for(m = 0; m < k; m++){
                            let i = this.pointClass.prototype.applyOptions.apply({
                                series: this
                            }, [
                                t[m]
                            ]);
                            for (let t of p)e[t][m] = i[t];
                        }
                        c.setColumns(e);
                    }
                    for(rZ(this.getColumn("y")[0]) && rH(14, !0, n), this.data = [], this.options.data = this.userOptions.data = t, m = r; m--;)o[m]?.destroy();
                    l && (l.minRange = l.userMinRange), this.isDirty = n.isDirtyBox = !0, this.isDirtyData = !!o, i = !1;
                }
                "point" === a.legendType && (this.processData(), this.generatePoints()), e && n.redraw(i);
            }
            sortData(t) {
                let e = this, i = e.options.dataSorting.sortKey || "y", s = function(t, e) {
                    return rN(e) && t.pointClass.prototype.optionsToObject.call({
                        series: t
                    }, e) || {};
                };
                return t.forEach(function(i, o) {
                    t[o] = s(e, i), t[o].index = o;
                }, this), t.concat().sort((t, e)=>{
                    let s = rY(i, t), o = rY(i, e);
                    return o < s ? -1 : +(o > s);
                }).forEach(function(t, e) {
                    t.x = e;
                }, this), e.linkedSeries && e.linkedSeries.forEach(function(e) {
                    let i = e.options, o = i.data;
                    !i.dataSorting?.enabled && o && (o.forEach(function(i, r) {
                        o[r] = s(e, i), t[r] && (o[r].x = t[r].x, o[r].index = r);
                    }), e.setData(o, !1));
                }), t;
            }
            getProcessedData(t) {
                let e = this, { dataTable: i, isCartesian: s, options: o, xAxis: r } = e, a = o.cropThreshold, n = t || e.getExtremesFromAll, h = r?.logarithmic, l = i.rowCount, d, c, p = 0, g, u, f, m = e.getColumn("x"), x = i, y = !1;
                return r && (u = (g = r.getExtremes()).min, f = g.max, y = !!(r.categories && !r.names.length), s && e.sorted && !n && (!a || l > a || e.forceCrop) && (m[l - 1] < u || m[0] > f ? x = new rp : e.getColumn(e.pointValKey || "y").length && (m[0] < u || m[l - 1] > f) && (x = (d = this.cropData(i, u, f)).modified, p = d.start, c = !0))), m = x.getColumn("x") || [], {
                    modified: x,
                    cropped: c,
                    cropStart: p,
                    closestPointRange: rj([
                        h ? m.map(h.log2lin) : m
                    ], ()=>e.requireSorting && !y && rH(15, !1, e.chart))
                };
            }
            processData(t) {
                let e = this.xAxis, i = this.dataTable;
                if (this.isCartesian && !this.isDirty && !e.isDirty && !this.yAxis.isDirty && !t) return !1;
                let s = this.getProcessedData();
                i.modified = s.modified, this.cropped = s.cropped, this.cropStart = s.cropStart, this.closestPointRange = this.basePointRange = s.closestPointRange, rG(this, "afterProcessData");
            }
            cropData(t, e, i) {
                let s = t.getColumn("x", !0) || [], o = s.length, r = {}, a, n, h = 0, l = o;
                for(a = 0; a < o; a++)if (s[a] >= e) {
                    h = Math.max(0, a - 1);
                    break;
                }
                for(n = a; n < o; n++)if (s[n] > i) {
                    l = n + 1;
                    break;
                }
                for (let e of this.dataColumnKeys()){
                    let i = t.getColumn(e, !0);
                    i && (r[e] = i.slice(h, l));
                }
                return {
                    modified: new rp({
                        columns: r
                    }),
                    start: h,
                    end: l
                };
            }
            generatePoints() {
                let t = this.options, e = this.processedData || t.data, i = this.dataTable.modified, s = this.getColumn("x", !0), o = this.pointClass, r = i.rowCount, a = this.cropStart || 0, n = this.hasGroupedData, h = t.keys, l = [], d = t.dataGrouping?.groupAll ? a : 0, c = this.xAxis?.categories, p = this.pointArrayMap || [
                    "y"
                ], g = this.dataColumnKeys(), u, f, m, x, y = this.data, b;
                if (!y && !n) {
                    let t = [];
                    t.length = e?.length || 0, y = this.data = t;
                }
                for(h && n && (this.options.keys = !1), x = 0; x < r; x++)f = a + x, n ? ((m = new o(this, i.getRow(x, g) || [])).dataGroup = this.groupMap[d + x], m.dataGroup?.options && (m.options = m.dataGroup.options, rX(m, m.dataGroup.options), delete m.dataLabels)) : (m = y[f], b = e ? e[f] : i.getRow(x, p), m || void 0 === b || (y[f] = m = new o(this, b, s[x]))), m && (m.index = n ? d + x : f, l[x] = m, m.category = c?.[m.x] ?? m.x, m.key = m.name ?? m.category);
                if (this.options.keys = h, y && (r !== (u = y.length) || n)) for(x = 0; x < u; x++)x !== a || n || (x += r), y[x] && (y[x].destroyElements(), y[x].plotX = void 0);
                this.data = y, this.points = l, rG(this, "afterGeneratePoints");
            }
            getXExtremes(t) {
                return {
                    min: rE(t),
                    max: rO(t)
                };
            }
            getExtremes(t, e) {
                let { xAxis: i, yAxis: s } = this, o = e || this.getExtremesFromAll || this.options.getExtremesFromAll, r = o && this.cropped ? this.dataTable : this.dataTable.modified, a = r.rowCount, n = t || this.stackedYData, h = n ? [
                    n
                ] : (this.keysAffectYAxis || this.pointArrayMap || [
                    "y"
                ])?.map((t)=>r.getColumn(t, !0) || []) || [], l = this.getColumn("x", !0), d = [], c = this.requireSorting && !this.is("column") ? 1 : 0, p = !!s && s.positiveValuesOnly, g = o || this.cropped || !i, u, f, m, x = 0, y = 0;
                for(i && (x = (u = i.getExtremes()).min, y = u.max), m = 0; m < a; m++)if (f = l[m], g || (l[m + c] || f) >= x && (l[m - c] || f) <= y) for (let t of h){
                    let e = t[m];
                    rV(e) && (e > 0 || !p) && d.push(e);
                }
                let b = {
                    activeYData: d,
                    dataMin: rE(d),
                    dataMax: rO(d)
                };
                return rG(this, "afterGetExtremes", {
                    dataExtremes: b
                }), b;
            }
            applyExtremes() {
                let t = this.getExtremes();
                return this.dataMin = t.dataMin, this.dataMax = t.dataMax, t;
            }
            getFirstValidPoint(t, e = 0, i = 1) {
                let s = t.length, o = e;
                for(; o >= 0 && o < s;){
                    if (rN(t[o])) return t[o];
                    o += i;
                }
            }
            translate() {
                this.generatePoints();
                let t = this.options, e = t.stacking, i = this.xAxis, s = this.enabledDataSorting, o = this.yAxis, r = this.points, a = r.length, n = this.pointPlacementToXValue(), h = !!n, l = t.threshold, d = t.startFromThreshold ? l : 0, c = t?.nullInteraction && o.len, p, g, u, f, m = Number.MAX_VALUE;
                function x(t) {
                    return rI(t, -1000000000, 1e9);
                }
                for(p = 0; p < a; p++){
                    let t, a = r[p], y = a.x, b, v, k = a.y, w = a.low, M = e && o.stacking?.stacks[(this.negStacks && k < (d ? 0 : l) ? "-" : "") + this.stackKey];
                    a.plotX = rV(g = i.translate(y, !1, !1, !1, !0, n)) ? rD(x(g)) : void 0, e && this.visible && M && M[y] && (f = this.getStackIndicator(f, y, this.index), !a.isNull && f.key && (v = (b = M[y]).points[f.key]), b && r$(v) && (w = v[0], k = v[1], w === d && f.key === M[y].base && (w = rK(rV(l) ? l : o.min)), o.positiveValuesOnly && rN(w) && w <= 0 && (w = void 0), a.total = a.stackTotal = rK(b.total), a.percentage = rN(a.y) && b.total ? a.y / b.total * 100 : void 0, a.stackY = k, this.irregularWidths || b.setOffset(this.pointXOffset || 0, this.barW || 0, void 0, void 0, void 0, this.xAxis))), a.yBottom = rN(w) ? x(o.translate(w, !1, !0, !1, !0)) : void 0, this.dataModify && (k = this.dataModify.modifyValue(k, p)), rV(k) && void 0 !== a.plotX ? t = rV(t = o.translate(k, !1, !0, !1, !0)) ? x(t) : void 0 : !rV(k) && c && (t = c), a.plotY = t, a.isInside = this.isPointInside(a), a.clientX = h ? rD(i.translate(y, !1, !1, !1, !0, n)) : g, a.negative = (a.y || 0) < (l || 0), a.isNull || !1 === a.visible || (void 0 !== u && (m = Math.min(m, Math.abs(g - u))), u = g), a.zone = this.zones.length ? a.getZone() : void 0, !a.graphic && this.group && s && (a.isNew = !0);
                }
                this.closestPointRangePx = m, rG(this, "afterTranslate");
            }
            getValidPoints(t, e, i) {
                let s = this.chart;
                return (t || this.points || []).filter(function(t) {
                    let { plotX: o, plotY: r } = t;
                    return (!!i || !t.isNull && !!rV(r)) && (!e || !!s.isInsidePlot(o, r, {
                        inverted: s.inverted
                    })) && !1 !== t.visible;
                });
            }
            getSharedClipKey() {
                return this.sharedClipKey = (this.options.xAxis || 0) + "," + (this.options.yAxis || 0), this.sharedClipKey;
            }
            setClip() {
                let { chart: t, group: e, markerGroup: i } = this, s = t.sharedClips, o = t.renderer, r = t.getClipBox(this), a = this.getSharedClipKey(), n = s[a];
                n ? n.animate(r) : s[a] = n = o.clipRect(r), e && e.clip(!1 === this.options.clip ? void 0 : n), i && i.clip();
            }
            animate(t) {
                let { chart: e, group: i, markerGroup: s } = this, o = e.inverted, r = rw(this.options.animation), a = [
                    this.getSharedClipKey(),
                    r.duration,
                    r.easing,
                    r.defer
                ].join(","), n = e.sharedClips[a], h = e.sharedClips[a + "m"];
                if (t && i) {
                    let t = e.getClipBox(this);
                    if (n) n.attr("height", t.height);
                    else {
                        t.width = 0, o && (t.x = e.plotHeight), n = e.renderer.clipRect(t), e.sharedClips[a] = n;
                        let i = {
                            x: -99,
                            y: -99,
                            width: o ? e.plotWidth + 199 : 99,
                            height: o ? 99 : e.plotHeight + 199
                        };
                        h = e.renderer.clipRect(i), e.sharedClips[a + "m"] = h;
                    }
                    i.clip(n), s?.clip(h);
                } else if (n && !n.hasClass("highcharts-animating")) {
                    let t = e.getClipBox(this), i = r.step;
                    (s?.element.childNodes.length || e.series.length > 1) && (r.step = function(t, e) {
                        i && i.apply(e, arguments), "width" === e.prop && h?.element && h.attr(o ? "height" : "width", t + 99);
                    }), n.addClass("highcharts-animating").animate(t, r);
                }
            }
            afterAnimate() {
                this.setClip(), rq(this.chart.sharedClips, (t, e, i)=>{
                    t && !this.chart.container.querySelector(`[clip-path="url(#${t.id})"]`) && (t.destroy(), delete i[e]);
                }), this.finishedAnimating = !0, rG(this, "afterAnimate");
            }
            drawPoints(t = this.points) {
                let e, i, s, o, r, a, n, h = this.chart, l = h.styledMode, { colorAxis: d, options: c } = this, p = c.marker, g = c.nullInteraction, u = this[this.specialGroup || "markerGroup"], f = this.xAxis, m = rK(p.enabled, !f || !!f.isRadial || null, this.closestPointRangePx >= p.enabledThreshold * p.radius);
                if (!1 !== p.enabled || this._hasPointMarkers) for(e = 0; e < t.length; e++){
                    o = (s = (i = t[e]).graphic) ? "animate" : "attr", r = i.marker || {}, a = !!i.marker;
                    let c = i.isNull;
                    if ((m && !rN(r.enabled) || r.enabled) && (!c || g) && !1 !== i.visible) {
                        let t = rK(r.symbol, this.symbol, "rect");
                        n = this.markerAttribs(i, i.selected && "select"), this.enabledDataSorting && (i.startXPos = f.reversed ? -(n.width || 0) : f.width);
                        let e = !1 !== i.isInside;
                        if (!s && e && ((n.width || 0) > 0 || i.hasImage) && (i.graphic = s = h.renderer.symbol(t, n.x, n.y, n.width, n.height, a ? r : p).add(u), this.enabledDataSorting && h.hasRendered && (s.attr({
                            x: i.startXPos
                        }), o = "animate")), s && "animate" === o && s[e ? "show" : "hide"](e).animate(n), s) {
                            let t = this.pointAttribs(i, l || !i.selected ? void 0 : "select");
                            l ? d && s.css({
                                fill: t.fill
                            }) : s[o](t);
                        }
                        s && s.addClass(i.getClassName(), !0);
                    } else s && (i.graphic = s.destroy());
                }
            }
            markerAttribs(t, e) {
                let i = this.options, s = i.marker, o = t.marker || {}, r = o.symbol || s.symbol, a = {}, n, h, l = rK(o.radius, s?.radius);
                e && (n = s.states[e], h = o.states && o.states[e], l = rK(h?.radius, n?.radius, l && l + (n?.radiusPlus || 0))), t.hasImage = r && 0 === r.indexOf("url"), t.hasImage && (l = 0);
                let d = t.pos();
                return rV(l) && d && (i.crisp && (d[0] = rB(d[0], t.hasImage ? 0 : "rect" === r ? s?.lineWidth || 0 : 1)), a.x = d[0] - l, a.y = d[1] - l), l && (a.width = a.height = 2 * l), a;
            }
            pointAttribs(t, e) {
                let i = this.options, s = i.marker, o = t?.options, r = o?.marker || {}, a = o?.color, n = t?.color, h = t?.zone?.color, l, d, c = this.color, p, g, u = rK(r.lineWidth, s.lineWidth), f = t?.isNull && i.nullInteraction ? 0 : 1;
                return c = a || h || n || c, p = r.fillColor || s.fillColor || c, g = r.lineColor || s.lineColor || c, e = e || "normal", l = s.states[e] || {}, u = rK((d = r.states && r.states[e] || {}).lineWidth, l.lineWidth, u + rK(d.lineWidthPlus, l.lineWidthPlus, 0)), p = d.fillColor || l.fillColor || p, g = d.lineColor || l.lineColor || g, {
                    stroke: g,
                    "stroke-width": u,
                    fill: p,
                    opacity: f = rK(d.opacity, l.opacity, f)
                };
            }
            destroy(t) {
                let e, i, s = this, o = s.chart, r = /AppleWebKit\/533/.test(rA.navigator.userAgent), a = s.data || [];
                for(rG(s, "destroy", {
                    keepEventsForUpdate: t
                }), this.removeEvents(t), (s.axisTypes || []).forEach(function(t) {
                    i = s[t], i?.series && (rW(i.series, s), i.isDirty = i.forceRedraw = !0);
                }), s.legendItem && s.chart.legend.destroyItem(s), e = a.length; e--;)a[e]?.destroy?.();
                for (let t of s.zones)rz(t, void 0, !0);
                V.clearTimeout(s.animationTimeout), rq(s, function(t, e) {
                    t instanceof eJ && !t.survive && t[r && "group" === e ? "hide" : "destroy"]();
                }), o.hoverSeries === s && (o.hoverSeries = void 0), rW(o.series, s), o.orderItems("series"), rq(s, function(e, i) {
                    t && "hcEvents" === i || delete s[i];
                });
            }
            applyZones() {
                let { area: t, chart: e, graph: i, zones: s, points: o, xAxis: r, yAxis: a, zoneAxis: n } = this, { inverted: h, renderer: l } = e, d = this[`${n}Axis`], { isXAxis: c, len: p = 0, minPointOffset: g = 0 } = d || {}, u = (i?.strokeWidth() || 0) / 2 + 1, f = (t, e = 0, i = 0)=>{
                    h && (i = p - i);
                    let { translated: s = 0, lineClip: o } = t, r = i - s;
                    o?.push([
                        "L",
                        e,
                        Math.abs(r) < u ? i - u * (r <= 0 ? -1 : 1) : s
                    ]);
                };
                if (s.length && (i || t) && d && rV(d.min)) {
                    let e = d.getExtremes().max + g, u = (t)=>{
                        t.forEach((e, i)=>{
                            ("M" === e[0] || "L" === e[0]) && (t[i] = [
                                e[0],
                                c ? p - e[1] : e[1],
                                c ? e[2] : p - e[2]
                            ]);
                        });
                    };
                    if (s.forEach((t)=>{
                        t.lineClip = [], t.translated = rI(d.toPixels(rK(t.value, e), !0) || 0, 0, p);
                    }), i && !this.showLine && i.hide(), t && t.hide(), "y" === n && o.length < r.len) for (let t of o){
                        let { plotX: e, plotY: i, zone: o } = t, r = o && s[s.indexOf(o) - 1];
                        o && f(o, e, i), r && f(r, e, i);
                    }
                    let m = [], x = d.toPixels(d.getExtremes().min - g, !0);
                    s.forEach((e)=>{
                        let s = e.lineClip || [], o = Math.round(e.translated || 0);
                        r.reversed && s.reverse();
                        let { clip: n, simpleClip: d } = e, p = 0, g = 0, f = r.len, y = a.len;
                        c ? (p = o, f = x) : (g = o, y = x);
                        let b = [
                            [
                                "M",
                                p,
                                g
                            ],
                            [
                                "L",
                                f,
                                g
                            ],
                            [
                                "L",
                                f,
                                y
                            ],
                            [
                                "L",
                                p,
                                y
                            ],
                            [
                                "Z"
                            ]
                        ], v = [
                            b[0],
                            ...s,
                            b[1],
                            b[2],
                            ...m,
                            b[3],
                            b[4]
                        ];
                        m = s.reverse(), x = o, h && (u(v), t && u(b)), n ? (n.animate({
                            d: v
                        }), d?.animate({
                            d: b
                        })) : (n = e.clip = l.path(v), t && (d = e.simpleClip = l.path(b))), i && e.graph?.clip(n), t && e.area?.clip(d);
                    });
                } else this.visible && (i && i.show(), t && t.show());
            }
            plotGroup(t, e, i, s, o) {
                let r = this[t], a = !r, n = {
                    visibility: i,
                    zIndex: s || .1
                };
                return rN(this.opacity) && !this.chart.styledMode && "inactive" !== this.state && (n.opacity = this.opacity), r || (this[t] = r = this.chart.renderer.g().add(o)), r.addClass("highcharts-" + e + " highcharts-series-" + this.index + " highcharts-" + this.type + "-series " + (rN(this.colorIndex) ? "highcharts-color-" + this.colorIndex + " " : "") + (this.options.className || "") + (r.hasClass("highcharts-tracker") ? " highcharts-tracker" : ""), !0), r.attr(n)[a ? "attr" : "animate"](this.getPlotBox(e)), r;
            }
            getPlotBox(t) {
                let e = this.xAxis, i = this.yAxis, s = this.chart, o = s.inverted && !s.polar && e && this.invertible && "series" === t;
                s.inverted && (e = i, i = this.xAxis);
                let r = {
                    scale: 1,
                    translateX: e ? e.left : s.plotLeft,
                    translateY: i ? i.top : s.plotTop,
                    name: t
                };
                rG(this, "getPlotBox", r);
                let { scale: a, translateX: n, translateY: h } = r;
                return {
                    translateX: n,
                    translateY: h,
                    rotation: 90 * !!o,
                    rotationOriginX: o ? a * (e.len - i.len) / 2 : 0,
                    rotationOriginY: o ? a * (e.len + i.len) / 2 : 0,
                    scaleX: o ? -a : a,
                    scaleY: a
                };
            }
            removeEvents(t) {
                let { eventsToUnbind: e } = this;
                t || rJ(this), e.length && (e.forEach((t)=>{
                    t();
                }), e.length = 0);
            }
            render() {
                let t = this, { chart: e, options: i, hasRendered: s } = t, o = rw(i.animation), r = t.visible ? "inherit" : "hidden", a = i.zIndex, n = e.seriesGroup, h = t.finishedAnimating ? 0 : o.duration;
                rG(this, "render"), t.plotGroup("group", "series", r, a, n), t.markerGroup = t.plotGroup("markerGroup", "markers", r, a, n), !1 !== i.clip && t.setClip(), h && t.animate?.(!0), t.drawGraph && (t.drawGraph(), t.applyZones()), t.visible && t.drawPoints(), t.drawDataLabels?.(), t.redrawPoints?.(), i.enableMouseTracking && t.drawTracker?.(), h && t.animate?.(), s || (h && o.defer && (h += o.defer), t.animationTimeout = rQ(()=>{
                    t.afterAnimate();
                }, h || 0)), t.isDirty = !1, t.hasRendered = !0, rG(t, "afterRender");
            }
            redraw() {
                let t = this.isDirty || this.isDirtyData;
                this.translate(), this.render(), t && delete this.kdTree;
            }
            reserveSpace() {
                return this.visible || !this.chart.options.chart.ignoreHiddenSeries;
            }
            searchPoint(t, e) {
                let { xAxis: i, yAxis: s } = this, o = this.chart.inverted;
                return this.searchKDTree({
                    clientX: o ? i.len - t.chartY + i.pos : t.chartX - i.pos,
                    plotY: o ? s.len - t.chartX + s.pos : t.chartY - s.pos
                }, e, t);
            }
            buildKDTree(t) {
                this.buildingKdTree = !0;
                let e = this, i = e.options, s = i.findNearestPointBy.indexOf("y") > -1 ? 2 : 1;
                delete e.kdTree, rQ(function() {
                    e.kdTree = function t(i, s, o) {
                        let r, a, n = i?.length;
                        if (n) return r = e.kdAxisArray[s % o], i.sort((t, e)=>(t[r] || 0) - (e[r] || 0)), {
                            point: i[a = Math.floor(n / 2)],
                            left: t(i.slice(0, a), s + 1, o),
                            right: t(i.slice(a + 1), s + 1, o)
                        };
                    }(e.getValidPoints(void 0, !e.directTouch, i?.nullInteraction), s, s), e.buildingKdTree = !1;
                }, i.kdNow || t?.type === "touchstart" ? 0 : 1);
            }
            searchKDTree(t, e, i, s, o) {
                let r = this, [a, n] = this.kdAxisArray, h = e ? "distX" : "dist", l = (r.options.findNearestPointBy || "").indexOf("y") > -1 ? 2 : 1, d = !!r.isBubble, c = s || ((t, e, i)=>{
                    let s = t[i] || 0, o = e[i] || 0;
                    return [
                        s === o && t.index > e.index || s < o ? t : e,
                        !1
                    ];
                }), p = o || ((t, e)=>t < e);
                if (this.kdTree || this.buildingKdTree || this.buildKDTree(i), this.kdTree) return function t(e, i, s, o) {
                    let l = i.point, g = r.kdAxisArray[s % o], u = l, f = !1;
                    !function(t, e) {
                        let i = t[a], s = e[a], o = rN(i) && rN(s) ? i - s : null, r = t[n], h = e[n], l = rN(r) && rN(h) ? r - h : 0, c = d && e.marker?.radius || 0;
                        e.dist = Math.sqrt((o && o * o || 0) + l * l) - c, e.distX = rN(o) ? Math.abs(o) - c : Number.MAX_VALUE;
                    }(e, l);
                    let m = (e[g] || 0) - (l[g] || 0) + (d && l.marker?.radius || 0), x = m < 0 ? "left" : "right", y = m < 0 ? "right" : "left";
                    return i[x] && ([u, f] = c(l, t(e, i[x], s + 1, o), h)), i[y] && p(Math.sqrt(m * m), u[h], f) && (u = c(u, t(e, i[y], s + 1, o), h)[0]), u;
                }(t, this.kdTree, l, l);
            }
            pointPlacementToXValue() {
                let { options: t, xAxis: e } = this, i = t.pointPlacement;
                return "between" === i && (i = e.reversed ? -0.5 : .5), rV(i) ? i * (t.pointRange || e.pointRange) : 0;
            }
            isPointInside(t) {
                let { chart: e, xAxis: i, yAxis: s } = this, { plotX: o = -1, plotY: r = -1 } = t;
                return r >= 0 && r <= (s ? s.len : e.plotHeight) && o >= 0 && o <= (i ? i.len : e.plotWidth);
            }
            drawTracker() {
                let t = this, e = t.options, i = e.trackByArea, s = [].concat((i ? t.areaPath : t.graphPath) || []), o = t.chart, r = o.pointer, a = o.renderer, n = o.options.tooltip?.snap || 0, h = ()=>{
                    e.enableMouseTracking && o.hoverSeries !== t && t.onMouseOver();
                }, l = "rgba(192,192,192," + (rC ? 1e-4 : .002) + ")", d = t.tracker;
                d ? d.attr({
                    d: s
                }) : t.graph && (t.tracker = d = a.path(s).attr({
                    visibility: t.visible ? "inherit" : "hidden",
                    zIndex: 2
                }).addClass(i ? "highcharts-tracker-area" : "highcharts-tracker-line").add(t.group), o.styledMode || d.attr({
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    stroke: l,
                    fill: i ? l : "none",
                    "stroke-width": t.graph.strokeWidth() + (i ? 0 : 2 * n)
                }), [
                    t.tracker,
                    t.markerGroup,
                    t.dataLabelsGroup
                ].forEach((t)=>{
                    t && (t.addClass("highcharts-tracker").on("mouseover", h).on("mouseout", (t)=>{
                        r?.onTrackerMouseOut(t);
                    }), e.cursor && !o.styledMode && t.css({
                        cursor: e.cursor
                    }), t.on("touchstart", h));
                })), rG(this, "afterDrawTracker");
            }
            addPoint(t, e, i, s, o) {
                let r, a, n = this.options, { chart: h, data: l, dataTable: d, xAxis: c } = this, p = c?.hasNames && c.names, g = n.data, u = this.getColumn("x");
                e = rK(e, !0);
                let f = {
                    series: this
                };
                this.pointClass.prototype.applyOptions.apply(f, [
                    t
                ]);
                let m = f.x;
                if (a = u.length, this.requireSorting && m < u[a - 1]) for(r = !0; a && u[a - 1] > m;)a--;
                d.setRow(f, a, !0, {
                    addColumns: !1
                }), p && f.name && (p[m] = f.name), g?.splice(a, 0, t), (r || this.processedData) && (this.data.splice(a, 0, null), this.processData()), "point" === n.legendType && this.generatePoints(), i && (l[0] && l[0].remove ? l[0].remove(!1) : ([
                    l,
                    g
                ].filter(rN).forEach((t)=>{
                    t.shift();
                }), d.deleteRows(0))), !1 !== o && rG(this, "addPoint", {
                    point: f
                }), this.isDirty = !0, this.isDirtyData = !0, e && h.redraw(s);
            }
            removePoint(t, e, i) {
                let s = this, { chart: o, data: r, points: a, dataTable: n } = s, h = r[t], l = function() {
                    [
                        a?.length === r.length ? a : void 0,
                        r,
                        s.options.data
                    ].filter(rN).forEach((e)=>{
                        e.splice(t, 1);
                    }), n.deleteRows(t), h?.destroy(), s.isDirty = !0, s.isDirtyData = !0, e && o.redraw();
                };
                rM(i, o), e = rK(e, !0), h ? h.firePointEvent("remove", null, l) : l();
            }
            remove(t, e, i, s) {
                let o = this, r = o.chart;
                function a() {
                    o.destroy(s), r.isDirtyLegend = r.isDirtyBox = !0, r.linkSeries(s), rK(t, !0) && r.redraw(e);
                }
                !1 !== i ? rG(o, "remove", null, a) : a();
            }
            update(t, e) {
                rG(this, "update", {
                    options: t = rR(t, this.userOptions)
                });
                let i = this, s = i.chart, o = i.userOptions, r = i.initialType || i.type, a = s.options.plotOptions, n = rP[r].prototype, h = i.finishedAnimating && {
                    animation: !1
                }, l = {}, d, c, p = r0.keepProps.slice(), g = t.type || o.type || s.options.chart.type, u = !(this.hasDerivedData || g && g !== this.type || void 0 !== t.keys || void 0 !== t.pointStart || void 0 !== t.pointInterval || void 0 !== t.relativeXValue || t.joinBy || t.mapData || [
                    "dataGrouping",
                    "pointStart",
                    "pointInterval",
                    "pointIntervalUnit",
                    "keys"
                ].some((t)=>i.hasOptionChanged(t)));
                g = g || r, u ? (p.push.apply(p, r0.keepPropsForPoints), !1 !== t.visible && p.push("area", "graph"), i.parallelArrays.forEach(function(t) {
                    p.push(t + "Data");
                }), t.data && (t.dataSorting && rX(i.options.dataSorting, t.dataSorting), this.setData(t.data, !1))) : this.dataTable.modified = this.dataTable, t = r_(o, {
                    index: void 0 === o.index ? i.index : o.index,
                    pointStart: a?.series?.pointStart ?? o.pointStart ?? i.getColumn("x")[0]
                }, !u && {
                    data: i.options.data
                }, t, h), u && t.data && (t.data = i.options.data), (p = [
                    "group",
                    "markerGroup",
                    "dataLabelsGroup",
                    "transformGroup"
                ].concat(p)).forEach(function(t) {
                    p[t] = i[t], delete i[t];
                });
                let f = !1;
                if (rP[g]) {
                    if (f = g !== i.type, i.remove(!1, !1, !1, !0), f) {
                        if (s.propFromSeries(), Object.setPrototypeOf) Object.setPrototypeOf(i, rP[g].prototype);
                        else {
                            let t = Object.hasOwnProperty.call(i, "hcEvents") && i.hcEvents;
                            for(c in n)i[c] = void 0;
                            rX(i, rP[g].prototype), t ? i.hcEvents = t : delete i.hcEvents;
                        }
                    }
                } else rH(17, !0, s, {
                    missingModuleFor: g
                });
                if (p.forEach(function(t) {
                    i[t] = p[t];
                }), i.init(s, t), u && this.points) for (let t of (!1 === (d = i.options).visible ? (l.graphic = 1, l.dataLabel = 1) : (this.hasMarkerChanged(d, o) && (l.graphic = 1), i.hasDataLabels?.() || (l.dataLabel = 1)), this.points))t?.series && (t.resolveColor(), Object.keys(l).length && t.destroyElements(l), !1 === d.showInLegend && t.legendItem && s.legend.destroyItem(t));
                i.initialType = r, s.linkSeries(), s.setSortedData(), f && i.linkedSeries.length && (i.isDirtyData = !0), rG(this, "afterUpdate"), rK(e, !0) && s.redraw(!!u && void 0);
            }
            setName(t) {
                this.name = this.options.name = this.userOptions.name = t, this.chart.isDirtyLegend = !0;
            }
            hasOptionChanged(t) {
                let e = this.chart, i = this.options[t], s = e.options.plotOptions, o = this.userOptions[t], r = rK(s?.[this.type]?.[t], s?.series?.[t]);
                return o && !rN(r) ? i !== o : i !== rK(r, i);
            }
            onMouseOver() {
                let t = this.chart, e = t.hoverSeries, i = t.pointer;
                i?.setHoverChartIndex(), e && e !== this && e.onMouseOut(), this.options.events.mouseOver && rG(this, "mouseOver"), this.setState("hover"), t.hoverSeries = this;
            }
            onMouseOut() {
                let t = this.options, e = this.chart, i = e.tooltip, s = e.hoverPoint;
                e.hoverSeries = null, s && s.onMouseOut(), this && t.events.mouseOut && rG(this, "mouseOut"), i && !this.stickyTracking && (!i.shared || this.noSharedTooltip) && i.hide(), e.series.forEach(function(t) {
                    t.setState("", !0);
                });
            }
            setState(t, e) {
                let i = this, s = i.options, o = i.graph, r = s.inactiveOtherPoints, a = s.states, n = rK(a[t || "normal"] && a[t || "normal"].animation, i.chart.options.chart.animation), h = s.lineWidth, l = s.opacity;
                if (t = t || "", i.state !== t && ([
                    i.group,
                    i.markerGroup,
                    i.dataLabelsGroup
                ].forEach(function(e) {
                    e && (i.state && e.removeClass("highcharts-series-" + i.state), t && e.addClass("highcharts-series-" + t));
                }), i.state = t, !i.chart.styledMode)) {
                    if (a[t] && !1 === a[t].enabled) return;
                    if (t && (h = a[t].lineWidth || h + (a[t].lineWidthPlus || 0), l = rK(a[t].opacity, l)), o && !o.dashstyle && rV(h)) for (let t of [
                        o,
                        ...this.zones.map((t)=>t.graph)
                    ])t?.animate({
                        "stroke-width": h
                    }, n);
                    r || [
                        i.group,
                        i.markerGroup,
                        i.dataLabelsGroup,
                        i.labelBySeries
                    ].forEach(function(t) {
                        t && t.animate({
                            opacity: l
                        }, n);
                    });
                }
                e && r && i.points && i.setAllPointsToState(t || void 0);
            }
            setAllPointsToState(t) {
                this.points.forEach(function(e) {
                    e.setState && e.setState(t);
                });
            }
            setVisible(t, e) {
                let i = this, s = i.chart, o = s.options.chart.ignoreHiddenSeries, r = i.visible;
                i.visible = t = i.options.visible = i.userOptions.visible = void 0 === t ? !r : t;
                let a = t ? "show" : "hide";
                [
                    "group",
                    "dataLabelsGroup",
                    "markerGroup",
                    "tracker",
                    "tt"
                ].forEach((t)=>{
                    i[t]?.[a]();
                }), (s.hoverSeries === i || s.hoverPoint?.series === i) && i.onMouseOut(), i.legendItem && s.legend.colorizeItem(i, t), i.isDirty = !0, i.options.stacking && s.series.forEach((t)=>{
                    t.options.stacking && t.visible && (t.isDirty = !0);
                }), i.linkedSeries.forEach((e)=>{
                    e.setVisible(t, !1);
                }), o && (s.isDirtyBox = !0), rG(i, a), !1 !== e && s.redraw();
            }
            show() {
                this.setVisible(!0);
            }
            hide() {
                this.setVisible(!1);
            }
            select(t) {
                this.selected = t = this.options.selected = void 0 === t ? !this.selected : t, this.checkbox && (this.checkbox.checked = t), rG(this, t ? "select" : "unselect");
            }
            shouldShowTooltip(t, e, i = {}) {
                return i.series = this, i.visiblePlotOnly = !0, this.chart.isInsidePlot(t, e, i);
            }
            drawLegendSymbol(t, e) {
                rm[this.options.legendSymbol || "rectangle"]?.call(this, t, e);
            }
        }
        r0.defaultOptions = {
            lineWidth: 2,
            allowPointSelect: !1,
            crisp: !0,
            showCheckbox: !1,
            animation: {
                duration: 1e3
            },
            enableMouseTracking: !0,
            events: {},
            marker: {
                enabledThreshold: 2,
                lineColor: "#ffffff",
                lineWidth: 0,
                radius: 4,
                states: {
                    normal: {
                        animation: !0
                    },
                    hover: {
                        animation: {
                            duration: 150
                        },
                        enabled: !0,
                        radiusPlus: 2,
                        lineWidthPlus: 1
                    },
                    select: {
                        fillColor: "#cccccc",
                        lineColor: "#000000",
                        lineWidth: 2
                    }
                }
            },
            point: {
                events: {}
            },
            dataLabels: {
                animation: {},
                align: "center",
                borderWidth: 0,
                defer: !0,
                formatter: function() {
                    let { numberFormatter: t } = this.series.chart;
                    return "number" != typeof this.y ? "" : t(this.y, -1);
                },
                padding: 5,
                style: {
                    fontSize: "0.7em",
                    fontWeight: "bold",
                    color: "contrast",
                    textOutline: "1px contrast"
                },
                verticalAlign: "bottom",
                x: 0,
                y: 0
            },
            cropThreshold: 300,
            opacity: 1,
            pointRange: 0,
            softThreshold: !0,
            states: {
                normal: {
                    animation: !0
                },
                hover: {
                    animation: {
                        duration: 150
                    },
                    lineWidthPlus: 1,
                    marker: {},
                    halo: {
                        size: 10,
                        opacity: .25
                    }
                },
                select: {
                    animation: {
                        duration: 0
                    }
                },
                inactive: {
                    animation: {
                        duration: 150
                    },
                    opacity: .2
                }
            },
            stickyTracking: !0,
            turboThreshold: 1e3,
            findNearestPointBy: "x"
        }, r0.types = rk.seriesTypes, r0.registerType = rk.registerSeriesType, r0.keepProps = [
            "colorIndex",
            "eventOptions",
            "navigatorSeries",
            "symbolIndex",
            "baseSeries"
        ], r0.keepPropsForPoints = [
            "data",
            "isDirtyData",
            "isDirtyCanvas",
            "points",
            "dataTable",
            "processedData",
            "xIncrement",
            "cropped",
            "_hasPointMarkers",
            "hasDataLabels",
            "nodes",
            "layout",
            "level",
            "mapMap",
            "mapData",
            "minY",
            "maxY",
            "minX",
            "maxX",
            "transformGroups"
        ], rX(r0.prototype, {
            axisTypes: [
                "xAxis",
                "yAxis"
            ],
            coll: "series",
            colorCounter: 0,
            directTouch: !1,
            invertible: !0,
            isCartesian: !0,
            kdAxisArray: [
                "clientX",
                "plotY"
            ],
            parallelArrays: [
                "x",
                "y"
            ],
            pointClass: oK,
            requireSorting: !0,
            sorted: !0
        }), rk.series = r0;
        let r1 = r0, { animObject: r2, setAnimation: r3 } = tU, { registerEventOptions: r5 } = si, { composed: r6, marginNames: r9 } = w, { distribute: r4 } = ey, { format: r8 } = ep, { addEvent: r7, createElement: at, css: ae, defined: ai, discardElement: as, find: ao, fireEvent: ar, isNumber: aa, merge: an, pick: ah, pushUnique: al, relativeLength: ad, stableSort: ac, syncTimeout: ap } = V;
        class ag {
            constructor(t, e){
                this.allItems = [], this.initialItemY = 0, this.itemHeight = 0, this.itemMarginBottom = 0, this.itemMarginTop = 0, this.itemX = 0, this.itemY = 0, this.lastItemY = 0, this.lastLineHeight = 0, this.legendHeight = 0, this.legendWidth = 0, this.maxItemWidth = 0, this.maxLegendWidth = 0, this.offsetWidth = 0, this.padding = 0, this.pages = [], this.symbolHeight = 0, this.symbolWidth = 0, this.titleHeight = 0, this.totalItemWidth = 0, this.widthOption = 0, this.chart = t, this.setOptions(e), e.enabled && (this.render(), r5(this, e), r7(this.chart, "endResize", function() {
                    this.legend.positionCheckboxes();
                })), r7(this.chart, "render", ()=>{
                    this.options.enabled && this.proximate && (this.proximatePositions(), this.positionItems());
                });
            }
            setOptions(t) {
                let e = ah(t.padding, 8);
                this.options = t, this.chart.styledMode || (this.itemStyle = t.itemStyle, this.itemHiddenStyle = an(this.itemStyle, t.itemHiddenStyle)), this.itemMarginTop = t.itemMarginTop, this.itemMarginBottom = t.itemMarginBottom, this.padding = e, this.initialItemY = e - 5, this.symbolWidth = ah(t.symbolWidth, 16), this.pages = [], this.proximate = "proximate" === t.layout && !this.chart.inverted, this.baseline = void 0;
            }
            update(t, e) {
                let i = this.chart;
                this.setOptions(an(!0, this.options, t)), "events" in this.options && r5(this, this.options), this.destroy(), i.isDirtyLegend = i.isDirtyBox = !0, ah(e, !0) && i.redraw(), ar(this, "afterUpdate", {
                    redraw: e
                });
            }
            colorizeItem(t, e) {
                let i = t.color, { area: s, group: o, label: r, line: a, symbol: n } = t.legendItem || {};
                if ((t instanceof r1 || t instanceof oK) && (t.color = t.options?.legendSymbolColor || i), o?.[e ? "removeClass" : "addClass"]("highcharts-legend-item-hidden"), !this.chart.styledMode) {
                    let { itemHiddenStyle: i = {} } = this, o = i.color, { fillColor: h, fillOpacity: l, lineColor: d, marker: c } = t.options, p = (t)=>(!e && (t.fill && (t.fill = o), t.stroke && (t.stroke = o)), t);
                    r?.css(an(e ? this.itemStyle : i)), a?.attr(p({
                        stroke: d || t.color
                    })), n && n.attr(p(c && n.isMarker ? t.pointAttribs() : {
                        fill: t.color
                    })), s?.attr(p({
                        fill: h || t.color,
                        "fill-opacity": h ? 1 : l ?? .75
                    }));
                }
                t.color = i, ar(this, "afterColorizeItem", {
                    item: t,
                    visible: e
                });
            }
            positionItems() {
                this.allItems.forEach(this.positionItem, this), this.chart.isResizing || this.positionCheckboxes();
            }
            positionItem(t) {
                let { group: e, x: i = 0, y: s = 0 } = t.legendItem || {}, o = this.options, r = o.symbolPadding, a = !o.rtl, n = t.checkbox;
                if (e?.element) {
                    let o = {
                        translateX: a ? i : this.legendWidth - i - 2 * r - 4,
                        translateY: s
                    };
                    e[ai(e.translateY) ? "animate" : "attr"](o, void 0, ()=>{
                        ar(this, "afterPositionItem", {
                            item: t
                        });
                    });
                }
                n && (n.x = i, n.y = s);
            }
            destroyItem(t) {
                let e = t.legendItem || {};
                for (let t of [
                    "group",
                    "label",
                    "line",
                    "symbol"
                ])e[t] && (e[t] = e[t].destroy());
                t.checkbox = as(t.checkbox), t.legendItem = void 0;
            }
            destroy() {
                for (let t of this.getAllItems())this.destroyItem(t);
                for (let t of [
                    "clipRect",
                    "up",
                    "down",
                    "pager",
                    "nav",
                    "box",
                    "title",
                    "group"
                ])this[t] && (this[t] = this[t].destroy());
                this.display = null;
            }
            positionCheckboxes() {
                let t, e = this.group?.alignAttr, i = this.clipHeight || this.legendHeight, s = this.titleHeight;
                e && (t = e.translateY, this.allItems.forEach(function(o) {
                    let r, a = o.checkbox;
                    a && (r = t + s + a.y + (this.scrollOffset || 0) + 3, ae(a, {
                        left: e.translateX + o.checkboxOffset + a.x - 20 + "px",
                        top: r + "px",
                        display: this.proximate || r > t - 6 && r < t + i - 6 ? "" : "none"
                    }));
                }, this));
            }
            renderTitle() {
                let t = this.options, e = this.padding, i = t.title, s, o = 0;
                i.text && (this.title || (this.title = this.chart.renderer.label(i.text, e - 3, e - 4, void 0, void 0, void 0, t.useHTML, void 0, "legend-title").attr({
                    zIndex: 1
                }), this.chart.styledMode || this.title.css(i.style), this.title.add(this.group)), i.width || this.title.css({
                    width: this.maxLegendWidth + "px"
                }), o = (s = this.title.getBBox()).height, this.offsetWidth = s.width, this.contentGroup.attr({
                    translateY: o
                })), this.titleHeight = o;
            }
            setText(t) {
                let e = this.options;
                t.legendItem.label.attr({
                    text: e.labelFormat ? r8(e.labelFormat, t, this.chart) : e.labelFormatter.call(t)
                });
            }
            renderItem(t) {
                let e = t.legendItem = t.legendItem || {}, i = this.chart, s = i.renderer, o = this.options, r = "horizontal" === o.layout, a = this.symbolWidth, n = o.symbolPadding || 0, h = this.itemStyle, l = this.itemHiddenStyle, d = r ? ah(o.itemDistance, 20) : 0, c = !o.rtl, p = !t.series, g = !p && t.series.drawLegendSymbol ? t.series : t, u = g.options, f = !!this.createCheckboxForItem && u && u.showCheckbox, m = o.useHTML, x = t.options.className, y = e.label, b = a + n + d + 20 * !!f;
                !y && (e.group = s.g("legend-item").addClass("highcharts-" + g.type + "-series highcharts-color-" + t.colorIndex + (x ? " " + x : "") + (p ? " highcharts-series-" + t.index : "")).attr({
                    zIndex: 1
                }).add(this.scrollGroup), e.label = y = s.text("", c ? a + n : -n, this.baseline || 0, m), i.styledMode || y.css(an(t.visible ? h : l)), y.attr({
                    align: c ? "left" : "right",
                    zIndex: 2
                }).add(e.group), !this.baseline && (this.fontMetrics = s.fontMetrics(y), this.baseline = this.fontMetrics.f + 3 + this.itemMarginTop, y.attr("y", this.baseline), this.symbolHeight = ah(o.symbolHeight, this.fontMetrics.f), o.squareSymbol && (this.symbolWidth = ah(o.symbolWidth, Math.max(this.symbolHeight, 16)), b = this.symbolWidth + n + d + 20 * !!f, c && y.attr("x", this.symbolWidth + n))), g.drawLegendSymbol(this, t), this.setItemEvents && this.setItemEvents(t, y, m)), f && !t.checkbox && this.createCheckboxForItem && this.createCheckboxForItem(t), this.colorizeItem(t, t.visible), (i.styledMode || !h.width) && y.css({
                    width: (o.itemWidth || this.widthOption || i.spacingBox.width) - b + "px"
                }), this.setText(t);
                let v = y.getBBox(), k = this.fontMetrics?.h || 0;
                t.itemWidth = t.checkboxOffset = o.itemWidth || e.labelWidth || v.width + b, this.maxItemWidth = Math.max(this.maxItemWidth, t.itemWidth), this.totalItemWidth += t.itemWidth, this.itemHeight = t.itemHeight = Math.round(e.labelHeight || (v.height > 1.5 * k ? v.height : k));
            }
            layoutItem(t) {
                let e = this.options, i = this.padding, s = "horizontal" === e.layout, o = t.itemHeight, r = this.itemMarginBottom, a = this.itemMarginTop, n = s ? ah(e.itemDistance, 20) : 0, h = this.maxLegendWidth, l = e.alignColumns && this.totalItemWidth > h ? this.maxItemWidth : t.itemWidth, d = t.legendItem || {};
                s && this.itemX - i + l > h && (this.itemX = i, this.lastLineHeight && (this.itemY += a + this.lastLineHeight + r), this.lastLineHeight = 0), this.lastItemY = a + this.itemY + r, this.lastLineHeight = Math.max(o, this.lastLineHeight), d.x = this.itemX, d.y = this.itemY, s ? this.itemX += l : (this.itemY += a + o + r, this.lastLineHeight = o), this.offsetWidth = this.widthOption || Math.max((s ? this.itemX - i - (t.checkbox ? 0 : n) : l) + i, this.offsetWidth);
            }
            getAllItems() {
                let t = [];
                return this.chart.series.forEach(function(e) {
                    let i = e?.options;
                    e && ah(i.showInLegend, !ai(i.linkedTo) && void 0, !0) && (t = t.concat(e.legendItem?.labels || ("point" === i.legendType ? e.data : e)));
                }), ar(this, "afterGetAllItems", {
                    allItems: t
                }), t;
            }
            getAlignment() {
                let t = this.options;
                return this.proximate ? t.align.charAt(0) + "tv" : t.floating ? "" : t.align.charAt(0) + t.verticalAlign.charAt(0) + t.layout.charAt(0);
            }
            adjustMargins(t, e) {
                let i = this.chart, s = this.options, o = this.getAlignment();
                o && [
                    /(lth|ct|rth)/,
                    /(rtv|rm|rbv)/,
                    /(rbh|cb|lbh)/,
                    /(lbv|lm|ltv)/
                ].forEach((r, a)=>{
                    r.test(o) && !ai(t[a]) && (i[r9[a]] = Math.max(i[r9[a]], i.legend[(a + 1) % 2 ? "legendHeight" : "legendWidth"] + [
                        1,
                        -1,
                        -1,
                        1
                    ][a] * s[a % 2 ? "x" : "y"] + (s.margin ?? 12) + e[a] + (i.titleOffset[a] || 0)));
                });
            }
            proximatePositions() {
                let t, e = this.chart, i = [], s = "left" === this.options.align;
                for (let o of (this.allItems.forEach(function(t) {
                    let o, r, a = s, n, h;
                    t.yAxis && (t.xAxis.options.reversed && (a = !a), t.points && (o = ao(a ? t.points : t.points.slice(0).reverse(), function(t) {
                        return aa(t.plotY);
                    })), r = this.itemMarginTop + t.legendItem.label.getBBox().height + this.itemMarginBottom, h = t.yAxis.top - e.plotTop, n = t.visible ? (o ? o.plotY : t.yAxis.height) + (h - .3 * r) : h + t.yAxis.height, i.push({
                        target: n,
                        size: r,
                        item: t
                    }));
                }, this), r4(i, e.plotHeight)))t = o.item.legendItem || {}, aa(o.pos) && (t.y = e.plotTop - e.spacing[0] + o.pos);
            }
            render() {
                let t = this.chart, e = t.renderer, i = this.options, s = this.padding, o = this.getAllItems(), r, a, n, h = this.group, l, d = this.box;
                this.itemX = s, this.itemY = this.initialItemY, this.offsetWidth = 0, this.lastItemY = 0, this.widthOption = ad(i.width, t.spacingBox.width - s), l = t.spacingBox.width - 2 * s - i.x, [
                    "rm",
                    "lm"
                ].indexOf(this.getAlignment().substring(0, 2)) > -1 && (l /= 2), this.maxLegendWidth = this.widthOption || l, h || (this.group = h = e.g("legend").addClass(i.className || "").attr({
                    zIndex: 7
                }).add(), this.contentGroup = e.g().attr({
                    zIndex: 1
                }).add(h), this.scrollGroup = e.g().add(this.contentGroup)), this.renderTitle(), ac(o, (t, e)=>(t.options?.legendIndex || 0) - (e.options?.legendIndex || 0)), i.reversed && o.reverse(), this.allItems = o, this.display = r = !!o.length, this.lastLineHeight = 0, this.maxItemWidth = 0, this.totalItemWidth = 0, this.itemHeight = 0, o.forEach(this.renderItem, this), o.forEach(this.layoutItem, this), a = (this.widthOption || this.offsetWidth) + s, n = this.lastItemY + this.lastLineHeight + this.titleHeight, n = this.handleOverflow(n) + s, d || (this.box = d = e.rect().addClass("highcharts-legend-box").attr({
                    r: i.borderRadius
                }).add(h)), t.styledMode || d.attr({
                    stroke: i.borderColor,
                    "stroke-width": i.borderWidth || 0,
                    fill: i.backgroundColor || "none"
                }).shadow(i.shadow), a > 0 && n > 0 && d[d.placed ? "animate" : "attr"](d.crisp.call({}, {
                    x: 0,
                    y: 0,
                    width: a,
                    height: n
                }, d.strokeWidth())), h[r ? "show" : "hide"](), t.styledMode && "none" === h.getStyle("display") && (a = n = 0), this.legendWidth = a, this.legendHeight = n, r && this.align(), this.proximate || this.positionItems(), ar(this, "afterRender");
            }
            align(t = this.chart.spacingBox) {
                let e = this.chart, i = this.options, s = t.y;
                /(lth|ct|rth)/.test(this.getAlignment()) && e.titleOffset[0] > 0 ? s += e.titleOffset[0] : /(lbh|cb|rbh)/.test(this.getAlignment()) && e.titleOffset[2] > 0 && (s -= e.titleOffset[2]), s !== t.y && (t = an(t, {
                    y: s
                })), e.hasRendered || (this.group.placed = !1), this.group.align(an(i, {
                    width: this.legendWidth,
                    height: this.legendHeight,
                    verticalAlign: this.proximate ? "top" : i.verticalAlign
                }), !0, t);
            }
            handleOverflow(t) {
                let e = this, i = this.chart, s = i.renderer, o = this.options, r = o.y, a = "top" === o.verticalAlign, n = this.padding, h = o.maxHeight, l = o.navigation, d = ah(l.animation, !0), c = l.arrowSize || 12, p = this.pages, g = this.allItems, u = function(t) {
                    "number" == typeof t ? w.attr({
                        height: t
                    }) : w && (e.clipRect = w.destroy(), e.contentGroup.clip()), e.contentGroup.div && (e.contentGroup.div.style.clip = t ? "rect(" + n + "px,9999px," + (n + t) + "px,0)" : "auto");
                }, f = function(t) {
                    return e[t] = s.circle(0, 0, 1.3 * c).translate(c / 2, c / 2).add(k), i.styledMode || e[t].attr("fill", "rgba(0,0,0,0.0001)"), e[t];
                }, m, x, y, b, v = i.spacingBox.height + (a ? -r : r) - n, k = this.nav, w = this.clipRect;
                return "horizontal" !== o.layout || "middle" === o.verticalAlign || o.floating || (v /= 2), h && (v = Math.min(v, h)), p.length = 0, t && v > 0 && t > v && !1 !== l.enabled ? (this.clipHeight = m = Math.max(v - 20 - this.titleHeight - n, 0), this.currentPage = ah(this.currentPage, 1), this.fullHeight = t, g.forEach((t, e)=>{
                    let i = (y = t.legendItem || {}).y || 0, s = Math.round(y.label.getBBox().height), o = p.length;
                    (!o || i - p[o - 1] > m && (x || i) !== p[o - 1]) && (p.push(x || i), o++), y.pageIx = o - 1, x && b && (b.pageIx = o - 1), e === g.length - 1 && i + s - p[o - 1] > m && i > p[o - 1] && (p.push(i), y.pageIx = o), i !== x && (x = i), b = y;
                }), w || (w = e.clipRect = s.clipRect(0, n - 2, 9999, 0), e.contentGroup.clip(w)), u(m), k || (this.nav = k = s.g().attr({
                    zIndex: 1
                }).add(this.group), this.up = s.symbol("triangle", 0, 0, c, c).add(k), f("upTracker").on("click", function() {
                    e.scroll(-1, d);
                }), this.pager = s.text("", 15, 10).addClass("highcharts-legend-navigation"), !i.styledMode && l.style && this.pager.css(l.style), this.pager.add(k), this.down = s.symbol("triangle-down", 0, 0, c, c).add(k), f("downTracker").on("click", function() {
                    e.scroll(1, d);
                })), e.scroll(0), t = v) : k && (u(), this.nav = k.destroy(), this.scrollGroup.attr({
                    translateY: 1
                }), this.clipHeight = 0), t;
            }
            scroll(t, e) {
                let i = this.chart, s = this.pages, o = s.length, r = this.clipHeight, a = this.options.navigation, n = this.pager, h = this.padding, l = this.currentPage + t;
                l > o && (l = o), l > 0 && (void 0 !== e && r3(e, i), this.nav.attr({
                    translateX: h,
                    translateY: r + this.padding + 7 + this.titleHeight,
                    visibility: "inherit"
                }), [
                    this.up,
                    this.upTracker
                ].forEach(function(t) {
                    t.attr({
                        class: 1 === l ? "highcharts-legend-nav-inactive" : "highcharts-legend-nav-active"
                    });
                }), n.attr({
                    text: l + "/" + o
                }), [
                    this.down,
                    this.downTracker
                ].forEach(function(t) {
                    t.attr({
                        x: 18 + this.pager.getBBox().width,
                        class: l === o ? "highcharts-legend-nav-inactive" : "highcharts-legend-nav-active"
                    });
                }, this), i.styledMode || (this.up.attr({
                    fill: 1 === l ? a.inactiveColor : a.activeColor
                }), this.upTracker.css({
                    cursor: 1 === l ? "default" : "pointer"
                }), this.down.attr({
                    fill: l === o ? a.inactiveColor : a.activeColor
                }), this.downTracker.css({
                    cursor: l === o ? "default" : "pointer"
                })), this.scrollOffset = -s[l - 1] + this.initialItemY, this.scrollGroup.animate({
                    translateY: this.scrollOffset
                }), this.currentPage = l, this.positionCheckboxes(), ap(()=>{
                    ar(this, "afterScroll", {
                        currentPage: l
                    });
                }, r2(ah(e, i.renderer.globalAnimation, !0)).duration));
            }
            setItemEvents(t, e, i) {
                let s = this, o = t.legendItem || {}, r = s.chart.renderer.boxWrapper, a = t instanceof oK, n = t instanceof r1, h = "highcharts-legend-" + (a ? "point" : "series") + "-active", l = s.chart.styledMode, d = i ? [
                    e,
                    o.symbol
                ] : [
                    o.group
                ], c = (e)=>{
                    s.allItems.forEach((i)=>{
                        t !== i && [
                            i
                        ].concat(i.linkedSeries || []).forEach((t)=>{
                            t.setState(e, !a);
                        });
                    });
                };
                for (let i of d)i && i.on("mouseover", function() {
                    t.visible && c("inactive"), t.setState("hover"), t.visible && r.addClass(h), l || e.css(s.options.itemHoverStyle);
                }).on("mouseout", function() {
                    s.chart.styledMode || e.css(an(t.visible ? s.itemStyle : s.itemHiddenStyle)), c(""), r.removeClass(h), t.setState();
                }).on("click", function(e) {
                    let i = function() {
                        t.setVisible && t.setVisible(), c(t.visible ? "inactive" : "");
                    };
                    r.removeClass(h), ar(s, "itemClick", {
                        browserEvent: e,
                        legendItem: t
                    }, i), a ? t.firePointEvent("legendItemClick", {
                        browserEvent: e
                    }) : n && ar(t, "legendItemClick", {
                        browserEvent: e
                    });
                });
            }
            createCheckboxForItem(t) {
                t.checkbox = at("input", {
                    type: "checkbox",
                    className: "highcharts-legend-checkbox",
                    checked: t.selected,
                    defaultChecked: t.selected
                }, this.options.itemCheckboxStyle, this.chart.container), r7(t.checkbox, "click", function(e) {
                    let i = e.target;
                    ar(t.series || t, "checkboxClick", {
                        checked: i.checked,
                        item: t
                    }, function() {
                        t.select();
                    });
                });
            }
        }
        !function(t) {
            t.compose = function(e) {
                al(r6, "Core.Legend") && r7(e, "beforeMargins", function() {
                    this.legend = new t(this, this.options.legend);
                });
            };
        }(ag || (ag = {}));
        let au = ag, { animate: af, animObject: am, setAnimation: ax } = tU, { defaultOptions: ay } = tv, { numberFormat: ab } = ep, { registerEventOptions: av } = si, { charts: ak, doc: aw, marginNames: aM, svg: aS, win: aT } = w, { seriesTypes: aC } = rk, { addEvent: aA, attr: aP, createElement: aL, css: aO, defined: aE, diffObjects: aI, discardElement: aD, erase: aB, error: aN, extend: az, find: aR, fireEvent: aW, getAlignFactor: aH, getStyle: aX, isArray: aF, isNumber: aG, isObject: aj, isString: aY, merge: aU, objectEach: a$, pick: aV, pInt: aZ, relativeLength: a_, removeEvent: aq, splat: aK, syncTimeout: aJ, uniqueKey: aQ } = V;
        class a0 {
            static chart(t, e, i) {
                return new a0(t, e, i);
            }
            constructor(t, e, i){
                this.sharedClips = {};
                let s = [
                    ...arguments
                ];
                (aY(t) || t.nodeName) && (this.renderTo = s.shift()), this.init(s[0], s[1]);
            }
            setZoomOptions() {
                let t = this.options.chart, e = t.zooming;
                this.zooming = {
                    ...e,
                    type: aV(t.zoomType, e.type),
                    key: aV(t.zoomKey, e.key),
                    pinchType: aV(t.pinchType, e.pinchType),
                    singleTouch: aV(t.zoomBySingleTouch, e.singleTouch, !1),
                    resetButton: aU(e.resetButton, t.resetZoomButton)
                };
            }
            init(t, e) {
                aW(this, "init", {
                    args: arguments
                }, function() {
                    let i = aU(ay, t), s = i.chart, o = this.renderTo || s.renderTo;
                    this.userOptions = az({}, t), (this.renderTo = aY(o) ? aw.getElementById(o) : o) || aN(13, !0, this), this.margin = [], this.spacing = [], this.labelCollectors = [], this.callback = e, this.isResizing = 0, this.options = i, this.axes = [], this.series = [], this.locale = i.lang.locale ?? this.renderTo.closest("[lang]")?.lang, this.time = new tu(az(i.time || {}, {
                        locale: this.locale
                    }), i.lang), i.time = this.time.options, this.numberFormatter = (s.numberFormatter || ab).bind(this), this.styledMode = s.styledMode, this.hasCartesianSeries = s.showAxes, this.index = ak.length, ak.push(this), w.chartCount++, av(this, s), this.xAxis = [], this.yAxis = [], this.pointCount = this.colorCounter = this.symbolCounter = 0, this.setZoomOptions(), aW(this, "afterInit"), this.firstRender();
                });
            }
            initSeries(t) {
                let e = this.options.chart, i = t.type || e.type, s = aC[i];
                s || aN(17, !0, this, {
                    missingModuleFor: i
                });
                let o = new s;
                return "function" == typeof o.init && o.init(this, t), o;
            }
            setSortedData() {
                this.getSeriesOrderByLinks().forEach(function(t) {
                    t.points || t.data || !t.enabledDataSorting || t.setData(t.options.data, !1);
                });
            }
            getSeriesOrderByLinks() {
                return this.series.concat().sort(function(t, e) {
                    return t.linkedSeries.length || e.linkedSeries.length ? e.linkedSeries.length - t.linkedSeries.length : 0;
                });
            }
            orderItems(t, e = 0) {
                let i = this[t], s = this.options[t] = aK(this.options[t]).slice(), o = this.userOptions[t] = this.userOptions[t] ? aK(this.userOptions[t]).slice() : [];
                if (this.hasRendered && (s.splice(e), o.splice(e)), i) for(let t = e, r = i.length; t < r; ++t){
                    let e = i[t];
                    e && (e.index = t, e instanceof r1 && (e.name = e.getName()), e.options.isInternal || (s[t] = e.options, o[t] = e.userOptions));
                }
            }
            getClipBox(t, e) {
                let i = this.inverted, { xAxis: s, yAxis: o } = t || {}, { x: r, y: a, width: n, height: h } = aU(this.clipBox);
                return t && (s && s.len !== this.plotSizeX && (n = s.len), o && o.len !== this.plotSizeY && (h = o.len), i && !t.invertible && ([n, h] = [
                    h,
                    n
                ])), e && (r += (i ? o : s)?.pos ?? this.plotLeft, a += (i ? s : o)?.pos ?? this.plotTop), {
                    x: r,
                    y: a,
                    width: n,
                    height: h
                };
            }
            isInsidePlot(t, e, i = {}) {
                let { inverted: s, plotBox: o, plotLeft: r, plotTop: a, scrollablePlotBox: n } = this, { scrollLeft: h = 0, scrollTop: l = 0 } = i.visiblePlotOnly && this.scrollablePlotArea?.scrollingContainer || {}, d = i.series, c = i.visiblePlotOnly && n || o, p = i.inverted ? e : t, g = i.inverted ? t : e, u = {
                    x: p,
                    y: g,
                    isInsidePlot: !0,
                    options: i
                };
                if (!i.ignoreX) {
                    let t = d && (s && !this.polar ? d.yAxis : d.xAxis) || {
                        pos: r,
                        len: 1 / 0
                    }, e = i.paneCoordinates ? t.pos + p : r + p;
                    e >= Math.max(h + r, t.pos) && e <= Math.min(h + r + c.width, t.pos + t.len) || (u.isInsidePlot = !1);
                }
                if (!i.ignoreY && u.isInsidePlot) {
                    let t = !s && i.axis && !i.axis.isXAxis && i.axis || d && (s ? d.xAxis : d.yAxis) || {
                        pos: a,
                        len: 1 / 0
                    }, e = i.paneCoordinates ? t.pos + g : a + g;
                    e >= Math.max(l + a, t.pos) && e <= Math.min(l + a + c.height, t.pos + t.len) || (u.isInsidePlot = !1);
                }
                return aW(this, "afterIsInsidePlot", u), u.isInsidePlot;
            }
            redraw(t) {
                aW(this, "beforeRedraw");
                let e = this.hasCartesianSeries ? this.axes : this.colorAxis || [], i = this.series, s = this.pointer, o = this.legend, r = this.userOptions.legend, a = this.renderer, n = a.isHidden(), h = [], l, d, c, p = this.isDirtyBox, g = this.isDirtyLegend, u;
                for(a.rootFontSize = a.boxWrapper.getStyle("font-size"), this.setResponsive && this.setResponsive(!1), ax(!!this.hasRendered && t, this), n && this.temporaryDisplay(), this.layOutTitles(!1), c = i.length; c--;)if (((u = i[c]).options.stacking || u.options.centerInCategory) && (d = !0, u.isDirty)) {
                    l = !0;
                    break;
                }
                if (l) for(c = i.length; c--;)(u = i[c]).options.stacking && (u.isDirty = !0);
                i.forEach(function(t) {
                    t.isDirty && ("point" === t.options.legendType ? ("function" == typeof t.updateTotals && t.updateTotals(), g = !0) : r && (r.labelFormatter || r.labelFormat) && (g = !0)), t.isDirtyData && aW(t, "updatedData");
                }), g && o && o.options.enabled && (o.render(), this.isDirtyLegend = !1), d && this.getStacks(), e.forEach(function(t) {
                    t.updateNames(), t.setScale();
                }), this.getMargins(), e.forEach(function(t) {
                    t.isDirty && (p = !0);
                }), e.forEach(function(t) {
                    let e = t.min + "," + t.max;
                    t.extKey !== e && (t.extKey = e, h.push(function() {
                        aW(t, "afterSetExtremes", az(t.eventArgs, t.getExtremes())), delete t.eventArgs;
                    })), (p || d) && t.redraw();
                }), p && this.drawChartBox(), aW(this, "predraw"), i.forEach(function(t) {
                    (p || t.isDirty) && t.visible && t.redraw(), t.isDirtyData = !1;
                }), s && s.reset(!0), a.draw(), aW(this, "redraw"), aW(this, "render"), n && this.temporaryDisplay(!0), h.forEach(function(t) {
                    t.call();
                });
            }
            get(t) {
                let e = this.series;
                function i(e) {
                    return e.id === t || e.options && e.options.id === t;
                }
                let s = aR(this.axes, i) || aR(this.series, i);
                for(let t = 0; !s && t < e.length; t++)s = aR(e[t].points || [], i);
                return s;
            }
            createAxes() {
                let t = this.userOptions;
                for (let e of (aW(this, "createAxes"), [
                    "xAxis",
                    "yAxis"
                ]))for (let i of t[e] = aK(t[e] || {}))new s$(this, i, e);
                aW(this, "afterCreateAxes");
            }
            getSelectedPoints() {
                return this.series.reduce((t, e)=>(e.getPointsCollection().forEach((e)=>{
                        aV(e.selectedStaging, e.selected) && t.push(e);
                    }), t), []);
            }
            getSelectedSeries() {
                return this.series.filter((t)=>t.selected);
            }
            setTitle(t, e, i) {
                this.applyDescription("title", t), this.applyDescription("subtitle", e), this.applyDescription("caption", void 0), this.layOutTitles(i);
            }
            applyDescription(t, e) {
                let i = this, s = this.options[t] = aU(this.options[t], e), o = this[t];
                o && e && (this[t] = o = o.destroy()), s && !o && ((o = this.renderer.text(s.text, 0, 0, s.useHTML).attr({
                    align: s.align,
                    class: "highcharts-" + t,
                    zIndex: s.zIndex || 4
                }).css({
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap"
                }).add()).update = function(e, s) {
                    i.applyDescription(t, e), i.layOutTitles(s);
                }, this.styledMode || o.css(az("title" === t ? {
                    fontSize: this.options.isStock ? "1em" : "1.2em"
                } : {}, s.style)), o.textPxLength = o.getBBox().width, o.css({
                    whiteSpace: s.style?.whiteSpace
                }), this[t] = o);
            }
            layOutTitles(t = !0) {
                let e = [
                    0,
                    0,
                    0
                ], { options: i, renderer: s, spacingBox: o } = this;
                [
                    "title",
                    "subtitle",
                    "caption"
                ].forEach((t)=>{
                    let i = this[t], r = this.options[t], a = aU(o), n = i?.textPxLength || 0;
                    if (i && r) {
                        aW(this, "layOutTitle", {
                            alignTo: a,
                            key: t,
                            textPxLength: n
                        });
                        let o = s.fontMetrics(i), h = o.b, l = o.h, d = r.verticalAlign || "top", c = "top" === d, p = c && r.minScale || 1, g = "title" === t ? c ? -3 : 0 : c ? e[0] + 2 : 0, u = Math.min(a.width / n, 1), f = Math.max(p, u), m = aU({
                            y: "bottom" === d ? h : g + h
                        }, {
                            align: "title" === t ? u < p ? "left" : "center" : this.title?.alignValue
                        }, r), x = (r.width || (u > p ? this.chartWidth : a.width) / f) + "px";
                        i.alignValue !== m.align && (i.placed = !1);
                        let y = Math.round(i.css({
                            width: x
                        }).getBBox(r.useHTML).height);
                        if (m.height = y, i.align(m, !1, a).attr({
                            align: m.align,
                            scaleX: f,
                            scaleY: f,
                            "transform-origin": `${a.x + n * f * aH(m.align)} ${l}`
                        }), !r.floating) {
                            let t = y * (y < 1.2 * l ? 1 : f);
                            "top" === d ? e[0] = Math.ceil(e[0] + t) : "bottom" === d && (e[2] = Math.ceil(e[2] + t));
                        }
                    }
                }, this), e[0] && "top" === (i.title?.verticalAlign || "top") && (e[0] += i.title?.margin || 0), e[2] && i.caption?.verticalAlign === "bottom" && (e[2] += i.caption?.margin || 0);
                let r = !this.titleOffset || this.titleOffset.join(",") !== e.join(",");
                this.titleOffset = e, aW(this, "afterLayOutTitles"), !this.isDirtyBox && r && (this.isDirtyBox = this.isDirtyLegend = r, this.hasRendered && t && this.isDirtyBox && this.redraw());
            }
            getContainerBox() {
                let t = [].map.call(this.renderTo.children, (t)=>{
                    if (t !== this.container) {
                        let e = t.style.display;
                        return t.style.display = "none", [
                            t,
                            e
                        ];
                    }
                }), e = {
                    width: aX(this.renderTo, "width", !0) || 0,
                    height: aX(this.renderTo, "height", !0) || 0
                };
                return t.filter(Boolean).forEach(([t, e])=>{
                    t.style.display = e;
                }), e;
            }
            getChartSize() {
                let t = this.options.chart, e = t.width, i = t.height, s = this.getContainerBox(), o = s.height <= 1 || !this.renderTo.parentElement?.style.height && "100%" === this.renderTo.style.height;
                this.chartWidth = Math.max(0, e || s.width || 600), this.chartHeight = Math.max(0, a_(i, this.chartWidth) || (o ? 400 : s.height)), this.containerBox = s;
            }
            temporaryDisplay(t) {
                let e = this.renderTo, i;
                if (t) for(; e?.style;)e.hcOrigStyle && (aO(e, e.hcOrigStyle), delete e.hcOrigStyle), e.hcOrigDetached && (aw.body.removeChild(e), e.hcOrigDetached = !1), e = e.parentNode;
                else for(; e?.style && (aw.body.contains(e) || e.parentNode || (e.hcOrigDetached = !0, aw.body.appendChild(e)), ("none" === aX(e, "display", !1) || e.hcOricDetached) && (e.hcOrigStyle = {
                    display: e.style.display,
                    height: e.style.height,
                    overflow: e.style.overflow
                }, i = {
                    display: "block",
                    overflow: "hidden"
                }, e !== this.renderTo && (i.height = 0), aO(e, i), e.offsetWidth || e.style.setProperty("display", "block", "important")), (e = e.parentNode) !== aw.body););
            }
            setClassName(t) {
                this.container.className = "highcharts-container " + (t || "");
            }
            getContainer() {
                let t, e = this.options, i = e.chart, s = "data-highcharts-chart", o = aQ(), r = this.renderTo, a = aZ(aP(r, s));
                aG(a) && ak[a] && ak[a].hasRendered && ak[a].destroy(), aP(r, s, this.index), r.innerHTML = t6.emptyHTML, i.skipClone || r.offsetWidth || this.temporaryDisplay(), this.getChartSize();
                let n = this.chartHeight, h = this.chartWidth;
                aO(r, {
                    overflow: "hidden"
                }), this.styledMode || (t = az({
                    position: "relative",
                    overflow: "hidden",
                    width: h + "px",
                    height: n + "px",
                    textAlign: "left",
                    lineHeight: "normal",
                    zIndex: 0,
                    "-webkit-tap-highlight-color": "rgba(0,0,0,0)",
                    userSelect: "none",
                    "touch-action": "manipulation",
                    outline: "none",
                    padding: "0px"
                }, i.style || {}));
                let l = aL("div", {
                    id: o
                }, t, r);
                this.container = l, this.getChartSize(), h !== this.chartWidth && (h = this.chartWidth, this.styledMode || aO(l, {
                    width: aV(i.style?.width, h + "px")
                })), this.containerBox = this.getContainerBox(), this._cursor = l.style.cursor;
                let d = i.renderer || !aS ? eg.getRendererType(i.renderer) : iU;
                if (this.renderer = new d(l, h, n, void 0, i.forExport, e.exporting?.allowHTML, this.styledMode), ax(void 0, this), this.setClassName(i.className), this.styledMode) for(let t in e.defs)this.renderer.definition(e.defs[t]);
                else this.renderer.setStyle(i.style);
                this.renderer.chartIndex = this.index, aW(this, "afterGetContainer");
            }
            getMargins(t) {
                let { spacing: e, margin: i, titleOffset: s } = this;
                this.resetMargins(), s[0] && !aE(i[0]) && (this.plotTop = Math.max(this.plotTop, s[0] + e[0])), s[2] && !aE(i[2]) && (this.marginBottom = Math.max(this.marginBottom, s[2] + e[2])), this.legend?.display && this.legend.adjustMargins(i, e), aW(this, "getMargins"), t || this.getAxisMargins();
            }
            getAxisMargins() {
                let t = this, e = t.axisOffset = [
                    0,
                    0,
                    0,
                    0
                ], i = t.colorAxis, s = t.margin, o = (t)=>{
                    t.forEach((t)=>{
                        t.visible && t.getOffset();
                    });
                };
                t.hasCartesianSeries ? o(t.axes) : i?.length && o(i), aM.forEach((i, o)=>{
                    aE(s[o]) || (t[i] += e[o]);
                }), t.setChartSize();
            }
            getOptions() {
                return aI(this.userOptions, ay);
            }
            reflow(t) {
                let e = this, i = e.containerBox, s = e.getContainerBox();
                delete e.pointer?.chartPosition, !e.exporting?.isPrinting && !e.isResizing && i && s.width && ((s.width !== i.width || s.height !== i.height) && (V.clearTimeout(e.reflowTimeout), e.reflowTimeout = aJ(function() {
                    e.container && e.setSize(void 0, void 0, !1);
                }, 100 * !!t)), e.containerBox = s);
            }
            setReflow() {
                let t = this, e = (e)=>{
                    t.options?.chart.reflow && t.hasLoaded && t.reflow(e);
                };
                if ("function" == typeof ResizeObserver) new ResizeObserver(e).observe(t.renderTo);
                else {
                    let t = aA(aT, "resize", e);
                    aA(this, "destroy", t);
                }
            }
            setSize(t, e, i) {
                let s = this, o = s.renderer;
                s.isResizing += 1, ax(i, s);
                let r = o.globalAnimation;
                s.oldChartHeight = s.chartHeight, s.oldChartWidth = s.chartWidth, void 0 !== t && (s.options.chart.width = t), void 0 !== e && (s.options.chart.height = e), s.getChartSize();
                let { chartWidth: a, chartHeight: n, scrollablePixelsX: h = 0, scrollablePixelsY: l = 0 } = s;
                (s.isDirtyBox || a !== s.oldChartWidth || n !== s.oldChartHeight) && (s.styledMode || (r ? af : aO)(s.container, {
                    width: `${a + h}px`,
                    height: `${n + l}px`
                }, r), s.setChartSize(!0), o.setSize(a, n, r), s.axes.forEach(function(t) {
                    t.isDirty = !0, t.setScale();
                }), s.isDirtyLegend = !0, s.isDirtyBox = !0, s.layOutTitles(), s.getMargins(), s.redraw(r), s.oldChartHeight = void 0, aW(s, "resize"), setTimeout(()=>{
                    s && aW(s, "endResize");
                }, am(r).duration)), s.isResizing -= 1;
            }
            setChartSize(t) {
                let e, i, s, o, { chartHeight: r, chartWidth: a, inverted: n, spacing: h, renderer: l } = this, d = this.clipOffset, c = Math[n ? "floor" : "round"];
                this.plotLeft = e = Math.round(this.plotLeft), this.plotTop = i = Math.round(this.plotTop), this.plotWidth = s = Math.max(0, Math.round(a - e - (this.marginRight ?? 0))), this.plotHeight = o = Math.max(0, Math.round(r - i - (this.marginBottom ?? 0))), this.plotSizeX = n ? o : s, this.plotSizeY = n ? s : o, this.spacingBox = l.spacingBox = {
                    x: h[3],
                    y: h[0],
                    width: a - h[3] - h[1],
                    height: r - h[0] - h[2]
                }, this.plotBox = l.plotBox = {
                    x: e,
                    y: i,
                    width: s,
                    height: o
                }, d && (this.clipBox = {
                    x: c(d[3]),
                    y: c(d[0]),
                    width: c(this.plotSizeX - d[1] - d[3]),
                    height: c(this.plotSizeY - d[0] - d[2])
                }), t || (this.axes.forEach(function(t) {
                    t.setAxisSize(), t.setAxisTranslation();
                }), l.alignElements()), aW(this, "afterSetChartSize", {
                    skipAxes: t
                });
            }
            resetMargins() {
                aW(this, "resetMargins");
                let t = this, e = t.options.chart, i = e.plotBorderWidth || 0, s = Math.round(i) / 2;
                [
                    "margin",
                    "spacing"
                ].forEach((i)=>{
                    let s = e[i], o = aj(s) ? s : [
                        s,
                        s,
                        s,
                        s
                    ];
                    [
                        "Top",
                        "Right",
                        "Bottom",
                        "Left"
                    ].forEach((s, r)=>{
                        t[i][r] = e[`${i}${s}`] ?? o[r];
                    });
                }), aM.forEach((e, i)=>{
                    t[e] = t.margin[i] ?? t.spacing[i];
                }), t.axisOffset = [
                    0,
                    0,
                    0,
                    0
                ], t.clipOffset = [
                    s,
                    s,
                    s,
                    s
                ], t.plotBorderWidth = i;
            }
            drawChartBox() {
                let t = this.options.chart, e = this.renderer, i = this.chartWidth, s = this.chartHeight, o = this.styledMode, r = this.plotBGImage, a = t.backgroundColor, n = t.plotBackgroundColor, h = t.plotBackgroundImage, l = this.plotLeft, d = this.plotTop, c = this.plotWidth, p = this.plotHeight, g = this.plotBox, u = this.clipRect, f = this.clipBox, m = this.chartBackground, x = this.plotBackground, y = this.plotBorder, b, v, k, w = "animate";
                m || (this.chartBackground = m = e.rect().addClass("highcharts-background").add(), w = "attr"), o ? b = v = m.strokeWidth() : (v = (b = t.borderWidth || 0) + 8 * !!t.shadow, k = {
                    fill: a || "none"
                }, (b || m["stroke-width"]) && (k.stroke = t.borderColor, k["stroke-width"] = b), m.attr(k).shadow(t.shadow)), m[w]({
                    x: v / 2,
                    y: v / 2,
                    width: i - v - b % 2,
                    height: s - v - b % 2,
                    r: t.borderRadius
                }), w = "animate", x || (w = "attr", this.plotBackground = x = e.rect().addClass("highcharts-plot-background").add()), x[w](g), !o && (x.attr({
                    fill: n || "none"
                }).shadow(t.plotShadow), h && (r ? (h !== r.attr("href") && r.attr("href", h), r.animate(g)) : this.plotBGImage = e.image(h, l, d, c, p).add())), u ? u.animate({
                    width: f.width,
                    height: f.height
                }) : this.clipRect = e.clipRect(f), w = "animate", y || (w = "attr", this.plotBorder = y = e.rect().addClass("highcharts-plot-border").attr({
                    zIndex: 1
                }).add()), o || y.attr({
                    stroke: t.plotBorderColor,
                    "stroke-width": t.plotBorderWidth || 0,
                    fill: "none"
                }), y[w](y.crisp(g, -y.strokeWidth())), this.isDirtyBox = !1, aW(this, "afterDrawChartBox");
            }
            propFromSeries() {
                let t, e, i, s = this, o = s.options.chart, r = s.options.series;
                [
                    "inverted",
                    "angular",
                    "polar"
                ].forEach(function(a) {
                    for(e = aC[o.type], i = o[a] || e && e.prototype[a], t = r?.length; !i && t--;)(e = aC[r[t].type]) && e.prototype[a] && (i = !0);
                    s[a] = i;
                });
            }
            linkSeries(t) {
                let e = this, i = e.series;
                i.forEach(function(t) {
                    t.linkedSeries.length = 0;
                }), i.forEach(function(t) {
                    let { linkedTo: i } = t.options;
                    if (aY(i)) {
                        let s;
                        (s = ":previous" === i ? e.series[t.index - 1] : e.get(i)) && s.linkedParent !== t && (s.linkedSeries.push(t), t.linkedParent = s, s.enabledDataSorting && t.setDataSortingOptions(), t.visible = aV(t.options.visible, s.options.visible, t.visible));
                    }
                }), aW(this, "afterLinkSeries", {
                    isUpdating: t
                });
            }
            renderSeries() {
                this.series.forEach(function(t) {
                    t.translate(), t.render();
                });
            }
            render() {
                let t = this.axes, e = this.colorAxis, i = this.renderer, s = this.options.chart.axisLayoutRuns || 2, o = (t)=>{
                    t.forEach((t)=>{
                        t.visible && t.render();
                    });
                }, r = 0, a = !0, n, h = 0;
                for (let e of (this.setTitle(), aW(this, "beforeMargins"), this.getStacks?.(), this.getMargins(!0), this.setChartSize(), t)){
                    let { options: t } = e, { labels: i } = t;
                    if (this.hasCartesianSeries && e.horiz && e.visible && i.enabled && e.series.length && "colorAxis" !== e.coll && !this.polar) {
                        r = t.tickLength, e.createGroups();
                        let s = new sf(e, 0, "", !0), o = s.createLabel("x", i);
                        if (s.destroy(), o && aV(i.reserveSpace, !aG(t.crossing)) && (r = o.getBBox().height + i.distance + Math.max(t.offset || 0, 0)), r) {
                            o?.destroy();
                            break;
                        }
                    }
                }
                for(this.plotHeight = Math.max(this.plotHeight - r, 0); (a || n || s > 1) && h < s;){
                    let e = this.plotWidth, i = this.plotHeight;
                    for (let e of t)0 === h ? e.setScale() : (e.horiz && a || !e.horiz && n) && e.setTickInterval(!0);
                    0 === h ? this.getAxisMargins() : this.getMargins(), a = e / this.plotWidth > (h ? 1 : 1.1), n = i / this.plotHeight > (h ? 1 : 1.05), h++;
                }
                this.drawChartBox(), this.hasCartesianSeries ? o(t) : e?.length && o(e), this.seriesGroup || (this.seriesGroup = i.g("series-group").attr({
                    zIndex: 3
                }).shadow(this.options.chart.seriesGroupShadow).add()), this.dataLabelsGroup || (this.dataLabelsGroup = i.g("datalabels-group").attr({
                    zIndex: 6
                }).add()), this.renderSeries(), this.addCredits(), this.setResponsive && this.setResponsive(), this.hasRendered = !0;
            }
            addCredits(t) {
                let e = this, i = aU(!0, this.options.credits, t);
                i.enabled && !this.credits && (this.credits = this.renderer.text(i.text + (this.mapCredits || ""), 0, 0).addClass("highcharts-credits").on("click", function() {
                    i.href && (aT.location.href = i.href);
                }).attr({
                    align: i.position.align,
                    zIndex: 8
                }), e.styledMode || this.credits.css(i.style), this.credits.add().align(i.position), this.credits.update = function(t) {
                    e.credits = e.credits.destroy(), e.addCredits(t);
                });
            }
            destroy() {
                let t, e = this, i = e.axes, s = e.series, o = e.container, r = o?.parentNode;
                for(aW(e, "destroy"), e.renderer.forExport ? aB(ak, e) : ak[e.index] = void 0, w.chartCount--, e.renderTo.removeAttribute("data-highcharts-chart"), aq(e), t = i.length; t--;)i[t] = i[t].destroy();
                for(this.scroller?.destroy?.(), t = s.length; t--;)s[t] = s[t].destroy();
                [
                    "title",
                    "subtitle",
                    "chartBackground",
                    "plotBackground",
                    "plotBGImage",
                    "plotBorder",
                    "seriesGroup",
                    "clipRect",
                    "credits",
                    "pointer",
                    "rangeSelector",
                    "legend",
                    "resetZoomButton",
                    "tooltip",
                    "renderer"
                ].forEach((t)=>{
                    e[t] = e[t]?.destroy?.();
                }), o && (o.innerHTML = t6.emptyHTML, aq(o), r && aD(o)), a$(e, function(t, i) {
                    delete e[i];
                });
            }
            firstRender() {
                let t = this, e = t.options;
                t.getContainer(), t.resetMargins(), t.setChartSize(), t.propFromSeries(), t.createAxes();
                let i = aF(e.series) ? e.series : [];
                e.series = [], i.forEach(function(e) {
                    t.initSeries(e);
                }), t.linkSeries(), t.setSortedData(), aW(t, "beforeRender"), t.render(), t.pointer?.getChartPosition(), t.renderer.imgCount || t.hasLoaded || t.onload(), t.temporaryDisplay(!0);
            }
            onload() {
                this.callbacks.concat([
                    this.callback
                ]).forEach(function(t) {
                    t && void 0 !== this.index && t.apply(this, [
                        this
                    ]);
                }, this), aW(this, "load"), aW(this, "render"), aE(this.index) && this.setReflow(), this.warnIfA11yModuleNotLoaded(), this.hasLoaded = !0;
            }
            warnIfA11yModuleNotLoaded() {
                let { options: t, title: e } = this;
                t && !this.accessibility && (this.renderer.boxWrapper.attr({
                    role: "img",
                    "aria-label": (e?.element.textContent || "").replace(/</g, "&lt;")
                }), t.accessibility && !1 === t.accessibility.enabled || aN('Highcharts warning: Consider including the "accessibility.js" module to make your chart more usable for people with disabilities. Set the "accessibility.enabled" option to false to remove this warning. See https://www.highcharts.com/docs/accessibility/accessibility-module.', !1, this));
            }
            addSeries(t, e, i) {
                let s, o = this;
                return t && (e = aV(e, !0), aW(o, "addSeries", {
                    options: t
                }, function() {
                    s = o.initSeries(t), o.isDirtyLegend = !0, o.linkSeries(), s.enabledDataSorting && s.setData(t.data, !1), aW(o, "afterAddSeries", {
                        series: s
                    }), e && o.redraw(i);
                })), s;
            }
            addAxis(t, e, i, s) {
                return this.createAxis(e ? "xAxis" : "yAxis", {
                    axis: t,
                    redraw: i,
                    animation: s
                });
            }
            addColorAxis(t, e, i) {
                return this.createAxis("colorAxis", {
                    axis: t,
                    redraw: e,
                    animation: i
                });
            }
            createAxis(t, e) {
                let i = new s$(this, e.axis, t);
                return aV(e.redraw, !0) && this.redraw(e.animation), i;
            }
            showLoading(t) {
                let e = this, i = e.options, s = i.loading, o = function() {
                    r && aO(r, {
                        left: e.plotLeft + "px",
                        top: e.plotTop + "px",
                        width: e.plotWidth + "px",
                        height: e.plotHeight + "px"
                    });
                }, r = e.loadingDiv, a = e.loadingSpan;
                r || (e.loadingDiv = r = aL("div", {
                    className: "highcharts-loading highcharts-loading-hidden"
                }, null, e.container)), a || (e.loadingSpan = a = aL("span", {
                    className: "highcharts-loading-inner"
                }, null, r), aA(e, "redraw", o)), r.className = "highcharts-loading", t6.setElementHTML(a, aV(t, i.lang.loading, "")), !e.styledMode && (aO(r, az(s.style, {
                    zIndex: 10
                })), aO(a, s.labelStyle), e.loadingShown || (aO(r, {
                    opacity: 0,
                    display: ""
                }), af(r, {
                    opacity: s.style.opacity || .5
                }, {
                    duration: s.showDuration || 0
                }))), e.loadingShown = !0, o();
            }
            hideLoading() {
                let t = this.options, e = this.loadingDiv;
                e && (e.className = "highcharts-loading highcharts-loading-hidden", this.styledMode || af(e, {
                    opacity: 0
                }, {
                    duration: t.loading.hideDuration || 100,
                    complete: function() {
                        aO(e, {
                            display: "none"
                        });
                    }
                })), this.loadingShown = !1;
            }
            update(t, e, i, s) {
                let o, r, a, n = this, h = {
                    credits: "addCredits",
                    title: "setTitle",
                    subtitle: "setSubtitle",
                    caption: "setCaption"
                }, l = t.isResponsiveOptions, d = [];
                aW(n, "update", {
                    options: t
                }), l || n.setResponsive(!1, !0), t = aI(t, n.options), n.userOptions = aU(n.userOptions, t);
                let c = t.chart;
                c && (aU(!0, n.options.chart, c), this.setZoomOptions(), "className" in c && n.setClassName(c.className), ("inverted" in c || "polar" in c || "type" in c) && (n.propFromSeries(), o = !0), "alignTicks" in c && (o = !0), "events" in c && av(this, c), a$(c, function(t, e) {
                    -1 !== n.propsRequireUpdateSeries.indexOf("chart." + e) && (r = !0), -1 !== n.propsRequireDirtyBox.indexOf(e) && (n.isDirtyBox = !0), -1 !== n.propsRequireReflow.indexOf(e) && (n.isDirtyBox = !0, l || (a = !0));
                }), !n.styledMode && c.style && n.renderer.setStyle(n.options.chart.style || {})), !n.styledMode && t.colors && (this.options.colors = t.colors), a$(t, function(e, i) {
                    n[i] && "function" == typeof n[i].update ? n[i].update(e, !1) : "function" == typeof n[h[i]] ? n[h[i]](e) : "colors" !== i && -1 === n.collectionsWithUpdate.indexOf(i) && aU(!0, n.options[i], t[i]), "chart" !== i && -1 !== n.propsRequireUpdateSeries.indexOf(i) && (r = !0);
                }), this.collectionsWithUpdate.forEach(function(e) {
                    t[e] && (aK(t[e]).forEach(function(t, s) {
                        let o, r = aE(t.id);
                        r && (o = n.get(t.id)), !o && n[e] && (o = n[e][aV(t.index, s)]) && (r && aE(o.options.id) || o.options.isInternal) && (o = void 0), o && o.coll === e && (o.update(t, !1), i && (o.touched = !0)), !o && i && n.collectionsWithInit[e] && (n.collectionsWithInit[e][0].apply(n, [
                            t
                        ].concat(n.collectionsWithInit[e][1] || []).concat([
                            !1
                        ])).touched = !0);
                    }), i && n[e].forEach(function(t) {
                        t.touched || t.options.isInternal ? delete t.touched : d.push(t);
                    }));
                }), d.forEach(function(t) {
                    t.chart && t.remove && t.remove(!1);
                }), o && n.axes.forEach(function(t) {
                    t.update({}, !1);
                }), r && n.getSeriesOrderByLinks().forEach(function(t) {
                    t.chart && t.update({}, !1);
                }, this);
                let p = c?.width, g = c && (aY(c.height) ? a_(c.height, p || n.chartWidth) : c.height);
                a || aG(p) && p !== n.chartWidth || aG(g) && g !== n.chartHeight ? n.setSize(p, g, s) : aV(e, !0) && n.redraw(s), aW(n, "afterUpdate", {
                    options: t,
                    redraw: e,
                    animation: s
                });
            }
            setSubtitle(t, e) {
                this.applyDescription("subtitle", t), this.layOutTitles(e);
            }
            setCaption(t, e) {
                this.applyDescription("caption", t), this.layOutTitles(e);
            }
            showResetZoom() {
                let t = this, e = ay.lang, i = t.zooming.resetButton, s = i.theme, o = "chart" === i.relativeTo || "spacingBox" === i.relativeTo ? null : "plotBox";
                function r() {
                    t.zoomOut();
                }
                aW(this, "beforeShowResetZoom", null, function() {
                    t.resetZoomButton = t.renderer.button(e.resetZoom, null, null, r, s).attr({
                        align: i.position.align,
                        title: e.resetZoomTitle
                    }).addClass("highcharts-reset-zoom").add().align(i.position, !1, o);
                }), aW(this, "afterShowResetZoom");
            }
            zoomOut() {
                aW(this, "selection", {
                    resetSelection: !0
                }, ()=>this.transform({
                        reset: !0,
                        trigger: "zoom"
                    }));
            }
            pan(t, e) {
                let i = this, s = "object" == typeof e ? e : {
                    enabled: e,
                    type: "x"
                }, o = s.type, r = o && i[({
                    x: "xAxis",
                    xy: "axes",
                    y: "yAxis"
                })[o]].filter((t)=>t.options.panningEnabled && !t.options.isInternal), a = i.options.chart;
                a?.panning && (a.panning = s), aW(this, "pan", {
                    originalEvent: t
                }, ()=>{
                    i.transform({
                        axes: r,
                        event: t,
                        to: {
                            x: t.chartX - (i.mouseDownX || 0),
                            y: t.chartY - (i.mouseDownY || 0)
                        },
                        trigger: "pan"
                    }), aO(i.container, {
                        cursor: "move"
                    });
                });
            }
            transform(t) {
                let { axes: e = this.axes, event: i, from: s = {}, reset: o, selection: r, to: a = {}, trigger: n } = t, { inverted: h, time: l } = this;
                this.hoverPoints?.forEach((t)=>t.setState()), aW(this, "transform", t);
                let d = t.hasZoomed || !1, c, p;
                for (let t of e){
                    let { horiz: e, len: g, minPointOffset: u = 0, options: f, reversed: m } = t, x = e ? "width" : "height", y = e ? "x" : "y", b = aV(a[x], t.len), v = aV(s[x], t.len), k = 10 > Math.abs(b) ? 1 : b / v, w = (s[y] || 0) + v / 2 - t.pos, M = w - ((a[y] ?? t.pos) + b / 2 - t.pos) / k, S = m && !h || !m && h ? -1 : 1;
                    if (!o && (w < 0 || w > t.len)) continue;
                    let T = t.chart.polar || t.isOrdinal ? 0 : u * S || 0, C = t.toValue(M, !0), A = t.toValue(M + g / k, !0), P = C + T, L = A - T, O = t.allExtremes;
                    if (r && r[t.coll].push({
                        axis: t,
                        min: Math.min(C, A),
                        max: Math.max(C, A)
                    }), P > L && ([P, L] = [
                        L,
                        P
                    ]), 1 === k && !o && "yAxis" === t.coll && !O) {
                        for (let e of t.series){
                            let t = e.getExtremes(e.getProcessedData(!0).modified.getColumn("y") || [], !0);
                            O ?? (O = {
                                dataMin: Number.MAX_VALUE,
                                dataMax: -Number.MAX_VALUE
                            }), aG(t.dataMin) && aG(t.dataMax) && (O.dataMin = Math.min(t.dataMin, O.dataMin), O.dataMax = Math.max(t.dataMax, O.dataMax));
                        }
                        t.allExtremes = O;
                    }
                    let { dataMin: E, dataMax: I, min: D, max: B } = az(t.getExtremes(), O || {}), N = l.parse(f.min), z = l.parse(f.max), R = E ?? N, W = I ?? z, H = L - P, X = t.categories ? 0 : Math.min(H, W - R), F = R - X * (aE(N) ? 0 : f.minPadding), G = W + X * (aE(z) ? 0 : f.maxPadding), j = t.allowZoomOutside || 1 === k || "zoom" !== n && k > 1, Y = Math.min(N ?? F, F, j ? D : F), U = Math.max(z ?? G, G, j ? B : G);
                    (!t.isOrdinal || 1 !== k || o) && (P < Y && (P = Y, k >= 1 && (L = P + H)), L > U && (L = U, k >= 1 && (P = L - H)), (o || t.series.length && (P !== D || L !== B) && P >= Y && L <= U) && (r ? r[t.coll].push({
                        axis: t,
                        min: P,
                        max: L
                    }) : (t.isPanning = "zoom" !== n, t.isPanning && (p = !0), t.setExtremes(o ? void 0 : P, o ? void 0 : L, !1, !1, {
                        move: M,
                        trigger: n,
                        scale: k
                    }), !o && (P > Y || L < U) && "mousewheel" !== n && (c = !0)), d = !0), this.hasCartesianSeries || o || "mousewheel" === n || (c = !0), i && (this[e ? "mouseDownX" : "mouseDownY"] = i[e ? "chartX" : "chartY"]));
                }
                return d && (r ? aW(this, "selection", r, ()=>{
                    delete t.selection, t.trigger = "zoom", this.transform(t);
                }) : (!c || p || this.resetZoomButton ? !c && this.resetZoomButton && (this.resetZoomButton = this.resetZoomButton.destroy()) : this.showResetZoom(), this.redraw("zoom" === n && (this.options.chart.animation ?? this.pointCount < 100)))), d;
            }
        }
        az(a0.prototype, {
            callbacks: [],
            collectionsWithInit: {
                xAxis: [
                    a0.prototype.addAxis,
                    [
                        !0
                    ]
                ],
                yAxis: [
                    a0.prototype.addAxis,
                    [
                        !1
                    ]
                ],
                series: [
                    a0.prototype.addSeries
                ]
            },
            collectionsWithUpdate: [
                "xAxis",
                "yAxis",
                "series"
            ],
            propsRequireDirtyBox: [
                "backgroundColor",
                "borderColor",
                "borderWidth",
                "borderRadius",
                "plotBackgroundColor",
                "plotBackgroundImage",
                "plotBorderColor",
                "plotBorderWidth",
                "plotShadow",
                "shadow"
            ],
            propsRequireReflow: [
                "margin",
                "marginTop",
                "marginRight",
                "marginBottom",
                "marginLeft",
                "spacing",
                "spacingTop",
                "spacingRight",
                "spacingBottom",
                "spacingLeft"
            ],
            propsRequireUpdateSeries: [
                "chart.inverted",
                "chart.polar",
                "chart.ignoreHiddenSeries",
                "chart.type",
                "colors",
                "plotOptions",
                "time",
                "tooltip"
            ]
        });
        let { stop: a1 } = tU, { composed: a2 } = w, { addEvent: a3, createElement: a5, css: a6, defined: a9, erase: a4, merge: a8, pushUnique: a7 } = V;
        function nt() {
            let t = this.scrollablePlotArea;
            (this.scrollablePixelsX || this.scrollablePixelsY) && !t && (this.scrollablePlotArea = t = new ni(this)), t?.applyFixed();
        }
        function ne() {
            this.chart.scrollablePlotArea && (this.chart.scrollablePlotArea.isDirty = !0);
        }
        class ni {
            static compose(t, e, i) {
                a7(a2, this.compose) && (a3(t, "afterInit", ne), a3(e, "afterSetChartSize", (t)=>this.afterSetSize(t.target, t)), a3(e, "render", nt), a3(i, "show", ne));
            }
            static afterSetSize(t, e) {
                let i, s, o, { minWidth: r, minHeight: a } = t.options.chart.scrollablePlotArea || {}, { clipBox: n, plotBox: h, inverted: l, renderer: d } = t;
                if (!d.forExport) {
                    if (r ? (t.scrollablePixelsX = i = Math.max(0, r - t.chartWidth), i && (t.scrollablePlotBox = a8(t.plotBox), h.width = t.plotWidth += i, n[l ? "height" : "width"] += i, o = !0)) : a && (t.scrollablePixelsY = s = Math.max(0, a - t.chartHeight), a9(s) && (t.scrollablePlotBox = a8(t.plotBox), h.height = t.plotHeight += s, n[l ? "width" : "height"] += s, o = !1)), a9(o)) {
                        if (!e.skipAxes) for (let e of t.axes)(e.horiz === o || t.hasParallelCoordinates && "yAxis" === e.coll) && (e.setAxisSize(), e.setAxisTranslation());
                    } else delete t.scrollablePlotBox;
                }
            }
            constructor(t){
                let e, i = t.options.chart, s = eg.getRendererType(), o = i.scrollablePlotArea || {}, r = this.moveFixedElements.bind(this), a = {
                    WebkitOverflowScrolling: "touch",
                    overflowX: "hidden",
                    overflowY: "hidden"
                };
                t.scrollablePixelsX && (a.overflowX = "auto"), t.scrollablePixelsY && (a.overflowY = "auto"), this.chart = t;
                let n = this.parentDiv = a5("div", {
                    className: "highcharts-scrolling-parent"
                }, {
                    position: "relative"
                }, t.renderTo), h = this.scrollingContainer = a5("div", {
                    className: "highcharts-scrolling"
                }, a, n), l = this.innerContainer = a5("div", {
                    className: "highcharts-inner-container"
                }, void 0, h), d = this.fixedDiv = a5("div", {
                    className: "highcharts-fixed"
                }, {
                    position: "absolute",
                    overflow: "hidden",
                    pointerEvents: "none",
                    zIndex: (i.style?.zIndex || 0) + 2,
                    top: 0
                }, void 0, !0), c = this.fixedRenderer = new s(d, t.chartWidth, t.chartHeight, i.style);
                this.mask = c.path().attr({
                    fill: i.backgroundColor || "#fff",
                    "fill-opacity": o.opacity ?? .85,
                    zIndex: -1
                }).addClass("highcharts-scrollable-mask").add(), h.parentNode.insertBefore(d, h), a6(t.renderTo, {
                    overflow: "visible"
                }), a3(t, "afterShowResetZoom", r), a3(t, "afterApplyDrilldown", r), a3(t, "afterLayOutTitles", r), a3(h, "scroll", ()=>{
                    let { pointer: i, hoverPoint: s } = t;
                    i && (delete i.chartPosition, s && (e = s), i.runPointActions(void 0, e, !0));
                }), l.appendChild(t.container);
            }
            applyFixed() {
                let { chart: t, fixedRenderer: e, isDirty: i, scrollingContainer: s } = this, { axisOffset: o, chartWidth: r, chartHeight: a, container: n, plotHeight: h, plotLeft: l, plotTop: d, plotWidth: c, scrollablePixelsX: p = 0, scrollablePixelsY: g = 0 } = t, { scrollPositionX: u = 0, scrollPositionY: f = 0 } = t.options.chart.scrollablePlotArea || {}, m = r + p, x = a + g;
                e.setSize(r, a), (i ?? !0) && (this.isDirty = !1, this.moveFixedElements()), a1(t.container), a6(n, {
                    width: `${m}px`,
                    height: `${x}px`
                }), t.renderer.boxWrapper.attr({
                    width: m,
                    height: x,
                    viewBox: [
                        0,
                        0,
                        m,
                        x
                    ].join(" ")
                }), t.chartBackground?.attr({
                    width: m,
                    height: x
                }), a6(s, {
                    width: `${r}px`,
                    height: `${a}px`
                }), a9(i) || (s.scrollLeft = p * u, s.scrollTop = g * f);
                let y = d - o[0] - 1, b = l - o[3] - 1, v = d + h + o[2] + 1, k = l + c + o[1] + 1, w = l + c - p, M = d + h - g, S = [
                    [
                        "M",
                        0,
                        0
                    ]
                ];
                p ? S = [
                    [
                        "M",
                        0,
                        y
                    ],
                    [
                        "L",
                        l - 1,
                        y
                    ],
                    [
                        "L",
                        l - 1,
                        v
                    ],
                    [
                        "L",
                        0,
                        v
                    ],
                    [
                        "Z"
                    ],
                    [
                        "M",
                        w,
                        y
                    ],
                    [
                        "L",
                        r,
                        y
                    ],
                    [
                        "L",
                        r,
                        v
                    ],
                    [
                        "L",
                        w,
                        v
                    ],
                    [
                        "Z"
                    ]
                ] : g && (S = [
                    [
                        "M",
                        b,
                        0
                    ],
                    [
                        "L",
                        b,
                        d - 1
                    ],
                    [
                        "L",
                        k,
                        d - 1
                    ],
                    [
                        "L",
                        k,
                        0
                    ],
                    [
                        "Z"
                    ],
                    [
                        "M",
                        b,
                        M
                    ],
                    [
                        "L",
                        b,
                        a
                    ],
                    [
                        "L",
                        k,
                        a
                    ],
                    [
                        "L",
                        k,
                        M
                    ],
                    [
                        "Z"
                    ]
                ]), "adjustHeight" !== t.redrawTrigger && this.mask.attr({
                    d: S
                });
            }
            moveFixedElements() {
                let t, { container: e, inverted: i, scrollablePixelsX: s, scrollablePixelsY: o } = this.chart, r = this.fixedRenderer, a = ni.fixedSelectors;
                if (s && !i ? t = ".highcharts-yaxis" : s && i || o && !i ? t = ".highcharts-xaxis" : o && i && (t = ".highcharts-yaxis"), t && !(this.chart.hasParallelCoordinates && ".highcharts-yaxis" === t)) for (let e of [
                    `${t}:not(.highcharts-radial-axis)`,
                    `${t}-labels:not(.highcharts-radial-axis-labels)`
                ])a7(a, e);
                else for (let t of [
                    ".highcharts-xaxis",
                    ".highcharts-yaxis"
                ])for (let e of [
                    `${t}:not(.highcharts-radial-axis)`,
                    `${t}-labels:not(.highcharts-radial-axis-labels)`
                ])a4(a, e);
                for (let t of a)[].forEach.call(e.querySelectorAll(t), (t)=>{
                    (t.namespaceURI === r.SVG_NS ? r.box : r.box.parentNode).appendChild(t), t.style.pointerEvents = "auto";
                });
            }
        }
        ni.fixedSelectors = [
            ".highcharts-breadcrumbs-group",
            ".highcharts-contextbutton",
            ".highcharts-caption",
            ".highcharts-credits",
            ".highcharts-drillup-button",
            ".highcharts-legend",
            ".highcharts-legend-checkbox",
            ".highcharts-navigator-series",
            ".highcharts-navigator-xaxis",
            ".highcharts-navigator-yaxis",
            ".highcharts-navigator",
            ".highcharts-range-selector-group",
            ".highcharts-reset-zoom",
            ".highcharts-scrollbar",
            ".highcharts-subtitle",
            ".highcharts-title"
        ];
        let { format: ns } = ep, { series: no } = rk, { destroyObjectProperties: nr, fireEvent: na, getAlignFactor: nn, isNumber: nh, pick: nl } = V, nd = class {
            constructor(t, e, i, s, o){
                let r = t.chart.inverted, a = t.reversed;
                this.axis = t;
                let n = this.isNegative = !!i != !!a;
                this.options = e = e || {}, this.x = s, this.total = null, this.cumulative = null, this.points = {}, this.hasValidPoints = !1, this.stack = o, this.leftCliff = 0, this.rightCliff = 0, this.alignOptions = {
                    align: e.align || (r ? n ? "left" : "right" : "center"),
                    verticalAlign: e.verticalAlign || (r ? "middle" : n ? "bottom" : "top"),
                    y: e.y,
                    x: e.x
                }, this.textAlign = e.textAlign || (r ? n ? "right" : "left" : "center");
            }
            destroy() {
                nr(this, this.axis);
            }
            render(t) {
                let e = this.axis.chart, i = this.options, s = i.format, o = s ? ns(s, this, e) : i.formatter.call(this);
                if (this.label) this.label.attr({
                    text: o,
                    visibility: "hidden"
                });
                else {
                    this.label = e.renderer.label(o, null, void 0, i.shape, void 0, void 0, i.useHTML, !1, "stack-labels");
                    let s = {
                        r: i.borderRadius || 0,
                        text: o,
                        padding: nl(i.padding, 5),
                        visibility: "hidden"
                    };
                    e.styledMode || (s.fill = i.backgroundColor, s.stroke = i.borderColor, s["stroke-width"] = i.borderWidth, this.label.css(i.style || {})), this.label.attr(s), this.label.added || this.label.add(t);
                }
                this.label.labelrank = e.plotSizeY, na(this, "afterRender");
            }
            setOffset(t, e, i, s, o, r) {
                let { alignOptions: a, axis: n, label: h, options: l, textAlign: d } = this, c = n.chart, p = this.getStackBox({
                    xOffset: t,
                    width: e,
                    boxBottom: i,
                    boxTop: s,
                    defaultX: o,
                    xAxis: r
                }), { verticalAlign: g } = a;
                if (h && p) {
                    let t = h.getBBox(void 0, 0), e = h.padding, i = "justify" === nl(l.overflow, "justify"), s;
                    a.x = l.x || 0, a.y = l.y || 0;
                    let { x: o, y: r } = this.adjustStackPosition({
                        labelBox: t,
                        verticalAlign: g,
                        textAlign: d
                    });
                    p.x -= o, p.y -= r, h.align(a, !1, p), (s = c.isInsidePlot(h.alignAttr.x + a.x + o, h.alignAttr.y + a.y + r)) || (i = !1), i && no.prototype.justifyDataLabel.call(n, h, a, h.alignAttr, t, p), h.attr({
                        x: h.alignAttr.x,
                        y: h.alignAttr.y,
                        rotation: l.rotation,
                        rotationOriginX: t.width * nn(l.textAlign || "center"),
                        rotationOriginY: t.height / 2
                    }), nl(!i && l.crop, !0) && (s = nh(h.x) && nh(h.y) && c.isInsidePlot(h.x - e + (h.width || 0), h.y) && c.isInsidePlot(h.x + e, h.y)), h[s ? "show" : "hide"]();
                }
                na(this, "afterSetOffset", {
                    xOffset: t,
                    width: e
                });
            }
            adjustStackPosition({ labelBox: t, verticalAlign: e, textAlign: i }) {
                return {
                    x: t.width / 2 + t.width / 2 * (2 * nn(i) - 1),
                    y: t.height / 2 * 2 * (1 - nn(e))
                };
            }
            getStackBox(t) {
                let e = this.axis, i = e.chart, { boxTop: s, defaultX: o, xOffset: r, width: a, boxBottom: n } = t, h = e.stacking.usePercentage ? 100 : nl(s, this.total, 0), l = e.toPixels(h), d = t.xAxis || i.xAxis[0], c = nl(o, d.translate(this.x)) + r, p = Math.abs(l - e.toPixels(n || nh(e.min) && e.logarithmic && e.logarithmic.lin2log(e.min) || 0)), g = i.inverted, u = this.isNegative;
                return g ? {
                    x: (u ? l : l - p) - i.plotLeft,
                    y: d.height - c - a + d.top - i.plotTop,
                    width: p,
                    height: a
                } : {
                    x: c + d.transB - i.plotLeft,
                    y: (u ? l - p : l) - i.plotTop,
                    width: a,
                    height: p
                };
            }
        }, { getDeferredAnimation: nc } = tU, { series: { prototype: np } } = rk, { addEvent: ng, correctFloat: nu, defined: nf, destroyObjectProperties: nm, fireEvent: nx, isNumber: ny, objectEach: nb, pick: nv } = V;
        function nk() {
            let t = this.inverted;
            this.axes.forEach((t)=>{
                t.stacking?.stacks && t.hasVisibleSeries && (t.stacking.oldStacks = t.stacking.stacks);
            }), this.series.forEach((e)=>{
                let i = e.xAxis?.options || {};
                e.options.stacking && e.reserveSpace() && (e.stackKey = [
                    e.type,
                    nv(e.options.stack, ""),
                    t ? i.top : i.left,
                    t ? i.height : i.width
                ].join(","));
            });
        }
        function nw() {
            let t = this.stacking;
            if (t) {
                let e = t.stacks;
                nb(e, (t, i)=>{
                    nm(t), delete e[i];
                }), t.stackTotalGroup?.destroy();
            }
        }
        function nM() {
            this.stacking || (this.stacking = new nL(this));
        }
        function nS(t, e, i, s) {
            return !nf(t) || t.x !== e || s && t.stackKey !== s ? t = {
                x: e,
                index: 0,
                key: s,
                stackKey: s
            } : t.index++, t.key = [
                i,
                e,
                t.index
            ].join(","), t;
        }
        function nT() {
            let t, e = this, i = e.yAxis, s = e.stackKey || "", o = i.stacking.stacks, r = e.getColumn("x", !0), a = e.options.stacking, n = e[a + "Stacker"];
            n && [
                s,
                "-" + s
            ].forEach((i)=>{
                let s = r.length, a, h, l;
                for(; s--;)a = r[s], t = e.getStackIndicator(t, a, e.index, i), h = o[i]?.[a], (l = h?.points[t.key || ""]) && n.call(e, l, h, s);
            });
        }
        function nC(t, e, i) {
            let s = e.total ? 100 / e.total : 0;
            t[0] = nu(t[0] * s), t[1] = nu(t[1] * s), this.stackedYData[i] = t[1];
        }
        function nA(t) {
            (this.is("column") || this.is("columnrange")) && (this.options.centerInCategory && this.chart.series.length > 1 ? np.setStackedPoints.call(this, t, "group") : t.stacking.resetStacks());
        }
        function nP(t, e) {
            let i, s, o, r, a, n, h, l = e || this.options.stacking;
            if (!l || !this.reserveSpace() || (({
                group: "xAxis"
            })[l] || "yAxis") !== t.coll) return;
            let d = this.getColumn("x", !0), c = this.getColumn(this.pointValKey || "y", !0), p = [], g = c.length, u = this.options, f = u.threshold || 0, m = u.startFromThreshold ? f : 0, x = u.stack, y = e ? `${this.type},${l}` : this.stackKey || "", b = "-" + y, v = this.negStacks, k = t.stacking, w = k.stacks, M = k.oldStacks;
            for(k.stacksTouched += 1, h = 0; h < g; h++){
                let e = d[h] || 0, g = c[h], u = ny(g) && g || 0;
                n = (i = this.getStackIndicator(i, e, this.index)).key || "", w[a = (s = v && u < (m ? 0 : f)) ? b : y] || (w[a] = {}), w[a][e] || (M[a]?.[e] ? (w[a][e] = M[a][e], w[a][e].total = null) : w[a][e] = new nd(t, t.options.stackLabels, !!s, e, x)), o = w[a][e], null !== g ? (o.points[n] = o.points[this.index] = [
                    nv(o.cumulative, m)
                ], nf(o.cumulative) || (o.base = n), o.touched = k.stacksTouched, i.index > 0 && !1 === this.singleStacks && (o.points[n][0] = o.points[this.index + "," + e + ",0"][0])) : (delete o.points[n], delete o.points[this.index]);
                let S = o.total || 0;
                "percent" === l ? (r = s ? y : b, S = v && w[r]?.[e] ? (r = w[r][e]).total = Math.max(r.total || 0, S) + Math.abs(u) : nu(S + Math.abs(u))) : "group" === l ? ny(g) && S++ : S = nu(S + u), "group" === l ? o.cumulative = (S || 1) - 1 : o.cumulative = nu(nv(o.cumulative, m) + u), o.total = S, null !== g && (o.points[n].push(o.cumulative), p[h] = o.cumulative, o.hasValidPoints = !0);
            }
            "percent" === l && (k.usePercentage = !0), "group" !== l && (this.stackedYData = p), k.oldStacks = {};
        }
        class nL {
            constructor(t){
                this.oldStacks = {}, this.stacks = {}, this.stacksTouched = 0, this.axis = t;
            }
            buildStacks() {
                let t, e, i = this.axis, s = i.series, o = "xAxis" === i.coll, r = i.options.reversedStacks, a = s.length;
                for(this.resetStacks(), this.usePercentage = !1, e = a; e--;)t = s[r ? e : a - e - 1], o && t.setGroupedPoints(i), t.setStackedPoints(i);
                if (!o) for(e = 0; e < a; e++)s[e].modifyStacks();
                nx(i, "afterBuildStacks");
            }
            cleanStacks() {
                this.oldStacks && (this.stacks = this.oldStacks, nb(this.stacks, (t)=>{
                    nb(t, (t)=>{
                        t.cumulative = t.total;
                    });
                }));
            }
            resetStacks() {
                nb(this.stacks, (t)=>{
                    nb(t, (e, i)=>{
                        ny(e.touched) && e.touched < this.stacksTouched ? (e.destroy(), delete t[i]) : (e.total = null, e.cumulative = null);
                    });
                });
            }
            renderStackTotals() {
                let t = this.axis, e = t.chart, i = e.renderer, s = this.stacks, o = nc(e, t.options.stackLabels?.animation || !1), r = this.stackTotalGroup = this.stackTotalGroup || i.g("stack-labels").attr({
                    zIndex: 6,
                    opacity: 0
                }).add();
                r.translate(e.plotLeft, e.plotTop), nb(s, (t)=>{
                    nb(t, (t)=>{
                        t.render(r);
                    });
                }), r.animate({
                    opacity: 1
                }, o);
            }
        }
        (g || (g = {})).compose = function(t, e, i) {
            let s = e.prototype, o = i.prototype;
            s.getStacks || (ng(t, "init", nM), ng(t, "destroy", nw), s.getStacks = nk, o.getStackIndicator = nS, o.modifyStacks = nT, o.percentStacker = nC, o.setGroupedPoints = nA, o.setStackedPoints = nP);
        };
        let nO = g, { defined: nE, merge: nI, isObject: nD } = V;
        class nB extends r1 {
            drawGraph() {
                let t = this.options, e = (this.gappedPath || this.getGraphPath).call(this), i = this.chart.styledMode;
                [
                    this,
                    ...this.zones
                ].forEach((s, o)=>{
                    let r, a = s.graph, n = a ? "animate" : "attr", h = s.dashStyle || t.dashStyle;
                    a ? (a.endX = this.preventGraphAnimation ? null : e.xMap, a.animate({
                        d: e
                    })) : e.length && (s.graph = a = this.chart.renderer.path(e).addClass("highcharts-graph" + (o ? ` highcharts-zone-graph-${o - 1} ` : " ") + (o && s.className || "")).attr({
                        zIndex: 1
                    }).add(this.group)), a && !i && (r = {
                        stroke: !o && t.lineColor || s.color || this.color || "#cccccc",
                        "stroke-width": t.lineWidth || 0,
                        fill: this.fillGraph && this.color || "none"
                    }, h ? r.dashstyle = h : "square" !== t.linecap && (r["stroke-linecap"] = r["stroke-linejoin"] = "round"), a[n](r).shadow(t.shadow && nI({
                        filterUnits: "userSpaceOnUse"
                    }, nD(t.shadow) ? t.shadow : {}))), a && (a.startX = e.xMap, a.isArea = e.isArea);
                });
            }
            getGraphPath(t, e, i) {
                let s = this, o = s.options, r = [], a = [], n, h = o.step, l = (t = t || s.points).reversed;
                return l && t.reverse(), (h = ({
                    right: 1,
                    center: 2
                })[h] || h && 3) && l && (h = 4 - h), (t = this.getValidPoints(t, !1, o.nullInteraction || !(o.connectNulls && !e && !i))).forEach(function(l, d) {
                    let c, p = l.plotX, g = l.plotY, u = t[d - 1], f = l.isNull || "number" != typeof g;
                    (l.leftCliff || u?.rightCliff) && !i && (n = !0), f && !nE(e) && d > 0 ? n = !o.connectNulls : f && !e ? n = !0 : (0 === d || n ? c = [
                        [
                            "M",
                            l.plotX,
                            l.plotY
                        ]
                    ] : s.getPointSpline ? c = [
                        s.getPointSpline(t, l, d)
                    ] : h ? (c = 1 === h ? [
                        [
                            "L",
                            u.plotX,
                            g
                        ]
                    ] : 2 === h ? [
                        [
                            "L",
                            (u.plotX + p) / 2,
                            u.plotY
                        ],
                        [
                            "L",
                            (u.plotX + p) / 2,
                            g
                        ]
                    ] : [
                        [
                            "L",
                            p,
                            u.plotY
                        ]
                    ]).push([
                        "L",
                        p,
                        g
                    ]) : c = [
                        [
                            "L",
                            p,
                            g
                        ]
                    ], a.push(l.x), h && (a.push(l.x), 2 === h && a.push(l.x)), r.push.apply(r, c), n = !1);
                }), r.xMap = a, s.graphPath = r, r;
            }
        }
        nB.defaultOptions = nI(r1.defaultOptions, {
            legendSymbol: "lineMarker"
        }), rk.registerSeriesType("line", nB);
        let { seriesTypes: { line: nN } } = rk, { extend: nz, merge: nR, objectEach: nW, pick: nH } = V;
        class nX extends nN {
            drawGraph() {
                this.areaPath = [], super.drawGraph.apply(this);
                let { areaPath: t, options: e } = this;
                [
                    this,
                    ...this.zones
                ].forEach((i, s)=>{
                    let o = {}, r = i.fillColor || e.fillColor, a = i.area, n = a ? "animate" : "attr";
                    a ? (a.endX = this.preventGraphAnimation ? null : t.xMap, a.animate({
                        d: t
                    })) : (o.zIndex = 0, (a = i.area = this.chart.renderer.path(t).addClass("highcharts-area" + (s ? ` highcharts-zone-area-${s - 1} ` : " ") + (s && i.className || "")).add(this.group)).isArea = !0), this.chart.styledMode || (o.fill = r || i.color || this.color, o["fill-opacity"] = r ? 1 : e.fillOpacity ?? .75, a.css({
                        pointerEvents: this.stickyTracking ? "none" : "auto"
                    })), a[n](o), a.startX = t.xMap, a.shiftUnit = e.step ? 2 : 1;
                });
            }
            getGraphPath(t) {
                let e, i, s, o = nN.prototype.getGraphPath, r = this.options, a = r.stacking, n = this.yAxis, h = [], l = [], d = this.index, c = n.stacking.stacks[this.stackKey], p = r.threshold, g = Math.round(n.getThreshold(r.threshold)), u = nH(r.connectNulls, "percent" === a), f = function(i, s, o) {
                    let r = t[i], u = a && c[r.x].points[d], f = r[o + "Null"] || 0, m = r[o + "Cliff"] || 0, x, y, b = !0;
                    m || f ? (x = (f ? u[0] : u[1]) + m, y = u[0] + m, b = !!f) : !a && t[s] && t[s].isNull && (x = y = p), void 0 !== x && (l.push({
                        plotX: e,
                        plotY: null === x ? g : n.getThreshold(x),
                        isNull: b,
                        isCliff: !0
                    }), h.push({
                        plotX: e,
                        plotY: null === y ? g : n.getThreshold(y),
                        doCurve: !1
                    }));
                };
                t = t || this.points, a && (t = this.getStackPoints(t));
                for(let o = 0, r = t.length; o < r; ++o)a || (t[o].leftCliff = t[o].rightCliff = t[o].leftNull = t[o].rightNull = void 0), i = t[o].isNull, e = nH(t[o].rectPlotX, t[o].plotX), s = a ? nH(t[o].yBottom, g) : g, (!i || u) && (u || f(o, o - 1, "left"), i && !a && u || (l.push(t[o]), h.push({
                    x: o,
                    plotX: e,
                    plotY: s
                })), u || f(o, o + 1, "right"));
                let m = o.call(this, l, !0, !0);
                h.reversed = !0;
                let x = o.call(this, h, !0, !0), y = x[0];
                y && "M" === y[0] && (x[0] = [
                    "L",
                    y[1],
                    y[2]
                ]);
                let b = m.concat(x);
                b.length && b.push([
                    "Z"
                ]);
                let v = o.call(this, l, !1, u);
                return this.chart.series.length > 1 && a && l.some((t)=>t.isCliff) && (b.hasStackedCliffs = v.hasStackedCliffs = !0), b.xMap = m.xMap, this.areaPath = b, v;
            }
            getStackPoints(t) {
                let e = this, i = [], s = [], o = this.xAxis, r = this.yAxis, a = r.stacking.stacks[this.stackKey], n = {}, h = r.series, l = h.length, d = r.options.reversedStacks ? 1 : -1, c = h.indexOf(e);
                if (t = t || this.points, this.options.stacking) {
                    for(let e = 0; e < t.length; e++)t[e].leftNull = t[e].rightNull = void 0, n[t[e].x] = t[e];
                    nW(a, function(t, e) {
                        null !== t.total && s.push(e);
                    }), s.sort(function(t, e) {
                        return t - e;
                    });
                    let p = h.map((t)=>t.visible);
                    s.forEach(function(t, g) {
                        let u = 0, f, m;
                        if (n[t] && !n[t].isNull) i.push(n[t]), [
                            -1,
                            1
                        ].forEach(function(i) {
                            let o = 1 === i ? "rightNull" : "leftNull", r = a[s[g + i]], u = 0;
                            if (r) {
                                let i = c;
                                for(; i >= 0 && i < l;){
                                    let s = h[i].index;
                                    !(f = r.points[s]) && (s === e.index ? n[t][o] = !0 : p[i] && (m = a[t].points[s]) && (u -= m[1] - m[0])), i += d;
                                }
                            }
                            n[t][1 === i ? "rightCliff" : "leftCliff"] = u;
                        });
                        else {
                            let e = c;
                            for(; e >= 0 && e < l;){
                                let i = h[e].index;
                                if (f = a[t].points[i]) {
                                    u = f[1];
                                    break;
                                }
                                e += d;
                            }
                            u = nH(u, 0), u = r.translate(u, 0, 1, 0, 1), i.push({
                                isNull: !0,
                                plotX: o.translate(t, 0, 0, 0, 1),
                                x: t,
                                plotY: u,
                                yBottom: u
                            });
                        }
                    });
                }
                return i;
            }
        }
        nX.defaultOptions = nR(nN.defaultOptions, {
            threshold: 0,
            legendSymbol: "areaMarker"
        }), nz(nX.prototype, {
            singleStacks: !1
        }), rk.registerSeriesType("area", nX);
        let { line: nF } = rk.seriesTypes, { merge: nG, pick: nj } = V;
        class nY extends nF {
            getPointSpline(t, e, i) {
                let s, o, r, a, n = e.plotX || 0, h = e.plotY || 0, l = t[i - 1], d = t[i + 1];
                function c(t) {
                    return t && !t.isNull && !1 !== t.doCurve && !e.isCliff;
                }
                if (c(l) && c(d)) {
                    let t = l.plotX || 0, i = l.plotY || 0, c = d.plotX || 0, p = d.plotY || 0, g = 0;
                    s = (1.5 * n + t) / 2.5, o = (1.5 * h + i) / 2.5, r = (1.5 * n + c) / 2.5, a = (1.5 * h + p) / 2.5, r !== s && (g = (a - o) * (r - n) / (r - s) + h - a), o += g, a += g, o > i && o > h ? (o = Math.max(i, h), a = 2 * h - o) : o < i && o < h && (o = Math.min(i, h), a = 2 * h - o), a > p && a > h ? (a = Math.max(p, h), o = 2 * h - a) : a < p && a < h && (a = Math.min(p, h), o = 2 * h - a), e.rightContX = r, e.rightContY = a, e.controlPoints = {
                        low: [
                            s,
                            o
                        ],
                        high: [
                            r,
                            a
                        ]
                    };
                }
                let p = [
                    "C",
                    nj(l.rightContX, l.plotX, 0),
                    nj(l.rightContY, l.plotY, 0),
                    nj(s, n, 0),
                    nj(o, h, 0),
                    n,
                    h
                ];
                return l.rightContX = l.rightContY = void 0, p;
            }
        }
        nY.defaultOptions = nG(nF.defaultOptions), rk.registerSeriesType("spline", nY);
        let nU = nY, { area: n$, area: { prototype: nV } } = rk.seriesTypes, { extend: nZ, merge: n_ } = V;
        class nq extends nU {
        }
        nq.defaultOptions = n_(nU.defaultOptions, n$.defaultOptions), nZ(nq.prototype, {
            getGraphPath: nV.getGraphPath,
            getStackPoints: nV.getStackPoints,
            drawGraph: nV.drawGraph
        }), rk.registerSeriesType("areaspline", nq);
        let { animObject: nK } = tU, { parse: nJ } = tL, { noop: nQ } = w, { clamp: n0, crisp: n1, defined: n2, extend: n3, fireEvent: n5, isArray: n6, isNumber: n9, merge: n4, pick: n8, objectEach: n7 } = V;
        class ht extends r1 {
            animate(t) {
                let e, i, s = this, o = this.yAxis, r = o.pos, a = o.reversed, n = s.options, { clipOffset: h, inverted: l } = this.chart, d = {}, c = l ? "translateX" : "translateY";
                t && h ? (d.scaleY = .001, i = n0(o.toPixels(n.threshold || 0), r, r + o.len), l ? d.translateX = (i += a ? -Math.floor(h[0]) : Math.ceil(h[2])) - o.len : d.translateY = i += a ? Math.ceil(h[0]) : -Math.floor(h[2]), s.clipBox && s.setClip(), s.group.attr(d)) : (e = Number(s.group.attr(c)), s.group.animate({
                    scaleY: 1
                }, n3(nK(s.options.animation), {
                    step: function(t, i) {
                        s.group && (d[c] = e + i.pos * (r - e), s.group.attr(d));
                    }
                })));
            }
            init(t, e) {
                super.init.apply(this, arguments);
                let i = this;
                (t = i.chart).hasRendered && t.series.forEach(function(t) {
                    t.type === i.type && (t.isDirty = !0);
                });
            }
            getColumnMetrics() {
                let t = this, e = t.options, i = t.xAxis, s = t.yAxis, o = i.options.reversedStacks, r = i.reversed && !o || !i.reversed && o, a = {}, n, h = 0;
                !1 === e.grouping ? h = 1 : t.chart.series.forEach(function(e) {
                    let i, o = e.yAxis, r = e.options;
                    e.type === t.type && e.reserveSpace() && s.len === o.len && s.pos === o.pos && (r.stacking && "group" !== r.stacking ? (void 0 === a[n = e.stackKey] && (a[n] = h++), i = a[n]) : !1 !== r.grouping && (i = h++), e.columnIndex = i);
                });
                let l = Math.min(Math.abs(i.transA) * (!i.brokenAxis?.hasBreaks && i.ordinal?.slope || e.pointRange || i.closestPointRange || i.tickInterval || 1), i.len), d = l * e.groupPadding, c = (l - 2 * d) / (h || 1), p = Math.min(e.maxPointWidth || i.len, n8(e.pointWidth, c * (1 - 2 * e.pointPadding))), g = (t.columnIndex || 0) + +!!r;
                return t.columnMetrics = {
                    width: p,
                    offset: (c - p) / 2 + (d + g * c - l / 2) * (r ? -1 : 1),
                    paddedWidth: c,
                    columnCount: h
                }, t.columnMetrics;
            }
            crispCol(t, e, i, s) {
                let o = this.borderWidth, r = this.chart.inverted;
                return s = n1(e + s, o, r) - (e = n1(e, o, r)), this.options.crisp && (i = n1(t + i, o) - (t = n1(t, o))), {
                    x: t,
                    y: e,
                    width: i,
                    height: s
                };
            }
            adjustForMissingColumns(t, e, i, s) {
                if (!i.isNull && s.columnCount > 1) {
                    let o = this.xAxis.series.filter((t)=>t.visible).map((t)=>t.index), r = 0, a = 0;
                    n7(this.xAxis.stacking?.stacks, (t)=>{
                        let e = "number" == typeof i.x ? t[i.x.toString()]?.points : void 0, s = e?.[this.index], n = {};
                        if (e && n6(s)) {
                            let t = this.index, i = Object.keys(e).filter((t)=>!t.match(",") && e[t] && e[t].length > 1).map(parseFloat).filter((t)=>-1 !== o.indexOf(t)).filter((e)=>{
                                let i = this.chart.series[e].options, s = i.stacking && i.stack;
                                if (n2(s)) {
                                    if (n9(n[s])) return t === e && (t = n[s]), !1;
                                    n[s] = e;
                                }
                                return !0;
                            }).sort((t, e)=>e - t);
                            r = i.indexOf(t), a = i.length;
                        }
                    }), r = this.xAxis.reversed ? a - 1 - r : r;
                    let n = (a - 1) * s.paddedWidth + e;
                    t = (i.plotX || 0) + n / 2 - e - r * s.paddedWidth;
                }
                return t;
            }
            translate() {
                let t = this, e = t.chart, i = t.options, s = t.dense = t.closestPointRange * t.xAxis.transA < 2, o = t.borderWidth = n8(i.borderWidth, +!s), r = t.xAxis, a = t.yAxis, n = i.threshold, h = n8(i.minPointLength, 5), l = t.getColumnMetrics(), d = l.width, c = t.pointXOffset = l.offset, p = t.dataMin, g = t.dataMax, u = t.translatedThreshold = a.getThreshold(n), f = t.barW = Math.max(d, 1 + 2 * o);
                i.pointPadding && i.crisp && (f = Math.ceil(f)), r1.prototype.translate.apply(t), t.points.forEach(function(s) {
                    let o = n8(s.yBottom, u), m = 999 + Math.abs(o), x = s.plotX || 0, y = n0(s.plotY, -m, a.len + m), b, v = Math.min(y, o), k = Math.max(y, o) - v, w = d, M = x + c, S = f;
                    h && Math.abs(k) < h && (k = h, b = !a.reversed && !s.negative || a.reversed && s.negative, n9(n) && n9(g) && s.y === n && g <= n && (a.min || 0) < n && (p !== g || (a.max || 0) <= n) && (b = !b, s.negative = !s.negative), v = Math.abs(v - u) > h ? o - h : u - (b ? h : 0)), n2(s.options.pointWidth) && (M -= Math.round(((w = S = Math.ceil(s.options.pointWidth)) - d) / 2)), i.centerInCategory && (M = t.adjustForMissingColumns(M, w, s, l)), s.barX = M, s.pointWidth = w, s.tooltipPos = e.inverted ? [
                        n0(a.len + a.pos - e.plotLeft - y, a.pos - e.plotLeft, a.len + a.pos - e.plotLeft),
                        r.len + r.pos - e.plotTop - M - S / 2,
                        k
                    ] : [
                        r.left - e.plotLeft + M + S / 2,
                        n0(y + a.pos - e.plotTop, a.pos - e.plotTop, a.len + a.pos - e.plotTop),
                        k
                    ], s.shapeType = t.pointClass.prototype.shapeType || "roundedRect", s.shapeArgs = t.crispCol(M, v, S, s.isNull ? 0 : k);
                }), n5(this, "afterColumnTranslate");
            }
            drawGraph() {
                this.group[this.dense ? "addClass" : "removeClass"]("highcharts-dense-data");
            }
            pointAttribs(t, e) {
                let i = this.options, s = this.pointAttrToOptions || {}, o = s.stroke || "borderColor", r = s["stroke-width"] || "borderWidth", a, n, h, l = t && t.color || this.color, d = t && t[o] || i[o] || l, c = t && t.options.dashStyle || i.dashStyle, p = t && t[r] || i[r] || this[r] || 0, g = t?.isNull && i.nullInteraction ? 0 : t?.opacity ?? i.opacity ?? 1;
                t && this.zones.length && (n = t.getZone(), l = t.options.color || n && (n.color || t.nonZonedColor) || this.color, n && (d = n.borderColor || d, c = n.dashStyle || c, p = n.borderWidth || p)), e && t && (h = (a = n4(i.states[e], t.options.states && t.options.states[e] || {})).brightness, l = a.color || void 0 !== h && nJ(l).brighten(a.brightness).get() || l, d = a[o] || d, p = a[r] || p, c = a.dashStyle || c, g = n8(a.opacity, g));
                let u = {
                    fill: l,
                    stroke: d,
                    "stroke-width": p,
                    opacity: g
                };
                return c && (u.dashstyle = c), u;
            }
            drawPoints(t = this.points) {
                let e, i = this, s = this.chart, o = i.options, r = o.nullInteraction, a = s.renderer, n = o.animationLimit || 250;
                t.forEach(function(t) {
                    let h = t.plotY, l = t.graphic, d = !!l, c = l && s.pointCount < n ? "animate" : "attr";
                    n9(h) && (null !== t.y || r) ? (e = t.shapeArgs, l && t.hasNewShapeType() && (l = l.destroy()), i.enabledDataSorting && (t.startXPos = i.xAxis.reversed ? -(e && e.width || 0) : i.xAxis.width), !l && (t.graphic = l = a[t.shapeType](e).add(t.group || i.group), l && i.enabledDataSorting && s.hasRendered && s.pointCount < n && (l.attr({
                        x: t.startXPos
                    }), d = !0, c = "animate")), l && d && l[c](n4(e)), s.styledMode || l[c](i.pointAttribs(t, t.selected && "select")).shadow(!1 !== t.allowShadow && o.shadow), l && (l.addClass(t.getClassName(), !0), l.attr({
                        visibility: t.visible ? "inherit" : "hidden"
                    }))) : l && (t.graphic = l.destroy());
                });
            }
            drawTracker(t = this.points) {
                let e, i = this, s = i.chart, o = s.pointer, r = function(t) {
                    o?.normalize(t);
                    let e = o?.getPointFromEvent(t);
                    o && e && i.options.enableMouseTracking && (s.isInsidePlot(t.chartX - s.plotLeft, t.chartY - s.plotTop, {
                        visiblePlotOnly: !0
                    }) || o?.inClass(t.target, "highcharts-data-label")) && (o.isDirectTouch = !0, e.onMouseOver(t));
                };
                t.forEach(function(t) {
                    e = n6(t.dataLabels) ? t.dataLabels : t.dataLabel ? [
                        t.dataLabel
                    ] : [], t.graphic && (t.graphic.element.point = t), e.forEach(function(e) {
                        (e.div || e.element).point = t;
                    });
                }), i._hasTracking || (i.trackerGroups.forEach(function(t) {
                    i[t] && (i[t].addClass("highcharts-tracker").on("mouseover", r).on("mouseout", function(t) {
                        o?.onTrackerMouseOut(t);
                    }).on("touchstart", r), !s.styledMode && i.options.cursor && i[t].css({
                        cursor: i.options.cursor
                    }));
                }), i._hasTracking = !0), n5(this, "afterDrawTracker");
            }
            remove() {
                let t = this, e = t.chart;
                e.hasRendered && e.series.forEach(function(e) {
                    e.type === t.type && (e.isDirty = !0);
                }), r1.prototype.remove.apply(t, arguments);
            }
        }
        ht.defaultOptions = n4(r1.defaultOptions, {
            borderRadius: 3,
            centerInCategory: !1,
            groupPadding: .2,
            marker: null,
            pointPadding: .1,
            minPointLength: 0,
            cropThreshold: 50,
            pointRange: null,
            states: {
                hover: {
                    halo: !1,
                    brightness: .1
                },
                select: {
                    color: "#cccccc",
                    borderColor: "#000000"
                }
            },
            dataLabels: {
                align: void 0,
                verticalAlign: void 0,
                y: void 0
            },
            startFromThreshold: !0,
            stickyTracking: !1,
            tooltip: {
                distance: 6
            },
            threshold: 0,
            borderColor: "#ffffff"
        }), n3(ht.prototype, {
            directTouch: !0,
            getSymbol: nQ,
            negStacks: !0,
            trackerGroups: [
                "group",
                "dataLabelsGroup"
            ]
        }), rk.registerSeriesType("column", ht);
        let he = ht, { getDeferredAnimation: hi } = tU, { format: hs } = ep, { defined: ho, extend: hr, fireEvent: ha, getAlignFactor: hn, isArray: hh, isString: hl, merge: hd, objectEach: hc, pick: hp, pInt: hg, splat: hu } = V;
        !function(t) {
            function e() {
                return h(this).some((t)=>t?.enabled);
            }
            function i(t, e, i, s, o) {
                let { chart: r, enabledDataSorting: a } = this, n = this.isCartesian && r.inverted, h = t.plotX, l = t.plotY, d = i.rotation || 0, c = ho(h) && ho(l) && r.isInsidePlot(h, Math.round(l), {
                    inverted: n,
                    paneCoordinates: !0,
                    series: this
                }), p = 0 === d && "justify" === hp(i.overflow, a ? "none" : "justify"), g = this.visible && !1 !== t.visible && ho(h) && (t.series.forceDL || a && !p || c || hp(i.inside, !!this.options.stacking) && s && r.isInsidePlot(h, n ? s.x + 1 : s.y + s.height - 1, {
                    inverted: n,
                    paneCoordinates: !0,
                    series: this
                })), u = t.pos();
                if (g && u) {
                    var f;
                    let h = e.getBBox(), l = e.getBBox(void 0, 0);
                    if (s = hr({
                        x: u[0],
                        y: Math.round(u[1]),
                        width: 0,
                        height: 0
                    }, s || {}), "plotEdges" === i.alignTo && this.isCartesian && (s[n ? "x" : "y"] = 0, s[n ? "width" : "height"] = this.yAxis?.len || 0), hr(i, {
                        width: h.width,
                        height: h.height
                    }), f = s, a && this.xAxis && !p && this.setDataLabelStartPos(t, e, o, c, f), e.align(hd(i, {
                        width: l.width,
                        height: l.height
                    }), !1, s, !1), e.alignAttr.x += hn(i.align) * (l.width - h.width), e.alignAttr.y += hn(i.verticalAlign) * (l.height - h.height), e[e.placed ? "animate" : "attr"]({
                        "text-align": e.alignAttr["text-align"] || "center",
                        x: e.alignAttr.x + (h.width - l.width) / 2,
                        y: e.alignAttr.y + (h.height - l.height) / 2,
                        rotationOriginX: (e.width || 0) / 2,
                        rotationOriginY: (e.height || 0) / 2
                    }), p && s.height >= 0) this.justifyDataLabel(e, i, e.alignAttr, h, s, o);
                    else if (hp(i.crop, !0)) {
                        let { x: t, y: i } = e.alignAttr;
                        g = r.isInsidePlot(t, i, {
                            paneCoordinates: !0,
                            series: this
                        }) && r.isInsidePlot(t + h.width - 1, i + h.height - 1, {
                            paneCoordinates: !0,
                            series: this
                        });
                    }
                    i.shape && !d && e[o ? "attr" : "animate"]({
                        anchorX: u[0],
                        anchorY: u[1]
                    });
                }
                o && a && (e.placed = !1), g || a && !p ? (e.show(), e.placed = !0) : (e.hide(), e.placed = !1);
            }
            function s() {
                return this.plotGroup("dataLabelsGroup", "data-labels", this.hasRendered ? "inherit" : "hidden", this.options.dataLabels.zIndex || 6, this.chart.dataLabelsGroup);
            }
            function o(t) {
                let e = this.hasRendered || 0, i = this.initDataLabelsGroup().attr({
                    opacity: +e
                });
                return !e && i && (this.visible && i.show(), this.options.animation ? i.animate({
                    opacity: 1
                }, t) : i.attr({
                    opacity: 1
                })), i;
            }
            function r(t) {
                let e;
                t = t || this.points;
                let i = this, s = i.chart, o = i.options, r = s.renderer, { backgroundColor: a, plotBackgroundColor: l } = s.options.chart, d = r.getContrast(hl(l) && l || hl(a) && a || "#000000"), c = h(i), { animation: p, defer: g } = c[0], u = g ? hi(s, p, i) : {
                    defer: 0,
                    duration: 0
                };
                ha(this, "drawDataLabels"), i.hasDataLabels?.() && (e = this.initDataLabels(u), t.forEach((t)=>{
                    let a = t.dataLabels || [], h = t.color || i.color;
                    hu(n(c, t.dlOptions || t.options?.dataLabels)).forEach((n, l)=>{
                        let c = n.enabled && (t.visible || t.dataLabelOnHidden) && (!t.isNull || t.dataLabelOnNull) && function(t, e) {
                            let i = e.filter;
                            if (i) {
                                let e = i.operator, s = t[i.property], o = i.value;
                                return ">" === e && s > o || "<" === e && s < o || ">=" === e && s >= o || "<=" === e && s <= o || "==" === e && s == o || "===" === e && s === o || "!=" === e && s != o || "!==" === e && s !== o || !1;
                            }
                            return !0;
                        }(t, n), { backgroundColor: p, borderColor: g, distance: u, style: f = {} } = n, m, x, y, b = {}, v = a[l], k = !v, w;
                        c && (x = ho(m = hp(n[t.formatPrefix + "Format"], n.format)) ? hs(m, t, s) : (n[t.formatPrefix + "Formatter"] || n.formatter).call(t, n), y = n.rotation, !s.styledMode && (f.color = hp(n.color, f.color, hl(i.color) ? i.color : void 0, "#000000"), "contrast" === f.color ? ("none" !== p && (w = p), t.contrastColor = r.getContrast("auto" !== w && hl(w) && w || (hl(h) ? h : "")), f.color = w || !ho(u) && n.inside || 0 > hg(u || 0) || o.stacking ? t.contrastColor : d) : delete t.contrastColor, o.cursor && (f.cursor = o.cursor)), b = {
                            r: n.borderRadius || 0,
                            rotation: y,
                            padding: n.padding,
                            zIndex: 1
                        }, s.styledMode || (b.fill = "auto" === p ? t.color : p, b.stroke = "auto" === g ? t.color : g, b["stroke-width"] = n.borderWidth), hc(b, (t, e)=>{
                            void 0 === t && delete b[e];
                        })), !v || c && ho(x) && !!(v.div || v.text?.foreignObject) == !!n.useHTML && (v.rotation && n.rotation || v.rotation === n.rotation) || (v = void 0, k = !0), c && ho(x) && "" !== x && (v ? b.text = x : (v = r.label(x, 0, 0, n.shape, void 0, void 0, n.useHTML, void 0, "data-label")).addClass(" highcharts-data-label-color-" + t.colorIndex + " " + (n.className || "") + (n.useHTML ? " highcharts-tracker" : "")), v && (v.options = n, v.attr(b), s.styledMode ? f.width && v.css({
                            width: f.width,
                            textOverflow: f.textOverflow,
                            whiteSpace: f.whiteSpace
                        }) : v.css(f).shadow(n.shadow), ha(v, "beforeAddingDataLabel", {
                            labelOptions: n,
                            point: t
                        }), v.added || v.add(e), i.alignDataLabel(t, v, n, void 0, k), v.isActive = !0, a[l] && a[l] !== v && a[l].destroy(), a[l] = v));
                    });
                    let l = a.length;
                    for(; l--;)a[l]?.isActive ? a[l].isActive = !1 : (a[l]?.destroy(), a.splice(l, 1));
                    t.dataLabel = a[0], t.dataLabels = a;
                })), ha(this, "afterDrawDataLabels");
            }
            function a(t, e, i, s, o, r) {
                let a = this.chart, n = e.align, h = e.verticalAlign, l = t.box ? 0 : t.padding || 0, d = a.inverted ? this.yAxis : this.xAxis, c = d ? d.left - a.plotLeft : 0, p = a.inverted ? this.xAxis : this.yAxis, g = p ? p.top - a.plotTop : 0, { x: u = 0, y: f = 0 } = e, m, x;
                return (m = (i.x || 0) + l + c) < 0 && ("right" === n && u >= 0 ? (e.align = "left", e.inside = !0) : u -= m, x = !0), (m = (i.x || 0) + s.width - l + c) > a.plotWidth && ("left" === n && u <= 0 ? (e.align = "right", e.inside = !0) : u += a.plotWidth - m, x = !0), (m = i.y + l + g) < 0 && ("bottom" === h && f >= 0 ? (e.verticalAlign = "top", e.inside = !0) : f -= m, x = !0), (m = (i.y || 0) + s.height - l + g) > a.plotHeight && ("top" === h && f <= 0 ? (e.verticalAlign = "bottom", e.inside = !0) : f += a.plotHeight - m, x = !0), x && (e.x = u, e.y = f, t.placed = !r, t.align(e, void 0, o)), x;
            }
            function n(t, e) {
                let i = [], s;
                if (hh(t) && !hh(e)) i = t.map(function(t) {
                    return hd(t, e);
                });
                else if (hh(e) && !hh(t)) i = e.map(function(e) {
                    return hd(t, e);
                });
                else if (hh(t) || hh(e)) {
                    if (hh(t) && hh(e)) for(s = Math.max(t.length, e.length); s--;)i[s] = hd(t[s], e[s]);
                } else i = hd(t, e);
                return i;
            }
            function h(t) {
                let e = t.chart.options.plotOptions;
                return hu(n(n(e?.series?.dataLabels, e?.[t.type]?.dataLabels), t.options.dataLabels));
            }
            function l(t, e, i, s, o) {
                let r = this.chart, a = r.inverted, n = this.xAxis, h = n.reversed, l = ((a ? e.height : e.width) || 0) / 2, d = t.pointWidth, c = d ? d / 2 : 0;
                e.startXPos = a ? o.x : h ? -l - c : n.width - l + c, e.startYPos = a ? h ? this.yAxis.height - l + c : -l - c : o.y, s ? "hidden" === e.visibility && (e.show(), e.attr({
                    opacity: 0
                }).animate({
                    opacity: 1
                })) : e.attr({
                    opacity: 1
                }).animate({
                    opacity: 0
                }, void 0, e.hide), r.hasRendered && (i && e.attr({
                    x: e.startXPos,
                    y: e.startYPos
                }), e.placed = !0);
            }
            t.compose = function(t) {
                let h = t.prototype;
                h.initDataLabels || (h.initDataLabels = o, h.initDataLabelsGroup = s, h.alignDataLabel = i, h.drawDataLabels = r, h.justifyDataLabel = a, h.mergeArrays = n, h.setDataLabelStartPos = l, h.hasDataLabels = e);
            };
        }(u || (u = {}));
        let hf = u, { composed: hm } = w, { series: hx } = rk, { merge: hy, pushUnique: hb } = V;
        !function(t) {
            function e(t, e, i, s, o) {
                let { chart: r, options: a } = this, n = r.inverted, h = this.xAxis?.len || r.plotSizeX || 0, l = this.yAxis?.len || r.plotSizeY || 0, d = t.dlBox || t.shapeArgs, c = t.below ?? (t.plotY || 0) > (this.translatedThreshold ?? l), p = i.inside ?? !!a.stacking;
                if (d) {
                    if (s = hy(d), "allow" !== i.overflow || !1 !== i.crop || !1 !== a.clip) {
                        s.y < 0 && (s.height += s.y, s.y = 0);
                        let t = s.y + s.height - l;
                        t > 0 && t < s.height - 1 && (s.height -= t);
                    }
                    n && (s = {
                        x: l - s.y - s.height,
                        y: h - s.x - s.width,
                        width: s.height,
                        height: s.width
                    }), p || (n ? (s.x += c ? 0 : s.width, s.width = 0) : (s.y += c ? s.height : 0, s.height = 0));
                }
                i.align ?? (i.align = !n || p ? "center" : c ? "right" : "left"), i.verticalAlign ?? (i.verticalAlign = n || p ? "middle" : c ? "top" : "bottom"), hx.prototype.alignDataLabel.call(this, t, e, i, s, o), i.inside && t.contrastColor && e.css({
                    color: t.contrastColor
                });
            }
            t.compose = function(t) {
                hf.compose(hx), hb(hm, "ColumnDataLabel") && (t.prototype.alignDataLabel = e);
            };
        }(f || (f = {}));
        let hv = f, { extend: hk, merge: hw } = V;
        class hM extends he {
        }
        hM.defaultOptions = hw(he.defaultOptions, {}), hk(hM.prototype, {
            inverted: !0
        }), rk.registerSeriesType("bar", hM);
        let { column: hS, line: hT } = rk.seriesTypes, { addEvent: hC, extend: hA, merge: hP } = V;
        class hL extends hT {
            applyJitter() {
                let t = this, e = this.options.jitter, i = this.points.length;
                e && this.points.forEach(function(s, o) {
                    [
                        "x",
                        "y"
                    ].forEach(function(r, a) {
                        if (e[r] && !s.isNull) {
                            let n = `plot${r.toUpperCase()}`, h = t[`${r}Axis`], l = e[r] * h.transA;
                            if (h && !h.logarithmic) {
                                let t = Math.max(0, (s[n] || 0) - l), e = Math.min(h.len, (s[n] || 0) + l);
                                s[n] = t + (e - t) * function(t) {
                                    let e = 1e4 * Math.sin(t);
                                    return e - Math.floor(e);
                                }(o + a * i), "x" === r && (s.clientX = s.plotX);
                            }
                        }
                    });
                });
            }
            drawGraph() {
                this.options.lineWidth ? super.drawGraph() : this.graph && (this.graph = this.graph.destroy());
            }
        }
        hL.defaultOptions = hP(hT.defaultOptions, {
            lineWidth: 0,
            findNearestPointBy: "xy",
            jitter: {
                x: 0,
                y: 0
            },
            marker: {
                enabled: !0
            },
            tooltip: {
                headerFormat: '<span style="color:{point.color}">\u25CF</span> <span style="font-size: 0.8em"> {series.name}</span><br/>',
                pointFormat: "x: <b>{point.x}</b><br/>y: <b>{point.y}</b><br/>"
            }
        }), hA(hL.prototype, {
            drawTracker: hS.prototype.drawTracker,
            sorted: !1,
            requireSorting: !1,
            noSharedTooltip: !0,
            trackerGroups: [
                "group",
                "markerGroup",
                "dataLabelsGroup"
            ]
        }), hC(hL, "afterTranslate", function() {
            this.applyJitter();
        }), rk.registerSeriesType("scatter", hL);
        let { deg2rad: hO } = w, { fireEvent: hE, isNumber: hI, pick: hD, relativeLength: hB } = V;
        !function(t) {
            t.getCenter = function() {
                let t = this.options, e = this.chart, i = 2 * (t.slicedOffset || 0), s = e.plotWidth - 2 * i, o = e.plotHeight - 2 * i, r = t.center, a = Math.min(s, o), n = t.thickness, h, l = t.size, d = t.innerSize || 0, c, p;
                "string" == typeof l && (l = parseFloat(l)), "string" == typeof d && (d = parseFloat(d));
                let g = [
                    hD(r?.[0], "50%"),
                    hD(r?.[1], "50%"),
                    hD(l && l < 0 ? void 0 : t.size, "100%"),
                    hD(d && d < 0 ? void 0 : t.innerSize || 0, "0%")
                ];
                for(!e.angular || this instanceof r1 || (g[3] = 0), c = 0; c < 4; ++c)p = g[c], h = c < 2 || 2 === c && /%$/.test(p), g[c] = hB(p, [
                    s,
                    o,
                    a,
                    g[2]
                ][c]) + (h ? i : 0);
                return g[3] > g[2] && (g[3] = g[2]), hI(n) && 2 * n < g[2] && n > 0 && (g[3] = g[2] - 2 * n), hE(this, "afterGetCenter", {
                    positions: g
                }), g;
            }, t.getStartAndEndRadians = function(t, e) {
                let i = hI(t) ? t : 0, s = hI(e) && e > i && e - i < 360 ? e : i + 360;
                return {
                    start: hO * (i + -90),
                    end: hO * (s + -90)
                };
            };
        }(m || (m = {}));
        let hN = m, { setAnimation: hz } = tU, { addEvent: hR, defined: hW, extend: hH, isNumber: hX, pick: hF, relativeLength: hG } = V;
        class hj extends oK {
            getConnectorPath(t) {
                let e = t.dataLabelPosition, i = t.options || {}, s = i.connectorShape, o = this.connectorShapes[s] || s;
                return e && o.call(this, {
                    ...e.computed,
                    alignment: e.alignment
                }, e.connectorPosition, i) || [];
            }
            getTranslate() {
                return this.sliced && this.slicedTranslation || {
                    translateX: 0,
                    translateY: 0
                };
            }
            haloPath(t) {
                let e = this.shapeArgs;
                return this.sliced || !this.visible ? [] : this.series.chart.renderer.symbols.arc(e.x, e.y, e.r + t, e.r + t, {
                    innerR: e.r - 1,
                    start: e.start,
                    end: e.end,
                    borderRadius: e.borderRadius
                });
            }
            constructor(t, e, i){
                super(t, e, i), this.half = 0, this.name ?? (this.name = t.chart.options.lang.pieSliceName);
                let s = (t)=>{
                    this.slice("select" === t.type);
                };
                hR(this, "select", s), hR(this, "unselect", s);
            }
            isValid() {
                return hX(this.y) && this.y >= 0;
            }
            setVisible(t, e = !0) {
                t !== this.visible && this.update({
                    visible: t ?? !this.visible
                }, e, void 0, !1);
            }
            slice(t, e, i) {
                let s = this.series;
                hz(i, s.chart), e = hF(e, !0), this.sliced = this.options.sliced = t = hW(t) ? t : !this.sliced, s.options.data[s.data.indexOf(this)] = this.options, this.graphic && this.graphic.animate(this.getTranslate());
            }
        }
        hH(hj.prototype, {
            connectorShapes: {
                fixedOffset: function(t, e, i) {
                    let s = e.breakAt, o = e.touchingSliceAt, r = i.softConnector ? [
                        "C",
                        t.x + ("left" === t.alignment ? -5 : 5),
                        t.y,
                        2 * s.x - o.x,
                        2 * s.y - o.y,
                        s.x,
                        s.y
                    ] : [
                        "L",
                        s.x,
                        s.y
                    ];
                    return [
                        [
                            "M",
                            t.x,
                            t.y
                        ],
                        r,
                        [
                            "L",
                            o.x,
                            o.y
                        ]
                    ];
                },
                straight: function(t, e) {
                    let i = e.touchingSliceAt;
                    return [
                        [
                            "M",
                            t.x,
                            t.y
                        ],
                        [
                            "L",
                            i.x,
                            i.y
                        ]
                    ];
                },
                crookedLine: function(t, e, i) {
                    let { angle: s = this.angle || 0, breakAt: o, touchingSliceAt: r } = e, { series: a } = this, [n, h, l] = a.center, d = l / 2, { plotLeft: c, plotWidth: p } = a.chart, g = "left" === t.alignment, { x: u, y: f } = t, m = o.x;
                    if (i.crookDistance) {
                        let t = hG(i.crookDistance, 1);
                        m = g ? n + d + (p + c - n - d) * (1 - t) : c + (n - d) * t;
                    } else m = n + (h - f) * Math.tan(s - Math.PI / 2);
                    let x = [
                        [
                            "M",
                            u,
                            f
                        ]
                    ];
                    return (g ? m <= u && m >= o.x : m >= u && m <= o.x) && x.push([
                        "L",
                        m,
                        f
                    ]), x.push([
                        "L",
                        o.x,
                        o.y
                    ], [
                        "L",
                        r.x,
                        r.y
                    ]), x;
                }
            }
        });
        let { getStartAndEndRadians: hY } = hN, { noop: hU } = w, { clamp: h$, extend: hV, fireEvent: hZ, merge: h_, pick: hq } = V;
        class hK extends r1 {
            animate(t) {
                let e = this, i = e.points, s = e.startAngleRad;
                t || i.forEach(function(t) {
                    let i = t.graphic, o = t.shapeArgs;
                    i && o && (i.attr({
                        r: hq(t.startR, e.center && e.center[3] / 2),
                        start: s,
                        end: s
                    }), i.animate({
                        r: o.r,
                        start: o.start,
                        end: o.end
                    }, e.options.animation));
                });
            }
            drawEmpty() {
                let t, e, i = this.startAngleRad, s = this.endAngleRad, o = this.options;
                0 === this.total && this.center ? (t = this.center[0], e = this.center[1], this.graph || (this.graph = this.chart.renderer.arc(t, e, this.center[1] / 2, 0, i, s).addClass("highcharts-empty-series").add(this.group)), this.graph.attr({
                    d: is.arc(t, e, this.center[2] / 2, 0, {
                        start: i,
                        end: s,
                        innerR: this.center[3] / 2
                    })
                }), this.chart.styledMode || this.graph.attr({
                    "stroke-width": o.borderWidth,
                    fill: o.fillColor || "none",
                    stroke: o.color || "#cccccc"
                })) : this.graph && (this.graph = this.graph.destroy());
            }
            drawPoints() {
                let t = this.chart.renderer;
                this.points.forEach(function(e) {
                    e.graphic && e.hasNewShapeType() && (e.graphic = e.graphic.destroy()), e.graphic || (e.graphic = t[e.shapeType](e.shapeArgs).add(e.series.group), e.delayedRendering = !0);
                });
            }
            generatePoints() {
                super.generatePoints(), this.updateTotals();
            }
            getX(t, e, i, s) {
                let o = this.center, r = this.radii ? this.radii[i.index] || 0 : o[2] / 2, a = s.dataLabelPosition, n = a?.distance || 0, h = Math.asin(h$((t - o[1]) / (r + n), -1, 1));
                return o[0] + Math.cos(h) * (r + n) * (e ? -1 : 1) + (n > 0 ? (e ? -1 : 1) * (s.padding || 0) : 0);
            }
            hasData() {
                return this.points.some((t)=>t.visible);
            }
            redrawPoints() {
                let t, e, i, s, o = this, r = o.chart;
                this.drawEmpty(), o.group && !r.styledMode && o.group.shadow(o.options.shadow), o.points.forEach(function(a) {
                    let n = {};
                    e = a.graphic, !a.isNull && e ? (s = a.shapeArgs, t = a.getTranslate(), r.styledMode || (i = o.pointAttribs(a, a.selected && "select")), a.delayedRendering ? (e.setRadialReference(o.center).attr(s).attr(t), r.styledMode || e.attr(i).attr({
                        "stroke-linejoin": "round"
                    }), a.delayedRendering = !1) : (e.setRadialReference(o.center), r.styledMode || h_(!0, n, i), h_(!0, n, s, t), e.animate(n)), e.attr({
                        visibility: a.visible ? "inherit" : "hidden"
                    }), e.addClass(a.getClassName(), !0)) : e && (a.graphic = e.destroy());
                });
            }
            sortByAngle(t, e) {
                t.sort(function(t, i) {
                    return void 0 !== t.angle && (i.angle - t.angle) * e;
                });
            }
            translate(t) {
                hZ(this, "translate"), this.generatePoints();
                let e = this.options, i = e.slicedOffset, s = hY(e.startAngle, e.endAngle), o = this.startAngleRad = s.start, r = (this.endAngleRad = s.end) - o, a = this.points, n = e.ignoreHiddenPoint, h = a.length, l, d, c, p, g, u, f, m = 0;
                for(t || (this.center = t = this.getCenter()), u = 0; u < h; u++){
                    f = a[u], l = o + m * r, f.isValid() && (!n || f.visible) && (m += f.percentage / 100), d = o + m * r;
                    let e = {
                        x: t[0],
                        y: t[1],
                        r: t[2] / 2,
                        innerR: t[3] / 2,
                        start: Math.round(1e3 * l) / 1e3,
                        end: Math.round(1e3 * d) / 1e3
                    };
                    f.shapeType = "arc", f.shapeArgs = e, (c = (d + l) / 2) > 1.5 * Math.PI ? c -= 2 * Math.PI : c < -Math.PI / 2 && (c += 2 * Math.PI), f.slicedTranslation = {
                        translateX: Math.round(Math.cos(c) * i),
                        translateY: Math.round(Math.sin(c) * i)
                    }, p = Math.cos(c) * t[2] / 2, g = Math.sin(c) * t[2] / 2, f.tooltipPos = [
                        t[0] + .7 * p,
                        t[1] + .7 * g
                    ], f.half = +(c < -Math.PI / 2 || c > Math.PI / 2), f.angle = c;
                }
                hZ(this, "afterTranslate");
            }
            updateTotals() {
                let t = this.points, e = t.length, i = this.options.ignoreHiddenPoint, s, o, r = 0;
                for(s = 0; s < e; s++)(o = t[s]).isValid() && (!i || o.visible) && (r += o.y);
                for(s = 0, this.total = r; s < e; s++)(o = t[s]).percentage = r > 0 && (o.visible || !i) ? o.y / r * 100 : 0, o.total = r;
            }
        }
        hK.defaultOptions = h_(r1.defaultOptions, {
            borderRadius: 3,
            center: [
                null,
                null
            ],
            clip: !1,
            colorByPoint: !0,
            dataLabels: {
                connectorPadding: 5,
                connectorShape: "crookedLine",
                crookDistance: void 0,
                distance: 30,
                enabled: !0,
                formatter: function() {
                    return this.isNull ? void 0 : this.name;
                },
                softConnector: !0,
                x: 0
            },
            fillColor: void 0,
            ignoreHiddenPoint: !0,
            inactiveOtherPoints: !0,
            legendType: "point",
            marker: null,
            size: null,
            showInLegend: !1,
            slicedOffset: 10,
            stickyTracking: !1,
            tooltip: {
                followPointer: !0
            },
            borderColor: "#ffffff",
            borderWidth: 1,
            lineWidth: void 0,
            states: {
                hover: {
                    brightness: .1
                }
            }
        }), hV(hK.prototype, {
            axisTypes: [],
            directTouch: !0,
            drawGraph: void 0,
            drawTracker: he.prototype.drawTracker,
            getCenter: hN.getCenter,
            getSymbol: hU,
            invertible: !1,
            isCartesian: !1,
            noSharedTooltip: !0,
            pointAttribs: he.prototype.pointAttribs,
            pointClass: hj,
            requireSorting: !1,
            searchPoint: hU,
            trackerGroups: [
                "group",
                "dataLabelsGroup"
            ]
        }), rk.registerSeriesType("pie", hK);
        let { composed: hJ, noop: hQ } = w, { distribute: h0 } = ey, { series: h1 } = rk, { arrayMax: h2, clamp: h3, defined: h5, isNumber: h6, pick: h9, pushUnique: h4, relativeLength: h8 } = V;
        !function(t) {
            let e = {
                radialDistributionY: function(t, e) {
                    return (e.dataLabelPosition?.top || 0) + t.distributeBox.pos;
                },
                radialDistributionX: function(t, e, i, s, o) {
                    let r = o.dataLabelPosition;
                    return t.getX(i < (r?.top || 0) + 2 || i > (r?.bottom || 0) - 2 ? s : i, e.half, e, o);
                },
                justify: function(t, e, i, s) {
                    return s[0] + (t.half ? -1 : 1) * (i + (e.dataLabelPosition?.distance || 0));
                },
                alignToPlotEdges: function(t, e, i, s) {
                    let o = t.getBBox().width;
                    return e ? o + s : i - o - s;
                },
                alignToConnectors: function(t, e, i, s) {
                    let o = 0, r;
                    return t.forEach(function(t) {
                        (r = t.dataLabel.getBBox().width) > o && (o = r);
                    }), e ? o + s : i - o - s;
                }
            };
            function i(t, e) {
                let i = Math.PI / 2, { start: s = 0, end: o = 0 } = t.shapeArgs || {}, r = t.angle || 0;
                e > 0 && s < i && o > i && r > i / 2 && r < 1.5 * i && (r = r <= i ? Math.max(i / 2, (s + i) / 2) : Math.min(1.5 * i, (i + o) / 2));
                let { center: a, options: n } = this, h = a[2] / 2, l = Math.cos(r), d = Math.sin(r), c = a[0] + l * h, p = a[1] + d * h, g = Math.min((n.slicedOffset || 0) + (n.borderWidth || 0), e / 5);
                return {
                    natural: {
                        x: c + l * e,
                        y: p + d * e
                    },
                    computed: {},
                    alignment: e < 0 ? "center" : t.half ? "right" : "left",
                    connectorPosition: {
                        angle: r,
                        breakAt: {
                            x: c + l * g,
                            y: p + d * g
                        },
                        touchingSliceAt: {
                            x: c,
                            y: p
                        }
                    },
                    distance: e
                };
            }
            function s() {
                let t = this, e = t.points, i = t.chart, s = i.plotWidth, o = i.plotHeight, r = i.plotLeft, a = Math.round(i.chartWidth / 3), n = t.center, h = n[2] / 2, l = n[1], d = [
                    [],
                    []
                ], c = [
                    0,
                    0,
                    0,
                    0
                ], p = t.dataLabelPositioners, g, u, f, m = 0;
                t.visible && t.hasDataLabels?.() && (e.forEach((t)=>{
                    (t.dataLabels || []).forEach((t)=>{
                        t.shortened && (t.attr({
                            width: "auto"
                        }).css({
                            width: "auto",
                            textOverflow: "clip"
                        }), t.shortened = !1);
                    });
                }), h1.prototype.drawDataLabels.apply(t), e.forEach((t)=>{
                    (t.dataLabels || []).forEach((e, i)=>{
                        let s = n[2] / 2, o = e.options, r = h8(o?.distance || 0, s);
                        0 === i && d[t.half].push(t), !h5(o?.style?.width) && e.getBBox().width > a && (e.css({
                            width: Math.round(.7 * a) + "px"
                        }), e.shortened = !0), e.dataLabelPosition = this.getDataLabelPosition(t, r), m = Math.max(m, r);
                    });
                }), d.forEach((e, a)=>{
                    let d = e.length, g = [], x, y, b = 0, v;
                    d && (t.sortByAngle(e, a - .5), m > 0 && (x = Math.max(0, l - h - m), y = Math.min(l + h + m, i.plotHeight), e.forEach((t)=>{
                        (t.dataLabels || []).forEach((e)=>{
                            let s = e.dataLabelPosition;
                            s && s.distance > 0 && (s.top = Math.max(0, l - h - s.distance), s.bottom = Math.min(l + h + s.distance, i.plotHeight), b = e.getBBox().height || 21, e.lineHeight = i.renderer.fontMetrics(e.text || e).h + 2 * e.padding, t.distributeBox = {
                                target: (e.dataLabelPosition?.natural.y || 0) - s.top + e.lineHeight / 2,
                                size: b,
                                rank: t.y
                            }, g.push(t.distributeBox));
                        });
                    }), h0(g, v = y + b - x, v / 5)), e.forEach((i)=>{
                        (i.dataLabels || []).forEach((l)=>{
                            let d = l.options || {}, m = i.distributeBox, x = l.dataLabelPosition, y = x?.natural.y || 0, b = d.connectorPadding || 0, v = l.lineHeight || 21, k = (v - l.getBBox().height) / 2, w = 0, M = y, S = "inherit";
                            if (x) {
                                if (g && h5(m) && x.distance > 0 && (void 0 === m.pos ? S = "hidden" : (f = m.size, M = p.radialDistributionY(i, l))), d.justify) w = p.justify(i, l, h, n);
                                else switch(d.alignTo){
                                    case "connectors":
                                        w = p.alignToConnectors(e, a, s, r);
                                        break;
                                    case "plotEdges":
                                        w = p.alignToPlotEdges(l, a, s, r);
                                        break;
                                    default:
                                        w = p.radialDistributionX(t, i, M - k, y, l);
                                }
                                if (x.attribs = {
                                    visibility: S,
                                    align: x.alignment
                                }, x.posAttribs = {
                                    x: w + (d.x || 0) + (({
                                        left: b,
                                        right: -b
                                    })[x.alignment] || 0),
                                    y: M + (d.y || 0) - v / 2
                                }, x.computed.x = w, x.computed.y = M - k, h9(d.crop, !0)) {
                                    let t;
                                    w - (u = l.getBBox().width) < b && 1 === a ? (t = Math.round(u - w + b), c[3] = Math.max(t, c[3])) : w + u > s - b && 0 === a && (t = Math.round(w + u - s + b), c[1] = Math.max(t, c[1])), M - f / 2 < 0 ? c[0] = Math.max(Math.round(-M + f / 2), c[0]) : M + f / 2 > o && (c[2] = Math.max(Math.round(M + f / 2 - o), c[2])), x.sideOverflow = t;
                                }
                            }
                        });
                    }));
                }), (0 === h2(c) || this.verifyDataLabelOverflow(c)) && (this.placeDataLabels(), this.points.forEach((e)=>{
                    (e.dataLabels || []).forEach((s)=>{
                        let { connectorColor: o, connectorWidth: r = 1 } = s.options || {}, a = s.dataLabelPosition;
                        if (h6(r)) {
                            let n;
                            g = s.connector, a && a.distance > 0 ? (n = !g, g || (s.connector = g = i.renderer.path().addClass("highcharts-data-label-connector  highcharts-color-" + e.colorIndex + (e.className ? " " + e.className : "")).add(t.dataLabelsGroup)), i.styledMode || g.attr({
                                "stroke-width": r,
                                stroke: o || e.color || "#666666"
                            }), g[n ? "attr" : "animate"]({
                                d: e.getConnectorPath(s)
                            }), g.attr({
                                visibility: a.attribs?.visibility
                            })) : g && (s.connector = g.destroy());
                        }
                    });
                })));
            }
            function o() {
                this.points.forEach((t)=>{
                    (t.dataLabels || []).forEach((t)=>{
                        let e = t.dataLabelPosition;
                        e ? (e.sideOverflow && (t.css({
                            width: Math.max(t.getBBox().width - e.sideOverflow, 0) + "px",
                            textOverflow: t.options?.style?.textOverflow || "ellipsis"
                        }), t.shortened = !0), t.attr(e.attribs), t[t.moved ? "animate" : "attr"](e.posAttribs), t.moved = !0) : t && t.attr({
                            y: -9999
                        });
                    }), delete t.distributeBox;
                }, this);
            }
            function r(t) {
                let e = this.center, i = this.options, s = i.center, o = i.minSize || 80, r = o, a = null !== i.size;
                return !a && (null !== s[0] ? r = Math.max(e[2] - Math.max(t[1], t[3]), o) : (r = Math.max(e[2] - t[1] - t[3], o), e[0] += (t[3] - t[1]) / 2), null !== s[1] ? r = h3(r, o, e[2] - Math.max(t[0], t[2])) : (r = h3(r, o, e[2] - t[0] - t[2]), e[1] += (t[0] - t[2]) / 2), r < e[2] ? (e[2] = r, e[3] = Math.min(i.thickness ? Math.max(0, r - 2 * i.thickness) : Math.max(0, h8(i.innerSize || 0, r)), r), this.translate(e), this.drawDataLabels && this.drawDataLabels()) : a = !0), a;
            }
            t.compose = function(t) {
                if (hf.compose(h1), h4(hJ, "PieDataLabel")) {
                    let a = t.prototype;
                    a.dataLabelPositioners = e, a.alignDataLabel = hQ, a.drawDataLabels = s, a.getDataLabelPosition = i, a.placeDataLabels = o, a.verifyDataLabelOverflow = r;
                }
            };
        }(x || (x = {}));
        let h7 = x;
        !function(t) {
            t.getCenterOfPoints = function(t) {
                let e = t.reduce((t, e)=>(t.x += e.x, t.y += e.y, t), {
                    x: 0,
                    y: 0
                });
                return {
                    x: e.x / t.length,
                    y: e.y / t.length
                };
            }, t.getDistanceBetweenPoints = function(t, e) {
                return Math.sqrt(Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2));
            }, t.getAngleBetweenPoints = function(t, e) {
                return Math.atan2(e.x - t.x, e.y - t.y);
            }, t.pointInPolygon = function({ x: t, y: e }, i) {
                let s = i.length, o, r, a = !1;
                for(o = 0, r = s - 1; o < s; r = o++){
                    let [s, n] = i[o], [h, l] = i[r];
                    n > e != l > e && t < (h - s) * (e - n) / (l - n) + s && (a = !a);
                }
                return a;
            };
        }(y || (y = {}));
        let { pointInPolygon: lt } = y, { addEvent: le, getAlignFactor: li, fireEvent: ls, objectEach: lo, pick: lr } = V;
        function la(t) {
            let e = t.length, i = (t, e)=>!(e.x >= t.x + t.width || e.x + e.width <= t.x || e.y >= t.y + t.height || e.y + e.height <= t.y), s = (t, e)=>{
                for (let i of t)if (lt({
                    x: i[0],
                    y: i[1]
                }, e)) return !0;
                return !1;
            }, o, r, a, n, h, l = !1;
            for(let i = 0; i < e; i++)(o = t[i]) && (o.oldOpacity = o.opacity, o.newOpacity = 1, o.absoluteBox = function(t) {
                if (t && (!t.alignAttr || t.placed)) {
                    let e = t.box ? 0 : t.padding || 0, i = t.alignAttr || {
                        x: t.attr("x"),
                        y: t.attr("y")
                    }, { height: s, polygon: o, width: r } = t.getBBox(), a = li(t.alignValue) * r;
                    return t.width = r, t.height = s, {
                        x: i.x + (t.parentGroup?.translateX || 0) + e - a,
                        y: i.y + (t.parentGroup?.translateY || 0) + e,
                        width: r - 2 * e,
                        height: s - 2 * e,
                        polygon: o
                    };
                }
            }(o));
            t.sort((t, e)=>(e.labelrank || 0) - (t.labelrank || 0));
            for(let o = 0; o < e; ++o){
                n = (r = t[o]) && r.absoluteBox;
                let l = n?.polygon;
                for(let d = o + 1; d < e; ++d){
                    h = (a = t[d]) && a.absoluteBox;
                    let e = !1;
                    if (n && h && r !== a && 0 !== r.newOpacity && 0 !== a.newOpacity && "hidden" !== r.visibility && "hidden" !== a.visibility) {
                        let t = h.polygon;
                        if (l && t && l !== t ? s(l, t) && (e = !0) : i(n, h) && (e = !0), e) {
                            let t = r.labelrank < a.labelrank ? r : a, e = t.text;
                            t.newOpacity = 0, e?.element.querySelector("textPath") && e.hide();
                        }
                    }
                }
            }
            for (let e of t)ln(e, this) && (l = !0);
            l && ls(this, "afterHideAllOverlappingLabels");
        }
        function ln(t, e) {
            let i, s = !1;
            return t && (i = t.newOpacity, t.oldOpacity !== i && (t.hasClass("highcharts-data-label") ? (t[i ? "removeClass" : "addClass"]("highcharts-data-label-hidden"), s = !0, t[t.isOld ? "animate" : "attr"]({
                opacity: i
            }, void 0, function() {
                e.styledMode || t.css({
                    pointerEvents: i ? "auto" : "none"
                });
            }), ls(e, "afterHideOverlappingLabel")) : t.attr({
                opacity: i
            })), t.isOld = !0), s;
        }
        function lh() {
            let t = this, e = [];
            for (let i of t.labelCollectors || [])e = e.concat(i());
            for (let i of t.yAxis || [])i.stacking && i.options.stackLabels && !i.options.stackLabels.allowOverlap && lo(i.stacking.stacks, (t)=>{
                lo(t, (t)=>{
                    t.label && e.push(t.label);
                });
            });
            for (let i of t.series || [])if (i.visible && i.hasDataLabels?.()) {
                let s = (i)=>{
                    for (let s of i)s.visible && (s.dataLabels || []).forEach((i)=>{
                        let o = i.options || {};
                        i.labelrank = lr(o.labelrank, s.labelrank, s.shapeArgs?.height), o.allowOverlap ?? Number(o.distance) > 0 ? (i.oldOpacity = i.opacity, i.newOpacity = 1, ln(i, t)) : e.push(i);
                    });
                };
                s(i.nodes || []), s(i.points);
            }
            this.hideOverlappingLabels(e);
        }
        let ll = {
            compose: function(t) {
                let e = t.prototype;
                e.hideOverlappingLabels || (e.hideOverlappingLabels = la, le(t, "render", lh));
            }
        }, { defaultOptions: ld } = tv, { noop: lc } = w, { addEvent: lp, extend: lg, isObject: lu, merge: lf, relativeLength: lm } = V, lx = {
            radius: 0,
            scope: "stack",
            where: void 0
        }, ly = lc, lb = lc;
        function lv(t, e, i, s, o = {}) {
            let r = ly(t, e, i, s, o), { brStart: a = !0, brEnd: n = !0, innerR: h = 0, r: l = i, start: d = 0, end: c = 0 } = o;
            if (o.open || !o.borderRadius) return r;
            let p = c - d, g = Math.sin(p / 2), u = Math.max(Math.min(lm(o.borderRadius || 0, l - h), (l - h) / 2, l * g / (1 + g)), 0), f = Math.min(u, p / Math.PI * 2 * h), m = r.length - 1;
            for(; m--;)(a || 0 !== m && 3 !== m) && (n || 1 !== m && 2 !== m) && !function(t, e, i) {
                let s, o, r, a = t[e], n = t[e + 1];
                if ("Z" === n[0] && (n = t[0]), ("M" === a[0] || "L" === a[0]) && "A" === n[0] ? (s = a, o = n, r = !0) : "A" === a[0] && ("M" === n[0] || "L" === n[0]) && (s = n, o = a), s && o && o.params) {
                    let a = o[1], n = o[5], h = o.params, { start: l, end: d, cx: c, cy: p } = h, g = n ? a - i : a + i, u = g ? Math.asin(i / g) : 0, f = n ? u : -u, m = Math.cos(u) * g;
                    r ? (h.start = l + f, s[1] = c + m * Math.cos(l), s[2] = p + m * Math.sin(l), t.splice(e + 1, 0, [
                        "A",
                        i,
                        i,
                        0,
                        0,
                        1,
                        c + a * Math.cos(h.start),
                        p + a * Math.sin(h.start)
                    ])) : (h.end = d - f, o[6] = c + a * Math.cos(h.end), o[7] = p + a * Math.sin(h.end), t.splice(e + 1, 0, [
                        "A",
                        i,
                        i,
                        0,
                        0,
                        1,
                        c + m * Math.cos(d),
                        p + m * Math.sin(d)
                    ])), o[4] = Math.abs(h.end - h.start) < Math.PI ? 0 : 1;
                }
            }(r, m, m > 1 ? f : u);
            return r;
        }
        function lk() {
            if (this.options.borderRadius && !(this.chart.is3d && this.chart.is3d())) {
                let { options: t, yAxis: e } = this, i = "percent" === t.stacking, s = ld.plotOptions?.[this.type]?.borderRadius, o = lw(t.borderRadius, lu(s) ? s : {}), r = e.options.reversed;
                for (let s of this.points){
                    let { shapeArgs: a } = s;
                    if ("roundedRect" === s.shapeType && a) {
                        let { width: n = 0, height: h = 0, y: l = 0 } = a, d = l, c = h;
                        if ("stack" === o.scope && s.stackTotal) {
                            let o = e.translate(i ? 100 : s.stackTotal, !1, !0, !1, !0), r = e.translate(t.threshold || 0, !1, !0, !1, !0), a = this.crispCol(0, Math.min(o, r), 0, Math.abs(o - r));
                            d = a.y, c = a.height;
                        }
                        let p = (s.negative ? -1 : 1) * (r ? -1 : 1) == -1, g = o.where;
                        !g && this.is("waterfall") && Math.abs((s.yBottom || 0) - (this.translatedThreshold || 0)) > this.borderWidth && (g = "all"), g || (g = "end");
                        let u = Math.min(lm(o.radius, n), n / 2, "all" === g ? h / 2 : 1 / 0) || 0;
                        "end" === g && (p && (d -= u), c += u), lg(a, {
                            brBoxHeight: c,
                            brBoxY: d,
                            r: u
                        });
                    }
                }
            }
        }
        function lw(t, e) {
            return lu(t) || (t = {
                radius: t || 0
            }), lf(lx, e, t);
        }
        function lM() {
            let t = lw(this.options.borderRadius);
            for (let e of this.points){
                let i = e.shapeArgs;
                i && (i.borderRadius = lm(t.radius, (i.r || 0) - (i.innerR || 0)));
            }
        }
        function lS(t, e, i, s, o = {}) {
            let r = lb(t, e, i, s, o), { r: a = 0, brBoxHeight: n = s, brBoxY: h = e } = o, l = e - h, d = h + n - (e + s), c = l - a > -0.1 ? 0 : a, p = d - a > -0.1 ? 0 : a, g = Math.max(c && l, 0), u = Math.max(p && d, 0), f = [
                t + c,
                e
            ], m = [
                t + i - c,
                e
            ], x = [
                t + i,
                e + c
            ], y = [
                t + i,
                e + s - p
            ], b = [
                t + i - p,
                e + s
            ], v = [
                t + p,
                e + s
            ], k = [
                t,
                e + s - p
            ], w = [
                t,
                e + c
            ], M = (t, e)=>Math.sqrt(Math.pow(t, 2) - Math.pow(e, 2));
            if (g) {
                let t = M(c, c - g);
                f[0] -= t, m[0] += t, x[1] = w[1] = e + c - g;
            }
            if (s < c - g) {
                let o = M(c, c - g - s);
                x[0] = y[0] = t + i - c + o, b[0] = Math.min(x[0], b[0]), v[0] = Math.max(y[0], v[0]), k[0] = w[0] = t + c - o, x[1] = w[1] = e + s;
            }
            if (u) {
                let t = M(p, p - u);
                b[0] += t, v[0] -= t, y[1] = k[1] = e + s - p + u;
            }
            if (s < p - u) {
                let o = M(p, p - u - s);
                x[0] = y[0] = t + i - p + o, m[0] = Math.min(x[0], m[0]), f[0] = Math.max(y[0], f[0]), k[0] = w[0] = t + p - o, y[1] = k[1] = e;
            }
            return r.length = 0, r.push([
                "M",
                ...f
            ], [
                "L",
                ...m
            ], [
                "A",
                c,
                c,
                0,
                0,
                1,
                ...x
            ], [
                "L",
                ...y
            ], [
                "A",
                p,
                p,
                0,
                0,
                1,
                ...b
            ], [
                "L",
                ...v
            ], [
                "A",
                p,
                p,
                0,
                0,
                1,
                ...k
            ], [
                "L",
                ...w
            ], [
                "A",
                c,
                c,
                0,
                0,
                1,
                ...f
            ], [
                "Z"
            ]), r;
        }
        let { diffObjects: lT, extend: lC, find: lA, merge: lP, pick: lL, uniqueKey: lO } = V;
        !function(t) {
            function e(t, e) {
                let i = t.condition;
                (i.callback || function() {
                    return this.chartWidth <= lL(i.maxWidth, Number.MAX_VALUE) && this.chartHeight <= lL(i.maxHeight, Number.MAX_VALUE) && this.chartWidth >= lL(i.minWidth, 0) && this.chartHeight >= lL(i.minHeight, 0);
                }).call(this) && e.push(t._id);
            }
            function i(t, e) {
                let i = this.options.responsive, s = this.currentResponsive, o = [], r;
                !e && i && i.rules && i.rules.forEach((t)=>{
                    void 0 === t._id && (t._id = lO()), this.matchResponsiveRule(t, o);
                }, this);
                let a = lP(...o.map((t)=>lA(i?.rules || [], (e)=>e._id === t)).map((t)=>t?.chartOptions));
                a.isResponsiveOptions = !0, o = o.toString() || void 0;
                let n = s?.ruleIds;
                o !== n && (s && (this.currentResponsive = void 0, this.updatingResponsive = !0, this.update(s.undoOptions, t, !0), this.updatingResponsive = !1), o ? ((r = lT(a, this.options, !0, this.collectionsWithUpdate)).isResponsiveOptions = !0, this.currentResponsive = {
                    ruleIds: o,
                    mergedOptions: a,
                    undoOptions: r
                }, this.updatingResponsive || this.update(a, t, !0)) : this.currentResponsive = void 0);
            }
            t.compose = function(t) {
                let s = t.prototype;
                return s.matchResponsiveRule || lC(s, {
                    matchResponsiveRule: e,
                    setResponsive: i
                }), t;
            };
        }(b || (b = {}));
        let lE = b;
        w.AST = t6, w.Axis = s$, w.Chart = a0, w.Color = tL, w.DataLabel = hf, w.DataTableCore = rp, w.Fx = tB, w.HTMLElement = i6, w.Legend = au, w.LegendSymbol = rm, w.OverlappingDataLabels = w.OverlappingDataLabels || ll, w.PlotLineOrBand = oa, w.Point = oK, w.Pointer = ra, w.RendererRegistry = eg, w.Series = r1, w.SeriesRegistry = rk, w.StackItem = nd, w.SVGElement = eJ, w.SVGRenderer = iU, w.Templating = ep, w.Tick = sf, w.Time = tu, w.Tooltip = oE, w.animate = tU.animate, w.animObject = tU.animObject, w.chart = a0.chart, w.color = tL.parse, w.dateFormat = ep.dateFormat, w.defaultOptions = tv.defaultOptions, w.distribute = ey.distribute, w.format = ep.format, w.getDeferredAnimation = tU.getDeferredAnimation, w.getOptions = tv.getOptions, w.numberFormat = ep.numberFormat, w.seriesType = rk.seriesType, w.setAnimation = tU.setAnimation, w.setOptions = tv.setOptions, w.stop = tU.stop, w.time = tv.defaultTime, w.timers = tB.timers, ({
            compose: function(t, e, i) {
                let s = t.types.pie;
                if (!e.symbolCustomAttribs.includes("borderRadius")) {
                    let o = i.prototype.symbols;
                    lp(t, "afterColumnTranslate", lk, {
                        order: 9
                    }), lp(s, "afterTranslate", lM), e.symbolCustomAttribs.push("borderRadius", "brBoxHeight", "brBoxY", "brEnd", "brStart"), ly = o.arc, lb = o.roundedRect, o.arc = lv, o.roundedRect = lS;
                }
            },
            optionsToObject: lw
        }).compose(w.Series, w.SVGElement, w.SVGRenderer), hv.compose(w.Series.types.column), hf.compose(w.Series), sK.compose(w.Axis), i6.compose(w.SVGRenderer), au.compose(w.Chart), s1.compose(w.Axis), ll.compose(w.Chart), h7.compose(w.Series.types.pie), oa.compose(w.Chart, w.Axis), ra.compose(w.Chart), lE.compose(w.Chart), ni.compose(w.Axis, w.Chart, w.Series), nO.compose(w.Axis, w.Chart, w.Series), oE.compose(w.Pointer), V.extend(w, V);
        let lI = w;
        return k.default;
    })());

});

parcelRegister("1vTJy", function(module, exports) {

$parcel$export(module.exports, "default", () => $11a3eb427b5a5b5d$export$2e2bcd8739ae039);
/**
 * @license Highcharts Grid v2.1.1 (2025-12-10)
 * @module grid/grid-lite
 *
 * (c) 2009-2025 Highsoft AS
 *
 * License: www.highcharts.com/license
 */ 
var $6phAG = parcelRequire("6phAG");

var $5YKvy = parcelRequire("5YKvy");

var $711xA = parcelRequire("711xA");

var $6GqCF = parcelRequire("6GqCF");

var $5Jprx = parcelRequire("5Jprx");

var $1WhMx = parcelRequire("1WhMx");

var $jE1JP = parcelRequire("jE1JP");

var $7fvOS = parcelRequire("7fvOS");

var $jcnyQ = parcelRequire("jcnyQ");

var $5PVyc = parcelRequire("5PVyc");

var $cZqnj = parcelRequire("cZqnj");

var $7Tdil = parcelRequire("7Tdil");

var $fCJD3 = parcelRequire("fCJD3");

var $ekDzA = parcelRequire("ekDzA");

var $cRqRU = parcelRequire("cRqRU");

var $l3aRA = parcelRequire("l3aRA");

var $gGcXV = parcelRequire("gGcXV");

var $32BbZ = parcelRequire("32BbZ");
parcelRequire("bilki");
parcelRequire("lM6pi");
parcelRequire("gm72G");
parcelRequire("8tmXn");
parcelRequire("2pvlc");
parcelRequire("7Vf02");
parcelRequire("f9g5d");
parcelRequire("in0Rk");
parcelRequire("e5SH1");
/* *
 *
 *  Namespace
 *
 * */ const $11a3eb427b5a5b5d$var$G = {
    AST: $6phAG.default,
    ColumnResizing: $711xA.default,
    DataConnector: $6GqCF.default,
    DataConverter: $5Jprx.default,
    DataCursor: $1WhMx.default,
    DataModifier: $7fvOS.default,
    DataPool: $jcnyQ.default,
    DataTable: $5PVyc.default,
    defaultOptions: (0, $cZqnj.default).defaultOptions,
    Grid: (0, $jE1JP.default),
    grid: (0, $jE1JP.default).grid,
    grids: (0, $jE1JP.default).grids,
    isHighContrastModeActive: (0, $fCJD3.default).isHighContrastModeActive,
    merge: (0, $l3aRA.default).merge,
    Pagination: $32BbZ.default,
    product: 'Grid Lite',
    setOptions: (0, $cZqnj.default).setOptions,
    SvgIcons: $gGcXV.default,
    Table: $ekDzA.default,
    Templating: $5YKvy.default,
    version: (0, $7Tdil.default).version,
    win: (0, $7Tdil.default).win
};
(0, $cRqRU.default).compose($11a3eb427b5a5b5d$var$G.Grid, $11a3eb427b5a5b5d$var$G.Table);
const { defaultOptions: $11a3eb427b5a5b5d$export$ba43bf67f3d48107, Grid: $11a3eb427b5a5b5d$export$ef2184bd89960b14, grid: $11a3eb427b5a5b5d$export$85fc379452d91af0, grids: $11a3eb427b5a5b5d$export$5c5a246395cc6cbc, isHighContrastModeActive: $11a3eb427b5a5b5d$export$a16c26806a6d52c, merge: $11a3eb427b5a5b5d$export$4950aa0f605343fb, product: $11a3eb427b5a5b5d$export$dbd0f18357df1ddd, setOptions: $11a3eb427b5a5b5d$export$add91eafeaeab287, version: $11a3eb427b5a5b5d$export$83d89fbfd8236492, win: $11a3eb427b5a5b5d$export$10a0f131c0eea21b } = $11a3eb427b5a5b5d$var$G;
var $11a3eb427b5a5b5d$export$2e2bcd8739ae039 = $11a3eb427b5a5b5d$var$G;

});
parcelRegister("6phAG", function(module, exports) {

$parcel$export(module.exports, "default", () => $4aa2b902a5e78904$export$2e2bcd8739ae039);
/* *
 *
 *  (c) 2010-2025 Torstein Honsi
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 * */ 
var $30Vhv = parcelRequire("30Vhv");

var $l3aRA = parcelRequire("l3aRA");
'use strict';
const { SVG_NS: $4aa2b902a5e78904$var$SVG_NS, win: $4aa2b902a5e78904$var$win } = (0, $30Vhv.default);
const { attr: $4aa2b902a5e78904$var$attr, createElement: $4aa2b902a5e78904$var$createElement, css: $4aa2b902a5e78904$var$css, error: $4aa2b902a5e78904$var$error, isFunction: $4aa2b902a5e78904$var$isFunction, isString: $4aa2b902a5e78904$var$isString, objectEach: $4aa2b902a5e78904$var$objectEach, splat: $4aa2b902a5e78904$var$splat } = (0, $l3aRA.default);
const { trustedTypes: $4aa2b902a5e78904$var$trustedTypes } = $4aa2b902a5e78904$var$win;
/* *
 *
 *  Constants
 *
 * */ // Create the trusted type policy. This should not be exposed.
const $4aa2b902a5e78904$var$trustedTypesPolicy = $4aa2b902a5e78904$var$trustedTypes && $4aa2b902a5e78904$var$isFunction($4aa2b902a5e78904$var$trustedTypes.createPolicy) && $4aa2b902a5e78904$var$trustedTypes.createPolicy('highcharts', {
    createHTML: (s)=>s
});
const $4aa2b902a5e78904$var$emptyHTML = $4aa2b902a5e78904$var$trustedTypesPolicy ? $4aa2b902a5e78904$var$trustedTypesPolicy.createHTML('') : '';
/* *
 *
 *  Class
 *
 * */ /**
 * The AST class represents an abstract syntax tree of HTML or SVG content. It
 * can take HTML as an argument, parse it, optionally transform it to SVG, then
 * perform sanitation before inserting it into the DOM.
 *
 * @class
 * @name Highcharts.AST
 *
 * @param {string|Array<Highcharts.ASTNode>} source
 * Either an HTML string or an ASTNode list to populate the tree.
 */ class $4aa2b902a5e78904$var$AST {
    /* *
     *
     *  Static Functions
     *
     * */ /**
     * Filter an object of SVG or HTML attributes against the allow list.
     *
     * @static
     *
     * @function Highcharts.AST#filterUserAttributes
     *
     * @param {Highcharts.SVGAttributes} attributes The attributes to filter
     *
     * @return {Highcharts.SVGAttributes}
     * The filtered attributes
     */ static filterUserAttributes(attributes) {
        $4aa2b902a5e78904$var$objectEach(attributes, (val, key)=>{
            let valid = true;
            if ($4aa2b902a5e78904$var$AST.allowedAttributes.indexOf(key) === -1) valid = false;
            if ([
                'background',
                'dynsrc',
                'href',
                'lowsrc',
                'src'
            ].indexOf(key) !== -1) valid = $4aa2b902a5e78904$var$isString(val) && $4aa2b902a5e78904$var$AST.allowedReferences.some((ref)=>val.indexOf(ref) === 0);
            if (!valid) {
                $4aa2b902a5e78904$var$error(33, false, void 0, {
                    'Invalid attribute in config': `${key}`
                });
                delete attributes[key];
            }
            // #17753, < is not allowed in SVG attributes
            if ($4aa2b902a5e78904$var$isString(val) && attributes[key]) attributes[key] = val.replace(/</g, '&lt;');
        });
        return attributes;
    }
    static parseStyle(style) {
        return style.split(';').reduce((styles, line)=>{
            const pair = line.split(':').map((s)=>s.trim()), key = pair.shift();
            if (key && pair.length) styles[key.replace(/-([a-z])/g, (g)=>g[1].toUpperCase())] = pair.join(':'); // #17146
            return styles;
        }, {});
    }
    /**
     * Utility function to set html content for an element by passing in a
     * markup string. The markup is safely parsed by the AST class to avoid
     * XSS vulnerabilities. This function should be used instead of setting
     * `innerHTML` in all cases where the content is not fully trusted.
     *
     * @static
     * @function Highcharts.AST#setElementHTML
     *
     * @param {SVGDOMElement|HTMLDOMElement} el
     * Node to set content of.
     *
     * @param {string} html
     * Markup string
     */ static setElementHTML(el, html) {
        el.innerHTML = $4aa2b902a5e78904$var$AST.emptyHTML; // Clear previous
        if (html) {
            const ast = new $4aa2b902a5e78904$var$AST(html);
            ast.addToDOM(el);
        }
    }
    /* *
     *
     *  Constructor
     *
     * */ // Construct an AST from HTML markup, or wrap an array of existing AST nodes
    constructor(source){
        this.nodes = typeof source === 'string' ? this.parseMarkup(source) : source;
    }
    /* *
     *
     *  Functions
     *
     * */ /**
     * Add the tree defined as a hierarchical JS structure to the DOM
     *
     * @function Highcharts.AST#addToDOM
     *
     * @param {Highcharts.HTMLDOMElement|Highcharts.SVGDOMElement} parent
     * The node where it should be added
     *
     * @return {Highcharts.HTMLDOMElement|Highcharts.SVGDOMElement}
     * The inserted node.
     */ addToDOM(parent) {
        /**
         * @private
         * @param {Highcharts.ASTNode} subtree
         * HTML/SVG definition
         * @param {Element} [subParent]
         * parent node
         * @return {Highcharts.SVGDOMElement|Highcharts.HTMLDOMElement}
         * The inserted node.
         */ function recurse(subtree, subParent) {
            let ret;
            $4aa2b902a5e78904$var$splat(subtree).forEach(function(item) {
                const tagName = item.tagName;
                const textNode = item.textContent ? (0, $30Vhv.default).doc.createTextNode(item.textContent) : void 0;
                // Whether to ignore the AST filtering totally, #15345
                const bypassHTMLFiltering = $4aa2b902a5e78904$var$AST.bypassHTMLFiltering;
                let node;
                if (tagName) {
                    if (tagName === '#text') node = textNode;
                    else if ($4aa2b902a5e78904$var$AST.allowedTags.indexOf(tagName) !== -1 || bypassHTMLFiltering) {
                        const NS = tagName === 'svg' ? $4aa2b902a5e78904$var$SVG_NS : subParent.namespaceURI || $4aa2b902a5e78904$var$SVG_NS;
                        const element = (0, $30Vhv.default).doc.createElementNS(NS, tagName);
                        const attributes = item.attributes || {};
                        // Apply attributes from root of AST node, legacy from
                        // from before TextBuilder
                        $4aa2b902a5e78904$var$objectEach(item, function(val, key) {
                            if (key !== 'tagName' && key !== 'attributes' && key !== 'children' && key !== 'style' && key !== 'textContent') attributes[key] = val;
                        });
                        $4aa2b902a5e78904$var$attr(element, bypassHTMLFiltering ? attributes : $4aa2b902a5e78904$var$AST.filterUserAttributes(attributes));
                        if (item.style) $4aa2b902a5e78904$var$css(element, item.style);
                        // Add text content
                        if (textNode) element.appendChild(textNode);
                        // Recurse
                        recurse(item.children || [], element);
                        node = element;
                    } else $4aa2b902a5e78904$var$error(33, false, void 0, {
                        'Invalid tagName in config': tagName
                    });
                }
                // Add to the tree
                if (node) subParent.appendChild(node);
                ret = node;
            });
            // Return last node added (on top level it's the only one)
            return ret;
        }
        return recurse(this.nodes, parent);
    }
    /**
     * Parse HTML/SVG markup into AST Node objects. Used internally from the
     * constructor.
     *
     * @private
     *
     * @function Highcharts.AST#getNodesFromMarkup
     *
     * @param {string} markup The markup string.
     *
     * @return {Array<Highcharts.ASTNode>} The parsed nodes.
     */ parseMarkup(markup) {
        const nodes = [];
        markup = markup.trim()// The style attribute throws a warning when parsing when CSP is
        // enabled (#6884), so use an alias and pick it up below
        // Make all quotation marks parse correctly to DOM (#17627)
        .replace(/ style=(["'])/g, ' data-style=$1');
        let doc;
        try {
            doc = new DOMParser().parseFromString($4aa2b902a5e78904$var$trustedTypesPolicy ? $4aa2b902a5e78904$var$trustedTypesPolicy.createHTML(markup) : markup, 'text/html');
        } catch  {
        // There are two cases where this fails:
        // 1. IE9 and PhantomJS, where the DOMParser only supports parsing
        //    XML
        // 2. Due to a Chromium issue where chart redraws are triggered by
        //    a `beforeprint` event (#16931),
        //    https://issues.chromium.org/issues/40222135
        }
        if (!doc) {
            const body = $4aa2b902a5e78904$var$createElement('div');
            body.innerHTML = markup;
            doc = {
                body: body
            };
        }
        const appendChildNodes = (node, addTo)=>{
            const tagName = node.nodeName.toLowerCase();
            // Add allowed tags
            const astNode = {
                tagName: tagName
            };
            if (tagName === '#text') astNode.textContent = node.textContent || '';
            const parsedAttributes = node.attributes;
            // Add attributes
            if (parsedAttributes) {
                const attributes = {};
                [].forEach.call(parsedAttributes, (attrib)=>{
                    if (attrib.name === 'data-style') astNode.style = $4aa2b902a5e78904$var$AST.parseStyle(attrib.value);
                    else attributes[attrib.name] = attrib.value;
                });
                astNode.attributes = attributes;
            }
            // Handle children
            if (node.childNodes.length) {
                const children = [];
                [].forEach.call(node.childNodes, (childNode)=>{
                    appendChildNodes(childNode, children);
                });
                if (children.length) astNode.children = children;
            }
            addTo.push(astNode);
        };
        [].forEach.call(doc.body.childNodes, (childNode)=>appendChildNodes(childNode, nodes));
        return nodes;
    }
}
/* *
 *
 *  Static Properties
 *
 * */ /**
 * The list of allowed SVG or HTML attributes, used for sanitizing
 * potentially harmful content from the chart configuration before adding to
 * the DOM.
 *
 * @see [Source code with default values](
 * https://github.com/highcharts/highcharts/blob/master/ts/Core/Renderer/HTML/AST.ts#:~:text=public%20static%20allowedAttributes)
 *
 * @example
 * // Allow a custom, trusted attribute
 * Highcharts.AST.allowedAttributes.push('data-value');
 *
 * @name Highcharts.AST.allowedAttributes
 * @type {Array<string>}
 */ $4aa2b902a5e78904$var$AST.allowedAttributes = [
    'alt',
    'aria-controls',
    'aria-describedby',
    'aria-expanded',
    'aria-haspopup',
    'aria-hidden',
    'aria-label',
    'aria-labelledby',
    'aria-live',
    'aria-pressed',
    'aria-readonly',
    'aria-roledescription',
    'aria-selected',
    'class',
    'clip-path',
    'color',
    'colspan',
    'cx',
    'cy',
    'd',
    'disabled',
    'dx',
    'dy',
    'fill',
    'filterUnits',
    'flood-color',
    'flood-opacity',
    'height',
    'href',
    'id',
    'in',
    'in2',
    'markerHeight',
    'markerWidth',
    'offset',
    'opacity',
    'operator',
    'orient',
    'padding',
    'paddingLeft',
    'paddingRight',
    'patternUnits',
    'r',
    'radius',
    'refX',
    'refY',
    'result',
    'role',
    'rowspan',
    'scope',
    'slope',
    'src',
    'startOffset',
    'stdDeviation',
    'stroke-linecap',
    'stroke-width',
    'stroke',
    'style',
    'summary',
    'tabindex',
    'tableValues',
    'target',
    'text-align',
    'text-anchor',
    'textAnchor',
    'textLength',
    'title',
    'type',
    'valign',
    'width',
    'x',
    'x1',
    'x2',
    'xlink:href',
    'y',
    'y1',
    'y2',
    'zIndex'
];
/**
 * The list of allowed references for referring attributes like `href` and
 * `src`. Attribute values will only be allowed if they start with one of
 * these strings.
 *
 * @see [Source code with default values](
 * https://github.com/highcharts/highcharts/blob/master/ts/Core/Renderer/HTML/AST.ts#:~:text=public%20static%20allowedReferences)
 *
 * @example
 * // Allow tel:
 * Highcharts.AST.allowedReferences.push('tel:');
 *
 * @name    Highcharts.AST.allowedReferences
 * @type    {Array<string>}
 */ $4aa2b902a5e78904$var$AST.allowedReferences = [
    'https://',
    'http://',
    'mailto:',
    '/',
    '../',
    './',
    '#'
];
/**
 * The list of allowed SVG or HTML tags, used for sanitizing potentially
 * harmful content from the chart configuration before adding to the DOM.
 *
 * @see [Source code with default values](
 * https://github.com/highcharts/highcharts/blob/master/ts/Core/Renderer/HTML/AST.ts#:~:text=public%20static%20allowedTags)
 *
 * @example
 * // Allow a custom, trusted tag
 * Highcharts.AST.allowedTags.push('blink'); // ;)
 *
 * @name    Highcharts.AST.allowedTags
 * @type    {Array<string>}
 */ $4aa2b902a5e78904$var$AST.allowedTags = [
    '#text',
    'a',
    'abbr',
    'b',
    'br',
    'button',
    'caption',
    'circle',
    'clipPath',
    'code',
    'dd',
    'defs',
    'div',
    'dl',
    'dt',
    'em',
    'feComponentTransfer',
    'feComposite',
    'feDropShadow',
    'feFlood',
    'feFuncA',
    'feFuncB',
    'feFuncG',
    'feFuncR',
    'feGaussianBlur',
    'feMerge',
    'feMergeNode',
    'feMorphology',
    'feOffset',
    'filter',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'hr',
    'i',
    'img',
    'li',
    'linearGradient',
    'marker',
    'ol',
    'p',
    'path',
    'pattern',
    'pre',
    'rect',
    'small',
    'span',
    'stop',
    'strong',
    'style',
    'sub',
    'sup',
    'svg',
    'table',
    'tbody',
    'td',
    'text',
    'textPath',
    'th',
    'thead',
    'title',
    'tr',
    'tspan',
    'u',
    'ul'
];
$4aa2b902a5e78904$var$AST.emptyHTML = $4aa2b902a5e78904$var$emptyHTML;
/**
 * Allow all custom SVG and HTML attributes, references and tags (together
 * with potentially harmful ones) to be added to the DOM from the chart
 * configuration. In other words, disable the allow-listing which is the
 * primary functionality of the AST.
 *
 * WARNING: Setting this property to `true` while allowing untrusted user
 * data in the chart configuration will expose your application to XSS
 * security risks!
 *
 * Note that in case you want to allow a known set of tags or attributes,
 * you should allow-list them instead of disabling the filtering totally.
 * See [allowedAttributes](Highcharts.AST#.allowedAttributes),
 * [allowedReferences](Highcharts.AST#.allowedReferences) and
 * [allowedTags](Highcharts.AST#.allowedTags). The `bypassHTMLFiltering`
 * setting is intended only for those cases where allow-listing is not
 * practical, and the chart configuration already comes from a secure
 * source.
 *
 * @example
 * // Allow all custom attributes, references and tags (disable DOM XSS
 * // filtering)
 * Highcharts.AST.bypassHTMLFiltering = true;
 *
 * @name Highcharts.AST.bypassHTMLFiltering
 * @static
 */ $4aa2b902a5e78904$var$AST.bypassHTMLFiltering = false;
var /* *
 *
 *  Default Export
 *
 * */ $4aa2b902a5e78904$export$2e2bcd8739ae039 = $4aa2b902a5e78904$var$AST;
/* *
 *
 *  API Declarations
 *
 * */ /**
 * Serialized form of an SVG/HTML definition, including children.
 *
 * @interface Highcharts.ASTNode
 */ /**
* @name Highcharts.ASTNode#attributes
* @type {Highcharts.SVGAttributes|undefined}
*/ /**
* @name Highcharts.ASTNode#children
* @type {Array<Highcharts.ASTNode>|undefined}
*/ /**
* @name Highcharts.ASTNode#tagName
* @type {string|undefined}
*/ /**
* @name Highcharts.ASTNode#textContent
* @type {string|undefined}
*/ ''; // Keeps doclets above in file

});
parcelRegister("30Vhv", function(module, exports) {

$parcel$export(module.exports, "default", () => $231dce0c5c0d24c6$export$2e2bcd8739ae039);
/* *
 *
 *  (c) 2010-2025 Torstein Honsi
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 * */ 'use strict';
/* *
 *
 *  Namespace
 *
 * */ /**
 * Shared Highcharts properties.
 * @private
 */ var $231dce0c5c0d24c6$var$Globals;
(function(Globals) {
    /* *
     *
     *  Constants
     *
     * */ Globals.SVG_NS = 'http://www.w3.org/2000/svg', Globals.product = 'Highcharts', Globals.version = '2.1.1', Globals.win = typeof window !== 'undefined' ? window : {}, Globals.doc = Globals.win.document, Globals.svg = !!Globals.doc?.createElementNS?.(Globals.SVG_NS, 'svg')?.createSVGRect, Globals.pageLang = Globals.doc?.documentElement?.closest('[lang]')?.lang, Globals.userAgent = Globals.win.navigator?.userAgent || '', Globals.isChrome = Globals.win.chrome, Globals.isFirefox = Globals.userAgent.indexOf('Firefox') !== -1, Globals.isMS = /(edge|msie|trident)/i.test(Globals.userAgent) && !Globals.win.opera, Globals.isSafari = !Globals.isChrome && Globals.userAgent.indexOf('Safari') !== -1, Globals.isTouchDevice = /(Mobile|Android|Windows Phone)/.test(Globals.userAgent), Globals.isWebKit = Globals.userAgent.indexOf('AppleWebKit') !== -1, Globals.deg2rad = Math.PI * 2 / 360, Globals.marginNames = [
        'plotTop',
        'marginRight',
        'marginBottom',
        'plotLeft'
    ], Globals.noop = function() {}, Globals.supportsPassiveEvents = function() {
        // Checks whether the browser supports passive events, (#11353).
        let supportsPassive = false;
        // Object.defineProperty doesn't work on IE as well as passive
        // events - instead of using polyfill, we can exclude IE totally.
        if (!Globals.isMS) {
            const opts = Object.defineProperty({}, 'passive', {
                get: function() {
                    supportsPassive = true;
                }
            });
            if (Globals.win.addEventListener && Globals.win.removeEventListener) {
                Globals.win.addEventListener('testPassive', Globals.noop, opts);
                Globals.win.removeEventListener('testPassive', Globals.noop, opts);
            }
        }
        return supportsPassive;
    }();
    /**
     * An array containing the current chart objects in the page. A chart's
     * position in the array is preserved throughout the page's lifetime. When
     * a chart is destroyed, the array item becomes `undefined`.
     *
     * @name Highcharts.charts
     * @type {Array<Highcharts.Chart|undefined>}
     */ Globals.charts = [];
    /**
     * A shared registry between all bundles to keep track of applied
     * compositions.
     * @private
     */ Globals.composed = [];
    /**
     * A hook for defining additional date format specifiers. New
     * specifiers are defined as key-value pairs by using the
     * specifier as key, and a function which takes the timestamp as
     * value. This function returns the formatted portion of the
     * date.
     *
     * Using `dateFormats` is also a convenient way to define new keys for
     * complex locale-aware date formats compatible with the
     * [Intl.DateTimeFormat](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat)
     * browser API, whenever the built-in formats are not sufficient.
     *
     * @sample highcharts/global/dateformats/
     *         Adding support for week number
     * @sample highcharts/global/dateformats-object/
     *         A locale-aware date format using `Intl.DateTimeFormat`
     *
     * @name Highcharts.dateFormats
     * @type {Record<string, Highcharts.TimeFormatCallbackFunction>}
     */ Globals.dateFormats = {};
    /**
     * @private
     * @deprecated
     * @todo Use only `Core/Series/SeriesRegistry.seriesTypes`
     */ Globals.seriesTypes = {};
    /**
     * @private
     */ Globals.symbolSizes = {};
    /* *
     *
     *  Properties
     *
     * */ // eslint-disable-next-line prefer-const
    Globals.chartCount = 0;
})($231dce0c5c0d24c6$var$Globals || ($231dce0c5c0d24c6$var$Globals = {}));
var /* *
 *
 *  Default Export
 *
 * */ $231dce0c5c0d24c6$export$2e2bcd8739ae039 = $231dce0c5c0d24c6$var$Globals;
/* *
 *
 *  API Declarations
 *
 * */ /**
 * Theme options that should get applied to the chart. In module mode it
 * might not be possible to change this property because of read-only
 * restrictions, instead use {@link Highcharts.setOptions}.
 *
 * @deprecated
 * @name Highcharts.theme
 * @type {Highcharts.Options}
 */ ''; // Keeps doclets above in JS file

});

parcelRegister("l3aRA", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5324dfd0bb3e10b$export$2e2bcd8739ae039);
/* *
 *
 *  (c) 2010-2025 Torstein Honsi
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 * */ 
var $30Vhv = parcelRequire("30Vhv");
'use strict';
const { charts: $f5324dfd0bb3e10b$var$charts, doc: $f5324dfd0bb3e10b$var$doc, win: $f5324dfd0bb3e10b$var$win } = (0, $30Vhv.default);
/* *
 *
 *  Functions
 *
 * */ /**
 * Provide error messages for debugging, with links to online explanation. This
 * function can be overridden to provide custom error handling.
 *
 * @sample highcharts/chart/highcharts-error/
 *         Custom error handler
 *
 * @function Highcharts.error
 *
 * @param {number|string} code
 *        The error code. See
 *        [errors.xml](https://github.com/highcharts/highcharts/blob/master/errors/errors.xml)
 *        for available codes. If it is a string, the error message is printed
 *        directly in the console.
 *
 * @param {boolean} [stop=false]
 *        Whether to throw an error or just log a warning in the console.
 *
 * @param {Highcharts.Chart} [chart]
 *        Reference to the chart that causes the error. Used in 'debugger'
 *        module to display errors directly on the chart.
 *        Important note: This argument is undefined for errors that lack
 *        access to the Chart instance. In such case, the error will be
 *        displayed on the last created chart.
 *
 * @param {Highcharts.Dictionary<string>} [params]
 *        Additional parameters for the generated message.
 *
 * @return {void}
 */ function $f5324dfd0bb3e10b$var$error(code, stop, chart, params) {
    const severity = stop ? 'Highcharts error' : 'Highcharts warning';
    if (code === 32) code = `${severity}: Deprecated member`;
    const isCode = $f5324dfd0bb3e10b$var$isNumber(code);
    let message = isCode ? `${severity} #${code}: www.highcharts.com/errors/${code}/` : code.toString();
    const defaultHandler = function() {
        if (stop) throw new Error(message);
        // Else ...
        if ($f5324dfd0bb3e10b$var$win.console && $f5324dfd0bb3e10b$var$error.messages.indexOf(message) === -1 // Prevent console flooting
        ) console.warn(message); // eslint-disable-line no-console
    };
    if (typeof params !== 'undefined') {
        let additionalMessages = '';
        if (isCode) message += '?';
        $f5324dfd0bb3e10b$var$objectEach(params, function(value, key) {
            additionalMessages += `\n - ${key}: ${value}`;
            if (isCode) message += encodeURI(key) + '=' + encodeURI(value);
        });
        message += additionalMessages;
    }
    $f5324dfd0bb3e10b$var$fireEvent((0, $30Vhv.default), 'displayError', {
        chart: chart,
        code: code,
        message: message,
        params: params
    }, defaultHandler);
    $f5324dfd0bb3e10b$var$error.messages.push(message);
}
(function(error) {
    error.messages = [];
})($f5324dfd0bb3e10b$var$error || ($f5324dfd0bb3e10b$var$error = {}));
/**
 * Utility function to deep merge two or more objects and return a third object.
 * If the first argument is true, the contents of the second object is copied
 * into the first object. The merge function can also be used with a single
 * object argument to create a deep copy of an object.
 *
 * @function Highcharts.merge<T>
 *
 * @param {true | T} extendOrSource
 *        Whether to extend the left-side object,
 *        or the first object to merge as a deep copy.
 *
 * @param {...Array<object|undefined>} [sources]
 *        Object(s) to merge into the previous one.
 *
 * @return {T}
 *         The merged object. If the first argument is true, the return is the
 *         same as the second argument.
 */ function $f5324dfd0bb3e10b$var$merge(extendOrSource, ...sources) {
    let i, args = [
        extendOrSource,
        ...sources
    ], ret = {};
    const doCopy = function(copy, original) {
        // An object is replacing a primitive
        if (typeof copy !== 'object') copy = {};
        $f5324dfd0bb3e10b$var$objectEach(original, function(value, key) {
            // Prototype pollution (#14883)
            if (key === '__proto__' || key === 'constructor') return;
            // Copy the contents of objects, but not arrays or DOM nodes
            if ($f5324dfd0bb3e10b$var$isObject(value, true) && !$f5324dfd0bb3e10b$var$isClass(value) && !$f5324dfd0bb3e10b$var$isDOMElement(value)) copy[key] = doCopy(copy[key] || {}, value);
            else copy[key] = original[key];
        });
        return copy;
    };
    // If first argument is true, copy into the existing object. Used in
    // setOptions.
    if (extendOrSource === true) {
        ret = args[1];
        args = Array.prototype.slice.call(args, 2);
    }
    // For each argument, extend the return
    const len = args.length;
    for(i = 0; i < len; i++)ret = doCopy(ret, args[i]);
    return ret;
}
/**
 * Constrain a value to within a lower and upper threshold.
 *
 * @private
 * @param {number} value The initial value
 * @param {number} min The lower threshold
 * @param {number} max The upper threshold
 * @return {number} Returns a number value within min and max.
 */ function $f5324dfd0bb3e10b$var$clamp(value, min, max) {
    return value > min ? value < max ? value : max : min;
}
/**
 * Utility for crisping a line position to the nearest full pixel depening on
 * the line width
 * @param {number} value       The raw pixel position
 * @param {number} lineWidth   The line width
 * @param {boolean} [inverted] Whether the containing group is inverted.
 *                             Crisping round numbers on the y-scale need to go
 *                             to the other side because the coordinate system
 *                             is flipped (scaleY is -1)
 * @return {number}            The pixel position to use for a crisp display
 */ function $f5324dfd0bb3e10b$var$crisp(value, lineWidth = 0, inverted) {
    const mod = lineWidth % 2 / 2, inverter = inverted ? -1 : 1;
    return (Math.round(value * inverter - mod) + mod) * inverter;
}
// eslint-disable-next-line valid-jsdoc
/**
 * Return the deep difference between two objects. It can either return the new
 * properties, or optionally return the old values of new properties.
 * @private
 */ function $f5324dfd0bb3e10b$var$diffObjects(newer, older, keepOlder, collectionsWithUpdate) {
    const ret = {};
    /**
     * Recurse over a set of options and its current values, and store the
     * current values in the ret object.
     */ function diff(newer, older, ret, depth) {
        const keeper = keepOlder ? older : newer;
        $f5324dfd0bb3e10b$var$objectEach(newer, function(newerVal, key) {
            if (!depth && collectionsWithUpdate && collectionsWithUpdate.indexOf(key) > -1 && older[key]) {
                newerVal = $f5324dfd0bb3e10b$var$splat(newerVal);
                ret[key] = [];
                // Iterate over collections like series, xAxis or yAxis and map
                // the items by index.
                for(let i = 0; i < Math.max(newerVal.length, older[key].length); i++)// Item exists in current data (#6347)
                if (older[key][i]) {
                    // If the item is missing from the new data, we need to
                    // save the whole config structure. Like when
                    // responsively updating from a dual axis layout to a
                    // single axis and back (#13544).
                    if (newerVal[i] === void 0) ret[key][i] = older[key][i];
                    else {
                        ret[key][i] = {};
                        diff(newerVal[i], older[key][i], ret[key][i], depth + 1);
                    }
                }
            } else if ($f5324dfd0bb3e10b$var$isObject(newerVal, true) && !newerVal.nodeType // #10044
            ) {
                ret[key] = $f5324dfd0bb3e10b$var$isArray(newerVal) ? [] : {};
                diff(newerVal, older[key] || {}, ret[key], depth + 1);
                // Delete empty nested objects
                if (Object.keys(ret[key]).length === 0 && // Except colorAxis which is a special case where the empty
                // object means it is enabled. Which is unfortunate and we
                // should try to find a better way.
                !(key === 'colorAxis' && depth === 0)) delete ret[key];
            } else if (newer[key] !== older[key] || // If the newer key is explicitly undefined, keep it (#10525)
            key in newer && !(key in older)) {
                if (key !== '__proto__' && key !== 'constructor') ret[key] = keeper[key];
            }
        });
    }
    diff(newer, older, ret, 0);
    return ret;
}
/**
 * Shortcut for parseInt
 *
 * @private
 * @function Highcharts.pInt
 *
 * @param {*} s
 *        any
 *
 * @param {number} [mag]
 *        Magnitude
 *
 * @return {number}
 *         number
 */ function $f5324dfd0bb3e10b$var$pInt(s, mag) {
    return parseInt(s, mag || 10);
}
/**
 * Utility function to check for string type.
 *
 * @function Highcharts.isString
 *
 * @param {*} s
 *        The item to check.
 *
 * @return {boolean}
 *         True if the argument is a string.
 */ function $f5324dfd0bb3e10b$var$isString(s) {
    return typeof s === 'string';
}
/**
 * Utility function to check if an item is an array.
 *
 * @function Highcharts.isArray
 *
 * @param {*} obj
 *        The item to check.
 *
 * @return {boolean}
 *         True if the argument is an array.
 */ function $f5324dfd0bb3e10b$var$isArray(obj) {
    const str = Object.prototype.toString.call(obj);
    return str === '[object Array]' || str === '[object Array Iterator]';
}
/**
 * Utility function to check if an item is of type object.
 *
 * @function Highcharts.isObject
 *
 * @param {*} obj
 *        The item to check.
 *
 * @param {boolean} [strict=false]
 *        Also checks that the object is not an array.
 *
 * @return {boolean}
 *         True if the argument is an object.
 */ function $f5324dfd0bb3e10b$var$isObject(obj, strict) {
    return !!obj && typeof obj === 'object' && (!strict || !$f5324dfd0bb3e10b$var$isArray(obj)); // eslint-disable-line @typescript-eslint/no-explicit-any
}
/**
 * Utility function to check if an Object is a HTML Element.
 *
 * @function Highcharts.isDOMElement
 *
 * @param {*} obj
 *        The item to check.
 *
 * @return {boolean}
 *         True if the argument is a HTML Element.
 */ function $f5324dfd0bb3e10b$var$isDOMElement(obj) {
    return $f5324dfd0bb3e10b$var$isObject(obj) && typeof obj.nodeType === 'number';
}
/**
 * Utility function to check if an Object is a class.
 *
 * @function Highcharts.isClass
 *
 * @param {object|undefined} obj
 *        The item to check.
 *
 * @return {boolean}
 *         True if the argument is a class.
 */ function $f5324dfd0bb3e10b$var$isClass(obj) {
    const c = obj?.constructor;
    return !!($f5324dfd0bb3e10b$var$isObject(obj, true) && !$f5324dfd0bb3e10b$var$isDOMElement(obj) && c?.name && c.name !== 'Object');
}
/**
 * Utility function to check if an item is a number and it is finite (not NaN,
 * Infinity or -Infinity).
 *
 * @function Highcharts.isNumber
 *
 * @param {*} n
 *        The item to check.
 *
 * @return {boolean}
 *         True if the item is a finite number
 */ function $f5324dfd0bb3e10b$var$isNumber(n) {
    return typeof n === 'number' && !isNaN(n) && n < Infinity && n > -Infinity;
}
/**
 * Remove the last occurence of an item from an array.
 *
 * @function Highcharts.erase
 *
 * @param {Array<*>} arr
 *        The array.
 *
 * @param {*} item
 *        The item to remove.
 *
 * @return {void}
 */ function $f5324dfd0bb3e10b$var$erase(arr, item) {
    let i = arr.length;
    while(i--)if (arr[i] === item) {
        arr.splice(i, 1);
        break;
    }
}
/**
 * Insert a series or an axis in a collection with other items, either the
 * chart series or yAxis series or axis collections, in the correct order
 * according to the index option and whether it is internal. Used internally
 * when adding series and axes.
 *
 * @private
 * @function Highcharts.Chart#insertItem
 * @param  {Highcharts.Series|Highcharts.Axis} item
 *         The item to insert
 * @param  {Array<Highcharts.Series>|Array<Highcharts.Axis>} collection
 *         A collection of items, like `chart.series` or `xAxis.series`.
 * @return {number} The index of the series in the collection.
 */ function $f5324dfd0bb3e10b$var$insertItem(item, collection) {
    const indexOption = item.options.index, length = collection.length;
    let i;
    for(// Internal item (navigator) should always be pushed to the end
    i = item.options.isInternal ? length : 0; i < length + 1; i++)if (// No index option, reached the end of the collection,
    // equivalent to pushing
    !collection[i] || // Handle index option, the element to insert has lower index
    $f5324dfd0bb3e10b$var$isNumber(indexOption) && indexOption < $f5324dfd0bb3e10b$var$pick(collection[i].options.index, collection[i]._i) || // Insert the new item before other internal items
    // (navigator)
    collection[i].options.isInternal) {
        collection.splice(i, 0, item);
        break;
    }
    return i;
}
/**
 * Adds an item to an array, if it is not present in the array.
 *
 * @function Highcharts.pushUnique
 *
 * @param {Array<unknown>} array
 * The array to add the item to.
 *
 * @param {unknown} item
 * The item to add.
 *
 * @return {boolean}
 * Returns true, if the item was not present and has been added.
 */ function $f5324dfd0bb3e10b$var$pushUnique(array, item) {
    return array.indexOf(item) < 0 && !!array.push(item);
}
/**
 * Check if an object is null or undefined.
 *
 * @function Highcharts.defined
 *
 * @param {*} obj
 *        The object to check.
 *
 * @return {boolean}
 *         False if the object is null or undefined, otherwise true.
 */ function $f5324dfd0bb3e10b$var$defined(obj) {
    return typeof obj !== 'undefined' && obj !== null;
}
/**
 * Set or get an attribute or an object of attributes.
 *
 * To use as a setter, pass a key and a value, or let the second argument be a
 * collection of keys and values. When using a collection, passing a value of
 * `null` or `undefined` will remove the attribute.
 *
 * To use as a getter, pass only a string as the second argument.
 *
 * @function Highcharts.attr
 *
 * @param {Highcharts.HTMLDOMElement|Highcharts.SVGDOMElement} elem
 *        The DOM element to receive the attribute(s).
 *
 * @param {string|Highcharts.HTMLAttributes|Highcharts.SVGAttributes} [keyOrAttribs]
 *        The property or an object of key-value pairs.
 *
 * @param {number|string} [value]
 *        The value if a single property is set.
 *
 * @return {string|null|undefined}
 *         When used as a getter, return the value.
 */ function $f5324dfd0bb3e10b$var$attr(elem, keyOrAttribs, value) {
    const isGetter = $f5324dfd0bb3e10b$var$isString(keyOrAttribs) && !$f5324dfd0bb3e10b$var$defined(value);
    let ret;
    const attrSingle = (value, key)=>{
        // Set the value
        if ($f5324dfd0bb3e10b$var$defined(value)) elem.setAttribute(key, value);
        else if (isGetter) {
            ret = elem.getAttribute(key);
            // IE7 and below cannot get class through getAttribute (#7850)
            if (!ret && key === 'class') ret = elem.getAttribute(key + 'Name');
        // Remove the value
        } else elem.removeAttribute(key);
    };
    // If keyOrAttribs is a string
    if ($f5324dfd0bb3e10b$var$isString(keyOrAttribs)) attrSingle(value, keyOrAttribs);
    else $f5324dfd0bb3e10b$var$objectEach(keyOrAttribs, attrSingle);
    return ret;
}
/**
 * Check if an element is an array, and if not, make it into an array.
 *
 * @function Highcharts.splat
 *
 * @param {*} obj
 *        The object to splat.
 *
 * @return {Array}
 *         The produced or original array.
 */ function $f5324dfd0bb3e10b$var$splat(obj) {
    return $f5324dfd0bb3e10b$var$isArray(obj) ? obj : [
        obj
    ];
}
/**
 * Set a timeout if the delay is given, otherwise perform the function
 * synchronously.
 *
 * @function Highcharts.syncTimeout
 *
 * @param {Function} fn
 *        The function callback.
 *
 * @param {number} delay
 *        Delay in milliseconds.
 *
 * @param {*} [context]
 *        An optional context to send to the function callback.
 *
 * @return {number}
 *         An identifier for the timeout that can later be cleared with
 *         Highcharts.clearTimeout. Returns -1 if there is no timeout.
 */ function $f5324dfd0bb3e10b$var$syncTimeout(fn, delay, context) {
    if (delay > 0) return setTimeout(fn, delay, context);
    fn.call(0, context);
    return -1;
}
/**
 * Internal clear timeout. The function checks that the `id` was not removed
 * (e.g. by `chart.destroy()`). For the details see
 * [issue #7901](https://github.com/highcharts/highcharts/issues/7901).
 *
 * @function Highcharts.clearTimeout
 *
 * @param {number|undefined} id
 * Id of a timeout.
 */ function $f5324dfd0bb3e10b$var$internalClearTimeout(id) {
    if ($f5324dfd0bb3e10b$var$defined(id)) clearTimeout(id);
}
/* eslint-disable valid-jsdoc */ /**
 * Utility function to extend an object with the members of another.
 *
 * @function Highcharts.extend<T>
 *
 * @param {T|undefined} a
 *        The object to be extended.
 *
 * @param {Partial<T>} b
 *        The object to add to the first one.
 *
 * @return {T}
 *         Object a, the original object.
 */ function $f5324dfd0bb3e10b$var$extend(a, b) {
    /* eslint-enable valid-jsdoc */ let n;
    if (!a) a = {};
    for(n in b)a[n] = b[n];
    return a;
}
/* eslint-disable valid-jsdoc */ /**
 * Return the first value that is not null or undefined.
 *
 * @function Highcharts.pick<T>
 *
 * @param {...Array<T|null|undefined>} items
 *        Variable number of arguments to inspect.
 *
 * @return {T}
 *         The value of the first argument that is not null or undefined.
 */ function $f5324dfd0bb3e10b$var$pick() {
    const args = arguments;
    const length = args.length;
    for(let i = 0; i < length; i++){
        const arg = args[i];
        if (typeof arg !== 'undefined' && arg !== null) return arg;
    }
}
/**
 * Set CSS on a given element.
 *
 * @function Highcharts.css
 *
 * @param {Highcharts.HTMLDOMElement|Highcharts.SVGDOMElement} el
 *        An HTML DOM element.
 *
 * @param {Highcharts.CSSObject} styles
 *        Style object with camel case property names.
 *
 * @return {void}
 */ function $f5324dfd0bb3e10b$var$css(el, styles) {
    $f5324dfd0bb3e10b$var$extend(el.style, styles);
}
/**
 * Utility function to create an HTML element with attributes and styles.
 *
 * @function Highcharts.createElement
 *
 * @param {string} tag
 *        The HTML tag.
 *
 * @param {Highcharts.HTMLAttributes} [attribs]
 *        Attributes as an object of key-value pairs.
 *
 * @param {Highcharts.CSSObject} [styles]
 *        Styles as an object of key-value pairs.
 *
 * @param {Highcharts.HTMLDOMElement} [parent]
 *        The parent HTML object.
 *
 * @param {boolean} [nopad=false]
 *        If true, remove all padding, border and margin.
 *
 * @return {Highcharts.HTMLDOMElement}
 *         The created DOM element.
 */ function $f5324dfd0bb3e10b$var$createElement(tag, attribs, styles, parent, nopad) {
    const el = $f5324dfd0bb3e10b$var$doc.createElement(tag);
    if (attribs) $f5324dfd0bb3e10b$var$extend(el, attribs);
    if (nopad) $f5324dfd0bb3e10b$var$css(el, {
        padding: '0',
        border: 'none',
        margin: '0'
    });
    if (styles) $f5324dfd0bb3e10b$var$css(el, styles);
    if (parent) parent.appendChild(el);
    return el;
}
// eslint-disable-next-line valid-jsdoc
/**
 * Extend a prototyped class by new members.
 *
 * @deprecated
 * @function Highcharts.extendClass<T>
 *
 * @param {Highcharts.Class<T>} parent
 *        The parent prototype to inherit.
 *
 * @param {Highcharts.Dictionary<*>} members
 *        A collection of prototype members to add or override compared to the
 *        parent prototype.
 *
 * @return {Highcharts.Class<T>}
 *         A new prototype.
 */ function $f5324dfd0bb3e10b$var$extendClass(parent, members) {
    const obj = function() {};
    obj.prototype = new parent(); // eslint-disable-line new-cap
    $f5324dfd0bb3e10b$var$extend(obj.prototype, members);
    return obj;
}
/**
 * Left-pad a string to a given length by adding a character repetitively.
 *
 * @function Highcharts.pad
 *
 * @param {number} number
 *        The input string or number.
 *
 * @param {number} [length]
 *        The desired string length.
 *
 * @param {string} [padder=0]
 *        The character to pad with.
 *
 * @return {string}
 *         The padded string.
 */ function $f5324dfd0bb3e10b$var$pad(number, length, padder) {
    return new Array((length || 2) + 1 - String(number).replace('-', '').length).join(padder || '0') + number;
}
/**
 * Return a length based on either the integer value, or a percentage of a base.
 *
 * @function Highcharts.relativeLength
 *
 * @param {Highcharts.RelativeSize} value
 *        A percentage string or a number.
 *
 * @param {number} base
 *        The full length that represents 100%.
 *
 * @param {number} [offset=0]
 *        A pixel offset to apply for percentage values. Used internally in
 *        axis positioning.
 *
 * @return {number}
 *         The computed length.
 */ function $f5324dfd0bb3e10b$var$relativeLength(value, base, offset) {
    return /%$/.test(value) ? base * parseFloat(value) / 100 + (offset || 0) : parseFloat(value);
}
/**
 * Replaces text in a string with a given replacement in a loop to catch nested
 * matches after previous replacements.
 *
 * @function Highcharts.replaceNested
 *
 * @param {string} text
 * Text to search and modify.
 *
 * @param {...Array<(RegExp|string)>} replacements
 * One or multiple tuples with search pattern (`[0]: (string|RegExp)`) and
 * replacement (`[1]: string`) for matching text.
 *
 * @return {string}
 * Text with replacements.
 */ function $f5324dfd0bb3e10b$var$replaceNested(text, ...replacements) {
    let previous, replacement;
    do {
        previous = text;
        for (replacement of replacements)text = text.replace(replacement[0], replacement[1]);
    }while (text !== previous);
    return text;
}
/**
 * Wrap a method with extended functionality, preserving the original function.
 *
 * @function Highcharts.wrap
 *
 * @param {*} obj
 *        The context object that the method belongs to. In real cases, this is
 *        often a prototype.
 *
 * @param {string} method
 *        The name of the method to extend.
 *
 * @param {Highcharts.WrapProceedFunction} func
 *        A wrapper function callback. This function is called with the same
 *        arguments as the original function, except that the original function
 *        is unshifted and passed as the first argument.
 */ function $f5324dfd0bb3e10b$var$wrap(obj, method, func) {
    const proceed = obj[method];
    obj[method] = function() {
        const outerArgs = arguments, scope = this;
        return func.apply(this, [
            function() {
                return proceed.apply(scope, arguments.length ? arguments : outerArgs);
            }
        ].concat([].slice.call(arguments)));
    };
}
/**
 * Get the magnitude of a number.
 *
 * @function Highcharts.getMagnitude
 *
 * @param {number} num
 *        The number.
 *
 * @return {number}
 *         The magnitude, where 1-9 are magnitude 1, 10-99 magnitude 2 etc.
 */ function $f5324dfd0bb3e10b$var$getMagnitude(num) {
    return Math.pow(10, Math.floor(Math.log(num) / Math.LN10));
}
/**
 * Take an interval and normalize it to multiples of round numbers.
 *
 * @deprecated
 * @function Highcharts.normalizeTickInterval
 *
 * @param {number} interval
 *        The raw, un-rounded interval.
 *
 * @param {Array<*>} [multiples]
 *        Allowed multiples.
 *
 * @param {number} [magnitude]
 *        The magnitude of the number.
 *
 * @param {boolean} [allowDecimals]
 *        Whether to allow decimals.
 *
 * @param {boolean} [hasTickAmount]
 *        If it has tickAmount, avoid landing on tick intervals lower than
 *        original.
 *
 * @return {number}
 *         The normalized interval.
 *
 * @todo
 * Move this function to the Axis prototype. It is here only for historical
 * reasons.
 */ function $f5324dfd0bb3e10b$var$normalizeTickInterval(interval, multiples, magnitude, allowDecimals, hasTickAmount) {
    let i, retInterval = interval;
    // Round to a tenfold of 1, 2, 2.5 or 5
    magnitude = $f5324dfd0bb3e10b$var$pick(magnitude, $f5324dfd0bb3e10b$var$getMagnitude(interval));
    const normalized = interval / magnitude;
    // Multiples for a linear scale
    if (!multiples) {
        multiples = hasTickAmount ? // Finer grained ticks when the tick amount is hard set, including
        // when alignTicks is true on multiple axes (#4580).
        [
            1,
            1.2,
            1.5,
            2,
            2.5,
            3,
            4,
            5,
            6,
            8,
            10
        ] : // Else, let ticks fall on rounder numbers
        [
            1,
            2,
            2.5,
            5,
            10
        ];
        // The allowDecimals option
        if (allowDecimals === false) {
            if (magnitude === 1) multiples = multiples.filter(function(num) {
                return num % 1 === 0;
            });
            else if (magnitude <= 0.1) multiples = [
                1 / magnitude
            ];
        }
    }
    // Normalize the interval to the nearest multiple
    for(i = 0; i < multiples.length; i++){
        retInterval = multiples[i];
        // Only allow tick amounts smaller than natural
        if (hasTickAmount && retInterval * magnitude >= interval || !hasTickAmount && normalized <= (multiples[i] + (multiples[i + 1] || multiples[i])) / 2) break;
    }
    // Multiply back to the correct magnitude. Correct floats to appropriate
    // precision (#6085).
    retInterval = $f5324dfd0bb3e10b$var$correctFloat(retInterval * magnitude, -Math.round(Math.log(0.001) / Math.LN10));
    return retInterval;
}
/**
 * Sort an object array and keep the order of equal items. The ECMAScript
 * standard does not specify the behaviour when items are equal.
 *
 * @function Highcharts.stableSort
 *
 * @param {Array<*>} arr
 *        The array to sort.
 *
 * @param {Function} sortFunction
 *        The function to sort it with, like with regular Array.prototype.sort.
 */ function $f5324dfd0bb3e10b$var$stableSort(arr, sortFunction) {
    // @todo It seems like Chrome since v70 sorts in a stable way internally,
    // plus all other browsers do it, so over time we may be able to remove this
    // function
    const length = arr.length;
    let sortValue, i;
    // Add index to each item
    for(i = 0; i < length; i++)arr[i].safeI = i; // Stable sort index
    arr.sort(function(a, b) {
        sortValue = sortFunction(a, b);
        return sortValue === 0 ? a.safeI - b.safeI : sortValue;
    });
    // Remove index from items
    for(i = 0; i < length; i++)delete arr[i].safeI; // Stable sort index
}
/**
 * Non-recursive method to find the lowest member of an array. `Math.min` raises
 * a maximum call stack size exceeded error in Chrome when trying to apply more
 * than 150.000 points. This method is slightly slower, but safe.
 *
 * @function Highcharts.arrayMin
 *
 * @param {Array<*>} data
 *        An array of numbers.
 *
 * @return {number}
 *         The lowest number.
 */ function $f5324dfd0bb3e10b$var$arrayMin(data) {
    let i = data.length, min = data[0];
    while(i--)if (data[i] < min) min = data[i];
    return min;
}
/**
 * Non-recursive method to find the lowest member of an array. `Math.max` raises
 * a maximum call stack size exceeded error in Chrome when trying to apply more
 * than 150.000 points. This method is slightly slower, but safe.
 *
 * @function Highcharts.arrayMax
 *
 * @param {Array<*>} data
 *        An array of numbers.
 *
 * @return {number}
 *         The highest number.
 */ function $f5324dfd0bb3e10b$var$arrayMax(data) {
    let i = data.length, max = data[0];
    while(i--)if (data[i] > max) max = data[i];
    return max;
}
/**
 * Utility method that destroys any SVGElement instances that are properties on
 * the given object. It loops all properties and invokes destroy if there is a
 * destroy method. The property is then delete.
 *
 * @function Highcharts.destroyObjectProperties
 *
 * @param {*} obj
 *        The object to destroy properties on.
 *
 * @param {*} [except]
 *        Exception, do not destroy this property, only delete it.
 */ function $f5324dfd0bb3e10b$var$destroyObjectProperties(obj, except, destructablesOnly) {
    $f5324dfd0bb3e10b$var$objectEach(obj, function(val, n) {
        // If the object is non-null and destroy is defined
        if (val !== except && val?.destroy) // Invoke the destroy
        val.destroy();
        // Delete the property from the object
        if (val?.destroy || !destructablesOnly) delete obj[n];
    });
}
/**
 * Discard a HTML element
 *
 * @function Highcharts.discardElement
 *
 * @param {Highcharts.HTMLDOMElement} element
 *        The HTML node to discard.
 */ function $f5324dfd0bb3e10b$var$discardElement(element) {
    element?.parentElement?.removeChild(element);
}
/**
 * Fix JS round off float errors.
 *
 * @function Highcharts.correctFloat
 *
 * @param {number} num
 *        A float number to fix.
 *
 * @param {number} [prec=14]
 *        The precision.
 *
 * @return {number}
 *         The corrected float number.
 */ function $f5324dfd0bb3e10b$var$correctFloat(num, prec) {
    // When the number is higher than 1e14 use the number (#16275)
    return num > 1e14 ? num : parseFloat(num.toPrecision(prec || 14));
}
/**
 * The time unit lookup
 *
 * @ignore
 */ const $f5324dfd0bb3e10b$var$timeUnits = {
    millisecond: 1,
    second: 1000,
    minute: 60000,
    hour: 3600000,
    day: 86400000,
    week: 604800000,
    month: 2419200000,
    year: 31449600000
};
/**
 * Easing definition
 *
 * @private
 * @function Math.easeInOutSine
 *
 * @param {number} pos
 *        Current position, ranging from 0 to 1.
 *
 * @return {number}
 *         Ease result
 */ Math.easeInOutSine = function(pos) {
    return -0.5 * (Math.cos(Math.PI * pos) - 1);
};
/**
 * Convenience function to get the align factor, used several places for
 * computing positions
 * @private
 */ const $f5324dfd0bb3e10b$var$getAlignFactor = (align = '')=>({
        center: 0.5,
        right: 1,
        middle: 0.5,
        bottom: 1
    })[align] || 0;
/**
 * Find the closest distance between two values of a two-dimensional array
 * @private
 * @function Highcharts.getClosestDistance
 *
 * @param {Array<Array<number>>} arrays
 *          An array of arrays of numbers
 *
 * @return {number | undefined}
 *          The closest distance between values
 */ function $f5324dfd0bb3e10b$var$getClosestDistance(arrays, onError) {
    const allowNegative = !onError;
    let closest, loopLength, distance, i;
    arrays.forEach((xData)=>{
        if (xData.length > 1) {
            loopLength = xData.length - 1;
            for(i = loopLength; i > 0; i--){
                distance = xData[i] - xData[i - 1];
                if (distance < 0 && !allowNegative) {
                    onError?.();
                    // Only one call
                    onError = void 0;
                } else if (distance && (typeof closest === 'undefined' || distance < closest)) closest = distance;
            }
        }
    });
    return closest;
}
/**
 * Returns the value of a property path on a given object.
 *
 * @private
 * @function getNestedProperty
 *
 * @param {string} path
 * Path to the property, for example `custom.myValue`.
 *
 * @param {unknown} obj
 * Instance containing the property on the specific path.
 *
 * @return {unknown}
 * The unknown property value.
 */ function $f5324dfd0bb3e10b$var$getNestedProperty(path, parent) {
    const pathElements = path.split('.');
    while(pathElements.length && $f5324dfd0bb3e10b$var$defined(parent)){
        const pathElement = pathElements.shift();
        // Filter on the key
        if (typeof pathElement === 'undefined' || pathElement === '__proto__') return; // Undefined
        if (pathElement === 'this') {
            let thisProp;
            if ($f5324dfd0bb3e10b$var$isObject(parent)) thisProp = parent['@this'];
            return thisProp ?? parent;
        }
        const child = parent[pathElement.replace(/[\\'"]/g, '')];
        // Filter on the child
        if (!$f5324dfd0bb3e10b$var$defined(child) || typeof child === 'function' || typeof child.nodeType === 'number' || child === $f5324dfd0bb3e10b$var$win) return; // Undefined
        // Else, proceed
        parent = child;
    }
    return parent;
}
/**
 * Get the computed CSS value for given element and property, only for numerical
 * properties. For width and height, the dimension of the inner box (excluding
 * padding) is returned. Used for fitting the chart within the container.
 *
 * @function Highcharts.getStyle
 *
 * @param {Highcharts.HTMLDOMElement} el
 * An HTML element.
 *
 * @param {string} prop
 * The property name.
 *
 * @param {boolean} [toInt=true]
 * Parse to integer.
 *
 * @return {number|string|undefined}
 * The style value.
 */ function $f5324dfd0bb3e10b$var$getStyle(el, prop, toInt) {
    let style;
    // For width and height, return the actual inner pixel size (#4913)
    if (prop === 'width') {
        let offsetWidth = Math.min(el.offsetWidth, el.scrollWidth);
        // In flex boxes, we need to use getBoundingClientRect and floor it,
        // because scrollWidth doesn't support subpixel precision (#6427) ...
        const boundingClientRectWidth = el.getBoundingClientRect?.().width;
        // ...unless if the containing div or its parents are transform-scaled
        // down, in which case the boundingClientRect can't be used as it is
        // also scaled down (#9871, #10498).
        if (boundingClientRectWidth < offsetWidth && boundingClientRectWidth >= offsetWidth - 1) offsetWidth = Math.floor(boundingClientRectWidth);
        return Math.max(0, offsetWidth - ($f5324dfd0bb3e10b$var$getStyle(el, 'padding-left', true) || 0) - ($f5324dfd0bb3e10b$var$getStyle(el, 'padding-right', true) || 0));
    }
    if (prop === 'height') return Math.max(0, Math.min(el.offsetHeight, el.scrollHeight) - ($f5324dfd0bb3e10b$var$getStyle(el, 'padding-top', true) || 0) - ($f5324dfd0bb3e10b$var$getStyle(el, 'padding-bottom', true) || 0));
    // Otherwise, get the computed style
    const css = $f5324dfd0bb3e10b$var$win.getComputedStyle(el, void 0); // eslint-disable-line no-undefined
    if (css) {
        style = css.getPropertyValue(prop);
        if ($f5324dfd0bb3e10b$var$pick(toInt, prop !== 'opacity')) style = $f5324dfd0bb3e10b$var$pInt(style);
    }
    return style;
}
/**
 * Return the value of the first element in the array that satisfies the
 * provided testing function.
 *
 * @function Highcharts.find<T>
 *
 * @param {Array<T>} arr
 *        The array to test.
 *
 * @param {Function} callback
 *        The callback function. The function receives the item as the first
 *        argument. Return `true` if this item satisfies the condition.
 *
 * @return {T|undefined}
 *         The value of the element.
 */ const $f5324dfd0bb3e10b$var$find = Array.prototype.find ? function(arr, callback) {
    return arr.find(callback);
} : // Legacy implementation. PhantomJS, IE <= 11 etc. #7223.
function(arr, callback) {
    let i;
    const length = arr.length;
    for(i = 0; i < length; i++){
        if (callback(arr[i], i)) return arr[i];
    }
};
/**
 * Get the element's offset position, corrected for `overflow: auto`.
 *
 * @function Highcharts.offset
 *
 * @param {global.Element} el
 *        The DOM element.
 *
 * @return {Highcharts.OffsetObject}
 *         An object containing `left` and `top` properties for the position in
 *         the page.
 */ function $f5324dfd0bb3e10b$var$offset(el) {
    const docElem = $f5324dfd0bb3e10b$var$doc.documentElement, box = el.parentElement || el.parentNode ? el.getBoundingClientRect() : {
        top: 0,
        left: 0,
        width: 0,
        height: 0
    };
    return {
        top: box.top + ($f5324dfd0bb3e10b$var$win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
        left: box.left + ($f5324dfd0bb3e10b$var$win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0),
        width: box.width,
        height: box.height
    };
}
/* eslint-disable valid-jsdoc */ /**
 * Iterate over object key pairs in an object.
 *
 * @function Highcharts.objectEach<T>
 *
 * @param {*} obj
 *        The object to iterate over.
 *
 * @param {Highcharts.ObjectEachCallbackFunction<T>} fn
 *        The iterator callback. It passes three arguments:
 *        * value - The property value.
 *        * key - The property key.
 *        * obj - The object that objectEach is being applied to.
 *
 * @param {T} [ctx]
 *        The context.
 */ function $f5324dfd0bb3e10b$var$objectEach(obj, fn, ctx) {
    /* eslint-enable valid-jsdoc */ for(const key in obj)if (Object.hasOwnProperty.call(obj, key)) fn.call(ctx || obj[key], obj[key], key, obj);
}
/* eslint-disable valid-jsdoc */ /**
 * Add an event listener.
 *
 * @function Highcharts.addEvent<T>
 *
 * @param  {Highcharts.Class<T>|T} el
 *         The element or object to add a listener to. It can be a
 *         {@link HTMLDOMElement}, an {@link SVGElement} or any other object.
 *
 * @param  {string} type
 *         The event type.
 *
 * @param  {Highcharts.EventCallbackFunction<T>|Function} fn
 *         The function callback to execute when the event is fired.
 *
 * @param  {Highcharts.EventOptionsObject} [options]
 *         Options for adding the event.
 *
 * @sample highcharts/members/addevent
 *         Use a general `render` event to draw shapes on a chart
 *
 * @return {Function}
 *         A callback function to remove the added event.
 */ function $f5324dfd0bb3e10b$var$addEvent(el, type, fn, options = {}) {
    /* eslint-enable valid-jsdoc */ // Add hcEvents to either the prototype (in case we're running addEvent on a
    // class) or the instance. If hasOwnProperty('hcEvents') is false, it is
    // inherited down the prototype chain, in which case we need to set the
    // property on this instance (which may itself be a prototype).
    const owner = typeof el === 'function' && el.prototype || el;
    if (!Object.hasOwnProperty.call(owner, 'hcEvents')) owner.hcEvents = {};
    const events = owner.hcEvents;
    // Allow click events added to points, otherwise they will be prevented by
    // the TouchPointer.pinch function after a pinch zoom operation (#7091).
    if ((0, $30Vhv.default).Point && // Without H a dependency loop occurs
    el instanceof (0, $30Vhv.default).Point && el.series && el.series.chart) el.series.chart.runTrackerClick = true;
    // Handle DOM events
    // If the browser supports passive events, add it to improve performance
    // on touch events (#11353).
    const addEventListener = el.addEventListener;
    if (addEventListener) addEventListener.call(el, type, fn, (0, $30Vhv.default).supportsPassiveEvents ? {
        passive: options.passive === void 0 ? type.indexOf('touch') !== -1 : options.passive,
        capture: false
    } : false);
    if (!events[type]) events[type] = [];
    const eventObject = {
        fn: fn,
        order: typeof options.order === 'number' ? options.order : Infinity
    };
    events[type].push(eventObject);
    // Order the calls
    events[type].sort((a, b)=>a.order - b.order);
    // Return a function that can be called to remove this event.
    return function() {
        $f5324dfd0bb3e10b$var$removeEvent(el, type, fn);
    };
}
/* eslint-disable valid-jsdoc */ /**
 * Remove an event that was added with {@link Highcharts#addEvent}.
 *
 * @function Highcharts.removeEvent<T>
 *
 * @param {Highcharts.Class<T>|T} el
 *        The element to remove events on.
 *
 * @param {string} [type]
 *        The type of events to remove. If undefined, all events are removed
 *        from the element.
 *
 * @param {Highcharts.EventCallbackFunction<T>} [fn]
 *        The specific callback to remove. If undefined, all events that match
 *        the element and optionally the type are removed.
 *
 * @return {void}
 */ function $f5324dfd0bb3e10b$var$removeEvent(el, type, fn) {
    /* eslint-enable valid-jsdoc */ /**
     * @private
     */ function removeOneEvent(type, fn) {
        const removeEventListener = el.removeEventListener;
        if (removeEventListener) removeEventListener.call(el, type, fn, false);
    }
    /**
     * @private
     */ function removeAllEvents(eventCollection) {
        let types, len;
        if (!el.nodeName) return; // Break on non-DOM events
        if (type) {
            types = {};
            types[type] = true;
        } else types = eventCollection;
        $f5324dfd0bb3e10b$var$objectEach(types, function(_val, n) {
            if (eventCollection[n]) {
                len = eventCollection[n].length;
                while(len--)removeOneEvent(n, eventCollection[n][len].fn);
            }
        });
    }
    const owner = typeof el === 'function' && el.prototype || el;
    if (Object.hasOwnProperty.call(owner, 'hcEvents')) {
        const events = owner.hcEvents;
        if (type) {
            const typeEvents = events[type] || [];
            if (fn) {
                events[type] = typeEvents.filter(function(obj) {
                    return fn !== obj.fn;
                });
                removeOneEvent(type, fn);
            } else {
                removeAllEvents(events);
                events[type] = [];
            }
        } else {
            removeAllEvents(events);
            delete owner.hcEvents;
        }
    }
}
/* eslint-disable valid-jsdoc */ /**
 * Fire an event that was registered with {@link Highcharts#addEvent}.
 *
 * @function Highcharts.fireEvent<T>
 *
 * @param {T} el
 *        The object to fire the event on. It can be a {@link HTMLDOMElement},
 *        an {@link SVGElement} or any other object.
 *
 * @param {string} type
 *        The type of event.
 *
 * @param {Highcharts.Dictionary<*>|Event} [eventArguments]
 *        Custom event arguments that are passed on as an argument to the event
 *        handler.
 *
 * @param {Highcharts.EventCallbackFunction<T>|Function} [defaultFunction]
 *        The default function to execute if the other listeners haven't
 *        returned false.
 *
 * @return {void}
 */ function $f5324dfd0bb3e10b$var$fireEvent(el, type, eventArguments, defaultFunction) {
    /* eslint-enable valid-jsdoc */ eventArguments = eventArguments || {};
    if ($f5324dfd0bb3e10b$var$doc?.createEvent && (el.dispatchEvent || el.fireEvent && // Enable firing events on Highcharts instance.
    el !== (0, $30Vhv.default))) {
        const e = $f5324dfd0bb3e10b$var$doc.createEvent('Events');
        e.initEvent(type, true, true);
        eventArguments = $f5324dfd0bb3e10b$var$extend(e, eventArguments);
        if (el.dispatchEvent) el.dispatchEvent(eventArguments);
        else el.fireEvent(type, eventArguments);
    } else if (el.hcEvents) {
        if (!eventArguments.target) // We're running a custom event
        $f5324dfd0bb3e10b$var$extend(eventArguments, {
            // Attach a simple preventDefault function to skip
            // default handler if called. The built-in
            // defaultPrevented property is not overwritable (#5112)
            preventDefault: function() {
                eventArguments.defaultPrevented = true;
            },
            // Setting target to native events fails with clicking
            // the zoom-out button in Chrome.
            target: el,
            // If the type is not set, we're running a custom event
            // (#2297). If it is set, we're running a browser event.
            type: type
        });
        const events = [];
        let object = el;
        let multilevel = false;
        // Recurse up the inheritance chain and collect hcEvents set as own
        // objects on the prototypes.
        while(object.hcEvents){
            if (Object.hasOwnProperty.call(object, 'hcEvents') && object.hcEvents[type]) {
                if (events.length) multilevel = true;
                events.unshift.apply(events, object.hcEvents[type]);
            }
            object = Object.getPrototypeOf(object);
        }
        // For performance reasons, only sort the event handlers in case we are
        // dealing with multiple levels in the prototype chain. Otherwise, the
        // events are already sorted in the addEvent function.
        if (multilevel) // Order the calls
        events.sort((a, b)=>a.order - b.order);
        // Call the collected event handlers
        events.forEach((obj)=>{
            // If the event handler returns false, prevent the default handler
            // from executing
            if (obj.fn.call(el, eventArguments) === false) eventArguments.preventDefault();
        });
    }
    // Run the default if not prevented
    if (defaultFunction && !eventArguments.defaultPrevented) defaultFunction.call(el, eventArguments);
}
let $f5324dfd0bb3e10b$var$serialMode;
/**
 * Get a unique key for using in internal element id's and pointers. The key is
 * composed of a random hash specific to this Highcharts instance, and a
 * counter.
 *
 * @example
 * let id = uniqueKey(); // => 'highcharts-x45f6hp-0'
 *
 * @function Highcharts.uniqueKey
 *
 * @return {string}
 * A unique key.
 */ const $f5324dfd0bb3e10b$var$uniqueKey = function() {
    const hash = Math.random().toString(36).substring(2, 9) + '-';
    let id = 0;
    return function() {
        return 'highcharts-' + ($f5324dfd0bb3e10b$var$serialMode ? '' : hash) + id++;
    };
}();
/**
 * Activates a serial mode for element IDs provided by
 * {@link Highcharts.uniqueKey}. This mode can be used in automated tests, where
 * a simple comparison of two rendered SVG graphics is needed.
 *
 * **Note:** This is only for testing purposes and will break functionality in
 * webpages with multiple charts.
 *
 * @example
 * if (
 *   process &&
 *   process.env.NODE_ENV === 'development'
 * ) {
 *   Highcharts.useSerialIds(true);
 * }
 *
 * @function Highcharts.useSerialIds
 *
 * @param {boolean} [mode]
 * Changes the state of serial mode.
 *
 * @return {boolean|undefined}
 * State of the serial mode.
 */ function $f5324dfd0bb3e10b$var$useSerialIds(mode) {
    return $f5324dfd0bb3e10b$var$serialMode = $f5324dfd0bb3e10b$var$pick(mode, $f5324dfd0bb3e10b$var$serialMode);
}
function $f5324dfd0bb3e10b$var$isFunction(obj) {
    return typeof obj === 'function';
}
function $f5324dfd0bb3e10b$var$ucfirst(s) {
    return $f5324dfd0bb3e10b$var$isString(s) ? s.substring(0, 1).toUpperCase() + s.substring(1) : String(s);
}
/* *
 *
 *  External
 *
 * */ // Register Highcharts as a plugin in jQuery
if ($f5324dfd0bb3e10b$var$win.jQuery) /**
     * Highcharts-extended JQuery.
     *
     * @external JQuery
     */ /**
     * Helper function to return the chart of the current JQuery selector
     * element.
     *
     * @function external:JQuery#highcharts
     *
     * @return {Highcharts.Chart}
     *         The chart that is linked to the JQuery selector element.
     */ /**
    * Factory function to create a chart in the current JQuery selector
    * element.
    *
    * @function external:JQuery#highcharts
    *
    * @param {'Chart'|'Map'|'StockChart'|string} [className]
    *        Name of the factory class in the Highcharts namespace.
    *
    * @param {Highcharts.Options} [options]
    *        The chart options structure.
    *
    * @param {Highcharts.ChartCallbackFunction} [callback]
    *        Function to run when the chart has loaded and all external
    *        images are loaded. Defining a
    *        [chart.events.load](https://api.highcharts.com/highcharts/chart.events.load)
    *        handler is equivalent.
    *
    * @return {JQuery}
    *         The current JQuery selector.
    */ $f5324dfd0bb3e10b$var$win.jQuery.fn.highcharts = function() {
    const args = [].slice.call(arguments);
    if (this[0]) {
        // Create the chart
        if (args[0]) {
            new (0, $30Vhv.default)[// Constructor defaults to Chart
            $f5324dfd0bb3e10b$var$isString(args[0]) ? args.shift() : 'Chart'](this[0], args[0], args[1]);
            return this;
        }
        // When called without parameters or with the return argument,
        // return an existing chart
        return $f5324dfd0bb3e10b$var$charts[$f5324dfd0bb3e10b$var$attr(this[0], 'data-highcharts-chart')];
    }
};
/* *
 *
 *  Default Export
 *
 * */ // TODO use named exports when supported.
const $f5324dfd0bb3e10b$var$Utilities = {
    addEvent: $f5324dfd0bb3e10b$var$addEvent,
    arrayMax: $f5324dfd0bb3e10b$var$arrayMax,
    arrayMin: $f5324dfd0bb3e10b$var$arrayMin,
    attr: $f5324dfd0bb3e10b$var$attr,
    clamp: $f5324dfd0bb3e10b$var$clamp,
    clearTimeout: $f5324dfd0bb3e10b$var$internalClearTimeout,
    correctFloat: $f5324dfd0bb3e10b$var$correctFloat,
    createElement: $f5324dfd0bb3e10b$var$createElement,
    crisp: $f5324dfd0bb3e10b$var$crisp,
    css: $f5324dfd0bb3e10b$var$css,
    defined: $f5324dfd0bb3e10b$var$defined,
    destroyObjectProperties: $f5324dfd0bb3e10b$var$destroyObjectProperties,
    diffObjects: $f5324dfd0bb3e10b$var$diffObjects,
    discardElement: $f5324dfd0bb3e10b$var$discardElement,
    erase: $f5324dfd0bb3e10b$var$erase,
    error: $f5324dfd0bb3e10b$var$error,
    extend: $f5324dfd0bb3e10b$var$extend,
    extendClass: $f5324dfd0bb3e10b$var$extendClass,
    find: $f5324dfd0bb3e10b$var$find,
    fireEvent: $f5324dfd0bb3e10b$var$fireEvent,
    getAlignFactor: $f5324dfd0bb3e10b$var$getAlignFactor,
    getClosestDistance: $f5324dfd0bb3e10b$var$getClosestDistance,
    getMagnitude: $f5324dfd0bb3e10b$var$getMagnitude,
    getNestedProperty: $f5324dfd0bb3e10b$var$getNestedProperty,
    getStyle: $f5324dfd0bb3e10b$var$getStyle,
    insertItem: $f5324dfd0bb3e10b$var$insertItem,
    isArray: $f5324dfd0bb3e10b$var$isArray,
    isClass: $f5324dfd0bb3e10b$var$isClass,
    isDOMElement: $f5324dfd0bb3e10b$var$isDOMElement,
    isFunction: $f5324dfd0bb3e10b$var$isFunction,
    isNumber: $f5324dfd0bb3e10b$var$isNumber,
    isObject: $f5324dfd0bb3e10b$var$isObject,
    isString: $f5324dfd0bb3e10b$var$isString,
    merge: $f5324dfd0bb3e10b$var$merge,
    normalizeTickInterval: $f5324dfd0bb3e10b$var$normalizeTickInterval,
    objectEach: $f5324dfd0bb3e10b$var$objectEach,
    offset: $f5324dfd0bb3e10b$var$offset,
    pad: $f5324dfd0bb3e10b$var$pad,
    pick: $f5324dfd0bb3e10b$var$pick,
    pInt: $f5324dfd0bb3e10b$var$pInt,
    pushUnique: $f5324dfd0bb3e10b$var$pushUnique,
    relativeLength: $f5324dfd0bb3e10b$var$relativeLength,
    removeEvent: $f5324dfd0bb3e10b$var$removeEvent,
    replaceNested: $f5324dfd0bb3e10b$var$replaceNested,
    splat: $f5324dfd0bb3e10b$var$splat,
    stableSort: $f5324dfd0bb3e10b$var$stableSort,
    syncTimeout: $f5324dfd0bb3e10b$var$syncTimeout,
    timeUnits: $f5324dfd0bb3e10b$var$timeUnits,
    ucfirst: $f5324dfd0bb3e10b$var$ucfirst,
    uniqueKey: $f5324dfd0bb3e10b$var$uniqueKey,
    useSerialIds: $f5324dfd0bb3e10b$var$useSerialIds,
    wrap: $f5324dfd0bb3e10b$var$wrap
};
var $f5324dfd0bb3e10b$export$2e2bcd8739ae039 = $f5324dfd0bb3e10b$var$Utilities;
/* *
 *
 *  API Declarations
 *
 * */ /**
 * An animation configuration. Animation configurations can also be defined as
 * booleans, where `false` turns off animation and `true` defaults to a duration
 * of 500ms and defer of 0ms.
 *
 * @interface Highcharts.AnimationOptionsObject
 */ /**
* A callback function to execute when the animation finishes.
* @name Highcharts.AnimationOptionsObject#complete
* @type {Function|undefined}
*/ /**
* The animation defer in milliseconds.
* @name Highcharts.AnimationOptionsObject#defer
* @type {number|undefined}
*/ /**
* The animation duration in milliseconds.
* @name Highcharts.AnimationOptionsObject#duration
* @type {number|undefined}
*/ /**
* The name of an easing function as defined on the `Math` object.
* @name Highcharts.AnimationOptionsObject#easing
* @type {string|Function|undefined}
*/ /**
* A callback function to execute on each step of each attribute or CSS property
* that's being animated. The first argument contains information about the
* animation and progress.
* @name Highcharts.AnimationOptionsObject#step
* @type {Function|undefined}
*/ /**
 * Creates a frame for the animated SVG element.
 *
 * @callback Highcharts.AnimationStepCallbackFunction
 *
 * @param {Highcharts.SVGElement} this
 *        The SVG element to animate.
 *
 * @return {void}
 */ /**
 * Interface description for a class.
 *
 * @interface Highcharts.Class<T>
 * @extends Function
 */ /**
* Class constructor.
* @function Highcharts.Class<T>#new
* @param {...Array<*>} args
*        Constructor arguments.
* @return {T}
*         Class instance.
*/ /**
 * A style object with camel case property names to define visual appearance of
 * a SVG element or HTML element. The properties can be whatever styles are
 * supported on the given SVG or HTML element.
 *
 * @example
 * {
 *    fontFamily: 'monospace',
 *    fontSize: '1.2em'
 * }
 *
 * @interface Highcharts.CSSObject
 */ /**
* @name Highcharts.CSSObject#[key:string]
* @type {boolean|number|string|undefined}
*/ /**
* Background style for the element.
* @name Highcharts.CSSObject#background
* @type {string|undefined}
*/ /**
* Background color of the element.
* @name Highcharts.CSSObject#backgroundColor
* @type {Highcharts.ColorString|undefined}
*/ /**
* Border style for the element.
* @name Highcharts.CSSObject#border
* @type {string|undefined}
*/ /**
* Radius of the element border.
* @name Highcharts.CSSObject#borderRadius
* @type {number|undefined}
*/ /**
* Color used in the element. The 'contrast' option is a Highcharts custom
* property that results in black or white, depending on the background of the
* element.
* @name Highcharts.CSSObject#color
* @type {'contrast'|Highcharts.ColorString|undefined}
*/ /**
* Style of the mouse cursor when resting over the element.
* @name Highcharts.CSSObject#cursor
* @type {Highcharts.CursorValue|undefined}
*/ /**
* Font family of the element text. Multiple values have to be in decreasing
* preference order and separated by comma.
* @name Highcharts.CSSObject#fontFamily
* @type {string|undefined}
*/ /**
* Font size of the element text.
* @name Highcharts.CSSObject#fontSize
* @type {string|undefined}
*/ /**
* Font weight of the element text.
* @name Highcharts.CSSObject#fontWeight
* @type {string|undefined}
*/ /**
* Height of the element.
* @name Highcharts.CSSObject#height
* @type {number|undefined}
*/ /**
* The maximum number of lines. If lines are cropped away, an ellipsis will be
* added.
* @name Highcharts.CSSObject#lineClamp
* @type {number|undefined}
*/ /**
* Width of the element border.
* @name Highcharts.CSSObject#lineWidth
* @type {number|undefined}
*/ /**
* Opacity of the element.
* @name Highcharts.CSSObject#opacity
* @type {number|undefined}
*/ /**
* Space around the element content.
* @name Highcharts.CSSObject#padding
* @type {string|undefined}
*/ /**
* Behaviour of the element when the mouse cursor rests over it.
* @name Highcharts.CSSObject#pointerEvents
* @type {string|undefined}
*/ /**
* Positioning of the element.
* @name Highcharts.CSSObject#position
* @type {string|undefined}
*/ /**
* Alignment of the element text.
* @name Highcharts.CSSObject#textAlign
* @type {string|undefined}
*/ /**
* Additional decoration of the element text.
* @name Highcharts.CSSObject#textDecoration
* @type {string|undefined}
*/ /**
* Outline style of the element text.
* @name Highcharts.CSSObject#textOutline
* @type {string|undefined}
*/ /**
* Line break style of the element text. Highcharts SVG elements support
* `ellipsis` when a `width` is set.
* @name Highcharts.CSSObject#textOverflow
* @type {string|undefined}
*/ /**
* Top spacing of the element relative to the parent element.
* @name Highcharts.CSSObject#top
* @type {string|undefined}
*/ /**
* Animated transition of selected element properties.
* @name Highcharts.CSSObject#transition
* @type {string|undefined}
*/ /**
* Line break style of the element text.
* @name Highcharts.CSSObject#whiteSpace
* @type {string|undefined}
*/ /**
* Width of the element.
* @name Highcharts.CSSObject#width
* @type {number|undefined}
*/ /**
 * All possible cursor styles.
 *
 * @typedef {'alias'|'all-scroll'|'auto'|'cell'|'col-resize'|'context-menu'|'copy'|'crosshair'|'default'|'e-resize'|'ew-resize'|'grab'|'grabbing'|'help'|'move'|'n-resize'|'ne-resize'|'nesw-resize'|'no-drop'|'none'|'not-allowed'|'ns-resize'|'nw-resize'|'nwse-resize'|'pointer'|'progress'|'row-resize'|'s-resize'|'se-resize'|'sw-resize'|'text'|'vertical-text'|'w-resize'|'wait'|'zoom-in'|'zoom-out'} Highcharts.CursorValue
 */ /**
 * All possible dash styles.
 *
 * @typedef {'Dash'|'DashDot'|'Dot'|'LongDash'|'LongDashDot'|'LongDashDotDot'|'ShortDash'|'ShortDashDot'|'ShortDashDotDot'|'ShortDot'|'Solid'} Highcharts.DashStyleValue
 */ /**
 * Generic dictionary in TypeScript notation.
 * Use the native `AnyRecord` instead.
 *
 * @deprecated
 * @interface Highcharts.Dictionary<T>
 */ /**
* @name Highcharts.Dictionary<T>#[key:string]
* @type {T}
*/ /**
 * The function callback to execute when the event is fired. The `this` context
 * contains the instance, that fired the event.
 *
 * @callback Highcharts.EventCallbackFunction<T>
 *
 * @param {T} this
 *
 * @param {Highcharts.Dictionary<*>|Event} [eventArguments]
 *        Event arguments.
 *
 * @return {boolean|void}
 */ /**
 * The event options for adding function callback.
 *
 * @interface Highcharts.EventOptionsObject
 */ /**
* The order the event handler should be called. This opens for having one
* handler be called before another, independent of in which order they were
* added.
* @name Highcharts.EventOptionsObject#order
* @type {number}
*/ /**
* Whether an event should be passive or not.
* When set to `true`, the function specified by listener will never call
* `preventDefault()`.
* @name Highcharts.EventOptionsObject#passive
* @type boolean
*/ /**
 * Formats data as a string. Usually the data is accessible through the `this`
 * keyword.
 *
 * @callback Highcharts.FormatterCallbackFunction<T>
 *
 * @param {T} this
 *        Context to format
 *
 * @return {string}
 *         Formatted text
 */ /**
 * An object of key-value pairs for HTML attributes.
 *
 * @typedef {Highcharts.Dictionary<boolean|number|string|Function>} Highcharts.HTMLAttributes
 */ /**
 * An HTML DOM element. The type is a reference to the regular HTMLElement in
 * the global scope.
 *
 * @typedef {global.HTMLElement} Highcharts.HTMLDOMElement
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement
 */ /**
 * The iterator callback.
 *
 * @callback Highcharts.ObjectEachCallbackFunction<T>
 *
 * @param {T} this
 *        The context.
 *
 * @param {*} value
 *        The property value.
 *
 * @param {string} key
 *        The property key.
 *
 * @param {*} obj
 *        The object that objectEach is being applied to.
 */ /**
 * An object containing `left` and `top` properties for the position in the
 * page.
 *
 * @interface Highcharts.OffsetObject
 */ /**
* Left distance to the page border.
* @name Highcharts.OffsetObject#left
* @type {number}
*/ /**
* Top distance to the page border.
* @name Highcharts.OffsetObject#top
* @type {number}
*/ /**
 * Describes a range.
 *
 * @interface Highcharts.RangeObject
 */ /**
* Maximum number of the range.
* @name Highcharts.RangeObject#max
* @type {number}
*/ /**
* Minimum number of the range.
* @name Highcharts.RangeObject#min
* @type {number}
*/ /**
 * If a number is given, it defines the pixel length. If a percentage string is
 * given, like for example `'50%'`, the setting defines a length relative to a
 * base size, for example the size of a container.
 *
 * @typedef {number|string} Highcharts.RelativeSize
 */ /**
 * Proceed function to call original (wrapped) function.
 *
 * @callback Highcharts.WrapProceedFunction
 *
 * @param {*} [arg1]
 *        Optional argument. Without any arguments defaults to first argument of
 *        the wrapping function.
 *
 * @param {*} [arg2]
 *        Optional argument. Without any arguments defaults to second argument
 *        of the wrapping function.
 *
 * @param {*} [arg3]
 *        Optional argument. Without any arguments defaults to third argument of
 *        the wrapping function.
 *
 * @return {*}
 *         Return value of the original function.
 */ /**
 * The Highcharts object is the placeholder for all other members, and various
 * utility functions. The most important member of the namespace would be the
 * chart constructor.
 *
 * @example
 * let chart = Highcharts.chart('container', { ... });
 *
 * @namespace Highcharts
 */ ''; // Detach doclets above

});


parcelRegister("5YKvy", function(module, exports) {

$parcel$export(module.exports, "default", () => $45a6a1d688db3322$export$2e2bcd8739ae039);
/* *
 *
 *  (c) 2010-2025 Torstein Honsi
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 * */ 
var $3vHyG = parcelRequire("3vHyG");

var $30Vhv = parcelRequire("30Vhv");

var $l3aRA = parcelRequire("l3aRA");
'use strict';
const { defaultOptions: $45a6a1d688db3322$var$defaultOptions, defaultTime: $45a6a1d688db3322$var$defaultTime } = (0, $3vHyG.default);
const { pageLang: $45a6a1d688db3322$var$pageLang } = (0, $30Vhv.default);
const { extend: $45a6a1d688db3322$var$extend, getNestedProperty: $45a6a1d688db3322$var$getNestedProperty, isArray: $45a6a1d688db3322$var$isArray, isNumber: $45a6a1d688db3322$var$isNumber, isObject: $45a6a1d688db3322$var$isObject, isString: $45a6a1d688db3322$var$isString, pick: $45a6a1d688db3322$var$pick, ucfirst: $45a6a1d688db3322$var$ucfirst } = (0, $l3aRA.default);
const $45a6a1d688db3322$var$helpers = {
    // Built-in helpers
    add: (a, b)=>a + b,
    divide: (a, b)=>b !== 0 ? a / b : '',
    // eslint-disable-next-line eqeqeq
    eq: (a, b)=>a == b,
    each: function(arr) {
        const match = arguments[arguments.length - 1];
        return $45a6a1d688db3322$var$isArray(arr) ? arr.map((item, i)=>$45a6a1d688db3322$var$format(match.body, $45a6a1d688db3322$var$extend($45a6a1d688db3322$var$isObject(item) ? item : {
                '@this': item
            }, {
                '@index': i,
                '@first': i === 0,
                '@last': i === arr.length - 1
            }))).join('') : false;
    },
    ge: (a, b)=>a >= b,
    gt: (a, b)=>a > b,
    'if': (condition)=>!!condition,
    le: (a, b)=>a <= b,
    lt: (a, b)=>a < b,
    multiply: (a, b)=>a * b,
    // eslint-disable-next-line eqeqeq
    ne: (a, b)=>a != b,
    subtract: (a, b)=>a - b,
    ucfirst: $45a6a1d688db3322$var$ucfirst,
    unless: (condition)=>!condition
};
const $45a6a1d688db3322$var$numberFormatCache = {};
/* *
 *
 *  Functions
 *
 * */ // Internal convenience function
const $45a6a1d688db3322$var$isQuotedString = (str)=>/^["'].+["']$/.test(str);
/**
 * Formats a JavaScript date timestamp (milliseconds since Jan 1st 1970) into a
 * human readable date string. The format is a subset of the formats for PHP's
 * [strftime](https://www.php.net/manual/en/function.strftime.php) function.
 * Additional formats can be given in the {@link Highcharts.dateFormats} hook.
 *
 * Since v6.0.5, all internal dates are formatted through the
 * {@link Highcharts.Chart#time} instance to respect chart-level time settings.
 * The `Highcharts.dateFormat` function only reflects global time settings set
 * with `setOptions`.
 *
 * Supported format keys:
 * - `%a`: Short weekday, like 'Mon'
 * - `%A`: Long weekday, like 'Monday'
 * - `%d`: Two digit day of the month, 01 to 31
 * - `%e`: Day of the month, 1 through 31
 * - `%w`: Day of the week, 0 through 6
 * - `%b`: Short month, like 'Jan'
 * - `%B`: Long month, like 'January'
 * - `%m`: Two digit month number, 01 through 12
 * - `%y`: Two digits year, like 09 for 2009
 * - `%Y`: Four digits year, like 2009
 * - `%H`: Two digits hours in 24h format, 00 through 23
 * - `%k`: Hours in 24h format, 0 through 23
 * - `%I`: Two digits hours in 12h format, 00 through 11
 * - `%l`: Hours in 12h format, 1 through 12
 * - `%M`: Two digits minutes, 00 through 59
 * - `%p`: Upper case AM or PM
 * - `%P`: Lower case AM or PM
 * - `%S`: Two digits seconds, 00 through 59
 * - `%L`: Milliseconds (naming from Ruby)
 *
 * @function Highcharts.dateFormat
 *
 * @param {string} format
 *        The desired format where various time representations are prefixed
 *        with `%`.
 *
 * @param {number} timestamp
 *        The JavaScript timestamp.
 *
 * @param {boolean} [upperCaseFirst=false]
 *        Upper case first letter in the return.
 *
 * @return {string}
 *         The formatted date.
 */ function $45a6a1d688db3322$var$dateFormat(format, timestamp, upperCaseFirst) {
    return $45a6a1d688db3322$var$defaultTime.dateFormat(format, timestamp, upperCaseFirst);
}
/**
 * Format a string according to a subset of the rules of Python's String.format
 * method.
 *
 * @example
 * let s = Highcharts.format(
 *     'The {color} fox was {len:.2f} feet long',
 *     { color: 'red', len: Math.PI }
 * );
 * // => The red fox was 3.14 feet long
 *
 * @function Highcharts.format
 *
 * @param {string} str
 *        The string to format.
 *
 * @param {Record<string, *>} ctx
 *        The context, a collection of key-value pairs where each key is
 *        replaced by its value.
 *
 * @param {Highcharts.Chart} [owner]
 *        A `Chart` or `Grid` instance used to get numberFormatter and time.
 *
 * @return {string}
 *         The formatted string.
 */ function $45a6a1d688db3322$var$format(str = '', ctx, owner) {
    // eslint-disable-next-line prefer-regex-literals
    const regex = new RegExp("\\{([\\p{L}\\d:\\.,;\\-\\/<>\\[\\]%_@+\"'\u2019= #\\(\\)]+)\\}", 'gu'), // The sub expression regex is the same as the top expression regex,
    // but except parens and block helpers (#), and surrounded by parens
    // instead of curly brackets.
    // eslint-disable-next-line prefer-regex-literals
    subRegex = new RegExp('\\(([\\p{L}\\d:\\.,;\\-\\/<>\\[\\]%_@+"\'= ]+)\\)', 'gu'), matches = [], floatRegex = /f$/, decRegex = /\.(\d)/, lang = owner?.options?.lang || $45a6a1d688db3322$var$defaultOptions.lang, time = owner?.time || $45a6a1d688db3322$var$defaultTime, numberFormatter = owner?.numberFormatter || $45a6a1d688db3322$var$numberFormat.bind(owner);
    /*
     * Get a literal or variable value inside a template expression. May be
     * extended with other types like string or null if needed, but keep it
     * small for now.
     */ const resolveProperty = (key = '')=>{
        let n;
        // Literals
        if (key === 'true') return true;
        if (key === 'false') return false;
        if ((n = Number(key)).toString() === key) return n;
        if ($45a6a1d688db3322$var$isQuotedString(key)) return key.slice(1, -1);
        // Variables and constants
        return $45a6a1d688db3322$var$getNestedProperty(key, ctx);
    };
    let match, currentMatch, depth = 0, hasSub;
    // Parse and create tree
    while((match = regex.exec(str)) !== null){
        // When a sub expression is found, it is evaluated first, and the
        // results recursively evaluated until no subexpression exists.
        const mainMatch = match, subMatch = subRegex.exec(match[1]);
        if (subMatch) {
            match = subMatch;
            hasSub = true;
        }
        if (!currentMatch?.isBlock) currentMatch = {
            ctx: ctx,
            expression: match[1],
            find: match[0],
            isBlock: match[1].charAt(0) === '#',
            start: match.index,
            startInner: match.index + match[0].length,
            length: match[0].length
        };
        // Identify helpers
        const fn = (currentMatch.isBlock ? mainMatch : match)[1].split(' ')[0].replace('#', '');
        if ($45a6a1d688db3322$var$helpers[fn]) {
            // Block helper, only 0 level is handled
            if (currentMatch.isBlock && fn === currentMatch.fn) depth++;
            if (!currentMatch.fn) currentMatch.fn = fn;
        }
        // Closing a block helper
        const startingElseSection = match[1] === 'else';
        if (currentMatch.isBlock && currentMatch.fn && (match[1] === `/${currentMatch.fn}` || startingElseSection)) {
            if (!depth) {
                const start = currentMatch.startInner, body = str.substr(start, match.index - start);
                // Either closing without an else section, or when encountering
                // an else section
                if (currentMatch.body === void 0) {
                    currentMatch.body = body;
                    currentMatch.startInner = match.index + match[0].length;
                // The body exists already, so this is the else section
                } else currentMatch.elseBody = body;
                currentMatch.find += body + match[0];
                if (!startingElseSection) {
                    matches.push(currentMatch);
                    currentMatch = void 0;
                }
            } else if (!startingElseSection) depth--;
        // Common expression
        } else if (!currentMatch.isBlock) matches.push(currentMatch);
        // Evaluate sub-matches one by one to prevent orphaned block closers
        if (subMatch && !currentMatch?.isBlock) break;
    }
    // Execute
    matches.forEach((match)=>{
        const { body: body, elseBody: elseBody, expression: expression, fn: fn } = match;
        let replacement, i;
        // Helper function
        if (fn) {
            // Pass the helpers the amount of arguments defined by the function,
            // then the match as the last argument.
            const args = [
                match
            ], parts = [], len = expression.length;
            let start = 0, startChar;
            for(i = 0; i <= len; i++){
                const char = expression.charAt(i);
                // Start of string
                if (!startChar && (char === '"' || char === '\'')) startChar = char;
                else if (startChar === char) startChar = '';
                if (!startChar && (char === ' ' || i === len)) {
                    parts.push(expression.substr(start, i - start));
                    start = i + 1;
                }
            }
            i = $45a6a1d688db3322$var$helpers[fn].length;
            while(i--)args.unshift(resolveProperty(parts[i + 1]));
            replacement = $45a6a1d688db3322$var$helpers[fn].apply(ctx, args);
            // Block helpers may return true or false. They may also return a
            // string, like the `each` helper.
            if (match.isBlock && typeof replacement === 'boolean') replacement = $45a6a1d688db3322$var$format(replacement ? body : elseBody, ctx, owner);
        // Simple variable replacement
        } else {
            const valueAndFormat = $45a6a1d688db3322$var$isQuotedString(expression) ? [
                expression
            ] : expression.split(':');
            replacement = resolveProperty(valueAndFormat.shift() || '');
            // Format the replacement
            if (valueAndFormat.length && typeof replacement === 'number') {
                const segment = valueAndFormat.join(':');
                if (floatRegex.test(segment)) {
                    const decimals = parseInt((segment.match(decRegex) || [
                        '',
                        '-1'
                    ])[1], 10);
                    if (replacement !== null) replacement = numberFormatter(replacement, decimals, lang.decimalPoint, segment.indexOf(',') > -1 ? lang.thousandsSep : '');
                } else replacement = time.dateFormat(segment, replacement);
            }
            // Use string literal in order to be preserved in the outer
            // expression
            subRegex.lastIndex = 0;
            if (subRegex.test(match.find) && $45a6a1d688db3322$var$isString(replacement)) replacement = `"${replacement}"`;
        }
        str = str.replace(match.find, $45a6a1d688db3322$var$pick(replacement, ''));
    });
    return hasSub ? $45a6a1d688db3322$var$format(str, ctx, owner) : str;
}
/**
 * Format a number and return a string based on input settings.
 *
 * @sample highcharts/members/highcharts-numberformat/
 *         Custom number format
 *
 * @function Highcharts.numberFormat
 *
 * @param {number} number
 *        The input number to format.
 *
 * @param {number} decimals
 *        The amount of decimals. A value of -1 preserves the amount in the
 *        input number.
 *
 * @param {string} [decimalPoint]
 *        The decimal point, defaults to the one given in the lang options, or
 *        a dot.
 *
 * @param {string} [thousandsSep]
 *        The thousands separator, defaults to the one given in the lang
 *        options, or a space character.
 *
 * @return {string}
 *         The formatted number.
 */ function $45a6a1d688db3322$var$numberFormat(number, decimals, decimalPoint, thousandsSep) {
    number = +number || 0;
    decimals = +decimals;
    let ret, fractionDigits, [mantissa, exp] = number.toString().split('e').map(Number);
    const lang = this?.options?.lang || $45a6a1d688db3322$var$defaultOptions.lang, origDec = (number.toString().split('.')[1] || '').split('e')[0].length, firstDecimals = decimals, options = {};
    decimalPoint ?? (decimalPoint = lang.decimalPoint);
    thousandsSep ?? (thousandsSep = lang.thousandsSep);
    if (decimals === -1) // Preserve decimals. Not huge numbers (#3793).
    decimals = Math.min(origDec, 20);
    else if (!$45a6a1d688db3322$var$isNumber(decimals)) decimals = 2;
    else if (decimals && exp < 0) {
        // Expose decimals from exponential notation (#7042)
        fractionDigits = decimals + exp;
        if (fractionDigits >= 0) {
            // Remove too small part of the number while keeping the notation
            mantissa = +mantissa.toExponential(fractionDigits).split('e')[0];
            decimals = fractionDigits;
        } else {
            // `fractionDigits < 0`
            mantissa = Math.floor(mantissa);
            if (decimals < 20) // Use number instead of exponential notation (#7405)
            number = +(mantissa * Math.pow(10, exp)).toFixed(decimals);
            else // Or zero
            number = 0;
            exp = 0;
        }
    }
    if (exp) {
        decimals ?? (decimals = 2);
        number = mantissa;
    }
    if ($45a6a1d688db3322$var$isNumber(decimals) && decimals >= 0) {
        options.minimumFractionDigits = decimals;
        options.maximumFractionDigits = decimals;
    }
    if (thousandsSep === '') options.useGrouping = false;
    const hasSeparators = thousandsSep || decimalPoint, locale = hasSeparators ? 'en' : this?.locale || lang.locale || $45a6a1d688db3322$var$pageLang, cacheKey = JSON.stringify(options) + locale, nf = $45a6a1d688db3322$var$numberFormatCache[cacheKey] ?? ($45a6a1d688db3322$var$numberFormatCache[cacheKey] = new Intl.NumberFormat(locale, options));
    ret = nf.format(number);
    // If thousandsSep or decimalPoint are set, fall back to using English
    // format with string replacement for the separators.
    if (hasSeparators) ret = ret// Preliminary step to avoid re-swapping (#22402)
    .replace(/([,\.])/g, '_$1').replace(/_\,/g, thousandsSep ?? ',').replace('_.', decimalPoint ?? '.');
    if (// Remove signed zero (#20564)
    !decimals && +ret === 0 || // Small numbers, no decimals (#14023)
    exp < 0 && !firstDecimals) ret = '0';
    if (exp && +ret !== 0) ret += 'e' + (exp < 0 ? '' : '+') + exp;
    return ret;
}
/* *
 *
 *  Default Export
 *
 * */ const $45a6a1d688db3322$var$Templating = {
    dateFormat: $45a6a1d688db3322$var$dateFormat,
    format: $45a6a1d688db3322$var$format,
    helpers: $45a6a1d688db3322$var$helpers,
    numberFormat: $45a6a1d688db3322$var$numberFormat
};
var $45a6a1d688db3322$export$2e2bcd8739ae039 = $45a6a1d688db3322$var$Templating;
/* *
 * API Declarations
 * */ /**
 * @interface Highcharts.Templating
 *
 * The Highcharts.Templating interface provides a structure for defining
 * helpers. Helpers can be used as conditional blocks or functions within
 * expressions. Highcharts includes several built-in helpers and supports
 * the addition of custom helpers.
 *
 * @see [More information](
 * https://www.highcharts.com/docs/chart-concepts/templating#helpers)
 *
 * @example
 * // Define a custom helper to return the absolute value of a number
 * Highcharts.Templating.helpers.abs = value => Math.abs(value);
 *
 * // Usage in a format string
 * format: 'Absolute value: {abs point.y}'
 *
 * @name Highcharts.Templating#helpers
 * @type {Record<string, Function>}
 */ ''; // Keeps doclets above in file

});
parcelRegister("3vHyG", function(module, exports) {

$parcel$export(module.exports, "default", () => $28e60e23d058c899$export$2e2bcd8739ae039);
/* *
 *
 *  (c) 2010-2025 Torstein Honsi
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 * */ 
var $h63sD = parcelRequire("h63sD");

var $30Vhv = parcelRequire("30Vhv");

var $8eMVW = parcelRequire("8eMVW");

var $a3xCS = parcelRequire("a3xCS");

var $l3aRA = parcelRequire("l3aRA");
'use strict';
const { isTouchDevice: $28e60e23d058c899$var$isTouchDevice } = (0, $30Vhv.default);
const { fireEvent: $28e60e23d058c899$var$fireEvent, merge: $28e60e23d058c899$var$merge } = (0, $l3aRA.default);
/* *
 *
 *  API Options
 *
 * */ /**
 * Global default settings.
 *
 * @name Highcharts.defaultOptions
 * @type {Highcharts.Options}
 */ /**
* @optionparent
* @private
*/ const $28e60e23d058c899$var$defaultOptions = {
    /**
     * An array containing the default colors for the chart's series. When
     * all colors are used, new colors are pulled from the start again.
     *
     * Default colors can also be set on a series or series.type basis,
     * see [column.colors](#plotOptions.column.colors),
     * [pie.colors](#plotOptions.pie.colors).
     *
     * In styled mode, the colors option doesn't exist. Instead, colors
     * are defined in CSS and applied either through series or point class
     * names, or through the [chart.colorCount](#chart.colorCount) option.
     *
     * @sample {highcharts} highcharts/chart/colors/
     *         Assign a global color theme
     * @sample highcharts/members/theme-v10/
     *         Latest release styled like version 10
     *
     * @type    {Array<(Highcharts.ColorString|Highcharts.GradientColorObject|Highcharts.PatternObject)>}
     * @default [
     *     "#2caffe",
     *     "#544fc5",
     *     "#00e272",
     *     "#fe6a35",
     *     "#6b8abc",
     *     "#d568fb",
     *     "#2ee0ca",
     *     "#fa4b42",
     *     "#feb56a",
     *     "#91e8e1"
     * ]
     */ colors: (0, $8eMVW.default).colors,
    /**
     * Styled mode only. Configuration object for adding SVG definitions for
     * reusable elements. See [gradients, shadows and
     * patterns](https://www.highcharts.com/docs/chart-design-and-style/gradients-shadows-and-patterns)
     * for more information and code examples.
     *
     * @type      {*}
     * @since     5.0.0
     * @apioption defs
     */ /**
     * @ignore-option
     */ symbols: [
        'circle',
        'diamond',
        'square',
        'triangle',
        'triangle-down'
    ],
    /**
     * An object containing language-related strings and settings. A typical
     * setup uses `Highcharts.setOptions` to make the options apply to all
     * charts in the same page.
     *
     * Some language options, like `months` and `weekdays`, are only used
     * with non-locale-aware date formats.
     *
     * ```js
     * Highcharts.setOptions({
     *     lang: {
     *         locale: 'fr'
     *     }
     * });
     * ```
     *
     * @optionparent lang
     */ lang: {
        weekFrom: 'week from',
        /**
         * The default chart title.
         *
         * @since 12.2.0
         */ chartTitle: 'Chart title',
        /**
         * The browser locale to use for date and number formatting. The actual
         * locale used for each chart is determined in three steps:
         * 1. If this `lang.locale` option is specified, it is used.
         * 2. Else, look for the closest ancestor HTML element with a `lang`
         *    attribute, typically the `<html>` element.
         * 3. If no 'lang' attribute is found, use the default browser locale.
         *
         * Use `en-GB`, British English, for approximate consistency with
         * Highcharts v < 12.
         *
         * @sample highcharts/lang/locale/
         *         Set the locale using the `lang.locale` option
         * @sample highcharts/lang/locale-attribute/
         *         Pick up the locale from the HTML `lang` attribute
         * @sample highcharts/members/highcharts-numberformat
         *         Arabic locale with digits and dates         *
         *
         * @since 12.0.0
         * @type {string|Array<string>}
         */ locale: void 0,
        /**
         * The loading text that appears when the chart is set into the loading
         * state following a call to `chart.showLoading`.
         */ loading: 'Loading...',
        /**
         * An array containing the months names. Corresponds to the `%B` format
         * in `Highcharts.dateFormat()`. Defaults to 'undefined',
         * meaning the default month names are used according to the
         * `lang.locale` or browser settings.
         *
         * @type    {Array<string>}
         */ months: void 0,
        /**
         * [Format string](https://www.highcharts.com/docs/chart-concepts/templating) for the default series name.
         *
         * @since 12.2.0
         */ seriesName: 'Series {add index 1}',
        /**
         * An array containing the months names in abbreviated form. Corresponds
         * to the `%b` format in `Highcharts.dateFormat()`. Defaults to
         * 'undefined', meaning the default short month names are used according
         * to the `lang.locale` or browser settings.
         *
         * @type    {Array<string>}
         */ shortMonths: void 0,
        /**
         * An array containing the weekday names. Corresponds
         * to the `%A` format in `Highcharts.dateFormat()`. Defaults to
         * 'undefined', meaning the default weekday names are used according to
         * the `lang.locale` or browser settings.
         *
         * @type    {Array<string>}
         */ weekdays: void 0,
        /**
         * Short week days, starting Sunday. Corresponds to the `%a` format in
         * `Highcharts.dateFormat()`. Defaults to 'undefined', meaning
         * the default short weekday names are used according to the
         * `lang.locale` or browser settings.
         *
         * @sample highcharts/lang/shortweekdays/
         *         Finnish two-letter abbreviations
         *
         * @type      {Array<string>}
         * @since     4.2.4
         * @apioption lang.shortWeekdays
         */ /**
         * What to show in a date field for invalid dates. Defaults to an empty
         * string.
         *
         * @type      {string}
         * @since     4.1.8
         * @product   highcharts highstock
         * @apioption lang.invalidDate
         */ /**
         * The title appearing on hovering the zoom in button. The text itself
         * defaults to "+" and can be changed in the button options.
         *
         * @type      {string}
         * @default   Zoom in
         * @product   highmaps
         * @apioption lang.zoomIn
         */ /**
         * The title appearing on hovering the zoom out button. The text itself
         * defaults to "-" and can be changed in the button options.
         *
         * @type      {string}
         * @default   Zoom out
         * @product   highmaps
         * @apioption lang.zoomOut
         */ /**
         * The default decimal point used in the `Highcharts.numberFormat`
         * method unless otherwise specified in the function arguments. Defaults
         * to the locale decimal point as determined by `lang.locale`.
         *
         * @type      {string}
         * @default   undefined
         * @since     1.2.2
         * @apioption lang.decimalPoint
         */ /**
         * [Metric prefixes](https://en.wikipedia.org/wiki/Metric_prefix) used
         * to shorten high numbers in axis labels. Replacing any of the
         * positions with `null` causes the full number to be written. Setting
         * `numericSymbols` to `undefined` disables shortening altogether.
         *
         * @sample {highcharts} highcharts/lang/numericsymbols/
         *         Replacing the symbols with text
         * @sample {highstock} highcharts/lang/numericsymbols/
         *         Replacing the symbols with text
         *
         * @type    {Array<string>}
         * @default ["k", "M", "G", "T", "P", "E"]
         * @since   2.3.0
         */ numericSymbols: [
            'k',
            'M',
            'G',
            'T',
            'P',
            'E'
        ],
        /**
         * The default name for a pie slice (point).
         * @since 12.2.0
         */ pieSliceName: 'Slice',
        /**
         * The magnitude of [numericSymbols](#lang.numericSymbol) replacements.
         * Use 10000 for Japanese, Korean and various Chinese locales, which
         * use symbols for 10^4, 10^8 and 10^12.
         *
         * @sample highcharts/lang/numericsymbolmagnitude/
         *         10000 magnitude for Japanese
         *
         * @type      {number}
         * @default   1000
         * @since     5.0.3
         * @apioption lang.numericSymbolMagnitude
         */ /**
         * The default thousands separator used in the `Highcharts.numberFormat`
         * method unless otherwise specified in the function arguments. Defaults
         * to the locale thousands separator as determined by `lang.locale`.
         *
         * @type      {string}
         * @default   undefined
         * @since     1.2.2
         * @apioption lang.thousandsSep
         */ /**
         * The text for the label appearing when a chart is zoomed.
         *
         * @since 1.2.4
         */ resetZoom: 'Reset zoom',
        /**
         * The tooltip title for the label appearing when a chart is zoomed.
         *
         * @since 1.2.4
         */ /**
         * The default title of the Y axis
         *
         * @since 12.2.0
         */ yAxisTitle: 'Values',
        resetZoomTitle: 'Reset zoom level 1:1'
    },
    /**
     * Global options that don't apply to each chart. These options must be set
     * using the `Highcharts.setOptions` method.
     *
     * ```js
     * Highcharts.setOptions({
     *     global: {
     *         buttonTheme: {
     *             fill: '#d0d0d0'
     *         }
     *     }
     * });
     * ```
     */ global: {
        /**
         * General theme for buttons. This applies to the zoom button, exporting
         * context menu, map navigation, range selector buttons and custom
         * buttons generated using the `SVGRenderer.button` function. However,
         * each of these may be overridden with more specific options.
         *
         * @sample highcharts/global/buttontheme
         *         General button theme
         * @since 11.4.2
         */ buttonTheme: {
            /**
             * The fill color for buttons
             */ fill: "#f7f7f7" /* Palette.neutralColor3 */ ,
            /**
             * The padding of buttons
             */ padding: 8,
            /**
             * The border radius for buttons
             */ r: 2,
            /**
             * The stroke color for buttons
             */ stroke: "#cccccc" /* Palette.neutralColor20 */ ,
            /**
             * The stroke width for buttons
             */ 'stroke-width': 1,
            /**
             * CSS styling for the buttons' text
             */ style: {
                color: "#333333" /* Palette.neutralColor80 */ ,
                cursor: 'pointer',
                fontSize: '0.8em',
                fontWeight: 'normal'
            },
            /**
             * State overrides for the buttons
             */ states: {
                /**
                 * Hover state overrides for the buttons are applied in addition
                 * to the normal state options
                 */ hover: {
                    fill: "#e6e6e6" /* Palette.neutralColor10 */ 
                },
                /**
                 * Select state overrides for the buttons are applied in
                 * addition to the normal state options
                 */ select: {
                    fill: "#e6e9ff" /* Palette.highlightColor10 */ ,
                    style: {
                        color: "#000000" /* Palette.neutralColor100 */ ,
                        fontWeight: 'bold'
                    }
                },
                /**
                 * Disabled state overrides for the buttons are applied in
                 * addition to the normal state options
                 */ disabled: {
                    /**
                     * Disabled state CSS style overrides for the buttons' text
                     */ style: {
                        color: "#cccccc" /* Palette.neutralColor20 */ 
                    }
                }
            }
        }
    },
    /**
     * Time options that can apply globally or to individual charts. These
     * settings affect how `datetime` axes are laid out, how tooltips are
     * formatted, how series
     * [pointIntervalUnit](#plotOptions.series.pointIntervalUnit) works and how
     * the Highcharts Stock range selector handles time.
     *
     * The common use case is that all charts in the same Highcharts object
     * share the same time settings, in which case the global settings are set
     * using `setOptions`.
     *
     * ```js
     * // Apply time settings globally
     * Highcharts.setOptions({
     *     time: {
     *         timezone: 'Europe/London'
     *     }
     * });
     * // Apply time settings by instance
     * const chart = Highcharts.chart('container', {
     *     time: {
     *         timezone: 'America/New_York'
     *     },
     *     series: [{
     *         data: [1, 4, 3, 5]
     *     }]
     * });
     *
     * // Use the Time object
     * console.log(
     *        'Current time in New York',
     *        chart.time.dateFormat('%Y-%m-%d %H:%M:%S', Date.now())
     * );
     * ```
     *
     * Since v6.0.5, the time options were moved from the `global` object to the
     * `time` object, and time options can be set on each individual chart.
     *
     * @sample {highcharts|highstock}
     *         highcharts/time/timezone/
     *         Set the timezone globally
     * @sample {highcharts}
     *         highcharts/time/individual/
     *         Set the timezone per chart instance
     * @sample {highstock}
     *         stock/time/individual/
     *         Set the timezone per chart instance
     *
     * @since     6.0.5
     * @optionparent time
     */ time: {
        /**
         * A custom `Date` class for advanced date handling. For example,
         * [JDate](https://github.com/tahajahangir/jdate) can be hooked in to
         * handle Jalali dates.
         *
         * @type      {*}
         * @since     4.0.4
         * @product   highcharts highstock gantt
         */ Date: void 0,
        /**
         * A named time zone. Supported time zone names rely on the browser
         * implementations, as described in the [mdn
         * docs](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat#timezone).
         * If the given time zone is not recognized by the browser, Highcharts
         * provides a warning and falls back to returning a 0 offset,
         * corresponding to the UTC time zone.
         *
         * The time zone affects axis scaling, tickmark placement and
         * time display in `Highcharts.dateFormat`.
         *
         * Setting `timezone` to `undefined` falls back to the default browser
         * timezone setting.
         *
         * Until v11.2.0, this option depended on moment.js.
         *
         * @sample {highcharts|highstock} highcharts/time/timezone/ Europe/Oslo
         *
         * @type      {string}
         * @since     5.0.7
         * @product   highcharts highstock gantt
         */ timezone: 'UTC',
        /**
         * The timezone offset in minutes. Positive values are west, negative
         * values are east of UTC, as in the ECMAScript
         * [getTimezoneOffset](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/getTimezoneOffset)
         * method. Use this to display UTC based data in a predefined time zone.
         *
         * This option is deprecated as of v11.4.1 and will be removed in a
         * future release. Use the [time.timezone](#time.timezone) option
         * instead.
         *
         * @see [time.getTimezoneOffset](#time.getTimezoneOffset)
         *
         * @sample {highcharts|highstock} highcharts/time/timezoneoffset/
         *         Timezone offset
         *
         * @since     3.0.8
         * @deprecated 11.4.2
         * @product   highcharts highstock gantt
         */ timezoneOffset: 0,
        /**
         * Whether to use UTC time for axis scaling, tickmark placement and
         * time display in `Highcharts.dateFormat`. Advantages of using UTC
         * is that the time displays equally regardless of the user agent's
         * time zone settings. Local time can be used when the data is loaded
         * in real time or when correct Daylight Saving Time transitions are
         * required.
         *
         * Setting `useUTC` to true is equivalent to setting `time.timezone` to
         * `"UTC"`. Setting `useUTC` to false is equivalent to setting
         * `time.timezone` to `undefined`.
         *
         * @see [time.timezone](#timezone)
         *
         * @sample {highcharts} highcharts/time/useutc-true/
         *         True by default
         * @sample {highcharts} highcharts/time/useutc-false/
         *         False
         *
         * @deprecated
         */ useUTC: void 0
    },
    chart: (0, $h63sD.default),
    /**
     * The chart's main title.
     *
     * @sample {highmaps} maps/title/title/
     *         Title options demonstrated
     * @sample {highcharts} highcharts/title/align-auto/
     *         Default title alignment
     */ title: {
        /**
         * When the title is floating, the plot area will not move to make space
         * for it.
         *
         * @sample {highcharts} highcharts/chart/zoomtype-none/
         *         False by default
         * @sample {highcharts} highcharts/title/floating/
         *         True - title on top of the plot area
         * @sample {highstock} stock/chart/title-floating/
         *         True - title on top of the plot area
         *
         * @type      {boolean}
         * @default   false
         * @since     2.1
         * @apioption title.floating
         */ /**
         * Whether to
         * [use HTML](https://www.highcharts.com/docs/chart-concepts/labels-and-string-formatting#html)
         * to render the text.
         *
         * @type      {boolean}
         * @default   false
         * @apioption title.useHTML
         */ /**
         * The vertical alignment of the title. Can be one of `"top"`,
         * `"middle"` and `"bottom"`. When a value is given, the title behaves
         * as if [floating](#title.floating) were `true`.
         *
         * @sample {highcharts} highcharts/title/verticalalign/
         *         Chart title in bottom right corner
         * @sample {highstock} stock/chart/title-verticalalign/
         *         Chart title in bottom right corner
         *
         * @type      {Highcharts.VerticalAlignValue}
         * @since     2.1
         * @apioption title.verticalAlign
         */ /**
         * The x position of the title relative to the alignment within
         * `chart.spacingLeft` and `chart.spacingRight`.
         *
         * @sample {highcharts} highcharts/title/align/
         *         Aligned to the plot area (x = 70px = margin left - spacing
         *         left)
         * @sample {highstock} stock/chart/title-align/
         *         Aligned to the plot area (x = 50px = margin left - spacing
         *         left)
         *
         * @type      {number}
         * @default   0
         * @since     2.0
         * @apioption title.x
         */ /**
         * The y position of the title relative to the alignment within
         * [chart.spacingTop](#chart.spacingTop) and [chart.spacingBottom](
         * #chart.spacingBottom). By default it depends on the font size.
         *
         * @sample {highcharts} highcharts/title/y/
         *         Title inside the plot area
         * @sample {highstock} stock/chart/title-verticalalign/
         *         Chart title in bottom right corner
         *
         * @type      {number}
         * @since     2.0
         * @apioption title.y
         */ /**
         * CSS styles for the title. Use this for font styling, but use `align`,
         * `x` and `y` for text alignment.
         *
         * Note that the default [title.minScale](#title.minScale) option also
         * affects the rendered font size. In order to keep the font size fixed
         * regardless of title length, set `minScale` to 1.
         *
         * In styled mode, the title style is given in the `.highcharts-title`
         * class.
         *
         * @sample {highcharts} highcharts/title/style/
         *         Custom color and weight
         * @sample {highstock} stock/chart/title-style/
         *         Custom color and weight
         * @sample highcharts/css/titles/
         *         Styled mode
         *
         * @type      {Highcharts.CSSObject}
         * @default   {highcharts|highmaps} { "color": "#333333", "fontSize": "18px" }
         * @default   {highstock} { "color": "#333333", "fontSize": "16px" }
         */ style: {
            color: "#333333" /* Palette.neutralColor80 */ ,
            fontWeight: 'bold'
        },
        /**
         * The title of the chart. To disable the title, set the `text` to
         * `undefined`.
         *
         * @sample {highcharts} highcharts/title/text/
         *         Custom title
         * @sample {highstock} stock/chart/title-text/
         *         Custom title
         *
         * @default {highcharts|highmaps} Chart title
         * @default {highstock} undefined
         */ text: 'Chart title',
        /**
         * The horizontal alignment of the title. Can be one of "left", "center"
         * and "right".
         *
         * Since v12 it defaults to `undefined`, meaning the alignment is
         * computed for best fit. If the text fits in one line, it aligned to
         * the center, but if it is wrapped into multiple lines, it is aligned
         * to the left.
         *
         * @sample {highcharts} highcharts/title/align-auto/
         *         Default alignment, dynamic
         * @sample {highcharts} highcharts/title/align/
         *         Aligned to the plot area (x = 70px = margin left - spacing
         *         left)
         * @sample {highstock} stock/chart/title-align/
         *         Aligned to the plot area (x = 50px = margin left - spacing
         *         left)
         *
         * @type      {Highcharts.AlignValue}
         * @default   undefined
         * @since     2.0
         * @apioption title.align
         */ /**
         * The margin between the title and the plot area, or if a subtitle
         * is present, the margin between the subtitle and the plot area.
         *
         * @sample {highcharts} highcharts/title/margin-50/
         *         A chart title margin of 50
         * @sample {highcharts} highcharts/title/margin-subtitle/
         *         The same margin applied with a subtitle
         * @sample {highstock} stock/chart/title-margin/
         *         A chart title margin of 50
         *
         * @since 2.1
         */ margin: 15,
        /**
         * When the title is too wide to fit in the chart, the default behavior
         * is to scale it down to fit, or apply word wrap if it is scaled down
         * to `minScale` and still doesn't fit.
         *
         * The default value reflects the scale, when using default font sizes,
         * when the title font size matches that of the subtitle. The title
         * still stands out as it is bold by default.
         *
         * Set `minScale` to 1 to avoid downscaling.
         *
         * @sample {highcharts} highcharts/title/align-auto/
         *         Downscaling demonstrated
         *
         * @since 12.0.0
         */ minScale: 0.67
    },
    /**
     * The chart's subtitle. This can be used both to display a subtitle below
     * the main title, and to display random text anywhere in the chart. The
     * subtitle can be updated after chart initialization through the
     * `Chart.setTitle` method.
     *
     * @sample {highcharts} highcharts/title/align-auto/
     *         Default title alignment
     * @sample {highmaps} maps/title/subtitle/
     *         Subtitle options demonstrated
     */ subtitle: {
        /**
         * The horizontal alignment of the subtitle. Can be one of "left",
         * "center" and "right". Since v12, it defaults to `undefined`, meaning
         * the actual alignment is inherited from the alignment of the main
         * title.
         *
         * @sample {highcharts} highcharts/title/align-auto/
         *         Default title and subtitle alignment, dynamic
         * @sample {highcharts} highcharts/subtitle/align/
         *         Footnote at right of plot area
         * @sample {highstock} stock/chart/subtitle-footnote
         *         Footnote at bottom right of plot area
         *
         * @type  {Highcharts.AlignValue}
         * @default undefined
         * @since 2.0
         * @apioption subtitle.align
         */ /**
         * When the subtitle is floating, the plot area will not move to make
         * space for it.
         *
         * @sample {highcharts} highcharts/subtitle/floating/
         *         Floating title and subtitle
         * @sample {highstock} stock/chart/subtitle-footnote
         *         Footnote floating at bottom right of plot area
         *
         * @type      {boolean}
         * @default   false
         * @since     2.1
         * @apioption subtitle.floating
         */ /**
         * CSS styles for the title.
         *
         * In styled mode, the subtitle style is given in the
         * `.highcharts-subtitle` class.
         *
         * @sample {highcharts} highcharts/subtitle/style/
         *         Custom color and weight
         * @sample {highcharts} highcharts/css/titles/
         *         Styled mode
         * @sample {highstock} stock/chart/subtitle-style
         *         Custom color and weight
         * @sample {highstock} highcharts/css/titles/
         *         Styled mode
         * @sample {highmaps} highcharts/css/titles/
         *         Styled mode
         *
         * @type      {Highcharts.CSSObject}
         * @default   {"color": "#666666"}
         * @apioption subtitle.style
         */ /**
         * Whether to
         * [use HTML](https://www.highcharts.com/docs/chart-concepts/labels-and-string-formatting#html)
         * to render the text.
         *
         * @type      {boolean}
         * @default   false
         * @apioption subtitle.useHTML
         */ /**
         * The vertical alignment of the title. Can be one of `"top"`,
         * `"middle"` and `"bottom"`. When middle, the subtitle behaves as
         * floating.
         *
         * @sample {highcharts} highcharts/subtitle/verticalalign/
         *         Footnote at the bottom right of plot area
         * @sample {highstock} stock/chart/subtitle-footnote
         *         Footnote at the bottom right of plot area
         *
         * @type      {Highcharts.VerticalAlignValue}
         * @since     2.1
         * @apioption subtitle.verticalAlign
         */ /**
         * The x position of the subtitle relative to the alignment within
         * `chart.spacingLeft` and `chart.spacingRight`.
         *
         * @sample {highcharts} highcharts/subtitle/align/
         *         Footnote at right of plot area
         * @sample {highstock} stock/chart/subtitle-footnote
         *         Footnote at the bottom right of plot area
         *
         * @type      {number}
         * @default   0
         * @since     2.0
         * @apioption subtitle.x
         */ /**
         * The y position of the subtitle relative to the alignment within
         * `chart.spacingTop` and `chart.spacingBottom`. By default the subtitle
         * is laid out below the title unless the title is floating.
         *
         * @sample {highcharts} highcharts/subtitle/verticalalign/
         *         Footnote at the bottom right of plot area
         * @sample {highstock} stock/chart/subtitle-footnote
         *         Footnote at the bottom right of plot area
         *
         * @type      {number}
         * @since     2.0
         * @apioption subtitle.y
         */ /**
         * CSS styles for the title.
         *
         * In styled mode, the subtitle style is given in the
         * `.highcharts-subtitle` class.
         *
         * @sample {highcharts} highcharts/subtitle/style/
         *         Custom color and weight
         * @sample {highcharts} highcharts/css/titles/
         *         Styled mode
         * @sample {highstock} stock/chart/subtitle-style
         *         Custom color and weight
         * @sample {highstock} highcharts/css/titles/
         *         Styled mode
         * @sample {highmaps} highcharts/css/titles/
         *         Styled mode
         *
         * @type      {Highcharts.CSSObject}
         * @default   {"color": "#666666"}
         */ style: {
            color: "#666666" /* Palette.neutralColor60 */ ,
            /**
             * @type {number|string}
             */ fontSize: '0.8em'
        },
        /**
         * The subtitle of the chart.
         *
         * @sample {highcharts|highstock} highcharts/subtitle/text/
         *         Custom subtitle
         * @sample {highcharts|highstock} highcharts/subtitle/text-formatted/
         *         Formatted and linked text.
         */ text: ''
    },
    /**
     * The chart's caption, which will render below the chart and will be part
     * of exported charts. The caption can be updated after chart initialization
     * through the `Chart.update` or `Chart.caption.update` methods.
     *
     * @sample highcharts/caption/text/
     *         A chart with a caption
     * @since  7.2.0
     */ caption: {
        /**
         * When the caption is floating, the plot area will not move to make
         * space for it.
         *
         * @type      {boolean}
         * @default   false
         * @apioption caption.floating
         */ /**
         * The margin between the caption and the plot area.
         */ margin: 15,
        /**
         * Whether to
         * [use HTML](https://www.highcharts.com/docs/chart-concepts/labels-and-string-formatting#html)
         * to render the text.
         *
         * @type      {boolean}
         * @default   false
         * @apioption caption.useHTML
         */ /**
         * The x position of the caption relative to the alignment within
         * `chart.spacingLeft` and `chart.spacingRight`.
         *
         * @type      {number}
         * @default   0
         * @apioption caption.x
         */ /**
         * The y position of the caption relative to the alignment within
         * `chart.spacingTop` and `chart.spacingBottom`.
         *
         * @type      {number}
         * @apioption caption.y
         */ /**
         * CSS styles for the caption.
         *
         * In styled mode, the caption style is given in the
         * `.highcharts-caption` class.
         *
         * @sample {highcharts} highcharts/css/titles/
         *         Styled mode
         *
         * @type      {Highcharts.CSSObject}
         * @default   {"color": "#666666"}
         */ style: {
            color: "#666666" /* Palette.neutralColor60 */ ,
            /**
             * @type {number|string}
             */ fontSize: '0.8em'
        },
        /**
         * The caption text of the chart.
         *
         * @sample {highcharts} highcharts/caption/text/
         *         Custom caption
         */ text: '',
        /**
         * The horizontal alignment of the caption. Can be one of "left",
         *  "center" and "right".
         *
         * @type  {Highcharts.AlignValue}
         */ align: 'left',
        /**
         * The vertical alignment of the caption. Can be one of `"top"`,
         * `"middle"` and `"bottom"`. When middle, the caption behaves as
         * floating.
         *
         * @type      {Highcharts.VerticalAlignValue}
         */ verticalAlign: 'bottom'
    },
    /**
     * The plotOptions is a wrapper object for config objects for each series
     * type. The config objects for each series can also be overridden for
     * each series item as given in the series array.
     *
     * Configuration options for the series are given in three levels. Options
     * for all series in a chart are given in the [plotOptions.series](
     * #plotOptions.series) object. Then options for all series of a specific
     * type are given in the plotOptions of that type, for example
     * `plotOptions.line`. Next, options for one single series are given in
     * [the series array](#series).
     */ plotOptions: {},
    /**
     * The legend is a box containing a symbol and name for each series
     * item or point item in the chart. Each series (or points in case
     * of pie charts) is represented by a symbol and its name in the legend.
     *
     * It is possible to override the symbol creator function and create
     * [custom legend symbols](https://jsfiddle.net/gh/get/library/pure/highcharts/highcharts/tree/master/samples/highcharts/studies/legend-custom-symbol/).
     *
     * @productdesc {highmaps}
     * A Highmaps legend by default contains one legend item per series, but if
     * a `colorAxis` is defined, the axis will be displayed in the legend.
     * Either as a gradient, or as multiple legend items for `dataClasses`.
     */ legend: {
        /**
         * The background color of the legend.
         *
         * @see In styled mode, the legend background fill can be applied with
         *      the `.highcharts-legend-box` class.
         *
         * @sample {highcharts} highcharts/legend/backgroundcolor/
         *         Yellowish background
         * @sample {highstock} stock/legend/align/
         *         Various legend options
         * @sample {highmaps} maps/legend/border-background/
         *         Border and background options
         *
         * @type      {Highcharts.ColorString|Highcharts.GradientColorObject|Highcharts.PatternObject}
         * @apioption legend.backgroundColor
         */ /**
         * The width of the drawn border around the legend.
         *
         * @see In styled mode, the legend border stroke width can be applied
         *      with the `.highcharts-legend-box` class.
         *
         * @sample {highcharts} highcharts/legend/borderwidth/
         *         2px border width
         * @sample {highstock} stock/legend/align/
         *         Various legend options
         * @sample {highmaps} maps/legend/border-background/
         *         Border and background options
         *
         * @type      {number}
         * @default   0
         * @apioption legend.borderWidth
         */ /**
         * Enable or disable the legend. There is also a series-specific option,
         * [showInLegend](#plotOptions.series.showInLegend), that can hide the
         * series from the legend. In some series types this is `false` by
         * default, so it must set to `true` in order to show the legend for the
         * series.
         *
         * @sample {highcharts} highcharts/legend/enabled-false/ Legend disabled
         * @sample {highstock} stock/legend/align/ Various legend options
         * @sample {highmaps} maps/legend/enabled-false/ Legend disabled
         *
         * @default {highstock} false
         * @default {highmaps} true
         * @default {gantt} false
         */ enabled: true,
        /**
         * The horizontal alignment of the legend box within the chart area.
         * Valid values are `left`, `center` and `right`.
         *
         * In the case that the legend is aligned in a corner position, the
         * `layout` option will determine whether to place it above/below
         * or on the side of the plot area.
         *
         * @sample {highcharts} highcharts/legend/align/
         *         Legend at the right of the chart
         * @sample {highstock} stock/legend/align/
         *         Various legend options
         * @sample {highmaps} maps/legend/alignment/
         *         Legend alignment
         *
         * @type  {Highcharts.AlignValue}
         * @since 2.0
         */ align: 'center',
        /**
         * If the [layout](legend.layout) is `horizontal` and the legend items
         * span over two lines or more, whether to align the items into vertical
         * columns. Setting this to `false` makes room for more items, but will
         * look more messy.
         *
         * @since 6.1.0
         */ alignColumns: true,
        /**
         * A CSS class name to apply to the legend group.
         */ className: 'highcharts-no-tooltip',
        /**
         * General event handlers for the legend. These event hooks can
         * also be attached to the legend at run time using the
         * `Highcharts.addEvent` function.
         *
         * @declare Highcharts.LegendEventsOptionsObject
         *
         * @private
         */ events: {},
        /**
         * Fires when the legend item belonging to the series is clicked. One
         * parameter, `event`, is passed to the function. The default action
         * is to toggle the visibility of the series, point or data class. This
         * can be prevented by returning `false` or calling
         * `event.preventDefault()`.
         *
         * @sample {highcharts} highcharts/legend/itemclick/
         *         Confirm hiding and showing
         * @sample {highcharts} highcharts/legend/pie-legend-itemclick/
         *         Confirm toggle visibility of pie slices
         *
         * @type      {Highcharts.LegendItemClickCallbackFunction}
         * @context   Highcharts.Legend
         * @apioption legend.events.itemClick
         */ /**
         * When the legend is floating, the plot area ignores it and is allowed
         * to be placed below it.
         *
         * @sample {highcharts} highcharts/legend/floating-false/
         *         False by default
         * @sample {highcharts} highcharts/legend/floating-true/
         *         True
         * @sample {highmaps} maps/legend/alignment/
         *         Floating legend
         *
         * @type      {boolean}
         * @default   false
         * @since     2.1
         * @apioption legend.floating
         */ /**
         * The layout of the legend items. Can be one of `horizontal` or
         * `vertical` or `proximate`. When `proximate`, the legend items will be
         * placed as close as possible to the graphs they're representing,
         * except in inverted charts or when the legend position doesn't allow
         * it.
         *
         * @sample {highcharts} highcharts/legend/layout-horizontal/
         *         Horizontal by default
         * @sample {highcharts} highcharts/legend/layout-vertical/
         *         Vertical
         * @sample highcharts/legend/layout-proximate
         *         Labels proximate to the data
         * @sample {highstock} stock/legend/layout-horizontal/
         *         Horizontal by default
         * @sample {highmaps} maps/legend/padding-itemmargin/
         *         Vertical with data classes
         * @sample {highmaps} maps/legend/layout-vertical/
         *         Vertical with color axis gradient
         *
         * @validvalue ["horizontal", "vertical", "proximate"]
         */ layout: 'horizontal',
        /**
         * In a legend with horizontal layout, the itemDistance defines the
         * pixel distance between each item.
         *
         * @sample {highcharts} highcharts/legend/layout-horizontal/
         *         50px item distance
         * @sample {highstock} highcharts/legend/layout-horizontal/
         *         50px item distance
         *
         * @type      {number}
         * @default   {highcharts} 20
         * @default   {highstock} 20
         * @default   {highmaps} 8
         * @since     3.0.3
         * @apioption legend.itemDistance
         */ /**
         * The pixel bottom margin for each legend item.
         *
         * @sample {highcharts|highstock} highcharts/legend/padding-itemmargin/
         *         Padding and item margins demonstrated
         * @sample {highmaps} maps/legend/padding-itemmargin/
         *         Padding and item margins demonstrated
         *
         * @since     2.2.0
         */ itemMarginBottom: 2,
        /**
         * The pixel top margin for each legend item.
         *
         * @sample {highcharts|highstock} highcharts/legend/padding-itemmargin/
         *         Padding and item margins demonstrated
         * @sample {highmaps} maps/legend/padding-itemmargin/
         *         Padding and item margins demonstrated
         *
         * @since     2.2.0
         */ itemMarginTop: 2,
        /**
         * The width for each legend item. By default the items are laid out
         * successively. In a [horizontal layout](legend.layout), if the items
         * are laid out across two rows or more, they will be vertically aligned
         * depending on the [legend.alignColumns](legend.alignColumns) option.
         *
         * @sample {highcharts} highcharts/legend/itemwidth-default/
         *         Undefined by default
         * @sample {highcharts} highcharts/legend/itemwidth-80/
         *         80 for aligned legend items
         *
         * @type      {number}
         * @since     2.0
         * @apioption legend.itemWidth
         */ /**
         * A [format string](https://www.highcharts.com/docs/chart-concepts/labels-and-string-formatting)
         * for each legend label. Available variables relates to properties on
         * the series, or the point in case of pies.
         *
         * @type      {string}
         * @default   {name}
         * @since     1.3
         * @apioption legend.labelFormat
         */ /* eslint-disable valid-jsdoc */ /**
         * Callback function to format each of the series' labels. The `this`
         * keyword refers to the series object, or the point object in case of
         * pie charts. By default the series or point name is printed.
         *
         * @productdesc {highmaps}
         * In Highmaps the context can also be a data class in case of a
         * `colorAxis`.
         *
         * @sample {highcharts} highcharts/legend/labelformatter/
         *         Add text
         * @sample {highmaps} maps/legend/labelformatter/
         *         Data classes with label formatter
         *
         * @type {Highcharts.FormatterCallbackFunction<Point|Series>}
         */ labelFormatter: function() {
            // eslint-enable valid-jsdoc
            return this.name;
        },
        /**
         * Line height for the legend items. Deprecated as of 2.1\. Instead,
         * the line height for each item can be set using
         * `itemStyle.lineHeight`, and the padding between items using
         * `itemMarginTop` and `itemMarginBottom`.
         *
         * @sample {highcharts} highcharts/legend/lineheight/
         *         Setting padding
         *
         * @deprecated
         *
         * @type      {number}
         * @default   16
         * @since     2.0
         * @product   highcharts gantt
         * @apioption legend.lineHeight
         */ /**
         * If the plot area sized is calculated automatically and the legend is
         * not floating, the legend margin is the space between the legend and
         * the axis labels or plot area.
         *
         * @sample {highcharts} highcharts/legend/margin-default/
         *         12 pixels by default
         * @sample {highcharts} highcharts/legend/margin-30/
         *         30 pixels
         *
         * @type      {number}
         * @default   12
         * @since     2.1
         * @apioption legend.margin
         */ /**
         * Maximum width for the legend. Can be a percentage of the chart width,
         * or an integer representing how many pixels wide the legend can be.
         *
         * @sample {highcharts} highcharts/legend/maxwidth/
         *         Max width set to 7%
         *
         * @type      {number|string}
         * @apioption legend.maxWidth
         */ /**
         * Maximum pixel height for the legend. When the maximum height is
         * extended, navigation will show.
         *
         * @type      {number}
         * @since     2.3.0
         * @apioption legend.maxHeight
         */ /**
         * The color of the drawn border around the legend.
         *
         * @see In styled mode, the legend border stroke can be applied with the
         *      `.highcharts-legend-box` class.
         *
         * @sample {highcharts} highcharts/legend/bordercolor/
         *         Brown border
         * @sample {highstock} stock/legend/align/
         *         Various legend options
         * @sample {highmaps} maps/legend/border-background/
         *         Border and background options
         *
         * @type {Highcharts.ColorString|Highcharts.GradientColorObject|Highcharts.PatternObject}
         */ borderColor: "#999999" /* Palette.neutralColor40 */ ,
        /**
         * The border corner radius of the legend.
         *
         * @sample {highcharts} highcharts/legend/borderradius-default/
         *         Square by default
         * @sample {highcharts} highcharts/legend/borderradius-round/
         *         5px rounded
         * @sample {highmaps} maps/legend/border-background/
         *         Border and background options
         */ borderRadius: 0,
        /**
         * Options for the paging or navigation appearing when the legend is
         * overflown. Navigation works well on screen, but not in static
         * exported images. One way of working around that is to
         * [increase the chart height in
         * export](https://jsfiddle.net/gh/get/library/pure/highcharts/highcharts/tree/master/samples/highcharts/legend/navigation-enabled-false/).
         *
         * @sample highcharts/legend/scrollable-vertical/
         *         Legend with vertical scrollable extension
         * @sample highcharts/legend/scrollable-horizontal/
         *         Legend with horizontal scrollable extension
         *
         */ navigation: {
            /**
             * How to animate the pages when navigating up or down. A value of
             * `true` applies the default navigation given in the
             * `chart.animation` option. Additional options can be given as an
             * object containing values for easing and duration.
             *
             * @sample {highcharts} highcharts/legend/navigation/
             *         Legend page navigation demonstrated
             * @sample {highstock} highcharts/legend/navigation/
             *         Legend page navigation demonstrated
             *
             * @type      {boolean|Partial<Highcharts.AnimationOptionsObject>}
             * @default   true
             * @since     2.2.4
             * @apioption legend.navigation.animation
             */ /**
             * The pixel size of the up and down arrows in the legend paging
             * navigation.
             *
             * @sample {highcharts} highcharts/legend/navigation/
             *         Legend page navigation demonstrated
             * @sample {highstock} highcharts/legend/navigation/
             *         Legend page navigation demonstrated
             *
             * @type      {number}
             * @default   12
             * @since     2.2.4
             * @apioption legend.navigation.arrowSize
             */ /**
             * Whether to enable the legend navigation. In most cases, disabling
             * the navigation results in an unwanted overflow.
             *
             * See also the
             * [adapt chart to legend](https://github.com/highcharts/adapt-chart-to-legend)
             * plugin for a solution to extend the chart height to make room for
             * the legend, optionally in exported charts only.
             *
             * @type      {boolean}
             * @default   true
             * @since     4.2.4
             * @apioption legend.navigation.enabled
             */ /**
             * Text styles for the legend page navigation.
             *
             * @see In styled mode, the navigation items are styled with the
             *      `.highcharts-legend-navigation` class.
             *
             * @sample {highcharts} highcharts/legend/navigation/
             *         Legend page navigation demonstrated
             * @sample {highstock} highcharts/legend/navigation/
             *         Legend page navigation demonstrated
             *
             * @type      {Highcharts.CSSObject}
             * @since     2.2.4
             * @apioption legend.navigation.style
             */ style: {
                /**
                 * @type {number|string}
                 */ fontSize: '0.8em'
            },
            /**
             * The color for the active up or down arrow in the legend page
             * navigation.
             *
             * @see In styled mode, the active arrow be styled with the
             *      `.highcharts-legend-nav-active` class.
             *
             * @sample  {highcharts} highcharts/legend/navigation/
             *          Legend page navigation demonstrated
             * @sample  {highstock} highcharts/legend/navigation/
             *          Legend page navigation demonstrated
             *
             * @type  {Highcharts.ColorString|Highcharts.GradientColorObject|Highcharts.PatternObject}
             * @since 2.2.4
             */ activeColor: "#0022ff" /* Palette.highlightColor100 */ ,
            /**
             * The color of the inactive up or down arrow in the legend page
             * navigation. .
             *
             * @see In styled mode, the inactive arrow be styled with the
             *      `.highcharts-legend-nav-inactive` class.
             *
             * @sample {highcharts} highcharts/legend/navigation/
             *         Legend page navigation demonstrated
             * @sample {highstock} highcharts/legend/navigation/
             *         Legend page navigation demonstrated
             *
             * @type  {Highcharts.ColorString|Highcharts.GradientColorObject|Highcharts.PatternObject}
             * @since 2.2.4
             */ inactiveColor: "#cccccc" /* Palette.neutralColor20 */ 
        },
        /**
         * The inner padding of the legend box.
         *
         * @sample {highcharts|highstock} highcharts/legend/padding-itemmargin/
         *         Padding and item margins demonstrated
         * @sample {highmaps} maps/legend/padding-itemmargin/
         *         Padding and item margins demonstrated
         *
         * @type      {number}
         * @default   8
         * @since     2.2.0
         * @apioption legend.padding
         */ /**
         * Whether to reverse the order of the legend items compared to the
         * order of the series or points as defined in the configuration object.
         *
         * @see [yAxis.reversedStacks](#yAxis.reversedStacks),
         *      [series.legendIndex](#series.legendIndex)
         *
         * @sample {highcharts} highcharts/legend/reversed/
         *         Stacked bar with reversed legend
         *
         * @type      {boolean}
         * @default   false
         * @since     1.2.5
         * @apioption legend.reversed
         */ /**
         * Whether to show the symbol on the right side of the text rather than
         * the left side. This is common in Arabic and Hebrew.
         *
         * @sample {highcharts} highcharts/legend/rtl/
         *         Symbol to the right
         *
         * @type      {boolean}
         * @default   false
         * @since     2.2
         * @apioption legend.rtl
         */ /**
         * CSS styles for the legend area. In the 1.x versions the position
         * of the legend area was determined by CSS. In 2.x, the position is
         * determined by properties like `align`, `verticalAlign`, `x` and `y`,
         * but the styles are still parsed for backwards compatibility.
         *
         * @deprecated
         *
         * @type      {Highcharts.CSSObject}
         * @product   highcharts highstock
         * @apioption legend.style
         */ /**
         * CSS styles for each legend item. Only a subset of CSS is supported,
         * notably those options related to text. The default `textOverflow`
         * property makes long texts truncate. Set it to `undefined` to wrap
         * text instead. A `width` property can be added to control the text
         * width.
         *
         * @see In styled mode, the legend items can be styled with the
         *      `.highcharts-legend-item` class.
         *
         * @sample {highcharts} highcharts/legend/itemstyle/
         *         Bold black text
         * @sample {highmaps} maps/legend/itemstyle/
         *         Item text styles
         *
         * @type    {Highcharts.CSSObject}
         * @default {"color": "#333333", "cursor": "pointer", "fontSize": "0.8em", "fontWeight": "bold", "textOverflow": "ellipsis"}
         */ itemStyle: {
            /**
             * @ignore
             */ color: "#333333" /* Palette.neutralColor80 */ ,
            /**
             * @ignore
             */ cursor: 'pointer',
            /**
             * @ignore
             */ fontSize: '0.8em',
            /**
             * @ignore
             */ textDecoration: 'none',
            /**
             * @ignore
             */ textOverflow: 'ellipsis'
        },
        /**
         * CSS styles for each legend item in hover mode. Only a subset of
         * CSS is supported, notably those options related to text. Properties
         * are inherited from `style` unless overridden here.
         *
         * @see In styled mode, the hovered legend items can be styled with
         *      the `.highcharts-legend-item:hover` pseudo-class.
         *
         * @sample {highcharts} highcharts/legend/itemhoverstyle/
         *         Red on hover
         * @sample {highmaps} maps/legend/itemstyle/
         *         Item text styles
         *
         * @type    {Highcharts.CSSObject}
         * @default {"color": "#000000"}
         */ itemHoverStyle: {
            /**
             * @ignore
             */ color: "#000000" /* Palette.neutralColor100 */ 
        },
        /**
         * CSS styles for each legend item when the corresponding series or
         * point is hidden. Only a subset of CSS is supported, notably those
         * options related to text. Properties are inherited from `style`
         * unless overridden here.
         *
         * @see In styled mode, the hidden legend items can be styled with
         *      the `.highcharts-legend-item-hidden` class.
         *
         * @sample {highcharts} highcharts/legend/itemhiddenstyle/
         *         Darker gray color
         *
         * @type    {Highcharts.CSSObject}
         * @default {"color": "#cccccc"}
         */ itemHiddenStyle: {
            /**
             * @ignore
             */ color: "#666666" /* Palette.neutralColor60 */ ,
            /**
             * @ignore
             */ textDecoration: 'line-through'
        },
        /**
         * Whether to apply a drop shadow to the legend. A `backgroundColor`
         * also needs to be applied for this to take effect. The shadow can be
         * an object configuration containing `color`, `offsetX`, `offsetY`,
         * `opacity` and `width`.
         *
         * @sample {highcharts} highcharts/legend/shadow/
         *         White background and drop shadow
         * @sample {highstock} stock/legend/align/
         *         Various legend options
         * @sample {highmaps} maps/legend/border-background/
         *         Border and background options
         *
         * @type {boolean|Highcharts.CSSObject}
         */ shadow: false,
        /**
         * Default styling for the checkbox next to a legend item when
         * `showCheckbox` is true.
         *
         * @type {Highcharts.CSSObject}
         * @default {"width": "13px", "height": "13px", "position":"absolute"}
         */ itemCheckboxStyle: {
            /**
             * @ignore
             */ position: 'absolute',
            /**
             * @ignore
             */ width: '13px',
            /**
             * @ignore
             */ height: '13px'
        },
        /// itemWidth: undefined,
        /**
         * When this is true, the legend symbol width will be the same as
         * the symbol height, which in turn defaults to the font size of the
         * legend items.
         *
         * @since 5.0.0
         */ squareSymbol: true,
        /**
         * The pixel height of the symbol for series types that use a rectangle
         * in the legend. Defaults to the font size of legend items.
         *
         * Note: This option is a default source of color axis height, if the
         * [colorAxis.height](https://api.highcharts.com/highcharts/colorAxis.height)
         * option is not set.
         *
         * @productdesc {highmaps}
         * In Highmaps, when the symbol is the gradient of a vertical color
         * axis, the height defaults to 200.
         *
         * @sample {highmaps} maps/legend/layout-vertical-sized/
         *         Sized vertical gradient
         * @sample {highmaps} maps/legend/padding-itemmargin/
         *         No distance between data classes
         *
         * @type      {number}
         * @since     3.0.8
         * @apioption legend.symbolHeight
         */ /**
         * The border radius of the symbol for series types that use a rectangle
         * in the legend. Defaults to half the `symbolHeight`, effectively
         * creating a circle.
         *
         * For color axis scales, it defaults to 3.
         *
         * @sample {highcharts} highcharts/legend/symbolradius/
         *         Round symbols
         * @sample {highstock} highcharts/legend/symbolradius/
         *         Round symbols
         * @sample {highmaps} highcharts/legend/symbolradius/
         *         Round symbols
         *
         * @type      {number}
         * @since     3.0.8
         * @apioption legend.symbolRadius
         */ /**
         * The pixel width of the legend item symbol. When the `squareSymbol`
         * option is set, this defaults to the `symbolHeight`, otherwise 16.
         *
         * Note: This option is a default source of color axis width, if the
         * [colorAxis.width](https://api.highcharts.com/highcharts/colorAxis.width)
         * option is not set.
         *
         * @productdesc {highmaps}
         * In Highmaps, when the symbol is the gradient of a horizontal color
         * axis, the width defaults to 200.
         *
         * @sample {highcharts} highcharts/legend/symbolwidth/
         *         Greater symbol width and padding
         * @sample {highmaps} maps/legend/padding-itemmargin/
         *         Padding and item margins demonstrated
         * @sample {highmaps} maps/legend/layout-vertical-sized/
         *         Sized vertical gradient
         *
         * @type      {number}
         * @apioption legend.symbolWidth
         */ /**
         * Whether to [use HTML](https://www.highcharts.com/docs/chart-concepts/labels-and-string-formatting#html)
         * to render the legend item texts.
         *
         * Prior to 4.1.7, when using HTML, [legend.navigation](
         * #legend.navigation) was disabled.
         *
         * @sample highcharts/legend/scrollable-vertical/
         *         Legend with vertical scrollable extension
         * @sample highcharts/legend/scrollable-horizontal/
         *         Legend with horizontal scrollable extension
         *
         * @type      {boolean}
         * @default   false
         * @apioption legend.useHTML
         */ /**
         * For a color axis with data classes, how many decimals to render in
         * the legend. The default preserves the decimals of the range numbers.
         *
         * @type      {number}
         * @default   -1
         * @product   highcharts highmaps
         * @apioption legend.valueDecimals
         */ /**
         * For a color axis with data classes, a suffix for the range numbers in
         * the legend.
         *
         * @type      {string}
         * @default   ''
         * @product   highcharts highmaps
         * @apioption legend.valueSuffix
         */ /**
         * The width of the legend box. If a number is set, it translates to
         * pixels. Since v7.0.2 it allows setting a percent string of the full
         * chart width, for example `40%`.
         *
         * Defaults to the full chart width for legends below or above the
         * chart, half the chart width for legends to the left and right.
         *
         * @sample {highcharts} highcharts/legend/width/
         *         Aligned to the plot area
         * @sample {highcharts} highcharts/legend/width-percent/
         *         A percent of the chart width
         *
         * @type      {number|string}
         * @since     2.0
         * @apioption legend.width
         */ /**
         * The pixel padding between the legend item symbol and the legend
         * item text.
         *
         * @sample {highcharts} highcharts/legend/symbolpadding/
         *         Greater symbol width and padding
         */ symbolPadding: 5,
        /**
         * The vertical alignment of the legend box. Can be one of `top`,
         * `middle` or `bottom`. Vertical position can be further determined
         * by the `y` option.
         *
         * In the case that the legend is aligned in a corner position, the
         * `layout` option will determine whether to place it above/below
         * or on the side of the plot area.
         *
         * When the [layout](#legend.layout) option is `proximate`, the
         * `verticalAlign` option doesn't apply.
         *
         * @sample {highcharts} highcharts/legend/verticalalign/
         *         Legend 100px from the top of the chart
         * @sample {highstock} stock/legend/align/
         *         Various legend options
         * @sample {highmaps} maps/legend/alignment/
         *         Legend alignment
         *
         * @type  {Highcharts.VerticalAlignValue}
         * @since 2.0
         */ verticalAlign: 'bottom',
        // Width: undefined,
        /**
         * The x offset of the legend relative to its horizontal alignment
         * `align` within chart.spacingLeft and chart.spacingRight. Negative
         * x moves it to the left, positive x moves it to the right.
         *
         * @sample {highcharts} highcharts/legend/width/
         *         Aligned to the plot area
         *
         * @since 2.0
         */ x: 0,
        /**
         * The vertical offset of the legend relative to it's vertical alignment
         * `verticalAlign` within chart.spacingTop and chart.spacingBottom.
         *  Negative y moves it up, positive y moves it down.
         *
         * @sample {highcharts} highcharts/legend/verticalalign/
         *         Legend 100px from the top of the chart
         * @sample {highstock} stock/legend/align/
         *         Various legend options
         * @sample {highmaps} maps/legend/alignment/
         *         Legend alignment
         *
         * @since 2.0
         */ y: 0,
        /**
         * A title to be added on top of the legend.
         *
         * @sample {highcharts} highcharts/legend/title/
         *         Legend title
         * @sample {highmaps} maps/legend/alignment/
         *         Legend with title
         *
         * @since 3.0
         */ title: {
            /**
             * A text or HTML string for the title.
             *
             * @type      {string}
             * @since     3.0
             * @apioption legend.title.text
             */ /**
             * Generic CSS styles for the legend title.
             *
             * @see In styled mode, the legend title is styled with the
             *      `.highcharts-legend-title` class.
             *
             * @type    {Highcharts.CSSObject}
             * @default {"fontSize": "0.8em", "fontWeight": "bold"}
             * @since   3.0
             */ style: {
                /**
                 * @ignore
                 */ color: "#333333" /* Palette.neutralColor80 */ ,
                /**
                 * @ignore
                 */ fontSize: '0.8em',
                /**
                 * @ignore
                 */ fontWeight: 'bold'
            }
        }
    },
    /**
     * The loading options control the appearance of the loading screen
     * that covers the plot area on chart operations. This screen only
     * appears after an explicit call to `chart.showLoading()`. It is a
     * utility for developers to communicate to the end user that something
     * is going on, for example while retrieving new data via an XHR connection.
     * The "Loading..." text itself is not part of this configuration
     * object, but part of the `lang` object.
     */ loading: {
        /**
         * The duration in milliseconds of the fade out effect.
         *
         * @sample highcharts/loading/hideduration/
         *         Fade in and out over a second
         *
         * @type      {number}
         * @default   100
         * @since     1.2.0
         * @apioption loading.hideDuration
         */ /**
         * The duration in milliseconds of the fade in effect.
         *
         * @sample highcharts/loading/hideduration/
         *         Fade in and out over a second
         *
         * @type      {number}
         * @default   100
         * @since     1.2.0
         * @apioption loading.showDuration
         */ /**
         * CSS styles for the loading label `span`.
         *
         * @see In styled mode, the loading label is styled with the
         *      `.highcharts-loading-inner` class.
         *
         * @sample {highcharts|highmaps} highcharts/loading/labelstyle/
         *         Vertically centered
         * @sample {highstock} stock/loading/general/
         *         Label styles
         *
         * @type    {Highcharts.CSSObject}
         * @default {"fontWeight": "bold", "position": "relative", "top": "45%"}
         * @since   1.2.0
         */ labelStyle: {
            /**
             * @ignore
             */ fontWeight: 'bold',
            /**
             * @ignore
             */ position: 'relative',
            /**
             * @ignore
             */ top: '45%'
        },
        /**
         * CSS styles for the loading screen that covers the plot area.
         *
         * In styled mode, the loading label is styled with the
         * `.highcharts-loading` class.
         *
         * @sample  {highcharts|highmaps} highcharts/loading/style/
         *          Gray plot area, white text
         * @sample  {highstock} stock/loading/general/
         *          Gray plot area, white text
         *
         * @type    {Highcharts.CSSObject}
         * @default {"position": "absolute", "backgroundColor": "#ffffff", "opacity": 0.5, "textAlign": "center"}
         * @since   1.2.0
         */ style: {
            /**
             * @ignore
             */ position: 'absolute',
            /**
             * @ignore
             */ backgroundColor: "#ffffff" /* Palette.backgroundColor */ ,
            /**
             * @ignore
             */ opacity: 0.5,
            /**
             * @ignore
             */ textAlign: 'center'
        }
    },
    /**
     * Options for the tooltip that appears when the user hovers over a
     * series or point.
     *
     * @declare Highcharts.TooltipOptions
     */ tooltip: {
        /**
         * The color of the tooltip border. When `undefined`, the border takes
         * the color of the corresponding series or point.
         *
         * Note that the [borderWidth](#tooltip.borderWidth) is usually 0 by
         * default, so the border color may not be visible until a border width
         * is set.
         *
         * @sample {highcharts} highcharts/tooltip/bordercolor-default/ Follow
         *         series by default
         * @sample {highcharts} highcharts/tooltip/bordercolor-black/ Black
         *         border
         * @sample {highstock} stock/tooltip/general/ Styled tooltip
         * @sample {highmaps} maps/tooltip/background-border/ Background and
         *         border demo
         *
         * @type {Highcharts.ColorString|Highcharts.GradientColorObject|Highcharts.PatternObject}
         * @apioption tooltip.borderColor
         */ /**
         * A CSS class name to apply to the tooltip's container div,
         * allowing unique CSS styling for each chart.
         *
         * @type      {string}
         * @apioption tooltip.className
         */ /**
         * Since 4.1, the crosshair definitions are moved to the Axis object
         * in order for a better separation from the tooltip. See
         * [xAxis.crosshair](#xAxis.crosshair).
         *
         * @sample {highcharts} highcharts/tooltip/crosshairs-x/
         *         Enable a crosshair for the x value
         *
         * @deprecated
         *
         * @type      {*}
         * @default   true
         * @apioption tooltip.crosshairs
         */ /**
         * Distance from point to tooltip in pixels.
         *
         * @type      {number}
         * @default   16
         * @apioption tooltip.distance
         */ /**
         * Whether the tooltip should be fixed to one position in the chart, or
         * located next to the point or mouse. When the tooltip is fixed, the
         * position can be further specified with the
         * [tooltip.position](#tooltip.position) options set.
         *
         * @sample    highcharts/tooltip/fixed/
         *            Fixed tooltip and position options
         * @sample    {highstock} stock/tooltip/fixed/
         *            Stock chart with fixed tooltip
         * @sample    {highmaps} maps/tooltip/fixed/
         *            Map with fixed tooltip
         *
         * @type      {boolean}
         * @default   false
         * @since 12.2.0
         * @apioption tooltip.fixed
         */ /**
         * Whether the tooltip should follow the mouse as it moves across
         * columns, pie slices and other point types with an extent.
         * By default it behaves this way for pie, polygon, map, sankey
         * and wordcloud series by override in the `plotOptions`
         * for those series types.
         *
         * Does not apply if [split](#tooltip.split) is `true`.
         *
         * For touch moves to behave the same way, [followTouchMove](
         * #tooltip.followTouchMove) must be `true` also.
         *
         * @sample highcharts/tooltip/followpointer/
         *         Tooltip follow pointer comparison
         *
         * @type      {boolean}
         * @default   {highcharts} false
         * @default   {highstock} false
         * @default   {highmaps} true
         * @since     3.0
         * @apioption tooltip.followPointer
         */ /**
         * Whether the tooltip should update as the finger moves on a touch
         * device. If this is `true` and [chart.panning](#chart.panning) is
         * set,`followTouchMove` will take over one-finger touches, so the user
         * needs to use two fingers for zooming and panning.
         *
         * Note the difference to [followPointer](#tooltip.followPointer) that
         * only defines the _position_ of the tooltip. If `followPointer` is
         * false in for example a column series, the tooltip will show above or
         * below the column, but as `followTouchMove` is true, the tooltip will
         * jump from column to column as the user swipes across the plot area.
         *
         * @type      {boolean}
         * @default   {highcharts} true
         * @default   {highstock} true
         * @default   {highmaps} false
         * @since     3.0.1
         * @apioption tooltip.followTouchMove
         */ /**
         * A [format string](https://www.highcharts.com/docs/chart-concepts/labels-and-string-formatting)
         * for the whole shared tooltip. When format strings are a requirement,
         * it is usually more convenient to use `headerFormat`, `pointFormat`
         * and `footerFormat`, but the `format` option allows combining them
         * into one setting.
         *
         * The context of the format string is the same as that of the
         * `tooltip.formatter` callback.
         *
         * @sample {highcharts} highcharts/tooltip/format-shared/
         *         Format for shared tooltip
         *
         * @type      {string}
         * @default   undefined
         * @since     11.1.0
         * @apioption tooltip.format
         */ /**
         * Callback function to format the text of the tooltip from scratch. In
         * case of single or [shared](#tooltip.shared) tooltips, a string should
         * be returned. In case of [split](#tooltip.split) tooltips, it should
         * return an array where the first item is the header, and subsequent
         * items are mapped to the points. Return `false` to disable tooltip for
         * a specific point on series.
         *
         * A subset of HTML is supported. Unless `useHTML` is true, the HTML of
         * the tooltip is parsed and converted to SVG, therefore this isn't a
         * complete HTML renderer. The following HTML tags are supported: `b`,
         * `br`, `em`, `i`, `span`, `strong`. Spans can be styled with a `style`
         * attribute, but only text-related CSS, that is shared with SVG, is
         * handled.
         *
         * The context of the formatter (since v12) is the
         * [Point](https://api.highcharts.com/class-reference/Highcharts.Point)
         * instance. If the tooltip is shared or split, an array `this.points`
         * contains all points of the hovered x-value.
         *
         * Common properties from the Point to use in the formatter include:
         *
         * - **Point.percentage**:
         *   Stacked series and pies only. The point's percentage of the total.
         *
         * - **Point.points**:
         *   In a shared or split tooltip, this is an array containing all the
         *   hovered points.
         *
         * - **this.series**:
         *   The series object. The series name is available through
         *   `this.series.name`.
         *
         * - **this.total**:
         *   The total value at this point's x value in a stacked series, or the
         *   sum of all slices in a pie series.
         *
         * - **this.x**:
         *   The x value.
         *
         * - **this.y**:
         *   The y value.
         *
         * @sample {highcharts} highcharts/tooltip/formatter-simple/
         *         Simple string formatting
         * @sample {highcharts} highcharts/tooltip/formatter-shared/
         *         Formatting with shared tooltip
         * @sample {highcharts|highstock} highcharts/tooltip/formatter-split/
         *         Formatting with split tooltip
         * @sample highcharts/tooltip/formatter-conditional-default/
         *         Extending default formatter
         * @sample {highstock} stock/tooltip/formatter/
         *         Formatting with shared tooltip
         * @sample {highmaps} maps/tooltip/formatter/
         *         String formatting
         *
         * @type      {Highcharts.TooltipFormatterCallbackFunction}
         * @apioption tooltip.formatter
         */ /**
         * Callback function to format the text of the tooltip for
         * visible null points.
         * Works analogously to [formatter](#tooltip.formatter).
         *
         * @sample highcharts/plotoptions/series-nullformat
         *         Format data label and tooltip for null point.
         *
         * @type      {Highcharts.TooltipFormatterCallbackFunction}
         * @apioption tooltip.nullFormatter
         */ /**
         * Whether to allow the tooltip to render outside the chart's SVG
         * element box. By default (`false`), the tooltip is rendered within the
         * chart's SVG element, which results in the tooltip being aligned
         * inside the chart area. For small charts, this may result in clipping
         * or overlapping. When `true`, a separate SVG element is created and
         * overlaid on the page, allowing the tooltip to be aligned inside the
         * page itself. Beware that with this option active, CSS classes on the
         * chart's target container, with classnames matching the pattern
         * 'highcharts-*', will be set on the tooltip as well. This is done to
         * support theming for tooltips with this option.
         *
         * Defaults to `true` if `chart.scrollablePlotArea` is activated,
         * otherwise `false`.
         *
         * @sample highcharts/tooltip/outside
         *         Small charts with tooltips outside
         *
         * @type      {boolean|undefined}
         * @default   undefined
         * @since     6.1.1
         * @apioption tooltip.outside
         */ /**
         * A callback function for formatting the HTML output for a single point
         * in the tooltip. Like the `pointFormat` string, but with more
         * flexibility.
         *
         * @type      {Highcharts.FormatterCallbackFunction<Highcharts.Point>}
         * @since     4.1.0
         * @context   Highcharts.Point
         * @apioption tooltip.pointFormatter
         */ /**
         * A callback function to place the tooltip in a custom position. The
         * callback receives three parameters: `labelWidth`, `labelHeight` and
         * `point`, where point contains values for `plotX` and `plotY` telling
         * where the reference point is in the plot area. Add `chart.plotLeft`
         * and `chart.plotTop` to get the full coordinates.
         *
         * To find the actual hovered `Point` instance, use
         * `this.chart.hoverPoint`. For shared or split tooltips, all the hover
         * points are available in `this.chart.hoverPoints`.
         *
         * Since v7, when [tooltip.split](#tooltip.split) option is enabled,
         * positioner is called for each of the boxes separately, including
         * xAxis header. xAxis header is not a point, instead `point` argument
         * contains info: `{ plotX: Number, plotY: Number, isHeader: Boolean }`
         *
         * Since v12.2, the [tooltip.fixed](#tooltip.fixed) option combined with
         * [tooltip.position](#tooltip.position) covers most of the use cases
         * for custom tooltip positioning.
         *
         * The return should be an object containing x and y values, for example
         * `{ x: 100, y: 100 }`.
         *
         * @sample {highcharts} highcharts/tooltip/positioner/
         *         A fixed tooltip position
         * @sample {highstock} stock/tooltip/positioner/
         *         A fixed tooltip position on top of the chart
         * @sample {highmaps} maps/tooltip/positioner/
         *         A fixed tooltip position
         * @sample {highstock} stock/tooltip/split-positioner/
         *         Split tooltip with fixed positions
         * @sample {highstock} stock/tooltip/positioner-scrollable-plotarea/
         *         Scrollable plot area combined with tooltip positioner
         *
         * @see [position](#tooltip.position)
         *
         * @type      {Highcharts.TooltipPositionerCallbackFunction}
         * @since     2.2.4
         * @apioption tooltip.positioner
         */ /**
         * Shows tooltip for all points with the same X value. Splits the
         * tooltip into one label per series, with the header close to the axis.
         * This is recommended over [shared](#tooltip.shared)
         * tooltips for charts with multiple line series, generally making them
         * easier to read. This option takes precedence over `tooltip.shared`.
         *
         * Not supported for [polar](#chart.polar) and [inverted](#chart.inverted) charts.
         *
         * @productdesc {highstock} In Highcharts Stock, tooltips are split
         * by default since v6.0.0. Stock charts typically contain
         * multi-dimension points and multiple panes, making split tooltips
         * the preferred layout over
         * the previous `shared` tooltip.
         *
         * @sample highcharts/tooltip/split/
         *         Split tooltip
         * @sample {highcharts|highstock} highcharts/tooltip/formatter-split/
         *         Split tooltip and custom formatter callback
         *
         * @type      {boolean}
         * @default   {highcharts} false
         * @default   {highstock} true
         * @since     5.0.0
         * @product   highcharts highstock
         * @apioption tooltip.split
         */ /**
         * Prevents the tooltip from switching or closing, when touched or
         * pointed.
         *
         * @sample highcharts/tooltip/stickoncontact/
         *         Tooltip sticks on pointer contact
         *
         * @type      {boolean}
         * @since     8.0.1
         * @apioption tooltip.stickOnContact
         */ /**
         * Use HTML to render the contents of the tooltip instead of SVG. Using
         * HTML allows advanced formatting like tables and images in the
         * tooltip. It is also recommended for rtl languages as it works around
         * rtl bugs in early Firefox.
         *
         * @sample {highcharts|highstock} highcharts/tooltip/footerformat/
         *         A table for value alignment
         * @sample {highcharts|highstock} highcharts/tooltip/fullhtml/
         *         Full HTML tooltip
         * @sample {highmaps} maps/tooltip/usehtml/
         *         Pure HTML tooltip
         *
         * @type      {boolean}
         * @default   false
         * @since     2.2
         * @apioption tooltip.useHTML
         */ /**
         * How many decimals to show in each series' y value. This is
         * overridable in each series' tooltip options object. The default is to
         * preserve all decimals.
         *
         * @sample {highcharts|highstock} highcharts/tooltip/valuedecimals/
         *         Set decimals, prefix and suffix for the value
         * @sample {highmaps} maps/tooltip/valuedecimals/
         *         Set decimals, prefix and suffix for the value
         *
         * @type      {number|undefined}
         * @since     2.2
         * @apioption tooltip.valueDecimals
         */ /**
         * A string to prepend to each series' y value. Overridable in each
         * series' tooltip options object.
         *
         * @sample {highcharts|highstock} highcharts/tooltip/valuedecimals/
         *         Set decimals, prefix and suffix for the value
         * @sample {highmaps} maps/tooltip/valuedecimals/
         *         Set decimals, prefix and suffix for the value
         *
         * @type      {string}
         * @since     2.2
         * @apioption tooltip.valuePrefix
         */ /**
         * A string to append to each series' y value. Overridable in each
         * series' tooltip options object.
         *
         * @sample {highcharts|highstock} highcharts/tooltip/valuedecimals/
         *         Set decimals, prefix and suffix for the value
         * @sample {highmaps} maps/tooltip/valuedecimals/
         *         Set decimals, prefix and suffix for the value
         *
         * @type      {string}
         * @since     2.2
         * @apioption tooltip.valueSuffix
         */ /**
         * The format for the date in the tooltip header if the X axis is a
         * datetime axis. The default is a best guess based on the smallest
         * distance between points in the chart.
         *
         * @sample {highcharts} highcharts/tooltip/xdateformat/
         *         A different format
         *
         * @type      {string|Highcharts.DateTimeFormatOptions}
         * @product   highcharts highstock gantt
         * @apioption tooltip.xDateFormat
         */ /**
         * How many decimals to show for the `point.change`
         * or the `point.cumulativeSum` value when the `series.compare`
         * or the `series.cumulative` option is set.
         * This is overridable in each series' tooltip options object.
         *
         * @type      {number}
         * @default   2
         * @since     1.0.1
         * @product   highstock
         * @apioption tooltip.changeDecimals
         */ /**
         * Enable or disable the tooltip.
         *
         * @sample {highcharts} highcharts/tooltip/enabled/
         *         Disabled
         * @sample {highcharts} highcharts/plotoptions/series-point-events-mouseover/
         *         Disable tooltip and show values on chart instead
         */ enabled: true,
        /**
         * Enable or disable animation of the tooltip.
         *
         * @type       {boolean|Partial<Highcharts.AnimationOptionsObject>}
         * @since      2.3.0
         */ animation: {
            duration: 300,
            // EaseOutCirc
            easing: (x)=>Math.sqrt(1 - Math.pow(x - 1, 2))
        },
        /**
         * The radius of the rounded border corners.
         *
         * @sample {highcharts} highcharts/tooltip/bordercolor-default/
         *         Default border radius
         * @sample {highcharts} highcharts/tooltip/borderradius-0/
         *         Square borders
         * @sample {highmaps} maps/tooltip/background-border/
         *         Background and border demo
         */ borderRadius: 3,
        /**
         * For series on datetime axes, the date format in the tooltip's
         * header will by default be guessed based on the closest data points.
         * This member gives the default string representations used for
         * each unit. For an overview of the string or object configuration, see
         * [dateFormat](/class-reference/Highcharts.Time#dateFormat).
         *
         * @see [xAxis.dateTimeLabelFormats](#xAxis.dateTimeLabelFormats)
         *
         * @type    {Highcharts.Dictionary<string|Highcharts.DateTimeFormatOptions>}
         * @product highcharts highstock gantt
         */ dateTimeLabelFormats: {
            /** @internal */ millisecond: '%[AebHMSL]',
            /** @internal */ second: '%[AebHMS]',
            /** @internal */ minute: '%[AebHM]',
            /** @internal */ hour: '%[AebHM]',
            /** @internal */ day: '%[AebY]',
            /** @internal */ week: '%v %[AebY]',
            /** @internal */ month: '%[BY]',
            /** @internal */ year: '%Y'
        },
        /**
         * A string to append to the tooltip format.
         *
         * @sample {highcharts} highcharts/tooltip/footerformat/
         *         A table for value alignment
         * @sample {highmaps} maps/tooltip/format/
         *         Format demo
         *
         * @since 2.2
         */ footerFormat: '',
        /**
         * The name of a symbol to use for the border around the tooltip
         * header. Applies only when [tooltip.split](#tooltip.split) is
         * enabled.
         *
         * Custom callbacks for symbol path generation can also be added to
         * `Highcharts.SVGRenderer.prototype.symbols` the same way as for
         * [series.marker.symbol](plotOptions.line.marker.symbol).
         *
         * @see [tooltip.shape](#tooltip.shape)
         *
         * @sample {highstock} stock/tooltip/split-positioner/
         *         Different shapes for header and split boxes
         *
         * @type       {Highcharts.TooltipShapeValue}
         * @validvalue ["callout", "rect"]
         * @since      7.0
         */ headerShape: 'callout',
        /**
         * The number of milliseconds to wait until the tooltip is hidden when
         * mouse out from a point or chart.
         *
         * @since 3.0
         */ hideDelay: 500,
        /**
         * Padding inside the tooltip, in pixels.
         *
         * @since 5.0.0
         */ padding: 8,
        /**
         * Positioning options for fixed tooltip, taking effect only when
         * [tooltip.fixed](#tooltip.fixed) is `true`.
         *
         * @sample {highcharts} highcharts/tooltip/fixed/
         *         Fixed tooltip and position options
         * @sample {highstock} stock/tooltip/fixed/
         *         Stock chart with fixed tooltip
         * @sample {highmaps} maps/tooltip/fixed/
         *         Map with fixed tooltip
         *
         * @since 12.2.0
         */ position: {
            /**
             * The horizontal alignment of the fixed tooltip.
             *
             * @sample highcharts/tooltip/fixed/
             *         Fixed tooltip
             * @sample {highstock} stock/tooltip/fixed/
             *         Stock chart with fixed tooltip
             *
             * @type {Highcharts.AlignValue}
             * @default left
             * @apioption tooltip.position.align
             */ /**
             * The vertical alignment of the fixed tooltip.
             *
             * @sample highcharts/tooltip/fixed/
             *         Fixed tooltip
             * @sample {highstock} stock/tooltip/fixed/
             *         Stock chart with fixed tooltip
             *
             * @type {Highcharts.VerticalAlignValue}
             * @default top
             * @apioption tooltip.position.verticalAlign
             */ /**
             * What the fixed tooltip alignment should be relative to.
             *
             * The default, `pane`, means that it is aligned within the plot
             * area for that given series. If the tooltip is split (as default
             * in Stock charts), each partial tooltip is aligned within the
             * series' pane.
             *
             * @sample highcharts/tooltip/fixed/
             *         Fixed tooltip
             * @sample {highstock} stock/tooltip/fixed/
             *         Stock chart with fixed tooltip
             *
             * @type {string}
             * @default pane
             * @validvalue ["pane", "chart", "plotBox", "spacingBox"]
             * @apioption tooltip.position.relativeTo
             */ /**
             * X pixel offset from the given position. Can be used to shy away
             * from axis lines, grid lines etc to avoid the tooltip overlapping
             * other elements.
             *
             * @sample highcharts/tooltip/fixed/
             *         Fixed tooltip
             * @sample {highstock} stock/tooltip/fixed/
             *         Stock chart with fixed tooltip
             */ x: 0,
            /**
             * Y pixel offset from the given position. Can be used to shy away
             * from axis lines, grid lines etc to avoid the tooltip overlapping
             * other elements.
             *
             * @sample highcharts/tooltip/fixed/
             *         Fixed tooltip
             * @sample {highstock} stock/tooltip/fixed/
             *         Stock chart with fixed tooltip
             */ y: 3
        },
        /**
         * The name of a symbol to use for the border around the tooltip. Can
         * be one of: `"callout"`, `"circle"` or `"rect"`. When
         * [tooltip.split](#tooltip.split)
         * option is enabled, shape is applied to all boxes except header, which
         * is controlled by
         * [tooltip.headerShape](#tooltip.headerShape).
         *
         * Custom callbacks for symbol path generation can also be added to
         * `Highcharts.SVGRenderer.prototype.symbols` the same way as for
         * [series.marker.symbol](plotOptions.line.marker.symbol).
         *
         * Defaults to `callout` for floating tooltip, `rect` for
         * [fixed](#tooltip.fixed) tooltip.
         *
         * @type  {Highcharts.TooltipShapeValue}
         * @since 4.0
         * @default undefined
         * @apioption tooltip.shape
         */ /**
         * Shows information in the tooltip for all points with the same X
         * value. When the tooltip is shared, the entire plot area will capture
         * mouse movement or touch events. Tooltip texts for series types with
         * ordered data (not pie, scatter, flags etc) will be shown in a single
         * bubble. This is recommended for single series charts and for
         * tablet/mobile optimized charts.
         *
         * See also [tooltip.split](#tooltip.split), that is better suited for
         * charts with many series, especially line-type series. The
         * `tooltip.split` option takes precedence over `tooltip.shared`.
         *
         * @sample {highcharts} highcharts/tooltip/shared-false/
         *         False by default
         * @sample {highcharts} highcharts/tooltip/shared-true/
         *         True
         * @sample {highcharts} highcharts/tooltip/shared-x-crosshair/
         *         True with x axis crosshair
         * @sample {highcharts} highcharts/tooltip/shared-true-mixed-types/
         *         True with mixed series types
         *
         * @since   2.1
         * @product highcharts highstock
         */ shared: false,
        /**
         * Proximity snap for graphs or single points. It defaults to 10 for
         * mouse-powered devices and 25 for touch devices.
         *
         * Note that in most cases the whole plot area captures the mouse
         * movement, and in these cases `tooltip.snap` doesn't make sense. This
         * applies when [stickyTracking](#plotOptions.series.stickyTracking)
         * is `true` (default) and when the tooltip is [shared](#tooltip.shared)
         * or [split](#tooltip.split).
         *
         * @sample {highcharts} highcharts/tooltip/bordercolor-default/
         *         10 px by default
         * @sample {highcharts} highcharts/tooltip/snap-50/
         *         50 px on graph
         *
         * @type    {number}
         * @default 10/25
         * @since   1.2.0
         * @product highcharts highstock
         */ snap: $28e60e23d058c899$var$isTouchDevice ? 25 : 10,
        /**
         * The HTML of the tooltip header line. The context is the
         * [Point class](https://api.highcharts.com/class-reference/Highcharts.Point).
         * Variables are enclosed in curly brackets. Examples of common
         * variables to include are `x`, `y`, `series.name` and `series.color`
         * and other properties on the same form. The `point.key` variable
         * contains the category name, x value or datetime string depending on
         * the type of axis. For datetime axes, the `point.key` date format can
         * be set using `tooltip.xDateFormat`.
         *
         * @sample {highcharts} highcharts/tooltip/footerformat/
         *         An HTML table in the tooltip
         * @sample {highstock} highcharts/tooltip/footerformat/
         *         An HTML table in the tooltip
         * @sample {highmaps} maps/tooltip/format/
         *         Format demo
         *
         * @type      {string}
         * @apioption tooltip.headerFormat
         */ headerFormat: '<span style="font-size: 0.8em">{ucfirst point.key}</span><br/>',
        /**
         * The HTML of the null point's line in the tooltip. Works analogously
         * to [pointFormat](#tooltip.pointFormat).
         *
         * @sample {highcharts} highcharts/series/null-interaction
         *         Line chart with null interaction
         * @sample {highcharts} highcharts/plotoptions/series-nullformat
         *         Heatmap with null interaction
         *
         * @type      {string}
         * @apioption tooltip.nullFormat
         */ /**
         * The HTML of the point's line in the tooltip. The context is the
         * [Point class](https://api.highcharts.com/class-reference/Highcharts.Point).
         * Variables are enclosed in curly brackets. Examples of common
         * variables to include are `x`, `y`, `series.name` and `series.color`
         * and other properties on the same form. Furthermore, `y` can be
         * extended by the `tooltip.valuePrefix` and `tooltip.valueSuffix`
         * variables. This can also be overridden for each series, which makes
         * it a good hook for displaying units.
         *
         * In styled mode, the dot is colored by a class name rather than the
         * point color.
         *
         * @sample {highcharts} highcharts/tooltip/pointformat/
         *         A different point format with value suffix
         * @sample {highcharts|highstock} highcharts/tooltip/pointformat-extra-information/
         *         Show extra information about points in the tooltip
         * @sample {highmaps} maps/tooltip/format/
         *         Format demo
         *
         * @type       {string}
         * @since      2.2
         * @apioption  tooltip.pointFormat
         */ pointFormat: '<span style="color:{point.color}">\u25CF</span> {series.name}: <b>{point.y}</b><br/>',
        /**
         * The background color or gradient for the tooltip.
         *
         * In styled mode, the stroke width is set in the
         * `.highcharts-tooltip-box` class.
         *
         * @sample {highcharts} highcharts/tooltip/backgroundcolor-solid/
         *         Yellowish background
         * @sample {highcharts} highcharts/tooltip/backgroundcolor-gradient/
         *         Gradient
         * @sample {highcharts} highcharts/css/tooltip-border-background/
         *         Tooltip in styled mode
         * @sample {highstock} stock/tooltip/general/
         *         Custom tooltip
         * @sample {highstock} highcharts/css/tooltip-border-background/
         *         Tooltip in styled mode
         * @sample {highmaps} maps/tooltip/background-border/
         *         Background and border demo
         * @sample {highmaps} highcharts/css/tooltip-border-background/
         *         Tooltip in styled mode
         *
         * @type {Highcharts.ColorString|Highcharts.GradientColorObject|Highcharts.PatternObject}
         */ backgroundColor: "#ffffff" /* Palette.backgroundColor */ ,
        /**
         * The pixel width of the tooltip border. Defaults to 0 for single
         * tooltips and fixed tooltips, otherwise 1 for split tooltips.
         *
         * In styled mode, the stroke width is set in the
         * `.highcharts-tooltip-box` class.
         *
         * @sample {highcharts} highcharts/tooltip/bordercolor-default/
         *         2 pixels
         * @sample {highcharts} highcharts/tooltip/borderwidth/
         *         No border (shadow only)
         * @sample {highcharts} highcharts/css/tooltip-border-background/
         *         Tooltip in styled mode
         * @sample {highstock} stock/tooltip/general/
         *         Custom tooltip
         * @sample {highstock} highcharts/css/tooltip-border-background/
         *         Tooltip in styled mode
         * @sample {highmaps} maps/tooltip/background-border/
         *         Background and border demo
         * @sample {highmaps} highcharts/css/tooltip-border-background/
         *         Tooltip in styled mode
         *
         * @type {number}
         */ borderWidth: void 0,
        /**
         * Whether to apply a drop shadow to the tooltip. Defaults to true,
         * unless the tooltip is [fixed](#tooltip.fixed).
         *
         * @sample {highcharts} highcharts/tooltip/bordercolor-default/
         *         True by default
         * @sample {highcharts} highcharts/tooltip/shadow/
         *         False
         * @sample {highmaps} maps/tooltip/positioner/
         *         Fixed tooltip position, border and shadow disabled
         *
         * @type {boolean|Highcharts.ShadowOptionsObject}
         * @default undefined
         * @apioption tooltip.shadow
         */ /**
         * Prevents the tooltip from switching or closing when touched or
         * pointed.
         *
         * @sample highcharts/tooltip/stickoncontact/
         *         Tooltip sticks on pointer contact
         *
         * @since 8.0.1
         */ stickOnContact: false,
        /**
         * CSS styles for the tooltip. The tooltip can also be styled through
         * the CSS class `.highcharts-tooltip`.
         *
         * Note that the default `pointerEvents` style makes the tooltip ignore
         * mouse events, so in order to use clickable tooltips, this value must
         * be set to `auto`.
         *
         * @sample {highcharts} highcharts/tooltip/style/
         *         Greater padding, bold text
         *
         * @type {Highcharts.CSSObject}
         */ style: {
            /** @internal */ color: "#333333" /* Palette.neutralColor80 */ ,
            /** @internal */ cursor: 'default',
            /**
             * @type {number|string}
             */ fontSize: '0.8em'
        },
        /**
         * Use HTML to render the contents of the tooltip instead of SVG. Using
         * HTML allows advanced formatting like tables and images in the
         * tooltip. It is also recommended for rtl languages as it works around
         * rtl bugs in early Firefox.
         *
         * @sample {highcharts|highstock} highcharts/tooltip/footerformat/
         *         A table for value alignment
         * @sample {highcharts|highstock} highcharts/tooltip/fullhtml/
         *         Full HTML tooltip
         * @sample {highmaps} maps/tooltip/usehtml/
         *         Pure HTML tooltip
         *
         * @since 2.2
         */ useHTML: false
    },
    /**
     * Highchart by default puts a credits label in the lower right corner
     * of the chart. This can be changed using these options.
     */ credits: {
        /**
         * Credits for map source to be concatenated with conventional credit
         * text. By default this is a format string that collects copyright
         * information from the map if available.
         *
         * @see [mapTextFull](#credits.mapTextFull)
         * @see [text](#credits.text)
         *
         * @type      {string}
         * @default   \u00a9 <a href="{geojson.copyrightUrl}">{geojson.copyrightShort}</a>
         * @since     4.2.2
         * @product   highmaps
         * @apioption credits.mapText
         */ /**
         * Detailed credits for map source to be displayed on hover of credits
         * text. By default this is a format string that collects copyright
         * information from the map if available.
         *
         * @see [mapText](#credits.mapText)
         * @see [text](#credits.text)
         *
         * @type      {string}
         * @default   {geojson.copyright}
         * @since     4.2.2
         * @product   highmaps
         * @apioption credits.mapTextFull
         */ /**
         * Whether to show the credits text.
         *
         * @sample {highcharts} highcharts/credits/enabled-false/
         *         Credits disabled
         * @sample {highstock} stock/credits/enabled/
         *         Credits disabled
         * @sample {highmaps} maps/credits/enabled-false/
         *         Credits disabled
         */ enabled: true,
        /**
         * The URL for the credits label.
         *
         * @sample {highcharts} highcharts/credits/href/
         *         Custom URL and text
         * @sample {highmaps} maps/credits/customized/
         *         Custom URL and text
         */ href: 'https://www.highcharts.com?credits',
        /**
         * Position configuration for the credits label.
         *
         * @sample {highcharts} highcharts/credits/position-left/
         *         Left aligned
         * @sample {highcharts} highcharts/credits/position-left/
         *         Left aligned
         * @sample {highmaps} maps/credits/customized/
         *         Left aligned
         * @sample {highmaps} maps/credits/customized/
         *         Left aligned
         *
         * @type    {Highcharts.AlignObject}
         * @since   2.1
         */ position: {
            /** @internal */ align: 'right',
            /** @internal */ x: -10,
            /** @internal */ verticalAlign: 'bottom',
            /** @internal */ y: -5
        },
        /**
         * CSS styles for the credits label.
         *
         * @see In styled mode, credits styles can be set with the
         *      `.highcharts-credits` class.
         *
         * @type {Highcharts.CSSObject}
         */ style: {
            /** @internal */ cursor: 'pointer',
            /** @internal */ color: "#999999" /* Palette.neutralColor40 */ ,
            /**
             * @type {number|string}
             */ fontSize: '0.6em'
        },
        /**
         * The text for the credits label.
         *
         * @productdesc {highmaps}
         * If a map is loaded as GeoJSON, the text defaults to
         * `Highcharts @ {map-credits}`. Otherwise, it defaults to
         * `Highcharts.com`.
         *
         * @sample {highcharts} highcharts/credits/href/
         *         Custom URL and text
         * @sample {highmaps} maps/credits/customized/
         *         Custom URL and text
         */ text: 'Highcharts.com'
    }
};
const $28e60e23d058c899$var$defaultTime = new (0, $a3xCS.default)($28e60e23d058c899$var$defaultOptions.time, $28e60e23d058c899$var$defaultOptions.lang);
/**
 * Get the updated default options. Until 3.0.7, merely exposing defaultOptions
 * for outside modules wasn't enough because the setOptions method created a new
 * object.
 *
 * @function Highcharts.getOptions
 *
 * @return {Highcharts.Options}
 * Default options.
 */ function $28e60e23d058c899$var$getOptions() {
    return $28e60e23d058c899$var$defaultOptions;
}
/**
 * Merge the default options with custom options and return the new options
 * structure. Commonly used for defining reusable templates.
 *
 * @sample highcharts/members/setoptions Applying a global theme
 *
 * @function Highcharts.setOptions
 *
 * @param {Highcharts.Options} options
 * The new custom chart options.
 *
 * @return {Highcharts.Options}
 * Updated options.
 */ function $28e60e23d058c899$var$setOptions(options) {
    $28e60e23d058c899$var$fireEvent((0, $30Vhv.default), 'setOptions', {
        options: options
    });
    // Copy in the default options
    $28e60e23d058c899$var$merge(true, $28e60e23d058c899$var$defaultOptions, options);
    // Update the time object
    if (options.time) $28e60e23d058c899$var$defaultTime.update($28e60e23d058c899$var$defaultOptions.time);
    if (options.lang && 'locale' in options.lang) $28e60e23d058c899$var$defaultTime.update({
        locale: options.lang.locale
    });
    if (options.lang?.chartTitle) $28e60e23d058c899$var$defaultOptions.title = {
        ...$28e60e23d058c899$var$defaultOptions.title,
        text: options.lang.chartTitle
    };
    return $28e60e23d058c899$var$defaultOptions;
}
/* *
 *
 *  Default Export
 *
 * */ const $28e60e23d058c899$var$DefaultOptions = {
    defaultOptions: $28e60e23d058c899$var$defaultOptions,
    defaultTime: $28e60e23d058c899$var$defaultTime,
    getOptions: $28e60e23d058c899$var$getOptions,
    setOptions: $28e60e23d058c899$var$setOptions
};
var $28e60e23d058c899$export$2e2bcd8739ae039 = $28e60e23d058c899$var$DefaultOptions;
/* *
 *
 *  API Declarations
 *
 * */ /**
 * @typedef {"plotBox"|"spacingBox"} Highcharts.ButtonRelativeToValue
 */ /**
 * Gets fired when a series is added to the chart after load time, using the
 * `addSeries` method. Returning `false` prevents the series from being added.
 *
 * @callback Highcharts.ChartAddSeriesCallbackFunction
 *
 * @param {Highcharts.Chart} this
 *        The chart on which the event occurred.
 *
 * @param {Highcharts.ChartAddSeriesEventObject} event
 *        The event that occurred.
 */ /**
 * Contains common event information. Through the `options` property you can
 * access the series options that were passed to the `addSeries` method.
 *
 * @interface Highcharts.ChartAddSeriesEventObject
 */ /**
* The series options that were passed to the `addSeries` method.
* @name Highcharts.ChartAddSeriesEventObject#options
* @type {Highcharts.SeriesOptionsType}
*/ /**
* Prevents the default behaviour of the event.
* @name Highcharts.ChartAddSeriesEventObject#preventDefault
* @type {Function}
*/ /**
* The event target.
* @name Highcharts.ChartAddSeriesEventObject#target
* @type {Highcharts.Chart}
*/ /**
* The event type.
* @name Highcharts.ChartAddSeriesEventObject#type
* @type {"addSeries"}
*/ /**
 * Gets fired when clicking on the plot background.
 *
 * @callback Highcharts.ChartClickCallbackFunction
 *
 * @param {Highcharts.Chart} this
 *        The chart on which the event occurred.
 *
 * @param {Highcharts.PointerEventObject} event
 *        The event that occurred.
 */ /**
 * Contains an axes of the clicked spot.
 *
 * @interface Highcharts.ChartClickEventAxisObject
 */ /**
* Axis at the clicked spot.
* @name Highcharts.ChartClickEventAxisObject#axis
* @type {Highcharts.Axis}
*/ /**
* Axis value at the clicked spot.
* @name Highcharts.ChartClickEventAxisObject#value
* @type {number}
*/ /**
 * Contains information about the clicked spot on the chart. Remember the unit
 * of a datetime axis is milliseconds since 1970-01-01 00:00:00.
 *
 * @interface Highcharts.ChartClickEventObject
 * @extends Highcharts.PointerEventObject
 */ /**
* Information about the x-axis on the clicked spot.
* @name Highcharts.ChartClickEventObject#xAxis
* @type {Array<Highcharts.ChartClickEventAxisObject>}
*/ /**
* Information about the y-axis on the clicked spot.
* @name Highcharts.ChartClickEventObject#yAxis
* @type {Array<Highcharts.ChartClickEventAxisObject>}
*/ /**
* Information about the z-axis on the clicked spot.
* @name Highcharts.ChartClickEventObject#zAxis
* @type {Array<Highcharts.ChartClickEventAxisObject>|undefined}
*/ /**
 * Gets fired when the chart is finished loading.
 *
 * @callback Highcharts.ChartLoadCallbackFunction
 *
 * @param {Highcharts.Chart} this
 *        The chart on which the event occurred.
 *
 * @param {global.Event} event
 *        The event that occurred.
 */ /**
 * Fires when the chart is redrawn, either after a call to `chart.redraw()` or
 * after an axis, series or point is modified with the `redraw` option set to
 * `true`.
 *
 * @callback Highcharts.ChartRedrawCallbackFunction
 *
 * @param {Highcharts.Chart} this
 *        The chart on which the event occurred.
 *
 * @param {global.Event} event
 *        The event that occurred.
 */ /**
 * Gets fired after initial load of the chart (directly after the `load` event),
 * and after each redraw (directly after the `redraw` event).
 *
 * @callback Highcharts.ChartRenderCallbackFunction
 *
 * @param {Highcharts.Chart} this
 *        The chart on which the event occurred.
 *
 * @param {global.Event} event
 *        The event that occurred.
 */ /**
 * Gets fired when an area of the chart has been selected. The default action
 * for the selection event is to zoom the chart to the selected area. It can be
 * prevented by calling `event.preventDefault()` or return false.
 *
 * @callback Highcharts.ChartSelectionCallbackFunction
 *
 * @param {Highcharts.Chart} this
 *        The chart on which the event occurred.
 *
 * @param {Highcharts.SelectEventObject} event
 *        Event informations
 *
 * @return {boolean|undefined}
 *         Return false to prevent the default action, usually zoom.
 */ ''; // Detach doclets above

});
parcelRegister("h63sD", function(module, exports) {

$parcel$export(module.exports, "default", () => $c725ae796117313a$export$2e2bcd8739ae039);
/* *
 *
 *  (c) 2010-2025 Torstein Honsi
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 * */ 'use strict';
/* *
 *
 *  API Options
 *
 * */ /**
 * General options for the chart.
 *
 * @optionparent chart
 */ const $c725ae796117313a$var$ChartDefaults = {
    /**
     * Default `mapData` for all series, in terms of a GeoJSON or TopoJSON
     * object. If set to a string, it functions as an index into the
     * `Highcharts.maps` array.
     *
     * For picking out individual shapes and geometries to use for each series
     * of the map, see [series.mapData](#series.map.mapData).
     *
     * @sample    maps/demo/geojson
     *            Loading GeoJSON data
     * @sample    maps/chart/topojson
     *            Loading TopoJSON data
     *
     * @type      {string|Array<*>|Highcharts.GeoJSON|Highcharts.TopoJSON}
     * @since     5.0.0
     * @product   highmaps
     * @apioption chart.map
     */ /**
     * Set lat/lon transformation definitions for the chart. If not defined,
     * these are extracted from the map data.
     *
     * @type      {*}
     * @since     5.0.0
     * @product   highmaps
     * @apioption chart.mapTransforms
     */ /**
     * When using multiple axes, the ticks of two or more opposite axes
     * will automatically be aligned by adding ticks to the axis or axes
     * with the least ticks, as if `tickAmount` were specified.
     *
     * This can be prevented by setting `alignTicks` to false. If the grid
     * lines look messy, it's a good idea to hide them for the secondary
     * axis by setting `gridLineWidth` to 0.
     *
     * If `startOnTick` or `endOnTick` in the axis options are set to false,
     * then the `alignTicks ` will be disabled for the axis.
     *
     * Disabled for logarithmic axes.
     *
     * @sample {highcharts} highcharts/chart/alignticks-true/
     *         True by default
     * @sample {highcharts} highcharts/chart/alignticks-false/
     *         False
     * @sample {highstock} stock/chart/alignticks-true/
     *         True by default
     * @sample {highstock} stock/chart/alignticks-false/
     *         False
     *
     * @type      {boolean}
     * @default   true
     * @product   highcharts highstock gantt
     * @apioption chart.alignTicks
     */ /**
     * When using multiple axes, align the thresholds. When this is true, other
     * ticks will also be aligned.
     *
     * Note that for line series and some other series types, the `threshold`
     * option is set to `null` by default. This will in turn cause their y-axis
     * to not have a threshold. In order to avoid that, set the series
     * `threshold` to 0 or another number.
     *
     * If `startOnTick` or `endOnTick` in the axis options are set to false, or
     * if the axis is logarithmic, the threshold will not be aligned.
     *
     * @sample {highcharts} highcharts/chart/alignthresholds/ Set to true
     *
     * @since 10.0.0
     * @product   highcharts highstock gantt
     * @apioption chart.alignThresholds
     */ alignThresholds: false,
    /**
     * Set the overall animation for all chart updating. Animation can be
     * disabled throughout the chart by setting it to false here. It can
     * be overridden for each individual API method as a function parameter.
     * The only animation not affected by this option is the initial series
     * animation, see [plotOptions.series.animation](
     * #plotOptions.series.animation).
     *
     * The animation can either be set as a boolean or a configuration
     * object. If `true`, it will use the 'swing' jQuery easing and a
     * duration of 500 ms. If used as a configuration object, the following
     * properties are supported:
     *
     * - `defer`: The animation delay time in milliseconds.
     *
     * - `duration`: The duration of the animation in milliseconds.
     *
     * - `easing`: A string reference to an easing function set on the
     *   `Math` object. See
     *   [the easing demo](https://jsfiddle.net/gh/get/library/pure/highcharts/highcharts/tree/master/samples/highcharts/plotoptions/series-animation-easing/).
     *
     * When zooming on a series with less than 100 points, the chart redraw
     * will be done with animation, but in case of more data points, it is
     * necessary to set this option to ensure animation on zoom.
     *
     * @sample {highcharts} highcharts/chart/animation-none/
     *         Updating with no animation
     * @sample {highcharts} highcharts/chart/animation-duration/
     *         With a longer duration
     * @sample {highcharts} highcharts/chart/animation-easing/
     *         With a jQuery UI easing
     * @sample {highmaps} maps/chart/animation-none/
     *         Updating with no animation
     * @sample {highmaps} maps/chart/animation-duration/
     *         With a longer duration
     *
     * @type      {boolean|Partial<Highcharts.AnimationOptionsObject>}
     * @default   true
     * @apioption chart.animation
     */ /**
     * A CSS class name to apply to the charts container `div`, allowing
     * unique CSS styling for each chart.
     *
     * @type      {string}
     * @apioption chart.className
     */ /**
     * Event listeners for the chart.
     *
     * @apioption chart.events
     */ /**
     * Fires when a series is added to the chart after load time, using the
     * `addSeries` method. One parameter, `event`, is passed to the
     * function, containing common event information. Through
     * `event.options` you can access the series options that were passed to
     * the `addSeries` method. Returning false prevents the series from
     * being added.
     *
     * @sample {highcharts} highcharts/chart/events-addseries/
     *         Alert on add series
     * @sample {highstock} stock/chart/events-addseries/
     *         Alert on add series
     *
     * @type      {Highcharts.ChartAddSeriesCallbackFunction}
     * @since     1.2.0
     * @context   Highcharts.Chart
     * @apioption chart.events.addSeries
     */ /**
     * Fires when clicking on the plot background. One parameter, `event`,
     * is passed to the function, containing common event information.
     *
     * Information on the clicked spot can be found through `event.xAxis`
     * and `event.yAxis`, which are arrays containing the axes of each
     * dimension and each axis' value at the clicked spot. The primary axes
     * are `event.xAxis[0]` and `event.yAxis[0]`. Remember the unit of a
     * datetime axis is milliseconds since 1970-01-01 00:00:00.
     *
     * ```js
     * click: function(e) {
     *     console.log(
     *         Highcharts.dateFormat('%Y-%m-%d %H:%M:%S', e.xAxis[0].value),
     *         e.yAxis[0].value
     *     )
     * }
     * ```
     *
     * @sample {highcharts} highcharts/chart/events-click/
     *         Alert coordinates on click
     * @sample {highcharts} highcharts/chart/events-container/
     *         Alternatively, attach event to container
     * @sample {highstock} stock/chart/events-click/
     *         Alert coordinates on click
     * @sample {highstock} highcharts/chart/events-container/
     *         Alternatively, attach event to container
     * @sample {highmaps} maps/chart/events-click/
     *         Record coordinates on click
     * @sample {highmaps} highcharts/chart/events-container/
     *         Alternatively, attach event to container
     *
     * @type      {Highcharts.ChartClickCallbackFunction}
     * @since     1.2.0
     * @context   Highcharts.Chart
     * @apioption chart.events.click
     */ /**
     * Fires when the chart is finished loading. Since v4.2.2, it also waits
     * for images to be loaded, for example from point markers. One
     * parameter, `event`, is passed to the function, containing common
     * event information.
     *
     * There is also a second parameter to the chart constructor where a
     * callback function can be passed to be executed on chart.load.
     *
     * @sample {highcharts} highcharts/chart/events-load/
     *         Alert on chart load
     * @sample {highcharts} highcharts/chart/events-render/
     *         Load vs Redraw vs Render
     * @sample {highstock} stock/chart/events-load/
     *         Alert on chart load
     * @sample {highmaps} maps/chart/events-load/
     *         Add series on chart load
     *
     * @type      {Highcharts.ChartLoadCallbackFunction}
     * @context   Highcharts.Chart
     * @apioption chart.events.load
     */ /**
     * Fires when the chart is redrawn, either after a call to
     * `chart.redraw()` or after an axis, series or point is modified with
     * the `redraw` option set to `true`. One parameter, `event`, is passed
     * to the function, containing common event information.
     *
     * @sample {highcharts} highcharts/chart/events-redraw/
     *         Alert on chart redraw
     * @sample {highcharts} highcharts/chart/events-render/
     *         Load vs Redraw vs Render
     * @sample {highstock} stock/chart/events-redraw/
     *         Alert on chart redraw when adding a series or moving the
     *         zoomed range
     * @sample {highmaps} maps/chart/events-redraw/
     *         Set subtitle on chart redraw
     *
     * @type      {Highcharts.ChartRedrawCallbackFunction}
     * @since     1.2.0
     * @context   Highcharts.Chart
     * @apioption chart.events.redraw
     */ /**
     * Fires after initial load of the chart (directly after the `load`
     * event), and after each redraw (directly after the `redraw` event).
     *
     * @sample {highcharts} highcharts/chart/events-render/
     *         Load vs Redraw vs Render
     *
     * @type      {Highcharts.ChartRenderCallbackFunction}
     * @since     5.0.7
     * @context   Highcharts.Chart
     * @apioption chart.events.render
     */ /**
     * Fires when an area of the chart has been selected. Selection is
     * enabled by setting the chart's zoomType. One parameter, `event`, is
     * passed to the function, containing common event information. The
     * default action for the selection event is to zoom the chart to the
     * selected area. It can be prevented by calling
     * `event.preventDefault()` or return false.
     *
     * Information on the selected area can be found through `event.xAxis`
     * and `event.yAxis`, which are arrays containing the axes of each
     * dimension and each axis' min and max values. The primary axes are
     * `event.xAxis[0]` and `event.yAxis[0]`. Remember the unit of a
     * datetime axis is milliseconds since 1970-01-01 00:00:00.
     *
     * ```js
     * selection: function(event) {
     *     // log the min and max of the primary, datetime x-axis
     *     console.log(
     *         Highcharts.dateFormat(
     *             '%Y-%m-%d %H:%M:%S',
     *             event.xAxis[0].min
     *         ),
     *         Highcharts.dateFormat(
     *             '%Y-%m-%d %H:%M:%S',
     *             event.xAxis[0].max
     *         )
     *     );
     *     // log the min and max of the y axis
     *     console.log(event.yAxis[0].min, event.yAxis[0].max);
     * }
     * ```
     *
     * @sample {highcharts} highcharts/chart/events-selection/
     *         Report on selection and reset
     * @sample {highcharts} highcharts/chart/events-selection-points/
     *         Select a range of points through a drag selection
     * @sample {highstock} stock/chart/events-selection/
     *         Report on selection and reset
     * @sample {highstock} highcharts/chart/events-selection-points/
     *         Select a range of points through a drag selection
     *         (Highcharts)
     *
     * @type      {Highcharts.ChartSelectionCallbackFunction}
     * @apioption chart.events.selection
     */ /**
     * The margin between the outer edge of the chart and the plot area.
     * The numbers in the array designate top, right, bottom and left
     * respectively. Use the options `marginTop`, `marginRight`,
     * `marginBottom` and `marginLeft` for shorthand setting of one option.
     *
     * By default there is no margin. The actual space is dynamically
     * calculated from the offset of axis labels, axis title, title,
     * subtitle and legend in addition to the `spacingTop`, `spacingRight`,
     * `spacingBottom` and `spacingLeft` options.
     *
     * @sample {highcharts} highcharts/chart/margins-zero/
     *         Zero margins
     * @sample {highstock} stock/chart/margin-zero/
     *         Zero margins
     *
     * @type      {number|Array<number>}
     * @apioption chart.margin
     */ /**
     * The margin between the bottom outer edge of the chart and the plot
     * area. Use this to set a fixed pixel value for the margin as opposed
     * to the default dynamic margin. See also `spacingBottom`.
     *
     * @sample {highcharts} highcharts/chart/marginbottom/
     *         100px bottom margin
     * @sample {highstock} stock/chart/marginbottom/
     *         100px bottom margin
     * @sample {highmaps} maps/chart/margin/
     *         100px margins
     *
     * @type      {number}
     * @since     2.0
     * @apioption chart.marginBottom
     */ /**
     * The margin between the left outer edge of the chart and the plot
     * area. Use this to set a fixed pixel value for the margin as opposed
     * to the default dynamic margin. See also `spacingLeft`.
     *
     * @sample {highcharts} highcharts/chart/marginleft/
     *         150px left margin
     * @sample {highstock} stock/chart/marginleft/
     *         150px left margin
     * @sample {highmaps} maps/chart/margin/
     *         100px margins
     *
     * @type      {number}
     * @since     2.0
     * @apioption chart.marginLeft
     */ /**
     * The margin between the right outer edge of the chart and the plot
     * area. Use this to set a fixed pixel value for the margin as opposed
     * to the default dynamic margin. See also `spacingRight`.
     *
     * @sample {highcharts} highcharts/chart/marginright/
     *         100px right margin
     * @sample {highstock} stock/chart/marginright/
     *         100px right margin
     * @sample {highmaps} maps/chart/margin/
     *         100px margins
     *
     * @type      {number}
     * @since     2.0
     * @apioption chart.marginRight
     */ /**
     * The margin between the top outer edge of the chart and the plot area.
     * Use this to set a fixed pixel value for the margin as opposed to
     * the default dynamic margin. See also `spacingTop`.
     *
     * @sample {highcharts} highcharts/chart/margintop/ 100px top margin
     * @sample {highstock} stock/chart/margintop/
     *         100px top margin
     * @sample {highmaps} maps/chart/margin/
     *         100px margins
     *
     * @type      {number}
     * @since     2.0
     * @apioption chart.marginTop
     */ /**
     * Callback function to override the default function that formats all
     * the numbers in the chart. Returns a string with the formatted number.
     *
     * @sample highcharts/members/highcharts-numberformat
     *      Arabic digits in Highcharts
     * @type {Highcharts.NumberFormatterCallbackFunction}
     * @since 8.0.0
     * @apioption chart.numberFormatter
     */ /**
     * When a chart with an x and a y-axis is rendered, we first pre-render the
     * labels of both in order to measure them. Then, if either of the axis
     * labels take up so much space that it significantly affects the length of
     * the other axis, we repeat the process.
     *
     * By default we stop at two axis layout runs, but it may be that the second
     * run also alter the space required by either axis, for example if it
     * causes the labels to rotate. In this situation, a subsequent redraw of
     * the chart may cause the tick and label placement to change for apparently
     * no reason.
     *
     * Use the `axisLayoutRuns` option to set the maximum allowed number of
     * repetitions. But keep in mind that the default value of 2 is set because
     * every run costs performance time.
     *
     * **Note:** Changing that option to higher than the default might decrease
     * performance significantly, especially with bigger sets of data.
     *
     * @type      {number}
     * @default   2
     * @since     11.3.0
     * @apioption chart.axisLayoutRuns
     */ /**
     * Allows setting a key to switch between zooming and panning. Can be
     * one of `alt`, `ctrl`, `meta` (the command key on Mac and Windows
     * key on Windows) or `shift`. The keys are mapped directly to the key
     * properties of the click event argument (`event.altKey`,
     * `event.ctrlKey`, `event.metaKey` and `event.shiftKey`).
     *
     * @type       {string}
     * @since      4.0.3
     * @product    highcharts gantt
     * @validvalue ["alt", "ctrl", "meta", "shift"]
     * @apioption  chart.panKey
     */ /**
     * Allow panning in a chart. Best used with [panKey](#chart.panKey)
     * to combine zooming and panning.
     *
     * On touch devices, when the [tooltip.followTouchMove](
     * #tooltip.followTouchMove) option is `true` (default), panning
     * requires two fingers. To allow panning with one finger, set
     * `followTouchMove` to `false`.
     *
     * @sample  {highcharts} highcharts/chart/pankey/ Zooming and panning
     * @sample  {highstock} stock/chart/panning/ Zooming and xy panning
     */ panning: {
        /**
         * Enable or disable chart panning.
         *
         * @type      {boolean}
         * @default   {highcharts} false
         * @default   {highstock|highmaps} true
         */ enabled: false,
        /**
         * Decides in what dimensions the user can pan the chart. Can be
         * one of `x`, `y`, or `xy`.
         *
         * During panning, all axes will behave as if
         * [`startOnTick`](#yAxis.startOnTick) and
         * [`endOnTick`](#yAxis.endOnTick) were set to `false`. After the
         * panning action is finished, the axes will adjust to their actual
         * settings.
         *
         * **Note:** For non-cartesian series, the only supported panning type
         * is `xy`, as zooming in a single direction is not applicable due to
         * the radial nature of the coordinate system.
         *
         * @sample {highcharts} highcharts/chart/panning-type
         *         Zooming and xy panning
         *
         * @declare    Highcharts.OptionsChartPanningTypeValue
         * @type       {string}
         * @validvalue ["x", "y", "xy"]
         * @product    highcharts highstock gantt
         */ type: 'x'
    },
    /**
     * Equivalent to [zoomType](#chart.zoomType), but for multitouch
     * gestures only. By default, the `pinchType` is the same as the
     * `zoomType` setting. However, pinching can be enabled separately in
     * some cases, for example in stock charts where a mouse drag pans the
     * chart, while pinching is enabled. When [tooltip.followTouchMove](
     * #tooltip.followTouchMove) is true, pinchType only applies to
     * two-finger touches.
     *
     * @type       {string}
     * @default    {highcharts} undefined
     * @default    {highstock} undefined
     * @since      3.0
     * @product    highcharts highstock gantt
     * @deprecated
     * @validvalue ["x", "y", "xy"]
     * @apioption  chart.pinchType
     */ /**
     * Whether to apply styled mode. When in styled mode, no presentational
     * attributes or CSS are applied to the chart SVG. Instead, CSS rules
     * are required to style the chart. The default style sheet is
     * available from `https://code.highcharts.com/css/highcharts.css`.
     *
     * [Read more in the docs](https://www.highcharts.com/docs/chart-design-and-style/style-by-css)
     * on what classes and variables are available.
     *
     * @sample highcharts/css/colors
     *         Color theming with CSS
     * @sample highcharts/css/prefers-color-scheme
     *         Dynamic theme based on system settings
     * @type       {boolean}
     * @default    false
     * @since      7.0
     * @apioption  chart.styledMode
     */ styledMode: false,
    /**
     * The corner radius of the outer chart border.
     *
     * @sample {highcharts} highcharts/chart/borderradius/
     *         20px radius
     * @sample {highstock} stock/chart/border/
     *         10px radius
     * @sample {highmaps} maps/chart/border/
     *         Border options
     *
     */ borderRadius: 0,
    /**
     * In styled mode, this sets how many colors the class names
     * should rotate between. With ten colors, series (or points) are
     * given class names like `highcharts-color-0`, `highcharts-color-1`
     * [...] `highcharts-color-9`. The equivalent in non-styled mode
     * is to set colors using the [colors](#colors) setting.
     *
     * @since      5.0.0
     */ colorCount: 10,
    /**
     * By default, (because of memory and performance reasons) the chart does
     * not copy the data but keeps it as a reference. In some cases, this might
     * result in mutating the original data source. In order to prevent that,
     * set that property to false. Please note that changing that might decrease
     * performance, especially with bigger sets of data.
     *
     * @type       {boolean}
     * @since 10.1.0
     */ allowMutatingData: true,
    /**
     * If true, the axes will scale to the remaining visible series once
     * one series is hidden. If false, hiding and showing a series will
     * not affect the axes or the other series. For stacks, once one series
     * within the stack is hidden, the rest of the stack will close in
     * around it even if the axis is not affected.
     *
     * @sample {highcharts} highcharts/chart/ignorehiddenseries-true/
     *         True by default
     * @sample {highcharts} highcharts/chart/ignorehiddenseries-false/
     *         False
     * @sample {highcharts} highcharts/chart/ignorehiddenseries-true-stacked/
     *         True with stack
     * @sample {highstock} stock/chart/ignorehiddenseries-true/
     *         True by default
     * @sample {highstock} stock/chart/ignorehiddenseries-false/
     *         False
     *
     * @since   1.2.0
     * @product highcharts highstock gantt
     */ ignoreHiddenSeries: true,
    /**
     * Whether to invert the axes so that the x axis is vertical and y axis
     * is horizontal. When `true`, the x axis is [reversed](#xAxis.reversed)
     * by default.
     *
     * @productdesc {highcharts}
     * If a bar series is present in the chart, it will be inverted
     * automatically. Inverting the chart doesn't have an effect if there
     * are no cartesian series in the chart.
     *
     * @sample {highcharts} highcharts/chart/inverted/
     *         Inverted line
     * @sample {highstock} stock/navigator/inverted/
     *         Inverted stock chart
     *
     * @type      {boolean}
     * @default   false
     * @product   highcharts highstock gantt
     * @apioption chart.inverted
     */ /**
     * The distance between the outer edge of the chart and the content,
     * like title or legend, or axis title and labels if present. The
     * numbers in the array designate top, right, bottom and left
     * respectively. Use the options spacingTop, spacingRight, spacingBottom
     * and spacingLeft options for shorthand setting of one option.
     *
     * @type    {Array<number>}
     * @see     [chart.margin](#chart.margin)
     * @default [10, 10, 15, 10]
     * @since   3.0.6
     */ spacing: [
        10,
        10,
        15,
        10
    ],
    /**
     * The button that appears after a selection zoom, allowing the user
     * to reset zoom. This option is deprecated in favor of
     * [zooming](#chart.zooming).
     *
     * @since      2.2
     * @deprecated 10.2.1
     */ resetZoomButton: {
        /**
         * What frame the button placement should be related to. Can be
         * either `plotBox` or `spacingBox`.
         *
         * @sample {highcharts} highcharts/chart/resetzoombutton-relativeto/
         *         Relative to the chart
         * @sample {highstock} highcharts/chart/resetzoombutton-relativeto/
         *         Relative to the chart
         *
         * @type      {Highcharts.ButtonRelativeToValue}
         * @apioption chart.resetZoomButton.relativeTo
         */ /**
         * A collection of attributes for the button. The object takes SVG
         * attributes like `fill`, `stroke`, `stroke-width` or `r`, the
         * border radius. The theme also supports `style`, a collection of
         * CSS properties for the text. Equivalent attributes for the hover
         * state are given in `theme.states.hover`.
         *
         * @sample {highcharts} highcharts/chart/resetzoombutton-theme/
         *         Theming the button
         * @sample {highstock} highcharts/chart/resetzoombutton-theme/
         *         Theming the button
         *
         * @type {Highcharts.SVGAttributes}
         */ theme: {
        },
        /**
         * The position of the button.
         *
         * @sample {highcharts} highcharts/chart/resetzoombutton-position/
         *         Above the plot area
         * @sample {highstock} highcharts/chart/resetzoombutton-position/
         *         Above the plot area
         * @sample {highmaps} highcharts/chart/resetzoombutton-position/
         *         Above the plot area
         *
         * @type {Highcharts.AlignObject}
         */ position: {
        }
    },
    /**
     * The pixel width of the plot area border.
     *
     * @sample {highcharts} highcharts/chart/plotborderwidth/
     *         1px border
     * @sample {highstock} stock/chart/plotborder/
     *         2px border
     * @sample {highmaps} maps/chart/plotborder/
     *         Plot border options
     *
     * @type      {number}
     * @default   0
     * @apioption chart.plotBorderWidth
     */ /**
     * Whether to apply a drop shadow to the plot area. Requires that
     * plotBackgroundColor be set. The shadow can be an object configuration
     * containing `color`, `offsetX`, `offsetY`, `opacity` and `width`.
     *
     * @sample {highcharts} highcharts/chart/plotshadow/
     *         Plot shadow
     * @sample {highstock} stock/chart/plotshadow/
     *         Plot shadow
     * @sample {highmaps} maps/chart/plotborder/
     *         Plot border options
     *
     * @type      {boolean|Highcharts.ShadowOptionsObject}
     * @default   false
     * @apioption chart.plotShadow
     */ /**
     * When true, cartesian charts like line, spline, area and column are
     * transformed into the polar coordinate system. This produces _polar
     * charts_, also known as _radar charts_.
     *
     * @sample {highcharts} highcharts/demo/polar/
     *         Polar chart
     * @sample {highcharts} highcharts/demo/polar-wind-rose/
     *         Wind rose, stacked polar column chart
     * @sample {highcharts} highcharts/demo/polar-spider/
     *         Spider web chart
     * @sample {highcharts} highcharts/parallel-coordinates/polar/
     *         Star plot, multivariate data in a polar chart
     *
     * @type      {boolean}
     * @default   false
     * @since     2.3.0
     * @product   highcharts
     * @requires  highcharts-more
     * @apioption chart.polar
     */ /**
     * Whether to reflow the chart to fit the width of the container div
     * on resizing the window.
     *
     * @sample {highcharts} highcharts/chart/reflow-true/
     *         True by default
     * @sample {highcharts} highcharts/chart/reflow-false/
     *         False
     * @sample {highstock} stock/chart/reflow-true/
     *         True by default
     * @sample {highstock} stock/chart/reflow-false/
     *         False
     * @sample {highmaps} maps/chart/reflow-true/
     *         True by default
     * @sample {highmaps} maps/chart/reflow-false/
     *         False
     *
     * @since     2.1
     */ reflow: true,
    /**
     * The HTML element where the chart will be rendered. If it is a string,
     * the element by that id is used. The HTML element can also be passed
     * by direct reference, or as the first argument of the chart
     * constructor, in which case the option is not needed.
     *
     * @sample {highcharts} highcharts/chart/reflow-true/
     *         String
     * @sample {highcharts} highcharts/chart/renderto-object/
     *         Object reference
     * @sample {highstock} stock/chart/renderto-string/
     *         String
     * @sample {highstock} stock/chart/renderto-object/
     *         Object reference
     *
     * @type      {string|Highcharts.HTMLDOMElement}
     * @apioption chart.renderTo
     */ /**
     * The background color of the marker square when selecting (zooming
     * in on) an area of the chart.
     *
     * @see In styled mode, the selection marker fill is set with the
     *      `.highcharts-selection-marker` class.
     *
     * @type      {Highcharts.ColorString|Highcharts.GradientColorObject|Highcharts.PatternObject}
     * @default   rgba(51,92,173,0.25)
     * @since     2.1.7
     * @apioption chart.selectionMarkerFill
     */ /**
     * Whether to apply a drop shadow to the global series group. This causes
     * all the series to have the same shadow. Contrary to the `series.shadow`
     * option, this prevents items from casting shadows on each other, like for
     * others series in a stack. The shadow can be an object configuration
     * containing `color`, `offsetX`, `offsetY`, `opacity` and `width`.
     *
     * @sample highcharts/chart/seriesgroupshadow/
     *         Shadow
     *
     * @type      {boolean|Highcharts.ShadowOptionsObject}
     * @default   false
     * @apioption chart.seriesGroupShadow
     */ /**
     * Whether to apply a drop shadow to the outer chart area. Requires
     * that backgroundColor be set. The shadow can be an object
     * configuration containing `color`, `offsetX`, `offsetY`, `opacity` and
     * `width`.
     *
     * @sample {highcharts} highcharts/chart/shadow/
     *         Shadow
     * @sample {highstock} stock/chart/shadow/
     *         Shadow
     * @sample {highmaps} maps/chart/border/
     *         Chart border and shadow
     *
     * @type      {boolean|Highcharts.ShadowOptionsObject}
     * @default   false
     * @apioption chart.shadow
     */ /**
     * Whether to show the axes initially. This only applies to empty charts
     * where series are added dynamically, as axes are automatically added
     * to cartesian series.
     *
     * @sample {highcharts} highcharts/chart/showaxes-false/
     *         False by default
     * @sample {highcharts} highcharts/chart/showaxes-true/
     *         True
     *
     * @type      {boolean}
     * @since     1.2.5
     * @product   highcharts gantt
     * @apioption chart.showAxes
     */ /**
     * The space between the bottom edge of the chart and the content (plot
     * area, axis title and labels, title, subtitle or legend in top
     * position).
     *
     * @sample {highcharts} highcharts/chart/spacingbottom/
     *         Spacing bottom set to 100
     * @sample {highstock} stock/chart/spacingbottom/
     *         Spacing bottom set to 100
     * @sample {highmaps} maps/chart/spacing/
     *         Spacing 100 all around
     *
     * @type      {number}
     * @default   15
     * @since     2.1
     * @apioption chart.spacingBottom
     */ /**
     * The space between the left edge of the chart and the content (plot
     * area, axis title and labels, title, subtitle or legend in top
     * position).
     *
     * @sample {highcharts} highcharts/chart/spacingleft/
     *         Spacing left set to 100
     * @sample {highstock} stock/chart/spacingleft/
     *         Spacing left set to 100
     * @sample {highmaps} maps/chart/spacing/
     *         Spacing 100 all around
     *
     * @type      {number}
     * @default   10
     * @since     2.1
     * @apioption chart.spacingLeft
     */ /**
     * The space between the right edge of the chart and the content (plot
     * area, axis title and labels, title, subtitle or legend in top
     * position).
     *
     * @sample {highcharts} highcharts/chart/spacingright-100/
     *         Spacing set to 100
     * @sample {highcharts} highcharts/chart/spacingright-legend/
     *         Legend in right position with default spacing
     * @sample {highstock} stock/chart/spacingright/
     *         Spacing set to 100
     * @sample {highmaps} maps/chart/spacing/
     *         Spacing 100 all around
     *
     * @type      {number}
     * @default   10
     * @since     2.1
     * @apioption chart.spacingRight
     */ /**
     * The space between the top edge of the chart and the content (plot
     * area, axis title and labels, title, subtitle or legend in top
     * position).
     *
     * @sample {highcharts} highcharts/chart/spacingtop-100/
     *         A top spacing of 100
     * @sample {highcharts} highcharts/chart/spacingtop-10/
     *         Floating chart title makes the plot area align to the default
     *         spacingTop of 10.
     * @sample {highstock} stock/chart/spacingtop/
     *         A top spacing of 100
     * @sample {highmaps} maps/chart/spacing/
     *         Spacing 100 all around
     *
     * @type      {number}
     * @default   10
     * @since     2.1
     * @apioption chart.spacingTop
     */ /**
     * Additional CSS styles to apply inline to the container `div` and the root
     * SVG.
     *
     * According to the CSS syntax documentation, it is recommended to quote
     * font family names that contain white space, digits, or punctuation
     * characters other than hyphens. In such cases, wrap the fontFamily
     * name as follows: `fontFamily: '"Font name"'`.
     *
     * Since v11, the root font size is 1rem by default, and all child element
     * are given a relative `em` font size by default. This allows implementers
     * to control all the chart's font sizes by only setting the root level.
     *
     * @see    In styled mode, general chart styles can be set with the
     *         `.highcharts-root` class.
     * @sample {highcharts} highcharts/chart/style-serif-font/
     *         Using a serif type font
     * @sample {highcharts} highcharts/chart/style-special-font/
     *         Using a font with special character in name
     * @sample {highcharts} highcharts/members/relative-font-size/
     *         Relative font sizes
     * @sample {highcharts} highcharts/css/em/
     *         Styled mode with relative font sizes
     * @sample {highstock} stock/chart/style/
     *         Using a serif type font
     * @sample {highmaps} maps/chart/style-serif-font/
     *         Using a serif type font
     *
     * @type      {Highcharts.CSSObject}
     * @default   {"fontFamily": "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', sans-serif", "fontSize":"1rem"}
     * @apioption chart.style
     */ /**
     * The default series type for the chart. Can be any of the chart types
     * listed under [plotOptions](#plotOptions) and [series](#series) or can
     * be a series provided by an additional module.
     *
     * In TypeScript this option has no effect in sense of typing and
     * instead the `type` option must always be set in the series.
     *
     * @sample {highcharts} highcharts/chart/type-bar/
     *         Bar
     * @sample {highstock} stock/chart/type/
     *         Areaspline
     * @sample {highmaps} maps/chart/type-mapline/
     *         Mapline
     *
     * @type       {string}
     * @default    {highcharts} line
     * @default    {highstock} line
     * @default    {highmaps} map
     * @since      2.1.0
     * @apioption  chart.type
     */ type: 'line',
    /**
     * Decides in what dimensions the user can zoom by dragging the mouse.
     * Can be one of `x`, `y` or `xy`.
     *
     * @see [panKey](#chart.panKey)
     *
     * @sample {highcharts} highcharts/chart/zoomtype-none/
     *         None by default
     * @sample {highcharts} highcharts/chart/zoomtype-x/
     *         X
     * @sample {highcharts} highcharts/chart/zoomtype-y/
     *         Y
     * @sample {highcharts} highcharts/chart/zoomtype-xy/
     *         Xy
     * @sample {highcharts} highcharts/chart/zoomtype-polar/
     *         Zoom on polar chart
     * @sample {highstock} stock/demo/basic-line/
     *         None by default
     * @sample {highstock} stock/chart/zoomtype-x/
     *         X
     * @sample {highstock} stock/chart/zoomtype-y/
     *         Y
     * @sample {highstock} stock/chart/zoomtype-xy/
     *         Xy
     * @sample {highmaps} maps/chart/zoomtype-xy/
     *         Map with selection zoom
     *
     * @type       {string}
     * @validvalue ["x", "y", "xy"]
     * @deprecated
     * @apioption  chart.zoomType
     */ /**
     * Enables zooming by a single touch, in combination with
     * [chart.zoomType](#chart.zoomType). When enabled, two-finger pinch
     * will still work as set up by [chart.pinchType](#chart.pinchType).
     * However, `zoomBySingleTouch` will interfere with touch-dragging the
     * chart to read the tooltip. And especially when vertical zooming is
     * enabled, it will make it hard to scroll vertically on the page.
     * @since      9.0.0
     * @sample     highcharts/chart/zoombysingletouch
     *             Zoom by single touch enabled, with buttons to toggle
     * @product    highcharts highstock gantt
     * @deprecated
     */ /**
     * Chart zooming options.
     * @since 10.2.1
     *
     * @sample     highcharts/plotoptions/sankey-node-color
     *             Zooming in sankey series
     * @sample     highcharts/series-treegraph/link-types
     *             Zooming in treegraph series
     */ zooming: {
        /**
         * Equivalent to [type](#chart.zooming.type), but for multitouch
         * gestures only. By default, the `pinchType` is the same as the
         * `type` setting. However, pinching can be enabled separately in
         * some cases, for example in stock charts where a mouse drag pans the
         * chart, while pinching is enabled. When [tooltip.followTouchMove](
         * #tooltip.followTouchMove) is true, pinchType only applies to
         * two-finger touches.
         *
         * @type       {string}
         * @default    {highcharts} undefined
         * @default    {highstock} x
         * @product    highcharts highstock gantt
         * @validvalue ["x", "y", "xy"]
         * @apioption  chart.zooming.pinchType
         */ /**
         * Decides in what dimensions the user can zoom by dragging the mouse.
         * Can be one of `x`, `y` or `xy`.
         *
         * **Note:** For non-cartesian series, the only supported zooming type
         * is `xy`, as zooming in a single direction is not applicable due to
         * the radial nature of the coordinate system.
         *
         * @declare    Highcharts.OptionsChartZoomingTypeValue
         * @type       {string}
         * @default    {highcharts} undefined
         * @product    highcharts highstock gantt
         * @validvalue ["x", "y", "xy"]
         * @apioption  chart.zooming.type
         */ /**
         * Set a key to hold when dragging to zoom the chart. This is useful to
         * avoid zooming while moving points. Should be set different than
         * [chart.panKey](#chart.panKey).
         *
         * @type       {string}
         * @default    {highcharts} undefined
         * @validvalue ["alt", "ctrl", "meta", "shift"]
         * @requires   modules/draggable-points
         * @apioption  chart.zooming.key
         */ /**
         * Enables zooming by a single touch, in combination with
         * [chart.zooming.type](#chart.zooming.type). When enabled, two-finger
         * pinch will still work as set up by [chart.zooming.pinchType]
         * (#chart.zooming.pinchType). However, `singleTouch` will interfere
         * with touch-dragging the chart to read the tooltip. And especially
         * when vertical zooming is enabled, it will make it hard to scroll
         * vertically on the page.
         *
         * @sample  highcharts/chart/zoombysingletouch
         *          Zoom by single touch enabled, with buttons to toggle
         *
         * @product highcharts highstock gantt
         */ singleTouch: false,
        /**
         * The button that appears after a selection zoom, allowing the user
         * to reset zoom.
         */ resetButton: {
            /**
             * What frame the button placement should be related to. Can be
             * either `plotBox` or `spacingBox`.
             *
             * @sample {highcharts} highcharts/chart/resetzoombutton-relativeto/
             *         Relative to the chart
             * @sample {highstock} highcharts/chart/resetzoombutton-relativeto/
             *         Relative to the chart
             *
             * @type      {Highcharts.ButtonRelativeToValue}
             * @default   plot
             * @apioption chart.zooming.resetButton.relativeTo
             */ /**
             * A collection of attributes for the button. The object takes SVG
             * attributes like `fill`, `stroke`, `stroke-width` or `r`, the
             * border radius. The theme also supports `style`, a collection of
             * CSS properties for the text. Equivalent attributes for the hover
             * state are given in `theme.states.hover`.
             *
             * @sample {highcharts} highcharts/chart/resetzoombutton-theme/
             *         Theming the button
             * @sample {highstock} highcharts/chart/resetzoombutton-theme/
             *         Theming the button
             *
             * @type  {Highcharts.SVGAttributes}
             * @since 10.2.1
             */ theme: {
                /** @internal */ zIndex: 6
            },
            /**
             * The position of the button.
             *
             * Note: Adjusting position values might cause overlap with chart
             * elements. Ensure coordinates do not obstruct other components or
             * data visibility.
             *
             * @sample {highcharts} highcharts/chart/resetzoombutton-position/
             *         Above the plot area
             * @sample {highstock} highcharts/chart/resetzoombutton-position/
             *         Above the plot area
             * @sample {highmaps} highcharts/chart/resetzoombutton-position/
             *         Above the plot area
             *
             * @type  {Highcharts.AlignObject}
             * @since 10.2.1
             */ position: {
                /**
                 * The horizontal alignment of the button.
                 */ align: 'right',
                /**
                 * The horizontal offset of the button.
                 */ x: -10,
                /**
                 * The vertical alignment of the button.
                 *
                 * @type       {Highcharts.VerticalAlignValue}
                 * @default    top
                 * @apioption  chart.zooming.resetButton.position.verticalAlign
                 */ /**
                 * The vertical offset of the button.
                 */ y: 10
            }
        }
    },
    /**
     * An explicit width for the chart. By default (when `null`) the width
     * is calculated from the offset width of the containing element.
     *
     * @sample {highcharts} highcharts/chart/width/
     *         800px wide
     * @sample {highstock} stock/chart/width/
     *         800px wide
     * @sample {highmaps} maps/chart/size/
     *         Chart with explicit size
     *
     * @type {null|number|string}
     */ width: null,
    /**
     * An explicit height for the chart. If a _number_, the height is
     * given in pixels. If given a _percentage string_ (for example
     * `'56%'`), the height is given as the percentage of the actual chart
     * width. This allows for preserving the aspect ratio across responsive
     * sizes.
     *
     * By default (when `null`) the height is calculated from the offset
     * height of the containing element, or 400 pixels if the containing
     * element's height is 0.
     *
     * @sample {highcharts} highcharts/chart/height/
     *         Forced 200px height
     * @sample {highstock} stock/chart/height/
     *         300px height
     * @sample {highmaps} maps/chart/size/
     *         Chart with explicit size
     * @sample highcharts/chart/height-percent/
     *         Highcharts with percentage height
     * @sample highcharts/chart/height-inherited/
     *         Chart with inherited height
     *
     * @type {null|number|string}
     */ height: null,
    /**
     * The color of the outer chart border.
     *
     * @see In styled mode, the stroke is set with the
     *      `.highcharts-background` class.
     *
     * @sample {highcharts} highcharts/chart/bordercolor/
     *         Brown border
     * @sample {highstock} stock/chart/border/
     *         Brown border
     * @sample {highmaps} maps/chart/border/
     *         Border options
     *
     * @type {Highcharts.ColorString|Highcharts.GradientColorObject|Highcharts.PatternObject}
     */ borderColor: "#334eff" /* Palette.highlightColor80 */ ,
    /**
     * The pixel width of the outer chart border.
     *
     * @see In styled mode, the stroke is set with the
     *      `.highcharts-background` class.
     *
     * @sample {highcharts} highcharts/chart/borderwidth/
     *         5px border
     * @sample {highstock} stock/chart/border/
     *         2px border
     * @sample {highmaps} maps/chart/border/
     *         Border options
     *
     * @type      {number}
     * @default   0
     * @apioption chart.borderWidth
     */ /**
     * The background color or gradient for the outer chart area.
     *
     * @see In styled mode, the background is set with the
     *      `.highcharts-background` class.
     *
     * @sample {highcharts} highcharts/chart/backgroundcolor-color/
     *         Color
     * @sample {highcharts} highcharts/chart/backgroundcolor-gradient/
     *         Gradient
     * @sample {highstock} stock/chart/backgroundcolor-color/
     *         Color
     * @sample {highstock} stock/chart/backgroundcolor-gradient/
     *         Gradient
     * @sample {highmaps} maps/chart/backgroundcolor-color/
     *         Color
     * @sample {highmaps} maps/chart/backgroundcolor-gradient/
     *         Gradient
     *
     * @type {Highcharts.ColorString|Highcharts.GradientColorObject|Highcharts.PatternObject}
     */ backgroundColor: "#ffffff" /* Palette.backgroundColor */ ,
    /**
     * The background color or gradient for the plot area.
     *
     * @see In styled mode, the plot background is set with the
     *      `.highcharts-plot-background` class.
     *
     * @sample {highcharts} highcharts/chart/plotbackgroundcolor-color/
     *         Color
     * @sample {highcharts} highcharts/chart/plotbackgroundcolor-gradient/
     *         Gradient
     * @sample {highstock} stock/chart/plotbackgroundcolor-color/
     *         Color
     * @sample {highstock} stock/chart/plotbackgroundcolor-gradient/
     *         Gradient
     * @sample {highmaps} maps/chart/plotbackgroundcolor-color/
     *         Color
     * @sample {highmaps} maps/chart/plotbackgroundcolor-gradient/
     *         Gradient
     *
     * @type      {Highcharts.ColorString|Highcharts.GradientColorObject|Highcharts.PatternObject}
     * @apioption chart.plotBackgroundColor
     */ /**
     * The URL for an image to use as the plot background. To set an image
     * as the background for the entire chart, set a CSS background image
     * to the container element. Note that for the image to be applied to
     * exported charts, its URL needs to be accessible by the export server.
     *
     * @see In styled mode, a plot background image can be set with the
     *      `.highcharts-plot-background` class and a [custom pattern](
     *      https://www.highcharts.com/docs/chart-design-and-style/gradients-shadows-and-patterns).
     *
     * @sample {highcharts} highcharts/chart/plotbackgroundimage/
     *         Skies
     * @sample {highstock} stock/chart/plotbackgroundimage/
     *         Skies
     *
     * @type      {string}
     * @apioption chart.plotBackgroundImage
     */ /**
     * The color of the inner chart or plot area border.
     *
     * @see In styled mode, a plot border stroke can be set with the
     *      `.highcharts-plot-border` class.
     *
     * @sample {highcharts} highcharts/chart/plotbordercolor/
     *         Blue border
     * @sample {highstock} stock/chart/plotborder/
     *         Blue border
     * @sample {highmaps} maps/chart/plotborder/
     *         Plot border options
     *
     * @type {Highcharts.ColorString|Highcharts.GradientColorObject|Highcharts.PatternObject}
     */ plotBorderColor: "#cccccc" /* Palette.neutralColor20 */ 
};
var /* *
 *
 *  Default Export
 *
 * */ $c725ae796117313a$export$2e2bcd8739ae039 = $c725ae796117313a$var$ChartDefaults;

});

parcelRegister("8eMVW", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ff596bc613beea4$export$2e2bcd8739ae039);
/**
 * Series palettes for Highcharts. Series colors are defined in highcharts.css.
 * **Do not edit this file!** This file is generated using the 'gulp palette' task.
 * @private
 */ const $5ff596bc613beea4$var$SeriesPalettes = {
    /**
     * Colors for data series and points
     */ colors: [
        '#2caffe',
        '#544fc5',
        '#00e272',
        '#fe6a35',
        '#6b8abc',
        '#d568fb',
        '#2ee0ca',
        '#fa4b42',
        '#feb56a',
        '#91e8e1'
    ]
};
var $5ff596bc613beea4$export$2e2bcd8739ae039 = $5ff596bc613beea4$var$SeriesPalettes;

});

parcelRegister("a3xCS", function(module, exports) {

$parcel$export(module.exports, "default", () => $7524449db18d8b1d$export$2e2bcd8739ae039);
/* *
 *
 *  (c) 2010-2025 Torstein Honsi
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 * */ 
var $8UUCj = parcelRequire("8UUCj");

var $l3aRA = parcelRequire("l3aRA");
'use strict';
const { defined: $7524449db18d8b1d$var$defined, extend: $7524449db18d8b1d$var$extend, timeUnits: $7524449db18d8b1d$var$timeUnits } = (0, $l3aRA.default);
/* *
 *
 *  Constants
 *
 * */ class $7524449db18d8b1d$var$Time extends (0, $8UUCj.default) {
    /**
     * Return an array with time positions distributed on round time values
     * right and right after min and max. Used in datetime axes as well as for
     * grouping data on a datetime axis.
     *
     * @function Highcharts.Time#getTimeTicks
     *
     * @param {Highcharts.TimeNormalizedObject} normalizedInterval
     *        The interval in axis values (ms) and the count
     *
     * @param {number} [min]
     *        The minimum in axis values
     *
     * @param {number} [max]
     *        The maximum in axis values
     *
     * @param {number} [startOfWeek=1]
     *
     * @return {Highcharts.AxisTickPositionsArray}
     * Time positions
     */ getTimeTicks(normalizedInterval, min, max, startOfWeek) {
        const time = this, tickPositions = [], higherRanks = {}, { count: count = 1, unitRange: unitRange } = normalizedInterval;
        let [year, month, dayOfMonth, hours, minutes, seconds] = time.toParts(min), milliseconds = (min || 0) % 1000, variableDayLength;
        startOfWeek ?? (startOfWeek = 1);
        if ($7524449db18d8b1d$var$defined(min)) {
            milliseconds = unitRange >= $7524449db18d8b1d$var$timeUnits.second ? 0 : count * Math.floor(milliseconds / count);
            if (unitRange >= $7524449db18d8b1d$var$timeUnits.second) seconds = unitRange >= $7524449db18d8b1d$var$timeUnits.minute ? 0 : count * Math.floor(seconds / count);
            if (unitRange >= $7524449db18d8b1d$var$timeUnits.minute) minutes = unitRange >= $7524449db18d8b1d$var$timeUnits.hour ? 0 : count * Math.floor(minutes / count);
            if (unitRange >= $7524449db18d8b1d$var$timeUnits.hour) hours = unitRange >= $7524449db18d8b1d$var$timeUnits.day ? 0 : count * Math.floor(hours / count);
            if (unitRange >= $7524449db18d8b1d$var$timeUnits.day) dayOfMonth = unitRange >= $7524449db18d8b1d$var$timeUnits.month ? 1 : Math.max(1, count * Math.floor(dayOfMonth / count));
            if (unitRange >= $7524449db18d8b1d$var$timeUnits.month) month = unitRange >= $7524449db18d8b1d$var$timeUnits.year ? 0 : count * Math.floor(month / count);
            if (unitRange >= $7524449db18d8b1d$var$timeUnits.year) year -= year % count;
            // Week is a special case that runs outside the hierarchy
            if (unitRange === $7524449db18d8b1d$var$timeUnits.week) {
                if (count) min = time.makeTime(year, month, dayOfMonth, hours, minutes, seconds, milliseconds);
                // Get start of current week, independent of count
                const weekday = this.dateTimeFormat({
                    timeZone: this.timezone,
                    weekday: 'narrow'
                }, min, 'es'), // Spanish weekday index
                weekdayNo = 'DLMXJVS'.indexOf(weekday);
                dayOfMonth += -weekdayNo + startOfWeek + // We don't want to skip days that are before
                // startOfWeek (#7051)
                (weekdayNo < startOfWeek ? -7 : 0);
            }
            min = time.makeTime(year, month, dayOfMonth, hours, minutes, seconds, milliseconds);
            // Handle local timezone offset
            if (time.variableTimezone && $7524449db18d8b1d$var$defined(max)) // Detect whether we need to take the DST crossover into
            // consideration. If we're crossing over DST, the day length may
            // be 23h or 25h and we need to compute the exact clock time for
            // each tick instead of just adding hours. This comes at a cost,
            // so first we find out if it is needed (#4951).
            variableDayLength = // Long range, assume we're crossing over.
            max - min > 4 * $7524449db18d8b1d$var$timeUnits.month || // Short range, check if min and max are in different time
            // zones.
            time.getTimezoneOffset(min) !== time.getTimezoneOffset(max);
            // Iterate and add tick positions at appropriate values
            let t = min, i = 1;
            while(t < max){
                tickPositions.push(t);
                // Increase the years
                if (unitRange === $7524449db18d8b1d$var$timeUnits.year) t = time.makeTime(year + i * count, 0);
                else if (unitRange === $7524449db18d8b1d$var$timeUnits.month) t = time.makeTime(year, month + i * count);
                else if (variableDayLength && (unitRange === $7524449db18d8b1d$var$timeUnits.day || unitRange === $7524449db18d8b1d$var$timeUnits.week)) t = time.makeTime(year, month, dayOfMonth + i * count * (unitRange === $7524449db18d8b1d$var$timeUnits.day ? 1 : 7));
                else if (variableDayLength && unitRange === $7524449db18d8b1d$var$timeUnits.hour && count > 1) // Make sure higher ranks are preserved across DST (#6797,
                // #7621)
                t = time.makeTime(year, month, dayOfMonth, hours + i * count);
                else t += unitRange * count;
                i++;
            }
            // Push the last time
            tickPositions.push(t);
            // Handle higher ranks. Mark new days if the time is on midnight
            // (#950, #1649, #1760, #3349). Use a reasonable dropout threshold
            // to prevent looping over dense data grouping (#6156).
            if (unitRange <= $7524449db18d8b1d$var$timeUnits.hour && tickPositions.length < 10000) tickPositions.forEach((t)=>{
                if (// Speed optimization, no need to run dateFormat unless
                // we're on a full or half hour
                t % 1800000 === 0 && // Check for local or global midnight
                time.dateFormat('%H%M%S%L', t) === '000000000') higherRanks[t] = 'day';
            });
        }
        // Record information on the chosen unit - for dynamic label formatter
        tickPositions.info = $7524449db18d8b1d$var$extend(normalizedInterval, {
            higherRanks: higherRanks,
            totalRange: unitRange * count
        });
        return tickPositions;
    }
}
var /* *
 *
 * Default export
 *
 * */ $7524449db18d8b1d$export$2e2bcd8739ae039 = $7524449db18d8b1d$var$Time;

});
parcelRegister("8UUCj", function(module, exports) {

$parcel$export(module.exports, "default", () => $67df78a36cc0fc3c$export$2e2bcd8739ae039);
/* *
 *
 *  (c) 2010-2025 Torstein Honsi
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 * */ 
var $30Vhv = parcelRequire("30Vhv");

var $l3aRA = parcelRequire("l3aRA");
'use strict';
const { pageLang: $67df78a36cc0fc3c$var$pageLang, win: $67df78a36cc0fc3c$var$win } = (0, $30Vhv.default);
const { defined: $67df78a36cc0fc3c$var$defined, error: $67df78a36cc0fc3c$var$error, extend: $67df78a36cc0fc3c$var$extend, isNumber: $67df78a36cc0fc3c$var$isNumber, isObject: $67df78a36cc0fc3c$var$isObject, isString: $67df78a36cc0fc3c$var$isString, merge: $67df78a36cc0fc3c$var$merge, objectEach: $67df78a36cc0fc3c$var$objectEach, pad: $67df78a36cc0fc3c$var$pad, splat: $67df78a36cc0fc3c$var$splat, timeUnits: $67df78a36cc0fc3c$var$timeUnits, ucfirst: $67df78a36cc0fc3c$var$ucfirst } = (0, $l3aRA.default);
/* *
 *
 *  Constants
 *
 * */ // To do: Remove this when we no longer need support for Safari < v14.1
const $67df78a36cc0fc3c$var$hasOldSafariBug = (0, $30Vhv.default).isSafari && $67df78a36cc0fc3c$var$win.Intl && !$67df78a36cc0fc3c$var$win.Intl.DateTimeFormat.prototype.formatRange;
const $67df78a36cc0fc3c$var$isDateTimeFormatOptions = (obj)=>obj.main === void 0;
/* *
 *
 *  Class
 *
 * */ /* eslint-disable no-invalid-this, valid-jsdoc */ /**
 * The Time class. Time settings are applied in general for each page using
 * `Highcharts.setOptions`, or individually for each Chart item through the
 * [time](https://api.highcharts.com/highcharts/time) options set.
 *
 * The Time object is available from {@link Highcharts.Chart#time}, which refers
 * to  `Highcharts.time` unless individual time settings are applied for each
 * chart.
 *
 * When configuring time settings for individual chart instances, be aware that
 * using `Highcharts.dateFormat` or `Highcharts.time.dateFormat` within
 * formatter callbacks relies on the global time object, which applies the
 * global language and time zone settings. To ensure charts with local time
 * settings function correctly, use `chart.time.dateFormat? instead. However,
 * the recommended best practice is to use `setOptions` to define global time
 * settings unless specific configurations are needed for each chart.
 *
 * @example
 * // Apply time settings globally
 * Highcharts.setOptions({
 *     time: {
 *         timezone: 'Europe/London'
 *     }
 * });
 *
 * // Apply time settings by instance
 * const chart = Highcharts.chart('container', {
 *     time: {
 *         timezone: 'America/New_York'
 *     },
 *     series: [{
 *         data: [1, 4, 3, 5]
 *     }]
 * });
 *
 * // Use the Time object of a chart instance
 * console.log(
 *        'Current time in New York',
 *        chart.time.dateFormat('%Y-%m-%d %H:%M:%S', Date.now())
 * );
 *
 * // Standalone use
 * const time = new Highcharts.Time({
 *    timezone: 'America/New_York'
 * });
 * const s = time.dateFormat('%Y-%m-%d %H:%M:%S', Date.UTC(2020, 0, 1));
 * console.log(s); // => 2019-12-31 19:00:00
 *
 * @since 6.0.5
 *
 * @class
 * @name Highcharts.Time
 *
 * @param {Highcharts.TimeOptions} [options] Time options as defined in
 * [chart.options.time](/highcharts/time).
 */ class $67df78a36cc0fc3c$var$TimeBase {
    /* *
     *
     *  Constructors
     *
     * */ constructor(options, lang){
        /* *
         *
         *  Properties
         *
         * */ this.options = {
            timezone: 'UTC'
        };
        this.variableTimezone = false;
        this.Date = $67df78a36cc0fc3c$var$win.Date;
        this.update(options);
        this.lang = lang;
    }
    /* *
     *
     *  Functions
     *
     * */ /**
     * Update the Time object with current options. It is called internally on
     * initializing Highcharts, after running `Highcharts.setOptions` and on
     * `Chart.update`.
     *
     * @private
     * @function Highcharts.Time#update
     *
     * @param {Highcharts.TimeOptions} [options]
     *
     */ update(options = {}) {
        this.dTLCache = {};
        this.options = options = $67df78a36cc0fc3c$var$merge(true, this.options, options);
        const { timezoneOffset: timezoneOffset, useUTC: useUTC, locale: locale } = options;
        // Allow using a different Date class
        this.Date = options.Date || $67df78a36cc0fc3c$var$win.Date || Date;
        // Assign the time zone. Handle the legacy, deprecated `useUTC` option.
        let timezone = options.timezone;
        if ($67df78a36cc0fc3c$var$defined(useUTC)) timezone = useUTC ? 'UTC' : void 0;
        // The Etc/GMT time zones do not support offsets with half-hour
        // resolutions
        if (timezoneOffset && timezoneOffset % 60 === 0) timezone = 'Etc/GMT' + (timezoneOffset > 0 ? '+' : '') + timezoneOffset / 60;
        /*
         * The time object has options allowing for variable time zones, meaning
         * the axis ticks or series data needs to consider this.
         */ this.variableTimezone = timezone !== 'UTC' && timezone?.indexOf('Etc/GMT') !== 0;
        this.timezone = timezone;
        // Update locale.
        if (this.lang && locale) this.lang.locale = locale;
        // Assign default time formats from locale strings
        [
            'months',
            'shortMonths',
            'weekdays',
            'shortWeekdays'
        ].forEach((name)=>{
            const isMonth = /months/i.test(name), isShort = /short/.test(name), options = {
                timeZone: 'UTC'
            };
            options[isMonth ? 'month' : 'weekday'] = isShort ? 'short' : 'long';
            this[name] = (isMonth ? [
                0,
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ] : [
                3,
                4,
                5,
                6,
                7,
                8,
                9
            ]).map((position)=>this.dateFormat(options, (isMonth ? 31 : 1) * 24 * 36e5 * position));
        });
    }
    /**
     * Get a date in terms of numbers (year, month, day etc) for further
     * processing. Takes the current `timezone` setting into account. Inverse of
     * `makeTime` and the native `Date` constructor and `Date.UTC`.
     *
     * The date is returned in array format with the following indices:
     *
     * 0: year,
     * 1: month (zero based),
     * 2: day,
     * 3: hours,
     * 4: minutes,
     * 5: seconds,
     * 6: milliseconds,
     * 7: weekday (Sunday as 0)
     *
     * @function Highcharts.Time#toParts
     *
     * @param {number|Date} [timestamp]
     *                 The timestamp in milliseconds since January 1st 1970.
     *                 A Date object is also accepted.
     *
     * @return {Array<number>} The date parts in array format.
     */ toParts(timestamp) {
        const [weekday, dayOfMonth, month, year, hours, minutes, seconds] = this.dateTimeFormat({
            weekday: 'narrow',
            day: 'numeric',
            month: 'numeric',
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric'
        }, timestamp, 'es')// The ', ' splitter is for all modern browsers:
        //      L, 6/3/2023, 14:30:00
        // The ' ' splitter is for legacy Safari with no comma between date
        // and time (#22445):
        //      L, 6/3/2023 14:30:00
        .split(/(?:, | |\/|:)/g);
        return [
            year,
            +month - 1,
            dayOfMonth,
            hours,
            minutes,
            seconds,
            // Milliseconds
            Math.floor(Number(timestamp) || 0) % 1000,
            // Spanish weekday index
            'DLMXJVS'.indexOf(weekday)
        ].map(Number);
    }
    /**
     * Shorthand to get a cached `Intl.DateTimeFormat` instance.
     */ dateTimeFormat(options, timestamp, locale = this.options.locale || $67df78a36cc0fc3c$var$pageLang) {
        const cacheKey = JSON.stringify(options) + locale;
        if ($67df78a36cc0fc3c$var$isString(options)) options = this.str2dtf(options);
        let dTL = this.dTLCache[cacheKey];
        if (!dTL) {
            options.timeZone ?? (options.timeZone = this.timezone);
            try {
                dTL = new Intl.DateTimeFormat(locale, options);
            } catch (e) {
                if (/Invalid time zone/i.test(e.message)) {
                    $67df78a36cc0fc3c$var$error(34);
                    options.timeZone = 'UTC';
                    dTL = new Intl.DateTimeFormat(locale, options);
                } else $67df78a36cc0fc3c$var$error(e.message, false);
            }
        }
        this.dTLCache[cacheKey] = dTL;
        return dTL?.format(timestamp) || '';
    }
    /**
     * Take a locale-aware string format and return a full DateTimeFormat in
     * object form.
     */ str2dtf(s, dtf = {}) {
        const mapping = {
            L: {
                fractionalSecondDigits: 3
            },
            S: {
                second: '2-digit'
            },
            M: {
                minute: 'numeric'
            },
            H: {
                hour: '2-digit'
            },
            k: {
                hour: 'numeric'
            },
            E: {
                weekday: 'narrow'
            },
            a: {
                weekday: 'short'
            },
            A: {
                weekday: 'long'
            },
            d: {
                day: '2-digit'
            },
            e: {
                day: 'numeric'
            },
            b: {
                month: 'short'
            },
            B: {
                month: 'long'
            },
            m: {
                month: '2-digit'
            },
            o: {
                month: 'numeric'
            },
            y: {
                year: '2-digit'
            },
            Y: {
                year: 'numeric'
            }
        };
        Object.keys(mapping).forEach((key)=>{
            if (s.indexOf(key) !== -1) $67df78a36cc0fc3c$var$extend(dtf, mapping[key]);
        });
        return dtf;
    }
    /**
     * Make a time and returns milliseconds. Similar to `Date.UTC`, but takes
     * the current `timezone` setting into account.
     *
     * @function Highcharts.Time#makeTime
     *
     * @param {number} year
     *        The year
     *
     * @param {number} month
     *        The month. Zero-based, so January is 0.
     *
     * @param {number} [date=1]
     *        The day of the month
     *
     * @param {number} [hours=0]
     *        The hour of the day, 0-23.
     *
     * @param {number} [minutes=0]
     *        The minutes
     *
     * @param {number} [seconds=0]
     *        The seconds
     *
     * @return {number}
     *         The time in milliseconds since January 1st 1970.
     */ makeTime(year, month, date = 1, hours = 0, minutes, seconds, milliseconds) {
        // eslint-disable-next-line new-cap
        let d = this.Date.UTC(year, month, date, hours, minutes || 0, seconds || 0, milliseconds || 0);
        if (this.timezone !== 'UTC') {
            const offset = this.getTimezoneOffset(d);
            d += offset;
            // Adjustments close to DST transitions
            if (// Optimize for speed by limiting the number of calls to
            // `getTimezoneOffset`. According to
            // https://en.wikipedia.org/wiki/Daylight_saving_time_by_country,
            // DST change may only occur in these months.
            [
                2,
                3,
                8,
                9,
                10,
                11
            ].indexOf(month) !== -1 && // DST transitions occur only in the night-time
            (hours < 5 || hours > 20)) {
                const newOffset = this.getTimezoneOffset(d);
                if (offset !== newOffset) d += newOffset - offset;
                else if (offset - 36e5 === this.getTimezoneOffset(d - 36e5) && !$67df78a36cc0fc3c$var$hasOldSafariBug) d -= 36e5;
            }
        }
        return d;
    }
    /**
     * Parse a datetime string. Unless the string contains time zone
     * information, apply the current `timezone` from options. If the argument
     * is a number, return it.
     *
     * @function Highcharts.Time#parse
     * @param    {string|number|undefined} s The datetime string to parse
     * @return   {number|undefined}          Parsed JavaScript timestamp
     */ parse(s) {
        if (!$67df78a36cc0fc3c$var$isString(s)) return s ?? void 0;
        s = s// Firefox fails on YYYY/MM/DD
        .replace(/\//g, '-')// Replace some non-standard notations
        .replace(/(GMT|UTC)/, '');
        // Extend shorthand hour timezone offset like +02
        // .replace(/([+-][0-9]{2})$/, '$1:00');
        // Check if the string has time zone information
        const hasTimezone = s.indexOf('Z') > -1 || /([+-][0-9]{2}):?[0-9]{2}$/.test(s), // YYYY-MM-DD and YYYY-MM are always UTC
        isYYYYMMDD = /^[0-9]{4}-[0-9]{2}(-[0-9]{2}|)$/.test(s);
        if (!hasTimezone && !isYYYYMMDD) s += 'Z';
        const ts = Date.parse(s);
        if ($67df78a36cc0fc3c$var$isNumber(ts)) // Unless the string contains time zone information, convert from
        // the local time result of `Date.parse` via UTC into the current
        // timezone of the time object.
        return ts + (!hasTimezone || isYYYYMMDD ? this.getTimezoneOffset(ts) : 0);
    }
    /**
     * Get the time zone offset based on the current timezone information as
     * set in the global options.
     *
     * @function Highcharts.Time#getTimezoneOffset
     *
     * @param {number} timestamp
     *        The JavaScript timestamp to inspect.
     *
     * @return {number}
     *         The timezone offset in minutes compared to UTC.
     */ getTimezoneOffset(timestamp) {
        if (this.timezone !== 'UTC') {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const [date, gmt, hours, colon, minutes = 0] = this.dateTimeFormat({
                timeZoneName: 'shortOffset'
            }, timestamp, 'en').split(/(GMT|:)/).map(Number), offset = -(hours + minutes / 60) * 3600000;
            // Possible future NaNs stop here
            if ($67df78a36cc0fc3c$var$isNumber(offset)) return offset;
        }
        return 0;
    }
    /**
     * Formats a JavaScript date timestamp (milliseconds since January 1 1970)
     * into a human readable date string.
     *
     * The `format` parameter accepts two types of values:
     * - An object containing settings that are passed directly on to
     *   [Intl.DateTimeFormat.prototype.format](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/format).
     * - A format string containing either individual or locale-aware format
     *   keys. **Individual keys**, for example `%Y-%m-%d`, are listed below.
     *   **Locale-aware keys** are grouped by square brackets, for example
     *   `%[Ymd]`. The order of keys within the square bracket doesn't affect
     *   the output, which is determined by the locale. See example below.
     *   Internally, the locale-aware format keys are just a shorthand for the
     *   full object formats, but are particularly practical in
     *   [templating](https://www.highcharts.com/docs/chart-concepts/templating)
     *   where full object definitions are not an option.
     *
     * The available string format keys are listed below. Additional formats can
     * be given in the {@link Highcharts.dateFormats} hook.
     *
     * Supported format keys:
     * | Key  | Description                     | Notes on locale-aware format |
     * -------|----------------------------------------------|-------|
     * | `%A` | Long weekday, like 'Monday'                  |       |
     * | `%a` | Short weekday, like 'Mon'                    |       |
     * | `%E` | Narrow weekday, single character             |       |
     * | `%d` | Two digit day of the month, 01 to 31         |       |
     * | `%e` | Day of the month, 1 through 31               |       |
     * | `%w` | Day of the week, 0 through 6                 | N/A   |
     * | `%v` | The prefix "week from", read from `lang.weekFrom` | N/A |
     * | `%b` | Short month, like 'Jan'                      |       |
     * | `%B` | Long month, like 'January'                   |       |
     * | `%m` | Two digit month number, 01 through 12        |       |
     * | `%o` | Month number, 1 through 12                   |       |
     * | `%y` | Two digits year, like 24 for 2024            |       |
     * | `%Y` | Four digits year, like 2024                  |       |
     * | `%H` | Two digits hours in 24h format, 00 through 23 | Depending on the locale, 12h format may be instered. |
     * | `%k` | Hours in 24h format, 0 through 23            | Depending on the locale, 12h format may be instered. |
     * | `%I` | Two digits hours in 12h format, 00 through 11 | N/A. The locale determines the hour format. |
     * | `%l` | Hours in 12h format, 1 through 12            | N/A. The locale determines the hour format. |
     * | `%M` | Two digits minutes, 00 through 59            |       |
     * | `%p` | Upper case AM or PM                          | N/A. The locale determines whether to add AM and PM. |
     * | `%P` | Lower case AM or PM                          | N/A. The locale determines whether to add AM and PM. |
     * | `%S` | Two digits seconds, 00 through 59            |       |
     * | `%L` | Milliseconds (naming from Ruby)              |       |
     *
     * @example
     * // Object format, US English
     * const time1 = new Highcharts.Time({ locale: 'en-US' });
     * console.log(
     *     time1.dateFormat({
     *         day: 'numeric',
     *         month: 'short',
     *         year: 'numeric',
     *         hour: 'numeric',
     *         minute: 'numeric'
     *     }, Date.UTC(2024, 11, 31))
     * ); // => Dec 31, 2024, 12:00 AM
     *
     * // Object format, British English
     * const time2 = new Highcharts.Time({ locale: 'en-GB' });
     * console.log(
     *     time2.dateFormat({
     *         day: 'numeric',
     *         month: 'short',
     *         year: 'numeric',
     *         hour: 'numeric',
     *         minute: 'numeric'
     *     }, Date.UTC(2024, 11, 31))
     * ); // => 31 Dec 2024, 00:00
     *
     * // Individual key string replacement
     * const time3 = new Highcharts.Time();
     * console.log(
     *     time3.dateFormat('%Y-%m-%d %H:%M:%S', Date.UTC(2024, 11, 31))
     * ); // => 2024-12-31 00:00:00
     *
     * // Locale-aware keys, US English
     * const time4 = new Highcharts.Time({ locale: 'en-US' });
     * console.log(
     *     time4.dateFormat('%[YebHM]', Date.UTC(2024, 11, 31))
     * ); // => Dec 31, 2024, 12:00 AM
     *
     * // Locale-aware keys, British English
     * const time5 = new Highcharts.Time({ locale: 'en-GB' });
     * console.log(
     *     time5.dateFormat('%[YebHM]', Date.UTC(2024, 11, 31))
     * ); // => 31 Dec 2024, 00:00
     *
     * // Mixed locale-aware and individual keys
     * console.log(
     *     time5.dateFormat('%[Yeb], %H:%M', Date.UTC(2024, 11, 31))
     * ); // => 31 Dec 2024, 00:00
     *
     * @function Highcharts.Time#dateFormat
     *
     * @param {string|Highcharts.DateTimeFormatOptions} format
     *        The desired string format where various time representations are
     *        prefixed with %, or an object representing the locale-aware format
     *        options.
     *
     * @param {number} [timestamp]
     *        The JavaScript timestamp.
     *
     * @param {boolean} [upperCaseFirst=false]
     *        Upper case first letter in the return.
     *
     * @return {string}
     *         The formatted date.
     */ dateFormat(format, timestamp, upperCaseFirst) {
        const lang = this.lang;
        if (!$67df78a36cc0fc3c$var$defined(timestamp) || isNaN(timestamp)) return lang?.invalidDate || '';
        format = format ?? '%Y-%m-%d %H:%M:%S';
        // First, identify and replace locale-aware formats like %[Ymd]
        if ($67df78a36cc0fc3c$var$isString(format)) {
            const localeAwareRegex = /%\[([a-zA-Z]+)\]/g;
            let match;
            while(match = localeAwareRegex.exec(format))format = format.replace(match[0], this.dateTimeFormat(match[1], timestamp, lang?.locale));
        }
        // Then, replace static formats like %Y, %m, %d etc.
        if ($67df78a36cc0fc3c$var$isString(format) && format.indexOf('%') !== -1) {
            const time = this, [fullYear, month, dayOfMonth, hours, minutes, seconds, milliseconds, weekday] = this.toParts(timestamp), langWeekdays = lang?.weekdays || this.weekdays, shortWeekdays = lang?.shortWeekdays || this.shortWeekdays, months = lang?.months || this.months, shortMonths = lang?.shortMonths || this.shortMonths, // List all format keys. Custom formats can be added from the
            // outside.
            replacements = $67df78a36cc0fc3c$var$extend({
                // Day
                // Short weekday, like 'Mon'
                a: shortWeekdays ? shortWeekdays[weekday] : langWeekdays[weekday].substr(0, 3),
                // Long weekday, like 'Monday'
                A: langWeekdays[weekday],
                // Two digit day of the month, 01 to 31
                d: $67df78a36cc0fc3c$var$pad(dayOfMonth),
                // Day of the month, 1 through 31
                e: $67df78a36cc0fc3c$var$pad(dayOfMonth, 2, ' '),
                // Day of the week, 0 through 6
                w: weekday,
                // Week (none implemented)
                // 'W': weekNumber(),
                v: lang?.weekFrom ?? '',
                // Month
                // Short month, like 'Jan'
                b: shortMonths[month],
                // Long month, like 'January'
                B: months[month],
                // Two digit month number, 01 through 12
                m: $67df78a36cc0fc3c$var$pad(month + 1),
                // Month number, 1 through 12 (#8150)
                o: month + 1,
                // Year
                // Two digits year, like 09 for 2009
                y: fullYear.toString().substr(2, 2),
                // Four digits year, like 2009
                Y: fullYear,
                // Time
                // Two digits hours in 24h format, 00 through 23
                H: $67df78a36cc0fc3c$var$pad(hours),
                // Hours in 24h format, 0 through 23
                k: hours,
                // Two digits hours in 12h format, 00 through 11
                I: $67df78a36cc0fc3c$var$pad(hours % 12 || 12),
                // Hours in 12h format, 1 through 12
                l: hours % 12 || 12,
                // Two digits minutes, 00 through 59
                M: $67df78a36cc0fc3c$var$pad(minutes),
                // Upper case AM or PM
                p: hours < 12 ? 'AM' : 'PM',
                // Lower case AM or PM
                P: hours < 12 ? 'am' : 'pm',
                // Two digits seconds, 00 through 59
                S: $67df78a36cc0fc3c$var$pad(seconds),
                // Milliseconds (naming from Ruby)
                L: $67df78a36cc0fc3c$var$pad(milliseconds, 3)
            }, (0, $30Vhv.default).dateFormats);
            // Do the replaces
            $67df78a36cc0fc3c$var$objectEach(replacements, function(val, key) {
                if ($67df78a36cc0fc3c$var$isString(format)) // Regex would do it in one line, but this is faster
                while(format.indexOf('%' + key) !== -1)format = format.replace('%' + key, typeof val === 'function' ? val.call(time, timestamp) : val);
            });
        } else if ($67df78a36cc0fc3c$var$isObject(format)) {
            const tzHours = (this.getTimezoneOffset(timestamp) || 0) / 3600000, timeZone = this.timezone || 'Etc/GMT' + (tzHours >= 0 ? '+' : '') + tzHours, { prefix: prefix = '', suffix: suffix = '' } = format;
            format = prefix + this.dateTimeFormat($67df78a36cc0fc3c$var$extend({
                timeZone: timeZone
            }, format), timestamp) + suffix;
        }
        // Optionally sentence-case the string and return
        return upperCaseFirst ? $67df78a36cc0fc3c$var$ucfirst(format) : format;
    }
    /**
     * Resolve legacy formats of dateTimeLabelFormats (strings and arrays) into
     * an object.
     * @private
     * @param {string|Array<T>|Highcharts.Dictionary<T>} f
     * General format description
     * @return {Highcharts.Dictionary<T>}
     * The object definition
     */ resolveDTLFormat(f) {
        if (!$67df78a36cc0fc3c$var$isObject(f, true)) {
            f = $67df78a36cc0fc3c$var$splat(f);
            return {
                main: f[0],
                from: f[1],
                to: f[2]
            };
        }
        // Type-check DateTimeFormatOptions against DateTimeLabelFormatObject
        if ($67df78a36cc0fc3c$var$isObject(f, true) && $67df78a36cc0fc3c$var$isDateTimeFormatOptions(f)) return {
            main: f
        };
        return f;
    }
    /**
     * Get the optimal date format for a point, based on a range.
     *
     * @private
     * @function Highcharts.Time#getDateFormat
     *
     * @param {number} range
     *        The time range
     *
     * @param {number} timestamp
     *        The timestamp of the date
     *
     * @param {number} startOfWeek
     *        An integer representing the first day of the week, where 0 is
     *        Sunday.
     *
     * @param {Highcharts.Dictionary<string>} dateTimeLabelFormats
     *        A map of time units to formats.
     *
     * @return {string}
     *         The optimal date format for a point.
     */ getDateFormat(range, timestamp, startOfWeek, dateTimeLabelFormats) {
        const dateStr = this.dateFormat('%m-%d %H:%M:%S.%L', timestamp), blank = '01-01 00:00:00.000', strpos = {
            millisecond: 15,
            second: 12,
            minute: 9,
            hour: 6,
            day: 3
        };
        let n = 'millisecond', // For sub-millisecond data, #4223
        lastN = n;
        for(n in $67df78a36cc0fc3c$var$timeUnits){
            // If the range is exactly one week and we're looking at a
            // Sunday/Monday, go for the week format
            if (range && range === $67df78a36cc0fc3c$var$timeUnits.week && +this.dateFormat('%w', timestamp) === startOfWeek && dateStr.substr(6) === blank.substr(6)) {
                n = 'week';
                break;
            }
            // The first format that is too great for the range
            if (range && $67df78a36cc0fc3c$var$timeUnits[n] > range) {
                n = lastN;
                break;
            }
            // If the point is placed every day at 23:59, we need to show
            // the minutes as well. #2637.
            if (strpos[n] && dateStr.substr(strpos[n]) !== blank.substr(strpos[n])) break;
            // Weeks are outside the hierarchy, only apply them on
            // Mondays/Sundays like in the first condition
            if (n !== 'week') lastN = n;
        }
        return this.resolveDTLFormat(dateTimeLabelFormats[n]).main;
    }
}
var /* *
 *
 * Default export
 *
 * */ $67df78a36cc0fc3c$export$2e2bcd8739ae039 = $67df78a36cc0fc3c$var$TimeBase;
/* *
 *
 * API Declarations
 *
 * */ /**
 * Normalized interval.
 *
 * @interface Highcharts.TimeNormalizedObject
 */ /**
* The count.
*
* @name Highcharts.TimeNormalizedObject#count
* @type {number|undefined}
*/ /**
* The interval in axis values (ms).
*
* @name Highcharts.TimeNormalizedObject#unitRange
* @type {number}
*/ /**
 * Function of an additional date format specifier.
 *
 * @callback Highcharts.TimeFormatCallbackFunction
 *
 * @param {number} timestamp
 *        The time to format.
 *
 * @return {string}
 *         The formatted portion of the date.
 */ /**
 * Time ticks.
 *
 * @interface Highcharts.AxisTickPositionsArray
 * @extends global.Array<number>
 */ /**
* @name Highcharts.AxisTickPositionsArray#info
* @type {Highcharts.TimeTicksInfoObject|undefined}
*/ /**
 * A callback to return the time zone offset for a given datetime. It
 * takes the timestamp in terms of milliseconds since January 1 1970,
 * and returns the timezone offset in minutes. This provides a hook
 * for drawing time based charts in specific time zones using their
 * local DST crossover dates, with the help of external libraries.
 *
 * @callback Highcharts.TimezoneOffsetCallbackFunction
 *
 * @param {number} timestamp
 * Timestamp in terms of milliseconds since January 1 1970.
 *
 * @return {number}
 * Timezone offset in minutes.
 */ /**
 * Options for formatting dates and times using the [Intl.DateTimeFormat](
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat
 * ) API, and extended with some custom options for Highcharts.
 *
 * @interface Highcharts.DateTimeFormatOptions
 */ /**
* The locale matching algorithm to use.
*
* @name Highcharts.DateTimeFormatOptions#localeMatcher
* @type {string|undefined}
*/ /**
* The time zone to use. The default is the browser's default time zone.
*
* @name Highcharts.DateTimeFormatOptions#timeZone
* @type {string|undefined}
*/ /**
* Whether to use 12-hour time (as opposed to 24-hour time).
*
* @name Highcharts.DateTimeFormatOptions#hour12
* @type {'auto'|'always'|'never'|undefined}
*/ /**
* The format matching algorithm to use.
*
* @name Highcharts.DateTimeFormatOptions#formatMatcher
* @type {string|undefined}
*/ /**
* The representation of the weekday.
*
* @name Highcharts.DateTimeFormatOptions#weekday
* @type {'narrow'|'short'|'long'|undefined}
*/ /**
* The representation of the era.
*
* @name Highcharts.DateTimeFormatOptions#era
* @type {'narrow'|'short'|'long'|undefined}
*/ /**
* The representation of the year.
*
* @name Highcharts.DateTimeFormatOptions#year
* @type {'numeric'|'2-digit'|undefined}
*/ /**
* The representation of the month.
* "narrow", "short", "long".
*
* @name Highcharts.DateTimeFormatOptions#month
* @type {'numeric'|'2-digit'|'narrow'|'short'|'long'|undefined}
*/ /**
* The representation of the day.
*
* @name Highcharts.DateTimeFormatOptions#day
* @type {'numeric'|'2-digit'|undefined}
*/ /**
* The representation of the hour.
*
* @name Highcharts.DateTimeFormatOptions#hour
* @type {'numeric'|'2-digit'|undefined}
*/ /**
* The representation of the minute.
*
* @name Highcharts.DateTimeFormatOptions#minute
* @type {'numeric'|'2-digit'|undefined}
*/ /**
* The representation of the second.
*
* @name Highcharts.DateTimeFormatOptions#second
* @type {'numeric'|'2-digit'|undefined}
*/ /**
* The number of fractional digits to use. 3 means milliseconds.
*
* @name Highcharts.DateTimeFormatOptions#fractionalSecondDigits
* @type {number|undefined}
*/ /**
* The representation of the time zone name.
*
* @name Highcharts.DateTimeFormatOptions#timeZoneName
* @type {'short'|'long'|undefined}
*/ /**
* A prefix for the time string. Custom Highcharts option.
*
* @name Highcharts.DateTimeFormatOptions#prefix
* @type {'string'|undefined}
*/ /**
* A suffix for the time string. Custom Highcharts option.
*
* @name Highcharts.DateTimeFormatOptions#suffix
* @type {'string'|undefined}
*/ ''; // Keeps doclets above in JS file

});




parcelRegister("711xA", function(module, exports) {

$parcel$export(module.exports, "default", () => $51b9d2561df58de6$export$2e2bcd8739ae039);
/* *
 *
 *  Column Resizing namespace
 *
 *  (c) 2020-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Dawid Dragula
 *
 * */ 
var $9znIs = parcelRequire("9znIs");

var $hhH3c = parcelRequire("hhH3c");

var $dK2c3 = parcelRequire("dK2c3");

var $lT4GX = parcelRequire("lT4GX");
'use strict';
const $51b9d2561df58de6$export$3a577424b4aa83ea = (0, $9znIs.default);
const $51b9d2561df58de6$export$b14ad400b1d09e0f = {
    adjacent: (0, $hhH3c.default),
    distributed: (0, $lT4GX.default),
    independent: (0, $dK2c3.default)
};
function $51b9d2561df58de6$export$1cc5a34f706666a6(viewport) {
    const modeName = viewport.grid.options?.rendering?.columns?.resizing?.mode || 'adjacent';
    let ModeConstructor = $51b9d2561df58de6$export$b14ad400b1d09e0f[modeName];
    if (!ModeConstructor) {
        // eslint-disable-next-line no-console
        console.warn(`Unknown column resizing mode: '${modeName}'. Applied ` + 'default \'adjacent\' mode.');
        ModeConstructor = $51b9d2561df58de6$export$b14ad400b1d09e0f.adjacent;
    }
    return new ModeConstructor(viewport);
}
var /* *
 *
 *  Default Export
 *
 * */ $51b9d2561df58de6$export$2e2bcd8739ae039 = {
    initMode: $51b9d2561df58de6$export$1cc5a34f706666a6,
    types: $51b9d2561df58de6$export$b14ad400b1d09e0f,
    AbstractStrategy: $51b9d2561df58de6$export$3a577424b4aa83ea
};

});
parcelRegister("9znIs", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f79c776b6dd1900$export$2e2bcd8739ae039);
/* *
 *
 *  Resizing Mode abstract class
 *
 *  (c) 2020-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Dawid Dragula
 *
 * */ 
var $l3aRA = parcelRequire("l3aRA");
'use strict';
const { getStyle: $6f79c776b6dd1900$var$getStyle, defined: $6f79c776b6dd1900$var$defined } = (0, $l3aRA.default);
/* *
 *
 *  Class
 *
 * */ /**
 * Represents a column distribution strategy.
 */ class $6f79c776b6dd1900$var$ResizingMode {
    /* *
    *
    *  Constructor
    *
    * */ /**
     * Creates a new column distribution strategy.
     *
     * @param viewport
     * The table that the column distribution strategy is applied to.
     */ constructor(viewport){
        /**
         * The current widths values of the columns.
         */ this.columnWidths = {};
        /**
         * Array of units for each column width value. Codified as:
         * - `0` - px
         * - `1` - %
         */ this.columnWidthUnits = {};
        this.viewport = viewport;
    }
    /**
     * Returns the column's current width in pixels.
     *
     * @param column
     * The column to get the width for.
     *
     * @returns
     * The column's current width in pixels.
     */ getColumnWidth(column) {
        const vp = this.viewport;
        const widthValue = this.columnWidths[column.id];
        const minWidth = $6f79c776b6dd1900$var$ResizingMode.getMinWidth(column);
        if (!$6f79c776b6dd1900$var$defined(widthValue)) {
            const tbody = vp.tbodyElement;
            const freeWidth = tbody.getBoundingClientRect().width - this.calculateOccupiedWidth() - tbody.offsetWidth + tbody.clientWidth;
            const freeColumns = (vp.grid.enabledColumns?.length || 0) - Object.keys(this.columnWidths).length;
            // If undefined width:
            return Math.max(freeWidth / freeColumns, minWidth);
        }
        if (this.columnWidthUnits[column.id] === 0) // If px:
        return widthValue;
        // If %:
        return Math.max(vp.getWidthFromRatio(widthValue / 100), minWidth);
    }
    /**
     * Performs important calculations when the column is loaded.
     *
     * @param column
     * The column that is loaded.
     */ loadColumn(column) {
        const rawWidth = column.options.width;
        if (!rawWidth) return;
        let value;
        let unitCode = 0;
        if (typeof rawWidth === 'number') {
            value = rawWidth;
            unitCode = 0;
        } else {
            value = parseFloat(rawWidth);
            unitCode = rawWidth.charAt(rawWidth.length - 1) === '%' ? 1 : 0;
        }
        this.columnWidthUnits[column.id] = unitCode;
        this.columnWidths[column.id] = value;
    }
    /**
     * Loads the column to the distribution strategy. Should be called before
     * the table is rendered.
     */ loadColumns() {
        const { columns: columns } = this.viewport;
        for(let i = 0, iEnd = columns.length; i < iEnd; ++i)this.loadColumn(columns[i]);
    }
    /**
     * Recaulculates the changing dimentions of the table.
     */ reflow() {
        const vp = this.viewport;
        let rowsWidth = 0;
        for(let i = 0, iEnd = vp.columns.length; i < iEnd; ++i)rowsWidth += this.getColumnWidth(vp.columns[i]);
        vp.rowsWidth = rowsWidth;
    }
    /* *
     *
     * Static Methods
     *
     * */ /**
     * Returns the minimum width of the column.
     *
     * @param column
     * The column to get the minimum width for.
     *
     * @returns
     * The minimum width in pixels.
     */ static getMinWidth(column) {
        const tableColumnEl = column.cells[0]?.htmlElement;
        const headerColumnEl = column.header?.htmlElement;
        const getElPaddings = (el)=>($6f79c776b6dd1900$var$getStyle(el, 'padding-left', true) || 0) + ($6f79c776b6dd1900$var$getStyle(el, 'padding-right', true) || 0) + ($6f79c776b6dd1900$var$getStyle(el, 'border-left', true) || 0) + ($6f79c776b6dd1900$var$getStyle(el, 'border-right', true) || 0);
        let result = $6f79c776b6dd1900$var$ResizingMode.MIN_COLUMN_WIDTH;
        if (tableColumnEl) result = Math.max(result, getElPaddings(tableColumnEl));
        if (headerColumnEl) result = Math.max(result, getElPaddings(headerColumnEl));
        return result;
    }
    /**
     * Calculates defined (px and %) widths of all columns with non-undefined
     * widths in the grid. Total in px.
     */ calculateOccupiedWidth() {
        const vp = this.viewport;
        let occupiedWidth = 0;
        let unit, width;
        const columnIds = Object.keys(this.columnWidths);
        let columnId;
        for(let i = 0, iEnd = columnIds.length; i < iEnd; ++i){
            columnId = columnIds[i];
            unit = this.columnWidthUnits[columnId];
            if (unit === 0) {
                occupiedWidth += this.columnWidths[columnId];
                continue;
            }
            width = this.columnWidths[columnId];
            occupiedWidth += vp.getWidthFromRatio(width / 100);
        }
        return occupiedWidth;
    }
}
/* *
*
*  Static Properties
*
* */ /**
 * The minimum width of a column.
 * @internal
 */ $6f79c776b6dd1900$var$ResizingMode.MIN_COLUMN_WIDTH = 20;
var /* *
 *
 *  Default Export
 *
 * */ $6f79c776b6dd1900$export$2e2bcd8739ae039 = $6f79c776b6dd1900$var$ResizingMode;

});

parcelRegister("hhH3c", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9556b2d70c15d0b$export$2e2bcd8739ae039);
/* *
 *
 *  Adjacent Resizing Mode class
 *
 *  (c) 2020-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Dawid Dragula
 *
 * */ 
var $9znIs = parcelRequire("9znIs");
'use strict';
/* *
 *
 *  Class
 *
 * */ class $c9556b2d70c15d0b$var$AdjacentResizingMode extends (0, $9znIs.default) {
    constructor(){
        /* *
         *
         *  Properties
         *
         * */ super(...arguments);
        this.type = 'adjacent';
    }
    /* *
     *
     *  Methods
     *
     * */ resize(resizer, diff) {
        const vp = this.viewport;
        const column = resizer.draggedColumn;
        if (!column) return;
        const colW = resizer.columnStartWidth ?? 0;
        const minWidth = (0, $9znIs.default).getMinWidth(column);
        const nextCol = vp.columns[column.index + 1];
        const newW = Math.round(Math.max(colW + diff, minWidth) * 10) / 10;
        this.columnWidths[column.id] = newW;
        this.columnWidthUnits[column.id] = 0; // Always save in px
        column.setOptions({
            width: newW
        });
        if (nextCol) {
            const newNextW = this.columnWidths[nextCol.id] = Math.round(Math.max((resizer.nextColumnStartWidth ?? 0) + colW - newW, minWidth) * 10) / 10;
            this.columnWidthUnits[nextCol.id] = 0; // Always save in px
            nextCol.setOptions({
                width: newNextW
            });
        }
    }
}
var /* *
 *
 *  Default Export
 *
 * */ $c9556b2d70c15d0b$export$2e2bcd8739ae039 = $c9556b2d70c15d0b$var$AdjacentResizingMode;

});

parcelRegister("dK2c3", function(module, exports) {

$parcel$export(module.exports, "default", () => $a01145cb3d37a04d$export$2e2bcd8739ae039);
/* *
 *
 *  Independent Resizing Mode class
 *
 *  (c) 2020-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Dawid Dragula
 *
 * */ 
var $9znIs = parcelRequire("9znIs");
'use strict';
/* *
 *
 *  Class
 *
 * */ class $a01145cb3d37a04d$var$IndependentResizingMode extends (0, $9znIs.default) {
    constructor(){
        /* *
         *
         *  Properties
         *
         * */ super(...arguments);
        this.type = 'independent';
    }
    /* *
     *
     *  Methods
     *
     * */ resize(resizer, diff) {
        const column = resizer.draggedColumn;
        if (!column) return;
        // Set the width of the resized column.
        const width = this.columnWidths[column.id] = Math.round(Math.max((resizer.columnStartWidth || 0) + diff, (0, $9znIs.default).getMinWidth(column)) * 10) / 10;
        this.columnWidthUnits[column.id] = 0; // Set to px
        // Change width units of all columns on the right to px.
        const vp = this.viewport;
        const colIndex = column.index;
        for(let i = colIndex; i < vp.columns.length; ++i){
            const rightCol = vp.columns[i];
            const rcWidth = this.columnWidths[rightCol.id] = rightCol.getWidth();
            this.columnWidthUnits[rightCol.id] = 0; // Set to px
            rightCol.setOptions({
                width: rcWidth
            });
        }
        column.setOptions({
            width: width
        });
    }
}
var /* *
 *
 *  Default Export
 *
 * */ $a01145cb3d37a04d$export$2e2bcd8739ae039 = $a01145cb3d37a04d$var$IndependentResizingMode;

});

parcelRegister("lT4GX", function(module, exports) {

$parcel$export(module.exports, "default", () => $fef25fc018fbdcfd$export$2e2bcd8739ae039);
/* *
 *
 *  Distributed Resizing Mode class
 *
 *  (c) 2020-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Dawid Dragula
 *
 * */ 
var $9znIs = parcelRequire("9znIs");
'use strict';
/* *
 *
 *  Class
 *
 * */ class $fef25fc018fbdcfd$var$DistributedResizingMode extends (0, $9znIs.default) {
    constructor(){
        /* *
         *
         *  Properties
         *
         * */ super(...arguments);
        this.type = 'distributed';
    }
    /* *
     *
     *  Methods
     *
     * */ resize(resizer, diff) {
        const column = resizer.draggedColumn;
        if (!column) return;
        // Set the width of the resized column.
        const width = this.columnWidths[column.id] = Math.round(Math.max((resizer.columnStartWidth || 0) + diff, (0, $9znIs.default).getMinWidth(column)) * 10) / 10;
        this.columnWidthUnits[column.id] = 0; // Set to px
        column.setOptions({
            width: width
        });
    }
}
var /* *
 *
 *  Default Export
 *
 * */ $fef25fc018fbdcfd$export$2e2bcd8739ae039 = $fef25fc018fbdcfd$var$DistributedResizingMode;

});


parcelRegister("6GqCF", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ddb51054679abb5$export$2e2bcd8739ae039);
/* *
 *
 *  (c) 2009-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Sophie Bremer
 *  - Wojciech Chmiel
 *  - Gøran Slettemark
 *  - Dawid Dragula
 *  - Kamil Kubik
 *
 * */ 
var $7fvOS = parcelRequire("7fvOS");

var $5PVyc = parcelRequire("5PVyc");

var $l3aRA = parcelRequire("l3aRA");
'use strict';
const { addEvent: $4ddb51054679abb5$var$addEvent, fireEvent: $4ddb51054679abb5$var$fireEvent, merge: $4ddb51054679abb5$var$merge, pick: $4ddb51054679abb5$var$pick } = (0, $l3aRA.default);
/* *
 *
 *  Class
 *
 * */ /**
 * Abstract class providing an interface for managing a DataConnector.
 */ class $4ddb51054679abb5$var$DataConnector {
    /**
     * Whether the connector is currently polling for new data.
     */ get polling() {
        return !!this._polling;
    }
    /* *
     *
     *  Constructor
     *
     * */ /**
     * Constructor for the connector class.
     *
     * @param {DataConnectorOptions} [options]
     * Options to use in the connector.
     */ constructor(options){
        /**
         * Tables managed by this DataConnector instance.
         */ this.dataTables = {};
        /**
         * Helper flag for detecting whether the data connector is loaded.
         * @internal
         */ this.loaded = false;
        this.metadata = options.metadata || {
            columns: {}
        };
        this.options = options;
        // Create a data table for each defined in the dataTables user options.
        const dataTables = options?.dataTables;
        let dataTableIndex = 0;
        if (options.options) // eslint-disable-next-line no-console
        console.error('The `DataConnectorOptions.options` property was removed in Dashboards v4.0.0. Check how to upgrade your connector to use the new options structure here: https://api.highcharts.com/dashboards/#interfaces/Data_DataTableOptions.DataTableOptions');
        if (dataTables && dataTables?.length > 0) for(let i = 0, iEnd = dataTables.length; i < iEnd; ++i){
            const dataTable = dataTables[i];
            const key = dataTable?.key;
            this.dataTables[key ?? dataTableIndex] = new (0, $5PVyc.default)(dataTable);
            if (!key) dataTableIndex++;
        }
        else // If user options dataTables is not defined, generate a default
        // table.
        this.dataTables[0] = new (0, $5PVyc.default)({
            id: options.id // Required by DataTableCore
        });
    }
    /* *
     *
     *  Methods
     *
     * */ /**
     * Returns a single data table instance based on the provided key.
     * Otherwise, returns the first data table.
     *
     * @param {string} [key]
     * The data table key.
     *
     * @return {DataTable}
     * The data table instance.
     */ getTable(key) {
        if (key) return this.dataTables[key];
        return Object.values(this.dataTables)[0];
    }
    /**
     * Method for adding metadata for a single column.
     *
     * @param {string} name
     * The name of the column to be described.
     *
     * @param {DataConnector.MetaColumn} columnMeta
     * The metadata to apply to the column.
     */ describeColumn(name, columnMeta) {
        const connector = this;
        const columns = connector.metadata.columns;
        columns[name] = $4ddb51054679abb5$var$merge(columns[name] || {}, columnMeta);
    }
    /**
     * Method for applying columns meta information to the whole DataConnector.
     *
     * @param {Highcharts.Dictionary<DataConnector.MetaColumn>} columns
     * Pairs of column names and MetaColumn objects.
     */ describeColumns(columns) {
        const connector = this;
        const columnIds = Object.keys(columns);
        let columnId;
        while(typeof (columnId = columnIds.pop()) === 'string')connector.describeColumn(columnId, columns[columnId]);
    }
    /**
     * Returns the order of columns.
     *
     * @return {string[] | undefined}
     * Order of columns.
     */ getColumnOrder() {
        const connector = this, columns = connector.metadata.columns, names = Object.keys(columns || {});
        if (names.length) return names.sort((a, b)=>$4ddb51054679abb5$var$pick(columns[a].index, 0) - $4ddb51054679abb5$var$pick(columns[b].index, 0));
    }
    /**
     * Retrieves the columns of the dataTable,
     * applies column order from meta.
     *
     * @return {Highcharts.DataTableColumnCollection}
     * An object with the properties `columnIds` and `columnValues`
     */ getSortedColumns() {
        return this.getTable().getColumns(this.getColumnOrder());
    }
    /**
     * Sets the index and order of columns.
     *
     * @param {Array<string>} columnIds
     * Order of columns.
     */ setColumnOrder(columnIds) {
        const connector = this;
        for(let i = 0, iEnd = columnIds.length; i < iEnd; ++i)connector.describeColumn(columnIds[i], {
            index: i
        });
    }
    /**
     * The default load method, which fires the `afterLoad` event
     *
     * @return {Promise<DataConnector>}
     * The loaded connector.
     *
     * @emits DataConnector#afterLoad
     */ load() {
        this.emit({
            type: 'afterLoad'
        });
        return Promise.resolve(this);
    }
    /**
     * Applies the data modifiers to the data tables according to the
     * connector data tables options.
     */ async applyTableModifiers() {
        const tableOptionsArray = this.options?.dataTables;
        for (const [key, table] of Object.entries(this.dataTables)){
            // Take data modifier options from the corresponsing data table
            // options, otherwise take the data modifier options from the
            // connector options.
            const dataModifierOptions = tableOptionsArray?.find((dataTable)=>dataTable.key === key)?.dataModifier ?? this.options?.dataModifier;
            const ModifierClass = dataModifierOptions && (0, $7fvOS.default).types[dataModifierOptions.type];
            await table.setModifier(ModifierClass ? new ModifierClass(dataModifierOptions) : void 0);
        }
        return this;
    }
    /**
     * Starts polling new data after the specific time span in milliseconds.
     *
     * @param {number} refreshTime
     * Refresh time in milliseconds between polls.
     */ startPolling(refreshTime = 1000) {
        const connector = this;
        // Assign a new abort controller.
        this.pollingController = new AbortController();
        // Clear the polling timeout.
        window.clearTimeout(connector._polling);
        connector._polling = window.setTimeout(()=>connector.load()['catch']((error)=>connector.emit({
                    type: 'loadError',
                    error: error
                })).then(()=>{
                if (connector._polling) connector.startPolling(refreshTime);
            }), refreshTime);
    }
    /**
     * Stops polling data. Shouldn't be performed if polling is already stopped.
     */ stopPolling() {
        const connector = this;
        if (!connector.polling) return;
        // Abort the existing request.
        connector?.pollingController?.abort();
        // Clear the polling timeout.
        window.clearTimeout(connector._polling);
        delete connector._polling;
    }
    /**
     * Emits an event on the connector to all registered callbacks of this
     * event.
     *
     * @param {DataConnector.Event} e
     * Event object containing additional event information.
     */ emit(e) {
        $4ddb51054679abb5$var$fireEvent(this, e.type, e);
    }
    /**
     * Registers a callback for a specific connector event.
     *
     * @param type
     * Event type.
     *
     * @param callback
     * Function to register for the connector callback.
     *
     * @return {Function}
     * Function to unregister callback from the connector event.
     */ on(type, callback) {
        return $4ddb51054679abb5$var$addEvent(this, type, callback);
    }
    /**
     * Iterates over the dataTables and initiates the corresponding converters.
     * Updates the dataTables and assigns the first converter.
     *
     * @param {T}[data]
     * Data specific to the corresponding converter.
     *
     * @param {DataConnector.CreateConverterFunction}[createConverter]
     * Creates a specific converter combining the dataTable options.
     *
     * @param {DataConnector.ParseDataFunction<T>}[parseData]
     * Runs the converter parse method with the specific data type.
     */ initConverters(data, createConverter, parseData) {
        let index = 0;
        for (const [key, table] of Object.entries(this.dataTables)){
            // Create a proper converter and parse its data.
            const converter = createConverter(key);
            const columns = parseData(converter, data);
            // Update the dataTable.
            table.deleteColumns();
            table.setColumns(columns);
            // Assign the first converter.
            if (index === 0) this.converter = converter;
            index++;
        }
    }
}
/* *
 *
 *  Class Namespace
 *
 * */ (function(DataConnector) {
    /* *
     *
     *  Declarations
     *
     * */ /* *
     *
     *  Constants
     *
     * */ /**
     * Registry as a record object with connector names and their class.
     */ DataConnector.types = {};
    /* *
     *
     *  Functions
     *
     * */ /**
     * Adds a connector class to the registry. The connector has to provide the
     * `DataConnector.options` property and the `DataConnector.load` method to
     * modify the table.
     *
     * @private
     *
     * @param {string} key
     * Registry key of the connector class.
     *
     * @param {DataConnectorType} DataConnectorClass
     * Connector class (aka class constructor) to register.
     *
     * @return {boolean}
     * Returns true, if the registration was successful. False is returned, if
     * their is already a connector registered with this key.
     */ function registerType(key, DataConnectorClass) {
        return !!key && !DataConnector.types[key] && !!(DataConnector.types[key] = DataConnectorClass);
    }
    DataConnector.registerType = registerType;
})($4ddb51054679abb5$var$DataConnector || ($4ddb51054679abb5$var$DataConnector = {}));
var /* *
 *
 *  Default Export
 *
 * */ $4ddb51054679abb5$export$2e2bcd8739ae039 = $4ddb51054679abb5$var$DataConnector;

});
parcelRegister("7fvOS", function(module, exports) {

$parcel$export(module.exports, "default", () => $54729dd7dfdc0aa6$export$2e2bcd8739ae039);
/* *
 *
 *  (c) 2009-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Sophie Bremer
 *  - Gøran Slettemark
 *  - Dawid Dragula
 *
 * */ 
var $l3aRA = parcelRequire("l3aRA");
'use strict';
const { addEvent: $54729dd7dfdc0aa6$var$addEvent, fireEvent: $54729dd7dfdc0aa6$var$fireEvent, merge: $54729dd7dfdc0aa6$var$merge } = (0, $l3aRA.default);
/* *
 *
 *  Class
 *
 * */ /**
 * Abstract class to provide an interface for modifying a table.
 */ class $54729dd7dfdc0aa6$var$DataModifier {
    /* *
     *
     *  Functions
     *
     * */ /**
     * Runs a timed execution of the modifier on the given datatable.
     * Can be configured to run multiple times.
     *
     * @param {DataTable} dataTable
     * The datatable to execute
     *
     * @param {DataModifier.BenchmarkOptions} options
     * Options. Currently supports `iterations` for number of iterations.
     *
     * @return {Array<number>}
     * An array of times in milliseconds
     *
     */ benchmark(dataTable, options) {
        const results = [];
        const modifier = this;
        const execute = ()=>{
            modifier.modifyTable(dataTable);
            modifier.emit({
                type: 'afterBenchmarkIteration'
            });
        };
        const defaultOptions = {
            iterations: 1
        };
        const { iterations: iterations } = $54729dd7dfdc0aa6$var$merge(defaultOptions, options);
        modifier.on('afterBenchmarkIteration', ()=>{
            if (results.length === iterations) {
                modifier.emit({
                    type: 'afterBenchmark',
                    results: results
                });
                return;
            }
            // Run again
            execute();
        });
        const times = {
            startTime: 0,
            endTime: 0
        };
        // Add timers
        modifier.on('modify', ()=>{
            times.startTime = window.performance.now();
        });
        modifier.on('afterModify', ()=>{
            times.endTime = window.performance.now();
            results.push(times.endTime - times.startTime);
        });
        // Initial run
        execute();
        return results;
    }
    /**
     * Emits an event on the modifier to all registered callbacks of this event.
     *
     * @param {DataModifier.Event} [e]
     * Event object containing additonal event information.
     */ emit(e) {
        $54729dd7dfdc0aa6$var$fireEvent(this, e.type, e);
    }
    /**
     * Modifies the given table and sets its `modified` property as a reference
     * to the modified table. If `modified` property does not exist on the
     * original table, it's always created.
     *
     * @param {Highcharts.DataTable} table
     * Table to modify.
     *
     * @param {DataEvent.Detail} [eventDetail]
     * Custom information for pending events.
     *
     * @return {Promise<Highcharts.DataTable>}
     * Table with `modified` property as a reference.
     */ modify(table, eventDetail) {
        const modifier = this;
        return new Promise((resolve, reject)=>{
            if (!table.modified) table.modified = table.clone(false, eventDetail);
            try {
                resolve(modifier.modifyTable(table, eventDetail));
            } catch (e) {
                modifier.emit({
                    type: 'error',
                    detail: eventDetail,
                    table: table
                });
                reject(e instanceof Error ? e : new Error('' + e));
            }
        });
    }
    /**
     * Registers a callback for a specific modifier event.
     *
     * @param {string} type
     * Event type as a string.
     *
     * @param {DataEventEmitter.Callback} callback
     * Function to register for an modifier callback.
     *
     * @return {Function}
     * Function to unregister callback from the modifier event.
     */ on(type, callback) {
        return $54729dd7dfdc0aa6$var$addEvent(this, type, callback);
    }
}
/* *
 *
 *  Class Namespace
 *
 * */ /**
 * Additionally provided types for modifier events and options.
 */ (function(DataModifier) {
    /* *
     *
     *  Declarations
     *
     * */ /* *
     *
     *  Constants
     *
     * */ /**
     * Registry as a record object with modifier names and their class
     * constructor.
     */ DataModifier.types = {};
    /* *
     *
     *  Functions
     *
     * */ /**
     * Adds a modifier class to the registry. The modifier class has to provide
     * the `DataModifier.options` property and the `DataModifier.modifyTable`
     * method to modify the table.
     *
     * @private
     *
     * @param {string} key
     * Registry key of the modifier class.
     *
     * @param {DataModifierType} DataModifierClass
     * Modifier class (aka class constructor) to register.
     *
     * @return {boolean}
     * Returns true, if the registration was successful. False is returned, if
     * their is already a modifier registered with this key.
     */ function registerType(key, DataModifierClass) {
        return !!key && !DataModifier.types[key] && !!(DataModifier.types[key] = DataModifierClass);
    }
    DataModifier.registerType = registerType;
})($54729dd7dfdc0aa6$var$DataModifier || ($54729dd7dfdc0aa6$var$DataModifier = {}));
var /* *
 *
 *  Default Export
 *
 * */ $54729dd7dfdc0aa6$export$2e2bcd8739ae039 = $54729dd7dfdc0aa6$var$DataModifier;

});

parcelRegister("5PVyc", function(module, exports) {

$parcel$export(module.exports, "default", () => $43fe5b800d4cd23a$export$2e2bcd8739ae039);
/* *
 *
 *  (c) 2009-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Sophie Bremer
 *  - Gøran Slettemark
 *  - Jomar Hønsi
 *  - Dawid Dragula
 *
 * */ 
var $jphPm = parcelRequire("jphPm");

var $arnqq = parcelRequire("arnqq");

var $l3aRA = parcelRequire("l3aRA");
'use strict';
const { splice: $43fe5b800d4cd23a$var$splice, setLength: $43fe5b800d4cd23a$var$setLength } = (0, $arnqq.default);
const { addEvent: $43fe5b800d4cd23a$var$addEvent, defined: $43fe5b800d4cd23a$var$defined, extend: $43fe5b800d4cd23a$var$extend, fireEvent: $43fe5b800d4cd23a$var$fireEvent, isNumber: $43fe5b800d4cd23a$var$isNumber, uniqueKey: $43fe5b800d4cd23a$var$uniqueKey } = (0, $l3aRA.default);
/* *
 *
 *  Class
 *
 * */ /**
 * Class to manage columns and rows in a table structure. It provides methods
 * to add, remove, and manipulate columns and rows, as well as to retrieve data
 * from specific cells.
 *
 * @class
 * @name Highcharts.DataTable
 *
 * @param {Highcharts.DataTableOptions} [options]
 * Options to initialize the new DataTable instance.
 */ class $43fe5b800d4cd23a$var$DataTable extends (0, $jphPm.default) {
    /* *
     *
     *  Constructor
     *
     * */ constructor(options = {}){
        super(options);
        this.metadata = options.metadata;
    }
    /* *
     *
     *  Functions
     *
     * */ /**
     * Returns a clone of this table. The cloned table is completely independent
     * of the original, and any changes made to the clone will not affect
     * the original table.
     *
     * @function Highcharts.DataTable#clone
     *
     * @param {boolean} [skipColumns]
     * Whether to clone columns or not.
     *
     * @param {Highcharts.DataTableEventDetail} [eventDetail]
     * Custom information for pending events.
     *
     * @return {Highcharts.DataTable}
     * Clone of this data table.
     *
     * @emits #cloneTable
     * @emits #afterCloneTable
     */ clone(skipColumns, eventDetail) {
        const table = this, tableOptions = {};
        table.emit({
            type: 'cloneTable',
            detail: eventDetail
        });
        if (!skipColumns) tableOptions.columns = table.columns;
        if (!table.autoId) tableOptions.id = table.id;
        const tableClone = new $43fe5b800d4cd23a$var$DataTable(tableOptions);
        if (!skipColumns) {
            tableClone.versionTag = table.versionTag;
            tableClone.originalRowIndexes = table.originalRowIndexes;
            tableClone.localRowIndexes = table.localRowIndexes;
        }
        tableClone.metadata = {
            ...table.metadata
        };
        table.emit({
            type: 'afterCloneTable',
            detail: eventDetail,
            tableClone: tableClone
        });
        return tableClone;
    }
    /**
     * Deletes columns from the table.
     *
     * @function Highcharts.DataTable#deleteColumns
     *
     * @param {Array<string>} [columnIds]
     * Names of columns to delete. If no array is provided, all
     * columns will be deleted.
     *
     * @param {Highcharts.DataTableEventDetail} [eventDetail]
     * Custom information for pending events.
     *
     * @return {Highcharts.DataTableColumnCollection|undefined}
     * Returns the deleted columns, if found.
     *
     * @emits #deleteColumns
     * @emits #afterDeleteColumns
     */ deleteColumns(columnIds, eventDetail) {
        const table = this, columns = table.columns, deletedColumns = {}, modifiedColumns = {}, modifier = table.modifier, rowCount = table.rowCount;
        columnIds = columnIds || Object.keys(columns);
        if (columnIds.length) {
            table.emit({
                type: 'deleteColumns',
                columnIds: columnIds,
                detail: eventDetail
            });
            for(let i = 0, iEnd = columnIds.length, column, columnId; i < iEnd; ++i){
                columnId = columnIds[i];
                column = columns[columnId];
                if (column) {
                    deletedColumns[columnId] = column;
                    modifiedColumns[columnId] = new Array(rowCount);
                }
                delete columns[columnId];
            }
            if (!Object.keys(columns).length) {
                table.rowCount = 0;
                this.deleteRowIndexReferences();
            }
            if (modifier) modifier.modifyTable(table);
            table.emit({
                type: 'afterDeleteColumns',
                columns: deletedColumns,
                columnIds: columnIds,
                detail: eventDetail
            });
            return deletedColumns;
        }
    }
    /**
     * Deletes the row index references. This is useful when the original table
     * is deleted, and the references are no longer needed. This table is
     * then considered an original table or a table that has the same rows
     * order as the original table.
     */ deleteRowIndexReferences() {
        delete this.originalRowIndexes;
        delete this.localRowIndexes;
    }
    /**
     * Deletes rows in this table.
     *
     * @function Highcharts.DataTable#deleteRows
     *
     * @param {number} [rowIndex]
     * Index to start delete of rows. If not specified, all rows will be
     * deleted.
     *
     * @param {number} [rowCount=1]
     * Number of rows to delete.
     *
     * @param {Highcharts.DataTableEventDetail} [eventDetail]
     * Custom information for pending events.
     *
     * @return {Array<Highcharts.DataTableRow>}
     * Returns the deleted rows, if found.
     *
     * @emits #deleteRows
     * @emits #afterDeleteRows
     */ deleteRows(rowIndex, rowCount = 1, eventDetail) {
        const table = this, deletedRows = [], modifiedRows = [], modifier = table.modifier;
        table.emit({
            type: 'deleteRows',
            detail: eventDetail,
            rowCount: rowCount,
            rowIndex: rowIndex || 0
        });
        if (typeof rowIndex === 'undefined') {
            rowIndex = 0;
            rowCount = table.rowCount;
        }
        if (rowCount > 0 && rowIndex < table.rowCount) {
            const columns = table.columns, columnIds = Object.keys(columns);
            for(let i = 0, iEnd = columnIds.length, column, deletedCells, columnId; i < iEnd; ++i){
                columnId = columnIds[i];
                column = columns[columnId];
                const result = $43fe5b800d4cd23a$var$splice(column, rowIndex, rowCount);
                deletedCells = result.removed;
                columns[columnId] = column = result.array;
                if (!i) table.rowCount = column.length;
                for(let j = 0, jEnd = deletedCells.length; j < jEnd; ++j){
                    deletedRows[j] = deletedRows[j] || [];
                    deletedRows[j][i] = deletedCells[j];
                }
                modifiedRows.push(new Array(iEnd));
            }
        }
        if (modifier) modifier.modifyTable(table);
        table.emit({
            type: 'afterDeleteRows',
            detail: eventDetail,
            rowCount: rowCount,
            rowIndex: rowIndex || 0,
            rows: deletedRows
        });
        return deletedRows;
    }
    /**
     * Emits an event on this table to all registered callbacks of the given
     * event.
     * @private
     *
     * @param {DataTable.Event} e
     * Event object with event information.
     */ emit(e) {
        if ([
            'afterDeleteColumns',
            'afterDeleteRows',
            'afterSetCell',
            'afterSetColumns',
            'afterSetRows'
        ].includes(e.type)) this.versionTag = $43fe5b800d4cd23a$var$uniqueKey();
        $43fe5b800d4cd23a$var$fireEvent(this, e.type, e);
    }
    /**
     * Fetches a single cell value.
     *
     * @function Highcharts.DataTable#getCell
     *
     * @param {string} columnId
     * Column name of the cell to retrieve.
     *
     * @param {number} rowIndex
     * Row index of the cell to retrieve.
     *
     * @return {Highcharts.DataTableCellType|undefined}
     * Returns the cell value or `undefined`.
     */ getCell(columnId, rowIndex) {
        const table = this;
        const column = table.columns[columnId];
        if (column) return column[rowIndex];
    }
    /**
     * Fetches the given column by the canonical column name.
     * This function is a simplified wrap of {@link getColumns}.
     *
     * @function Highcharts.DataTable#getColumn
     *
     * @param {string} columnId
     * Name of the column to get.
     *
     * @param {boolean} [asReference]
     * Whether to return the column as a readonly reference.
     *
     * @return {Highcharts.DataTableColumn|undefined}
     * A copy of the column, or `undefined` if not found.
     */ getColumn(columnId, asReference) {
        return this.getColumns([
            columnId
        ], asReference)[columnId];
    }
    /**
     * Fetches all column IDs.
     *
     * @function Highcharts.DataTable#getColumnIds
     *
     * @return {Array<string>}
     * Returns all column IDs.
     */ getColumnIds() {
        return Object.keys(this.columns);
    }
    /**
     * Retrieves all or the given columns.
     *
     * @function Highcharts.DataTable#getColumns
     *
     * @param {Array<string>} [columnIds]
     * Column names to retrieve.
     *
     * @param {boolean} [asReference]
     * Whether to return columns as a readonly reference.
     *
     * @param {boolean} [asBasicColumns]
     * Whether to transform all typed array columns to normal arrays.
     *
     * @return {Highcharts.DataTableColumnCollection}
     * Collection of columns. If a requested column was not found, it is
     * `undefined`.
     */ getColumns(columnIds, asReference, asBasicColumns) {
        const table = this, tableColumns = table.columns, columns = {};
        columnIds = columnIds || Object.keys(tableColumns);
        for(let i = 0, iEnd = columnIds.length, column, columnId; i < iEnd; ++i){
            columnId = columnIds[i];
            column = tableColumns[columnId];
            if (column) {
                if (asReference) columns[columnId] = column;
                else if (asBasicColumns && !Array.isArray(column)) columns[columnId] = Array.from(column);
                else columns[columnId] = column.slice();
            }
        }
        return columns;
    }
    /**
     * Takes the original row index and returns the local row index in the
     * modified table for which this function is called.
     *
     * @param {number} originalRowIndex
     * Original row index to get the local row index for.
     *
     * @return {number|undefined}
     * Returns the local row index or `undefined` if not found.
     */ getLocalRowIndex(originalRowIndex) {
        const { localRowIndexes: localRowIndexes } = this;
        if (localRowIndexes) return localRowIndexes[originalRowIndex];
        return originalRowIndex;
    }
    /**
     * Returns the modifier associated with this table, if any.
     *
     * @return {Highcharts.DataModifier|undefined}
     * Returns the modifier or `undefined`.
     *
     * @private
     */ getModifier() {
        return this.modifier;
    }
    /**
     * Takes the local row index and returns the index of the corresponding row
     * in the original table.
     *
     * @param {number} rowIndex
     * Local row index to get the original row index for.
     *
     * @return {number|undefined}
     * Returns the original row index or `undefined` if not found.
     */ getOriginalRowIndex(rowIndex) {
        const { originalRowIndexes: originalRowIndexes } = this;
        if (originalRowIndexes) return originalRowIndexes[rowIndex];
        return rowIndex;
    }
    /**
     * Retrieves the row at a given index. This function is a simplified wrap of
     * {@link getRows}.
     *
     * @function Highcharts.DataTable#getRow
     *
     * @param {number} rowIndex
     * Row index to retrieve. First row has index 0.
     *
     * @param {Array<string>} [columnIds]
     * Column names in order to retrieve.
     *
     * @return {Highcharts.DataTableRow}
     * Returns the row values, or `undefined` if not found.
     */ getRow(rowIndex, columnIds) {
        return this.getRows(rowIndex, 1, columnIds)[0];
    }
    /**
     * Returns the number of rows in this table.
     *
     * @function Highcharts.DataTable#getRowCount
     *
     * @return {number}
     * Number of rows in this table.
     */ getRowCount() {
        // @todo Implement via property getter `.length` browsers supported
        return this.rowCount;
    }
    /**
     * Retrieves the index of the first row matching a specific cell value.
     *
     * @function Highcharts.DataTable#getRowIndexBy
     *
     * @param {string} columnId
     * Column to search in.
     *
     * @param {Highcharts.DataTableCellType} cellValue
     * Cell value to search for. `NaN` and `undefined` are not supported.
     *
     * @param {number} [rowIndexOffset]
     * Index offset to start searching.
     *
     * @return {number|undefined}
     * Index of the first row matching the cell value.
     */ getRowIndexBy(columnId, cellValue, rowIndexOffset) {
        const table = this;
        const column = table.columns[columnId];
        if (column) {
            let rowIndex = -1;
            if (Array.isArray(column)) // Normal array
            rowIndex = column.indexOf(cellValue, rowIndexOffset);
            else if ($43fe5b800d4cd23a$var$isNumber(cellValue)) // Typed array
            rowIndex = column.indexOf(cellValue, rowIndexOffset);
            if (rowIndex !== -1) return rowIndex;
        }
    }
    /**
     * Retrieves the row at a given index. This function is a simplified wrap of
     * {@link getRowObjects}.
     *
     * @function Highcharts.DataTable#getRowObject
     *
     * @param {number} rowIndex
     * Row index.
     *
     * @param {Array<string>} [columnIds]
     * Column names and their order to retrieve.
     *
     * @return {Highcharts.DataTableRowObject}
     * Returns the row values, or `undefined` if not found.
     */ getRowObject(rowIndex, columnIds) {
        return this.getRowObjects(rowIndex, 1, columnIds)[0];
    }
    /**
     * Fetches all or a number of rows as an object.
     *
     * @function Highcharts.DataTable#getRowObjects
     *
     * @param {number} [rowIndex]
     * Index of the first row to fetch. Defaults to first row at index `0`.
     *
     * @param {number} [rowCount]
     * Number of rows to fetch. Defaults to maximal number of rows.
     *
     * @param {Array<string>} [columnIds]
     * Column names and their order to retrieve.
     *
     * @return {Highcharts.DataTableRowObject}
     * Returns retrieved rows.
     */ getRowObjects(rowIndex = 0, rowCount = this.rowCount - rowIndex, columnIds) {
        const table = this, columns = table.columns, rows = new Array(rowCount);
        columnIds = columnIds || Object.keys(columns);
        for(let i = rowIndex, i2 = 0, iEnd = Math.min(table.rowCount, rowIndex + rowCount), column, row; i < iEnd; ++i, ++i2){
            row = rows[i2] = {};
            for (const columnId of columnIds){
                column = columns[columnId];
                row[columnId] = column ? column[i] : void 0;
            }
        }
        return rows;
    }
    /**
     * Fetches all or a number of rows as an array.
     *
     * @function Highcharts.DataTable#getRows
     *
     * @param {number} [rowIndex]
     * Index of the first row to fetch. Defaults to first row at index `0`.
     *
     * @param {number} [rowCount]
     * Number of rows to fetch. Defaults to maximal number of rows.
     *
     * @param {Array<string>} [columnIds]
     * Column names and their order to retrieve.
     *
     * @return {Highcharts.DataTableRow}
     * Returns retrieved rows.
     */ getRows(rowIndex = 0, rowCount = this.rowCount - rowIndex, columnIds) {
        const table = this, columns = table.columns, rows = new Array(rowCount);
        columnIds = columnIds || Object.keys(columns);
        for(let i = rowIndex, i2 = 0, iEnd = Math.min(table.rowCount, rowIndex + rowCount), column, row; i < iEnd; ++i, ++i2){
            row = rows[i2] = [];
            for (const columnId of columnIds){
                column = columns[columnId];
                row.push(column ? column[i] : void 0);
            }
        }
        return rows;
    }
    /**
     * Returns the unique version tag of the current state of the table.
     *
     * @function Highcharts.DataTable#getVersionTag
     *
     * @return {string}
     * Unique version tag.
     */ getVersionTag() {
        return this.versionTag;
    }
    /**
     * Determines whether all specified column names exist in the table.
     *
     * @function Highcharts.DataTable#hasColumns
     *
     * @param {Array<string>} columnIds
     * Column names to check.
     *
     * @return {boolean}
     * Returns `true` if all columns have been found, otherwise `false`.
     */ hasColumns(columnIds) {
        const table = this, columns = table.columns;
        for(let i = 0, iEnd = columnIds.length, columnId; i < iEnd; ++i){
            columnId = columnIds[i];
            if (!columns[columnId]) return false;
        }
        return true;
    }
    /**
     * Checks if any row in the specified column contains the given cell value.
     *
     * @function Highcharts.DataTable#hasRowWith
     *
     * @param {string} columnId
     * Column to search in.
     *
     * @param {Highcharts.DataTableCellType} cellValue
     * Cell value to search for. `NaN` and `undefined` are not supported.
     *
     * @return {boolean}
     * True, if a row has been found, otherwise false.
     */ hasRowWith(columnId, cellValue) {
        const table = this;
        const column = table.columns[columnId];
        // Normal array
        if (Array.isArray(column)) return column.indexOf(cellValue) !== -1;
        // Typed array
        if ($43fe5b800d4cd23a$var$defined(cellValue) && Number.isFinite(cellValue)) return column.indexOf(+cellValue) !== -1;
        return false;
    }
    /**
     * Registers a callback function to be executed when a specific event is
     * emitted. To stop listening to the event, call the function returned by
     * this method.
     *
     * @function Highcharts.DataTable#on
     *
     * @param {string} type
     * Event type as a string.
     *
     * @param {Highcharts.EventCallbackFunction<Highcharts.DataTable>} callback
     * Function to register for an event callback.
     *
     * @return {Function}
     * Function to unregister callback from the event.
     */ on(type, callback) {
        return $43fe5b800d4cd23a$var$addEvent(this, type, callback);
    }
    /**
     * Changes the ID of an existing column to a new ID, effectively renaming
     * the column.
     *
     * @function Highcharts.DataTable#changeColumnId
     *
     * @param {string} columnId
     * Id of the column to be changed.
     *
     * @param {string} newColumnId
     * New id of the column.
     *
     * @return {boolean}
     * Returns `true` if successful, `false` if the column was not found.
     */ changeColumnId(columnId, newColumnId) {
        const table = this, columns = table.columns;
        if (columns[columnId]) {
            if (columnId !== newColumnId) {
                columns[newColumnId] = columns[columnId];
                delete columns[columnId];
            }
            return true;
        }
        return false;
    }
    /**
     * Sets the value of a specific cell identified by column ID and row index.
     * If the column does not exist, it will be created. If the row index is
     * beyond the current row count, the table will be expanded to accommodate
     * the new cell.
     *
     * @function Highcharts.DataTable#setCell
     *
     * @param {string} columnId
     * Column name to set.
     *
     * @param {number|undefined} rowIndex
     * Row index to set.
     *
     * @param {Highcharts.DataTableCellType} cellValue
     * Cell value to set.
     *
     * @param {Highcharts.DataTableEventDetail} [eventDetail]
     * Custom information for pending events.
     *
     * @emits #setCell
     * @emits #afterSetCell
     */ setCell(columnId, rowIndex, cellValue, eventDetail) {
        const table = this, columns = table.columns, modifier = table.modifier;
        let column = columns[columnId];
        if (column && column[rowIndex] === cellValue) return;
        table.emit({
            type: 'setCell',
            cellValue: cellValue,
            columnId: columnId,
            detail: eventDetail,
            rowIndex: rowIndex
        });
        if (!column) column = columns[columnId] = new Array(table.rowCount);
        if (rowIndex >= table.rowCount) table.rowCount = rowIndex + 1;
        column[rowIndex] = cellValue;
        if (modifier) modifier.modifyTable(table);
        table.emit({
            type: 'afterSetCell',
            cellValue: cellValue,
            columnId: columnId,
            detail: eventDetail,
            rowIndex: rowIndex
        });
    }
    /**
     * Replaces or updates multiple columns in the table with new data. If a
     * column does not exist, it will be created and added to the table.
     *
     * @function Highcharts.DataTable#setColumns
     *
     * @param {Highcharts.DataTableColumnCollection} columns
     * Columns as a collection, where the keys are the column names.
     *
     * @param {number} [rowIndex]
     * Index of the first row to change. Keep undefined to reset.
     *
     * @param {Highcharts.DataTableEventDetail} [eventDetail]
     * Custom information for pending events.
     *
     * @param {boolean} [typeAsOriginal=false]
     * Determines whether the original column retains its type when data
     * replaced. If `true`, the original column keeps its type. If not
     * (default), the original column will adopt the type of the replacement
     * column.
     *
     * @emits #setColumns
     * @emits #afterSetColumns
     */ setColumns(columns, rowIndex, eventDetail, typeAsOriginal) {
        const table = this, tableColumns = table.columns, tableModifier = table.modifier, columnIds = Object.keys(columns);
        let rowCount = table.rowCount;
        table.emit({
            type: 'setColumns',
            columns: columns,
            columnIds: columnIds,
            detail: eventDetail,
            rowIndex: rowIndex
        });
        if (!$43fe5b800d4cd23a$var$defined(rowIndex) && !typeAsOriginal) super.setColumns(columns, rowIndex, $43fe5b800d4cd23a$var$extend(eventDetail, {
            silent: true
        }));
        else {
            for(let i = 0, iEnd = columnIds.length, column, tableColumn, columnId, ArrayConstructor; i < iEnd; ++i){
                columnId = columnIds[i];
                column = columns[columnId];
                tableColumn = tableColumns[columnId];
                ArrayConstructor = Object.getPrototypeOf(tableColumn && typeAsOriginal ? tableColumn : column).constructor;
                if (!tableColumn) tableColumn = new ArrayConstructor(rowCount);
                else if (ArrayConstructor === Array) {
                    if (!Array.isArray(tableColumn)) tableColumn = Array.from(tableColumn);
                } else if (tableColumn.length < rowCount) {
                    tableColumn = new ArrayConstructor(rowCount);
                    tableColumn.set(tableColumns[columnId]);
                }
                tableColumns[columnId] = tableColumn;
                for(let i = rowIndex || 0, iEnd = column.length; i < iEnd; ++i)tableColumn[i] = column[i];
                rowCount = Math.max(rowCount, column.length);
            }
            this.applyRowCount(rowCount);
        }
        if (tableModifier) tableModifier.modifyTable(table);
        table.emit({
            type: 'afterSetColumns',
            columns: columns,
            columnIds: columnIds,
            detail: eventDetail,
            rowIndex: rowIndex
        });
    }
    /**
     * Assigns a new data modifier to the table.
     *
     * This method does not modify the table directly. Instead, it sets the
     * `.modified` property of the table with a modified copy of this table,
     * as produced by the modifier.
     *
     * @param {Highcharts.DataModifier} [modifier]
     * Modifier to set, or `undefined` to unset.
     *
     * @param {Highcharts.DataTableEventDetail} [eventDetail]
     * Custom information for pending events.
     *
     * @return {Promise<Highcharts.DataTable>}
     * Resolves to this table if successful, or rejects on failure.
     *
     * @emits #setModifier
     * @emits #afterSetModifier
     */ setModifier(modifier, eventDetail) {
        const table = this;
        let promise;
        table.emit({
            type: 'setModifier',
            detail: eventDetail,
            modifier: modifier,
            modified: table.getModified()
        });
        table.modifier = modifier;
        if (modifier) promise = modifier.modify(table);
        else promise = Promise.resolve(table);
        return promise.then((table)=>{
            table.emit({
                type: 'afterSetModifier',
                detail: eventDetail,
                modifier: modifier,
                modified: table.getModified()
            });
            return table;
        })['catch']((error)=>{
            table.emit({
                type: 'setModifierError',
                error: error,
                modifier: modifier,
                modified: table.getModified()
            });
            throw error;
        });
    }
    /**
     * Sets the original row indexes for the table. It is used to keep the
     * reference to the original rows when modifying the table.
     *
     * @param {Array<number|undefined>} originalRowIndexes
     * Original row indexes array.
     *
     * @param {boolean} omitLocalRowIndexes
     * Whether to omit the local row indexes calculation. Defaults to `false`.
     */ setOriginalRowIndexes(originalRowIndexes, omitLocalRowIndexes = false) {
        this.originalRowIndexes = originalRowIndexes;
        if (omitLocalRowIndexes) return;
        const modifiedIndexes = this.localRowIndexes = [];
        for(let i = 0, iEnd = originalRowIndexes.length, originalIndex; i < iEnd; ++i){
            originalIndex = originalRowIndexes[i];
            if ($43fe5b800d4cd23a$var$defined(originalIndex)) modifiedIndexes[originalIndex] = i;
        }
    }
    /**
     * Sets cell values of a row. Will insert a new row, if no index was
     * provided, or if the index is higher than the total number of table rows.
     *
     * Note: This function is just a simplified wrap of
     * {@link Highcharts.DataTable#setRows}.
     *
     * @function Highcharts.DataTable#setRow
     *
     * @param {Highcharts.DataTableRow|Highcharts.DataTableRowObject} row
     * Cell values to set.
     *
     * @param {number} [rowIndex]
     * Index of the row to set. Leave `undefined` to add as a new row.
     *
     * @param {boolean} [insert]
     * Whether to insert the row at the given index, or to overwrite the row.
     *
     * @param {Highcharts.DataTableEventDetail} [eventDetail]
     * Custom information for pending events.
     *
     * @emits #setRows
     * @emits #afterSetRows
     */ setRow(row, rowIndex, insert, eventDetail) {
        this.setRows([
            row
        ], rowIndex, insert, eventDetail);
    }
    /**
     * Sets cell values for multiple rows. Will insert new rows, if no index was
     * was provided, or if the index is higher than the total number of table
     * rows.
     *
     * @function Highcharts.DataTable#setRows
     *
     * @param {Array<(Highcharts.DataTableRow|Highcharts.DataTableRowObject)>} rows
     * Row values to set.
     *
     * @param {number} [rowIndex]
     * Index of the first row to set. Leave `undefined` to add as new rows.
     *
     * @param {boolean} [insert]
     * Whether to insert the row at the given index, or to overwrite the row.
     *
     * @param {Highcharts.DataTableEventDetail} [eventDetail]
     * Custom information for pending events.
     *
     * @emits #setRows
     * @emits #afterSetRows
     */ setRows(rows, rowIndex = this.rowCount, insert, eventDetail) {
        const table = this, columns = table.columns, columnIds = Object.keys(columns), modifier = table.modifier, rowCount = rows.length;
        table.emit({
            type: 'setRows',
            detail: eventDetail,
            rowCount: rowCount,
            rowIndex: rowIndex,
            rows: rows
        });
        for(let i = 0, i2 = rowIndex, row; i < rowCount; ++i, ++i2){
            row = rows[i];
            if (Object.keys(row).length === 0) for(let j = 0, jEnd = columnIds.length; j < jEnd; ++j){
                const column = columns[columnIds[j]];
                if (insert) columns[columnIds[j]] = $43fe5b800d4cd23a$var$splice(column, i2, 0, true, [
                    null
                ]).array;
                else column[i2] = null;
            }
            else if (Array.isArray(row)) for(let j = 0, jEnd = columnIds.length; j < jEnd; ++j)columns[columnIds[j]][i2] = row[j];
            else super.setRow(row, i2, insert, {
                silent: true
            });
        }
        const indexRowCount = insert ? rowCount + rows.length : rowIndex + rowCount;
        if (indexRowCount > table.rowCount) {
            table.rowCount = indexRowCount;
            for(let i = 0, iEnd = columnIds.length; i < iEnd; ++i){
                const columnId = columnIds[i];
                columns[columnId] = $43fe5b800d4cd23a$var$setLength(columns[columnId], indexRowCount);
            }
        }
        if (modifier) modifier.modifyTable(table);
        table.emit({
            type: 'afterSetRows',
            detail: eventDetail,
            rowCount: rowCount,
            rowIndex: rowIndex,
            rows: rows
        });
    }
}
var /* *
 *
 *  Default Export
 *
 * */ $43fe5b800d4cd23a$export$2e2bcd8739ae039 = $43fe5b800d4cd23a$var$DataTable;

});
parcelRegister("jphPm", function(module, exports) {

$parcel$export(module.exports, "default", () => $e20e2e4b91badc96$export$2e2bcd8739ae039);
/* *
 *
 *  (c) 2009-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Sophie Bremer
 *  - Gøran Slettemark
 *  - Torstein Hønsi
 *
 * */ 
var $arnqq = parcelRequire("arnqq");

var $l3aRA = parcelRequire("l3aRA");
'use strict';
const { setLength: $e20e2e4b91badc96$var$setLength, splice: $e20e2e4b91badc96$var$splice } = (0, $arnqq.default);
const { fireEvent: $e20e2e4b91badc96$var$fireEvent, objectEach: $e20e2e4b91badc96$var$objectEach, uniqueKey: $e20e2e4b91badc96$var$uniqueKey } = (0, $l3aRA.default);
/* *
 *
 *  Class
 *
 * */ /**
 * Class to manage columns and rows in a table structure. It provides methods
 * to add, remove, and manipulate columns and rows, as well as to retrieve data
 * from specific cells.
 *
 * @class
 * @name Highcharts.DataTable
 *
 * @param {Highcharts.DataTableOptions} [options]
 * Options to initialize the new DataTable instance.
 */ class $e20e2e4b91badc96$var$DataTableCore {
    /**
     * Constructs an instance of the DataTable class.
     *
     * @example
     * const dataTable = new Highcharts.DataTableCore({
     *   columns: {
     *     year: [2020, 2021, 2022, 2023],
     *     cost: [11, 13, 12, 14],
     *     revenue: [12, 15, 14, 18]
     *   }
     * });

     *
     * @param {Highcharts.DataTableOptions} [options]
     * Options to initialize the new DataTable instance.
     */ constructor(options = {}){
        /**
         * Whether the ID was automatic generated or given in the constructor.
         *
         * @name Highcharts.DataTable#autoId
         * @type {boolean}
         */ this.autoId = !options.id;
        this.columns = {};
        /**
         * ID of the table for identification purposes.
         *
         * @name Highcharts.DataTable#id
         * @type {string}
         */ this.id = options.id || $e20e2e4b91badc96$var$uniqueKey();
        this.rowCount = 0;
        this.versionTag = $e20e2e4b91badc96$var$uniqueKey();
        let rowCount = 0;
        $e20e2e4b91badc96$var$objectEach(options.columns || {}, (column, columnId)=>{
            this.columns[columnId] = column.slice();
            rowCount = Math.max(rowCount, column.length);
        });
        this.applyRowCount(rowCount);
    }
    /* *
     *
     *  Functions
     *
     * */ /**
     * Applies a row count to the table by setting the `rowCount` property and
     * adjusting the length of all columns.
     *
     * @private
     * @param {number} rowCount The new row count.
     */ applyRowCount(rowCount) {
        this.rowCount = rowCount;
        $e20e2e4b91badc96$var$objectEach(this.columns, (column, columnId)=>{
            if (column.length !== rowCount) this.columns[columnId] = $e20e2e4b91badc96$var$setLength(column, rowCount);
        });
    }
    /**
     * Delete rows. Simplified version of the full
     * `DataTable.deleteRows` method.
     *
     * @param {number} rowIndex
     * The start row index
     *
     * @param {number} [rowCount=1]
     * The number of rows to delete
     *
     * @return {void}
     *
     * @emits #afterDeleteRows
     */ deleteRows(rowIndex, rowCount = 1) {
        if (rowCount > 0 && rowIndex < this.rowCount) {
            let length = 0;
            $e20e2e4b91badc96$var$objectEach(this.columns, (column, columnId)=>{
                this.columns[columnId] = $e20e2e4b91badc96$var$splice(column, rowIndex, rowCount).array;
                length = column.length;
            });
            this.rowCount = length;
        }
        $e20e2e4b91badc96$var$fireEvent(this, 'afterDeleteRows', {
            rowIndex: rowIndex,
            rowCount: rowCount
        });
        this.versionTag = $e20e2e4b91badc96$var$uniqueKey();
    }
    /**
     * Fetches the given column by the canonical column name. Simplified version
     * of the full `DataTable.getRow` method, always returning by reference.
     *
     * @param {string} columnId
     * Name of the column to get.
     *
     * @return {Highcharts.DataTableColumn|undefined}
     * A copy of the column, or `undefined` if not found.
     */ getColumn(columnId, // eslint-disable-next-line @typescript-eslint/no-unused-vars
    asReference) {
        return this.columns[columnId];
    }
    /**
     * Retrieves all or the given columns. Simplified version of the full
     * `DataTable.getColumns` method, always returning by reference.
     *
     * @param {Array<string>} [columnIds]
     * Column ids to retrieve.
     *
     * @return {Highcharts.DataTableColumnCollection}
     * Collection of columns. If a requested column was not found, it is
     * `undefined`.
     */ getColumns(columnIds, // eslint-disable-next-line @typescript-eslint/no-unused-vars
    asReference) {
        return (columnIds || Object.keys(this.columns)).reduce((columns, columnId)=>{
            columns[columnId] = this.columns[columnId];
            return columns;
        }, {});
    }
    /**
     * Retrieves the row at a given index.
     *
     * @param {number} rowIndex
     * Row index to retrieve. First row has index 0.
     *
     * @param {Array<string>} [columnIds]
     * Column names to retrieve.
     *
     * @return {Record<string, number|string|undefined>|undefined}
     * Returns the row values, or `undefined` if not found.
     */ getRow(rowIndex, columnIds) {
        return (columnIds || Object.keys(this.columns)).map((key)=>this.columns[key]?.[rowIndex]);
    }
    /**
     * Sets cell values for a column. Will insert a new column, if not found.
     *
     * @param {string} columnId
     * Column name to set.
     *
     * @param {Highcharts.DataTableColumn} [column]
     * Values to set in the column.
     *
     * @param {number} [rowIndex]
     * Index of the first row to change. (Default: 0)
     *
     * @param {Record<string, (boolean|number|string|null|undefined)>} [eventDetail]
     * Custom information for pending events.
     *
     * @emits #setColumns
     * @emits #afterSetColumns
     */ setColumn(columnId, column = [], rowIndex = 0, eventDetail) {
        this.setColumns({
            [columnId]: column
        }, rowIndex, eventDetail);
    }
    /**
     * Sets cell values for multiple columns. Will insert new columns, if not
     * found. Simplified version of the full `DataTableCore.setColumns`, limited
     * to full replacement of the columns (undefined `rowIndex`).
     *
     * @param {Highcharts.DataTableColumnCollection} columns
     * Columns as a collection, where the keys are the column names.
     *
     * @param {number} [rowIndex]
     * Index of the first row to change. Ignored in the `DataTableCore`, as it
     * always replaces the full column.
     *
     * @param {Record<string, (boolean|number|string|null|undefined)>} [eventDetail]
     * Custom information for pending events.
     *
     * @emits #setColumns
     * @emits #afterSetColumns
     */ setColumns(columns, rowIndex, eventDetail) {
        let rowCount = this.rowCount;
        $e20e2e4b91badc96$var$objectEach(columns, (column, columnId)=>{
            this.columns[columnId] = column.slice();
            rowCount = column.length;
        });
        this.applyRowCount(rowCount);
        if (!eventDetail?.silent) {
            $e20e2e4b91badc96$var$fireEvent(this, 'afterSetColumns');
            this.versionTag = $e20e2e4b91badc96$var$uniqueKey();
        }
    }
    /**
     * Sets cell values of a row. Will insert a new row if no index was
     * provided, or if the index is higher than the total number of table rows.
     * A simplified version of the full `DateTable.setRow`, limited to objects.
     *
     * @param {Record<string, number|string|undefined>} row
     * Cell values to set.
     *
     * @param {number} [rowIndex]
     * Index of the row to set. Leave `undefined` to add as a new row.
     *
     * @param {boolean} [insert]
     * Whether to insert the row at the given index, or to overwrite the row.
     *
     * @param {Record<string, (boolean|number|string|null|undefined)>} [eventDetail]
     * Custom information for pending events.
     *
     * @emits #afterSetRows
     */ setRow(row, rowIndex = this.rowCount, insert, eventDetail) {
        const { columns: columns } = this, indexRowCount = insert ? this.rowCount + 1 : rowIndex + 1, rowKeys = Object.keys(row);
        if (eventDetail?.addColumns !== false) for(let i = 0, iEnd = rowKeys.length; i < iEnd; i++){
            const key = rowKeys[i];
            if (!columns[key]) columns[key] = [];
        }
        $e20e2e4b91badc96$var$objectEach(columns, (column, columnId)=>{
            if (!column && eventDetail?.addColumns !== false) column = new Array(indexRowCount);
            if (column) {
                if (insert) column = $e20e2e4b91badc96$var$splice(column, rowIndex, 0, true, [
                    row[columnId] ?? null
                ]).array;
                else column[rowIndex] = row[columnId] ?? null;
                columns[columnId] = column;
            }
        });
        if (indexRowCount > this.rowCount) this.applyRowCount(indexRowCount);
        if (!eventDetail?.silent) {
            $e20e2e4b91badc96$var$fireEvent(this, 'afterSetRows');
            this.versionTag = $e20e2e4b91badc96$var$uniqueKey();
        }
    }
    /**
     * Returns the medified (clone) or the original data table if the modified
     * one does not exist.
     *
     * @return {Highcharts.DataTableCore}
     * The medified (clone) or the original data table.
     */ getModified() {
        return this.modified || this;
    }
}
var /* *
 *
 *  Default Export
 *
 * */ $e20e2e4b91badc96$export$2e2bcd8739ae039 = $e20e2e4b91badc96$var$DataTableCore;
/* *
 *
 *  API Declarations
 *
 * */ /**
 * A typed array.
 * @typedef {Int8Array|Uint8Array|Uint8ClampedArray|Int16Array|Uint16Array|Int32Array|Uint32Array|Float32Array|Float64Array} Highcharts.TypedArray
 * //**
 * A column of values in a data table.
 * @typedef {Array<boolean|null|number|string|undefined>|Highcharts.TypedArray} Highcharts.DataTableColumn
 */ /**
* A collection of data table columns defined by a object where the key is the
* column name and the value is an array of the column values.
* @typedef {Record<string, Highcharts.DataTableColumn>} Highcharts.DataTableColumnCollection
*/ /**
 * Options for the `DataTable` or `DataTableCore` classes.
 * @interface Highcharts.DataTableOptions
 */ /**
* The column options for the data table. The columns are defined by an object
* where the key is the column ID and the value is an array of the column
* values.
*
* @name Highcharts.DataTableOptions.columns
* @type {Highcharts.DataTableColumnCollection|undefined}
*/ /**
* Custom ID to identify the new DataTable instance.
*
* @name Highcharts.DataTableOptions.id
* @type {string|undefined}
*/ ''; // Keeps doclets above in JS file

});
parcelRegister("arnqq", function(module, exports) {

$parcel$export(module.exports, "default", () => $799e98c2ce6a52fc$export$2e2bcd8739ae039);
/* *
 *
 *  (c) 2020-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Dawid Dragula
 *
 * */ /**
 * Utility functions for columns that can be either arrays or typed arrays.
 * @private
 */ var $799e98c2ce6a52fc$var$ColumnUtils;
(function(ColumnUtils) {
    /* *
    *
    *  Declarations
    *
    * */ /* *
    *
    * Functions
    *
    * */ /**
     * Sets the length of the column array.
     *
     * @param {DataTable.Column} column
     * Column to be modified.
     *
     * @param {number} length
     * New length of the column.
     *
     * @param {boolean} asSubarray
     * If column is a typed array, return a subarray instead of a new array. It
     * is faster `O(1)`, but the entire buffer will be kept in memory until all
     * views of it are destroyed. Default is `false`.
     *
     * @return {DataTable.Column}
     * Modified column.
     *
     * @private
     */ function setLength(column, length, asSubarray) {
        if (Array.isArray(column)) {
            column.length = length;
            return column;
        }
        return column[asSubarray ? 'subarray' : 'slice'](0, length);
    }
    ColumnUtils.setLength = setLength;
    /**
     * Splices a column array.
     *
     * @param {DataTable.Column} column
     * Column to be modified.
     *
     * @param {number} start
     * Index at which to start changing the array.
     *
     * @param {number} deleteCount
     * An integer indicating the number of old array elements to remove.
     *
     * @param {boolean} removedAsSubarray
     * If column is a typed array, return a subarray instead of a new array. It
     * is faster `O(1)`, but the entire buffer will be kept in memory until all
     * views to it are destroyed. Default is `true`.
     *
     * @param {Array<number>|TypedArray} items
     * The elements to add to the array, beginning at the start index. If you
     * don't specify any elements, `splice()` will only remove elements from the
     * array.
     *
     * @return {SpliceResult}
     * Object containing removed elements and the modified column.
     *
     * @private
     */ function splice(column, start, deleteCount, removedAsSubarray, items = []) {
        if (Array.isArray(column)) {
            if (!Array.isArray(items)) items = Array.from(items);
            return {
                removed: column.splice(start, deleteCount, ...items),
                array: column
            };
        }
        const Constructor = Object.getPrototypeOf(column).constructor;
        const removed = column[removedAsSubarray ? 'subarray' : 'slice'](start, start + deleteCount);
        const newLength = column.length - deleteCount + items.length;
        const result = new Constructor(newLength);
        result.set(column.subarray(0, start), 0);
        result.set(items, start);
        result.set(column.subarray(start + deleteCount), start + items.length);
        return {
            removed: removed,
            array: result
        };
    }
    ColumnUtils.splice = splice;
    /**
     * Converts a cell value to a number.
     *
     * @param {DataTable.CellType} value
     * Cell value to convert to a number.
     *
     * @param {boolean} useNaN
     * If `true`, returns `NaN` for non-numeric values; if `false`,
     * returns `null` instead.
     *
     * @return {number | null}
     * Number or `null` if the value is not a number.
     *
     * @private
     */ function convertToNumber(value, useNaN) {
        switch(typeof value){
            case 'boolean':
                return value ? 1 : 0;
            case 'number':
                return isNaN(value) && !useNaN ? null : value;
            default:
                value = parseFloat(`${value ?? ''}`);
                return isNaN(value) && !useNaN ? null : value;
        }
    }
    ColumnUtils.convertToNumber = convertToNumber;
})($799e98c2ce6a52fc$var$ColumnUtils || ($799e98c2ce6a52fc$var$ColumnUtils = {}));
var /* *
 *
 *  Default Export
 *
 * */ $799e98c2ce6a52fc$export$2e2bcd8739ae039 = $799e98c2ce6a52fc$var$ColumnUtils;

});




parcelRegister("5Jprx", function(module, exports) {

$parcel$export(module.exports, "default", () => $42c4e4384e1e09ed$export$2e2bcd8739ae039);
/* *
 *
 *  (c) 2009-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Sophie Bremer
 *  - Sebastian Bochan
 *  - Gøran Slettemark
 *  - Torstein Hønsi
 *  - Wojciech Chmiel
 *  - Jomar Hønsi
 *  - Kamil Kubik
 *
 * */ 
var $6NwQo = parcelRequire("6NwQo");

var $l3aRA = parcelRequire("l3aRA");
'use strict';
const { addEvent: $42c4e4384e1e09ed$var$addEvent, fireEvent: $42c4e4384e1e09ed$var$fireEvent, merge: $42c4e4384e1e09ed$var$merge } = (0, $l3aRA.default);
/* *
 *
 *  Class
 *
 * */ /**
 * Base class providing an interface and basic methods for a DataConverter
 *
 * @private
 */ class $42c4e4384e1e09ed$var$DataConverter {
    /* *
     *
     *  Constructor
     *
     * */ /**
     * Constructs an instance of the DataConverter.
     *
     * @param {DataConverter.UserOptions} [options]
     * Options for the DataConverter.
     */ constructor(options){
        /* *
         *
         *  Properties
         *
         * */ /**
         * A collection of available date formats.
         */ this.dateFormats = {
            'YYYY/mm/dd': {
                regex: /^(\d{4})([\-\.\/])(\d{1,2})\2(\d{1,2})$/,
                parser: function(match) {
                    return match ? Date.UTC(+match[1], +match[3] - 1, +match[4]) : NaN;
                }
            },
            'dd/mm/YYYY': {
                regex: /^(\d{1,2})([\-\.\/])(\d{1,2})\2(\d{4})$/,
                parser: function(match) {
                    return match ? Date.UTC(+match[4], +match[3] - 1, +match[1]) : NaN;
                },
                alternative: 'mm/dd/YYYY' // Different format with the same regex
            },
            'mm/dd/YYYY': {
                regex: /^(\d{1,2})([\-\.\/])(\d{1,2})\2(\d{4})$/,
                parser: function(match) {
                    return match ? Date.UTC(+match[4], +match[1] - 1, +match[3]) : NaN;
                }
            },
            'dd/mm/YY': {
                regex: /^(\d{1,2})([\-\.\/])(\d{1,2})\2(\d{2})$/,
                parser: function(match) {
                    const d = new Date();
                    if (!match) return NaN;
                    let year = +match[4];
                    if (year > d.getFullYear() - 2000) year += 1900;
                    else year += 2000;
                    return Date.UTC(year, +match[3] - 1, +match[1]);
                },
                alternative: 'mm/dd/YY' // Different format with the same regex
            },
            'mm/dd/YY': {
                regex: /^(\d{1,2})([\-\.\/])(\d{1,2})\2(\d{2})$/,
                parser: function(match) {
                    return match ? Date.UTC(+match[4] + 2000, +match[1] - 1, +match[3]) : NaN;
                }
            }
        };
        const mergedOptions = $42c4e4384e1e09ed$var$merge($42c4e4384e1e09ed$var$DataConverter.defaultOptions, options);
        let regExpPoint = mergedOptions.decimalPoint;
        if (regExpPoint === '.' || regExpPoint === ',') {
            regExpPoint = regExpPoint === '.' ? '\\.' : ',';
            this.decimalRegExp = new RegExp('^(-?[0-9]+)' + regExpPoint + '([0-9]+)$');
        }
        this.options = mergedOptions;
    }
    /* *
     *
     *  Functions
     *
     * */ /**
     * Converts a string value based on its guessed type.
     *
     * @param {*} value
     * The value to examine.
     *
     * @return {number | string | Date}
     * The converted value.
     */ convertByType(value) {
        const converter = this, typeMap = {
            'number': (value)=>(0, $6NwQo.default).asNumber(value, converter.decimalRegExp),
            'Date': (value)=>(0, $6NwQo.default).asDate(value, converter),
            'string': (0, $6NwQo.default).asString
        };
        return typeMap[(0, $6NwQo.default).guessType(value, converter)].call(converter, value);
    }
    /**
     * Tries to guess the date format
     *  - Check if either month candidate exceeds 12
     *  - Check if year is missing (use current year)
     *  - Check if a shortened year format is used (e.g. 1/1/99)
     *  - If no guess can be made, the user must be prompted
     * data is the data to deduce a format based on
     * @private
     *
     * @param {string[]} data
     * Data to check the format.
     *
     * @param {number} limit
     * Max data to check the format.
     *
     * @param {boolean} save
     * Whether to save the date format in the converter options.
     */ deduceDateFormat(data, limit, save) {
        const parser = this, stable = [], max = [];
        let format = 'YYYY/mm/dd', thing, guessedFormat = [], i = 0, madeDeduction = false, elem, j;
        if (!limit || limit > data.length) limit = data.length;
        for(; i < limit; i++)if (typeof data[i] !== 'undefined' && data[i] && data[i].length) {
            thing = data[i].trim().replace(/[\-\.\/]/g, ' ').split(' ');
            guessedFormat = [
                '',
                '',
                ''
            ];
            for(j = 0; j < thing.length; j++)if (j < guessedFormat.length) {
                elem = parseInt(thing[j], 10);
                if (elem) {
                    max[j] = !max[j] || max[j] < elem ? elem : max[j];
                    if (typeof stable[j] !== 'undefined') {
                        if (stable[j] !== elem) stable[j] = false;
                    } else stable[j] = elem;
                    if (elem > 31) {
                        if (elem < 100) guessedFormat[j] = 'YY';
                        else guessedFormat[j] = 'YYYY';
                    } else if (elem > 12 && elem <= 31) {
                        guessedFormat[j] = 'dd';
                        madeDeduction = true;
                    } else if (!guessedFormat[j].length) guessedFormat[j] = 'mm';
                }
            }
        }
        if (madeDeduction) {
            // This handles a few edge cases with hard to guess dates
            for(j = 0; j < stable.length; j++){
                if (stable[j] !== false) {
                    if (max[j] > 12 && guessedFormat[j] !== 'YY' && guessedFormat[j] !== 'YYYY') guessedFormat[j] = 'YY';
                } else if (max[j] > 12 && guessedFormat[j] === 'mm') guessedFormat[j] = 'dd';
            }
            // If the middle one is dd, and the last one is dd,
            // the last should likely be year.
            if (guessedFormat.length === 3 && guessedFormat[1] === 'dd' && guessedFormat[2] === 'dd') guessedFormat[2] = 'YY';
            format = guessedFormat.join('/');
        // If the caculated format is not valid, we need to present an
        // error.
        }
        // Save the deduced format in the converter options.
        if (save) parser.options.dateFormat = format;
        return format;
    }
    /**
     * Emits an event on the DataConverter instance.
     *
     * @param {DataConverter.Event} [e]
     * Event object containing additional event data
     */ emit(e) {
        $42c4e4384e1e09ed$var$fireEvent(this, e.type, e);
    }
    /**
     * Registers a callback for a specific event.
     *
     * @param {string} type
     * Event type as a string.
     *
     * @param {DataEventEmitter.Callback} callback
     * Function to register for an modifier callback.
     *
     * @return {Function}
     * Function to unregister callback from the modifier event.
     */ on(type, callback) {
        return $42c4e4384e1e09ed$var$addEvent(this, type, callback);
    }
    /**
     * Parse a date and return it as a number.
     *
     * @param {string} value
     * Value to parse.
     *
     * @param {string} dateFormatProp
     * Which of the predefined date formats
     * to use to parse date values.
     */ parseDate(value, dateFormatProp) {
        const converter = this, options = converter.options;
        let dateFormat = dateFormatProp || options.dateFormat, result = NaN, key, match = null;
        if (options.parseDate) result = options.parseDate(value);
        else {
            const dateFormats = converter.dateFormats;
            // Auto-detect the date format the first time
            if (!dateFormat) for(key in dateFormats){
                const format = dateFormats[key];
                match = value.match(format.regex);
                if (match) {
                    dateFormat = key;
                    result = format.parser(match);
                    break;
                }
            }
            else {
                let format = dateFormats[dateFormat];
                if (!format) // The selected format is invalid
                format = dateFormats['YYYY/mm/dd'];
                match = value.match(format.regex);
                if (match) result = format.parser(match);
            }
            // Fall back to Date.parse
            if (!match) {
                const parsed = Date.parse(value);
                if (!isNaN(parsed)) {
                    result = parsed - new Date(parsed).getTimezoneOffset() * 60000;
                    // Reset dates without year in Chrome
                    if (!value.includes('2001') && new Date(result).getFullYear() === 2001) result = NaN;
                }
            }
        }
        return result;
    }
}
/* *
 *
 *  Static Properties
 *
 * */ /**
 * Default options
 */ $42c4e4384e1e09ed$var$DataConverter.defaultOptions = {
    dateFormat: '',
    firstRowAsNames: true
};
/* *
 *
 *  Class Namespace
 *
 * */ /**
 * Additionally provided types for events and conversion.
 */ (function(DataConverter) {
    /* *
     *
     *  Declarations
     *
     * */ /* *
     *
     *  Constants
     *
     * */ /**
     * Registry as a record object with connector names and their class.
     */ DataConverter.types = {};
    /* *
     *
     *  Functions
     *
     * */ /**
     * Adds a converter class to the registry.
     *
     * @private
     *
     * @param {string} key
     * Registry key of the converter class.
     *
     * @param {DataConverterTypes} DataConverterClass
     * Connector class (aka class constructor) to register.
     *
     * @return {boolean}
     * Returns true, if the registration was successful. False is returned, if
     * their is already a converter registered with this key.
     */ function registerType(key, DataConverterClass) {
        return !!key && !DataConverter.types[key] && !!(DataConverter.types[key] = DataConverterClass);
    }
    DataConverter.registerType = registerType;
})($42c4e4384e1e09ed$var$DataConverter || ($42c4e4384e1e09ed$var$DataConverter = {}));
var /* *
 *
 *  Default Export
 *
 * */ $42c4e4384e1e09ed$export$2e2bcd8739ae039 = $42c4e4384e1e09ed$var$DataConverter;

});
parcelRegister("6NwQo", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f30cbd51ca97a62$export$2e2bcd8739ae039);
/* *
 *
 *  (c) 2009-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Kamil Kubik
 *
 * */ 
var $l3aRA = parcelRequire("l3aRA");
const { isNumber: $4f30cbd51ca97a62$var$isNumber } = (0, $l3aRA.default);
/* *
 *
 *  Namespace
 *
 * */ var $4f30cbd51ca97a62$var$DataConverterUtils;
(function(DataConverterUtils) {
    /* *
    *
    *  Properties
    *
    * */ /* *
    *
    * Functions
    *
    * */ /**
     * Converts a value to a Date.
     *
     * @param {DataConverter.Type} value
     * Value to convert.
     *
     * @return {globalThis.Date}
     * Converted value as a Date.
     */ function asDate(value, converter) {
        let timestamp;
        if (typeof value === 'string') timestamp = converter.parseDate(value);
        else if (typeof value === 'number') timestamp = value;
        else if (value instanceof Date) return value;
        else timestamp = converter.parseDate(asString(value));
        return new Date(timestamp);
    }
    DataConverterUtils.asDate = asDate;
    /**
     * Converts a value to a number.
     *
     * @param {DataConverter.Type} value
     * Value to convert.
     *
     * @return {number}
     * Converted value as a number.
     */ function asNumber(value, decimalRegExp) {
        if (typeof value === 'number') return value;
        if (typeof value === 'boolean') return value ? 1 : 0;
        if (typeof value === 'string') {
            const decimalRegex = decimalRegExp;
            if (value.indexOf(' ') > -1) value = value.replace(/\s+/g, '');
            if (decimalRegex) {
                if (!decimalRegex.test(value)) return NaN;
                value = value.replace(decimalRegex, '$1.$2');
            }
            return parseFloat(value);
        }
        if (value instanceof Date) return value.getDate();
        if (value) return value.getRowCount();
        return NaN;
    }
    DataConverterUtils.asNumber = asNumber;
    /**
     * Converts a value to a string.
     *
     * @param {DataConverter.Type} value
     * Value to convert.
     *
     * @return {string}
     * Converted value as a string.
     */ function asString(value) {
        return '' + value;
    }
    DataConverterUtils.asString = asString;
    /**
     * Converts a value to a boolean.
     *
     * @param {DataConverter.Type} value
     * Value to convert.
     *
     * @return {boolean}
     * Converted value as a boolean.
     */ function asBoolean(value) {
        if (typeof value === 'boolean') return value;
        if (typeof value === 'string') return value !== '' && value !== '0' && value !== 'false';
        return !!asNumber(value);
    }
    DataConverterUtils.asBoolean = asBoolean;
    /**
     * Guesses the potential type of a string value for parsing CSV etc.
     *
     * @param {*} value
     * The value to examine.
     *
     * @return {'number' | 'string' | 'Date'}
     * Type string, either `string`, `Date`, or `number`.
     */ function guessType(value, converter) {
        let result = 'string';
        if (typeof value === 'string') {
            const trimedValue = DataConverterUtils.trim(`${value}`), decimalRegExp = converter.decimalRegExp;
            let innerTrimedValue = DataConverterUtils.trim(trimedValue, true);
            if (decimalRegExp) innerTrimedValue = decimalRegExp.test(innerTrimedValue) ? innerTrimedValue.replace(decimalRegExp, '$1.$2') : '';
            const floatValue = parseFloat(innerTrimedValue);
            if (+innerTrimedValue === floatValue) // String is numeric
            value = floatValue;
            else {
                // Determine if a date string
                const dateValue = converter.parseDate(value);
                result = $4f30cbd51ca97a62$var$isNumber(dateValue) ? 'Date' : 'string';
            }
        }
        if (typeof value === 'number') // Greater than milliseconds in a year assumed timestamp
        result = value > 31536000000 ? 'Date' : 'number';
        return result;
    }
    DataConverterUtils.guessType = guessType;
    /**
     * Trim a string from whitespaces.
     *
     * @param {string} str
     * String to trim.
     *
     * @param {boolean} [inside=false]
     * Remove all spaces between numbers.
     *
     * @return {string}
     * Trimed string
     */ function trim(str, inside) {
        if (typeof str === 'string') {
            str = str.replace(/^\s+|\s+$/g, '');
            // Clear white space insdie the string, like thousands separators
            if (inside && /^[\d\s]+$/.test(str)) str = str.replace(/\s/g, '');
        }
        return str;
    }
    DataConverterUtils.trim = trim;
    /**
     * Parses an array of columns to a column collection. If more headers are
     * provided, the corresponding, empty columns are added.
     *
     * @param {DataTable.Column[]} [columnsArray]
     * Array of columns.
     *
     * @param {string[]} [headers]
     * Column ids to use.
     *
     * @return {DataTable.ColumnCollection}
     * Parsed columns.
     */ function getColumnsCollection(columnsArray = [], headers) {
        const columns = {};
        for(let i = 0, iEnd = Math.max(headers.length, columnsArray.length); i < iEnd; ++i){
            const columnId = headers[i] || `${i}`;
            columns[columnId] = columnsArray[i] ? columnsArray[i].slice() : [];
        }
        return columns;
    }
    DataConverterUtils.getColumnsCollection = getColumnsCollection;
})($4f30cbd51ca97a62$var$DataConverterUtils || ($4f30cbd51ca97a62$var$DataConverterUtils = {}));
var /* *
 *
 *  Default Export
 *
 * */ $4f30cbd51ca97a62$export$2e2bcd8739ae039 = $4f30cbd51ca97a62$var$DataConverterUtils;

});


parcelRegister("1WhMx", function(module, exports) {

$parcel$export(module.exports, "default", () => $169900544dd35db1$export$2e2bcd8739ae039);
/* *
 *
 *  (c) 2020-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Sophie Bremer
 *
 * */ 'use strict';
/* *
 *
 *  Class
 *
 * */ /**
 * This class manages state cursors pointing on {@link Data.DataTable}. It
 * creates a relation between states of the user interface and the table cells,
 * columns, or rows.
 *
 * @class
 * @name Data.DataCursor
 */ class $169900544dd35db1$var$DataCursor {
    /* *
     *
     *  Static Properties
     *
     * */ /* *
     *
     *  Constructor
     *
     * */ constructor(stateMap = {}){
        this.emittingRegister = [];
        this.listenerMap = {};
        this.stateMap = stateMap;
    }
    /* *
     *
     *  Functions
     *
     * */ /**
     * This function registers a listener for a specific state and table.
     *
     * @example
     * ```TypeScript
     * dataCursor.addListener(myTable.id, 'hover', (e: DataCursor.Event) => {
     *     if (e.cursor.type === 'position') {
     *         console.log(`Hover over row #${e.cursor.row}.`);
     *     }
     * });
     * ```
     *
     * @function #addListener
     *
     * @param {Data.DataCursor.TableId} tableId
     * The ID of the table to listen to.
     *
     * @param {Data.DataCursor.State} state
     * The state on the table to listen to.
     *
     * @param {Data.DataCursor.Listener} listener
     * The listener to register.
     *
     * @return {Data.DataCursor}
     * Returns the DataCursor instance for a call chain.
     */ addListener(tableId, state, listener) {
        const listenerMap = this.listenerMap[tableId] = this.listenerMap[tableId] || {};
        const listeners = listenerMap[state] = listenerMap[state] || [];
        listeners.push(listener);
        return this;
    }
    /**
     * @private
     */ buildEmittingTag(e) {
        return (e.cursor.type === 'position' ? [
            e.table.id,
            e.cursor.column,
            e.cursor.row,
            e.cursor.state,
            e.cursor.type
        ] : [
            e.table.id,
            e.cursor.columns,
            e.cursor.firstRow,
            e.cursor.lastRow,
            e.cursor.state,
            e.cursor.type
        ]).join('\0');
    }
    /**
     * This function emits a state cursor related to a table. It will provide
     * lasting state cursors of the table to listeners.
     *
     * @example
     * ```ts
     * dataCursor.emit(myTable, {
     *     type: 'position',
     *     column: 'city',
     *     row: 4,
     *     state: 'hover',
     * });
     * ```
     *
     * @param {Data.DataTable} table
     * The related table of the cursor.
     *
     * @param {Data.DataCursor.Type} cursor
     * The state cursor to emit.
     *
     * @param {Event} [event]
     * Optional event information from a related source.
     *
     * @param {boolean} [lasting]
     * Whether this state cursor should be kept until it is cleared with
     * {@link DataCursor#remitCursor}.
     *
     * @return {Data.DataCursor}
     * Returns the DataCursor instance for a call chain.
     */ emitCursor(table, cursor, event, lasting) {
        const tableId = table.id, state = cursor.state, listeners = this.listenerMap[tableId] && this.listenerMap[tableId][state];
        if (listeners) {
            const stateMap = this.stateMap[tableId] = this.stateMap[tableId] ?? {};
            const cursors = stateMap[cursor.state] || [];
            if (lasting) {
                if (!cursors.length) stateMap[cursor.state] = cursors;
                if ($169900544dd35db1$var$DataCursor.getIndex(cursor, cursors) === -1) cursors.push(cursor);
            }
            const e = {
                cursor: cursor,
                cursors: cursors,
                table: table
            };
            if (event) e.event = event;
            const emittingRegister = this.emittingRegister, emittingTag = this.buildEmittingTag(e);
            if (emittingRegister.indexOf(emittingTag) >= 0) // Break call stack loops
            return this;
            try {
                this.emittingRegister.push(emittingTag);
                for(let i = 0, iEnd = listeners.length; i < iEnd; ++i)listeners[i].call(this, e);
            } finally{
                const index = this.emittingRegister.indexOf(emittingTag);
                if (index >= 0) this.emittingRegister.splice(index, 1);
            }
        }
        return this;
    }
    /**
     * Removes a lasting state cursor.
     *
     * @function #remitCursor
     *
     * @param {string} tableId
     * ID of the related cursor table.
     *
     * @param {Data.DataCursor.Type} cursor
     * Copy or reference of the cursor.
     *
     * @return {Data.DataCursor}
     * Returns the DataCursor instance for a call chain.
     */ remitCursor(tableId, cursor) {
        const cursors = this.stateMap[tableId] && this.stateMap[tableId][cursor.state];
        if (cursors) {
            const index = $169900544dd35db1$var$DataCursor.getIndex(cursor, cursors);
            if (index >= 0) cursors.splice(index, 1);
        }
        return this;
    }
    /**
     * This function removes a listener.
     *
     * @function #addListener
     *
     * @param {Data.DataCursor.TableId} tableId
     * The ID of the table the listener is connected to.
     *
     * @param {Data.DataCursor.State} state
     * The state on the table the listener is listening to.
     *
     * @param {Data.DataCursor.Listener} listener
     * The listener to deregister.
     *
     * @return {Data.DataCursor}
     * Returns the DataCursor instance for a call chain.
     */ removeListener(tableId, state, listener) {
        const listeners = this.listenerMap[tableId] && this.listenerMap[tableId][state];
        if (listeners) {
            const index = listeners.indexOf(listener);
            if (index >= 0) listeners.splice(index, 1);
        }
        return this;
    }
}
/* *
 *
 *  Class Namespace
 *
 * */ /**
 * @class Data.DataCursor
 */ (function(DataCursor) {
    /* *
     *
     *  Declarations
     *
     * */ /* *
     *
     *  Functions
     *
     * */ /**
     * Finds the index of an cursor in an array.
     * @private
     */ function getIndex(needle, cursors) {
        if (needle.type === 'position') for(let cursor, i = 0, iEnd = cursors.length; i < iEnd; ++i){
            cursor = cursors[i];
            if (cursor.type === 'position' && cursor.state === needle.state && cursor.column === needle.column && cursor.row === needle.row) return i;
        }
        else {
            const columnNeedle = JSON.stringify(needle.columns);
            for(let cursor, i = 0, iEnd = cursors.length; i < iEnd; ++i){
                cursor = cursors[i];
                if (cursor.type === 'range' && cursor.state === needle.state && cursor.firstRow === needle.firstRow && cursor.lastRow === needle.lastRow && JSON.stringify(cursor.columns) === columnNeedle) return i;
            }
        }
        return -1;
    }
    DataCursor.getIndex = getIndex;
    /**
     * Checks whether two cursor share the same properties.
     * @private
     */ function isEqual(cursorA, cursorB) {
        if (cursorA.type === 'position' && cursorB.type === 'position') return cursorA.column === cursorB.column && cursorA.row === cursorB.row && cursorA.state === cursorB.state;
        if (cursorA.type === 'range' && cursorB.type === 'range') return cursorA.firstRow === cursorB.firstRow && cursorA.lastRow === cursorB.lastRow && JSON.stringify(cursorA.columns) === JSON.stringify(cursorB.columns);
        return false;
    }
    DataCursor.isEqual = isEqual;
    /**
     * Checks whether a cursor is in a range.
     * @private
     */ function isInRange(needle, range) {
        if (range.type === 'position') range = toRange(range);
        if (needle.type === 'position') needle = toRange(needle, range);
        const needleColumns = needle.columns;
        const rangeColumns = range.columns;
        return needle.firstRow >= range.firstRow && needle.lastRow <= range.lastRow && (!needleColumns || !rangeColumns || needleColumns.every((column)=>rangeColumns.indexOf(column) >= 0));
    }
    DataCursor.isInRange = isInRange;
    /**
     * @private
     */ function toPositions(cursor) {
        if (cursor.type === 'position') return [
            cursor
        ];
        const columns = cursor.columns || [];
        const positions = [];
        const state = cursor.state;
        for(let row = cursor.firstRow, rowEnd = cursor.lastRow; row < rowEnd; ++row){
            if (!columns.length) {
                positions.push({
                    type: 'position',
                    row: row,
                    state: state
                });
                continue;
            }
            for(let column = 0, columnEnd = columns.length; column < columnEnd; ++column)positions.push({
                type: 'position',
                column: columns[column],
                row: row,
                state: state
            });
        }
        return positions;
    }
    DataCursor.toPositions = toPositions;
    /**
     * @private
     */ function toRange(cursor, defaultRange) {
        if (cursor.type === 'range') return cursor;
        const range = {
            type: 'range',
            firstRow: cursor.row ?? (defaultRange && defaultRange.firstRow) ?? 0,
            lastRow: cursor.row ?? (defaultRange && defaultRange.lastRow) ?? Number.MAX_VALUE,
            state: cursor.state
        };
        if (typeof cursor.column !== 'undefined') range.columns = [
            cursor.column
        ];
        return range;
    }
    DataCursor.toRange = toRange;
})($169900544dd35db1$var$DataCursor || ($169900544dd35db1$var$DataCursor = {}));
var /* *
 *
 *  Default Export
 *
 * */ $169900544dd35db1$export$2e2bcd8739ae039 = $169900544dd35db1$var$DataCursor;

});

parcelRegister("jE1JP", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4d319e66f19a91b$export$2e2bcd8739ae039);
/* *
 *
 *  Highcharts Grid class
 *
 *  (c) 2020-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Dawid Dragula
 *  - Sebastian Bochan
 *
 * */ 
var $2LImV = parcelRequire("2LImV");

var $6phAG = parcelRequire("6phAG");

var $cZqnj = parcelRequire("cZqnj");

var $1I1ai = parcelRequire("1I1ai");

var $5PVyc = parcelRequire("5PVyc");

var $ekDzA = parcelRequire("ekDzA");

var $l3aRA = parcelRequire("l3aRA");

var $2JK0A = parcelRequire("2JK0A");

var $7Tdil = parcelRequire("7Tdil");

var $8UUCj = parcelRequire("8UUCj");

var $32BbZ = parcelRequire("32BbZ");
'use strict';
const { makeHTMLElement: $e4d319e66f19a91b$var$makeHTMLElement, setHTMLContent: $e4d319e66f19a91b$var$setHTMLContent } = (0, $1I1ai.default);
const { defined: $e4d319e66f19a91b$var$defined, diffObjects: $e4d319e66f19a91b$var$diffObjects, extend: $e4d319e66f19a91b$var$extend, fireEvent: $e4d319e66f19a91b$var$fireEvent, getStyle: $e4d319e66f19a91b$var$getStyle, merge: $e4d319e66f19a91b$var$merge, pick: $e4d319e66f19a91b$var$pick } = (0, $l3aRA.default);
class $e4d319e66f19a91b$export$ef2184bd89960b14 {
    // Implementation
    static grid(renderTo, options, async) {
        if (async) return new Promise((resolve)=>{
            new $e4d319e66f19a91b$export$ef2184bd89960b14(renderTo, options, (grid)=>{
                resolve(grid);
            });
        });
        return new $e4d319e66f19a91b$export$ef2184bd89960b14(renderTo, options);
    }
    /* *
    *
    *  Constructor
    *
    * */ /**
     * Constructs a new Grid.
     *
     * @param renderTo
     * The render target (container) of the Grid.
     *
     * @param options
     * The options of the Grid.
     *
     * @param afterLoadCallback
     * The callback that is called after the Grid is loaded.
     */ constructor(renderTo, options, afterLoadCallback){
        /**
         * The user options declared for the columns as an object of column ID to
         * column options.
         * @internal
         */ this.columnOptionsMap = {};
        /**
         * The options that were declared by the user when creating the Grid
         * or when updating it.
         */ this.userOptions = {};
        /**
         * The initial height of the container. Can be 0 also if not set.
         * @internal
         */ this.initialContainerHeight = 0;
        /**
         * The list of currently shown popups.
         */ this.popups = new Set();
        /**
         * Functions that unregister events attached to the grid's data table,
         * that need to be removed when the grid is destroyed.
         */ this.dataTableEventDestructors = [];
        /**
         * Whether the Grid is rendered.
         */ this.isRendered = false;
        /**
         * The flags that indicate which parts of the Grid are dirty and need to be
         * re-rendered.
         * @internal
         */ this.dirtyFlags = new Set();
        this.renderTo = renderTo;
        this.loadUserOptions(options);
        this.id = this.options?.id || (0, $l3aRA.default).uniqueKey();
        this.querying = new (0, $2JK0A.default)(this);
        this.locale = this.options?.lang?.locale || this.container?.closest('[lang]')?.lang;
        this.time = new (0, $8UUCj.default)($e4d319e66f19a91b$var$extend(this.options?.time, {
            locale: this.locale
        }), this.options?.lang);
        $e4d319e66f19a91b$var$fireEvent(this, 'beforeLoad');
        $e4d319e66f19a91b$export$ef2184bd89960b14.grids.push(this);
        this.render().then(()=>{
            afterLoadCallback?.(this);
            $e4d319e66f19a91b$var$fireEvent(this, 'afterLoad');
        });
    }
    /* *
     *
     *  Methods
     *
     * */ /*
     * Initializes the accessibility controller.
     */ initAccessibility() {
        this.accessibility?.destroy();
        delete this.accessibility;
        if (this.options?.accessibility?.enabled) this.accessibility = new (0, $2LImV.default)(this);
    }
    /*
     * Initializes the pagination.
     */ initPagination() {
        this.pagination?.destroy();
        delete this.pagination;
        if (this.options?.pagination?.enabled) this.pagination = new (0, $32BbZ.default)(this);
    }
    /**
     * Initializes the container of the Grid.
     *
     * @param renderTo
     * The render target (html element or id) of the Grid.
     *
     */ initContainer(renderTo) {
        const container = typeof renderTo === 'string' ? (0, $7Tdil.default).win.document.getElementById(renderTo) : renderTo;
        // Display an error if the renderTo is wrong
        if (!container) throw new Error("Rendering div not found. It is unable to find the HTML element to render the Grid in.");
        this.initialContainerHeight = $e4d319e66f19a91b$var$getStyle(container, 'height', true) || 0;
        this.container = container;
        this.container.innerHTML = (0, $6phAG.default).emptyHTML;
        this.contentWrapper = $e4d319e66f19a91b$var$makeHTMLElement('div', {
            className: (0, $7Tdil.default).getClassName('container')
        }, this.container);
    }
    /**
     * Loads the new user options to all the important fields (`userOptions`,
     * `options` and `columnOptionsMap`).
     *
     * @param newOptions
     * The options that were declared by the user.
     *
     * @param oneToOne
     * When `false` (default), the existing column options will be merged with
     * the ones that are currently defined in the user options. When `true`,
     * the columns not defined in the new options will be removed.
     *
     * @returns
     * An object of the changed options.
     */ loadUserOptions(newOptions, oneToOne = false) {
        // Operate on a copy of the options argument
        newOptions = $e4d319e66f19a91b$var$merge(newOptions);
        const diff = {};
        if (newOptions.columns) {
            if (oneToOne) diff.columns = this.setColumnOptionsOneToOne(newOptions.columns);
            else diff.columns = this.setColumnOptions(newOptions.columns);
            delete newOptions.columns;
        }
        if (diff.columns && Object.keys(diff.columns).length < 1) // Remove the columns property if it is empty object
        delete diff.columns;
        $e4d319e66f19a91b$var$merge(true, diff, $e4d319e66f19a91b$var$diffObjects(newOptions, this.userOptions));
        this.userOptions = $e4d319e66f19a91b$var$merge(this.userOptions, newOptions);
        this.options = $e4d319e66f19a91b$var$merge(this.options ?? (0, $cZqnj.defaultOptions), this.userOptions);
        return diff;
    }
    /**
     * Cleans up and reloads the column options from the `userOptions.columns`.
     * Generates the internal column options map from the options.columns array.
     */ reloadColumnOptions() {
        const colOptions = this.userOptions.columns;
        if (!colOptions) {
            this.columnOptionsMap = {};
            return;
        }
        if (colOptions.length < 1) {
            delete this.userOptions.columns;
            this.columnOptionsMap = {};
            return;
        }
        const columnOptionsMap = {};
        for(let i = 0, iEnd = colOptions.length; i < iEnd; ++i)columnOptionsMap[colOptions[i].id] = {
            index: i,
            options: colOptions[i]
        };
        this.columnOptionsMap = columnOptionsMap;
    }
    /**
     * Sets the new column options to the userOptions field.
     *
     * @param newColumnOptions
     * The new column options that should be loaded.
     *
     * @param overwrite
     * Whether to overwrite the existing column options with the new ones.
     * Default is `false`.
     *
     * @returns
     * An object of the changed column options in form of a record of
     * `[column.id]: column.options`.
     *
     * @internal
     */ setColumnOptions(newColumnOptions, overwrite = false) {
        const columnDiffOptions = {};
        if (!this.userOptions.columns) this.userOptions.columns = this.options?.columns ?? [];
        const columnOptions = this.userOptions.columns;
        for(let i = 0, iEnd = newColumnOptions.length; i < iEnd; ++i){
            const newOptions = newColumnOptions[i];
            const colOptionsIndex = this.columnOptionsMap?.[newOptions.id]?.index ?? -1;
            // If the new column options contain only the id.
            if (Object.keys(newOptions).length < 2) {
                if (overwrite && colOptionsIndex !== -1) {
                    columnDiffOptions[newOptions.id] = $e4d319e66f19a91b$var$diffObjects(columnOptions[colOptionsIndex], {
                        id: newOptions.id
                    }, true);
                    columnOptions.splice(colOptionsIndex, 1);
                }
                continue;
            }
            let diff;
            if (colOptionsIndex === -1) {
                diff = $e4d319e66f19a91b$var$merge(newOptions);
                columnOptions.push(newOptions);
            } else if (overwrite) {
                const prevOptions = columnOptions[colOptionsIndex];
                diff = $e4d319e66f19a91b$var$merge($e4d319e66f19a91b$var$diffObjects(prevOptions, newOptions, true), $e4d319e66f19a91b$var$diffObjects(newOptions, prevOptions));
                columnOptions[colOptionsIndex] = newOptions;
            } else {
                const prevOptions = columnOptions[colOptionsIndex];
                diff = $e4d319e66f19a91b$var$diffObjects(newOptions, prevOptions);
                $e4d319e66f19a91b$var$merge(true, prevOptions, newOptions);
            }
            delete diff.id;
            if (Object.keys(diff).length > 0) columnDiffOptions[newOptions.id] = diff;
        }
        this.reloadColumnOptions();
        return columnDiffOptions;
    }
    /**
     * Loads the new column options to the userOptions field in a one-to-one
     * manner. It means that all the columns that are not defined in the new
     * options will be removed.
     *
     * @param newColumnOptions
     * The new column options that should be loaded.
     *
     * @returns
     * The difference between the previous and the new column options in form
     * of a record of `[column.id]: column.options`.
     */ setColumnOptionsOneToOne(newColumnOptions) {
        const prevColumnOptions = this.userOptions.columns;
        const columnOptions = [];
        const columnDiffOptions = {};
        let prevOptions;
        for(let i = 0, iEnd = newColumnOptions.length; i < iEnd; ++i){
            const newOptions = newColumnOptions[i];
            const indexInPrevOptions = prevColumnOptions?.findIndex((prev)=>prev.id === newOptions.id);
            if (indexInPrevOptions !== void 0 && indexInPrevOptions !== -1) prevOptions = prevColumnOptions?.[indexInPrevOptions];
            const diffOptions = $e4d319e66f19a91b$var$diffObjects(newOptions, prevOptions ?? {});
            if (Object.keys(diffOptions).length > 0) {
                delete diffOptions.id;
                columnDiffOptions[newOptions.id] = diffOptions;
            }
            const resultOptions = $e4d319e66f19a91b$var$merge(prevOptions ?? {}, newOptions);
            if (Object.keys(resultOptions).length > 1) columnOptions.push(resultOptions);
        }
        this.userOptions.columns = columnOptions;
        this.reloadColumnOptions();
        return columnDiffOptions;
    }
    /**
     * Updates the Grid with new options.
     *
     * @param options
     * The options of the Grid that should be updated. If not provided,
     * the update will be proceeded based on the `this.userOptions` property.
     * The `column` options are merged using the `id` property as a key.
     *
     * @param redraw
     * Whether to redraw the Grid after updating the options.
     *
     * @param oneToOne
     * When `false` (default), the existing column options will be merged with
     * the ones that are currently defined in the user options. When `true`,
     * the columns not defined in the new options will be removed.
     */ async update(options = {}, redraw = true, oneToOne = false) {
        $e4d319e66f19a91b$var$fireEvent(this, 'beforeUpdate', {
            scope: 'grid',
            options: options,
            redraw: redraw,
            oneToOne: oneToOne
        });
        const { viewport: viewport } = this;
        const diff = this.loadUserOptions(options, oneToOne);
        const flags = this.dirtyFlags;
        if (viewport) {
            if (!this.dataTable || 'dataTable' in diff) {
                this.userOptions.dataTable = options.dataTable;
                (this.options ?? {}).dataTable = options.dataTable;
                this.loadDataTable();
                // TODO: Sometimes it can be too much, so we need to check if
                // the columns have changed or just their data. If just their
                // data, we can just mark the grid.table as dirty instead of the
                // whole grid.
                flags.add('grid');
            }
            if ('columns' in diff) {
                const ids = Object.keys(diff.columns ?? {});
                for (const id of ids){
                    // TODO: Move this to the column update method.
                    this.loadColumnOptionDiffs(viewport, id, diff.columns?.[id]);
                    delete diff.columns?.[id];
                }
                delete diff.columns;
            }
            if ('columnDefaults' in diff) {
                this.loadColumnOptionDiffs(viewport, null, diff.columnDefaults);
                delete diff.columnDefaults;
            }
            if (diff.lang) {
                const langDiff = diff.lang;
                if ('locale' in langDiff) {
                    this.locale = langDiff.locale;
                    this.time.update({
                        locale: this.locale
                    });
                }
                delete langDiff.locale;
                // TODO: Add more lang diff checks here.
                if (Object.keys(langDiff).length > 0) flags.add('grid');
            }
            delete diff.lang;
            if ('time' in diff) {
                this.time.update(diff.time);
                delete diff.time;
            }
            if (diff.pagination) {
                const paginationDiff = diff.pagination;
                if ('enabled' in paginationDiff) {
                    if (!this.pagination && paginationDiff.enabled) this.pagination = new (0, $32BbZ.default)(this);
                }
                this.pagination?.update(paginationDiff);
            }
            delete diff.pagination;
            // TODO: Add more options that can be optimized here.
            if (Object.keys(diff).length > 0) flags.add('grid');
        } else flags.add('grid');
        if (redraw) await this.redraw();
        $e4d319e66f19a91b$var$fireEvent(this, 'afterUpdate', {
            scope: 'grid',
            options: options,
            redraw: redraw,
            oneToOne: oneToOne
        });
    }
    /**
     * Loads the column option diffs by updating the dirty flags.
     *
     * @param vp
     * The viewport that the column option diffs should be loaded for.
     *
     * @param columnId
     * The ID of the column that should be updated.
     *
     * @param columnDiff
     * The difference between the previous and the new column options in form
     * of a record of `[column.id]: column.options`. If `null`, assume that
     * it refers to the column defaults.
     */ loadColumnOptionDiffs(vp, columnId, columnDiff = {}) {
        if (Object.keys(columnDiff).length < 1) return;
        const flags = this.dirtyFlags;
        const column = columnId ? this.viewport?.getColumn(columnId) : null;
        if (column !== null && (!column && columnDiff.enabled !== false || column && columnDiff.enabled === false)) flags.add('grid');
        delete columnDiff.enabled;
        if ('cells' in columnDiff) {
            const cellsDiff = columnDiff.cells ?? {};
            if ('format' in cellsDiff || 'formatter' in cellsDiff || 'className' in cellsDiff // TODO: check if this too
            ) // Optimization idea: list of columns to update
            flags.add('rows');
            delete cellsDiff.format;
            delete cellsDiff.formatter;
            delete cellsDiff.className;
            if (Object.keys(cellsDiff).length > 0) flags.add('rows');
        }
        delete columnDiff.cells;
        if ('width' in columnDiff) vp.columnResizing.isDirty = true;
        delete columnDiff.width;
        if ('sorting' in columnDiff) {
            const sortingDiff = columnDiff.sorting ?? {};
            if ('compare' in sortingDiff || 'order' in sortingDiff) flags.add('sorting');
            delete sortingDiff.compare;
            delete sortingDiff.order;
            // Idea: sortable - redraw only header cell
            if (Object.keys(sortingDiff).length > 0) flags.add('grid');
        }
        delete columnDiff.sorting;
        if ('filtering' in columnDiff) {
            const filteringDiff = columnDiff.filtering ?? {};
            if ('condition' in filteringDiff || 'value' in filteringDiff) flags.add('filtering');
            delete filteringDiff.condition;
            delete filteringDiff.value;
            if (Object.keys(filteringDiff).length > 0) flags.add('grid');
        }
        delete columnDiff.filtering;
        if (Object.keys(columnDiff).length > 0) flags.add('grid');
    }
    /**
     * Redraws the Grid in more optimized way than the regular render method.
     * It checks what parts of the Grid are marked as dirty and redraws only
     * them minimizing the number of DOM operations.
     */ async redraw() {
        $e4d319e66f19a91b$var$fireEvent(this, 'beforeRedraw');
        const flags = this.dirtyFlags;
        if (flags.has('grid')) return await this.render();
        const { viewport: vp, pagination: pagination } = this;
        const colResizing = vp?.columnResizing;
        if (flags.has('sorting') || flags.has('filtering') || pagination?.isDirtyQuerying) this.querying.loadOptions();
        if (colResizing?.isDirty) colResizing.loadColumns();
        if (flags.has('rows') || flags.has('sorting') || flags.has('filtering') || pagination?.isDirtyQuerying) await vp?.updateRows();
        else if (flags.has('reflow') || colResizing?.isDirty) vp?.reflow();
        const columns = vp?.columns ?? [];
        if (flags.has('sorting') || flags.has('filtering')) for (const column of columns)column.header?.toolbar?.refreshState();
        if (flags.has('filtering')) for (const column of columns)column.filtering?.refreshState();
        if (pagination?.isDirtyQuerying) pagination.updateControls(true);
        delete pagination?.isDirtyQuerying;
        delete colResizing?.isDirty;
        flags.clear();
        $e4d319e66f19a91b$var$fireEvent(this, 'afterRedraw');
    }
    /**
     * Updates the column of the Grid with new options.
     *
     * @param columnId
     * The ID of the column that should be updated.
     *
     * @param options
     * The options of the columns that should be updated. If null,
     * column options for this column ID will be removed.
     *
     * @param redraw
     * Whether to redraw the Grid after updating the columns.
     *
     * @param overwrite
     * If true, the column options will be updated by replacing the existing
     * options with the new ones instead of merging them.
     */ async updateColumn(columnId, options, redraw = true, overwrite = false) {
        $e4d319e66f19a91b$var$fireEvent(this, 'beforeUpdate', {
            scope: 'column',
            options: options,
            redraw: redraw,
            overwrite: overwrite,
            columnId: columnId
        });
        const vp = this.viewport;
        const diffs = this.setColumnOptions([
            {
                id: columnId,
                ...options
            }
        ], overwrite);
        const diff = diffs?.[columnId];
        if (diff && vp) this.loadColumnOptionDiffs(vp, columnId, diff);
        if (redraw) await this.redraw();
        $e4d319e66f19a91b$var$fireEvent(this, 'afterUpdate', {
            scope: 'column',
            options: options,
            redraw: redraw,
            overwrite: overwrite,
            columnId: columnId
        });
    }
    async render() {
        if (this.isRendered) this.destroy(true);
        this.loadDataTable();
        this.initContainer(this.renderTo);
        this.initAccessibility();
        this.initPagination();
        this.querying.loadOptions();
        await this.querying.proceed();
        this.renderViewport();
        this.isRendered = true;
        this.dirtyFlags.clear();
    }
    /**
     * Hovers the row with the provided index. It removes the hover effect from
     * the previously hovered row.
     *
     * @param rowIndex
     * The index of the row.
     */ hoverRow(rowIndex) {
        const rows = this.viewport?.rows;
        if (!rows) return;
        const firstRowIndex = this.viewport?.rows[0]?.index ?? 0;
        if (this.hoveredRowIndex !== void 0) rows[this.hoveredRowIndex - firstRowIndex]?.setHoveredState(false);
        if (rowIndex !== void 0) rows[rowIndex - firstRowIndex]?.setHoveredState(true);
        this.hoveredRowIndex = rowIndex;
    }
    /**
     * Hovers the column with the provided ID. It removes the hover effect from
     * the previously hovered column.
     *
     * @param columnId
     * The ID of the column.
     */ hoverColumn(columnId) {
        const vp = this.viewport;
        if (!vp) return;
        if (this.hoveredColumnId) vp.getColumn(this.hoveredColumnId)?.setHoveredState(false);
        if (columnId) vp.getColumn(columnId)?.setHoveredState(true);
        this.hoveredColumnId = columnId;
    }
    /**
     * Sets the sync state to the row with the provided index. It removes the
     * synced effect from the previously synced row.
     *
     * @param rowIndex
     * The index of the row.
     */ syncRow(rowIndex) {
        const rows = this.viewport?.rows;
        if (!rows) return;
        const firstRowIndex = this.viewport?.rows[0]?.index ?? 0;
        if (this.syncedRowIndex !== void 0) rows[this.syncedRowIndex - firstRowIndex]?.setSyncedState(false);
        if (rowIndex !== void 0) rows[rowIndex - firstRowIndex]?.setSyncedState(true);
        this.syncedRowIndex = rowIndex;
    }
    /**
     * Sets the sync state to the column with the provided ID. It removes the
     * synced effect from the previously synced column.
     *
     * @param columnId
     * The ID of the column.
     */ syncColumn(columnId) {
        const vp = this.viewport;
        if (!vp) return;
        if (this.syncedColumnId) vp.getColumn(this.syncedColumnId)?.setSyncedState(false);
        if (columnId) vp.getColumn(columnId)?.setSyncedState(true);
        this.syncedColumnId = columnId;
    }
    /**
     * Render caption above the grid.
     * @internal
     */ renderCaption() {
        const captionOptions = this.options?.caption;
        const captionText = captionOptions?.text;
        if (!captionText) return;
        // Create a caption element.
        this.captionElement = $e4d319e66f19a91b$var$makeHTMLElement('div', {
            className: (0, $7Tdil.default).getClassName('captionElement'),
            id: this.id + '-caption'
        }, this.contentWrapper);
        // Render the caption element content.
        $e4d319e66f19a91b$var$setHTMLContent(this.captionElement, captionText);
        if (captionOptions.className) this.captionElement.classList.add(...captionOptions.className.split(/\s+/g));
    }
    /**
     * Render description under the grid.
     *
     * @internal
     */ renderDescription() {
        const descriptionOptions = this.options?.description;
        const descriptionText = descriptionOptions?.text;
        if (!descriptionText) return;
        // Create a description element.
        this.descriptionElement = $e4d319e66f19a91b$var$makeHTMLElement('div', {
            className: (0, $7Tdil.default).getClassName('descriptionElement'),
            id: this.id + '-description'
        }, this.contentWrapper);
        // Render the description element content.
        $e4d319e66f19a91b$var$setHTMLContent(this.descriptionElement, descriptionText);
        if (descriptionOptions.className) this.descriptionElement.classList.add(...descriptionOptions.className.split(/\s+/g));
    }
    /**
     * Resets the content wrapper of the Grid. It clears the content and
     * resets the class names.
     * @internal
     */ resetContentWrapper() {
        if (!this.contentWrapper) return;
        this.contentWrapper.innerHTML = (0, $6phAG.default).emptyHTML;
        this.contentWrapper.className = (0, $7Tdil.default).getClassName('container') + ' ' + this.options?.rendering?.theme || '';
    }
    /**
     * Renders the viewport of the Grid. If the Grid is already
     * rendered, it will be destroyed and re-rendered with the new data.
     * @internal
     */ renderViewport() {
        const viewportMeta = this.viewport?.getStateMeta();
        const pagination = this.pagination;
        const paginationPosition = pagination?.options?.position;
        this.enabledColumns = this.getEnabledColumnIDs();
        this.credits?.destroy();
        this.viewport?.destroy();
        delete this.viewport;
        this.resetContentWrapper();
        $e4d319e66f19a91b$var$fireEvent(this, 'beforeRenderViewport');
        this.renderCaption();
        // Render top pagination if enabled (before table)
        if (paginationPosition === 'top') pagination?.render();
        if (this.enabledColumns.length > 0) {
            this.viewport = this.renderTable();
            if (viewportMeta && this.viewport) this.viewport.applyStateMeta(viewportMeta);
        } else this.renderNoData();
        this.accessibility?.setA11yOptions();
        // Render bottom pagination, footer pagination,
        // or custom container pagination (after table).
        if (paginationPosition !== 'top') pagination?.render();
        this.renderDescription();
        $e4d319e66f19a91b$var$fireEvent(this, 'afterRenderViewport');
        this.viewport?.reflow();
    }
    /**
     * Renders the table (viewport) of the Grid.
     *
     * @returns
     * The newly rendered table (viewport) of the Grid.
     */ renderTable() {
        this.tableElement = $e4d319e66f19a91b$var$makeHTMLElement('table', {
            className: (0, $7Tdil.default).getClassName('tableElement')
        }, this.contentWrapper);
        this.tableElement.setAttribute('role', 'grid');
        return new (0, $ekDzA.default)(this, this.tableElement);
    }
    /**
     * Renders a message that there is no data to display.
     */ renderNoData() {
        $e4d319e66f19a91b$var$makeHTMLElement('div', {
            className: (0, $7Tdil.default).getClassName('noData'),
            innerText: this.options?.lang?.noData
        }, this.contentWrapper);
    }
    /**
     * Returns the array of IDs of columns that should be displayed in the data
     * grid, in the correct order.
     */ getEnabledColumnIDs() {
        const { columnOptionsMap: columnOptionsMap } = this;
        const header = this.options?.header;
        const headerColumns = this.getColumnIds(header || [], false);
        const columnsIncluded = this.options?.rendering?.columns?.included || (headerColumns && headerColumns.length > 0 ? headerColumns : this.dataTable?.getColumnIds());
        if (!columnsIncluded?.length) return [];
        if (!columnOptionsMap) return columnsIncluded;
        let columnId;
        const result = [];
        for(let i = 0, iEnd = columnsIncluded.length; i < iEnd; ++i){
            columnId = columnsIncluded[i];
            if (columnOptionsMap?.[columnId]?.options?.enabled !== false) result.push(columnId);
        }
        return result;
    }
    /**
     * Loads the data table of the Grid. If the data table is passed as a
     * reference, it should be used instead of creating a new one.
     */ loadDataTable() {
        this.querying.shouldBeUpdated = true;
        // Unregister all events attached to the previous data table.
        this.dataTableEventDestructors.forEach((fn)=>fn());
        const tableOptions = this.options?.dataTable;
        // If the table is passed as a reference, it should be used instead of
        // creating a new one.
        if (tableOptions?.clone) {
            this.dataTable = tableOptions;
            this.presentationTable = this.dataTable.getModified();
            return;
        }
        const dt = this.dataTable = this.presentationTable = new (0, $5PVyc.default)(tableOptions);
        // If the data table is modified, mark the querying controller to be
        // updated on the next proceed.
        [
            'afterDeleteColumns',
            'afterDeleteRows',
            'afterSetCell',
            'afterSetColumns',
            'afterSetRows'
        ].forEach((eventName)=>{
            this.dataTableEventDestructors.push(dt.on(eventName, ()=>{
                this.querying.shouldBeUpdated = true;
            }));
        });
    }
    /**
     * Extracts all references to columnIds on all levels below defined level
     * in the settings.header structure.
     *
     * @param columnsTree
     * Structure that we start calculation
     *
     * @param [onlyEnabledColumns=true]
     * Extract all columns from header or columns filtered by enabled param
     * @returns
     */ getColumnIds(columnsTree, onlyEnabledColumns = true) {
        let columnIds = [];
        const { enabledColumns: enabledColumns } = this;
        for (const column of columnsTree){
            const columnId = typeof column === 'string' ? column : column.columnId;
            if (columnId && (!onlyEnabledColumns || enabledColumns?.includes(columnId))) columnIds.push(columnId);
            if (typeof column !== 'string' && column.columns) columnIds = columnIds.concat(this.getColumnIds(column.columns, onlyEnabledColumns));
        }
        return columnIds;
    }
    /**
     * Destroys the Grid.
     *
     * @param onlyDOM
     * Whether to destroy the Grid instance completely (`false` - default) or
     * just the DOM elements (`true`). If `true`, the Grid can be re-rendered
     * after destruction by calling the `render` method.
     */ destroy(onlyDOM = false) {
        this.isRendered = false;
        const dgIndex = $e4d319e66f19a91b$export$ef2184bd89960b14.grids.findIndex((dg)=>dg === this);
        this.dataTableEventDestructors.forEach((fn)=>fn());
        this.accessibility?.destroy();
        this.pagination?.destroy();
        this.viewport?.destroy();
        if (this.container) {
            this.container.innerHTML = (0, $6phAG.default).emptyHTML;
            this.container.classList.remove((0, $7Tdil.default).getClassName('container'));
        }
        if (onlyDOM) return;
        // Clear all properties
        Object.keys(this).forEach((key)=>{
            delete this[key];
        });
        $e4d319e66f19a91b$export$ef2184bd89960b14.grids.splice(dgIndex, 1);
    }
    /**
     * Grey out the Grid and show a loading indicator.
     *
     * @param message
     * The message to display in the loading indicator.
     */ showLoading(message) {
        if (this.loadingWrapper) return;
        // Create loading wrapper.
        this.loadingWrapper = $e4d319e66f19a91b$var$makeHTMLElement('div', {
            className: (0, $7Tdil.default).getClassName('loadingWrapper')
        }, this.contentWrapper);
        // Create spinner element.
        $e4d319e66f19a91b$var$makeHTMLElement('div', {
            className: (0, $7Tdil.default).getClassName('loadingSpinner')
        }, this.loadingWrapper);
        // Create loading message span element.
        const loadingSpan = $e4d319e66f19a91b$var$makeHTMLElement('span', {
            className: (0, $7Tdil.default).getClassName('loadingMessage')
        }, this.loadingWrapper);
        $e4d319e66f19a91b$var$setHTMLContent(loadingSpan, $e4d319e66f19a91b$var$pick(message, this.options?.lang?.loading, ''));
    }
    /**
     * Removes the loading indicator.
     */ hideLoading() {
        this.loadingWrapper?.remove();
        delete this.loadingWrapper;
    }
    /**
     * Returns the grid data as a JSON string.
     *
     * @param modified
     * Whether to return the modified data table (after filtering/sorting/etc.)
     * or the unmodified, original one. Default value is set to `true`.
     *
     * @return
     * JSON representation of the data
     */ getData(modified = true) {
        const dataTable = modified ? this.presentationTable : this.dataTable;
        const tableColumns = dataTable?.columns;
        const outputColumns = {};
        if (!this.enabledColumns || !tableColumns) return '{}';
        const typeParser = (type)=>{
            const TypeMap = {
                number: Number,
                datetime: Number,
                string: String,
                'boolean': Boolean
            };
            return (value)=>$e4d319e66f19a91b$var$defined(value) ? TypeMap[type](value) : null;
        };
        for (const columnId of Object.keys(tableColumns)){
            const column = this.viewport?.getColumn(columnId);
            if (column) {
                const columnData = tableColumns[columnId];
                const parser = typeParser(column.dataType);
                outputColumns[columnId] = (()=>{
                    const result = [];
                    for(let i = 0, iEnd = columnData.length; i < iEnd; ++i)result.push(parser(columnData[i]));
                    return result;
                })();
            }
        }
        return JSON.stringify(outputColumns, null, 2);
    }
    /**
     * Returns the current Grid options.
     *
     * @param onlyUserOptions
     * Whether to return only the user options or all options (user options
     * merged with the default ones). Default is `true`.
     *
     * @returns
     * Grid options.
     */ getOptions(onlyUserOptions = true) {
        const options = onlyUserOptions ? $e4d319e66f19a91b$var$merge(this.userOptions) : $e4d319e66f19a91b$var$merge(this.options);
        if (options.dataTable?.id) options.dataTable = {
            columns: options.dataTable.columns
        };
        return options;
    }
}
/* *
*
*  Properties
*
* */ /**
 * An array containing the current Grid objects in the page.
 * @private
 */ $e4d319e66f19a91b$export$ef2184bd89960b14.grids = [];
var /* *
 *
 *  Default Export
 *
 * */ $e4d319e66f19a91b$export$2e2bcd8739ae039 = $e4d319e66f19a91b$export$ef2184bd89960b14;

});
parcelRegister("2LImV", function(module, exports) {

$parcel$export(module.exports, "default", () => $20426342b767ffc5$export$2e2bcd8739ae039);
/* *
 *
 *  Grid Accessibility class
 *
 *  (c) 2020-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Dawid Dragula
 *  - Sebastian Bochan
 *
 * */ 
var $fCJD3 = parcelRequire("fCJD3");

var $7Tdil = parcelRequire("7Tdil");

var $d5G0E = parcelRequire("d5G0E");

var $1I1ai = parcelRequire("1I1ai");
'use strict';
const { formatText: $20426342b767ffc5$var$formatText } = (0, $1I1ai.default);
/**
 *  Representing the accessibility functionalities for the Data Grid.
 */ class $20426342b767ffc5$var$Accessibility {
    /* *
    *
    *  Constructor
    *
    * */ /**
     * Construct the accessibility object.
     *
     * @param grid
     * The Grid Table instance which the accessibility controller belong to.
     */ constructor(grid){
        this.grid = grid;
        this.element = document.createElement('div');
        this.element.classList.add((0, $7Tdil.default).getClassName('visuallyHidden'));
        this.grid.container?.prepend(this.element);
        this.announcerElement = document.createElement('p');
        this.announcerElement.setAttribute('aria-atomic', 'true');
        this.announcerElement.setAttribute('aria-hidden', 'false');
    }
    /* *
    *
    *  Methods
    *
    * */ /**
     * Add the description to the header cell.
     *
     * @param thElement
     * The header cell element to add the description to.
     *
     * @param description
     * The description to be added.
     */ addHeaderCellDescription(thElement, description) {
        if (description) thElement.setAttribute('aria-description', description);
    }
    /**
     * Announce the message to the screen reader.
     *
     * @param msg
     * The message to be announced.
     *
     * @param assertive
     * Whether the message should be assertive. Default is false.
     */ announce(msg, assertive = false) {
        if (this.announcerTimeout) clearTimeout(this.announcerTimeout);
        this.announcerElement.remove();
        this.announcerElement.setAttribute('aria-live', assertive ? 'assertive' : 'polite');
        this.element.appendChild(this.announcerElement);
        requestAnimationFrame(()=>{
            this.announcerElement.textContent = msg;
        });
        this.announcerTimeout = setTimeout(()=>{
            this.announcerElement.remove();
        }, 3000);
    }
    /**
     * Announce the message to the screen reader that the user sorted the
     * column.
     *
     * @param order
     * The order of the sorting.
     */ userSortedColumn(order) {
        const { options: options } = this.grid;
        const announcementsLang = options?.lang?.accessibility?.sorting?.announcements;
        if (!options?.accessibility?.announcements?.sorting) return;
        let msg;
        switch(order){
            case 'asc':
                msg = announcementsLang?.ascending;
                break;
            case 'desc':
                msg = announcementsLang?.descending;
                break;
            default:
                msg = announcementsLang?.none;
        }
        if (!msg) return;
        this.announce(msg, true);
    }
    /**
     * Set the aria sort state of the column header cell element.
     *
     * @param thElement
     * The header cell element to set the `aria-sort` state to.
     *
     * @param state
     * The sort state to be set for the column header cell.
     */ setColumnSortState(thElement, state) {
        thElement?.setAttribute('aria-sort', state);
    }
    /**
     * Announce the message to the screen reader that the user filtered the
     * column.
     *
     * @param filteredColumnValues
     * The values of the filtered column.
     *
     * @param filteringApplied
     * Whether the filtering was applied or cleared.
     */ userFilteredColumn(filteredColumnValues, filteringApplied) {
        const { columnId: columnId, condition: condition, value: value, rowsCount: rowsCount } = filteredColumnValues;
        const { lang: lang, accessibility: accessibility } = this.grid.options || {};
        if (!accessibility?.announcements?.filtering) return;
        const announcementsLang = lang?.accessibility?.filtering?.announcements;
        let msg;
        if (filteringApplied && condition) {
            const parsedCondition = (0, $d5G0E.default).parseCamelCaseToReadable(condition);
            if (condition === 'empty' || condition === 'notEmpty' || condition === 'false' || condition === 'true') msg = $20426342b767ffc5$var$formatText(announcementsLang?.emptyFilterApplied || '', {
                columnId: columnId,
                condition: parsedCondition,
                rowsCount: rowsCount
            });
            else msg = $20426342b767ffc5$var$formatText(announcementsLang?.filterApplied || '', {
                columnId: columnId,
                condition: parsedCondition,
                value: value?.toString() || '',
                rowsCount: rowsCount
            });
        } else msg = $20426342b767ffc5$var$formatText(announcementsLang?.filterCleared || '', {
            columnId: columnId,
            rowsCount: rowsCount
        });
        this.announce(msg, true);
    }
    /**
     * Adds high contrast CSS class, if the browser is in High Contrast mode.
     */ addHighContrast() {
        const highContrastMode = this.grid.options?.accessibility?.highContrastMode;
        if (highContrastMode !== false && ((0, $fCJD3.default).isHighContrastModeActive() || highContrastMode === true)) this.grid.contentWrapper?.classList.add('hcg-theme-highcontrast');
    }
    /**
     * Set the row index attribute for the row element.
     *
     * @param el
     * The row element to set the index to.
     *
     * @param idx
     * The index of the row in the data table.
     */ setRowIndex(el, idx) {
        el.setAttribute('aria-rowindex', idx);
    }
    /**
     * Set a11y options for the Grid.
     */ setA11yOptions() {
        const grid = this.grid;
        const tableEl = grid.tableElement;
        if (!tableEl) return;
        tableEl.setAttribute('aria-rowcount', grid.dataTable?.getRowCount() || 0);
        if (grid.captionElement) tableEl.setAttribute('aria-labelledby', grid.captionElement.id);
        if (grid.descriptionElement) tableEl.setAttribute('aria-describedby', grid.descriptionElement.id);
        this.addHighContrast();
    }
    /**
     * Destroy the accessibility controller.
     */ destroy() {
        this.element.remove();
        this.announcerElement.remove();
        clearTimeout(this.announcerTimeout);
    }
}
var /* *
 *
 *  Default Export
 *
 * */ $20426342b767ffc5$export$2e2bcd8739ae039 = $20426342b767ffc5$var$Accessibility;

});
parcelRegister("fCJD3", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5fdcc952b07ee4f$export$2e2bcd8739ae039);
/* *
 *
 *  (c) 2009-2025 Øystein Moseng
 *
 *  Handling for Windows High Contrast Mode.
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 * */ 
var $30Vhv = parcelRequire("30Vhv");
'use strict';
const { doc: $b5fdcc952b07ee4f$var$doc, isMS: $b5fdcc952b07ee4f$var$isMS, win: $b5fdcc952b07ee4f$var$win } = (0, $30Vhv.default);
/* *
 *
 *  Functions
 *
 * */ /**
 * Detect WHCM in the browser.
 *
 * @function Highcharts#isHighContrastModeActive
 * @private
 * @return {boolean} Returns true if the browser is in High Contrast mode.
 */ function $b5fdcc952b07ee4f$var$isHighContrastModeActive() {
    // Test BG image for IE
    if ($b5fdcc952b07ee4f$var$isMS && $b5fdcc952b07ee4f$var$win.getComputedStyle) {
        const testDiv = $b5fdcc952b07ee4f$var$doc.createElement('div');
        const imageSrc = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
        testDiv.style.backgroundImage = `url(${imageSrc})`; // #13071
        $b5fdcc952b07ee4f$var$doc.body.appendChild(testDiv);
        const bi = (testDiv.currentStyle || $b5fdcc952b07ee4f$var$win.getComputedStyle(testDiv)).backgroundImage;
        $b5fdcc952b07ee4f$var$doc.body.removeChild(testDiv);
        return bi === 'none';
    }
    // Other browsers use the forced-colors standard
    return $b5fdcc952b07ee4f$var$win.matchMedia && $b5fdcc952b07ee4f$var$win.matchMedia('(forced-colors: active)').matches;
}
/**
 * Force high contrast theme for the chart. The default theme is defined in
 * a separate file.
 *
 * @function Highcharts#setHighContrastTheme
 * @private
 * @param {Highcharts.AccessibilityChart} chart The chart to set the theme of.
 * @return {void}
 */ function $b5fdcc952b07ee4f$var$setHighContrastTheme(chart) {
    // We might want to add additional functionality here in the future for
    // storing the old state so that we can reset the theme if HC mode is
    // disabled. For now, the user will have to reload the page.
    chart.highContrastModeActive = true;
    // Apply theme to chart
    const theme = chart.options.accessibility.highContrastTheme;
    chart.update(theme, false);
    const hasCustomColors = theme.colors?.length > 1;
    // Force series colors (plotOptions is not enough)
    chart.series.forEach(function(s) {
        const plotOpts = theme.plotOptions[s.type] || {};
        const fillColor = hasCustomColors && s.colorIndex !== void 0 ? theme.colors[s.colorIndex] : plotOpts.color || 'window';
        const seriesOptions = {
            color: plotOpts.color || 'windowText',
            colors: hasCustomColors ? theme.colors : [
                plotOpts.color || 'windowText'
            ],
            borderColor: plotOpts.borderColor || 'window',
            fillColor: fillColor
        };
        s.update(seriesOptions, false);
        if (s.points) // Force point colors if existing
        s.points.forEach(function(p) {
            if (p.options && p.options.color) p.update({
                color: plotOpts.color || 'windowText',
                borderColor: plotOpts.borderColor || 'window'
            }, false);
        });
    });
    // The redraw for each series and after is required for 3D pie
    // (workaround)
    chart.redraw();
}
/* *
 *
 *  Default Export
 *
 * */ const $b5fdcc952b07ee4f$var$whcm = {
    isHighContrastModeActive: $b5fdcc952b07ee4f$var$isHighContrastModeActive,
    setHighContrastTheme: $b5fdcc952b07ee4f$var$setHighContrastTheme
};
var $b5fdcc952b07ee4f$export$2e2bcd8739ae039 = $b5fdcc952b07ee4f$var$whcm;

});

parcelRegister("7Tdil", function(module, exports) {

$parcel$export(module.exports, "default", () => $5be7fb88e9aa2eed$export$2e2bcd8739ae039);
/* *
 *
 *  (c) 2009-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Dawid Dragula
 *  - Sebastian Bochan
 *
 * */ 'use strict';
const $5be7fb88e9aa2eed$export$821aa83695b9c27 = 'hcg-';
const $5be7fb88e9aa2eed$export$83d89fbfd8236492 = '2.1.1';
const $5be7fb88e9aa2eed$export$3f7cafcc136496be = {
    container: 'container',
    tableElement: 'table',
    captionElement: 'caption',
    descriptionElement: 'description',
    theadElement: 'thead',
    tbodyElement: 'tbody',
    rowElement: 'row',
    rowEven: 'row-even',
    rowOdd: 'row-odd',
    hoveredRow: 'hovered-row',
    columnElement: 'column',
    hoveredCell: 'hovered-cell',
    hoveredColumn: 'hovered-column',
    syncedRow: 'synced-row',
    syncedCell: 'synced-cell',
    syncedColumn: 'synced-column',
    editedCell: 'edited-cell',
    mockedRow: 'mocked-row',
    rowsContentNowrap: 'rows-content-nowrap',
    virtualization: 'virtualization',
    scrollableContent: 'scrollable-content',
    headerCell: 'header-cell',
    headerCellContainer: 'header-cell-container',
    headerCellContent: 'header-cell-content',
    headerCellFilterIcon: 'header-cell-filter-icon',
    headerCellIcons: 'header-cell-icons',
    headerCellSortIcon: 'header-cell-sort-icon',
    headerCellMenuIcon: 'header-cell-menu-icon',
    headerRow: 'head-row-content',
    noData: 'no-data',
    noPadding: 'no-padding',
    columnFirst: 'column-first',
    columnSortable: 'column-sortable',
    columnSortableIcon: 'column-sortable-icon',
    columnSortedAsc: 'column-sorted-asc',
    columnSortedDesc: 'column-sorted-desc',
    resizableContent: 'resizable-content',
    resizerHandles: 'column-resizer',
    resizedColumn: 'column-resized',
    creditsContainer: 'credits-container',
    creditsText: 'credits',
    creditsPro: 'credits-pro',
    visuallyHidden: 'visually-hidden',
    lastHeaderCellInRow: 'last-header-cell-in-row',
    loadingWrapper: 'loading-wrapper',
    loadingSpinner: 'spinner',
    loadingMessage: 'loading-message',
    popup: 'popup',
    button: 'button',
    buttonSelected: 'button-selected',
    input: 'input',
    icon: 'icon',
    iconSearch: 'icon-search',
    popupContent: 'popup-content',
    columnFilterWrapper: 'column-filter-wrapper',
    toolbarButtonActiveIndicator: 'active-indicator',
    menuContainer: 'menu-container',
    menuItem: 'menu-item',
    menuHeader: 'menu-header',
    menuHeaderCategory: 'menu-header-category',
    menuHeaderName: 'menu-header-name',
    menuItemIcon: 'menu-item-icon',
    menuItemLabel: 'menu-item-label',
    menuDivider: 'menu-divider',
    clearFilterButton: 'clear-filter-button',
    paginationWrapper: 'pagination-wrapper',
    paginationContainer: 'pagination-container',
    paginationPageInfo: 'pagination-info',
    paginationControlsContainer: 'pagination-controls-container',
    paginationNavButtonsContainer: 'pagination-nav-buttons-container',
    paginationNavDropdown: 'pagination-nav-dropdown',
    paginationPageSize: 'pagination-page-size',
    noWidth: 'no-width',
    rightAlign: 'right',
    centerAlign: 'center',
    leftAlign: 'left'
};
const $5be7fb88e9aa2eed$export$10a0f131c0eea21b = window;
const $5be7fb88e9aa2eed$export$3bf036c976d2370d = [];
const $5be7fb88e9aa2eed$export$3dcce53a3755dc8c = $5be7fb88e9aa2eed$export$10a0f131c0eea21b.navigator && $5be7fb88e9aa2eed$export$10a0f131c0eea21b.navigator.userAgent || '';
const $5be7fb88e9aa2eed$export$6446a186d09e379e = $5be7fb88e9aa2eed$export$3dcce53a3755dc8c.indexOf('Chrome') !== -1;
const $5be7fb88e9aa2eed$export$95df08bae54cb4df = !$5be7fb88e9aa2eed$export$6446a186d09e379e && $5be7fb88e9aa2eed$export$3dcce53a3755dc8c.indexOf('Safari') !== -1;
const $5be7fb88e9aa2eed$export$307b18b61172f7ed = (classNameKey)=>$5be7fb88e9aa2eed$export$821aa83695b9c27 + $5be7fb88e9aa2eed$export$3f7cafcc136496be[classNameKey];
var /* *
 *
 *  Default Export
 *
 * */ $5be7fb88e9aa2eed$export$2e2bcd8739ae039 = {
    classNamePrefix: $5be7fb88e9aa2eed$export$821aa83695b9c27,
    version: $5be7fb88e9aa2eed$export$83d89fbfd8236492,
    rawClassNames: $5be7fb88e9aa2eed$export$3f7cafcc136496be,
    win: $5be7fb88e9aa2eed$export$10a0f131c0eea21b,
    composed: $5be7fb88e9aa2eed$export$3bf036c976d2370d,
    userAgent: $5be7fb88e9aa2eed$export$3dcce53a3755dc8c,
    isChrome: $5be7fb88e9aa2eed$export$6446a186d09e379e,
    isSafari: $5be7fb88e9aa2eed$export$95df08bae54cb4df,
    getClassName: $5be7fb88e9aa2eed$export$307b18b61172f7ed
};

});

parcelRegister("d5G0E", function(module, exports) {

$parcel$export(module.exports, "default", () => $987c543666d2ce2c$export$2e2bcd8739ae039);
/* *
 *
 *  Grid ColumnFiltering class
 *
 *  (c) 2020-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Dawid Dragula
 *  - Sebastian Bochan
 *  - Kamil Kubik
 *
 * */ 
var $l3aRA = parcelRequire("l3aRA");

var $1I1ai = parcelRequire("1I1ai");

var $7Tdil = parcelRequire("7Tdil");

var $ezFgT = parcelRequire("ezFgT");
'use strict';
const { defined: $987c543666d2ce2c$var$defined, fireEvent: $987c543666d2ce2c$var$fireEvent } = (0, $l3aRA.default);
const { makeHTMLElement: $987c543666d2ce2c$var$makeHTMLElement } = (0, $1I1ai.default);
/* *
 *
 *  Class
 *
 * */ /**
 * Class that manages filtering for a dedicated column.
 */ class $987c543666d2ce2c$var$ColumnFiltering {
    /* *
     *
     *  Static Methods
     *
     * */ /**
     * Parses a camel case string to a readable string and capitalizes the first
     * letter.
     *
     * @param value
     * The camel case string to parse.
     *
     * @returns
     * The readable string with the first letter capitalized.
     */ static parseCamelCaseToReadable(value) {
        const readable = value.replace(/([A-Z])/g, ' $1').trim().toLowerCase().split(/\s+/).join(' ');
        return readable.charAt(0).toUpperCase() + readable.slice(1);
    }
    /* *
    *
    *  Constructor
    *
    * */ /**
     * Constructs filtering controller for a dedicated column.
     *
     * @param column
     * The filtered column.
     */ constructor(column){
        /**
         * Handles the keydown event for the filtering content. Used externally,
         * not in the class itself.
         *
         * @param e
         * The keyboard event.
         */ this.onKeyDown = (e)=>{
            const contentOrder = [];
            if (this.filterSelect && !this.filterSelect.disabled) contentOrder.push(this.filterSelect);
            if (this.filterInput && !this.filterInput.disabled) contentOrder.push(this.filterInput);
            if (this.clearButton && !this.clearButton.disabled) contentOrder.push(this.clearButton);
            const direction = {
                'ArrowDown': 1,
                'ArrowUp': -1
            }[e.key];
            if (direction) {
                e.preventDefault();
                const currentIndex = contentOrder.indexOf(e.target);
                const n = contentOrder.length;
                contentOrder[(currentIndex + direction + n) % n].focus();
                return;
            }
            if (e.key === 'Enter') {
                if (e.target === this.clearButton) {
                    e.preventDefault();
                    this.set();
                    contentOrder[0]?.focus();
                    return;
                }
            }
        };
        this.column = column;
    }
    /* *
    *
    *  Methods
    *
    * */ /**
     * Sets the value and condition for the filtering.
     *
     * @param value
     * The value to set.
     *
     * @param condition
     * The condition to set.
     */ async set(value, condition) {
        if (this.filterInput) this.filterInput.value = value ?? '';
        if (this.filterSelect) this.filterSelect.value = condition ?? (0, $ezFgT.conditionsMap)[this.column.dataType][0];
        await this.applyFilter({
            value: value,
            condition: condition
        });
    }
    /**
     * Refreshes the state of the filtering content by updating the select,
     * input and clear button according to the column filtering options.
     * @internal
     */ refreshState() {
        const colFilteringOptions = this.column.options.filtering;
        if (this.filterSelect) this.filterSelect.value = colFilteringOptions?.condition ?? (0, $ezFgT.conditionsMap)[this.column.dataType][0];
        if (this.filterInput) this.filterInput.value = '' + (colFilteringOptions?.value ?? '');
        if (this.clearButton) this.clearButton.disabled = !this.isFilteringApplied();
        this.disableInputIfNeeded();
    }
    /**
     * Render the filtering content in the container.
     *
     * @param container
     * The container element.
     */ renderFilteringContent(container) {
        const column = this.column;
        const columnType = column.dataType;
        if (!column.options.filtering?.enabled) return;
        // Render the input wrapper.
        const inputWrapper = $987c543666d2ce2c$var$makeHTMLElement('div', {
            className: (0, $7Tdil.default).getClassName('columnFilterWrapper')
        }, container);
        this.renderConditionSelect(inputWrapper);
        if (columnType !== 'boolean') this.renderFilteringInput(inputWrapper, columnType);
        this.renderClearButton(inputWrapper);
    }
    /**
     * Takes the filtering value and condition from the inputs and applies it
     * to the column.
     */ applyFilterFromForm() {
        const result = {
            condition: this.filterSelect?.value
        };
        if (this.filterInput) result.value = this.filterInput.value;
        if (result.condition && (0, $ezFgT.conditionsMap)[this.column.dataType].includes(result.condition)) this.applyFilter(result);
    }
    /**
     * Applies the filtering to the column.
     *
     * @param condition
     * The filtering condition.
     */ async applyFilter(condition) {
        const viewport = this.column.viewport;
        const querying = viewport.grid.querying;
        const filteringController = querying.filtering;
        const columnId = this.column.id;
        const a11y = viewport.grid.accessibility;
        const { value: value } = condition;
        $987c543666d2ce2c$var$fireEvent(this.column, 'beforeFilter', {
            target: this.column
        });
        const filteringApplied = this.isFilteringApplied();
        const clearButton = this.clearButton;
        if (clearButton && filteringApplied === clearButton.disabled) clearButton.disabled = !filteringApplied;
        if ($987c543666d2ce2c$var$defined(value) && value !== '' && typeof value !== 'number') switch(this.column.dataType){
            case 'number':
                condition.value = Number(value);
                break;
            case 'datetime':
                condition.value = new Date(`${value}Z`).getTime();
                break;
        }
        this.column.setOptions({
            filtering: {
                condition: condition.condition,
                value: condition.value
            }
        });
        filteringController.addColumnFilterCondition(columnId, condition);
        this.disableInputIfNeeded();
        await querying.proceed();
        await viewport.updateRows();
        a11y?.userFilteredColumn({
            ...condition,
            columnId: columnId,
            rowsCount: viewport.rows.length
        }, filteringApplied);
        $987c543666d2ce2c$var$fireEvent(this.column, 'afterFilter', {
            target: this.column
        });
    }
    /**
     * Render the filtering input element, based on the column type.
     *
     * @param inputWrapper
     * Reference to the input wrapper.
     *
     * @param columnType
     * Reference to the column type.
     */ renderFilteringInput(inputWrapper, columnType) {
        // Render the input element.
        this.filterInput = $987c543666d2ce2c$var$makeHTMLElement('input', {
            className: (0, $7Tdil.default).getClassName('input')
        }, inputWrapper);
        this.filterInput.setAttribute('tabindex', '-1');
        const column = this.column;
        this.filterInput.setAttribute('id', 'filter-input-' + column.viewport.grid.id + '-' + column.id);
        this.filterInput.placeholder = 'Value...';
        if (columnType === 'number') this.filterInput.type = 'number';
        else if (columnType === 'datetime') this.filterInput.type = 'date';
        else {
            this.filterInput.type = 'text';
            this.filterInput.classList.add((0, $7Tdil.default).getClassName('icon'), (0, $7Tdil.default).getClassName('iconSearch'));
        }
        // Assign the default input value.
        const { value: value } = this.column.options.filtering ?? {};
        if (value || value === 0) this.filterInput.value = columnType === 'datetime' ? column.viewport.grid.time.dateFormat('%Y-%m-%d', Number(value)) : value.toString();
        if (this.filterSelect) this.disableInputIfNeeded();
        const eventTypes = {
            string: [
                'keyup'
            ],
            number: [
                'keyup',
                'change'
            ],
            datetime: [
                'change'
            ]
        };
        for (const eventType of eventTypes[columnType])this.filterInput.addEventListener(eventType, ()=>{
            this.applyFilterFromForm();
        });
    }
    /**
     * Render the condition select element.
     *
     * @param inputWrapper
     * Reference to the input wrapper.
     */ renderConditionSelect(inputWrapper) {
        // Render the select element.
        this.filterSelect = $987c543666d2ce2c$var$makeHTMLElement('select', {
            className: (0, $7Tdil.default).getClassName('input')
        }, inputWrapper);
        this.filterSelect.setAttribute('tabindex', '-1');
        const column = this.column;
        this.filterSelect.setAttribute('id', 'filter-select-' + column.viewport.grid.id + '-' + column.id);
        const conditions = (0, $ezFgT.conditionsMap)[column.dataType];
        const langConditions = this.column.viewport.grid.options?.lang?.columnFilteringConditions ?? {};
        // Render the options.
        for (const condition of conditions){
            const optionElement = document.createElement('option');
            optionElement.value = condition;
            optionElement.textContent = langConditions[condition] ?? $987c543666d2ce2c$var$ColumnFiltering.parseCamelCaseToReadable(condition);
            this.filterSelect.appendChild(optionElement);
        }
        // Use condition from options or first available condition as default.
        const filteringCondition = this.column.options.filtering?.condition;
        if (filteringCondition && conditions.includes(filteringCondition)) this.filterSelect.value = filteringCondition;
        else this.filterSelect.value = conditions[0];
        this.disableInputIfNeeded();
        // Attach event listener.
        this.filterSelect.addEventListener('change', ()=>{
            this.applyFilterFromForm();
        });
    }
    renderClearButton(inputWrapper) {
        this.clearButton = $987c543666d2ce2c$var$makeHTMLElement('button', {
            className: (0, $7Tdil.default).getClassName('clearFilterButton'),
            innerText: 'Clear filter' // TODO: Lang
        }, inputWrapper);
        this.clearButton.setAttribute('tabindex', '-1');
        this.clearButton.disabled = !this.isFilteringApplied();
        this.clearButton.addEventListener('click', ()=>{
            this.set();
        });
    }
    /**
     * Checks if filtering is applied to the column.
     *
     * @returns
     * `true` if filtering is applied to the column, `false` otherwise.
     */ isFilteringApplied() {
        const { filterSelect: select, filterInput: input } = this;
        const { dataType: dataType } = this.column;
        const condition = select?.value;
        if (dataType === 'boolean') return condition !== 'all';
        if (condition === 'empty' || condition === 'notEmpty') return true;
        return input?.value !== '';
    }
    /**
     * Disables the input element if the condition is `empty` or `notEmpty`.
     */ disableInputIfNeeded() {
        const { filterSelect: select, filterInput: input } = this;
        const condition = select?.value;
        if (!input || !select) return;
        if (condition === 'empty' || condition === 'notEmpty') input.disabled = true;
        else if (input?.disabled) input.disabled = false;
    }
}
var /* *
 *
 *  Default Export
 *
 * */ $987c543666d2ce2c$export$2e2bcd8739ae039 = $987c543666d2ce2c$var$ColumnFiltering;

});
parcelRegister("1I1ai", function(module, exports) {

$parcel$export(module.exports, "default", () => $13eacddabb22d706$export$2e2bcd8739ae039);
/* *
 *
 *  Grid utilities
 *
 *  (c) 2009-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Dawid Dragula
 *
 * */ 
var $6phAG = parcelRequire("6phAG");

var $l3aRA = parcelRequire("l3aRA");
const { isObject: $13eacddabb22d706$var$isObject } = (0, $l3aRA.default);
(0, $6phAG.default).allowedAttributes.push('srcset', 'media');
(0, $6phAG.default).allowedTags.push('picture', 'source');
function $13eacddabb22d706$export$c65c2a2dddfa2617(tagName, params, parent) {
    const element = document.createElement(tagName);
    if (params) {
        const paramsKeys = Object.keys(params);
        for(let i = 0; i < paramsKeys.length; i++){
            const key = paramsKeys[i];
            const value = params[key];
            if (value !== void 0) {
                if (key === 'style') Object.assign(element.style, value);
                else element[key] = value;
            }
        }
    }
    if (parent) parent.appendChild(element);
    return element;
}
function $13eacddabb22d706$export$acc4b943f61e54d9(className, id) {
    return $13eacddabb22d706$export$c65c2a2dddfa2617('div', {
        className: className,
        id: id
    });
}
function $13eacddabb22d706$export$be74c3c85f86c3a2(str) {
    return str.indexOf('<') !== -1;
}
function $13eacddabb22d706$export$ba2133a82fa5e0a1(text) {
    try {
        return new DOMParser().parseFromString(text, 'text/html').body.textContent || '';
    } catch  {
        return '';
    }
}
function $13eacddabb22d706$export$f700236e0a6fc0c7(element, content) {
    if ($13eacddabb22d706$export$be74c3c85f86c3a2(content)) {
        element.innerHTML = (0, $6phAG.default).emptyHTML;
        const formattedNodes = new (0, $6phAG.default)(content);
        formattedNodes.addToDOM(element);
    } else element.innerText = content;
}
function $13eacddabb22d706$export$e45a85b5c7beaf0f(options, defaultOptions = {}) {
    const handler = (defaults = {})=>({
            get (target, prop) {
                const targetValue = target[prop];
                const defaultValue = defaults[prop];
                if ($13eacddabb22d706$var$isObject(targetValue, true)) return new Proxy(targetValue, handler(defaultValue ?? {}));
                return targetValue ?? defaultValue;
            },
            set (target, prop, value) {
                target[prop] = value;
                return true;
            },
            deleteProperty (target, prop) {
                delete target[prop];
                return true;
            }
        });
    return new Proxy(options, handler(defaultOptions));
}
function $13eacddabb22d706$export$905fe28a7c283e1d(template, values) {
    return template.replace(/\{(\w+)\}/g, (match, key)=>values[key] !== void 0 ? String(values[key]) : match);
}
var /* *
 *
 *  Default Export
 *
 * */ $13eacddabb22d706$export$2e2bcd8739ae039 = {
    makeHTMLElement: $13eacddabb22d706$export$c65c2a2dddfa2617,
    makeDiv: $13eacddabb22d706$export$acc4b943f61e54d9,
    isHTML: $13eacddabb22d706$export$be74c3c85f86c3a2,
    sanitizeText: $13eacddabb22d706$export$ba2133a82fa5e0a1,
    setHTMLContent: $13eacddabb22d706$export$f700236e0a6fc0c7,
    createOptionsProxy: $13eacddabb22d706$export$e45a85b5c7beaf0f,
    formatText: $13eacddabb22d706$export$905fe28a7c283e1d
};

});

parcelRegister("ezFgT", function(module, exports) {

$parcel$export(module.exports, "conditionsMap", () => $a9c45934fd71ac56$export$a6bc4aa4ff1d8c4d);
/* *
 *
 *  Grid Filtering Types and Constants
 *
 *  (c) 2020-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Dawid Dragula
 *  - Sebastian Bochan
 *  - Kamil Kubik
 *
 * */ 'use strict';
const $a9c45934fd71ac56$export$c2c6519a5078bfc7 = [
    'contains',
    'doesNotContain',
    'equals',
    'doesNotEqual',
    'beginsWith',
    'endsWith',
    'empty',
    'notEmpty'
];
const $a9c45934fd71ac56$export$4f44fe82eac7cdcb = [
    'equals',
    'doesNotEqual',
    'greaterThan',
    'greaterThanOrEqualTo',
    'lessThan',
    'lessThanOrEqualTo',
    'empty',
    'notEmpty'
];
const $a9c45934fd71ac56$export$d0ad9785b70de4f1 = [
    'equals',
    'doesNotEqual',
    'before',
    'after',
    'empty',
    'notEmpty'
];
const $a9c45934fd71ac56$export$991f1ebe5f6aa880 = [
    'all',
    'true',
    'false',
    'empty'
];
const $a9c45934fd71ac56$export$cd2af887c2ce67a8 = {
    'all': 'all',
    'true': true,
    'false': false,
    'empty': null
};
const $a9c45934fd71ac56$export$a6bc4aa4ff1d8c4d = {
    string: $a9c45934fd71ac56$export$c2c6519a5078bfc7,
    number: $a9c45934fd71ac56$export$4f44fe82eac7cdcb,
    datetime: $a9c45934fd71ac56$export$d0ad9785b70de4f1,
    'boolean': $a9c45934fd71ac56$export$991f1ebe5f6aa880
};

});



parcelRegister("cZqnj", function(module, exports) {

$parcel$export(module.exports, "defaultOptions", () => $974fa4147d9eb400$export$ba43bf67f3d48107);
$parcel$export(module.exports, "default", () => $974fa4147d9eb400$export$2e2bcd8739ae039);
/* *
 *
 *  Grid default options
 *
 *  (c) 2009-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Dawid Dragula
 *  - Sebastian Bochan
 *
 * */ 
var $32BbZ = parcelRequire("32BbZ");

var $l3aRA = parcelRequire("l3aRA");
'use strict';
const { merge: $974fa4147d9eb400$var$merge } = (0, $l3aRA.default);
const $974fa4147d9eb400$export$c8e489186c0b2fd = {
    accessibility: {
        sorting: {
            sortable: 'Sortable.',
            announcements: {
                ascending: 'Sorted ascending.',
                descending: 'Sorted descending.',
                none: 'Not sorted.'
            }
        },
        pagination: {
            announcements: {
                pageSizeChange: 'Page size changed to',
                pageChange: 'Page changed to'
            }
        },
        filtering: {
            announcements: {
                filterApplied: "Filter applied for {columnId}, {condition} {value}. {rowsCount} results found.",
                emptyFilterApplied: "Filter applied for {columnId}, {condition} values. {rowsCount} results found.",
                filterCleared: "Filter cleared for {columnId}. {rowsCount} results found."
            }
        }
    },
    loading: 'Loading...',
    noData: 'No data to display',
    filter: 'Filter',
    sortAscending: 'Sort ascending',
    sortDescending: 'Sort descending',
    column: 'Column',
    setFilter: 'Set filter',
    pagination: {
        pageInfo: "Showing {start} - {end} of {total} (page {currentPage} of {totalPages})",
        pageSizeLabel: 'rows per page',
        firstPage: 'First page',
        previousPage: 'Previous page',
        nextPage: 'Next page',
        lastPage: 'Last page',
        pageNumber: 'Page {page}',
        ellipsis: 'More pages'
    },
    columnFilteringConditions: {
        contains: 'Contains',
        doesNotContain: 'Does not contain',
        equals: 'Equals',
        doesNotEqual: 'Does not equal',
        beginsWith: 'Begins with',
        endsWith: 'Ends with',
        empty: 'Empty',
        notEmpty: 'Not empty',
        greaterThan: 'Greater than',
        greaterThanOrEqualTo: 'Greater than or equal to',
        lessThan: 'Less than',
        lessThanOrEqualTo: 'Less than or equal to',
        before: 'Before',
        after: 'After',
        all: 'All',
        'true': 'True',
        'false': 'False'
    }
};
const $974fa4147d9eb400$export$ba43bf67f3d48107 = {
    accessibility: {
        enabled: true,
        highContrastMode: 'auto',
        announcements: {
            sorting: true,
            filtering: true
        }
    },
    time: {
        timezone: 'UTC'
    },
    rendering: {
        rows: {
            bufferSize: 10,
            minVisibleRows: 2,
            strictHeights: false,
            virtualizationThreshold: 50
        },
        header: {
            enabled: true
        },
        columns: {
            resizing: {
                enabled: true,
                mode: 'adjacent'
            }
        },
        theme: 'hcg-theme-default'
    },
    columnDefaults: {
        sorting: {
            sortable: true
        },
        filtering: {
            inline: false
        }
    },
    pagination: (0, $32BbZ.default).defaultOptions,
    lang: $974fa4147d9eb400$export$c8e489186c0b2fd
};
function $974fa4147d9eb400$export$add91eafeaeab287(options) {
    $974fa4147d9eb400$var$merge(true, $974fa4147d9eb400$export$ba43bf67f3d48107, options);
}
var /* *
 *
 *  Default Export
 *
 * */ $974fa4147d9eb400$export$2e2bcd8739ae039 = {
    defaultOptions: $974fa4147d9eb400$export$ba43bf67f3d48107,
    setOptions: $974fa4147d9eb400$export$add91eafeaeab287
};

});
parcelRegister("32BbZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $236e689f635c45aa$export$2e2bcd8739ae039);
/* *
 *
 *  Grid Pagination class
 *
 *  (c) 2020-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Sebastian Bochan
 *
 * */ 
var $dmBL2 = parcelRequire("dmBL2");

var $7Tdil = parcelRequire("7Tdil");

var $1I1ai = parcelRequire("1I1ai");

var $l3aRA = parcelRequire("l3aRA");

var $6phAG = parcelRequire("6phAG");
'use strict';
const { makeHTMLElement: $236e689f635c45aa$var$makeHTMLElement, formatText: $236e689f635c45aa$var$formatText } = (0, $1I1ai.default);
const { defined: $236e689f635c45aa$var$defined, fireEvent: $236e689f635c45aa$var$fireEvent, isObject: $236e689f635c45aa$var$isObject, merge: $236e689f635c45aa$var$merge } = (0, $l3aRA.default);
/**
 *  Representing the pagination functionalities for the Grid.
 */ class $236e689f635c45aa$var$Pagination {
    /* *
    *
    *  Constructor
    *
    * */ /**
     * Construct the pagination object.
     *
     * @param grid
     * The Grid Table instance which the pagination controller belongs to.
     */ constructor(grid){
        this.grid = grid;
        this.controller = grid.querying.pagination;
    }
    /* *
    *
    *  Methods
    *
    * */ /**
     * Returns the reference to the pagination options.
     */ get options() {
        return this.grid.options?.pagination;
    }
    /**
     * Returns the language options for pagination text.
     */ get lang() {
        return this.grid.options?.lang?.pagination;
    }
    /**
     * Returns the page size selector options.
     */ get pageSizeSelectorOptions() {
        const raw = this.options?.controls?.pageSizeSelector;
        if ($236e689f635c45aa$var$isObject(raw)) return raw.options ?? [];
        return ($236e689f635c45aa$var$Pagination.defaultOptions.controls?.pageSizeSelector).options ?? [];
    }
    /**
     * Internal method to set the dirty flags for the pagination based on the
     * options differences.
     *
     * @param diff
     * The differences between the previous and the new options.
     *
     * @internal
     */ update(diff) {
        if ('page' in diff || 'pageSize' in diff) {
            this.isDirtyQuerying = true;
            delete diff.page;
            delete diff.pageSize;
        }
        // TODO: Optimize more options here.
        if (Object.keys(diff).length > 0) this.grid.dirtyFlags.add('grid');
    }
    /**
     * Render the pagination container.
     *
     * The pagination container is positioned based on the `position` option:
     * - `'top'`: Rendered before the table
     * - `'bottom'`: Rendered after the table (default)
     * - `'footer'`: Rendered inside a tfoot element
     * - `'#id'` or any string: Rendered inside a custom container with
     * the specified ID.
     */ render() {
        const position = this.options?.position;
        const grid = this.grid;
        this.oldTotalItems = this.controller.totalItems;
        // Set row count for a11y
        grid.tableElement?.setAttribute('aria-current', 'page');
        this.updateA11yRowsCount(this.controller.currentPageSize);
        // Render pagination container
        if (typeof position === 'string' && position.startsWith('#')) this.renderCustomContainer(position);
        else {
            if (position === 'footer') this.renderFooter();
            this.contentWrapper = $236e689f635c45aa$var$makeHTMLElement('nav', {
                className: (0, $7Tdil.default).getClassName('paginationWrapper')
            }, position === 'footer' ? this.paginationContainer : grid.contentWrapper);
            this.contentWrapper.setAttribute('aria-label', 'Results pagination');
        }
        // Render all components
        this.renderPageInfo();
        this.renderControls();
        this.renderPageSizeSelector();
        // Update button states after rendering
        this.updateButtonStates();
    }
    /**
     * Render pagination in a tfoot element.
     */ renderFooter() {
        const tableElement = this.grid.tableElement;
        if (!tableElement) return;
        // Create tfoot element
        const tfootElement = $236e689f635c45aa$var$makeHTMLElement('tfoot', {}, tableElement);
        // Create tfoot row
        const tfootRow = $236e689f635c45aa$var$makeHTMLElement('tr', {}, tfootElement);
        // Create tfoot cell with colspan and store it in paginationContainer
        this.paginationContainer = $236e689f635c45aa$var$makeHTMLElement('td', {}, tfootRow);
        this.paginationContainer.setAttribute('colSpan', (this.grid.enabledColumns || []).length.toString());
        this.reflow();
    }
    /**
     * Render pagination in a custom container by ID.
     *
     * @param id
     * The ID of the custom container.
     */ renderCustomContainer(id) {
        const customContainer = document.querySelector(id);
        if (!customContainer) {
            console.warn(`Pagination: Custom container with ID "${id}" not found.`); // eslint-disable-line no-console
            return;
        }
        this.paginationContainer = customContainer;
        // Set content wrapper to the custom container
        this.contentWrapper = $236e689f635c45aa$var$makeHTMLElement('div', {
            className: (0, $7Tdil.default).getClassName('paginationContainer')
        }, customContainer);
    }
    /**
     * Render the page information text.
     */ renderPageInfo() {
        const pageInfo = this.options?.controls?.pageInfo;
        if (pageInfo === false || $236e689f635c45aa$var$isObject(pageInfo) && pageInfo.enabled === false) return;
        this.pageInfoElement = $236e689f635c45aa$var$makeHTMLElement('div', {
            className: (0, $7Tdil.default).getClassName('paginationPageInfo')
        }, this.contentWrapper);
        this.updatePageInfo();
    }
    /**
     * Update the page information text.
     */ updatePageInfo() {
        if (!this.pageInfoElement) return;
        const { currentPage: currentPage, currentPageSize: currentPageSize, totalItems: totalItems, totalPages: totalPages } = this.controller;
        const startItem = (currentPage - 1) * currentPageSize + 1;
        const endItem = Math.min(currentPage * currentPageSize, totalItems);
        const pageInfoText = $236e689f635c45aa$var$formatText(this.lang?.pageInfo ?? '', {
            start: startItem,
            end: endItem,
            total: totalItems,
            currentPage: currentPage,
            totalPages: totalPages
        });
        this.pageInfoElement.innerHTML = pageInfoText;
    }
    /**
     * Render the controls buttons and page numbers.
     */ renderControls() {
        const navContainer = $236e689f635c45aa$var$makeHTMLElement('div', {
            className: (0, $7Tdil.default).getClassName('paginationControlsContainer')
        }, this.contentWrapper);
        const controls = this.options?.controls || {};
        // Render first/previous buttons
        if (controls.firstLastButtons) this.renderFirstButton(navContainer);
        // Render previous button
        if (controls.previousNextButtons) this.renderPrevButton(navContainer);
        // Render page numbers
        if (controls.pageButtons) this.renderPageNumbers(navContainer);
        // Render dropdown page selector
        this.renderDropdownPageSelector(navContainer);
        // Render next button
        if (controls.previousNextButtons) this.renderNextButton(navContainer);
        // Render last/first buttons
        if (controls.firstLastButtons) this.renderLastButton(navContainer);
    }
    /**
     * Update the pagination controls.
     *
     * @param force
     * Whether to force update the controls.
     *
     * @internal
     */ updateControls(force = false) {
        const { totalItems: totalItems, currentPageSize: currentPageSize } = this.controller;
        if (this.oldTotalItems === this.controller.totalItems && !force) return;
        this.updatePageInfo();
        this.updatePageNumbers();
        this.updateButtonStates();
        this.updateA11yRowsCount(currentPageSize);
        this.oldTotalItems = totalItems;
    }
    /**
     * Render the first page button.
     *
     * @param container
     * The container element for the first page button.
     *
     */ renderFirstButton(container) {
        const firstLastButtons = this.options?.controls?.firstLastButtons;
        if (firstLastButtons === false || $236e689f635c45aa$var$isObject(firstLastButtons) && firstLastButtons.enabled === false) return;
        // Create first button
        this.firstButton = $236e689f635c45aa$var$makeHTMLElement('button', {
            className: (0, $7Tdil.default).getClassName('button'),
            innerHTML: (0, $dmBL2.default).first
        }, container);
        this.firstButton.title = this.lang?.firstPage ?? '';
        // Set aria-label for a11y
        this.firstButton.setAttribute('aria-label', this.lang?.firstPage ?? '');
        // Add click event
        this.firstButton.addEventListener('click', ()=>{
            this.goToPage(1);
        });
        this.setButtonState(this.firstButton, this.controller.currentPage === 1);
    }
    /**
     * Render the previous page button.
     *
     * @param container
     * The container element for the previous page button.
     */ renderPrevButton(container) {
        const previousNextButtons = this.options?.controls?.previousNextButtons;
        if (previousNextButtons === false || $236e689f635c45aa$var$isObject(previousNextButtons) && previousNextButtons.enabled === false) return;
        // Create previous button
        this.prevButton = $236e689f635c45aa$var$makeHTMLElement('button', {
            className: (0, $7Tdil.default).getClassName('button'),
            innerHTML: (0, $dmBL2.default).previous
        }, container);
        this.prevButton.title = this.lang?.previousPage ?? '';
        // Set aria-label for a11y
        this.prevButton.setAttribute('aria-label', this.lang?.previousPage ?? '');
        // Add click event
        this.prevButton.addEventListener('click', ()=>{
            this.goToPage(this.controller.currentPage - 1);
        });
        this.setButtonState(this.prevButton, this.controller.currentPage === 1);
    }
    /**
     * Render the next page button.
     *
     * @param container
     * The container element for the next page button.
     */ renderNextButton(container) {
        const previousNextButtons = this.options?.controls?.previousNextButtons;
        if (previousNextButtons === false || $236e689f635c45aa$var$isObject(previousNextButtons) && previousNextButtons.enabled === false) return;
        // Create next button
        this.nextButton = $236e689f635c45aa$var$makeHTMLElement('button', {
            className: (0, $7Tdil.default).getClassName('button'),
            innerHTML: (0, $dmBL2.default).next
        }, container);
        this.nextButton.title = this.lang?.nextPage ?? '';
        // Set aria-label for a11y
        this.nextButton.setAttribute('aria-label', this.lang?.nextPage ?? '');
        // Add click event
        this.nextButton.addEventListener('click', ()=>{
            this.goToPage(this.controller.currentPage + 1);
        });
        this.setButtonState(this.nextButton, this.controller.currentPage >= this.controller.totalPages);
    }
    /**
     * Render the last page button.
     *
     * @param container
     * The container element for the last page button.
     */ renderLastButton(container) {
        const firstLastButtons = this.options?.controls?.firstLastButtons;
        if (firstLastButtons === false || $236e689f635c45aa$var$isObject(firstLastButtons) && firstLastButtons.enabled === false) return;
        // Create last button
        this.lastButton = $236e689f635c45aa$var$makeHTMLElement('button', {
            className: (0, $7Tdil.default).getClassName('button'),
            innerHTML: (0, $dmBL2.default).last
        }, container);
        this.lastButton.title = this.lang?.lastPage ?? '';
        // Set aria-label for a11y
        this.lastButton.setAttribute('aria-label', this.lang?.lastPage ?? '');
        // Add click event
        this.lastButton.addEventListener('click', ()=>{
            this.goToPage(this.controller.totalPages);
        });
        this.setButtonState(this.lastButton, this.controller.currentPage >= this.controller.totalPages);
    }
    /**
     * Render page number buttons with ellipsis.
     *
     * @param container
     * The container element for the page number buttons.
     */ renderPageNumbers(container) {
        const pageButtons = this.options?.controls?.pageButtons;
        if (pageButtons === false || $236e689f635c45aa$var$isObject(pageButtons) && pageButtons.enabled === false) return;
        this.pageNumbersContainer = $236e689f635c45aa$var$makeHTMLElement('div', {
            className: (0, $7Tdil.default).getClassName('paginationNavButtonsContainer')
        }, container);
        this.updatePageNumbers();
    }
    /**
     * Update page number buttons based on current page and total pages.
     */ updatePageNumbers() {
        if (!this.pageNumbersContainer) return;
        // Clear existing page numbers
        this.pageNumbersContainer.innerHTML = (0, $6phAG.default).emptyHTML;
        const pageButtons = this.options?.controls?.pageButtons;
        const maxPageNumbers = $236e689f635c45aa$var$isObject(pageButtons) ? pageButtons.count : ($236e689f635c45aa$var$Pagination.defaultOptions.controls?.pageButtons).count; // eslint-disable-line
        if (!maxPageNumbers) return;
        const { totalPages: totalPages, currentPage: currentPage } = this.controller;
        if (totalPages <= maxPageNumbers) // Show all page numbers if total pages is less than max
        for(let i = 1; i <= totalPages; i++)this.createPageButton(i, i === currentPage);
        else {
            const elements = [];
            // Determine layout based on current page position
            const isNearStart = currentPage <= 3;
            const isNearEnd = currentPage >= totalPages - 2;
            if (isNearStart) {
                // -2 for ellipsis and last page
                const pagesToShow = maxPageNumbers - 2;
                const maxPages = Math.min(pagesToShow, totalPages - 1);
                for(let i = 1; i <= maxPages; i++)elements.push({
                    type: 'button',
                    page: i
                });
                if (totalPages > pagesToShow + 1) {
                    elements.push({
                        type: 'ellipsis'
                    });
                    elements.push({
                        type: 'button',
                        page: totalPages
                    });
                }
            } else if (isNearEnd) {
                // -2 for first page and ellipsis
                const pagesToShow = maxPageNumbers - 2;
                let i = totalPages - pagesToShow + 1;
                elements.push({
                    type: 'button',
                    page: 1
                });
                elements.push({
                    type: 'ellipsis'
                });
                for(i; i <= totalPages; i++)elements.push({
                    type: 'button',
                    page: i
                });
            } else {
                // Always add first page
                elements.push({
                    type: 'button',
                    page: 1
                });
                // -4 for first, last, and two ellipsis
                const maxMiddlePages = maxPageNumbers - 4;
                const halfMiddle = Math.floor(maxMiddlePages / 2);
                let startPage = Math.max(2, currentPage - halfMiddle);
                let endPage = Math.min(totalPages - 1, currentPage + halfMiddle);
                // Adjust to ensure we have exactly maxMiddlePages
                if (endPage - startPage + 1 > maxMiddlePages) {
                    if (startPage === 2) endPage = startPage + maxMiddlePages - 1;
                    else startPage = endPage - maxMiddlePages + 1;
                }
                // Check if we actually need ellipsis
                const needFirstEllipsis = startPage > 2;
                const needLastEllipsis = endPage < totalPages - 1;
                if (!needFirstEllipsis && !needLastEllipsis) {
                    // -2 for first and last
                    const availableSlots = maxPageNumbers - 2;
                    startPage = 2;
                    endPage = Math.min(totalPages - 1, startPage + availableSlots - 1);
                } else if (!needFirstEllipsis) {
                    // -3 for first, last, and one ellipsis
                    const availableSlots = maxPageNumbers - 3;
                    startPage = 2;
                    endPage = Math.min(totalPages - 1, startPage + availableSlots - 1);
                } else if (!needLastEllipsis) {
                    // -3 for first, last, and one ellipsis
                    const availableSlots = maxPageNumbers - 3;
                    endPage = totalPages - 1;
                    startPage = Math.max(2, endPage - availableSlots + 1);
                }
                // Add first ellipsis
                if (needFirstEllipsis) elements.push({
                    type: 'ellipsis'
                });
                // Add middle pages
                for(let i = startPage; i <= endPage; i++)elements.push({
                    type: 'button',
                    page: i
                });
                // Add last ellipsis
                if (needLastEllipsis) elements.push({
                    type: 'ellipsis'
                });
                // Always add last page
                elements.push({
                    type: 'button',
                    page: totalPages
                });
            }
            // Render all elements
            elements.forEach((element)=>{
                if (element.type === 'button' && $236e689f635c45aa$var$defined(element.page)) this.createPageButton(element.page, element.page === currentPage);
                else if (element.type === 'ellipsis') this.createEllipsis();
            });
        }
        // Update dropdown selector if it exists
        this.updateDropdownPageSelector();
    }
    /**
     * Create a page number button.
     *
     * @param pageNumber
     * The page number to create a button for.
     *
     * @param isActive
     * Whether the page number button is active.
     */ createPageButton(pageNumber, isActive) {
        if (!this.pageNumbersContainer) return;
        const button = $236e689f635c45aa$var$makeHTMLElement('button', {
            className: (0, $7Tdil.default).getClassName('button'),
            innerHTML: pageNumber.toString()
        }, this.pageNumbersContainer);
        if (isActive) {
            button.classList.add((0, $7Tdil.default).getClassName('buttonSelected'));
            button.setAttribute('aria-current', 'page');
        }
        button.title = $236e689f635c45aa$var$formatText(this.lang?.pageNumber ?? '', {
            page: pageNumber
        });
        // Set aria-label for a11y
        button.setAttribute('aria-label', $236e689f635c45aa$var$formatText(this.lang?.pageNumber ?? '', {
            page: pageNumber
        }));
        // Add click event
        button.addEventListener('click', ()=>{
            this.goToPage(pageNumber);
        });
    }
    /**
     * Create an ellipsis element.
     */ createEllipsis() {
        if (!this.pageNumbersContainer) return;
        const ellipsisElement = $236e689f635c45aa$var$makeHTMLElement('span', {
            innerHTML: '...'
        }, this.pageNumbersContainer);
        ellipsisElement.title = this.lang?.ellipsis ?? '';
        // Set aria-label for a11y
        ellipsisElement.setAttribute('aria-hidden', true);
    }
    /**
     * Render the page size selector.
     */ renderPageSizeSelector() {
        const pageSizeSelector = this.options?.controls?.pageSizeSelector;
        if (pageSizeSelector === false || $236e689f635c45aa$var$isObject(pageSizeSelector) && pageSizeSelector.enabled === false) return;
        const container = $236e689f635c45aa$var$makeHTMLElement('div', {
            className: (0, $7Tdil.default).getClassName('paginationPageSize')
        }, this.contentWrapper);
        $236e689f635c45aa$var$makeHTMLElement('span', {
            innerHTML: this.lang?.pageSizeLabel ?? ''
        }, container);
        this.pageSizeSelect = $236e689f635c45aa$var$makeHTMLElement('select', {
            className: (0, $7Tdil.default).getClassName('input'),
            id: (0, $7Tdil.default).getClassName('paginationPageSize')
        }, container);
        this.pageSizeSelectorOptions.forEach((option)=>{
            const optionElement = document.createElement('option');
            optionElement.value = option.toString();
            optionElement.innerHTML = option.toString();
            if (option === this.controller.currentPageSize) optionElement.selected = true;
            this.pageSizeSelect?.appendChild(optionElement);
        });
        this.pageSizeSelect.addEventListener('change', ()=>{
            if (!this.pageSizeSelect) return;
            this.setPageSize(parseInt(this.pageSizeSelect.value, 10));
        });
    }
    /**
     * Sets the new options for the pagination.
     *
     * @param newOptions
     * The new options to set.
     */ setOptions(newOptions) {
        var _a, _b, _c;
        const userOptions = (_a = this.grid.userOptions).pagination ?? (_a.pagination = {});
        const options = (_c = (_b = this.grid).options ?? (_b.options = {})).pagination ?? (_c.pagination = {});
        $236e689f635c45aa$var$merge(true, userOptions, newOptions);
        $236e689f635c45aa$var$merge(true, options, newOptions);
    }
    /**
     * Set the page size and recalculate pagination.
     *
     * @param newPageSize
     * The new page size to set.
     */ async setPageSize(newPageSize) {
        const oldPageSize = this.controller.currentPageSize;
        const langAccessibility = this.grid.options?.lang?.accessibility;
        $236e689f635c45aa$var$fireEvent(this, 'beforePageSizeChange', {
            pageSize: oldPageSize,
            newPageSize: newPageSize
        });
        this.controller.setPageSize(newPageSize);
        this.controller.setPage(1);
        this.setOptions({
            pageSize: newPageSize,
            page: 1
        });
        // Update the grid's pagination range
        await this.updateGridPagination();
        // Update UI
        this.updatePageInfo();
        this.updatePageNumbers();
        this.updateButtonStates();
        // Update row count for a11y
        this.updateA11yRowsCount(this.controller.currentPageSize);
        // Announce the page size change
        this.grid.accessibility?.announce(langAccessibility?.pagination?.announcements?.pageSizeChange + ' ' + newPageSize);
        $236e689f635c45aa$var$fireEvent(this, 'afterPageSizeChange', {
            pageSize: newPageSize,
            previousPageSize: oldPageSize
        });
    }
    /**
     * Navigate to a specific page.
     *
     * @param pageNumber
     * The page number to navigate to.
     */ async goToPage(pageNumber) {
        const langAccessibility = this.grid.options?.lang?.accessibility;
        const { totalPages: totalPages, currentPage: currentPage, currentPageSize: currentPageSize } = this.controller;
        if (pageNumber < 1 || pageNumber > totalPages || pageNumber === currentPage) return;
        const previousPage = currentPage;
        $236e689f635c45aa$var$fireEvent(this, 'beforePageChange', {
            currentPage: currentPage,
            nextPage: pageNumber,
            pageSize: currentPageSize
        });
        this.controller.setPage(pageNumber);
        const newPage = this.controller.currentPage; // Take clamped page
        this.setOptions({
            page: newPage
        });
        await this.updateGridPagination();
        this.updatePageInfo();
        this.updatePageNumbers();
        this.updateButtonStates();
        // Announce the page change
        this.grid.accessibility?.announce(langAccessibility?.pagination?.announcements?.pageChange + ' ' + newPage);
        $236e689f635c45aa$var$fireEvent(this, 'afterPageChange', {
            currentPage: newPage,
            previousPage: previousPage,
            pageSize: currentPageSize
        });
    }
    /**
     * Update the grid's pagination state.
     */ async updateGridPagination() {
        // Update the viewport to reflect the new data
        await this.grid.viewport?.updateRows();
        // Scroll to top after page change
        const tBody = this.grid.viewport?.tbodyElement;
        if (tBody) tBody.scrollTop = 0;
    }
    /**
     * Update button states based on current page.
     */ updateButtonStates() {
        const { currentPage: currentPage, totalPages: totalPages } = this.controller;
        if (this.firstButton) this.setButtonState(this.firstButton, currentPage === 1);
        if (this.prevButton) this.setButtonState(this.prevButton, currentPage === 1);
        if (this.nextButton) this.setButtonState(this.nextButton, currentPage >= totalPages);
        if (this.lastButton) this.setButtonState(this.lastButton, currentPage >= totalPages);
    }
    /**
     * Call modifier to replace items with new ones.
     *
     * @param isNextPage
     * Declare prev or next action triggered by button.
     * @returns
     */ async updatePage(isNextPage = true) {
        const { currentPage: currentPage } = this.controller;
        const newPage = isNextPage ? currentPage + 1 : currentPage - 1;
        await this.goToPage(newPage);
    }
    /**
     * Set button state (enabled/disabled).
     *
     * @param button
     * The button to set the state for.
     *
     * @param disabled
     * Whether the button should be disabled.
     */ setButtonState(button, disabled) {
        if (disabled) button.setAttribute('disabled', 'disabled');
        else button.removeAttribute('disabled');
    }
    /**
     * Reflow the pagination container.
     */ reflow() {
        const position = this.options?.position;
        if (!this.paginationContainer) return;
        if (position === 'footer') {
            // Set the width to match the table width
            this.paginationContainer.style.width = this.grid.tableElement?.offsetWidth + 'px';
            return;
        }
    }
    /**
     * Destroy the pagination instance.
     */ destroy() {
        const position = this.options?.position;
        if (position === 'footer') // For footer position, remove the entire tfoot element.
        this.paginationContainer?.parentElement?.parentElement?.remove();
        else this.contentWrapper?.remove();
    }
    /**
     * Render the dropdown page selector (select dropdown).
     *
     * @param container
     * The container element for the dropdown page selector.
     */ renderDropdownPageSelector(container) {
        if (this.controller.totalPages <= 1) return;
        const wrapper = $236e689f635c45aa$var$makeHTMLElement('div', {
            className: (0, $7Tdil.default).getClassName('paginationNavDropdown')
        }, container);
        const select = $236e689f635c45aa$var$makeHTMLElement('select', {
            className: (0, $7Tdil.default).getClassName('input'),
            id: (0, $7Tdil.default).getClassName('paginationNavDropdown')
        }, wrapper);
        this.dropdownPageSelector = select;
        this.updateDropdownPageSelector();
        // Add event listener for page change
        select.addEventListener('change', ()=>{
            const newPage = parseInt(select.value, 10);
            if (newPage !== this.controller.currentPage) this.goToPage(newPage);
        });
    }
    /**
     * Updates the dropdown page selector DOM elements.
     */ updateDropdownPageSelector() {
        const select = this.dropdownPageSelector;
        if (!select) return;
        const { totalPages: totalPages, currentPage: currentPage } = this.controller;
        select.innerHTML = (0, $6phAG.default).emptyHTML;
        // Add options for each page
        for(let i = 1; i <= totalPages; i++){
            const option = $236e689f635c45aa$var$makeHTMLElement('option', {}, select);
            option.value = i.toString();
            option.textContent = `Page ${i} of ${totalPages}`;
        }
        // Set current page as selected
        select.value = currentPage.toString();
    }
    /**
     * Update the row count for a11y.
     *
     * @param currentPageSize
     * The current page size.
     */ updateA11yRowsCount(currentPageSize) {
        const grid = this.grid;
        grid.tableElement?.setAttribute('aria-rowcount', currentPageSize || this.controller.totalItems);
    }
}
/* *
*
*  Static Properties
*
* */ /**
 * Default options of the pagination.
 */ $236e689f635c45aa$var$Pagination.defaultOptions = {
    enabled: false,
    page: 1,
    pageSize: 10,
    position: 'bottom',
    controls: {
        pageSizeSelector: {
            enabled: true,
            options: [
                10,
                20,
                50,
                100
            ]
        },
        pageInfo: {
            enabled: true
        },
        firstLastButtons: {
            enabled: true
        },
        previousNextButtons: {
            enabled: true
        },
        pageButtons: {
            enabled: true,
            count: 7
        }
    }
};
var /* *
 *
 *  Default Export
 *
 * */ $236e689f635c45aa$export$2e2bcd8739ae039 = $236e689f635c45aa$var$Pagination;

});
parcelRegister("dmBL2", function(module, exports) {

$parcel$export(module.exports, "default", () => $9baa9e4e8e5d7d26$export$2e2bcd8739ae039);
const $9baa9e4e8e5d7d26$var$icons = {
    first: '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M5 9L1 5L5 1M9 9L5 5L9 1" stroke="currentColor" stroke-width="1.34" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    previous: '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 8 10" fill="none"><path d="M5 9L1 5L5 1" stroke="currentColor" stroke-width="1.34" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    next: '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 4 10" fill="none"><path d="M1 1L5 5L1 9" stroke="currentColor" stroke-width="1.34" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    last: '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M5 1L9 5L5 9M1 1L5 5L1 9" stroke="currentColor" stroke-width="1.34" stroke-linecap="round" stroke-linejoin="round"/></svg>'
};
var $9baa9e4e8e5d7d26$export$2e2bcd8739ae039 = $9baa9e4e8e5d7d26$var$icons;

});



parcelRegister("ekDzA", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6f1a151c537c40f$export$2e2bcd8739ae039);
/* *
 *
 *  Grid Table Viewport class
 *
 *  (c) 2020-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Dawid Dragula
 *  - Sebastian Bochan
 *
 * */ 
var $1I1ai = parcelRequire("1I1ai");

var $l3aRA = parcelRequire("l3aRA");

var $711xA = parcelRequire("711xA");

var $vHnEw = parcelRequire("vHnEw");

var $5lg52 = parcelRequire("5lg52");

var $dmvLI = parcelRequire("dmvLI");

var $aBO4X = parcelRequire("aBO4X");

var $7Tdil = parcelRequire("7Tdil");
'use strict';
const { makeHTMLElement: $a6f1a151c537c40f$var$makeHTMLElement } = (0, $1I1ai.default);
const { fireEvent: $a6f1a151c537c40f$var$fireEvent, getStyle: $a6f1a151c537c40f$var$getStyle, defined: $a6f1a151c537c40f$var$defined } = (0, $l3aRA.default);
/* *
 *
 *  Class
 *
 * */ /**
 * Represents a table viewport of the data grid.
 */ class $a6f1a151c537c40f$var$Table {
    /* *
    *
    *  Constructor
    *
    * */ /**
     * Constructs a new data grid table.
     *
     * @param grid
     * The data grid instance which the table (viewport) belongs to.
     *
     * @param tableElement
     * The HTML table element of the data grid.
     */ constructor(grid, tableElement){
        /**
         * The visible columns of the table.
         */ this.columns = [];
        /**
         * The visible rows of the table.
         */ this.rows = [];
        /**
         * Handles the focus event on the table body.
         *
         * @param e
         * The focus event.
         */ this.onTBodyFocus = (e)=>{
            e.preventDefault();
            this.rows[this.rowsVirtualizer.rowCursor - this.rows[0].index]?.cells[0]?.htmlElement.focus();
        };
        /**
         * Handles the resize event.
         */ this.onResize = ()=>{
            this.reflow();
        };
        /**
         * Handles the scroll event.
         */ this.onScroll = ()=>{
            if (this.virtualRows) this.rowsVirtualizer.scroll();
            this.header?.scrollHorizontally(this.tbodyElement.scrollLeft);
        };
        this.grid = grid;
        this.tableElement = tableElement;
        this.dataTable = this.grid.presentationTable;
        const dgOptions = grid.options;
        const customClassName = dgOptions?.rendering?.table?.className;
        this.columnResizing = (0, $711xA.default).initMode(this);
        this.virtualRows = this.shouldVirtualizeRows();
        if (dgOptions?.rendering?.header?.enabled) this.theadElement = $a6f1a151c537c40f$var$makeHTMLElement('thead', {}, tableElement);
        this.tbodyElement = $a6f1a151c537c40f$var$makeHTMLElement('tbody', {}, tableElement);
        if (this.virtualRows) tableElement.classList.add((0, $7Tdil.default).getClassName('virtualization'));
        if (dgOptions?.rendering?.columns?.resizing?.enabled) this.columnsResizer = new (0, $aBO4X.default)(this);
        if (customClassName) tableElement.classList.add(...customClassName.split(/\s+/g));
        tableElement.classList.add((0, $7Tdil.default).getClassName('scrollableContent'));
        // Load columns
        this.loadColumns();
        // Virtualization
        this.rowsVirtualizer = new (0, $dmvLI.default)(this);
        // Init Table
        this.init();
        // Add event listeners
        this.resizeObserver = new ResizeObserver(this.onResize);
        this.resizeObserver.observe(tableElement);
        this.tbodyElement.addEventListener('scroll', this.onScroll);
        this.tbodyElement.addEventListener('focus', this.onTBodyFocus);
    }
    /* *
    *
    *  Methods
    *
    * */ /**
     * Initializes the data grid table.
     */ init() {
        $a6f1a151c537c40f$var$fireEvent(this, 'beforeInit');
        this.setTbodyMinHeight();
        // Load & render head
        if (this.grid.options?.rendering?.header?.enabled) {
            this.header = new (0, $5lg52.default)(this);
            this.header.render();
        }
        // TODO: Load & render footer
        // this.footer = new TableFooter(this);
        // this.footer.render();
        this.rowsVirtualizer.initialRender();
        $a6f1a151c537c40f$var$fireEvent(this, 'afterInit');
    }
    /**
     * Sets the minimum height of the table body.
     */ setTbodyMinHeight() {
        const { options: options } = this.grid;
        const minVisibleRows = options?.rendering?.rows?.minVisibleRows;
        const tbody = this.tbodyElement;
        if ($a6f1a151c537c40f$var$defined(minVisibleRows) && !$a6f1a151c537c40f$var$getStyle(tbody, 'min-height', true)) tbody.style.minHeight = minVisibleRows * this.rowsVirtualizer.defaultRowHeight + 'px';
    }
    /**
     * Checks if rows virtualization should be enabled.
     *
     * @returns
     * Whether rows virtualization should be enabled.
     */ shouldVirtualizeRows() {
        const { grid: grid } = this;
        const rows = grid.userOptions.rendering?.rows;
        if ($a6f1a151c537c40f$var$defined(rows?.virtualization)) return rows.virtualization;
        // Consider changing this to use the presentation table row count
        // instead of the original data table row count.
        const rowCount = Number(grid.dataTable?.rowCount);
        const threshold = rows?.virtualizationThreshold ?? 50;
        if (grid.pagination) return grid.querying.pagination.currentPageSize >= threshold;
        return rowCount >= threshold;
    }
    /**
     * Loads the columns of the table.
     */ loadColumns() {
        const { enabledColumns: enabledColumns } = this.grid;
        if (!enabledColumns) return;
        let columnId;
        for(let i = 0, iEnd = enabledColumns.length; i < iEnd; ++i){
            columnId = enabledColumns[i];
            this.columns.push(new (0, $vHnEw.default)(this, columnId, i));
        }
        this.columnResizing.loadColumns();
    }
    /**
     * Updates the rows of the table.
     */ async updateRows() {
        const vp = this;
        let focusedRowId;
        if (vp.focusCursor) focusedRowId = vp.dataTable.getOriginalRowIndex(vp.focusCursor[0]);
        vp.grid.querying.pagination.clampPage();
        // Update data
        const oldRowsCount = (vp.rows[vp.rows.length - 1]?.index ?? -1) + 1;
        await vp.grid.querying.proceed();
        vp.dataTable = vp.grid.presentationTable;
        for (const column of vp.columns)column.loadData();
        // Update virtualization if needed
        const shouldVirtualize = this.shouldVirtualizeRows();
        let shouldRerender = false;
        if (this.virtualRows !== shouldVirtualize) {
            this.virtualRows = shouldVirtualize;
            vp.tableElement.classList.toggle((0, $7Tdil.default).getClassName('virtualization'), shouldVirtualize);
            shouldRerender = true;
        }
        if (shouldRerender || oldRowsCount !== vp.dataTable.rowCount) // Rerender all rows
        vp.rowsVirtualizer.rerender();
        else // Update existing rows
        for(let i = 0, iEnd = vp.rows.length; i < iEnd; ++i)vp.rows[i].update();
        // Update the pagination controls
        vp.grid.pagination?.updateControls();
        vp.reflow();
        // Scroll to the focused row
        if (focusedRowId !== void 0 && vp.focusCursor) {
            const newRowIndex = vp.dataTable.getLocalRowIndex(focusedRowId);
            if (newRowIndex !== void 0) {
                // Scroll to the focused row.
                vp.scrollToRow(newRowIndex);
                // Focus the cell that was focused before the update.
                setTimeout(()=>{
                    if (!$a6f1a151c537c40f$var$defined(vp.focusCursor?.[1])) return;
                    vp.rows[newRowIndex - vp.rows[0].index]?.cells[vp.focusCursor[1]].htmlElement.focus();
                });
            }
        }
        vp.grid.dirtyFlags.delete('rows');
    }
    /**
     * Reflows the table's content dimensions.
     */ reflow() {
        // TODO: More `needsReflow` logic can be added in the future to avoid
        // unnecessary reflows of the table parts.
        this.columnResizing.reflow();
        // Reflow the head
        this.header?.reflow();
        // Reflow rows content dimensions
        this.rowsVirtualizer.reflowRows();
        // Reflow the pagination
        this.grid.pagination?.reflow();
        // Reflow popups
        this.grid.popups.forEach((popup)=>{
            popup.reflow();
        });
        this.grid.dirtyFlags.delete('reflow');
    }
    /**
     * Scrolls the table to the specified row.
     *
     * @param index
     * The index of the row to scroll to.
     *
     * Try it: {@link https://jsfiddle.net/gh/get/library/pure/highcharts/highcharts/tree/master/samples/grid-lite/basic/scroll-to-row | Scroll to row}
     */ scrollToRow(index) {
        if (this.virtualRows) {
            this.tbodyElement.scrollTop = index * this.rowsVirtualizer.defaultRowHeight;
            return;
        }
        const rowClass = '.' + (0, $7Tdil.default).getClassName('rowElement');
        const firstRowTop = this.tbodyElement.querySelectorAll(rowClass)[0].getBoundingClientRect().top;
        this.tbodyElement.scrollTop = this.tbodyElement.querySelectorAll(rowClass)[index].getBoundingClientRect().top - firstRowTop;
    }
    /**
     * Get the widthRatio value from the width in pixels. The widthRatio is
     * calculated based on the width of the viewport.
     *
     * @param width
     * The width in pixels.
     *
     * @return The width ratio.
     *
     * @internal
     */ getRatioFromWidth(width) {
        return width / this.tbodyElement.clientWidth;
    }
    /**
     * Get the width in pixels from the widthRatio value. The width is
     * calculated based on the width of the viewport.
     *
     * @param ratio
     * The width ratio.
     *
     * @returns The width in pixels.
     *
     * @internal
     */ getWidthFromRatio(ratio) {
        return this.tbodyElement.clientWidth * ratio;
    }
    /**
     * Destroys the grid table.
     */ destroy() {
        this.tbodyElement.removeEventListener('focus', this.onTBodyFocus);
        this.tbodyElement.removeEventListener('scroll', this.onScroll);
        this.resizeObserver.disconnect();
        this.columnsResizer?.removeEventListeners();
        this.header?.destroy();
        for(let i = 0, iEnd = this.rows.length; i < iEnd; ++i)this.rows[i].destroy();
        $a6f1a151c537c40f$var$fireEvent(this, 'afterDestroy');
    }
    /**
     * Get the viewport state metadata. It is used to save the state of the
     * viewport and restore it when the data grid is re-rendered.
     *
     * @returns
     * The viewport state metadata.
     */ getStateMeta() {
        return {
            scrollTop: this.tbodyElement.scrollTop,
            scrollLeft: this.tbodyElement.scrollLeft,
            columnResizing: this.columnResizing,
            focusCursor: this.focusCursor
        };
    }
    /**
     * Apply the metadata to the viewport state. It is used to restore the state
     * of the viewport when the data grid is re-rendered.
     *
     * @param meta
     * The viewport state metadata.
     */ applyStateMeta(meta) {
        this.tbodyElement.scrollTop = meta.scrollTop;
        this.tbodyElement.scrollLeft = meta.scrollLeft;
        if (meta.focusCursor) {
            const [rowIndex, columnIndex] = meta.focusCursor;
            const row = this.rows[rowIndex - this.rows[0].index];
            row?.cells[columnIndex]?.htmlElement.focus();
        }
    }
    /**
     * Sets the focus anchor cell.
     *
     * @param cell
     * The cell to set as the focus anchor cell.
     */ setFocusAnchorCell(cell) {
        this.focusAnchorCell?.htmlElement.setAttribute('tabindex', '-1');
        this.focusAnchorCell = cell;
        this.focusAnchorCell.htmlElement.setAttribute('tabindex', '0');
    }
    /**
     * Returns the column with the provided ID.
     *
     * @param id
     * The ID of the column.
     */ getColumn(id) {
        const columns = this.grid.enabledColumns;
        if (!columns) return;
        const columnIndex = columns.indexOf(id);
        if (columnIndex < 0) return;
        return this.columns[columnIndex];
    }
    /**
     * Returns the row with the provided ID.
     *
     * @param id
     * The ID of the row.
     */ getRow(id) {
        // TODO: Change `find` to a method using `vp.dataTable.getLocalRowIndex`
        // and rows[presentationRowIndex - firstRowIndex]. Needs more testing,
        // but it should be faster.
        return this.rows.find((row)=>row.id === id);
    }
}
var /* *
 *
 *  Default Export
 *
 * */ $a6f1a151c537c40f$export$2e2bcd8739ae039 = $a6f1a151c537c40f$var$Table;

});
parcelRegister("vHnEw", function(module, exports) {

$parcel$export(module.exports, "default", () => $05f48bd3c32b7d6b$export$2e2bcd8739ae039);
/* *
 *
 *  Grid Column class
 *
 *  (c) 2020-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Dawid Dragula
 *  - Sebastian Bochan
 *
 * */ 
var $l3aRA = parcelRequire("l3aRA");

var $d5G0E = parcelRequire("d5G0E");

var $5YKvy = parcelRequire("5YKvy");

var $dFY4g = parcelRequire("dFY4g");

var $7Tdil = parcelRequire("7Tdil");

var $1I1ai = parcelRequire("1I1ai");
'use strict';
const { defined: $05f48bd3c32b7d6b$var$defined, fireEvent: $05f48bd3c32b7d6b$var$fireEvent } = (0, $l3aRA.default);
const { createOptionsProxy: $05f48bd3c32b7d6b$var$createOptionsProxy } = (0, $1I1ai.default);
class $05f48bd3c32b7d6b$export$816b5d811295e6bc {
    /* *
    *
    *  Constructor
    *
    * */ /**
     * Constructs a column in the data grid.
     *
     * @param viewport
     * The viewport (table) the column belongs to.
     *
     * @param id
     * The id of the column (`name` in the Data Table).
     *
     * @param index
     * The index of the column.
     */ constructor(viewport, id, index){
        var _a;
        /**
         * The cells of the column.
         */ this.cells = [];
        const { grid: grid } = viewport;
        this.id = id;
        this.index = index;
        this.viewport = viewport;
        this.loadData();
        this.dataType = this.assumeDataType();
        // Populate column options map if not exists, to prepare option
        // references for each column.
        if (grid.options && !grid.columnOptionsMap?.[id]) {
            const columnOptions = {
                id: id
            };
            ((_a = grid.options).columns ?? (_a.columns = [])).push(columnOptions);
            grid.columnOptionsMap[id] = {
                index: grid.options.columns.length - 1,
                options: columnOptions
            };
        }
        this.options = $05f48bd3c32b7d6b$var$createOptionsProxy(grid.columnOptionsMap?.[id]?.options ?? {}, grid.options?.columnDefaults);
        if (this.options.filtering?.enabled) this.filtering = new (0, $d5G0E.default)(this);
        $05f48bd3c32b7d6b$var$fireEvent(this, 'afterInit');
    }
    /* *
    *
    *  Methods
    *
    * */ /**
     * Loads the data of the column from the viewport's data table.
     */ loadData() {
        this.data = this.viewport.dataTable.getColumn(this.id, true);
    }
    /**
     * Creates a cell content instance.
     *
     * @param cell
     * The cell that is to be edited.
     *
     */ createCellContent(cell) {
        return new (0, $dFY4g.default)(cell);
    }
    /**
     * Assumes the data type of the column based on the options or data in the
     * column if not specified.
     */ assumeDataType() {
        const { grid: grid } = this.viewport;
        const type = grid.columnOptionsMap?.[this.id]?.options.dataType ?? grid.options?.columnDefaults?.dataType;
        if (type) return type;
        if (!this.data) return 'string';
        if (!Array.isArray(this.data)) // Typed array
        return 'number';
        for(let i = 0, iEnd = Math.min(this.data.length, 30); i < iEnd; ++i){
            if (!$05f48bd3c32b7d6b$var$defined(this.data[i])) continue;
            switch(typeof this.data[i]){
                case 'number':
                    return 'number';
                case 'boolean':
                    return 'boolean';
                default:
                    return 'string';
            }
        }
        // eslint-disable-next-line no-console
        console.warn(`Column "${this.id}" contains too few data points with ` + 'unambiguous types to correctly determine its dataType. It\'s ' + 'recommended to set the `dataType` option for it.');
        return 'string';
    }
    /**
     * Registers a cell in the column.
     *
     * @param cell
     * The cell to register.
     */ registerCell(cell) {
        cell.htmlElement.setAttribute('data-column-id', this.id);
        if (this.options.className) cell.htmlElement.classList.add(...this.options.className.split(/\s+/g));
        if (this.viewport.grid.hoveredColumnId === this.id) cell.htmlElement.classList.add((0, $7Tdil.default).getClassName('hoveredColumn'));
        this.cells.push(cell);
    }
    /**
     * Unregister a cell from the column.
     *
     * @param cell
     * The cell to unregister.
     */ unregisterCell(cell) {
        const index = this.cells.indexOf(cell);
        if (index > -1) this.cells.splice(index, 1);
    }
    /**
     * Returns the width of the column in pixels.
     */ getWidth() {
        return this.viewport.columnResizing.getColumnWidth(this);
    }
    /**
     * Adds or removes the hovered CSS class to the column element
     * and its cells.
     *
     * @param hovered
     * Whether the column should be hovered.
     */ setHoveredState(hovered) {
        this.header?.htmlElement?.classList[hovered ? 'add' : 'remove']((0, $7Tdil.default).getClassName('hoveredColumn'));
        for(let i = 0, iEnd = this.cells.length; i < iEnd; ++i)this.cells[i].htmlElement.classList[hovered ? 'add' : 'remove']((0, $7Tdil.default).getClassName('hoveredColumn'));
    }
    /**
     * Adds or removes the synced CSS class to the column element
     * and its cells.
     *
     * @param synced
     * Whether the column should have synced state.
     */ setSyncedState(synced) {
        this.header?.htmlElement?.classList[synced ? 'add' : 'remove']((0, $7Tdil.default).getClassName('syncedColumn'));
        for(let i = 0, iEnd = this.cells.length; i < iEnd; ++i)this.cells[i].htmlElement.classList[synced ? 'add' : 'remove']((0, $7Tdil.default).getClassName('syncedColumn'));
    }
    /**
     * Returns the formatted string where the templating context is the column.
     *
     * @param template
     * The template string.
     *
     * @return
     * The formatted string.
     */ format(template) {
        return (0, $5YKvy.default).format(template, this, this.viewport.grid);
    }
    /**
     * Sets the new column options to the userOptions field.
     *
     * @param options
     * The options to set.
     *
     * @param overwrite
     * Whether to overwrite the existing column options with the new ones.
     * Default is `false`.
     *
     * @returns
     * The difference between the previous and the new column options in form
     * of a record of `[column.id]: column.options`.
     *
     * @internal
     */ setOptions(options, overwrite = false) {
        return this.viewport.grid.setColumnOptions([
            {
                id: this.id,
                ...options
            }
        ], overwrite);
    }
    /**
     * Updates the column with new options.
     *
     * @param newOptions
     * The new options for the column.
     *
     * @param render
     * Whether to re-render after the update. If `false`, the update will just
     * extend the options object. Defaults to `true`.
     */ async update(newOptions, render = true) {
        await this.viewport.grid.updateColumn(this.id, newOptions, render);
    }
}
var /* *
 *
 *  Default Export
 *
 * */ $05f48bd3c32b7d6b$export$2e2bcd8739ae039 = $05f48bd3c32b7d6b$export$816b5d811295e6bc;

});
parcelRegister("dFY4g", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f4db2e92364afcf$export$2e2bcd8739ae039);
/* *
 *
 *  Text Cell Content class
 *
 *  (c) 2020-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Dawid Dragula
 *
 * */ 
var $6phAG = parcelRequire("6phAG");

var $3dSvr = parcelRequire("3dSvr");

var $1I1ai = parcelRequire("1I1ai");

var $l3aRA = parcelRequire("l3aRA");
'use strict';
const { setHTMLContent: $9f4db2e92364afcf$var$setHTMLContent } = (0, $1I1ai.default);
const { defined: $9f4db2e92364afcf$var$defined, isString: $9f4db2e92364afcf$var$isString } = (0, $l3aRA.default);
/* *
 *
 *  Class
 *
 * */ /**
 * Represents a text type of content.
 */ class $9f4db2e92364afcf$var$TextContent extends (0, $3dSvr.default) {
    /* *
     *
     *  Constructor
     *
     * */ constructor(cell){
        super(cell);
        this.add();
    }
    /* *
     *
     *  Methods
     *
     * */ add() {
        this.update();
    }
    destroy() {
        this.cell.htmlElement.innerHTML = (0, $6phAG.default).emptyHTML;
    }
    update() {
        $9f4db2e92364afcf$var$setHTMLContent(this.cell.htmlElement, this.format());
    }
    /**
     * Returns the formatted value of the cell.
     *
     * @internal
     */ format() {
        const { cell: cell } = this;
        const cellsDefaults = cell.row.viewport.grid.options?.columnDefaults?.cells || {};
        const { format: format, formatter: formatter } = cell.column.options.cells || {};
        let value = cell.value;
        if (!$9f4db2e92364afcf$var$defined(value)) value = '';
        let cellContent = '';
        if (!format && !formatter) return cell.format($9f4db2e92364afcf$var$TextContent.defaultFormatsForDataTypes[cell.column.dataType]);
        const isDefaultFormat = cellsDefaults.format === format;
        const isDefaultFormatter = cellsDefaults.formatter === formatter;
        if (isDefaultFormat && isDefaultFormatter) cellContent = formatter ? formatter.call(cell).toString() : format ? cell.format(format) : value + '';
        else if (isDefaultFormat) {
            const formattedValue = formatter?.call(cell);
            if ($9f4db2e92364afcf$var$isString(formattedValue)) cellContent = formattedValue;
            else cellContent = value + '';
        } else if (isDefaultFormatter) cellContent = format ? cell.format(format) : value + '';
        return cellContent;
    }
}
/* *
 *
 *  Static Properties
 *
 * */ $9f4db2e92364afcf$var$TextContent.defaultFormatsForDataTypes = {
    string: '{value}',
    number: '{value}',
    'boolean': '{value}',
    datetime: '{value:%Y-%m-%d %H:%M:%S}'
};
var /* *
 *
 *  Default Export
 *
 * */ $9f4db2e92364afcf$export$2e2bcd8739ae039 = $9f4db2e92364afcf$var$TextContent;

});
parcelRegister("3dSvr", function(module, exports) {

$parcel$export(module.exports, "default", () => $258cddc091eec79f$export$2e2bcd8739ae039);
/* *
 *
 *  Cell Content abstract class
 *
 *  (c) 2020-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Dawid Dragula
 *
 * */ 'use strict';
/* *
 *
 *  Class
 *
 * */ /**
 * Represents a cell content in the grid.
 */ class $258cddc091eec79f$var$CellContent {
    /**
     * Creates and renders the cell content.
     *
     * @param cell
     * The cell to which the content belongs.
     */ constructor(cell){
        this.cell = cell;
    }
}
var /* *
 *
 *  Default Export
 *
 * */ $258cddc091eec79f$export$2e2bcd8739ae039 = $258cddc091eec79f$var$CellContent;

});



parcelRegister("5lg52", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e3b631a0374d2e3$export$2e2bcd8739ae039);
/* *
 *
 *  Grid TableHeader class
 *
 *  (c) 2020-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Dawid Dragula
 *  - Sebastian Bochan
 *
 * */ 
var $27D49 = parcelRequire("27D49");

var $eUXb0 = parcelRequire("eUXb0");
'use strict';
/* *
 *
 *  Class
 *
 * */ /**
 * Represents a table header row containing the cells (headers) with
 * column names.
 */ class $3e3b631a0374d2e3$var$TableHeader {
    /* *
    *
    *  Constructor
    *
    * */ /**
     * Constructs a new table head.
     *
     * @param viewport
     * The viewport (table) the table head belongs to.
     */ constructor(viewport){
        /* *
        *
        *  Properties
        *
        * */ /**
         * The visible columns of the table.
         */ this.columns = [];
        /**
         * The container of the table head.
         */ this.rows = [];
        /**
         * Amount of levels in the header, that is used in creating correct rows.
         * Excludes any extra levels, like filtering row.
         */ this.levels = 1;
        this.viewport = viewport;
        this.columns = viewport.columns;
        if (viewport.grid.options?.header) this.levels = this.getRowLevels(viewport.grid.options?.header);
    }
    /* *
    *
    *  Methods
    *
    * */ /**
     * Renders the table head content.
     */ render() {
        const vp = this.viewport;
        if (!vp.grid.enabledColumns) return;
        // Render regular, multiple level rows.
        for(let i = 0, iEnd = this.levels; i < iEnd; i++){
            const row = new (0, $27D49.default)(vp, i + 1); // Avoid indexing from 0
            row.renderContent(i);
            this.rows.push(row);
        }
        // Render an extra row for inline filtering.
        if (vp.columns.some((column)=>column.options.filtering?.enabled && column.options.filtering.inline || false)) {
            const row = new (0, $eUXb0.default)(vp);
            row.renderContent();
            this.rows.push(row);
        }
    }
    /**
     * Reflows the table head's content dimensions.
     */ reflow() {
        const vp = this.viewport;
        if (!vp.theadElement) return;
        const { clientWidth: clientWidth, offsetWidth: offsetWidth } = vp.tbodyElement;
        const rows = this.rows;
        const bordersWidth = offsetWidth - clientWidth;
        for (const row of rows)row.reflow();
        if (vp.rowsWidth) vp.theadElement.style.width = Math.max(vp.rowsWidth, clientWidth) + bordersWidth + 'px';
    }
    /**
     * Returns amount of rows for the current cell in header tree.
     *
     * @param scope
     * Structure of header
     *
     * @returns
     */ getRowLevels(scope) {
        let maxDepth = 0;
        for (const item of scope)if (typeof item !== 'string' && item.columns) {
            const depth = this.getRowLevels(item.columns);
            if (depth > maxDepth) maxDepth = depth;
        }
        return maxDepth + 1;
    }
    /**
     * Scrolls the table head horizontally, only when the virtualization
     * is enabled.
     *
     * @param scrollLeft
     * The left scroll position.
     */ scrollHorizontally(scrollLeft) {
        const el = this.viewport.theadElement;
        if (!el) return;
        el.style.transform = `translateX(${-scrollLeft}px)`;
    }
    /**
     * Destroys the table header and all its associated components.
     */ destroy() {
        for (const row of this.rows)row.destroy();
    }
}
var /* *
 *
 *  Default Export
 *
 * */ $3e3b631a0374d2e3$export$2e2bcd8739ae039 = $3e3b631a0374d2e3$var$TableHeader;

});
parcelRegister("27D49", function(module, exports) {

$parcel$export(module.exports, "default", () => $18ba89e3a2abc51e$export$2e2bcd8739ae039);
/* *
 *
 *  Grid HeaderRow class
 *
 *  (c) 2020-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Dawid Dragula
 *  - Sebastian Bochan
 *
 * */ 
var $8VMz6 = parcelRequire("8VMz6");

var $eWdjg = parcelRequire("eWdjg");

var $7Tdil = parcelRequire("7Tdil");

var $l3aRA = parcelRequire("l3aRA");
'use strict';
const { isString: $18ba89e3a2abc51e$var$isString } = (0, $l3aRA.default);
/* *
 *
 *  Class
 *
 * */ /**
 * Represents a row in the data grid header.
 */ class $18ba89e3a2abc51e$var$HeaderRow extends (0, $8VMz6.default) {
    /* *
    *
    *  Constructor
    *
    * */ /**
     * Constructs a row in the data grid.
     *
     * @param viewport
     * The Grid Table instance which the row belongs to.
     *
     * @param level
     * The current level of header that is rendered.
     */ constructor(viewport, level){
        super(viewport);
        this.level = level;
        this.setRowAttributes();
    }
    /* *
    *
    *  Methods
    *
    * */ createCell(column, columnsTree) {
        return new (0, $eWdjg.default)(this, column, columnsTree);
    }
    /**
     * Renders the row's content in the header.
     *
     * @param level
     * The current level in the header tree
     *
     * @internal
     */ renderContent(level) {
        const headerOpt = this.viewport.grid.options?.header;
        const vp = this.viewport;
        const enabledColumns = vp.grid.enabledColumns || [];
        // Render element
        vp.theadElement?.appendChild(this.htmlElement);
        this.htmlElement.classList.add((0, $7Tdil.default).getClassName('headerRow'));
        if (!headerOpt) super.render();
        else {
            const columnsOnLevel = this.getColumnsAtLevel(headerOpt, level);
            for(let i = 0, iEnd = columnsOnLevel.length; i < iEnd; i++){
                const columnOnLevel = columnsOnLevel[i];
                const colIsString = typeof columnOnLevel === 'string';
                const colSpan = !colIsString && columnOnLevel.columns ? vp.grid.getColumnIds(columnOnLevel.columns).length : 0;
                const columnId = colIsString ? columnOnLevel : columnOnLevel.columnId;
                const dataColumn = columnId ? vp.getColumn(columnId || '') : void 0;
                const headerFormat = !colIsString ? columnOnLevel.format : void 0;
                const className = !colIsString ? columnOnLevel.className : void 0;
                // Skip hidden column or header when all columns are hidden.
                if (columnId && enabledColumns && enabledColumns.indexOf(columnId) < 0 || !dataColumn && colSpan === 0) continue;
                const headerCell = this.createCell(dataColumn, !colIsString ? columnOnLevel.columns : void 0);
                if (!colIsString) vp.grid.accessibility?.addHeaderCellDescription(headerCell.htmlElement, columnOnLevel.accessibility?.description);
                if ($18ba89e3a2abc51e$var$isString(headerFormat)) {
                    if (!headerCell.superColumnOptions.header) headerCell.superColumnOptions.header = {};
                    headerCell.superColumnOptions.header.format = headerFormat;
                }
                if (className) headerCell.superColumnOptions.className = className;
                // Add class to disable left border on first column
                if (dataColumn?.index === 0 && i === 0) headerCell.htmlElement.classList.add((0, $7Tdil.default).getClassName('columnFirst'));
                headerCell.render();
                if (columnId) headerCell.htmlElement.setAttribute('rowSpan', (this.viewport.header?.levels || 1) - level);
                else if (colSpan > 1) headerCell.htmlElement.setAttribute('colSpan', colSpan);
            }
        }
        this.setLastCellClass();
    }
    reflow() {
        const row = this;
        for(let i = 0, iEnd = row.cells.length; i < iEnd; i++){
            const cell = row.cells[i];
            cell.reflow();
        }
    }
    /**
     * Sets a specific class to the last cell in the row.
     */ setLastCellClass() {
        const lastCell = this.cells[this.cells.length - 1];
        if (lastCell.isLastColumn()) lastCell.htmlElement.classList.add((0, $7Tdil.default).getClassName('lastHeaderCellInRow'));
    }
    /**
     * Get all headers that should be rendered in a level.
     *
     * @param scope
     * Level that we start from
     *
     * @param targetLevel
     * Max level
     *
     * @param currentLevel
     * Current level
     *
     * @return
     * Array of headers that should be rendered in a level
     */ getColumnsAtLevel(scope, targetLevel, currentLevel = 0) {
        let result = [];
        for (const column of scope){
            if (currentLevel === targetLevel) result.push(column);
            if (typeof column !== 'string' && column.columns) result = result.concat(this.getColumnsAtLevel(column.columns, targetLevel, currentLevel + 1));
        }
        return result;
    }
    /**
     * Sets the row HTML element attributes and additional classes.
     */ setRowAttributes() {
        this.viewport.grid.accessibility?.setRowIndex(this.htmlElement, this.level // Level (1-based)
        );
    }
}
var /* *
 *
 *  Default Export
 *
 * */ $18ba89e3a2abc51e$export$2e2bcd8739ae039 = $18ba89e3a2abc51e$var$HeaderRow;

});
parcelRegister("8VMz6", function(module, exports) {

$parcel$export(module.exports, "default", () => $680951a0fd7fff82$export$2e2bcd8739ae039);
/* *
 *
 *  Grid Row abstract class
 *
 *  (c) 2020-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Dawid Dragula
 *  - Sebastian Bochan
 *
 * */ 
var $1I1ai = parcelRequire("1I1ai");
'use strict';
const { makeHTMLElement: $680951a0fd7fff82$var$makeHTMLElement } = (0, $1I1ai.default);
/* *
 *
 *  Abstract Class of Row
 *
 * */ /**
 * Represents a row in the data grid.
 */ class $680951a0fd7fff82$var$Row {
    /* *
    *
    *  Constructor
    *
    * */ /**
     * Constructs a row in the data grid.
     *
     * @param viewport
     * The Grid Table instance which the row belongs to.
     */ constructor(viewport){
        /* *
        *
        *  Properties
        *
        * */ /**
         * The cells of the row.
         */ this.cells = [];
        this.viewport = viewport;
        this.htmlElement = $680951a0fd7fff82$var$makeHTMLElement('tr', {});
        this.htmlElement.setAttribute('role', 'row');
    }
    /**
     * Renders the row's content. It does not attach the row element to the
     * viewport nor pushes the rows to the viewport.rows array.
     */ render() {
        const columns = this.viewport.columns;
        for(let i = 0, iEnd = columns.length; i < iEnd; i++){
            const cell = this.createCell(columns[i]);
            cell.render();
        }
        this.rendered = true;
        if (this.viewport.virtualRows) this.reflow();
    }
    /**
     * Reflows the row's content dimensions.
     */ reflow() {
        for(let j = 0, jEnd = this.cells.length; j < jEnd; ++j)this.cells[j].reflow();
        const vp = this.viewport;
        if (vp.rowsWidth) this.htmlElement.style.width = vp.rowsWidth + 'px';
    }
    /**
     * Destroys the row.
     */ destroy() {
        if (!this.htmlElement) return;
        for(let i = this.cells.length - 1; i >= 0; --i)this.cells[i].destroy();
        this.htmlElement.remove();
    }
    /**
     * Returns the cell with the given column ID.
     *
     * @param columnId
     * The column ID that the cell belongs to.
     *
     * @returns
     * The cell with the given column ID or undefined if not found.
     */ getCell(columnId) {
        return this.cells.find((cell)=>cell.column?.id === columnId);
    }
    /**
     * Registers a cell in the row.
     *
     * @param cell
     * The cell to register.
     */ registerCell(cell) {
        this.cells.push(cell);
    }
    /**
     * Unregister a cell from the row.
     *
     * @param cell
     * The cell to unregister.
     */ unregisterCell(cell) {
        const index = this.cells.indexOf(cell);
        if (index > -1) this.cells.splice(index, 1);
    }
}
var /* *
 *
 *  Default Export
 *
 * */ $680951a0fd7fff82$export$2e2bcd8739ae039 = $680951a0fd7fff82$var$Row;

});

parcelRegister("eWdjg", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae00ce7c271b7058$export$2e2bcd8739ae039);
/* *
 *
 *  Grid HeaderCell class
 *
 *  (c) 2020-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Dawid Dragula
 *  - Sebastian Bochan
 *
 * */ 
var $l3Gyg = parcelRequire("l3Gyg");

var $1I1ai = parcelRequire("1I1ai");

var $iuitX = parcelRequire("iuitX");

var $7Tdil = parcelRequire("7Tdil");

var $l3aRA = parcelRequire("l3aRA");

var $dKdb0 = parcelRequire("dKdb0");
'use strict';
const { makeHTMLElement: $ae00ce7c271b7058$var$makeHTMLElement, setHTMLContent: $ae00ce7c271b7058$var$setHTMLContent, createOptionsProxy: $ae00ce7c271b7058$var$createOptionsProxy } = (0, $1I1ai.default);
const { fireEvent: $ae00ce7c271b7058$var$fireEvent, isString: $ae00ce7c271b7058$var$isString } = (0, $l3aRA.default);
/* *
 *
 *  Class
 *
 * */ /**
 * Represents a cell in the data grid header.
 */ class $ae00ce7c271b7058$var$HeaderCell extends (0, $l3Gyg.default) {
    /* *
    *
    *  Constructor
    *
    * */ /**
     * Constructs a cell in the data grid header.
     *
     * @param row
     * The row of the cell.
     *
     * @param column
     * The column of the cell.
     *
     * @param columnsTree
     * If the cell is a wider than one column, this property contains the
     * structure of the columns that are subordinated to the header cell.
     */ constructor(row, column, columnsTree){
        super(row, column);
        /**
         * Reference to options taken from the header settings, that will override
         * the column options.
         * @internal
         */ this.superColumnOptions = {};
        /**
         * List of columns that are subordinated to the header cell.
         */ this.columns = [];
        /**
         * Content value of the header cell.
         */ this.value = '';
        const header = this.row.viewport.header;
        if (!header) throw new Error('No header found.');
        this.tableHeader = header;
        if (column) {
            column.header = this;
            this.columns.push(column);
        } else if (columnsTree) {
            const vp = this.row.viewport;
            const columnIds = vp.grid.getColumnIds(columnsTree, true);
            for (const columnId of columnIds){
                const column = vp.getColumn(columnId);
                if (column) this.columns.push(column);
            }
        }
    }
    /* *
    *
    *  Methods
    *
    * */ /**
     * Init element.
     */ init() {
        const elem = document.createElement('th', {});
        elem.classList.add((0, $7Tdil.default).getClassName('headerCell'));
        elem.setAttribute('role', 'columnheader');
        return elem;
    }
    /**
     * Render the cell container.
     */ render() {
        const { column: column } = this;
        const options = $ae00ce7c271b7058$var$createOptionsProxy(this.superColumnOptions, column?.options);
        const headerCellOptions = options.header || {};
        if (headerCellOptions.formatter) this.value = headerCellOptions.formatter.call(this).toString();
        else if ($ae00ce7c271b7058$var$isString(headerCellOptions.format)) this.value = column ? column.format(headerCellOptions.format) : headerCellOptions.format;
        else this.value = column?.id || '';
        // Render content of th element
        this.row.htmlElement.appendChild(this.htmlElement);
        // Create flex container for header content and icons
        const container = this.container = $ae00ce7c271b7058$var$makeHTMLElement('div', {
            className: (0, $7Tdil.default).getClassName('headerCellContainer')
        }, this.htmlElement);
        this.headerContent = $ae00ce7c271b7058$var$makeHTMLElement('span', {
            className: (0, $7Tdil.default).getClassName('headerCellContent')
        }, container);
        // Render the header cell element content.
        $ae00ce7c271b7058$var$setHTMLContent(this.headerContent, this.value);
        this.htmlElement.setAttribute('scope', 'col');
        if (this.superColumnOptions.className) this.htmlElement.classList.add(...this.superColumnOptions.className.split(/\s+/g));
        if (column) {
            this.htmlElement.setAttribute('data-column-id', column.id);
            this.htmlElement.setAttribute('aria-label', column.id);
            // Add user column classname
            if (column.options.className) this.htmlElement.classList.add(...column.options.className.split(/\s+/g));
            // Add resizing
            column.viewport.columnsResizer?.renderColumnDragHandles(column, this);
            // Add toolbar
            this.toolbar = new (0, $dKdb0.default)(column);
            this.toolbar.add();
            // Add sorting
            this.initColumnSorting();
        }
        // Set alignment in column cells based on column data type
        this.htmlElement.classList[column?.dataType === 'number' ? 'add' : 'remove']((0, $7Tdil.default).getClassName('rightAlign'));
        // Add custom class name from column options
        this.setCustomClassName(options.header?.className);
        $ae00ce7c271b7058$var$fireEvent(this, 'afterRender', {
            column: column
        });
    }
    reflow() {
        const th = this.htmlElement;
        if (!th) return;
        let width = 0;
        for (const column of this.columns)width += column.getWidth() || 0;
        // Set the width of the column. Max width is needed for the
        // overflow: hidden to work.
        th.style.width = th.style.maxWidth = width + 'px';
        this.toolbar?.reflow();
    }
    onKeyDown(e) {
        if (!this.column || e.target !== this.htmlElement) return;
        if (e.key === 'Enter') {
            this.toolbar?.focus();
            e.preventDefault();
            return;
        }
        super.onKeyDown(e);
    }
    onClick(e) {
        const column = this.column;
        if (!column || e.target !== this.htmlElement && e.target !== column.header?.headerContent || column.viewport.columnsResizer?.isResizing) return;
        if (column.options.sorting?.sortable) column.sorting?.toggle();
        $ae00ce7c271b7058$var$fireEvent(this, 'click', {
            originalEvent: e,
            column: this.column
        });
    }
    /**
     * Add sorting option to the column.
     */ initColumnSorting() {
        const { column: column } = this;
        if (!column) return;
        column.sorting = new (0, $iuitX.default)(column, this.htmlElement);
    }
    /**
     * Check if the cell is part of the last cell in the header.
     */ isLastColumn() {
        const vp = this.row.viewport;
        const lastViewportColumn = vp.columns[vp.columns.length - 1];
        const lastCellColumn = this.columns?.[this.columns.length - 1];
        return lastViewportColumn === lastCellColumn;
    }
    destroy() {
        this.toolbar?.destroy();
        super.destroy();
    }
}
var /* *
 *
 *  Default Export
 *
 * */ $ae00ce7c271b7058$export$2e2bcd8739ae039 = $ae00ce7c271b7058$var$HeaderCell;

});
parcelRegister("l3Gyg", function(module, exports) {

$parcel$export(module.exports, "default", () => $f54ae2ad52f08d57$export$2e2bcd8739ae039);
/* *
 *
 *  Grid Cell abstract class
 *
 *  (c) 2020-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Dawid Dragula
 *  - Sebastian Bochan
 *
 * */ 
var $5YKvy = parcelRequire("5YKvy");

var $l3aRA = parcelRequire("l3aRA");
'use strict';
const { fireEvent: $f54ae2ad52f08d57$var$fireEvent } = (0, $l3aRA.default);
/* *
 *
 *  Abstract Class of Cell
 *
 * */ class $f54ae2ad52f08d57$var$Cell {
    /* *
    *
    *  Constructor
    *
    * */ /**
     * Constructs a cell in the data grid.
     *
     * @param row
     * The row of the cell.
     *
     * @param column
     * The column of the cell.
     */ constructor(row, column){
        /**
         * Array of cell events to be removed when the cell is destroyed.
         */ this.cellEvents = [];
        this.column = column;
        this.row = row;
        this.row.registerCell(this);
        this.htmlElement = this.init();
        this.htmlElement.setAttribute('tabindex', '-1');
        if (!this.column?.options.cells?.editMode?.enabled) this.htmlElement.setAttribute('aria-readonly', 'true');
        this.initEvents();
    }
    /* *
    *
    *  Methods
    *
    * */ /**
     * Init element.
     * @internal
     */ init() {
        const cell = document.createElement('td', {});
        cell.setAttribute('role', 'gridcell');
        return cell;
    }
    /**
     * Initialize event listeners. Events added to the `cellEvents` array will
     * be registered now and unregistered when the cell is destroyed.
     */ initEvents() {
        this.cellEvents.push([
            'blur',
            ()=>this.onBlur()
        ]);
        this.cellEvents.push([
            'focus',
            ()=>this.onFocus()
        ]);
        this.cellEvents.push([
            'click',
            (e)=>{
                this.onClick(e);
            }
        ]);
        this.cellEvents.push([
            'keydown',
            (e)=>{
                this.onKeyDown(e);
            }
        ]);
        this.cellEvents.push([
            'mouseout',
            ()=>{
                this.onMouseOut();
            }
        ]);
        this.cellEvents.push([
            'mouseover',
            ()=>{
                this.onMouseOver();
            }
        ]);
        this.cellEvents.forEach((pair)=>{
            this.htmlElement.addEventListener(pair[0], pair[1]);
        });
    }
    /**
     * Handles the focus event on the cell.
     */ onFocus() {
        this.row.viewport.setFocusAnchorCell(this);
    }
    /**
     * Handles the blur event on the cell.
     */ onBlur() {
        delete this.row.viewport.focusCursor;
    }
    /**
     * Handles user keydown on the cell.
     *
     * @param e
     * Keyboard event object.
     */ onKeyDown(e) {
        const { row: row, column: column } = this;
        if (!column) return;
        const vp = row.viewport;
        const { header: header } = vp;
        const getVerticalPos = ()=>{
            if (row.index !== void 0) return row.index - vp.rows[0].index;
            const level = row.level;
            if (!header || level === void 0) return 0;
            return Math.max(level, header.levels) - header.rows.length - 1;
        };
        const changeFocusKeys = {
            ArrowDown: [
                1,
                0
            ],
            ArrowUp: [
                -1,
                0
            ],
            ArrowLeft: [
                0,
                -1
            ],
            ArrowRight: [
                0,
                1
            ]
        };
        const dir = changeFocusKeys[e.key];
        if (e.key === 'Enter') this.onClick(e);
        if (dir) {
            e.preventDefault();
            e.stopPropagation();
            const { header: header } = vp;
            const localRowIndex = getVerticalPos();
            const nextVerticalDir = localRowIndex + dir[0];
            if (nextVerticalDir < 0 && header) {
                const extraRowIdx = header.rows.length + nextVerticalDir;
                if (extraRowIdx + 1 > header.levels) header.rows[extraRowIdx].cells[column.index + dir[1]]?.htmlElement.focus();
                else vp.columns[column.index + dir[1]]?.header?.htmlElement.focus();
                return;
            }
            const nextRow = vp.rows[nextVerticalDir];
            if (nextRow) nextRow.cells[column.index + dir[1]]?.htmlElement.focus();
        }
    }
    /**
     * Handles the mouse over event on the cell.
     * @internal
     */ onMouseOver() {
        const { grid: grid } = this.row.viewport;
        grid.hoverColumn(this.column?.id);
        $f54ae2ad52f08d57$var$fireEvent(this, 'mouseOver', {
            target: this
        });
    }
    /**
     * Handles the mouse out event on the cell.
     * @internal
     */ onMouseOut() {
        const { grid: grid } = this.row.viewport;
        grid.hoverColumn();
        $f54ae2ad52f08d57$var$fireEvent(this, 'mouseOut', {
            target: this
        });
    }
    /**
     * Renders the cell by appending the HTML element to the row.
     */ render() {
        this.row.htmlElement.appendChild(this.htmlElement);
        this.reflow();
    }
    /**
     * Reflows the cell dimensions.
     */ reflow() {
        const column = this.column;
        if (!column) return;
        const elementStyle = this.htmlElement.style;
        elementStyle.width = elementStyle.maxWidth = column.getWidth() + 'px';
    }
    /**
     * Returns the formatted string where the templating context is the cell.
     *
     * @param template
     * The template string.
     *
     * @return
     * The formatted string.
     */ format(template) {
        return (0, $5YKvy.default).format(template, this, this.row.viewport.grid);
    }
    /**
     * Sets the custom class name of the cell based on the template.
     *
     * @param template
     * The template string.
     */ setCustomClassName(template) {
        const element = this.htmlElement;
        if (this.customClassName) element.classList.remove(...this.customClassName.split(/\s+/g));
        if (!template) {
            delete this.customClassName;
            return;
        }
        const newClassName = this.format(template);
        if (!newClassName) {
            delete this.customClassName;
            return;
        }
        element.classList.add(...newClassName.split(/\s+/g));
        this.customClassName = newClassName;
    }
    /**
     * Destroys the cell.
     */ destroy() {
        this.cellEvents.forEach((pair)=>{
            this.htmlElement.removeEventListener(pair[0], pair[1]);
        });
        this.column?.unregisterCell(this);
        this.row.unregisterCell(this);
        this.htmlElement.remove();
    }
}
var /* *
 *
 *  Default Export
 *
 * */ $f54ae2ad52f08d57$export$2e2bcd8739ae039 = $f54ae2ad52f08d57$var$Cell;

});

parcelRegister("iuitX", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7595d7d44e2a7fd$export$2e2bcd8739ae039);
/* *
 *
 *  Grid ColumnSorting class
 *
 *  (c) 2020-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Dawid Dragula
 *  - Sebastian Bochan
 *
 * */ 
var $7Tdil = parcelRequire("7Tdil");

var $l3aRA = parcelRequire("l3aRA");
'use strict';
const { fireEvent: $d7595d7d44e2a7fd$var$fireEvent } = (0, $l3aRA.default);
/* *
 *
 *  Class
 *
 * */ /**
 * Class that manages sorting for a dedicated column.
 */ class $d7595d7d44e2a7fd$var$ColumnSorting {
    /* *
    *
    *  Constructor
    *
    * */ /**
     * Constructs sorting for a dedicated column.
     *
     * @param column
     * The column that be sorted.
     *
     * @param headerCellElement
     * The head element of the column.
     */ constructor(column, headerCellElement){
        /**
         * Toggle sorting order for the column in the order: asc -> desc -> none
         */ this.toggle = ()=>{
            const viewport = this.column.viewport;
            const querying = viewport.grid.querying;
            const sortingController = querying.sorting;
            const currentOrder = (sortingController.currentSorting?.columnId === this.column.id ? sortingController.currentSorting.order : null) || 'none';
            const consequents = {
                none: 'asc',
                asc: 'desc',
                desc: null
            };
            this.setOrder(consequents[currentOrder]);
        };
        this.column = column;
        this.headerCellElement = headerCellElement;
        this.addHeaderElementAttributes();
        if (column.options.sorting?.sortable) headerCellElement.classList.add((0, $7Tdil.default).getClassName('columnSortable'));
    }
    /* *
    *
    *  Methods
    *
    * */ /**
     * Adds attributes to the column header.
     */ addHeaderElementAttributes() {
        const col = this.column;
        const a11y = col.viewport.grid.accessibility;
        const sortingOptions = col.options.sorting;
        const { currentSorting: currentSorting } = col.viewport.grid.querying.sorting;
        const sortedAscClassName = (0, $7Tdil.default).getClassName('columnSortedAsc');
        const sortedDescClassName = (0, $7Tdil.default).getClassName('columnSortedDesc');
        const el = this.headerCellElement;
        if (currentSorting?.columnId !== col.id || !currentSorting?.order) {
            el.classList.remove(sortedAscClassName);
            el.classList.remove(sortedDescClassName);
            if (sortingOptions?.sortable) a11y?.setColumnSortState(el, 'none');
            return;
        }
        switch(currentSorting?.order){
            case 'asc':
                el.classList.add(sortedAscClassName);
                el.classList.remove(sortedDescClassName);
                a11y?.setColumnSortState(el, 'ascending');
                break;
            case 'desc':
                el.classList.remove(sortedAscClassName);
                el.classList.add(sortedDescClassName);
                a11y?.setColumnSortState(el, 'descending');
                break;
        }
    }
    /**
     * Updates the column options with the new sorting state.
     *
     * @param col
     * The column to update.
     */ updateColumnOptions(col) {
        const order = col.viewport.grid.querying.sorting.currentSorting?.order;
        if (col.id === this.column.id && order) col.setOptions({
            sorting: {
                order: order
            }
        });
        else {
            delete col.options.sorting?.order;
            if (col.options.sorting && Object.keys(col.options.sorting).length < 1) delete col.options.sorting;
        }
    }
    /**
     * Set sorting order for the column. It will modify the presentation data
     * and rerender the rows.
     *
     * @param order
     * The order of sorting. It can be `'asc'`, `'desc'` or `null` if the
     * sorting should be disabled.
     */ async setOrder(order) {
        const viewport = this.column.viewport;
        // Do not call sorting when cell is currently edited and validated.
        if (viewport.validator?.errorCell) return;
        const querying = viewport.grid.querying;
        const sortingController = querying.sorting;
        const a11y = viewport.grid.accessibility;
        [
            this.column,
            viewport.grid
        ].forEach((source)=>{
            $d7595d7d44e2a7fd$var$fireEvent(source, 'beforeSort', {
                target: this.column,
                order: order
            });
        });
        sortingController.setSorting(order, this.column.id);
        await viewport.updateRows();
        for (const col of viewport.columns){
            this.updateColumnOptions(col);
            col.sorting?.addHeaderElementAttributes();
        }
        a11y?.userSortedColumn(order);
        [
            this.column,
            viewport.grid
        ].forEach((source)=>{
            $d7595d7d44e2a7fd$var$fireEvent(source, 'afterSort', {
                target: this.column,
                order: order
            });
        });
    }
}
var /* *
 *
 *  Default Export
 *
 * */ $d7595d7d44e2a7fd$export$2e2bcd8739ae039 = $d7595d7d44e2a7fd$var$ColumnSorting;

});

parcelRegister("dKdb0", function(module, exports) {

$parcel$export(module.exports, "default", () => $a019cad597281b2e$export$2e2bcd8739ae039);
/* *
 *
 *  Grid Header Cell Toolbar class
 *
 *  (c) 2020-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Dawid Dragula
 *
 * */ 
var $1I1ai = parcelRequire("1I1ai");

var $7Tdil = parcelRequire("7Tdil");

var $KupA2 = parcelRequire("KupA2");

var $eU5BN = parcelRequire("eU5BN");

var $dCihi = parcelRequire("dCihi");

var $l3aRA = parcelRequire("l3aRA");
'use strict';
const { makeHTMLElement: $a019cad597281b2e$var$makeHTMLElement } = (0, $1I1ai.default);
const { getStyle: $a019cad597281b2e$var$getStyle } = (0, $l3aRA.default);
/* *
 *
 *  Class
 *
 * */ class $a019cad597281b2e$var$HeaderCellToolbar {
    /* *
     *
     *  Constructor
     *
     * */ constructor(column){
        this.buttons = [];
        this.focusCursor = 0;
        /**
         * The event listener destroyers of the toolbar.
         */ this.eventListenerDestroyers = [];
        this.column = column;
    }
    /* *
     *
     *  Methods
     *
     * */ /**
     * Initializes the buttons of the toolbar.
     */ renderFull() {
        const columnOptions = this.column.options;
        if (columnOptions.sorting?.sortable) new (0, $KupA2.default)().add(this);
        if (columnOptions.filtering?.enabled && !columnOptions.filtering.inline) new (0, $eU5BN.default)().add(this);
    }
    renderMinimized() {
        const columnOptions = this.column.options;
        if (columnOptions.sorting?.sortable || columnOptions.filtering?.enabled && !columnOptions.filtering.inline) new (0, $dCihi.default)().add(this);
    }
    /**
     * Render the toolbar.
     */ add() {
        const headerCell = this.column.header;
        if (!headerCell?.container) return;
        if (this.columnResizeObserver) {
            this.columnResizeObserver.disconnect();
            delete this.columnResizeObserver;
        }
        this.columnResizeObserver = new ResizeObserver(()=>this.reflow());
        this.columnResizeObserver.observe(headerCell.container);
        const container = this.container = $a019cad597281b2e$var$makeHTMLElement('div', {
            className: (0, $7Tdil.default).getClassName('headerCellIcons')
        });
        headerCell.container.appendChild(container);
        const onKeyDown = (e)=>{
            this.keyDownHandler(e);
        };
        container.addEventListener('keydown', onKeyDown);
        this.eventListenerDestroyers.push(()=>{
            container.removeEventListener('keydown', onKeyDown);
        });
    }
    /**
     * Refreshes the state of the toolbar buttons.
     * @internal
     */ refreshState() {
        for (const button of this.buttons)button.refreshState();
    }
    /**
     * Destroys all buttons of the toolbar.
     */ clearButtons() {
        const { buttons: buttons } = this;
        while(buttons.length > 0)buttons[buttons.length - 1].destroy();
    }
    /**
     * Reflows the toolbar. It is called when the column is resized.
     */ reflow() {
        const width = this.column.getWidth();
        const shouldBeMinimized = width <= $a019cad597281b2e$var$HeaderCellToolbar.MINIMIZED_COLUMN_WIDTH;
        if (shouldBeMinimized !== this.isMinimized) {
            this.isMinimized = shouldBeMinimized;
            this.clearButtons();
            if (shouldBeMinimized) this.renderMinimized();
            else this.renderFull();
        }
        if (!shouldBeMinimized) return;
        const parent = this.column.header?.htmlElement;
        const container = this.container;
        const parentWidth = parent?.offsetWidth || 0;
        const containerWidth = this.buttons[0]?.wrapper?.offsetWidth || 0;
        const parentPaddings = (parent && $a019cad597281b2e$var$getStyle(parent, 'padding-left', true) || 0) + (parent && $a019cad597281b2e$var$getStyle(parent, 'padding-right', true) || 0);
        const containerMargins = (container && $a019cad597281b2e$var$getStyle(container, 'margin-left', true) || 0) + (container && $a019cad597281b2e$var$getStyle(container, 'margin-right', true) || 0);
        const shouldBeCentered = parentWidth - parentPaddings < containerWidth + containerMargins;
        if (this.isMenuCentered !== shouldBeCentered) {
            this.isMenuCentered = shouldBeCentered;
            this.column.header?.container?.classList.toggle((0, $7Tdil.default).getClassName('noWidth'), shouldBeCentered);
        }
    }
    /**
     * Destroy the toolbar.
     */ destroy() {
        for (const destroyer of this.eventListenerDestroyers)destroyer();
        this.eventListenerDestroyers.length = 0;
        this.clearButtons();
        this.columnResizeObserver?.disconnect();
        delete this.columnResizeObserver;
    }
    /**
     * Focuses the first button of the toolbar.
     */ focus() {
        this.buttons[0]?.focus();
    }
    /**
     * Handles the key down event on the toolbar.
     *
     * @param e
     * Keyboard event object.
     */ keyDownHandler(e) {
        const len = this.buttons.length;
        const cursor = this.focusCursor;
        switch(e.key){
            case 'ArrowUp':
            case 'ArrowLeft':
                this.buttons[Math.abs((cursor - 1 + len) % len)].focus();
                break;
            case 'ArrowDown':
            case 'ArrowRight':
                this.buttons[(cursor + 1) % len].focus();
                break;
            case 'Escape':
                this.column.header?.htmlElement.focus();
                break;
        }
    }
}
/**
 * The maximum width of the column to be minimized.
 */ $a019cad597281b2e$var$HeaderCellToolbar.MINIMIZED_COLUMN_WIDTH = 120;
var /* *
 *
 *  Default Export
 *
 * */ $a019cad597281b2e$export$2e2bcd8739ae039 = $a019cad597281b2e$var$HeaderCellToolbar;

});
parcelRegister("KupA2", function(module, exports) {

$parcel$export(module.exports, "default", () => $08bbe31986cb0df0$export$2e2bcd8739ae039);
/* *
 *
 *  Grid Sort Toolbar Button class
 *
 *  (c) 2020-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Dawid Dragula
 *
 * */ 
var $dON9w = parcelRequire("dON9w");

var $6erAn = parcelRequire("6erAn");

var $l3aRA = parcelRequire("l3aRA");
'use strict';
const { addEvent: $08bbe31986cb0df0$var$addEvent } = (0, $l3aRA.default);
/* *
 *
 *  Class
 *
 * */ class $08bbe31986cb0df0$var$SortToolbarButton extends (0, $dON9w.default) {
    /* *
     *
     *  Constructor
     *
     * */ constructor(){
        super({
            icon: 'upDownArrows',
            classNameKey: 'headerCellSortIcon',
            accessibility: {
                ariaLabel: 'sort'
            }
        });
    }
    /* *
     *
     *  Methods
     *
     * */ clickHandler(event) {
        super.clickHandler(event);
        this.toolbar?.column.sorting?.toggle();
    }
    refreshState() {
        const column = this.toolbar?.column;
        if (!column) return;
        if (!(0, $6erAn.default).isSorted(column)) {
            this.setActive(false);
            this.setIcon('upDownArrows');
            return;
        }
        const { currentSorting: currentSorting } = column.viewport.grid.querying.sorting;
        this.setActive(true);
        this.setIcon(currentSorting?.order === 'asc' ? 'sortAsc' : 'sortDesc');
    }
    addEventListeners() {
        super.addEventListeners();
        const column = this.toolbar?.column;
        if (!column) return;
        // If this grid is currently sorted, update the state
        this.eventListenerDestroyers.push($08bbe31986cb0df0$var$addEvent(column.viewport.grid, 'afterSort', ()=>this.refreshState()));
    }
    renderActiveIndicator() {
    // Do nothing
    }
}
var /* *
 *
 *  Default Export
 *
 * */ $08bbe31986cb0df0$export$2e2bcd8739ae039 = $08bbe31986cb0df0$var$SortToolbarButton;

});
parcelRegister("dON9w", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0f6128cc4780edd$export$2e2bcd8739ae039);
/* *
 *
 *  Grid Toolbar Button class
 *
 *  (c) 2020-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Dawid Dragula
 *
 * */ 
var $gGcXV = parcelRequire("gGcXV");

var $7Tdil = parcelRequire("7Tdil");

var $1I1ai = parcelRequire("1I1ai");
'use strict';
const { makeHTMLElement: $a0f6128cc4780edd$var$makeHTMLElement } = (0, $1I1ai.default);
/* *
 *
 *  Class
 *
 * */ class $a0f6128cc4780edd$var$ToolbarButton {
    /* *
     *
     *  Constructor
     *
     * */ constructor(options){
        /**
         * Used to remove the event listeners when the button is destroyed.
         */ this.eventListenerDestroyers = [];
        /**
         * Whether the button is active.
         */ this.isActive = false;
        this.options = options;
    }
    /* *
     *
     *  Methods
     *
     * */ /**
     * Adds the button to the toolbar.
     *
     * @param toolbar
     * The toolbar to add the button to.
     */ add(toolbar) {
        const cfg = this.options;
        this.toolbar = toolbar;
        toolbar.buttons.push(this);
        const wrapper = $a0f6128cc4780edd$var$makeHTMLElement('span', cfg.classNameKey && {
            className: (0, $7Tdil.default).getClassName(cfg.classNameKey)
        }, toolbar.container);
        this.wrapper = wrapper;
        const button = this.buttonEl = $a0f6128cc4780edd$var$makeHTMLElement('button', {
            className: (0, $7Tdil.default).getClassName('button') + (this.isActive ? ' active' : '')
        }, wrapper);
        button.setAttribute('type', 'button');
        button.setAttribute('tabindex', '-1');
        this.setA11yAttributes(button);
        this.setIcon(cfg.icon);
        this.refreshState();
        this.addEventListeners();
        return this;
    }
    setA11yAttributes(button) {
        const { accessibility: accessibility, tooltip: tooltip } = this.options;
        const { ariaLabel: ariaLabel, ariaExpanded: ariaExpanded, ariaControls: ariaControls } = accessibility || {};
        if (tooltip) button.title = tooltip;
        if (ariaLabel) button.setAttribute('aria-label', ariaLabel);
        if (typeof ariaExpanded === 'boolean') button.setAttribute('aria-expanded', ariaExpanded);
        if (ariaControls) button.setAttribute('aria-controls', ariaControls);
    }
    focus() {
        this.buttonEl?.focus();
        const tb = this.toolbar;
        if (tb) tb.focusCursor = tb.buttons.indexOf(this);
    }
    /**
     * Sets the icon for the button.
     *
     * @param icon
     * The icon to set.
     */ setIcon(icon) {
        this.icon?.remove();
        this.icon = (0, $gGcXV.createGridIcon)(icon);
        this.buttonEl?.appendChild(this.icon);
    }
    setActive(active) {
        this.isActive = active;
        this.buttonEl?.classList.toggle('active', active);
        this.renderActiveIndicator(active);
    }
    setHighlighted(highlighted) {
        this.buttonEl?.classList.toggle('highlighted', highlighted);
        const ariaExpanded = this.options.accessibility?.ariaExpanded;
        if (typeof ariaExpanded === 'boolean') this.buttonEl?.setAttribute('aria-expanded', highlighted);
    }
    /**
     * Destroys the button.
     */ destroy() {
        this.removeEventListeners();
        this.wrapper?.remove();
        // Unregister from toolbar
        this.toolbar?.buttons.splice(this.toolbar.buttons.indexOf(this), 1);
        delete this.toolbar;
    }
    /**
     * Refreshes the state of the button.
     * @internal
     */ refreshState() {
    // Do nothing, to be overridden by subclasses
    }
    /**
     * Handles the click event for the button.
     *
     * @param event
     * The mouse event.
     */ clickHandler(event) {
        this.options.onClick?.(event, this);
    }
    /**
     * Renders the active indicator for the button.
     *
     * @param render
     * Whether the active indicator should be rendered.
     */ renderActiveIndicator(render) {
        const button = this.buttonEl;
        if (!button) return;
        this.activeIndicator?.remove();
        if (!render) {
            delete this.activeIndicator;
            return;
        }
        this.activeIndicator = $a0f6128cc4780edd$var$makeHTMLElement('div', {
            className: (0, $7Tdil.default).getClassName('toolbarButtonActiveIndicator')
        }, button);
    }
    /**
     * Adds event listeners to the button.
     */ addEventListeners() {
        const clickListener = (event)=>{
            this.clickHandler(event);
        };
        this.buttonEl?.addEventListener('click', clickListener);
        this.eventListenerDestroyers.push(()=>{
            this.buttonEl?.removeEventListener('click', clickListener);
        });
    }
    /**
     * Removes event listeners from the button.
     */ removeEventListeners() {
        for (const destroyer of this.eventListenerDestroyers)destroyer();
        this.eventListenerDestroyers.length = 0;
    }
}
var /* *
 *
 *  Default Export
 *
 * */ $a0f6128cc4780edd$export$2e2bcd8739ae039 = $a0f6128cc4780edd$var$ToolbarButton;

});
parcelRegister("gGcXV", function(module, exports) {

$parcel$export(module.exports, "createGridIcon", () => $c24aa0432fb14e1e$export$b665c5bd8748855e);
$parcel$export(module.exports, "default", () => $c24aa0432fb14e1e$export$2e2bcd8739ae039);
/* *
 *
 *  Grid Svg Icons Registry
 *
 *  (c) 2020-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Mikkel Espolin Birkeland
 *  - Dawid Dragula
 *
 * */ 
var $7Tdil = parcelRequire("7Tdil");
'use strict';
const $c24aa0432fb14e1e$export$df03f54e09e486fa = {
    filter: {
        width: 16,
        height: 14,
        children: [
            {
                d: 'M2.2571 2.77791C1.75287 2.21437 1.50076 1.93259 1.49125 1.69312C1.48299 1.48509 1.57238 1.28515 1.73292 1.15259C1.91773 1 2.29583 1 3.05202 1H12.9473C13.7035 1 14.0816 1 14.2664 1.15259C14.427 1.28515 14.5163 1.48509 14.5081 1.69312C14.4986 1.93259 14.2465 2.21437 13.7422 2.77791L9.93808 7.02962C9.83756 7.14196 9.78731 7.19813 9.75147 7.26205C9.71969 7.31875 9.69637 7.37978 9.68225 7.44323C9.66633 7.51476 9.66633 7.59013 9.66633 7.74087V11.3056C9.66633 11.436 9.66633 11.5011 9.64531 11.5575C9.62673 11.6073 9.59651 11.6519 9.55717 11.6877C9.51265 11.7281 9.45213 11.7524 9.33108 11.8008L7.06441 12.7074C6.81938 12.8054 6.69687 12.8545 6.59852 12.834C6.51251 12.8161 6.43704 12.765 6.3885 12.6918C6.333 12.6081 6.333 12.4762 6.333 12.2122V7.74087C6.333 7.59013 6.333 7.51476 6.31708 7.44323C6.30296 7.37978 6.27964 7.31875 6.24786 7.26205C6.21203 7.19813 6.16177 7.14196 6.06126 7.02962L2.2571 2.77791Z'
            }
        ]
    },
    menu: {
        width: 4,
        height: 12,
        children: [
            {
                d: 'M2.00016 6.66675C2.36835 6.66675 2.66683 6.36827 2.66683 6.00008C2.66683 5.63189 2.36835 5.33341 2.00016 5.33341C1.63197 5.33341 1.3335 5.63189 1.3335 6.00008C1.3335 6.36827 1.63197 6.66675 2.00016 6.66675Z'
            },
            {
                d: 'M2.00016 2.00008C2.36835 2.00008 2.66683 1.7016 2.66683 1.33341C2.66683 0.965225 2.36835 0.666748 2.00016 0.666748C1.63197 0.666748 1.3335 0.965225 1.3335 1.33341C1.3335 1.7016 1.63197 2.00008 2.00016 2.00008Z'
            },
            {
                d: 'M2.00016 11.3334C2.36835 11.3334 2.66683 11.0349 2.66683 10.6667C2.66683 10.2986 2.36835 10.0001 2.00016 10.0001C1.63197 10.0001 1.3335 10.2986 1.3335 10.6667C1.3335 11.0349 1.63197 11.3334 2.00016 11.3334Z'
            }
        ]
    },
    chevronRight: {
        width: 6,
        height: 10,
        children: [
            {
                d: 'M1 9L5 5L1 1',
                'stroke-width': 1.34
            }
        ]
    },
    checkmark: {
        width: 12,
        height: 9,
        children: [
            {
                d: 'M11.3332 1L3.99984 8.33333L0.666504 5'
            }
        ]
    },
    upDownArrows: {
        width: 14,
        height: 12,
        children: [
            {
                d: 'M3.66667 0.666748V11.3334M3.66667 11.3334L1 8.66675M3.66667 11.3334L6.33333 8.66675M10.3333 11.3334V0.666748M10.3333 0.666748L7.66667 3.33341M10.3333 0.666748L13 3.33341'
            }
        ]
    },
    sortAsc: {
        width: 14,
        height: 12,
        children: [
            {
                d: 'M3.66667 0.666748V11.3334M3.66667 11.3334L1 8.66675M3.66667 11.3334L6.33333 8.66675',
                opacity: 0.2
            },
            {
                d: 'M 10.3333 11.3334 V 0.6667 M 10.3333 0.6667 L 7.6667 3.3334 M 10.3333 0.6667 L 13 3.3334'
            }
        ]
    },
    sortDesc: {
        width: 14,
        height: 12,
        children: [
            {
                d: 'M3.66667 0.666748V11.3334M3.66667 11.3334L1 8.66675M3.66667 11.3334L6.33333 8.66675'
            },
            {
                d: 'M 10.3333 11.3334 V 0.6667 M 10.3333 0.6667 L 7.6667 3.3334 M 10.3333 0.6667 L 13 3.3334',
                opacity: 0.2
            }
        ]
    }
};
const $c24aa0432fb14e1e$export$152c49d0a7db7c6b = {
    stroke: 'currentColor',
    'stroke-width': 1.33,
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round'
};
function $c24aa0432fb14e1e$export$b665c5bd8748855e(name, className = (0, $7Tdil.default).getClassName('icon')) {
    const createElement = (type)=>document.createElementNS('http://www.w3.org/2000/svg', type);
    const { width: width = 16, height: height = 16, viewBox: viewBox, fill: fill, children: children } = $c24aa0432fb14e1e$export$df03f54e09e486fa[name];
    const svg = createElement('svg');
    svg.setAttribute('width', width.toString());
    svg.setAttribute('height', height.toString());
    svg.setAttribute('viewBox', viewBox ?? `0 0 ${width} ${height}`);
    svg.setAttribute('fill', fill ?? 'none');
    for (const childDefinition of children ?? []){
        const path = createElement('path');
        const attrKeys = new Set([
            ...Object.keys(childDefinition),
            ...Object.keys($c24aa0432fb14e1e$export$152c49d0a7db7c6b)
        ]);
        for (const attr of attrKeys){
            const value = childDefinition[attr] ?? $c24aa0432fb14e1e$export$152c49d0a7db7c6b[attr];
            if (value !== void 0) path.setAttribute(attr, value.toString());
        }
        svg.appendChild(path);
    }
    svg.classList.add(className);
    return svg;
}
var /* *
 *
 *  Default Export
 *
 * */ $c24aa0432fb14e1e$export$2e2bcd8739ae039 = {
    createGridIcon: $c24aa0432fb14e1e$export$b665c5bd8748855e,
    icons: $c24aa0432fb14e1e$export$df03f54e09e486fa,
    pathDefaults: $c24aa0432fb14e1e$export$152c49d0a7db7c6b
};

});


parcelRegister("6erAn", function(module, exports) {

$parcel$export(module.exports, "default", () => $489972d2b29674d9$export$2e2bcd8739ae039);
/* *
 *
 *  Grid Header Cell State Helpers namespace
 *
 *  (c) 2020-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Dawid Dragula
 *
 * */ 'use strict';
function $489972d2b29674d9$export$e00bdcbec4a5a6e3(column) {
    const { condition: condition, value: value } = column.options.filtering || {};
    return !!(condition && ([
        'empty',
        'notEmpty',
        'true',
        'false'
    ].includes(condition) || value !== void 0 && value !== '' // Accept null and 0
    ));
}
function $489972d2b29674d9$export$efa610630f9e181(column, order) {
    const { currentSorting: currentSorting } = column.viewport.grid.querying.sorting || {};
    if (currentSorting?.columnId !== column.id) return false;
    return order ? currentSorting?.order === order : !!currentSorting?.order;
}
var /* *
 *
 *  Default Export
 *
 * */ $489972d2b29674d9$export$2e2bcd8739ae039 = {
    isFiltered: $489972d2b29674d9$export$e00bdcbec4a5a6e3,
    isSorted: $489972d2b29674d9$export$efa610630f9e181
};

});


parcelRegister("eU5BN", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad9aa5625109d6ca$export$2e2bcd8739ae039);
/* *
 *
 *  Grid Filter Toolbar Button class
 *
 *  (c) 2020-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Dawid Dragula
 *
 * */ 
var $5CCA4 = parcelRequire("5CCA4");

var $dON9w = parcelRequire("dON9w");

var $6erAn = parcelRequire("6erAn");

var $l3aRA = parcelRequire("l3aRA");
'use strict';
const { addEvent: $ad9aa5625109d6ca$var$addEvent } = (0, $l3aRA.default);
/* *
 *
 *  Class
 *
 * */ class $ad9aa5625109d6ca$var$FilterToolbarButton extends (0, $dON9w.default) {
    /* *
     *
     *  Constructor
     *
     * */ constructor(){
        super({
            icon: 'filter',
            classNameKey: 'headerCellFilterIcon',
            accessibility: {
                ariaLabel: 'filter',
                ariaExpanded: false,
                ariaControls: 'filter-popup'
            }
        });
    }
    /* *
     *
     *  Methods
     *
     * */ refreshState() {
        const column = this.toolbar?.column;
        if (column) this.setActive((0, $6erAn.default).isFiltered(column));
    }
    addEventListeners() {
        super.addEventListeners();
        const toolbar = this.toolbar;
        if (!toolbar) return;
        this.eventListenerDestroyers.push($ad9aa5625109d6ca$var$addEvent(toolbar.column, 'afterFilter', ()=>{
            this.refreshState();
        }));
    }
    clickHandler(event) {
        super.clickHandler(event);
        const filtering = this.toolbar?.column.filtering;
        if (!filtering) return;
        if (!this.popup) this.popup = new (0, $5CCA4.default)(filtering, this);
        this.popup.toggle(this.wrapper);
    }
}
var /* *
 *
 *  Default Export
 *
 * */ $ad9aa5625109d6ca$export$2e2bcd8739ae039 = $ad9aa5625109d6ca$var$FilterToolbarButton;

});
parcelRegister("5CCA4", function(module, exports) {

$parcel$export(module.exports, "default", () => $417e6db12587f781$export$2e2bcd8739ae039);
/* *
 *
 *  Grid Filter Popup class
 *
 *  (c) 2020-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Dawid Dragula
 *
 * */ 
var $kSMh5 = parcelRequire("kSMh5");

var $l3aRA = parcelRequire("l3aRA");
'use strict';
const { merge: $417e6db12587f781$var$merge } = (0, $l3aRA.default);
/* *
 *
 *  Class
 *
 * */ /**
 * The column filtering popup.
 */ class $417e6db12587f781$var$FilterPopup extends (0, $kSMh5.default) {
    /* *
     *
     *  Constructor
     *
     * */ /**
     * Constructs a column filtering popup.
     *
     * @param filtering
     * The column filtering.
     *
     * @param button
     * The button that opened the popup.
     *
     * @param options
     * Popup options.
     */ constructor(filtering, button, options){
        const grid = filtering.column.viewport.grid;
        super(grid, button, $417e6db12587f781$var$merge({
            header: {
                category: grid.options?.lang?.setFilter,
                label: filtering.column.header?.value || ''
            }
        }, options));
        this.filtering = filtering;
    }
    /* *
     *
     *  Methods
     *
     * */ show(anchorElement) {
        super.show(anchorElement);
        this.filtering.filterSelect?.focus();
    }
    renderContent(contentElement) {
        this.filtering.renderFilteringContent(contentElement);
    }
    onKeyDown(event) {
        super.onKeyDown(event);
        this.filtering.onKeyDown(event);
    }
}
var /* *
 *
 *  Default Export
 *
 * */ $417e6db12587f781$export$2e2bcd8739ae039 = $417e6db12587f781$var$FilterPopup;

});
parcelRegister("kSMh5", function(module, exports) {

$parcel$export(module.exports, "default", () => $f33e4c1edd9aa7bc$export$2e2bcd8739ae039);
/* *
 *
 *  Grid Popup abstract class
 *
 *  (c) 2020-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Dawid Dragula
 *
 * */ 
var $1I1ai = parcelRequire("1I1ai");

var $7Tdil = parcelRequire("7Tdil");

var $l3aRA = parcelRequire("l3aRA");
'use strict';
const { makeHTMLElement: $f33e4c1edd9aa7bc$var$makeHTMLElement } = (0, $1I1ai.default);
const { fireEvent: $f33e4c1edd9aa7bc$var$fireEvent } = (0, $l3aRA.default);
class $f33e4c1edd9aa7bc$export$129a32eedafa97c5 {
    /* *
     *
     *  Constructor
     *
     * */ /**
     * Constructs a popup for the given grid.
     *
     * @param grid
     * The grid that will own this popup.
     *
     * @param button
     * The button that opened the popup, if any.
     *
     * @param options
     * Popup options.
     */ constructor(grid, button, options){
        /**
         * Whether the popup is currently visible.
         */ this.isVisible = false;
        /**
         * Event listener destroyers.
         */ this.eventListenerDestroyers = [];
        this.grid = grid;
        this.button = button;
        this.options = options || {};
    }
    /**
     * Shows the popup positioned relative to the anchor element.
     *
     * @param anchorElement
     * The element to position the popup relative to.
     */ show(anchorElement) {
        if (this.container) return;
        this.button?.setHighlighted(true);
        this.container = $f33e4c1edd9aa7bc$var$makeHTMLElement('div', {
            className: (0, $7Tdil.default).getClassName('popup')
        });
        this.content = $f33e4c1edd9aa7bc$var$makeHTMLElement('div', {
            className: (0, $7Tdil.default).getClassName('popupContent')
        });
        const { header: header } = this.options;
        if (header) this.addHeader(header.label, header.category);
        this.renderContent(this.content);
        this.container.appendChild(this.content);
        this.anchorElement = anchorElement;
        this.isVisible = true;
        this.grid.contentWrapper?.appendChild(this.container);
        this.position(anchorElement);
        this.addEventListeners();
        this.grid.popups.add(this);
        $f33e4c1edd9aa7bc$var$fireEvent(this, 'afterShow');
    }
    /**
     * Hides the popup. In reality, it just destroys the popup container and
     * removes the event listeners.
     */ hide() {
        if (!this.container) return;
        $f33e4c1edd9aa7bc$var$fireEvent(this, 'beforeHide');
        this.grid.popups.delete(this);
        this.isVisible = false;
        // Remove event listeners
        this.removeEventListeners();
        this.container.remove();
        delete this.container;
        delete this.content;
        this.button?.setHighlighted(false);
        $f33e4c1edd9aa7bc$var$fireEvent(this, 'afterHide');
    }
    /**
     * Toggles the popup visibility.
     *
     * @param anchorElement
     * The element to position the popup relative to. If not provided, the popup
     * will be positioned relative to the parent element.
     */ toggle(anchorElement) {
        if (this.isVisible) this.hide();
        else this.show(anchorElement);
    }
    /**
     * Reflows the popup.
     */ reflow() {
        if (this.anchorElement?.isConnected) this.position(this.anchorElement);
        else this.hide();
    }
    /**
     * Positions the popup relative to the anchor element.
     *
     * @param anchorElement
     * The element to position relative to. If not provided, the popup will be
     * positioned relative to the parent element.
     */ position(anchorElement) {
        const wrapper = this.grid.contentWrapper;
        if (!this.container || !this.content || !wrapper) return;
        const next = this.options.nextToAnchor || false;
        const popupRect = this.container.getBoundingClientRect();
        const parentRect = wrapper.getBoundingClientRect();
        const anchorRect = anchorElement?.getBoundingClientRect() ?? parentRect;
        const top = next ? anchorRect.top : anchorRect.bottom + 4;
        let left = next ? anchorRect.right + 3 : anchorRect.left;
        // If popup's right side is after the parent's right side, shift popup
        // to the left of the anchor element.
        if (left + popupRect.width > parentRect.width) left = -popupRect.width + (next ? anchorRect.left + 4 : anchorRect.right);
        // If popup's left side is before the parent's left side,
        // shift popup so it's aligned to parent's left.
        if (left < parentRect.left) left = parentRect.left;
        // Apply positioning
        this.container.style.top = `${top - parentRect.top}px`;
        this.container.style.left = `${left - parentRect.left}px`;
        // If the content is too tall, constrain the container to the bottom
        // of the parent to enable content Y-scrolling.
        const contentRect = this.content.getBoundingClientRect();
        if (contentRect.height + contentRect.top - parentRect.top > parentRect.height) {
            this.container.style.top = 'auto';
            this.container.style.bottom = '0';
        } else {
            this.container.style.top = `${top - parentRect.top}px`;
            this.container.style.bottom = 'auto';
        }
    }
    /**
     * Adds a header to the context menu.
     *
     * @param label
     * The label shown in the header of the context menu.
     *
     * @param category
     * The category shown in the header of the context menu, before the label.
     *
     * @returns
     * The header element.
     */ addHeader(label, category) {
        if (!this.content) return;
        const container = $f33e4c1edd9aa7bc$var$makeHTMLElement('div', {
            className: (0, $7Tdil.default).getClassName('menuHeader')
        }, this.content);
        if (category) $f33e4c1edd9aa7bc$var$makeHTMLElement('span', {
            className: (0, $7Tdil.default).getClassName('menuHeaderCategory'),
            innerText: category + ' '
        }, container);
        $f33e4c1edd9aa7bc$var$makeHTMLElement('span', {
            className: (0, $7Tdil.default).getClassName('menuHeaderName'),
            innerText: label
        }, container);
        return container;
    }
    /**
     * Handles key down events.
     *
     * @param e
     * Keyboard event
     */ onKeyDown(e) {
        if (e.key === 'Escape' || e.key === 'Tab' && e.shiftKey) {
            e.preventDefault();
            this.hide();
            this.button?.focus();
        }
    }
    /**
     * Handles click outside events.
     *
     * @param e
     * Mouse event
     */ onClickOutside(e) {
        if (!this.container?.contains(e.target) && !this.anchorElement?.contains(e.target)) this.hide();
    }
    /**
     * Adds event listeners for click outside and escape key.
     */ addEventListeners() {
        const container = this.container;
        if (!container) return;
        const clickOutsideListener = (event)=>{
            this.onClickOutside(event);
        };
        const keyDownListener = (event)=>{
            this.onKeyDown(event);
        };
        document.addEventListener('mousedown', clickOutsideListener);
        container.addEventListener('keydown', keyDownListener);
        this.eventListenerDestroyers.push(()=>{
            document.removeEventListener('mousedown', clickOutsideListener);
            container.removeEventListener('keydown', keyDownListener);
        });
    }
    /**
     * Removes event listeners.
     */ removeEventListeners() {
        for (const destroyer of this.eventListenerDestroyers)destroyer();
        this.eventListenerDestroyers.length = 0;
    }
}
var /* *
 *
 *  Default Export
 *
 * */ $f33e4c1edd9aa7bc$export$2e2bcd8739ae039 = $f33e4c1edd9aa7bc$export$129a32eedafa97c5;

});



parcelRegister("dCihi", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e9d00932ceee2c6$export$2e2bcd8739ae039);
/* *
 *
 *  Grid Menu Toolbar Button class
 *
 *  (c) 2020-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Dawid Dragula
 *
 * */ 
var $dON9w = parcelRequire("dON9w");

var $6erAn = parcelRequire("6erAn");

var $8k0op = parcelRequire("8k0op");

var $l3aRA = parcelRequire("l3aRA");
'use strict';
const { addEvent: $9e9d00932ceee2c6$var$addEvent } = (0, $l3aRA.default);
/* *
 *
 *  Class
 *
 * */ class $9e9d00932ceee2c6$var$MenuToolbarButton extends (0, $dON9w.default) {
    /* *
     *
     *  Constructor
     *
     * */ constructor(){
        super({
            icon: 'menu',
            classNameKey: 'headerCellMenuIcon'
        });
    }
    /* *
     *
     *  Methods
     *
     * */ clickHandler(event) {
        super.clickHandler(event);
        const grid = this.toolbar?.column.viewport.grid;
        if (!grid) return;
        if (!this.popup) this.popup = new (0, $8k0op.default)(grid, this);
        this.popup.toggle(this.wrapper);
    }
    refreshState() {
        const column = this.toolbar?.column;
        if (!column) return;
        this.setActive((0, $6erAn.default).isSorted(column) || (0, $6erAn.default).isFiltered(column));
    }
    addEventListeners() {
        super.addEventListeners();
        const column = this.toolbar?.column;
        if (!column) return;
        this.eventListenerDestroyers.push($9e9d00932ceee2c6$var$addEvent(column.viewport.grid, 'afterSort', ()=>{
            this.refreshState();
        }), $9e9d00932ceee2c6$var$addEvent(column, 'afterFilter', ()=>{
            this.refreshState();
        }));
    }
}
var /* *
 *
 *  Default Export
 *
 * */ $9e9d00932ceee2c6$export$2e2bcd8739ae039 = $9e9d00932ceee2c6$var$MenuToolbarButton;

});
parcelRegister("8k0op", function(module, exports) {

$parcel$export(module.exports, "default", () => $60f07ef20a888563$export$2e2bcd8739ae039);
/* *
 *
 *  Grid Menu Popup class
 *
 *  (c) 2020-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Dawid Dragula
 *
 * */ 
var $kUtIc = parcelRequire("kUtIc");

var $bCSHy = parcelRequire("bCSHy");

var $dshMS = parcelRequire("dshMS");
'use strict';
/* *
 *
 *  Class
 *
 * */ /**
 * The column filtering popup.
 */ class $60f07ef20a888563$var$MenuPopup extends (0, $kUtIc.default) {
    /* *
     *
     *  Constructor
     *
     * */ constructor(grid, button){
        super(grid, button);
        this.button = button;
    }
    /* *
     *
     *  Methods
     *
     * */ renderContent() {
        const lang = this.grid.options?.lang || {};
        const columnOptions = this.button.toolbar?.column.options || {};
        const filteringEnabled = columnOptions.filtering?.enabled && !columnOptions.filtering.inline;
        const sortingEnabled = columnOptions.sorting?.sortable;
        this.addHeader(this.button.toolbar?.column.header?.value || '', lang.column);
        if (sortingEnabled) {
            new (0, $dshMS.default)(lang, 'desc').add(this);
            new (0, $dshMS.default)(lang, 'asc').add(this);
            if (filteringEnabled) this.addDivider();
        }
        if (filteringEnabled) new (0, $bCSHy.default)(lang || {}).add(this);
    }
}
var /* *
 *
 *  Default Export
 *
 * */ $60f07ef20a888563$export$2e2bcd8739ae039 = $60f07ef20a888563$var$MenuPopup;

});
parcelRegister("kUtIc", function(module, exports) {

$parcel$export(module.exports, "default", () => $f39015cb1ee8a389$export$2e2bcd8739ae039);
/* *
 *
 * Grid Context Menu abstract class
 *
 *  (c) 2020-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Dawid Dragula
 *
 * */ 
var $kSMh5 = parcelRequire("kSMh5");

var $7Tdil = parcelRequire("7Tdil");

var $1I1ai = parcelRequire("1I1ai");
'use strict';
const { makeHTMLElement: $f39015cb1ee8a389$var$makeHTMLElement } = (0, $1I1ai.default);
class $f39015cb1ee8a389$export$8dc6765e8be191c7 extends (0, $kSMh5.default) {
    constructor(){
        /* *
         *
         *  Properties
         *
         * */ super(...arguments);
        /**
         * The array of buttons in the context menu.
         */ this.buttons = [];
        /**
         * The index of the focused button in the context menu.
         */ this.focusCursor = 0;
    }
    /* *
     *
     *  Methods
     *
     * */ /**
     * Ensures that the items container element is created.
     *
     * @returns
     * The items container element.
     */ ensureItemsContainer() {
        if (!this.content) return;
        if (this.itemsContainer) return this.itemsContainer;
        this.itemsContainer = $f39015cb1ee8a389$var$makeHTMLElement('ul', {
            className: (0, $7Tdil.default).getClassName('menuContainer')
        }, this.content);
        return this.itemsContainer;
    }
    show(anchorElement) {
        super.show(anchorElement);
        this.buttons[0]?.focus();
    }
    hide() {
        for (const btn of this.buttons)btn.destroy();
        this.buttons.length = 0;
        this.itemsContainer?.remove();
        delete this.itemsContainer;
        super.hide();
    }
    /**
     * Adds a divider to the context menu.
     *
     * @returns
     * The divider element.
     */ addDivider() {
        if (!this.ensureItemsContainer()) return;
        return $f39015cb1ee8a389$var$makeHTMLElement('li', {
            className: (0, $7Tdil.default).getClassName('menuDivider')
        }, this.itemsContainer);
    }
    onClickOutside(event) {
        const buttons = this.buttons;
        for(let i = 0, iEnd = buttons.length; i < iEnd; ++i){
            if (buttons[i].popup?.container?.contains(event.target)) return;
        }
        super.onClickOutside(event);
    }
    onKeyDown(e) {
        super.onKeyDown(e);
        const len = this.buttons.length;
        const cursor = this.focusCursor;
        switch(e.key){
            case 'ArrowUp':
            case 'ArrowLeft':
                e.preventDefault();
                this.buttons[Math.abs((cursor - 1 + len) % len)].focus();
                break;
            case 'ArrowDown':
            case 'ArrowRight':
                e.preventDefault();
                this.buttons[(cursor + 1) % len].focus();
                break;
        }
    }
}
var /* *
 *
 *  Default Export
 *
 * */ $f39015cb1ee8a389$export$2e2bcd8739ae039 = $f39015cb1ee8a389$export$8dc6765e8be191c7;

});

parcelRegister("bCSHy", function(module, exports) {

$parcel$export(module.exports, "default", () => $876dace28709efe4$export$2e2bcd8739ae039);
/* *
 *
 *  Grid Filter Context Menu Button class
 *
 *  (c) 2020-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Dawid Dragula
 *
 * */ 
var $5CCA4 = parcelRequire("5CCA4");

var $6erAn = parcelRequire("6erAn");

var $aPPhS = parcelRequire("aPPhS");

var $l3aRA = parcelRequire("l3aRA");
'use strict';
const { addEvent: $876dace28709efe4$var$addEvent } = (0, $l3aRA.default);
/* *
 *
 *  Class
 *
 * */ class $876dace28709efe4$var$FilterToolbarButton extends (0, $aPPhS.default) {
    /* *
     *
     *  Constructor
     *
     * */ constructor(langOptions){
        super({
            label: langOptions.filter,
            icon: 'filter',
            chevron: true
        });
    }
    /* *
     *
     *  Methods
     *
     * */ refreshState() {
        const column = this.contextMenu?.button.toolbar?.column;
        if (column) this.setActive((0, $6erAn.default).isFiltered(column));
    }
    addEventListeners() {
        super.addEventListeners();
        const toolbar = this.contextMenu?.button.toolbar;
        if (!toolbar) return;
        this.eventListenerDestroyers.push($876dace28709efe4$var$addEvent(toolbar.column, 'afterFilter', ()=>{
            this.refreshState();
        }));
    }
    clickHandler(event) {
        super.clickHandler(event);
        const filtering = this.contextMenu?.button.toolbar?.column.filtering;
        if (!filtering) return;
        if (!this.popup) this.popup = new (0, $5CCA4.default)(filtering, this, {
            nextToAnchor: true
        });
        this.popup.toggle(this.wrapper);
    }
}
var /* *
 *
 *  Default Export
 *
 * */ $876dace28709efe4$export$2e2bcd8739ae039 = $876dace28709efe4$var$FilterToolbarButton;

});
parcelRegister("aPPhS", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e3673629cc8cdf6$export$2e2bcd8739ae039);
/* *
 *
 *  Grid Context Menu Button class
 *
 *  (c) 2020-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Dawid Dragula
 *
 * */ 
var $gGcXV = parcelRequire("gGcXV");

var $7Tdil = parcelRequire("7Tdil");

var $1I1ai = parcelRequire("1I1ai");
'use strict';
const { makeHTMLElement: $7e3673629cc8cdf6$var$makeHTMLElement } = (0, $1I1ai.default);
class $7e3673629cc8cdf6$export$12bd1ca0725acab2 {
    /* *
     *
     *  Constructor
     *
     * */ constructor(options){
        /**
         * Used to remove the event listeners when the button is destroyed.
         */ this.eventListenerDestroyers = [];
        /**
         * Whether the button is active.
         */ this.isActive = false;
        this.options = options;
    }
    /* *
     *
     *  Methods
     *
     * */ /**
     * Adds the button to the context menu.
     *
     * @param contextMenu
     * The context menu to add the button to.
     */ add(contextMenu) {
        const cfg = this.options;
        this.contextMenu = contextMenu;
        contextMenu.buttons.push(this);
        const container = contextMenu.ensureItemsContainer();
        if (!container) return;
        const liEl = this.wrapper = $7e3673629cc8cdf6$var$makeHTMLElement('li', cfg.classNameKey && {
            className: (0, $7Tdil.default).getClassName(cfg.classNameKey)
        }, container);
        const buttonEl = this.buttonEl = $7e3673629cc8cdf6$var$makeHTMLElement('button', {
            className: (0, $7Tdil.default).getClassName('menuItem')
        }, liEl);
        const iconEl = this.iconWrapper = $7e3673629cc8cdf6$var$makeHTMLElement('span', {
            className: (0, $7Tdil.default).getClassName('menuItemIcon')
        }, buttonEl);
        this.spanEl = $7e3673629cc8cdf6$var$makeHTMLElement('span', {
            className: (0, $7Tdil.default).getClassName('menuItemLabel'),
            innerText: cfg.label || ''
        }, buttonEl);
        const chevronEl = $7e3673629cc8cdf6$var$makeHTMLElement('span', {
            className: (0, $7Tdil.default).getClassName('menuItemIcon')
        }, buttonEl);
        iconEl.setAttribute('aria-hidden', 'true');
        chevronEl.setAttribute('aria-hidden', 'true');
        buttonEl.setAttribute('type', 'button');
        buttonEl.setAttribute('tabindex', '-1');
        this.refreshState();
        if (cfg.chevron) chevronEl.appendChild((0, $gGcXV.createGridIcon)('chevronRight'));
        if (cfg.icon) this.setIcon(cfg.icon);
        this.addEventListeners();
        return this;
    }
    focus() {
        this.buttonEl?.focus();
        const cm = this.contextMenu;
        if (cm) cm.focusCursor = cm.buttons.indexOf(this);
    }
    setLabel(label) {
        if (this.spanEl) this.spanEl.innerText = label;
    }
    /**
     * Sets the icon for the button.
     *
     * @param icon
     * The icon to set.
     */ setIcon(icon) {
        this.icon?.remove();
        if (!icon) return;
        this.icon = (0, $gGcXV.createGridIcon)(icon);
        this.iconWrapper?.appendChild(this.icon);
    }
    setActive(active) {
        this.isActive = active;
        this.buttonEl?.classList.toggle('active', active);
        const { activeIcon: activeIcon, icon: icon } = this.options;
        if (activeIcon) this.setIcon(active ? activeIcon : icon);
    }
    setHighlighted(highlighted) {
        this.buttonEl?.classList.toggle('highlighted', highlighted);
    }
    /**
     * Destroys the button.
     */ destroy() {
        this.removeEventListeners();
        this.wrapper?.remove();
        // Unregister from the context menu
        const cm = this.contextMenu;
        if (cm) {
            cm.buttons.splice(cm.buttons.indexOf(this), 1);
            delete this.contextMenu;
        }
    }
    /**
     * Initializes the state of the button.
     */ refreshState() {
    // Do nothing, to be overridden by subclasses
    }
    /**
     * Handles the click event for the button.
     *
     * @param event
     * The mouse event.
     */ clickHandler(event) {
        this.options.onClick?.(event, this);
    }
    /**
     * Adds event listeners to the button.
     */ addEventListeners() {
        const clickListener = (event)=>{
            this.clickHandler(event);
        };
        this.buttonEl?.addEventListener('click', clickListener);
        this.eventListenerDestroyers.push(()=>{
            this.buttonEl?.removeEventListener('click', clickListener);
        });
    }
    /**
     * Removes event listeners from the button.
     */ removeEventListeners() {
        for (const destroyer of this.eventListenerDestroyers)destroyer();
        this.eventListenerDestroyers.length = 0;
    }
}
var /* *
 *
 *  Default Export
 *
 * */ $7e3673629cc8cdf6$export$2e2bcd8739ae039 = $7e3673629cc8cdf6$export$12bd1ca0725acab2;

});


parcelRegister("dshMS", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cbbb017eacde36c$export$2e2bcd8739ae039);
/* *
 *
 *  Grid Sort Context Menu Button class
 *
 *  (c) 2020-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Dawid Dragula
 *
 * */ 
var $aPPhS = parcelRequire("aPPhS");

var $6erAn = parcelRequire("6erAn");

var $l3aRA = parcelRequire("l3aRA");
'use strict';
const { addEvent: $9cbbb017eacde36c$var$addEvent } = (0, $l3aRA.default);
/* *
 *
 *  Class
 *
 * */ class $9cbbb017eacde36c$var$SortMenuButton extends (0, $aPPhS.default) {
    /* *
     *
     *  Constructor
     *
     * */ constructor(langOptions, direction){
        super({
            icon: direction === 'asc' ? 'sortAsc' : 'sortDesc'
        });
        this.direction = direction;
        this.options.label = langOptions[direction === 'asc' ? 'sortAscending' : 'sortDescending'];
    }
    /* *
     *
     *  Methods
     *
     * */ refreshState() {
        const column = this.contextMenu?.button?.toolbar?.column;
        if (!column) return;
        this.setActive((0, $6erAn.default).isSorted(column, this.direction));
    }
    addEventListeners() {
        super.addEventListeners();
        const column = this.contextMenu?.button?.toolbar?.column;
        if (!column) return;
        // If this grid is currently sorted, update the state
        this.eventListenerDestroyers.push($9cbbb017eacde36c$var$addEvent(column.viewport.grid, 'afterSort', ()=>this.refreshState()));
    }
    clickHandler(event) {
        super.clickHandler(event);
        const sorting = this.contextMenu?.button?.toolbar?.column.sorting;
        if (!sorting) return;
        sorting.setOrder(this.isActive ? null : this.direction);
    }
}
var /* *
 *
 *  Default Export
 *
 * */ $9cbbb017eacde36c$export$2e2bcd8739ae039 = $9cbbb017eacde36c$var$SortMenuButton;

});






parcelRegister("eUXb0", function(module, exports) {

$parcel$export(module.exports, "default", () => $adc432d9f63da7f0$export$2e2bcd8739ae039);
/* *
 *
 *  Grid FilteringRow class
 *
 *  (c) 2020-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Dawid Dragula
 *
 * */ 
var $8OMyt = parcelRequire("8OMyt");

var $7Tdil = parcelRequire("7Tdil");

var $27D49 = parcelRequire("27D49");
'use strict';
/* *
 *
 *  Class
 *
 * */ /**
 * Represents a special filtering row in the data grid header.
 */ class $adc432d9f63da7f0$var$FilterRow extends (0, $27D49.default) {
    /* *
     *
     *  Constructor
     *
     * */ /**
     * Constructs a filtering row in the Grid's header.
     *
     * @param viewport
     * The Grid Table instance which the row belongs to.
     */ constructor(viewport){
        super(viewport, (viewport.header?.levels ?? 0) + 1 // Level (1-based)
        );
    }
    /* *
     *
     *  Methods
     *
     * */ createCell(column) {
        return new (0, $8OMyt.default)(this, column);
    }
    renderContent() {
        const vp = this.viewport;
        const enabledColumns = vp.grid.enabledColumns || [];
        vp.theadElement?.appendChild(this.htmlElement);
        this.htmlElement.classList.add((0, $7Tdil.default).getClassName('headerRow'));
        for(let i = 0, iEnd = vp.columns.length; i < iEnd; i++){
            const column = vp.columns[i];
            if (enabledColumns?.indexOf(column.id) < 0) continue;
            const cell = this.createCell(column);
            cell.render();
            if (column.options.filtering?.inline) column.filtering?.renderFilteringContent(cell.htmlElement);
        }
        const firstCell = this.cells[0];
        if (firstCell.column?.index === 0) // Add class to disable left border on first column
        this.cells[0].htmlElement.classList.add((0, $7Tdil.default).getClassName('columnFirst'));
        this.setLastCellClass();
    }
}
var /* *
 *
 *  Default Export
 *
 * */ $adc432d9f63da7f0$export$2e2bcd8739ae039 = $adc432d9f63da7f0$var$FilterRow;

});
parcelRegister("8OMyt", function(module, exports) {

$parcel$export(module.exports, "default", () => $66b8a83f90e75f7c$export$2e2bcd8739ae039);
/* *
 *
 *  Grid Filter Cell class
 *
 *  (c) 2020-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Dawid Dragula
 *
 * */ 
var $eWdjg = parcelRequire("eWdjg");

var $l3aRA = parcelRequire("l3aRA");
'use strict';
const { fireEvent: $66b8a83f90e75f7c$var$fireEvent } = (0, $l3aRA.default);
/* *
 *
 *  Class
 *
 * */ /**
 * Represents a cell in the data grid header.
 */ class $66b8a83f90e75f7c$var$FilterCell extends (0, $eWdjg.default) {
    /* *
     *
     *  Constructor
     *
     * */ constructor(row, column){
        const trueHeader = column.header;
        super(row, column);
        column.header = trueHeader;
    }
    /* *
     *
     *  Methods
     *
     * */ render() {
        const { column: column } = this;
        if (!column) return;
        // Render content of th element
        this.row.htmlElement.appendChild(this.htmlElement);
        this.htmlElement.setAttribute('scope', 'col');
        this.htmlElement.setAttribute('data-column-id', column.id);
        // Add user column classname
        if (column.options.className) this.htmlElement.classList.add(...column.options.className.split(/\s+/g));
        this.setCustomClassName(column.options.header?.className);
        $66b8a83f90e75f7c$var$fireEvent(this, 'afterRender', {
            column: column,
            filtering: true
        });
    }
    onKeyDown(e) {
        this.column.filtering?.onKeyDown(e);
        if (e.target === this.htmlElement) {
            if (e.key === 'Enter') this.column.filtering?.filterSelect?.focus();
            else super.onKeyDown(e);
        } else if (e.key === 'Escape') this.htmlElement.focus();
    }
    onClick(e) {
        if (e.target === this.htmlElement) this.htmlElement.focus();
    }
}
var /* *
 *
 *  Default Export
 *
 * */ $66b8a83f90e75f7c$export$2e2bcd8739ae039 = $66b8a83f90e75f7c$var$FilterCell;

});



parcelRegister("dmvLI", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ba5f9079b817e03$export$2e2bcd8739ae039);
/* *
 *
 *  Grid Rows Renderer class.
 *
 *  (c) 2020-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Dawid Dragula
 *
 * */ 
var $5BNJr = parcelRequire("5BNJr");

var $7Tdil = parcelRequire("7Tdil");
'use strict';
/* *
 *
 *  Class
 *
 * */ /**
 * Represents a virtualized rows renderer for the data grid.
 */ class $9ba5f9079b817e03$var$RowsVirtualizer {
    /* *
    *
    *  Constructor
    *
    * */ /**
     * Constructs an instance of the rows virtualizer.
     *
     * @param viewport
     * The viewport of the data grid to render rows in.
     */ constructor(viewport){
        /**
         * The index of the first visible row.
         */ this.rowCursor = 0;
        /**
         * Flag indicating if the scrolling handler should be prevented to avoid
         * flickering loops when scrolling to the last row.
         */ this.preventScroll = false;
        this.rowSettings = viewport.grid.options?.rendering?.rows;
        this.viewport = viewport;
        this.strictRowHeights = this.rowSettings.strictHeights;
        this.buffer = Math.max(this.rowSettings.bufferSize, 0);
        this.defaultRowHeight = this.getDefaultRowHeight();
        if (this.strictRowHeights) viewport.tbodyElement.classList.add((0, $7Tdil.default).getClassName('rowsContentNowrap'));
    }
    /* *
    *
    *  Functions
    *
    * */ /**
     * Renders the rows in the viewport for the first time.
     */ initialRender() {
        // Initial reflow to set the viewport height
        if (this.viewport.virtualRows) this.viewport.reflow();
        // Load & render rows
        this.renderRows(this.rowCursor);
        this.adjustRowHeights();
    }
    /**
     * Renders the rows in the viewport. It is called when the rows need to be
     * re-rendered, e.g., after a sort or filter operation.
     */ rerender() {
        const tbody = this.viewport.tbodyElement;
        let rows = this.viewport.rows;
        const oldScrollLeft = tbody.scrollLeft;
        let oldScrollTop;
        if (rows.length) {
            oldScrollTop = tbody.scrollTop;
            for(let i = 0, iEnd = rows.length; i < iEnd; ++i)rows[i].destroy();
            rows.length = 0;
        }
        this.renderRows(this.rowCursor);
        if (this.viewport.virtualRows) {
            if (oldScrollTop !== void 0) tbody.scrollTop = oldScrollTop;
            this.scroll();
        }
        rows = this.viewport.rows;
        // Reflow the rendered row cells widths (check redundancy)
        for(let i = 0, iEnd = rows.length; i < iEnd; ++i)rows[i].reflow();
        tbody.scrollLeft = oldScrollLeft;
    }
    /**
     * Method called on the viewport scroll event, only when the virtualization
     * is enabled.
     */ scroll() {
        const target = this.viewport.tbodyElement;
        const { defaultRowHeight: rowHeight } = this;
        const lastScrollTop = target.scrollTop;
        if (this.preventScroll) {
            if (lastScrollTop <= target.scrollTop) this.preventScroll = false;
            this.adjustBottomRowHeights();
            return;
        }
        // Do vertical virtual scrolling
        const rowCursor = Math.floor(target.scrollTop / rowHeight);
        if (this.rowCursor !== rowCursor) this.renderRows(rowCursor);
        this.rowCursor = rowCursor;
        this.adjustRowHeights();
        if (!this.strictRowHeights && lastScrollTop > target.scrollTop && !this.preventScroll) {
            target.scrollTop = lastScrollTop;
            this.preventScroll = true;
        }
    }
    /**
     * Adjusts the visible row heights from the bottom of the viewport.
     */ adjustBottomRowHeights() {
        const rows = this.viewport.rows;
        const rowsLn = rows.length;
        const lastRow = rows[rowsLn - 1];
        let rowTop = lastRow.translateY;
        const rowBottom = rowTop + lastRow.htmlElement.offsetHeight;
        let newHeight = lastRow.cells[0].htmlElement.offsetHeight;
        rowTop = rowBottom - newHeight;
        lastRow.htmlElement.style.height = newHeight + 'px';
        lastRow.setTranslateY(rowTop);
        for(let j = 0, jEnd = lastRow.cells.length; j < jEnd; ++j)lastRow.cells[j].htmlElement.style.transform = '';
        for(let i = rowsLn - 2; i >= 0; i--){
            const row = rows[i];
            newHeight = row.cells[0].htmlElement.offsetHeight;
            rowTop -= newHeight;
            row.htmlElement.style.height = newHeight + 'px';
            row.setTranslateY(rowTop);
            for(let j = 0, jEnd = row.cells.length; j < jEnd; ++j)row.cells[j].htmlElement.style.transform = '';
        }
    }
    /**
     * Renders rows in the specified range. Removes rows that are out of the
     * range except the last row.
     *
     * @param rowCursor
     * The index of the first visible row.
     */ renderRows(rowCursor) {
        const { viewport: vp, buffer: buffer } = this;
        const rowCount = vp.dataTable.getRowCount();
        // Stop rendering if there are no rows to render.
        if (rowCount < 1) return;
        const isVirtualization = this.viewport.virtualRows;
        const rowsPerPage = isVirtualization ? Math.ceil((vp.grid.tableElement?.clientHeight || 0) / this.defaultRowHeight) : Infinity; // Need to be refactored when add pagination
        let rows = vp.rows;
        if (!isVirtualization && rows.length > 50) // eslint-disable-next-line no-console
        console.warn("Grid: a large dataset can cause performance issues when virtualization is disabled. Consider enabling virtualization in the rows settings.");
        if (!rows.length) {
            const last = new (0, $5BNJr.default)(vp, rowCount - 1);
            vp.tbodyElement.appendChild(last.htmlElement);
            last.render();
            rows.push(last);
            if (isVirtualization) last.setTranslateY(last.getDefaultTopOffset());
        }
        const from = Math.max(0, Math.min(rowCursor - buffer, rowCount - rowsPerPage));
        const to = Math.min(rowCursor + rowsPerPage + buffer, rows[rows.length - 1].index - 1);
        const alwaysLastRow = rows.pop();
        const tempRows = [];
        // Remove rows that are out of the range except the last row.
        for(let i = 0, iEnd = rows.length; i < iEnd; ++i){
            const row = rows[i];
            const rowIndex = row.index;
            if (rowIndex < from || rowIndex > to) row.destroy();
            else tempRows.push(row);
        }
        rows = tempRows;
        vp.rows = rows;
        for(let i = from; i <= to; ++i){
            const row = rows[i - (rows[0]?.index || 0)];
            // Recreate row when it is destroyed and it is in the range.
            if (!row) {
                const newRow = new (0, $5BNJr.default)(vp, i);
                rows.push(newRow);
                newRow.rendered = false;
                if (isVirtualization) newRow.setTranslateY(newRow.getDefaultTopOffset());
            }
        }
        rows.sort((a, b)=>a.index - b.index);
        for(let i = 0, iEnd = rows.length; i < iEnd; ++i)if (!rows[i].rendered) {
            vp.tbodyElement.insertBefore(rows[i].htmlElement, vp.tbodyElement.lastChild);
            rows[i].render();
        }
        if (alwaysLastRow) rows.push(alwaysLastRow);
        // Focus the cell if the focus cursor is set
        if (vp.focusCursor) {
            const [rowIndex, columnIndex] = vp.focusCursor;
            const row = rows.find((row)=>row.index === rowIndex);
            if (row) row.cells[columnIndex]?.htmlElement.focus({
                preventScroll: true
            });
        }
        // Set the focus anchor cell
        if ((!vp.focusCursor || !vp.focusAnchorCell?.row.rendered) && rows.length > 0) {
            const rowIndex = rowCursor - rows[0].index;
            if (rows[rowIndex]) vp.setFocusAnchorCell(rows[rowIndex].cells[0]);
        }
    }
    /**
     * Adjusts the heights of the rows based on the current scroll position.
     * It handles the possibility of the rows having different heights than
     * the default height.
     */ adjustRowHeights() {
        if (this.strictRowHeights || !this.viewport.virtualRows) return;
        const { rowCursor: cursor, defaultRowHeight: defaultH } = this;
        const { rows: rows, tbodyElement: tbodyElement } = this.viewport;
        const rowsLn = rows.length;
        if (rowsLn < 1) return;
        let translateBuffer = rows[0].getDefaultTopOffset();
        for(let i = 0; i < rowsLn; ++i){
            const row = rows[i];
            // Reset row height and cell transforms
            row.htmlElement.style.height = '';
            if (row.cells[0].htmlElement.style.transform) for(let j = 0, jEnd = row.cells.length; j < jEnd; ++j){
                const cell = row.cells[j];
                cell.htmlElement.style.transform = '';
            }
            // Rows above the first visible row
            if (row.index < cursor) {
                row.htmlElement.style.height = defaultH + 'px';
                continue;
            }
            const cellHeight = row.cells[0].htmlElement.offsetHeight;
            row.htmlElement.style.height = cellHeight + 'px';
            // Rows below the first visible row
            if (row.index > cursor) continue;
            // First visible row
            if (row.htmlElement.offsetHeight > defaultH) {
                const newHeight = Math.floor(cellHeight - (cellHeight - defaultH) * (tbodyElement.scrollTop / defaultH - cursor));
                row.htmlElement.style.height = newHeight + 'px';
                for(let j = 0, jEnd = row.cells.length; j < jEnd; ++j){
                    const cell = row.cells[j];
                    cell.htmlElement.style.transform = `translateY(${newHeight - cellHeight}px)`;
                }
            }
        }
        rows[0].setTranslateY(translateBuffer);
        for(let i = 1, iEnd = rowsLn - 1; i < iEnd; ++i){
            translateBuffer += rows[i - 1].htmlElement.offsetHeight;
            rows[i].setTranslateY(translateBuffer);
        }
        // Set the proper offset for the last row
        const lastRow = rows[rowsLn - 1];
        const preLastRow = rows[rowsLn - 2];
        if (preLastRow && preLastRow.index === lastRow.index - 1) lastRow.setTranslateY(preLastRow.htmlElement.offsetHeight + translateBuffer);
    }
    /**
     * Reflow the rendered rows content dimensions.
     */ reflowRows() {
        const rows = this.viewport.rows;
        if (rows.length < 1) return;
        for(let i = 0, iEnd = rows.length; i < iEnd; ++i)rows[i].reflow();
        this.adjustRowHeights();
    }
    /**
     * Returns the default height of a row. This method should be called only
     * once on initialization.
     */ getDefaultRowHeight() {
        const vp = this.viewport;
        const mockRow = new (0, $5BNJr.default)(vp, 0);
        mockRow.htmlElement.style.position = 'absolute';
        mockRow.htmlElement.classList.add((0, $7Tdil.default).getClassName('mockedRow'));
        this.viewport.tbodyElement.appendChild(mockRow.htmlElement);
        mockRow.render();
        const defaultRowHeight = mockRow.htmlElement.offsetHeight;
        mockRow.destroy();
        return defaultRowHeight;
    }
}
var /* *
 *
 *  Default Export
 *
 * */ $9ba5f9079b817e03$export$2e2bcd8739ae039 = $9ba5f9079b817e03$var$RowsVirtualizer;

});
parcelRegister("5BNJr", function(module, exports) {

$parcel$export(module.exports, "default", () => $4156fc28ff4f27cf$export$2e2bcd8739ae039);
/* *
 *
 *  Grid TableRow class
 *
 *  (c) 2020-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Dawid Dragula
 *  - Sebastian Bochan
 *
 * */ 
var $8VMz6 = parcelRequire("8VMz6");

var $5qDHU = parcelRequire("5qDHU");

var $7Tdil = parcelRequire("7Tdil");
'use strict';
/* *
 *
 *  Class
 *
 * */ /**
 * Represents a row in the data grid.
 */ class $4156fc28ff4f27cf$var$TableRow extends (0, $8VMz6.default) {
    /* *
    *
    *  Constructor
    *
    * */ /**
     * Constructs a row in the data grid.
     *
     * @param viewport
     * The Grid Table instance which the row belongs to.
     *
     * @param index
     * The index of the row in the data table.
     */ constructor(viewport, index){
        super(viewport);
        /* *
        *
        *  Properties
        *
        * */ /**
         * The row values from the data table in the original column order.
         */ this.data = {};
        /**
         * The vertical translation of the row.
         */ this.translateY = 0;
        this.index = index;
        this.id = viewport.dataTable.getOriginalRowIndex(index);
        this.loadData();
        this.setRowAttributes();
    }
    /* *
    *
    *  Methods
    *
    * */ createCell(column) {
        return new (0, $5qDHU.default)(this, column);
    }
    /**
     * Loads the row data from the data table.
     */ loadData() {
        const data = this.viewport.dataTable.getRowObject(this.index);
        if (!data) return;
        this.data = data;
    }
    /**
     * Updates the row data and its cells with the latest values from the data
     * table.
     */ update() {
        this.id = this.viewport.dataTable.getOriginalRowIndex(this.index);
        this.updateRowAttributes();
        this.loadData();
        for(let i = 0, iEnd = this.cells.length; i < iEnd; ++i){
            const cell = this.cells[i];
            cell.setValue();
        }
        this.reflow();
    }
    /**
     * Adds or removes the hovered CSS class to the row element.
     *
     * @param hovered
     * Whether the row should be hovered.
     */ setHoveredState(hovered) {
        this.htmlElement.classList[hovered ? 'add' : 'remove']((0, $7Tdil.default).getClassName('hoveredRow'));
        if (hovered) this.viewport.grid.hoveredRowIndex = this.index;
    }
    /**
     * Adds or removes the synced CSS class to the row element.
     *
     * @param synced
     * Whether the row should be synced.
     */ setSyncedState(synced) {
        this.htmlElement.classList[synced ? 'add' : 'remove']((0, $7Tdil.default).getClassName('syncedRow'));
        if (synced) this.viewport.grid.syncedRowIndex = this.index;
    }
    /**
     * Sets the row HTML element attributes and additional classes.
     */ setRowAttributes() {
        const idx = this.index;
        const el = this.htmlElement;
        el.classList.add((0, $7Tdil.default).getClassName('rowElement'));
        // Index of the row in the presentation data table
        el.setAttribute('data-row-index', idx);
        this.updateRowAttributes();
        // Indexing from 0, so rows with even index are odd.
        el.classList.add((0, $7Tdil.default).getClassName(idx % 2 ? 'rowEven' : 'rowOdd'));
        if (this.viewport.grid.hoveredRowIndex === idx) el.classList.add((0, $7Tdil.default).getClassName('hoveredRow'));
        if (this.viewport.grid.syncedRowIndex === idx) el.classList.add((0, $7Tdil.default).getClassName('syncedRow'));
    }
    /**
     * Sets the row HTML element attributes that are updateable in the row
     * lifecycle.
     */ updateRowAttributes() {
        const vp = this.viewport;
        const a11y = vp.grid.accessibility;
        const idx = this.index;
        const el = this.htmlElement;
        // Index of the row in the original data table (ID)
        if (this.id !== void 0) el.setAttribute('data-row-id', this.id);
        // Calculate levels of header, 1 to avoid indexing from 0
        a11y?.setRowIndex(el, idx + (vp.header?.rows.length ?? 0) + 1);
    }
    /**
     * Sets the vertical translation of the row. Used for virtual scrolling.
     *
     * @param value
     * The vertical translation of the row.
     */ setTranslateY(value) {
        this.translateY = value;
        this.htmlElement.style.transform = `translateY(${value}px)`;
    }
    /**
     * Returns the default top offset of the row (before adjusting row heights).
     * @internal
     */ getDefaultTopOffset() {
        return this.index * this.viewport.rowsVirtualizer.defaultRowHeight;
    }
}
var /* *
 *
 *  Default Export
 *
 * */ $4156fc28ff4f27cf$export$2e2bcd8739ae039 = $4156fc28ff4f27cf$var$TableRow;

});
parcelRegister("5qDHU", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f3e2e7e12bdb1c1$export$2e2bcd8739ae039);
/* *
 *
 *  Grid class
 *
 *  (c) 2020-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Dawid Dragula
 *  - Sebastian Bochan
 *
 * */ 
var $7Tdil = parcelRequire("7Tdil");

var $l3Gyg = parcelRequire("l3Gyg");

var $l3aRA = parcelRequire("l3aRA");
'use strict';
const { fireEvent: $3f3e2e7e12bdb1c1$var$fireEvent } = (0, $l3aRA.default);
/* *
 *
 *  Class
 *
 * */ /**
 * Represents a cell in the data grid.
 */ class $3f3e2e7e12bdb1c1$var$TableCell extends (0, $l3Gyg.default) {
    /* *
    *
    *  Constructor
    *
    * */ /**
     * Constructs a cell in the data grid.
     *
     * @param row
     * The row of the cell.
     *
     * @param column
     * The column of the cell.
     */ constructor(row, column){
        super(row, column);
        this.column = column;
        this.row = row;
        this.column.registerCell(this);
    }
    /* *
    *
    *  Methods
    *
    * */ /**
     * Renders the cell by appending it to the row and setting its value.
     */ render() {
        super.render();
        this.setValue();
    }
    /**
     * Edits the cell value and updates the data table. Call this instead of
     * `setValue` when you want it to trigger the cell value user change event.
     *
     * @param value
     * The new value to set.
     */ async editValue(value) {
        if (this.value === value) return;
        $3f3e2e7e12bdb1c1$var$fireEvent(this, 'beforeEditValue');
        await this.setValue(value, true);
        $3f3e2e7e12bdb1c1$var$fireEvent(this, 'afterEditValue');
    }
    /**
     * Sets the cell value and updates its content with it.
     *
     * @param value
     * The raw value to set. If not provided, it will use the value from the
     * data table for the current row and column.
     *
     * @param updateTable
     * Whether to update the table after setting the content. Defaults to
     * `false`, meaning the table will not be updated.
     */ async setValue(value = this.column.data?.[this.row.index], updateTable = false) {
        this.value = value;
        if (updateTable && await this.updateDataTable()) return;
        if (this.content) this.content.update();
        else this.content = this.column.createCellContent(this);
        this.htmlElement.setAttribute('data-value', this.value + '');
        // Set alignment in column cells based on column data type
        this.htmlElement.classList[this.column.dataType === 'number' ? 'add' : 'remove']((0, $7Tdil.default).getClassName('rightAlign'));
        // Add custom class name from column options
        this.setCustomClassName(this.column.options.cells?.className);
        $3f3e2e7e12bdb1c1$var$fireEvent(this, 'afterRender', {
            target: this
        });
    }
    /**
     * Updates the the data table so that it reflects the current state of
     * the grid.
     *
     * @returns
     * A promise that resolves to `true` if the cell triggered all the whole
     * viewport rows to be updated, or `false` if the only change should be
     * the cell's content.
     */ async updateDataTable() {
        if (this.column.data?.[this.row.index] === this.value) // Abort if the value is the same as in the data table.
        return false;
        const vp = this.column.viewport;
        const { dataTable: originalDataTable } = vp.grid;
        const rowTableIndex = this.row.id && originalDataTable?.getLocalRowIndex(this.row.id);
        if (!originalDataTable || rowTableIndex === void 0) return false;
        this.row.data[this.column.id] = this.value;
        originalDataTable.setCell(this.column.id, rowTableIndex, this.value);
        // If no modifiers, don't update all rows
        if (vp.grid.dataTable === vp.grid.presentationTable) return false;
        await vp.updateRows();
        return true;
    }
    initEvents() {
        this.cellEvents.push([
            'dblclick',
            (e)=>this.onDblClick(e)
        ]);
        this.cellEvents.push([
            'mousedown',
            (e)=>{
                this.onMouseDown(e);
            }
        ]);
        super.initEvents();
    }
    /**
     * Handles the focus event on the cell.
     */ onFocus() {
        super.onFocus();
        const vp = this.row.viewport;
        vp.focusCursor = [
            this.row.index,
            this.column.index
        ];
    }
    /**
     * Handles the mouse down event on the cell.
     *
     * @param e
     * The mouse event object.
     *
     * @internal
     */ onMouseDown(e) {
        if (e.target === this.htmlElement) this.htmlElement.focus();
        $3f3e2e7e12bdb1c1$var$fireEvent(this, 'mouseDown', {
            target: this,
            originalEvent: e
        });
    }
    onMouseOver() {
        this.row.viewport.grid.hoverRow(this.row.index);
        super.onMouseOver();
    }
    onMouseOut() {
        this.row.viewport.grid.hoverRow();
        super.onMouseOut();
    }
    /**
     * Handles the double click event on the cell.
     *
     * @param e
     * The mouse event object.
     */ onDblClick(e) {
        $3f3e2e7e12bdb1c1$var$fireEvent(this, 'dblClick', {
            target: this,
            originalEvent: e
        });
    }
    onClick() {
        $3f3e2e7e12bdb1c1$var$fireEvent(this, 'click', {
            target: this
        });
    }
    /**
     * Handles the key down event on the cell.
     *
     * @param e
     * Keyboard event object.
     *
     * @internal
     */ onKeyDown(e) {
        if (e.target !== this.htmlElement) return;
        $3f3e2e7e12bdb1c1$var$fireEvent(this, 'keyDown', {
            target: this,
            originalEvent: e
        });
        super.onKeyDown(e);
    }
    /**
     * Destroys the cell.
     */ destroy() {
        this.content?.destroy();
        delete this.content;
        super.destroy();
    }
}
var /* *
 *
 *  Default Export
 *
 * */ $3f3e2e7e12bdb1c1$export$2e2bcd8739ae039 = $3f3e2e7e12bdb1c1$var$TableCell;

});



parcelRegister("aBO4X", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b9434bb653fc006$export$2e2bcd8739ae039);
/* *
 *
 *  Grid Columns Resizer class.
 *
 *  (c) 2020-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Dawid Dragula
 *  - Sebastian Bochan
 *
 * */ 
var $1I1ai = parcelRequire("1I1ai");

var $7Tdil = parcelRequire("7Tdil");

var $l3aRA = parcelRequire("l3aRA");
'use strict';
const { makeHTMLElement: $7b9434bb653fc006$var$makeHTMLElement } = (0, $1I1ai.default);
const { fireEvent: $7b9434bb653fc006$var$fireEvent } = (0, $l3aRA.default);
/* *
 *
 *  Class
 *
 * */ /**
 * The class that handles the resizing of columns in the data grid.
 */ class $7b9434bb653fc006$var$ColumnsResizer {
    /* *
     *
     *  Constructor
     *
     * */ constructor(viewport){
        /**
         * Any column is being resized. Turned off after slight delay.
         */ this.isResizing = false;
        /**
         * The handles and their mouse down event listeners.
         */ this.handles = [];
        /**
         * Handles the mouse move event on the document.
         *
         * @param e
         * The mouse event.
         *
         * @internal
         */ this.onDocumentMouseMove = (e)=>{
            if (!this.draggedResizeHandle || !this.draggedColumn) return;
            const diff = e.pageX - (this.dragStartX || 0);
            const vp = this.viewport;
            vp.columnResizing.resize(this, diff);
            vp.reflow();
            vp.rowsVirtualizer.adjustRowHeights();
            $7b9434bb653fc006$var$fireEvent(this.draggedColumn, 'afterResize', {
                target: this.draggedColumn,
                originalEvent: e
            });
        };
        /**
         * Handles the mouse up event on the document.
         */ this.onDocumentMouseUp = ()=>{
            this.draggedColumn?.header?.htmlElement?.classList.remove((0, $7Tdil.default).getClassName('resizedColumn'));
            if (!this.draggedResizeHandle?.matches(':hover')) this.draggedResizeHandle?.classList.remove('hovered');
            this.dragStartX = void 0;
            this.draggedColumn = void 0;
            this.draggedResizeHandle = void 0;
            this.columnStartWidth = void 0;
            this.nextColumnStartWidth = void 0;
            requestAnimationFrame(()=>{
                this.isResizing = false;
            });
        };
        this.viewport = viewport;
        document.addEventListener('mousemove', this.onDocumentMouseMove);
        document.addEventListener('mouseup', this.onDocumentMouseUp);
    }
    /* *
     *
     *  Functions
     *
     * */ /**
     * Render the drag handle for resizing columns.
     *
     * @param column
     * The reference to rendered column
     *
     * @param cell
     * The reference to rendered cell, where hadles should be added
     */ renderColumnDragHandles(column, cell) {
        const vp = column.viewport;
        if (vp.columnsResizer) {
            const handle = $7b9434bb653fc006$var$makeHTMLElement('div', {
                className: (0, $7Tdil.default).getClassName('resizerHandles')
            }, cell.htmlElement);
            handle.setAttribute('aria-hidden', true);
            vp.columnsResizer?.addHandleListeners(handle, column);
        }
    }
    /**
     * Adds event listeners to the handle.
     *
     * @param handle
     * The handle element.
     *
     * @param column
     * The column the handle belongs to.
     */ addHandleListeners(handle, column) {
        const onHandleMouseDown = (e)=>{
            const vp = column.viewport;
            this.isResizing = true;
            handle.classList.add('hovered');
            vp.reflow();
            this.dragStartX = e.pageX;
            this.draggedColumn = column;
            this.draggedResizeHandle = handle;
            this.columnStartWidth = column.getWidth();
            this.nextColumnStartWidth = vp.columns[column.index + 1]?.getWidth();
            column.header?.htmlElement.classList.add((0, $7Tdil.default).getClassName('resizedColumn'));
        };
        const onHandleMouseOver = ()=>{
            if (this.draggedResizeHandle) return;
            handle.classList.add('hovered');
        };
        const onHandleMouseOut = ()=>{
            if (this.draggedResizeHandle) return;
            handle.classList.remove('hovered');
        };
        const handleListeners = [
            {
                eventName: 'mousedown',
                listener: onHandleMouseDown
            },
            {
                eventName: 'mouseover',
                listener: onHandleMouseOver
            },
            {
                eventName: 'mouseout',
                listener: onHandleMouseOut
            }
        ];
        for (const { eventName: eventName, listener: listener } of handleListeners)handle.addEventListener(eventName, listener);
        this.handles.push([
            handle,
            handleListeners
        ]);
    }
    /**
     * Removes all added event listeners from the document and handles. This
     * should be called on the destroy of the data grid.
     */ removeEventListeners() {
        document.removeEventListener('mousemove', this.onDocumentMouseMove);
        document.removeEventListener('mouseup', this.onDocumentMouseUp);
        for(let i = 0, iEnd = this.handles.length; i < iEnd; i++){
            const [handle, listeners] = this.handles[i];
            for (const { eventName: eventName, listener: listener } of listeners)handle.removeEventListener(eventName, listener);
        }
    }
}
var /* *
 *
 *  Default Export
 *
 * */ $7b9434bb653fc006$export$2e2bcd8739ae039 = $7b9434bb653fc006$var$ColumnsResizer;

});


parcelRegister("2JK0A", function(module, exports) {

$parcel$export(module.exports, "default", () => $1fe3790bbf8de5c2$export$2e2bcd8739ae039);
/* *
 *
 *  Grid Querying Controller class
 *
 *  (c) 2020-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Dawid Dragula
 *
 * */ 
var $2pvlc = parcelRequire("2pvlc");

var $fq3e5 = parcelRequire("fq3e5");

var $26JVj = parcelRequire("26JVj");

var $f54h0 = parcelRequire("f54h0");
'use strict';
/* *
 *
 *  Class
 *
 * */ /**
 * Class that manage data modification of the visible data in the data grid.
 * It manages the modifiers that are applied to the data table.
 */ class $1fe3790bbf8de5c2$var$QueryingController {
    /* *
    *
    *  Constructor
    *
    * */ constructor(grid){
        /**
         * This flag should be set to `true` if the modifiers should reapply to the
         * data table due to some data change or other important reason.
         */ this.shouldBeUpdated = false;
        this.grid = grid;
        this.filtering = new (0, $26JVj.default)(this);
        this.sorting = new (0, $fq3e5.default)(this);
        this.pagination = new (0, $f54h0.default)(this);
    }
    /* *
    *
    *  Functions
    *
    * */ /**
     * Proceeds with the data modification if needed.
     *
     * @param force
     * If the data should be modified even if the significant options are not
     * changed.
     */ async proceed(force = false) {
        if (force || this.shouldBeUpdated) await this.modifyData();
    }
    /**
     * Load all options needed to generate the modifiers.
     */ loadOptions() {
        this.filtering.loadOptions();
        this.sorting.loadOptions();
        this.pagination.loadOptions();
    }
    /**
     * Creates a list of modifiers that should be applied to the data table.
     */ willNotModify() {
        return !this.sorting.modifier && !this.filtering.modifier;
    }
    /**
     * Returns a list of modifiers that should be applied to the data table.
     */ getGroupedModifiers() {
        const modifiers = [];
        if (this.sorting.modifier) modifiers.push(this.sorting.modifier);
        if (this.filtering.modifier) modifiers.push(this.filtering.modifier);
        return modifiers;
    }
    /**
     * Apply all modifiers to the data table.
     */ async modifyData() {
        const originalDataTable = this.grid.dataTable;
        if (!originalDataTable) return;
        const groupedModifiers = this.getGroupedModifiers();
        let interTable;
        // Grouped modifiers
        if (groupedModifiers.length > 0) {
            const chainModifier = new (0, $2pvlc.default)({}, ...groupedModifiers);
            const dataTableCopy = originalDataTable.clone();
            await chainModifier.modify(dataTableCopy.getModified());
            interTable = dataTableCopy.getModified();
        } else interTable = originalDataTable.getModified();
        // Pagination modifier
        const paginationModifier = this.pagination.createModifier(interTable.rowCount);
        if (paginationModifier) {
            interTable = interTable.clone();
            await paginationModifier.modify(interTable);
            interTable = interTable.getModified();
        }
        this.grid.presentationTable = interTable;
        this.shouldBeUpdated = false;
    }
}
var /* *
 *
 *  Default Export
 *
 * */ $1fe3790bbf8de5c2$export$2e2bcd8739ae039 = $1fe3790bbf8de5c2$var$QueryingController;

});
parcelRegister("2pvlc", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c163a3438b98341$export$2e2bcd8739ae039);
/* *
 *
 *  (c) 2009-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Sophie Bremer
 *  - Dawid Dragula
 *
 * */ 
var $7fvOS = parcelRequire("7fvOS");

var $l3aRA = parcelRequire("l3aRA");
'use strict';
const { addEvent: $1c163a3438b98341$var$addEvent, fireEvent: $1c163a3438b98341$var$fireEvent, merge: $1c163a3438b98341$var$merge } = (0, $l3aRA.default);
/* *
 *
 *  Class
 *
 * */ /**
 * Modifies a table with the help of modifiers in an ordered chain.
 *
 */ class $1c163a3438b98341$var$ChainModifier extends (0, $7fvOS.default) {
    /* *
     *
     *  Constructor
     *
     * */ /**
     * Constructs an instance of the modifier chain.
     *
     * @param {Partial<ChainModifier.Options>} [options]
     * Options to configure the modifier chain.
     *
     * @param {...DataModifier} [chain]
     * Ordered chain of modifiers.
     */ constructor(options, ...chain){
        super();
        this.chain = chain;
        this.options = $1c163a3438b98341$var$merge($1c163a3438b98341$var$ChainModifier.defaultOptions, options);
        const optionsChain = this.options.chain || [];
        for(let i = 0, iEnd = optionsChain.length, modifierOptions, ModifierClass; i < iEnd; ++i){
            modifierOptions = optionsChain[i];
            if (!modifierOptions.type) continue;
            ModifierClass = (0, $7fvOS.default).types[modifierOptions.type];
            if (ModifierClass) chain.push(new ModifierClass(modifierOptions));
        }
    }
    /* *
     *
     *  Functions
     *
     * */ /**
     * Adds a configured modifier to the end of the modifier chain. Please note,
     * that the modifier can be added multiple times.
     *
     * @param {DataModifier} modifier
     * Configured modifier to add.
     *
     * @param {DataEvent.Detail} [eventDetail]
     * Custom information for pending events.
     */ add(modifier, eventDetail) {
        this.emit({
            type: 'addModifier',
            detail: eventDetail,
            modifier: modifier
        });
        this.chain.push(modifier);
        this.emit({
            type: 'addModifier',
            detail: eventDetail,
            modifier: modifier
        });
    }
    /**
     * Clears all modifiers from the chain.
     *
     * @param {DataEvent.Detail} [eventDetail]
     * Custom information for pending events.
     */ clear(eventDetail) {
        this.emit({
            type: 'clearChain',
            detail: eventDetail
        });
        this.chain.length = 0;
        this.emit({
            type: 'afterClearChain',
            detail: eventDetail
        });
    }
    /**
     * Sequentially applies all modifiers in the chain to the given table,
     * updating its `modified` property with the final result.
     *
     * *Note:* The `modified` property reference of the table gets replaced.
     *
     * @param {Highcharts.DataTable} table
     * Table to modify.
     *
     * @param {DataEvent.Detail} [eventDetail]
     * Custom information for pending events.
     *
     * @return {Promise<Highcharts.DataTable>}
     * Table with `modified` property as a reference.
     */ async modify(table, eventDetail) {
        const modifiers = this.options.reverse ? this.chain.slice().reverse() : this.chain.slice();
        if (!table.modified) table.modified = table.clone(false, eventDetail);
        let modified = table;
        for(let i = 0, iEnd = modifiers.length; i < iEnd; ++i){
            try {
                await modifiers[i].modify(modified, eventDetail);
            } catch (error) {
                this.emit({
                    type: 'error',
                    detail: eventDetail,
                    table: table
                });
                throw error;
            }
            modified = modified.getModified();
        }
        table.modified = modified;
        return table;
    }
    /**
     * Applies several modifications to the table.
     *
     * *Note:* The `modified` property reference of the table gets replaced.
     *
     * @param {DataTable} table
     * Table to modify.
     *
     * @param {DataEvent.Detail} [eventDetail]
     * Custom information for pending events.
     *
     * @return {DataTable}
     * Table as a reference.
     *
     * @emits ChainDataModifier#execute
     * @emits ChainDataModifier#afterExecute
     */ modifyTable(table, eventDetail) {
        const chain = this;
        chain.emit({
            type: 'modify',
            detail: eventDetail,
            table: table
        });
        const modifiers = chain.options.reverse ? chain.chain.reverse() : chain.chain.slice();
        let modified = table.getModified();
        for(let i = 0, iEnd = modifiers.length, modifier; i < iEnd; ++i){
            modifier = modifiers[i];
            modified = modifier.modifyTable(modified, eventDetail).getModified();
        }
        table.modified = modified;
        chain.emit({
            type: 'afterModify',
            detail: eventDetail,
            table: table
        });
        return table;
    }
    /**
     * Removes a configured modifier from all positions in the modifier chain.
     *
     * @param {DataModifier} modifier
     * Configured modifier to remove.
     *
     * @param {DataEvent.Detail} [eventDetail]
     * Custom information for pending events.
     */ remove(modifier, eventDetail) {
        const modifiers = this.chain;
        this.emit({
            type: 'removeModifier',
            detail: eventDetail,
            modifier: modifier
        });
        modifiers.splice(modifiers.indexOf(modifier), 1);
        this.emit({
            type: 'afterRemoveModifier',
            detail: eventDetail,
            modifier: modifier
        });
    }
    emit(e) {
        $1c163a3438b98341$var$fireEvent(this, e.type, e);
    }
    on(type, callback) {
        return $1c163a3438b98341$var$addEvent(this, type, callback);
    }
}
/* *
 *
 *  Static Properties
 *
 * */ /**
 * Default option for the ordered modifier chain.
 */ $1c163a3438b98341$var$ChainModifier.defaultOptions = {
    type: 'Chain'
};
(0, $7fvOS.default).registerType('Chain', $1c163a3438b98341$var$ChainModifier);
var /* *
 *
 *  Default Export
 *
 * */ $1c163a3438b98341$export$2e2bcd8739ae039 = $1c163a3438b98341$var$ChainModifier;

});

parcelRegister("fq3e5", function(module, exports) {

$parcel$export(module.exports, "default", () => $b39bc96080f75cf8$export$2e2bcd8739ae039);
/* *
 *
 *  Grid Sorting Controller class
 *
 *  (c) 2020-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Dawid Dragula
 *
 * */ 
var $in0Rk = parcelRequire("in0Rk");
'use strict';
/* *
 *
 *  Class
 *
 * */ /**
 * Class that manages one of the data grid querying types - sorting.
 */ class $b39bc96080f75cf8$var$SortingController {
    /* *
    *
    *  Constructor
    *
    * */ /**
     * Constructs the SortingController instance.
     *
     * @param querying
     * The querying controller instance.
     */ constructor(querying){
        this.querying = querying;
    }
    /* *
    *
    *  Functions
    *
    * */ /**
     * Sets the sorting state. If the new sorting state is different than the
     * current one, the `shouldBeUpdated` flag is set to `true`. If the
     * same, the flag is set to `false`.
     *
     * @param order
     * The sorting order.
     *
     * @param columnId
     * The column ID to sort by.
     */ setSorting(order, columnId) {
        if (this.currentSorting?.columnId !== columnId || this.currentSorting?.order !== order) {
            this.querying.shouldBeUpdated = true;
            this.currentSorting = {
                columnId: columnId,
                order: order
            };
        }
        this.modifier = this.createModifier();
    }
    /**
     * Returns the sorting options from the data grid options.
     */ getSortingOptions() {
        const grid = this.querying.grid, { columnOptionsMap: columnOptionsMap } = grid;
        if (!columnOptionsMap) return {
            order: null
        };
        const columnIDs = Object.keys(columnOptionsMap);
        let foundOrder = null;
        let foundColumnId;
        for(let i = columnIDs.length - 1; i > -1; --i){
            const columnId = columnIDs[i];
            const columnOptions = columnOptionsMap[columnId]?.options || {};
            const order = columnOptions.sorting?.order;
            if (order) {
                if (foundColumnId) {
                    // eslint-disable-next-line no-console
                    console.warn("Grid: Only one column can be sorted at a time. Data will be sorted only by the last found column " + `with the sorting order defined in the options: "${foundColumnId}".`);
                    break;
                }
                foundOrder = order;
                foundColumnId = columnId;
            }
        }
        return {
            columnId: foundColumnId,
            order: foundOrder
        };
    }
    /**
     * Loads sorting options from the data grid options.
     */ loadOptions() {
        const stateFromOptions = this.getSortingOptions();
        if (stateFromOptions.columnId !== this.currentSorting?.columnId || stateFromOptions.order !== this.currentSorting?.order) this.setSorting(stateFromOptions.order, stateFromOptions.columnId);
    }
    /**
     * Returns the sorting modifier based on the loaded sorting options.
     */ createModifier() {
        if (!this.currentSorting) return;
        const { columnId: columnId, order: order } = this.currentSorting;
        if (!order || !columnId) return;
        const grid = this.querying.grid;
        return new (0, $in0Rk.default)({
            orderByColumn: columnId,
            direction: order,
            compare: grid.columnOptionsMap?.[columnId]?.options?.sorting?.compare || grid.options?.columnDefaults?.sorting?.compare
        });
    }
}
var /* *
 *
 *  Default Export
 *
 * */ $b39bc96080f75cf8$export$2e2bcd8739ae039 = $b39bc96080f75cf8$var$SortingController;

});
parcelRegister("in0Rk", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5fb0a9aa95cbec4$export$2e2bcd8739ae039);
/* *
 *
 *  (c) 2009-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Sophie Bremer
 *  - Dawid Dragula
 *
 * */ 
var $7fvOS = parcelRequire("7fvOS");

var $l3aRA = parcelRequire("l3aRA");
'use strict';
const { merge: $d5fb0a9aa95cbec4$var$merge } = (0, $l3aRA.default);
/* *
 *
 *  Class
 *
 * */ /**
 * Sort table rows according to values of a column.
 *
 */ class $d5fb0a9aa95cbec4$var$SortModifier extends (0, $7fvOS.default) {
    /* *
     *
     *  Static Functions
     *
     * */ static ascending(a, b) {
        return (a || 0) < (b || 0) ? -1 : (a || 0) > (b || 0) ? 1 : 0;
    }
    static descending(a, b) {
        return (b || 0) < (a || 0) ? -1 : (b || 0) > (a || 0) ? 1 : 0;
    }
    static compareFactory(direction, customCompare) {
        if (customCompare) {
            if (direction === 'desc') return (a, b)=>-customCompare(a, b);
            return customCompare;
        }
        return direction === 'asc' ? $d5fb0a9aa95cbec4$var$SortModifier.ascending : $d5fb0a9aa95cbec4$var$SortModifier.descending;
    }
    /* *
     *
     *  Constructor
     *
     * */ /**
     * Constructs an instance of the sort modifier.
     *
     * @param {Partial<SortDataModifier.Options>} [options]
     * Options to configure the sort modifier.
     */ constructor(options){
        super();
        this.options = $d5fb0a9aa95cbec4$var$merge($d5fb0a9aa95cbec4$var$SortModifier.defaultOptions, options);
    }
    /* *
     *
     *  Functions
     *
     * */ /**
     * Returns index and row for sort reference.
     *
     * @private
     *
     * @param {Highcharts.DataTable} table
     * Table with rows to reference.
     *
     * @return {Array<SortModifier.RowReference>}
     * Array of row references.
     */ getRowReferences(table) {
        const rows = table.getRows(), rowReferences = [];
        for(let i = 0, iEnd = rows.length; i < iEnd; ++i)rowReferences.push({
            index: i,
            row: rows[i]
        });
        return rowReferences;
    }
    modifyTable(table, eventDetail) {
        const modifier = this;
        modifier.emit({
            type: 'modify',
            detail: eventDetail,
            table: table
        });
        const columnIds = table.getColumnIds(), rowCount = table.getRowCount(), rowReferences = this.getRowReferences(table), { direction: direction, orderByColumn: orderByColumn, orderInColumn: orderInColumn, compare: customCompare } = modifier.options, compare = $d5fb0a9aa95cbec4$var$SortModifier.compareFactory(direction, customCompare), orderByColumnIndex = columnIds.indexOf(orderByColumn), modified = table.getModified();
        if (orderByColumnIndex !== -1) rowReferences.sort((a, b)=>compare(a.row[orderByColumnIndex], b.row[orderByColumnIndex]));
        if (orderInColumn) {
            const column = [];
            for(let i = 0; i < rowCount; ++i)column[rowReferences[i].index] = i;
            modified.setColumns({
                [orderInColumn]: column
            });
        } else {
            const originalIndexes = [];
            const rows = [];
            let rowReference;
            for(let i = 0; i < rowCount; ++i){
                rowReference = rowReferences[i];
                originalIndexes.push(table.getOriginalRowIndex(rowReference.index));
                rows.push(rowReference.row);
            }
            modified.setRows(rows, 0);
            modified.setOriginalRowIndexes(originalIndexes);
        }
        modifier.emit({
            type: 'afterModify',
            detail: eventDetail,
            table: table
        });
        return table;
    }
}
/* *
 *
 *  Static Properties
 *
 * */ /**
 * Default options to group table rows.
 */ $d5fb0a9aa95cbec4$var$SortModifier.defaultOptions = {
    type: 'Sort',
    direction: 'desc',
    orderByColumn: 'y'
};
(0, $7fvOS.default).registerType('Sort', $d5fb0a9aa95cbec4$var$SortModifier);
var /* *
 *
 *  Default Export
 *
 * */ $d5fb0a9aa95cbec4$export$2e2bcd8739ae039 = $d5fb0a9aa95cbec4$var$SortModifier;

});


parcelRegister("26JVj", function(module, exports) {

$parcel$export(module.exports, "default", () => $188fc3c28a71dcef$export$2e2bcd8739ae039);
/* *
 *
 *  Grid Filtering Controller class
 *
 *  (c) 2020-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Dawid Dragula
 *
 * */ 
var $e5SH1 = parcelRequire("e5SH1");

var $l3aRA = parcelRequire("l3aRA");
'use strict';
const { isString: $188fc3c28a71dcef$var$isString } = (0, $l3aRA.default);
/* *
 *
 *  Class
 *
 * */ /**
 * Class that manages one of the data grid querying types - filtering.
 */ class $188fc3c28a71dcef$var$FilteringController {
    /* *
    *
    *  Constructor
    *
    * */ /**
     * Constructs the FilteringController instance.
     *
     * @param querying
     * The querying controller instance.
     */ constructor(querying){
        /**
         * A map of the filtering conditions for each column.
         */ this.columnConditions = {};
        this.querying = querying;
    }
    /* *
    *
    *  Functions
    *
    * */ /**
     * Maps filtering options to the filtering condition.
     *
     * @param columnId
     * Id of the column to filter.
     *
     * @param options
     * Filtering options.
     */ static mapOptionsToFilter(columnId, options) {
        const { condition: condition, value: value } = options;
        const isStringValue = $188fc3c28a71dcef$var$isString(value);
        const stringifiedValue = isStringValue ? value : '';
        const nonValueConditions = [
            'empty',
            'notEmpty',
            'true',
            'false'
        ];
        if ((typeof value === 'undefined' || isStringValue && !stringifiedValue) && !nonValueConditions.includes(condition ?? '')) return;
        switch(condition){
            case 'contains':
                return {
                    columnId: columnId,
                    operator: 'contains',
                    value: stringifiedValue
                };
            case 'doesNotContain':
                return {
                    operator: 'not',
                    condition: {
                        columnId: columnId,
                        operator: 'contains',
                        value: stringifiedValue
                    }
                };
            case 'equals':
                return {
                    columnId: columnId,
                    operator: '===',
                    value: value
                };
            case 'doesNotEqual':
                return {
                    columnId: columnId,
                    operator: '!==',
                    value: value
                };
            case 'beginsWith':
                return {
                    columnId: columnId,
                    operator: 'startsWith',
                    value: stringifiedValue
                };
            case 'endsWith':
                return {
                    columnId: columnId,
                    operator: 'endsWith',
                    value: stringifiedValue
                };
            case 'greaterThan':
                return {
                    columnId: columnId,
                    operator: '>',
                    value: value
                };
            case 'greaterThanOrEqualTo':
                return {
                    columnId: columnId,
                    operator: '>=',
                    value: value
                };
            case 'lessThan':
                return {
                    columnId: columnId,
                    operator: '<',
                    value: value
                };
            case 'lessThanOrEqualTo':
                return {
                    columnId: columnId,
                    operator: '<=',
                    value: value
                };
            case 'before':
                return {
                    columnId: columnId,
                    operator: '<',
                    value: value
                };
            case 'after':
                return {
                    columnId: columnId,
                    operator: '>',
                    value: value
                };
            case 'empty':
                return {
                    columnId: columnId,
                    operator: 'empty',
                    value: value
                };
            case 'notEmpty':
                return {
                    operator: 'not',
                    condition: {
                        columnId: columnId,
                        operator: 'empty',
                        value: value
                    }
                };
            case 'true':
                return {
                    columnId: columnId,
                    operator: '===',
                    value: true
                };
            case 'false':
                return {
                    columnId: columnId,
                    operator: '===',
                    value: false
                };
        }
    }
    /**
     * Loads filtering options from the data grid options.
     */ loadOptions() {
        const columnOptionsMap = this.querying.grid.columnOptionsMap;
        const newConditions = {};
        if (columnOptionsMap) {
            const columnIds = Object.keys(columnOptionsMap);
            for(let i = 0, iEnd = columnIds.length; i < iEnd; ++i){
                const columnId = columnIds[i];
                const filteringOptions = columnOptionsMap[columnId]?.options?.filtering;
                if (!filteringOptions) continue;
                const condition = $188fc3c28a71dcef$var$FilteringController.mapOptionsToFilter(columnId, filteringOptions);
                if (condition) newConditions[columnId] = condition;
            }
        }
        this.columnConditions = newConditions;
        this.updateModifier();
    }
    /**
     * Adds a new filtering condition to the specified column.
     *
     * @param columnId
     * The column ID to filter in.
     *
     * @param options
     * The filtering options.
     */ addColumnFilterCondition(columnId, options) {
        const condition = $188fc3c28a71dcef$var$FilteringController.mapOptionsToFilter(columnId, options);
        if (condition) this.columnConditions[columnId] = condition;
        else delete this.columnConditions[columnId];
        this.updateModifier();
    }
    /**
     * Clears the filtering condition for the specified column. If no column ID
     * is provided, clears all the column filtering conditions.
     *
     * @param columnId
     * The column ID to clear or `undefined` to clear all the column filtering
     * conditions.
     */ clearColumnFiltering(columnId) {
        if (!columnId) this.columnConditions = {};
        else delete this.columnConditions[columnId];
        this.updateModifier();
    }
    /**
     * Updates the modifier based on the current column conditions.
     */ updateModifier() {
        const columnConditions = Object.values(this.columnConditions);
        this.querying.shouldBeUpdated = true;
        if (columnConditions.length < 1) {
            delete this.modifier;
            return;
        }
        this.modifier = new (0, $e5SH1.default)({
            condition: {
                operator: 'and',
                conditions: columnConditions
            }
        });
    }
}
var /* *
 *
 *  Default Export
 *
 * */ $188fc3c28a71dcef$export$2e2bcd8739ae039 = $188fc3c28a71dcef$var$FilteringController;

});
parcelRegister("e5SH1", function(module, exports) {

$parcel$export(module.exports, "default", () => $a42bf5355e3dad84$export$2e2bcd8739ae039);
/* *
 *
 *  (c) 2009-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Dawid Dragula
 *
 * */ 
var $7fvOS = parcelRequire("7fvOS");

var $l3aRA = parcelRequire("l3aRA");
'use strict';
const { isFunction: $a42bf5355e3dad84$var$isFunction, merge: $a42bf5355e3dad84$var$merge } = (0, $l3aRA.default);
/* *
 *
 *  Class
 *
 * */ /**
 * Filters out table rows matching a given condition.
 */ class $a42bf5355e3dad84$var$FilterModifier extends (0, $7fvOS.default) {
    /* *
     *
     *  Static Functions
     *
     * */ /**
     * Compiles a filter condition into a callback function.
     *
     * @param {FilterCondition} condition
     * Condition to compile.
     */ static compile(condition) {
        if ($a42bf5355e3dad84$var$isFunction(condition)) return condition;
        const op = condition.operator;
        switch(op){
            case 'and':
                {
                    const subs = condition.conditions.map((c)=>this.compile(c));
                    return (row, table, i)=>subs.every((cond)=>cond(row, table, i));
                }
            case 'or':
                {
                    const subs = condition.conditions.map((c)=>this.compile(c));
                    return (row, table, i)=>subs.some((cond)=>cond(row, table, i));
                }
            case 'not':
                {
                    const sub = this.compile(condition.condition);
                    return (row, table, i)=>!sub(row, table, i);
                }
        }
        const { columnId: col, value: value } = condition;
        switch(op){
            case '==':
                // eslint-disable-next-line eqeqeq
                return (row)=>row[col] == value;
            case '===':
                return (row)=>row[col] === value;
            case '!=':
                // eslint-disable-next-line eqeqeq
                return (row)=>row[col] != value;
            case '!==':
                return (row)=>row[col] !== value;
            case '>':
                return (row)=>(row[col] || 0) > (value || 0);
            case '>=':
                return (row)=>(row[col] || 0) >= (value || 0);
            case '<':
                return (row)=>(row[col] || 0) < (value || 0);
            case '<=':
                return (row)=>(row[col] || 0) <= (value || 0);
            case 'empty':
                return (row)=>row[col] === null || row[col] === '';
        }
        const { ignoreCase: ignoreCase } = condition;
        const str = (val)=>{
            const s = '' + val;
            return ignoreCase ?? true ? s.toLowerCase() : s;
        };
        switch(op){
            case 'contains':
                return (row)=>str(row[col]).includes(str(value));
            default:
                return (row)=>str(row[col])[op](str(value));
        }
    }
    /* *
     *
     *  Constructor
     *
     * */ /**
     * Constructs an instance of the filter modifier.
     *
     * @param {Partial<FilterModifier.Options>} [options]
     * Options to configure the filter modifier.
     */ constructor(options){
        super();
        this.options = $a42bf5355e3dad84$var$merge($a42bf5355e3dad84$var$FilterModifier.defaultOptions, options);
    }
    /* *
     *
     *  Functions
     *
     * */ /**
     * Filters out table rows matching a given condition. If the given table
     * does not have defined a `modified` property, the filtering is applied
     * in-place on the original table rather than on a `modified` copy.
     *
     * @param {DataTable} table
     * Table to modify.
     *
     * @param {DataEvent.Detail} [eventDetail]
     * Custom information for pending events.
     *
     * @return {DataTable}
     * Table with `modified` property as a reference or modified table, if
     * `modified` property of the original table is undefined.
     */ modifyTable(table, eventDetail) {
        const modifier = this;
        modifier.emit({
            type: 'modify',
            detail: eventDetail,
            table: table
        });
        const { condition: condition } = modifier.options;
        if (!condition) // If no condition is set, return the unmodified table.
        return table;
        const matchRow = $a42bf5355e3dad84$var$FilterModifier.compile(condition);
        const modified = table.getModified();
        const rows = [];
        const indexes = [];
        for(let i = 0, iEnd = table.getRowCount(); i < iEnd; ++i){
            const row = table.getRowObject(i);
            if (!row) continue;
            if (matchRow(row, table, i)) {
                rows.push(row);
                indexes.push(table.getOriginalRowIndex(i));
            }
        }
        modified.deleteRows();
        modified.setRows(rows);
        modified.setOriginalRowIndexes(indexes);
        modifier.emit({
            type: 'afterModify',
            detail: eventDetail,
            table: table
        });
        return table;
    }
}
/* *
 *
 *  Static Properties
 *
 * */ /**
 * Default options for the filter modifier.
 */ $a42bf5355e3dad84$var$FilterModifier.defaultOptions = {
    type: 'Filter'
};
(0, $7fvOS.default).registerType('Filter', $a42bf5355e3dad84$var$FilterModifier);
var /* *
 *
 *  Default Export
 *
 * */ $a42bf5355e3dad84$export$2e2bcd8739ae039 = $a42bf5355e3dad84$var$FilterModifier;

});


parcelRegister("f54h0", function(module, exports) {

$parcel$export(module.exports, "default", () => $afaaa34180417054$export$2e2bcd8739ae039);
/* *
 *
 *  Grid Pagination Controller class
 *
 *  (c) 2020-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Sebastian Bochan
 *
 * */ 
var $f9g5d = parcelRequire("f9g5d");
'use strict';
/* *
 *
 *  Class
 *
 * */ /**
 * Class that manages one of the data grid querying types - pagination.
 */ class $afaaa34180417054$var$PaginationController {
    /* *
    *
    *  Constructor
    *
    * */ /**
     * Constructs the PaginationController instance.
     *
     * @param querying
     * The querying controller instance.
     */ constructor(querying){
        /**
         * The current page (1-based index).
         */ this.currentPage = 1;
        /**
         * The current page size.
         */ this.currentPageSize = 10;
        this.querying = querying;
        this.enabled = !!querying.grid.options?.pagination?.enabled;
    }
    /* *
    *
    *  Functions
    *
    * */ /**
     * Total number of items (rows)
     */ get totalItems() {
        return this._totalItems ?? this.querying.grid.dataTable?.rowCount ?? 0;
    }
    /**
     * Gets the total number of pages.
     */ get totalPages() {
        return this.currentPageSize > 0 ? Math.ceil(this.totalItems / this.currentPageSize) : 1;
    }
    /**
     * Clamps the current page to the total number of pages.
     */ clampPage() {
        if (this.currentPage <= this.totalPages) return;
        this.currentPage = this.totalPages;
        this.querying.shouldBeUpdated = true;
    }
    /**
     * Sets the page.
     *
     * @param currentPage
     * The current page.
     */ setPage(currentPage) {
        this.currentPage = currentPage;
        this.clampPage();
        this.querying.shouldBeUpdated = true;
    }
    /**
     * Sets the page size.
     *
     * @param pageSize
     * The page size.
     */ setPageSize(pageSize) {
        this.currentPageSize = pageSize;
        this.querying.shouldBeUpdated = true;
    }
    /**
     * Loads range options from the grid options.
     */ loadOptions() {
        const options = this.querying.grid.options?.pagination || {};
        if (this.enabled === !options.enabled) {
            this.enabled = !!options.enabled;
            this.querying.shouldBeUpdated = true;
        }
        if (this.currentPageSize !== options.pageSize) this.setPageSize(options.pageSize ?? this.currentPageSize);
        if (this.currentPage !== options.page) this.setPage(options.page ?? this.currentPage);
    }
    /**
     * Returns the range modifier.
     *
     * @param rowsCountBeforePagination
     * The number of rows before pagination. Default is the number of rows in
     * the original data table.
     */ createModifier(rowsCountBeforePagination = this.querying.grid.dataTable?.rowCount || 0) {
        if (!this.enabled) return;
        const currentPage = this.currentPage;
        const pageSize = this.currentPageSize;
        // Calculate the start index (0-based)
        const start = (currentPage - 1) * pageSize;
        const end = Math.min(start + pageSize, rowsCountBeforePagination);
        this._totalItems = rowsCountBeforePagination;
        return new (0, $f9g5d.default)({
            start: start,
            end: end
        });
    }
}
var /* *
 *
 *  Default Export
 *
 * */ $afaaa34180417054$export$2e2bcd8739ae039 = $afaaa34180417054$var$PaginationController;

});
parcelRegister("f9g5d", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0742c134024d1e7$export$2e2bcd8739ae039);
/* *
 *
 *  (c) 2009-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Sophie Bremer
 *  - Dawid Dragula
 *
 * */ 
var $7fvOS = parcelRequire("7fvOS");

var $l3aRA = parcelRequire("l3aRA");
'use strict';
const { merge: $b0742c134024d1e7$var$merge } = (0, $l3aRA.default);
/* *
 *
 *  Class
 *
 * */ /**
 * Slices the table rows based on the specified range.
 */ class $b0742c134024d1e7$var$RangeModifier extends (0, $7fvOS.default) {
    /* *
     *
     *  Constructor
     *
     * */ /**
     * Constructs an instance of the range modifier.
     *
     * @param {Partial<RangeModifier.Options>} [options]
     * Options to configure the range modifier.
     */ constructor(options){
        super();
        this.options = $b0742c134024d1e7$var$merge($b0742c134024d1e7$var$RangeModifier.defaultOptions, options);
    }
    /* *
     *
     *  Functions
     *
     * */ /**
     * Replaces table rows with ranged rows. If the given table does not have
     * defined a `modified` property, the filtering is applied in-place on the
     * original table rather than on a `modified` copy.
     *
     * @param {DataTable} table
     * Table to modify.
     *
     * @param {DataEvent.Detail} [eventDetail]
     * Custom information for pending events.
     *
     * @return {DataTable}
     * Table with `modified` property as a reference or modified table, if
     * `modified` property of the original table is undefined.
     */ modifyTable(table, eventDetail) {
        const modifier = this;
        modifier.emit({
            type: 'modify',
            detail: eventDetail,
            table: table
        });
        let { start: start, end: end } = modifier.options;
        start = Math.max(0, start || 0);
        end = Math.min(end || Infinity, table.getRowCount());
        const length = Math.max(end - start, 0);
        const modified = table.getModified();
        modified.deleteRows();
        modified.setRows(table.getRows(start, length));
        modified.setOriginalRowIndexes(Array.from({
            length: length
        }, (_, i)=>table.getOriginalRowIndex(start + i)));
        modifier.emit({
            type: 'afterModify',
            detail: eventDetail,
            table: table
        });
        return table;
    }
}
/* *
 *
 *  Static Properties
 *
 * */ /**
 * Default options for the range modifier.
 */ $b0742c134024d1e7$var$RangeModifier.defaultOptions = {
    type: 'Range',
    start: 0,
    end: Infinity
};
(0, $7fvOS.default).registerType('Range', $b0742c134024d1e7$var$RangeModifier);
var /* *
 *
 *  Default Export
 *
 * */ $b0742c134024d1e7$export$2e2bcd8739ae039 = $b0742c134024d1e7$var$RangeModifier;

});




parcelRegister("jcnyQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfa16a0e4df29762$export$2e2bcd8739ae039);
/* *
 *
 *  (c) 2009-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Sophie Bremer
 *
 * */ 
var $6GqCF = parcelRequire("6GqCF");

var $l3aRA = parcelRequire("l3aRA");
'use strict';
const { addEvent: $dfa16a0e4df29762$var$addEvent, fireEvent: $dfa16a0e4df29762$var$fireEvent, merge: $dfa16a0e4df29762$var$merge } = (0, $l3aRA.default);
/* *
 *
 *  Class
 *
 * */ /**
 * Data pool to load connectors on-demand.
 *
 * @class
 * @name Data.DataPool
 *
 * @param {DataPoolOptions} options
 * Pool options with all connectors.
 */ class $dfa16a0e4df29762$var$DataPool {
    /* *
     *
     *  Constructor
     *
     * */ constructor(options){
        this.options = $dfa16a0e4df29762$var$merge($dfa16a0e4df29762$var$DataPool.defaultOptions, options);
        this.connectors = {};
        this.waiting = {};
    }
    /* *
     *
     *  Methods
     *
     * */ /**
     * Emits an event on this data pool to all registered callbacks of the given
     * event.
     *
     * @param {DataTable.Event} e
     * Event object with event information.
     */ emit(e) {
        $dfa16a0e4df29762$var$fireEvent(this, e.type, e);
    }
    /**
     * Loads the connector.
     *
     * @function Data.DataPool#getConnector
     *
     * @param {string} connectorId
     * ID of the connector.
     *
     * @return {Promise<Data.DataConnectorType>}
     * Returns the connector.
     */ getConnector(connectorId) {
        const connector = this.connectors[connectorId];
        // Already loaded
        if (connector?.loaded) return Promise.resolve(connector);
        let waitingList = this.waiting[connectorId];
        // Start loading
        if (!waitingList) {
            waitingList = this.waiting[connectorId] = [];
            const connectorOptions = this.getConnectorOptions(connectorId);
            if (!connectorOptions) throw new Error(`Connector '${connectorId}' not found.`);
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.loadConnector(connectorOptions).then((connector)=>{
                delete this.waiting[connectorId];
                for(let i = 0, iEnd = waitingList.length; i < iEnd; ++i)waitingList[i][0](connector);
            })['catch']((error)=>{
                delete this.waiting[connectorId];
                for(let i = 0, iEnd = waitingList.length; i < iEnd; ++i)waitingList[i][1](error);
            });
        }
        // Add request to waiting list
        return new Promise((resolve, reject)=>{
            waitingList.push([
                resolve,
                reject
            ]);
        });
    }
    /**
     * Returns the IDs of all connectors.
     *
     * @private
     *
     * @return {Array<string>}
     * Names of all connectors.
     */ getConnectorIds() {
        const connectors = this.options.connectors, connectorIds = [];
        for(let i = 0, iEnd = connectors.length; i < iEnd; ++i)connectorIds.push(connectors[i].id);
        return connectorIds;
    }
    /**
     * Loads the options of the connector.
     *
     * @private
     *
     * @param {string} connectorId
     * ID of the connector.
     *
     * @return {DataConnectorTypeOptions | undefined}
     * Returns the options of the connector, or `undefined` if not found.
     */ getConnectorOptions(connectorId) {
        const connectors = this.options.connectors;
        for(let i = 0, iEnd = connectors.length; i < iEnd; ++i){
            if (connectors[i].id === connectorId) return connectors[i];
        }
    }
    /**
     * Tests whether the connector has never been requested.
     *
     * @param {string} connectorId
     * Name of the connector.
     *
     * @return {boolean}
     * Returns `true`, if the connector has never been requested, otherwise
     * `false`.
     */ isNewConnector(connectorId) {
        return !this.connectors[connectorId];
    }
    /**
     * Instantiates the connector class for the given options and loads its
     * data.
     *
     * @private
     *
     * @param {Data.DataPoolConnectorOptions} options
     * Options of connector.
     *
     * @return {Promise<Data.DataConnectorType>}
     * Returns the connector.
     */ loadConnector(options) {
        return new Promise((resolve, reject)=>{
            this.emit({
                type: 'load',
                options: options
            });
            const ConnectorClass = (0, $6GqCF.default).types[options.type];
            if (!ConnectorClass) throw new Error(`Connector type not found. (${options.type})`);
            const connector = this.connectors[options.id] = new ConnectorClass(options);
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            connector.load().then(({ converter: converter })=>{
                connector.converter = converter;
                connector.loaded = true;
                this.emit({
                    type: 'afterLoad',
                    options: options
                });
                resolve(connector);
            })['catch'](reject);
        });
    }
    /**
     * Cancels all data connectors pending requests.
     */ cancelPendingRequests() {
        const { connectors: connectors } = this;
        for (const connectorKey of Object.keys(connectors))connectors[connectorKey].stopPolling();
    }
    /**
     * Registers a callback for a specific event.
     *
     * @function Highcharts.DataPool#on
     *
     * @param {string} type
     * Event type as a string.
     *
     * @param {Highcharts.EventCallbackFunction<Highcharts.DataPool>} callback
     * Function to register for an event callback.
     *
     * @return {Function}
     * Function to unregister callback from the event.
     */ on(type, callback) {
        return $dfa16a0e4df29762$var$addEvent(this, type, callback);
    }
    /**
     * Sets connector options under the specified `options.id`.
     *
     * @param options
     * Connector options to set.
     */ setConnectorOptions(options) {
        const connectorsOptions = this.options.connectors;
        const connectorsInstances = this.connectors;
        this.emit({
            type: 'setConnectorOptions',
            options: options
        });
        for(let i = 0, iEnd = connectorsOptions.length; i < iEnd; ++i)if (connectorsOptions[i].id === options.id) {
            connectorsOptions.splice(i, 1);
            break;
        }
        // TODO: Check if can be refactored
        if (connectorsInstances[options.id]) {
            connectorsInstances[options.id].stopPolling();
            delete connectorsInstances[options.id];
        }
        connectorsOptions.push(options);
        this.emit({
            type: 'afterSetConnectorOptions',
            options: options
        });
    }
}
/* *
 *
 *  Static Properties
 *
 * */ $dfa16a0e4df29762$var$DataPool.defaultOptions = {
    connectors: []
};
var /* *
 *
 *  Default Export
 *
 * */ $dfa16a0e4df29762$export$2e2bcd8739ae039 = $dfa16a0e4df29762$var$DataPool;

});

parcelRegister("cRqRU", function(module, exports) {

$parcel$export(module.exports, "default", () => $95cf46cfaa746602$export$2e2bcd8739ae039);
/* *
 *
 *  Grid Credits class
 *
 *  (c) 2020-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Sebastian Bochan
 *
 * */ 
var $30Vhv = parcelRequire("30Vhv");

var $3OZLm = parcelRequire("3OZLm");

var $l3aRA = parcelRequire("l3aRA");
const { addEvent: $95cf46cfaa746602$var$addEvent, pushUnique: $95cf46cfaa746602$var$pushUnique } = (0, $l3aRA.default);
/* *
 *
 *  Definitions
 *
 * */ let $95cf46cfaa746602$var$creditsObserver;
function $95cf46cfaa746602$export$f672e0b6f7222cd7(GridClass, TableClass) {
    if (!$95cf46cfaa746602$var$pushUnique((0, $30Vhv.default).composed, 'CreditsLite')) return;
    $95cf46cfaa746602$var$addEvent(GridClass, 'afterRenderViewport', $95cf46cfaa746602$var$initCredits);
    $95cf46cfaa746602$var$addEvent(TableClass, 'afterDestroy', $95cf46cfaa746602$var$destroyCredits);
}
/**
 * Callback function called before table initialization.
 */ function $95cf46cfaa746602$var$initCredits() {
    const credits = new (0, $3OZLm.default)(this);
    const containerStyle = credits.containerElement.style;
    // Apply static styles
    containerStyle.setProperty('display', 'flex', 'important');
    containerStyle.setProperty('padding', '5px 5px 0px 5px', 'important');
    containerStyle.setProperty('flex-direction', 'row-reverse', 'important');
    // Create an observer that check credits modifications
    $95cf46cfaa746602$var$creditsObserver = new MutationObserver(()=>{
        if (!credits.containerElement.querySelector('.hcg-credits')) credits.render();
    });
    // Start observing the credits
    $95cf46cfaa746602$var$creditsObserver.observe(credits.containerElement, {
        attributes: true,
        childList: true,
        subtree: true
    });
    return credits;
}
/**
 * Callback function called after credits destroy.
 */ function $95cf46cfaa746602$var$destroyCredits() {
    $95cf46cfaa746602$var$creditsObserver?.disconnect();
}
var /* *
 *
 *  Default Export
 *
 * */ $95cf46cfaa746602$export$2e2bcd8739ae039 = {
    compose: $95cf46cfaa746602$export$f672e0b6f7222cd7
};

});
parcelRegister("3OZLm", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c85f36da4e73aa7$export$2e2bcd8739ae039);
/* *
 *
 *  Grid Credits class
 *
 *  (c) 2020-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Dawid Dragula
 *  - Sebastian Bochan
 *
 * */ 
var $7Tdil = parcelRequire("7Tdil");

var $1I1ai = parcelRequire("1I1ai");
'use strict';
const { makeHTMLElement: $2c85f36da4e73aa7$var$makeHTMLElement, setHTMLContent: $2c85f36da4e73aa7$var$setHTMLContent } = (0, $1I1ai.default);
/* *
 *
 *  Class
 *
 * */ /**
 * Represents a credits in the grid.
 */ class $2c85f36da4e73aa7$var$Credits {
    /* *
    *
    *  Constructor
    *
    * */ /**
     * Construct the credits.
     *
     * @param grid
     * The Grid instance which the credits belong to.
     *
     * @param options
     * Options for the credits label. Predefined if not provided.
     *
     */ constructor(grid, options){
        this.grid = grid;
        this.containerElement = $2c85f36da4e73aa7$var$makeHTMLElement('div', {
            className: (0, $7Tdil.default).getClassName('creditsContainer')
        });
        this.textElement = this.renderAnchor();
        this.options = options ?? $2c85f36da4e73aa7$var$Credits.defaultOptions;
        this.render();
    }
    /* *
    *
    *  Methods
    *
    * */ /**
     * Render the credits. If the credits are disabled, they will be removed
     * from the container.
     */ render() {
        const grid = this.grid;
        const contentWrapper = grid.contentWrapper;
        const { text: text, href: href } = this.options;
        this.containerElement.remove();
        if (!this.textElement) this.textElement = this.renderAnchor();
        if (text) $2c85f36da4e73aa7$var$setHTMLContent(this.textElement, text);
        if (href) this.textElement.setAttribute('href', href || '');
        if (grid.descriptionElement) contentWrapper?.insertBefore(this.containerElement, grid.descriptionElement);
        else contentWrapper?.appendChild(this.containerElement);
    }
    renderAnchor() {
        const anchorElement = $2c85f36da4e73aa7$var$makeHTMLElement('a', {
            className: (0, $7Tdil.default).getClassName('creditsText')
        }, this.containerElement);
        anchorElement.setAttribute('target', '_blank');
        anchorElement.setAttribute('alt', 'Highcharts logo');
        return anchorElement;
    }
    /**
     * Get the height of the credits container.
     */ getHeight() {
        return this.containerElement.offsetHeight;
    }
    /**
     * Destroy the credits. The credits will be removed from the container and
     * the reference to the credits will be deleted from the Grid instance
     * it belongs to.
     */ destroy() {
        this.containerElement.remove();
    }
}
/* *
*
*  Static Properties
*
* */ /**
 * Default options of the credits.
 */ $2c85f36da4e73aa7$var$Credits.defaultOptions = {
    enabled: true,
    text: '',
    href: 'https://www.highcharts.com',
    position: 'bottom'
};
var /* *
 *
 *  Default Export
 *
 * */ $2c85f36da4e73aa7$export$2e2bcd8739ae039 = $2c85f36da4e73aa7$var$Credits;

});


parcelRegister("bilki", function(module, exports) {
/* *
 *
 *  (c) 2009-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Torstein Hønsi
 *  - Christer Vasseng
 *  - Gøran Slettemark
 *  - Sophie Bremer
 *  - Kamil Kubik
 *
 * */ 
var $ky97I = parcelRequire("ky97I");

var $6GqCF = parcelRequire("6GqCF");

var $l3aRA = parcelRequire("l3aRA");
'use strict';
const { merge: $8391eb23bcd34729$var$merge, fireEvent: $8391eb23bcd34729$var$fireEvent } = (0, $l3aRA.default);
/* *
 *
 *  Class
 *
 * */ /**
 * Class that handles creating a DataConnector from CSV
 *
 * @private
 */ class $8391eb23bcd34729$var$CSVConnector extends (0, $6GqCF.default) {
    /* *
     *
     *  Constructor
     *
     * */ /**
     * Constructs an instance of CSVConnector.
     *
     * @param {Partial<CSVConnectorOptions>} [options]
     * Options for the connector and converter.
     */ constructor(options){
        const mergedOptions = $8391eb23bcd34729$var$merge($8391eb23bcd34729$var$CSVConnector.defaultOptions, options);
        super(mergedOptions);
        this.options = mergedOptions;
        if (mergedOptions.enablePolling) this.startPolling(Math.max(mergedOptions.dataRefreshRate || 0, 1) * 1000);
    }
    /* *
     *
     *  Functions
     *
     * */ /**
     * Overrides the DataConnector method. Emits an event on the connector to
     * all registered callbacks of this event.
     *
     * @param {CSVConnector.Event} e
     * Event object containing additional event information.
     */ emit(e) {
        $8391eb23bcd34729$var$fireEvent(this, e.type, e);
    }
    /**
     * Initiates the loading of the CSV source to the connector
     *
     * @param {DataEvent.Detail} [eventDetail]
     * Custom information for pending events.
     *
     * @emits CSVConnector#load
     * @emits CSVConnector#afterLoad
     */ load(eventDetail) {
        const connector = this;
        const options = connector.options;
        const { csv: csv, csvURL: csvURL, dataTables: dataTables, decimalPoint: decimalPoint } = options;
        connector.emit({
            type: 'load',
            csv: csv
        });
        return Promise.resolve(csvURL ? fetch(csvURL, {
            signal: connector?.pollingController?.signal
        }).then((response)=>response.text()) : csv || '').then((csv)=>{
            if (csv) this.initConverters(csv, (key)=>{
                const tableOptions = dataTables?.find((dataTable)=>dataTable.key === key);
                // The data table options takes precedence over the
                // connector options.
                const { firstRowAsNames: firstRowAsNames = options.firstRowAsNames, beforeParse: beforeParse = options.beforeParse } = tableOptions || {};
                const converterOptions = {
                    decimalPoint: decimalPoint,
                    firstRowAsNames: firstRowAsNames,
                    beforeParse: beforeParse
                };
                return new (0, $ky97I.default)($8391eb23bcd34729$var$merge(options, converterOptions));
            }, (converter, data)=>converter.parse({
                    csv: data
                }));
            return connector.applyTableModifiers().then(()=>csv);
        }).then((csv)=>{
            connector.emit({
                type: 'afterLoad',
                detail: eventDetail,
                csv: csv
            });
            return connector;
        })['catch']((error)=>{
            connector.emit({
                type: 'loadError',
                detail: eventDetail,
                error: error
            });
            throw error;
        });
    }
}
/* *
 *
 *  Static Properties
 *
 * */ $8391eb23bcd34729$var$CSVConnector.defaultOptions = {
    id: 'csv-connector',
    type: 'CSV',
    csv: '',
    csvURL: '',
    enablePolling: false,
    dataRefreshRate: 1,
    firstRowAsNames: true
};
/* *
 *
 *  Registry
 *
 * */ (0, $6GqCF.default).registerType('CSV', $8391eb23bcd34729$var$CSVConnector);
var /* *
 *
 *  Default Export
 *
 * */ $8391eb23bcd34729$export$2e2bcd8739ae039 = $8391eb23bcd34729$var$CSVConnector;

});
parcelRegister("ky97I", function(module, exports) {

$parcel$export(module.exports, "default", () => $03dc5b162cfa48ce$export$2e2bcd8739ae039);
/* *
 *
 *  (c) 2009-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Torstein Hønsi
 *  - Christer Vasseng
 *  - Gøran Slettemark
 *  - Sophie Bremer
 *  - Kamil Kubik
 *
 * */ 
var $5Jprx = parcelRequire("5Jprx");

var $6NwQo = parcelRequire("6NwQo");

var $l3aRA = parcelRequire("l3aRA");
'use strict';
const { merge: $03dc5b162cfa48ce$var$merge } = (0, $l3aRA.default);
/* *
 *
 *  Class
 *
 * */ /**
 * Handles parsing and transforming CSV to a table.
 *
 * @private
 */ class $03dc5b162cfa48ce$var$CSVConverter extends (0, $5Jprx.default) {
    /* *
     *
     *  Constructor
     *
     * */ /**
     * Constructs an instance of the CSV parser.
     *
     * @param {Partial<CSVConverterOptions>} [options]
     * Options for the CSV parser.
     */ constructor(options){
        const mergedOptions = $03dc5b162cfa48ce$var$merge($03dc5b162cfa48ce$var$CSVConverter.defaultOptions, options);
        super(mergedOptions);
        /* *
         *
         *  Properties
         *
         * */ this.headers = [];
        this.dataTypes = [];
        this.options = mergedOptions;
    }
    /* *
     *
     *  Functions
     *
     * */ /**
     * Parses the CSV string into a DataTable column collection.
     * Handles line and item delimiters, optional header row, and
     * applies pre-processing if a beforeParse callback is provided.
     *
     * @param {Partial<CSVConverterOptions>} [options]
     * Options for the parser.
     * @param {DataEvent.Detail} [eventDetail]
     * Custom information for pending events.
     * @return {DataTable.ColumnCollection}
     * The parsed column collection.
     *
     * @emits CSVDataParser#parse
     * @emits CSVDataParser#afterParse
     */ parse(options, eventDetail) {
        const converter = this, dataTypes = converter.dataTypes, parserOptions = $03dc5b162cfa48ce$var$merge(this.options, options), { beforeParse: beforeParse, lineDelimiter: lineDelimiter, firstRowAsNames: firstRowAsNames, itemDelimiter: itemDelimiter } = parserOptions;
        let lines, rowIt = 0, { csv: csv, startRow: startRow, endRow: endRow } = parserOptions, column;
        const columnsArray = [];
        converter.emit({
            type: 'parse',
            columns: columnsArray,
            detail: eventDetail,
            headers: converter.headers
        });
        if (csv && beforeParse) csv = beforeParse(csv);
        if (csv) {
            lines = csv.replace(/\r\n|\r/g, '\n') // Windows | Mac
            .split(lineDelimiter || '\n');
            if (!startRow || startRow < 0) startRow = 0;
            if (!endRow || endRow >= lines.length) endRow = lines.length - 1;
            if (!itemDelimiter) converter.guessedItemDelimiter = converter.guessDelimiter(lines);
            // If the first row contain names, add them to the
            // headers array and skip the row.
            if (firstRowAsNames) {
                const headers = lines[0].split(itemDelimiter || converter.guessedItemDelimiter || ',');
                // Remove ""s from the headers
                for(let i = 0; i < headers.length; i++)headers[i] = headers[i].trim().replace(/^["']|["']$/g, '');
                converter.headers = headers;
                startRow++;
            }
            let offset = 0;
            for(rowIt = startRow; rowIt <= endRow; rowIt++)if (lines[rowIt][0] === '#') offset++;
            else converter.parseCSVRow(columnsArray, lines[rowIt], rowIt - startRow - offset);
            if (dataTypes.length && dataTypes[0].length && dataTypes[0][1] === 'date' && // Format is a string date
            !converter.options.dateFormat) converter.deduceDateFormat(columnsArray[0], null, true);
            // Guess types.
            for(let i = 0, iEnd = columnsArray.length; i < iEnd; ++i){
                column = columnsArray[i];
                for(let j = 0, jEnd = column.length; j < jEnd; ++j)if (column[j] && typeof column[j] === 'string') {
                    let cellValue = converter.convertByType(column[j]);
                    if (cellValue instanceof Date) cellValue = cellValue.getTime();
                    columnsArray[i][j] = cellValue;
                }
            }
        }
        // Normalize columns to same length to avoid truncation.
        columnsArray.forEach((col)=>{
            col.length = Math.max(...columnsArray.map((c)=>c.length));
        });
        converter.emit({
            type: 'afterParse',
            columns: columnsArray,
            detail: eventDetail,
            headers: converter.headers
        });
        return (0, $6NwQo.default).getColumnsCollection(columnsArray, converter.headers);
    }
    /**
     * Parses a single CSV row string into columns, handling delimiters,
     * quoted values, data type inference, and column range selection.
     */ parseCSVRow(columns, columnStr, rowNumber) {
        const converter = this, dataTypes = converter.dataTypes, { startColumn: startColumn, endColumn: endColumn } = converter.options, itemDelimiter = converter.options.itemDelimiter || converter.guessedItemDelimiter;
        let { decimalPoint: decimalPoint } = converter.options;
        if (!decimalPoint || decimalPoint === itemDelimiter) decimalPoint = converter.guessedDecimalPoint || '.';
        let i = 0, c = '', token = '', actualColumn = 0, column = 0;
        const read = (j)=>{
            c = columnStr[j];
        };
        const pushType = (type)=>{
            if (dataTypes.length < column + 1) dataTypes.push([
                type
            ]);
            if (dataTypes[column][dataTypes[column].length - 1] !== type) dataTypes[column].push(type);
        };
        const push = ()=>{
            if (startColumn > actualColumn || actualColumn > endColumn) {
                // Skip this column, but increment the column count (#7272)
                ++actualColumn;
                token = '';
                return;
            }
            // Save the type of the token.
            if (typeof token === 'string') {
                const parsedNumber = parseFloat(token);
                if (!isNaN(parsedNumber) && isFinite(Number(token))) {
                    token = parsedNumber;
                    pushType('number');
                } else if (!isNaN(Date.parse(token))) {
                    token = token.replace(/\//g, '-');
                    pushType('date');
                } else pushType('string');
            } else pushType('number');
            if (columns.length < column + 1) columns.push([]);
            // Try to apply the decimal point, and check if the token then is a
            // number. If not, reapply the initial value
            if (typeof token !== 'number' && (0, $6NwQo.default).guessType(token, converter) !== 'number' && decimalPoint) {
                const initialValue = token;
                token = token.replace(decimalPoint, '.');
                if ((0, $6NwQo.default).guessType(token, converter) !== 'number') token = initialValue;
            }
            columns[column][rowNumber] = token;
            token = '';
            ++column;
            ++actualColumn;
        };
        if (!columnStr.trim().length) return;
        if (columnStr.trim()[0] === '#') return;
        for(; i < columnStr.length; i++){
            read(i);
            if (c === '#') // If there are hexvalues remaining (#13283)
            {
                if (!/^#[A-F\d]{3,3}|[A-F\d]{6,6}/i.test(columnStr.substring(i))) {
                    // The rest of the row is a comment
                    push();
                    return;
                }
            }
            // Quoted string
            if (c === '"') {
                read(++i);
                while(i < columnStr.length){
                    if (c === '"') break;
                    token += c;
                    read(++i);
                }
            } else if (c === itemDelimiter) push();
            else token += c;
        }
        push();
    }
    /**
     * Internal method that guesses the delimiter from the first
     * 13 lines of the CSV
     * @param {string[]} lines
     * The CSV, split into lines
     */ guessDelimiter(lines) {
        let points = 0, commas = 0, guessed;
        const potDelimiters = {
            ',': 0,
            ';': 0,
            '\t': 0
        }, linesCount = lines.length;
        for(let i = 0; i < linesCount; i++){
            let inStr = false, c, cn, cl, token = '';
            // We should be able to detect dateformats within 13 rows
            if (i > 13) break;
            const columnStr = lines[i];
            for(let j = 0; j < columnStr.length; j++){
                c = columnStr[j];
                cn = columnStr[j + 1];
                cl = columnStr[j - 1];
                if (c === '#') break;
                if (c === '"') {
                    if (inStr) {
                        if (cl !== '"' && cn !== '"') {
                            while(cn === ' ' && j < columnStr.length)cn = columnStr[++j];
                            // After parsing a string, the next non-blank
                            // should be a delimiter if the CSV is properly
                            // formed.
                            if (typeof potDelimiters[cn] !== 'undefined') potDelimiters[cn]++;
                            inStr = false;
                        }
                    } else inStr = true;
                } else if (typeof potDelimiters[c] !== 'undefined') {
                    token = token.trim();
                    if (!isNaN(Date.parse(token))) potDelimiters[c]++;
                    else if (isNaN(Number(token)) || !isFinite(Number(token))) potDelimiters[c]++;
                    token = '';
                } else token += c;
                if (c === ',') commas++;
                if (c === '.') points++;
            }
        }
        // Count the potential delimiters.
        // This could be improved by checking if the number of delimiters
        // equals the number of columns - 1
        if (potDelimiters[';'] > potDelimiters[',']) guessed = ';';
        else if (potDelimiters[','] > potDelimiters[';']) guessed = ',';
        else // No good guess could be made..
        guessed = ',';
        // Try to deduce the decimal point if it's not explicitly set.
        // If both commas or points is > 0 there is likely an issue
        if (points > commas) this.guessedDecimalPoint = '.';
        else this.guessedDecimalPoint = ',';
        return guessed;
    }
}
/* *
 *
 *  Static Properties
 *
 * */ /**
 * Default options
 */ $03dc5b162cfa48ce$var$CSVConverter.defaultOptions = {
    ...(0, $5Jprx.default).defaultOptions,
    lineDelimiter: '\n',
    startColumn: 0,
    endColumn: Number.MAX_VALUE,
    startRow: 0,
    endRow: Number.MAX_VALUE
};
(0, $5Jprx.default).registerType('CSV', $03dc5b162cfa48ce$var$CSVConverter);
var /* *
 *
 *  Default Export
 *
 * */ $03dc5b162cfa48ce$export$2e2bcd8739ae039 = $03dc5b162cfa48ce$var$CSVConverter;

});


parcelRegister("lM6pi", function(module, exports) {
/* *
 *
 *  (c) 2009-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Torstein Hønsi
 *  - Gøran Slettemark
 *  - Wojciech Chmiel
 *  - Sophie Bremer
 *  - Jomar Hønsi
 *  - Kamil Kubik
 *
 * */ 
var $6GqCF = parcelRequire("6GqCF");

var $b0CyN = parcelRequire("b0CyN");

var $l3aRA = parcelRequire("l3aRA");
'use strict';
const { merge: $fda30cf0f81f436b$var$merge, pick: $fda30cf0f81f436b$var$pick, fireEvent: $fda30cf0f81f436b$var$fireEvent } = (0, $l3aRA.default);
/* *
 *
 *  Functions
 *
 * */ /**
 * Tests Google's response for error.
 * @private
 */ function $fda30cf0f81f436b$var$isGoogleError(json) {
    return typeof json === 'object' && json && typeof json.error === 'object' && json.error && typeof json.error.code === 'number' && typeof json.error.message === 'string' && typeof json.error.status === 'string';
}
/* *
 *
 *  Class
 *
 * */ /**
 * @private
 * @todo implement save, requires oauth2
 */ class $fda30cf0f81f436b$var$GoogleSheetsConnector extends (0, $6GqCF.default) {
    /* *
     *
     *  Constructor
     *
     * */ /**
     * Constructs an instance of GoogleSheetsConnector
     *
     * @param {Partial<GoogleSheetsConnectorOptions>} [options]
     * Options for the connector and converter.
     */ constructor(options){
        const mergedOptions = $fda30cf0f81f436b$var$merge($fda30cf0f81f436b$var$GoogleSheetsConnector.defaultOptions, options);
        super(mergedOptions);
        this.options = mergedOptions;
    }
    /* *
     *
     *  Functions
     *
     * */ /**
     * Overrides the DataConnector method. Emits an event on the connector to
     * all registered callbacks of this event.
     *
     * @param {GoogleSheetsConnector.Event} e
     * Event object containing additional event information.
     */ emit(e) {
        $fda30cf0f81f436b$var$fireEvent(this, e.type, e);
    }
    /**
     * Loads data from a Google Spreadsheet.
     *
     * @param {DataEvent.Detail} [eventDetail]
     * Custom information for pending events.
     *
     * @return {Promise<this>}
     * Same connector instance with modified table.
     */ load(eventDetail) {
        const connector = this;
        const options = connector.options;
        const { dataRefreshRate: dataRefreshRate, enablePolling: enablePolling, googleAPIKey: googleAPIKey, googleSpreadsheetKey: googleSpreadsheetKey, dataTables: dataTables } = options;
        const url = $fda30cf0f81f436b$var$GoogleSheetsConnector.buildFetchURL(googleAPIKey, googleSpreadsheetKey, options);
        connector.emit({
            type: 'load',
            detail: eventDetail,
            url: url
        });
        if (!URL.canParse(url)) throw new Error('Invalid URL: ' + url);
        return fetch(url, {
            signal: connector?.pollingController?.signal
        }).then((response)=>response.json()).then((json)=>{
            if ($fda30cf0f81f436b$var$isGoogleError(json)) throw new Error(json.error.message);
            this.initConverters(json, (key)=>{
                const tableOptions = dataTables?.find((dataTable)=>dataTable.key === key);
                // The data table options takes precedence over the
                // connector options.
                const { firstRowAsNames: firstRowAsNames = options.firstRowAsNames, beforeParse: beforeParse = options.beforeParse } = tableOptions || {};
                const converterOptions = {
                    firstRowAsNames: firstRowAsNames,
                    beforeParse: beforeParse
                };
                return new (0, $b0CyN.default)(converterOptions);
            }, (converter, data)=>converter.parse({
                    json: data
                }));
            return connector.applyTableModifiers();
        }).then(()=>{
            connector.emit({
                type: 'afterLoad',
                detail: eventDetail,
                url: url
            });
            // Polling
            if (enablePolling) setTimeout(()=>connector.load(), Math.max(dataRefreshRate || 0, 1) * 1000);
            return connector;
        })['catch']((error)=>{
            connector.emit({
                type: 'loadError',
                detail: eventDetail,
                error: error
            });
            throw error;
        });
    }
}
/* *
 *
 *  Static Properties
 *
 * */ $fda30cf0f81f436b$var$GoogleSheetsConnector.defaultOptions = {
    id: 'google-sheets-connector',
    type: 'GoogleSheets',
    googleAPIKey: '',
    googleSpreadsheetKey: '',
    enablePolling: false,
    dataRefreshRate: 2,
    firstRowAsNames: true
};
/* *
 *
 *  Class Namespace
 *
 * */ (function(GoogleSheetsConnector) {
    /* *
     *
     *  Declarations
     *
     * */ /* *
     *
     *  Constants
     *
     * */ const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    /* *
     *
     *  Functions
     *
     * */ /**
     * Creates GoogleSheets API v4 URL.
     * @private
     */ function buildFetchURL(apiKey, sheetKey, options = {}) {
        const url = new URL(`https://sheets.googleapis.com/v4/spreadsheets/${sheetKey}/values/`);
        const range = options.onlyColumnIds ? 'A1:Z1' : buildQueryRange(options);
        url.pathname += range;
        const searchParams = url.searchParams;
        searchParams.set('alt', 'json');
        if (!options.onlyColumnIds) {
            searchParams.set('dateTimeRenderOption', 'FORMATTED_STRING');
            searchParams.set('majorDimension', 'COLUMNS');
            searchParams.set('valueRenderOption', 'UNFORMATTED_VALUE');
        }
        searchParams.set('prettyPrint', 'false');
        searchParams.set('key', apiKey);
        return url.href;
    }
    GoogleSheetsConnector.buildFetchURL = buildFetchURL;
    /**
     * Creates sheets range.
     * @private
     */ function buildQueryRange(options = {}) {
        const { endColumn: endColumn, endRow: endRow, googleSpreadsheetRange: googleSpreadsheetRange, startColumn: startColumn, startRow: startRow } = options;
        return googleSpreadsheetRange || (alphabet[startColumn || 0] || 'A') + (Math.max(startRow || 0, 0) + 1) + ':' + (alphabet[$fda30cf0f81f436b$var$pick(endColumn, 25)] || 'Z') + (endRow ? Math.max(endRow, 0) : 'Z');
    }
    GoogleSheetsConnector.buildQueryRange = buildQueryRange;
})($fda30cf0f81f436b$var$GoogleSheetsConnector || ($fda30cf0f81f436b$var$GoogleSheetsConnector = {}));
/* *
 *
 *  Registry
 *
 * */ (0, $6GqCF.default).registerType('GoogleSheets', $fda30cf0f81f436b$var$GoogleSheetsConnector);
var /* *
 *
 *  Default Export
 *
 * */ $fda30cf0f81f436b$export$2e2bcd8739ae039 = $fda30cf0f81f436b$var$GoogleSheetsConnector;

});
parcelRegister("b0CyN", function(module, exports) {

$parcel$export(module.exports, "default", () => $803d9b0c32426568$export$2e2bcd8739ae039);
/* *
 *
 *  (c) 2009-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Torstein Hønsi
 *  - Gøran Slettemark
 *  - Wojciech Chmiel
 *  - Sophie Bremer
 *  - Kamil Kubik
 *
 * */ 
var $5Jprx = parcelRequire("5Jprx");

var $6NwQo = parcelRequire("6NwQo");

var $l3aRA = parcelRequire("l3aRA");
'use strict';
const { merge: $803d9b0c32426568$var$merge, uniqueKey: $803d9b0c32426568$var$uniqueKey } = (0, $l3aRA.default);
/* *
 *
 *  Class
 *
 * */ /**
 * Handles parsing and transformation of an Google Sheets to a table.
 *
 * @private
 */ class $803d9b0c32426568$var$GoogleSheetsConverter extends (0, $5Jprx.default) {
    /* *
     *
     *  Constructor
     *
     * */ /**
     * Constructs an instance of the GoogleSheetsConverter.
     *
     * @param {Partial<GoogleSheetsConverterOptions>} [options]
     * Options for the GoogleSheetsConverter.
     */ constructor(options){
        const mergedOptions = $803d9b0c32426568$var$merge($803d9b0c32426568$var$GoogleSheetsConverter.defaultOptions, options);
        super(mergedOptions);
        this.header = [];
        this.options = mergedOptions;
    }
    /* *
     *
     *  Functions
     *
     * */ /**
     * Initiates the parsing of the Google Sheet
     *
     * @param {Partial<GoogleSheetsConverterOptions>}[options]
     * Options for the parser
     *
     * @param {DataEvent.Detail} [eventDetail]
     * Custom information for pending events.
     *
     * @emits GoogleSheetsParser#parse
     * @emits GoogleSheetsParser#afterParse
     */ parse(options, eventDetail) {
        const converter = this, parseOptions = $803d9b0c32426568$var$merge(converter.options, options);
        let columnsArray = (parseOptions.json?.values || []).map((column)=>column.slice());
        if (columnsArray.length === 0) return {};
        converter.header = [];
        converter.emit({
            type: 'parse',
            columns: [],
            detail: eventDetail,
            headers: converter.header
        });
        // If beforeParse is defined, use it to modify the data
        const { beforeParse: beforeParse, json: json } = parseOptions;
        if (beforeParse && json) columnsArray = beforeParse(json.values);
        let column;
        for(let i = 0, iEnd = columnsArray.length; i < iEnd; i++){
            column = columnsArray[i];
            converter.header[i] = parseOptions.firstRowAsNames ? `${column.shift()}` : $803d9b0c32426568$var$uniqueKey();
            for(let j = 0, jEnd = column.length; j < jEnd; ++j){
                let cellValue = column[j];
                if ($803d9b0c32426568$var$isDateObject(cellValue)) cellValue = cellValue.getTime();
                columnsArray[i][j] = cellValue;
            }
        }
        converter.emit({
            type: 'afterParse',
            columns: columnsArray,
            detail: eventDetail,
            headers: converter.header
        });
        return (0, $6NwQo.default).getColumnsCollection(columnsArray, converter.header);
    }
}
/* *
 *
 *  Static Properties
 *
 * */ /**
 * Default options
 */ $803d9b0c32426568$var$GoogleSheetsConverter.defaultOptions = {
    ...(0, $5Jprx.default).defaultOptions
};
(0, $5Jprx.default).registerType('GoogleSheets', $803d9b0c32426568$var$GoogleSheetsConverter);
var /* *
 *
 *  Default Export
 *
 * */ $803d9b0c32426568$export$2e2bcd8739ae039 = $803d9b0c32426568$var$GoogleSheetsConverter;
/**
 * Check if a value is a Date object
 *
 * @param {unknown} value to verify
 * @return {boolean}
 * True if the value is a Date object, false otherwise.
 */ function $803d9b0c32426568$var$isDateObject(value) {
    return Object.prototype.toString.call(value) === '[object Date]';
}

});


parcelRegister("gm72G", function(module, exports) {
/* *
 *
 *  (c) 2009-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Torstein Hønsi
 *  - Gøran Slettemark
 *  - Wojciech Chmiel
 *  - Sophie Bremer
 *  - Kamil Kubik
 *
 * */ 
var $6GqCF = parcelRequire("6GqCF");

var $lORrh = parcelRequire("lORrh");

var $30Vhv = parcelRequire("30Vhv");

var $l3aRA = parcelRequire("l3aRA");
'use strict';
const { win: $be8429dba54d9589$var$win } = (0, $30Vhv.default);
const { merge: $be8429dba54d9589$var$merge } = (0, $l3aRA.default);
/* *
 *
 *  Class
 *
 * */ /**
 * Class that handles creating a data connector from an HTML table.
 *
 * @private
 */ class $be8429dba54d9589$var$HTMLTableConnector extends (0, $6GqCF.default) {
    /* *
     *
     *  Constructor
     *
     * */ /**
     * Constructs an instance of HTMLTableConnector.
     *
     * @param {HTMLTableConnector.CombinedHTMLTableConnectorOptions} [options]
     * Options for the connector and converter.
     */ constructor(options){
        const mergedOptions = $be8429dba54d9589$var$merge($be8429dba54d9589$var$HTMLTableConnector.defaultOptions, options);
        super(mergedOptions);
        this.options = mergedOptions;
        this.converter = new (0, $lORrh.default)(mergedOptions);
    }
    /**
     * Initiates creating the dataconnector from the HTML table
     *
     * @param {DataEvent.Detail} [eventDetail]
     * Custom information for pending events.
     *
     * @emits HTMLTableConnector#load
     * @emits HTMLTableConnector#afterLoad
     * @emits HTMLTableConnector#loadError
     */ async load(eventDetail) {
        const connector = this;
        const options = connector.options;
        const converter = connector.converter;
        const table = connector.getTable();
        const htmlTable = options.htmlTable;
        connector.emit({
            type: 'load',
            detail: eventDetail
        });
        let tableElement;
        if (typeof htmlTable === 'string') {
            connector.tableID = htmlTable;
            tableElement = $be8429dba54d9589$var$win.document.getElementById(htmlTable);
        } else {
            tableElement = htmlTable;
            connector.tableID = tableElement.id;
        }
        connector.tableElement = tableElement || void 0;
        if (!connector.tableElement) {
            const error = 'HTML table not provided, or element with ID not found';
            connector.emit({
                type: 'loadError',
                detail: eventDetail,
                error: error
            });
            return Promise.reject(new Error(error));
        }
        const columns = converter.parse($be8429dba54d9589$var$merge({
            tableElement: connector.tableElement
        }, options), eventDetail);
        // If already loaded, clear the current rows
        table.deleteColumns();
        table.setColumns(columns);
        await connector.applyTableModifiers();
        connector.emit({
            type: 'afterLoad',
            detail: eventDetail
        });
        return connector;
    }
}
/* *
 *
 *  Static Properties
 *
 * */ $be8429dba54d9589$var$HTMLTableConnector.defaultOptions = {
    id: 'HTML-table-connector',
    type: 'HTMLTable',
    htmlTable: ''
};
(0, $6GqCF.default).registerType('HTMLTable', $be8429dba54d9589$var$HTMLTableConnector);
var /* *
 *
 *  Default Export
 *
 * */ $be8429dba54d9589$export$2e2bcd8739ae039 = $be8429dba54d9589$var$HTMLTableConnector;

});
parcelRegister("lORrh", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe27b86227eb84cb$export$2e2bcd8739ae039);
/* *
 *
 *  (c) 2009-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Torstein Hønsi
 *  - Gøran Slettemark
 *  - Wojciech Chmiel
 *  - Sophie Bremer
 *  - Kamil Kubik
 *
 * */ 
var $5Jprx = parcelRequire("5Jprx");

var $6NwQo = parcelRequire("6NwQo");

var $l3aRA = parcelRequire("l3aRA");
'use strict';
const { merge: $fe27b86227eb84cb$var$merge } = (0, $l3aRA.default);
/* *
 *
 *  Functions
 *
 * */ /**
 * Row equal
 */ function $fe27b86227eb84cb$var$isRowEqual(row1, row2) {
    let i = row1.length;
    if (row2.length === i) while(--i){
        if (row1[i] !== row2[i]) return false;
    }
    else return false;
    return true;
}
/* *
 *
 *  Class
 *
 * */ /**
 * Handles parsing and transformation of an HTML table to a table.
 *
 * @private
 */ class $fe27b86227eb84cb$var$HTMLTableConverter extends (0, $5Jprx.default) {
    /* *
     *
     *  Constructor
     *
     * */ /**
     * Constructs an instance of the HTMLTableConverter.
     *
     * @param {Partial<HTMLTableConverterOptions>} [options]
     * Options for the HTMLTableConverter.
     */ constructor(options){
        const mergedOptions = $fe27b86227eb84cb$var$merge($fe27b86227eb84cb$var$HTMLTableConverter.defaultOptions, options);
        super(mergedOptions);
        this.headers = [];
        this.options = mergedOptions;
        if (mergedOptions.tableElement) {
            this.tableElement = mergedOptions.tableElement;
            this.tableElementID = mergedOptions.tableElement.id;
        }
    }
    /* *
     *
     *  Functions
     *
     * */ /**
     * Exports the dataconnector as an HTML string, using the options
     * provided on import unless other options are provided.
     *
     * @param {DataConnector} connector
     * Connector instance to export from.
     *
     * @param {HTMLTableConnector.ExportOptions} [options]
     * Options that override default or existing export options.
     *
     * @return {string}
     * HTML from the current dataTable.
     */ export(connector, options = this.options) {
        const exportNames = options.firstRowAsNames !== false, useMultiLevelHeaders = options.useMultiLevelHeaders;
        const columns = connector.getSortedColumns(), columnIds = Object.keys(columns), htmlRows = [], columnsCount = columnIds.length;
        const rowArray = [];
        let tableHead = '';
        // Add the names as the first row if they should be exported
        if (exportNames) {
            const subcategories = [];
            // If using multilevel headers, the first value
            // of each column is a subcategory
            if (useMultiLevelHeaders) {
                for (const columnId of columnIds){
                    let column = columns[columnId];
                    if (!Array.isArray(column)) // Convert to conventional array from typed array
                    // if needed
                    column = Array.from(column);
                    const subhead = (column.shift() || '').toString();
                    columns[columnId] = column;
                    subcategories.push(subhead);
                }
                tableHead = this.getTableHeaderHTML(columnIds, subcategories, options);
            } else tableHead = this.getTableHeaderHTML(void 0, columnIds, options);
        }
        for(let columnIndex = 0; columnIndex < columnsCount; columnIndex++){
            const columnId = columnIds[columnIndex], column = columns[columnId], columnLength = column.length;
            for(let rowIndex = 0; rowIndex < columnLength; rowIndex++){
                let cellValue = column[rowIndex];
                if (!rowArray[rowIndex]) rowArray[rowIndex] = [];
                if (!(typeof cellValue === 'string' || typeof cellValue === 'number' || typeof cellValue === 'undefined')) cellValue = (cellValue || '').toString();
                rowArray[rowIndex][columnIndex] = this.getCellHTMLFromValue(columnIndex ? 'td' : 'th', null, columnIndex ? '' : 'scope="row"', cellValue);
                // On the final column, push the row to the array
                if (columnIndex === columnsCount - 1) htmlRows.push('<tr>' + rowArray[rowIndex].join('') + '</tr>');
            }
        }
        let caption = '';
        // Add table caption
        // Current exportdata falls back to chart title
        // but that should probably be handled elsewhere?
        if (options.tableCaption) caption = '<caption class="highcharts-table-caption">' + options.tableCaption + '</caption>';
        return '<table>' + caption + tableHead + '<tbody>' + htmlRows.join('') + '</tbody>' + '</table>';
    }
    /**
     * Get table cell markup from row data.
     */ getCellHTMLFromValue(tag, classes, attrs, value, decimalPoint) {
        let val = value, className = 'text' + (classes ? ' ' + classes : '');
        // Convert to string if number
        if (typeof val === 'number') {
            val = val.toString();
            if (decimalPoint === ',') val = val.replace('.', decimalPoint);
            className = 'number';
        } else if (!value) {
            val = '';
            className = 'empty';
        }
        return '<' + tag + (attrs ? ' ' + attrs : '') + ' class="' + className + '">' + val + '</' + tag + '>';
    }
    /**
     * Get table header markup from row data.
     */ getTableHeaderHTML(topheaders = [], subheaders = [], options = this.options) {
        const { useMultiLevelHeaders: useMultiLevelHeaders, useRowspanHeaders: useRowspanHeaders } = options;
        let html = '<thead>', i = 0, len = subheaders && subheaders.length, next, cur, curColspan = 0, rowspan;
        // Clean up multiple table headers. Exporting.getDataRows() returns two
        // levels of headers when using multilevel, not merged. We need to
        // merge identical headers, remove redundant headers, and keep it
        // all marked up nicely.
        if (useMultiLevelHeaders && topheaders && subheaders && !$fe27b86227eb84cb$var$isRowEqual(topheaders, subheaders)) {
            html += '<tr>';
            for(; i < len; ++i){
                cur = topheaders[i];
                next = topheaders[i + 1];
                if (cur === next) ++curColspan;
                else if (curColspan) {
                    // Ended colspan
                    // Add cur to HTML with colspan.
                    html += this.getCellHTMLFromValue('th', 'highcharts-table-topheading', 'scope="col" colspan="' + (curColspan + 1) + '"', cur);
                    curColspan = 0;
                } else {
                    // Cur is standalone. If it is same as sublevel,
                    // remove sublevel and add just toplevel.
                    if (cur === subheaders[i]) {
                        if (useRowspanHeaders) {
                            rowspan = 2;
                            subheaders.splice(i, 1);
                        } else {
                            rowspan = 1;
                            subheaders[i] = '';
                        }
                    } else rowspan = 1;
                    html += this.getCellHTMLFromValue('th', 'highcharts-table-topheading', 'scope="col"' + (rowspan > 1 ? ' valign="top" rowspan="' + rowspan + '"' : ''), cur);
                }
            }
            html += '</tr>';
        }
        // Add the subheaders (the only headers if not using multilevels)
        if (subheaders) {
            html += '<tr>';
            for(i = 0, len = subheaders.length; i < len; ++i)if (typeof subheaders[i] !== 'undefined') html += this.getCellHTMLFromValue('th', null, 'scope="col"', subheaders[i]);
            html += '</tr>';
        }
        html += '</thead>';
        return html;
    }
    /**
     * Initiates the parsing of the HTML table
     *
     * @param {Partial<HTMLTableConverterOptions>}[options]
     * Options for the parser
     *
     * @param {DataEvent.Detail} [eventDetail]
     * Custom information for pending events.
     *
     * @emits CSVDataParser#parse
     * @emits CSVDataParser#afterParse
     * @emits HTMLTableParser#parseError
     */ parse(options, eventDetail) {
        const converter = this, columnsArray = [], headers = [], parseOptions = $fe27b86227eb84cb$var$merge(converter.options, options), { endRow: endRow, startColumn: startColumn, endColumn: endColumn, firstRowAsNames: firstRowAsNames } = parseOptions, tableHTML = parseOptions.tableElement || this.tableElement;
        if (!(tableHTML instanceof HTMLElement)) {
            converter.emit({
                type: 'parseError',
                columns: columnsArray,
                detail: eventDetail,
                headers: headers,
                error: 'Not a valid HTML Table'
            });
            return {};
        }
        converter.tableElement = tableHTML;
        converter.tableElementID = tableHTML.id;
        this.emit({
            type: 'parse',
            columns: columnsArray,
            detail: eventDetail,
            headers: converter.headers
        });
        const rows = tableHTML.getElementsByTagName('tr'), rowsCount = rows.length;
        let rowIndex = 0, item, { startRow: startRow } = parseOptions;
        // Insert headers from the first row
        if (firstRowAsNames && rowsCount) {
            const items = rows[0].children, itemsLength = items.length;
            for(let i = startColumn; i < itemsLength; i++){
                if (i > endColumn) break;
                item = items[i];
                if (item.tagName === 'TD' || item.tagName === 'TH') headers.push(item.innerHTML);
            }
            startRow++;
        }
        while(rowIndex < rowsCount){
            if (rowIndex >= startRow && rowIndex <= endRow) {
                const columnsInRow = rows[rowIndex].children, columnsInRowLength = columnsInRow.length;
                let columnIndex = 0;
                while(columnIndex < columnsInRowLength){
                    const relativeColumnIndex = columnIndex - startColumn, row = columnsArray[relativeColumnIndex];
                    item = columnsInRow[columnIndex];
                    if ((item.tagName === 'TD' || item.tagName === 'TH') && columnIndex >= startColumn && columnIndex <= endColumn) {
                        if (!columnsArray[relativeColumnIndex]) columnsArray[relativeColumnIndex] = [];
                        let cellValue = converter.convertByType(item.innerHTML);
                        if (cellValue instanceof Date) cellValue = cellValue.getTime();
                        columnsArray[relativeColumnIndex][rowIndex - startRow] = cellValue;
                        // Loop over all previous indices and make sure
                        // they are nulls, not undefined.
                        let i = 1;
                        while(rowIndex - startRow >= i && row[rowIndex - startRow - i] === void 0){
                            row[rowIndex - startRow - i] = null;
                            i++;
                        }
                    }
                    columnIndex++;
                }
            }
            rowIndex++;
        }
        this.headers = headers;
        this.emit({
            type: 'afterParse',
            columns: columnsArray,
            detail: eventDetail,
            headers: headers
        });
        return (0, $6NwQo.default).getColumnsCollection(columnsArray, converter.headers);
    }
}
/* *
 *
 *  Static Properties
 *
 * */ /**
 * Default options
 */ $fe27b86227eb84cb$var$HTMLTableConverter.defaultOptions = {
    ...(0, $5Jprx.default).defaultOptions,
    useRowspanHeaders: true,
    useMultiLevelHeaders: true,
    startColumn: 0,
    endColumn: Number.MAX_VALUE,
    startRow: 0,
    endRow: Number.MAX_VALUE
};
(0, $5Jprx.default).registerType('HTMLTable', $fe27b86227eb84cb$var$HTMLTableConverter);
var /* *
 *
 *  Default Export
 *
 * */ $fe27b86227eb84cb$export$2e2bcd8739ae039 = $fe27b86227eb84cb$var$HTMLTableConverter;

});


parcelRegister("8tmXn", function(module, exports) {
/* *
 *
 *  (c) 2009-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Pawel Lysy
 *  - Kamil Kubik
 *
 * */ 
var $6GqCF = parcelRequire("6GqCF");

var $h4aBi = parcelRequire("h4aBi");

var $l3aRA = parcelRequire("l3aRA");
'use strict';
const { merge: $62b2d6e2e7011d67$var$merge, fireEvent: $62b2d6e2e7011d67$var$fireEvent } = (0, $l3aRA.default);
/* *
 *
 *  Class
 *
 * */ /**
 * Class that handles creating a DataConnector from JSON structure
 *
 * @private
 */ class $62b2d6e2e7011d67$var$JSONConnector extends (0, $6GqCF.default) {
    /* *
     *
     *  Constructor
     *
     * */ /**
     * Constructs an instance of JSONConnector.
     *
     * @param {Partial<JSONConnectorOptions>} [options]
     * Options for the connector and converter.
     */ constructor(options){
        const mergedOptions = $62b2d6e2e7011d67$var$merge($62b2d6e2e7011d67$var$JSONConnector.defaultOptions, options);
        super(mergedOptions);
        this.options = mergedOptions;
        if (mergedOptions.enablePolling) this.startPolling(Math.max(mergedOptions.dataRefreshRate || 0, 1) * 1000);
    }
    /* *
     *
     *  Functions
     *
     * */ /**
     * Overrides the DataConnector method. Emits an event on the connector to
     * all registered callbacks of this event.
     *
     * @param {JSONConnector.Event} e
     * Event object containing additional event information.
     */ emit(e) {
        $62b2d6e2e7011d67$var$fireEvent(this, e.type, e);
    }
    /**
     * Initiates the loading of the JSON source to the connector
     *
     * @param {DataEvent.Detail} [eventDetail]
     * Custom information for pending events.
     *
     * @emits JSONConnector#load
     * @emits JSONConnector#afterLoad
     */ load(eventDetail) {
        const connector = this;
        const options = connector.options;
        const { data: data, dataUrl: dataUrl, dataTables: dataTables } = options;
        connector.emit({
            type: 'load',
            detail: eventDetail,
            data: data
        });
        return Promise.resolve(dataUrl ? fetch(dataUrl, {
            signal: connector?.pollingController?.signal
        }).then((response)=>response.json())['catch']((error)=>{
            connector.emit({
                type: 'loadError',
                detail: eventDetail,
                error: error
            });
            console.warn(`Unable to fetch data from ${dataUrl}.`); // eslint-disable-line no-console
        }) : data || []).then(async (data)=>{
            if (data) this.initConverters(data, (key)=>{
                const tableOptions = dataTables?.find((dataTable)=>dataTable.key === key);
                // The data table options takes precedence over the
                // connector options.
                const { columnIds: columnIds = options.columnIds, firstRowAsNames: firstRowAsNames = options.firstRowAsNames, orientation: orientation = options.orientation, beforeParse: beforeParse = options.beforeParse } = tableOptions || {};
                const converterOptions = {
                    data: data,
                    columnIds: columnIds,
                    firstRowAsNames: firstRowAsNames,
                    orientation: orientation,
                    beforeParse: beforeParse
                };
                return new (0, $h4aBi.default)(converterOptions);
            }, (converter, data)=>converter.parse({
                    data: data
                }));
            return connector.applyTableModifiers().then(()=>data ?? []);
        }).then((data)=>{
            connector.emit({
                type: 'afterLoad',
                detail: eventDetail,
                data: data
            });
            return connector;
        })['catch']((error)=>{
            connector.emit({
                type: 'loadError',
                detail: eventDetail,
                error: error
            });
            throw error;
        });
    }
}
/* *
 *
 *  Static Properties
 *
 * */ $62b2d6e2e7011d67$var$JSONConnector.defaultOptions = {
    type: 'JSON',
    id: 'json-connector',
    data: [],
    enablePolling: false,
    dataRefreshRate: 0,
    firstRowAsNames: true,
    orientation: 'rows'
};
/* *
 *
 *  Registry
 *
 * */ (0, $6GqCF.default).registerType('JSON', $62b2d6e2e7011d67$var$JSONConnector);
var /* *
 *
 *  Default Export
 *
 * */ $62b2d6e2e7011d67$export$2e2bcd8739ae039 = $62b2d6e2e7011d67$var$JSONConnector;

});
parcelRegister("h4aBi", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6cb086fbd795717$export$2e2bcd8739ae039);
/* *
 *
 *  (c) 2009-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Pawel Lysy
 *  - Kamil Kubik
 *
 * */ 
var $5Jprx = parcelRequire("5Jprx");

var $6NwQo = parcelRequire("6NwQo");

var $l3aRA = parcelRequire("l3aRA");
'use strict';
const { error: $c6cb086fbd795717$var$error, isArray: $c6cb086fbd795717$var$isArray, merge: $c6cb086fbd795717$var$merge, objectEach: $c6cb086fbd795717$var$objectEach } = (0, $l3aRA.default);
/* *
 *
 *  Class
 *
 * */ /**
 * Handles parsing and transforming JSON to a table.
 *
 * @private
 */ class $c6cb086fbd795717$var$JSONConverter extends (0, $5Jprx.default) {
    /* *
     *
     *  Constructor
     *
     * */ /**
     * Constructs an instance of the JSON parser.
     *
     * @param {Partial<JSONConverterOptions>} [options]
     * Options for the JSON parser.
     */ constructor(options){
        const mergedOptions = $c6cb086fbd795717$var$merge($c6cb086fbd795717$var$JSONConverter.defaultOptions, options);
        super(mergedOptions);
        /* *
         *
         *  Properties
         *
         * */ this.headerColumnIds = [];
        this.headers = [];
        this.options = mergedOptions;
    }
    /* *
     *
     *  Functions
     *
     * */ /**
     * Initiates parsing of JSON structure.
     *
     * @param {Partial<JSONConverterOptions>}[options]
     * Options for the parser
     *
     * @param {DataEvent.Detail} [eventDetail]
     * Custom information for pending events.
     *
     * @emits JSONConverter#parse
     * @emits JSONConverter#afterParse
     */ parse(options, eventDetail) {
        const converter = this;
        options = $c6cb086fbd795717$var$merge(converter.options, options);
        const { beforeParse: beforeParse, orientation: orientation, firstRowAsNames: firstRowAsNames, columnIds: columnIds } = options;
        let data = options.data;
        if (!data) return {};
        converter.headers = [];
        const columnsArray = [];
        converter.emit({
            type: 'parse',
            columns: columnsArray,
            detail: eventDetail,
            headers: converter.headers
        });
        if (beforeParse) data = beforeParse(data);
        data = data.slice();
        if (orientation === 'columns') this.parseColumnsOrientation(columnsArray, data, firstRowAsNames, columnIds);
        else if (orientation === 'rows') this.parseRowsOrientation(columnsArray, data, firstRowAsNames, columnIds);
        converter.emit({
            type: 'afterParse',
            columns: columnsArray,
            detail: eventDetail,
            headers: converter.headers
        });
        return (0, $6NwQo.default).getColumnsCollection(columnsArray, converter.headers);
    }
    /**
     * Helper for parsing data in 'columns' orientation.
     *
     * @param {DataTable.BasicColumn[]} [columnsArray]
     * Array of columns.
     *
     * @param {unknown[]} [data]
     * Array of data elements.
     *
     * @param {Boolean} [firstRowAsNames]
     * Defines row as names.
     *
     * @param {Array<string>} [columnIds]
     * Column ids to retrieve.
     *
     * @return {void}
     */ parseColumnsOrientation(columnsArray, data, firstRowAsNames, columnIds) {
        const converter = this;
        for(let i = 0, iEnd = data.length; i < iEnd; i++){
            const item = data[i];
            if (!Array.isArray(item)) return;
            if (Array.isArray(converter.headers)) {
                if (firstRowAsNames) converter.headers.push(`${item.shift()}`);
                else if (columnIds && Array.isArray(columnIds)) converter.headers.push(columnIds[i]);
                columnsArray.push(item);
            } else $c6cb086fbd795717$var$error('JSONConverter: Invalid `columnIds` option.', false);
        }
    }
    /**
     * Helper for parsing data in 'rows' orientation.
     *
     * @param {DataTable.BasicColumn[]} [columnsArray]
     * Array of columns.
     *
     * Helper for parsing data in 'rows' orientation.
     *
     * @param {unknown[]} [data]
     * Array of data elements.
     *
     * @param {Boolean} [firstRowAsNames]
     * Defines row as names.
     *
     * @param {Array<string>} [columnIds]
     * Column ids to retrieve.
     *
     * @return {DataTable.BasicColumn[]}
     * Parsed columns.
     */ parseRowsOrientation(columnsArray, data, firstRowAsNames, columnIds) {
        const converter = this;
        if (firstRowAsNames) converter.headers = data.shift();
        else if (columnIds) converter.headerColumnIds = columnIds;
        for(let rowIndex = 0, iEnd = data.length; rowIndex < iEnd; rowIndex++){
            let row = data[rowIndex];
            if (!$c6cb086fbd795717$var$isArray(row)) row = this.convertItemToRow(row, columnIds);
            for(let columnIndex = 0, jEnd = row.length; columnIndex < jEnd; columnIndex++){
                if (columnsArray.length < columnIndex + 1) columnsArray.push([]);
                columnsArray[columnIndex].push(row[columnIndex]);
                // Create headers only once.
                if (!firstRowAsNames && rowIndex === 0) {
                    if (Array.isArray(converter.headerColumnIds)) converter.headers.push(converter.headerColumnIds[columnIndex] || columnIndex.toString());
                    else $c6cb086fbd795717$var$error('JSONConverter: Invalid `columnIds` option.', false);
                }
            }
        }
    }
    /**
     * Extracts a row from an object, using columnIds if provided.
     *
     * @param {Record<string, string|number>} [rowObj]
     * Set of props.
     *
     * @param {Array<string>} [columnIds]
     * Column ids to retrieve.
     *
     * @return {Array<string | number>}
     * Row converted to array.
     */ convertItemToRow(rowObj, columnIds) {
        const converter = this;
        if (columnIds && !Array.isArray(columnIds)) {
            const newRow = [];
            $c6cb086fbd795717$var$objectEach(columnIds, (arrayWithPath, name)=>{
                newRow.push(arrayWithPath.reduce((acc, key)=>acc[key], rowObj));
                if (converter.headers.indexOf(name) < 0) converter.headers.push(name);
            });
            return newRow;
        }
        converter.headerColumnIds = Object.keys(rowObj);
        return Object.values(rowObj);
    }
}
/* *
 *
 *  Static Properties
 *
 * */ /**
 * Default options
 */ $c6cb086fbd795717$var$JSONConverter.defaultOptions = {
    ...(0, $5Jprx.default).defaultOptions,
    orientation: 'rows'
};
(0, $5Jprx.default).registerType('JSON', $c6cb086fbd795717$var$JSONConverter);
var /* *
 *
 *  Default Export
 *
 * */ $c6cb086fbd795717$export$2e2bcd8739ae039 = $c6cb086fbd795717$var$JSONConverter;

});


parcelRegister("7Vf02", function(module, exports) {
/* *
 *
 *  (c) 2009-2025 Highsoft AS
 *
 *  License: www.highcharts.com/license
 *
 *  !!!!!!! SOURCE GETS TRANSPILED BY TYPESCRIPT. EDIT TS FILE ONLY. !!!!!!!
 *
 *  Authors:
 *  - Wojciech Chmiel
 *  - Sophie Bremer
 *
 * */ 
var $7fvOS = parcelRequire("7fvOS");

var $l3aRA = parcelRequire("l3aRA");
'use strict';
const { merge: $5c497de62290f49d$var$merge } = (0, $l3aRA.default);
/* *
 *
 *  Class
 *
 * */ /**
 * Inverts columns and rows in a table.
 *
 * @private
 */ class $5c497de62290f49d$var$InvertModifier extends (0, $7fvOS.default) {
    /* *
     *
     *  Constructor
     *
     * */ /**
     * Constructs an instance of the invert modifier.
     *
     * @param {Partial<InvertModifier.Options>} [options]
     * Options to configure the invert modifier.
     */ constructor(options){
        super();
        this.options = $5c497de62290f49d$var$merge($5c497de62290f49d$var$InvertModifier.defaultOptions, options);
    }
    /* *
     *
     *  Functions
     *
     * */ /**
     * Inverts rows and columns in the table. If the given table does not have
     * defined a `modified` property, the filtering is applied in-place on the
     * original table rather than on a `modified` copy.
     *
     * @param {DataTable} table
     * Table to invert.
     *
     * @param {DataEvent.Detail} [eventDetail]
     * Custom information for pending events.
     *
     * @return {DataTable}
     * Table with inverted `modified` property as a reference or modified table,
     * if `modified` property of the original table is undefined.
     */ modifyTable(table, eventDetail) {
        const modifier = this;
        modifier.emit({
            type: 'modify',
            detail: eventDetail,
            table: table
        });
        const modified = table.getModified();
        if (table.hasColumns([
            'columnIds'
        ])) {
            const columnIdsColumn = (table.deleteColumns([
                'columnIds'
            ]) || {}).columnIds || [], columns = {}, columnIds = [];
            for(let i = 0, iEnd = columnIdsColumn.length; i < iEnd; ++i)columnIds.push('' + columnIdsColumn[i]);
            for(let i = 0, iEnd = table.getRowCount(), row; i < iEnd; ++i){
                row = table.getRow(i);
                if (row) columns[columnIds[i]] = row;
            }
            modified.deleteColumns();
            modified.setColumns(columns);
        } else {
            const columns = {};
            for(let i = 0, iEnd = table.getRowCount(), row; i < iEnd; ++i){
                row = table.getRow(i);
                if (row) columns[`${i}`] = row;
            }
            columns.columnIds = table.getColumnIds();
            modified.deleteColumns();
            modified.setColumns(columns);
        }
        modifier.emit({
            type: 'afterModify',
            detail: eventDetail,
            table: table
        });
        return table;
    }
}
/* *
 *
 *  Static Properties
 *
 * */ /**
 * Default options for the invert modifier.
 */ $5c497de62290f49d$var$InvertModifier.defaultOptions = {
    type: 'Invert'
};
(0, $7fvOS.default).registerType('Invert', $5c497de62290f49d$var$InvertModifier);
var /* *
 *
 *  Default Export
 *
 * */ $5c497de62290f49d$export$2e2bcd8739ae039 = $5c497de62290f49d$var$InvertModifier;

});


parcelRegister("euawG", function(module, exports) {
!/**
 * Highcharts JS v12.4.0 (2025-09-04)
 * @module highcharts/highcharts-more
 * @requires highcharts
 *
 * (c) 2009-2025 Highsoft AS
 *
 * License: www.highcharts.com/license
 */ function(t, e) {
    module.exports = e(t._Highcharts, t._Highcharts.SeriesRegistry, t._Highcharts.Series, t._Highcharts.Series.types.column, t._Highcharts.Templating, t._Highcharts.Point, t._Highcharts.Color, t._Highcharts.Chart, t._Highcharts.SVGElement, t._Highcharts.StackItem);
}("undefined" == typeof window ? module.exports : window, (t, e, i, s, a, o, r, n, l, h)=>(()=>{
        "use strict";
        var p, d, c, u = {
            28: (t)=>{
                t.exports = l;
            },
            184: (t)=>{
                t.exports = h;
            },
            260: (t)=>{
                t.exports = o;
            },
            448: (t)=>{
                t.exports = s;
            },
            512: (t)=>{
                t.exports = e;
            },
            620: (t)=>{
                t.exports = r;
            },
            820: (t)=>{
                t.exports = i;
            },
            944: (e)=>{
                e.exports = t;
            },
            960: (t)=>{
                t.exports = n;
            },
            984: (t)=>{
                t.exports = a;
            }
        }, g = {};
        function f(t) {
            var e = g[t];
            if (void 0 !== e) return e.exports;
            var i = g[t] = {
                exports: {}
            };
            return u[t](i, i.exports, f), i.exports;
        }
        f.n = (t)=>{
            var e = t && t.__esModule ? ()=>t.default : ()=>t;
            return f.d(e, {
                a: e
            }), e;
        }, f.d = (t, e)=>{
            for(var i in e)f.o(e, i) && !f.o(t, i) && Object.defineProperty(t, i, {
                enumerable: !0,
                get: e[i]
            });
        }, f.o = (t, e)=>Object.prototype.hasOwnProperty.call(t, e);
        var m = {};
        f.d(m, {
            default: ()=>ak
        });
        var b = f(944), y = f.n(b), x = f(512), P = f.n(x), M = f(820), v = f.n(M);
        let { deg2rad: L } = y(), { fireEvent: k, isNumber: w, pick: A, relativeLength: S } = y();
        !function(t) {
            t.getCenter = function() {
                let t = this.options, e = this.chart, i = 2 * (t.slicedOffset || 0), s = e.plotWidth - 2 * i, a = e.plotHeight - 2 * i, o = t.center, r = Math.min(s, a), n = t.thickness, l, h = t.size, p = t.innerSize || 0, d, c;
                "string" == typeof h && (h = parseFloat(h)), "string" == typeof p && (p = parseFloat(p));
                let u = [
                    A(o?.[0], "50%"),
                    A(o?.[1], "50%"),
                    A(h && h < 0 ? void 0 : t.size, "100%"),
                    A(p && p < 0 ? void 0 : t.innerSize || 0, "0%")
                ];
                for(!e.angular || this instanceof v() || (u[3] = 0), d = 0; d < 4; ++d)c = u[d], l = d < 2 || 2 === d && /%$/.test(c), u[d] = S(c, [
                    s,
                    a,
                    r,
                    u[2]
                ][d]) + (l ? i : 0);
                return u[3] > u[2] && (u[3] = u[2]), w(n) && 2 * n < u[2] && n > 0 && (u[3] = u[2] - 2 * n), k(this, "afterGetCenter", {
                    positions: u
                }), u;
            }, t.getStartAndEndRadians = function(t, e) {
                let i = w(t) ? t : 0, s = w(e) && e > i && e - i < 360 ? e : i + 360;
                return {
                    start: L * (i + -90),
                    end: L * (s + -90)
                };
            };
        }(p || (p = {}));
        let T = p, { addEvent: C, correctFloat: N, defined: X, pick: Y } = y();
        function R(t) {
            let e, i = this;
            return t && i.pane.forEach((s)=>{
                I(t.chartX - i.plotLeft, t.chartY - i.plotTop, s.center) && (e = s);
            }), e;
        }
        function I(t, e, i, s, a) {
            let o = !0, r = i[0], n = i[1], l = 2 * Math.PI, h = Math.sqrt(Math.pow(t - r, 2) + Math.pow(e - n, 2));
            if (X(s) && X(a)) {
                let i = Math.atan2(N(e - n, 8), N(t - r, 8));
                i = (i + l) % l, s = (s + l) % l, Math.abs((a = (a + l) % l) - s) > 1e-6 && (o = s > a ? i >= s || i <= a : i >= s && i <= a);
            } else o = !0;
            return h <= Math.ceil(i[2] / 2) && o;
        }
        function E(t) {
            this.polar && (t.options.inverted && ([t.x, t.y] = [
                t.y,
                t.x
            ]), t.isInsidePlot = this.pane.some((e)=>I(t.x, t.y, e.center, e.axis && e.axis.normalizedStartAngleRad, e.axis && e.axis.normalizedEndAngleRad)));
        }
        function D(t) {
            let e = this.chart;
            t.hoverPoint && t.hoverPoint.plotX && t.hoverPoint.plotY && e.hoverPane && !I(t.hoverPoint.plotX, t.hoverPoint.plotY, e.hoverPane.center) && (t.hoverPoint = void 0);
        }
        function z(t) {
            let e = this.chart;
            e.polar ? (e.hoverPane = e.getHoverPane(t), t.filter = function(i) {
                return i.visible && !(!t.shared && i.directTouch) && Y(i.options.enableMouseTracking, !0) && (!e.hoverPane || i.xAxis.pane === e.hoverPane);
            }) : e.hoverPane = void 0;
        }
        let { defaultOptions: O } = y(), H = {
            shape: "circle",
            borderRadius: 0,
            borderWidth: 1,
            borderColor: "#cccccc",
            backgroundColor: {
                linearGradient: {
                    x1: 0,
                    y1: 0,
                    x2: 0,
                    y2: 1
                },
                stops: [
                    [
                        0,
                        "#ffffff"
                    ],
                    [
                        1,
                        "#e6e6e6"
                    ]
                ]
            },
            from: -Number.MAX_VALUE,
            innerRadius: 0,
            to: Number.MAX_VALUE,
            outerRadius: "105%"
        }, B = {
            background: H,
            center: [
                "50%",
                "50%"
            ],
            size: "85%",
            innerSize: "0%",
            startAngle: 0
        };
        O.pane = B;
        let W = {
            pane: B,
            background: H
        }, { extend: F, merge: G, splat: q } = y();
        class V {
            constructor(t, e){
                this.coll = "pane", this.init(t, e);
            }
            init(t, e) {
                this.chart = e, this.background = [], e.pane.push(this), this.setOptions(t);
            }
            setOptions(t) {
                this.options = t = G(W.pane, {
                    background: this.chart.angular ? {} : void 0
                }, t);
            }
            render() {
                let t = this.options, e = this.chart.renderer;
                this.group || (this.group = e.g("pane-group").attr({
                    zIndex: t.zIndex || 0
                }).add()), this.updateCenter();
                let i = this.options.background;
                if (i) {
                    let t = Math.max((i = q(i)).length, this.background.length || 0);
                    for(let e = 0; e < t; e++)i[e] && this.axis ? this.renderBackground(G(W.background, i[e]), e) : this.background[e] && (this.background[e] = this.background[e].destroy(), this.background.splice(e, 1));
                }
            }
            renderBackground(t, e) {
                let i = {
                    class: "highcharts-pane " + (t.className || "")
                }, s = "animate";
                this.chart.styledMode || F(i, {
                    fill: t.backgroundColor,
                    stroke: t.borderColor,
                    "stroke-width": t.borderWidth
                }), this.background[e] || (this.background[e] = this.chart.renderer.path().add(this.group), s = "attr"), this.background[e][s]({
                    d: this.axis.getPlotBandPath(t.from, t.to, t)
                }).attr(i);
            }
            updateCenter(t) {
                this.center = (t || this.axis || {}).center = T.getCenter.call(this);
            }
            update(t, e) {
                G(!0, this.options, t), this.setOptions(this.options), this.render(), this.chart.axes.forEach(function(t) {
                    t.pane === this && (t.pane = null, t.update({}, e));
                }, this);
            }
        }
        V.compose = function(t, e) {
            let i = t.prototype;
            i.getHoverPane || (i.collectionsWithUpdate.push("pane"), i.getHoverPane = R, C(t, "afterIsInsidePlot", E), C(e, "afterGetHoverData", D), C(e, "beforeGetHoverData", z));
        };
        let { area: { prototype: { pointClass: _, pointClass: { prototype: U } } } } = P().seriesTypes, { defined: K, isNumber: j } = y(), Z = class extends _ {
            setState() {
                let t = this.state, e = this.series, i = e.chart.polar;
                K(this.plotHigh) || (this.plotHigh = e.yAxis.toPixels(this.high, !0)), K(this.plotLow) || (this.plotLow = this.plotY = e.yAxis.toPixels(this.low, !0)), e.lowerStateMarkerGraphic = e.stateMarkerGraphic, e.stateMarkerGraphic = e.upperStateMarkerGraphic, this.graphic = this.graphics && this.graphics[1], this.plotY = this.plotHigh, i && j(this.plotHighX) && (this.plotX = this.plotHighX), U.setState.apply(this, arguments), this.state = t, this.plotY = this.plotLow, this.graphic = this.graphics && this.graphics[0], i && j(this.plotLowX) && (this.plotX = this.plotLowX), e.upperStateMarkerGraphic = e.stateMarkerGraphic, e.stateMarkerGraphic = e.lowerStateMarkerGraphic, e.lowerStateMarkerGraphic = void 0;
                let s = e.modifyMarkerSettings();
                U.setState.apply(this, arguments), e.restoreMarkerSettings(s);
            }
            haloPath() {
                let t = this.series.chart.polar, e = [];
                return this.plotY = this.plotLow, t && j(this.plotLowX) && (this.plotX = this.plotLowX), this.isInside && (e = U.haloPath.apply(this, arguments)), this.plotY = this.plotHigh, t && j(this.plotHighX) && (this.plotX = this.plotHighX), this.isTopInside && (e = e.concat(U.haloPath.apply(this, arguments))), e;
            }
            isValid() {
                return j(this.low) && j(this.high);
            }
        }, { noop: $ } = y(), { area: Q, area: { prototype: J }, column: { prototype: tt } } = P().seriesTypes, { addEvent: te, defined: ti, extend: ts, isArray: ta, isNumber: to, pick: tr, merge: tn } = y();
        class tl extends Q {
            toYData(t) {
                return [
                    t.low,
                    t.high
                ];
            }
            highToXY(t) {
                let e = this.chart, i = this.xAxis.postTranslate(t.rectPlotX || 0, this.yAxis.len - (t.plotHigh || 0));
                t.plotHighX = i.x - e.plotLeft, t.plotHigh = i.y - e.plotTop, t.plotLowX = t.plotX;
            }
            getGraphPath(t) {
                let e = [], i = [], s = J.getGraphPath, a = this.options, o = this.chart.polar, r = o && !1 !== a.connectEnds, n = a.connectNulls, l, h, p, d = a.step;
                for(l = (t = t || this.points).length; l--;){
                    h = t[l];
                    let s = o ? {
                        plotX: h.rectPlotX,
                        plotY: h.yBottom,
                        doCurve: !1
                    } : {
                        plotX: h.plotX,
                        plotY: h.plotY,
                        doCurve: !1
                    };
                    h.isNull || r || n || t[l + 1] && !t[l + 1].isNull || i.push(s), p = {
                        polarPlotY: h.polarPlotY,
                        rectPlotX: h.rectPlotX,
                        yBottom: h.yBottom,
                        plotX: tr(h.plotHighX, h.plotX),
                        plotY: h.plotHigh,
                        isNull: h.isNull
                    }, i.push(p), e.push(p), h.isNull || r || n || t[l - 1] && !t[l - 1].isNull || i.push(s);
                }
                let c = s.call(this, t);
                d && (!0 === d && (d = "left"), a.step = ({
                    left: "right",
                    center: "center",
                    right: "left"
                })[d]);
                let u = s.call(this, e), g = s.call(this, i);
                a.step = d;
                let f = [].concat(c, u);
                return !this.chart.polar && g[0] && "M" === g[0][0] && (g[0] = [
                    "L",
                    g[0][1],
                    g[0][2]
                ]), this.graphPath = f, this.areaPath = c.concat(g), f.isArea = !0, f.xMap = c.xMap, this.areaPath.xMap = c.xMap, f;
            }
            drawDataLabels() {
                let t, e, i, s, a, o = this.points, r = o.length, n = [], l = this.options.dataLabels, h = this.chart.inverted;
                if (l) {
                    if (ta(l) ? (s = l[0] || {
                        enabled: !1
                    }, a = l[1] || {
                        enabled: !1
                    }) : ((s = ts({}, l)).x = l.xHigh, s.y = l.yHigh, (a = ts({}, l)).x = l.xLow, a.y = l.yLow), s.enabled || this.hasDataLabels?.()) {
                        for(t = r; t--;)if (e = o[t]) {
                            let { plotHigh: a = 0, plotLow: o = 0 } = e;
                            i = s.inside ? a < o : a > o, e.y = e.high, e._plotY = e.plotY, e.plotY = a, n[t] = e.dataLabel, e.dataLabel = e.dataLabelUpper, e.below = i, h ? s.align || (s.align = i ? "right" : "left") : s.verticalAlign || (s.verticalAlign = i ? "top" : "bottom");
                        }
                        for(this.options.dataLabels = s, J.drawDataLabels && J.drawDataLabels.apply(this, arguments), t = r; t--;)(e = o[t]) && (e.dataLabelUpper = e.dataLabel, e.dataLabel = n[t], delete e.dataLabels, e.y = e.low, e.plotY = e._plotY);
                    }
                    if (a.enabled || this.hasDataLabels?.()) {
                        for(t = r; t--;)if (e = o[t]) {
                            let { plotHigh: t = 0, plotLow: s = 0 } = e;
                            i = a.inside ? t < s : t > s, e.below = !i, h ? a.align || (a.align = i ? "left" : "right") : a.verticalAlign || (a.verticalAlign = i ? "bottom" : "top");
                        }
                        this.options.dataLabels = a, J.drawDataLabels && J.drawDataLabels.apply(this, arguments);
                    }
                    if (s.enabled) for(t = r; t--;)(e = o[t]) && (e.dataLabels = [
                        e.dataLabelUpper,
                        e.dataLabel
                    ].filter(function(t) {
                        return !!t;
                    }));
                    this.options.dataLabels = l;
                }
            }
            alignDataLabel() {
                tt.alignDataLabel.apply(this, arguments);
            }
            modifyMarkerSettings() {
                let t = {
                    marker: this.options.marker,
                    symbol: this.symbol
                };
                if (this.options.lowMarker) {
                    let { options: { marker: t, lowMarker: e } } = this;
                    this.options.marker = tn(t, e), e.symbol && (this.symbol = e.symbol);
                }
                return t;
            }
            restoreMarkerSettings(t) {
                this.options.marker = t.marker, this.symbol = t.symbol;
            }
            drawPoints() {
                let t, e, i = this.points.length, s = this.modifyMarkerSettings();
                for(J.drawPoints.apply(this, arguments), this.restoreMarkerSettings(s), t = 0; t < i;)(e = this.points[t]).graphics = e.graphics || [], e.origProps = {
                    plotY: e.plotY,
                    plotX: e.plotX,
                    isInside: e.isInside,
                    negative: e.negative,
                    zone: e.zone,
                    y: e.y
                }, (e.graphic || e.graphics[0]) && (e.graphics[0] = e.graphic), e.graphic = e.graphics[1], e.plotY = e.plotHigh, ti(e.plotHighX) && (e.plotX = e.plotHighX), e.y = tr(e.high, e.origProps.y), e.negative = e.y < (this.options.threshold || 0), this.zones.length && (e.zone = e.getZone()), this.chart.polar || (e.isInside = e.isTopInside = void 0 !== e.plotY && e.plotY >= 0 && e.plotY <= this.yAxis.len && e.plotX >= 0 && e.plotX <= this.xAxis.len), t++;
                for(J.drawPoints.apply(this, arguments), t = 0; t < i;)(e = this.points[t]).graphics = e.graphics || [], (e.graphic || e.graphics[1]) && (e.graphics[1] = e.graphic), e.graphic = e.graphics[0], e.origProps && (ts(e, e.origProps), delete e.origProps), t++;
            }
            hasMarkerChanged(t, e) {
                let i = t.lowMarker, s = e.lowMarker || {};
                return i && (!1 === i.enabled || s.symbol !== i.symbol || s.height !== i.height || s.width !== i.width) || super.hasMarkerChanged(t, e);
            }
        }
        tl.defaultOptions = tn(Q.defaultOptions, {
            lineWidth: 1,
            threshold: null,
            tooltip: {
                pointFormat: '<span style="color:{series.color}">\u25CF</span> {series.name}: <b>{point.low}</b> - <b>{point.high}</b><br/>'
            },
            trackByArea: !0,
            dataLabels: {
                align: void 0,
                verticalAlign: void 0,
                xLow: 0,
                xHigh: 0,
                yLow: 0,
                yHigh: 0
            }
        }), te(tl, "afterTranslate", function() {
            "low,high" === this.pointArrayMap.join(",") && this.points.forEach((t)=>{
                let e = t.high, i = t.plotY;
                t.isNull ? t.plotY = void 0 : (t.plotLow = i, t.plotHigh = to(e) ? this.yAxis.translate(this.dataModify ? this.dataModify.modifyValue(e) : e, !1, !0, void 0, !0) : void 0, this.dataModify && (t.yBottom = t.plotHigh));
            });
        }, {
            order: 0
        }), te(tl, "afterTranslate", function() {
            this.points.forEach((t)=>{
                if (this.chart.polar) this.highToXY(t), t.plotLow = t.plotY, t.tooltipPos = [
                    ((t.plotHighX || 0) + (t.plotLowX || 0)) / 2,
                    ((t.plotHigh || 0) + (t.plotLow || 0)) / 2
                ];
                else {
                    let e = t.pos(!1, t.plotLow), i = t.pos(!1, t.plotHigh);
                    e && i && (e[0] = (e[0] + i[0]) / 2, e[1] = (e[1] + i[1]) / 2), t.tooltipPos = e;
                }
            });
        }, {
            order: 3
        }), ts(tl.prototype, {
            deferTranslatePolar: !0,
            pointArrayMap: [
                "low",
                "high"
            ],
            pointClass: Z,
            pointValKey: "low",
            setStackedPoints: $
        }), P().registerSeriesType("arearange", tl);
        let th = tl, { spline: { prototype: tp } } = P().seriesTypes, { merge: td, extend: tc } = y();
        class tu extends th {
        }
        tu.defaultOptions = td(th.defaultOptions), tc(tu.prototype, {
            getPointSpline: tp.getPointSpline
        }), P().registerSeriesType("areasplinerange", tu);
        var tg = f(448), tf = f.n(tg);
        let { noop: tm } = y(), { crisp: tb, extend: ty, merge: tx, pick: tP, relativeLength: tM } = y();
        class tv extends tf() {
            pointAttribs() {
                return {};
            }
            getWhiskerPair(t, e, i, s, a) {
                let o = a.whiskers.strokeWidth(), r = (i, s)=>{
                    let a = tM(i, 2 * t) / 2, r = tb(s, o);
                    return [
                        [
                            "M",
                            tb(e - a),
                            r
                        ],
                        [
                            "L",
                            tb(e + a),
                            r
                        ]
                    ];
                };
                return [
                    ...r(i, a.highPlot),
                    ...r(s, a.lowPlot)
                ];
            }
            translate() {
                let t = this.yAxis, e = this.pointArrayMap;
                super.translate.apply(this), this.points.forEach(function(i) {
                    e.forEach(function(e) {
                        null !== i[e] && (i[e + "Plot"] = t.translate(i[e], 0, 1, 0, 1));
                    }), i.plotHigh = i.highPlot;
                });
            }
            drawPoints() {
                let t, e, i, s, a, o, r, n, l, h, p, d = this.points, c = this.options, u = this.chart, g = u.renderer, f = !1 !== this.doQuartiles, m = this.options.whiskerLength;
                for (let b of d){
                    let d = (n = b.graphic) ? "animate" : "attr", y = b.shapeArgs, x = {}, P = {}, M = {}, v = {}, L = b.color || this.color, k = b.options.whiskerLength || m;
                    if (void 0 !== b.plotY) {
                        let w;
                        l = y.width, p = (h = y.x) + l, t = f ? b.q1Plot : b.lowPlot, e = f ? b.q3Plot : b.lowPlot, i = b.highPlot, s = b.lowPlot, n || (b.graphic = n = g.g("point").add(this.group), b.stem = g.path().addClass("highcharts-boxplot-stem").add(n), m && (b.whiskers = g.path().addClass("highcharts-boxplot-whisker").add(n)), f && (b.box = g.path(r).addClass("highcharts-boxplot-box").add(n)), b.medianShape = g.path(o).addClass("highcharts-boxplot-median").add(n)), u.styledMode || (P.stroke = b.stemColor || c.stemColor || L, P["stroke-width"] = tP(b.stemWidth, c.stemWidth, c.lineWidth), P.dashstyle = b.stemDashStyle || c.stemDashStyle || c.dashStyle, b.stem.attr(P), k && (M.stroke = b.whiskerColor || c.whiskerColor || L, M["stroke-width"] = tP(b.whiskerWidth, c.whiskerWidth, c.lineWidth), M.dashstyle = b.whiskerDashStyle || c.whiskerDashStyle || c.dashStyle, b.whiskers.attr(M)), f && (x.fill = b.fillColor || c.fillColor || L, x.stroke = c.lineColor || L, x["stroke-width"] = c.lineWidth || 0, x.dashstyle = b.boxDashStyle || c.boxDashStyle || c.dashStyle, b.box.attr(x)), v.stroke = b.medianColor || c.medianColor || L, v["stroke-width"] = tP(b.medianWidth, c.medianWidth, c.lineWidth), v.dashstyle = b.medianDashStyle || c.medianDashStyle || c.dashStyle, b.medianShape.attr(v));
                        let A = tb((b.plotX || 0) + (this.pointXOffset || 0) + (this.barW || 0) / 2, b.stem.strokeWidth());
                        if (w = [
                            [
                                "M",
                                A,
                                e
                            ],
                            [
                                "L",
                                A,
                                i
                            ],
                            [
                                "M",
                                A,
                                t
                            ],
                            [
                                "L",
                                A,
                                s
                            ]
                        ], b.stem[d]({
                            d: w
                        }), f) {
                            let i = b.box.strokeWidth();
                            t = tb(t, i), e = tb(e, i), w = [
                                [
                                    "M",
                                    h = tb(h, i),
                                    e
                                ],
                                [
                                    "L",
                                    h,
                                    t
                                ],
                                [
                                    "L",
                                    p = tb(p, i),
                                    t
                                ],
                                [
                                    "L",
                                    p,
                                    e
                                ],
                                [
                                    "L",
                                    h,
                                    e
                                ],
                                [
                                    "Z"
                                ]
                            ], b.box[d]({
                                d: w
                            });
                        }
                        if (k) {
                            let t = l / 2, e = this.getWhiskerPair(t, A, b.upperWhiskerLength ?? c.upperWhiskerLength ?? k, b.lowerWhiskerLength ?? c.lowerWhiskerLength ?? k, b);
                            b.whiskers[d]({
                                d: e
                            });
                        }
                        w = [
                            [
                                "M",
                                h,
                                a = tb(b.medianPlot, b.medianShape.strokeWidth())
                            ],
                            [
                                "L",
                                p,
                                a
                            ]
                        ], b.medianShape[d]({
                            d: w
                        });
                    }
                }
            }
            toYData(t) {
                return [
                    t.low,
                    t.q1,
                    t.median,
                    t.q3,
                    t.high
                ];
            }
        }
        tv.defaultOptions = tx(tf().defaultOptions, {
            threshold: null,
            tooltip: {
                pointFormat: '<span style="color:{point.color}">\u25CF</span> <b>{series.name}</b><br/>Maximum: {point.high}<br/>Upper quartile: {point.q3}<br/>Median: {point.median}<br/>Lower quartile: {point.q1}<br/>Minimum: {point.low}<br/>'
            },
            whiskerLength: "50%",
            fillColor: "#ffffff",
            lineWidth: 1,
            medianWidth: 2,
            whiskerWidth: 2
        }), ty(tv.prototype, {
            pointArrayMap: [
                "low",
                "q1",
                "median",
                "q3",
                "high"
            ],
            pointValKey: "high",
            drawDataLabels: tm,
            setStackedPoints: tm
        }), P().registerSeriesType("boxplot", tv);
        let tL = tv, tk = {
            borderColor: void 0,
            borderWidth: 2,
            className: void 0,
            color: void 0,
            connectorClassName: void 0,
            connectorColor: void 0,
            connectorDistance: 60,
            connectorWidth: 1,
            enabled: !1,
            labels: {
                className: void 0,
                allowOverlap: !1,
                format: "",
                formatter: void 0,
                align: "right",
                style: {
                    fontSize: "0.9em",
                    color: "#000000"
                },
                x: 0,
                y: 0
            },
            maxSize: 60,
            minSize: 10,
            legendIndex: 0,
            ranges: {
                value: void 0,
                borderColor: void 0,
                color: void 0,
                connectorColor: void 0
            },
            sizeBy: "area",
            sizeByAbsoluteValue: !1,
            zIndex: 1,
            zThreshold: 0
        };
        var tw = f(984), tA = f.n(tw);
        let { noop: tS } = y(), { arrayMax: tT, arrayMin: tC, isNumber: tN, merge: tX, pick: tY, stableSort: tR } = y(), tI = class {
            constructor(t, e){
                this.setState = tS, this.init(t, e);
            }
            init(t, e) {
                this.options = t, this.visible = !0, this.chart = e.chart, this.legend = e;
            }
            addToLegend(t) {
                t.splice(this.options.legendIndex, 0, this);
            }
            drawLegendSymbol(t) {
                let e, i = tY(t.options.itemDistance, 20), s = this.legendItem || {}, a = this.options, o = a.ranges, r = a.connectorDistance;
                if (!o || !o.length || !tN(o[0].value)) {
                    t.options.bubbleLegend.autoRanges = !0;
                    return;
                }
                tR(o, function(t, e) {
                    return e.value - t.value;
                }), this.ranges = o, this.setOptions(), this.render();
                let n = this.getMaxLabelSize(), l = this.ranges[0].radius, h = 2 * l;
                e = (e = r - l + n.width) > 0 ? e : 0, this.maxLabel = n, this.movementX = "left" === a.labels.align ? e : 0, s.labelWidth = h + e + i, s.labelHeight = h + n.height / 2;
            }
            setOptions() {
                let t = this.ranges, e = this.options, i = this.chart.series[e.seriesIndex], s = this.legend.baseline, a = {
                    zIndex: e.zIndex,
                    "stroke-width": e.borderWidth
                }, o = {
                    zIndex: e.zIndex,
                    "stroke-width": e.connectorWidth
                }, r = {
                    align: this.legend.options.rtl || "left" === e.labels.align ? "right" : "left",
                    zIndex: e.zIndex
                }, n = i.options.marker.fillOpacity, l = this.chart.styledMode;
                t.forEach(function(h, p) {
                    l || (a.stroke = tY(h.borderColor, e.borderColor, i.color), a.fill = h.color || e.color, a.fill || (a.fill = i.color, a["fill-opacity"] = n ?? 1), o.stroke = tY(h.connectorColor, e.connectorColor, i.color)), t[p].radius = this.getRangeRadius(h.value), t[p] = tX(t[p], {
                        center: t[0].radius - t[p].radius + s
                    }), l || tX(!0, t[p], {
                        bubbleAttribs: tX(a),
                        connectorAttribs: tX(o),
                        labelAttribs: r
                    });
                }, this);
            }
            getRangeRadius(t) {
                let e = this.options, i = this.options.seriesIndex, s = this.chart.series[i], a = e.ranges[0].value, o = e.ranges[e.ranges.length - 1].value, r = e.minSize, n = e.maxSize;
                return s.getRadius.call(this, o, a, r, n, t);
            }
            render() {
                let t = this.legendItem || {}, e = this.chart.renderer, i = this.options.zThreshold;
                for (let s of (this.symbols || (this.symbols = {
                    connectors: [],
                    bubbleItems: [],
                    labels: []
                }), t.symbol = e.g("bubble-legend"), t.label = e.g("bubble-legend-item").css(this.legend.itemStyle || {}), t.symbol.translateX = 0, t.symbol.translateY = 0, t.symbol.add(t.label), t.label.add(t.group), this.ranges))s.value >= i && this.renderRange(s);
                this.hideOverlappingLabels();
            }
            renderRange(t) {
                let e = this.ranges[0], i = this.legend, s = this.options, a = s.labels, o = this.chart, r = o.series[s.seriesIndex], n = o.renderer, l = this.symbols, h = l.labels, p = t.center, d = Math.abs(t.radius), c = s.connectorDistance || 0, u = a.align, g = i.options.rtl, f = s.borderWidth, m = s.connectorWidth, b = e.radius || 0, y = p - d - f / 2 + m / 2, x = (y % 1 ? 1 : .5) - (m % 2 ? 0 : .5), P = n.styledMode, M = g || "left" === u ? -c : c;
                "center" === u && (M = 0, s.connectorDistance = 0, t.labelAttribs.align = "center"), l.bubbleItems.push(n.circle(b, p + x, d).attr(P ? {} : t.bubbleAttribs).addClass((P ? "highcharts-color-" + r.colorIndex + " " : "") + "highcharts-bubble-legend-symbol " + (s.className || "")).add(this.legendItem.symbol)), l.connectors.push(n.path(n.crispLine([
                    [
                        "M",
                        b,
                        y
                    ],
                    [
                        "L",
                        b + M,
                        y
                    ]
                ], s.connectorWidth)).attr(P ? {} : t.connectorAttribs).addClass((P ? "highcharts-color-" + this.options.seriesIndex + " " : "") + "highcharts-bubble-legend-connectors " + (s.connectorClassName || "")).add(this.legendItem.symbol));
                let v = n.text(this.formatLabel(t)).attr(P ? {} : t.labelAttribs).css(P ? {} : a.style).addClass("highcharts-bubble-legend-labels " + (s.labels.className || "")).add(this.legendItem.symbol), L = {
                    x: b + M + s.labels.x,
                    y: y + s.labels.y + .4 * v.getBBox().height
                };
                v.attr(L), h.push(v), v.placed = !0, v.alignAttr = L;
            }
            getMaxLabelSize() {
                let t, e;
                return this.symbols.labels.forEach(function(i) {
                    e = i.getBBox(!0), t = t ? e.width > t.width ? e : t : e;
                }), t || {};
            }
            formatLabel(t) {
                let e = this.options, i = e.labels.formatter, s = e.labels.format, { numberFormatter: a } = this.chart;
                return s ? tA().format(s, t, this.chart) : i ? i.call(t) : a(t.value, 1);
            }
            hideOverlappingLabels() {
                let t = this.chart, e = this.options.labels.allowOverlap, i = this.symbols;
                !e && i && (t.hideOverlappingLabels(i.labels), i.labels.forEach(function(t, e) {
                    t.newOpacity ? t.newOpacity !== t.oldOpacity && i.connectors[e].show() : i.connectors[e].hide();
                }));
            }
            getRanges() {
                let t = this.legend.bubbleLegend, e = t.chart.series, i = t.options.ranges, s, a, o = Number.MAX_VALUE, r = -Number.MAX_VALUE;
                return e.forEach(function(t) {
                    t.isBubble && !t.ignoreSeries && (a = t.getColumn("z").filter(tN)).length && (o = tY(t.options.zMin, Math.min(o, Math.max(tC(a), !1 === t.options.displayNegative ? t.options.zThreshold : -Number.MAX_VALUE))), r = tY(t.options.zMax, Math.max(r, tT(a))));
                }), s = o === r ? [
                    {
                        value: r
                    }
                ] : [
                    {
                        value: o
                    },
                    {
                        value: (o + r) / 2
                    },
                    {
                        value: r,
                        autoRanges: !0
                    }
                ], i.length && i[0].radius && s.reverse(), s.forEach(function(t, e) {
                    i && i[e] && (s[e] = tX(i[e], t));
                }), s;
            }
            predictBubbleSizes() {
                let t = this.chart, e = t.legend.options, i = e.floating, s = "horizontal" === e.layout, a = s ? t.legend.lastLineHeight : 0, o = t.plotSizeX, r = t.plotSizeY, n = t.series[this.options.seriesIndex], l = n.getPxExtremes(), h = Math.ceil(l.minPxSize), p = Math.ceil(l.maxPxSize), d = Math.min(r, o), c, u = n.options.maxSize;
                return i || !/%$/.test(u) ? c = p : (c = (d + a) * (u = parseFloat(u)) / 100 / (u / 100 + 1), (s && r - c >= o || !s && o - c >= r) && (c = p)), [
                    h,
                    Math.ceil(c)
                ];
            }
            updateRanges(t, e) {
                let i = this.legend.options.bubbleLegend;
                i.minSize = t, i.maxSize = e, i.ranges = this.getRanges();
            }
            correctSizes() {
                let t = this.legend, e = this.chart.series[this.options.seriesIndex].getPxExtremes();
                Math.abs(Math.ceil(e.maxPxSize) - this.options.maxSize) > 1 && (this.updateRanges(this.options.minSize, e.maxPxSize), t.render());
            }
        }, { setOptions: tE } = y(), { composed: tD } = y(), { addEvent: tz, objectEach: tO, pushUnique: tH, wrap: tB } = y();
        function tW(t, e, i) {
            let s, a, o, r = this.legend, n = tF(this) >= 0;
            r && r.options.enabled && r.bubbleLegend && r.options.bubbleLegend.autoRanges && n ? (s = r.bubbleLegend.options, a = r.bubbleLegend.predictBubbleSizes(), r.bubbleLegend.updateRanges(a[0], a[1]), s.placed || (r.group.placed = !1, r.allItems.forEach((t)=>{
                (o = t.legendItem || {}).group && (o.group.translateY = void 0);
            })), r.render(), s.placed || (this.getMargins(), this.axes.forEach((t)=>{
                t.setScale(), t.updateNames(), tO(t.ticks, function(t) {
                    t.isNew = !0, t.isNewLabel = !0;
                });
            }), this.getMargins()), s.placed = !0, t.call(this, e, i), r.bubbleLegend.correctSizes(), t_(r, tG(r))) : (t.call(this, e, i), r && r.options.enabled && r.bubbleLegend && (r.render(), t_(r, tG(r))));
        }
        function tF(t) {
            let e = t.series, i = 0;
            for(; i < e.length;){
                if (e[i] && e[i].isBubble && e[i].visible && e[i].dataTable.rowCount) return i;
                i++;
            }
            return -1;
        }
        function tG(t) {
            let e = t.allItems, i = [], s = e.length, a, o, r, n = 0, l = 0;
            for(n = 0; n < s; n++)if (o = e[n].legendItem || {}, r = (e[n + 1] || {}).legendItem || {}, o.labelHeight && (e[n].itemHeight = o.labelHeight), e[n] === e[s - 1] || o.y !== r.y) {
                for(i.push({
                    height: 0
                }), a = i[i.length - 1]; l <= n; l++)e[l].itemHeight > a.height && (a.height = e[l].itemHeight);
                a.step = n;
            }
            return i;
        }
        function tq(t) {
            let e = this.bubbleLegend, i = this.options, s = i.bubbleLegend, a = tF(this.chart);
            e && e.ranges && e.ranges.length && (s.ranges.length && (s.autoRanges = !!s.ranges[0].autoRanges), this.destroyItem(e)), a >= 0 && i.enabled && s.enabled && (s.seriesIndex = a, this.bubbleLegend = new tI(s, this), this.bubbleLegend.addToLegend(t.allItems));
        }
        function tV(t) {
            let e;
            if (t.defaultPrevented) return !1;
            let i = t.legendItem, s = this.chart, a = i.visible;
            this && this.bubbleLegend && (i.visible = !a, i.ignoreSeries = a, e = tF(s) >= 0, this.bubbleLegend.visible !== e && (this.update({
                bubbleLegend: {
                    enabled: e
                }
            }), this.bubbleLegend.visible = e), i.visible = a);
        }
        function t_(t, e) {
            let i = t.allItems, s = t.options.rtl, a, o, r, n, l = 0;
            i.forEach((t, i)=>{
                (n = t.legendItem || {}).group && (a = n.group.translateX || 0, o = n.y || 0, ((r = t.movementX) || s && t.ranges) && (r = s ? a - t.options.maxSize / 2 : a + r, n.group.attr({
                    translateX: r
                })), i > e[l].step && l++, n.group.attr({
                    translateY: Math.round(o + e[l].height / 2)
                }), n.y = o + e[l].height / 2);
            });
        }
        let tU = {
            compose: function(t, e) {
                tH(tD, "Series.BubbleLegend") && (tE({
                    legend: {
                        bubbleLegend: tk
                    }
                }), tB(t.prototype, "drawChartBox", tW), tz(e, "afterGetAllItems", tq), tz(e, "itemClick", tV));
            }
        };
        var tK = f(260), tj = f.n(tK);
        let { seriesTypes: { scatter: { prototype: { pointClass: tZ } } } } = P(), { extend: t$ } = y();
        class tQ extends tZ {
            haloPath(t) {
                let e = (t && this.marker && this.marker.radius || 0) + t;
                if (this.series.chart.inverted) {
                    let t = this.pos() || [
                        0,
                        0
                    ], { xAxis: i, yAxis: s, chart: a } = this.series, o = 2 * e;
                    return a.renderer.symbols.circle((i?.len || 0) - t[1] - e, (s?.len || 0) - t[0] - e, o, o);
                }
                return tj().prototype.haloPath.call(this, e);
            }
        }
        t$(tQ.prototype, {
            ttBelow: !1
        });
        let { composed: tJ, noop: t0 } = y(), { series: t1, seriesTypes: { column: { prototype: t2 }, scatter: t3 } } = P(), { addEvent: t5, arrayMax: t8, arrayMin: t6, clamp: t9, extend: t4, isNumber: t7, merge: et, pick: ee, pushUnique: ei } = y();
        function es() {
            let t = this.len, { coll: e, isXAxis: i, min: s } = this, a = (this.max || 0) - (s || 0), o = 0, r = t, n = t / a, l;
            ("xAxis" === e || "yAxis" === e) && (this.series.forEach((t)=>{
                if (t.bubblePadding && t.reserveSpace()) {
                    this.allowZoomOutside = !0, l = !0;
                    let e = t.getColumn(i ? "x" : "y");
                    if (i && ((t.onPoint || t).getRadii(0, 0, t), t.onPoint && (t.radii = t.onPoint.radii)), a > 0) {
                        let i = e.length;
                        for(; i--;)if (t7(e[i]) && this.dataMin <= e[i] && e[i] <= this.max) {
                            let a = t.radii && t.radii[i] || 0;
                            o = Math.min((e[i] - s) * n - a, o), r = Math.max((e[i] - s) * n + a, r);
                        }
                    }
                }
            }), l && a > 0 && !this.logarithmic && (r -= t, n *= (t + Math.max(0, o) - Math.min(r, t)) / t, [
                [
                    "min",
                    "userMin",
                    o
                ],
                [
                    "max",
                    "userMax",
                    r
                ]
            ].forEach((t)=>{
                void 0 === ee(this.options[t[0]], this[t[1]]) && (this[t[0]] += t[2] / n);
            })));
        }
        function ea() {
            let { ticks: t, tickPositions: e, dataMin: i = 0, dataMax: s = 0, categories: a } = this, o = this.options.type;
            if ((a?.length || "category" === o) && this.series.find((t)=>t.bubblePadding)) {
                let a = e.length;
                for(; a--;){
                    let o = t[e[a]], r = o.pos || 0;
                    (r > s || r < i) && o.label?.hide();
                }
            }
        }
        class eo extends t3 {
            static compose(t, e, i) {
                tU.compose(e, i), ei(tJ, "Series.Bubble") && (t5(t, "foundExtremes", es), t5(t, "afterRender", ea));
            }
            animate(t) {
                !t && this.points.length < this.options.animationLimit && this.points.forEach(function(t) {
                    let { graphic: e, plotX: i = 0, plotY: s = 0 } = t;
                    e && e.width && (this.hasRendered || e.attr({
                        x: i,
                        y: s,
                        width: 1,
                        height: 1
                    }), e.animate(this.markerAttribs(t), this.options.animation));
                }, this);
            }
            getRadii() {
                let t = this.getColumn("z"), e = this.getColumn("y"), i = [], s, a, o, r = this.chart.bubbleZExtremes, { minPxSize: n, maxPxSize: l } = this.getPxExtremes();
                if (!r) {
                    let t, e = Number.MAX_VALUE, i = -Number.MAX_VALUE;
                    this.chart.series.forEach((s)=>{
                        if (s.bubblePadding && s.reserveSpace()) {
                            let a = (s.onPoint || s).getZExtremes();
                            a && (e = Math.min(ee(e, a.zMin), a.zMin), i = Math.max(ee(i, a.zMax), a.zMax), t = !0);
                        }
                    }), t ? (r = {
                        zMin: e,
                        zMax: i
                    }, this.chart.bubbleZExtremes = r) : r = {
                        zMin: 0,
                        zMax: 0
                    };
                }
                for(a = 0, s = t.length; a < s; a++)o = t[a], i.push(this.getRadius(r.zMin, r.zMax, n, l, o, e && e[a]));
                this.radii = i;
            }
            getRadius(t, e, i, s, a, o) {
                let r = this.options, n = "width" !== r.sizeBy, l = r.zThreshold, h = e - t, p = .5;
                if (null === o || null === a) return null;
                if (t7(a)) {
                    if (r.sizeByAbsoluteValue && (a = Math.abs(a - l), e = h = Math.max(e - l, Math.abs(t - l)), t = 0), a < t) return i / 2 - 1;
                    h > 0 && (p = (a - t) / h);
                }
                return n && p >= 0 && (p = Math.sqrt(p)), Math.ceil(i + p * (s - i)) / 2;
            }
            hasData() {
                return !!this.dataTable.rowCount;
            }
            markerAttribs(t, e) {
                let i = super.markerAttribs(t, e), { height: s = 0, width: a = 0 } = i;
                return this.chart.inverted ? t4(i, {
                    x: (t.plotX || 0) - a / 2,
                    y: (t.plotY || 0) - s / 2
                }) : i;
            }
            pointAttribs(t, e) {
                let i = this.options.marker, s = i?.fillOpacity, a = t1.prototype.pointAttribs.call(this, t, e);
                return a["fill-opacity"] = s ?? 1, a;
            }
            translate() {
                super.translate.call(this), this.getRadii(), this.translateBubble();
            }
            translateBubble() {
                let { data: t, options: e, radii: i } = this, { minPxSize: s } = this.getPxExtremes(), a = t.length;
                for(; a--;){
                    let o = t[a], r = i ? i[a] : 0;
                    "z" === this.zoneAxis && (o.negative = (o.z || 0) < (e.zThreshold || 0)), t7(r) && r >= s / 2 ? (o.marker = t4(o.marker, {
                        radius: r,
                        width: 2 * r,
                        height: 2 * r
                    }), o.dlBox = {
                        x: o.plotX - r,
                        y: o.plotY - r,
                        width: 2 * r,
                        height: 2 * r
                    }) : (o.shapeArgs = o.plotY = o.dlBox = void 0, o.isInside = !1);
                }
            }
            getPxExtremes() {
                let t = Math.min(this.chart.plotWidth, this.chart.plotHeight), e = (e)=>{
                    let i;
                    return "string" == typeof e && (i = /%$/.test(e), e = parseInt(e, 10)), i ? t * e / 100 : e;
                }, i = e(ee(this.options.minSize, 8)), s = Math.max(e(ee(this.options.maxSize, "20%")), i);
                return {
                    minPxSize: i,
                    maxPxSize: s
                };
            }
            getZExtremes() {
                let t = this.options, e = this.getColumn("z").filter(t7);
                if (e.length) {
                    let i = ee(t.zMin, t9(t6(e), !1 === t.displayNegative ? t.zThreshold || 0 : -Number.MAX_VALUE, Number.MAX_VALUE)), s = ee(t.zMax, t8(e));
                    if (t7(i) && t7(s)) return {
                        zMin: i,
                        zMax: s
                    };
                }
            }
            searchKDTree(t, e, i, s = t0, a = t0) {
                return s = (t, e, i)=>{
                    let s = t[i] || 0, a = e[i] || 0, o, r = !1;
                    return s === a ? o = t.index > e.index ? t : e : s < 0 && a < 0 ? (o = s - (t.marker?.radius || 0) >= a - (e.marker?.radius || 0) ? t : e, r = !0) : o = s < a ? t : e, [
                        o,
                        r
                    ];
                }, a = (t, e, i)=>!i && t > e || t < e, super.searchKDTree(t, e, i, s, a);
            }
        }
        eo.defaultOptions = et(t3.defaultOptions, {
            dataLabels: {
                formatter: function() {
                    let { numberFormatter: t } = this.series.chart, { z: e } = this.point;
                    return t7(e) ? t(e, -1) : "";
                },
                inside: !0,
                verticalAlign: "middle"
            },
            animationLimit: 250,
            marker: {
                lineColor: null,
                lineWidth: 1,
                fillOpacity: .5,
                radius: null,
                states: {
                    hover: {
                        radiusPlus: 0
                    }
                },
                symbol: "circle"
            },
            minSize: 8,
            maxSize: "20%",
            softThreshold: !1,
            states: {
                hover: {
                    halo: {
                        size: 5
                    }
                }
            },
            tooltip: {
                pointFormat: "({point.x}, {point.y}), Size: {point.z}"
            },
            turboThreshold: 0,
            zThreshold: 0,
            zoneAxis: "z"
        }), t4(eo.prototype, {
            alignDataLabel: t2.alignDataLabel,
            applyZones: t0,
            bubblePadding: !0,
            isBubble: !0,
            keysAffectYAxis: [
                "y"
            ],
            pointArrayMap: [
                "y",
                "z"
            ],
            pointClass: tQ,
            parallelArrays: [
                "x",
                "y",
                "z"
            ],
            trackerGroups: [
                "group",
                "dataLabelsGroup"
            ],
            specialGroup: "group",
            zoneAxis: "z"
        }), t5(eo, "updatedData", (t)=>{
            delete t.target.chart.bubbleZExtremes;
        }), t5(eo, "remove", (t)=>{
            delete t.target.chart.bubbleZExtremes;
        }), P().registerSeriesType("bubble", eo);
        let { seriesTypes: { column: { prototype: { pointClass: { prototype: er } } }, arearange: { prototype: { pointClass: en } } } } = P(), { extend: el, isNumber: eh } = y();
        class ep extends en {
            isValid() {
                return eh(this.low);
            }
        }
        el(ep.prototype, {
            setState: er.setState
        });
        let { noop: ed } = y(), { seriesTypes: { arearange: ec, column: eu, column: { prototype: eg } } } = P(), { addEvent: ef, clamp: em, extend: eb, isNumber: ey, merge: ex, pick: eP } = y();
        class eM extends ec {
            setOptions() {
                return ex(!0, arguments[0], {
                    stacking: void 0
                }), ec.prototype.setOptions.apply(this, arguments);
            }
            translate() {
                return eg.translate.apply(this);
            }
            pointAttribs() {
                return eg.pointAttribs.apply(this, arguments);
            }
            translate3dPoints() {
                return eg.translate3dPoints.apply(this, arguments);
            }
            translate3dShapes() {
                return eg.translate3dShapes.apply(this, arguments);
            }
            afterColumnTranslate() {
                let t, e, i, s, a = this.yAxis, o = this.xAxis, r = o.startAngleRad, n = this.chart, l = this.xAxis.isRadial, h = Math.max(n.chartWidth, n.chartHeight) + 999;
                this.points.forEach((p)=>{
                    let d = p.shapeArgs || {}, c = this.options.minPointLength, u = p.plotY, g = a.translate(p.high, 0, 1, 0, 1);
                    if (ey(g) && ey(u)) {
                        if (p.plotHigh = em(g, -h, h), p.plotLow = em(u, -h, h), s = p.plotHigh, Math.abs(t = eP(p.rectPlotY, p.plotY) - p.plotHigh) < c ? (e = c - t, t += e, s -= e / 2) : t < 0 && (t *= -1, s -= t), l && this.polar) i = p.barX + r, p.shapeType = "arc", p.shapeArgs = this.polar.arc(s + t, s, i, i + p.pointWidth);
                        else {
                            d.height = t, d.y = s;
                            let { x: e = 0, width: i = 0 } = d;
                            p.shapeArgs = ex(p.shapeArgs, this.crispCol(e, s, i, t)), p.tooltipPos = n.inverted ? [
                                a.len + a.pos - n.plotLeft - s - t / 2,
                                o.len + o.pos - n.plotTop - e - i / 2,
                                t
                            ] : [
                                o.left - n.plotLeft + e + i / 2,
                                a.pos - n.plotTop + s + t / 2,
                                t
                            ];
                        }
                    }
                });
            }
        }
        eM.defaultOptions = ex(eu.defaultOptions, ec.defaultOptions, {
            borderRadius: {
                where: "all"
            },
            pointRange: null,
            legendSymbol: "rectangle",
            marker: null,
            states: {
                hover: {
                    halo: !1
                }
            }
        }), ef(eM, "afterColumnTranslate", function() {
            eM.prototype.afterColumnTranslate.apply(this);
        }, {
            order: 5
        }), eb(eM.prototype, {
            directTouch: !0,
            pointClass: ep,
            trackerGroups: [
                "group",
                "dataLabelsGroup"
            ],
            adjustForMissingColumns: eg.adjustForMissingColumns,
            animate: eg.animate,
            crispCol: eg.crispCol,
            drawGraph: ed,
            drawPoints: eg.drawPoints,
            getSymbol: ed,
            drawTracker: eg.drawTracker,
            getColumnMetrics: eg.getColumnMetrics
        }), P().registerSeriesType("columnrange", eM);
        let { column: ev } = P().seriesTypes, { clamp: eL, merge: ek, pick: ew } = y();
        class eA extends ev {
            translate() {
                let t = this.chart, e = this.options, i = this.dense = this.closestPointRange * this.xAxis.transA < 2, s = this.borderWidth = ew(e.borderWidth, +!i), a = this.yAxis, o = e.threshold, r = ew(e.minPointLength, 5), n = this.getColumnMetrics(), l = n.width, h = this.pointXOffset = n.offset, p = this.translatedThreshold = a.getThreshold(o), d = this.barW = Math.max(l, 1 + 2 * s);
                for (let i of (t.inverted && (p -= .5), e.pointPadding && (d = Math.ceil(d)), super.translate(), this.points)){
                    let s = ew(i.yBottom, p), c = 999 + Math.abs(s), u = eL(i.plotY, -c, a.len + c), g = d / 2, f = Math.min(u, s), m = Math.max(u, s) - f, b = i.plotX + h, y, x, P, M, v, L, k, w, A, S, T;
                    e.centerInCategory && (b = this.adjustForMissingColumns(b, l, i, n)), i.barX = b, i.pointWidth = l, i.tooltipPos = t.inverted ? [
                        a.len + a.pos - t.plotLeft - u,
                        this.xAxis.len - b - g,
                        m
                    ] : [
                        b + g,
                        u + a.pos - t.plotTop,
                        m
                    ], y = o + (i.total || i.y), "percent" === e.stacking && (y = o + (i.y < 0) ? -100 : 100);
                    let C = a.toPixels(y, !0);
                    P = (x = t.plotHeight - C - (t.plotHeight - p)) ? g * (f - C) / x : 0, M = x ? g * (f + m - C) / x : 0, L = b - P + g, k = b + P + g, w = b + M + g, A = b - M + g, S = f - r, T = f + m, i.y < 0 && (S = f, T = f + m + r), t.inverted && (v = a.width - f, x = C - (a.width - p), P = g * (C - v) / x, M = g * (C - (v - m)) / x, k = (L = b + g + P) - 2 * P, w = b - M + g, A = b + M + g, S = f, T = f + m - r, i.y < 0 && (T = f + m + r)), i.shapeType = "path", i.shapeArgs = {
                        x: L,
                        y: S,
                        width: k - L,
                        height: m,
                        d: [
                            [
                                "M",
                                L,
                                S
                            ],
                            [
                                "L",
                                k,
                                S
                            ],
                            [
                                "L",
                                w,
                                T
                            ],
                            [
                                "L",
                                A,
                                T
                            ],
                            [
                                "Z"
                            ]
                        ]
                    };
                }
            }
        }
        eA.defaultOptions = ek(ev.defaultOptions, {}), P().registerSeriesType("columnpyramid", eA);
        let { arearange: eS } = P().seriesTypes, { addEvent: eT, merge: eC, extend: eN } = y();
        class eX extends tL {
            getColumnMetrics() {
                return this.linkedParent && this.linkedParent.columnMetrics || tf().prototype.getColumnMetrics.call(this);
            }
            drawDataLabels() {
                let t = this.pointValKey;
                if (eS) for (let e of (eS.prototype.drawDataLabels.call(this), this.points))e.y = e[t];
            }
            toYData(t) {
                return [
                    t.low,
                    t.high
                ];
            }
        }
        eX.defaultOptions = eC(tL.defaultOptions, {
            color: "#000000",
            grouping: !1,
            linkedTo: ":previous",
            tooltip: {
                pointFormat: '<span style="color:{point.color}">\u25CF</span> {series.name}: <b>{point.low}</b> - <b>{point.high}</b><br/>'
            },
            whiskerWidth: null
        }), eT(eX, "afterTranslate", function() {
            for (let t of this.points)t.plotLow = t.plotY;
        }, {
            order: 0
        }), eN(eX.prototype, {
            pointArrayMap: [
                "low",
                "high"
            ],
            pointValKey: "high",
            doQuartiles: !1
        }), P().registerSeriesType("errorbar", eX);
        let { series: { prototype: { pointClass: eY } } } = P(), { noop: eR } = y(), { series: eI, seriesTypes: { column: eE } } = P(), { clamp: eD, isNumber: ez, extend: eO, merge: eH, pick: eB, pInt: eW, defined: eF } = y();
        class eG extends eI {
            translate() {
                let t = this.yAxis, e = this.options, i = t.center;
                this.generatePoints(), this.points.forEach((s)=>{
                    let a = eH(e.dial, s.dial), o = eW(a.radius) * i[2] / 200, r = eW(a.baseLength) * o / 100, n = eW(a.rearLength) * o / 100, l = a.baseWidth, h = a.topWidth, p = e.overshoot, d = t.startAngleRad + t.translate(s.y, void 0, void 0, void 0, !0);
                    (ez(p) || !1 === e.wrap) && (p = ez(p) ? p / 180 * Math.PI : 0, d = eD(d, t.startAngleRad - p, t.endAngleRad + p)), d = 180 * d / Math.PI, s.shapeType = "path", s.shapeArgs = {
                        d: a.path || [
                            [
                                "M",
                                -n,
                                -l / 2
                            ],
                            [
                                "L",
                                r,
                                -l / 2
                            ],
                            [
                                "L",
                                o,
                                -h / 2
                            ],
                            [
                                "L",
                                o,
                                h / 2
                            ],
                            [
                                "L",
                                r,
                                l / 2
                            ],
                            [
                                "L",
                                -n,
                                l / 2
                            ],
                            [
                                "Z"
                            ]
                        ],
                        translateX: i[0],
                        translateY: i[1],
                        rotation: d
                    }, s.plotX = i[0], s.plotY = i[1], eF(s.y) && t.max - t.min && (s.percentage = (s.y - t.min) / (t.max - t.min) * 100);
                });
            }
            drawPoints() {
                let t = this, e = t.chart, i = t.yAxis.center, s = t.pivot, a = t.options, o = a.pivot, r = e.renderer;
                t.points.forEach((i)=>{
                    let s = i.graphic, o = i.shapeArgs, n = o.d, l = eH(a.dial, i.dial);
                    s ? (s.animate(o), o.d = n) : i.graphic = r[i.shapeType](o).addClass("highcharts-dial").add(t.group), e.styledMode || i.graphic[s ? "animate" : "attr"]({
                        stroke: l.borderColor,
                        "stroke-width": l.borderWidth,
                        fill: l.backgroundColor
                    });
                }), s ? s.animate({
                    translateX: i[0],
                    translateY: i[1]
                }) : o && (t.pivot = r.circle(0, 0, o.radius).attr({
                    zIndex: 2
                }).addClass("highcharts-pivot").translate(i[0], i[1]).add(t.group), e.styledMode || t.pivot.attr({
                    fill: o.backgroundColor,
                    stroke: o.borderColor,
                    "stroke-width": o.borderWidth
                }));
            }
            animate(t) {
                let e = this;
                t || e.points.forEach((t)=>{
                    let i = t.graphic;
                    i && (i.attr({
                        rotation: 180 * e.yAxis.startAngleRad / Math.PI
                    }), i.animate({
                        rotation: t.shapeArgs.rotation
                    }, e.options.animation));
                });
            }
            render() {
                this.group = this.plotGroup("group", "series", this.visible ? "inherit" : "hidden", this.options.zIndex, this.chart.seriesGroup), eI.prototype.render.call(this), this.group.clip(this.chart.clipRect);
            }
            setData(t, e) {
                eI.prototype.setData.call(this, t, !1), this.processData(), this.generatePoints(), eB(e, !0) && this.chart.redraw();
            }
            hasData() {
                return !!this.points.length;
            }
        }
        eG.defaultOptions = eH(eI.defaultOptions, {
            dataLabels: {
                borderColor: "#cccccc",
                borderRadius: 3,
                borderWidth: 1,
                crop: !1,
                defer: !1,
                enabled: !0,
                verticalAlign: "top",
                y: 15,
                zIndex: 2
            },
            dial: {
                backgroundColor: "#000000",
                baseLength: "70%",
                baseWidth: 3,
                borderColor: "#cccccc",
                borderWidth: 0,
                radius: "80%",
                rearLength: "10%",
                topWidth: 1
            },
            pivot: {
                radius: 5,
                borderWidth: 0,
                borderColor: "#cccccc",
                backgroundColor: "#000000"
            },
            tooltip: {
                headerFormat: ""
            },
            showInLegend: !1
        }), eO(eG.prototype, {
            angular: !0,
            directTouch: !0,
            drawGraph: eR,
            drawTracker: eE.prototype.drawTracker,
            fixedBox: !0,
            forceDL: !0,
            noSharedTooltip: !0,
            pointClass: class extends eY {
                setState(t) {
                    this.state = t;
                }
            },
            trackerGroups: [
                "group",
                "dataLabelsGroup"
            ]
        }), P().registerSeriesType("gauge", eG);
        var eq = f(620), eV = f.n(eq);
        let { composed: e_ } = y(), { addEvent: eU, pushUnique: eK } = y();
        function ej() {
            let t, e, i, s, a = this;
            a.container && (t = eU(a.container, "mousedown", (t)=>{
                e && e(), i && i(), (s = a.hoverPoint) && s.series && s.series.hasDraggableNodes && s.series.options.draggable && (s.series.onMouseDown(s, t), e = eU(a.container, "mousemove", (t)=>s && s.series && s.series.onMouseMove(s, t)), i = eU(a.container.ownerDocument, "mouseup", (t)=>(e(), i(), s && s.series && s.series.onMouseUp(s, t))));
            })), eU(a, "destroy", function() {
                t();
            });
        }
        let eZ = {
            compose: function(t) {
                eK(e_, "DragNodes") && eU(t, "load", ej);
            },
            onMouseDown: function(t, e) {
                let { panKey: i } = this.chart.options.chart;
                if (i && e[`${i}Key`]) return;
                let s = this.chart.pointer?.normalize(e) || e;
                t.fixedPosition = {
                    chartX: s.chartX,
                    chartY: s.chartY,
                    plotX: t.plotX,
                    plotY: t.plotY
                }, t.inDragMode = !0;
            },
            onMouseMove: function(t, e) {
                if (t.fixedPosition && t.inDragMode) {
                    let i, s, a = this.chart, o = a.pointer?.normalize(e) || e, r = t.fixedPosition.chartX - o.chartX, n = t.fixedPosition.chartY - o.chartY, l = a.graphLayoutsLookup;
                    (Math.abs(r) > 5 || Math.abs(n) > 5) && (i = t.fixedPosition.plotX - r, s = t.fixedPosition.plotY - n, a.isInsidePlot(i, s) && (t.plotX = i, t.plotY = s, t.hasDragged = !0, this.redrawHalo(t), l.forEach((t)=>{
                        t.restartSimulation();
                    })));
                }
            },
            onMouseUp: function(t) {
                t.fixedPosition && (t.hasDragged && (this.layout.enableSimulation ? this.layout.start() : this.chart.redraw()), t.inDragMode = t.hasDragged = !1, this.options.fixedDraggable || delete t.fixedPosition);
            },
            redrawHalo: function(t) {
                t && this.halo && this.halo.attr({
                    d: t.haloPath(this.options.states.hover.halo.size)
                });
            }
        }, { setAnimation: e$ } = y(), { composed: eQ } = y(), { addEvent: eJ, pushUnique: e0 } = y();
        function e1() {
            this.graphLayoutsLookup && (this.graphLayoutsLookup.forEach((t)=>{
                t.updateSimulation();
            }), this.redraw());
        }
        function e2() {
            this.graphLayoutsLookup && (this.graphLayoutsLookup.forEach((t)=>{
                t.updateSimulation(!1);
            }), this.redraw());
        }
        function e3() {
            this.graphLayoutsLookup && this.graphLayoutsLookup.forEach((t)=>{
                t.stop();
            });
        }
        function e5() {
            let t, e = !1, i = (i)=>{
                i.maxIterations-- && isFinite(i.temperature) && !i.isStable() && !i.enableSimulation && (i.beforeStep && i.beforeStep(), i.step(), t = !1, e = !0);
            };
            if (this.graphLayoutsLookup && !this.pointer?.hasDragged) {
                for(e$(!1, this), this.graphLayoutsLookup.forEach((t)=>t.start()); !t;)t = !0, this.graphLayoutsLookup.forEach(i);
                e && this.series.forEach((t)=>{
                    t && t.layout && t.render();
                });
            }
        }
        let e8 = {
            compose: function(t) {
                e0(eQ, "GraphLayout") && (eJ(t, "afterPrint", e1), eJ(t, "beforePrint", e2), eJ(t, "predraw", e3), eJ(t, "render", e5));
            },
            integrations: {},
            layouts: {}
        };
        var e6 = f(960), e9 = f.n(e6);
        let { seriesTypes: { bubble: { prototype: { pointClass: e4 } } } } = P(), e7 = class extends e4 {
            destroy() {
                return this.series?.layout && this.series.layout.removeElementFromCollection(this, this.series.layout.nodes), tj().prototype.destroy.apply(this, arguments);
            }
            firePointEvent() {
                let t = this.series.options;
                if (this.isParentNode && t.parentNode) {
                    let e = t.allowPointSelect;
                    t.allowPointSelect = t.parentNode.allowPointSelect, tj().prototype.firePointEvent.apply(this, arguments), t.allowPointSelect = e;
                } else tj().prototype.firePointEvent.apply(this, arguments);
            }
            select() {
                let t = this.series.chart;
                this.isParentNode ? (t.getSelectedPoints = t.getSelectedParentNodes, tj().prototype.select.apply(this, arguments), t.getSelectedPoints = e9().prototype.getSelectedPoints) : tj().prototype.select.apply(this, arguments);
            }
            setState(t, e) {
                this?.graphic?.parentGroup?.element && super.setState(t, e);
            }
        }, { isNumber: it } = y(), ie = {
            attractive: function(t, e, i) {
                let s = t.getMass(), a = -i.x * e * this.diffTemperature, o = -i.y * e * this.diffTemperature;
                t.fromNode.fixedPosition || (t.fromNode.plotX -= a * s.fromNode / t.fromNode.degree, t.fromNode.plotY -= o * s.fromNode / t.fromNode.degree), t.toNode.fixedPosition || (t.toNode.plotX += a * s.toNode / t.toNode.degree, t.toNode.plotY += o * s.toNode / t.toNode.degree);
            },
            attractiveForceFunction: function(t, e) {
                return (e - t) / t;
            },
            barycenter: function() {
                let t = this.options.gravitationalConstant || 0, e = (this.barycenter.xFactor - (this.box.left + this.box.width) / 2) * t, i = (this.barycenter.yFactor - (this.box.top + this.box.height) / 2) * t;
                this.nodes.forEach(function(t) {
                    t.fixedPosition || (t.plotX -= e / t.mass / t.degree, t.plotY -= i / t.mass / t.degree);
                });
            },
            getK: function(t) {
                return Math.pow(t.box.width * t.box.height / t.nodes.length, .5);
            },
            integrate: function(t, e) {
                let i = -t.options.friction, s = t.options.maxSpeed, a = e.prevX, o = e.prevY, r = (e.plotX + e.dispX - a) * i, n = (e.plotY + e.dispY - o) * i, l = Math.abs, h = l(r) / (r || 1), p = l(n) / (n || 1), d = h * Math.min(s, Math.abs(r)), c = p * Math.min(s, Math.abs(n));
                e.prevX = e.plotX + e.dispX, e.prevY = e.plotY + e.dispY, e.plotX += d, e.plotY += c, e.temperature = t.vectorLength({
                    x: d,
                    y: c
                });
            },
            repulsive: function(t, e, i) {
                let s = e * this.diffTemperature / t.mass / t.degree;
                t.fixedPosition || (t.plotX += i.x * s, t.plotY += i.y * s);
            },
            repulsiveForceFunction: function(t, e) {
                return (e - t) / t * (e > t);
            }
        }, { noop: ii } = y(), is = {
            barycenter: function() {
                let t, e, i = this.options.gravitationalConstant || 0, s = this.box, a = this.nodes, o = Math.sqrt(a.length);
                for (let r of a)if (!r.fixedPosition) {
                    let a = r.mass * o, n = r.plotX || 0, l = r.plotY || 0, h = r.series, p = h.parentNode;
                    this.resolveSplitSeries(r) && p && !r.isParentNode ? (t = p.plotX || 0, e = p.plotY || 0) : (t = s.width / 2, e = s.height / 2), r.plotX = n - (n - t) * i / a, r.plotY = l - (l - e) * i / a, h.chart.hoverPoint === r && h.redrawHalo && h.halo && h.redrawHalo(r);
                }
            },
            getK: ii,
            integrate: ie.integrate,
            repulsive: function(t, e, i, s) {
                let a = e * this.diffTemperature / t.mass / t.degree, o = i.x * a, r = i.y * a;
                t.fixedPosition || (t.plotX += o, t.plotY += r), s.fixedPosition || (s.plotX -= o, s.plotY -= r);
            },
            repulsiveForceFunction: function(t, e, i, s) {
                return Math.min(t, (i.marker.radius + s.marker.radius) / 2);
            }
        }, ia = {
            attractive: function(t, e, i, s) {
                let a = t.getMass(), o = i.x / s * e, r = i.y / s * e;
                t.fromNode.fixedPosition || (t.fromNode.dispX -= o * a.fromNode / t.fromNode.degree, t.fromNode.dispY -= r * a.fromNode / t.fromNode.degree), t.toNode.fixedPosition || (t.toNode.dispX += o * a.toNode / t.toNode.degree, t.toNode.dispY += r * a.toNode / t.toNode.degree);
            },
            attractiveForceFunction: function(t, e) {
                return t * t / e;
            },
            barycenter: function() {
                let t = this.options.gravitationalConstant, e = this.barycenter.xFactor, i = this.barycenter.yFactor;
                this.nodes.forEach(function(s) {
                    if (!s.fixedPosition) {
                        let a = s.getDegree(), o = a * (1 + a / 2);
                        s.dispX += (e - s.plotX) * t * o / s.degree, s.dispY += (i - s.plotY) * t * o / s.degree;
                    }
                });
            },
            getK: function(t) {
                return Math.pow(t.box.width * t.box.height / t.nodes.length, .3);
            },
            integrate: function(t, e) {
                e.dispX += e.dispX * t.options.friction, e.dispY += e.dispY * t.options.friction;
                let i = e.temperature = t.vectorLength({
                    x: e.dispX,
                    y: e.dispY
                });
                0 !== i && (e.plotX += e.dispX / i * Math.min(Math.abs(e.dispX), t.temperature), e.plotY += e.dispY / i * Math.min(Math.abs(e.dispY), t.temperature));
            },
            repulsive: function(t, e, i, s) {
                t.dispX += i.x / s * e / t.degree, t.dispY += i.y / s * e / t.degree;
            },
            repulsiveForceFunction: function(t, e) {
                return e * e / t;
            }
        };
        class io {
            constructor(t){
                this.body = !1, this.isEmpty = !1, this.isInternal = !1, this.nodes = [], this.box = t, this.boxSize = Math.min(t.width, t.height);
            }
            divideBox() {
                let t = this.box.width / 2, e = this.box.height / 2;
                this.nodes[0] = new io({
                    left: this.box.left,
                    top: this.box.top,
                    width: t,
                    height: e
                }), this.nodes[1] = new io({
                    left: this.box.left + t,
                    top: this.box.top,
                    width: t,
                    height: e
                }), this.nodes[2] = new io({
                    left: this.box.left + t,
                    top: this.box.top + e,
                    width: t,
                    height: e
                }), this.nodes[3] = new io({
                    left: this.box.left,
                    top: this.box.top + e,
                    width: t,
                    height: e
                });
            }
            getBoxPosition(t) {
                let e = t.plotX < this.box.left + this.box.width / 2, i = t.plotY < this.box.top + this.box.height / 2;
                return e ? 3 * !i : i ? 1 : 2;
            }
            insert(t, e) {
                let i;
                this.isInternal ? this.nodes[this.getBoxPosition(t)].insert(t, e - 1) : (this.isEmpty = !1, this.body ? e ? (this.isInternal = !0, this.divideBox(), !0 !== this.body && (this.nodes[this.getBoxPosition(this.body)].insert(this.body, e - 1), this.body = !0), this.nodes[this.getBoxPosition(t)].insert(t, e - 1)) : ((i = new io({
                    top: t.plotX || NaN,
                    left: t.plotY || NaN,
                    width: .1,
                    height: .1
                })).body = t, i.isInternal = !1, this.nodes.push(i)) : (this.isInternal = !1, this.body = t));
            }
            updateMassAndCenter() {
                let t = 0, e = 0, i = 0;
                if (this.isInternal) {
                    for (let s of this.nodes)s.isEmpty || (t += s.mass, e += s.plotX * s.mass, i += s.plotY * s.mass);
                    e /= t, i /= t;
                } else this.body && (t = this.body.mass, e = this.body.plotX, i = this.body.plotY);
                this.mass = t, this.plotX = e, this.plotY = i;
            }
        }
        let ir = class {
            constructor(t, e, i, s){
                this.box = {
                    left: t,
                    top: e,
                    width: i,
                    height: s
                }, this.maxDepth = 25, this.root = new io(this.box), this.root.isInternal = !0, this.root.isRoot = !0, this.root.divideBox();
            }
            calculateMassAndCenter() {
                this.visitNodeRecursive(null, null, function(t) {
                    t.updateMassAndCenter();
                });
            }
            insertNodes(t) {
                for (let e of t)this.root.insert(e, this.maxDepth);
            }
            visitNodeRecursive(t, e, i) {
                let s;
                if (t || (t = this.root), t === this.root && e && (s = e(t)), !1 !== s) {
                    for (let a of t.nodes){
                        if (a.isInternal) {
                            if (e && (s = e(a)), !1 === s) continue;
                            this.visitNodeRecursive(a, e, i);
                        } else a.body && e && e(a.body);
                        i && i(a);
                    }
                    t === this.root && i && i(t);
                }
            }
        }, { win: il } = y(), { clamp: ih, defined: ip, isFunction: id, fireEvent: ic, pick: iu } = y();
        class ig {
            constructor(){
                this.box = {}, this.currentStep = 0, this.initialRendering = !0, this.links = [], this.nodes = [], this.series = [], this.simulation = !1;
            }
            static compose(t) {
                e8.compose(t), e8.integrations.euler = ia, e8.integrations.verlet = ie, e8.layouts["reingold-fruchterman"] = ig;
            }
            init(t) {
                this.options = t, this.nodes = [], this.links = [], this.series = [], this.box = {
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0
                }, this.setInitialRendering(!0), this.integration = e8.integrations[t.integration], this.enableSimulation = t.enableSimulation, this.attractiveForce = iu(t.attractiveForce, this.integration.attractiveForceFunction), this.repulsiveForce = iu(t.repulsiveForce, this.integration.repulsiveForceFunction), this.approximation = t.approximation;
            }
            updateSimulation(t) {
                this.enableSimulation = iu(t, this.options.enableSimulation);
            }
            start() {
                let t = this.series, e = this.options;
                this.currentStep = 0, this.forces = t[0] && t[0].forces || [], this.chart = t[0] && t[0].chart, this.initialRendering && (this.initPositions(), t.forEach(function(t) {
                    t.finishedAnimating = !0, t.render();
                })), this.setK(), this.resetSimulation(e), this.enableSimulation && this.step();
            }
            step() {
                let t = this.series;
                for (let t of (this.currentStep++, "barnes-hut" === this.approximation && (this.createQuadTree(), this.quadTree.calculateMassAndCenter()), this.forces || []))this[t + "Forces"](this.temperature);
                if (this.applyLimits(), this.temperature = this.coolDown(this.startTemperature, this.diffTemperature, this.currentStep), this.prevSystemTemperature = this.systemTemperature, this.systemTemperature = this.getSystemTemperature(), this.enableSimulation) {
                    for (let e of t)e.chart && e.render();
                    this.maxIterations-- && isFinite(this.temperature) && !this.isStable() ? (this.simulation && il.cancelAnimationFrame(this.simulation), this.simulation = il.requestAnimationFrame(()=>this.step())) : (this.simulation = !1, this.series.forEach((t)=>{
                        ic(t, "afterSimulation");
                    }));
                }
            }
            stop() {
                this.simulation && il.cancelAnimationFrame(this.simulation);
            }
            setArea(t, e, i, s) {
                this.box = {
                    left: t,
                    top: e,
                    width: i,
                    height: s
                };
            }
            setK() {
                this.k = this.options.linkLength || this.integration.getK(this);
            }
            addElementsToCollection(t, e) {
                for (let i of t)-1 === e.indexOf(i) && e.push(i);
            }
            removeElementFromCollection(t, e) {
                let i = e.indexOf(t);
                -1 !== i && e.splice(i, 1);
            }
            clear() {
                this.nodes.length = 0, this.links.length = 0, this.series.length = 0, this.resetSimulation();
            }
            resetSimulation() {
                this.forcedStop = !1, this.systemTemperature = 0, this.setMaxIterations(), this.setTemperature(), this.setDiffTemperature();
            }
            restartSimulation() {
                this.simulation ? this.resetSimulation() : (this.setInitialRendering(!1), this.enableSimulation ? this.start() : this.setMaxIterations(1), this.chart && this.chart.redraw(), this.setInitialRendering(!0));
            }
            setMaxIterations(t) {
                this.maxIterations = iu(t, this.options.maxIterations);
            }
            setTemperature() {
                this.temperature = this.startTemperature = Math.sqrt(this.nodes.length);
            }
            setDiffTemperature() {
                this.diffTemperature = this.startTemperature / (this.options.maxIterations + 1);
            }
            setInitialRendering(t) {
                this.initialRendering = t;
            }
            createQuadTree() {
                this.quadTree = new ir(this.box.left, this.box.top, this.box.width, this.box.height), this.quadTree.insertNodes(this.nodes);
            }
            initPositions() {
                let t = this.options.initialPositions;
                if (id(t)) for (let e of (t.call(this), this.nodes))ip(e.prevX) || (e.prevX = e.plotX), ip(e.prevY) || (e.prevY = e.plotY), e.dispX = 0, e.dispY = 0;
                else "circle" === t ? this.setCircularPositions() : this.setRandomPositions();
            }
            setCircularPositions() {
                let t, e = this.box, i = this.nodes, s = 2 * Math.PI / (i.length + 1), a = i.filter(function(t) {
                    return 0 === t.linksTo.length;
                }), o = {}, r = this.options.initialPositionRadius, n = (t)=>{
                    for (let e of t.linksFrom || [])o[e.toNode.id] || (o[e.toNode.id] = !0, l.push(e.toNode), n(e.toNode));
                }, l = [];
                for (let t of a)l.push(t), n(t);
                if (l.length) for (let t of i)-1 === l.indexOf(t) && l.push(t);
                else l = i;
                for(let i = 0, a = l.length; i < a; ++i)(t = l[i]).plotX = t.prevX = iu(t.plotX, e.width / 2 + r * Math.cos(i * s)), t.plotY = t.prevY = iu(t.plotY, e.height / 2 + r * Math.sin(i * s)), t.dispX = 0, t.dispY = 0;
            }
            setRandomPositions() {
                let t, e = this.box, i = this.nodes, s = i.length + 1, a = (t)=>{
                    let e = t * t / Math.PI;
                    return e - Math.floor(e);
                };
                for(let o = 0, r = i.length; o < r; ++o)(t = i[o]).plotX = t.prevX = iu(t.plotX, e.width * a(o)), t.plotY = t.prevY = iu(t.plotY, e.height * a(s + o)), t.dispX = 0, t.dispY = 0;
            }
            force(t, ...e) {
                this.integration[t].apply(this, e);
            }
            barycenterForces() {
                this.getBarycenter(), this.force("barycenter");
            }
            getBarycenter() {
                let t = 0, e = 0, i = 0;
                for (let s of this.nodes)e += s.plotX * s.mass, i += s.plotY * s.mass, t += s.mass;
                return this.barycenter = {
                    x: e,
                    y: i,
                    xFactor: e / t,
                    yFactor: i / t
                }, this.barycenter;
            }
            barnesHutApproximation(t, e) {
                let i, s, a = this.getDistXY(t, e), o = this.vectorLength(a);
                return t !== e && 0 !== o && (e.isInternal ? e.boxSize / o < this.options.theta && 0 !== o ? (s = this.repulsiveForce(o, this.k), this.force("repulsive", t, s * e.mass, a, o), i = !1) : i = !0 : (s = this.repulsiveForce(o, this.k), this.force("repulsive", t, s * e.mass, a, o))), i;
            }
            repulsiveForces() {
                if ("barnes-hut" === this.approximation) for (let t of this.nodes)this.quadTree.visitNodeRecursive(null, (e)=>this.barnesHutApproximation(t, e));
                else {
                    let t, e, i;
                    for (let s of this.nodes)for (let a of this.nodes)s === a || s.fixedPosition || (i = this.getDistXY(s, a), 0 !== (e = this.vectorLength(i)) && (t = this.repulsiveForce(e, this.k), this.force("repulsive", s, t * a.mass, i, e)));
                }
            }
            attractiveForces() {
                let t, e, i;
                for (let s of this.links)s.fromNode && s.toNode && (t = this.getDistXY(s.fromNode, s.toNode), 0 !== (e = this.vectorLength(t)) && (i = this.attractiveForce(e, this.k), this.force("attractive", s, i, t, e)));
            }
            applyLimits() {
                for (let t of this.nodes)t.fixedPosition || (this.integration.integrate(this, t), this.applyLimitBox(t, this.box), t.dispX = 0, t.dispY = 0);
            }
            applyLimitBox(t, e) {
                let i = t.radius;
                t.plotX = ih(t.plotX, e.left + i, e.width - i), t.plotY = ih(t.plotY, e.top + i, e.height - i);
            }
            coolDown(t, e, i) {
                return t - e * i;
            }
            isStable() {
                return 1e-5 > Math.abs(this.systemTemperature - this.prevSystemTemperature) || this.temperature <= 0;
            }
            getSystemTemperature() {
                let t = 0;
                for (let e of this.nodes)t += e.temperature;
                return t;
            }
            vectorLength(t) {
                return Math.sqrt(t.x * t.x + t.y * t.y);
            }
            getDistR(t, e) {
                let i = this.getDistXY(t, e);
                return this.vectorLength(i);
            }
            getDistXY(t, e) {
                let i = t.plotX - e.plotX, s = t.plotY - e.plotY;
                return {
                    x: i,
                    y: s,
                    absX: Math.abs(i),
                    absY: Math.abs(s)
                };
            }
        }
        let im = ig, { addEvent: ib, defined: iy, pick: ix } = y();
        function iP() {
            let t = this.series, e = [];
            return t.forEach((t)=>{
                t.parentNode && t.parentNode.selected && e.push(t.parentNode);
            }), e;
        }
        function iM() {
            this.allDataPoints && delete this.allDataPoints;
        }
        class iv extends im {
            constructor(){
                super(...arguments), this.index = NaN, this.nodes = [], this.series = [];
            }
            static compose(t) {
                im.compose(t), e8.integrations.packedbubble = is, e8.layouts.packedbubble = iv;
                let e = t.prototype;
                e.getSelectedParentNodes || (ib(t, "beforeRedraw", iM), e.getSelectedParentNodes = iP), e.allParentNodes || (e.allParentNodes = []);
            }
            beforeStep() {
                this.options.marker && this.series.forEach((t)=>{
                    t && t.calculateParentRadius();
                });
            }
            isStable() {
                let t = Math.abs(this.prevSystemTemperature - this.systemTemperature);
                return 1 > Math.abs(10 * this.systemTemperature / Math.sqrt(this.nodes.length)) && t < 1e-5 || this.temperature <= 0;
            }
            setCircularPositions() {
                let t = this.box, e = [
                    ...this.nodes,
                    ...this?.chart?.allParentNodes || []
                ], i = 2 * Math.PI / (e.length + 1), s = this.options.initialPositionRadius, a, o, r = 0;
                for (let n of e)this.resolveSplitSeries(n) && !n.isParentNode ? (a = n.series.parentNode.plotX, o = n.series.parentNode.plotY) : (a = t.width / 2, o = t.height / 2), n.plotX = n.prevX = ix(n.plotX, a + s * Math.cos(n.index || r * i)), n.plotY = n.prevY = ix(n.plotY, o + s * Math.sin(n.index || r * i)), n.dispX = 0, n.dispY = 0, r++;
            }
            repulsiveForces() {
                let { options: t, k: e } = this, { bubblePadding: i = 0, seriesInteraction: s } = t, a = [
                    ...this.nodes,
                    ...this?.chart?.allParentNodes || []
                ];
                for (let t of a){
                    let o = t.series, r = t.fixedPosition, n = (t.marker?.radius || 0) + i;
                    for (let i of (t.degree = t.mass, t.neighbours = 0, a)){
                        let a = i.series;
                        if (t !== i && !r && (s || o === a) && !(o === a && (i.isParentNode || t.isParentNode))) {
                            let s, a = this.getDistXY(t, i), o = this.vectorLength(a) - (n + (i.marker?.radius || 0));
                            o < 0 && (t.degree += .01, s = this.repulsiveForce(-o / Math.sqrt(++t.neighbours), e, t, i) * i.mass), this.force("repulsive", t, s || 0, a, i, o);
                        }
                    }
                }
            }
            resolveSplitSeries(t) {
                let e = t.series?.options?.layoutAlgorithm?.splitSeries;
                return !iy(e) && t.series.chart?.options?.plotOptions?.packedbubble?.layoutAlgorithm?.splitSeries || e || !1;
            }
            applyLimitBox(t, e) {
                let i, s;
                this.resolveSplitSeries(t) && !t.isParentNode && this.options.parentNodeLimit && (i = this.getDistXY(t, t.series.parentNode), (s = t.series.parentNodeRadius - t.marker.radius - this.vectorLength(i)) < 0 && s > -2 * t.marker.radius && (t.plotX -= .01 * i.x, t.plotY -= .01 * i.y)), super.applyLimitBox(t, e);
            }
        }
        e8.layouts.packedbubble = iv;
        let { merge: iL, syncTimeout: ik } = y(), { animObject: iw } = y();
        var iA = f(28), iS = f.n(iA);
        let { deg2rad: iT } = y(), { addEvent: iC, merge: iN, uniqueKey: iX, defined: iY, extend: iR } = y();
        function iI(t, e) {
            e = iN(!0, {
                enabled: !0,
                attributes: {
                    dy: -5,
                    startOffset: "50%",
                    textAnchor: "middle"
                }
            }, e);
            let i = this.renderer.url, s = this.text || this, a = s.textPath, { attributes: o, enabled: r } = e;
            if (t = t || a && a.path, a && a.undo(), t && r) {
                let e = iC(s, "afterModifyTree", (e)=>{
                    if (t && r) {
                        let a = t.attr("id");
                        a || t.attr("id", a = iX());
                        let r = {
                            x: 0,
                            y: 0
                        };
                        iY(o.dx) && (r.dx = o.dx, delete o.dx), iY(o.dy) && (r.dy = o.dy, delete o.dy), s.attr(r), this.attr({
                            transform: ""
                        }), this.box && (this.box = this.box.destroy());
                        let n = e.nodes.slice(0);
                        e.nodes.length = 0, e.nodes[0] = {
                            tagName: "textPath",
                            attributes: iR(o, {
                                "text-anchor": o.textAnchor,
                                href: `${i}#${a}`
                            }),
                            children: n
                        };
                    }
                });
                s.textPath = {
                    path: t,
                    undo: e
                };
            } else s.attr({
                dx: 0,
                dy: 0
            }), delete s.textPath;
            return this.added && (s.textCache = "", this.renderer.buildText(s)), this;
        }
        function iE(t) {
            let e = t.bBox, i = this.element?.querySelector("textPath");
            if (i) {
                let t = [], { b: s, h: a } = this.renderer.fontMetrics(this.element), o = a - s, r = RegExp('(<tspan>|<tspan(?!\\sclass="highcharts-br")[^>]*>|<\\/tspan>)', "g"), n = i.innerHTML.replace(r, "").split(/<tspan class="highcharts-br"[^>]*>/), l = n.length, h = (t, e)=>{
                    let { x: a, y: r } = e, n = (i.getRotationOfChar(t) - 90) * iT, l = Math.cos(n), h = Math.sin(n);
                    return [
                        [
                            a - o * l,
                            r - o * h
                        ],
                        [
                            a + s * l,
                            r + s * h
                        ]
                    ];
                };
                for(let e = 0, s = 0; s < l; s++){
                    let a = n[s].length;
                    for(let o = 0; o < a; o += 5)try {
                        let a = e + o + s, [r, n] = h(a, i.getStartPositionOfChar(a));
                        0 === o ? (t.push(n), t.push(r)) : (0 === s && t.unshift(n), s === l - 1 && t.push(r));
                    } catch  {
                        break;
                    }
                    e += a - 1;
                    try {
                        let a = e + s, o = i.getEndPositionOfChar(a), [r, n] = h(a, o);
                        t.unshift(n), t.unshift(r);
                    } catch  {
                        break;
                    }
                }
                t.length && t.push(t[0].slice()), e.polygon = t;
            }
            return e;
        }
        function iD(t) {
            let e = t.labelOptions, i = t.point, s = e[i.formatPrefix + "TextPath"] || e.textPath;
            s && !e.useHTML && (this.setTextPath(i.getDataLabelPath?.(this) || i.graphic, s), i.dataLabelPath && !s.enabled && (i.dataLabelPath = i.dataLabelPath.destroy()));
        }
        let { parse: iz } = eV(), { noop: iO } = y(), { series: { prototype: iH }, seriesTypes: { bubble: iB } } = P(), { initDataLabels: iW, initDataLabelsDefer: iF } = {
            initDataLabels: function() {
                let t = this.options.dataLabels;
                if (!this.dataLabelsGroup) {
                    let e = this.initDataLabelsGroup();
                    return !this.chart.styledMode && t?.style && e.css(t.style), e.attr({
                        opacity: 0
                    }), this.visible && (this.options.animation && t?.animation ? e.animate({
                        opacity: 1
                    }, t?.animation) : e.attr({
                        opacity: 1
                    }), e.show()), e;
                }
                return this.dataLabelsGroup.attr(iL({
                    opacity: 1
                }, this.getPlotBox("data-labels"))), this.dataLabelsGroup;
            },
            initDataLabelsDefer: function() {
                let t = this.options.dataLabels;
                t?.defer && this.options.layoutAlgorithm?.enableSimulation ? ik(()=>{
                    this.deferDataLabels = !1;
                }, t ? iw(t.animation).defer : 0) : this.deferDataLabels = !1;
            }
        }, { addEvent: iG, clamp: iq, defined: iV, extend: i_, fireEvent: iU, isArray: iK, isNumber: ij, merge: iZ, pick: i$ } = y();
        ({
            compose: function(t) {
                iC(t, "afterGetBBox", iE), iC(t, "beforeAddingDataLabel", iD);
                let e = t.prototype;
                e.setTextPath || (e.setTextPath = iI);
            }
        }).compose(iS());
        class iQ extends iB {
            constructor(){
                super(...arguments), this.parentNodeMass = 0, this.deferDataLabels = !0;
            }
            static compose(t, e, i) {
                iB.compose(t, e, i), eZ.compose(e), iv.compose(e);
            }
            accumulateAllPoints() {
                let t = this.chart, e = [];
                for (let i of t.series)if (i.is("packedbubble") && i.reserveSpace()) {
                    let t = i.getColumn("value");
                    for(let s = 0; s < t.length; s++)e.push([
                        null,
                        null,
                        t[s],
                        i.index,
                        s,
                        {
                            id: s,
                            marker: {
                                radius: 0
                            }
                        }
                    ]);
                }
                return e;
            }
            addLayout() {
                let t = this.options.layoutAlgorithm = this.options.layoutAlgorithm || {}, e = t.type || "packedbubble", i = this.chart.options.chart, s = this.chart.graphLayoutsStorage, a = this.chart.graphLayoutsLookup, o;
                s || (this.chart.graphLayoutsStorage = s = {}, this.chart.graphLayoutsLookup = a = []), (o = s[e]) || (t.enableSimulation = iV(i.forExport) ? !i.forExport : t.enableSimulation, s[e] = o = new e8.layouts[e], o.init(t), a.splice(o.index, 0, o)), this.layout = o, this.points.forEach((t)=>{
                    t.mass = 2, t.degree = 1, t.collisionNmb = 1;
                }), o.setArea(0, 0, this.chart.plotWidth, this.chart.plotHeight), o.addElementsToCollection([
                    this
                ], o.series), o.addElementsToCollection(this.points, o.nodes);
            }
            addSeriesLayout() {
                let t = this.options.layoutAlgorithm = this.options.layoutAlgorithm || {}, e = t.type || "packedbubble", i = this.chart.graphLayoutsStorage, s = this.chart.graphLayoutsLookup, a = iZ(t, t.parentNodeOptions, {
                    enableSimulation: this.layout.options.enableSimulation
                }), o = i[e + "-series"];
                o || (i[e + "-series"] = o = new e8.layouts[e], o.init(a), s.splice(o.index, 0, o)), this.parentNodeLayout = o, this.createParentNodes();
            }
            calculateParentRadius() {
                let t = this.seriesBox();
                this.parentNodeRadius = iq(Math.sqrt(2 * this.parentNodeMass / Math.PI) + 20, 20, t ? Math.max(Math.sqrt(Math.pow(t.width, 2) + Math.pow(t.height, 2)) / 2 + 20, 20) : Math.sqrt(2 * this.parentNodeMass / Math.PI) + 20), this.parentNode && (this.parentNode.marker.radius = this.parentNode.radius = this.parentNodeRadius);
            }
            calculateZExtremes() {
                let t = this.chart.series, e = this.options.zMin, i = this.options.zMax, s = 1 / 0, a = -1 / 0;
                return e && i ? [
                    e,
                    i
                ] : (t.forEach((t)=>{
                    t.getColumn("value").forEach((t)=>{
                        iV(t) && (t > a && (a = t), t < s && (s = t));
                    });
                }), [
                    e = i$(e, s),
                    i = i$(i, a)
                ]);
            }
            checkOverlap(t, e) {
                let i = t[0] - e[0], s = t[1] - e[1];
                return Math.sqrt(i * i + s * s) - Math.abs(t[2] + e[2]) < -0.001;
            }
            createParentNodes() {
                let t = this.pointClass, e = this.chart, i = this.parentNodeLayout, s = this.layout.options, a, o = this.parentNode, r = {
                    radius: this.parentNodeRadius,
                    lineColor: this.color,
                    fillColor: iz(this.color).brighten(.4).get()
                };
                s.parentNodeOptions && (r = iZ(s.parentNodeOptions.marker || {}, r)), this.parentNodeMass = 0, this.points.forEach((t)=>{
                    this.parentNodeMass += Math.PI * Math.pow(t.marker.radius, 2);
                }), this.calculateParentRadius(), i.nodes.forEach((t)=>{
                    t.seriesIndex === this.index && (a = !0);
                }), i.setArea(0, 0, e.plotWidth, e.plotHeight), a || (o || (o = new t(this, {
                    mass: this.parentNodeRadius / 2,
                    marker: r,
                    dataLabels: {
                        inside: !1
                    },
                    states: {
                        normal: {
                            marker: r
                        },
                        hover: {
                            marker: r
                        }
                    },
                    dataLabelOnNull: !0,
                    degree: this.parentNodeRadius,
                    isParentNode: !0,
                    seriesIndex: this.index
                }), this.chart.allParentNodes.push(o)), this.parentNode && (o.plotX = this.parentNode.plotX, o.plotY = this.parentNode.plotY), this.parentNode = o, i.addElementsToCollection([
                    this
                ], i.series), i.addElementsToCollection([
                    o
                ], i.nodes));
            }
            deferLayout() {
                let t = this.options.layoutAlgorithm;
                this.visible && (this.addLayout(), t.splitSeries && this.addSeriesLayout());
            }
            destroy() {
                this.chart.graphLayoutsLookup && this.chart.graphLayoutsLookup.forEach((t)=>{
                    t.removeElementFromCollection(this, t.series);
                }, this), this.parentNode && this.parentNodeLayout && (this.parentNodeLayout.removeElementFromCollection(this.parentNode, this.parentNodeLayout.nodes), this.parentNode.dataLabel && (this.parentNode.dataLabel = this.parentNode.dataLabel.destroy())), iH.destroy.apply(this, arguments);
            }
            drawDataLabels() {
                !this.deferDataLabels && (iH.drawDataLabels.call(this, this.points), this.parentNode && (this.parentNode.formatPrefix = "parentNode", iH.drawDataLabels.call(this, [
                    this.parentNode
                ])));
            }
            drawGraph() {
                if (!this.layout || !this.layout.options.splitSeries) return;
                let t = this.chart, e = this.layout.options.parentNodeOptions.marker, i = {
                    fill: e.fillColor || iz(this.color).brighten(.4).get(),
                    opacity: e.fillOpacity,
                    stroke: e.lineColor || this.color,
                    "stroke-width": i$(e.lineWidth, this.options.lineWidth)
                }, s = {};
                this.parentNodesGroup = this.plotGroup("parentNodesGroup", "parentNode", this.visible ? "inherit" : "hidden", .1, t.seriesGroup), this.group?.attr({
                    zIndex: 2
                }), this.calculateParentRadius(), this.parentNode && iV(this.parentNode.plotX) && iV(this.parentNode.plotY) && iV(this.parentNodeRadius) && (s = iZ({
                    x: this.parentNode.plotX - this.parentNodeRadius,
                    y: this.parentNode.plotY - this.parentNodeRadius,
                    width: 2 * this.parentNodeRadius,
                    height: 2 * this.parentNodeRadius
                }, i), this.parentNode.graphic || (this.graph = this.parentNode.graphic = t.renderer.symbol(i.symbol).add(this.parentNodesGroup)), this.parentNode.graphic.attr(s));
            }
            drawTracker() {
                let t, e = this.parentNode;
                super.drawTracker(), e && (t = iK(e.dataLabels) ? e.dataLabels : e.dataLabel ? [
                    e.dataLabel
                ] : [], e.graphic && (e.graphic.element.point = e), t.forEach((t)=>{
                    (t.div || t.element).point = e;
                }));
            }
            getPointRadius() {
                let t, e, i, s, a = this.chart, o = a.plotWidth, r = a.plotHeight, n = this.options, l = n.useSimulation, h = Math.min(o, r), p = {}, d = [], c = a.allDataPoints || [], u = c.length;
                [
                    "minSize",
                    "maxSize"
                ].forEach((t)=>{
                    let e = parseInt(n[t], 10), i = /%$/.test(n[t]);
                    p[t] = i ? h * e / 100 : e * Math.sqrt(u);
                }), a.minRadius = t = p.minSize / Math.sqrt(u), a.maxRadius = e = p.maxSize / Math.sqrt(u);
                let g = l ? this.calculateZExtremes() : [
                    t,
                    e
                ];
                c.forEach((a, o)=>{
                    i = l ? iq(a[2], g[0], g[1]) : a[2], 0 === (s = this.getRadius(g[0], g[1], t, e, i)) && (s = null), c[o][2] = s, d.push(s);
                }), this.radii = d;
            }
            init() {
                return iH.init.apply(this, arguments), iF.call(this), this.eventsToUnbind.push(iG(this, "updatedData", function() {
                    this.chart.series.forEach((t)=>{
                        t.type === this.type && (t.isDirty = !0);
                    }, this);
                })), this;
            }
            onMouseUp(t) {
                if (t.fixedPosition && !t.removed) {
                    let e, i = this.layout, s = this.parentNodeLayout;
                    !t.isParentNode && s && i.options.dragBetweenSeries && s.nodes.forEach((s)=>{
                        t && t.marker && s !== t.series.parentNode && (e = i.getDistXY(t, s), i.vectorLength(e) - s.marker.radius - t.marker.radius < 0 && (s.series.addPoint(iZ(t.options, {
                            plotX: t.plotX,
                            plotY: t.plotY
                        }), !1), i.removeElementFromCollection(t, i.nodes), t.remove()));
                    }), eZ.onMouseUp.apply(this, arguments);
                }
            }
            placeBubbles(t) {
                let e = this.checkOverlap, i = this.positionBubble, s = [], a = 1, o = 0, r = 0, n, l = [], h, p = t.sort((t, e)=>e[2] - t[2]);
                if (p.length) {
                    if (s.push([
                        [
                            0,
                            0,
                            p[0][2],
                            p[0][3],
                            p[0][4]
                        ]
                    ]), p.length > 1) for(s.push([
                        [
                            0,
                            0 - p[1][2] - p[0][2],
                            p[1][2],
                            p[1][3],
                            p[1][4]
                        ]
                    ]), h = 2; h < p.length; h++)p[h][2] = p[h][2] || 1, e(n = i(s[a][o], s[a - 1][r], p[h]), s[a][0]) ? (s.push([]), r = 0, s[a + 1].push(i(s[a][o], s[a][0], p[h])), a++, o = 0) : a > 1 && s[a - 1][r + 1] && e(n, s[a - 1][r + 1]) ? (r++, s[a].push(i(s[a][o], s[a - 1][r], p[h])), o++) : (o++, s[a].push(n));
                    this.chart.stages = s, this.chart.rawPositions = [].concat.apply([], s), this.resizeRadius(), l = this.chart.rawPositions;
                }
                return l;
            }
            pointAttribs(t, e) {
                let i = this.options, s = t && t.isParentNode, a = i.marker;
                s && i.layoutAlgorithm && i.layoutAlgorithm.parentNodeOptions && (a = i.layoutAlgorithm.parentNodeOptions.marker);
                let o = a.fillOpacity, r = iH.pointAttribs.call(this, t, e);
                return 1 !== o && (r["fill-opacity"] = o), r;
            }
            positionBubble(t, e, i) {
                let s = Math.asin, a = Math.acos, o = Math.pow, r = Math.abs, n = (0, Math.sqrt)(o(t[0] - e[0], 2) + o(t[1] - e[1], 2)), l = a((o(n, 2) + o(i[2] + e[2], 2) - o(i[2] + t[2], 2)) / (2 * (i[2] + e[2]) * n)), h = s(r(t[0] - e[0]) / n), p = (t[1] - e[1] < 0 ? 0 : Math.PI) + l + h * ((t[0] - e[0]) * (t[1] - e[1]) < 0 ? 1 : -1), d = Math.cos(p), c = Math.sin(p);
                return [
                    e[0] + (e[2] + i[2]) * c,
                    e[1] - (e[2] + i[2]) * d,
                    i[2],
                    i[3],
                    i[4]
                ];
            }
            render() {
                let t = [];
                iH.render.apply(this, arguments), !this.options.dataLabels.allowOverlap && (this.data.forEach((e)=>{
                    iK(e.dataLabels) && e.dataLabels.forEach((e)=>{
                        t.push(e);
                    });
                }), this.options.useSimulation && this.chart.hideOverlappingLabels(t));
            }
            resizeRadius() {
                let t, e, i, s, a, o = this.chart, r = o.rawPositions, n = Math.min, l = Math.max, h = o.plotLeft, p = o.plotTop, d = o.plotHeight, c = o.plotWidth;
                for (let o of (t = i = Number.POSITIVE_INFINITY, e = s = Number.NEGATIVE_INFINITY, r))a = o[2], t = n(t, o[0] - a), e = l(e, o[0] + a), i = n(i, o[1] - a), s = l(s, o[1] + a);
                let u = [
                    e - t,
                    s - i
                ], g = [
                    (c - h) / u[0],
                    (d - p) / u[1]
                ], f = n.apply([], g);
                if (Math.abs(f - 1) > 1e-10) {
                    for (let t of r)t[2] *= f;
                    this.placeBubbles(r);
                } else o.diffY = d / 2 + p - i - (s - i) / 2, o.diffX = c / 2 + h - t - (e - t) / 2;
            }
            seriesBox() {
                let t, e = this.chart, i = this.data, s = Math.max, a = Math.min, o = [
                    e.plotLeft,
                    e.plotLeft + e.plotWidth,
                    e.plotTop,
                    e.plotTop + e.plotHeight
                ];
                return i.forEach((e)=>{
                    iV(e.plotX) && iV(e.plotY) && e.marker.radius && (t = e.marker.radius, o[0] = a(o[0], e.plotX - t), o[1] = s(o[1], e.plotX + t), o[2] = a(o[2], e.plotY - t), o[3] = s(o[3], e.plotY + t));
                }), ij(o.width / o.height) ? o : null;
            }
            setVisible() {
                let t = this;
                iH.setVisible.apply(t, arguments), t.parentNodeLayout && t.graph ? t.visible ? (t.graph.show(), t.parentNode.dataLabel && t.parentNode.dataLabel.show()) : (t.graph.hide(), t.parentNodeLayout.removeElementFromCollection(t.parentNode, t.parentNodeLayout.nodes), t.parentNode.dataLabel && t.parentNode.dataLabel.hide()) : t.layout && (t.visible ? t.layout.addElementsToCollection(t.points, t.layout.nodes) : t.points.forEach((e)=>{
                    t.layout.removeElementFromCollection(e, t.layout.nodes);
                }));
            }
            translate() {
                let t, e, i, s = this.chart, a = this.data, o = this.index, r = this.options.useSimulation;
                for (let n of (this.generatePoints(), iV(s.allDataPoints) || (s.allDataPoints = this.accumulateAllPoints(), this.getPointRadius()), r ? i = s.allDataPoints : (i = this.placeBubbles(s.allDataPoints), this.options.draggable = !1), i))n[3] === o && (t = a[n[4]], e = i$(n[2], void 0), r || (t.plotX = n[0] - s.plotLeft + s.diffX, t.plotY = n[1] - s.plotTop + s.diffY), ij(e) && (t.marker = i_(t.marker, {
                    radius: e,
                    width: 2 * e,
                    height: 2 * e
                }), t.radius = e));
                r && this.deferLayout(), iU(this, "afterTranslate");
            }
        }
        iQ.defaultOptions = iZ(iB.defaultOptions, {
            minSize: "10%",
            maxSize: "50%",
            sizeBy: "area",
            zoneAxis: "y",
            crisp: !1,
            tooltip: {
                pointFormat: "Value: {point.value}"
            },
            draggable: !0,
            useSimulation: !0,
            parentNode: {
                allowPointSelect: !1
            },
            dataLabels: {
                formatter: function() {
                    let { numberFormatter: t } = this.series.chart, { value: e } = this.point;
                    return it(e) ? t(e, -1) : "";
                },
                parentNodeFormatter: function() {
                    return this.name || "";
                },
                parentNodeTextPath: {
                    enabled: !0
                },
                padding: 0,
                style: {
                    transition: "opacity 2000ms"
                }
            },
            layoutAlgorithm: {
                initialPositions: "circle",
                initialPositionRadius: 20,
                bubblePadding: 5,
                parentNodeLimit: !1,
                seriesInteraction: !0,
                dragBetweenSeries: !1,
                parentNodeOptions: {
                    maxIterations: 400,
                    gravitationalConstant: .03,
                    maxSpeed: 50,
                    initialPositionRadius: 100,
                    seriesInteraction: !0,
                    marker: {
                        fillColor: null,
                        fillOpacity: 1,
                        lineWidth: null,
                        lineColor: null,
                        symbol: "circle"
                    }
                },
                enableSimulation: !0,
                type: "packedbubble",
                integration: "packedbubble",
                maxIterations: 1e3,
                splitSeries: !1,
                maxSpeed: 5,
                gravitationalConstant: .01,
                friction: -0.981
            },
            stickyTracking: !1
        }), i_(iQ.prototype, {
            pointClass: e7,
            axisTypes: [],
            directTouch: !0,
            forces: [
                "barycenter",
                "repulsive"
            ],
            hasDraggableNodes: !0,
            invertible: !1,
            isCartesian: !1,
            noSharedTooltip: !0,
            pointArrayMap: [
                "value"
            ],
            pointValKey: "value",
            requireSorting: !1,
            trackerGroups: [
                "group",
                "dataLabelsGroup",
                "parentNodesGroup"
            ],
            initDataLabels: iW,
            alignDataLabel: iH.alignDataLabel,
            indexateNodes: iO,
            onMouseDown: eZ.onMouseDown,
            onMouseMove: eZ.onMouseMove,
            redrawHalo: eZ.redrawHalo,
            searchPoint: iO
        }), P().registerSeriesType("packedbubble", iQ);
        let { noop: iJ } = y(), { area: i0, line: i1, scatter: i2 } = P().seriesTypes, { extend: i3, merge: i5 } = y();
        class i8 extends i2 {
            getGraphPath() {
                let t = i1.prototype.getGraphPath.call(this), e = t.length + 1;
                for(; e--;)(e === t.length || "M" === t[e][0]) && e > 0 && t.splice(e, 0, [
                    "Z"
                ]);
                return this.areaPath = t, t;
            }
            drawGraph() {
                this.options.fillColor = this.color, i0.prototype.drawGraph.call(this);
            }
        }
        i8.defaultOptions = i5(i2.defaultOptions, {
            marker: {
                enabled: !1,
                states: {
                    hover: {
                        enabled: !1
                    }
                }
            },
            stickyTracking: !1,
            tooltip: {
                followPointer: !0,
                pointFormat: ""
            },
            trackByArea: !0,
            legendSymbol: "rectangle"
        }), i3(i8.prototype, {
            type: "polygon",
            drawTracker: i1.prototype.drawTracker,
            setStackedPoints: iJ
        }), P().registerSeriesType("polygon", i8);
        let { defaultOptions: i6 } = y(), { noop: i9 } = y(), { addEvent: i4, extend: i7, isObject: st, merge: se, relativeLength: si } = y(), ss = {
            radius: 0,
            scope: "stack",
            where: void 0
        }, sa = i9, so = i9;
        function sr(t, e, i, s, a = {}) {
            let o = sa(t, e, i, s, a), { brStart: r = !0, brEnd: n = !0, innerR: l = 0, r: h = i, start: p = 0, end: d = 0 } = a;
            if (a.open || !a.borderRadius) return o;
            let c = d - p, u = Math.sin(c / 2), g = Math.max(Math.min(si(a.borderRadius || 0, h - l), (h - l) / 2, h * u / (1 + u)), 0), f = Math.min(g, c / Math.PI * 2 * l), m = o.length - 1;
            for(; m--;)(r || 0 !== m && 3 !== m) && (n || 1 !== m && 2 !== m) && !function(t, e, i) {
                let s, a, o, r = t[e], n = t[e + 1];
                if ("Z" === n[0] && (n = t[0]), ("M" === r[0] || "L" === r[0]) && "A" === n[0] ? (s = r, a = n, o = !0) : "A" === r[0] && ("M" === n[0] || "L" === n[0]) && (s = n, a = r), s && a && a.params) {
                    let r = a[1], n = a[5], l = a.params, { start: h, end: p, cx: d, cy: c } = l, u = n ? r - i : r + i, g = u ? Math.asin(i / u) : 0, f = n ? g : -g, m = Math.cos(g) * u;
                    o ? (l.start = h + f, s[1] = d + m * Math.cos(h), s[2] = c + m * Math.sin(h), t.splice(e + 1, 0, [
                        "A",
                        i,
                        i,
                        0,
                        0,
                        1,
                        d + r * Math.cos(l.start),
                        c + r * Math.sin(l.start)
                    ])) : (l.end = p - f, a[6] = d + r * Math.cos(l.end), a[7] = c + r * Math.sin(l.end), t.splice(e + 1, 0, [
                        "A",
                        i,
                        i,
                        0,
                        0,
                        1,
                        d + m * Math.cos(p),
                        c + m * Math.sin(p)
                    ])), a[4] = Math.abs(l.end - l.start) < Math.PI ? 0 : 1;
                }
            }(o, m, m > 1 ? f : g);
            return o;
        }
        function sn() {
            if (this.options.borderRadius && !(this.chart.is3d && this.chart.is3d())) {
                let { options: t, yAxis: e } = this, i = "percent" === t.stacking, s = i6.plotOptions?.[this.type]?.borderRadius, a = sl(t.borderRadius, st(s) ? s : {}), o = e.options.reversed;
                for (let s of this.points){
                    let { shapeArgs: r } = s;
                    if ("roundedRect" === s.shapeType && r) {
                        let { width: n = 0, height: l = 0, y: h = 0 } = r, p = h, d = l;
                        if ("stack" === a.scope && s.stackTotal) {
                            let a = e.translate(i ? 100 : s.stackTotal, !1, !0, !1, !0), o = e.translate(t.threshold || 0, !1, !0, !1, !0), r = this.crispCol(0, Math.min(a, o), 0, Math.abs(a - o));
                            p = r.y, d = r.height;
                        }
                        let c = (s.negative ? -1 : 1) * (o ? -1 : 1) == -1, u = a.where;
                        !u && this.is("waterfall") && Math.abs((s.yBottom || 0) - (this.translatedThreshold || 0)) > this.borderWidth && (u = "all"), u || (u = "end");
                        let g = Math.min(si(a.radius, n), n / 2, "all" === u ? l / 2 : 1 / 0) || 0;
                        "end" === u && (c && (p -= g), d += g), i7(r, {
                            brBoxHeight: d,
                            brBoxY: p,
                            r: g
                        });
                    }
                }
            }
        }
        function sl(t, e) {
            return st(t) || (t = {
                radius: t || 0
            }), se(ss, e, t);
        }
        function sh() {
            let t = sl(this.options.borderRadius);
            for (let e of this.points){
                let i = e.shapeArgs;
                i && (i.borderRadius = si(t.radius, (i.r || 0) - (i.innerR || 0)));
            }
        }
        function sp(t, e, i, s, a = {}) {
            let o = so(t, e, i, s, a), { r: r = 0, brBoxHeight: n = s, brBoxY: l = e } = a, h = e - l, p = l + n - (e + s), d = h - r > -0.1 ? 0 : r, c = p - r > -0.1 ? 0 : r, u = Math.max(d && h, 0), g = Math.max(c && p, 0), f = [
                t + d,
                e
            ], m = [
                t + i - d,
                e
            ], b = [
                t + i,
                e + d
            ], y = [
                t + i,
                e + s - c
            ], x = [
                t + i - c,
                e + s
            ], P = [
                t + c,
                e + s
            ], M = [
                t,
                e + s - c
            ], v = [
                t,
                e + d
            ], L = (t, e)=>Math.sqrt(Math.pow(t, 2) - Math.pow(e, 2));
            if (u) {
                let t = L(d, d - u);
                f[0] -= t, m[0] += t, b[1] = v[1] = e + d - u;
            }
            if (s < d - u) {
                let a = L(d, d - u - s);
                b[0] = y[0] = t + i - d + a, x[0] = Math.min(b[0], x[0]), P[0] = Math.max(y[0], P[0]), M[0] = v[0] = t + d - a, b[1] = v[1] = e + s;
            }
            if (g) {
                let t = L(c, c - g);
                x[0] += t, P[0] -= t, y[1] = M[1] = e + s - c + g;
            }
            if (s < c - g) {
                let a = L(c, c - g - s);
                b[0] = y[0] = t + i - c + a, m[0] = Math.min(b[0], m[0]), f[0] = Math.max(y[0], f[0]), M[0] = v[0] = t + c - a, y[1] = M[1] = e;
            }
            return o.length = 0, o.push([
                "M",
                ...f
            ], [
                "L",
                ...m
            ], [
                "A",
                d,
                d,
                0,
                0,
                1,
                ...b
            ], [
                "L",
                ...y
            ], [
                "A",
                c,
                c,
                0,
                0,
                1,
                ...x
            ], [
                "L",
                ...P
            ], [
                "A",
                c,
                c,
                0,
                0,
                1,
                ...M
            ], [
                "L",
                ...v
            ], [
                "A",
                d,
                d,
                0,
                0,
                1,
                ...f
            ], [
                "Z"
            ]), o;
        }
        let sd = {
            circular: {
                gridLineWidth: 1,
                labels: {
                    align: void 0,
                    x: 0,
                    y: void 0
                },
                maxPadding: 0,
                minPadding: 0,
                showLastLabel: !1,
                tickLength: 0
            },
            radial: {
                gridLineInterpolation: "circle",
                gridLineWidth: 1,
                labels: {
                    align: "right",
                    padding: 5,
                    x: -3,
                    y: -2
                },
                showLastLabel: !1,
                title: {
                    x: 4,
                    text: null,
                    rotation: 90
                }
            },
            radialGauge: {
                endOnTick: !1,
                gridLineWidth: 0,
                labels: {
                    align: "center",
                    distance: -25,
                    x: 0,
                    y: void 0
                },
                lineWidth: 1,
                minorGridLineWidth: 0,
                minorTickInterval: "auto",
                minorTickLength: 10,
                minorTickPosition: "inside",
                minorTickWidth: 1,
                startOnTick: !1,
                tickLength: 10,
                tickPixelInterval: 100,
                tickPosition: "inside",
                tickWidth: 2,
                title: {
                    rotation: 0,
                    text: ""
                },
                zIndex: 2
            }
        }, { defaultOptions: sc } = y(), { composed: su, noop: sg } = y(), { addEvent: sf, correctFloat: sm, defined: sb, extend: sy, fireEvent: sx, isObject: sP, merge: sM, pick: sv, pushUnique: sL, relativeLength: sk, splat: sw, wrap: sA } = y();
        !function(t) {
            function e() {
                this.autoConnect = this.isCircular && void 0 === sv(this.userMax, this.options.max) && sm(this.endAngleRad - this.startAngleRad) === sm(2 * Math.PI), !this.isCircular && this.chart.inverted && this.max++, this.autoConnect && (this.max += this.categories && 1 || this.pointRange || this.closestPointRange || 0);
            }
            function i() {
                return ()=>{
                    if (this.isRadial && this.tickPositions && this.options.labels && !0 !== this.options.labels.allowOverlap) return this.tickPositions.map((t)=>this.ticks[t]?.label).filter((t)=>!!t);
                };
            }
            function s() {
                return sg;
            }
            function a(t, e, i) {
                let s = this.pane.center, a = t.value, o, r, n;
                return this.isCircular ? (sb(a) ? t.point && (t.point.shapeArgs || {}).start && (a = this.chart.inverted ? this.translate(t.point.rectPlotY, !0) : t.point.x) : (r = t.chartX || 0, n = t.chartY || 0, a = this.translate(Math.atan2(n - i, r - e) - this.startAngleRad, !0)), r = (o = this.getPosition(a)).x, n = o.y) : (sb(a) || (r = t.chartX, n = t.chartY), sb(r) && sb(n) && (i = s[1] + this.chart.plotTop, a = this.translate(Math.min(Math.sqrt(Math.pow(r - e, 2) + Math.pow(n - i, 2)), s[2] / 2) - s[3] / 2, !0))), [
                    a,
                    r || 0,
                    n || 0
                ];
            }
            function o(t, e, i) {
                let s = this.pane.center, a = this.chart, o = this.left || 0, r = this.top || 0, n, l = sv(e, s[2] / 2 - this.offset), h;
                return void 0 === i && (i = this.horiz ? 0 : this.center && -this.center[3] / 2), i && (l += i), this.isCircular || void 0 !== e ? ((h = this.chart.renderer.symbols.arc(o + s[0], r + s[1], l, l, {
                    start: this.startAngleRad,
                    end: this.endAngleRad,
                    open: !0,
                    innerR: 0
                })).xBounds = [
                    o + s[0]
                ], h.yBounds = [
                    r + s[1] - l
                ]) : (n = this.postTranslate(this.angleRad, l), h = [
                    [
                        "M",
                        this.center[0] + a.plotLeft,
                        this.center[1] + a.plotTop
                    ],
                    [
                        "L",
                        n.x,
                        n.y
                    ]
                ]), h;
            }
            function r() {
                this.constructor.prototype.getOffset.call(this), this.chart.axisOffset[this.side] = 0;
            }
            function n(t, e, i) {
                let s = this.chart, a = (t)=>{
                    if ("string" == typeof t) {
                        let e = parseInt(t, 10);
                        return c.test(t) && (e = e * l / 100), e;
                    }
                    return t;
                }, o = this.center, r = this.startAngleRad, n = i.borderRadius, l = o[2] / 2, h = Math.min(this.offset, 0), p = this.left || 0, d = this.top || 0, c = /%$/, u = this.isCircular, g = this.options.plotBands || [], f = g.indexOf(i), m, b, y, x, P, M, v = sv(a(i.outerRadius), l), L = a(i.innerRadius), k = sv(a(i.thickness), 10), w = !0, A = !0;
                if (n && f > -1 && (g[f - 1] && g[f - 1].to === t && (w = !1), g[f + 1] && g[f + 1].from === e && (A = !1)), "polygon" === this.options.gridLineInterpolation) M = this.getPlotLinePath({
                    value: t
                }).concat(this.getPlotLinePath({
                    value: e,
                    reverse: !0
                }));
                else {
                    t = Math.max(t, this.min), e = Math.min(e, this.max);
                    let a = this.translate(t), l = this.translate(e);
                    u || (v = a || 0, L = l || 0), "circle" !== i.shape && u ? (m = r + (a || 0), b = r + (l || 0)) : (m = -Math.PI / 2, b = 1.5 * Math.PI, P = !0), v -= h, k -= h, M = s.renderer.symbols.arc(p + o[0], d + o[1], v, v, {
                        start: Math.min(m, b),
                        end: Math.max(m, b),
                        innerR: sv(L, v - k),
                        open: P,
                        borderRadius: n,
                        brStart: w,
                        brEnd: A
                    }), u && (y = (b + m) / 2, x = p + o[0] + o[2] / 2 * Math.cos(y), M.xBounds = y > -Math.PI / 2 && y < Math.PI / 2 ? [
                        x,
                        s.plotWidth
                    ] : [
                        0,
                        x
                    ], M.yBounds = [
                        d + o[1] + o[2] / 2 * Math.sin(y)
                    ], M.yBounds[0] += y > -Math.PI && y < 0 || y > Math.PI ? -10 : 10);
                }
                return M;
            }
            function l(t) {
                let e = this.pane.center, i = this.chart, s = i.inverted, a = t.reverse, o = this.pane.options.background, r = o ? sw(o)[0] : {}, n = r.innerRadius || "0%", l = r.outerRadius || "100%", h = e[0] + i.plotLeft, p = e[1] + i.plotTop, d = this.height, c = t.isCrosshair, u = e[3] / 2, g = t.value, f, m, b, y, x, P, M, v, L, k = this.getPosition(g), w = k.x, A = k.y;
                if (c && (g = (v = this.getCrosshairPosition(t, h, p))[0], w = v[1], A = v[2]), this.isCircular) m = Math.sqrt(Math.pow(w - h, 2) + Math.pow(A - p, 2)), b = "string" == typeof n ? sk(n, 1) : n / m, y = "string" == typeof l ? sk(l, 1) : l / m, e && u && (b < (f = u / m) && (b = f), y < f && (y = f)), L = [
                    [
                        "M",
                        h + b * (w - h),
                        p - b * (p - A)
                    ],
                    [
                        "L",
                        w - (1 - y) * (w - h),
                        A + (1 - y) * (p - A)
                    ]
                ];
                else if ((g = this.translate(g)) && (g < 0 || g > d) && (g = 0), "circle" === this.options.gridLineInterpolation) L = this.getLinePath(0, g, u);
                else if (L = [], i[s ? "yAxis" : "xAxis"].forEach((t)=>{
                    t.pane === this.pane && (x = t);
                }), x) {
                    M = x.tickPositions, x.autoConnect && (M = M.concat([
                        M[0]
                    ])), a && (M = M.slice().reverse()), g && (g += u);
                    for(let t = 0; t < M.length; t++)P = x.getPosition(M[t], g), L.push(t ? [
                        "L",
                        P.x,
                        P.y
                    ] : [
                        "M",
                        P.x,
                        P.y
                    ]);
                }
                return L;
            }
            function h(t, e) {
                let i = this.translate(t);
                return this.postTranslate(this.isCircular ? i : this.angleRad, sv(this.isCircular ? e : i < 0 ? 0 : i, this.center[2] / 2) - this.offset);
            }
            function p() {
                let t = this.center, e = this.chart, i = this.options.title;
                return {
                    x: e.plotLeft + t[0] + (i.x || 0),
                    y: e.plotTop + t[1] - ({
                        high: .5,
                        middle: .25,
                        low: 0
                    })[i.align] * t[2] + (i.y || 0)
                };
            }
            function d(t) {
                t.beforeSetTickPositions = e, t.createLabelCollector = i, t.getCrosshairPosition = a, t.getLinePath = o, t.getOffset = r, t.getPlotBandPath = n, t.getPlotLinePath = l, t.getPosition = h, t.getTitlePosition = p, t.postTranslate = M, t.setAxisSize = L, t.setAxisTranslation = k, t.setOptions = w;
            }
            function c() {
                let t = this.chart, e = this.options, i = t.angular && this.isXAxis, s = this.pane, a = s?.options;
                if (!i && s && (t.angular || t.polar)) {
                    let t = 2 * Math.PI, i = (sv(a.startAngle, 0) - 90) * Math.PI / 180, s = (sv(a.endAngle, sv(a.startAngle, 0) + 360) - 90) * Math.PI / 180;
                    this.angleRad = (e.angle || 0) * Math.PI / 180, this.startAngleRad = i, this.endAngleRad = s, this.offset = e.offset || 0;
                    let o = (i % t + t) % t, r = (s % t + t) % t;
                    o > Math.PI && (o -= t), r > Math.PI && (r -= t), this.normalizedStartAngleRad = o, this.normalizedEndAngleRad = r;
                }
            }
            function u(t) {
                this.isRadial && (t.align = void 0, t.preventDefault());
            }
            function g() {
                if (this.chart?.labelCollectors) {
                    let t = this.labelCollector ? this.chart.labelCollectors.indexOf(this.labelCollector) : -1;
                    t >= 0 && this.chart.labelCollectors.splice(t, 1);
                }
            }
            function f(t) {
                let e, i = this.chart, a = i.angular, o = i.polar, r = this.isXAxis, n = this.coll, l = t.userOptions.pane || 0, h = this.pane = i.pane && i.pane[l];
                if ("colorAxis" === n) {
                    this.isRadial = !1;
                    return;
                }
                if (a) {
                    if (a && r) this.isHidden = !0, this.createLabelCollector = s, this.getOffset = sg, this.redraw = v, this.render = v, this.setScale = sg, this.setCategories = sg, this.setTitle = sg;
                    else d(this);
                    e = !r;
                } else o && (d(this), e = this.horiz);
                a || o ? (this.isRadial = !0, this.labelCollector || (this.labelCollector = this.createLabelCollector()), this.labelCollector && i.labelCollectors.push(this.labelCollector)) : this.isRadial = !1, h && e && (h.axis = this), this.isCircular = e;
            }
            function m() {
                this.isRadial && this.beforeSetTickPositions();
            }
            function b(t) {
                let e = this.label;
                if (!e) return;
                let i = this.axis, s = e.getBBox(), a = i.options.labels, o = (i.translate(this.pos) + i.startAngleRad + Math.PI / 2) / Math.PI * 180 % 360, r = Math.round(o), n = sb(a.y) ? 0 : -(.3 * s.height), l = a.y, h, p = 20, d = a.align, c = "end", u = r < 0 ? r + 360 : r, g = u, f = 0, m = 0;
                i.isRadial && (h = i.getPosition(this.pos, i.center[2] / 2 + sk(sv(a.distance, -25), i.center[2] / 2, -i.center[2] / 2)), "auto" === a.rotation ? e.attr({
                    rotation: o
                }) : sb(l) || (l = i.chart.renderer.fontMetrics(e).b - s.height / 2), sb(d) || (i.isCircular ? (s.width > i.len * i.tickInterval / (i.max - i.min) && (p = 0), d = o > p && o < 180 - p ? "left" : o > 180 + p && o < 360 - p ? "right" : "center") : d = "center", e.attr({
                    align: d
                })), "auto" === d && 2 === i.tickPositions.length && i.isCircular && (u > 90 && u < 180 ? u = 180 - u : u > 270 && u <= 360 && (u = 540 - u), g > 180 && g <= 360 && (g = 360 - g), (i.pane.options.startAngle === r || i.pane.options.startAngle === r + 360 || i.pane.options.startAngle === r - 360) && (c = "start"), d = r >= -90 && r <= 90 || r >= -360 && r <= -270 || r >= 270 && r <= 360 ? "start" === c ? "right" : "left" : "start" === c ? "left" : "right", g > 70 && g < 110 && (d = "center"), u < 15 || u >= 180 && u < 195 ? f = .3 * s.height : u >= 15 && u <= 35 ? f = "start" === c ? 0 : .75 * s.height : u >= 195 && u <= 215 ? f = "start" === c ? .75 * s.height : 0 : u > 35 && u <= 90 ? f = "start" === c ? -(.25 * s.height) : s.height : u > 215 && u <= 270 && (f = "start" === c ? s.height : -(.25 * s.height)), g < 15 ? m = "start" === c ? -(.15 * s.height) : .15 * s.height : g > 165 && g <= 180 && (m = "start" === c ? .15 * s.height : -(.15 * s.height)), e.attr({
                    align: d
                }), e.translate(m, f + n)), t.pos.x = h.x + (a.x || 0), t.pos.y = h.y + (l || 0));
            }
            function x(t) {
                this.axis.getPosition && sy(t.pos, this.axis.getPosition(this.pos));
            }
            function P({ options: e }) {
                e.xAxis && sM(!0, t.radialDefaultOptions.circular, e.xAxis), e.yAxis && sM(!0, t.radialDefaultOptions.radialGauge, e.yAxis);
            }
            function M(t, e) {
                let i = this.chart, s = this.center;
                return t = this.startAngleRad + t, {
                    x: i.plotLeft + s[0] + Math.cos(t) * e,
                    y: i.plotTop + s[1] + Math.sin(t) * e
                };
            }
            function v() {
                this.isDirty = !1;
            }
            function L() {
                let t, e;
                this.constructor.prototype.setAxisSize.call(this), this.isRadial && (this.pane.updateCenter(this), t = this.center = this.pane.center.slice(), this.isCircular ? this.sector = this.endAngleRad - this.startAngleRad : (e = this.postTranslate(this.angleRad, t[3] / 2), t[0] = e.x - this.chart.plotLeft, t[1] = e.y - this.chart.plotTop), this.len = this.width = this.height = (t[2] - t[3]) * sv(this.sector, 1) / 2);
            }
            function k() {
                this.constructor.prototype.setAxisTranslation.call(this), this.center && (this.isCircular ? this.transA = (this.endAngleRad - this.startAngleRad) / (this.max - this.min || 1) : this.transA = (this.center[2] - this.center[3]) / 2 / (this.max - this.min || 1), this.isXAxis ? this.minPixelPadding = this.transA * this.minPointOffset : this.minPixelPadding = 0);
            }
            function w(e) {
                let { coll: i } = this, { angular: s, inverted: a, polar: o } = this.chart, r = {};
                s ? this.isXAxis || (r = sM(sc.yAxis, t.radialDefaultOptions.radialGauge)) : o && (r = this.horiz ? sM(sc.xAxis, t.radialDefaultOptions.circular) : sM("xAxis" === i ? sc.xAxis : sc.yAxis, t.radialDefaultOptions.radial)), a && "yAxis" === i && (r.stackLabels = sP(sc.yAxis, !0) ? sc.yAxis.stackLabels : {}, r.reversedStacks = !0);
                let n = this.options = sM(r, e);
                n.plotBands || (n.plotBands = []), sx(this, "afterSetOptions");
            }
            function A(t, e, i, s, a, o, r) {
                let n, l, h = this.axis;
                return h.isRadial ? [
                    "M",
                    e,
                    i,
                    "L",
                    (n = h.getPosition(this.pos, h.center[2] / 2 + s)).x,
                    n.y
                ] : t.call(this, e, i, s, a, o, r);
            }
            t.radialDefaultOptions = sM(sd), t.compose = function(t, e) {
                return sL(su, "Axis.Radial") && (sf(t, "afterInit", c), sf(t, "autoLabelAlign", u), sf(t, "destroy", g), sf(t, "init", f), sf(t, "initialAxisTranslation", m), sf(e, "afterGetLabelPosition", b), sf(e, "afterGetPosition", x), sf(y(), "setOptions", P), sA(e.prototype, "getMarkPath", A)), t;
            };
        }(d || (d = {}));
        let sS = d, { animObject: sT } = y(), { optionsToObject: sC } = {
            compose: function(t, e, i) {
                let s = t.types.pie;
                if (!e.symbolCustomAttribs.includes("borderRadius")) {
                    let a = i.prototype.symbols;
                    i4(t, "afterColumnTranslate", sn, {
                        order: 9
                    }), i4(s, "afterTranslate", sh), e.symbolCustomAttribs.push("borderRadius", "brBoxHeight", "brBoxY", "brEnd", "brStart"), sa = a.arc, so = a.roundedRect, a.arc = sr, a.roundedRect = sp;
                }
            },
            optionsToObject: sl
        }, { defaultOptions: sN } = y(), { composed: sX } = y(), { addEvent: sY, defined: sR, find: sI, isNumber: sE, isObject: sD, merge: sz, pick: sO, pushUnique: sH, relativeLength: sB, splat: sW, uniqueKey: sF, wrap: sG } = y();
        function sq() {
            (this.pane || []).forEach((t)=>{
                t.render();
            });
        }
        function sV(t) {
            let e = t.args[0].xAxis, i = t.args[0].yAxis, s = t.args[0].chart;
            e && i && ("polygon" === i.gridLineInterpolation ? (e.startOnTick = !0, e.endOnTick = !0) : "polygon" === e.gridLineInterpolation && s.inverted && (i.startOnTick = !0, i.endOnTick = !0));
        }
        function s_() {
            this.pane || (this.pane = []), this.options.pane = sW(this.options.pane || {}), sW(this.userOptions.pane || {}).forEach((t)=>{
                new V(t, this);
            }, this);
        }
        function sU(t) {
            let e = t.args.marker, i = this.chart.xAxis[0], s = this.chart.yAxis[0], a = this.chart.inverted, o = a ? s : i, r = a ? i : s;
            if (this.chart.polar) {
                t.preventDefault();
                let i = (e.attr ? e.attr("start") : e.start) - o.startAngleRad, s = e.attr ? e.attr("r") : e.r, a = (e.attr ? e.attr("end") : e.end) - o.startAngleRad, n = e.attr ? e.attr("innerR") : e.innerR;
                t.result.x = i + o.pos, t.result.width = a - i, t.result.y = r.len + r.pos - s, t.result.height = s - n;
            }
        }
        function sK(t) {
            let e = this.chart;
            if (e.polar && e.hoverPane && e.hoverPane.axis) {
                t.preventDefault();
                let i = e.hoverPane.center, s = e.mouseDownX || 0, a = e.mouseDownY || 0, o = t.args.chartY, r = t.args.chartX, n = 2 * Math.PI, l = e.hoverPane.axis.startAngleRad, h = e.hoverPane.axis.endAngleRad, p = e.inverted ? e.xAxis[0] : e.yAxis[0], d = {}, c = "arc";
                if (d.x = i[0] + e.plotLeft, d.y = i[1] + e.plotTop, this.zoomHor) {
                    let t = l > 0 ? h - l : Math.abs(l) + Math.abs(h), u = Math.atan2(a - e.plotTop - i[1], s - e.plotLeft - i[0]) - l, g = Math.atan2(o - e.plotTop - i[1], r - e.plotLeft - i[0]) - l;
                    d.r = i[2] / 2, d.innerR = i[3] / 2, u <= 0 && (u += n), g <= 0 && (g += n), g < u && (g = [
                        u,
                        u = g
                    ][0]), t < n && l + g > h + (n - t) / 2 && (g = u, u = l <= 0 ? l : 0);
                    let f = d.start = Math.max(u + l, l), m = d.end = Math.min(g + l, h);
                    if ("polygon" === p.options.gridLineInterpolation) {
                        let t = e.hoverPane.axis, s = f - t.startAngleRad + t.pos, a = p.getPlotLinePath({
                            value: p.max
                        }), o = t.toValue(s), r = t.toValue(s + (m - f));
                        if (o < t.getExtremes().min) {
                            let { min: e, max: i } = t.getExtremes();
                            o = i - (e - o);
                        }
                        if (r < t.getExtremes().min) {
                            let { min: e, max: i } = t.getExtremes();
                            r = i - (e - r);
                        }
                        r < o && (r = [
                            o,
                            o = r
                        ][0]), (a = sJ(a, o, r, t)).push([
                            "L",
                            i[0] + e.plotLeft,
                            e.plotTop + i[1]
                        ]), d.d = a, c = "path";
                    }
                }
                if (this.zoomVert) {
                    let t = e.inverted ? e.xAxis[0] : e.yAxis[0], n = Math.sqrt(Math.pow(s - e.plotLeft - i[0], 2) + Math.pow(a - e.plotTop - i[1], 2)), p = Math.sqrt(Math.pow(r - e.plotLeft - i[0], 2) + Math.pow(o - e.plotTop - i[1], 2));
                    if (p < n && (n = [
                        p,
                        p = n
                    ][0]), p > i[2] / 2 && (p = i[2] / 2), n < i[3] / 2 && (n = i[3] / 2), this.zoomHor || (d.start = l, d.end = h), d.r = p, d.innerR = n, "polygon" === t.options.gridLineInterpolation) {
                        let e = t.toValue(t.len + t.pos - n), i = t.toValue(t.len + t.pos - p);
                        d.d = t.getPlotLinePath({
                            value: i
                        }).concat(t.getPlotLinePath({
                            value: e,
                            reverse: !0
                        })), c = "path";
                    }
                }
                if (this.zoomHor && this.zoomVert && "polygon" === p.options.gridLineInterpolation) {
                    let t = e.hoverPane.axis, i = d.start || 0, s = d.end || 0, a = i - t.startAngleRad + t.pos, o = t.toValue(a), r = t.toValue(a + (s - i));
                    if (d.d instanceof Array) {
                        let t = d.d.slice(0, d.d.length / 2), i = d.d.slice(d.d.length / 2, d.d.length);
                        i = [
                            ...i
                        ].reverse();
                        let s = e.hoverPane.axis;
                        t = sJ(t, o, r, s), (i = sJ(i, o, r, s)) && (i[0][0] = "L"), i = [
                            ...i
                        ].reverse(), d.d = t.concat(i), c = "path";
                    }
                }
                t.attrs = d, t.shapeType = c;
            }
        }
        function sj() {
            let t = this.chart;
            t.polar && (this.polar = new s7(this), t.inverted && (this.isRadialSeries = !0, this.is("column") && (this.isRadialBar = !0)));
        }
        function sZ() {
            let { chart: t, options: e, yAxis: i } = this;
            if (e.borderRadius && t.polar && t.inverted) {
                let t = sN.plotOptions?.[this.type]?.borderRadius, { scope: s, where: a = "end" } = sC(e.borderRadius, sD(t) ? t : {});
                for (let t of this.points){
                    let { shapeArgs: o } = t;
                    if ("arc" === t.shapeType && o) {
                        let r = "all" === a, n = !0;
                        e.stacking && "stack" === s && (r = t.stackY === t.y && "all" === a, n = t.stackY === t.stackTotal), i.reversed && ([r, n] = [
                            n,
                            r
                        ]), o.brStart = r, o.brEnd = n;
                    }
                }
            }
        }
        function s$() {
            if (this.chart.polar && this.xAxis) {
                let { xAxis: t, yAxis: e } = this, i = this.chart;
                this.kdByAngle = i.tooltip && i.tooltip.shared, this.kdByAngle || i.inverted ? this.searchPoint = sQ : this.options.findNearestPointBy = "xy";
                let s = this.points, a = s.length;
                for(; a--;)this.is("column") || this.is("columnrange") || this.polar.toXY(s[a]), i.hasParallelCoordinates || this.yAxis.reversed || (sO(s[a].y, Number.MIN_VALUE) < e.min || s[a].x < t.min || s[a].x > t.max ? (s[a].isNull = !0, s[a].plotY = NaN) : s[a].isNull = s[a].isValid && !s[a].isValid());
                this.hasClipCircleSetter || (this.hasClipCircleSetter = !!this.eventsToUnbind.push(sY(this, "afterRender", function() {
                    let t;
                    i.polar && !1 !== this.options.clip && (t = this.yAxis.pane.center, this.clipCircle ? this.clipCircle.animate({
                        x: t[0],
                        y: t[1],
                        r: t[2] / 2,
                        innerR: t[3] / 2
                    }) : this.clipCircle = function(t, e, i, s, a) {
                        let o = sF(), r = t.createElement("clipPath").attr({
                            id: o
                        }).add(t.defs), n = a ? t.arc(e, i, s, a, 0, 2 * Math.PI).add(r) : t.circle(e, i, s).add(r);
                        return n.id = o, n.clipPath = r, n;
                    }(i.renderer, t[0], t[1], t[2] / 2, t[3] / 2), this.group.clip(this.clipCircle), this.setClip = y().noop);
                })));
            }
        }
        function sQ(t) {
            let e = this.chart, i = this.xAxis, s = this.yAxis, a = i.pane && i.pane.center, o = t.chartX - (a && a[0] || 0) - e.plotLeft, r = t.chartY - (a && a[1] || 0) - e.plotTop, n = e.inverted ? {
                clientX: t.chartX - s.pos,
                plotY: t.chartY - i.pos
            } : {
                clientX: 180 + -180 / Math.PI * Math.atan2(o, r)
            };
            return this.searchKDTree(n);
        }
        function sJ(t, e, i, s) {
            let a = s.tickInterval, o = s.tickPositions, r = sI(o, (t)=>t >= i), n = sI([
                ...o
            ].reverse(), (t)=>t <= e);
            return sR(r) || (r = o[o.length - 1]), sR(n) || (n = o[0], r += a, t[0][0] = "L", t.unshift(t[t.length - 3])), (t = t.slice(o.indexOf(n), o.indexOf(r) + 1))[0][0] = "M", t;
        }
        function s0(t, e) {
            return sI(this.pane || [], (t)=>t.options.id === e) || t.call(this, e);
        }
        function s1(t, e, i, s, a, o) {
            let r, n, l, h = this.chart, p = sO(s.inside, !!this.options.stacking);
            if (h.polar) {
                if (r = e.rectPlotX / Math.PI * 180, h.inverted) this.forceDL = h.isInsidePlot(e.plotX, e.plotY), p && e.shapeArgs ? (n = e.shapeArgs, a = sz(a, {
                    x: (l = this.yAxis.postTranslate(((n.start || 0) + (n.end || 0)) / 2 - this.xAxis.startAngleRad, e.barX + e.pointWidth / 2)).x - h.plotLeft,
                    y: l.y - h.plotTop
                })) : e.tooltipPos && (a = sz(a, {
                    x: e.tooltipPos[0],
                    y: e.tooltipPos[1]
                })), s.align = sO(s.align, "center"), s.verticalAlign = sO(s.verticalAlign, "middle");
                else {
                    var d;
                    null === (d = s).align && (d.align = r > 20 && r < 160 ? "left" : r > 200 && r < 340 ? "right" : "center"), null === d.verticalAlign && (d.verticalAlign = r < 45 || r > 315 ? "bottom" : r > 135 && r < 225 ? "top" : "middle"), s = d;
                }
                v().prototype.alignDataLabel.call(this, e, i, s, a, o), this.isRadialBar && e.shapeArgs && e.shapeArgs.start === e.shapeArgs.end ? i.hide() : i.show();
            } else t.call(this, e, i, s, a, o);
        }
        function s2() {
            let t = this.options, e = t.stacking, i = this.chart, s = this.xAxis, a = this.yAxis, o = a.reversed, r = a.center, n = s.startAngleRad, l = s.endAngleRad - n, h = t.threshold, p = 0, d, c, u, g, f, m = 0, b = 0, x, P, M, v, L, k, w, A;
            if (s.isRadial) for(u = (d = this.points).length, g = a.translate(a.min), f = a.translate(a.max), h = t.threshold || 0, i.inverted && sE(h) && sR(p = a.translate(h)) && (p < 0 ? p = 0 : p > l && (p = l), this.translatedThreshold = p + n); u--;){
                if (k = (c = d[u]).barX, P = c.x, M = c.y, c.shapeType = "arc", i.inverted) {
                    c.plotY = a.translate(M), e && a.stacking ? (L = a.stacking.stacks[(M < 0 ? "-" : "") + this.stackKey], this.visible && L && L[P] && !c.isNull && (v = L[P].points[this.getStackIndicator(void 0, P, this.index).key], m = a.translate(v[0]), b = a.translate(v[1]), sR(m) && (m = y().clamp(m, 0, l)))) : (m = p, b = c.plotY), m > b && (b = [
                        m,
                        m = b
                    ][0]), o ? b > g ? b = g : m < f ? m = f : (m > g || b < f) && (m = b = l) : m < g ? m = g : b > f ? b = f : (b < g || m > f) && (m = b = 0), a.min > a.max && (m = b = o ? l : 0), m += n, b += n, r && (c.barX = k += r[3] / 2), w = Math.max(k, 0), A = Math.max(k + c.pointWidth, 0);
                    let i = t.borderRadius, s = sB(("object" == typeof i ? i.radius : i) || 0, A - w);
                    c.shapeArgs = {
                        x: r[0],
                        y: r[1],
                        r: A,
                        innerR: w,
                        start: m,
                        end: b,
                        borderRadius: s
                    }, c.opacity = m === b ? 0 : void 0, c.plotY = (sR(this.translatedThreshold) && (m < this.translatedThreshold ? m : b)) - n;
                } else m = k + n, c.shapeArgs = this.polar.arc(c.yBottom, c.plotY, m, m + c.pointWidth), c.shapeArgs.borderRadius = 0;
                this.polar.toXY(c), i.inverted ? (x = a.postTranslate(c.rectPlotY, k + c.pointWidth / 2), c.tooltipPos = [
                    x.x - i.plotLeft,
                    x.y - i.plotTop
                ]) : c.tooltipPos = [
                    c.plotX,
                    c.plotY
                ], r && (c.ttBelow = c.plotY > r[1]);
            }
        }
        function s3(t, e) {
            let i, s, a = this;
            if (this.chart.polar) {
                e = e || this.points;
                for(let t = 0; t < e.length; t++)if (!e[t].isNull) {
                    i = t;
                    break;
                }
                !1 !== this.options.connectEnds && void 0 !== i && (this.connectEnds = !0, e.splice(e.length, 0, e[i]), s = !0), e.forEach((t)=>{
                    void 0 === t.polarPlotY && a.polar.toXY(t);
                });
            }
            let o = t.apply(this, [].slice.call(arguments, 1));
            return s && e.pop(), o;
        }
        function s5(t, e) {
            let i = this.chart, s = {
                xAxis: [],
                yAxis: []
            };
            return i.polar ? i.axes.forEach((t)=>{
                if ("colorAxis" === t.coll) return;
                let a = t.isXAxis, o = t.center, r = e.chartX - o[0] - i.plotLeft, n = e.chartY - o[1] - i.plotTop;
                s[a ? "xAxis" : "yAxis"].push({
                    axis: t,
                    value: t.translate(a ? Math.PI - Math.atan2(r, n) : Math.sqrt(Math.pow(r, 2) + Math.pow(n, 2)), !0)
                });
            }) : s = t.call(this, e), s;
        }
        function s8(t, e) {
            this.chart.polar || t.call(this, e);
        }
        function s6(t, e) {
            let i = this, s = this.chart, a = this.group, o = this.markerGroup, r = this.xAxis && this.xAxis.center, n = s.plotLeft, l = s.plotTop, h = this.options.animation, p, d, c, u, g, f;
            s.polar ? i.isRadialBar ? e || (i.startAngleRad = sO(i.translatedThreshold, i.xAxis.startAngleRad), y().seriesTypes.pie.prototype.animate.call(i, e)) : (h = sT(h), i.is("column") ? e || (d = r[3] / 2, i.points.forEach((t)=>{
                c = t.graphic, g = (u = t.shapeArgs) && u.r, f = u && u.innerR, c && u && (c.attr({
                    r: d,
                    innerR: d
                }), c.animate({
                    r: g,
                    innerR: f
                }, i.options.animation));
            })) : e ? (p = {
                translateX: r[0] + n,
                translateY: r[1] + l,
                scaleX: .001,
                scaleY: .001
            }, a.attr(p), o && o.attr(p)) : (p = {
                translateX: n,
                translateY: l,
                scaleX: 1,
                scaleY: 1
            }, a.animate(p, h), o && o.animate(p, h))) : t.call(this, e);
        }
        function s9(t, e, i, s) {
            let a, o;
            if (this.chart.polar) {
                if (s) {
                    let t = (o = function t(e, i, s, a) {
                        let o, r, n, l, h, p, d = +!!a, c = (o = i >= 0 && i <= e.length - 1 ? i : i < 0 ? e.length - 1 + i : 0) - 1 < 0 ? e.length - (1 + d) : o - 1, u = o + 1 > e.length - 1 ? d : o + 1, g = e[c], f = e[u], m = g.plotX, b = g.plotY, y = f.plotX, x = f.plotY, P = e[o].plotX, M = e[o].plotY;
                        r = (1.5 * P + m) / 2.5, n = (1.5 * M + b) / 2.5, l = (1.5 * P + y) / 2.5, h = (1.5 * M + x) / 2.5;
                        let v = Math.sqrt(Math.pow(r - P, 2) + Math.pow(n - M, 2)), L = Math.sqrt(Math.pow(l - P, 2) + Math.pow(h - M, 2)), k = Math.atan2(n - M, r - P);
                        p = Math.PI / 2 + (k + Math.atan2(h - M, l - P)) / 2, Math.abs(k - p) > Math.PI / 2 && (p -= Math.PI), r = P + Math.cos(p) * v, n = M + Math.sin(p) * v;
                        let w = {
                            rightContX: l = P + Math.cos(Math.PI + p) * L,
                            rightContY: h = M + Math.sin(Math.PI + p) * L,
                            leftContX: r,
                            leftContY: n,
                            plotX: P,
                            plotY: M
                        };
                        return s && (w.prevPointCont = t(e, c, !1, a)), w;
                    }(e, s, !0, this.connectEnds)).prevPointCont && o.prevPointCont.rightContX, i = o.prevPointCont && o.prevPointCont.rightContY;
                    a = [
                        "C",
                        sE(t) ? t : o.plotX,
                        sE(i) ? i : o.plotY,
                        sE(o.leftContX) ? o.leftContX : o.plotX,
                        sE(o.leftContY) ? o.leftContY : o.plotY,
                        o.plotX,
                        o.plotY
                    ];
                } else a = [
                    "M",
                    i.plotX,
                    i.plotY
                ];
            } else a = t.call(this, e, i, s);
            return a;
        }
        function s4(t, e, i = this.plotY) {
            if (!this.destroyed) {
                let { plotX: s, series: a } = this, { chart: o } = a;
                return o.polar && sE(s) && sE(i) ? [
                    s + (e ? o.plotLeft : 0),
                    i + (e ? o.plotTop : 0)
                ] : t.call(this, e, i);
            }
        }
        class s7 {
            static compose(t, e, i, s, a, o, r, n, l, h) {
                if (V.compose(e, i), sS.compose(t, a), sH(sX, "Polar")) {
                    let t = e.prototype, a = o.prototype, p = i.prototype, d = s.prototype;
                    if (sY(e, "afterDrawChartBox", sq), sY(e, "createAxes", s_), sY(e, "init", sV), sG(t, "get", s0), sG(p, "getCoordinates", s5), sG(p, "pinch", s8), sY(i, "getSelectionMarkerAttrs", sK), sY(i, "getSelectionBox", sU), sY(s, "afterInit", sj), sY(s, "afterColumnTranslate", sZ, {
                        order: 9
                    }), sY(s, "afterTranslate", s$, {
                        order: 2
                    }), sY(s, "afterColumnTranslate", s2, {
                        order: 4
                    }), sG(d, "animate", s6), sG(a, "pos", s4), n) {
                        let t = n.prototype;
                        sG(t, "alignDataLabel", s1), sG(t, "animate", s6);
                    }
                    if (l && sG(l.prototype, "getGraphPath", s3), h) {
                        let t = h.prototype;
                        sG(t, "getPointSpline", s9), r && (r.prototype.getPointSpline = t.getPointSpline);
                    }
                }
            }
            constructor(t){
                this.series = t;
            }
            arc(t, e, i, s) {
                let a = this.series, o = a.xAxis.center, r = a.yAxis.len, n = o[3] / 2, l = r - e + n, h = r - sO(t, r) + n;
                return a.yAxis.reversed && (l < 0 && (l = n), h < 0 && (h = n)), {
                    x: o[0],
                    y: o[1],
                    r: l,
                    innerR: h,
                    start: i,
                    end: s
                };
            }
            toXY(t) {
                let e = this.series, i = e.chart, s = e.xAxis, a = e.yAxis, o = t.plotX, r = i.inverted, n = t.y, l = t.plotY, h = r ? o : a.len - l, p;
                if (r && e && !e.isRadialBar && (t.plotY = l = sE(n) ? a.translate(n) : 0), t.rectPlotX = o, t.rectPlotY = l, a.center && (h += a.center[3] / 2), sE(l)) {
                    let e = r ? a.postTranslate(l, h) : s.postTranslate(o, h);
                    t.plotX = t.polarPlotX = e.x - i.plotLeft, t.plotY = t.polarPlotY = e.y - i.plotTop;
                }
                e.kdByAngle ? ((p = (o / Math.PI * 180 + s.pane.options.startAngle) % 360) < 0 && (p += 360), t.clientX = p) : t.clientX = t.plotX;
            }
        }
        var at = f(184), ae = f.n(at);
        let { composed: ai } = y(), { addEvent: as, objectEach: aa, pushUnique: ao } = y();
        !function(t) {
            function e() {
                let t = this.waterfall?.stacks;
                t && (t.changed = !1, delete t.alreadyChanged);
            }
            function i() {
                let t = this.options.stackLabels;
                t?.enabled && this.waterfall?.stacks && this.waterfall.renderStackTotals();
            }
            function s() {
                this.waterfall || (this.waterfall = new o(this));
            }
            function a() {
                let t = this.axes;
                for (let e of this.series)if (e.options.stacking) {
                    for (let e of t)!e.isXAxis && e.waterfall && (e.waterfall.stacks.changed = !0);
                    break;
                }
            }
            t.compose = function(t, o) {
                ao(ai, "Axis.Waterfall") && (as(t, "init", s), as(t, "afterBuildStacks", e), as(t, "afterRender", i), as(o, "beforeRedraw", a));
            };
            class o {
                constructor(t){
                    this.axis = t, this.stacks = {
                        changed: !1
                    };
                }
                renderStackTotals() {
                    let t = this.axis, e = t.waterfall?.stacks, i = t.stacking?.stackTotalGroup, s = new (ae())(t, t.options.stackLabels || {}, !1, 0, void 0);
                    this.dummyStackItem = s, i && aa(e, (t)=>{
                        aa(t, (t, e)=>{
                            s.total = t.stackTotal, s.x = +e, t.label && (s.label = t.label), ae().prototype.render.call(s, i), t.label = s.label, delete s.label;
                        });
                    }), s.total = null;
                }
            }
            t.Composition = o;
        }(c || (c = {}));
        let ar = c, { isNumber: an } = y();
        class al extends tf().prototype.pointClass {
            getClassName() {
                let t = tj().prototype.getClassName.call(this);
                return this.isSum ? t += " highcharts-sum" : this.isIntermediateSum && (t += " highcharts-intermediate-sum"), t;
            }
            isValid() {
                return an(this.y) || this.isSum || !!this.isIntermediateSum;
            }
        }
        let { column: ah, line: ap } = P().seriesTypes, { addEvent: ad, arrayMax: ac, arrayMin: au, correctFloat: ag, crisp: af, extend: am, isNumber: ab, merge: ay, objectEach: ax, pick: aP } = y();
        function aM(t, e) {
            return Object.hasOwnProperty.call(t, e);
        }
        class av extends ah {
            generatePoints() {
                ah.prototype.generatePoints.apply(this);
                let t = this.getColumn("y", !0);
                for(let e = 0, i = this.points.length; e < i; e++){
                    let i = this.points[e], s = t[e];
                    ab(s) && (i.isIntermediateSum || i.isSum) && (i.y = ag(s));
                }
            }
            processData(t) {
                let e, i, s, a, o, r, n = this.options, l = this.getColumn("y"), h = n.data, p = l.length, d = n.threshold || 0;
                s = i = a = o = 0;
                for(let t = 0; t < p; t++)r = l[t], e = h?.[t] || {}, "sum" === r || e.isSum ? l[t] = ag(s) : "intermediateSum" === r || e.isIntermediateSum ? (l[t] = ag(i), i = 0) : (s += r, i += r), a = Math.min(s, a), o = Math.max(s, o);
                super.processData.call(this, t), n.stacking || (this.dataMin = a + d, this.dataMax = o);
            }
            toYData(t) {
                return t.isSum ? "sum" : t.isIntermediateSum ? "intermediateSum" : t.y;
            }
            pointAttribs(t, e) {
                let i = this.options.upColor;
                i && !t.options.color && ab(t.y) && (t.color = t.y > 0 ? i : void 0);
                let s = ah.prototype.pointAttribs.call(this, t, e);
                return delete s.dashstyle, s;
            }
            getGraphPath() {
                return this.graph?.pathArray || [
                    [
                        "M",
                        0,
                        0
                    ]
                ];
            }
            getCrispPath() {
                let t = this.points.filter((t)=>ab(t.y)), e = this.yAxis, i = t.length, s = this.graph?.strokeWidth() || 0, a = this.xAxis.reversed, o = this.yAxis.reversed, r = this.options.stacking, n = [];
                for(let l = 1; l < i; l++){
                    if (!(this.options.connectNulls || ab(this.data[t[l].index - 1].y))) continue;
                    let i = t[l].box, h = t[l - 1], p = h.y || 0, d = t[l - 1].box;
                    if (!i || !d) continue;
                    let c = e.waterfall?.stacks[this.stackKey], u = p > 0 ? -d.height : 0;
                    if (c && d && i) {
                        let t, p = c[l - 1];
                        t = r ? af(e.translate(p.connectorThreshold || 0, !1, !0, !1, !0) + (o ? u : 0), s) : af(d.y + (h.minPointLengthOffset || 0), s), n.push([
                            "M",
                            (d.x || 0) + (a ? 0 : d.width || 0),
                            t
                        ], [
                            "L",
                            (i.x || 0) + (a && i.width || 0),
                            t
                        ]);
                    }
                    if (d && n.length && (!r && p < 0 && !o || p > 0 && o)) {
                        let t = n[n.length - 2];
                        t && "number" == typeof t[2] && (t[2] += d.height || 0);
                        let e = n[n.length - 1];
                        e && "number" == typeof e[2] && (e[2] += d.height || 0);
                    }
                }
                return n;
            }
            drawGraph() {
                ap.prototype.drawGraph.call(this), this.graph?.animate({
                    d: this.getCrispPath()
                });
            }
            setStackedPoints(t) {
                let e = this.options, i = t.waterfall?.stacks, s = e.threshold || 0, a = this.stackKey, o = this.getColumn("x"), r = this.getColumn("y"), n = o.length, l = s, h = l, p, d = 0, c = 0, u = 0, g, f, m, b, y, x, P, M, v = (t, e, i, s)=>{
                    if (p) {
                        if (g) for(; i < g; i++)p.stackState[i] += s;
                        else p.stackState[0] = t, g = p.stackState.length;
                        p.stackState.push(p.stackState[g - 1] + e);
                    }
                };
                if (t.stacking && i && this.reserveSpace()) {
                    M = i.changed, (P = i.alreadyChanged) && 0 > P.indexOf(a) && (M = !0), i[a] || (i[a] = {});
                    let t = i[a];
                    if (t) for(let i = 0; i < n; i++)(!t[x = o[i]] || M) && (t[x] = {
                        negTotal: 0,
                        posTotal: 0,
                        stackTotal: 0,
                        threshold: 0,
                        stateIndex: 0,
                        stackState: [],
                        label: M && t[x] ? t[x].label : void 0
                    }), p = t[x], (y = r[i]) >= 0 ? p.posTotal += y : p.negTotal += y, b = e.data[i], f = p.absolutePos = p.posTotal, m = p.absoluteNeg = p.negTotal, p.stackTotal = f + m, g = p.stackState.length, b?.isIntermediateSum ? (v(u, c, 0, u), u = c, c = s, l ^= h, h ^= l, l ^= h) : b?.isSum ? (v(s, d, g, 0), l = s) : (v(l, y, 0, d), b && (d += y, c += y)), p.stateIndex++, p.threshold = l, l += p.stackTotal;
                    i.changed = !1, i.alreadyChanged || (i.alreadyChanged = []), i.alreadyChanged.push(a);
                }
            }
            getExtremes() {
                let t, e, i = this.options.stacking, s = this.yAxis, a = s.waterfall?.stacks;
                return i && a ? (t = this.stackedYNeg = [], e = this.stackedYPos = [], "overlap" === i ? ax(a[this.stackKey], function(i) {
                    t.push(au(i.stackState)), e.push(ac(i.stackState));
                }) : ax(a[this.stackKey], function(i) {
                    t.push(i.negTotal + i.threshold), e.push(i.posTotal + i.threshold);
                }), {
                    dataMin: au(t),
                    dataMax: ac(e)
                }) : {
                    dataMin: this.dataMin,
                    dataMax: this.dataMax
                };
            }
        }
        av.defaultOptions = ay(ah.defaultOptions, {
            dataLabels: {
                inside: !0
            },
            lineWidth: 1,
            lineColor: "#333333",
            dashStyle: "Dot",
            borderColor: "#333333",
            states: {
                hover: {
                    lineWidthPlus: 0
                }
            }
        }), av.compose = ar.compose, am(av.prototype, {
            pointValKey: "y",
            showLine: !0,
            pointClass: al
        }), ad(av, "afterColumnTranslate", function() {
            let { options: t, points: e, yAxis: i } = this, s = aP(t.minPointLength, 5), a = s / 2, o = t.threshold || 0, r = t.stacking, n = i.waterfall?.stacks[this.stackKey], l = this.getColumn("y", !0), h = o, p = o, d, c, u, g;
            for(let t = 0; t < e.length; t++){
                let f = e[t], m = l[t], b = am({
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0
                }, f.shapeArgs || {});
                f.box = b;
                let y = [
                    0,
                    m
                ], x = f.y || 0;
                if (r) {
                    if (n) {
                        let e = n[t];
                        "overlap" === r ? (c = e.stackState[e.stateIndex--], d = x >= 0 ? c : c - x, aM(e, "absolutePos") && delete e.absolutePos, aM(e, "absoluteNeg") && delete e.absoluteNeg) : (x >= 0 ? (c = e.threshold + e.posTotal, e.posTotal -= x, d = c) : (c = e.threshold + e.negTotal, e.negTotal -= x, d = c - x), !e.posTotal && ab(e.absolutePos) && aM(e, "absolutePos") && (e.posTotal = e.absolutePos, delete e.absolutePos), !e.negTotal && ab(e.absoluteNeg) && aM(e, "absoluteNeg") && (e.negTotal = e.absoluteNeg, delete e.absoluteNeg)), f.isSum || (e.connectorThreshold = e.threshold + e.stackTotal), i.reversed ? (u = x >= 0 ? d - x : d + x, g = d) : (u = d, g = d - x), f.below = u <= o, b.y = i.translate(u, !1, !0, !1, !0), b.height = Math.abs(b.y - i.translate(g, !1, !0, !1, !0));
                        let s = i.waterfall?.dummyStackItem;
                        s && (s.x = t, s.label = n[t].label, s.setOffset(this.pointXOffset || 0, this.barW || 0, this.stackedYNeg[t], this.stackedYPos[t], void 0, this.xAxis));
                    }
                } else d = Math.max(p, p + x) + y[0], b.y = i.translate(d, !1, !0, !1, !0), f.isSum ? (b.y = i.translate(y[1], !1, !0, !1, !0), b.height = Math.min(i.translate(y[0], !1, !0, !1, !0), i.len) - b.y, f.below = y[1] <= o) : f.isIntermediateSum ? (x >= 0 ? (u = y[1] + h, g = h) : (u = h, g = y[1] + h), i.reversed && (u ^= g, g ^= u, u ^= g), b.y = i.translate(u, !1, !0, !1, !0), b.height = Math.abs(b.y - Math.min(i.translate(g, !1, !0, !1, !0), i.len)), h += y[1], f.below = u <= o) : (b.height = m > 0 ? i.translate(p, !1, !0, !1, !0) - b.y : i.translate(p, !1, !0, !1, !0) - i.translate(p - m, !1, !0, !1, !0), f.below = (p += m) < o), b.height < 0 && (b.y += b.height, b.height *= -1);
                f.plotY = b.y, f.yBottom = b.y + b.height, b.height <= s && !f.isNull ? (b.height = s, b.y -= a, f.yBottom = b.y + b.height, f.plotY = b.y, x < 0 ? f.minPointLengthOffset = -a : f.minPointLengthOffset = a) : (f.isNull && (b.width = 0), f.minPointLengthOffset = 0);
                let P = f.plotY + (f.negative ? b.height : 0);
                f.below && (f.plotY += b.height), f.tooltipPos && (this.chart.inverted ? f.tooltipPos[0] = i.len - P : f.tooltipPos[1] = P), f.isInside = this.isPointInside(f);
                let M = af(f.yBottom, this.borderWidth);
                b.y = af(b.y, this.borderWidth), b.height = M - b.y, ay(!0, f.shapeArgs, b);
            }
        }, {
            order: 2
        }), P().registerSeriesType("waterfall", av);
        let aL = y();
        aL.RadialAxis = sS, eo.compose(aL.Axis, aL.Chart, aL.Legend), iQ.compose(aL.Axis, aL.Chart, aL.Legend), V.compose(aL.Chart, aL.Pointer), s7.compose(aL.Axis, aL.Chart, aL.Pointer, aL.Series, aL.Tick, aL.Point, P().seriesTypes.areasplinerange, P().seriesTypes.column, P().seriesTypes.line, P().seriesTypes.spline), av.compose(aL.Axis, aL.Chart);
        let ak = aL;
        return m.default;
    })());

});

parcelRegister("fsPq0", function(module, exports) {
!/**
 * Highcharts JS v12.4.0 (2025-09-04)
 * @module highcharts/modules/solid-gauge
 * @requires highcharts
 * @requires highcharts/highcharts-more
 *
 * Solid angular gauge module
 *
 * (c) 2010-2025 Torstein Honsi
 *
 * License: www.highcharts.com/license
 */ function(t, e) {
    module.exports = e(t._Highcharts, t._Highcharts.SeriesRegistry, t._Highcharts.Color);
}("undefined" == typeof window ? module.exports : window, (t, e, o)=>(()=>{
        "use strict";
        var s, r = {
            512: (t)=>{
                t.exports = e;
            },
            620: (t)=>{
                t.exports = o;
            },
            944: (e)=>{
                e.exports = t;
            }
        }, i = {};
        function a(t) {
            var e = i[t];
            if (void 0 !== e) return e.exports;
            var o = i[t] = {
                exports: {}
            };
            return r[t](o, o.exports, a), o.exports;
        }
        a.n = (t)=>{
            var e = t && t.__esModule ? ()=>t.default : ()=>t;
            return a.d(e, {
                a: e
            }), e;
        }, a.d = (t, e)=>{
            for(var o in e)a.o(e, o) && !a.o(t, o) && Object.defineProperty(t, o, {
                enumerable: !0,
                get: e[o]
            });
        }, a.o = (t, e)=>Object.prototype.hasOwnProperty.call(t, e);
        var n = {};
        a.d(n, {
            default: ()=>N
        });
        var l = a(944), d = a.n(l);
        let { defaultOptions: h } = d(), { noop: c } = d(), { addEvent: g, extend: p, isObject: u, merge: f, relativeLength: m } = d(), y = {
            radius: 0,
            scope: "stack",
            where: void 0
        };
        function x(t, e) {
            return u(t) || (t = {
                radius: t || 0
            }), f(y, e, t);
        }
        let C = {
            optionsToObject: x
        };
        var R = a(512), v = a.n(R), A = a(620);
        let { parse: b } = a.n(A)(), { merge: w } = d();
        !function(t) {
            t.initDataClasses = function(t) {
                let e = this.chart, o = this.legendItem = this.legendItem || {}, s = this.options, r = t.dataClasses || [], i, a, n = e.options.chart.colorCount, l = 0, d;
                this.dataClasses = a = [], o.labels = [];
                for(let t = 0, o = r.length; t < o; ++t)i = w(i = r[t]), a.push(i), (e.styledMode || !i.color) && ("category" === s.dataClassColor ? (e.styledMode || (n = (d = e.options.colors || []).length, i.color = d[l]), i.colorIndex = l, ++l === n && (l = 0)) : i.color = b(s.minColor).tweenTo(b(s.maxColor), o < 2 ? .5 : t / (o - 1)));
            }, t.initStops = function() {
                let t = this.options, e = this.stops = t.stops || [
                    [
                        0,
                        t.minColor || ""
                    ],
                    [
                        1,
                        t.maxColor || ""
                    ]
                ];
                for(let t = 0, o = e.length; t < o; ++t)e[t].color = b(e[t][1]);
            }, t.normalizedValue = function(t) {
                let e = this.max || 0, o = this.min || 0;
                return this.logarithmic && (t = this.logarithmic.log2lin(t)), 1 - (e - t) / (e - o || 1);
            }, t.toColor = function(t, e) {
                let o, s, r, i, a, n, l = this.dataClasses, d = this.stops;
                if (l) {
                    for(n = l.length; n--;)if (s = (a = l[n]).from, r = a.to, (void 0 === s || t >= s) && (void 0 === r || t <= r)) {
                        i = a.color, e && (e.dataClass = n, e.colorIndex = a.colorIndex);
                        break;
                    }
                } else {
                    for(o = this.normalizedValue(t), n = d.length; n-- && !(o > d[n][0]););
                    s = d[n] || d[n + 1], o = 1 - ((r = d[n + 1] || s)[0] - o) / (r[0] - s[0] || 1), i = s.color.tweenTo(r.color, o);
                }
                return i;
            };
        }(s || (s = {}));
        let M = s, { extend: H } = d(), I = {
            init: function(t) {
                H(t, M);
            }
        }, { gauge: _, pie: j } = v().seriesTypes, { clamp: P, extend: S, isNumber: k, merge: O, pick: T, pInt: z } = d();
        class D extends _ {
            translate() {
                let t = this.yAxis;
                I.init(t), !t.dataClasses && t.options.dataClasses && t.initDataClasses(t.options), t.initStops(), _.prototype.translate.call(this);
            }
            drawPoints() {
                let t, e = this.yAxis, o = e.center, s = this.options, r = this.chart.renderer, i = s.overshoot, a = s.rounded && void 0 === s.borderRadius, n = k(i) ? i / 180 * Math.PI : 0;
                for (let i of (k(s.threshold) && (t = e.startAngleRad + e.translate(s.threshold, void 0, void 0, void 0, !0)), this.thresholdAngleRad = T(t, e.startAngleRad), this.points))if (!i.isNull) {
                    let t = z(T(i.options.radius, s.radius, 100)) * o[2] / 200, l = z(T(i.options.innerRadius, s.innerRadius, 60)) * o[2] / 200, d = Math.min(e.startAngleRad, e.endAngleRad), h = Math.max(e.startAngleRad, e.endAngleRad), c = i.graphic, g = e.startAngleRad + e.translate(i.y, void 0, void 0, void 0, !0), p, u, f = e.toColor(i.y, i), m = i.getClassName();
                    "none" === f && (f = i.color || this.color || "none"), "none" !== f && (i.color = f), g = P(g, d - n, h + n), !1 === s.wrap && (g = P(g, d, h));
                    let y = a ? (t - l) / 2 / t : 0, x = Math.min(g, this.thresholdAngleRad) - y, R = Math.max(g, this.thresholdAngleRad) + y;
                    R - x > 2 * Math.PI && (R = x + 2 * Math.PI);
                    let v = a ? "50%" : 0;
                    s.borderRadius && (v = C.optionsToObject(s.borderRadius).radius), i.shapeArgs = p = {
                        x: o[0],
                        y: o[1],
                        r: t,
                        innerR: l,
                        start: x,
                        end: R,
                        borderRadius: v
                    }, i.startR = t, c ? (u = p.d, c.animate(S({
                        fill: f
                    }, p)), u && (p.d = u)) : i.graphic = c = r.arc(p).attr({
                        fill: f,
                        "sweep-flag": 0
                    }).add(this.group), this.chart.styledMode ? this.yAxis?.stops && (m = m.replace(/highcharts-color-\d/gm, "").trim()) : ("square" !== s.linecap && c.attr({
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                    }), c.attr({
                        stroke: s.borderColor || "none",
                        "stroke-width": s.borderWidth || 0
                    })), c && c.addClass(m);
                }
            }
            animate(t) {
                t || (this.startAngleRad = this.thresholdAngleRad, j.prototype.animate.call(this, t));
            }
        }
        D.defaultOptions = O(_.defaultOptions, {
            colorByPoint: !0,
            dataLabels: {
                y: 0
            }
        }), v().registerSeriesType("solidgauge", D);
        let N = d();
        return n.default;
    })());

});

parcelRegister("1gFhB", function(module, exports) {
!/**
 * Highmaps JS v12.4.0 (2025-09-04)
 * @module highcharts/modules/map
 * @requires highcharts
 *
 * Highmaps as a plugin for Highcharts or Highcharts Stock.
 *
 * (c) 2011-2025 Torstein Honsi
 *
 * License: www.highcharts.com/license
 */ function(t, e) {
    module.exports = e(t._Highcharts, t._Highcharts.Axis, t._Highcharts.Color, t._Highcharts.LegendSymbol, t._Highcharts.SeriesRegistry, t._Highcharts.SVGElement, t._Highcharts.Series, t._Highcharts.Chart, t._Highcharts.SVGRenderer, t._Highcharts.Templating, t._Highcharts.Series.types.scatter, t._Highcharts.Point);
}("undefined" == typeof window ? module.exports : window, (t, e, i, s, o, r, a, n, l, h, p, d)=>(()=>{
        "use strict";
        let c;
        var u, m, g, f, b, y, x, M = {
            28: (t)=>{
                t.exports = r;
            },
            260: (t)=>{
                t.exports = d;
            },
            500: (t)=>{
                t.exports = s;
            },
            512: (t)=>{
                t.exports = o;
            },
            532: (t)=>{
                t.exports = e;
            },
            540: (t)=>{
                t.exports = l;
            },
            620: (t)=>{
                t.exports = i;
            },
            632: (t)=>{
                t.exports = p;
            },
            820: (t)=>{
                t.exports = a;
            },
            944: (e)=>{
                e.exports = t;
            },
            960: (t)=>{
                t.exports = n;
            },
            984: (t)=>{
                t.exports = h;
            }
        }, v = {};
        function w(t) {
            var e = v[t];
            if (void 0 !== e) return e.exports;
            var i = v[t] = {
                exports: {}
            };
            return M[t](i, i.exports, w), i.exports;
        }
        w.n = (t)=>{
            var e = t && t.__esModule ? ()=>t.default : ()=>t;
            return w.d(e, {
                a: e
            }), e;
        }, w.d = (t, e)=>{
            for(var i in e)w.o(e, i) && !w.o(t, i) && Object.defineProperty(t, i, {
                enumerable: !0,
                get: e[i]
            });
        }, w.o = (t, e)=>Object.prototype.hasOwnProperty.call(t, e);
        var C = {};
        w.d(C, {
            default: ()=>sB
        });
        var T = w(944), L = w.n(T), P = w(532), A = w.n(P), k = w(620), j = w.n(k);
        let { parse: z } = j(), { addEvent: S, extend: I, merge: B, pick: E, splat: D } = L();
        !function(t) {
            let e;
            function i() {
                let { userOptions: t } = this;
                this.colorAxis = [], t.colorAxis && (t.colorAxis = D(t.colorAxis), t.colorAxis.map((t)=>new e(this, t)));
            }
            function s(t) {
                let e = this.chart.colorAxis || [], i = (e)=>{
                    let i = t.allItems.indexOf(e);
                    -1 !== i && (this.destroyItem(t.allItems[i]), t.allItems.splice(i, 1));
                }, s = [], o, r;
                for(e.forEach(function(t) {
                    o = t.options, o?.showInLegend && (o.dataClasses && o.visible ? s = s.concat(t.getDataClassLegendSymbols()) : o.visible && s.push(t), t.series.forEach(function(t) {
                        (!t.options.showInLegend || o.dataClasses) && ("point" === t.options.legendType ? t.points.forEach(function(t) {
                            i(t);
                        }) : i(t));
                    }));
                }), r = s.length; r--;)t.allItems.unshift(s[r]);
            }
            function o(t) {
                t.visible && t.item.legendColor && t.item.legendItem.symbol.attr({
                    fill: t.item.legendColor
                });
            }
            function r(t) {
                this.chart.colorAxis?.forEach((e)=>{
                    e.update({}, t.redraw);
                });
            }
            function a() {
                (this.chart.colorAxis?.length || this.colorAttribs) && this.translateColors();
            }
            function n() {
                let t = this.axisTypes;
                t ? -1 === t.indexOf("colorAxis") && t.push("colorAxis") : this.axisTypes = [
                    "colorAxis"
                ];
            }
            function l(t) {
                let e = this, i = t ? "show" : "hide";
                e.visible = e.options.visible = !!t, [
                    "graphic",
                    "dataLabel"
                ].forEach(function(t) {
                    e[t] && e[t][i]();
                }), this.series.buildKDTree();
            }
            function h() {
                let t = this, e = this.getPointsCollection(), i = this.options.nullColor, s = this.colorAxis, o = this.colorKey;
                e.forEach((e)=>{
                    let r = e.getNestedProperty(o), a = e.options.color || (e.isNull || null === e.value ? i : s && void 0 !== r ? s.toColor(r, e) : e.color || t.color);
                    a && e.color !== a && (e.color = a, "point" === t.options.legendType && e.legendItem && e.legendItem.label && t.chart.legend.colorizeItem(e, e.visible));
                });
            }
            function p() {
                this.elem.attr("fill", z(this.start).tweenTo(z(this.end), this.pos), void 0, !0);
            }
            function d() {
                this.elem.attr("stroke", z(this.start).tweenTo(z(this.end), this.pos), void 0, !0);
            }
            t.compose = function(t, c, u, m, g) {
                let f = c.prototype, b = u.prototype, y = g.prototype;
                f.collectionsWithUpdate.includes("colorAxis") || (e = t, f.collectionsWithUpdate.push("colorAxis"), f.collectionsWithInit.colorAxis = [
                    f.addColorAxis
                ], S(c, "afterCreateAxes", i), function(t) {
                    let i = t.prototype.createAxis;
                    t.prototype.createAxis = function(t, s) {
                        if ("colorAxis" !== t) return i.apply(this, arguments);
                        let o = new e(this, B(s.axis, {
                            index: this[t].length,
                            isX: !1
                        }));
                        return this.isDirtyLegend = !0, this.axes.forEach((t)=>{
                            t.series = [];
                        }), this.series.forEach((t)=>{
                            t.bindAxes(), t.isDirtyData = !0;
                        }), E(s.redraw, !0) && this.redraw(s.animation), o;
                    };
                }(c), b.fillSetter = p, b.strokeSetter = d, S(m, "afterGetAllItems", s), S(m, "afterColorizeItem", o), S(m, "afterUpdate", r), I(y, {
                    optionalAxis: "colorAxis",
                    translateColors: h
                }), I(y.pointClass.prototype, {
                    setVisible: l
                }), S(g, "afterTranslate", a, {
                    order: 1
                }), S(g, "bindAxes", n));
            }, t.pointSetVisible = l;
        }(u || (u = {}));
        let V = u, { parse: O } = j(), { merge: N } = L();
        !function(t) {
            t.initDataClasses = function(t) {
                let e = this.chart, i = this.legendItem = this.legendItem || {}, s = this.options, o = t.dataClasses || [], r, a, n = e.options.chart.colorCount, l = 0, h;
                this.dataClasses = a = [], i.labels = [];
                for(let t = 0, i = o.length; t < i; ++t)r = N(r = o[t]), a.push(r), (e.styledMode || !r.color) && ("category" === s.dataClassColor ? (e.styledMode || (n = (h = e.options.colors || []).length, r.color = h[l]), r.colorIndex = l, ++l === n && (l = 0)) : r.color = O(s.minColor).tweenTo(O(s.maxColor), i < 2 ? .5 : t / (i - 1)));
            }, t.initStops = function() {
                let t = this.options, e = this.stops = t.stops || [
                    [
                        0,
                        t.minColor || ""
                    ],
                    [
                        1,
                        t.maxColor || ""
                    ]
                ];
                for(let t = 0, i = e.length; t < i; ++t)e[t].color = O(e[t][1]);
            }, t.normalizedValue = function(t) {
                let e = this.max || 0, i = this.min || 0;
                return this.logarithmic && (t = this.logarithmic.log2lin(t)), 1 - (e - t) / (e - i || 1);
            }, t.toColor = function(t, e) {
                let i, s, o, r, a, n, l = this.dataClasses, h = this.stops;
                if (l) {
                    for(n = l.length; n--;)if (s = (a = l[n]).from, o = a.to, (void 0 === s || t >= s) && (void 0 === o || t <= o)) {
                        r = a.color, e && (e.dataClass = n, e.colorIndex = a.colorIndex);
                        break;
                    }
                } else {
                    for(i = this.normalizedValue(t), n = h.length; n-- && !(i > h[n][0]););
                    s = h[n] || h[n + 1], i = 1 - ((o = h[n + 1] || s)[0] - i) / (o[0] - s[0] || 1), r = s.color.tweenTo(o.color, i);
                }
                return r;
            };
        }(m || (m = {}));
        let G = m;
        var X = w(500), R = w.n(X), H = w(512), W = w.n(H);
        let { defaultOptions: Y } = L(), { series: U } = W(), { defined: F, extend: Z, fireEvent: _, isArray: K, isNumber: q, merge: $, pick: J, relativeLength: Q } = L();
        Y.colorAxis = $(Y.xAxis, {
            lineWidth: 0,
            minPadding: 0,
            maxPadding: 0,
            gridLineColor: "#ffffff",
            gridLineWidth: 1,
            tickPixelInterval: 72,
            startOnTick: !0,
            endOnTick: !0,
            offset: 0,
            marker: {
                animation: {
                    duration: 50
                },
                width: .01,
                color: "#999999"
            },
            labels: {
                distance: 8,
                overflow: "justify",
                rotation: 0
            },
            minColor: "#e6e9ff",
            maxColor: "#0022ff",
            tickLength: 5,
            showInLegend: !0
        });
        class tt extends A() {
            static compose(t, e, i, s) {
                V.compose(tt, t, e, i, s);
            }
            constructor(t, e){
                super(t, e), this.coll = "colorAxis", this.visible = !0, this.init(t, e);
            }
            init(t, e) {
                let i = t.options.legend || {}, s = e.layout ? "vertical" !== e.layout : "vertical" !== i.layout;
                this.side = e.side || s ? 2 : 1, this.reversed = e.reversed, this.opposite = !s, super.init(t, e, "colorAxis"), this.userOptions = e, K(t.userOptions.colorAxis) && (t.userOptions.colorAxis[this.index] = e), e.dataClasses && this.initDataClasses(e), this.initStops(), this.horiz = s, this.zoomEnabled = !1;
            }
            hasData() {
                return !!(this.tickPositions || []).length;
            }
            setTickPositions() {
                if (!this.dataClasses) return super.setTickPositions();
            }
            setOptions(t) {
                let e = $(Y.colorAxis, t, {
                    showEmpty: !1,
                    title: null,
                    visible: this.chart.options.legend.enabled && !1 !== t.visible
                });
                super.setOptions(e), this.options.crosshair = this.options.marker;
            }
            setAxisSize() {
                let t = this.chart, e = this.legendItem?.symbol, { width: i, height: s } = this.getSize();
                e && (this.left = +e.attr("x"), this.top = +e.attr("y"), this.width = i = +e.attr("width"), this.height = s = +e.attr("height"), this.right = t.chartWidth - this.left - i, this.bottom = t.chartHeight - this.top - s, this.pos = this.horiz ? this.left : this.top), this.len = (this.horiz ? i : s) || tt.defaultLegendLength;
            }
            getOffset() {
                let t = this.legendItem?.group, e = this.chart.axisOffset[this.side];
                if (t) {
                    this.axisParent = t, super.getOffset();
                    let i = this.chart.legend;
                    i.allItems.forEach(function(t) {
                        t instanceof tt && t.drawLegendSymbol(i, t);
                    }), i.render(), this.chart.getMargins(!0), this.chart.series.some((t)=>t.isDrilling) || (this.isDirty = !0), this.added || (this.added = !0), this.labelLeft = 0, this.labelRight = this.width, this.chart.axisOffset[this.side] = e;
                }
            }
            setLegendColor() {
                let t = this.horiz, e = this.reversed, i = +!!e, s = +!e, o = t ? [
                    i,
                    0,
                    s,
                    0
                ] : [
                    0,
                    s,
                    0,
                    i
                ];
                this.legendColor = {
                    linearGradient: {
                        x1: o[0],
                        y1: o[1],
                        x2: o[2],
                        y2: o[3]
                    },
                    stops: this.stops
                };
            }
            drawLegendSymbol(t, e) {
                let i = e.legendItem || {}, s = t.padding, o = t.options, r = this.options.labels, a = J(o.itemDistance, 10), n = this.horiz, { width: l, height: h } = this.getSize(), p = J(o.labelPadding, n ? 16 : 30);
                this.setLegendColor(), i.symbol || (i.symbol = this.chart.renderer.symbol("roundedRect").attr({
                    r: o.symbolRadius ?? 3,
                    zIndex: 1
                }).add(i.group)), i.symbol.attr({
                    x: 0,
                    y: (t.baseline || 0) - 11,
                    width: l,
                    height: h
                }), i.labelWidth = l + s + (n ? a : J(r.x, r.distance) + (this.maxLabelLength || 0)), i.labelHeight = h + s + (n ? p : 0);
            }
            setState(t) {
                this.series.forEach(function(e) {
                    e.setState(t);
                });
            }
            setVisible() {}
            getSeriesExtremes() {
                let t = this.series, e, i, s, o, r = t.length;
                for(this.dataMin = 1 / 0, this.dataMax = -1 / 0; r--;){
                    for (let a of (i = (o = t[r]).colorKey = J(o.options.colorKey, o.colorKey, o.pointValKey, o.zoneAxis, "y"), s = o[i + "Min"] && o[i + "Max"], [
                        i,
                        "value",
                        "y"
                    ]))if ((e = o.getColumn(a)).length) break;
                    if (s) o.minColorValue = o[i + "Min"], o.maxColorValue = o[i + "Max"];
                    else {
                        let t = U.prototype.getExtremes.call(o, e);
                        o.minColorValue = t.dataMin, o.maxColorValue = t.dataMax;
                    }
                    F(o.minColorValue) && F(o.maxColorValue) && (this.dataMin = Math.min(this.dataMin, o.minColorValue), this.dataMax = Math.max(this.dataMax, o.maxColorValue)), s || U.prototype.applyExtremes.call(o);
                }
            }
            drawCrosshair(t, e) {
                let i, s = this.legendItem || {}, o = e?.plotX, r = e?.plotY, a = this.pos, n = this.len;
                e && ((i = this.toPixels(e.getNestedProperty(e.series.colorKey))) < a ? i = a - 2 : i > a + n && (i = a + n + 2), e.plotX = i, e.plotY = this.len - i, super.drawCrosshair(t, e), e.plotX = o, e.plotY = r, this.cross && !this.cross.addedToColorAxis && s.group && (this.cross.addClass("highcharts-coloraxis-marker").add(s.group), this.cross.addedToColorAxis = !0, this.chart.styledMode || "object" != typeof this.crosshair || this.cross.attr({
                    fill: this.crosshair.color
                })));
            }
            getPlotLinePath(t) {
                let e = this.left, i = t.translatedValue, s = this.top;
                return q(i) ? this.horiz ? [
                    [
                        "M",
                        i - 4,
                        s - 6
                    ],
                    [
                        "L",
                        i + 4,
                        s - 6
                    ],
                    [
                        "L",
                        i,
                        s
                    ],
                    [
                        "Z"
                    ]
                ] : [
                    [
                        "M",
                        e,
                        i
                    ],
                    [
                        "L",
                        e - 6,
                        i + 6
                    ],
                    [
                        "L",
                        e - 6,
                        i - 6
                    ],
                    [
                        "Z"
                    ]
                ] : super.getPlotLinePath(t);
            }
            update(t, e) {
                let i = this.chart.legend;
                this.series.forEach((t)=>{
                    t.isDirtyData = !0;
                }), (t.dataClasses && i.allItems || this.dataClasses) && this.destroyItems(), super.update(t, e), this.legendItem?.label && (this.setLegendColor(), i.colorizeItem(this, !0));
            }
            destroyItems() {
                let t = this.chart, e = this.legendItem || {};
                if (e.label) t.legend.destroyItem(this);
                else if (e.labels) for (let i of e.labels)t.legend.destroyItem(i);
                t.isDirtyLegend = !0;
            }
            destroy() {
                this.chart.isDirtyLegend = !0, this.destroyItems(), super.destroy(...[].slice.call(arguments));
            }
            remove(t) {
                this.destroyItems(), super.remove(t);
            }
            getDataClassLegendSymbols() {
                let t, e = this, i = e.chart, s = e.legendItem && e.legendItem.labels || [], o = i.options.legend, r = J(o.valueDecimals, -1), a = J(o.valueSuffix, ""), n = (t)=>e.series.reduce((e, i)=>(e.push(...i.points.filter((e)=>e.dataClass === t)), e), []);
                return s.length || e.dataClasses.forEach((o, l)=>{
                    let h = o.from, p = o.to, { numberFormatter: d } = i, c = !0;
                    t = "", void 0 === h ? t = "< " : void 0 === p && (t = "> "), void 0 !== h && (t += d(h, r) + a), void 0 !== h && void 0 !== p && (t += " - "), void 0 !== p && (t += d(p, r) + a), s.push(Z({
                        chart: i,
                        name: t,
                        options: {},
                        drawLegendSymbol: R().rectangle,
                        visible: !0,
                        isDataClass: !0,
                        setState: (t)=>{
                            for (let e of n(l))e.setState(t);
                        },
                        setVisible: function() {
                            this.visible = c = e.visible = !c;
                            let t = [];
                            for (let e of n(l))e.setVisible(c), e.hiddenInDataClass = !c, -1 === t.indexOf(e.series) && t.push(e.series);
                            i.legend.colorizeItem(this, c), t.forEach((t)=>{
                                _(t, "afterDataClassLegendClick");
                            });
                        }
                    }, o));
                }), s;
            }
            getSize() {
                let { chart: t, horiz: e } = this, { height: i, width: s } = this.options, { legend: o } = t.options;
                return {
                    width: J(F(s) ? Q(s, t.chartWidth) : void 0, o?.symbolWidth, e ? tt.defaultLegendLength : 12),
                    height: J(F(i) ? Q(i, t.chartHeight) : void 0, o?.symbolHeight, e ? 12 : tt.defaultLegendLength)
                };
            }
        }
        tt.defaultLegendLength = 200, tt.keepProps = [
            "legendItem"
        ], Z(tt.prototype, G), Array.prototype.push.apply(A().keepProps, tt.keepProps); /**
 * @license Highcharts JS v12.4.0 (2025-09-04)
 * @module highcharts/modules/color-axis
 * @requires highcharts
 *
 * ColorAxis module
 *
 * (c) 2012-2025 Pawel Potaczek
 *
 * License: www.highcharts.com/license
 */ 
        let te = L();
        te.ColorAxis = te.ColorAxis || tt, te.ColorAxis.compose(te.Chart, te.Fx, te.Legend, te.Series);
        let ti = {
            lang: {
                zoomIn: "Zoom in",
                zoomOut: "Zoom out"
            },
            mapNavigation: {
                buttonOptions: {
                    alignTo: "plotBox",
                    align: "left",
                    verticalAlign: "top",
                    x: 0,
                    width: 18,
                    height: 18,
                    padding: 5,
                    style: {
                        color: "#666666",
                        fontSize: "1em",
                        fontWeight: "bold"
                    },
                    theme: {
                        fill: "#ffffff",
                        stroke: "#e6e6e6",
                        "stroke-width": 1,
                        "text-align": "center"
                    }
                },
                buttons: {
                    zoomIn: {
                        onclick: function() {
                            this.mapZoom(.5);
                        },
                        text: "+",
                        y: 0
                    },
                    zoomOut: {
                        onclick: function() {
                            this.mapZoom(2);
                        },
                        text: "-",
                        y: 28
                    }
                },
                mouseWheelSensitivity: 1.1
            }
        }, { defined: ts, extend: to, pick: tr, wrap: ta } = L();
        !function(t) {
            let e, i = 0;
            function s(t) {
                let e = this.chart;
                t = this.normalize(t), e.options.mapNavigation.enableDoubleClickZoomTo ? e.pointer.inClass(t.target, "highcharts-tracker") && e.hoverPoint && e.hoverPoint.zoomTo() : e.isInsidePlot(t.chartX - e.plotLeft, t.chartY - e.plotTop) && e.mapZoom(.5, void 0, void 0, t.chartX, t.chartY);
            }
            function o(t) {
                let s = this.chart, o = ts((t = this.normalize(t)).wheelDelta) && -t.wheelDelta / 120 || t.deltaY || t.detail;
                Math.abs(o) >= 1 && (i += Math.abs(o), e && clearTimeout(e), e = setTimeout(()=>{
                    i = 0;
                }, 50)), i < 10 && s.isInsidePlot(t.chartX - s.plotLeft, t.chartY - s.plotTop) && s.mapView && s.mapView.zoomBy(-((s.options.mapNavigation.mouseWheelSensitivity - 1) * o), void 0, [
                    t.chartX,
                    t.chartY
                ], !(1 > Math.abs(o)) && void 0);
            }
            function r(t, e, i) {
                let s = this.chart;
                if (e = t.call(this, e, i), s && s.mapView) {
                    let t = s.mapView.pixelsToLonLat({
                        x: e.chartX - s.plotLeft,
                        y: e.chartY - s.plotTop
                    });
                    t && to(e, t);
                }
                return e;
            }
            function a(t) {
                let e = this.chart.options.mapNavigation;
                e && tr(e.enableTouchZoom, e.enabled) && (this.chart.zooming.pinchType = "xy"), t.apply(this, [].slice.call(arguments, 1));
            }
            t.compose = function(t) {
                let e = t.prototype;
                e.onContainerDblClick || (to(e, {
                    onContainerDblClick: s,
                    onContainerMouseWheel: o
                }), ta(e, "normalize", r), ta(e, "zoomOption", a));
            };
        }(g || (g = {}));
        let tn = g;
        function tl(t, e, i, s, o) {
            if (o) {
                let t = o?.r || 0;
                o.brBoxY = e - t, o.brBoxHeight = s + t;
            }
            return c.roundedRect(t, e, i, s, o);
        }
        function th(t, e, i, s, o) {
            if (o) {
                let t = o?.r || 0;
                o.brBoxHeight = s + t;
            }
            return c.roundedRect(t, e, i, s, o);
        }
        let tp = {
            compose: function(t) {
                (c = t.prototype.symbols).bottombutton = tl, c.topbutton = th;
            }
        }, { setOptions: td } = L(), { composed: tc } = L(), { addEvent: tu, extend: tm, merge: tg, objectEach: tf, pick: tb, pushUnique: ty } = L();
        function tx(t) {
            t && (t.preventDefault?.(), t.stopPropagation?.(), t.cancelBubble = !0);
        }
        class tM {
            static compose(t, e, i) {
                tn.compose(e), tp.compose(i), ty(tc, "Map.Navigation") && (tu(t, "beforeRender", function() {
                    this.mapNavigation = new tM(this), this.mapNavigation.update();
                }), td(ti));
            }
            constructor(t){
                this.chart = t, this.navButtons = [];
            }
            update(t) {
                let e = this, i = e.chart, s = e.navButtons, o = function(t) {
                    this.handler.call(i, t), tx(t);
                }, r = i.options.mapNavigation;
                for(t && (r = i.options.mapNavigation = tg(i.options.mapNavigation, t)); s.length;)s.pop()?.destroy();
                if (!i.renderer.forExport && tb(r.enableButtons, r.enabled)) {
                    e.navButtonsGroup || (e.navButtonsGroup = i.renderer.g().attr({
                        zIndex: 7
                    }).add()), tf(r.buttons, (t, a)=>{
                        let n = {
                            padding: (t = tg(r.buttonOptions, t)).padding
                        };
                        !i.styledMode && t.theme && (tm(n, t.theme), n.style = tg(t.theme.style, t.style));
                        let { text: l, width: h = 0, height: p = 0, padding: d = 0 } = t, c = i.renderer.button("+" !== l && "-" !== l && l || "", 0, 0, o, n, void 0, void 0, void 0, "zoomIn" === a ? "topbutton" : "bottombutton").addClass("highcharts-map-navigation highcharts-" + ({
                            zoomIn: "zoom-in",
                            zoomOut: "zoom-out"
                        })[a]).attr({
                            width: h,
                            height: p,
                            title: i.options.lang[a],
                            zIndex: 5
                        }).add(e.navButtonsGroup);
                        if ("+" === l || "-" === l) {
                            let e = h + 1, s = [
                                [
                                    "M",
                                    d + 3,
                                    d + p / 2
                                ],
                                [
                                    "L",
                                    d + e - 3,
                                    d + p / 2
                                ]
                            ];
                            "+" === l && s.push([
                                "M",
                                d + e / 2,
                                d + 3
                            ], [
                                "L",
                                d + e / 2,
                                d + p - 3
                            ]), i.renderer.path(s).addClass("highcharts-button-symbol").attr(i.styledMode ? {} : {
                                stroke: t.style?.color,
                                "stroke-width": 3,
                                "stroke-linecap": "round"
                            }).add(c);
                        }
                        if (c.handler = t.onclick, tu(c.element, "dblclick", tx), s.push(c), tm(t, {
                            width: c.width,
                            height: 2 * (c.height || 0)
                        }), i.hasLoaded) c.align(t, !1, t.alignTo);
                        else {
                            let e = tu(i, "load", ()=>{
                                c.element && c.align(t, !1, t.alignTo), e();
                            });
                        }
                    });
                    let t = (t, e)=>!(e.x >= t.x + t.width || e.x + e.width <= t.x || e.y >= t.y + t.height || e.y + e.height <= t.y);
                    i.hasLoaded || tu(i, "render", function() {
                        let s = i.exporting?.group?.getBBox();
                        if (s) {
                            let i = e.navButtonsGroup.getBBox();
                            if (t(s, i)) {
                                let t = -i.y - i.height + s.y - 5, o = s.y + s.height - i.y + 5, a = r.buttonOptions && r.buttonOptions.verticalAlign;
                                e.navButtonsGroup.attr({
                                    translateY: "bottom" === a ? t : o
                                });
                            }
                        }
                    });
                }
                this.updateEvents(r);
            }
            updateEvents(t) {
                let e = this.chart;
                tb(t.enableDoubleClickZoom, t.enabled) || t.enableDoubleClickZoomTo ? this.unbindDblClick = this.unbindDblClick || tu(e.container, "dblclick", function(t) {
                    e.pointer.onContainerDblClick(t);
                }) : this.unbindDblClick && (this.unbindDblClick = this.unbindDblClick()), tb(t.enableMouseWheelZoom, t.enabled) ? this.unbindMouseWheel = this.unbindMouseWheel || tu(e.container, "wheel", function(t) {
                    if (!e.pointer.inClass(t.target, "highcharts-no-mousewheel")) {
                        let i = e.mapView?.zoom;
                        e.pointer.onContainerMouseWheel(t), i !== e.mapView?.zoom && tx(t);
                    }
                    return !1;
                }) : this.unbindMouseWheel && (this.unbindMouseWheel = this.unbindMouseWheel());
            }
        }
        var tv = w(28), tw = w.n(tv);
        let { column: { prototype: tC } } = W().seriesTypes, { addEvent: tT, defined: tL } = L();
        !function(t) {
            function e(t) {
                let e = this.series, i = e.chart.renderer;
                this.moveToTopOnHover && this.graphic && (e.stateMarkerGraphic || (e.stateMarkerGraphic = new (tw())(i, "use").css({
                    pointerEvents: "none"
                }).add(this.graphic.parentGroup)), t?.state === "hover" ? (this.graphic.attr({
                    id: this.id
                }), e.stateMarkerGraphic.attr({
                    href: `${i.url}#${this.id}`,
                    visibility: "visible"
                })) : e.stateMarkerGraphic.attr({
                    href: ""
                }));
            }
            t.pointMembers = {
                dataLabelOnNull: !0,
                moveToTopOnHover: !0,
                isValid: function() {
                    return null !== this.value && this.value !== 1 / 0 && this.value !== -1 / 0 && (void 0 === this.value || !isNaN(this.value));
                }
            }, t.seriesMembers = {
                colorKey: "value",
                axisTypes: [
                    "xAxis",
                    "yAxis",
                    "colorAxis"
                ],
                parallelArrays: [
                    "x",
                    "y",
                    "value"
                ],
                pointArrayMap: [
                    "value"
                ],
                trackerGroups: [
                    "group",
                    "markerGroup",
                    "dataLabelsGroup"
                ],
                colorAttribs: function(t) {
                    let e = {};
                    return tL(t.color) && (!t.state || "normal" === t.state) && (e[this.colorProp || "fill"] = t.color), e;
                },
                pointAttribs: tC.pointAttribs
            }, t.compose = function(t) {
                return tT(t.prototype.pointClass, "afterSetState", e), t;
            };
        }(f || (f = {}));
        let tP = f;
        var tA = w(820), tk = w.n(tA);
        let { deg2rad: tj } = L(), { fireEvent: tz, isNumber: tS, pick: tI, relativeLength: tB } = L();
        !function(t) {
            t.getCenter = function() {
                let t = this.options, e = this.chart, i = 2 * (t.slicedOffset || 0), s = e.plotWidth - 2 * i, o = e.plotHeight - 2 * i, r = t.center, a = Math.min(s, o), n = t.thickness, l, h = t.size, p = t.innerSize || 0, d, c;
                "string" == typeof h && (h = parseFloat(h)), "string" == typeof p && (p = parseFloat(p));
                let u = [
                    tI(r?.[0], "50%"),
                    tI(r?.[1], "50%"),
                    tI(h && h < 0 ? void 0 : t.size, "100%"),
                    tI(p && p < 0 ? void 0 : t.innerSize || 0, "0%")
                ];
                for(!e.angular || this instanceof tk() || (u[3] = 0), d = 0; d < 4; ++d)c = u[d], l = d < 2 || 2 === d && /%$/.test(c), u[d] = tB(c, [
                    s,
                    o,
                    a,
                    u[2]
                ][d]) + (l ? i : 0);
                return u[3] > u[2] && (u[3] = u[2]), tS(n) && 2 * n < u[2] && n > 0 && (u[3] = u[2] - 2 * n), tz(this, "afterGetCenter", {
                    positions: u
                }), u;
            }, t.getStartAndEndRadians = function(t, e) {
                let i = tS(t) ? t : 0, s = tS(e) && e > i && e - i < 360 ? e : i + 360;
                return {
                    start: tj * (i + -90),
                    end: tj * (s + -90)
                };
            };
        }(b || (b = {}));
        let tE = b;
        var tD = w(960), tV = w.n(tD), tO = w(540), tN = w.n(tO);
        let { getOptions: tG } = L(), { isNumber: tX, merge: tR, pick: tH } = L();
        class tW extends tV() {
            init(t, e) {
                let i = tG().credits, s = tR({
                    chart: {
                        panning: {
                            enabled: !0,
                            type: "xy"
                        },
                        type: "map"
                    },
                    credits: {
                        mapText: tH(i.mapText, ' \xa9 <a href="{geojson.copyrightUrl}">{geojson.copyrightShort}</a>'),
                        mapTextFull: tH(i.mapTextFull, "{geojson.copyright}")
                    },
                    mapView: {},
                    tooltip: {
                        followTouchMove: !1
                    }
                }, t);
                super.init(s, e);
            }
            mapZoom(t, e, i, s, o) {
                this.mapView && (tX(t) && (t = Math.log(t) / Math.log(.5)), this.mapView.zoomBy(t, tX(e) && tX(i) ? this.mapView.projection.inverse([
                    e,
                    i
                ]) : void 0, tX(s) && tX(o) ? [
                    s,
                    o
                ] : void 0));
            }
            update(t) {
                t.chart && "map" in t.chart && this.mapView?.recommendMapView(this, [
                    t.chart.map,
                    ...(this.options.series || []).map((t)=>t.mapData)
                ], !0), super.update.apply(this, arguments);
            }
        }
        !function(t) {
            t.maps = {}, t.mapChart = function(e, i, s) {
                return new t(e, i, s);
            }, t.splitPath = function(t) {
                let e;
                return e = "string" == typeof t ? (t = t.replace(/([A-Z])/gi, " $1 ").replace(/^\s*/, "").replace(/\s*$/, "")).split(/[ ,;]+/).map((t)=>/[A-Z]/i.test(t) ? t : parseFloat(t)) : t, tN().prototype.pathToSegments(e);
            };
        }(tW || (tW = {}));
        let tY = tW, tU = {
            boundsFromPath: function(t) {
                let e = -Number.MAX_VALUE, i = Number.MAX_VALUE, s = -Number.MAX_VALUE, o = Number.MAX_VALUE, r;
                if (t.forEach((t)=>{
                    let a = t[t.length - 2], n = t[t.length - 1];
                    "number" == typeof a && "number" == typeof n && (i = Math.min(i, a), e = Math.max(e, a), o = Math.min(o, n), s = Math.max(s, n), r = !0);
                }), r) return {
                    x1: i,
                    y1: o,
                    x2: e,
                    y2: s
                };
            }
        }, { boundsFromPath: tF } = tU, tZ = W().seriesTypes.scatter.prototype.pointClass, { extend: t_, isNumber: tK, pick: tq } = L();
        class t$ extends tZ {
            static getProjectedPath(t, e) {
                return t.projectedPath || (e && t.geometry ? (e.hasCoordinates = !0, t.projectedPath = e.path(t.geometry)) : t.projectedPath = t.path), t.projectedPath || [];
            }
            applyOptions(t, e) {
                let i = this.series, s = super.applyOptions(t, e), o = i.joinBy;
                if (i.mapData && i.mapMap) {
                    let t = o[1], e = super.getNestedProperty(t), r = void 0 !== e && i.mapMap[e];
                    r ? t_(s, {
                        ...r,
                        name: s.name ?? r.name
                    }) : -1 !== i.pointArrayMap.indexOf("value") && (s.value = s.value || null);
                }
                return s;
            }
            getProjectedBounds(t) {
                let e = tF(t$.getProjectedPath(this, t)), i = this.properties, s = this.series.chart.mapView;
                if (e) {
                    let o = i?.["hc-middle-lon"], r = i?.["hc-middle-lat"];
                    if (s && tK(o) && tK(r)) {
                        let i = t.forward([
                            o,
                            r
                        ]);
                        e.midX = i[0], e.midY = i[1];
                    } else {
                        let t = i?.["hc-middle-x"], s = i?.["hc-middle-y"];
                        e.midX = e.x1 + (e.x2 - e.x1) * tq(this.middleX, tK(t) ? t : .5);
                        let o = tq(this.middleY, tK(s) ? s : .5);
                        this.geometry || (o = 1 - o), e.midY = e.y2 - (e.y2 - e.y1) * o;
                    }
                    return e;
                }
            }
            onMouseOver(t) {
                L().clearTimeout(this.colorInterval), !this.isNull && this.visible || this.series.options.nullInteraction ? super.onMouseOver.call(this, t) : this.series.onMouseOut();
            }
            setVisible(t) {
                this.visible = this.options.visible = !!t, this.dataLabel && this.dataLabel[t ? "show" : "hide"](), this.graphic && this.graphic.attr(this.series.pointAttribs(this));
            }
            zoomTo(t) {
                let e = this.series.chart, i = e.mapView, s = this.bounds;
                if (i && s) {
                    let o = tK(this.insetIndex) && i.insets[this.insetIndex];
                    if (o) {
                        let t = o.projectedUnitsToPixels({
                            x: s.x1,
                            y: s.y1
                        }), e = o.projectedUnitsToPixels({
                            x: s.x2,
                            y: s.y2
                        }), r = i.pixelsToProjectedUnits({
                            x: t.x,
                            y: t.y
                        }), a = i.pixelsToProjectedUnits({
                            x: e.x,
                            y: e.y
                        });
                        s = {
                            x1: r.x,
                            y1: r.y,
                            x2: a.x,
                            y2: a.y
                        };
                    }
                    i.fitToBounds(s, void 0, !1), this.series.isDirty = !0, e.redraw(t);
                }
            }
        }
        t_(t$.prototype, {
            dataLabelOnNull: tP.pointMembers.dataLabelOnNull,
            moveToTopOnHover: tP.pointMembers.moveToTopOnHover,
            isValid: tP.pointMembers.isValid
        });
        let { isNumber: tJ } = L(), tQ = {
            center: [
                0,
                0
            ],
            fitToGeometry: void 0,
            maxZoom: void 0,
            padding: 0,
            projection: {
                name: void 0,
                parallels: void 0,
                rotation: void 0
            },
            zoom: void 0,
            insetOptions: {
                borderColor: "#cccccc",
                borderWidth: 1,
                padding: "10%",
                relativeTo: "mapBoundingBox",
                units: "percent"
            }
        };
        var t0 = w(984), t1 = w.n(t0);
        let { win: t2 } = L(), { format: t6 } = t1(), { error: t3, extend: t8, merge: t7, wrap: t9 } = L();
        !function(t) {
            function e(t) {
                return this.mapView && this.mapView.lonLatToProjectedUnits(t);
            }
            function i(t) {
                return this.mapView && this.mapView.projectedUnitsToLonLat(t);
            }
            function s(t, e) {
                let i = this.options.chart.proj4 || t2.proj4;
                if (!i) return void t3(21, !1, this);
                let { jsonmarginX: s = 0, jsonmarginY: o = 0, jsonres: r = 1, scale: a = 1, xoffset: n = 0, xpan: l = 0, yoffset: h = 0, ypan: p = 0 } = e, d = i(e.crs, [
                    t.lon,
                    t.lat
                ]), c = e.cosAngle || e.rotation && Math.cos(e.rotation), u = e.sinAngle || e.rotation && Math.sin(e.rotation), m = e.rotation ? [
                    d[0] * c + d[1] * u,
                    -d[0] * u + d[1] * c
                ] : d;
                return {
                    x: ((m[0] - n) * a + l) * r + s,
                    y: -(((h - m[1]) * a + p) * r - o)
                };
            }
            function o(t, e) {
                let i = this.options.chart.proj4 || t2.proj4;
                if (!i) return void t3(21, !1, this);
                if (null === t.y) return;
                let { jsonmarginX: s = 0, jsonmarginY: o = 0, jsonres: r = 1, scale: a = 1, xoffset: n = 0, xpan: l = 0, yoffset: h = 0, ypan: p = 0 } = e, d = {
                    x: ((t.x - s) / r - l) / a + n,
                    y: ((t.y - o) / r + p) / a + h
                }, c = e.cosAngle || e.rotation && Math.cos(e.rotation), u = e.sinAngle || e.rotation && Math.sin(e.rotation), m = i(e.crs, "WGS84", e.rotation ? {
                    x: d.x * c + -(d.y * u),
                    y: d.x * u + d.y * c
                } : d);
                return {
                    lat: m.y,
                    lon: m.x
                };
            }
            function r(t, e) {
                e || (e = Object.keys(t.objects)[0]);
                let i = t.objects[e];
                if (i["hc-decoded-geojson"] && i["hc-decoded-geojson"].title === t.title) return i["hc-decoded-geojson"];
                let s = t.arcs;
                if (t.transform) {
                    let e, i, o, r = t.arcs, { scale: a, translate: n } = t.transform;
                    s = [];
                    for(let t = 0, l = r.length; t < l; ++t){
                        let l = r[t];
                        s.push(e = []), i = 0, o = 0;
                        for(let t = 0, s = l.length; t < s; ++t)e.push([
                            (i += l[t][0]) * a[0] + n[0],
                            (o += l[t][1]) * a[1] + n[1]
                        ]);
                    }
                }
                let o = (t)=>"number" == typeof t[0] ? t.reduce((t, e, i)=>{
                        let o = e < 0 ? s[~e] : s[e];
                        return e < 0 ? (o = o.slice(0, 0 === i ? o.length : o.length - 1)).reverse() : i && (o = o.slice(1)), t.concat(o);
                    }, []) : t.map(o), r = i.geometries, a = [];
                for(let t = 0, e = r.length; t < e; ++t)a.push({
                    type: "Feature",
                    properties: r[t].properties,
                    geometry: {
                        type: r[t].type,
                        coordinates: r[t].coordinates || o(r[t].arcs)
                    }
                });
                let n = {
                    type: "FeatureCollection",
                    copyright: t.copyright,
                    copyrightShort: t.copyrightShort,
                    copyrightUrl: t.copyrightUrl,
                    features: a,
                    "hc-recommended-mapview": i["hc-recommended-mapview"],
                    bbox: t.bbox,
                    title: t.title
                };
                return i["hc-decoded-geojson"] = n, n;
            }
            function a(t, e) {
                e = t7(!0, this.options.credits, e), t.call(this, e), this.credits && this.mapCreditsFull && this.credits.attr({
                    title: this.mapCreditsFull
                });
            }
            t.compose = function(t) {
                let r = t.prototype;
                r.transformFromLatLon || (r.fromLatLonToPoint = e, r.fromPointToLatLon = i, r.transformFromLatLon = s, r.transformToLatLon = o, t9(r, "addCredits", a));
            }, t.geojson = function(t, e = "map", i) {
                let s = [], o = "Topology" === t.type ? r(t) : t, a = o.features;
                for(let t = 0, i = a.length; t < i; ++t){
                    let i, o = a[t], r = o.geometry || {}, n = r.type, l = r.coordinates, h = o.properties;
                    if (("map" === e || "mapbubble" === e) && ("Polygon" === n || "MultiPolygon" === n) || "mapline" === e && ("LineString" === n || "MultiLineString" === n) ? l.length && (i = {
                        geometry: {
                            coordinates: l,
                            type: n
                        }
                    }) : "mappoint" === e && "Point" === n && l.length && (i = {
                        geometry: {
                            coordinates: l,
                            type: n
                        }
                    }), i) {
                        let t = h && (h.name || h.NAME), e = h && h.lon, o = h && h.lat;
                        s.push(t8(i, {
                            lat: "number" == typeof o ? o : void 0,
                            lon: "number" == typeof e ? e : void 0,
                            name: "string" == typeof t ? t : void 0,
                            properties: h
                        }));
                    }
                }
                return i && o.copyrightShort && (i.chart.mapCredits = t6(i.chart.options.credits?.mapText, {
                    geojson: o
                }), i.chart.mapCreditsFull = t6(i.chart.options.credits?.mapTextFull, {
                    geojson: o
                })), s;
            }, t.topo2geo = r;
        }(y || (y = {}));
        let t4 = y;
        !function(t) {
            t.getCenterOfPoints = function(t) {
                let e = t.reduce((t, e)=>(t.x += e.x, t.y += e.y, t), {
                    x: 0,
                    y: 0
                });
                return {
                    x: e.x / t.length,
                    y: e.y / t.length
                };
            }, t.getDistanceBetweenPoints = function(t, e) {
                return Math.sqrt(Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2));
            }, t.getAngleBetweenPoints = function(t, e) {
                return Math.atan2(e.x - t.x, e.y - t.y);
            }, t.pointInPolygon = function({ x: t, y: e }, i) {
                let s = i.length, o, r, a = !1;
                for(o = 0, r = s - 1; o < s; r = o++){
                    let [s, n] = i[o], [l, h] = i[r];
                    n > e != h > e && t < (l - s) * (e - n) / (h - n) + s && (a = !a);
                }
                return a;
            };
        }(x || (x = {}));
        let t5 = x;
        function et(t, e, i = !0) {
            let s = e[e.length - 1], o, r, a, n = t;
            for(let t = 0; t < e.length; t++){
                let l = n;
                o = e[t], n = [], r = i ? l[l.length - 1] : l[0];
                for(let t = 0; t < l.length; t++)ee(s, o, a = l[t]) ? (ee(s, o, r) || n.push(ei(s, o, r, a)), n.push(a)) : ee(s, o, r) && n.push(ei(s, o, r, a)), r = a;
                s = o;
            }
            return n;
        }
        function ee(t, e, i) {
            return (e[0] - t[0]) * (i[1] - t[1]) > (e[1] - t[1]) * (i[0] - t[0]);
        }
        function ei(t, e, i, s) {
            let o = [
                t[0] - e[0],
                t[1] - e[1]
            ], r = [
                i[0] - s[0],
                i[1] - s[1]
            ], a = t[0] * e[1] - t[1] * e[0], n = i[0] * s[1] - i[1] * s[0], l = 1 / (o[0] * r[1] - o[1] * r[0]), h = [
                (a * r[0] - n * o[0]) * l,
                (a * r[1] - n * o[1]) * l
            ];
            return h.isIntersection = !0, h;
        }
        let es = Math.sign || ((t)=>0 === t ? 0 : t > 0 ? 1 : -1), eo = Math.PI / 180, er = Math.PI / 2, ea = (t)=>Math.tan((er + t) / 2), en = class {
            constructor(t){
                let e = (t.parallels || []).map((t)=>t * eo), i = e[0] || 0, s = e[1] ?? i, o = Math.cos(i);
                "object" == typeof t.projectedBounds && (this.projectedBounds = t.projectedBounds);
                let r = i === s ? Math.sin(i) : Math.log(o / Math.cos(s)) / Math.log(ea(s) / ea(i));
                1e-10 > Math.abs(r) && (r = 1e-10 * (es(r) || 1)), this.n = r, this.c = o * Math.pow(ea(i), r) / r;
            }
            forward(t) {
                let { c: e, n: i, projectedBounds: s } = this, o = t[0] * eo, r = t[1] * eo;
                e > 0 ? r < -er + 1e-6 && (r = -er + 1e-6) : r > er - 1e-6 && (r = er - 1e-6);
                let a = e / Math.pow(ea(r), i), n = a * Math.sin(i * o) * 63.78137, l = (e - a * Math.cos(i * o)) * 63.78137, h = [
                    n,
                    l
                ];
                return s && (n < s.x1 || n > s.x2 || l < s.y1 || l > s.y2) && (h.outside = !0), h;
            }
            inverse(t) {
                let { c: e, n: i } = this, s = t[0] / 63.78137, o = e - t[1] / 63.78137, r = es(i) * Math.sqrt(s * s + o * o), a = Math.atan2(s, Math.abs(o)) * es(o);
                return o * i < 0 && (a -= Math.PI * es(s) * es(o)), [
                    a / i / eo,
                    (2 * Math.atan(Math.pow(e / r, 1 / i)) - er) / eo
                ];
            }
        }, el = Math.sqrt(3) / 2, eh = class {
            constructor(){
                this.bounds = {
                    x1: -200.37508342789243,
                    x2: 200.37508342789243,
                    y1: -97.52595454902263,
                    y2: 97.52595454902263
                };
            }
            forward(t) {
                let e = Math.PI / 180, i = Math.asin(el * Math.sin(t[1] * e)), s = i * i, o = s * s * s;
                return [
                    t[0] * e * Math.cos(i) * 74.03120656864502 / (el * (1.340264 + -0.24331799999999998 * s + o * (.0062510000000000005 + .034164 * s))),
                    74.03120656864502 * i * (1.340264 + -0.081106 * s + o * (893e-6 + .003796 * s))
                ];
            }
            inverse(t) {
                let e = t[0] / 74.03120656864502, i = t[1] / 74.03120656864502, s = 180 / Math.PI, o = i, r, a, n, l;
                for(let t = 0; t < 12 && (a = (r = o * o) * r * r, n = o * (1.340264 + -0.081106 * r + a * (893e-6 + .003796 * r)) - i, o -= l = n / (1.340264 + -0.24331799999999998 * r + a * (.0062510000000000005 + .034164 * r)), !(1e-9 > Math.abs(l))); ++t);
                a = (r = o * o) * r * r;
                let h = s * el * e * (1.340264 + -0.24331799999999998 * r + a * (.0062510000000000005 + .034164 * r)) / Math.cos(o), p = s * Math.asin(Math.sin(o) / el);
                return Math.abs(h) > 180 ? [
                    NaN,
                    NaN
                ] : [
                    h,
                    p
                ];
            }
        }, ep = Math.PI / 4, ed = Math.PI / 180, ec = class {
            constructor(){
                this.bounds = {
                    x1: -200.37508342789243,
                    x2: 200.37508342789243,
                    y1: -146.91480769173063,
                    y2: 146.91480769173063
                };
            }
            forward(t) {
                return [
                    t[0] * ed * 63.78137,
                    79.7267125 * Math.log(Math.tan(ep + .4 * t[1] * ed))
                ];
            }
            inverse(t) {
                return [
                    t[0] / 63.78137 / ed,
                    2.5 * (Math.atan(Math.exp(.8 * (t[1] / 63.78137))) - ep) / ed
                ];
            }
        }, eu = Math.PI / 180, em = class {
            constructor(){
                this.antimeridianCutting = !1, this.bounds = {
                    x1: -63.78460826781007,
                    x2: 63.78460826781007,
                    y1: -63.78460826781007,
                    y2: 63.78460826781007
                };
            }
            forward(t) {
                let e = t[0], i = t[1] * eu, s = [
                    Math.cos(i) * Math.sin(e * eu) * 63.78460826781007,
                    63.78460826781007 * Math.sin(i)
                ];
                return (e < -90 || e > 90) && (s.outside = !0), s;
            }
            inverse(t) {
                let e = t[0] / 63.78460826781007, i = t[1] / 63.78460826781007, s = Math.sqrt(e * e + i * i), o = Math.asin(s), r = Math.sin(o);
                return [
                    Math.atan2(e * r, s * Math.cos(o)) / eu,
                    Math.asin(s && i * r / s) / eu
                ];
            }
        }, eg = Math.PI / 180, ef = class {
            constructor(){
                this.bounds = {
                    x1: -200.37508342789243,
                    x2: 200.37508342789243,
                    y1: -200.3750834278071,
                    y2: 200.3750834278071
                }, this.maxLatitude = 85.0511287798;
            }
            forward(t) {
                let e = Math.sin(t[1] * eg), i = [
                    63.78137 * t[0] * eg,
                    63.78137 * Math.log((1 + e) / (1 - e)) / 2
                ];
                return Math.abs(t[1]) > this.maxLatitude && (i.outside = !0), i;
            }
            inverse(t) {
                return [
                    t[0] / (63.78137 * eg),
                    (2 * Math.atan(Math.exp(t[1] / 63.78137)) - Math.PI / 2) / eg
                ];
            }
        }, { clipLineString: eb, clipPolygon: ey } = {
            clipLineString: function(t, e) {
                let i = [], s = et(t, e, !1);
                for(let t = 1; t < s.length; t++)s[t].isIntersection && s[t - 1].isIntersection && (i.push(s.splice(0, t)), t = 0), t === s.length - 1 && i.push(s);
                return i;
            },
            clipPolygon: et
        }, { clamp: ex, erase: eM } = L(), ev = 2 * Math.PI / 360, ew = (t)=>(t < -180 && (t += 360), t > 180 && (t -= 360), t), eC = (t)=>(1 - Math.cos(t)) / 2, eT = (t, e)=>{
            let i = Math.cos, s = t[1] * ev, o = t[0] * ev, r = e[1] * ev, a = e[0] * ev;
            return eC(r - s) + i(s) * i(r) * eC(a - o);
        };
        class eL {
            static add(t, e) {
                eL.registry[t] = e;
            }
            static distance(t, e) {
                let { atan2: i, sqrt: s } = Math, o = eT(t, e);
                return 6371e3 * (2 * i(s(o), s(1 - o)));
            }
            static geodesic(t, e, i, s = 5e5) {
                let { atan2: o, cos: r, sin: a, sqrt: n } = Math, l = eL.distance, h = t[1] * ev, p = t[0] * ev, d = e[1] * ev, c = e[0] * ev, u = r(h) * r(p), m = r(d) * r(c), g = r(h) * a(p), f = r(d) * a(c), b = a(h), y = a(d), x = l(t, e), M = x / 6371e3, v = a(M), w = Math.round(x / s), C = [];
                if (i && C.push(t), w > 1) {
                    let t = 1 / w;
                    for(let e = t; e < .999; e += t){
                        let t = a((1 - e) * M) / v, i = a(e * M) / v, s = t * u + i * m, r = t * g + i * f, l = o(t * b + i * y, n(s * s + r * r)), h = o(r, s);
                        C.push([
                            h / ev,
                            l / ev
                        ]);
                    }
                }
                return i && C.push(e), C;
            }
            static insertGeodesics(t) {
                let e = t.length - 1;
                for(; e--;)if (Math.max(Math.abs(t[e][0] - t[e + 1][0]), Math.abs(t[e][1] - t[e + 1][1])) > 10) {
                    let i = eL.geodesic(t[e], t[e + 1]);
                    i.length && t.splice(e + 1, 0, ...i);
                }
            }
            static toString(t) {
                let { name: e, rotation: i } = t || {};
                return [
                    e,
                    i && i.join(",")
                ].join(";");
            }
            constructor(t = {}){
                this.hasCoordinates = !1, this.hasGeoProjection = !1, this.maxLatitude = 90, this.options = t;
                let { name: e, projectedBounds: i, rotation: s } = t;
                this.rotator = s ? this.getRotator(s) : void 0;
                let o = e ? eL.registry[e] : void 0;
                o && (this.def = new o(t));
                let { def: r, rotator: a } = this;
                r && (this.maxLatitude = r.maxLatitude || 90, this.hasGeoProjection = !0), a && r ? (this.forward = (t)=>r.forward(a.forward(t)), this.inverse = (t)=>a.inverse(r.inverse(t))) : r ? (this.forward = (t)=>r.forward(t), this.inverse = (t)=>r.inverse(t)) : a && (this.forward = a.forward, this.inverse = a.inverse), this.bounds = "world" === i ? r && r.bounds : i;
            }
            lineIntersectsBounds(t) {
                let { x1: e, x2: i, y1: s, y2: o } = this.bounds || {}, r = (t, e, i)=>{
                    let [s, o] = t, r = +!e;
                    if ("number" == typeof i && s[e] >= i != o[e] >= i) {
                        let t = (i - s[e]) / (o[e] - s[e]), a = s[r] + t * (o[r] - s[r]);
                        return e ? [
                            a,
                            i
                        ] : [
                            i,
                            a
                        ];
                    }
                }, a, n = t[0];
                return (a = r(t, 0, e)) ? (n = a, t[1] = a) : (a = r(t, 0, i)) && (n = a, t[1] = a), (a = r(t, 1, s)) ? n = a : (a = r(t, 1, o)) && (n = a), n;
            }
            getRotator(t) {
                let e = t[0] * ev, i = (t[1] || 0) * ev, s = (t[2] || 0) * ev, o = Math.cos(i), r = Math.sin(i), a = Math.cos(s), n = Math.sin(s);
                if (0 !== e || 0 !== i || 0 !== s) return {
                    forward: (t)=>{
                        let i = t[0] * ev + e, s = t[1] * ev, l = Math.cos(s), h = Math.cos(i) * l, p = Math.sin(i) * l, d = Math.sin(s), c = d * o + h * r;
                        return [
                            Math.atan2(p * a - c * n, h * o - d * r) / ev,
                            Math.asin(c * a + p * n) / ev
                        ];
                    },
                    inverse: (t)=>{
                        let i = t[0] * ev, s = t[1] * ev, l = Math.cos(s), h = Math.cos(i) * l, p = Math.sin(i) * l, d = Math.sin(s), c = d * a - p * n;
                        return [
                            (Math.atan2(p * a + d * n, h * o + c * r) - e) / ev,
                            Math.asin(c * o - h * r) / ev
                        ];
                    }
                };
            }
            forward(t) {
                return t;
            }
            inverse(t) {
                return t;
            }
            cutOnAntimeridian(t, e) {
                let i, s = [], o = [
                    t
                ];
                for(let i = 0, o = t.length; i < o; ++i){
                    let o = t[i], r = t[i - 1];
                    if (!i) {
                        if (!e) continue;
                        r = t[t.length - 1];
                    }
                    let a = r[0], n = o[0];
                    if ((a < -90 || a > 90) && (n < -90 || n > 90) && a > 0 != n > 0) {
                        let t = ex((180 - (a + 360) % 360) / ((n + 360) % 360 - (a + 360) % 360), 0, 1), e = r[1] + t * (o[1] - r[1]);
                        s.push({
                            i: i,
                            lat: e,
                            direction: a < 0 ? 1 : -1,
                            previousLonLat: r,
                            lonLat: o
                        });
                    }
                }
                if (s.length) {
                    if (e) {
                        s.length % 2 == 1 && (i = s.slice().sort((t, e)=>Math.abs(e.lat) - Math.abs(t.lat))[0], eM(s, i));
                        let e = s.length - 2;
                        for(; e >= 0;){
                            let i = s[e].i, r = ew(180 + 1e-6 * s[e].direction), a = ew(180 - 1e-6 * s[e].direction), n = t.splice(i, s[e + 1].i - i, ...eL.geodesic([
                                r,
                                s[e].lat
                            ], [
                                r,
                                s[e + 1].lat
                            ], !0));
                            n.push(...eL.geodesic([
                                a,
                                s[e + 1].lat
                            ], [
                                a,
                                s[e].lat
                            ], !0)), o.push(n), e -= 2;
                        }
                        if (i) for(let t = 0; t < o.length; t++){
                            let { direction: e, lat: s } = i, r = o[t], a = r.indexOf(i.lonLat);
                            if (a > -1) {
                                let t = (s < 0 ? -1 : 1) * this.maxLatitude, o = ew(180 + 1e-6 * e), n = ew(180 - 1e-6 * e), l = eL.geodesic([
                                    o,
                                    s
                                ], [
                                    o,
                                    t
                                ], !0);
                                for(let i = o + 120 * e; i > -180 && i < 180; i += 120 * e)l.push([
                                    i,
                                    t
                                ]);
                                l.push(...eL.geodesic([
                                    n,
                                    t
                                ], [
                                    n,
                                    i.lat
                                ], !0)), r.splice(a, 0, ...l);
                                break;
                            }
                        }
                    } else {
                        let e = s.length;
                        for(; e--;){
                            let i = s[e].i, r = t.splice(i, t.length, [
                                ew(180 + 1e-6 * s[e].direction),
                                s[e].lat
                            ]);
                            r.unshift([
                                ew(180 - 1e-6 * s[e].direction),
                                s[e].lat
                            ]), o.push(r);
                        }
                    }
                }
                return o;
            }
            path(t) {
                let e, { bounds: i, def: s, rotator: o } = this, r = [], a = "Polygon" === t.type || "MultiPolygon" === t.type, n = this.hasGeoProjection, l = !s || !1 !== s.antimeridianCutting, h = l ? o : void 0, p = l && s || this;
                i && (e = [
                    [
                        i.x1,
                        i.y1
                    ],
                    [
                        i.x2,
                        i.y1
                    ],
                    [
                        i.x2,
                        i.y2
                    ],
                    [
                        i.x1,
                        i.y2
                    ]
                ]);
                let d = (t)=>{
                    let s = t.map((t)=>{
                        if (l) {
                            h && (t = h.forward(t));
                            let e = t[0];
                            1e-6 > Math.abs(e - 180) && (e = e < 180 ? 179.999999 : 180.000001), t = [
                                e,
                                t[1]
                            ];
                        }
                        return t;
                    }), o = [
                        s
                    ];
                    n && (eL.insertGeodesics(s), l && (o = this.cutOnAntimeridian(s, a))), o.forEach((t)=>{
                        let s, o;
                        if (t.length < 2) return;
                        let h = !1, d = !1, c = (t)=>{
                            h ? r.push([
                                "L",
                                t[0],
                                t[1]
                            ]) : (r.push([
                                "M",
                                t[0],
                                t[1]
                            ]), h = !0);
                        }, u = !1, m = !1, g = t.map((t)=>{
                            let e = p.forward(t);
                            return e.outside ? u = !0 : m = !0, e[1] === 1 / 0 ? e[1] = 1e10 : e[1] === -1 / 0 && (e[1] = -10000000000), e;
                        });
                        if (l) {
                            if (a && g.push(g[0]), u) {
                                if (!m) return;
                                if (e) {
                                    if (a) g = ey(g, e);
                                    else if (i) return void eb(g, e).forEach((t)=>{
                                        h = !1, t.forEach(c);
                                    });
                                }
                            }
                            g.forEach(c);
                        } else for(let e = 0; e < g.length; e++){
                            let i = t[e], r = g[e];
                            r.outside ? d = !0 : (a && !s && (s = i, t.push(i), g.push(r)), d && o && (a && n ? eL.geodesic(o, i).forEach((t)=>c(p.forward(t))) : h = !1), c(r), o = i, d = !1);
                        }
                    });
                };
                return "LineString" === t.type ? d(t.coordinates) : "MultiLineString" === t.type ? t.coordinates.forEach((t)=>d(t)) : "Polygon" === t.type ? (t.coordinates.forEach((t)=>d(t)), r.length && r.push([
                    "Z"
                ])) : "MultiPolygon" === t.type && (t.coordinates.forEach((t)=>{
                    t.forEach((t)=>d(t));
                }), r.length && r.push([
                    "Z"
                ])), r;
            }
        }
        eL.registry = {
            EqualEarth: eh,
            LambertConformalConic: en,
            Miller: ec,
            Orthographic: em,
            WebMercator: ef
        };
        let { composed: eP } = L(), { pointInPolygon: eA } = t5, { topo2geo: ek } = t4, { boundsFromPath: ej } = tU, { addEvent: ez, clamp: eS, crisp: eI, fireEvent: eB, isArray: eE, isNumber: eD, isObject: eV, isString: eO, merge: eN, pick: eG, pushUnique: eX, relativeLength: eR } = L(), eH = {};
        function eW(t, e) {
            let { width: i, height: s } = e;
            return Math.log(400.979322 / Math.max((t.x2 - t.x1) / (i / 256), (t.y2 - t.y1) / (s / 256))) / Math.log(2);
        }
        function eY(t) {
            t.seriesOptions.mapData && this.mapView?.recommendMapView(this, [
                this.options.chart.map,
                t.seriesOptions.mapData
            ], this.options.drilldown?.mapZooming);
        }
        class eU {
            static compose(t) {
                eX(eP, "MapView") && (eH = t.maps, ez(t, "afterInit", function() {
                    this.mapView = new eU(this, this.options.mapView);
                }, {
                    order: 0
                }), ez(t, "addSeriesAsDrilldown", eY), ez(t, "afterDrillUp", eY));
            }
            static compositeBounds(t) {
                if (t.length) return t.slice(1).reduce((t, e)=>(t.x1 = Math.min(t.x1, e.x1), t.y1 = Math.min(t.y1, e.y1), t.x2 = Math.max(t.x2, e.x2), t.y2 = Math.max(t.y2, e.y2), t), eN(t[0]));
            }
            static mergeInsets(t, e) {
                let i = (t)=>{
                    let e = {};
                    return t.forEach((t, i)=>{
                        e[t && t.id || `i${i}`] = t;
                    }), e;
                }, s = eN(i(t), i(e));
                return Object.keys(s).map((t)=>s[t]);
            }
            constructor(t, e){
                this.allowTransformAnimation = !0, this.eventsToUnbind = [], this.insets = [], this.padding = [
                    0,
                    0,
                    0,
                    0
                ], this.recommendedMapView = {}, this instanceof eF || this.recommendMapView(t, [
                    t.options.chart.map,
                    ...(t.options.series || []).map((t)=>t.mapData)
                ]), this.userOptions = e || {};
                let i = eN(tQ, this.recommendedMapView, e), s = this.recommendedMapView?.insets, o = e && e.insets;
                s && o && (i.insets = eU.mergeInsets(s, o)), this.chart = t, this.center = i.center, this.options = i, this.projection = new eL(i.projection), this.playingField = t.plotBox, this.zoom = i.zoom || 0, this.minZoom = i.minZoom, this.createInsets(), this.eventsToUnbind.push(ez(t, "afterSetChartSize", ()=>{
                    this.playingField = this.getField(), (void 0 === this.minZoom || this.minZoom === this.zoom) && (this.fitToBounds(void 0, void 0, !1), !this.chart.hasRendered && eD(this.userOptions.zoom) && (this.zoom = this.userOptions.zoom), this.userOptions.center && eN(!0, this.center, this.userOptions.center));
                })), this.setUpEvents();
            }
            createInsets() {
                let t = this.options, e = t.insets;
                e && e.forEach((e)=>{
                    let i = new eF(this, eN(t.insetOptions, e));
                    this.insets.push(i);
                });
            }
            fitToBounds(t, e, i = !0, s) {
                let o = t || this.getProjectedBounds();
                if (o) {
                    let r = eG(e, t ? 0 : this.options.padding), a = this.getField(!1), n = eE(r) ? r : [
                        r,
                        r,
                        r,
                        r
                    ];
                    this.padding = [
                        eR(n[0], a.height),
                        eR(n[1], a.width),
                        eR(n[2], a.height),
                        eR(n[3], a.width)
                    ], this.playingField = this.getField();
                    let l = eW(o, this.playingField);
                    t || (this.minZoom = l);
                    let h = this.projection.inverse([
                        (o.x2 + o.x1) / 2,
                        (o.y2 + o.y1) / 2
                    ]);
                    this.setView(h, l, i, s);
                }
            }
            getField(t = !0) {
                let e = t ? this.padding : [
                    0,
                    0,
                    0,
                    0
                ];
                return {
                    x: e[3],
                    y: e[0],
                    width: this.chart.plotWidth - e[1] - e[3],
                    height: this.chart.plotHeight - e[0] - e[2]
                };
            }
            getGeoMap(t) {
                if (eO(t)) return eH[t] && "Topology" === eH[t].type ? ek(eH[t]) : eH[t];
                if (eV(t, !0)) {
                    if ("FeatureCollection" === t.type) return t;
                    if ("Topology" === t.type) return ek(t);
                }
            }
            getMapBBox() {
                let t = this.getProjectedBounds(), e = this.getScale();
                if (t) {
                    let i = this.padding, s = this.projectedUnitsToPixels({
                        x: t.x1,
                        y: t.y2
                    });
                    return {
                        width: (t.x2 - t.x1) * e + i[1] + i[3],
                        height: (t.y2 - t.y1) * e + i[0] + i[2],
                        x: s.x - i[3],
                        y: s.y - i[0]
                    };
                }
            }
            getProjectedBounds() {
                let t = this.projection, e = this.chart.series.reduce((t, e)=>{
                    let i = e.getProjectedBounds && e.getProjectedBounds();
                    return i && !1 !== e.options.affectsMapView && t.push(i), t;
                }, []), i = this.options.fitToGeometry;
                if (i) {
                    if (!this.fitToGeometryCache) {
                        if ("MultiPoint" === i.type) {
                            let e = i.coordinates.map((e)=>t.forward(e)), s = e.map((t)=>t[0]), o = e.map((t)=>t[1]);
                            this.fitToGeometryCache = {
                                x1: Math.min.apply(0, s),
                                x2: Math.max.apply(0, s),
                                y1: Math.min.apply(0, o),
                                y2: Math.max.apply(0, o)
                            };
                        } else this.fitToGeometryCache = ej(t.path(i));
                    }
                    return this.fitToGeometryCache;
                }
                return this.projection.bounds || eU.compositeBounds(e);
            }
            getScale() {
                return 256 / 400.979322 * Math.pow(2, this.zoom);
            }
            getSVGTransform() {
                let { x: t, y: e, width: i, height: s } = this.playingField, o = this.projection.forward(this.center), r = this.projection.hasCoordinates ? -1 : 1, a = this.getScale(), n = a * r, l = t + i / 2 - o[0] * a, h = e + s / 2 - o[1] * n;
                return {
                    scaleX: a,
                    scaleY: n,
                    translateX: l,
                    translateY: h
                };
            }
            lonLatToPixels(t) {
                let e = this.lonLatToProjectedUnits(t);
                if (e) return this.projectedUnitsToPixels(e);
            }
            lonLatToProjectedUnits(t) {
                let e = this.chart, i = e.mapTransforms;
                if (i) {
                    for(let s in i)if (Object.hasOwnProperty.call(i, s) && i[s].hitZone) {
                        let o = e.transformFromLatLon(t, i[s]);
                        if (o && eA(o, i[s].hitZone.coordinates[0])) return o;
                    }
                    return e.transformFromLatLon(t, i.default);
                }
                for (let e of this.insets)if (e.options.geoBounds && eA({
                    x: t.lon,
                    y: t.lat
                }, e.options.geoBounds.coordinates[0])) {
                    let i = e.projection.forward([
                        t.lon,
                        t.lat
                    ]), s = e.projectedUnitsToPixels({
                        x: i[0],
                        y: i[1]
                    });
                    return this.pixelsToProjectedUnits(s);
                }
                let s = this.projection.forward([
                    t.lon,
                    t.lat
                ]);
                if (!s.outside) return {
                    x: s[0],
                    y: s[1]
                };
            }
            projectedUnitsToLonLat(t) {
                let e = this.chart, i = e.mapTransforms;
                if (i) {
                    for(let s in i)if (Object.hasOwnProperty.call(i, s) && i[s].hitZone && eA(t, i[s].hitZone.coordinates[0])) return e.transformToLatLon(t, i[s]);
                    return e.transformToLatLon(t, i.default);
                }
                let s = this.projectedUnitsToPixels(t);
                for (let t of this.insets)if (t.hitZone && eA(s, t.hitZone.coordinates[0])) {
                    let e = t.pixelsToProjectedUnits(s), i = t.projection.inverse([
                        e.x,
                        e.y
                    ]);
                    return {
                        lon: i[0],
                        lat: i[1]
                    };
                }
                let o = this.projection.inverse([
                    t.x,
                    t.y
                ]);
                return {
                    lon: o[0],
                    lat: o[1]
                };
            }
            recommendMapView(t, e, i = !1) {
                this.recommendedMapView = {};
                let s = e.map((t)=>this.getGeoMap(t)), o = [];
                s.forEach((t)=>{
                    if (t && (Object.keys(this.recommendedMapView).length || (this.recommendedMapView = t["hc-recommended-mapview"] || {}), t.bbox)) {
                        let [e, i, s, r] = t.bbox;
                        o.push({
                            x1: e,
                            y1: i,
                            x2: s,
                            y2: r
                        });
                    }
                });
                let r = o.length && eU.compositeBounds(o);
                eB(this, "onRecommendMapView", {
                    geoBounds: r,
                    chart: t
                }, function() {
                    if (r && this.recommendedMapView) {
                        if (!this.recommendedMapView.projection) {
                            let { x1: t, y1: e, x2: i, y2: s } = r;
                            this.recommendedMapView.projection = i - t > 180 && s - e > 90 ? {
                                name: "EqualEarth",
                                parallels: [
                                    0,
                                    0
                                ],
                                rotation: [
                                    0
                                ]
                            } : {
                                name: "LambertConformalConic",
                                parallels: [
                                    e,
                                    s
                                ],
                                rotation: [
                                    -(t + i) / 2
                                ]
                            };
                        }
                        this.recommendedMapView.insets || (this.recommendedMapView.insets = void 0);
                    }
                }), this.geoMap = s[0], i && t.hasRendered && !t.userOptions.mapView?.projection && this.recommendedMapView && this.update(this.recommendedMapView);
            }
            redraw(t) {
                this.chart.series.forEach((t)=>{
                    t.useMapGeometry && (t.isDirty = !0);
                }), this.chart.redraw(t);
            }
            setView(t, e, i = !0, s) {
                t && (this.center = t), "number" == typeof e && ("number" == typeof this.minZoom && (e = Math.max(e, this.minZoom)), "number" == typeof this.options.maxZoom && (e = Math.min(e, this.options.maxZoom)), eD(e) && (this.zoom = e));
                let o = this.getProjectedBounds();
                if (o) {
                    let t = this.projection.forward(this.center), { x: e, y: i, width: s, height: r } = this.playingField, a = this.getScale(), n = this.projectedUnitsToPixels({
                        x: o.x1,
                        y: o.y1
                    }), l = this.projectedUnitsToPixels({
                        x: o.x2,
                        y: o.y2
                    }), h = [
                        (o.x1 + o.x2) / 2,
                        (o.y1 + o.y2) / 2
                    ];
                    if (!this.chart.series.some((t)=>t.isDrilling)) {
                        let o = n.x, p = l.y, d = l.x, c = n.y;
                        d - o < s ? t[0] = h[0] : o < e && d < e + s ? t[0] += Math.max(o - e, d - s - e) / a : d > e + s && o > e && (t[0] += Math.min(d - s - e, o - e) / a), c - p < r ? t[1] = h[1] : p < i && c < i + r ? t[1] -= Math.max(p - i, c - r - i) / a : c > i + r && p > i && (t[1] -= Math.min(c - r - i, p - i) / a), this.center = this.projection.inverse(t);
                    }
                    this.insets.forEach((t)=>{
                        t.options.field && (t.hitZone = t.getHitZone(), t.playingField = t.getField());
                    }), this.render();
                }
                eB(this, "afterSetView"), i && this.redraw(s);
            }
            projectedUnitsToPixels(t) {
                let e = this.getScale(), i = this.projection.forward(this.center), s = this.playingField, o = s.x + s.width / 2, r = s.y + s.height / 2;
                return {
                    x: o - e * (i[0] - t.x),
                    y: r + e * (i[1] - t.y)
                };
            }
            pixelsToLonLat(t) {
                return this.projectedUnitsToLonLat(this.pixelsToProjectedUnits(t));
            }
            pixelsToProjectedUnits(t) {
                let { x: e, y: i } = t, s = this.getScale(), o = this.projection.forward(this.center), r = this.playingField, a = r.x + r.width / 2, n = r.y + r.height / 2;
                return {
                    x: o[0] + (e - a) / s,
                    y: o[1] - (i - n) / s
                };
            }
            setUpEvents() {
                let t, e, i, { chart: s } = this, o = (o)=>{
                    let { lastTouches: r, pinchDown: a } = s.pointer, n = this.projection, l = o.touches, { mouseDownX: h, mouseDownY: p } = s, d = 0;
                    if (a?.length === 1 ? (h = a[0].chartX, p = a[0].chartY) : a?.length === 2 && (h = (a[0].chartX + a[1].chartX) / 2, p = (a[0].chartY + a[1].chartY) / 2), l?.length === 2 && r && (d = Math.log(Math.sqrt(Math.pow(r[0].chartX - r[1].chartX, 2) + Math.pow(r[0].chartY - r[1].chartY, 2)) / Math.sqrt(Math.pow(l[0].chartX - l[1].chartX, 2) + Math.pow(l[0].chartY - l[1].chartY, 2))) / Math.log(.5)), eD(h) && eD(p)) {
                        let r = `${h},${p}`, { chartX: a, chartY: c } = o.originalEvent;
                        l?.length === 2 && (a = (l[0].chartX + l[1].chartX) / 2, c = (l[0].chartY + l[1].chartY) / 2), r !== e && (e = r, t = this.projection.forward(this.center), i = (this.projection.options.rotation || [
                            0,
                            0
                        ]).slice());
                        let u = n.def && n.def.bounds, m = u && eW(u, this.playingField) || -1 / 0;
                        if ("Orthographic" === n.options.name && 2 > (l?.length || 0) && (this.minZoom || 1 / 0) < 1.3 * m) {
                            let t = 440 / (this.getScale() * Math.min(s.plotWidth, s.plotHeight));
                            if (i) {
                                let e = (h - a) * t - i[0], o = eS(-i[1] - (p - c) * t, -80, 80), r = this.zoom;
                                this.update({
                                    projection: {
                                        rotation: [
                                            -e,
                                            -o
                                        ]
                                    }
                                }, !1), this.fitToBounds(void 0, void 0, !1), this.zoom = r, s.redraw(!1);
                            }
                        } else if (eD(a) && eD(c)) {
                            let e = this.getScale(), i = this.projection.hasCoordinates ? 1 : -1, s = this.projection.inverse([
                                t[0] + (h - a) / e,
                                t[1] - (p - c) / e * i
                            ]);
                            isNaN(s[0] + s[1]) || this.zoomBy(d, s, void 0, !1);
                        }
                        o.preventDefault();
                    }
                };
                ez(s, "pan", o), ez(s, "touchpan", o), ez(s, "selection", (t)=>{
                    if (t.resetSelection) this.zoomBy();
                    else {
                        let e = t.x - s.plotLeft, i = t.y - s.plotTop, { y: o, x: r } = this.pixelsToProjectedUnits({
                            x: e,
                            y: i
                        }), { y: a, x: n } = this.pixelsToProjectedUnits({
                            x: e + t.width,
                            y: i + t.height
                        });
                        this.fitToBounds({
                            x1: r,
                            y1: o,
                            x2: n,
                            y2: a
                        }, void 0, !0, !t.originalEvent.touches && void 0), /^touch/.test(t.originalEvent.type) || s.showResetZoom(), t.preventDefault();
                    }
                });
            }
            render() {
                this.group || (this.group = this.chart.renderer.g("map-view").attr({
                    zIndex: 4
                }).add());
            }
            update(t, e = !0, i) {
                let s = t.projection, o = s && eL.toString(s) !== eL.toString(this.options.projection), r = !1;
                eN(!0, this.userOptions, t), eN(!0, this.options, t), "insets" in t && (this.insets.forEach((t)=>t.destroy()), this.insets.length = 0, r = !0), (o || "fitToGeometry" in t) && delete this.fitToGeometryCache, (o || r) && (this.chart.series.forEach((t)=>{
                    let e = t.transformGroups;
                    if (t.clearBounds && t.clearBounds(), t.isDirty = !0, t.isDirtyData = !0, r && e) for(; e.length > 1;){
                        let t = e.pop();
                        t && t.destroy();
                    }
                }), o && (this.projection = new eL(this.options.projection)), r && this.createInsets(), !t.center && Object.hasOwnProperty.call(t, "zoom") && !eD(t.zoom) && this.fitToBounds(void 0, void 0, !1)), t.center || eD(t.zoom) ? this.setView(this.options.center, t.zoom, !1) : "fitToGeometry" in t && this.fitToBounds(void 0, void 0, !1), e && this.chart.redraw(i);
            }
            zoomBy(t, e, i, s) {
                let o = this.chart, r = this.projection.forward(this.center);
                if ("number" == typeof t) {
                    let a, n, l, h = this.zoom + t;
                    if (i) {
                        let [t, e] = i, s = this.getScale(), a = t - o.plotLeft - o.plotWidth / 2, h = e - o.plotTop - o.plotHeight / 2;
                        n = r[0] + a / s, l = r[1] + h / s;
                    }
                    if ("number" == typeof n && "number" == typeof l) {
                        let t = 1 - Math.pow(2, this.zoom) / Math.pow(2, h), e = r[0] - n, i = r[1] - l;
                        r[0] -= e * t, r[1] += i * t, a = this.projection.inverse(r);
                    }
                    this.setView(e || a, h, void 0, s);
                } else this.fitToBounds(void 0, void 0, void 0, s);
            }
        }
        class eF extends eU {
            constructor(t, e){
                if (super(t.chart, e), this.id = e.id, this.mapView = t, this.options = eN({
                    center: [
                        0,
                        0
                    ]
                }, t.options.insetOptions, e), this.allBounds = [], this.options.geoBounds) {
                    let e = t.projection.path(this.options.geoBounds);
                    this.geoBoundsProjectedBox = ej(e), this.geoBoundsProjectedPolygon = e.map((t)=>[
                            t[1] || 0,
                            t[2] || 0
                        ]);
                }
            }
            getField(t = !0) {
                let e = this.hitZone;
                if (e) {
                    let i = t ? this.padding : [
                        0,
                        0,
                        0,
                        0
                    ], s = e.coordinates[0], o = s.map((t)=>t[0]), r = s.map((t)=>t[1]), a = Math.min.apply(0, o) + i[3], n = Math.max.apply(0, o) - i[1], l = Math.min.apply(0, r) + i[0], h = Math.max.apply(0, r) - i[2];
                    if (eD(a) && eD(l)) return {
                        x: a,
                        y: l,
                        width: n - a,
                        height: h - l
                    };
                }
                return super.getField.call(this, t);
            }
            getHitZone() {
                let { chart: t, mapView: e, options: i } = this, { coordinates: s } = i.field || {};
                if (s) {
                    let o = s[0];
                    if ("percent" === i.units) {
                        let s = "mapBoundingBox" === i.relativeTo && e.getMapBBox() || eN(t.plotBox, {
                            x: 0,
                            y: 0
                        });
                        o = o.map((t)=>[
                                eR(`${t[0]}%`, s.width, s.x),
                                eR(`${t[1]}%`, s.height, s.y)
                            ]);
                    }
                    return {
                        type: "Polygon",
                        coordinates: [
                            o
                        ]
                    };
                }
            }
            getProjectedBounds() {
                return eU.compositeBounds(this.allBounds);
            }
            isInside(t) {
                let { geoBoundsProjectedBox: e, geoBoundsProjectedPolygon: i } = this;
                return !!(e && t.x >= e.x1 && t.x <= e.x2 && t.y >= e.y1 && t.y <= e.y2 && i && eA(t, i));
            }
            render() {
                let { chart: t, mapView: e, options: i } = this, s = i.borderPath || i.field;
                if (s && e.group) {
                    let o = !0;
                    this.border || (this.border = t.renderer.path().addClass("highcharts-mapview-inset-border").add(e.group), o = !1), t.styledMode || this.border.attr({
                        stroke: i.borderColor,
                        "stroke-width": i.borderWidth
                    });
                    let r = this.border.strokeWidth(), a = "mapBoundingBox" === i.relativeTo && e.getMapBBox() || e.playingField, n = (s.coordinates || []).reduce((e, s)=>s.reduce((e, s, o)=>{
                            let [n, l] = s;
                            return "percent" === i.units && (n = t.plotLeft + eR(`${n}%`, a.width, a.x), l = t.plotTop + eR(`${l}%`, a.height, a.y)), n = eI(n, r), l = eI(l, r), e.push(0 === o ? [
                                "M",
                                n,
                                l
                            ] : [
                                "L",
                                n,
                                l
                            ]), e;
                        }, e), []);
                    this.border[o ? "animate" : "attr"]({
                        d: n
                    });
                }
            }
            destroy() {
                this.border && (this.border = this.border.destroy()), this.eventsToUnbind.forEach((t)=>t());
            }
            setUpEvents() {}
        }
        let { animObject: eZ, stop: e_ } = L(), { noop: eK } = L(), { splitPath: eq } = tY, { column: e$, scatter: eJ } = W().seriesTypes, { extend: eQ, find: e0, fireEvent: e1, getNestedProperty: e2, isArray: e6, defined: e3, isNumber: e8, isObject: e7, merge: e9, objectEach: e4, pick: e5, splat: it } = L();
        class ie extends eJ {
            constructor(){
                super(...arguments), this.processedData = [];
            }
            animate(t) {
                let { chart: e, group: i } = this, s = eZ(this.options.animation);
                t ? i.attr({
                    translateX: e.plotLeft + e.plotWidth / 2,
                    translateY: e.plotTop + e.plotHeight / 2,
                    scaleX: .001,
                    scaleY: .001
                }) : i.animate({
                    translateX: e.plotLeft,
                    translateY: e.plotTop,
                    scaleX: 1,
                    scaleY: 1
                }, s);
            }
            clearBounds() {
                this.points.forEach((t)=>{
                    delete t.bounds, delete t.insetIndex, delete t.projectedPath;
                }), delete this.bounds;
            }
            doFullTranslate() {
                return !!(this.isDirtyData || this.chart.isResizing || !this.hasRendered);
            }
            drawMapDataLabels() {
                super.drawDataLabels(), this.dataLabelsGroup && this.dataLabelsGroup.clip(this.chart.clipRect);
            }
            drawPoints() {
                let t = this, { chart: e, group: i, transformGroups: s = [] } = this, { mapView: o, renderer: r } = e;
                if (o) {
                    this.transformGroups = s, s[0] || (s[0] = r.g().add(i));
                    for(let t = 0, e = o.insets.length; t < e; ++t)s[t + 1] || s.push(r.g().add(i));
                    this.doFullTranslate() && (this.points.forEach((t)=>{
                        let { graphic: e } = t;
                        t.group = s["number" == typeof t.insetIndex ? t.insetIndex + 1 : 0], e && e.parentGroup !== t.group && e.add(t.group);
                    }), e$.prototype.drawPoints.apply(this), this.points.forEach((i)=>{
                        let s = i.graphic;
                        if (s) {
                            let o = s.animate, r = "";
                            i.name && (r += "highcharts-name-" + i.name.replace(/ /g, "-").toLowerCase()), i.properties?.["hc-key"] && (r += " highcharts-key-" + i.properties["hc-key"].toString().toLowerCase()), r && s.addClass(r), e.styledMode && s.css(this.pointAttribs(i, i.selected && "select" || void 0)), s.attr({
                                visibility: !i.visible && (i.visible || i.isNull) ? "hidden" : "inherit"
                            }), s.animate = function(i, r, a) {
                                let n = e8(i["stroke-width"]) && !e8(s["stroke-width"]), l = e8(s["stroke-width"]) && !e8(i["stroke-width"]);
                                if (n || l) {
                                    let o = e5(t.getStrokeWidth(t.options), 1) / (e.mapView?.getScale() || 1);
                                    n && (s["stroke-width"] = o), l && (i["stroke-width"] = o);
                                }
                                return o.call(s, i, r, l ? function() {
                                    s.element.removeAttribute("stroke-width"), delete s["stroke-width"], a && a.apply(this, arguments);
                                } : a);
                            };
                        }
                    })), s.forEach((i, s)=>{
                        let a = (0 === s ? o : o.insets[s - 1]).getSVGTransform(), n = e5(this.getStrokeWidth(this.options), 1), l = a.scaleX, h = a.scaleY > 0 ? 1 : -1, p = (e)=>{
                            (t.points || []).forEach((t)=>{
                                let i, s = t.graphic;
                                s?.["stroke-width"] && (i = this.getStrokeWidth(t.options)) && s.attr({
                                    "stroke-width": i / e
                                });
                            });
                        };
                        if (r.globalAnimation && e.hasRendered && o.allowTransformAnimation) {
                            let t = Number(i.attr("translateX")), e = Number(i.attr("translateY")), s = Number(i.attr("scaleX")), o = (o, r)=>{
                                let d = s + (l - s) * r.pos;
                                i.attr({
                                    translateX: t + (a.translateX - t) * r.pos,
                                    translateY: e + (a.translateY - e) * r.pos,
                                    scaleX: d,
                                    scaleY: d * h,
                                    "stroke-width": n / d
                                }), p(d);
                            }, d = e9(eZ(r.globalAnimation)), c = d.step;
                            d.step = function() {
                                c && c.apply(this, arguments), o.apply(this, arguments);
                            }, i.attr({
                                animator: 0
                            }).animate({
                                animator: 1
                            }, d, (function() {
                                "boolean" != typeof r.globalAnimation && r.globalAnimation.complete && r.globalAnimation.complete({
                                    applyDrilldown: !0
                                }), e1(this, "mapZoomComplete");
                            }).bind(this));
                        } else e_(i), i.attr(e9(a, {
                            "stroke-width": n / l
                        })), p(l);
                    }), this.isDrilling || this.drawMapDataLabels();
                }
            }
            getProjectedBounds() {
                if (!this.bounds && this.chart.mapView) {
                    let { insets: t, projection: e } = this.chart.mapView, i = [];
                    (this.points || []).forEach((s)=>{
                        if (s.path || s.geometry) {
                            if ("string" == typeof s.path ? s.path = eq(s.path) : e6(s.path) && "M" === s.path[0] && (s.path = this.chart.renderer.pathToSegments(s.path)), !s.bounds) {
                                let i = s.getProjectedBounds(e);
                                if (i) {
                                    s.labelrank = e5(s.labelrank, (i.x2 - i.x1) * (i.y2 - i.y1));
                                    let { midX: e, midY: o } = i;
                                    if (t && e8(e) && e8(o)) {
                                        let r = e0(t, (t)=>t.isInside({
                                                x: e,
                                                y: o
                                            }));
                                        r && (delete s.projectedPath, (i = s.getProjectedBounds(r.projection)) && r.allBounds.push(i), s.insetIndex = t.indexOf(r));
                                    }
                                    s.bounds = i;
                                }
                            }
                            s.bounds && void 0 === s.insetIndex && i.push(s.bounds);
                        }
                    }), this.bounds = eU.compositeBounds(i);
                }
                return this.bounds;
            }
            getStrokeWidth(t) {
                let e = this.pointAttrToOptions;
                return t[e?.["stroke-width"] || "borderWidth"];
            }
            hasData() {
                return !!this.dataTable.rowCount;
            }
            pointAttribs(t, e) {
                let { mapView: i, styledMode: s } = t.series.chart, o = s ? this.colorAttribs(t) : e$.prototype.pointAttribs.call(this, t, e), r = this.getStrokeWidth(t.options);
                if (e) {
                    let i = e9(this.options.states && this.options.states[e], t.options.states && t.options.states[e] || {}), s = this.getStrokeWidth(i);
                    e3(s) && (r = s), o.stroke = i.borderColor ?? t.color;
                }
                r && i && (r /= i.getScale());
                let a = this.getStrokeWidth(this.options);
                return o.dashstyle && i && e8(a) && (r = a / i.getScale()), t.visible || (o.fill = this.options.nullColor), e3(r) ? o["stroke-width"] = r : delete o["stroke-width"], o["stroke-linecap"] = o["stroke-linejoin"] = this.options.linecap, o;
            }
            updateData() {
                return !this.processedData && super.updateData.apply(this, arguments);
            }
            setData(t, e = !0, i, s) {
                delete this.bounds, super.setData(t, !1, void 0, s), this.processData(), this.generatePoints(), e && this.chart.redraw(i);
            }
            dataColumnKeys() {
                return this.pointArrayMap;
            }
            processData() {
                let t, e, i, s = this.options, o = s.data, r = this.chart, a = r.options.chart, n = this.joinBy, l = s.keys || this.pointArrayMap, h = [], p = {}, d = this.chart.mapView, c = d && (e7(s.mapData, !0) ? d.getGeoMap(s.mapData) : d.geoMap), u = r.mapTransforms = a.mapTransforms || c?.["hc-transform"] || r.mapTransforms;
                u && e4(u, (t)=>{
                    t.rotation && (t.cosAngle = Math.cos(t.rotation), t.sinAngle = Math.sin(t.rotation));
                }), e6(s.mapData) ? i = s.mapData : c && "FeatureCollection" === c.type && (this.mapTitle = c.title, i = L().geojson(c, this.type, this)), this.processedData = [];
                let m = this.processedData;
                if (o) {
                    let t;
                    for(let e = 0, i = o.length; e < i; ++e){
                        if (e8(t = o[e])) m[e] = {
                            value: t
                        };
                        else if (e6(t)) {
                            let i = 0;
                            m[e] = {}, !s.keys && t.length > l.length && "string" == typeof t[0] && (m[e]["hc-key"] = t[0], ++i);
                            for(let s = 0; s < l.length; ++s, ++i)l[s] && void 0 !== t[i] && (l[s].indexOf(".") > 0 ? t$.prototype.setNestedProperty(m[e], t[i], l[s]) : m[e][l[s]] = t[i]);
                        } else m[e] = o[e];
                        n && "_i" === n[0] && (m[e]._i = e);
                    }
                }
                if (i) {
                    this.mapData = i, this.mapMap = {};
                    for(let s = 0; s < i.length; s++)e = (t = i[s]).properties, t._i = s, n[0] && e && e[n[0]] && (t[n[0]] = e[n[0]]), p[t[n[0]]] = t;
                    if (this.mapMap = p, n[1]) {
                        let t = n[1];
                        m.forEach((e)=>{
                            let i = e2(t, e);
                            p[i] && h.push(p[i]);
                        });
                    }
                    if (s.allAreas) {
                        if (n[1]) {
                            let t = n[1];
                            m.forEach((e)=>{
                                h.push(e2(t, e));
                            });
                        }
                        let t = "|" + h.map(function(t) {
                            return t && t[n[0]];
                        }).join("|") + "|";
                        i.forEach((e)=>{
                            n[0] && -1 !== t.indexOf("|" + e[n[0]] + "|") || m.push(e9(e, {
                                value: null
                            }));
                        });
                    }
                }
                this.dataTable.rowCount = m.length;
            }
            setOptions(t) {
                let e = super.setOptions(t), i = e.joinBy;
                return null === e.joinBy && (i = "_i"), i && (this.joinBy = it(i), this.joinBy[1] || (this.joinBy[1] = this.joinBy[0])), e;
            }
            translate() {
                let t = this.doFullTranslate(), e = this.chart.mapView, i = e?.projection;
                if (this.chart.hasRendered && (this.isDirtyData || !this.hasRendered) && (this.processData(), this.generatePoints(), delete this.bounds, !e || e.userOptions.center || e8(e.userOptions.zoom) || e.zoom !== e.minZoom ? this.getProjectedBounds() : e.fitToBounds(void 0, void 0, !1)), e) {
                    let s = e.getSVGTransform();
                    this.points.forEach((o)=>{
                        let r = e8(o.insetIndex) && e.insets[o.insetIndex].getSVGTransform() || s;
                        r && o.bounds && e8(o.bounds.midX) && e8(o.bounds.midY) && (o.plotX = o.bounds.midX * r.scaleX + r.translateX, o.plotY = o.bounds.midY * r.scaleY + r.translateY), t && (o.shapeType = "path", o.shapeArgs = {
                            d: t$.getProjectedPath(o, i)
                        }), !o.hiddenInDataClass && (o.projectedPath && !o.projectedPath.length ? o.setVisible(!1) : o.visible || o.setVisible(!0));
                    });
                }
                e1(this, "afterTranslate");
            }
            update(t) {
                t.mapData && this.chart.mapView?.recommendMapView(this.chart, [
                    this.chart.options.chart.map,
                    ...(this.chart.options.series || []).map((e, i)=>i === this._i ? t.mapData : e.mapData)
                ], !0), super.update.apply(this, arguments);
            }
        }
        ie.defaultOptions = e9(eJ.defaultOptions, {
            affectsMapView: !0,
            animation: !1,
            dataLabels: {
                crop: !1,
                formatter: function() {
                    let { numberFormatter: t } = this.series.chart, { value: e } = this.point;
                    return tJ(e) ? t(e, -1) : this.point.name || "";
                },
                inside: !0,
                overflow: !1,
                padding: 0,
                verticalAlign: "middle"
            },
            linecap: "round",
            marker: null,
            nullColor: "#f7f7f7",
            stickyTracking: !1,
            tooltip: {
                followPointer: !0,
                pointFormat: "{point.name}: {point.value}<br/>"
            },
            turboThreshold: 0,
            allAreas: !0,
            borderColor: "#e6e6e6",
            borderWidth: 1,
            joinBy: "hc-key",
            states: {
                hover: {
                    halo: void 0,
                    borderColor: "#666666",
                    borderWidth: 2
                },
                normal: {
                    animation: !0
                },
                select: {
                    color: "#cccccc"
                }
            },
            legendSymbol: "rectangle"
        }), eQ(ie.prototype, {
            type: "map",
            axisTypes: tP.seriesMembers.axisTypes,
            colorAttribs: tP.seriesMembers.colorAttribs,
            colorKey: tP.seriesMembers.colorKey,
            directTouch: !0,
            drawDataLabels: eK,
            drawGraph: eK,
            forceDL: !0,
            getCenter: tE.getCenter,
            getExtremesFromAll: !0,
            getSymbol: eK,
            isCartesian: !1,
            parallelArrays: tP.seriesMembers.parallelArrays,
            pointArrayMap: tP.seriesMembers.pointArrayMap,
            pointClass: t$,
            preserveAspectRatio: !0,
            searchPoint: eK,
            trackerGroups: tP.seriesMembers.trackerGroups,
            useMapGeometry: !0
        }), tP.compose(ie), W().registerSeriesType("map", ie);
        let ii = ie, { extend: is, merge: io } = L();
        class ir extends ii {
            pointAttribs(t, e) {
                let i = super.pointAttribs(t, e);
                return i.fill = this.options.fillColor, i;
            }
        }
        ir.defaultOptions = io(ii.defaultOptions, {
            lineWidth: 1,
            fillColor: "none",
            legendSymbol: "lineMarker"
        }), is(ir.prototype, {
            type: "mapline",
            colorProp: "stroke",
            pointAttrToOptions: {
                stroke: "color",
                "stroke-width": "lineWidth"
            }
        }), W().registerSeriesType("mapline", ir);
        let { scatter: ia } = W().seriesTypes, { isNumber: il } = L();
        class ih extends ia.prototype.pointClass {
            isValid() {
                return !!(this.options.geometry || il(this.x) && il(this.y) || il(this.options.lon) && il(this.options.lat));
            }
        }
        w(632);
        let { noop: ip } = L(), { map: id, scatter: ic } = W().seriesTypes, { extend: iu, fireEvent: im, isNumber: ig, merge: ib } = L();
        class iy extends ic {
            constructor(){
                super(...arguments), this.clearBounds = id.prototype.clearBounds;
            }
            drawDataLabels() {
                super.drawDataLabels(), this.dataLabelsGroup && this.dataLabelsGroup.clip(this.chart.clipRect);
            }
            projectPoint(t) {
                let e = this.chart.mapView;
                if (e) {
                    let { geometry: i, lon: s, lat: o } = t, r = i && "Point" === i.type && i.coordinates;
                    if (ig(s) && ig(o) && (r = [
                        s,
                        o
                    ]), r) return e.lonLatToProjectedUnits({
                        lon: r[0],
                        lat: r[1]
                    });
                }
            }
            translate() {
                let t = this.chart.mapView;
                if (this.generatePoints(), this.getProjectedBounds && this.isDirtyData && (delete this.bounds, this.getProjectedBounds()), t) {
                    let e = t.getSVGTransform(), { hasCoordinates: i } = t.projection;
                    this.points.forEach((s)=>{
                        let o, { x: r, y: a } = s, n = ig(s.insetIndex) && t.insets[s.insetIndex].getSVGTransform() || e, l = this.projectPoint(s.options) || s.properties && this.projectPoint(s.properties);
                        if (l ? (r = l.x, a = l.y) : s.bounds && (r = s.bounds.midX, a = s.bounds.midY, n && ig(r) && ig(a) && (s.plotX = r * n.scaleX + n.translateX, s.plotY = a * n.scaleY + n.translateY, o = !0)), ig(r) && ig(a)) {
                            if (!o) {
                                let e = t.projectedUnitsToPixels({
                                    x: r,
                                    y: a
                                });
                                s.plotX = e.x, s.plotY = i ? e.y : this.chart.plotHeight - e.y;
                            }
                        } else s.y = s.plotX = s.plotY = void 0;
                        s.isInside = this.isPointInside(s), s.zone = this.zones.length ? s.getZone() : void 0;
                    });
                }
                im(this, "afterTranslate");
            }
        }
        iy.defaultOptions = ib(ic.defaultOptions, {
            dataLabels: {
                crop: !1,
                defer: !1,
                enabled: !0,
                formatter: function() {
                    return this.point.name;
                },
                overflow: !1,
                style: {
                    color: "#000000"
                }
            },
            legendSymbol: "lineMarker"
        }), tN().prototype.symbols.mapmarker = (t, e, i, s, o)=>{
            let r, a, n = o && "legend" === o.context;
            n ? (r = t + i / 2, a = e + s) : o && "number" == typeof o.anchorX && "number" == typeof o.anchorY ? (r = o.anchorX, a = o.anchorY) : (r = t + i / 2, a = e + s / 2, e -= s);
            let l = n ? s / 3 : s / 2;
            return [
                [
                    "M",
                    r,
                    a
                ],
                [
                    "C",
                    r,
                    a,
                    r - l,
                    e + 1.5 * l,
                    r - l,
                    e + l
                ],
                [
                    "A",
                    l,
                    l,
                    1,
                    1,
                    1,
                    r + l,
                    e + l
                ],
                [
                    "C",
                    r + l,
                    e + 1.5 * l,
                    r,
                    a,
                    r,
                    a
                ],
                [
                    "Z"
                ]
            ];
        }, iu(iy.prototype, {
            type: "mappoint",
            axisTypes: [
                "colorAxis"
            ],
            forceDL: !0,
            isCartesian: !1,
            pointClass: ih,
            searchPoint: ip,
            useMapGeometry: !0
        }), W().registerSeriesType("mappoint", iy);
        let ix = {
            borderColor: void 0,
            borderWidth: 2,
            className: void 0,
            color: void 0,
            connectorClassName: void 0,
            connectorColor: void 0,
            connectorDistance: 60,
            connectorWidth: 1,
            enabled: !1,
            labels: {
                className: void 0,
                allowOverlap: !1,
                format: "",
                formatter: void 0,
                align: "right",
                style: {
                    fontSize: "0.9em",
                    color: "#000000"
                },
                x: 0,
                y: 0
            },
            maxSize: 60,
            minSize: 10,
            legendIndex: 0,
            ranges: {
                value: void 0,
                borderColor: void 0,
                color: void 0,
                connectorColor: void 0
            },
            sizeBy: "area",
            sizeByAbsoluteValue: !1,
            zIndex: 1,
            zThreshold: 0
        }, { noop: iM } = L(), { arrayMax: iv, arrayMin: iw, isNumber: iC, merge: iT, pick: iL, stableSort: iP } = L(), iA = class {
            constructor(t, e){
                this.setState = iM, this.init(t, e);
            }
            init(t, e) {
                this.options = t, this.visible = !0, this.chart = e.chart, this.legend = e;
            }
            addToLegend(t) {
                t.splice(this.options.legendIndex, 0, this);
            }
            drawLegendSymbol(t) {
                let e, i = iL(t.options.itemDistance, 20), s = this.legendItem || {}, o = this.options, r = o.ranges, a = o.connectorDistance;
                if (!r || !r.length || !iC(r[0].value)) {
                    t.options.bubbleLegend.autoRanges = !0;
                    return;
                }
                iP(r, function(t, e) {
                    return e.value - t.value;
                }), this.ranges = r, this.setOptions(), this.render();
                let n = this.getMaxLabelSize(), l = this.ranges[0].radius, h = 2 * l;
                e = (e = a - l + n.width) > 0 ? e : 0, this.maxLabel = n, this.movementX = "left" === o.labels.align ? e : 0, s.labelWidth = h + e + i, s.labelHeight = h + n.height / 2;
            }
            setOptions() {
                let t = this.ranges, e = this.options, i = this.chart.series[e.seriesIndex], s = this.legend.baseline, o = {
                    zIndex: e.zIndex,
                    "stroke-width": e.borderWidth
                }, r = {
                    zIndex: e.zIndex,
                    "stroke-width": e.connectorWidth
                }, a = {
                    align: this.legend.options.rtl || "left" === e.labels.align ? "right" : "left",
                    zIndex: e.zIndex
                }, n = i.options.marker.fillOpacity, l = this.chart.styledMode;
                t.forEach(function(h, p) {
                    l || (o.stroke = iL(h.borderColor, e.borderColor, i.color), o.fill = h.color || e.color, o.fill || (o.fill = i.color, o["fill-opacity"] = n ?? 1), r.stroke = iL(h.connectorColor, e.connectorColor, i.color)), t[p].radius = this.getRangeRadius(h.value), t[p] = iT(t[p], {
                        center: t[0].radius - t[p].radius + s
                    }), l || iT(!0, t[p], {
                        bubbleAttribs: iT(o),
                        connectorAttribs: iT(r),
                        labelAttribs: a
                    });
                }, this);
            }
            getRangeRadius(t) {
                let e = this.options, i = this.options.seriesIndex, s = this.chart.series[i], o = e.ranges[0].value, r = e.ranges[e.ranges.length - 1].value, a = e.minSize, n = e.maxSize;
                return s.getRadius.call(this, r, o, a, n, t);
            }
            render() {
                let t = this.legendItem || {}, e = this.chart.renderer, i = this.options.zThreshold;
                for (let s of (this.symbols || (this.symbols = {
                    connectors: [],
                    bubbleItems: [],
                    labels: []
                }), t.symbol = e.g("bubble-legend"), t.label = e.g("bubble-legend-item").css(this.legend.itemStyle || {}), t.symbol.translateX = 0, t.symbol.translateY = 0, t.symbol.add(t.label), t.label.add(t.group), this.ranges))s.value >= i && this.renderRange(s);
                this.hideOverlappingLabels();
            }
            renderRange(t) {
                let e = this.ranges[0], i = this.legend, s = this.options, o = s.labels, r = this.chart, a = r.series[s.seriesIndex], n = r.renderer, l = this.symbols, h = l.labels, p = t.center, d = Math.abs(t.radius), c = s.connectorDistance || 0, u = o.align, m = i.options.rtl, g = s.borderWidth, f = s.connectorWidth, b = e.radius || 0, y = p - d - g / 2 + f / 2, x = (y % 1 ? 1 : .5) - (f % 2 ? 0 : .5), M = n.styledMode, v = m || "left" === u ? -c : c;
                "center" === u && (v = 0, s.connectorDistance = 0, t.labelAttribs.align = "center"), l.bubbleItems.push(n.circle(b, p + x, d).attr(M ? {} : t.bubbleAttribs).addClass((M ? "highcharts-color-" + a.colorIndex + " " : "") + "highcharts-bubble-legend-symbol " + (s.className || "")).add(this.legendItem.symbol)), l.connectors.push(n.path(n.crispLine([
                    [
                        "M",
                        b,
                        y
                    ],
                    [
                        "L",
                        b + v,
                        y
                    ]
                ], s.connectorWidth)).attr(M ? {} : t.connectorAttribs).addClass((M ? "highcharts-color-" + this.options.seriesIndex + " " : "") + "highcharts-bubble-legend-connectors " + (s.connectorClassName || "")).add(this.legendItem.symbol));
                let w = n.text(this.formatLabel(t)).attr(M ? {} : t.labelAttribs).css(M ? {} : o.style).addClass("highcharts-bubble-legend-labels " + (s.labels.className || "")).add(this.legendItem.symbol), C = {
                    x: b + v + s.labels.x,
                    y: y + s.labels.y + .4 * w.getBBox().height
                };
                w.attr(C), h.push(w), w.placed = !0, w.alignAttr = C;
            }
            getMaxLabelSize() {
                let t, e;
                return this.symbols.labels.forEach(function(i) {
                    e = i.getBBox(!0), t = t ? e.width > t.width ? e : t : e;
                }), t || {};
            }
            formatLabel(t) {
                let e = this.options, i = e.labels.formatter, s = e.labels.format, { numberFormatter: o } = this.chart;
                return s ? t1().format(s, t, this.chart) : i ? i.call(t) : o(t.value, 1);
            }
            hideOverlappingLabels() {
                let t = this.chart, e = this.options.labels.allowOverlap, i = this.symbols;
                !e && i && (t.hideOverlappingLabels(i.labels), i.labels.forEach(function(t, e) {
                    t.newOpacity ? t.newOpacity !== t.oldOpacity && i.connectors[e].show() : i.connectors[e].hide();
                }));
            }
            getRanges() {
                let t = this.legend.bubbleLegend, e = t.chart.series, i = t.options.ranges, s, o, r = Number.MAX_VALUE, a = -Number.MAX_VALUE;
                return e.forEach(function(t) {
                    t.isBubble && !t.ignoreSeries && (o = t.getColumn("z").filter(iC)).length && (r = iL(t.options.zMin, Math.min(r, Math.max(iw(o), !1 === t.options.displayNegative ? t.options.zThreshold : -Number.MAX_VALUE))), a = iL(t.options.zMax, Math.max(a, iv(o))));
                }), s = r === a ? [
                    {
                        value: a
                    }
                ] : [
                    {
                        value: r
                    },
                    {
                        value: (r + a) / 2
                    },
                    {
                        value: a,
                        autoRanges: !0
                    }
                ], i.length && i[0].radius && s.reverse(), s.forEach(function(t, e) {
                    i && i[e] && (s[e] = iT(i[e], t));
                }), s;
            }
            predictBubbleSizes() {
                let t = this.chart, e = t.legend.options, i = e.floating, s = "horizontal" === e.layout, o = s ? t.legend.lastLineHeight : 0, r = t.plotSizeX, a = t.plotSizeY, n = t.series[this.options.seriesIndex], l = n.getPxExtremes(), h = Math.ceil(l.minPxSize), p = Math.ceil(l.maxPxSize), d = Math.min(a, r), c, u = n.options.maxSize;
                return i || !/%$/.test(u) ? c = p : (c = (d + o) * (u = parseFloat(u)) / 100 / (u / 100 + 1), (s && a - c >= r || !s && r - c >= a) && (c = p)), [
                    h,
                    Math.ceil(c)
                ];
            }
            updateRanges(t, e) {
                let i = this.legend.options.bubbleLegend;
                i.minSize = t, i.maxSize = e, i.ranges = this.getRanges();
            }
            correctSizes() {
                let t = this.legend, e = this.chart.series[this.options.seriesIndex].getPxExtremes();
                Math.abs(Math.ceil(e.maxPxSize) - this.options.maxSize) > 1 && (this.updateRanges(this.options.minSize, e.maxPxSize), t.render());
            }
        }, { setOptions: ik } = L(), { composed: ij } = L(), { addEvent: iz, objectEach: iS, pushUnique: iI, wrap: iB } = L();
        function iE(t, e, i) {
            let s, o, r, a = this.legend, n = iD(this) >= 0;
            a && a.options.enabled && a.bubbleLegend && a.options.bubbleLegend.autoRanges && n ? (s = a.bubbleLegend.options, o = a.bubbleLegend.predictBubbleSizes(), a.bubbleLegend.updateRanges(o[0], o[1]), s.placed || (a.group.placed = !1, a.allItems.forEach((t)=>{
                (r = t.legendItem || {}).group && (r.group.translateY = void 0);
            })), a.render(), s.placed || (this.getMargins(), this.axes.forEach((t)=>{
                t.setScale(), t.updateNames(), iS(t.ticks, function(t) {
                    t.isNew = !0, t.isNewLabel = !0;
                });
            }), this.getMargins()), s.placed = !0, t.call(this, e, i), a.bubbleLegend.correctSizes(), iG(a, iV(a))) : (t.call(this, e, i), a && a.options.enabled && a.bubbleLegend && (a.render(), iG(a, iV(a))));
        }
        function iD(t) {
            let e = t.series, i = 0;
            for(; i < e.length;){
                if (e[i] && e[i].isBubble && e[i].visible && e[i].dataTable.rowCount) return i;
                i++;
            }
            return -1;
        }
        function iV(t) {
            let e = t.allItems, i = [], s = e.length, o, r, a, n = 0, l = 0;
            for(n = 0; n < s; n++)if (r = e[n].legendItem || {}, a = (e[n + 1] || {}).legendItem || {}, r.labelHeight && (e[n].itemHeight = r.labelHeight), e[n] === e[s - 1] || r.y !== a.y) {
                for(i.push({
                    height: 0
                }), o = i[i.length - 1]; l <= n; l++)e[l].itemHeight > o.height && (o.height = e[l].itemHeight);
                o.step = n;
            }
            return i;
        }
        function iO(t) {
            let e = this.bubbleLegend, i = this.options, s = i.bubbleLegend, o = iD(this.chart);
            e && e.ranges && e.ranges.length && (s.ranges.length && (s.autoRanges = !!s.ranges[0].autoRanges), this.destroyItem(e)), o >= 0 && i.enabled && s.enabled && (s.seriesIndex = o, this.bubbleLegend = new iA(s, this), this.bubbleLegend.addToLegend(t.allItems));
        }
        function iN(t) {
            let e;
            if (t.defaultPrevented) return !1;
            let i = t.legendItem, s = this.chart, o = i.visible;
            this && this.bubbleLegend && (i.visible = !o, i.ignoreSeries = o, e = iD(s) >= 0, this.bubbleLegend.visible !== e && (this.update({
                bubbleLegend: {
                    enabled: e
                }
            }), this.bubbleLegend.visible = e), i.visible = o);
        }
        function iG(t, e) {
            let i = t.allItems, s = t.options.rtl, o, r, a, n, l = 0;
            i.forEach((t, i)=>{
                (n = t.legendItem || {}).group && (o = n.group.translateX || 0, r = n.y || 0, ((a = t.movementX) || s && t.ranges) && (a = s ? o - t.options.maxSize / 2 : o + a, n.group.attr({
                    translateX: a
                })), i > e[l].step && l++, n.group.attr({
                    translateY: Math.round(r + e[l].height / 2)
                }), n.y = r + e[l].height / 2);
            });
        }
        let iX = {
            compose: function(t, e) {
                iI(ij, "Series.BubbleLegend") && (ik({
                    legend: {
                        bubbleLegend: ix
                    }
                }), iB(t.prototype, "drawChartBox", iE), iz(e, "afterGetAllItems", iO), iz(e, "itemClick", iN));
            }
        };
        var iR = w(260), iH = w.n(iR);
        let { seriesTypes: { scatter: { prototype: { pointClass: iW } } } } = W(), { extend: iY } = L();
        class iU extends iW {
            haloPath(t) {
                let e = (t && this.marker && this.marker.radius || 0) + t;
                if (this.series.chart.inverted) {
                    let t = this.pos() || [
                        0,
                        0
                    ], { xAxis: i, yAxis: s, chart: o } = this.series, r = 2 * e;
                    return o.renderer.symbols.circle((i?.len || 0) - t[1] - e, (s?.len || 0) - t[0] - e, r, r);
                }
                return iH().prototype.haloPath.call(this, e);
            }
        }
        iY(iU.prototype, {
            ttBelow: !1
        });
        let iF = iU, { composed: iZ, noop: i_ } = L(), { series: iK, seriesTypes: { column: { prototype: iq }, scatter: i$ } } = W(), { addEvent: iJ, arrayMax: iQ, arrayMin: i0, clamp: i1, extend: i2, isNumber: i6, merge: i3, pick: i8, pushUnique: i7 } = L();
        function i9() {
            let t = this.len, { coll: e, isXAxis: i, min: s } = this, o = (this.max || 0) - (s || 0), r = 0, a = t, n = t / o, l;
            ("xAxis" === e || "yAxis" === e) && (this.series.forEach((t)=>{
                if (t.bubblePadding && t.reserveSpace()) {
                    this.allowZoomOutside = !0, l = !0;
                    let e = t.getColumn(i ? "x" : "y");
                    if (i && ((t.onPoint || t).getRadii(0, 0, t), t.onPoint && (t.radii = t.onPoint.radii)), o > 0) {
                        let i = e.length;
                        for(; i--;)if (i6(e[i]) && this.dataMin <= e[i] && e[i] <= this.max) {
                            let o = t.radii && t.radii[i] || 0;
                            r = Math.min((e[i] - s) * n - o, r), a = Math.max((e[i] - s) * n + o, a);
                        }
                    }
                }
            }), l && o > 0 && !this.logarithmic && (a -= t, n *= (t + Math.max(0, r) - Math.min(a, t)) / t, [
                [
                    "min",
                    "userMin",
                    r
                ],
                [
                    "max",
                    "userMax",
                    a
                ]
            ].forEach((t)=>{
                void 0 === i8(this.options[t[0]], this[t[1]]) && (this[t[0]] += t[2] / n);
            })));
        }
        function i4() {
            let { ticks: t, tickPositions: e, dataMin: i = 0, dataMax: s = 0, categories: o } = this, r = this.options.type;
            if ((o?.length || "category" === r) && this.series.find((t)=>t.bubblePadding)) {
                let o = e.length;
                for(; o--;){
                    let r = t[e[o]], a = r.pos || 0;
                    (a > s || a < i) && r.label?.hide();
                }
            }
        }
        class i5 extends i$ {
            static compose(t, e, i) {
                iX.compose(e, i), i7(iZ, "Series.Bubble") && (iJ(t, "foundExtremes", i9), iJ(t, "afterRender", i4));
            }
            animate(t) {
                !t && this.points.length < this.options.animationLimit && this.points.forEach(function(t) {
                    let { graphic: e, plotX: i = 0, plotY: s = 0 } = t;
                    e && e.width && (this.hasRendered || e.attr({
                        x: i,
                        y: s,
                        width: 1,
                        height: 1
                    }), e.animate(this.markerAttribs(t), this.options.animation));
                }, this);
            }
            getRadii() {
                let t = this.getColumn("z"), e = this.getColumn("y"), i = [], s, o, r, a = this.chart.bubbleZExtremes, { minPxSize: n, maxPxSize: l } = this.getPxExtremes();
                if (!a) {
                    let t, e = Number.MAX_VALUE, i = -Number.MAX_VALUE;
                    this.chart.series.forEach((s)=>{
                        if (s.bubblePadding && s.reserveSpace()) {
                            let o = (s.onPoint || s).getZExtremes();
                            o && (e = Math.min(i8(e, o.zMin), o.zMin), i = Math.max(i8(i, o.zMax), o.zMax), t = !0);
                        }
                    }), t ? (a = {
                        zMin: e,
                        zMax: i
                    }, this.chart.bubbleZExtremes = a) : a = {
                        zMin: 0,
                        zMax: 0
                    };
                }
                for(o = 0, s = t.length; o < s; o++)r = t[o], i.push(this.getRadius(a.zMin, a.zMax, n, l, r, e && e[o]));
                this.radii = i;
            }
            getRadius(t, e, i, s, o, r) {
                let a = this.options, n = "width" !== a.sizeBy, l = a.zThreshold, h = e - t, p = .5;
                if (null === r || null === o) return null;
                if (i6(o)) {
                    if (a.sizeByAbsoluteValue && (o = Math.abs(o - l), e = h = Math.max(e - l, Math.abs(t - l)), t = 0), o < t) return i / 2 - 1;
                    h > 0 && (p = (o - t) / h);
                }
                return n && p >= 0 && (p = Math.sqrt(p)), Math.ceil(i + p * (s - i)) / 2;
            }
            hasData() {
                return !!this.dataTable.rowCount;
            }
            markerAttribs(t, e) {
                let i = super.markerAttribs(t, e), { height: s = 0, width: o = 0 } = i;
                return this.chart.inverted ? i2(i, {
                    x: (t.plotX || 0) - o / 2,
                    y: (t.plotY || 0) - s / 2
                }) : i;
            }
            pointAttribs(t, e) {
                let i = this.options.marker, s = i?.fillOpacity, o = iK.prototype.pointAttribs.call(this, t, e);
                return o["fill-opacity"] = s ?? 1, o;
            }
            translate() {
                super.translate.call(this), this.getRadii(), this.translateBubble();
            }
            translateBubble() {
                let { data: t, options: e, radii: i } = this, { minPxSize: s } = this.getPxExtremes(), o = t.length;
                for(; o--;){
                    let r = t[o], a = i ? i[o] : 0;
                    "z" === this.zoneAxis && (r.negative = (r.z || 0) < (e.zThreshold || 0)), i6(a) && a >= s / 2 ? (r.marker = i2(r.marker, {
                        radius: a,
                        width: 2 * a,
                        height: 2 * a
                    }), r.dlBox = {
                        x: r.plotX - a,
                        y: r.plotY - a,
                        width: 2 * a,
                        height: 2 * a
                    }) : (r.shapeArgs = r.plotY = r.dlBox = void 0, r.isInside = !1);
                }
            }
            getPxExtremes() {
                let t = Math.min(this.chart.plotWidth, this.chart.plotHeight), e = (e)=>{
                    let i;
                    return "string" == typeof e && (i = /%$/.test(e), e = parseInt(e, 10)), i ? t * e / 100 : e;
                }, i = e(i8(this.options.minSize, 8)), s = Math.max(e(i8(this.options.maxSize, "20%")), i);
                return {
                    minPxSize: i,
                    maxPxSize: s
                };
            }
            getZExtremes() {
                let t = this.options, e = this.getColumn("z").filter(i6);
                if (e.length) {
                    let i = i8(t.zMin, i1(i0(e), !1 === t.displayNegative ? t.zThreshold || 0 : -Number.MAX_VALUE, Number.MAX_VALUE)), s = i8(t.zMax, iQ(e));
                    if (i6(i) && i6(s)) return {
                        zMin: i,
                        zMax: s
                    };
                }
            }
            searchKDTree(t, e, i, s = i_, o = i_) {
                return s = (t, e, i)=>{
                    let s = t[i] || 0, o = e[i] || 0, r, a = !1;
                    return s === o ? r = t.index > e.index ? t : e : s < 0 && o < 0 ? (r = s - (t.marker?.radius || 0) >= o - (e.marker?.radius || 0) ? t : e, a = !0) : r = s < o ? t : e, [
                        r,
                        a
                    ];
                }, o = (t, e, i)=>!i && t > e || t < e, super.searchKDTree(t, e, i, s, o);
            }
        }
        i5.defaultOptions = i3(i$.defaultOptions, {
            dataLabels: {
                formatter: function() {
                    let { numberFormatter: t } = this.series.chart, { z: e } = this.point;
                    return i6(e) ? t(e, -1) : "";
                },
                inside: !0,
                verticalAlign: "middle"
            },
            animationLimit: 250,
            marker: {
                lineColor: null,
                lineWidth: 1,
                fillOpacity: .5,
                radius: null,
                states: {
                    hover: {
                        radiusPlus: 0
                    }
                },
                symbol: "circle"
            },
            minSize: 8,
            maxSize: "20%",
            softThreshold: !1,
            states: {
                hover: {
                    halo: {
                        size: 5
                    }
                }
            },
            tooltip: {
                pointFormat: "({point.x}, {point.y}), Size: {point.z}"
            },
            turboThreshold: 0,
            zThreshold: 0,
            zoneAxis: "z"
        }), i2(i5.prototype, {
            alignDataLabel: iq.alignDataLabel,
            applyZones: i_,
            bubblePadding: !0,
            isBubble: !0,
            keysAffectYAxis: [
                "y"
            ],
            pointArrayMap: [
                "y",
                "z"
            ],
            pointClass: iF,
            parallelArrays: [
                "x",
                "y",
                "z"
            ],
            trackerGroups: [
                "group",
                "dataLabelsGroup"
            ],
            specialGroup: "group",
            zoneAxis: "z"
        }), iJ(i5, "updatedData", (t)=>{
            delete t.target.chart.bubbleZExtremes;
        }), iJ(i5, "remove", (t)=>{
            delete t.target.chart.bubbleZExtremes;
        }), W().registerSeriesType("bubble", i5);
        let st = i5, { seriesTypes: { map: { prototype: { pointClass: { prototype: se } } } } } = W(), { extend: si } = L();
        class ss extends iF {
            isValid() {
                return "number" == typeof this.z;
            }
        }
        si(ss.prototype, {
            applyOptions: se.applyOptions,
            getProjectedBounds: se.getProjectedBounds
        });
        let { seriesTypes: { map: { prototype: so }, mappoint: { prototype: sr } } } = W(), { extend: sa, merge: sn } = L();
        class sl extends st {
            constructor(){
                super(...arguments), this.clearBounds = so.clearBounds;
            }
            searchPoint(t, e) {
                return this.searchKDTree({
                    plotX: t.chartX - this.chart.plotLeft,
                    plotY: t.chartY - this.chart.plotTop
                }, e, t);
            }
            translate() {
                sr.translate.call(this), this.getRadii(), this.translateBubble();
            }
        }
        sl.defaultOptions = sn(st.defaultOptions, {
            lineWidth: 0,
            animationLimit: 500,
            joinBy: "hc-key",
            tooltip: {
                pointFormat: "{point.name}: {point.z}"
            }
        }), sa(sl.prototype, {
            type: "mapbubble",
            axisTypes: [
                "colorAxis"
            ],
            getProjectedBounds: so.getProjectedBounds,
            isCartesian: !1,
            pointArrayMap: [
                "z"
            ],
            pointClass: ss,
            processData: so.processData,
            projectPoint: sr.projectPoint,
            kdAxisArray: [
                "plotX",
                "plotY"
            ],
            setData: so.setData,
            setOptions: so.setOptions,
            updateData: so.updateData,
            useMapGeometry: !0,
            xyFromShape: !0
        }), W().registerSeriesType("mapbubble", sl);
        let { scatter: { prototype: { pointClass: sh } } } = W().seriesTypes, { clamp: sp, defined: sd, extend: sc, pick: su } = L();
        class sm extends sh {
            applyOptions(t, e) {
                return (this.isNull || null === this.value) && delete this.color, super.applyOptions(t, e), this.formatPrefix = this.isNull || null === this.value ? "null" : "point", this;
            }
            getCellAttributes() {
                let t = this.series, e = t.options, i = (e.colsize || 1) / 2, s = (e.rowsize || 1) / 2, o = t.xAxis, r = t.yAxis, a = this.options.marker || t.options.marker, n = t.pointPlacementToXValue(), l = su(this.pointPadding, e.pointPadding, 0), h = {
                    x1: sp(Math.round(o.len - o.translate(this.x - i, !1, !0, !1, !0, -n)), -o.len, 2 * o.len),
                    x2: sp(Math.round(o.len - o.translate(this.x + i, !1, !0, !1, !0, -n)), -o.len, 2 * o.len),
                    y1: sp(Math.round(r.translate(this.y - s, !1, !0, !1, !0)), -r.len, 2 * r.len),
                    y2: sp(Math.round(r.translate(this.y + s, !1, !0, !1, !0)), -r.len, 2 * r.len)
                };
                for (let t of [
                    [
                        "width",
                        "x"
                    ],
                    [
                        "height",
                        "y"
                    ]
                ]){
                    let e = t[0], i = t[1], s = i + "1", n = i + "2", p = Math.abs(h[s] - h[n]), d = a && a.lineWidth || 0, c = Math.abs(h[s] + h[n]) / 2, u = a && a[e];
                    if (sd(u) && u < p) {
                        let t = u / 2 + d / 2;
                        h[s] = c - t, h[n] = c + t;
                    }
                    l && (("x" === i && o.reversed || "y" === i && !r.reversed) && (s = n, n = i + "1"), h[s] += l, h[n] -= l);
                }
                return h;
            }
            haloPath(t) {
                if (!t) return [];
                let { x: e = 0, y: i = 0, width: s = 0, height: o = 0 } = this.shapeArgs || {};
                return [
                    [
                        "M",
                        e - t,
                        i - t
                    ],
                    [
                        "L",
                        e - t,
                        i + o + t
                    ],
                    [
                        "L",
                        e + s + t,
                        i + o + t
                    ],
                    [
                        "L",
                        e + s + t,
                        i - t
                    ],
                    [
                        "Z"
                    ]
                ];
            }
            isValid() {
                return this.value !== 1 / 0 && this.value !== -1 / 0;
            }
        }
        sc(sm.prototype, {
            dataLabelOnNull: !0,
            moveToTopOnHover: !0,
            ttBelow: !1
        });
        let { isNumber: sg } = L(), { doc: sf } = L(), { defined: sb, pick: sy } = L(), { series: sx, seriesTypes: { column: sM, scatter: sv } } = W(), { prototype: { symbols: sw } } = tN(), { addEvent: sC, extend: sT, fireEvent: sL, isNumber: sP, merge: sA, pick: sk } = L(), { colorFromPoint: sj, getContext: sz } = {
            colorFromPoint: function(t, e) {
                let i = e.series.colorAxis;
                if (i) {
                    let s = i.toColor(t || 0, e).split(")")[0].split("(")[1].split(",").map((t)=>sy(parseFloat(t), parseInt(t, 10)));
                    return s[3] = 255 * sy(s[3], 1), sb(t) && e.visible || (s[3] = 0), s;
                }
                return [
                    0,
                    0,
                    0,
                    0
                ];
            },
            getContext: function(t) {
                let { canvas: e, context: i } = t;
                return e && i ? (i.clearRect(0, 0, e.width, e.height), i) : (t.canvas = sf.createElement("canvas"), t.context = t.canvas.getContext("2d", {
                    willReadFrequently: !0
                }) || void 0, t.context);
            }
        };
        class sS extends sv {
            constructor(){
                super(...arguments), this.valueMax = NaN, this.valueMin = NaN, this.isDirtyCanvas = !0;
            }
            drawPoints() {
                let t = this, e = t.options, i = e.interpolation, s = e.marker || {};
                if (i) {
                    let { image: e, chart: i, xAxis: s, yAxis: o } = t, { reversed: r = !1, len: a } = s, { reversed: n = !1, len: l } = o, h = {
                        width: a,
                        height: l
                    };
                    if (!e || t.isDirtyData || t.isDirtyCanvas) {
                        let a = sz(t), { canvas: l, options: { colsize: p = 1, rowsize: d = 1 }, points: c, points: { length: u } } = t, m = i.colorAxis && i.colorAxis[0];
                        if (l && a && m) {
                            let { min: m, max: g } = s.getExtremes(), { min: f, max: b } = o.getExtremes(), y = g - m, x = b - f, M = Math.round(y / p / 8 * 8), v = Math.round(x / d / 8 * 8), [w, C] = [
                                [
                                    M,
                                    M / y,
                                    r,
                                    "ceil"
                                ],
                                [
                                    v,
                                    v / x,
                                    !n,
                                    "floor"
                                ]
                            ].map(([t, e, i, s])=>i ? (i)=>Math[s](t - e * i) : (t)=>Math[s](e * t)), T = l.width = M + 1, L = T * (l.height = v + 1), P = (u - 1) / L, A = new Uint8ClampedArray(4 * L), k = (t, e)=>4 * Math.ceil(T * C(e - f) + w(t - m));
                            t.buildKDTree();
                            for(let t = 0; t < L; t++){
                                let e = c[Math.ceil(P * t)], { x: i, y: s } = e;
                                A.set(sj(e.value, e), k(i, s));
                            }
                            a.putImageData(new ImageData(A, T), 0, 0), e ? e.attr({
                                ...h,
                                href: l.toDataURL("image/png", 1)
                            }) : (t.directTouch = !1, t.image = i.renderer.image(l.toDataURL("image/png", 1)).attr(h).add(t.group));
                        }
                        t.isDirtyCanvas = !1;
                    } else (e.width !== a || e.height !== l) && e.attr(h);
                } else (s.enabled || t._hasPointMarkers) && (sx.prototype.drawPoints.call(t), t.points.forEach((e)=>{
                    e.graphic && (e.graphic[t.chart.styledMode ? "css" : "animate"](t.colorAttribs(e)), null === e.value && e.graphic.addClass("highcharts-null-point"));
                }));
            }
            getExtremes() {
                let { dataMin: t, dataMax: e } = sx.prototype.getExtremes.call(this, this.getColumn("value"));
                return sP(t) && (this.valueMin = t), sP(e) && (this.valueMax = e), sx.prototype.getExtremes.call(this);
            }
            getValidPoints(t, e) {
                return sx.prototype.getValidPoints.call(this, t, e, !0);
            }
            hasData() {
                return !!this.dataTable.rowCount;
            }
            init() {
                super.init.apply(this, arguments);
                let t = this.options;
                t.pointRange = sk(t.pointRange, t.colsize || 1), this.yAxis.axisPointRange = t.rowsize || 1, sw.ellipse = sw.circle, t.marker && sP(t.borderRadius) && (t.marker.r = t.borderRadius);
            }
            markerAttribs(t, e) {
                let i = t.shapeArgs || {};
                if (t.hasImage) return {
                    x: t.plotX,
                    y: t.plotY
                };
                if (e && "normal" !== e) {
                    let s = t.options.marker || {}, o = this.options.marker || {}, r = o.states?.[e] || {}, a = s.states?.[e] || {}, n = (a.width || r.width || i.width || 0) + (a.widthPlus || r.widthPlus || 0), l = (a.height || r.height || i.height || 0) + (a.heightPlus || r.heightPlus || 0);
                    return {
                        x: (i.x || 0) + ((i.width || 0) - n) / 2,
                        y: (i.y || 0) + ((i.height || 0) - l) / 2,
                        width: n,
                        height: l
                    };
                }
                return i;
            }
            pointAttribs(t, e) {
                let i = sx.prototype.pointAttribs.call(this, t, e), s = this.options || {}, o = this.chart.options.plotOptions || {}, r = o.series || {}, a = o.heatmap || {}, n = t?.options.borderColor || s.borderColor || a.borderColor || r.borderColor, l = t?.options.borderWidth || s.borderWidth || a.borderWidth || r.borderWidth || i["stroke-width"];
                if (i.stroke = t?.marker?.lineColor || s.marker?.lineColor || n || this.color, i["stroke-width"] = l, e && "normal" !== e) {
                    let o = sA(s.states?.[e], s.marker?.states?.[e], t?.options.states?.[e] || {});
                    i.fill = o.color || j().parse(i.fill).brighten(o.brightness || 0).get(), i.stroke = o.lineColor || i.stroke;
                }
                return i;
            }
            translate() {
                let { borderRadius: t, marker: e } = this.options, i = e?.symbol || "rect", s = sw[i] ? i : "rect", o = -1 !== [
                    "circle",
                    "square"
                ].indexOf(s);
                for (let e of (this.generatePoints(), this.points)){
                    let r = e.getCellAttributes(), a = Math.min(r.x1, r.x2), n = Math.min(r.y1, r.y2), l = Math.max(Math.abs(r.x2 - r.x1), 0), h = Math.max(Math.abs(r.y2 - r.y1), 0);
                    if (e.hasImage = 0 === (e.marker?.symbol || i || "").indexOf("url"), o) {
                        let t = Math.abs(l - h);
                        a = Math.min(r.x1, r.x2) + (l < h ? 0 : t / 2), n = Math.min(r.y1, r.y2) + (l < h ? t / 2 : 0), l = h = Math.min(l, h);
                    }
                    e.hasImage && (e.marker = {
                        width: l,
                        height: h
                    }), e.plotX = e.clientX = (r.x1 + r.x2) / 2, e.plotY = (r.y1 + r.y2) / 2, e.shapeType = "path", e.shapeArgs = sA(!0, {
                        x: a,
                        y: n,
                        width: l,
                        height: h
                    }, {
                        d: sw[s](a, n, l, h, {
                            r: sP(t) ? t : 0
                        })
                    });
                }
                sL(this, "afterTranslate");
            }
        }
        sS.defaultOptions = sA(sv.defaultOptions, {
            animation: !1,
            borderRadius: 0,
            borderWidth: 0,
            interpolation: !1,
            nullColor: "#f7f7f7",
            dataLabels: {
                formatter: function() {
                    let { numberFormatter: t } = this.series.chart, { value: e } = this.point;
                    return sg(e) ? t(e, -1) : "";
                },
                inside: !0,
                verticalAlign: "middle",
                crop: !1,
                overflow: "allow",
                padding: 0
            },
            marker: {
                symbol: "rect",
                radius: 0,
                lineColor: void 0,
                states: {
                    hover: {
                        lineWidthPlus: 0
                    },
                    select: {}
                }
            },
            clip: !0,
            pointRange: null,
            tooltip: {
                pointFormat: "{point.x}, {point.y}: {point.value}<br/>"
            },
            states: {
                hover: {
                    halo: !1,
                    brightness: .2
                }
            },
            legendSymbol: "rectangle"
        }), sC(sS, "afterDataClassLegendClick", function() {
            this.isDirtyCanvas = !0, this.drawPoints();
        }), sT(sS.prototype, {
            axisTypes: tP.seriesMembers.axisTypes,
            colorKey: tP.seriesMembers.colorKey,
            directTouch: !0,
            getExtremesFromAll: !0,
            keysAffectYAxis: [
                "y"
            ],
            parallelArrays: tP.seriesMembers.parallelArrays,
            pointArrayMap: [
                "y",
                "value"
            ],
            pointClass: sm,
            specialGroup: "group",
            trackerGroups: tP.seriesMembers.trackerGroups,
            alignDataLabel: sM.prototype.alignDataLabel,
            colorAttribs: tP.seriesMembers.colorAttribs,
            getSymbol: sx.prototype.getSymbol
        }), tP.compose(sS), W().registerSeriesType("heatmap", sS);
        let sI = L();
        sI.ColorMapComposition = tP, sI.MapChart = sI.MapChart || tY, sI.MapNavigation = sI.MapNavigation || tM, sI.MapView = sI.MapView || eU, sI.Projection = sI.Projection || eL, sI.mapChart = sI.Map = sI.MapChart.mapChart, sI.maps = sI.MapChart.maps, sI.geojson = t4.geojson, sI.topo2geo = t4.topo2geo, t4.compose(sI.Chart), sl.compose(sI.Axis, sI.Chart, sI.Legend), tM.compose(tY, sI.Pointer, sI.SVGRenderer), eU.compose(tY);
        let sB = L();
        return C.default;
    })());

});

parcelRegister("7oF7a", function(module, exports) {
!/**
 * Highcharts JS v12.4.0 (2025-09-04)
 * @module highcharts/modules/series-on-point
 * @requires highcharts
 *
 * Series on point module
 *
 * (c) 2010-2025 Highsoft AS
 * Author: Rafal Sebestjanski and Piotr Madej
 *
 * License: www.highcharts.com/license
 */ function(t, e) {
    module.exports = e(t._Highcharts, t._Highcharts.Point, t._Highcharts.SeriesRegistry, t._Highcharts.SVGRenderer);
}("undefined" == typeof window ? module.exports : window, (t, e, s, o)=>(()=>{
        "use strict";
        var i, r, n = {
            260: (t)=>{
                t.exports = e;
            },
            512: (t)=>{
                t.exports = s;
            },
            540: (t)=>{
                t.exports = o;
            },
            944: (e)=>{
                e.exports = t;
            }
        }, h = {};
        function a(t) {
            var e = h[t];
            if (void 0 !== e) return e.exports;
            var s = h[t] = {
                exports: {}
            };
            return n[t](s, s.exports, a), s.exports;
        }
        a.n = (t)=>{
            var e = t && t.__esModule ? ()=>t.default : ()=>t;
            return a.d(e, {
                a: e
            }), e;
        }, a.d = (t, e)=>{
            for(var s in e)a.o(e, s) && !a.o(t, s) && Object.defineProperty(t, s, {
                enumerable: !0,
                get: e[s]
            });
        }, a.o = (t, e)=>Object.prototype.hasOwnProperty.call(t, e);
        var l = {};
        a.d(l, {
            default: ()=>T
        });
        var c = a(944), u = a.n(c);
        !function(t) {
            t.setLength = function(t, e, s) {
                return Array.isArray(t) ? (t.length = e, t) : t[s ? "subarray" : "slice"](0, e);
            }, t.splice = function(t, e, s, o, i = []) {
                if (Array.isArray(t)) return Array.isArray(i) || (i = Array.from(i)), {
                    removed: t.splice(e, s, ...i),
                    array: t
                };
                let r = Object.getPrototypeOf(t).constructor, n = t[o ? "subarray" : "slice"](e, e + s), h = new r(t.length - s + i.length);
                return h.set(t.subarray(0, e), 0), h.set(i, e), h.set(t.subarray(e + s), e + i.length), {
                    removed: n,
                    array: h
                };
            };
        }(i || (i = {}));
        let { setLength: p, splice: d } = i, { fireEvent: f, objectEach: g, uniqueKey: y } = u(), m = class {
            constructor(t = {}){
                this.autoId = !t.id, this.columns = {}, this.id = t.id || y(), this.modified = this, this.rowCount = 0, this.versionTag = y();
                let e = 0;
                g(t.columns || {}, (t, s)=>{
                    this.columns[s] = t.slice(), e = Math.max(e, t.length);
                }), this.applyRowCount(e);
            }
            applyRowCount(t) {
                this.rowCount = t, g(this.columns, (e, s)=>{
                    e.length !== t && (this.columns[s] = p(e, t));
                });
            }
            deleteRows(t, e = 1) {
                if (e > 0 && t < this.rowCount) {
                    let s = 0;
                    g(this.columns, (o, i)=>{
                        this.columns[i] = d(o, t, e).array, s = o.length;
                    }), this.rowCount = s;
                }
                f(this, "afterDeleteRows", {
                    rowIndex: t,
                    rowCount: e
                }), this.versionTag = y();
            }
            getColumn(t, e) {
                return this.columns[t];
            }
            getColumns(t, e) {
                return (t || Object.keys(this.columns)).reduce((t, e)=>(t[e] = this.columns[e], t), {});
            }
            getRow(t, e) {
                return (e || Object.keys(this.columns)).map((e)=>this.columns[e]?.[t]);
            }
            setColumn(t, e = [], s = 0, o) {
                this.setColumns({
                    [t]: e
                }, s, o);
            }
            setColumns(t, e, s) {
                let o = this.rowCount;
                g(t, (t, e)=>{
                    this.columns[e] = t.slice(), o = t.length;
                }), this.applyRowCount(o), s?.silent || (f(this, "afterSetColumns"), this.versionTag = y());
            }
            setRow(t, e = this.rowCount, s, o) {
                let { columns: i } = this, r = s ? this.rowCount + 1 : e + 1;
                g(t, (t, n)=>{
                    let h = i[n] || o?.addColumns !== !1 && Array(r);
                    h && (s ? h = d(h, e, 0, !0, [
                        t
                    ]).array : h[e] = t, i[n] = h);
                }), r > this.rowCount && this.applyRowCount(r), o?.silent || (f(this, "afterSetRows"), this.versionTag = y());
            }
        };
        var w = a(260), C = a.n(w), b = a(512), x = a.n(b), P = a(540), R = a.n(P);
        let { composed: v } = u(), { bubble: S } = x().seriesTypes, { addEvent: H, defined: A, find: O, isNumber: _, pushUnique: G } = u();
        !function(t) {
            t.compose = function(t, s) {
                if (G(v, "SeriesOnPoint")) {
                    let { chartGetZData: o, seriesAfterInit: i, seriesAfterRender: r, seriesGetCenter: n, seriesShowOrHide: h, seriesTranslate: a } = e.prototype;
                    t.types.pie.prototype.onPointSupported = !0, H(t, "afterInit", i), H(t, "afterRender", r), H(t, "afterGetCenter", n), H(t, "hide", h), H(t, "show", h), H(t, "translate", a), H(s, "beforeRender", o), H(s, "beforeRedraw", o);
                }
                return t;
            };
            class e {
                constructor(t){
                    this.getColumn = S.prototype.getColumn, this.getRadii = S.prototype.getRadii, this.getRadius = S.prototype.getRadius, this.getPxExtremes = S.prototype.getPxExtremes, this.getZExtremes = S.prototype.getZExtremes, this.chart = t.chart, this.series = t, this.options = t.options.onPoint;
                }
                drawConnector() {
                    this.connector || (this.connector = this.series.chart.renderer.path().addClass("highcharts-connector-seriesonpoint").attr({
                        zIndex: -1
                    }).add(this.series.markerGroup));
                    let t = this.getConnectorAttributes();
                    t && this.connector.animate(t);
                }
                getConnectorAttributes() {
                    let t = this.series.chart, e = this.options;
                    if (!e) return;
                    let s = e.connectorOptions || {}, o = e.position, i = t.get(e.id);
                    if (!(i instanceof C()) || !o || !A(i.plotX) || !A(i.plotY)) return;
                    let r = A(o.x) ? o.x : i.plotX, n = A(o.y) ? o.y : i.plotY, h = r + (o.offsetX || 0), a = n + (o.offsetY || 0), l = s.width || 1, c = s.stroke || this.series.color, u = s.dashstyle, p = {
                        d: R().prototype.crispLine([
                            [
                                "M",
                                r,
                                n
                            ],
                            [
                                "L",
                                h,
                                a
                            ]
                        ], l),
                        "stroke-width": l
                    };
                    return t.styledMode || (p.stroke = c, p.dashstyle = u), p;
                }
                seriesAfterInit() {
                    this.onPointSupported && this.options.onPoint && (this.bubblePadding = !0, this.useMapGeometry = !0, this.onPoint = new e(this));
                }
                seriesAfterRender() {
                    delete this.chart.bubbleZExtremes, this.onPoint && this.onPoint.drawConnector();
                }
                seriesGetCenter(t) {
                    let e = this.options.onPoint, s = t.positions;
                    if (e) {
                        let t = this.chart.get(e.id);
                        t instanceof C() && A(t.plotX) && A(t.plotY) && (s[0] = t.plotX, s[1] = t.plotY);
                        let o = e.position;
                        o && (A(o.x) && (s[0] = o.x), A(o.y) && (s[1] = o.y), o.offsetX && (s[0] += o.offsetX), o.offsetY && (s[1] += o.offsetY));
                    }
                    let o = this.radii && this.radii[this.index];
                    _(o) && (s[2] = 2 * o), t.positions = s;
                }
                seriesShowOrHide() {
                    let t = this.chart.series;
                    this.points?.forEach((e)=>{
                        let s = O(t, (t)=>{
                            let s = ((t.onPoint || {}).options || {}).id;
                            return !!s && s === e.id;
                        });
                        s && s.setVisible(!s.visible, !1);
                    });
                }
                seriesTranslate() {
                    this.onPoint && (this.onPoint.getRadii(), this.radii = this.onPoint.radii);
                }
                chartGetZData() {
                    let t = [];
                    this.series.forEach((e)=>{
                        let s = e.options.onPoint;
                        t.push(s?.z ?? null);
                    });
                    let e = new m({
                        columns: {
                            z: t
                        }
                    });
                    this.series.forEach((t)=>{
                        t.onPoint && (t.onPoint.dataTable = t.dataTable = e);
                    });
                }
            }
            t.Additions = e;
        }(r || (r = {}));
        let j = r, E = u();
        j.compose(E.Series, E.Chart);
        let T = u();
        return l.default;
    })());

});

parcelRegister("9a0Nt", function(module, exports) {
!/**
 * Highcharts JS v12.4.0 (2025-09-04)
 * @module highcharts/modules/exporting
 * @requires highcharts
 *
 * Exporting module
 *
 * (c) 2010-2025 Torstein Honsi
 *
 * License: www.highcharts.com/license
 */ function(e, t) {
    module.exports = t(e._Highcharts, e._Highcharts.AST, e._Highcharts.Chart);
}("undefined" == typeof window ? module.exports : window, (e, t, n)=>(()=>{
        "use strict";
        var i, o, r = {
            660: (e)=>{
                e.exports = t;
            },
            944: (t)=>{
                t.exports = e;
            },
            960: (e)=>{
                e.exports = n;
            }
        }, a = {};
        function s(e) {
            var t = a[e];
            if (void 0 !== t) return t.exports;
            var n = a[e] = {
                exports: {}
            };
            return r[e](n, n.exports, s), n.exports;
        }
        s.n = (e)=>{
            var t = e && e.__esModule ? ()=>e.default : ()=>e;
            return s.d(t, {
                a: t
            }), t;
        }, s.d = (e, t)=>{
            for(var n in t)s.o(t, n) && !s.o(e, n) && Object.defineProperty(e, n, {
                enumerable: !0,
                get: t[n]
            });
        }, s.o = (e, t)=>Object.prototype.hasOwnProperty.call(e, t);
        var l = {};
        s.d(l, {
            default: ()=>eu
        });
        var c = s(944), h = s.n(c), p = s(660), d = s.n(p), u = s(960), g = s.n(u);
        !function(e) {
            e.compose = function(e) {
                return e.navigation || (e.navigation = new t(e)), e;
            };
            class t {
                constructor(e){
                    this.updates = [], this.chart = e;
                }
                addUpdate(e) {
                    this.chart.navigation.updates.push(e);
                }
                update(e, t) {
                    this.updates.forEach((n)=>{
                        n.call(this.chart, e, t);
                    });
                }
            }
            e.Additions = t;
        }(i || (i = {}));
        let f = i, { isSafari: m, win: y, win: { document: x } } = h(), { error: w } = h(), b = y.URL || y.webkitURL || y;
        function v(e) {
            let t = e.replace(/filename=.*;/, "").match(/data:([^;]*)(;base64)?,([A-Z+\d\/]+)/i);
            if (t && t.length > 3 && y.atob && y.ArrayBuffer && y.Uint8Array && y.Blob && b.createObjectURL) {
                let e = y.atob(t[3]), n = new y.ArrayBuffer(e.length), i = new y.Uint8Array(n);
                for(let t = 0; t < i.length; ++t)i[t] = e.charCodeAt(t);
                return b.createObjectURL(new y.Blob([
                    i
                ], {
                    type: t[1]
                }));
            }
        }
        let { isTouchDevice: S } = h(), C = {
            exporting: {
                allowTableSorting: !0,
                libURL: "https://code.highcharts.com/12.4.0/lib/",
                local: !0,
                type: "image/png",
                url: `https://export-svg.highcharts.com?v=${h().version}`,
                pdfFont: {
                    normal: void 0,
                    bold: void 0,
                    bolditalic: void 0,
                    italic: void 0
                },
                printMaxWidth: 780,
                scale: 2,
                buttons: {
                    contextButton: {
                        className: "highcharts-contextbutton",
                        menuClassName: "highcharts-contextmenu",
                        symbol: "menu",
                        titleKey: "contextButtonTitle",
                        menuItems: [
                            "viewFullscreen",
                            "printChart",
                            "separator",
                            "downloadPNG",
                            "downloadJPEG",
                            "downloadSVG"
                        ]
                    }
                },
                menuItemDefinitions: {
                    viewFullscreen: {
                        textKey: "viewFullscreen",
                        onclick: function() {
                            this.fullscreen?.toggle();
                        }
                    },
                    printChart: {
                        textKey: "printChart",
                        onclick: function() {
                            this.exporting?.print();
                        }
                    },
                    separator: {
                        separator: !0
                    },
                    downloadPNG: {
                        textKey: "downloadPNG",
                        onclick: async function() {
                            await this.exporting?.exportChart();
                        }
                    },
                    downloadJPEG: {
                        textKey: "downloadJPEG",
                        onclick: async function() {
                            await this.exporting?.exportChart({
                                type: "image/jpeg"
                            });
                        }
                    },
                    downloadPDF: {
                        textKey: "downloadPDF",
                        onclick: async function() {
                            await this.exporting?.exportChart({
                                type: "application/pdf"
                            });
                        }
                    },
                    downloadSVG: {
                        textKey: "downloadSVG",
                        onclick: async function() {
                            await this.exporting?.exportChart({
                                type: "image/svg+xml"
                            });
                        }
                    }
                }
            },
            lang: {
                viewFullscreen: "View in full screen",
                exitFullscreen: "Exit from full screen",
                printChart: "Print chart",
                downloadPNG: "Download PNG image",
                downloadJPEG: "Download JPEG image",
                downloadPDF: "Download PDF document",
                downloadSVG: "Download SVG vector image",
                contextButtonTitle: "Chart context menu"
            },
            navigation: {
                buttonOptions: {
                    symbolSize: 14,
                    symbolX: 14.5,
                    symbolY: 13.5,
                    align: "right",
                    buttonSpacing: 5,
                    height: 28,
                    y: -5,
                    verticalAlign: "top",
                    width: 28,
                    symbolFill: "#666666",
                    symbolStroke: "#666666",
                    symbolStrokeWidth: 3,
                    theme: {
                        fill: "#ffffff",
                        padding: 5,
                        stroke: "none",
                        "stroke-linecap": "round"
                    }
                },
                menuStyle: {
                    border: "none",
                    borderRadius: "3px",
                    background: "#ffffff",
                    padding: "0.5em"
                },
                menuItemStyle: {
                    background: "none",
                    borderRadius: "3px",
                    color: "#333333",
                    padding: "0.5em",
                    fontSize: S ? "0.9em" : "0.8em",
                    transition: "background 250ms, color 250ms"
                },
                menuItemHoverStyle: {
                    background: "#f2f2f2"
                }
            }
        };
        !function(e) {
            let t = [];
            function n(e, t, n, i) {
                return [
                    [
                        "M",
                        e,
                        t + 2.5
                    ],
                    [
                        "L",
                        e + n,
                        t + 2.5
                    ],
                    [
                        "M",
                        e,
                        t + i / 2 + .5
                    ],
                    [
                        "L",
                        e + n,
                        t + i / 2 + .5
                    ],
                    [
                        "M",
                        e,
                        t + i - 1.5
                    ],
                    [
                        "L",
                        e + n,
                        t + i - 1.5
                    ]
                ];
            }
            function i(e, t, n, i) {
                let o = i / 3 - 2, r = [];
                return r.concat(this.circle(n - o, t, o, o), this.circle(n - o, t + o + 4, o, o), this.circle(n - o, t + 2 * (o + 4), o, o));
            }
            e.compose = function(e) {
                if (-1 === t.indexOf(e)) {
                    t.push(e);
                    let o = e.prototype.symbols;
                    o.menu = n, o.menuball = i.bind(o);
                }
            };
        }(o || (o = {}));
        let E = o, { composed: O } = h(), { addEvent: T, fireEvent: k, pushUnique: F } = h();
        function R() {
            this.fullscreen = new N(this);
        }
        class N {
            static compose(e) {
                F(O, "Fullscreen") && T(e, "beforeRender", R);
            }
            constructor(e){
                this.chart = e, this.isOpen = !1;
                let t = e.renderTo;
                !this.browserProps && ("function" == typeof t.requestFullscreen ? this.browserProps = {
                    fullscreenChange: "fullscreenchange",
                    requestFullscreen: "requestFullscreen",
                    exitFullscreen: "exitFullscreen"
                } : t.mozRequestFullScreen ? this.browserProps = {
                    fullscreenChange: "mozfullscreenchange",
                    requestFullscreen: "mozRequestFullScreen",
                    exitFullscreen: "mozCancelFullScreen"
                } : t.webkitRequestFullScreen ? this.browserProps = {
                    fullscreenChange: "webkitfullscreenchange",
                    requestFullscreen: "webkitRequestFullScreen",
                    exitFullscreen: "webkitExitFullscreen"
                } : t.msRequestFullscreen && (this.browserProps = {
                    fullscreenChange: "MSFullscreenChange",
                    requestFullscreen: "msRequestFullscreen",
                    exitFullscreen: "msExitFullscreen"
                }));
            }
            close() {
                let e = this, t = e.chart, n = t.options.chart;
                k(t, "fullscreenClose", null, function() {
                    e.isOpen && e.browserProps && t.container.ownerDocument instanceof Document && t.container.ownerDocument[e.browserProps.exitFullscreen](), e.unbindFullscreenEvent && (e.unbindFullscreenEvent = e.unbindFullscreenEvent()), t.setSize(e.origWidth, e.origHeight, !1), e.origWidth = void 0, e.origHeight = void 0, n.width = e.origWidthOption, n.height = e.origHeightOption, e.origWidthOption = void 0, e.origHeightOption = void 0, e.isOpen = !1, e.setButtonText();
                });
            }
            open() {
                let e = this, t = e.chart, n = t.options.chart;
                k(t, "fullscreenOpen", null, function() {
                    if (n && (e.origWidthOption = n.width, e.origHeightOption = n.height), e.origWidth = t.chartWidth, e.origHeight = t.chartHeight, e.browserProps) {
                        let n = T(t.container.ownerDocument, e.browserProps.fullscreenChange, function() {
                            e.isOpen ? (e.isOpen = !1, e.close()) : (t.setSize(null, null, !1), e.isOpen = !0, e.setButtonText());
                        }), i = T(t, "destroy", n);
                        e.unbindFullscreenEvent = ()=>{
                            n(), i();
                        };
                        let o = t.renderTo[e.browserProps.requestFullscreen]();
                        o && o.catch(function() {
                            alert("Full screen is not supported inside a frame.");
                        });
                    }
                });
            }
            setButtonText() {
                let e = this.chart, t = e.exporting?.divElements, n = e.options.exporting, i = n && n.buttons && n.buttons.contextButton.menuItems, o = e.options.lang;
                if (n && n.menuItemDefinitions && o && o.exitFullscreen && o.viewFullscreen && i && t) {
                    let e = t[i.indexOf("viewFullscreen")];
                    e && d().setElementHTML(e, this.isOpen ? o.exitFullscreen : n.menuItemDefinitions.viewFullscreen.text || o.viewFullscreen);
                }
            }
            toggle() {
                this.isOpen ? this.close() : this.open();
            }
        }
        let { win: P } = h(), { discardElement: H, objectEach: L } = h(), M = {
            ajax: function(e) {
                let t = {
                    json: "application/json",
                    xml: "application/xml",
                    text: "text/plain",
                    octet: "application/octet-stream"
                }, n = new XMLHttpRequest;
                function i(t, n) {
                    e.error && e.error(t, n);
                }
                if (!e.url) return !1;
                n.open((e.type || "get").toUpperCase(), e.url, !0), e.headers?.["Content-Type"] || n.setRequestHeader("Content-Type", t[e.dataType || "json"] || t.text), L(e.headers, function(e, t) {
                    n.setRequestHeader(t, e);
                }), e.responseType && (n.responseType = e.responseType), n.onreadystatechange = function() {
                    let t;
                    if (4 === n.readyState) {
                        if (200 === n.status) {
                            if ("blob" !== e.responseType && (t = n.responseText, "json" === e.dataType)) try {
                                t = JSON.parse(t);
                            } catch (e) {
                                if (e instanceof Error) return i(n, e);
                            }
                            return e.success?.(t, n);
                        }
                        i(n, n.responseText);
                    }
                }, e.data && "string" != typeof e.data && (e.data = JSON.stringify(e.data)), n.send(e.data);
            },
            getJSON: function(e, t) {
                M.ajax({
                    url: e,
                    success: t,
                    dataType: "json",
                    headers: {
                        "Content-Type": "text/plain"
                    }
                });
            },
            post: async function(e, t, n) {
                let i = new P.FormData;
                L(t, function(e, t) {
                    i.append(t, e);
                }), i.append("b64", "true");
                let o = await P.fetch(e, {
                    method: "POST",
                    body: i,
                    ...n
                });
                if (o.ok) {
                    let e = await o.text(), n = document.createElement("a");
                    n.href = `data:${t.type};base64,${e}`, n.download = t.filename, n.click(), H(n);
                }
            }
        }, { defaultOptions: A, setOptions: D } = h(), { downloadURL: U, getScript: I } = {
            dataURLtoBlob: v,
            downloadURL: function(e, t) {
                let n = y.navigator, i = x.createElement("a");
                if ("string" != typeof e && !(e instanceof String) && n.msSaveOrOpenBlob) return void n.msSaveOrOpenBlob(e, t);
                if (e = "" + e, n.userAgent.length > 1e3) throw Error("Input too long");
                let o = /Edge\/\d+/.test(n.userAgent);
                if ((m && "string" == typeof e && 0 === e.indexOf("data:application/pdf") || o || e.length > 2e6) && !(e = v(e) || "")) throw Error("Failed to convert to blob");
                if (void 0 !== i.download) i.href = e, i.download = t, x.body.appendChild(i), i.click(), x.body.removeChild(i);
                else try {
                    if (!y.open(e, "chart")) throw Error("Failed to open window");
                } catch  {
                    y.location.href = e;
                }
            },
            getScript: function(e) {
                return new Promise((t, n)=>{
                    let i = x.getElementsByTagName("head")[0], o = x.createElement("script");
                    o.type = "text/javascript", o.src = e, o.onload = ()=>{
                        t();
                    }, o.onerror = ()=>{
                        let t = `Error loading script ${e}`;
                        w(t), n(Error(t));
                    }, i.appendChild(o);
                });
            }
        }, { composed: j, doc: B, isFirefox: G, isMS: $, isSafari: V, SVG_NS: W, win: q } = h(), { addEvent: z, clearTimeout: K, createElement: J, css: _, discardElement: X, error: Y, extend: Z, find: Q, fireEvent: ee, isObject: et, merge: en, objectEach: ei, pick: eo, pushUnique: er, removeEvent: ea, splat: es, uniqueKey: el } = h();
        d().allowedAttributes.push("data-z-index", "fill-opacity", "filter", "preserveAspectRatio", "rx", "ry", "stroke-dasharray", "stroke-linejoin", "stroke-opacity", "text-anchor", "transform", "transform-origin", "version", "viewBox", "visibility", "xmlns", "xmlns:xlink"), d().allowedTags.push("desc", "clippath", "fedropshadow", "femorphology", "g", "image");
        let ec = q.URL || q.webkitURL || q;
        class eh {
            constructor(e, t){
                this.options = {}, this.chart = e, this.options = t, this.btnCount = 0, this.buttonOffset = 0, this.divElements = [], this.svgElements = [];
            }
            static hyphenate(e) {
                return e.replace(/[A-Z]/g, function(e) {
                    return "-" + e.toLowerCase();
                });
            }
            static async imageToDataURL(e, t, n) {
                let i = await eh.loadImage(e), o = B.createElement("canvas"), r = o?.getContext("2d");
                if (r) return o.height = i.height * t, o.width = i.width * t, r.drawImage(i, 0, 0, o.width, o.height), o.toDataURL(n);
                throw Error("No canvas found!");
            }
            static async fetchCSS(e) {
                let t = await fetch(e).then((e)=>e.text()), n = new CSSStyleSheet;
                return n.replaceSync(t), n;
            }
            static async handleStyleSheet(e, t) {
                try {
                    for (let n of Array.from(e.cssRules)){
                        if (n instanceof CSSImportRule) {
                            let e = await eh.fetchCSS(n.href);
                            await eh.handleStyleSheet(e, t);
                        }
                        if (n instanceof CSSFontFaceRule) {
                            let i = n.cssText;
                            if (e.href) {
                                let t = e.href, n = /url\(\s*(['"]?)(?![a-z]+:|\/\/)([^'")]+?)\1\s*\)/gi;
                                i = i.replace(n, (e, n, i)=>{
                                    let o = new URL(i, t).href;
                                    return `url(${n}${o}${n})`;
                                });
                            }
                            t.push(i);
                        }
                    }
                } catch  {
                    if (e.href) {
                        let n = await eh.fetchCSS(e.href);
                        await eh.handleStyleSheet(n, t);
                    }
                }
            }
            static async fetchStyleSheets() {
                let e = [];
                for (let t of Array.from(B.styleSheets))await eh.handleStyleSheet(t, e);
                return e;
            }
            static async inlineFonts(e) {
                let t = await eh.fetchStyleSheets(), n = /url\(([^)]+)\)/g, i = [], o = t.join("\n"), r;
                for(; r = n.exec(o);){
                    let e = r[1].replace(/['"]/g, "");
                    i.includes(e) || i.push(e);
                }
                let a = (e)=>{
                    let t = "", n = new Uint8Array(e);
                    for(let e = 0; e < n.byteLength; e++)t += String.fromCharCode(n[e]);
                    return btoa(t);
                }, s = {};
                for (let e of i)try {
                    let t = await fetch(e), n = t.headers.get("Content-Type") || "", i = a(await t.arrayBuffer());
                    s[e] = `data:${n};base64,${i}`;
                } catch  {}
                o = o.replace(n, (e, t)=>{
                    let n = t.replace(/['"]/g, "");
                    return `url(${s[n] || n})`;
                });
                let l = document.createElementNS("http://www.w3.org/2000/svg", "style");
                return l.textContent = o, e.append(l), e;
            }
            static loadImage(e) {
                return new Promise((t, n)=>{
                    let i = new q.Image;
                    i.crossOrigin = "Anonymous", i.onload = ()=>{
                        setTimeout(()=>{
                            t(i);
                        }, eh.loadEventDeferDelay);
                    }, i.onerror = (e)=>{
                        n(e);
                    }, i.src = e;
                });
            }
            static prepareImageOptions(e) {
                let t = e?.type || "image/png", n = e?.libURL || A.exporting?.libURL;
                return {
                    type: t,
                    filename: (e?.filename || "chart") + "." + ("image/svg+xml" === t ? "svg" : t.split("/")[1]),
                    scale: e?.scale || 1,
                    libURL: n?.slice(-1) !== "/" ? n + "/" : n
                };
            }
            static sanitizeSVG(e, t) {
                let n = e.indexOf("</svg>") + 6, i = e.indexOf("<foreignObject") > -1, o = e.substr(n);
                return e = e.substr(0, n), i ? e = e.replace(/(<(?:img|br).*?(?=\>))>/g, "$1 />") : o && t?.exporting?.allowHTML && (o = '<foreignObject x="0" y="0" width="' + t.chart.width + '" height="' + t.chart.height + '"><body xmlns="http://www.w3.org/1999/xhtml">' + o.replace(/(<(?:img|br).*?(?=\>))>/g, "$1 />") + "</body></foreignObject>", e = e.replace("</svg>", o + "</svg>")), e = e.replace(/zIndex="[^"]+"/g, "").replace(/symbolName="[^"]+"/g, "").replace(/jQuery\d+="[^"]+"/g, "").replace(/url\(("|&quot;)(.*?)("|&quot;)\;?\)/g, "url($2)").replace(/url\([^#]+#/g, "url(#").replace(/<svg /, '<svg xmlns:xlink="http://www.w3.org/1999/xlink" ').replace(/ (NS\d+\:)?href=/g, " xlink:href=").replace(/\n+/g, " ").replace(/&nbsp;/g, "\xa0").replace(/&shy;/g, "\xad");
            }
            static svgToDataURL(e) {
                let t = q.navigator.userAgent, n = t.indexOf("WebKit") > -1 && 0 > t.indexOf("Chrome");
                try {
                    if (!n && -1 === e.indexOf("<foreignObject")) return ec.createObjectURL(new q.Blob([
                        e
                    ], {
                        type: "image/svg+xml;charset-utf-16"
                    }));
                } catch  {}
                return "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(e);
            }
            addButton(e) {
                let t, n = this, i = n.chart, o = i.renderer, r = en(i.options.navigation?.buttonOptions, e), a = r.onclick, s = r.menuItems, l = r.symbolSize || 12;
                if (!1 === r.enabled || !r.theme) return;
                let c = i.styledMode ? {} : r.theme, h = ()=>{};
                a ? h = function(e) {
                    e && e.stopPropagation(), a.call(i, e);
                } : s && (h = function(e) {
                    e && e.stopPropagation(), n.contextMenu(p.menuClassName, s, p.translateX || 0, p.translateY || 0, p.width || 0, p.height || 0, p), p.setState(2);
                }), r.text && r.symbol ? c.paddingLeft = eo(c.paddingLeft, 30) : r.text || Z(c, {
                    width: r.width,
                    height: r.height,
                    padding: 0
                });
                let p = o.button(r.text || "", 0, 0, h, c, void 0, void 0, void 0, void 0, r.useHTML).addClass(e.className || "").attr({
                    title: eo(i.options.lang[r._titleKey || r.titleKey], "")
                });
                p.menuClassName = e.menuClassName || "highcharts-menu-" + n.btnCount++, r.symbol && (t = o.symbol(r.symbol, Math.round((r.symbolX || 0) - l / 2), Math.round((r.symbolY || 0) - l / 2), l, l, {
                    width: l,
                    height: l
                }).addClass("highcharts-button-symbol").attr({
                    zIndex: 1
                }).add(p), i.styledMode || t.attr({
                    stroke: r.symbolStroke,
                    fill: r.symbolFill,
                    "stroke-width": r.symbolStrokeWidth || 1
                })), p.add(n.group).align(Z(r, {
                    width: p.width,
                    x: eo(r.x, n.buttonOffset)
                }), !0, "spacingBox"), n.buttonOffset += ((p.width || 0) + (r.buttonSpacing || 0)) * ("right" === r.align ? -1 : 1), n.svgElements.push(p, t);
            }
            afterPrint() {
                let e = this.chart;
                if (!this.printReverseInfo) return;
                let { childNodes: t, origDisplay: n, resetParams: i } = this.printReverseInfo;
                this.moveContainers(e.renderTo), [].forEach.call(t, function(e, t) {
                    1 === e.nodeType && (e.style.display = n[t] || "");
                }), this.isPrinting = !1, i && e.setSize.apply(e, i), delete this.printReverseInfo, eh.printingChart = void 0, ee(e, "afterPrint");
            }
            beforePrint() {
                let e = this.chart, t = B.body, n = this.options.printMaxWidth, i = {
                    childNodes: t.childNodes,
                    origDisplay: [],
                    resetParams: void 0
                };
                this.isPrinting = !0, e.pointer?.reset(void 0, 0), ee(e, "beforePrint"), n && e.chartWidth > n && (i.resetParams = [
                    e.options.chart.width,
                    void 0,
                    !1
                ], e.setSize(n, void 0, !1)), [].forEach.call(i.childNodes, function(e, t) {
                    1 === e.nodeType && (i.origDisplay[t] = e.style.display, e.style.display = "none");
                }), this.moveContainers(t), this.printReverseInfo = i;
            }
            contextMenu(e, t, n, i, o, r, a) {
                let s = this, l = s.chart, c = l.options.navigation, h = l.chartWidth, p = l.chartHeight, u = "cache-" + e, g = Math.max(o, r), f, m = l[u];
                m || (s.contextMenuEl = l[u] = m = J("div", {
                    className: e
                }, {
                    position: "absolute",
                    zIndex: 1e3,
                    padding: g + "px",
                    pointerEvents: "auto",
                    ...l.renderer.style
                }, l.scrollablePlotArea?.fixedDiv || l.container), f = J("ul", {
                    className: "highcharts-menu"
                }, l.styledMode ? {} : {
                    listStyle: "none",
                    margin: 0,
                    padding: 0
                }, m), l.styledMode || _(f, Z({
                    MozBoxShadow: "3px 3px 10px #0008",
                    WebkitBoxShadow: "3px 3px 10px #0008",
                    boxShadow: "3px 3px 10px #0008"
                }, c?.menuStyle || {})), m.hideMenu = function() {
                    _(m, {
                        display: "none"
                    }), a && a.setState(0), l.exporting && (l.exporting.openMenu = !1), _(l.renderTo, {
                        overflow: "hidden"
                    }), _(l.container, {
                        overflow: "hidden"
                    }), K(m.hideTimer), ee(l, "exportMenuHidden");
                }, s.events?.push(z(m, "mouseleave", function() {
                    m.hideTimer = q.setTimeout(m.hideMenu, 500);
                }), z(m, "mouseenter", function() {
                    K(m.hideTimer);
                }), z(B, "mouseup", function(t) {
                    l.pointer?.inClass(t.target, e) || m.hideMenu();
                }), z(m, "click", function() {
                    l.exporting?.openMenu && m.hideMenu();
                })), t.forEach(function(e) {
                    if ("string" == typeof e && s.options.menuItemDefinitions?.[e] && (e = s.options.menuItemDefinitions[e]), et(e, !0)) {
                        let t;
                        e.separator ? t = J("hr", void 0, void 0, f) : ("viewData" === e.textKey && s.isDataTableVisible && (e.textKey = "hideData"), t = J("li", {
                            className: "highcharts-menu-item",
                            onclick: function(t) {
                                t && t.stopPropagation(), m.hideMenu(), "string" != typeof e && e.onclick && e.onclick.apply(l, arguments);
                            }
                        }, void 0, f), d().setElementHTML(t, e.text || l.options.lang[e.textKey]), l.styledMode || (t.onmouseover = function() {
                            _(this, c?.menuItemHoverStyle || {});
                        }, t.onmouseout = function() {
                            _(this, c?.menuItemStyle || {});
                        }, _(t, Z({
                            cursor: "pointer"
                        }, c?.menuItemStyle || {})))), s.divElements.push(t);
                    }
                }), s.divElements.push(f, m), s.menuHeight = m.offsetHeight, s.menuWidth = m.offsetWidth);
                let y = {
                    display: "block"
                };
                n + (s.menuWidth || 0) > h ? y.right = h - n - o - g + "px" : y.left = n - g + "px", i + r + (s.menuHeight || 0) > p && a.alignOptions?.verticalAlign !== "top" ? y.bottom = p - i - g + "px" : y.top = i + r - g + "px", _(m, y), _(l.renderTo, {
                    overflow: ""
                }), _(l.container, {
                    overflow: ""
                }), l.exporting && (l.exporting.openMenu = !0), ee(l, "exportMenuShown");
            }
            destroy(e) {
                let t, n = e ? e.target : this.chart, { divElements: i, events: o, svgElements: r } = this;
                r.forEach((e, i)=>{
                    e && (e.onclick = e.ontouchstart = null, n[t = "cache-" + e.menuClassName] && delete n[t], r[i] = e.destroy());
                }), r.length = 0, this.group && (this.group.destroy(), delete this.group), i.forEach(function(e, t) {
                    e && (K(e.hideTimer), ea(e, "mouseleave"), i[t] = e.onmouseout = e.onmouseover = e.ontouchstart = e.onclick = null, X(e));
                }), i.length = 0, o && (o.forEach(function(e) {
                    e();
                }), o.length = 0);
            }
            async downloadSVG(e, t) {
                let n, i = {
                    svg: e,
                    exportingOptions: t,
                    exporting: this
                };
                if (ee(eh.prototype, "downloadSVG", i), i.defaultPrevented) return;
                let { type: o, filename: r, scale: a, libURL: s } = eh.prepareImageOptions(t);
                if ("application/pdf" === o) throw Error("Offline exporting logic for PDF type is not found.");
                if ("image/svg+xml" === o) {
                    if (void 0 !== q.MSBlobBuilder) {
                        let t = new q.MSBlobBuilder;
                        t.append(e), n = t.getBlob("image/svg+xml");
                    } else n = eh.svgToDataURL(e);
                    U(n, r);
                } else {
                    n = eh.svgToDataURL(e);
                    try {
                        eh.objectURLRevoke = !0;
                        let e = await eh.imageToDataURL(n, a, o);
                        U(e, r);
                    } catch (c) {
                        if ("No canvas found!" === c.message) throw c;
                        if (e.length > 1e8) throw Error("Input too long");
                        let t = B.createElement("canvas"), n = t.getContext("2d"), i = e.match(/^<svg[^>]*\s{,1000}width\s{,1000}=\s{,1000}\"?(\d+)\"?[^>]*>/), l = e.match(/^<svg[^>]*\s{0,1000}height\s{,1000}=\s{,1000}\"?(\d+)\"?[^>]*>/);
                        if (n && i && l) {
                            let c = i[1] * a, h = l[1] * a;
                            t.width = c, t.height = h, q.canvg || (eh.objectURLRevoke = !0, await I(s + "canvg.js")), q.canvg.Canvg.fromString(n, e).start(), U(q.navigator.msSaveOrOpenBlob ? t.msToBlob() : t.toDataURL(o), r);
                        }
                    } finally{
                        if (eh.objectURLRevoke) try {
                            ec.revokeObjectURL(n);
                        } catch  {}
                    }
                }
            }
            async exportChart(e, t) {
                if ((e = en(this.options, e)).local) await this.localExport(e, t || {});
                else {
                    let n = this.getSVGForExport(e, t);
                    e.url && await M.post(e.url, {
                        filename: e.filename ? e.filename.replace(/\//g, "-") : this.getFilename(),
                        type: e.type,
                        width: e.width,
                        scale: e.scale,
                        svg: n
                    }, e.fetchOptions);
                }
            }
            async fallbackToServer(e, t) {
                !1 === e.fallbackToExportServer ? e.error ? e.error(e, t) : Y(28, !0) : "application/pdf" === e.type && (e.local = !1, await this.exportChart(e));
            }
            getChartHTML(e) {
                let t = this.chart;
                return e && this.inlineStyles(), this.resolveCSSVariables(), t.container.innerHTML;
            }
            getFilename() {
                let e = this.chart.userOptions.title?.text, t = this.options.filename;
                return t ? t.replace(/\//g, "-") : ("string" == typeof e && (t = e.toLowerCase().replace(/<\/?[^>]+(>|$)/g, "").replace(/[\s_]+/g, "-").replace(/[^a-z\d\-]/g, "").replace(/^[\-]+/g, "").replace(/[\-]+/g, "-").substr(0, 24).replace(/[\-]+$/g, "")), (!t || t.length < 5) && (t = "chart"), t);
            }
            getSVG(e) {
                let t = this.chart, n, i, o = en(t.options, e);
                o.plotOptions = en(t.userOptions.plotOptions, e?.plotOptions), o.time = en(t.userOptions.time, e?.time);
                let r = J("div", void 0, {
                    position: "absolute",
                    top: "-9999em",
                    width: t.chartWidth + "px",
                    height: t.chartHeight + "px"
                }, B.body), a = t.renderTo.style.width, s = t.renderTo.style.height, l = o.exporting?.sourceWidth || o.chart.width || /px$/.test(a) && parseInt(a, 10) || (o.isGantt ? 800 : 600), c = o.exporting?.sourceHeight || o.chart.height || /px$/.test(s) && parseInt(s, 10) || 400;
                Z(o.chart, {
                    animation: !1,
                    renderTo: r,
                    forExport: !0,
                    renderer: "SVGRenderer",
                    width: l,
                    height: c
                }), o.exporting && (o.exporting.enabled = !1), delete o.data, o.series = [], t.series.forEach(function(e) {
                    (i = en(e.userOptions, {
                        animation: !1,
                        enableMouseTracking: !1,
                        showCheckbox: !1,
                        visible: e.visible
                    })).isInternal || o?.series?.push(i);
                });
                let h = {};
                t.axes.forEach(function(e) {
                    e.userOptions.internalKey || (e.userOptions.internalKey = el()), o && !e.options.isInternal && (h[e.coll] || (h[e.coll] = !0, o[e.coll] = []), o[e.coll].push(en(e.userOptions, {
                        visible: e.visible,
                        type: e.type,
                        uniqueNames: e.uniqueNames
                    })));
                }), o.colorAxis = t.userOptions.colorAxis;
                let p = new t.constructor(o, t.callback);
                return e && [
                    "xAxis",
                    "yAxis",
                    "series"
                ].forEach(function(t) {
                    e[t] && p.update({
                        [t]: e[t]
                    });
                }), t.axes.forEach(function(t) {
                    let n = Q(p.axes, (e)=>e.options.internalKey === t.userOptions.internalKey);
                    if (n) {
                        let i = t.getExtremes(), o = es(e?.[t.coll] || {})[0], r = "min" in o ? o.min : i.userMin, a = "max" in o ? o.max : i.userMax;
                        (void 0 !== r && r !== n.min || void 0 !== a && a !== n.max) && n.setExtremes(r ?? void 0, a ?? void 0, !0, !1);
                    }
                }), n = p.exporting?.getChartHTML(t.styledMode || o.exporting?.applyStyleSheets) || "", ee(t, "getSVG", {
                    chartCopy: p
                }), n = eh.sanitizeSVG(n, o), o = void 0, p.destroy(), X(r), n;
            }
            getSVGForExport(e, t) {
                let n = this.options;
                return this.getSVG(en({
                    chart: {
                        borderRadius: 0
                    }
                }, n.chartOptions, t, {
                    exporting: {
                        sourceWidth: e?.sourceWidth || n.sourceWidth,
                        sourceHeight: e?.sourceHeight || n.sourceHeight
                    }
                }));
            }
            inlineStyles() {
                let e, t = eh.inlineDenylist, n = eh.inlineAllowlist, i = {}, o = J("iframe", void 0, {
                    width: "1px",
                    height: "1px",
                    visibility: "hidden"
                }, B.body), r = o.contentWindow?.document;
                r && r.body.appendChild(r.createElementNS(W, "svg")), !function o(a) {
                    let s, l, c, h, p, d, u = {};
                    if (r && 1 === a.nodeType && -1 === eh.unstyledElements.indexOf(a.nodeName)) {
                        if (s = q.getComputedStyle(a, null), l = "svg" === a.nodeName ? {} : q.getComputedStyle(a.parentNode, null), !i[a.nodeName]) {
                            e = r.getElementsByTagName("svg")[0], c = r.createElementNS(a.namespaceURI, a.nodeName), e.appendChild(c);
                            let t = q.getComputedStyle(c, null), n = {};
                            for(let e in t)e.length < 1e3 && "string" == typeof t[e] && !/^\d+$/.test(e) && (n[e] = t[e]);
                            i[a.nodeName] = n, "text" === a.nodeName && delete i.text.fill, e.removeChild(c);
                        }
                        for(let e in s)(G || $ || V || Object.hasOwnProperty.call(s, e)) && function(e, o) {
                            if (h = p = !1, n.length) {
                                for(d = n.length; d-- && !p;)p = n[d].test(o);
                                h = !p;
                            }
                            for("transform" === o && "none" === e && (h = !0), d = t.length; d-- && !h;){
                                if (o.length > 1e3) throw Error("Input too long");
                                h = t[d].test(o) || "function" == typeof e;
                            }
                            !h && (l[o] !== e || "svg" === a.nodeName) && i[a.nodeName][o] !== e && (eh.inlineToAttributes && -1 === eh.inlineToAttributes.indexOf(o) ? u[o] = e : e && a.setAttribute(eh.hyphenate(o), e));
                        }(s[e], e);
                        if (_(a, u), "svg" === a.nodeName && a.setAttribute("stroke-width", "1px"), "text" === a.nodeName) return;
                        [].forEach.call(a.children || a.childNodes, o);
                    }
                }(this.chart.container.querySelector("svg")), e.parentNode.removeChild(e), o.parentNode.removeChild(o);
            }
            async localExport(e, t) {
                let n = this.chart, i, o, r = null, a;
                if ($ && n.styledMode && !eh.inlineAllowlist.length && eh.inlineAllowlist.push(/^blockSize/, /^border/, /^caretColor/, /^color/, /^columnRule/, /^columnRuleColor/, /^cssFloat/, /^cursor/, /^fill$/, /^fillOpacity/, /^font/, /^inlineSize/, /^length/, /^lineHeight/, /^opacity/, /^outline/, /^parentRule/, /^rx$/, /^ry$/, /^stroke/, /^textAlign/, /^textAnchor/, /^textDecoration/, /^transform/, /^vectorEffect/, /^visibility/, /^x$/, /^y$/), $ && ("application/pdf" === e.type || n.container.getElementsByTagName("image").length && "image/svg+xml" !== e.type) || "application/pdf" === e.type && [].some.call(n.container.getElementsByTagName("image"), function(e) {
                    let t = e.getAttribute("href");
                    return "" !== t && "string" == typeof t && 0 !== t.indexOf("data:");
                })) return void await this.fallbackToServer(e, Error("Image type not supported for this chart/browser."));
                let s = z(n, "getSVG", (e)=>{
                    o = e.chartCopy.options, a = (i = e.chartCopy.container.cloneNode(!0)) && i.getElementsByTagName("image") || [];
                });
                try {
                    let n;
                    for (let n of (this.getSVGForExport(e, t), a ? Array.from(a) : []))if (r = n.getAttributeNS("http://www.w3.org/1999/xlink", "href")) {
                        eh.objectURLRevoke = !1;
                        let t = await eh.imageToDataURL(r, e?.scale || 1, e?.type || "image/png");
                        n.setAttributeNS("http://www.w3.org/1999/xlink", "href", t);
                    } else n.parentNode.removeChild(n);
                    let s = i?.querySelector("svg");
                    s && !e.chartOptions?.chart?.style?.fontFamily && await eh.inlineFonts(s);
                    let l = (n = i?.innerHTML, eh.sanitizeSVG(n || "", o));
                    if (l.indexOf("<foreignObject") > -1 && "image/svg+xml" !== e.type && ($ || "application/pdf" === e.type)) throw Error("Image type not supported for charts with embedded HTML");
                    return await this.downloadSVG(l, Z({
                        filename: this.getFilename()
                    }, e)), l;
                } catch (t) {
                    await this.fallbackToServer(e, t);
                } finally{
                    s();
                }
            }
            moveContainers(e) {
                let t = this.chart, { scrollablePlotArea: n } = t;
                (n ? [
                    n.fixedDiv,
                    n.scrollingContainer
                ] : [
                    t.container
                ]).forEach(function(t) {
                    e.appendChild(t);
                });
            }
            print() {
                let e = this.chart;
                this.isPrinting || (eh.printingChart = e, V || this.beforePrint(), setTimeout(()=>{
                    q.focus(), q.print(), V || setTimeout(()=>{
                        e.exporting?.afterPrint();
                    }, 1e3);
                }, 1));
            }
            render() {
                let e = this, { chart: t, options: n } = e, i = e?.isDirty || !e?.svgElements.length;
                e.buttonOffset = 0, e.isDirty && e.destroy(), i && !1 !== n.enabled && (e.events = [], e.group || (e.group = t.renderer.g("exporting-group").attr({
                    zIndex: 3
                }).add()), ei(n?.buttons, function(t) {
                    e.addButton(t);
                }), e.isDirty = !1);
            }
            resolveCSSVariables() {
                Array.from(this.chart.container.querySelectorAll("*")).forEach((e)=>{
                    [
                        "color",
                        "fill",
                        "stop-color",
                        "stroke"
                    ].forEach((t)=>{
                        let n = e.getAttribute(t);
                        n?.includes("var(") && e.setAttribute(t, getComputedStyle(e).getPropertyValue(t));
                        let i = e.style?.[t];
                        i?.includes("var(") && (e.style[t] = getComputedStyle(e).getPropertyValue(t));
                    });
                });
            }
            update(e, t) {
                this.isDirty = !0, en(!0, this.options, e), eo(t, !0) && this.chart.redraw();
            }
        }
        eh.inlineAllowlist = [], eh.inlineDenylist = [
            /-/,
            /^(clipPath|cssText|d|height|width)$/,
            /^font$/,
            /[lL]ogical(Width|Height)$/,
            /^parentRule$/,
            /^(cssRules|ownerRules)$/,
            /perspective/,
            /TapHighlightColor/,
            /^transition/,
            /^length$/,
            /^\d+$/
        ], eh.inlineToAttributes = [
            "fill",
            "stroke",
            "strokeLinecap",
            "strokeLinejoin",
            "strokeWidth",
            "textAnchor",
            "x",
            "y"
        ], eh.loadEventDeferDelay = 150 * !!$, eh.unstyledElements = [
            "clipPath",
            "defs",
            "desc"
        ], function(e) {
            function t(e) {
                let t = e.exporting;
                t && (t.render(), z(e, "redraw", function() {
                    this.exporting?.render();
                }), z(e, "destroy", function() {
                    this.exporting?.destroy();
                }));
            }
            function n() {
                let t = this;
                t.options.exporting && (t.exporting = new e(t, t.options.exporting), f.compose(t).navigation.addUpdate((e, n)=>{
                    t.exporting && (t.exporting.isDirty = !0, en(!0, t.options.navigation, e), eo(n, !0) && t.redraw());
                }));
            }
            function i({ alignTo: e, key: t, textPxLength: n }) {
                let i = this.options.exporting, { align: o, buttonSpacing: r = 0, verticalAlign: a, width: s = 0 } = en(this.options.navigation?.buttonOptions, i?.buttons?.contextButton), l = e.width - n, c = s + r;
                (i?.enabled ?? !0) && "title" === t && "right" === o && "top" === a && l < 2 * c && (l < c ? e.width -= c : this.title?.alignValue !== "left" && (e.x -= c - l / 2));
            }
            e.compose = function(o, r) {
                E.compose(r), N.compose(o), er(j, "Exporting") && (Z(g().prototype, {
                    exportChart: async function(e, t) {
                        await this.exporting?.exportChart(e, t);
                    },
                    getChartHTML: function(e) {
                        return this.exporting?.getChartHTML(e);
                    },
                    getFilename: function() {
                        return this.exporting?.getFilename();
                    },
                    getSVG: function(e) {
                        return this.exporting?.getSVG(e);
                    },
                    print: function() {
                        return this.exporting?.print();
                    }
                }), o.prototype.callbacks.push(t), z(o, "afterInit", n), z(o, "layOutTitle", i), V && q.matchMedia("print").addListener(function(t) {
                    e.printingChart && (t.matches ? e.printingChart.exporting?.beforePrint() : e.printingChart.exporting?.afterPrint());
                }), D(C));
            };
        }(eh || (eh = {}));
        let ep = eh, ed = h();
        ed.Exporting = ep, ed.HttpUtilities = ed.HttpUtilities || M, ed.ajax = ed.HttpUtilities.ajax, ed.getJSON = ed.HttpUtilities.getJSON, ed.post = ed.HttpUtilities.post, ep.compose(ed.Chart, ed.Renderer);
        let eu = h();
        return l.default;
    })());

});

parcelRegister("edxFI", function(module, exports) {

$parcel$export(module.exports, "research", () => $a59c66174eda3706$export$2c37ad40f3b5bcf1);
$parcel$export(module.exports, "filterByCategory", () => $a59c66174eda3706$export$6d1731a321e8bdf4);
$parcel$export(module.exports, "getSPP", () => $a59c66174eda3706$export$771046e941ba1965);
$parcel$export(module.exports, "getSMSizes", () => $a59c66174eda3706$export$1d3d202e952b2622);

var $5QsV4 = parcelRequire("5QsV4");

var $1Opay = parcelRequire("1Opay");
const $a59c66174eda3706$var$smData = (0, (/*@__PURE__*/$parcel$interopDefault($5QsV4))).sm;
const $a59c66174eda3706$var$cities = (0, (/*@__PURE__*/$parcel$interopDefault($5QsV4))).cities;
const $a59c66174eda3706$export$2c37ad40f3b5bcf1 = (0, (/*@__PURE__*/$parcel$interopDefault($5QsV4))).research;
function $a59c66174eda3706$export$6d1731a321e8bdf4(categories) {
    const filtered = $a59c66174eda3706$var$smData.filter((sm)=>categories.includes(sm[1] + ""));
    const cityData = {};
    filtered.forEach(([city, metric, value])=>{
        if (!cityData[city]) cityData[city] = $a59c66174eda3706$var$cities[city];
        categories.forEach((category)=>{
            if (metric === category) cityData[city][category] = value;
        });
    });
    return Object.entries(cityData).map(([city, data])=>({
            city: city,
            ...data
        }));
}
function $a59c66174eda3706$export$771046e941ba1965() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($1Opay))).map((c)=>({
            city: c[0],
            metric: c[1],
            year: c[2],
            value: c[3],
            isEstimate: c[4] ?? false
        }));
}
function $a59c66174eda3706$export$1d3d202e952b2622() {
    const sizes = $a59c66174eda3706$export$6d1731a321e8bdf4([
        "Bud\u017Cet",
        "Etaty: liczba stra\u017Cnik\xf3w",
        "Liczba mieszka\u0144c\xf3w"
    ]);
    sizes.forEach((sm)=>{
        sm.guardsPer100k = Math.round(sm["Etaty: liczba stra\u017Cnik\xf3w"] / sm["Liczba mieszka\u0144c\xf3w"] * 1000000) / 10;
    });
    sizes.forEach((sm)=>{
        sm.budgetPerCitizen = Math.round(sm["Bud\u017Cet"] / sm["Liczba mieszka\u0144c\xf3w"] * 10) / 10;
    });
    return sizes.sort((a, b)=>b.budgetPerCitizen - a.budgetPerCitizen);
}

});
parcelRegister("5QsV4", function(module, exports) {
module.exports = JSON.parse('{"cities":{"Warszawa":{"lat":52.2297,"lon":21.0122},"Krak\xf3w":{"lat":50.0647,"lon":19.945},"\u0141\xf3d\u017A":{"lat":51.7592,"lon":19.456},"Gda\u0144sk":{"lat":54.352,"lon":18.6466},"Wroc\u0142aw":{"lat":51.1079,"lon":17.0385},"Pozna\u0144":{"lat":52.4064,"lon":16.9252},"Bydgoszcz":{"lat":53.1235,"lon":18.0084},"Szczecin":{"lat":53.4285,"lon":14.5528},"Lublin":{"lat":51.2465,"lon":22.5684},"Bia\u0142ystok":{"lat":53.1325,"lon":23.1688},"Toru\u0144":{"lat":53.0138,"lon":18.5984},"Opole":{"lat":50.6751,"lon":17.9213},"Kielce":{"lat":50.8661,"lon":20.6286},"Olsztyn":{"lat":53.7784,"lon":20.4801},"Gorz\xf3w":{"lat":52.7368,"lon":15.2288},"Katowice":{"lat":50.2649,"lon":19.0238},"Rzesz\xf3w":{"lat":50.0412,"lon":21.9991},"Zielona G\xf3ra":{"lat":51.9356,"lon":15.5062}},"sm":[["Olsztyn","Bud\u017Cet",6817624],["Olsztyn","Etaty: liczba stra\u017Cnik\xf3w",44],["Olsztyn","Etaty: Nieobsadzone wakaty stra\u017Cnik\xf3w",13],["Olsztyn","Etaty: Mediana wynagrodze\u0144\xa0stra\u017Cnik\xf3w brutto",4900],["Olsztyn","Zg\u0142oszenia: liczba otrzymanych",12407],["Olsztyn","Zg\u0142oszenia: liczba otrzymanych dot. PRD",5036],["Olsztyn","Interwencje: liczba",16296],["Olsztyn","Interwencje: liczba dot. PRD",7031],["Olsztyn","Mandaty: liczba wystawionych",4117],["Olsztyn","Pouczenia: liczba",4934],["Olsztyn","Mandaty: warto\u015B\u0107",487360],["Olsztyn","Mandaty: liczba wystawionych dot. PRD",3189],["Olsztyn","Pouczenia: liczba dot. PRD",3880],["Olsztyn","Mandaty: warto\u015B\u0107 wystawionych dot. PRD",402600],["Olsztyn","Blokady: liczba",3604],["Olsztyn","Holowanie: nie-wraki \u0142\u0105cznie",226],["Olsztyn","Holowanie: utrudnianie ruchu",153],["Olsztyn","Holowanie: stwarzanie zagro\u017Cenia",12],["Olsztyn","Holowanie: DMC",null],["Olsztyn","Holowanie: niepe\u0142nosprawni",null],["Olsztyn","Holowanie: T-24",null],["Olsztyn","Holowanie: wraki",61],["Olsztyn","Liczba etat\xf3w og\xf3\u0142em",51],["Olsztyn","Liczba samochod\xf3w",null],["Olsztyn","Liczba rower\xf3w",null],["Olsztyn","Liczba koni",null],["Olsztyn","Liczba mieszka\u0144c\xf3w",170225],["Bia\u0142ystok","Czas reakcji: liczba zg\u0142osze\u0144",1242],["Bia\u0142ystok","Czas reakcji: liczba zamkni\u0119tych",23],["Bia\u0142ystok","Czas reakcji: \u015Bredni czas (dni)","72.78"],["Bydgoszcz","Czas reakcji: liczba zg\u0142osze\u0144",4208],["Bydgoszcz","Czas reakcji: liczba zamkni\u0119tych",555],["Bydgoszcz","Czas reakcji: \u015Bredni czas (dni)","184.71"],["Gda\u0144sk","Czas reakcji: liczba zg\u0142osze\u0144",8647],["Gda\u0144sk","Czas reakcji: liczba zamkni\u0119tych",3975],["Gda\u0144sk","Czas reakcji: \u015Bredni czas (dni)","86.09"],["Gorz\xf3w","Czas reakcji: liczba zg\u0142osze\u0144",58],["Gorz\xf3w","Czas reakcji: liczba zamkni\u0119tych",17],["Gorz\xf3w","Czas reakcji: \u015Bredni czas (dni)","254.25"],["Katowice","Czas reakcji: liczba zg\u0142osze\u0144",1044],["Katowice","Czas reakcji: liczba zamkni\u0119tych",17],["Katowice","Czas reakcji: \u015Bredni czas (dni)","90.9"],["Kielce","Czas reakcji: liczba zg\u0142osze\u0144",329],["Kielce","Czas reakcji: liczba zamkni\u0119tych",152],["Kielce","Czas reakcji: \u015Bredni czas (dni)","57.39"],["Krak\xf3w","Czas reakcji: liczba zg\u0142osze\u0144",3454],["Krak\xf3w","Czas reakcji: liczba zamkni\u0119tych",902],["Krak\xf3w","Czas reakcji: \u015Bredni czas (dni)","103.89"],["\u0141\xf3d\u017A","Czas reakcji: liczba zg\u0142osze\u0144",5234],["\u0141\xf3d\u017A","Czas reakcji: liczba zamkni\u0119tych",683],["\u0141\xf3d\u017A","Czas reakcji: \u015Bredni czas (dni)","102.3"],["Lublin","Czas reakcji: liczba zg\u0142osze\u0144",220],["Lublin","Czas reakcji: liczba zamkni\u0119tych",29],["Lublin","Czas reakcji: \u015Bredni czas (dni)","63.23"],["Olsztyn","Czas reakcji: liczba zg\u0142osze\u0144",427],["Olsztyn","Czas reakcji: liczba zamkni\u0119tych",67],["Olsztyn","Czas reakcji: \u015Bredni czas (dni)","10.41"],["Opole","Czas reakcji: liczba zg\u0142osze\u0144",3023],["Opole","Czas reakcji: liczba zamkni\u0119tych",1656],["Opole","Czas reakcji: \u015Bredni czas (dni)","102.87"],["Pozna\u0144","Czas reakcji: liczba zg\u0142osze\u0144",9589],["Pozna\u0144","Czas reakcji: liczba zamkni\u0119tych",518],["Pozna\u0144","Czas reakcji: \u015Bredni czas (dni)","185.01"],["Rzesz\xf3w","Czas reakcji: liczba zg\u0142osze\u0144",176],["Rzesz\xf3w","Czas reakcji: liczba zamkni\u0119tych",21],["Rzesz\xf3w","Czas reakcji: \u015Bredni czas (dni)","69.53"],["Szczecin","Czas reakcji: liczba zg\u0142osze\u0144",845],["Szczecin","Czas reakcji: liczba zamkni\u0119tych",54],["Szczecin","Czas reakcji: \u015Bredni czas (dni)","113.65"],["Toru\u0144","Czas reakcji: liczba zg\u0142osze\u0144",1320],["Toru\u0144","Czas reakcji: liczba zamkni\u0119tych",3],["Toru\u0144","Czas reakcji: \u015Bredni czas (dni)","50.58"],["Warszawa","Czas reakcji: liczba zg\u0142osze\u0144",58040],["Warszawa","Czas reakcji: liczba zamkni\u0119tych",1904],["Warszawa","Czas reakcji: \u015Bredni czas (dni)","220.11"],["Wroc\u0142aw","Czas reakcji: liczba zg\u0142osze\u0144",43241],["Wroc\u0142aw","Czas reakcji: liczba zamkni\u0119tych",526],["Wroc\u0142aw","Czas reakcji: \u015Bredni czas (dni)","103.55"],["Zielona G\xf3ra","Czas reakcji: liczba zg\u0142osze\u0144",488],["Zielona G\xf3ra","Czas reakcji: liczba zamkni\u0119tych",52],["Zielona G\xf3ra","Czas reakcji: \u015Bredni czas (dni)","47.27"],["Bia\u0142ystok","Policja: mandaty og\xf3\u0142em",44289],["Bydgoszcz","Policja: mandaty parkowanie",32],["Bydgoszcz","Policja: wykroczenia parkowanie",104],["Gda\u0144sk","Policja: mandaty og\xf3\u0142em",29080],["Gda\u0144sk","Policja: pouczenia og\xf3\u0142em",5081],["Gda\u0144sk","Policja: s\u0105d og\xf3\u0142em",4777],["Gda\u0144sk","Policja: wykroczenia og\xf3\u0142em",38938],["Gda\u0144sk","Policja: wykroczenia parkowanie",958],["Gorz\xf3w","Policja: mandaty og\xf3\u0142em",14990],["Gorz\xf3w","Policja: mandaty parkowanie",224],["Gorz\xf3w","Policja: pouczenia og\xf3\u0142em",2588],["Gorz\xf3w","Policja: s\u0105d og\xf3\u0142em",1129],["Gorz\xf3w","Policja: wykroczenia og\xf3\u0142em",18084],["Gorz\xf3w","Policja: wykroczenia parkowanie",234],["Katowice","Policja: mandaty og\xf3\u0142em",30232],["Katowice","Policja: pouczenia og\xf3\u0142em",8044],["Katowice","Policja: s\u0105d og\xf3\u0142em",2082],["Katowice","Policja: wykroczenia og\xf3\u0142em",40358],["Kielce","Policja: mandaty og\xf3\u0142em",12275],["Kielce","Policja: pouczenia og\xf3\u0142em",16173],["Kielce","Policja: s\u0105d og\xf3\u0142em",3399],["Kielce","Policja: wykroczenia og\xf3\u0142em",32770],["Lublin","Policja: mandaty og\xf3\u0142em",26428],["Lublin","Policja: pouczenia og\xf3\u0142em",8947],["Lublin","Policja: s\u0105d og\xf3\u0142em",2863],["Lublin","Policja: wykroczenia og\xf3\u0142em",37238],["Lublin","Policja: wykroczenia parkowanie",891],["\u0141\xf3d\u017A","Policja: wykroczenia parkowanie",1181],["Olsztyn","Policja: mandaty parkowanie",2623],["Opole","Policja: mandaty og\xf3\u0142em",4330],["Opole","Policja: mandaty parkowanie",152],["Opole","Policja: pouczenia og\xf3\u0142em",14595],["Opole","Policja: s\u0105d og\xf3\u0142em",1220],["Opole","Policja: s\u0105d parkowanie",7],["Opole","Policja: wykroczenia parkowanie",233],["Pozna\u0144","Policja: mandaty og\xf3\u0142em",54125],["Pozna\u0144","Policja: pouczenia og\xf3\u0142em",8009],["Pozna\u0144","Policja: s\u0105d og\xf3\u0142em",3123],["Pozna\u0144","Policja: wykroczenia og\xf3\u0142em",65257],["Rzesz\xf3w","Policja: mandaty parkowanie",2722],["Rzesz\xf3w","Policja: pouczenia parkowanie",null],["Rzesz\xf3w","Policja: s\u0105d parkowanie",48],["Rzesz\xf3w","Policja: wykroczenia parkowanie",2770],["Szczecin","Policja: mandaty og\xf3\u0142em",14524],["Szczecin","Policja: pouczenia og\xf3\u0142em",12669],["Szczecin","Policja: s\u0105d og\xf3\u0142em",3546],["Szczecin","Policja: wykroczenia og\xf3\u0142em",30739],["Szczecin","Policja: wykroczenia parkowanie",15252],["Toru\u0144","Policja: mandaty og\xf3\u0142em",20532],["Toru\u0144","Policja: pouczenia og\xf3\u0142em",6606],["Toru\u0144","Policja: s\u0105d og\xf3\u0142em",1024],["Toru\u0144","Policja: wykroczenia og\xf3\u0142em",28164],["Toru\u0144","Policja: wykroczenia parkowanie",121],["Warszawa","Policja: mandaty og\xf3\u0142em",100209],["Warszawa","Policja: mandaty parkowanie",4796],["Warszawa","Policja: pouczenia og\xf3\u0142em",75629],["Warszawa","Policja: pouczenia parkowanie",1272],["Warszawa","Policja: s\u0105d og\xf3\u0142em",6435],["Warszawa","Policja: s\u0105d parkowanie",415],["Warszawa","Policja: wykroczenia og\xf3\u0142em",183283],["Warszawa","Policja: wykroczenia parkowanie",29409],["Wroc\u0142aw","Policja: mandaty og\xf3\u0142em",21700],["Wroc\u0142aw","Policja: pouczenia og\xf3\u0142em",35161],["Wroc\u0142aw","Policja: s\u0105d og\xf3\u0142em",4367],["Wroc\u0142aw","Policja: wykroczenia og\xf3\u0142em",61228],["Wroc\u0142aw","Policja: wykroczenia parkowanie",602],["Zielona G\xf3ra","Policja: mandaty parkowanie",1761],["Krak\xf3w","Policja: mandaty parkowanie",2169.4199999999996],["Krak\xf3w","Policja: pouczenia parkowanie",1117.5800000000002],["Lublin","Bud\u017Cet",16052676],["Lublin","Etaty: liczba stra\u017Cnik\xf3w",110],["Lublin","Etaty: Nieobsadzone wakaty stra\u017Cnik\xf3w",10],["Lublin","Etaty: Mediana wynagrodze\u0144\xa0stra\u017Cnik\xf3w brutto",6288],["Lublin","Zg\u0142oszenia: liczba otrzymanych",26694],["Lublin","Zg\u0142oszenia: liczba otrzymanych dot. PRD",9533],["Lublin","Interwencje: liczba",36071],["Lublin","Interwencje: liczba dot. PRD",17401],["Lublin","Mandaty: liczba wystawionych",16684],["Lublin","Pouczenia: liczba",2700],["Lublin","Mandaty: warto\u015B\u0107",2380570],["Lublin","Mandaty: liczba wystawionych dot. PRD",13124],["Lublin","Pouczenia: liczba dot. PRD",1875],["Lublin","Mandaty: warto\u015B\u0107 wystawionych dot. PRD",1891960],["Lublin","Blokady: liczba",8350],["Lublin","Holowanie: nie-wraki \u0142\u0105cznie",1180],["Lublin","Holowanie: utrudnianie ruchu",null],["Lublin","Holowanie: stwarzanie zagro\u017Cenia",null],["Lublin","Holowanie: DMC",null],["Lublin","Holowanie: niepe\u0142nosprawni",60],["Lublin","Holowanie: T-24",null],["Lublin","Holowanie: wraki",4],["Lublin","Liczba etat\xf3w og\xf3\u0142em",130],["Lublin","Liczba samochod\xf3w",18],["Lublin","Liczba rower\xf3w",12],["Lublin","Liczba koni",null],["Lublin","Liczba mieszka\u0144c\xf3w",334681],["Kielce","Bud\u017Cet",8795000],["Kielce","Etaty: liczba stra\u017Cnik\xf3w",71],["Kielce","Etaty: Nieobsadzone wakaty stra\u017Cnik\xf3w",null],["Kielce","Etaty: Mediana wynagrodze\u0144\xa0stra\u017Cnik\xf3w brutto",5640],["Kielce","Zg\u0142oszenia: liczba otrzymanych",16038],["Kielce","Zg\u0142oszenia: liczba otrzymanych dot. PRD",7867],["Kielce","Interwencje: liczba",25653],["Kielce","Interwencje: liczba dot. PRD",7867],["Kielce","Mandaty: liczba wystawionych",6731],["Kielce","Pouczenia: liczba",3418],["Kielce","Mandaty: warto\u015B\u0107",740687],["Kielce","Mandaty: liczba wystawionych dot. PRD",4519],["Kielce","Pouczenia: liczba dot. PRD",2532],["Kielce","Mandaty: warto\u015B\u0107 wystawionych dot. PRD",532350],["Kielce","Blokady: liczba",5519],["Kielce","Holowanie: nie-wraki \u0142\u0105cznie",18],["Kielce","Holowanie: utrudnianie ruchu",null],["Kielce","Holowanie: stwarzanie zagro\u017Cenia",null],["Kielce","Holowanie: DMC",null],["Kielce","Holowanie: niepe\u0142nosprawni",null],["Kielce","Holowanie: T-24",null],["Kielce","Holowanie: wraki",19],["Kielce","Liczba etat\xf3w og\xf3\u0142em",null],["Kielce","Liczba samochod\xf3w",null],["Kielce","Liczba rower\xf3w",null],["Kielce","Liczba koni",null],["Kielce","Liczba mieszka\u0144c\xf3w",186838],["Rzesz\xf3w","Bud\u017Cet",6734308],["Rzesz\xf3w","Etaty: liczba stra\u017Cnik\xf3w",56],["Rzesz\xf3w","Etaty: Nieobsadzone wakaty stra\u017Cnik\xf3w",4],["Rzesz\xf3w","Etaty: Mediana wynagrodze\u0144\xa0stra\u017Cnik\xf3w brutto",null],["Rzesz\xf3w","Zg\u0142oszenia: liczba otrzymanych",null],["Rzesz\xf3w","Zg\u0142oszenia: liczba otrzymanych dot. PRD",null],["Rzesz\xf3w","Interwencje: liczba",null],["Rzesz\xf3w","Interwencje: liczba dot. PRD",null],["Rzesz\xf3w","Mandaty: liczba wystawionych",3422],["Rzesz\xf3w","Pouczenia: liczba",3545],["Rzesz\xf3w","Mandaty: warto\u015B\u0107",381600],["Rzesz\xf3w","Mandaty: liczba wystawionych dot. PRD",2759],["Rzesz\xf3w","Pouczenia: liczba dot. PRD",2767],["Rzesz\xf3w","Mandaty: warto\u015B\u0107 wystawionych dot. PRD",330950],["Rzesz\xf3w","Blokady: liczba",null],["Rzesz\xf3w","Holowanie: nie-wraki \u0142\u0105cznie",null],["Rzesz\xf3w","Holowanie: utrudnianie ruchu",null],["Rzesz\xf3w","Holowanie: stwarzanie zagro\u017Cenia",null],["Rzesz\xf3w","Holowanie: DMC",null],["Rzesz\xf3w","Holowanie: niepe\u0142nosprawni",null],["Rzesz\xf3w","Holowanie: T-24",null],["Rzesz\xf3w","Holowanie: wraki",null],["Rzesz\xf3w","Liczba etat\xf3w og\xf3\u0142em",64],["Rzesz\xf3w","Liczba samochod\xf3w",9],["Rzesz\xf3w","Liczba rower\xf3w",null],["Rzesz\xf3w","Liczba koni",null],["Rzesz\xf3w","Uwagi","Mam dane z 2023. Brak odpowiedzi na 2024. Gro\u017Aba wys\u0142ana 26.11"],["Rzesz\xf3w","Liczba mieszka\u0144c\xf3w",196638],["Katowice","Bud\u017Cet",19032023],["Katowice","Etaty: liczba stra\u017Cnik\xf3w",125],["Katowice","Etaty: Nieobsadzone wakaty stra\u017Cnik\xf3w",8],["Katowice","Etaty: Mediana wynagrodze\u0144\xa0stra\u017Cnik\xf3w brutto",5578],["Katowice","Zg\u0142oszenia: liczba otrzymanych",23311],["Katowice","Zg\u0142oszenia: liczba otrzymanych dot. PRD",12789],["Katowice","Interwencje: liczba",38224],["Katowice","Interwencje: liczba dot. PRD",23607],["Katowice","Mandaty: liczba wystawionych",14680],["Katowice","Pouczenia: liczba",2630],["Katowice","Mandaty: warto\u015B\u0107",1877670],["Katowice","Mandaty: liczba wystawionych dot. PRD",11890],["Katowice","Pouczenia: liczba dot. PRD",2413],["Katowice","Mandaty: warto\u015B\u0107 wystawionych dot. PRD",1442010],["Katowice","Blokady: liczba",4696],["Katowice","Holowanie: nie-wraki \u0142\u0105cznie",26],["Katowice","Holowanie: utrudnianie ruchu",26],["Katowice","Holowanie: stwarzanie zagro\u017Cenia",null],["Katowice","Holowanie: DMC",null],["Katowice","Holowanie: niepe\u0142nosprawni",null],["Katowice","Holowanie: T-24",null],["Katowice","Holowanie: wraki",84],["Katowice","Liczba etat\xf3w og\xf3\u0142em",143],["Katowice","Liczba samochod\xf3w",16],["Katowice","Liczba rower\xf3w",5],["Katowice","Liczba koni",null],["Katowice","Liczba mieszka\u0144c\xf3w",285711],["Wroc\u0142aw","Bud\u017Cet",44032796],["Wroc\u0142aw","Etaty: liczba stra\u017Cnik\xf3w",311],["Wroc\u0142aw","Etaty: Nieobsadzone wakaty stra\u017Cnik\xf3w",66],["Wroc\u0142aw","Etaty: Mediana wynagrodze\u0144\xa0stra\u017Cnik\xf3w brutto",8163],["Wroc\u0142aw","Zg\u0142oszenia: liczba otrzymanych",72408],["Wroc\u0142aw","Zg\u0142oszenia: liczba otrzymanych dot. PRD",54117],["Wroc\u0142aw","Interwencje: liczba",37972],["Wroc\u0142aw","Interwencje: liczba dot. PRD",34788],["Wroc\u0142aw","Mandaty: liczba wystawionych",20482],["Wroc\u0142aw","Pouczenia: liczba",8605],["Wroc\u0142aw","Mandaty: warto\u015B\u0107",3560710],["Wroc\u0142aw","Mandaty: liczba wystawionych dot. PRD",18380],["Wroc\u0142aw","Pouczenia: liczba dot. PRD",8030],["Wroc\u0142aw","Mandaty: warto\u015B\u0107 wystawionych dot. PRD",3165570],["Wroc\u0142aw","Blokady: liczba",610],["Wroc\u0142aw","Holowanie: nie-wraki \u0142\u0105cznie",2915],["Wroc\u0142aw","Holowanie: utrudnianie ruchu",115],["Wroc\u0142aw","Holowanie: stwarzanie zagro\u017Cenia",70],["Wroc\u0142aw","Holowanie: DMC",null],["Wroc\u0142aw","Holowanie: niepe\u0142nosprawni",232],["Wroc\u0142aw","Holowanie: T-24",2498],["Wroc\u0142aw","Holowanie: wraki",366],["Wroc\u0142aw","Liczba etat\xf3w og\xf3\u0142em",null],["Wroc\u0142aw","Liczba samochod\xf3w",null],["Wroc\u0142aw","Liczba rower\xf3w",null],["Wroc\u0142aw","Liczba koni",null],["Wroc\u0142aw","Liczba mieszka\u0144c\xf3w",672929],["Krak\xf3w","Bud\u017Cet",106269155],["Krak\xf3w","Etaty: liczba stra\u017Cnik\xf3w",421.75],["Krak\xf3w","Etaty: Nieobsadzone wakaty stra\u017Cnik\xf3w",7.5],["Krak\xf3w","Etaty: Mediana wynagrodze\u0144\xa0stra\u017Cnik\xf3w brutto",9792],["Krak\xf3w","Zg\u0142oszenia: liczba otrzymanych",108420],["Krak\xf3w","Zg\u0142oszenia: liczba otrzymanych dot. PRD",52231],["Krak\xf3w","Interwencje: liczba",null],["Krak\xf3w","Interwencje: liczba dot. PRD",null],["Krak\xf3w","Mandaty: liczba wystawionych",73303],["Krak\xf3w","Pouczenia: liczba",64482],["Krak\xf3w","Mandaty: warto\u015B\u0107",9056285],["Krak\xf3w","Mandaty: liczba wystawionych dot. PRD",42141],["Krak\xf3w","Pouczenia: liczba dot. PRD",44046],["Krak\xf3w","Mandaty: warto\u015B\u0107 wystawionych dot. PRD",5485085],["Krak\xf3w","Blokady: liczba",18165],["Krak\xf3w","Holowanie: nie-wraki \u0142\u0105cznie",867],["Krak\xf3w","Holowanie: utrudnianie ruchu",null],["Krak\xf3w","Holowanie: stwarzanie zagro\u017Cenia",null],["Krak\xf3w","Holowanie: DMC",null],["Krak\xf3w","Holowanie: niepe\u0142nosprawni",null],["Krak\xf3w","Holowanie: T-24",null],["Krak\xf3w","Holowanie: wraki",536],["Krak\xf3w","Liczba etat\xf3w og\xf3\u0142em",528.75],["Krak\xf3w","Liczba samochod\xf3w",89],["Krak\xf3w","Liczba rower\xf3w",44],["Krak\xf3w","Liczba koni",null],["Krak\xf3w","Liczba mieszka\u0144c\xf3w",800653],["Bia\u0142ystok","Bud\u017Cet",14968677],["Bia\u0142ystok","Etaty: liczba stra\u017Cnik\xf3w",105],["Bia\u0142ystok","Etaty: Nieobsadzone wakaty stra\u017Cnik\xf3w",null],["Bia\u0142ystok","Etaty: Mediana wynagrodze\u0144\xa0stra\u017Cnik\xf3w brutto",5835],["Bia\u0142ystok","Zg\u0142oszenia: liczba otrzymanych",27714],["Bia\u0142ystok","Zg\u0142oszenia: liczba otrzymanych dot. PRD",12643],["Bia\u0142ystok","Interwencje: liczba",15632],["Bia\u0142ystok","Interwencje: liczba dot. PRD",11361],["Bia\u0142ystok","Mandaty: liczba wystawionych",6503],["Bia\u0142ystok","Pouczenia: liczba",6075],["Bia\u0142ystok","Mandaty: warto\u015B\u0107",670580],["Bia\u0142ystok","Mandaty: liczba wystawionych dot. PRD",4651],["Bia\u0142ystok","Pouczenia: liczba dot. PRD",5367],["Bia\u0142ystok","Mandaty: warto\u015B\u0107 wystawionych dot. PRD",533580],["Bia\u0142ystok","Blokady: liczba",38],["Bia\u0142ystok","Holowanie: nie-wraki \u0142\u0105cznie",77],["Bia\u0142ystok","Holowanie: utrudnianie ruchu",null],["Bia\u0142ystok","Holowanie: stwarzanie zagro\u017Cenia",null],["Bia\u0142ystok","Holowanie: DMC",null],["Bia\u0142ystok","Holowanie: niepe\u0142nosprawni",null],["Bia\u0142ystok","Holowanie: T-24",null],["Bia\u0142ystok","Holowanie: wraki",78],["Bia\u0142ystok","Liczba etat\xf3w og\xf3\u0142em",145],["Bia\u0142ystok","Liczba samochod\xf3w",20],["Bia\u0142ystok","Liczba rower\xf3w",8],["Bia\u0142ystok","Liczba koni",null],["Bia\u0142ystok","Liczba mieszka\u0144c\xf3w",294242],["Bydgoszcz","Bud\u017Cet",22021328],["Bydgoszcz","Etaty: liczba stra\u017Cnik\xf3w",136],["Bydgoszcz","Etaty: Nieobsadzone wakaty stra\u017Cnik\xf3w",24.06],["Bydgoszcz","Etaty: Mediana wynagrodze\u0144\xa0stra\u017Cnik\xf3w brutto",null],["Bydgoszcz","Zg\u0142oszenia: liczba otrzymanych",28340],["Bydgoszcz","Zg\u0142oszenia: liczba otrzymanych dot. PRD",15043],["Bydgoszcz","Interwencje: liczba",null],["Bydgoszcz","Interwencje: liczba dot. PRD",null],["Bydgoszcz","Mandaty: liczba wystawionych",13087],["Bydgoszcz","Pouczenia: liczba",5631],["Bydgoszcz","Mandaty: warto\u015B\u0107",1736933.55],["Bydgoszcz","Mandaty: liczba wystawionych dot. PRD",9605],["Bydgoszcz","Pouczenia: liczba dot. PRD",3913],["Bydgoszcz","Mandaty: warto\u015B\u0107 wystawionych dot. PRD",1403923],["Bydgoszcz","Blokady: liczba",5090],["Bydgoszcz","Holowanie: nie-wraki \u0142\u0105cznie",1135],["Bydgoszcz","Holowanie: utrudnianie ruchu",null],["Bydgoszcz","Holowanie: stwarzanie zagro\u017Cenia",null],["Bydgoszcz","Holowanie: DMC",null],["Bydgoszcz","Holowanie: niepe\u0142nosprawni",null],["Bydgoszcz","Holowanie: T-24",null],["Bydgoszcz","Holowanie: wraki",63],["Bydgoszcz","Liczba etat\xf3w og\xf3\u0142em",null],["Bydgoszcz","Liczba samochod\xf3w",null],["Bydgoszcz","Liczba rower\xf3w",null],["Bydgoszcz","Liczba koni",null],["Bydgoszcz","Liczba mieszka\u0144c\xf3w",337666],["Gda\u0144sk","Bud\u017Cet",44613742],["Gda\u0144sk","Etaty: liczba stra\u017Cnik\xf3w",249],["Gda\u0144sk","Etaty: Nieobsadzone wakaty stra\u017Cnik\xf3w",52],["Gda\u0144sk","Etaty: Mediana wynagrodze\u0144\xa0stra\u017Cnik\xf3w brutto",5467],["Gda\u0144sk","Zg\u0142oszenia: liczba otrzymanych",22016],["Gda\u0144sk","Zg\u0142oszenia: liczba otrzymanych dot. PRD",12180],["Gda\u0144sk","Interwencje: liczba","sprawozdanie"],["Gda\u0144sk","Interwencje: liczba dot. PRD",28371],["Gda\u0144sk","Mandaty: liczba wystawionych",30689],["Gda\u0144sk","Pouczenia: liczba",2087],["Gda\u0144sk","Mandaty: warto\u015B\u0107",3298615],["Gda\u0144sk","Mandaty: liczba wystawionych dot. PRD",24102],["Gda\u0144sk","Pouczenia: liczba dot. PRD",1507],["Gda\u0144sk","Mandaty: warto\u015B\u0107 wystawionych dot. PRD",2822150],["Gda\u0144sk","Blokady: liczba",11029],["Gda\u0144sk","Holowanie: nie-wraki \u0142\u0105cznie",160],["Gda\u0144sk","Holowanie: utrudnianie ruchu",31],["Gda\u0144sk","Holowanie: stwarzanie zagro\u017Cenia",5],["Gda\u0144sk","Holowanie: DMC",null],["Gda\u0144sk","Holowanie: niepe\u0142nosprawni",33],["Gda\u0144sk","Holowanie: T-24",91],["Gda\u0144sk","Holowanie: wraki",167],["Gda\u0144sk","Liczba etat\xf3w og\xf3\u0142em",314],["Gda\u0144sk","Liczba samochod\xf3w",34],["Gda\u0144sk","Liczba rower\xf3w",15],["Gda\u0144sk","Liczba koni",null],["Gda\u0144sk","Liczba mieszka\u0144c\xf3w",486022],["Gorz\xf3w","Bud\u017Cet",2234705],["Gorz\xf3w","Etaty: liczba stra\u017Cnik\xf3w",17],["Gorz\xf3w","Etaty: Nieobsadzone wakaty stra\u017Cnik\xf3w",null],["Gorz\xf3w","Etaty: Mediana wynagrodze\u0144\xa0stra\u017Cnik\xf3w brutto",7475],["Gorz\xf3w","Zg\u0142oszenia: liczba otrzymanych",1101],["Gorz\xf3w","Zg\u0142oszenia: liczba otrzymanych dot. PRD",815],["Gorz\xf3w","Interwencje: liczba",9961],["Gorz\xf3w","Interwencje: liczba dot. PRD",4516],["Gorz\xf3w","Mandaty: liczba wystawionych",2075],["Gorz\xf3w","Pouczenia: liczba",5445],["Gorz\xf3w","Mandaty: warto\u015B\u0107",266114.5],["Gorz\xf3w","Mandaty: liczba wystawionych dot. PRD",1489],["Gorz\xf3w","Pouczenia: liczba dot. PRD",2979],["Gorz\xf3w","Mandaty: warto\u015B\u0107 wystawionych dot. PRD",186700],["Gorz\xf3w","Blokady: liczba",null],["Gorz\xf3w","Holowanie: nie-wraki \u0142\u0105cznie",248],["Gorz\xf3w","Holowanie: utrudnianie ruchu",15],["Gorz\xf3w","Holowanie: stwarzanie zagro\u017Cenia",18],["Gorz\xf3w","Holowanie: DMC",11],["Gorz\xf3w","Holowanie: niepe\u0142nosprawni",null],["Gorz\xf3w","Holowanie: T-24",204],["Gorz\xf3w","Holowanie: wraki",64],["Gorz\xf3w","Liczba etat\xf3w og\xf3\u0142em",19],["Gorz\xf3w","Liczba samochod\xf3w",3],["Gorz\xf3w","Liczba rower\xf3w",5],["Gorz\xf3w","Liczba koni",null],["Gorz\xf3w","Liczba mieszka\u0144c\xf3w",119964],["\u0141\xf3d\u017A","Bud\u017Cet",55873502],["\u0141\xf3d\u017A","Etaty: liczba stra\u017Cnik\xf3w",333],["\u0141\xf3d\u017A","Etaty: Nieobsadzone wakaty stra\u017Cnik\xf3w",66],["\u0141\xf3d\u017A","Etaty: Mediana wynagrodze\u0144\xa0stra\u017Cnik\xf3w brutto",6274],["\u0141\xf3d\u017A","Zg\u0142oszenia: liczba otrzymanych",40866],["\u0141\xf3d\u017A","Zg\u0142oszenia: liczba otrzymanych dot. PRD",20264],["\u0141\xf3d\u017A","Interwencje: liczba",42372],["\u0141\xf3d\u017A","Interwencje: liczba dot. PRD",17867],["\u0141\xf3d\u017A","Mandaty: liczba wystawionych",21330],["\u0141\xf3d\u017A","Pouczenia: liczba",12875],["\u0141\xf3d\u017A","Mandaty: warto\u015B\u0107",2564455],["\u0141\xf3d\u017A","Mandaty: liczba wystawionych dot. PRD",15264],["\u0141\xf3d\u017A","Pouczenia: liczba dot. PRD",6414],["\u0141\xf3d\u017A","Mandaty: warto\u015B\u0107 wystawionych dot. PRD",2010740],["\u0141\xf3d\u017A","Blokady: liczba",6404],["\u0141\xf3d\u017A","Holowanie: nie-wraki \u0142\u0105cznie",534],["\u0141\xf3d\u017A","Holowanie: utrudnianie ruchu",null],["\u0141\xf3d\u017A","Holowanie: stwarzanie zagro\u017Cenia",null],["\u0141\xf3d\u017A","Holowanie: DMC",null],["\u0141\xf3d\u017A","Holowanie: niepe\u0142nosprawni",null],["\u0141\xf3d\u017A","Holowanie: T-24",null],["\u0141\xf3d\u017A","Holowanie: wraki",282],["\u0141\xf3d\u017A","Liczba etat\xf3w og\xf3\u0142em",406],["\u0141\xf3d\u017A","Liczba samochod\xf3w",51],["\u0141\xf3d\u017A","Liczba rower\xf3w",35],["\u0141\xf3d\u017A","Liczba koni",8],["\u0141\xf3d\u017A","Liczba mieszka\u0144c\xf3w",670642],["Opole","Bud\u017Cet",9333324],["Opole","Etaty: liczba stra\u017Cnik\xf3w",44],["Opole","Etaty: Nieobsadzone wakaty stra\u017Cnik\xf3w",18],["Opole","Etaty: Mediana wynagrodze\u0144\xa0stra\u017Cnik\xf3w brutto",7320],["Opole","Zg\u0142oszenia: liczba otrzymanych",9183],["Opole","Zg\u0142oszenia: liczba otrzymanych dot. PRD",4703],["Opole","Interwencje: liczba",22872],["Opole","Interwencje: liczba dot. PRD",9996],["Opole","Mandaty: liczba wystawionych",2623],["Opole","Pouczenia: liczba",3640],["Opole","Mandaty: warto\u015B\u0107",239940],["Opole","Mandaty: liczba wystawionych dot. PRD",1915],["Opole","Pouczenia: liczba dot. PRD",3117],["Opole","Mandaty: warto\u015B\u0107 wystawionych dot. PRD",205890],["Opole","Blokady: liczba",891],["Opole","Holowanie: nie-wraki \u0142\u0105cznie",129],["Opole","Holowanie: utrudnianie ruchu",63],["Opole","Holowanie: stwarzanie zagro\u017Cenia",23],["Opole","Holowanie: DMC",null],["Opole","Holowanie: niepe\u0142nosprawni",4],["Opole","Holowanie: T-24",39],["Opole","Holowanie: wraki",26],["Opole","Liczba etat\xf3w og\xf3\u0142em",65],["Opole","Liczba samochod\xf3w",10],["Opole","Liczba rower\xf3w",8],["Opole","Liczba koni",null],["Opole","Liczba mieszka\u0144c\xf3w",127387],["Pozna\u0144","Bud\u017Cet",41079987],["Pozna\u0144","Etaty: liczba stra\u017Cnik\xf3w",248],["Pozna\u0144","Etaty: Nieobsadzone wakaty stra\u017Cnik\xf3w",14],["Pozna\u0144","Etaty: Mediana wynagrodze\u0144\xa0stra\u017Cnik\xf3w brutto",6018],["Pozna\u0144","Zg\u0142oszenia: liczba otrzymanych",80037],["Pozna\u0144","Zg\u0142oszenia: liczba otrzymanych dot. PRD",46137],["Pozna\u0144","Interwencje: liczba",null],["Pozna\u0144","Interwencje: liczba dot. PRD",null],["Pozna\u0144","Mandaty: liczba wystawionych",51715],["Pozna\u0144","Pouczenia: liczba",4766],["Pozna\u0144","Mandaty: warto\u015B\u0107",6330130],["Pozna\u0144","Mandaty: liczba wystawionych dot. PRD",42439],["Pozna\u0144","Pouczenia: liczba dot. PRD",3779],["Pozna\u0144","Mandaty: warto\u015B\u0107 wystawionych dot. PRD",5305620],["Pozna\u0144","Blokady: liczba",16756],["Pozna\u0144","Holowanie: nie-wraki \u0142\u0105cznie",1206],["Pozna\u0144","Holowanie: utrudnianie ruchu",228],["Pozna\u0144","Holowanie: stwarzanie zagro\u017Cenia",42],["Pozna\u0144","Holowanie: DMC",null],["Pozna\u0144","Holowanie: niepe\u0142nosprawni",77],["Pozna\u0144","Holowanie: T-24",379],["Pozna\u0144","Holowanie: wraki",194],["Pozna\u0144","Liczba etat\xf3w og\xf3\u0142em",309],["Pozna\u0144","Liczba samochod\xf3w",33],["Pozna\u0144","Liczba rower\xf3w",33],["Pozna\u0144","Liczba koni",null],["Pozna\u0144","Liczba mieszka\u0144c\xf3w",546859],["Szczecin","Bud\u017Cet",18537592],["Szczecin","Etaty: liczba stra\u017Cnik\xf3w",118],["Szczecin","Etaty: Nieobsadzone wakaty stra\u017Cnik\xf3w",4.75],["Szczecin","Etaty: Mediana wynagrodze\u0144\xa0stra\u017Cnik\xf3w brutto",5175],["Szczecin","Zg\u0142oszenia: liczba otrzymanych",34644],["Szczecin","Zg\u0142oszenia: liczba otrzymanych dot. PRD",13397],["Szczecin","Interwencje: liczba",44418],["Szczecin","Interwencje: liczba dot. PRD",39510],["Szczecin","Mandaty: liczba wystawionych",11992],["Szczecin","Pouczenia: liczba",4457],["Szczecin","Mandaty: warto\u015B\u0107",2902408],["Szczecin","Mandaty: liczba wystawionych dot. PRD",11057],["Szczecin","Pouczenia: liczba dot. PRD",4001],["Szczecin","Mandaty: warto\u015B\u0107 wystawionych dot. PRD",2723880],["Szczecin","Blokady: liczba",3499],["Szczecin","Holowanie: nie-wraki \u0142\u0105cznie",925],["Szczecin","Holowanie: utrudnianie ruchu",286],["Szczecin","Holowanie: stwarzanie zagro\u017Cenia",null],["Szczecin","Holowanie: DMC",null],["Szczecin","Holowanie: niepe\u0142nosprawni",70],["Szczecin","Holowanie: T-24",569],["Szczecin","Holowanie: wraki",260],["Szczecin","Liczba etat\xf3w og\xf3\u0142em",137.25],["Szczecin","Liczba samochod\xf3w",34],["Szczecin","Liczba rower\xf3w",2],["Szczecin","Liczba koni",null],["Szczecin","Liczba mieszka\u0144c\xf3w",396168],["Toru\u0144","Bud\u017Cet",14613400],["Toru\u0144","Etaty: liczba stra\u017Cnik\xf3w",106],["Toru\u0144","Etaty: Nieobsadzone wakaty stra\u017Cnik\xf3w",9],["Toru\u0144","Etaty: Mediana wynagrodze\u0144\xa0stra\u017Cnik\xf3w brutto",7012.4],["Toru\u0144","Zg\u0142oszenia: liczba otrzymanych",18334],["Toru\u0144","Zg\u0142oszenia: liczba otrzymanych dot. PRD",8331],["Toru\u0144","Interwencje: liczba",19675],["Toru\u0144","Interwencje: liczba dot. PRD",13877],["Toru\u0144","Mandaty: liczba wystawionych",7030],["Toru\u0144","Pouczenia: liczba",10771],["Toru\u0144","Mandaty: warto\u015B\u0107",920020],["Toru\u0144","Mandaty: liczba wystawionych dot. PRD",5967],["Toru\u0144","Pouczenia: liczba dot. PRD",7455],["Toru\u0144","Mandaty: warto\u015B\u0107 wystawionych dot. PRD",781770],["Toru\u0144","Blokady: liczba",2768],["Toru\u0144","Holowanie: nie-wraki \u0142\u0105cznie",13],["Toru\u0144","Holowanie: utrudnianie ruchu",1],["Toru\u0144","Holowanie: stwarzanie zagro\u017Cenia",null],["Toru\u0144","Holowanie: DMC",null],["Toru\u0144","Holowanie: niepe\u0142nosprawni",6],["Toru\u0144","Holowanie: T-24",6],["Toru\u0144","Holowanie: wraki",23],["Toru\u0144","Liczba etat\xf3w og\xf3\u0142em",125.25],["Toru\u0144","Liczba samochod\xf3w",null],["Toru\u0144","Liczba rower\xf3w",null],["Toru\u0144","Liczba koni",null],["Toru\u0144","Liczba mieszka\u0144c\xf3w",198273],["Warszawa","Bud\u017Cet",260599049],["Warszawa","Etaty: liczba stra\u017Cnik\xf3w",1271.5],["Warszawa","Etaty: Nieobsadzone wakaty stra\u017Cnik\xf3w",292],["Warszawa","Etaty: Mediana wynagrodze\u0144\xa0stra\u017Cnik\xf3w brutto",8020],["Warszawa","Zg\u0142oszenia: liczba otrzymanych",410120],["Warszawa","Zg\u0142oszenia: liczba otrzymanych dot. PRD",210112],["Warszawa","Interwencje: liczba",null],["Warszawa","Interwencje: liczba dot. PRD",null],["Warszawa","Mandaty: liczba wystawionych",101096],["Warszawa","Pouczenia: liczba",51543],["Warszawa","Mandaty: warto\u015B\u0107",16907646],["Warszawa","Mandaty: liczba wystawionych dot. PRD",81566],["Warszawa","Pouczenia: liczba dot. PRD",33159],["Warszawa","Mandaty: warto\u015B\u0107 wystawionych dot. PRD",14479089],["Warszawa","Blokady: liczba",8523],["Warszawa","Holowanie: nie-wraki \u0142\u0105cznie",14840],["Warszawa","Holowanie: utrudnianie ruchu",5398],["Warszawa","Holowanie: stwarzanie zagro\u017Cenia",null],["Warszawa","Holowanie: DMC",null],["Warszawa","Holowanie: niepe\u0142nosprawni",1204],["Warszawa","Holowanie: T-24",8238],["Warszawa","Holowanie: wraki",1642],["Warszawa","Liczba etat\xf3w og\xf3\u0142em",1616],["Warszawa","Liczba samochod\xf3w",260],["Warszawa","Liczba rower\xf3w",127],["Warszawa","Liczba koni",null],["Warszawa","Liczba mieszka\u0144c\xf3w",1860281],["Zielona G\xf3ra","Bud\u017Cet",412650],["Zielona G\xf3ra","Etaty: liczba stra\u017Cnik\xf3w",14],["Zielona G\xf3ra","Etaty: Nieobsadzone wakaty stra\u017Cnik\xf3w",null],["Zielona G\xf3ra","Etaty: Mediana wynagrodze\u0144\xa0stra\u017Cnik\xf3w brutto",7395.53],["Zielona G\xf3ra","Zg\u0142oszenia: liczba otrzymanych",3104],["Zielona G\xf3ra","Zg\u0142oszenia: liczba otrzymanych dot. PRD",1157],["Zielona G\xf3ra","Interwencje: liczba",4034],["Zielona G\xf3ra","Interwencje: liczba dot. PRD",null],["Zielona G\xf3ra","Mandaty: liczba wystawionych",59],["Zielona G\xf3ra","Pouczenia: liczba",318],["Zielona G\xf3ra","Mandaty: warto\u015B\u0107",11700],["Zielona G\xf3ra","Mandaty: liczba wystawionych dot. PRD",8],["Zielona G\xf3ra","Pouczenia: liczba dot. PRD",143],["Zielona G\xf3ra","Mandaty: warto\u015B\u0107 wystawionych dot. PRD",1650],["Zielona G\xf3ra","Blokady: liczba",null],["Zielona G\xf3ra","Holowanie: nie-wraki \u0142\u0105cznie",null],["Zielona G\xf3ra","Holowanie: utrudnianie ruchu",null],["Zielona G\xf3ra","Holowanie: stwarzanie zagro\u017Cenia",null],["Zielona G\xf3ra","Holowanie: DMC",null],["Zielona G\xf3ra","Holowanie: niepe\u0142nosprawni",null],["Zielona G\xf3ra","Holowanie: T-24",null],["Zielona G\xf3ra","Holowanie: wraki",54],["Zielona G\xf3ra","Liczba etat\xf3w og\xf3\u0142em",14],["Zielona G\xf3ra","Liczba samochod\xf3w",3],["Zielona G\xf3ra","Liczba rower\xf3w",2],["Zielona G\xf3ra","Liczba koni",null],["Zielona G\xf3ra","Uwagi","Dopyta\u0142em o bud\u017Cet i \u015Brednie wynagrodzenie 26.11"],["Zielona G\xf3ra","Liczba mieszka\u0144c\xf3w",140002]],"research":[{"city":"Szczecin","count":1085,"area":"\u015Ar\xf3dmie\u015Bcie","residentPercent":15,"source":"Szczecin Polityka Parkingowa etap I, s. 35, 49"},{"city":"Kielce","count":743,"area":"SPP oraz obszar przyleg\u0142y (Sektory 1, 2, 3)","residentPercent":10,"source":"Polityka parkingowa - raport g\u0142\xf3wny, s. 21, 55"},{"city":"\u0141\xf3d\u017A","count":2337,"area":"SPP","residentPercent":15,"source":"Sprawozdanie z Badania SPP w \u0141odzi, s. 45"},{"city":"Gorz\xf3w","count":555,"area":"Obecna i planowana SPP","residentPercent":8,"source":"Gorz\xf3w badanie.pdf, s. 102, 106"},{"city":"Rzesz\xf3w","count":301,"area":"SPP","residentPercent":5,"source":"Analiza funkcjonowania SPP, s. 30"},{"city":"Pozna\u0144","count":119,"area":"Fragment SPP na Je\u017Cycach","residentPercent":1,"source":"180820 Opracowanie ko\u0144cowe v. 1.0.pdf, s. 9"},{"city":"Warszawa","count":1127,"area":"Po\u0142udniowa cz\u0119\u015B\u0107 dzielnicy Mokot\xf3w","residentPercent":3,"source":"Raport Warszawa Mokotow strefa2.pdf, s. 15"}]}');

});

parcelRegister("1Opay", function(module, exports) {
module.exports = JSON.parse('[["Warszawa","Liczba wyznaczonych miejsc postojowych",2024,65830],["Warszawa","Liczba miejsc kubaturowych",2024,537],["Warszawa","Liczba sprzedanych abonament\xf3w w sumie",2024,66246],["Warszawa","Liczba wydanych uprawnie\u0144 do parkowania bez op\u0142at",2024,2096],["Warszawa","Suma zebranych op\u0142at za post\xf3j",2024,266645000],["Warszawa","\u0141\u0105czna liczba wystawionych wezwa\u0144 do zap\u0142aty za z\u0142amanie regulaminu parkowania",2024,411784],["Warszawa","\u0141\u0105czna kwota pobranych op\u0142at za z\u0142amanie regulaminu parkowania",2024,61733000],["Gda\u0144sk","Liczba wyznaczonych miejsc postojowych",2024,8878],["Gda\u0144sk","Liczba miejsc kubaturowych",2024,378],["Gda\u0144sk","Liczba sprzedanych abonament\xf3w w sumie",2024,7764],["Gda\u0144sk","\u0141\u0105czny wp\u0142yw z abonament\xf3w",2024,1303460],["Gda\u0144sk","Liczba wydanych uprawnie\u0144 do parkowania bez op\u0142at",2024,2362],["Gda\u0144sk","Suma zebranych op\u0142at za post\xf3j",2024,32237677.29],["Gda\u0144sk","\u0141\u0105czna liczba wystawionych wezwa\u0144 do zap\u0142aty za z\u0142amanie regulaminu parkowania",2024,69758],["Gda\u0144sk","\u0141\u0105czna kwota pobranych op\u0142at za z\u0142amanie regulaminu parkowania",2024,9470812.57],["Krak\xf3w","Liczba wyznaczonych miejsc postojowych",2024,20800],["Krak\xf3w","Liczba miejsc kubaturowych",2024,335],["Krak\xf3w","Liczba sprzedanych abonament\xf3w w sumie",2024,41719],["Krak\xf3w","Liczba sprzedanych abonament\xf3w dniowych",2024,1322],["Krak\xf3w","Liczba sprzedanych abonament\xf3w miesi\u0119cznych",2024,9568],["Krak\xf3w","\u0141\u0105czny wp\u0142yw z abonament\xf3w",2024,10438270.49],["Krak\xf3w","Liczba wydanych uprawnie\u0144 do parkowania bez op\u0142at",2024,893],["Krak\xf3w","Suma zebranych op\u0142at za post\xf3j",2024,110703348.93],["Krak\xf3w","\u0141\u0105czna liczba wystawionych wezwa\u0144 do zap\u0142aty za z\u0142amanie regulaminu parkowania",2024,121032],["Krak\xf3w","\u0141\u0105czna kwota pobranych op\u0142at za z\u0142amanie regulaminu parkowania",2024,14659950.82],["Wroc\u0142aw","Liczba wyznaczonych miejsc postojowych",2024,9369],["Wroc\u0142aw","Liczba miejsc kubaturowych",2024,984],["Wroc\u0142aw","\u0141\u0105czny wp\u0142yw z abonament\xf3w",2024,2802943.74],["Wroc\u0142aw","Liczba wydanych uprawnie\u0144 do parkowania bez op\u0142at",2024,2669],["Wroc\u0142aw","Suma zebranych op\u0142at za post\xf3j",2024,40449409.92],["Wroc\u0142aw","\u0141\u0105czna liczba wystawionych wezwa\u0144 do zap\u0142aty za z\u0142amanie regulaminu parkowania",2024,74948],["Wroc\u0142aw","\u0141\u0105czna kwota pobranych op\u0142at za z\u0142amanie regulaminu parkowania",2024,10173467.64],["Pozna\u0144","Liczba wyznaczonych miejsc postojowych",2024,14670],["Pozna\u0144","Liczba miejsc kubaturowych",2024,0],["Pozna\u0144","Liczba sprzedanych abonament\xf3w w sumie",2024,18890],["Pozna\u0144","\u0141\u0105czny wp\u0142yw z abonament\xf3w",2024,4357630],["Pozna\u0144","Liczba wydanych uprawnie\u0144 do parkowania bez op\u0142at",2024,1421],["Pozna\u0144","Suma zebranych op\u0142at za post\xf3j",2024,73078610.83],["Pozna\u0144","\u0141\u0105czna liczba wystawionych wezwa\u0144 do zap\u0142aty za z\u0142amanie regulaminu parkowania",2024,84471],["Pozna\u0144","\u0141\u0105czna kwota pobranych op\u0142at za z\u0142amanie regulaminu parkowania",2024,18583620,true],["Szczecin","Liczba wyznaczonych miejsc postojowych",2024,12000],["Szczecin","Liczba sprzedanych abonament\xf3w w sumie",2024,109624],["Szczecin","Liczba sprzedanych abonament\xf3w dniowych",2024,65814],["Szczecin","Liczba sprzedanych abonament\xf3w miesi\u0119cznych",2024,30839],["Szczecin","Liczba sprzedanych abonament\xf3w p\xf3\u0142rocznych",2024,3931],["Szczecin","Liczba sprzedanych abonament\xf3w rocznych",2024,3020],["Szczecin","\u0141\u0105czny wp\u0142yw z abonament\xf3w",2024,9595120],["Szczecin","Liczba wydanych uprawnie\u0144 do parkowania bez op\u0142at",2024,1273],["Szczecin","Suma zebranych op\u0142at za post\xf3j",2024,33098108.39],["Szczecin","\u0141\u0105czna liczba wystawionych wezwa\u0144 do zap\u0142aty za z\u0142amanie regulaminu parkowania",2024,106765],["Szczecin","\u0141\u0105czna liczba pobranych op\u0142at za z\u0142amanie regulaminu parkowania",2024,36309],["Szczecin","\u0141\u0105czna kwota pobranych op\u0142at za z\u0142amanie regulaminu parkowania",2024,3883894.69],["Bydgoszcz","Liczba wyznaczonych miejsc postojowych",2024,4257],["Bydgoszcz","Liczba miejsc kubaturowych",2024,285],["Bydgoszcz","Liczba sprzedanych abonament\xf3w w sumie",2024,13236],["Bydgoszcz","Liczba sprzedanych abonament\xf3w miesi\u0119cznych",2024,10173],["Bydgoszcz","Liczba sprzedanych abonament\xf3w kwartalnych",2024,2197],["Bydgoszcz","Liczba sprzedanych abonament\xf3w p\xf3\u0142rocznych",2024,567],["Bydgoszcz","Liczba sprzedanych abonament\xf3w rocznych",2024,299],["Bydgoszcz","\u0141\u0105czny wp\u0142yw z abonament\xf3w",2024,877295],["Bydgoszcz","Liczba wydanych uprawnie\u0144 do parkowania bez op\u0142at",2024,541],["Bydgoszcz","Suma zebranych op\u0142at za post\xf3j",2024,9023068.36],["Bydgoszcz","\u0141\u0105czna liczba wystawionych wezwa\u0144 do zap\u0142aty za z\u0142amanie regulaminu parkowania",2024,17544],["Bydgoszcz","\u0141\u0105czna kwota pobranych op\u0142at za z\u0142amanie regulaminu parkowania",2024,1660952.56],["Katowice","Liczba wyznaczonych miejsc postojowych",2024,9057],["Katowice","Liczba miejsc kubaturowych",2024,0],["Katowice","Liczba sprzedanych abonament\xf3w w sumie",2024,22896],["Katowice","\u0141\u0105czny wp\u0142yw z abonament\xf3w",2024,2300000],["Katowice","Liczba wydanych uprawnie\u0144 do parkowania bez op\u0142at",2024,0],["Katowice","Suma zebranych op\u0142at za post\xf3j",2024,28600000],["Katowice","\u0141\u0105czna liczba pobranych op\u0142at za z\u0142amanie regulaminu parkowania",2024,14400],["Katowice","\u0141\u0105czna kwota pobranych op\u0142at za z\u0142amanie regulaminu parkowania",2024,1900000],["Bia\u0142ystok","Liczba wyznaczonych miejsc postojowych",2024,3700],["Bia\u0142ystok","Liczba miejsc kubaturowych",2024,0],["Bia\u0142ystok","Liczba sprzedanych abonament\xf3w w sumie",2024,2267],["Bia\u0142ystok","Liczba sprzedanych abonament\xf3w miesi\u0119cznych",2024,472],["Bia\u0142ystok","Liczba sprzedanych abonament\xf3w kwartalnych",2024,256],["Bia\u0142ystok","Liczba sprzedanych abonament\xf3w p\xf3\u0142rocznych",2024,303],["Bia\u0142ystok","Liczba sprzedanych abonament\xf3w rocznych",2024,1236],["Bia\u0142ystok","\u0141\u0105czny wp\u0142yw z abonament\xf3w",2024,981833],["Bia\u0142ystok","Liczba wydanych uprawnie\u0144 do parkowania bez op\u0142at",2024,0],["Bia\u0142ystok","Suma zebranych op\u0142at za post\xf3j",2024,12197042.53],["Bia\u0142ystok","\u0141\u0105czna liczba wystawionych wezwa\u0144 do zap\u0142aty za z\u0142amanie regulaminu parkowania",2024,17412],["Bia\u0142ystok","\u0141\u0105czna kwota pobranych op\u0142at za z\u0142amanie regulaminu parkowania",2024,1300318.27],["Opole","Liczba miejsc kubaturowych",2024,343],["Opole","Liczba sprzedanych abonament\xf3w w sumie",2024,2600],["Opole","Liczba wydanych uprawnie\u0144 do parkowania bez op\u0142at",2024,0],["Opole","Koszt op\u0142aty dodatkowej za z\u0142amanie regulaminu parkowania",2024,120],["Opole","Suma zebranych op\u0142at za post\xf3j",2024,8442277],["Opole","\u0141\u0105czna liczba wystawionych wezwa\u0144 do zap\u0142aty za z\u0142amanie regulaminu parkowania",2024,29350],["Opole","\u0141\u0105czna kwota pobranych op\u0142at za z\u0142amanie regulaminu parkowania",2024,1761000,true],["Kielce","Liczba wyznaczonych miejsc postojowych",2024,2000],["Kielce","Liczba miejsc kubaturowych",2024,0],["Kielce","Liczba sprzedanych abonament\xf3w w sumie",2024,2318],["Kielce","Liczba sprzedanych abonament\xf3w dniowych",2024,182],["Kielce","\u0141\u0105czny wp\u0142yw z abonament\xf3w",2024,833680],["Kielce","Liczba wydanych uprawnie\u0144 do parkowania bez op\u0142at",2024,2341],["Kielce","Suma zebranych op\u0142at za post\xf3j",2024,3446787.1],["Kielce","\u0141\u0105czna liczba wystawionych wezwa\u0144 do zap\u0142aty za z\u0142amanie regulaminu parkowania",2024,13801],["Kielce","\u0141\u0105czna kwota pobranych op\u0142at za z\u0142amanie regulaminu parkowania",2024,1914100],["Lublin","Liczba wyznaczonych miejsc postojowych",2024,2740],["Lublin","Liczba miejsc kubaturowych",2024,0],["Lublin","Liczba sprzedanych abonament\xf3w w sumie",2024,4912],["Lublin","Liczba wydanych uprawnie\u0144 do parkowania bez op\u0142at",2024,12],["Toru\u0144","Liczba sprzedanych abonament\xf3w w sumie",2024,4646],["Toru\u0144","\u0141\u0105czny wp\u0142yw z abonament\xf3w",2024,398584],["Toru\u0144","Liczba wydanych uprawnie\u0144 do parkowania bez op\u0142at",2024,70],["Toru\u0144","Suma zebranych op\u0142at za post\xf3j",2024,9701640],["Toru\u0144","\u0141\u0105czna kwota pobranych op\u0142at za z\u0142amanie regulaminu parkowania",2024,892790.15],["\u0141\xf3d\u017A","Liczba wyznaczonych miejsc postojowych",2023,7273960],["\u0141\xf3d\u017A","Liczba miejsc kubaturowych",2023,0],["\u0141\xf3d\u017A","Liczba sprzedanych abonament\xf3w w sumie",2023,4184],["\u0141\xf3d\u017A","Liczba sprzedanych abonament\xf3w miesi\u0119cznych",2023,31],["\u0141\xf3d\u017A","Liczba sprzedanych abonament\xf3w kwartalnych",2023,130],["\u0141\xf3d\u017A","Liczba sprzedanych abonament\xf3w rocznych",2023,203],["\u0141\xf3d\u017A","\u0141\u0105czny wp\u0142yw z abonament\xf3w",2023,1518030],["\u0141\xf3d\u017A","Liczba wydanych uprawnie\u0144 do parkowania bez op\u0142at",2023,4801],["\u0141\xf3d\u017A","Koszt op\u0142aty dodatkowej za z\u0142amanie regulaminu parkowania",2023,200],["\u0141\xf3d\u017A","Suma zebranych op\u0142at za post\xf3j",2023,17677567],["\u0141\xf3d\u017A","\u0141\u0105czna kwota pobranych op\u0142at za z\u0142amanie regulaminu parkowania",2023,5692492],["Rzesz\xf3w","Liczba wyznaczonych miejsc postojowych",2023,3491],["Rzesz\xf3w","Liczba miejsc kubaturowych",2023,510],["Rzesz\xf3w","Liczba sprzedanych abonament\xf3w w sumie",2023,37464],["Rzesz\xf3w","\u0141\u0105czny wp\u0142yw z abonament\xf3w",2023,938585],["Rzesz\xf3w","Liczba wydanych uprawnie\u0144 do parkowania bez op\u0142at",2023,0],["Rzesz\xf3w","Koszt op\u0142aty dodatkowej za z\u0142amanie regulaminu parkowania",2023,200],["Rzesz\xf3w","Suma zebranych op\u0142at za post\xf3j",2023,10565545.29],["Rzesz\xf3w","\u0141\u0105czna kwota pobranych op\u0142at za z\u0142amanie regulaminu parkowania",2023,687627],["Gorz\xf3w","Liczba wyznaczonych miejsc postojowych",2023,1170],["Gorz\xf3w","Liczba miejsc kubaturowych",2023,0],["Gorz\xf3w","Liczba sprzedanych abonament\xf3w w sumie",2023,1034],["Gorz\xf3w","Liczba sprzedanych abonament\xf3w miesi\u0119cznych",2023,641],["Gorz\xf3w","Liczba sprzedanych abonament\xf3w rocznych",2023,372],["Gorz\xf3w","\u0141\u0105czny wp\u0142yw z abonament\xf3w",2023,263800],["Gorz\xf3w","Koszt op\u0142aty dodatkowej za z\u0142amanie regulaminu parkowania",2023,200],["Gorz\xf3w","Suma zebranych op\u0142at za post\xf3j",2023,2942511.17],["Gorz\xf3w","\u0141\u0105czna liczba pobranych op\u0142at za z\u0142amanie regulaminu parkowania",2023,1090],["Gorz\xf3w","\u0141\u0105czna kwota pobranych op\u0142at za z\u0142amanie regulaminu parkowania",2023,54500],["Olsztyn","Liczba wyznaczonych miejsc postojowych",2023,2400],["Olsztyn","Liczba miejsc kubaturowych",2023,0],["Olsztyn","Liczba sprzedanych abonament\xf3w w sumie",2023,1178],["Olsztyn","Liczba sprzedanych abonament\xf3w miesi\u0119cznych",2023,316],["Olsztyn","Liczba sprzedanych abonament\xf3w p\xf3\u0142rocznych",2023,862],["Olsztyn","\u0141\u0105czny wp\u0142yw z abonament\xf3w",2023,938500],["Olsztyn","Koszt op\u0142aty dodatkowej za z\u0142amanie regulaminu parkowania",2023,150],["Olsztyn","Suma zebranych op\u0142at za post\xf3j",2023,5775082],["Olsztyn","\u0141\u0105czna liczba pobranych op\u0142at za z\u0142amanie regulaminu parkowania",2023,2426],["Olsztyn","\u0141\u0105czna kwota pobranych op\u0142at za z\u0142amanie regulaminu parkowania",2023,130324]]');

});


parcelRegister("ljriQ", function(module, exports) {

$parcel$export(module.exports, "loadPolandMapData", () => $f8408d1fd0fbf5cd$export$b25102e1371b02d1);
async function $f8408d1fd0fbf5cd$export$b25102e1371b02d1() {
    try {
        const response = await fetch('https://code.highcharts.com/mapdata/countries/pl/pl-all.topo.json');
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        const mapData = await response.json();
        return mapData;
    } catch (error) {
        console.warn("Nie uda\u0142o si\u0119 za\u0142adowa\u0107 mapy Polski:", error.message);
        return null;
    }
}

});

parcelRegister("iQmng", function(module, exports) {
module.exports = JSON.parse('{"metrics":{"Wydajno\u015B\u0107":{"weight":2,"max":200,"direction":"up","format":{"decimals":1,"suffix":" mandat\xf3w na stra\u017Cnika miesi\u0119cznie","prefix":""},"raw_min":0,"raw_avg":6.2,"raw_max":14.3},"Pob\u0142a\u017Cliwo\u015B\u0107":{"weight":1,"max":100,"direction":"down","format":{"decimals":0,"suffix":"% poucze\u0144","prefix":""},"raw_min":6,"raw_avg":40,"raw_max":95},"Blokady":{"weight":1,"max":100,"direction":"up","format":{"decimals":1,"suffix":" blokad na stra\u017Cnika miesi\u0119cznie","prefix":""},"raw_min":0,"raw_avg":2.6,"raw_max":6.8},"Holowania":{"weight":1,"max":100,"direction":"up","format":{"decimals":0,"suffix":" holowa\u0144 na 100k mieszka\u0144c\xf3w","prefix":""},"raw_min":0,"raw_avg":171,"raw_max":798},"Holowanie z przej\u015B\u0107":{"weight":1,"max":100,"direction":"up","format":{"decimals":1,"suffix":" holowa\u0144 na 100k mieszka\u0144c\xf3w","prefix":""},"raw_min":0,"raw_avg":3.3,"raw_max":18.1},"Holowanie wrak\xf3w":{"weight":1,"max":100,"direction":"up","format":{"decimals":0,"suffix":" wrak\xf3w na 100k mieszka\u0144c\xf3w","prefix":""},"raw_min":0,"raw_avg":35,"raw_max":88},"Wsp\xf3\u0142praca":{"weight":1,"max":100,"direction":"up","format":{"decimals":0,"suffix":"% zamkni\u0119tych spraw w UD","prefix":""},"raw_min":0,"raw_avg":17,"raw_max":55},"Niesprawiedliwo\u015B\u0107":{"weight":1,"max":100,"direction":"down","format":{"decimals":2,"suffix":"\xd7 (op\u0142aty SPP / mandaty SM za PRD)","prefix":""},"raw_min":0.29,"raw_avg":2.64,"raw_max":8.55},"Stra\u017Cnicy":{"weight":1,"max":100,"direction":"up","format":{"decimals":0,"suffix":" stra\u017Cnik\xf3w na 100 tys. mieszka\u0144c\xf3w","prefix":""},"raw_min":10,"raw_avg":39,"raw_max":68},"Bud\u017Cet":{"weight":0.5,"max":50,"direction":"up","format":{"decimals":0,"suffix":" z\u0142 na mieszka\u0144ca rocznie","prefix":""},"raw_min":3,"raw_avg":64,"raw_max":140},"Mandaty PRD":{"weight":0.5,"max":50,"direction":"down","format":{"decimals":0,"suffix":"% mandat\xf3w za parkowanie","prefix":""},"raw_min":14,"raw_avg":74,"raw_max":92},"Koszt mandatu":{"weight":0.5,"max":50,"direction":"down","format":{"decimals":0,"suffix":" z\u0142","prefix":""},"raw_min":794,"raw_avg":2082,"raw_max":6994},"Wynagrodzenie":{"weight":0.5,"max":50,"direction":"up","format":{"decimals":0,"suffix":" z\u0142","prefix":"~"},"raw_min":4900,"raw_avg":6453,"raw_max":9792}},"cities":[{"city":"Bia\u0142ystok","score":208,"Wydajno\u015B\u0107":{"raw":3.7,"normalized":51},"Pob\u0142a\u017Cliwo\u015B\u0107":{"raw":54,"normalized":0},"Blokady":{"raw":0,"normalized":0},"Holowania":{"raw":26,"normalized":3},"Holowanie z przej\u015B\u0107":{"raw":0,"normalized":0},"Holowanie wrak\xf3w":{"raw":27,"normalized":30},"Wsp\xf3\u0142praca":{"raw":2,"normalized":3},"Niesprawiedliwo\u015B\u0107":{"raw":2.44,"normalized":21},"Stra\u017Cnicy":{"raw":36,"normalized":44},"Bud\u017Cet":{"raw":51,"normalized":16},"Mandaty PRD":{"raw":72,"normalized":14},"Koszt mandatu":{"raw":2302,"normalized":16},"Wynagrodzenie":{"raw":5835,"normalized":10}},{"city":"Bydgoszcz","score":407,"Wydajno\u015B\u0107":{"raw":5.9,"normalized":82},"Pob\u0142a\u017Cliwo\u015B\u0107":{"raw":29,"normalized":53},"Blokady":{"raw":3.1,"normalized":46},"Holowania":{"raw":336,"normalized":42},"Holowanie z przej\u015B\u0107":{"raw":0,"normalized":0},"Holowanie wrak\xf3w":{"raw":19,"normalized":21},"Wsp\xf3\u0142praca":{"raw":13,"normalized":24},"Niesprawiedliwo\u015B\u0107":{"raw":1.18,"normalized":67},"Stra\u017Cnicy":{"raw":40,"normalized":52},"Bud\u017Cet":{"raw":65,"normalized":21},"Mandaty PRD":{"raw":73,"normalized":11},"Koszt mandatu":{"raw":1683,"normalized":30},"Wynagrodzenie":{"raw":4900,"normalized":0}},{"city":"Gda\u0144sk","score":545,"Wydajno\u015B\u0107":{"raw":8.1,"normalized":113},"Pob\u0142a\u017Cliwo\u015B\u0107":{"raw":6,"normalized":100},"Blokady":{"raw":3.7,"normalized":54},"Holowania":{"raw":33,"normalized":4},"Holowanie z przej\u015B\u0107":{"raw":1,"normalized":6},"Holowanie wrak\xf3w":{"raw":34,"normalized":39},"Wsp\xf3\u0142praca":{"raw":46,"normalized":84},"Niesprawiedliwo\u015B\u0107":{"raw":3.36,"normalized":0},"Stra\u017Cnicy":{"raw":51,"normalized":71},"Bud\u017Cet":{"raw":92,"normalized":31},"Mandaty PRD":{"raw":79,"normalized":2},"Koszt mandatu":{"raw":1454,"normalized":35},"Wynagrodzenie":{"raw":5467,"normalized":6}},{"city":"Gorz\xf3w","score":519,"Wydajno\u015B\u0107":{"raw":7.3,"normalized":102},"Pob\u0142a\u017Cliwo\u015B\u0107":{"raw":67,"normalized":0},"Blokady":{"raw":0,"normalized":0},"Holowania":{"raw":207,"normalized":26},"Holowanie z przej\u015B\u0107":{"raw":15,"normalized":83},"Holowanie wrak\xf3w":{"raw":53,"normalized":60},"Wsp\xf3\u0142praca":{"raw":29,"normalized":53},"Niesprawiedliwo\u015B\u0107":{"raw":0.29,"normalized":100},"Stra\u017Cnicy":{"raw":14,"normalized":7},"Bud\u017Cet":{"raw":19,"normalized":3},"Mandaty PRD":{"raw":72,"normalized":14},"Koszt mandatu":{"raw":1077,"normalized":44},"Wynagrodzenie":{"raw":7475,"normalized":26}},{"city":"Katowice","score":464,"Wydajno\u015B\u0107":{"raw":7.9,"normalized":111},"Pob\u0142a\u017Cliwo\u015B\u0107":{"raw":17,"normalized":83},"Blokady":{"raw":3.1,"normalized":46},"Holowania":{"raw":9,"normalized":1},"Holowanie z przej\u015B\u0107":{"raw":0,"normalized":0},"Holowanie wrak\xf3w":{"raw":29,"normalized":33},"Wsp\xf3\u0142praca":{"raw":2,"normalized":3},"Niesprawiedliwo\u015B\u0107":{"raw":1.32,"normalized":62},"Stra\u017Cnicy":{"raw":44,"normalized":58},"Bud\u017Cet":{"raw":67,"normalized":22},"Mandaty PRD":{"raw":81,"normalized":0},"Koszt mandatu":{"raw":1296,"normalized":39},"Wynagrodzenie":{"raw":5578,"normalized":7}},{"city":"Kielce","score":431,"Wydajno\u015B\u0107":{"raw":5.3,"normalized":74},"Pob\u0142a\u017Cliwo\u015B\u0107":{"raw":36,"normalized":35},"Blokady":{"raw":6.5,"normalized":95},"Holowania":{"raw":10,"normalized":1},"Holowanie z przej\u015B\u0107":{"raw":0,"normalized":0},"Holowanie wrak\xf3w":{"raw":10,"normalized":12},"Wsp\xf3\u0142praca":{"raw":46,"normalized":84},"Niesprawiedliwo\u015B\u0107":{"raw":3.6,"normalized":0},"Stra\u017Cnicy":{"raw":38,"normalized":48},"Bud\u017Cet":{"raw":47,"normalized":14},"Mandaty PRD":{"raw":67,"normalized":21},"Koszt mandatu":{"raw":1307,"normalized":38},"Wynagrodzenie":{"raw":5640,"normalized":8}},{"city":"Krak\xf3w","score":561,"Wydajno\u015B\u0107":{"raw":8.3,"normalized":117},"Pob\u0142a\u017Cliwo\u015B\u0107":{"raw":51,"normalized":0},"Blokady":{"raw":3.6,"normalized":53},"Holowania":{"raw":108,"normalized":14},"Holowanie z przej\u015B\u0107":{"raw":0,"normalized":0},"Holowanie wrak\xf3w":{"raw":67,"normalized":76},"Wsp\xf3\u0142praca":{"raw":26,"normalized":47},"Niesprawiedliwo\u015B\u0107":{"raw":2.67,"normalized":12},"Stra\u017Cnicy":{"raw":53,"normalized":73},"Bud\u017Cet":{"raw":133,"normalized":47},"Mandaty PRD":{"raw":57,"normalized":38},"Koszt mandatu":{"raw":1450,"normalized":35},"Wynagrodzenie":{"raw":9792,"normalized":50}},{"city":"Lublin","score":511,"Wydajno\u015B\u0107":{"raw":9.9,"normalized":139},"Pob\u0142a\u017Cliwo\u015B\u0107":{"raw":13,"normalized":94},"Blokady":{"raw":6.3,"normalized":93},"Holowania":{"raw":353,"normalized":44},"Holowanie z przej\u015B\u0107":{"raw":0,"normalized":0},"Holowanie wrak\xf3w":{"raw":1,"normalized":1},"Wsp\xf3\u0142praca":{"raw":13,"normalized":24},"Niesprawiedliwo\u015B\u0107":{"raw":null,"normalized":0},"Stra\u017Cnicy":{"raw":33,"normalized":39},"Bud\u017Cet":{"raw":48,"normalized":15},"Mandaty PRD":{"raw":79,"normalized":2},"Koszt mandatu":{"raw":962,"normalized":46},"Wynagrodzenie":{"raw":6288,"normalized":14}},{"city":"Olsztyn","score":481,"Wydajno\u015B\u0107":{"raw":6,"normalized":84},"Pob\u0142a\u017Cliwo\u015B\u0107":{"raw":55,"normalized":0},"Blokady":{"raw":6.8,"normalized":100},"Holowania":{"raw":133,"normalized":17},"Holowanie z przej\u015B\u0107":{"raw":7,"normalized":39},"Holowanie wrak\xf3w":{"raw":36,"normalized":41},"Wsp\xf3\u0142praca":{"raw":16,"normalized":28},"Niesprawiedliwo\u015B\u0107":{"raw":0.32,"normalized":99},"Stra\u017Cnicy":{"raw":26,"normalized":27},"Bud\u017Cet":{"raw":40,"normalized":12},"Mandaty PRD":{"raw":77,"normalized":4},"Koszt mandatu":{"raw":1656,"normalized":30},"Wynagrodzenie":{"raw":4900,"normalized":0}},{"city":"Opole","score":414,"Wydajno\u015B\u0107":{"raw":3.6,"normalized":50},"Pob\u0142a\u017Cliwo\u015B\u0107":{"raw":62,"normalized":0},"Blokady":{"raw":1.7,"normalized":25},"Holowania":{"raw":101,"normalized":13},"Holowanie z przej\u015B\u0107":{"raw":18.1,"normalized":100},"Holowanie wrak\xf3w":{"raw":20,"normalized":23},"Wsp\xf3\u0142praca":{"raw":55,"normalized":100},"Niesprawiedliwo\u015B\u0107":{"raw":8.55,"normalized":0},"Stra\u017Cnicy":{"raw":35,"normalized":42},"Bud\u017Cet":{"raw":73,"normalized":24},"Mandaty PRD":{"raw":73,"normalized":12},"Koszt mandatu":{"raw":3558,"normalized":0},"Wynagrodzenie":{"raw":7320,"normalized":25}},{"city":"Pozna\u0144","score":649,"Wydajno\u015B\u0107":{"raw":14.3,"normalized":200},"Pob\u0142a\u017Cliwo\u015B\u0107":{"raw":8,"normalized":100},"Blokady":{"raw":5.6,"normalized":82},"Holowania":{"raw":221,"normalized":28},"Holowanie z przej\u015B\u0107":{"raw":7.7,"normalized":43},"Holowanie wrak\xf3w":{"raw":35,"normalized":40},"Wsp\xf3\u0142praca":{"raw":5,"normalized":9},"Niesprawiedliwo\u015B\u0107":{"raw":3.5,"normalized":0},"Stra\u017Cnicy":{"raw":45,"normalized":61},"Bud\u017Cet":{"raw":75,"normalized":25},"Mandaty PRD":{"raw":82,"normalized":0},"Koszt mandatu":{"raw":794,"normalized":50},"Wynagrodzenie":{"raw":6018,"normalized":11}},{"city":"Rzesz\xf3w","score":177,"Wydajno\u015B\u0107":{"raw":4.1,"normalized":57},"Pob\u0142a\u017Cliwo\u015B\u0107":{"raw":50,"normalized":0},"Blokady":{"raw":0,"normalized":0},"Holowania":{"raw":0,"normalized":0},"Holowanie z przej\u015B\u0107":{"raw":0,"normalized":0},"Holowanie wrak\xf3w":{"raw":0,"normalized":0},"Wsp\xf3\u0142praca":{"raw":12,"normalized":21},"Niesprawiedliwo\u015B\u0107":{"raw":2.08,"normalized":34},"Stra\u017Cnicy":{"raw":28,"normalized":32},"Bud\u017Cet":{"raw":34,"normalized":9},"Mandaty PRD":{"raw":81,"normalized":0},"Koszt mandatu":{"raw":1968,"normalized":23},"Wynagrodzenie":{"raw":4900,"normalized":0}},{"city":"Szczecin","score":461,"Wydajno\u015B\u0107":{"raw":7.8,"normalized":109},"Pob\u0142a\u017Cliwo\u015B\u0107":{"raw":27,"normalized":59},"Blokady":{"raw":2.5,"normalized":36},"Holowania":{"raw":233,"normalized":29},"Holowanie z przej\u015B\u0107":{"raw":0,"normalized":0},"Holowanie wrak\xf3w":{"raw":66,"normalized":74},"Wsp\xf3\u0142praca":{"raw":6,"normalized":11},"Niesprawiedliwo\u015B\u0107":{"raw":1.43,"normalized":58},"Stra\u017Cnicy":{"raw":30,"normalized":34},"Bud\u017Cet":{"raw":47,"normalized":14},"Mandaty PRD":{"raw":92,"normalized":0},"Koszt mandatu":{"raw":1546,"normalized":33},"Wynagrodzenie":{"raw":5175,"normalized":3}},{"city":"Toru\u0144","score":321,"Wydajno\u015B\u0107":{"raw":4.7,"normalized":65},"Pob\u0142a\u017Cliwo\u015B\u0107":{"raw":56,"normalized":0},"Blokady":{"raw":2.2,"normalized":32},"Holowania":{"raw":7,"normalized":1},"Holowanie z przej\u015B\u0107":{"raw":0,"normalized":0},"Holowanie wrak\xf3w":{"raw":12,"normalized":13},"Wsp\xf3\u0142praca":{"raw":0,"normalized":0},"Niesprawiedliwo\u015B\u0107":{"raw":1.14,"normalized":69},"Stra\u017Cnicy":{"raw":53,"normalized":74},"Bud\u017Cet":{"raw":74,"normalized":25},"Mandaty PRD":{"raw":85,"normalized":0},"Koszt mandatu":{"raw":2079,"normalized":21},"Wynagrodzenie":{"raw":7012,"normalized":22}},{"city":"Warszawa","score":533,"Wydajno\u015B\u0107":{"raw":5.3,"normalized":75},"Pob\u0142a\u017Cliwo\u015B\u0107":{"raw":29,"normalized":53},"Blokady":{"raw":0.6,"normalized":8},"Holowania":{"raw":798,"normalized":100},"Holowanie z przej\u015B\u0107":{"raw":0,"normalized":0},"Holowanie wrak\xf3w":{"raw":88,"normalized":100},"Wsp\xf3\u0142praca":{"raw":3,"normalized":6},"Niesprawiedliwo\u015B\u0107":{"raw":4.26,"normalized":0},"Stra\u017Cnicy":{"raw":68,"normalized":100},"Bud\u017Cet":{"raw":140,"normalized":50},"Mandaty PRD":{"raw":81,"normalized":0},"Koszt mandatu":{"raw":2578,"normalized":10},"Wynagrodzenie":{"raw":8020,"normalized":32}},{"city":"Wroc\u0142aw","score":431,"Wydajno\u015B\u0107":{"raw":4.9,"normalized":69},"Pob\u0142a\u017Cliwo\u015B\u0107":{"raw":30,"normalized":49},"Blokady":{"raw":0.2,"normalized":2},"Holowania":{"raw":433,"normalized":54},"Holowanie z przej\u015B\u0107":{"raw":10.4,"normalized":58},"Holowanie wrak\xf3w":{"raw":54,"normalized":62},"Wsp\xf3\u0142praca":{"raw":1,"normalized":2},"Niesprawiedliwo\u015B\u0107":{"raw":3.21,"normalized":0},"Stra\u017Cnicy":{"raw":46,"normalized":62},"Bud\u017Cet":{"raw":65,"normalized":21},"Mandaty PRD":{"raw":90,"normalized":0},"Koszt mandatu":{"raw":2150,"normalized":19},"Wynagrodzenie":{"raw":8163,"normalized":33}},{"city":"Zielona G\xf3ra","score":138,"Wydajno\u015B\u0107":{"raw":0,"normalized":0},"Pob\u0142a\u017Cliwo\u015B\u0107":{"raw":95,"normalized":0},"Blokady":{"raw":0,"normalized":0},"Holowania":{"raw":0,"normalized":0},"Holowanie z przej\u015B\u0107":{"raw":0,"normalized":0},"Holowanie wrak\xf3w":{"raw":39,"normalized":44},"Wsp\xf3\u0142praca":{"raw":11,"normalized":19},"Niesprawiedliwo\u015B\u0107":{"raw":null,"normalized":0},"Stra\u017Cnicy":{"raw":10,"normalized":0},"Bud\u017Cet":{"raw":3,"normalized":0},"Mandaty PRD":{"raw":14,"normalized":50},"Koszt mandatu":{"raw":6994,"normalized":0},"Wynagrodzenie":{"raw":7396,"normalized":26}},{"city":"\u0141\xf3d\u017A","score":348,"Wydajno\u015B\u0107":{"raw":3.8,"normalized":53},"Pob\u0142a\u017Cliwo\u015B\u0107":{"raw":30,"normalized":51},"Blokady":{"raw":1.6,"normalized":23},"Holowania":{"raw":80,"normalized":10},"Holowanie z przej\u015B\u0107":{"raw":0,"normalized":0},"Holowanie wrak\xf3w":{"raw":42,"normalized":48},"Wsp\xf3\u0142praca":{"raw":13,"normalized":24},"Niesprawiedliwo\u015B\u0107":{"raw":2.83,"normalized":6},"Stra\u017Cnicy":{"raw":50,"normalized":68},"Bud\u017Cet":{"raw":83,"normalized":28},"Mandaty PRD":{"raw":72,"normalized":14},"Koszt mandatu":{"raw":2619,"normalized":9},"Wynagrodzenie":{"raw":6274,"normalized":14}}]}');

});

parcelRegister("bNSop", function(module, exports) {

$parcel$export(module.exports, "gradientHex", () => $897e768f62e17b01$export$d13ccb638c7e68f8);
/**
 * @param {string} hex
 */ function $897e768f62e17b01$var$hexToRgb(hex) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
}
/**
 * @param {number} r
 * @param {number} g
 * @param {number} b
 */ function $897e768f62e17b01$var$rgbToHex(r, g, b) {
    return "#" + (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
}
function $897e768f62e17b01$export$d13ccb638c7e68f8(startHex, endHex, level) {
    const start = $897e768f62e17b01$var$hexToRgb(startHex);
    const end = $897e768f62e17b01$var$hexToRgb(endHex);
    const r = Math.round(start.r + (end.r - start.r) * Math.max(0, Math.min(1, level)));
    const g = Math.round(start.g + (end.g - start.g) * Math.max(0, Math.min(1, level)));
    const b = Math.round(start.b + (end.b - start.b) * Math.max(0, Math.min(1, level)));
    return $897e768f62e17b01$var$rgbToHex(r, g, b);
}

});

parcelRegister("edzU1", function(module, exports) {

$parcel$export(module.exports, "default", () => $a59e211bd0dfe751$export$2e2bcd8739ae039);
const $a59e211bd0dfe751$var$globalOptions = {
    colors: [
        '#3498db',
        '#2c3e50',
        '#e74c3c',
        '#f1c40f',
        '#2ecc71'
    ],
    chart: {
        style: {
            fontFamily: "'Segoe UI', Roboto, Helvetica, Arial, sans-serif"
        }
    },
    lang: {
        thousandsSep: "\xa0"
    },
    accessibility: {
        enabled: false
    }
};
var $a59e211bd0dfe751$export$2e2bcd8739ae039 = $a59e211bd0dfe751$var$globalOptions;

});

parcelRegister("hxh3D", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc42c001f4f863e1$export$2e2bcd8739ae039);

var $1uKuL = parcelRequire("1uKuL");
function $cc42c001f4f863e1$export$2e2bcd8739ae039() {
    // Check if menu exists
    const navigationMenu = document.querySelector('.navigation-menu');
    const menuListView = document.querySelector('.menu-list-view');
    const stickyMenu = document.querySelector('.sticky-menu');
    if (!navigationMenu || !menuListView || !stickyMenu) {
        console.error('Menu elements not found!');
        return;
    }
    // Handle scroll to show/hide sticky menu
    function handleMenuVisibility() {
        const modal = document.querySelector('.modal--active');
        const scrollPosition = modal ? modal.scrollTop : window.scrollY;
        const wynikiTop = document.getElementById('wyniki')?.offsetTop ?? 1200;
        if (scrollPosition > wynikiTop - 50) stickyMenu?.classList.add('sticky-menu--visible');
        else stickyMenu?.classList.remove('sticky-menu--visible');
    }
    // Smooth scrolling for all menu links (both list and sticky)
    const allMenuLinks = document.querySelectorAll('.menu-list-item[href], .menu-item[href]');
    if (allMenuLinks.length === 0) {
        console.error('No menu links found!');
        return;
    }
    allMenuLinks.forEach((link)=>{
        link.addEventListener('click', function(e) {
            e.preventDefault(); // Prevent default to control scrolling manually
            const sectionId = this.getAttribute('href').split('=').pop().trim();
            const targetElement = document.querySelector('#' + sectionId);
            if (targetElement && 'offsetTop' in targetElement) {
                let menuHeight = 100;
                const offset = 20; // Additional offset for better spacing
                const targetPosition = Number(targetElement.offsetTop) - menuHeight - offset;
                // Check if we're inside a modal
                const modal = document.querySelector('.modal--active');
                if (modal) // Scroll the modal container instead of window
                modal.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth'
                });
                else // Standard window scrolling
                window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth'
                });
                // Update URL to include query param i and hash
                setTimeout(()=>{
                    const newUrl = `?i=${sectionId}`;
                    history.pushState(null, '', newUrl);
                }, 100);
            } else console.error('Target element not found: #', sectionId);
        });
    });
    // Highlight active menu item based on scroll position
    function updateActiveMenuItem(skipUrlUpdate = false) {
        const sections = document.querySelectorAll('section[id]');
        const stickyMenuItems = document.querySelectorAll('.sticky-menu .menu-item[href]');
        const listMenuItems = document.querySelectorAll('.menu-list-item[href]');
        let menuHeight = 100;
        // Check if we're inside a modal and get scroll position accordingly
        const modal = document.querySelector('.modal--active');
        const scrollPosition = modal ? modal.scrollTop + menuHeight + 50 : window.scrollY + menuHeight + 50;
        let activeSection = null;
        sections.forEach((section)=>{
            if ('offsetTop' in section && 'offsetHeight' in section) {
                const sectionTop = Number(section.offsetTop);
                const sectionBottom = sectionTop + Number(section.offsetHeight);
                if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) activeSection = section.id;
            }
        });
        // Remove active class from all menu items (both sticky and list)
        stickyMenuItems.forEach((item)=>{
            item.classList.remove('menu-item--active');
        });
        listMenuItems.forEach((item)=>{
            item.classList.remove('menu-list-item--active');
        });
        // Add active class to current section's menu items
        if (activeSection) {
            const activeStickyMenuItem = document.querySelector(`.sticky-menu .menu-item[href="?i=${activeSection}"]`);
            const activeListMenuItem = document.querySelector(`.menu-list-item[href="?i=${activeSection}"]`);
            if (activeStickyMenuItem) activeStickyMenuItem.classList.add('menu-item--active');
            if (activeListMenuItem) activeListMenuItem.classList.add('menu-list-item--active');
            // Update URL without adding to history
            if (!skipUrlUpdate) {
                const url = new URL(window.location);
                if (url.searchParams.get('i') !== activeSection) {
                    url.searchParams.set('i', activeSection);
                    history.replaceState(null, '', url.toString());
                }
            }
        }
    }
    // Combined scroll handler
    const debouncedHandleScroll = (0, $1uKuL.default)(()=>{
        handleMenuVisibility();
        updateActiveMenuItem();
    }, 100); // Debounce by 100ms
    // Update on scroll
    const modal = document.querySelector('.modal--active');
    if (modal) modal.addEventListener('scroll', debouncedHandleScroll);
    else window.addEventListener('scroll', debouncedHandleScroll);
    // Handle direct hash navigation (e.g., when user enters URL with hash)
    function handleHashNavigation() {
        const sectionId = $cc42c001f4f863e1$var$getSectionId();
        if (!sectionId) return false;
        const targetSelector = `#${sectionId}`;
        const targetElement = document.querySelector(targetSelector);
        if (targetElement && 'offsetTop' in targetElement) {
            setTimeout(()=>{
                let menuHeight = 100;
                const offset = 20;
                const targetPosition = Number(targetElement.offsetTop) - menuHeight - offset;
                // Check if we're inside a modal
                const modal = document.querySelector('.modal--active');
                if (modal) modal.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth'
                });
                else window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth'
                });
            }, 100);
            return true;
        }
        return false;
    }
    // Handle hash navigation on page load and hash change
    window.addEventListener('hashchange', handleHashNavigation);
    // Initial calls
    handleMenuVisibility();
    const isNavigating = handleHashNavigation(); // Call on initial load
    updateActiveMenuItem(isNavigating);
}
function $cc42c001f4f863e1$var$getSectionId() {
    const urlParams = new URLSearchParams(window.location.search);
    let sectionId = urlParams.get('i');
    if (sectionId) return sectionId;
    const hboxId = urlParams.get('h');
    if (hboxId) {
        const hbox = document.getElementById(hboxId);
        sectionId = hbox?.dataset.sectionId;
    }
    if (sectionId) return sectionId;
    return null;
}

});
parcelRegister("1uKuL", function(module, exports) {

$parcel$export(module.exports, "default", () => $116ca8c6022b7c2e$export$2e2bcd8739ae039);
function $116ca8c6022b7c2e$var$debounce(callback, wait = 300, context = this) {
    let timeout = null;
    let callbackArgs = null;
    const later = ()=>callback.apply(context, callbackArgs);
    return function() {
        callbackArgs = arguments; // eslint-disable-line prefer-rest-params
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
var $116ca8c6022b7c2e$export$2e2bcd8739ae039 = $116ca8c6022b7c2e$var$debounce;

});


parcelRegister("dFE0m", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f3e22d4ff6503ec$export$2e2bcd8739ae039);
// Function to add link icons to section headers
function $9f3e22d4ff6503ec$export$2e2bcd8739ae039() {
    // Find all h2 elements within sections that have an id
    const sections = document.querySelectorAll('section[id]:not(.locked-section)');
    sections.forEach((section)=>{
        const h2 = section.querySelector('h2:not(.skip-menu)');
        if (h2 && section.id) {
            // Create link icon
            const linkIcon = document.createElement('a');
            linkIcon.href = `?i=${section.id}`;
            linkIcon.className = 'section-link';
            linkIcon.setAttribute('aria-label', `Link do sekcji: ${h2.textContent.trim()}`);
            linkIcon.setAttribute('title', 'Skopiuj link do tej sekcji');
            // Add link icon (using Unicode link symbol)
            linkIcon.innerHTML = "\uD83D\uDD17";
            // Add click handler for copying link
            linkIcon.addEventListener('click', function(e) {
                e.preventDefault();
                // Get full URL with query param and hash
                const fullUrl = window.location.origin + window.location.pathname + `?i=${section.id}`;
                // Copy to clipboard
                $9f3e22d4ff6503ec$var$copyToClipboard(fullUrl, linkIcon);
            });
            // Add the link icon to the h2
            h2.appendChild(linkIcon);
        }
    });
}
// Function to copy text to clipboard with visual feedback
function $9f3e22d4ff6503ec$var$copyToClipboard(text, element) {
    // Try modern clipboard API first
    if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(text).then(()=>{
        $9f3e22d4ff6503ec$var$showCopyFeedback(element, true);
    }).catch(()=>{
        // Fallback to older method
        $9f3e22d4ff6503ec$var$fallbackCopyToClipboard(text, element);
    });
    else // Fallback for older browsers or non-secure contexts
    $9f3e22d4ff6503ec$var$fallbackCopyToClipboard(text, element);
}
// Fallback copy method for older browsers
function $9f3e22d4ff6503ec$var$fallbackCopyToClipboard(text, element) {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
        const successful = document.execCommand('copy');
        $9f3e22d4ff6503ec$var$showCopyFeedback(element, successful);
    } catch (err) {
        $9f3e22d4ff6503ec$var$showCopyFeedback(element, false);
    } finally{
        document.body.removeChild(textArea);
    }
}
// Show visual feedback when link is copied
function $9f3e22d4ff6503ec$var$showCopyFeedback(element, success) {
    const originalContent = element.innerHTML;
    const originalTitle = element.title;
    if (success) {
        element.innerHTML = "\u2713";
        element.title = 'Link skopiowany!';
        element.style.color = '#28a745';
    } else {
        element.innerHTML = "\u274C";
        element.title = "B\u0142\u0105d kopiowania";
        element.style.color = '#dc3545';
    }
    // Reset after 2 seconds
    setTimeout(()=>{
        element.innerHTML = originalContent;
        element.title = originalTitle;
        element.style.color = '';
    }, 2000);
}

});

parcelRegister("n1uPX", function(module, exports) {

$parcel$export(module.exports, "default", () => $04534f3ed983bdfd$export$2e2bcd8739ae039);
function $04534f3ed983bdfd$export$2e2bcd8739ae039() {
    const collapsibleHeaders = document.querySelectorAll('.collapsible-header');
    collapsibleHeaders.forEach((header)=>{
        header.addEventListener('click', function() {
            const collapsible = this.parentElement;
            const isActive = collapsible.classList.contains('active');
            // Toggle active state
            if (isActive) collapsible.classList.remove('active');
            else collapsible.classList.add('active');
        });
        // Add keyboard support
        header.addEventListener('keydown', function(e) {
            if (e instanceof KeyboardEvent && (e.key === 'Enter' || e.key === ' ')) {
                e.preventDefault();
                this.click();
            }
        });
    });
}

});


var $bIbwS = parcelRequire("bIbwS");

var $1vTJy = parcelRequire("1vTJy");
parcelRequire("euawG");
parcelRequire("fsPq0");
parcelRequire("1gFhB");
parcelRequire("7oF7a");
parcelRequire("9a0Nt");

var $bIbwS = parcelRequire("bIbwS");

var $edxFI = parcelRequire("edxFI");

var $ljriQ = parcelRequire("ljriQ");
async function $dbeb6bf7b9b3b790$export$2e2bcd8739ae039(id) {
    if (!document.getElementById(id)) return;
    const mapData = await (0, $ljriQ.loadPolandMapData)();
    const smData = (0, $edxFI.getSMSizes)();
    smData.forEach((city)=>{
        city.b = city["Bud\u017Cet"];
        city.l = city["Liczba mieszka\u0144c\xf3w"];
        city.e = city["Etaty: liczba stra\u017Cnik\xf3w"];
    });
    const avgBudgetPerCitizen = smData.reduce((sum, city)=>sum + city.b / city.l, 0) / smData.length;
    const budget = [
        ...smData
    ];
    budget.forEach((city)=>{
        city.z = city.b / city.l;
        city.value = city.z;
        // Dodaj współrzędne geograficzne dla każdego miasta
        city.x = city.lon;
        city.y = city.lat;
    });
    const series = [];
    if (mapData) series.push({
        type: 'map',
        name: 'Polska',
        mapData: mapData,
        color: '#f0f0f0',
        borderColor: '#606060',
        borderWidth: 0.5,
        nullColor: '#f0f0f0',
        showInLegend: false,
        enableMouseTracking: false
    });
    // Dodaj serię z bąbelkami miast
    series.push({
        type: 'mapbubble',
        name: "Bud\u017Cet na mieszka\u0144ca",
        data: budget,
        maxSize: '25%',
        minSize: '5%',
        colorAxis: 'budget-axis',
        colorKey: 'value',
        dataLabels: {
            enabled: true,
            format: "{point.city}<br>{point.z:,.0f} z\u0142",
            style: {
                fontSize: '11px',
                color: '#2c3e50',
                textOutline: '2px white'
            }
        }
    });
    // @ts-ignore - ignoruj błędy TypeScript dla konfiguracji mapy
    (0, (/*@__PURE__*/$parcel$interopDefault($bIbwS))).mapChart(id, {
        chart: {
            backgroundColor: 'transparent'
        },
        title: {
            text: "Roczny bud\u017Cet SM na mieszka\u0144ca"
        },
        subtitle: {
            text: `\u{15A}rednia: ${avgBudgetPerCitizen.toFixed(0)} z\u{142}`
        },
        mapNavigation: {
            enabled: false
        },
        colorAxis: {
            id: 'budget-axis',
            min: 20,
            max: 140,
            stops: [
                [
                    0,
                    '#e74c3c'
                ],
                [
                    0.5,
                    '#f1c40f'
                ],
                [
                    1,
                    '#2ecc71'
                ] // Zielony (> 140 zł)
            ],
            labels: {
                format: "{value} z\u0142"
            }
        },
        tooltip: {
            pointFormat: "<b>{point.z:,.0f} z\u0142</b> na mieszka\u0144ca<br>Bud\u017Cet ca\u0142kowity: <b>{point.b:,.0f} z\u0142</b>"
        },
        credits: {
            enabled: false
        },
        series: series
    });
}



var $bIbwS = parcelRequire("bIbwS");

var $ljriQ = parcelRequire("ljriQ");

var $iQmng = parcelRequire("iQmng");

var $5QsV4 = parcelRequire("5QsV4");
async function $4a0b867d884097f3$export$2e2bcd8739ae039(id) {
    if (!document.getElementById(id)) return;
    const mapData = await (0, $ljriQ.loadPolandMapData)();
    const cityCoords = (0, (/*@__PURE__*/$parcel$interopDefault($5QsV4))).cities;
    // Sortuj malejąco po punktach → miejsce 2 (pierwsze jest puste), 3, 4...
    const rankings = [
        ...(0, (/*@__PURE__*/$parcel$interopDefault($iQmng))).cities
    ].sort((a, b)=>b.score - a.score).map((c, i)=>({
            city: c.city,
            score: c.score,
            rank: i + 2,
            lat: cityCoords[c.city]?.lat,
            lon: cityCoords[c.city]?.lon,
            name: `${i + 2}. ${c.city}`
        })).filter((c)=>c.lat != null);
    const series = [];
    if (mapData) series.push({
        type: 'map',
        mapData: mapData,
        showInLegend: false,
        enableMouseTracking: false,
        color: '#f0f0f0',
        borderColor: '#b0b0b0',
        borderWidth: 0.5,
        nullColor: '#f0f0f0'
    });
    series.push({
        type: 'mappoint',
        name: 'Ranking',
        showInLegend: false,
        marker: {
            symbol: 'circle',
            radius: 5,
            lineColor: '#ffffff',
            lineWidth: 1.5,
            color: '#009c7f'
        },
        dataLabels: {
            enabled: true,
            format: '{point.name}',
            allowOverlap: true,
            x: 9,
            align: 'left',
            verticalAlign: 'middle',
            style: {
                fontSize: '13px',
                fontWeight: '600',
                color: '#1a1a1a',
                textOutline: '2px white'
            }
        },
        tooltip: {
            pointFormat: '<b>{point.name}</b><br/>{point.score}/1200 pkt'
        },
        data: rankings.map((r)=>({
                name: r.name,
                city: r.city,
                rank: r.rank,
                score: r.score,
                lat: r.lat,
                lon: r.lon,
                marker: {
                    fillColor: r.rank === 2 ? '#C0C0C0' : r.rank === 3 ? '#CD7F32' : '#cccccc',
                    color: '#009c7f',
                    lineColor: '#ffffff',
                    lineWidth: 1.5,
                    symbol: 'circle',
                    radius: 5
                },
                dataLabels: {
                    style: {
                        fontSize: Math.round(30 - Math.log10(r.rank) * 14) + 'px'
                    }
                }
            }))
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($bIbwS))).mapChart(id, {
        chart: {
            backgroundColor: 'transparent',
            animation: false
        },
        title: {
            text: null
        },
        mapNavigation: {
            enabled: false
        },
        legend: {
            enabled: false
        },
        credits: {
            enabled: false
        },
        series: series
    });
}



var $bIbwS = parcelRequire("bIbwS");

var $edxFI = parcelRequire("edxFI");
parcelRequire("bNSop");
function $788f583bce274779$export$7468621831ec0817() {
    const categories = [
        'Mandaty: liczba wystawionych',
        "Etaty: liczba stra\u017Cnik\xf3w",
        "Bud\u017Cet",
        "Mandaty: warto\u015B\u0107",
        'Mandaty: liczba wystawionych dot. PRD',
        "Mandaty: warto\u015B\u0107 wystawionych dot. PRD"
    ];
    const data = (0, $edxFI.filterByCategory)(categories);
    // Filtruj miasta z kompletnymi danymi dla podstawowych statystyk
    const validData = data.filter((sm)=>sm['Mandaty: liczba wystawionych'] !== null && sm["Etaty: liczba stra\u017Cnik\xf3w"] !== null && sm["Bud\u017Cet"] !== null && sm["Mandaty: warto\u015B\u0107"] !== null && typeof sm['Mandaty: liczba wystawionych'] === 'number' && typeof sm["Etaty: liczba stra\u017Cnik\xf3w"] === 'number' && typeof sm["Bud\u017Cet"] === 'number' && typeof sm["Mandaty: warto\u015B\u0107"] === 'number');
    validData.forEach((sm)=>{
        // Mandaty na strażnika miesięcznie
        sm.finesPerGuardMonthly = Math.round(sm['Mandaty: liczba wystawionych'] / sm["Etaty: liczba stra\u017Cnik\xf3w"] / 12 * 10) / 10;
        // Stopień samofinansowania (w %)
        sm.selfFinancingRate = Math.round(sm["Mandaty: warto\u015B\u0107"] / sm["Bud\u017Cet"] * 1000) / 10;
        // Średnia wartość mandatu PRD
        if (sm["Mandaty: warto\u015B\u0107 wystawionych dot. PRD"] && sm['Mandaty: liczba wystawionych dot. PRD']) sm.avgPrdFine = Math.round(sm["Mandaty: warto\u015B\u0107 wystawionych dot. PRD"] / sm['Mandaty: liczba wystawionych dot. PRD']);
        else sm.avgPrdFine = null;
    });
    return validData.sort((a, b)=>b.finesPerGuardMonthly - a.finesPerGuardMonthly);
}
function $788f583bce274779$export$2e2bcd8739ae039(id) {
    if (!document.getElementById(id)) return;
    const data = $788f583bce274779$export$7468621831ec0817();
    // Oblicz udział PRD (%) dla każdego miasta
    const chartData = data.filter((sm)=>sm['Mandaty: liczba wystawionych dot. PRD'] != null && sm['Mandaty: liczba wystawionych'] > 0).map((sm)=>({
            city: sm.city,
            prdPercent: Math.round(sm['Mandaty: liczba wystawionych dot. PRD'] / sm['Mandaty: liczba wystawionych'] * 1000) / 10
        })).sort((a, b)=>b.prdPercent - a.prdPercent);
    const categories = chartData.map((d)=>d.city);
    const prdPercents = chartData.map((d)=>d.prdPercent);
    const avg = 76; //Math.round(prdPercents.reduce((a, b) => a + b, 0) / prdPercents.length * 10) / 10;
    (0, (/*@__PURE__*/$parcel$interopDefault($bIbwS))).chart(id, {
        chart: {
            type: 'bar',
            backgroundColor: 'transparent'
        },
        title: {
            text: "Udzia\u0142 mandat\xf3w drogowych (PRD) w ca\u0142kowitej liczbie mandat\xf3w"
        },
        xAxis: {
            categories: categories,
            title: {
                text: null
            },
            labels: {
                style: {
                    fontSize: '14px'
                }
            }
        },
        yAxis: {
            title: {
                text: "Udzia\u0142 mandat\xf3w PRD"
            },
            min: 0,
            max: 100,
            labels: {
                format: '{value}%'
            },
            gridLineWidth: 1,
            plotLines: [
                {
                    value: avg,
                    color: '#2c3e50',
                    dashStyle: 'ShortDash',
                    width: 1,
                    label: {
                        text: `\u{15A}rednia: ${avg}%`,
                        align: 'right',
                        verticalAlign: 'bottom',
                        style: {
                            color: '#2c3e50',
                            fontWeight: 'bold'
                        }
                    }
                }
            ]
        },
        legend: {
            enabled: false
        },
        tooltip: {
            formatter: function() {
                return `<b>${this.x}</b><br/>Mandaty PRD: <b>${this.y}%</b>`;
            }
        },
        plotOptions: {
            bar: {
                borderRadius: 4,
                dataLabels: {
                    enabled: true,
                    format: '{y}%',
                    style: {
                        fontSize: '11px',
                        textOutline: 'none'
                    }
                }
            },
            series: {
                borderWidth: 0
            }
        },
        credits: {
            enabled: false
        },
        series: [
            {
                name: "Udzia\u0142 PRD",
                color: '#FFFF00',
                data: prdPercents.map((d)=>({
                        y: d,
                        color: d > avg ? '#cb3d20ff' : '#cb9520'
                    }))
            }
        ]
    });
}



var $edzU1 = parcelRequire("edzU1");

var $bIbwS = parcelRequire("bIbwS");

var $edxFI = parcelRequire("edxFI");
function $352eaa88a59beb78$export$2e2bcd8739ae039(id) {
    if (!document.getElementById(id)) return;
    const cityData = (0, $edxFI.getSMSizes)().sort((a, b)=>b.guardsPer100k - a.guardsPer100k);
    const categories = cityData.map((item)=>item.city);
    const guardsData = cityData.map((item)=>item["Etaty: liczba stra\u017Cnik\xf3w"]);
    const guardsPer100kData = cityData.map((item)=>item.guardsPer100k);
    const avgPer100k = guardsPer100kData.reduce((a, b)=>a + b, 0) / guardsPer100kData.length;
    const barColor = '#3498db';
    const belowAvgColor = '#547a94';
    const guardsPer100kDataWithColor = cityData.map((item)=>({
            y: item.guardsPer100k,
            color: item.guardsPer100k >= avgPer100k ? barColor : belowAvgColor
        }));
    (0, (/*@__PURE__*/$parcel$interopDefault($bIbwS))).chart(id, {
        chart: {
            type: 'bar',
            backgroundColor: 'transparent'
        },
        title: {
            text: "Liczba stra\u017Cnik\xf3w miejskich i wska\u017Anik na 100k mieszka\u0144c\xf3w"
        },
        xAxis: {
            categories: categories,
            type: 'category',
            title: {
                text: null
            },
            labels: {
                style: {
                    fontSize: '16px'
                }
            }
        },
        yAxis: [
            {
                title: {
                    text: null
                },
                labels: {
                    style: {
                        color: '#999'
                    }
                },
                opposite: true
            },
            {
                min: 0,
                title: {
                    text: null
                },
                labels: {
                    style: {
                        color: barColor
                    }
                },
                plotLines: [
                    {
                        value: avgPer100k,
                        dashStyle: 'ShortDot',
                        width: 3,
                        zIndex: 5,
                        label: {
                            text: `\u{15A}rednia: ${avgPer100k.toFixed(0)}`,
                            align: 'right',
                            verticalAlign: 'bottom',
                            style: {
                                color: barColor,
                                fontWeight: 'bold'
                            }
                        }
                    }
                ]
            }
        ],
        legend: {
            enabled: true,
            verticalAlign: 'top',
            align: 'center'
        },
        tooltip: {
            shared: true,
            formatter: function() {
                let tooltip = ``;
                if (this.points) this.points.forEach((point)=>{
                    if (point.series.name === "Liczba stra\u017Cnik\xf3w") tooltip += `${point.series.name}: <b>${point.y}</b><br/>`;
                    else tooltip += `${point.series.name}: <b>${point.y}</b><br/>`;
                });
                return tooltip;
            }
        },
        plotOptions: {
            bar: {
                borderRadius: 4,
                dataLabels: {
                    enabled: true,
                    formatter: function() {
                        if (this.series.name === "Liczba stra\u017Cnik\xf3w") return Math.round(this.y || 0);
                        else return this.y;
                    }
                }
            },
            series: {
                grouping: false,
                borderWidth: 0
            }
        },
        credits: {
            enabled: false
        },
        series: [
            {
                name: "Liczba stra\u017Cnik\xf3w",
                type: 'bar',
                yAxis: 0,
                data: guardsData,
                color: '#999',
                pointPlacement: -0.2
            },
            {
                name: "Stra\u017Cnicy na 100k mieszka\u0144c\xf3w",
                type: 'bar',
                yAxis: 1,
                data: guardsPer100kDataWithColor,
                color: barColor,
                id: 'main',
                dataSorting: {
                    enabled: true,
                    matchByName: true
                }
            }
        ]
    });
}



var $bIbwS = parcelRequire("bIbwS");

var $edxFI = parcelRequire("edxFI");
function $6ea0380ed9a29449$var$getMandatyFinanse() {
    const categories = [
        'Mandaty: liczba wystawionych',
        "Etaty: liczba stra\u017Cnik\xf3w",
        "Bud\u017Cet",
        "Mandaty: warto\u015B\u0107",
        'Mandaty: liczba wystawionych dot. PRD',
        "Mandaty: warto\u015B\u0107 wystawionych dot. PRD",
        'Pouczenia: liczba'
    ];
    const data = (0, $edxFI.filterByCategory)(categories);
    // Filtruj miasta z kompletnymi danymi dla podstawowych statystyk
    const validData = data.filter((sm)=>sm['Mandaty: liczba wystawionych'] !== null && sm["Etaty: liczba stra\u017Cnik\xf3w"] !== null && sm["Bud\u017Cet"] !== null && sm["Mandaty: warto\u015B\u0107"] !== null && typeof sm['Mandaty: liczba wystawionych'] === 'number' && typeof sm["Etaty: liczba stra\u017Cnik\xf3w"] === 'number' && typeof sm["Bud\u017Cet"] === 'number' && typeof sm["Mandaty: warto\u015B\u0107"] === 'number');
    validData.forEach((sm)=>{
        // Mandaty na strażnika miesięcznie
        sm.finesPerGuardMonthly = Math.round(sm['Mandaty: liczba wystawionych'] / sm["Etaty: liczba stra\u017Cnik\xf3w"] / 12 * 10) / 10;
        // Stopień samofinansowania (w %)
        sm.selfFinancingRate = Math.round(sm["Mandaty: warto\u015B\u0107"] / sm["Bud\u017Cet"] * 1000) / 10;
        // Średnia wartość mandatu PRD
        if (sm["Mandaty: warto\u015B\u0107 wystawionych dot. PRD"] && sm['Mandaty: liczba wystawionych dot. PRD']) sm.avgPrdFine = Math.round(sm["Mandaty: warto\u015B\u0107 wystawionych dot. PRD"] / sm['Mandaty: liczba wystawionych dot. PRD']);
        else sm.avgPrdFine = null;
    });
    return validData.sort((a, b)=>b.finesPerGuardMonthly - a.finesPerGuardMonthly);
}
function $6ea0380ed9a29449$export$757ae431edaef9da(id) {
    if (!document.getElementById(id)) return;
    const data = $6ea0380ed9a29449$var$getMandatyFinanse();
    // Chart 1: Mandaty na strażnika (combined with Average Fine Value)
    const categories1 = data.map((item)=>item.city);
    const finesPerGuardData = data.map((item)=>item.finesPerGuardMonthly);
    const avgFineData = data.map((item)=>item.avgPrdFine || 0);
    const sumOfMandaty = data.reduce((sum, city)=>sum + city["Mandaty: warto\u015B\u0107 wystawionych dot. PRD"], 0);
    const countOfMandaty = data.reduce((sum, city)=>sum + city['Mandaty: liczba wystawionych dot. PRD'], 0);
    const average = sumOfMandaty / countOfMandaty;
    (0, (/*@__PURE__*/$parcel$interopDefault($bIbwS))).chart(id, {
        chart: {
            type: 'bar',
            backgroundColor: 'transparent'
        },
        title: {
            text: "Efektywno\u015B\u0107 mandatowa i \u015Brednia wysoko\u015B\u0107 kary"
        },
        xAxis: {
            categories: categories1,
            type: 'category',
            title: {
                text: null
            },
            labels: {
                style: {
                    fontSize: '16px'
                }
            }
        },
        yAxis: [
            {
                title: {
                    text: null
                },
                labels: {
                    style: {
                        color: '#999'
                    },
                    format: "{value} z\u0142"
                },
                opposite: true,
                plotLines: [
                    {
                        value: average,
                        color: '#999',
                        dashStyle: 'ShortDot',
                        width: 3,
                        zIndex: 5,
                        label: {
                            text: `\u{15A}rednia: ${average.toFixed(0)} z\u{142}`,
                            align: 'right',
                            verticalAlign: 'bottom',
                            style: {
                                color: '#000',
                                fontWeight: 'bold'
                            }
                        }
                    }
                ]
            },
            {
                min: 0,
                title: {
                    text: null
                },
                labels: {
                    style: {
                        color: '#e74c3c'
                    }
                }
            }
        ],
        legend: {
            enabled: false
        },
        tooltip: {
            shared: true
        },
        plotOptions: {
            bar: {
                borderRadius: 4,
                dataLabels: {
                    enabled: true,
                    formatter: function() {
                        if (this.series.name === "\u015Arednia warto\u015B\u0107 mandatu PRD") return this.y ? `${this.y} z\u{142}` : '';
                        else return this.y;
                    }
                }
            },
            series: {
                grouping: false,
                borderWidth: 0
            }
        },
        credits: {
            enabled: false
        },
        series: [
            {
                name: "\u015Arednia warto\u015B\u0107 mandatu PRD",
                type: 'bar',
                yAxis: 0,
                data: avgFineData,
                color: '#999',
                linkedTo: 'main',
                pointPlacement: -0.2
            },
            {
                name: "Mandaty PRD na stra\u017Cnika (miesi\u0119cznie)",
                type: 'bar',
                yAxis: 1,
                data: finesPerGuardData,
                color: '#e74c3c',
                id: 'main'
            }
        ]
    });
}
function $6ea0380ed9a29449$export$486fca12c2d4e98f(id) {
    const data = $6ea0380ed9a29449$var$getMandatyFinanse();
    const data2 = [
        ...data
    ].sort((a, b)=>b.selfFinancingRate - a.selfFinancingRate);
    const categories = data2.map((item)=>item.city);
    const selfFinancingData = data2.map((item)=>item.selfFinancingRate);
    const backgroundData = selfFinancingData.map(()=>100);
    const avg = selfFinancingData.reduce((a, b)=>a + b, 0) / selfFinancingData.length;
    const barColor = '#27ae60';
    const belowAvgColor = '#548067';
    const selfFinancingDataWithColor = data2.map((item)=>({
            y: item.selfFinancingRate,
            color: item.selfFinancingRate >= avg ? barColor : belowAvgColor
        }));
    (0, (/*@__PURE__*/$parcel$interopDefault($bIbwS))).chart(id, {
        chart: {
            type: 'bar',
            backgroundColor: 'transparent'
        },
        title: {
            text: "Stopie\u0144 pokrycia bud\u017Cetu wp\u0142ywami z mandat\xf3w"
        },
        subtitle: {
            text: "Stopie\u0144 pokrycia bud\u017Cetu SM wp\u0142ywami z mandat\xf3w"
        },
        xAxis: {
            categories: categories,
            title: {
                text: null
            },
            labels: {
                style: {
                    fontSize: '14px'
                }
            }
        },
        yAxis: {
            title: {
                text: '%'
            },
            min: 0,
            max: 100,
            labels: {
                format: '{value}%'
            }
        },
        legend: {
            enabled: false
        },
        tooltip: {
            valueSuffix: '%'
        },
        plotOptions: {
            bar: {
                grouping: false,
                borderRadius: 4,
                dataLabels: {
                    enabled: true,
                    format: '{y}%'
                }
            },
            series: {
                borderWidth: 0
            }
        },
        credits: {
            enabled: false
        },
        series: [
            {
                name: "Bud\u017Cet",
                data: backgroundData,
                color: '#ecf0f1',
                enableMouseTracking: false,
                dataLabels: {
                    enabled: false
                }
            },
            {
                name: "Pokrycie bud\u017Cetu",
                data: selfFinancingDataWithColor,
                color: '#27ae60'
            }
        ]
    });
}
function $6ea0380ed9a29449$export$8ec6650e9088f965(id) {
    const data = $6ea0380ed9a29449$var$getMandatyFinanse();
    data.forEach((sm)=>{
        sm.pricePerAction = Math.round(sm["Bud\u017Cet"] / (sm['Mandaty: liczba wystawionych'] + (sm['Pouczenia: liczba'] || 0)));
        sm.pricePerFine = Math.round(sm["Bud\u017Cet"] / sm['Mandaty: liczba wystawionych']);
    });
    const data2 = [
        ...data
    ].sort((a, b)=>b.pricePerAction - a.pricePerAction);
    const categories = data2.map((item)=>item.city);
    const pricePerActionData = data2.map((item)=>item.pricePerAction);
    const pricePerFineData = data2.map((item)=>item.pricePerFine);
    (0, (/*@__PURE__*/$parcel$interopDefault($bIbwS))).chart(id, {
        chart: {
            type: 'bar',
            backgroundColor: 'transparent'
        },
        title: {
            text: "Bud\u017Cet SM per mandat lub pouczenie"
        },
        subtitle: {
            text: 'Ile kosztuje wystawienie jednego mandatu lub pouczenia?'
        },
        xAxis: {
            categories: categories,
            title: {
                text: null
            },
            labels: {
                style: {
                    fontSize: '14px'
                }
            }
        },
        yAxis: {
            title: {
                text: ''
            },
            labels: {
                format: "{value} z\u0142"
            }
        },
        legend: {
            enabled: true,
            verticalAlign: 'top',
            reversed: true
        },
        tooltip: {
            valueSuffix: " z\u0142",
            shared: true
        },
        plotOptions: {
            bar: {
                grouping: false,
                borderRadius: 4,
                dataLabels: {
                    enabled: true,
                    format: "{y}\xa0z\u0142"
                }
            },
            series: {
                borderWidth: 0
            }
        },
        credits: {
            enabled: false
        },
        series: [
            {
                name: "Bud\u017Cet per mandat",
                data: pricePerFineData,
                color: '#999'
            },
            {
                name: "Bud\u017Cet per mandat lub pouczenie",
                data: pricePerActionData,
                color: '#a70000',
                dataLabels: {
                    inside: true
                }
            }
        ]
    });
}



var $1vTJy = parcelRequire("1vTJy");

var $edxFI = parcelRequire("edxFI");
const $01d158adc2c26960$var$columns = {
    city: "Miasto",
    budget: "Bud\u017Cet",
    budgetPerCitizen: "Bud\u017Cet na<br>mieszka\u0144ca",
    guards: "Liczba<br>stra\u017Cnik\xf3w",
    guardsPer100k: "Stra\u017Cnik\xf3w na<br>100k mieszka\u0144c\xf3w"
};
function $01d158adc2c26960$export$2e2bcd8739ae039(id) {
    if (!document.getElementById(id)) return;
    const smData = (0, $edxFI.getSMSizes)();
    (0, $1vTJy.default).grid(id, {
        dataTable: {
            columns: {
                [$01d158adc2c26960$var$columns.city]: smData.map((e)=>e.city),
                [$01d158adc2c26960$var$columns.budget]: smData.map((e)=>e["Bud\u017Cet"]),
                [$01d158adc2c26960$var$columns.budgetPerCitizen]: smData.map((e)=>e.budgetPerCitizen),
                [$01d158adc2c26960$var$columns.guards]: smData.map((e)=>e["Etaty: liczba stra\u017Cnik\xf3w"]),
                [$01d158adc2c26960$var$columns.guardsPer100k]: smData.map((e)=>e.guardsPer100k)
            }
        },
        rendering: {
            rows: {
                strictHeights: false
            },
            theme: 'hcg-theme-default theme-compact'
        },
        columns: [
            {
                id: "Miasto",
                cells: {
                    className: 'bold'
                }
            },
            {
                id: $01d158adc2c26960$var$columns.budget,
                cells: {
                    format: "{(divide value 1000000):.1f}\xa0mln\xa0z\u0142"
                }
            },
            {
                id: "Bud\u017Cet na<br>mieszka\u0144ca",
                cells: {
                    format: "{(value):.0f}\xa0z\u0142"
                }
            },
            {
                id: "Liczba<br>stra\u017Cnik\xf3w",
                cells: {
                    format: '{(value):.0f}'
                }
            },
            {
                id: "Stra\u017Cnik\xf3w na<br>100k mieszka\u0144c\xf3w",
                cells: {
                    format: '{(value):.1f}'
                }
            }
        ]
    });
}



var $bIbwS = parcelRequire("bIbwS");

var $edxFI = parcelRequire("edxFI");
function $349a92fc1fb0dd6a$var$getPouczeniaMandaty() {
    const data = (0, $edxFI.filterByCategory)([
        'Mandaty: liczba wystawionych',
        'Pouczenia: liczba',
        "Liczba mieszka\u0144c\xf3w"
    ]);
    // Filtruj miasta z kompletnymi danymi
    const validData = data.filter((sm)=>sm['Mandaty: liczba wystawionych'] && sm['Pouczenia: liczba'] && typeof sm['Mandaty: liczba wystawionych'] === 'number' && typeof sm['Pouczenia: liczba'] === 'number');
    validData.forEach((sm)=>{
        // Oblicz stosunek mandatów do pouczeń
        sm.mandatyNaPouczenie = Math.round(sm['Mandaty: liczba wystawionych'] / sm['Pouczenia: liczba'] * 100) / 100;
        // Oblicz na ile mandatów przypada jedno pouczenie
        sm.pouczenieNaMandaty = Math.round(sm['Pouczenia: liczba'] / sm['Mandaty: liczba wystawionych'] * 100) / 100;
        sm.mandatyNaPouczenia = Math.round(10 / sm.pouczenieNaMandaty) / 10;
        // Oblicz mandaty na 100k mieszkańców
        sm.mandatyPer100k = Math.round(sm['Mandaty: liczba wystawionych'] / sm["Liczba mieszka\u0144c\xf3w"] * 100000);
        // Oblicz pouczenia na 100k mieszkańców  
        sm.pouczeniaPer100k = Math.round(sm['Pouczenia: liczba'] / sm["Liczba mieszka\u0144c\xf3w"] * 100000);
        // Oblicz łączną liczbę interwencji
        sm.lacznie = sm['Mandaty: liczba wystawionych'] + sm['Pouczenia: liczba'];
        // Oblicz procent pouczeń w stosunku do wszystkich interwencji
        sm.procentPouczen = Math.round(sm['Pouczenia: liczba'] / sm.lacznie * 100);
    });
    return validData.sort((a, b)=>b.mandatyNaPouczenia - a.mandatyNaPouczenia);
}
function $349a92fc1fb0dd6a$export$2e2bcd8739ae039(id) {
    if (!document.getElementById(id)) return;
    const data = $349a92fc1fb0dd6a$var$getPouczeniaMandaty();
    // Wykres słupkowy - stosunek pouczeń do mandatów
    const chartData = data.map((sm)=>({
            name: sm.city,
            y: sm.mandatyNaPouczenia,
            mandaty: sm['Mandaty: liczba wystawionych'],
            pouczenia: sm['Pouczenia: liczba'],
            procentPouczen: sm.procentPouczen
        }));
    (0, (/*@__PURE__*/$parcel$interopDefault($bIbwS))).chart(id, {
        chart: {
            type: 'column',
            height: 600
        },
        title: {
            text: "Stosunek mandat\xf3w do poucze\u0144",
            style: {
                fontSize: '18px',
                fontWeight: 'bold'
            }
        },
        subtitle: {
            text: "Na ile mandat\xf3w przypada jedno pouczenie (wy\u017Csze warto\u015Bci = mniej poucze\u0144)"
        },
        xAxis: {
            categories: chartData.map((item)=>item.name),
            labels: {
                rotation: -45,
                style: {
                    fontSize: '11px'
                }
            }
        },
        yAxis: {
            title: {
                text: 'Pouczenia na mandat'
            },
            min: 0
        },
        plotOptions: {
            column: {
                dataLabels: {
                    enabled: true,
                    format: '{y}',
                    style: {
                        fontSize: '10px'
                    }
                },
                colorByPoint: true
            }
        },
        tooltip: {
            pointFormat: '<b>{point.name}</b><br/>Mandaty na pouczenie: <b>{point.y}</b>'
        },
        series: [
            {
                type: 'column',
                name: 'Mandaty na pouczenie',
                data: chartData,
                showInLegend: false
            }
        ],
        credits: {
            enabled: false
        }
    });
}



var $1vTJy = parcelRequire("1vTJy");

var $edxFI = parcelRequire("edxFI");
function $7ce13169721f306b$export$2e2bcd8739ae039(id) {
    if (!document.getElementById(id)) return;
    (0, $1vTJy.default).grid(id, {
        dataTable: {
            columns: {
                "Miasto": (0, $edxFI.research).map((e)=>e.city),
                "Liczba nieprawid\u0142owo<br>zaparkowanych pojazd\xf3w": (0, $edxFI.research).map((e)=>`Pojazd\xf3w w obszarze: ${e.count.toLocaleString('pl-PL')}<br><i>(Szacunek dla ca\u{142}ego miasta: ${Math.round(e.count / (e.residentPercent / 100)).toLocaleString('pl-PL')})</i>`),
                "Obszar badania": (0, $edxFI.research).map((e)=>`${e.area}<br><i>(Obszar zamieszkany przez oko\u{142}o ${e.residentPercent}% mieszka\u{144}c\xf3w miasta)</i>`),
                "\u0179r\xf3d\u0142o": (0, $edxFI.research).map((e)=>e.source)
            }
        },
        rendering: {
            rows: {
                strictHeights: false
            },
            theme: 'hcg-theme-default theme-compact'
        },
        columns: [
            {
                id: "Miasto",
                cells: {
                    className: 'bold'
                },
                width: 100
            },
            {
                id: "Liczba nieprawid\u0142owo<br>zaparkowanych pojazd\xf3w",
                cells: {
                    format: '{value}'
                }
            },
            {
                id: "Obszar badania"
            },
            {
                id: "\u0179r\xf3d\u0142o"
            }
        ]
    });
}



var $hxh3D = parcelRequire("hxh3D");

var $dFE0m = parcelRequire("dFE0m");

var $n1uPX = parcelRequire("n1uPX");
function $e9931649c14141c6$export$2e2bcd8739ae039() {
    document.querySelectorAll('.ranking-card__metrics-toggle').forEach((btn)=>{
        btn.addEventListener('click', ()=>{
            const body = btn.closest('.ranking-card__body');
            if (!body) return;
            const isExpanded = body.classList.toggle('is-expanded');
            btn.setAttribute('aria-expanded', String(isExpanded));
            const toggleText = btn.querySelector('.ranking-card__metrics-toggle-text');
            if (toggleText) toggleText.textContent = isExpanded ? "Zwi\u0144" : "Poka\u017C wszystkie";
        });
    });
}



var $bIbwS = parcelRequire("bIbwS");

var $edxFI = parcelRequire("edxFI");
function $cf6b0260f53c524f$export$da729129a47089ef() {
    const categories = [
        "Etaty: liczba stra\u017Cnik\xf3w",
        "Etaty: Nieobsadzone wakaty stra\u017Cnik\xf3w",
        "Etaty: Mediana wynagrodze\u0144\xa0stra\u017Cnik\xf3w brutto",
        "Liczba etat\xf3w og\xf3\u0142em"
    ];
    const data = (0, $edxFI.filterByCategory)(categories);
    data.forEach((sm)=>{
        // Vacancies
        sm.guards = sm["Etaty: liczba stra\u017Cnik\xf3w"] || 0;
        const vacancies = sm["Etaty: Nieobsadzone wakaty stra\u017Cnik\xf3w"] || 0;
        // Assuming authorized guard posts = filled + vacancies
        const totalAuthorizedGuards = sm.guards + vacancies;
        sm.vacancyRate = totalAuthorizedGuards > 0 ? Math.round(vacancies / totalAuthorizedGuards * 1000) / 10 : 0;
        sm.filledGuards = sm.guards;
        sm.vacantGuards = vacancies;
        // Salaries
        sm.salary = sm["Etaty: Mediana wynagrodze\u0144\xa0stra\u017Cnik\xf3w brutto"];
        // Civilians
        // Assuming 'Liczba etatów ogółem' refers to total FILLED posts (guards + civilians)
        const totalFilledPosts = sm["Liczba etat\xf3w og\xf3\u0142em"];
        if (totalFilledPosts && sm.guards) {
            const civilians = Math.max(0, totalFilledPosts - sm.guards);
            sm.civilians = Math.round(civilians * 10) / 10;
            sm.civilianRatio = Math.round(civilians / totalFilledPosts * 1000) / 10;
            sm.guardRatio = Math.round(sm.guards / totalFilledPosts * 1000) / 10;
            sm.totalFilled = totalFilledPosts;
        } else {
            sm.civilians = null;
            sm.civilianRatio = null;
            sm.guardRatio = null;
            sm.totalFilled = null;
        }
    });
    return data;
}
function $cf6b0260f53c524f$export$2e2bcd8739ae039(id) {
    if (!document.getElementById(id)) return;
    // Filter out cities with null salary and sort
    const cityData = $cf6b0260f53c524f$export$da729129a47089ef().filter((item)=>item.salary !== null).sort((a, b)=>b.salary - a.salary);
    const categories = cityData.map((item)=>item.city);
    const salaries = cityData.map((item)=>item.salary);
    const salaryData = cityData.map((item)=>{
        return {
            salary: item.salary,
            guards: item.guards
        };
    }).filter((item)=>item.salary !== null);
    const sumOfGuards = salaryData.reduce((sum, item)=>sum + item.guards, 0);
    const sumOfSalaries = salaryData.reduce((sum, item)=>sum + item.guards * item.salary, 0);
    const averageSalary = sumOfSalaries / sumOfGuards;
    const barColor = '#2ecc71';
    const belowAvgColor = '#43845e';
    const salariesWithColor = salaries.map((item)=>({
            y: item,
            color: item >= averageSalary ? barColor : belowAvgColor
        }));
    (0, (/*@__PURE__*/$parcel$interopDefault($bIbwS))).chart(id, {
        chart: {
            type: 'bar',
            backgroundColor: 'transparent'
        },
        title: {
            text: "Mediana wynagrodze\u0144 brutto stra\u017Cnik\xf3w"
        },
        xAxis: {
            categories: categories,
            title: {
                text: null
            },
            labels: {
                style: {
                    fontSize: '14px'
                }
            }
        },
        yAxis: {
            min: 0,
            title: {
                text: 'PLN',
                align: 'high'
            },
            labels: {
                overflow: 'justify'
            },
            plotLines: [
                {
                    value: averageSalary,
                    color: '#2ecc71',
                    dashStyle: 'ShortDot',
                    width: 3,
                    zIndex: 5,
                    label: {
                        text: `\u{15A}rednia: ${averageSalary.toFixed(0)} z\u{142}`,
                        align: 'right',
                        verticalAlign: 'bottom',
                        style: {
                            color: '#104c29',
                            fontWeight: 'bold'
                        }
                    }
                }
            ]
        },
        tooltip: {
            valueSuffix: ' PLN'
        },
        plotOptions: {
            bar: {
                dataLabels: {
                    enabled: true,
                    format: "{point.y} z\u0142"
                },
                borderRadius: 4
            }
        },
        legend: {
            enabled: false
        },
        credits: {
            enabled: false
        },
        series: [
            {
                name: "Mediana wynagrodze\u0144",
                data: salariesWithColor,
                color: '#2ecc71'
            }
        ]
    });
}



var $bIbwS = parcelRequire("bIbwS");

function $e2d9a1ad085c9be4$export$2e2bcd8739ae039(id) {
    if (!document.getElementById(id)) return;
    // Filter cities with meaningful vacancy data (at least guards > 0)
    // Sort by vacancy rate desc
    const cityData = (0, $cf6b0260f53c524f$export$da729129a47089ef)().filter((item)=>item.filledGuards > 0).sort((a, b)=>b.vacancyRate - a.vacancyRate);
    const categories = cityData.map((item)=>item.city);
    const filledData = cityData.map((item)=>item.filledGuards);
    const vacantData = cityData.map((item)=>item.vacantGuards);
    (0, (/*@__PURE__*/$parcel$interopDefault($bIbwS))).chart(id, {
        chart: {
            type: 'bar',
            backgroundColor: 'transparent'
        },
        title: {
            text: "Etaty obsadzone a wakaty w stra\u017Cy miejskiej"
        },
        xAxis: {
            categories: categories,
            title: {
                text: null
            },
            labels: {
                style: {
                    fontSize: '14px'
                }
            }
        },
        yAxis: {
            min: 0,
            title: {
                text: "Liczba etat\xf3w"
            },
            reversedStacks: false // Vacancies on top or right
        },
        tooltip: {
            pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
            shared: true
        },
        plotOptions: {
            series: {
                stacking: 'normal',
                dataLabels: {
                    enabled: false
                }
            }
        },
        legend: {
            reversed: true // Matches stack order
        },
        credits: {
            enabled: false
        },
        series: [
            {
                name: 'Obsadzone etaty',
                data: filledData,
                color: '#3498db'
            },
            {
                name: 'Wakaty',
                data: vacantData,
                color: '#e74c3c',
                dataLabels: {
                    enabled: true,
                    inside: false,
                    align: 'left',
                    x: 5,
                    format: '{point.percentage:.0f}%',
                    style: {
                        color: '#000',
                        textOutline: 'none',
                        fontSize: '12px'
                    },
                    crop: false,
                    overflow: 'allow' // Pozwala etykiecie wyjść poza obszar rysowania
                }
            }
        ]
    });
}



var $bIbwS = parcelRequire("bIbwS");

function $32081bc3857e8987$export$2e2bcd8739ae039(id) {
    if (!document.getElementById(id)) return;
    // Filter cities where we could calculate civilians
    const cityData = (0, $cf6b0260f53c524f$export$da729129a47089ef)().filter((item)=>item.civilians !== null).sort((a, b)=>b.civilianRatio - a.civilianRatio);
    const categories = cityData.map((item)=>item.city);
    const guardsData = cityData.map((item)=>item.filledGuards); // Comparing filled to filled
    const civilianData = cityData.map((item)=>item.civilians);
    (0, (/*@__PURE__*/$parcel$interopDefault($bIbwS))).chart(id, {
        chart: {
            type: 'bar',
            backgroundColor: 'transparent'
        },
        title: {
            text: 'Struktura zatrudnienia: Mundurowi vs Cywile'
        },
        xAxis: {
            categories: categories,
            title: {
                text: null
            },
            labels: {
                style: {
                    fontSize: '14px'
                }
            }
        },
        yAxis: {
            min: 0,
            title: {
                text: "Procentowy udzia\u0142"
            },
            reversedStacks: false
        },
        tooltip: {
            pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
            shared: true
        },
        plotOptions: {
            series: {
                stacking: 'percent',
                dataLabels: {
                    enabled: true,
                    format: '{point.percentage:.1f}%'
                }
            }
        },
        legend: {
            reversed: true
        },
        credits: {
            enabled: false
        },
        series: [
            {
                name: 'Pracownicy cywilni',
                data: civilianData,
                color: '#f1c40f'
            },
            {
                name: "Stra\u017Cnicy miejscy",
                data: guardsData,
                color: '#2c3e50'
            }
        ]
    });
}



var $bIbwS = parcelRequire("bIbwS");

var $edxFI = parcelRequire("edxFI");
function $42e1ff9ab7e2bbbd$export$bfcc6a80de1b7a95() {
    const categories = [
        'Blokady: liczba',
        "Etaty: liczba stra\u017Cnik\xf3w",
        'Mandaty: liczba wystawionych',
        "Liczba mieszka\u0144c\xf3w"
    ];
    const data = (0, $edxFI.filterByCategory)(categories);
    const validData = data.filter((sm)=>(sm["Etaty: liczba stra\u017Cnik\xf3w"] || 0) > 0);
    validData.forEach((sm)=>{
        // Clamps per guard per month
        sm.clampsPerGuardMonthly = Math.round((sm['Blokady: liczba'] || 0) / sm["Etaty: liczba stra\u017Cnik\xf3w"] / 12 * 100) / 100;
        // How many clamps per 1000 fines? (legacy metric, kept for reference if needed)
        sm.clampsPer1000Fines = Math.round(sm['Blokady: liczba'] / sm['Mandaty: liczba wystawionych'] * 1000);
    });
    return validData.sort((a, b)=>b.clampsPerGuardMonthly - a.clampsPerGuardMonthly);
}
function $42e1ff9ab7e2bbbd$export$2e2bcd8739ae039(id) {
    if (!document.getElementById(id)) return;
    const cityData = $42e1ff9ab7e2bbbd$export$bfcc6a80de1b7a95();
    const categories = cityData.map((item)=>item.city);
    // Use the new metric: clampsPerGuardMonthly
    const clampsRatio = cityData.map((item)=>item.clampsPerGuardMonthly);
    (0, (/*@__PURE__*/$parcel$interopDefault($bIbwS))).chart(id, {
        chart: {
            type: 'bar',
            backgroundColor: 'transparent'
        },
        title: {
            text: "Miesi\u0119czna liczba za\u0142o\u017Conych blokad na jednego stra\u017Cnika"
        },
        xAxis: {
            categories: categories,
            title: {
                text: null
            },
            labels: {
                style: {
                    fontSize: '14px'
                }
            }
        },
        yAxis: {
            min: 0,
            title: {
                text: 'Liczba blokad'
            }
        },
        tooltip: {
            shared: true,
            pointFormat: "<b>{point.y}</b> blokad miesi\u0119cznie na etat"
        },
        plotOptions: {
            bar: {
                dataLabels: {
                    enabled: true,
                    format: '{point.y:.1f}'
                },
                borderRadius: 4
            }
        },
        legend: {
            enabled: false
        },
        credits: {
            enabled: false
        },
        series: [
            {
                name: "Blokady na stra\u017Cnika",
                data: clampsRatio,
                color: '#e67e22'
            }
        ]
    });
}



var $bIbwS = parcelRequire("bIbwS");

var $edxFI = parcelRequire("edxFI");
function $a22b172a84d9ec29$export$b3f8c26a727c436d(normalized) {
    const categories = [
        "Holowanie: nie-wraki \u0142\u0105cznie",
        'Holowanie: wraki',
        'Mandaty: liczba wystawionych dot. PRD',
        "Liczba mieszka\u0144c\xf3w",
        // Reasons
        'Holowanie: utrudnianie ruchu',
        "Holowanie: stwarzanie zagro\u017Cenia",
        "Holowanie: niepe\u0142nosprawni",
        'Holowanie: T-24',
        'Holowanie: DMC'
    ];
    const data = (0, $edxFI.filterByCategory)(categories);
    data.forEach((sm)=>{
        const divider = normalized ? sm["Liczba mieszka\u0144c\xf3w"] / 100000 : 1;
        const totalTows = (sm["Holowanie: nie-wraki \u0142\u0105cznie"] || 0) / divider;
        const t24 = Math.round((sm['Holowanie: T-24'] || 0) / divider);
        const disabled = Math.round((sm["Holowanie: niepe\u0142nosprawni"] || 0) / divider);
        const obstruction = Math.round((sm['Holowanie: utrudnianie ruchu'] || 0) / divider);
        const security = Math.round((sm["Holowanie: stwarzanie zagro\u017Cenia"] || 0) / divider);
        const dmc = Math.round((sm['Holowanie: DMC'] || 0) / divider);
        const other = Math.round(Math.max(0, totalTows - (t24 + disabled + obstruction + dmc + security)));
        const wreck = Math.round((sm['Holowanie: wraki'] || 0) / divider);
        sm.towingReasons = {
            t24: t24,
            disabled: disabled,
            obstruction: obstruction,
            security: security,
            dmc: dmc,
            other: other,
            wreck: wreck
        };
        sm.totalTows = totalTows + wreck;
    });
    return data;
}
function $a22b172a84d9ec29$export$dfe660387c03bf8(id) {
    $a22b172a84d9ec29$var$__chartTowing(id, "Liczba odholowa\u0144 na 100k mieszka\u0144c\xf3w", true);
}
function $a22b172a84d9ec29$export$bcda459361378a91(id) {
    $a22b172a84d9ec29$var$__chartTowing(id, "Liczba odholowa\u0144", false);
}
function $a22b172a84d9ec29$var$__chartTowing(id, title, normalized) {
    if (!document.getElementById(id)) return;
    const cityData = $a22b172a84d9ec29$export$b3f8c26a727c436d(normalized).sort((a, b)=>b.totalTows - a.totalTows);
    const categories = cityData.map((item)=>item.city);
    const t24Series = cityData.map((item)=>item.towingReasons.t24);
    const disabledSeries = cityData.map((item)=>item.towingReasons.disabled);
    const obstructionSeries = cityData.map((item)=>item.towingReasons.obstruction);
    const securitySeries = cityData.map((item)=>item.towingReasons.security);
    const dmcSeries = cityData.map((item)=>item.towingReasons.dmc);
    const otherSeries = cityData.map((item)=>item.towingReasons.other);
    const wreckSeries = cityData.map((item)=>item.towingReasons.wreck);
    (0, (/*@__PURE__*/$parcel$interopDefault($bIbwS))).chart(id, {
        chart: {
            type: 'bar',
            backgroundColor: 'transparent'
        },
        title: {
            text: title
        },
        xAxis: {
            categories: categories,
            title: {
                text: null
            },
            labels: {
                style: {
                    fontSize: '14px'
                }
            }
        },
        yAxis: {
            min: 0,
            title: {
                text: title
            },
            stackLabels: {
                enabled: true,
                style: {
                    fontWeight: 'bold',
                    color: (0, (/*@__PURE__*/$parcel$interopDefault($bIbwS))).defaultOptions.title.style && (0, (/*@__PURE__*/$parcel$interopDefault($bIbwS))).defaultOptions.title.style.color || 'gray'
                }
            }
        },
        tooltip: {
            headerFormat: '<b>{point.x}</b><br/>',
            pointFormat: "{series.name}: {point.y}<br/>\u0141\u0105cznie: {point.stackTotal}"
        },
        plotOptions: {
            series: {
                stacking: 'normal',
                dataLabels: {
                    enabled: false
                }
            }
        },
        legend: {
            enabled: true,
            verticalAlign: 'top',
            reversed: true
        },
        credits: {
            enabled: false
        },
        series: [
            {
                name: 'Brak danych',
                data: otherSeries,
                color: '#bdc3c7'
            },
            {
                name: 'DMC',
                data: dmcSeries,
                color: '#9b59b6'
            },
            {
                name: 'Utrudnianie',
                data: obstructionSeries,
                color: '#026900'
            },
            {
                name: "Zagro\u017Cenie",
                data: securitySeries,
                color: '#e74c3c'
            },
            {
                name: "Niepe\u0142nosprawni",
                data: disabledSeries,
                color: '#3498db'
            },
            {
                name: 'Tabliczka T-24',
                data: t24Series,
                color: '#f1c40f'
            },
            {
                name: 'Wraki',
                data: wreckSeries,
                color: '#000000'
            }
        ]
    });
}



var $bIbwS = parcelRequire("bIbwS");

function $f6f436d3083d4e8d$export$2e2bcd8739ae039(id) {
    if (!document.getElementById(id)) return;
    // Sort by wrecks per 100k
    const cityData = (0, $a22b172a84d9ec29$export$b3f8c26a727c436d)().sort((a, b)=>b.wrecksPer100k - a.wrecksPer100k);
    const categories = cityData.map((item)=>item.city);
    const wrecksData = cityData.map((item)=>item.wrecksPer100k);
    (0, (/*@__PURE__*/$parcel$interopDefault($bIbwS))).chart(id, {
        chart: {
            type: 'bar',
            backgroundColor: 'transparent'
        },
        title: {
            text: "Usuni\u0119te wraki na 100 tys. mieszka\u0144c\xf3w"
        },
        xAxis: {
            categories: categories,
            title: {
                text: null
            },
            labels: {
                style: {
                    fontSize: '14px'
                }
            }
        },
        yAxis: {
            min: 0,
            title: {
                text: "Liczba wrak\xf3w"
            }
        },
        tooltip: {
            shared: true,
            pointFormat: "<b>{point.y}</b> wrak\xf3w na 100k mieszka\u0144c\xf3w"
        },
        plotOptions: {
            bar: {
                dataLabels: {
                    enabled: true
                },
                borderRadius: 4
            }
        },
        legend: {
            enabled: false
        },
        credits: {
            enabled: false
        },
        series: [
            {
                name: "Usuni\u0119te wraki",
                data: wrecksData,
                color: '#7f8c8d'
            }
        ]
    });
}



var $bIbwS = parcelRequire("bIbwS");

var $edxFI = parcelRequire("edxFI");
function $75321edc190a01a5$export$5f0cc46cbda97b99() {
    const categories = [
        'Mandaty: liczba wystawionych dot. PRD',
        "Liczba mieszka\u0144c\xf3w",
        "Policja: mandaty og\xf3\u0142em",
        'Policja: mandaty parkowanie',
        "Policja: pouczenia og\xf3\u0142em",
        'Policja: pouczenia parkowanie',
        "Policja: wykroczenia og\xf3\u0142em",
        'Policja: wykroczenia parkowanie'
    ];
    const data = (0, $edxFI.filterByCategory)(categories);
    const parkingRatio = data.filter((d)=>d["Policja: mandaty og\xf3\u0142em"] > 0 && d['Policja: mandaty parkowanie'] > 0).reduce((acc, d)=>{
        acc.general += d["Policja: mandaty og\xf3\u0142em"];
        acc.parking += d['Policja: mandaty parkowanie'];
        return acc;
    }, {
        general: 0,
        parking: 0
    });
    const offenceRatio = data.filter((d)=>d['Policja: wykroczenia parkowanie'] > 0 && d['Policja: mandaty parkowanie'] > 0).reduce((acc, d)=>{
        acc.offence += d['Policja: wykroczenia parkowanie'];
        acc.parking += d['Policja: mandaty parkowanie'];
        return acc;
    }, {
        offence: 0,
        parking: 0
    });
    data.forEach((d)=>{
        if (!d['Policja: mandaty parkowanie']) {
            if (d["Policja: mandaty og\xf3\u0142em"]) {
                d['Policja: mandaty parkowanie'] = d["Policja: mandaty og\xf3\u0142em"] * parkingRatio.parking / parkingRatio.general;
                d.estimated = true;
            }
            if (d['Policja: wykroczenia parkowanie']) {
                d['Policja: mandaty parkowanie'] = Math.max(d['Policja: mandaty parkowanie'] || 0, d['Policja: wykroczenia parkowanie'] * offenceRatio.parking / offenceRatio.offence);
                d.estimated = true;
            }
        }
    });
    data.forEach((sm)=>{
        sm.policeFines = sm['Policja: mandaty parkowanie'] || 0;
        sm.smFines = sm['Mandaty: liczba wystawionych dot. PRD'] || 0;
        // Per 100k
        sm.policeFinesPer100k = Math.round(sm.policeFines / sm["Liczba mieszka\u0144c\xf3w"] * 100000);
        sm.smFinesPer100k = Math.round(sm.smFines / sm["Liczba mieszka\u0144c\xf3w"] * 100000);
    });
    return data.sort((a, b)=>b.smFinesPer100k - a.smFinesPer100k);
}
function $75321edc190a01a5$export$2e2bcd8739ae039(id) {
    if (!document.getElementById(id)) return;
    const data = $75321edc190a01a5$export$5f0cc46cbda97b99();
    const policeColor = '#3498db';
    const categories = data.map((item)=>item.city);
    const policeSeries = data.map((item)=>({
            y: item.policeFinesPer100k,
            color: item.estimated ? '#b1b1b1ff' : policeColor
        }));
    const smSeries = data.map((item)=>item.smFinesPer100k);
    (0, (/*@__PURE__*/$parcel$interopDefault($bIbwS))).chart(id, {
        chart: {
            type: 'bar',
            backgroundColor: 'transparent'
        },
        title: {
            text: "Mandaty za parkowanie na 100 tys. mieszka\u0144c\xf3w"
        },
        subtitle: {
            text: "Por\xf3wnanie aktywno\u015Bci stra\u017Cy miejskiej i policji"
        },
        xAxis: {
            categories: categories,
            type: 'category',
            title: {
                text: null
            },
            labels: {
                style: {
                    fontSize: '16px'
                }
            }
        },
        yAxis: [
            {
                title: {
                    text: null
                },
                labels: {
                    style: {
                        color: '#999'
                    }
                },
                opposite: true
            },
            {
                min: 0,
                title: {
                    text: null
                },
                labels: {
                    style: {
                        color: policeColor
                    }
                }
            }
        ],
        tooltip: {
            valueSuffix: ' na 100 tys. mieszk.'
        },
        legend: {
            enabled: true,
            verticalAlign: 'top',
            align: 'center'
        },
        plotOptions: {
            bar: {
                borderRadius: 4,
                dataLabels: {
                    enabled: true,
                    formatter: function() {
                        if (this.series.name === "Stra\u017C Miejska") return Math.round(this.y || 0);
                        else return this.y;
                    }
                }
            },
            series: {
                grouping: false,
                borderWidth: 0
            }
        },
        credits: {
            enabled: false
        },
        series: [
            {
                name: "Stra\u017C miejska",
                data: smSeries,
                color: '#018b1388'
            },
            {
                name: "Policja (szary kolor \u2013\xa0dane szacunkowe)",
                data: policeSeries,
                color: policeColor,
                pointPlacement: -0.2
            }
        ]
    });
}



var $bIbwS = parcelRequire("bIbwS");
function $aaa6dadd0325cb79$export$2e2bcd8739ae039(chartId) {
    if (!document.getElementById(chartId)) return;
    (0, (/*@__PURE__*/$parcel$interopDefault($bIbwS))).chart(chartId, {
        chart: {
            type: 'bar',
            backgroundColor: 'transparent'
        },
        title: {
            text: "Utrudnienia dojazdu Pa\u0144stwowej Stra\u017Cy Po\u017Carnej w 2025 r."
        },
        xAxis: {
            categories: [
                "Po\u017Cary",
                "Miejscowe zagro\u017Cenia"
            ],
            labels: {
                style: {
                    fontSize: '14px'
                }
            }
        },
        yAxis: {
            min: 0,
            title: {
                text: "Liczba utrudnie\u0144 dojazdu"
            }
        },
        legend: {
            enabled: false
        },
        tooltip: {
            pointFormat: "Liczba utrudnie\u0144 dojazdu: <b>{point.y}</b>"
        },
        credits: {
            enabled: false
        },
        series: [
            {
                name: 'Utrudnienia dojazdu',
                data: [
                    {
                        y: 1355,
                        color: '#e74c3c'
                    },
                    {
                        y: 2143,
                        color: '#f39c12'
                    }
                ],
                dataLabels: {
                    enabled: true,
                    style: {
                        fontSize: '14px'
                    }
                }
            }
        ]
    });
}



var $bIbwS = parcelRequire("bIbwS");

var $edxFI = parcelRequire("edxFI");
function $89b6c8bcf6e6d94c$var$getResponseTimeData() {
    const categories = [
        "Czas reakcji: liczba zg\u0142osze\u0144",
        "Czas reakcji: liczba zamkni\u0119tych",
        "Czas reakcji: \u015Bredni czas (dni)"
    ];
    const data = (0, $edxFI.filterByCategory)(categories);
    // Filter cities that have the required data
    const validData = data.filter((sm)=>sm["Czas reakcji: liczba zg\u0142osze\u0144"] !== undefined && sm["Czas reakcji: liczba zamkni\u0119tych"] !== undefined && sm["Czas reakcji: \u015Bredni czas (dni)"] !== undefined);
    validData.forEach((sm)=>{
        sm.closureRate = Math.round(sm["Czas reakcji: liczba zamkni\u0119tych"] / sm["Czas reakcji: liczba zg\u0142osze\u0144"] * 1000) / 10;
        sm.totalReports = sm["Czas reakcji: liczba zg\u0142osze\u0144"];
        sm.closedReports = sm["Czas reakcji: liczba zamkni\u0119tych"];
        sm.enoughReports = sm.totalReports > 1000;
        sm.enoughClosed = sm.closedReports > 100;
        sm.valid = sm.enoughReports && sm.enoughClosed;
        sm.avgTime = sm.valid ? Math.round(Number(sm["Czas reakcji: \u015Bredni czas (dni)"])) : 0;
    });
    // Sort by average time ascending (shortest time first)
    return validData.sort((a, b)=>(a.valid ? 0 : 1) - (b.valid ? 0 : 1) || a.avgTime - b.avgTime);
}
function $89b6c8bcf6e6d94c$export$2e2bcd8739ae039(id) {
    if (!document.getElementById(id)) return;
    const data = $89b6c8bcf6e6d94c$var$getResponseTimeData();
    const categories = data.map((item)=>item.city);
    const timeData = data.map((item)=>({
            y: item.avgTime,
            ...item
        }));
    (0, (/*@__PURE__*/$parcel$interopDefault($bIbwS))).chart(id, {
        chart: {
            type: 'bar',
            backgroundColor: 'transparent'
        },
        title: {
            text: "\u015Aredni czas reakcji (od wys\u0142ania zg\u0142oszenia do zamkni\u0119cia)"
        },
        subtitle: {
            text: "Na podstawie zg\u0142osze\u0144 z aplikacji Uprzejmie Donosz\u0119 (2024-2025)"
        },
        xAxis: {
            categories: categories,
            title: {
                text: null
            },
            labels: {
                style: {
                    fontSize: '14px'
                }
            }
        },
        yAxis: {
            title: {
                text: 'Dni'
            },
            min: 0
        },
        legend: {
            enabled: false
        },
        tooltip: {
            shared: true,
            useHTML: true,
            formatter: function() {
                const point = this.points[0];
                const cityData = data.find((d)=>d.city === point.key);
                return `<b>${point.key}</b><br/>` + (point.y > 0 ? `\u{15A}redni czas: <b>${point.y?.toFixed(0)} dni</b><br/>` : '') + `Zg\u{142}osze\u{144} \u{142}\u{105}cznie: ${cityData.totalReports}<br/>` + `Zg\u{142}osze\u{144} zamkni\u{119}tych: ${cityData.closedReports} (${cityData.closureRate.toFixed(0)}%)`;
            }
        },
        plotOptions: {
            bar: {
                borderRadius: 4,
                dataLabels: {
                    enabled: true,
                    formatter: function() {
                        if (!this.options.enoughReports) return "Za ma\u0142o zg\u0142osze\u0144";
                        if (!this.options.enoughClosed) return "Za ma\u0142o zamkni\u0119tych";
                        return `${this.y} dni`;
                    }
                }
            }
        },
        credits: {
            enabled: false
        },
        series: [
            {
                name: "\u015Aredni czas (dni)",
                data: timeData,
                color: '#3498db'
            }
        ]
    });
}



var $bIbwS = parcelRequire("bIbwS");

var $edxFI = parcelRequire("edxFI");
function $9bdf4bd0f8a1d205$var$getClosureRateData() {
    const categories = [
        "Czas reakcji: liczba zg\u0142osze\u0144",
        "Czas reakcji: liczba zamkni\u0119tych"
    ];
    const data = (0, $edxFI.filterByCategory)(categories);
    data.forEach((sm)=>{
        sm.closureRate = Math.round(sm["Czas reakcji: liczba zamkni\u0119tych"] / sm["Czas reakcji: liczba zg\u0142osze\u0144"] * 1000) / 10;
        sm.totalReports = sm["Czas reakcji: liczba zg\u0142osze\u0144"];
        sm.closedReports = sm["Czas reakcji: liczba zamkni\u0119tych"];
    });
    return data.sort((a, b)=>b.closureRate - a.closureRate);
}
function $9bdf4bd0f8a1d205$export$2e2bcd8739ae039(id) {
    if (!document.getElementById(id)) return;
    const data = $9bdf4bd0f8a1d205$var$getClosureRateData();
    const categories = data.map((item)=>item.city);
    const closureRate = data.map((item)=>item.closureRate);
    (0, (/*@__PURE__*/$parcel$interopDefault($bIbwS))).chart(id, {
        chart: {
            type: 'bar',
            backgroundColor: 'transparent'
        },
        title: {
            text: "Stosunek zg\u0142osze\u0144 zamkni\u0119tych do zg\u0142osze\u0144 \u0142\u0105cznie"
        },
        subtitle: {
            text: "Na podstawie zg\u0142osze\u0144 z aplikacji Uprzejmie Donosz\u0119 (2024-2025)"
        },
        xAxis: {
            categories: categories,
            title: {
                text: null
            },
            labels: {
                style: {
                    fontSize: '14px'
                }
            }
        },
        yAxis: {
            title: {
                text: 'Procent'
            },
            min: 0
        },
        legend: {
            enabled: false
        },
        tooltip: {
            shared: true
        },
        plotOptions: {
            bar: {
                borderRadius: 4,
                dataLabels: {
                    enabled: true,
                    format: '{y}%'
                }
            }
        },
        credits: {
            enabled: false
        },
        series: [
            {
                name: "% zamkni\u0119tych zg\u0142osze\u0144",
                data: closureRate,
                color: '#3498db'
            }
        ]
    });
}



var $1vTJy = parcelRequire("1vTJy");


var $edxFI = parcelRequire("edxFI");
function $b20a7fee582a2169$var$fmt(value, decimals, suffix = '') {
    if (value === null || value === undefined) return "\u2013";
    return value.toLocaleString('pl-PL', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
    }) + suffix;
}
function $b20a7fee582a2169$export$2e2bcd8739ae039(id) {
    if (!document.getElementById(id)) return;
    const policeData = (0, $75321edc190a01a5$export$5f0cc46cbda97b99)();
    const policeByCity = {};
    policeData.forEach((d)=>{
        policeByCity[d.city] = d;
    });
    const rows = (0, $edxFI.research).map((r)=>{
        const d = policeByCity[r.city] || {};
        const smFines = d.smFines || 0;
        const policeFines = d.policeFines || 0;
        const dailySM = smFines > 0 ? Math.round(smFines / 365 * 10) / 10 : null;
        const dailyPol = policeFines > 0 ? Math.round(policeFines / 365 * 10) / 10 : null;
        const maxSM = smFines > 0 ? Math.round(smFines / 365 / r.count * 10000) / 100 : null;
        const maxPol = policeFines > 0 ? Math.round(policeFines / 365 / r.count * 10000) / 100 : null;
        const totalMax = (maxSM ?? 0) + (maxPol ?? 0);
        const minTotal = r.residentPercent != null ? Math.round(totalMax * (r.residentPercent / 100) * 100) / 100 : null;
        return {
            city: r.city,
            illegalCars: r.count,
            illegalCarsCity: Math.round(r.count / (r.residentPercent / 100)),
            residentPercent: r.residentPercent,
            dailySM: dailySM,
            dailyPol: dailyPol,
            daily: (dailySM ?? 0) + (dailyPol ?? 0),
            max: (maxSM ?? 0) + (maxPol ?? 0),
            minTotal: minTotal,
            policeEstimated: d.estimated || false
        };
    });
    (0, $1vTJy.default).grid(id, {
        dataTable: {
            columns: {
                "Miasto": rows.map((r)=>r.city),
                "Nielegalne pojazdy<br>(badany obszar i miasto)": rows.map((r)=>`${$b20a7fee582a2169$var$fmt(r.illegalCars)}/obszar<br>~${$b20a7fee582a2169$var$fmt(r.illegalCarsCity)}/miasto`),
                "Mandaty / dzie\u0144<br>(SM + policja)": rows.map((r)=>`${$b20a7fee582a2169$var$fmt(r.dailySM, 0, '')} + ${$b20a7fee582a2169$var$fmt(r.dailyPol, 0, '')} = ${$b20a7fee582a2169$var$fmt(r.daily, 0, '')}`),
                "Prawdopodobie\u0144stwo<br>mandatu": rows.map((r)=>r.residentPercent > 5 ? $b20a7fee582a2169$var$fmt(r.minTotal, 2, '%') + ' ~ ' + $b20a7fee582a2169$var$fmt(r.max, 1, '%') : '~ ' + $b20a7fee582a2169$var$fmt(r.minTotal, 2, '%'))
            }
        },
        rendering: {
            rows: {
                strictHeights: false
            },
            theme: 'hcg-theme-default theme-compact'
        },
        columns: [
            {
                id: "Miasto",
                cells: {
                    className: 'bold'
                }
            },
            {
                id: "Nielegalne pojazdy<br>(badany obszar i miasto)",
                cells: {
                    className: 'cell-right'
                }
            },
            {
                id: "Mandaty / dzie\u0144<br>(SM + policja)",
                cells: {
                    className: 'cell-right'
                }
            },
            {
                id: "Prawdopodobie\u0144stwo<br>mandatu",
                cells: {
                    className: 'cell-right'
                }
            }
        ]
    });
}



var $bIbwS = parcelRequire("bIbwS");

var $1vTJy = parcelRequire("1vTJy");

var $edxFI = parcelRequire("edxFI");

var $bNSop = parcelRequire("bNSop");
const $8231361cd6c382da$var$REVENUE_COLOR = '#2222e668';
const $8231361cd6c382da$var$FINES_COLOR = '#8e44ad';
const $8231361cd6c382da$var$MANDATES_COLOR = '#e74c3c';
function $8231361cd6c382da$var$buildSPPCityMap() {
    const byCity = {};
    (0, $edxFI.getSPP)().forEach((entry)=>{
        if (!byCity[entry.city]) byCity[entry.city] = {};
        byCity[entry.city][entry.metric] = {
            value: entry.value
        };
    });
    return byCity;
}
function $8231361cd6c382da$var$fmt(value, decimals, suffix = '') {
    if (value === null || value === undefined) return "\u2013";
    return value.toLocaleString('pl-PL', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
    }) + suffix;
}
function $8231361cd6c382da$export$3e636db171c5a598(id) {
    if (!document.getElementById(id)) return;
    const sppByCity = $8231361cd6c382da$var$buildSPPCityMap();
    const smData = (0, $edxFI.filterByCategory)([
        "Liczba mieszka\u0144c\xf3w"
    ]);
    const popByCity = {};
    smData.forEach((d)=>{
        popByCity[d.city] = d["Liczba mieszka\u0144c\xf3w"];
    });
    const revenueKey = "Suma zebranych op\u0142at za post\xf3j";
    const finesKey = "\u0141\u0105czna kwota pobranych op\u0142at za z\u0142amanie regulaminu parkowania";
    const rows = Object.entries(sppByCity).filter(([city, metrics])=>metrics[revenueKey] !== undefined && popByCity[city]).map(([city, metrics])=>{
        const revenueEntry = metrics[revenueKey];
        const finesEntry = metrics[finesKey];
        const pop = popByCity[city];
        const parking = revenueEntry.value;
        const fines = finesEntry ? finesEntry.value : 0;
        return {
            city: city,
            parking: parking,
            fines: fines,
            perPersonParking: Math.round(parking / pop),
            perPersonFines: Math.round(fines / pop),
            perPersonTotal: Math.round(parking / pop) + Math.round(fines / pop)
        };
    }).sort((a, b)=>b.perPersonTotal - a.perPersonTotal);
    const byCity = {};
    rows.forEach((d)=>{
        byCity[d.city] = d;
    });
    const categories = rows.map((d)=>d.city);
    (0, (/*@__PURE__*/$parcel$interopDefault($bIbwS))).chart(id, {
        chart: {
            type: 'bar',
            backgroundColor: 'transparent'
        },
        title: {
            text: "Wp\u0142ywy z op\u0142at za post\xf3j na mieszka\u0144ca"
        },
        subtitle: {
            text: "Brak danych dla Zielonej G\xf3ry i Lublina."
        },
        xAxis: {
            categories: categories,
            title: {
                text: null
            },
            labels: {
                style: {
                    fontSize: '14px'
                }
            }
        },
        yAxis: {
            title: {
                text: null
            },
            labels: {
                format: "{value} z\u0142"
            },
            stackLabels: {
                enabled: true,
                formatter: function() {
                    return `${this.total.toLocaleString('pl-PL')} z\u{142}`;
                },
                style: {
                    fontSize: '12px',
                    fontWeight: 'bold',
                    color: '#333'
                }
            }
        },
        legend: {
            enabled: true,
            verticalAlign: 'top',
            reversed: true
        },
        tooltip: {
            formatter: function() {
                const d = byCity[this.key];
                if (!d) return false;
                return `<b>${d.city}</b><br>
                    Op\u{142}aty za post\xf3j: <b>${d.perPersonParking.toLocaleString('pl-PL')} z\u{142}</b>/mieszk.<br>
                    Op\u{142}aty dodatkowe: <b>${d.perPersonFines.toLocaleString('pl-PL')} z\u{142}</b>/mieszk.<br>
                    \u{141}\u{105}cznie: <b>${d.perPersonTotal.toLocaleString('pl-PL')} z\u{142}</b>/mieszk.`;
            }
        },
        plotOptions: {
            bar: {
                stacking: 'normal',
                borderRadius: 4,
                dataLabels: {
                    enabled: false
                }
            }
        },
        credits: {
            enabled: false
        },
        series: [
            {
                name: "Op\u0142aty dodatkowe za naruszenia regulaminu",
                color: $8231361cd6c382da$var$FINES_COLOR,
                data: rows.map((d)=>({
                        y: d.perPersonFines,
                        color: $8231361cd6c382da$var$FINES_COLOR
                    }))
            },
            {
                name: "Op\u0142aty za post\xf3j",
                color: $8231361cd6c382da$var$REVENUE_COLOR,
                data: rows.map((d)=>({
                        y: d.perPersonParking,
                        color: $8231361cd6c382da$var$REVENUE_COLOR
                    }))
            }
        ]
    });
}
function $8231361cd6c382da$export$9b3bb8ed1e0e655b(id) {
    if (!document.getElementById(id)) return;
    const sppByCity = $8231361cd6c382da$var$buildSPPCityMap();
    const smData = (0, $edxFI.filterByCategory)([
        "Mandaty: warto\u015B\u0107 wystawionych dot. PRD"
    ]);
    const smFinesByCity = {};
    smData.forEach((d)=>{
        smFinesByCity[d.city] = d["Mandaty: warto\u015B\u0107 wystawionych dot. PRD"];
    });
    const finesKey = "\u0141\u0105czna kwota pobranych op\u0142at za z\u0142amanie regulaminu parkowania";
    const revenueKey = "Suma zebranych op\u0142at za post\xf3j";
    const totals = {
        sppFines: 0,
        sppRevenue: 0,
        smFines: 0
    };
    const rows = Object.entries(sppByCity).filter(([city, metrics])=>metrics[finesKey] !== undefined && smFinesByCity[city]).map(([city, metrics])=>{
        const sppEntry = metrics[finesKey];
        const sppRevenue = metrics[revenueKey];
        const smFines = smFinesByCity[city];
        totals.sppFines += sppEntry.value;
        totals.sppRevenue += sppRevenue.value;
        totals.smFines += smFines;
        return {
            city: city,
            sppFines: sppEntry.value,
            sppRevenue: sppRevenue.value,
            smFines: smFines,
            total: smFines + sppEntry.value
        };
    }).sort((a, b)=>b.total - a.total);
    const rowsWithTotals = [
        ...rows
    ];
    rowsWithTotals.push({
        city: "\u0141\u0105cznie",
        ...totals,
        total: totals.smFines + totals.sppFines
    });
    const byCity = {};
    rows.forEach((d)=>{
        byCity[d.city] = d;
    });
    const toMln = (v)=>(Math.round(v / 1e5) / 10).toLocaleString('pl-PL');
    (0, $1vTJy.default).grid(id + '-grid', {
        dataTable: {
            columns: {
                "Miasto": rowsWithTotals.map((r)=>r.city),
                "SPP:<br>op\u0142aty za post\xf3j": rowsWithTotals.map((r)=>`${toMln(r.sppRevenue)} mln.`),
                "SPP:<br>op\u0142aty dodatkowe": rowsWithTotals.map((r)=>`${toMln(r.sppFines)} mln.`),
                "Mandaty SM": rowsWithTotals.map((r)=>`${toMln(r.smFines)} mln.`),
                "Proporcja kar": rowsWithTotals.map((r)=>`${$8231361cd6c382da$var$fmt(r.sppFines / r.smFines, 2, '')}`)
            }
        },
        rendering: {
            rows: {
                strictHeights: false
            },
            theme: 'hcg-theme-default theme-compact'
        },
        columns: [
            {
                id: "Miasto",
                cells: {
                    className: 'bold'
                }
            },
            {
                id: "SPP:<br>op\u0142aty za post\xf3j",
                cells: {
                    className: 'cell-right'
                }
            },
            {
                id: "SPP:<br>op\u0142aty dodatkowe",
                cells: {
                    className: 'cell-right'
                }
            },
            {
                id: "Mandaty SM",
                cells: {
                    className: 'cell-right'
                }
            },
            {
                id: "Proporcja kar",
                cells: {
                    className: 'cell-right'
                }
            }
        ]
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($bIbwS))).chart(id, {
        chart: {
            type: 'bar',
            backgroundColor: 'transparent'
        },
        title: {
            text: "Mandaty SM (PRD) i op\u0142aty dodatkowe SPP \u2013 \u0142\u0105czna warto\u015B\u0107"
        },
        subtitle: {
            text: "Brak danych dla Zielonej G\xf3ry i Lublina."
        },
        xAxis: {
            categories: rows.map((d)=>d.city),
            title: {
                text: null
            },
            labels: {
                style: {
                    fontSize: '14px'
                }
            }
        },
        yAxis: {
            title: {
                text: null
            },
            labels: {
                formatter: function() {
                    return `${toMln(this.value)} mln z\u{142}`;
                }
            },
            stackLabels: {
                enabled: true,
                formatter: function() {
                    return `${toMln(this.total)} mln z\u{142}`;
                },
                style: {
                    fontSize: '12px',
                    fontWeight: 'bold',
                    color: '#333'
                }
            }
        },
        legend: {
            enabled: true,
            verticalAlign: 'top',
            reversed: true
        },
        tooltip: {
            formatter: function() {
                const d = byCity[this.key];
                if (!d) return false;
                return `<b>${d.city}</b><br>
                    Mandaty SM (PRD): <b>${Math.round(d.smFines).toLocaleString('pl-PL')} z\u{142}</b><br>
                    Op\u{142}aty dodatkowe SPP: <b>${Math.round(d.sppFines).toLocaleString('pl-PL')} z\u{142}</b><br>
                    \u{141}\u{105}cznie: <b>${Math.round(d.total).toLocaleString('pl-PL')} z\u{142}</b>`;
            }
        },
        plotOptions: {
            bar: {
                stacking: 'normal',
                borderRadius: 4,
                dataLabels: {
                    enabled: false
                }
            }
        },
        credits: {
            enabled: false
        },
        series: [
            {
                name: "Op\u0142aty dodatkowe SPP",
                data: rows.map((d)=>({
                        y: d.sppFines
                    })),
                color: $8231361cd6c382da$var$FINES_COLOR
            },
            {
                name: 'Mandaty SM (PRD)',
                color: $8231361cd6c382da$var$MANDATES_COLOR,
                data: rows.map((d)=>({
                        y: d.smFines
                    }))
            }
        ]
    });
}
function $8231361cd6c382da$export$ce54586e625f4233(id) {
    if (!document.getElementById(id)) return;
    const sppByCity = $8231361cd6c382da$var$buildSPPCityMap();
    const smData = (0, $edxFI.filterByCategory)([
        "Mandaty: warto\u015B\u0107 wystawionych dot. PRD"
    ]);
    const smFinesByCity = {};
    smData.forEach((d)=>{
        smFinesByCity[d.city] = d["Mandaty: warto\u015B\u0107 wystawionych dot. PRD"];
    });
    const metricKey = "\u0141\u0105czna kwota pobranych op\u0142at za z\u0142amanie regulaminu parkowania";
    const rows = Object.entries(sppByCity).filter(([city, metrics])=>metrics[metricKey] !== undefined && smFinesByCity[city]).map(([city, metrics])=>{
        const entry = metrics[metricKey];
        const smFines = smFinesByCity[city];
        return {
            city: city,
            sppFines: entry.value,
            smFines: smFines,
            ratio: Math.round(entry.value / smFines * 10) / 10
        };
    }).sort((a, b)=>b.ratio - a.ratio);
    const byCity = {};
    rows.forEach((d)=>{
        byCity[d.city] = d;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($bIbwS))).chart(id, {
        chart: {
            type: 'bar',
            backgroundColor: 'transparent'
        },
        title: {
            text: "Op\u0142aty za z\u0142amanie regulaminu SPP a mandaty SM"
        },
        subtitle: {
            text: "Op\u0142aty dodatkowe SPP / mandaty SM."
        },
        xAxis: {
            categories: rows.map((d)=>d.city),
            title: {
                text: null
            },
            labels: {
                style: {
                    fontSize: '14px'
                }
            }
        },
        yAxis: {
            title: {
                text: null
            },
            labels: {
                format: '{value}'
            },
            min: 0
        },
        legend: {
            enabled: false
        },
        tooltip: {
            formatter: function() {
                const d = byCity[this.key];
                if (!d) return false;
                return `<b>${d.city}</b><br>
                    Op\u{142}aty SPP za naruszenia: ${Math.round(d.sppFines).toLocaleString('pl-PL')} z\u{142}<br>
                    Mandaty SM: ${Math.round(d.smFines).toLocaleString('pl-PL')} z\u{142}<br>
                    <b>Proporcja: ${d.ratio}</b>`;
            }
        },
        plotOptions: {
            bar: {
                borderRadius: 4,
                dataLabels: {
                    enabled: true,
                    formatter: function() {
                        return `${this.y}`;
                    },
                    style: {
                        fontSize: '12px',
                        textOutline: 'none'
                    }
                }
            }
        },
        credits: {
            enabled: false
        },
        series: [
            {
                name: "Op\u0142aty dodatkowe w SPP / mandaty SM",
                type: 'bar',
                yAxis: 0,
                id: 'main',
                color: '#FFFF00',
                data: rows.map((d)=>({
                        y: d.ratio,
                        color: (0, $bNSop.gradientHex)('#00881e', '#FF0000', d.ratio / 2)
                    }))
            }
        ]
    });
}



var $1vTJy = parcelRequire("1vTJy");
const $60bad8ec0dde0603$var$metrics = [
    {
        name: "Wydajno\u015B\u0107",
        definition: "Liczba mandat\xf3w za parkowanie wystawiona przez jednego stra\u017Cnika w ci\u0105gu miesi\u0105ca",
        normalization: "\u2191 min-max obserwowany (0\u201314,3 mandat\xf3w/stra\u017Cnik/miesi\u0105c)",
        max: 200
    },
    {
        name: "Pob\u0142a\u017Cliwo\u015B\u0107",
        definition: "Udzia\u0142 poucze\u0144 w \u0142\u0105cznej liczbie interwencji parkingowych (mandaty + pouczenia)",
        normalization: "\u2193 progi: \u226410% = maks., \u226550% = 0 pkt \u2013 stra\u017Ce wystawiaj\u0105ce mandaty w mniej ni\u017C po\u0142owie interwencji s\u0105 oceniane ni\u017Cej",
        max: 100
    },
    {
        name: 'Blokady',
        definition: "Liczba za\u0142o\u017Conych blokad k\xf3\u0142 na jednego stra\u017Cnika w ci\u0105gu miesi\u0105ca",
        normalization: "\u2191 min-max obserwowany (0\u20136,8 blokad/stra\u017Cnik/miesi\u0105c)",
        max: 100
    },
    {
        name: 'Holowania',
        definition: "Liczba holowa\u0144 pojazd\xf3w innych ni\u017C wraki na 100 tys. mieszka\u0144c\xf3w rocznie",
        normalization: "\u2191 min-max obserwowany (0\u2013798 holowa\u0144/100k)",
        max: 100
    },
    {
        name: "Holowanie z przej\u015B\u0107",
        definition: "Liczba holowa\u0144 za stwarzanie zagro\u017Cenia (m.in. blokowanie przej\u015B\u0107 dla pieszych) na 100 tys. mieszka\u0144c\xf3w rocznie",
        normalization: "\u2191 min-max obserwowany (0\u201318,1 holowa\u0144/100k)",
        max: 100
    },
    {
        name: "Holowanie wrak\xf3w",
        definition: "Liczba holowa\u0144 pojazd\xf3w uznanych za wraki na 100 tys. mieszka\u0144c\xf3w rocznie",
        normalization: "\u2191 min-max obserwowany (0\u201388 wrak\xf3w/100k)",
        max: 100
    },
    {
        name: "Wsp\xf3\u0142praca",
        definition: "Odsetek zg\u0142osze\u0144 z systemu czas-reakcji (urz\u0105d dzielnicy / miasta) zamkni\u0119tych przez stra\u017C",
        normalization: "\u2191 progi: 0% = 0 pkt, 100% = maks. (naturalna granica)",
        max: 100
    },
    {
        name: "Niesprawiedliwo\u015B\u0107",
        definition: "Stosunek \u0142\u0105cznej kwoty op\u0142at dodatkowych na\u0142o\u017Conych przez operatora SPP do warto\u015Bci mandat\xf3w za nieprawid\u0142owe parkowanie wystawionych przez stra\u017C miejsk\u0105",
        normalization: "\u2193 progi: \u22640,3 \xd7 = maks., \u22653 \xd7 = 0 pkt; miasta bez danych SPP otrzymuj\u0105 0 pkt",
        max: 100
    },
    {
        name: "Stra\u017Cnicy",
        definition: "Liczba etat\xf3w stra\u017Cnik\xf3w na 100 tys. mieszka\u0144c\xf3w",
        normalization: "\u2191 min-max obserwowany (10\u201368 stra\u017Cnik\xf3w/100k)",
        max: 100
    },
    {
        name: "Bud\u017Cet",
        definition: "Roczny bud\u017Cet stra\u017Cy podzielony przez liczb\u0119 mieszka\u0144c\xf3w",
        normalization: "\u2191 progi: \u226410 z\u0142/mieszka\u0144ca = 0 pkt, \u2265140 z\u0142/mieszka\u0144ca = maks.",
        max: 50
    },
    {
        name: 'Mandaty PRD',
        definition: "Udzia\u0142 mandat\xf3w za nieprawid\u0142owe parkowanie w og\xf3lnej liczbie wystawionych mandat\xf3w",
        normalization: "\u2193 progi: \u226450% = maks., \u226580% = 0 pkt \u2013 stra\u017Ce skupione niemal wy\u0142\u0105cznie na parkowaniu s\u0105 oceniane ni\u017Cej",
        max: 50
    },
    {
        name: 'Koszt mandatu',
        definition: "Roczny bud\u017Cet stra\u017Cy podzielony przez \u0142\u0105czn\u0105 liczb\u0119 wystawionych mandat\xf3w",
        normalization: "\u2193 progi: \u2264794 z\u0142/mandat = maks., \u22653\xa0000 z\u0142/mandat = 0 pkt",
        max: 50
    },
    {
        name: 'Wynagrodzenie',
        definition: "Mediana wynagrodze\u0144 brutto stra\u017Cnik\xf3w; jednostki bez danych otrzymuj\u0105 minimaln\u0105 warto\u015B\u0107 obserwowan\u0105 w zbiorze",
        normalization: "\u2191 min-max obserwowany (4\xa0900\u20139\xa0792 z\u0142 brutto)",
        max: 50
    }
];
function $60bad8ec0dde0603$export$2e2bcd8739ae039(id) {
    if (!document.getElementById(id)) return;
    (0, $1vTJy.default).grid(id, {
        dataTable: {
            columns: {
                'Metryka': $60bad8ec0dde0603$var$metrics.map((m)=>m.name),
                'Definicja': $60bad8ec0dde0603$var$metrics.map((m)=>m.definition),
                'Normalizacja': $60bad8ec0dde0603$var$metrics.map((m)=>m.normalization),
                'Maks.\u00a0pkt': $60bad8ec0dde0603$var$metrics.map((m)=>m.max)
            }
        },
        rendering: {
            rows: {
                strictHeights: false
            },
            theme: 'hcg-theme-default theme-compact'
        },
        columns: [
            {
                id: 'Metryka',
                cells: {
                    className: 'bold'
                },
                width: 140
            },
            {
                id: 'Definicja'
            },
            {
                id: 'Normalizacja'
            },
            {
                id: 'Maks. pkt',
                cells: {
                    className: 'cell-right'
                },
                width: 70
            }
        ]
    });
}


(0, (/*@__PURE__*/$parcel$interopDefault($bIbwS))).setOptions((0, $edzU1.default));
(0, $1vTJy.default).setOptions((0, $edzU1.default));
// Inicjalizacja wykresów po załadowaniu DOM
document.addEventListener('DOMContentLoaded', async function() {
    (0, $n1uPX.default)();
    (0, $e9931649c14141c6$export$2e2bcd8739ae039)();
    (0, $dFE0m.default)();
    // Add small delay to ensure menu is rendered
    setTimeout(()=>{
        (0, $hxh3D.default)();
    }, 100);
    (0, $352eaa88a59beb78$export$2e2bcd8739ae039)('bar-chart-staff');
    (0, $6ea0380ed9a29449$export$757ae431edaef9da)('bar-chart-fines-per-guard');
    (0, $6ea0380ed9a29449$export$486fca12c2d4e98f)('bar-chart-self-financing');
    (0, $6ea0380ed9a29449$export$8ec6650e9088f965)('bar-chart-price-of-fine');
    (0, $01d158adc2c26960$export$2e2bcd8739ae039)('table-budget');
    (0, $349a92fc1fb0dd6a$export$2e2bcd8739ae039)('bar-chart-pouczenia');
    (0, $7ce13169721f306b$export$2e2bcd8739ae039)('table-research');
    await (0, $4a0b867d884097f3$export$2e2bcd8739ae039)('map-ranking');
    await (0, $dbeb6bf7b9b3b790$export$2e2bcd8739ae039)('map-budgets');
    (0, $788f583bce274779$export$2e2bcd8739ae039)('chart-fines-structure');
    (0, $cf6b0260f53c524f$export$2e2bcd8739ae039)('bar-chart-salaries');
    (0, $e2d9a1ad085c9be4$export$2e2bcd8739ae039)('bar-chart-vacancies');
    (0, $32081bc3857e8987$export$2e2bcd8739ae039)('bar-chart-structure');
    (0, $42e1ff9ab7e2bbbd$export$2e2bcd8739ae039)('bar-chart-clamps');
    (0, $a22b172a84d9ec29$export$bcda459361378a91)('bar-chart-towing');
    (0, $a22b172a84d9ec29$export$dfe660387c03bf8)('bar-chart-towing100k');
    (0, $f6f436d3083d4e8d$export$2e2bcd8739ae039)('bar-chart-wrecks');
    (0, $75321edc190a01a5$export$2e2bcd8739ae039)('bar-chart-police');
    (0, $aaa6dadd0325cb79$export$2e2bcd8739ae039)('chart-fire-summary');
    (0, $89b6c8bcf6e6d94c$export$2e2bcd8739ae039)('bar-chart-response-time');
    (0, $9bdf4bd0f8a1d205$export$2e2bcd8739ae039)('bar-chart-closure-rate');
    (0, $b20a7fee582a2169$export$2e2bcd8739ae039)('table-efficiency');
    (0, $8231361cd6c382da$export$3e636db171c5a598)('chart-spp-revenue');
    (0, $8231361cd6c382da$export$ce54586e625f4233)('chart-spp-fines-share');
    (0, $8231361cd6c382da$export$9b3bb8ed1e0e655b)('chart-spp-absolute');
    (0, $60bad8ec0dde0603$export$2e2bcd8739ae039)('table-metodologia');
});

})();
//# sourceMappingURL=index.js.map
